// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"5DEId":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _jsxRuntime = require("react/jsx-runtime");
var _client = require("react-dom/client");
var _app = require("./App");
var _appDefault = parcelHelpers.interopDefault(_app);
var _store = require("./app/store");
var _deckSlice = require("./features/deck/deckSlice");
var _routeSlice = require("./features/route/routeSlice");
var _broadcast = require("./app/broadcast");
var _transcludeSlice = require("./features/transclude/transcludeSlice");
var _windowSlice = require("./features/window/windowSlice");
var _decks = require("./decks");
var _helpSlice = require("./features/help/helpSlice");
var _toolkit = require("@reduxjs/toolkit");
var _skippedSlice = require("./features/skipped/skippedSlice");
function randomId() {
    const uint32 = window.crypto.getRandomValues(new Uint32Array(1))[0];
    return uint32.toString(16);
}
const SLIDESHOW_ID = randomId();
const url = new URL(window.location.toString());
if (!url.searchParams.has("id")) {
    url.searchParams.set("id", SLIDESHOW_ID);
    window.history.replaceState(null, "", url);
}
const CHANNEL_ID = url.searchParams.get("id") || SLIDESHOW_ID;
const channel = new BroadcastChannel(CHANNEL_ID);
const store = (0, _store.buildStore)({
    channel,
    window
});
channel.addEventListener("message", (msg)=>{
    if (Array.isArray(msg.data)) {
        for (const data of msg.data)if ((0, _toolkit.isAction)(data)) store.dispatch(data);
    }
});
const getDeckAndPageFromUrl = (url)=>{
    const deckTxt = (0, _decks.validateDeckType)(url.searchParams.get("deck"));
    store.dispatch((0, _broadcast.broadcast)((0, _routeSlice.setDeck)(deckTxt)));
    const pageTxt = url.searchParams.get("page");
    const page = pageTxt ? parseInt(pageTxt, 10) : 1;
    store.dispatch((0, _broadcast.broadcast)((0, _deckSlice.setSlideIndex)(page)));
};
getDeckAndPageFromUrl(url);
const app = document.getElementById("app");
const root = (0, _client.createRoot)(app);
root.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appDefault.default), {
    store: store
}));
let runningTotal = 0;
window.addEventListener("keydown", (event)=>{
    if (event.key === "Meta") store.dispatch((0, _transcludeSlice.toggleShowCopy)());
    if (event.altKey || event.ctrlKey || event.metaKey) return;
    switch(event.key){
        case "ArrowRight":
        case "ArrowDown":
        case "PageDown":
            store.dispatch((0, _broadcast.broadcast)((0, _deckSlice.forward)()));
            break;
        case "ArrowLeft":
        case "ArrowUp":
        case "PageUp":
            store.dispatch((0, _broadcast.broadcast)((0, _deckSlice.backward)()));
            break;
        case "Home":
            store.dispatch((0, _broadcast.broadcast)((0, _deckSlice.firstSlide)()));
            break;
        case "End":
            store.dispatch((0, _broadcast.broadcast)((0, _deckSlice.lastSlide)()));
            break;
        case "a":
            store.dispatch((0, _broadcast.broadcast)((0, _deckSlice.toggleAspectRatio)()));
            break;
        case "c":
            window.open(window.location.toString(), "_blank", "popup=1");
            break;
        case "e":
            store.dispatch((0, _broadcast.broadcast)((0, _transcludeSlice.toggleShowEmphasis)()));
            break;
        case "g":
            if (runningTotal !== 0) store.dispatch((0, _broadcast.broadcast)((0, _deckSlice.setSlideIndex)(runningTotal)));
            break;
        case "p":
            store.dispatch((0, _deckSlice.togglePresenter)());
            break;
        case "s":
            store.dispatch((0, _skippedSlice.toggleSkipped)());
            break;
        case "+":
        case "=":
            store.dispatch((0, _windowSlice.increase)());
            break;
        case "-":
        case "_":
            store.dispatch((0, _windowSlice.decrease)());
            break;
        case ")":
            store.dispatch((0, _windowSlice.reset)());
            break;
        case "?":
            store.dispatch(_helpSlice.toggle());
            break;
    }
    const numericValue = Number(event.key);
    if (isNaN(numericValue)) runningTotal = 0;
    else runningTotal = runningTotal * 10 + numericValue;
});
window.addEventListener("beforeprint", (_event)=>{
    store.dispatch((0, _deckSlice.enablePrint)());
});
window.addEventListener("afterprint", (_event)=>{
    store.dispatch((0, _deckSlice.disablePrint)());
});
window.addEventListener("popstate", (_event)=>{
    const url = new URL(window.location.toString());
    getDeckAndPageFromUrl(url);
});

},{"react/jsx-runtime":"afIHK","react-dom/client":"cXlXT","./App":"ceurZ","./app/store":"cORaO","./features/deck/deckSlice":"dvasY","./features/route/routeSlice":"2FQD2","./app/broadcast":"eOCff","./features/transclude/transcludeSlice":"1B57U","./features/window/windowSlice":"b9JbQ","./decks":"fVdpz","./features/help/helpSlice":"3yLXh","@reduxjs/toolkit":"ey6Uw","./features/skipped/skippedSlice":"gcTsW","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"afIHK":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("d3cc7009e73a7470");

},{"d3cc7009e73a7470":"iHvCe"}],"iHvCe":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.jsx = jsxProd;
exports.jsxs = jsxProd;

},{}],"cXlXT":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("3e2f0592ef1ae779");

},{"3e2f0592ef1ae779":"6ZeLC"}],"6ZeLC":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";
var Scheduler = require("34889e2d9d2e5ad0"), React = require("4ca5dbf165264c00"), ReactDOM = require("d9c4e38f4a220051");
function formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function assertIsMounted(fiber) {
    if (getNearestMountedFiber(fiber) !== fiber) throw Error(formatProdErrorMessage(188));
}
function findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = getNearestMountedFiber(fiber);
        if (null === alternate) throw Error(formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return assertIsMounted(parentA), fiber;
                if (parentB === b) return assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error(formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error(formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error(formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error(formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var assign = Object.assign, REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case REACT_FRAGMENT_TYPE:
            return "Fragment";
        case REACT_PROFILER_TYPE:
            return "Profiler";
        case REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case REACT_SUSPENSE_TYPE:
            return "Suspense";
        case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case REACT_PORTAL_TYPE:
            return "Portal";
        case REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
        case REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var isArrayImpl = Array.isArray, ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ReactDOMSharedInternals = ReactDOM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, valueStack = [], index = -1;
function createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function pop(cursor) {
    0 > index || (cursor.current = valueStack[index], valueStack[index] = null, index--);
}
function push(cursor, value) {
    index++;
    valueStack[index] = cursor.current;
    cursor.current = value;
}
var contextStackCursor = createCursor(null), contextFiberStackCursor = createCursor(null), rootInstanceStackCursor = createCursor(null), hostTransitionProviderCursor = createCursor(null);
function pushHostContainer(fiber, nextRootInstance) {
    push(rootInstanceStackCursor, nextRootInstance);
    push(contextFiberStackCursor, fiber);
    push(contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = getOwnHostContext(nextRootInstance), fiber = getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    pop(contextStackCursor);
    push(contextStackCursor, fiber);
}
function popHostContainer() {
    pop(contextStackCursor);
    pop(contextFiberStackCursor);
    pop(rootInstanceStackCursor);
}
function pushHostContext(fiber) {
    null !== fiber.memoizedState && push(hostTransitionProviderCursor, fiber);
    var context = contextStackCursor.current;
    var JSCompiler_inline_result = getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && (push(contextFiberStackCursor, fiber), push(contextStackCursor, JSCompiler_inline_result));
}
function popHostContext(fiber) {
    contextFiberStackCursor.current === fiber && (pop(contextStackCursor), pop(contextFiberStackCursor));
    hostTransitionProviderCursor.current === fiber && (pop(hostTransitionProviderCursor), HostTransitionContext._currentValue = sharedNotPendingObject);
}
var prefix, suffix;
function describeBuiltInComponentFrame(name) {
    if (void 0 === prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        prefix = match && match[1] || "";
        suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + prefix + name + suffix;
}
var reentry = !1;
function describeNativeComponentFrame(fn, construct) {
    if (!fn || reentry) return "";
    reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return describeBuiltInComponentFrame(fiber.type);
        case 16:
            return describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? describeBuiltInComponentFrame("Suspense Fallback") : describeBuiltInComponentFrame("Suspense");
        case 19:
            return describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var hasOwnProperty = Object.prototype.hasOwnProperty, scheduleCallback$3 = Scheduler.unstable_scheduleCallback, cancelCallback$1 = Scheduler.unstable_cancelCallback, shouldYield = Scheduler.unstable_shouldYield, requestPaint = Scheduler.unstable_requestPaint, now = Scheduler.unstable_now, getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel, ImmediatePriority = Scheduler.unstable_ImmediatePriority, UserBlockingPriority = Scheduler.unstable_UserBlockingPriority, NormalPriority$1 = Scheduler.unstable_NormalPriority, LowPriority = Scheduler.unstable_LowPriority, IdlePriority = Scheduler.unstable_IdlePriority, log$1 = Scheduler.log, unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue, rendererID = null, injectedHook = null;
function setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof log$1 && unstable_setDisableYieldValue(newIsStrictMode);
    if (injectedHook && "function" === typeof injectedHook.setStrictMode) try {
        injectedHook.setStrictMode(rendererID, newIsStrictMode);
    } catch (err) {}
}
var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback, log = Math.log, LN2 = Math.LN2;
function clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - (log(x) / LN2 | 0) | 0;
}
var nextTransitionUpdateLane = 256, nextTransitionDeferredLane = 262144, nextRetryLane = 4194304;
function getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function claimNextRetryLane() {
    var lane = nextRetryLane;
    nextRetryLane <<= 1;
    0 === (nextRetryLane & 62914560) && (nextRetryLane = 4194304);
    return lane;
}
function createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function resolveUpdatePriority() {
    var updatePriority = ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : getEventPriority(updatePriority.type);
}
function runWithPriority(priority, fn) {
    var previousPriority = ReactDOMSharedInternals.p;
    try {
        return ReactDOMSharedInternals.p = priority, fn();
    } finally{
        ReactDOMSharedInternals.p = previousPriority;
    }
}
var randomKey = Math.random().toString(36).slice(2), internalInstanceKey = "__reactFiber$" + randomKey, internalPropsKey = "__reactProps$" + randomKey, internalContainerInstanceKey = "__reactContainer$" + randomKey, internalEventHandlersKey = "__reactEvents$" + randomKey, internalEventHandlerListenersKey = "__reactListeners$" + randomKey, internalEventHandlesSetKey = "__reactHandles$" + randomKey, internalRootNodeResourcesKey = "__reactResources$" + randomKey, internalHoistableMarker = "__reactMarker$" + randomKey;
function detachDeletedInstance(node) {
    delete node[internalInstanceKey];
    delete node[internalPropsKey];
    delete node[internalEventHandlersKey];
    delete node[internalEventHandlerListenersKey];
    delete node[internalEventHandlesSetKey];
}
function getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[internalInstanceKey]) return parentNode;
                targetNode = getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function getInstanceFromNode(node) {
    if (node = node[internalInstanceKey] || node[internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error(formatProdErrorMessage(33));
}
function getResourcesFromRoot(root) {
    var resources = root[internalRootNodeResourcesKey];
    resources || (resources = root[internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function markNodeAsHoistable(node) {
    node[internalHoistableMarker] = !0;
}
var allNativeEvents = new Set(), registrationNameDependencies = {};
function registerTwoPhaseEvent(registrationName, dependencies) {
    registerDirectEvent(registrationName, dependencies);
    registerDirectEvent(registrationName + "Capture", dependencies);
}
function registerDirectEvent(registrationName, dependencies) {
    registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)allNativeEvents.add(dependencies[registrationName]);
}
var VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), illegalAttributeNameCache = {}, validatedAttributeNameCache = {};
function isAttributeNameSafe(attributeName) {
    if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return !0;
    if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return !1;
    if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return validatedAttributeNameCache[attributeName] = !0;
    illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function setValueForAttribute(node, name, value) {
    if (isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function track(node) {
    if (!node._valueTracker) {
        var valueField = isCheckable(node) ? "checked" : "value";
        node._valueTracker = trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace(escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + getToStringValue(value);
        } else element.value !== "" + getToStringValue(value) && (element.value = "" + getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? setDefaultValue(element, type, getToStringValue(value)) : null != defaultValue ? setDefaultValue(element, type, getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + getToStringValue(name) : element.removeAttribute("name");
}
function initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + getToStringValue(defaultValue) : "";
        value = null != value ? "" + getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    track(element);
}
function setDefaultValue(node, type, value) {
    "number" === type && getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + getToStringValue(defaultValue) : "";
}
function initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error(formatProdErrorMessage(92));
            if (isArrayImpl(children)) {
                if (1 < children.length) throw Error(formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    track(element);
}
function setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error(formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function sanitizeURL(url) {
    return isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function noop$1() {}
var currentReplayingEvent = null;
function getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var restoreTarget = null, restoreQueue = null;
function restoreStateOfTarget(target) {
    var internalInstance = getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[internalPropsKey] || null;
                            if (!otherProps) throw Error(formatProdErrorMessage(90));
                            updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var isInsideEventHandler = !1;
function batchedUpdates$1(fn, a, b) {
    if (isInsideEventHandler) return fn(a, b);
    isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if (isInsideEventHandler = !1, null !== restoreTarget || null !== restoreQueue) {
            if (flushSyncWork$1(), restoreTarget && (a = restoreTarget, fn = restoreQueue, restoreQueue = restoreTarget = null, restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)restoreStateOfTarget(fn[a]);
        }
    }
}
function getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error(formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), passiveBrowserEventsSupported = !1;
if (canUseDOM) try {
    var options = {};
    Object.defineProperty(options, "passive", {
        get: function() {
            passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", options, options);
    window.removeEventListener("test", options, options);
} catch (e) {
    passiveBrowserEventsSupported = !1;
}
var root = null, startText = null, fallbackText = null;
function getData() {
    if (fallbackText) return fallbackText;
    var start, startValue = startText, startLength = startValue.length, end, endValue = "value" in root ? root.value : root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function functionThatReturnsTrue() {
    return !0;
}
function functionThatReturnsFalse() {
    return !1;
}
function createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? functionThatReturnsTrue : functionThatReturnsFalse;
        this.isPropagationStopped = functionThatReturnsFalse;
        return this;
    }
    assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, SyntheticEvent = createSyntheticEvent(EventInterface), UIEventInterface = assign({}, EventInterface, {
    view: 0,
    detail: 0
}), SyntheticUIEvent = createSyntheticEvent(UIEventInterface), lastMovementX, lastMovementY, lastMouseEvent, MouseEventInterface = assign({}, UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== lastMouseEvent && (lastMouseEvent && "mousemove" === event.type ? (lastMovementX = event.screenX - lastMouseEvent.screenX, lastMovementY = event.screenY - lastMouseEvent.screenY) : lastMovementY = lastMovementX = 0, lastMouseEvent = event);
        return lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : lastMovementY;
    }
}), SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface), DragEventInterface = assign({}, MouseEventInterface, {
    dataTransfer: 0
}), SyntheticDragEvent = createSyntheticEvent(DragEventInterface), FocusEventInterface = assign({}, UIEventInterface, {
    relatedTarget: 0
}), SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface), AnimationEventInterface = assign({}, EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface), ClipboardEventInterface = assign({}, EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface), CompositionEventInterface = assign({}, EventInterface, {
    data: 0
}), SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface), normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function getEventModifierState() {
    return modifierStateGetter;
}
var KeyboardEventInterface = assign({}, UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface), PointerEventInterface = assign({}, MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface), TouchEventInterface = assign({}, UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: getEventModifierState
}), SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface), TransitionEventInterface = assign({}, EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface), WheelEventInterface = assign({}, MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface), ToggleEventInterface = assign({}, EventInterface, {
    newState: 0,
    oldState: 0
}), SyntheticToggleEvent = createSyntheticEvent(ToggleEventInterface), END_KEYCODES = [
    9,
    13,
    27,
    32
], canUseCompositionEvent = canUseDOM && "CompositionEvent" in window, documentMode = null;
canUseDOM && "documentMode" in document && (documentMode = document.documentMode);
var canUseTextInputEvent = canUseDOM && "TextEvent" in window && !documentMode, useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && 8 < documentMode && 11 >= documentMode), SPACEBAR_CHAR = String.fromCharCode(32), hasSpaceKeypress = !1;
function isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var isComposing = !1;
function getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            hasSpaceKeypress = !0;
            return SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === SPACEBAR_CHAR && hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if (isComposing) return "compositionend" === domEventName || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = getData(), fallbackText = startText = root = null, isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    restoreTarget ? restoreQueue ? restoreQueue.push(target) : restoreQueue = [
        target
    ] : restoreTarget = target;
    inst = accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var activeElement$1 = null, activeElementInst$1 = null;
function runEventInBatch(dispatchQueue) {
    processDispatchQueue(dispatchQueue, 0);
}
function getInstIfValueChanged(targetInst) {
    var targetNode = getNodeFromInstance(targetInst);
    if (updateValueIfChanged(targetNode)) return targetInst;
}
function getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var isInputEventSupported = !1;
if (canUseDOM) {
    var JSCompiler_inline_result$jscomp$286;
    if (canUseDOM) {
        var isSupported$jscomp$inline_427 = "oninput" in document;
        if (!isSupported$jscomp$inline_427) {
            var element$jscomp$inline_428 = document.createElement("div");
            element$jscomp$inline_428.setAttribute("oninput", "return;");
            isSupported$jscomp$inline_427 = "function" === typeof element$jscomp$inline_428.oninput;
        }
        JSCompiler_inline_result$jscomp$286 = isSupported$jscomp$inline_427;
    } else JSCompiler_inline_result$jscomp$286 = !1;
    isInputEventSupported = JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function stopWatchingForValueChange() {
    activeElement$1 && (activeElement$1.detachEvent("onpropertychange", handlePropertyChange), activeElementInst$1 = activeElement$1 = null);
}
function handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && getInstIfValueChanged(activeElementInst$1)) {
        var dispatchQueue = [];
        createAndAccumulateChangeEvent(dispatchQueue, activeElementInst$1, nativeEvent, getEventTarget(nativeEvent));
        batchedUpdates$1(runEventInBatch, dispatchQueue);
    }
}
function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? (stopWatchingForValueChange(), activeElement$1 = target, activeElementInst$1 = targetInst, activeElement$1.attachEvent("onpropertychange", handlePropertyChange)) : "focusout" === domEventName && stopWatchingForValueChange();
}
function getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return getInstIfValueChanged(activeElementInst$1);
}
function getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return getInstIfValueChanged(targetInst);
}
function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return getInstIfValueChanged(targetInst);
}
function is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var objectIs = "function" === typeof Object.is ? Object.is : is;
function shallowEqual(objA, objB) {
    if (objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!hasOwnProperty.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function getNodeForCharacterOffset(root, offset) {
    var node = getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = getLeafNode(node);
    }
}
function containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = getActiveElement(containerInfo.document);
    }
    return element;
}
function hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var skipSelectionChangeEvent = canUseDOM && "documentMode" in document && 11 >= document.documentMode, activeElement = null, activeElementInst = null, lastSelection = null, mouseDown = !1;
function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    mouseDown || null == activeElement || activeElement !== getActiveElement(doc) || (doc = activeElement, "selectionStart" in doc && hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), lastSelection && shallowEqual(lastSelection, doc) || (lastSelection = doc, doc = accumulateTwoPhaseListeners(activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = activeElement)));
}
function makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var vendorPrefixes = {
    animationend: makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: makePrefixMap("Animation", "AnimationIteration"),
    animationstart: makePrefixMap("Animation", "AnimationStart"),
    transitionrun: makePrefixMap("Transition", "TransitionRun"),
    transitionstart: makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: makePrefixMap("Transition", "TransitionCancel"),
    transitionend: makePrefixMap("Transition", "TransitionEnd")
}, prefixedEventNames = {}, style = {};
canUseDOM && (style = document.createElement("div").style, "AnimationEvent" in window || (delete vendorPrefixes.animationend.animation, delete vendorPrefixes.animationiteration.animation, delete vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete vendorPrefixes.transitionend.transition);
function getVendorPrefixedEventName(eventName) {
    if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
    if (!vendorPrefixes[eventName]) return eventName;
    var prefixMap = vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) return prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var ANIMATION_END = getVendorPrefixedEventName("animationend"), ANIMATION_ITERATION = getVendorPrefixedEventName("animationiteration"), ANIMATION_START = getVendorPrefixedEventName("animationstart"), TRANSITION_RUN = getVendorPrefixedEventName("transitionrun"), TRANSITION_START = getVendorPrefixedEventName("transitionstart"), TRANSITION_CANCEL = getVendorPrefixedEventName("transitioncancel"), TRANSITION_END = getVendorPrefixedEventName("transitionend"), topLevelEventsToReactNames = new Map(), simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
simpleEventPluginEvents.push("scrollEnd");
function registerSimpleEvent(domEventName, reactName) {
    topLevelEventsToReactNames.set(domEventName, reactName);
    registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, concurrentQueues = [], concurrentQueuesIndex = 0, concurrentlyUpdatedLanes = 0;
function finishQueueingConcurrentUpdates() {
    for(var endIndex = concurrentQueuesIndex, i = concurrentlyUpdatedLanes = concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = concurrentQueues[i];
        concurrentQueues[i++] = null;
        var queue = concurrentQueues[i];
        concurrentQueues[i++] = null;
        var update = concurrentQueues[i];
        concurrentQueues[i++] = null;
        var lane = concurrentQueues[i];
        concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function enqueueUpdate$1(fiber, queue, update, lane) {
    concurrentQueues[concurrentQueuesIndex++] = fiber;
    concurrentQueues[concurrentQueuesIndex++] = queue;
    concurrentQueues[concurrentQueuesIndex++] = update;
    concurrentQueues[concurrentQueuesIndex++] = lane;
    concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    enqueueUpdate$1(fiber, queue, update, lane);
    return getRootForUpdatedFiber(fiber);
}
function enqueueConcurrentRenderForLane(fiber, lane) {
    enqueueUpdate$1(fiber, null, null, lane);
    return getRootForUpdatedFiber(fiber);
}
function markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function getRootForUpdatedFiber(sourceFiber) {
    if (50 < nestedUpdateCount) throw nestedUpdateCount = 0, rootWithNestedUpdates = null, Error(formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var emptyContextObject = {};
function FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function createFiberImplClass(tag, pendingProps, key, mode) {
    return new FiberNode(tag, pendingProps, key, mode);
}
function shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = isHostHoistableType(type, pendingProps, contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case REACT_ACTIVITY_TYPE:
            return type = createFiberImplClass(31, pendingProps, key, mode), type.elementType = REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case REACT_FRAGMENT_TYPE:
            return createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case REACT_PROFILER_TYPE:
            return type = createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case REACT_SUSPENSE_TYPE:
            return type = createFiberImplClass(13, pendingProps, key, mode), type.elementType = REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case REACT_SUSPENSE_LIST_TYPE:
            return type = createFiberImplClass(19, pendingProps, key, mode), type.elementType = REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error(formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function createFiberFromFragment(elements, mode, lanes, key) {
    elements = createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function createFiberFromText(content, mode, lanes) {
    content = createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function createFiberFromPortal(portal, mode, lanes) {
    mode = createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var CapturedStacks = new WeakMap();
function createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source)
        };
        CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: getStackByFiberInDevAndProd(source)
    };
}
var forkStack = [], forkStackIndex = 0, treeForkProvider = null, treeForkCount = 0, idStack = [], idStackIndex = 0, treeContextProvider = null, treeContextId = 1, treeContextOverflow = "";
function pushTreeFork(workInProgress, totalChildren) {
    forkStack[forkStackIndex++] = treeForkCount;
    forkStack[forkStackIndex++] = treeForkProvider;
    treeForkProvider = workInProgress;
    treeForkCount = totalChildren;
}
function pushTreeId(workInProgress, totalChildren, index) {
    idStack[idStackIndex++] = treeContextId;
    idStack[idStackIndex++] = treeContextOverflow;
    idStack[idStackIndex++] = treeContextProvider;
    treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = treeContextId;
    workInProgress = treeContextOverflow;
    var baseLength = 32 - clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        treeContextId = 1 << 32 - clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        treeContextOverflow = length + workInProgress;
    } else treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, treeContextOverflow = workInProgress;
}
function pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && (pushTreeFork(workInProgress, 1), pushTreeId(workInProgress, 1, 0));
}
function popTreeContext(workInProgress) {
    for(; workInProgress === treeForkProvider;)treeForkProvider = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null, treeForkCount = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null;
    for(; workInProgress === treeContextProvider;)treeContextProvider = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextOverflow = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextId = idStack[--idStackIndex], idStack[idStackIndex] = null;
}
function restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    idStack[idStackIndex++] = treeContextId;
    idStack[idStackIndex++] = treeContextOverflow;
    idStack[idStackIndex++] = treeContextProvider;
    treeContextId = suspendedContext.id;
    treeContextOverflow = suspendedContext.overflow;
    treeContextProvider = workInProgress;
}
var hydrationParentFiber = null, nextHydratableInstance = null, isHydrating = !1, hydrationErrors = null, rootOrSingletonContext = !1, HydrationMismatchException = Error(formatProdErrorMessage(519));
function throwOnHydrationMismatch(fiber) {
    var error = Error(formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    queueHydrationError(createCapturedValueAtFiber(error, fiber));
    throw HydrationMismatchException;
}
function prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[internalInstanceKey] = fiber;
    instance[internalPropsKey] = props;
    switch(type){
        case "dialog":
            listenToNonDelegatedEvent("cancel", instance);
            listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < mediaEventTypes.length; type++)listenToNonDelegatedEvent(mediaEventTypes[type], instance);
            break;
        case "source":
            listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            listenToNonDelegatedEvent("error", instance);
            listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            listenToNonDelegatedEvent("invalid", instance);
            initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            listenToNonDelegatedEvent("invalid", instance), initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && (listenToNonDelegatedEvent("beforetoggle", instance), listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = noop$1), instance = !0) : instance = !1;
    instance || throwOnHydrationMismatch(fiber, !0);
}
function popToNextHostParent(fiber) {
    for(hydrationParentFiber = fiber.return; hydrationParentFiber;)switch(hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            rootOrSingletonContext = !0;
            return;
        default:
            hydrationParentFiber = hydrationParentFiber.return;
    }
}
function popHydrationState(fiber) {
    if (fiber !== hydrationParentFiber) return !1;
    if (!isHydrating) return popToNextHostParent(fiber), isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && nextHydratableInstance && throwOnHydrationMismatch(fiber);
    popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error(formatProdErrorMessage(317));
        nextHydratableInstance = getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error(formatProdErrorMessage(317));
        nextHydratableInstance = getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = nextHydratableInstance, isSingletonScope(fiber.type) ? (fiber = previousHydratableOnEnteringScopedSingleton, previousHydratableOnEnteringScopedSingleton = null, nextHydratableInstance = fiber) : nextHydratableInstance = tag) : nextHydratableInstance = hydrationParentFiber ? getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function resetHydrationState() {
    nextHydratableInstance = hydrationParentFiber = null;
    isHydrating = !1;
}
function upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = hydrationErrors;
    null !== queuedErrors && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = queuedErrors : workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, queuedErrors), hydrationErrors = null);
    return queuedErrors;
}
function queueHydrationError(error) {
    null === hydrationErrors ? hydrationErrors = [
        error
    ] : hydrationErrors.push(error);
}
var valueCursor = createCursor(null), currentlyRenderingFiber$1 = null, lastContextDependency = null;
function pushProvider(providerFiber, context, nextValue) {
    push(valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function popProvider(context) {
    context._currentValue = valueCursor.current;
    pop(valueCursor);
}
function scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error(formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error(formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error(formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push(HostTransitionContext) : current = [
                HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function prepareToReadContext(workInProgress) {
    currentlyRenderingFiber$1 = workInProgress;
    lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function readContext(context) {
    return readContextForConsumer(currentlyRenderingFiber$1, context);
}
function readContextDuringReconciliation(consumer, context) {
    null === currentlyRenderingFiber$1 && prepareToReadContext(consumer);
    return readContextForConsumer(consumer, context);
}
function readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === lastContextDependency) {
        if (null === consumer) throw Error(formatProdErrorMessage(308));
        lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else lastContextDependency = lastContextDependency.next = context;
    return value;
}
var AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, scheduleCallback$2 = Scheduler.unstable_scheduleCallback, NormalPriority = Scheduler.unstable_NormalPriority, CacheContext = {
    $$typeof: REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function createCache() {
    return {
        controller: new AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && scheduleCallback$2(NormalPriority, function() {
        cache.controller.abort();
    });
}
var currentEntangledListeners = null, currentEntangledPendingCount = 0, currentEntangledLane = 0, currentEntangledActionThenable = null;
function entangleAsyncAction(transition, thenable) {
    if (null === currentEntangledListeners) {
        var entangledListeners = currentEntangledListeners = [];
        currentEntangledPendingCount = 0;
        currentEntangledLane = requestTransitionLane();
        currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    currentEntangledPendingCount++;
    thenable.then(pingEngtangledActionScope, pingEngtangledActionScope);
    return thenable;
}
function pingEngtangledActionScope() {
    if (0 === --currentEntangledPendingCount && null !== currentEntangledListeners) {
        null !== currentEntangledActionThenable && (currentEntangledActionThenable.status = "fulfilled");
        var listeners = currentEntangledListeners;
        currentEntangledListeners = null;
        currentEntangledLane = 0;
        currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var prevOnStartTransitionFinish = ReactSharedInternals.S;
ReactSharedInternals.S = function(transition, returnValue) {
    globalMostRecentTransitionTime = now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && entangleAsyncAction(transition, returnValue);
    null !== prevOnStartTransitionFinish && prevOnStartTransitionFinish(transition, returnValue);
};
var resumedCache = createCursor(null);
function peekCacheFromPool() {
    var cacheResumedFromPreviousRender = resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : workInProgressRoot.pooledCache;
}
function pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? push(resumedCache, resumedCache.current) : push(resumedCache, prevCachePool.pool);
}
function getSuspendedCache() {
    var cacheFromPool = peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var SuspenseException = Error(formatProdErrorMessage(460)), SuspenseyCommitException = Error(formatProdErrorMessage(474)), SuspenseActionException = Error(formatProdErrorMessage(542)), noopSuspenseyCommitThenable = {
    then: function() {}
};
function isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then(noop$1, noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then(noop$1, noop$1);
            else {
                thenableState = workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error(formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            suspendedThenable = thenable;
            throw SuspenseException;
    }
}
function resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw suspendedThenable = x, SuspenseException;
        throw x;
    }
}
var suspendedThenable = null;
function getSuspendedThenable() {
    if (null === suspendedThenable) throw Error(formatProdErrorMessage(459));
    var thenable = suspendedThenable;
    suspendedThenable = null;
    return thenable;
}
function checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === SuspenseException || rejectedReason === SuspenseActionException) throw Error(formatProdErrorMessage(483));
}
var thenableState$1 = null, thenableIndexCounter$1 = 0;
function unwrapThenable(thenable) {
    var index = thenableIndexCounter$1;
    thenableIndexCounter$1 += 1;
    null === thenableState$1 && (thenableState$1 = []);
    return trackUsedThenable(thenableState$1, thenable, index);
}
function coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === REACT_LEGACY_ELEMENT_TYPE) throw Error(formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error(formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), coerceRef(current, element), current.return = returnFiber, current;
        current = createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    return lanes = createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case REACT_PORTAL_TYPE:
                    return newChild = createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case REACT_LAZY_TYPE:
                    return newChild = resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if (isArrayImpl(newChild) || getIteratorFn(newChild)) return newChild = createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return createChild(returnFiber, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case REACT_LAZY_TYPE:
                    return newChild = resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if (isArrayImpl(newChild) || getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case REACT_LAZY_TYPE:
                    return newChild = resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if (isArrayImpl(newChild) || getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            isHydrating && pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        isHydrating && pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error(formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            isHydrating && pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        isHydrating && pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === REACT_LAZY_TYPE && resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === REACT_FRAGMENT_TYPE ? (lanes = createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case REACT_LAZY_TYPE:
                    return newChild = resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if (isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if (getIteratorFn(newChild)) {
                key = getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error(formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === SuspenseException || x === SuspenseActionException) throw x;
            var fiber = createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var reconcileChildFibers = createChildReconciler(!0), mountChildFibers = createChildReconciler(!1), hasForceUpdate = !1;
function initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== (executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = getRootForUpdatedFiber(fiber);
        markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    enqueueUpdate$1(fiber, updateQueue, update, lane);
    return getRootForUpdatedFiber(fiber);
}
function entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        markRootEntangled(root, lane);
    }
}
function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var didReadFromEntangledAsyncAction = !1;
function suspendIfUpdateReadFromEntangledAsyncAction() {
    if (didReadFromEntangledAsyncAction) {
        var entangledActionThenable = currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = assign({}, newState, updateLane);
                            break a;
                        case 2:
                            hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error(formatProdErrorMessage(191, callback));
    callback.call(context);
}
function commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)callCallback(callbacks[updateQueue], context);
}
var currentTreeHiddenStackCursor = createCursor(null), prevEntangledRenderLanesCursor = createCursor(0);
function pushHiddenContext(fiber, context) {
    fiber = entangledRenderLanes;
    push(prevEntangledRenderLanesCursor, fiber);
    push(currentTreeHiddenStackCursor, context);
    entangledRenderLanes = fiber | context.baseLanes;
}
function reuseHiddenContextOnStack() {
    push(prevEntangledRenderLanesCursor, entangledRenderLanes);
    push(currentTreeHiddenStackCursor, currentTreeHiddenStackCursor.current);
}
function popHiddenContext() {
    entangledRenderLanes = prevEntangledRenderLanesCursor.current;
    pop(currentTreeHiddenStackCursor);
    pop(prevEntangledRenderLanesCursor);
}
var suspenseHandlerStackCursor = createCursor(null), shellBoundary = null;
function pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    push(suspenseStackCursor, suspenseStackCursor.current & 1);
    push(suspenseHandlerStackCursor, handler);
    null === shellBoundary && (null === current || null !== currentTreeHiddenStackCursor.current ? shellBoundary = handler : null !== current.memoizedState && (shellBoundary = handler));
}
function pushDehydratedActivitySuspenseHandler(fiber) {
    push(suspenseStackCursor, suspenseStackCursor.current);
    push(suspenseHandlerStackCursor, fiber);
    null === shellBoundary && (shellBoundary = fiber);
}
function pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? (push(suspenseStackCursor, suspenseStackCursor.current), push(suspenseHandlerStackCursor, fiber), null === shellBoundary && (shellBoundary = fiber)) : reuseSuspenseHandlerOnStack(fiber);
}
function reuseSuspenseHandlerOnStack() {
    push(suspenseStackCursor, suspenseStackCursor.current);
    push(suspenseHandlerStackCursor, suspenseHandlerStackCursor.current);
}
function popSuspenseHandler(fiber) {
    pop(suspenseHandlerStackCursor);
    shellBoundary === fiber && (shellBoundary = null);
    pop(suspenseStackCursor);
}
var suspenseStackCursor = createCursor(0);
function findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || isSuspenseInstancePending(state) || isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var renderLanes = 0, currentlyRenderingFiber = null, currentHook = null, workInProgressHook = null, didScheduleRenderPhaseUpdate = !1, didScheduleRenderPhaseUpdateDuringThisPass = !1, shouldDoubleInvokeUserFnsInHooksDEV = !1, localIdCounter = 0, thenableIndexCounter = 0, thenableState = null, globalClientIdCounter = 0;
function throwInvalidHookError() {
    throw Error(formatProdErrorMessage(321));
}
function areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    renderLanes = nextRenderLanes;
    currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    ReactSharedInternals.H = null === current || null === current.memoizedState ? HooksDispatcherOnMount : HooksDispatcherOnUpdate;
    shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    shouldDoubleInvokeUserFnsInHooksDEV = !1;
    didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = renderWithHooksAgain(workInProgress, Component, props, secondArg));
    finishRenderingHooks(current);
    return nextRenderLanes;
}
function finishRenderingHooks(current) {
    ReactSharedInternals.H = ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== currentHook && null !== currentHook.next;
    renderLanes = 0;
    workInProgressHook = currentHook = currentlyRenderingFiber = null;
    didScheduleRenderPhaseUpdate = !1;
    thenableIndexCounter = 0;
    thenableState = null;
    if (didRenderTooFewHooks) throw Error(formatProdErrorMessage(300));
    null === current || didReceiveUpdate || (current = current.dependencies, null !== current && checkIfContextChanged(current) && (didReceiveUpdate = !0));
}
function renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        didScheduleRenderPhaseUpdateDuringThisPass && (thenableState = null);
        thenableIndexCounter = 0;
        didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error(formatProdErrorMessage(301));
        numberOfReRenders += 1;
        workInProgressHook = currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        ReactSharedInternals.H = HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while (didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function TransitionAwareHostComponent() {
    var dispatcher = ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== currentHook ? currentHook.memoizedState : null) !== dispatcher && (currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== localIdCounter;
    localIdCounter = 0;
    return didRenderIdHook;
}
function bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function resetHooksOnUnwind(workInProgress) {
    if (didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        didScheduleRenderPhaseUpdate = !1;
    }
    renderLanes = 0;
    workInProgressHook = currentHook = currentlyRenderingFiber = null;
    didScheduleRenderPhaseUpdateDuringThisPass = !1;
    thenableIndexCounter = localIdCounter = 0;
    thenableState = null;
}
function mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = hook : workInProgressHook = workInProgressHook.next = hook;
    return workInProgressHook;
}
function updateWorkInProgressHook() {
    if (null === currentHook) {
        var nextCurrentHook = currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = currentHook.next;
    var nextWorkInProgressHook = null === workInProgressHook ? currentlyRenderingFiber.memoizedState : workInProgressHook.next;
    if (null !== nextWorkInProgressHook) workInProgressHook = nextWorkInProgressHook, currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === currentlyRenderingFiber.alternate) throw Error(formatProdErrorMessage(467));
            throw Error(formatProdErrorMessage(310));
        }
        currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: currentHook.memoizedState,
            baseState: currentHook.baseState,
            baseQueue: currentHook.baseQueue,
            queue: currentHook.queue,
            next: null
        };
        null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = nextCurrentHook : workInProgressHook = workInProgressHook.next = nextCurrentHook;
    }
    return workInProgressHook;
}
function createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function useThenable(thenable) {
    var index = thenableIndexCounter;
    thenableIndexCounter += 1;
    null === thenableState && (thenableState = []);
    thenable = trackUsedThenable(thenableState, thenable, index);
    index = currentlyRenderingFiber;
    null === (null === workInProgressHook ? index.memoizedState : workInProgressHook.next) && (index = index.alternate, ReactSharedInternals.H = null === index || null === index.memoizedState ? HooksDispatcherOnMount : HooksDispatcherOnUpdate);
    return thenable;
}
function use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return useThenable(usable);
        if (usable.$$typeof === REACT_CONTEXT_TYPE) return readContext(usable);
    }
    throw Error(formatProdErrorMessage(438, String(usable)));
}
function useMemoCache(size) {
    var memoCache = null, updateQueue = currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function updateReducer(reducer) {
    var hook = updateWorkInProgressHook();
    return updateReducerImpl(hook, currentHook, reducer);
}
function updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error(formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if ((renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, currentlyRenderingFiber.lanes |= revertLane, workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, currentlyRenderingFiber.lanes |= updateLane, workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!objectIs(pendingQueue, hook.memoizedState) && (didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function rerenderReducer(reducer) {
    var hook = updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error(formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        objectIs(newState, hook.memoizedState) || (didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = currentlyRenderingFiber, hook = updateWorkInProgressHook(), isHydrating$jscomp$0 = isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error(formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !objectIs((currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, didReceiveUpdate = !0);
    hook = hook.queue;
    updateEffect(subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== workInProgressHook && workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        pushSimpleEffect(9, {
            destroy: void 0
        }, updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === workInProgressRoot) throw Error(formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== (renderLanes & 127) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
}
function subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
    });
}
function checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function forceStoreRerender(fiber) {
    var root = enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && scheduleUpdateOnFiber(root, fiber, 2);
}
function mountStateImpl(initialState) {
    var hook = mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
            setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return updateReducerImpl(hook, currentHook, "function" === typeof reducer ? reducer : basicStateReducer);
}
function dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if (isRenderPhaseUpdate(fiber)) throw Error(formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = ReactSharedInternals.T, currentTransition = {};
        ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        onActionError(actionQueue, node, error$66);
    }
}
function handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return onActionError(actionQueue, node, error);
    }) : onActionSuccess(actionQueue, node, returnValue);
}
function onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, runActionStateAction(actionQueue, nextState)));
}
function onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function actionStateReducer(oldState, newState) {
    return newState;
}
function mountActionState(action, initialStateProp) {
    if (isHydrating) {
        var ssrFormState = workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = currentlyRenderingFiber;
                if (isHydrating) {
                    if (nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = nextHydratableInstance;
                            for(var inRootOrSingleton = rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            nextHydratableInstance = getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = dispatchSetState.bind(null, currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = mountStateImpl(!1);
    inRootOrSingleton = dispatchOptimisticSetState.bind(null, currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = dispatchActionState.bind(null, currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function updateActionState(action) {
    var stateHook = updateWorkInProgressHook();
    return updateActionStateImpl(stateHook, currentHook, action);
}
function updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = updateReducerImpl(stateHook, currentStateHook, actionStateReducer)[0];
    stateHook = updateReducer(basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = useThenable(currentStateHook);
    } catch (x) {
        if (x === SuspenseException) throw SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && (currentlyRenderingFiber.flags |= 2048, pushSimpleEffect(9, {
        destroy: void 0
    }, actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function rerenderActionState(action) {
    var stateHook = updateWorkInProgressHook(), currentStateHook = currentHook;
    if (null !== currentStateHook) return updateActionStateImpl(stateHook, currentStateHook, action);
    updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = currentlyRenderingFiber.updateQueue;
    null === inst && (inst = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function updateRef() {
    return updateWorkInProgressHook().memoizedState;
}
function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = mountWorkInProgressHook();
    currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== currentHook && null !== deps && areHookInputsEqual(deps, currentHook.memoizedState.deps) ? hook.memoizedState = pushSimpleEffect(hookFlags, inst, create, deps) : (currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function mountEffect(create, deps) {
    mountEffectImpl(8390656, 8, create, deps);
}
function updateEffect(create, deps) {
    updateEffectImpl(2048, 8, create, deps);
}
function useEffectEventImpl(payload) {
    currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function updateEvent(callback) {
    var ref = updateWorkInProgressHook().memoizedState;
    useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== (executionContext & 2)) throw Error(formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function updateInsertionEffect(create, deps) {
    return updateEffectImpl(4, 2, create, deps);
}
function updateLayoutEffect(create, deps) {
    return updateEffectImpl(4, 4, create, deps);
}
function imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    updateEffectImpl(4, 4, imperativeHandleEffect.bind(null, create, ref), deps);
}
function mountDebugValue() {}
function updateCallback(callback, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function updateMemo(nextCreate, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if (shouldDoubleInvokeUserFnsInHooksDEV) {
        setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== (renderLanes & 1073741824) && 0 === (workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = requestDeferredLane();
    currentlyRenderingFiber.lanes |= hook;
    workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if (objectIs(value, prevValue)) return value;
    if (null !== currentTreeHiddenStackCursor.current) return hook = mountDeferredValueImpl(hook, value, initialValue), objectIs(hook, prevValue) || (didReceiveUpdate = !0), hook;
    if (0 === (renderLanes & 42) || 0 !== (renderLanes & 1073741824) && 0 === (workInProgressRootRenderLanes & 261930)) return didReceiveUpdate = !0, hook.memoizedState = value;
    hook = requestDeferredLane();
    currentlyRenderingFiber.lanes |= hook;
    workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = ReactDOMSharedInternals.p;
    ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = ReactSharedInternals.T, currentTransition = {};
    ReactSharedInternals.T = currentTransition;
    dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = chainThenableValue(returnValue, finishedState);
            dispatchSetStateInternal(fiber, queue, thenableForFinishedState, requestUpdateLane(fiber));
        } else dispatchSetStateInternal(fiber, queue, finishedState, requestUpdateLane(fiber));
    } catch (error) {
        dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, requestUpdateLane());
    } finally{
        ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition;
    }
}
function noop() {}
function startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error(formatProdErrorMessage(476));
    var queue = ensureFormComponentIsStateful(formFiber).queue;
    startTransition(formFiber, queue, pendingState, sharedNotPendingObject, null === action ? noop : function() {
        requestFormReset$1(formFiber);
        return action(formData);
    });
}
function ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: sharedNotPendingObject,
        baseState: sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function requestFormReset$1(formFiber) {
    var stateHook = ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, requestUpdateLane());
}
function useHostTransitionStatus() {
    return readContext(HostTransitionContext);
}
function updateId() {
    return updateWorkInProgressHook().memoizedState;
}
function updateRefresh() {
    return updateWorkInProgressHook().memoizedState;
}
function refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = requestUpdateLane();
                fiber = createUpdate(lane);
                var root$69 = enqueueUpdate(provider, fiber, lane);
                null !== root$69 && (scheduleUpdateOnFiber(root$69, provider, lane), entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function dispatchReducerAction(fiber, queue, action) {
    var lane = requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    isRenderPhaseUpdate(fiber) ? enqueueRenderPhaseUpdate(queue, action) : (action = enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && (scheduleUpdateOnFiber(action, fiber, lane), entangleTransitionUpdate(action, queue, lane)));
}
function dispatchSetState(fiber, queue, action) {
    var lane = requestUpdateLane();
    dispatchSetStateInternal(fiber, queue, action, lane);
}
function dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if (objectIs(eagerState, currentState)) return enqueueUpdate$1(fiber, queue, update, 0), null === workInProgressRoot && finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return scheduleUpdateOnFiber(action, fiber, lane), entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error(formatProdErrorMessage(479));
    } else throwIfDuringRender = enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === currentlyRenderingFiber || null !== alternate && alternate === currentlyRenderingFiber;
}
function enqueueRenderPhaseUpdate(queue, update) {
    didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        markRootEntangled(root, lane);
    }
}
var ContextOnlyDispatcher = {
    readContext: readContext,
    use: use,
    useCallback: throwInvalidHookError,
    useContext: throwInvalidHookError,
    useEffect: throwInvalidHookError,
    useImperativeHandle: throwInvalidHookError,
    useLayoutEffect: throwInvalidHookError,
    useInsertionEffect: throwInvalidHookError,
    useMemo: throwInvalidHookError,
    useReducer: throwInvalidHookError,
    useRef: throwInvalidHookError,
    useState: throwInvalidHookError,
    useDebugValue: throwInvalidHookError,
    useDeferredValue: throwInvalidHookError,
    useTransition: throwInvalidHookError,
    useSyncExternalStore: throwInvalidHookError,
    useId: throwInvalidHookError,
    useHostTransitionStatus: throwInvalidHookError,
    useFormState: throwInvalidHookError,
    useActionState: throwInvalidHookError,
    useOptimistic: throwInvalidHookError,
    useMemoCache: throwInvalidHookError,
    useCacheRefresh: throwInvalidHookError
};
ContextOnlyDispatcher.useEffectEvent = throwInvalidHookError;
var HooksDispatcherOnMount = {
    readContext: readContext,
    use: use,
    useCallback: function(callback, deps) {
        mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: readContext,
    useEffect: mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        mountEffectImpl(4194308, 4, imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
            setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if (shouldDoubleInvokeUserFnsInHooksDEV) {
                setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = dispatchReducerAction.bind(null, currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = dispatchSetState.bind(null, currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = mountWorkInProgressHook();
        return mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = mountStateImpl(!1);
        stateHook = startTransition.bind(null, currentlyRenderingFiber, stateHook.queue, !0, !1);
        mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber, hook = mountWorkInProgressHook();
        if (isHydrating) {
            if (void 0 === getServerSnapshot) throw Error(formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === workInProgressRoot) throw Error(formatProdErrorMessage(349));
            0 !== (workInProgressRootRenderLanes & 127) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        mountEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        pushSimpleEffect(9, {
            destroy: void 0
        }, updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = mountWorkInProgressHook(), identifierPrefix = workInProgressRoot.identifierPrefix;
        if (isHydrating) {
            var JSCompiler_inline_result = treeContextOverflow;
            var idWithLeadingBit = treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: useHostTransitionStatus,
    useFormState: mountActionState,
    useActionState: mountActionState,
    useOptimistic: function(passthrough) {
        var hook = mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = dispatchOptimisticSetState.bind(null, currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: useMemoCache,
    useCacheRefresh: function() {
        return mountWorkInProgressHook().memoizedState = refreshCache.bind(null, currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== (executionContext & 2)) throw Error(formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, HooksDispatcherOnUpdate = {
    readContext: readContext,
    use: use,
    useCallback: updateCallback,
    useContext: readContext,
    useEffect: updateEffect,
    useImperativeHandle: updateImperativeHandle,
    useInsertionEffect: updateInsertionEffect,
    useLayoutEffect: updateLayoutEffect,
    useMemo: updateMemo,
    useReducer: updateReducer,
    useRef: updateRef,
    useState: function() {
        return updateReducer(basicStateReducer);
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = updateWorkInProgressHook();
        return updateDeferredValueImpl(hook, currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = updateReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: updateSyncExternalStore,
    useId: updateId,
    useHostTransitionStatus: useHostTransitionStatus,
    useFormState: updateActionState,
    useActionState: updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = updateWorkInProgressHook();
        return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
    },
    useMemoCache: useMemoCache,
    useCacheRefresh: updateRefresh
};
HooksDispatcherOnUpdate.useEffectEvent = updateEvent;
var HooksDispatcherOnRerender = {
    readContext: readContext,
    use: use,
    useCallback: updateCallback,
    useContext: readContext,
    useEffect: updateEffect,
    useImperativeHandle: updateImperativeHandle,
    useInsertionEffect: updateInsertionEffect,
    useLayoutEffect: updateLayoutEffect,
    useMemo: updateMemo,
    useReducer: rerenderReducer,
    useRef: updateRef,
    useState: function() {
        return rerenderReducer(basicStateReducer);
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = updateWorkInProgressHook();
        return null === currentHook ? mountDeferredValueImpl(hook, value, initialValue) : updateDeferredValueImpl(hook, currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = rerenderReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: updateSyncExternalStore,
    useId: updateId,
    useHostTransitionStatus: useHostTransitionStatus,
    useFormState: rerenderActionState,
    useActionState: rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = updateWorkInProgressHook();
        if (null !== currentHook) return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: useMemoCache,
    useCacheRefresh: updateRefresh
};
HooksDispatcherOnRerender.useEffectEvent = updateEvent;
function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(), update = createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = enqueueUpdate(inst, update, lane);
        null !== payload && (scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(), update = createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = enqueueUpdate(inst, update, lane);
        null !== payload && (scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(), update = createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = enqueueUpdate(inst, update, lane);
        null !== callback && (scheduleUpdateOnFiber(callback, inst, lane), entangleTransitions(callback, inst, lane));
    }
};
function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState) : !0;
}
function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function defaultOnUncaughtError(error) {
    reportGlobalError(error);
}
function defaultOnCaughtError(error) {
    console.error(error);
}
function defaultOnRecoverableError(error) {
    reportGlobalError(error);
}
function logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function createRootErrorUpdate(root, errorInfo, lane) {
    lane = createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        logUncaughtError(root, errorInfo);
    };
    return lane;
}
function createClassErrorUpdate(lane) {
    lane = createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === legacyErrorBoundariesThatAlreadyFailed ? legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === shellBoundary ? renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === workInProgressRootExitStatus && (workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error(formatProdErrorMessage(435, sourceFiber.tag));
        }
        attachPingListener(root, value, rootRenderLanes);
        renderDidSuspendDelayIfPossible();
        return !1;
    }
    if (isHydrating) return returnFiber = suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== HydrationMismatchException && (root = Error(formatProdErrorMessage(422), {
        cause: value
    }), queueHydrationError(createCapturedValueAtFiber(root, sourceFiber)))) : (value !== HydrationMismatchException && (returnFiber = Error(formatProdErrorMessage(423), {
        cause: value
    }), queueHydrationError(createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = createRootErrorUpdate(root.stateNode, value, rootRenderLanes), enqueueCapturedUpdate(root, rootRenderLanes), 4 !== workInProgressRootExitStatus && (workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error(formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === workInProgressRootConcurrentErrors ? workInProgressRootConcurrentErrors = [
        wrapperError
    ] : workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== workInProgressRootExitStatus && (workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = createRootErrorUpdate(sourceFiber.stateNode, value, root), enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = createClassErrorUpdate(rootRenderLanes), initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var SelectiveHydrationException = Error(formatProdErrorMessage(461)), didReceiveUpdate = !1;
function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? mountChildFibers(workInProgress, null, nextChildren, renderLanes) : reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    prepareToReadContext(workInProgress);
    nextProps = renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = checkDidRenderIdHook();
    if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    isHydrating && key && pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if (didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && (didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? pushHiddenContext(workInProgress, prevState) : reuseHiddenContextOnStack(), pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? (pushTransition(workInProgress, prevState.cachePool), pushHiddenContext(workInProgress, prevState), reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && pushTransition(workInProgress, null), reuseHiddenContextOnStack(), reuseSuspenseHandlerOnStack(workInProgress));
    reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && pushTransition(workInProgress, null);
    reuseHiddenContextOnStack();
    pushOffscreenSuspenseHandler(workInProgress);
    null !== current && propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function mountActivityChildren(workInProgress, nextProps) {
    nextProps = mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if (isHydrating) {
            if ("hidden" === nextProps.mode) return current = mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, bailoutOffscreenComponent(null, current);
            pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = nextHydratableInstance) ? (current = canHydrateHydrationBoundary(current, rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== treeContextProvider ? {
                    id: treeContextId,
                    overflow: treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, hydrationParentFiber = workInProgress, nextHydratableInstance = null)) : current = null;
            if (null === current) throw throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error(formatProdErrorMessage(558));
        } else if (didReceiveUpdate || propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), didReceiveUpdate || didSuspend) {
            nextProps = workInProgressRoot;
            if (null !== nextProps && (dehydrated = getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, enqueueConcurrentRenderForLane(current, dehydrated), scheduleUpdateOnFiber(nextProps, current, dehydrated), SelectiveHydrationException;
            renderDidSuspendDelayIfPossible();
            workInProgress = retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, nextHydratableInstance = getNextHydratable(dehydrated.nextSibling), hydrationParentFiber = workInProgress, isHydrating = !0, hydrationErrors = null, rootOrSingletonContext = !1, null !== current && restoreSuspendedTreeContext(workInProgress, current), workInProgress = mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error(formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    prepareToReadContext(workInProgress);
    Component = renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = checkDidRenderIdHook();
    if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    isHydrating && nextProps && pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    finishRenderingHooks(current);
    Component = checkDidRenderIdHook();
    if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    isHydrating && Component && pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? readContext(contextType) : emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && (applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && classComponentUpdater.enqueueReplaceState(context, context.state, null), processUpdateQueue(workInProgress, nextProps, context, renderLanes), suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && (applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = hasForceUpdate || checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || hasForceUpdate || null !== current && null !== current.dependencies && checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && (applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = hasForceUpdate || checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = reconcileChildFibers(workInProgress, null, Component, renderLanes)) : reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    resetHydrationState();
    workInProgress.flags |= 256;
    reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: getSuspendedCache()
    };
}
function getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= workInProgressDeferredLane);
    return current;
}
function updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== (suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if (isHydrating) {
            showFallback ? pushPrimaryTreeSuspenseHandler(workInProgress) : reuseSuspenseHandlerOnStack(workInProgress);
            (current = nextHydratableInstance) ? (current = canHydrateHydrationBoundary(current, rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== treeContextProvider ? {
                    id: treeContextId,
                    overflow: treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, hydrationParentFiber = workInProgress, nextHydratableInstance = null)) : current = null;
            if (null === current) throw throwOnHydrationMismatch(workInProgress);
            isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, bailoutOffscreenComponent(null, nextProps);
        pushPrimaryTreeSuspenseHandler(workInProgress);
        return mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? (pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? (reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : (reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, workInProgress = bailoutOffscreenComponent(null, nextProps));
        else if (pushPrimaryTreeSuspenseHandler(workInProgress), isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error(formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if (didReceiveUpdate || propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, enqueueConcurrentRenderForLane(current, nextProps), scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), SelectiveHydrationException;
            isSuspenseInstancePending(nextPrimaryChildren) || renderDidSuspendDelayIfPossible();
            workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, nextHydratableInstance = getNextHydratable(nextPrimaryChildren.nextSibling), hydrationParentFiber = workInProgress, isHydrating = !0, hydrationErrors = null, rootOrSingletonContext = !1, null !== current && restoreSuspendedTreeContext(workInProgress, current), workInProgress = mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, bailoutOffscreenComponent(current.child, nextProps);
    pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    push(suspenseStackCursor, suspenseContext);
    reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = isHydrating ? treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if (propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error(formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && checkIfContextChanged(current) ? !0 : !1;
}
function attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            pushProvider(workInProgress, CacheContext, current.memoizedState.cache);
            resetHydrationState();
            break;
        case 27:
        case 5:
            pushHostContext(workInProgress);
            break;
        case 4:
            pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return updateSuspenseComponent(current, workInProgress, renderLanes);
                pushPrimaryTreeSuspenseHandler(workInProgress);
                current = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || (propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            push(suspenseStackCursor, suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            pushProvider(workInProgress, CacheContext, current.memoizedState.cache);
    }
    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) didReceiveUpdate = !0;
        else {
            if (!checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return didReceiveUpdate = !1, attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else didReceiveUpdate = !1, isHydrating && 0 !== (workInProgress.flags & 1048576) && pushTreeId(workInProgress, treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) shouldConstruct(current) ? (props = resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = getComponentNameFromType(current) || current;
                    throw Error(formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = resolveClassComponentProps(props, workInProgress.pendingProps), updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error(formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                cloneUpdateQueue(current, workInProgress);
                processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                pushProvider(workInProgress, CacheContext, props);
                props !== prevState.cache && propagateContextChanges(workInProgress, [
                    CacheContext
                ], renderLanes, !0);
                suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = createCapturedValueAtFiber(Error(formatProdErrorMessage(424)), workInProgress);
                        queueHydrationError($$typeof);
                        workInProgress = mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        nextHydratableInstance = getNextHydratable(current.firstChild);
                        hydrationParentFiber = workInProgress;
                        isHydrating = !0;
                        hydrationErrors = null;
                        rootOrSingletonContext = !0;
                        renderLanes = mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return markRef(current, workInProgress), null === current ? (renderLanes = getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = getOwnerDocumentFromRootContainer(rootInstanceStackCursor.current).createElement(renderLanes), props[internalInstanceKey] = workInProgress, props[internalPropsKey] = current, setInitialProperties(props, renderLanes, current), markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return pushHostContext(workInProgress), null === current && isHydrating && (props = workInProgress.stateNode = resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, rootInstanceStackCursor.current), hydrationParentFiber = workInProgress, rootOrSingletonContext = !0, $$typeof = nextHydratableInstance, isSingletonScope(workInProgress.type) ? (previousHydratableOnEnteringScopedSingleton = $$typeof, nextHydratableInstance = getNextHydratable(props.firstChild)) : nextHydratableInstance = $$typeof), reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && isHydrating) {
                if ($$typeof = props = nextHydratableInstance) props = canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, hydrationParentFiber = workInProgress, nextHydratableInstance = getNextHydratable(props.firstChild), rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || throwOnHydrationMismatch(workInProgress);
            }
            pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = renderWithHooks(current, workInProgress, TransitionAwareHostComponent, null, null, renderLanes), HostTransitionContext._currentValue = $$typeof);
            markRef(current, workInProgress);
            reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && isHydrating) {
                if (current = renderLanes = nextHydratableInstance) renderLanes = canHydrateTextInstance(renderLanes, workInProgress.pendingProps, rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, hydrationParentFiber = workInProgress, nextHydratableInstance = null, current = !0) : current = !1;
                current || throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = reconcileChildFibers(workInProgress, null, props, renderLanes) : reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, pushProvider(workInProgress, workInProgress.type, props.value), reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, prepareToReadContext(workInProgress), $$typeof = readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return prepareToReadContext(workInProgress), props = readContext(CacheContext), null === current ? ($$typeof = peekCacheFromPool(), null === $$typeof && ($$typeof = workInProgressRoot, prevState = createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, initializeUpdateQueue(workInProgress), pushProvider(workInProgress, CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && (cloneUpdateQueue(current, workInProgress), processUpdateQueue(workInProgress, null, null, renderLanes), suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), pushProvider(workInProgress, CacheContext, props)) : (props = prevState.cache, pushProvider(workInProgress, CacheContext, props), props !== $$typeof.cache && propagateContextChanges(workInProgress, [
                CacheContext
            ], renderLanes, !0))), reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error(formatProdErrorMessage(156, workInProgress.tag));
}
function markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if (shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !preloadResource(resource)) {
        if (shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
    }
}
function scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, workInProgressSuspendedRetryLanes |= retryQueue);
}
function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return bubbleProperties(workInProgress), null;
        case 1:
            return bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            popProvider(CacheContext);
            popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) popHydrationState(workInProgress) ? markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, upgradeHydrationErrorsToRecoverable());
            bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? (markUpdate(workInProgress), null !== nextResource ? (bubbleProperties(workInProgress), preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : (bubbleProperties(workInProgress), preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? (markUpdate(workInProgress), bubbleProperties(workInProgress), preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : (bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && markUpdate(workInProgress), bubbleProperties(workInProgress), preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            popHostContext(workInProgress);
            renderLanes = rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error(formatProdErrorMessage(166));
                    bubbleProperties(workInProgress);
                    return null;
                }
                current = contextStackCursor.current;
                popHydrationState(workInProgress) ? prepareToHydrateHostInstance(workInProgress, current) : (current = resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, markUpdate(workInProgress));
            }
            bubbleProperties(workInProgress);
            return null;
        case 5:
            popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error(formatProdErrorMessage(166));
                    bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = contextStackCursor.current;
                if (popHydrationState(workInProgress)) prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = getOwnerDocumentFromRootContainer(rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[internalInstanceKey] = workInProgress;
                    nextResource[internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch(setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && markUpdate(workInProgress);
                }
            }
            bubbleProperties(workInProgress);
            preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error(formatProdErrorMessage(166));
                current = rootInstanceStackCursor.current;
                if (popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || throwOnHydrationMismatch(workInProgress, !0);
                } else current = getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error(formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error(formatProdErrorMessage(557));
                        current[internalInstanceKey] = workInProgress;
                    } else resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return popSuspenseHandler(workInProgress), workInProgress;
                    popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error(formatProdErrorMessage(558));
            }
            bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error(formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error(formatProdErrorMessage(317));
                        type[internalInstanceKey] = workInProgress;
                    } else resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    bubbleProperties(workInProgress);
                    type = !1;
                } else type = upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return popSuspenseHandler(workInProgress), workInProgress;
                    popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            bubbleProperties(workInProgress);
            return null;
        case 4:
            return popHostContainer(), null === current && listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), bubbleProperties(workInProgress), null;
        case 10:
            return popProvider(workInProgress.type), bubbleProperties(workInProgress), null;
        case 19:
            pop(suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            push(suspenseStackCursor, suspenseStackCursor.current & 1 | 2);
                            isHydrating && pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && now() > workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, scheduleRetryEffect(workInProgress, current), cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !isHydrating) return bubbleProperties(workInProgress), null;
                    } else 2 * now() - newProps.renderingStartTime > workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = now(), current.sibling = null, renderLanes = suspenseStackCursor.current, push(suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), isHydrating && pushTreeFork(workInProgress, newProps.treeForkCount), current;
            bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return popSuspenseHandler(workInProgress), popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && (bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && pop(resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), popProvider(CacheContext), bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error(formatProdErrorMessage(156, workInProgress.tag));
}
function unwindWork(current, workInProgress) {
    popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return popProvider(CacheContext), popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error(formatProdErrorMessage(340));
                resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error(formatProdErrorMessage(340));
                resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return pop(suspenseStackCursor), null;
        case 4:
            return popHostContainer(), null;
        case 10:
            return popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return popSuspenseHandler(workInProgress), popHiddenContext(), null !== current && pop(resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return popProvider(CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function unwindInterruptedWork(current, interruptedWork) {
    popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            popProvider(CacheContext);
            popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            popHostContext(interruptedWork);
            break;
        case 4:
            popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && popSuspenseHandler(interruptedWork);
            break;
        case 13:
            popSuspenseHandler(interruptedWork);
            break;
        case 19:
            pop(suspenseStackCursor);
            break;
        case 10:
            popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            popSuspenseHandler(interruptedWork);
            popHiddenContext();
            null !== current && pop(resumedCache);
            break;
        case 24:
            popProvider(CacheContext);
    }
}
function commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            commitCallbacks(updateQueue, instance);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[internalPropsKey] = newProps;
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = noop$1));
    else if (4 !== tag && (27 === tag && isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for(insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for(insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        setInitialProperties(singleton, type, props);
        singleton[internalInstanceKey] = finishedWork;
        singleton[internalPropsKey] = props;
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var offscreenSubtreeIsHidden = !1, offscreenSubtreeWasHidden = !1, needsFormReset = !1, PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, nextEffect = null;
function commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    eventsEnabled = _enabled;
    root = getActiveElementDeep(root);
    if (hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    _enabled = !1;
    for(nextEffect = firstChild; null !== nextEffect;)if (firstChild = nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, nextEffect = root;
    else for(; null !== nextEffect;){
        firstChild = nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error(formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            nextEffect = root;
            break;
        }
        nextEffect = firstChild.return;
    }
}
function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && commitClassCallbacks(finishedWork);
            flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    commitCallbacks(finishedRoot, current);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && commitHostMount(finishedWork);
            flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = retryDehydratedSuspenseBoundary.bind(null, finishedWork), registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || offscreenSubtreeWasHidden;
                prevProps = offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                offscreenSubtreeIsHidden = flags;
                (offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                offscreenSubtreeIsHidden = prevProps;
                offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var hostParent = null, hostParentIsContainer = !1;
function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if (injectedHook && "function" === typeof injectedHook.onCommitFiberUnmount) try {
        injectedHook.onCommitFiberUnmount(rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = hostParent, prevHostParentIsContainer = hostParentIsContainer;
            isSingletonScope(deletedFiber.type) && (hostParent = deletedFiber.stateNode, hostParentIsContainer = !1);
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            releaseSingletonInstance(deletedFiber.stateNode);
            hostParent = prevHostParent;
            hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = hostParent;
            prevHostParentIsContainer = hostParentIsContainer;
            hostParent = null;
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            hostParent = prevHostParent;
            hostParentIsContainer = prevHostParentIsContainer;
            if (null !== hostParent) {
                if (hostParentIsContainer) try {
                    (9 === hostParent.nodeType ? hostParent.body : "HTML" === hostParent.nodeName ? hostParent.ownerDocument.body : hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== hostParent && (hostParentIsContainer ? (finishedRoot = hostParent, clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), retryIfBlockedOn(finishedRoot)) : clearHydrationBoundary(hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = hostParent;
            prevHostParentIsContainer = hostParentIsContainer;
            hostParent = deletedFiber.stateNode.containerInfo;
            hostParentIsContainer = !0;
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            hostParent = prevHostParent;
            hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            offscreenSubtreeWasHidden || commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            offscreenSubtreeWasHidden || (safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            offscreenSubtreeWasHidden = (prevHostParent = offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            retryIfBlockedOn(finishedRoot);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        retryIfBlockedOn(finishedRoot);
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new PossiblyWeakSet()), retryCache;
        default:
            throw Error(formatProdErrorMessage(435, finishedWork.tag));
    }
}
function attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if (isSingletonScope(parent.type)) {
                        hostParent = parent.stateNode;
                        hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    hostParent = parent.stateNode;
                    hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === hostParent) throw Error(formatProdErrorMessage(160));
        commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        hostParent = null;
        hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var currentHoistableRoot = null;
function commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 4 && (commitHookEffectListUnmount(3, finishedWork, finishedWork.return), commitHookEffectListMount(3, finishedWork), commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            flags & 64 && offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = currentHoistableRoot;
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[internalHoistableMarker] || currentResource[internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        setInitialProperties(currentResource, flags, current);
                                        currentResource[internalInstanceKey] = finishedWork;
                                        markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error(formatProdErrorMessage(468, flags));
                                }
                                currentResource[internalInstanceKey] = finishedWork;
                                markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            null !== current && flags & 4 && commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    setTextContent(hoistableRoot, "");
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && (needsFormReset = !0);
            break;
        case 6:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error(formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            tagCaches = null;
            hoistableRoot = currentHoistableRoot;
            currentHoistableRoot = getHoistableRoot(root.containerInfo);
            recursivelyTraverseMutationEffects(root, finishedWork);
            currentHoistableRoot = hoistableRoot;
            commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            needsFormReset && (needsFormReset = !1, recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = currentHoistableRoot;
            currentHoistableRoot = getHoistableRoot(finishedWork.stateNode.containerInfo);
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            currentHoistableRoot = flags;
            break;
        case 12:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            break;
        case 31:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && (globalMostRecentFallbackTime = now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
            offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            recursivelyTraverseMutationEffects(root, finishedWork);
            offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || offscreenSubtreeIsHidden || offscreenSubtreeWasHidden || recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? hideOrUnhideDehydratedBoundary(instance, !0) : hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            recursivelyTraverseMutationEffects(root, finishedWork), commitReconciliationEffects(finishedWork);
    }
}
function commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if (isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error(formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = getHostSibling(finishedWork);
                    insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && (setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = getHostSibling(finishedWork);
                    insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = getHostSibling(finishedWork);
                    insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error(formatProdErrorMessage(161));
            }
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                safelyDetachRef(finishedWork, finishedWork.return);
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && commitClassCallbacks(finishedWork);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && commitHostMount(finishedWork);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && releaseCache(previousCache));
}
function commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && releaseCache(current));
}
function recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var suspenseyCommitFlag = 8192;
function recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & suspenseyCommitFlag && null !== fiber.memoizedState && suspendResource(suspendedState, currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = currentHoistableRoot;
            currentHoistableRoot = getHoistableRoot(fiber.stateNode.containerInfo);
            recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = suspenseyCommitFlag, suspenseyCommitFlag = 16777216, recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), suspenseyCommitFlag = previousHoistableRoot) : recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            nextEffect = childToDelete;
            commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            nextEffect = childToDelete;
            commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                commitHookEffectListUnmount(8, deletions, deletions.return);
                recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== nextEffect;){
        var fiber = nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== nextEffect;){
            cache = nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            detachFiberAfterEffects(cache);
            if (cache === fiber) {
                nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                nextEffect = sibling;
                break a;
            }
            nextEffect = returnFiber;
        }
    }
}
var DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = readContext(CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return readContext(CacheContext).controller.signal;
    }
}, PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, executionContext = 0, workInProgressRoot = null, workInProgress = null, workInProgressRootRenderLanes = 0, workInProgressSuspendedReason = 0, workInProgressThrownValue = null, workInProgressRootDidSkipSuspendedSiblings = !1, workInProgressRootIsPrerendering = !1, workInProgressRootDidAttachPingListener = !1, entangledRenderLanes = 0, workInProgressRootExitStatus = 0, workInProgressRootSkippedLanes = 0, workInProgressRootInterleavedUpdatedLanes = 0, workInProgressRootPingedLanes = 0, workInProgressDeferredLane = 0, workInProgressSuspendedRetryLanes = 0, workInProgressRootConcurrentErrors = null, workInProgressRootRecoverableErrors = null, workInProgressRootDidIncludeRecursiveRenderUpdate = !1, globalMostRecentFallbackTime = 0, globalMostRecentTransitionTime = 0, workInProgressRootRenderTargetTime = Infinity, workInProgressTransitions = null, legacyErrorBoundariesThatAlreadyFailed = null, pendingEffectsStatus = 0, pendingEffectsRoot = null, pendingFinishedWork = null, pendingEffectsLanes = 0, pendingEffectsRemainingLanes = 0, pendingPassiveTransitions = null, pendingRecoverableErrors = null, nestedUpdateCount = 0, rootWithNestedUpdates = null;
function requestUpdateLane() {
    return 0 !== (executionContext & 2) && 0 !== workInProgressRootRenderLanes ? workInProgressRootRenderLanes & -workInProgressRootRenderLanes : null !== ReactSharedInternals.T ? requestTransitionLane() : resolveUpdatePriority();
}
function requestDeferredLane() {
    if (0 === workInProgressDeferredLane) {
        if (0 === (workInProgressRootRenderLanes & 536870912) || isHydrating) {
            var lane = nextTransitionDeferredLane;
            nextTransitionDeferredLane <<= 1;
            0 === (nextTransitionDeferredLane & 3932160) && (nextTransitionDeferredLane = 262144);
            workInProgressDeferredLane = lane;
        } else workInProgressDeferredLane = 536870912;
    }
    lane = suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return workInProgressDeferredLane;
}
function scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === workInProgressRoot && (2 === workInProgressSuspendedReason || 9 === workInProgressSuspendedReason) || null !== root.cancelPendingCommit) prepareFreshStack(root, 0), markRootSuspended(root, workInProgressRootRenderLanes, workInProgressDeferredLane, !1);
    markRootUpdated$1(root, lane);
    if (0 === (executionContext & 2) || root !== workInProgressRoot) root === workInProgressRoot && (0 === (executionContext & 2) && (workInProgressRootInterleavedUpdatedLanes |= lane), 4 === workInProgressRootExitStatus && markRootSuspended(root, workInProgressRootRenderLanes, workInProgressDeferredLane, !1)), ensureRootIsScheduled(root);
}
function performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? renderRootConcurrent(root$jscomp$0, lanes) : renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            workInProgressRootIsPrerendering && !shouldTimeSlice && markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && (prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if (workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = workInProgressRootRecoverableErrors;
                            workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = renderWasConcurrent : workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                prepareFreshStack(root$jscomp$0, 0);
                markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error(formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        markRootSuspended(shouldTimeSlice, lanes, workInProgressDeferredLane, !workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error(formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = globalMostRecentFallbackTime + 300 - now(), 10 < exitStatus)) {
                    markRootSuspended(shouldTimeSlice, lanes, workInProgressDeferredLane, !workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = scheduleTimeout(commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                commitRootWhenReady(shouldTimeSlice, forceSync, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    ensureRootIsScheduled(root$jscomp$0);
}
function commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: noop$1
        };
        accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? globalMostRecentFallbackTime - now() : (lanes & 4194048) === lanes ? globalMostRecentTransitionTime - now() : 0;
        timeoutOffset = waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset(commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~workInProgressRootPingedLanes;
    suspendedLanes &= ~workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function flushSyncWork$1() {
    return 0 === (executionContext & 6) ? (flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function resetWorkInProgressStack() {
    if (null !== workInProgress) {
        if (0 === workInProgressSuspendedReason) var interruptedWork = workInProgress.return;
        else interruptedWork = workInProgress, lastContextDependency = currentlyRenderingFiber$1 = null, resetHooksOnUnwind(interruptedWork), thenableState$1 = null, thenableIndexCounter$1 = 0, interruptedWork = workInProgress;
        for(; null !== interruptedWork;)unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        workInProgress = null;
    }
}
function prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    pendingEffectsLanes = 0;
    resetWorkInProgressStack();
    workInProgressRoot = root;
    workInProgress = timeoutHandle = createWorkInProgress(root.current, null);
    workInProgressRootRenderLanes = lanes;
    workInProgressSuspendedReason = 0;
    workInProgressThrownValue = null;
    workInProgressRootDidSkipSuspendedSiblings = !1;
    workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root, lanes);
    workInProgressRootDidAttachPingListener = !1;
    workInProgressSuspendedRetryLanes = workInProgressDeferredLane = workInProgressRootPingedLanes = workInProgressRootInterleavedUpdatedLanes = workInProgressRootSkippedLanes = workInProgressRootExitStatus = 0;
    workInProgressRootRecoverableErrors = workInProgressRootConcurrentErrors = null;
    workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    entangledRenderLanes = lanes;
    finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function handleThrow(root, thrownValue) {
    currentlyRenderingFiber = null;
    ReactSharedInternals.H = ContextOnlyDispatcher;
    thrownValue === SuspenseException || thrownValue === SuspenseActionException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = 3) : thrownValue === SuspenseyCommitException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = 4) : workInProgressSuspendedReason = thrownValue === SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    workInProgressThrownValue = thrownValue;
    null === workInProgress && (workInProgressRootExitStatus = 1, logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current)));
}
function shouldRemainOnPreviousScreen() {
    var handler = suspenseHandlerStackCursor.current;
    return null === handler ? !0 : (workInProgressRootRenderLanes & 4194048) === workInProgressRootRenderLanes ? null === shellBoundary ? !0 : !1 : (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes || 0 !== (workInProgressRootRenderLanes & 536870912) ? handler === shellBoundary : !1;
}
function pushDispatcher() {
    var prevDispatcher = ReactSharedInternals.H;
    ReactSharedInternals.H = ContextOnlyDispatcher;
    return null === prevDispatcher ? ContextOnlyDispatcher : prevDispatcher;
}
function pushAsyncDispatcher() {
    var prevAsyncDispatcher = ReactSharedInternals.A;
    ReactSharedInternals.A = DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function renderDidSuspendDelayIfPossible() {
    workInProgressRootExitStatus = 4;
    workInProgressRootDidSkipSuspendedSiblings || (workInProgressRootRenderLanes & 4194048) !== workInProgressRootRenderLanes && null !== suspenseHandlerStackCursor.current || (workInProgressRootIsPrerendering = !0);
    0 === (workInProgressRootSkippedLanes & 134217727) && 0 === (workInProgressRootInterleavedUpdatedLanes & 134217727) || null === workInProgressRoot || markRootSuspended(workInProgressRoot, workInProgressRootRenderLanes, workInProgressDeferredLane, !1);
}
function renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = executionContext;
    executionContext |= 2;
    var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
    if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) workInProgressTransitions = null, prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = workInProgressRootExitStatus;
    a: do try {
        if (0 !== workInProgressSuspendedReason && null !== workInProgress) {
            var unitOfWork = workInProgress, thrownValue = workInProgressThrownValue;
            switch(workInProgressSuspendedReason){
                case 8:
                    resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = workInProgressSuspendedReason;
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = workInProgressSuspendedReason, workInProgressSuspendedReason = 0, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        workLoopSync();
        exitStatus = workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    lastContextDependency = currentlyRenderingFiber$1 = null;
    executionContext = prevExecutionContext;
    ReactSharedInternals.H = prevDispatcher;
    ReactSharedInternals.A = prevAsyncDispatcher;
    null === workInProgress && (workInProgressRoot = null, workInProgressRootRenderLanes = 0, finishQueueingConcurrentUpdates());
    return exitStatus;
}
function workLoopSync() {
    for(; null !== workInProgress;)performUnitOfWork(workInProgress);
}
function renderRootConcurrent(root, lanes) {
    var prevExecutionContext = executionContext;
    executionContext |= 2;
    var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
    workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes ? (workInProgressTransitions = null, workInProgressRootRenderTargetTime = now() + 500, prepareFreshStack(root, lanes)) : workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== workInProgressSuspendedReason && null !== workInProgress) {
            lanes = workInProgress;
            var thrownValue = workInProgressThrownValue;
            b: switch(workInProgressSuspendedReason){
                case 1:
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if (isThenableResolved(thrownValue)) {
                        workInProgressSuspendedReason = 0;
                        workInProgressThrownValue = null;
                        replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== workInProgressSuspendedReason && 9 !== workInProgressSuspendedReason || workInProgressRoot !== root || (workInProgressSuspendedReason = 7);
                        ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    isThenableResolved(thrownValue) ? (workInProgressSuspendedReason = 0, workInProgressThrownValue = null, replaySuspendedUnitOfWork(lanes)) : (workInProgressSuspendedReason = 0, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch(workInProgress.tag){
                        case 26:
                            resource = workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = workInProgress;
                            if (resource ? preloadResource(resource) : hostFiber.stateNode.complete) {
                                workInProgressSuspendedReason = 0;
                                workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? (workInProgress = returnFiber, completeUnitOfWork(returnFiber)) : workInProgress = null;
                                }
                                break b;
                            }
                    }
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    resetWorkInProgressStack();
                    workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error(formatProdErrorMessage(462));
            }
        }
        workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        handleThrow(root, thrownValue$167);
    }
    while (1);
    lastContextDependency = currentlyRenderingFiber$1 = null;
    ReactSharedInternals.H = prevDispatcher;
    ReactSharedInternals.A = prevAsyncDispatcher;
    executionContext = prevExecutionContext;
    if (null !== workInProgress) return 0;
    workInProgressRoot = null;
    workInProgressRootRenderLanes = 0;
    finishQueueingConcurrentUpdates();
    return workInProgressRootExitStatus;
}
function workLoopConcurrentByScheduler() {
    for(; null !== workInProgress && !shouldYield();)performUnitOfWork(workInProgress);
}
function performUnitOfWork(unitOfWork) {
    var next = beginWork(unitOfWork.alternate, unitOfWork, entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? completeUnitOfWork(unitOfWork) : workInProgress = next;
}
function replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, workInProgressRootRenderLanes);
            break;
        case 11:
            next = replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, workInProgressRootRenderLanes);
            break;
        case 5:
            resetHooksOnUnwind(next);
        default:
            unwindInterruptedWork(current, next), next = workInProgress = resetWorkInProgress(next, entangledRenderLanes), next = beginWork(current, next, entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? completeUnitOfWork(unitOfWork) : workInProgress = next;
}
function throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    lastContextDependency = currentlyRenderingFiber$1 = null;
    resetHooksOnUnwind(unitOfWork);
    thenableState$1 = null;
    thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if (throwException(root, returnFiber, unitOfWork, thrownValue, workInProgressRootRenderLanes)) {
            workInProgressRootExitStatus = 1;
            logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current));
            workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw workInProgress = returnFiber, error;
        workInProgressRootExitStatus = 1;
        logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current));
        workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if (isHydrating || 1 === suspendedReason) root = !0;
        else if (workInProgressRootIsPrerendering || 0 !== (workInProgressRootRenderLanes & 536870912)) root = !1;
        else if (workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        unwindUnitOfWork(unitOfWork, root);
    } else completeUnitOfWork(unitOfWork);
}
function completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            unwindUnitOfWork(completedWork, workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = completeWork(completedWork.alternate, completedWork, entangledRenderLanes);
        if (null !== next) {
            workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            workInProgress = completedWork;
            return;
        }
        workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === workInProgressRootExitStatus && (workInProgressRootExitStatus = 5);
}
function unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            workInProgress = unitOfWork;
            return;
        }
        workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    workInProgressRootExitStatus = 6;
    workInProgress = null;
}
function commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do flushPendingEffects();
    while (0 !== pendingEffectsStatus);
    if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error(formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= concurrentlyUpdatedLanes;
        markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === workInProgressRoot && (workInProgress = workInProgressRoot = null, workInProgressRootRenderLanes = 0);
        pendingFinishedWork = finishedWork;
        pendingEffectsRoot = root;
        pendingEffectsLanes = lanes;
        pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        pendingPassiveTransitions = transitions;
        pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, scheduleCallback$1(NormalPriority$1, function() {
            flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = ReactSharedInternals.T;
            ReactSharedInternals.T = null;
            transitions = ReactDOMSharedInternals.p;
            ReactDOMSharedInternals.p = 2;
            spawnedLane = executionContext;
            executionContext |= 4;
            try {
                commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                executionContext = spawnedLane, ReactDOMSharedInternals.p = transitions, ReactSharedInternals.T = recoverableErrors;
            }
        }
        pendingEffectsStatus = 1;
        flushMutationEffects();
        flushLayoutEffects();
        flushSpawnedWork();
    }
}
function flushMutationEffects() {
    if (1 === pendingEffectsStatus) {
        pendingEffectsStatus = 0;
        var root = pendingEffectsRoot, finishedWork = pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = ReactSharedInternals.T;
            ReactSharedInternals.T = null;
            var previousPriority = ReactDOMSharedInternals.p;
            ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = executionContext;
            executionContext |= 4;
            try {
                commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = selectionInformation, curFocusedElem = getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                _enabled = !!eventsEnabled;
                selectionInformation = eventsEnabled = null;
            } finally{
                executionContext = prevExecutionContext, ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        pendingEffectsStatus = 2;
    }
}
function flushLayoutEffects() {
    if (2 === pendingEffectsStatus) {
        pendingEffectsStatus = 0;
        var root = pendingEffectsRoot, finishedWork = pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = ReactSharedInternals.T;
            ReactSharedInternals.T = null;
            var previousPriority = ReactDOMSharedInternals.p;
            ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = executionContext;
            executionContext |= 4;
            try {
                commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                executionContext = prevExecutionContext, ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        pendingEffectsStatus = 3;
    }
}
function flushSpawnedWork() {
    if (4 === pendingEffectsStatus || 3 === pendingEffectsStatus) {
        pendingEffectsStatus = 0;
        requestPaint();
        var root = pendingEffectsRoot, finishedWork = pendingFinishedWork, lanes = pendingEffectsLanes, recoverableErrors = pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? pendingEffectsStatus = 5 : (pendingEffectsStatus = 0, pendingFinishedWork = pendingEffectsRoot = null, releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && (legacyErrorBoundariesThatAlreadyFailed = null);
        lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if (injectedHook && "function" === typeof injectedHook.onCommitFiberRoot) try {
            injectedHook.onCommitFiberRoot(rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = ReactSharedInternals.T;
            remainingLanes = ReactDOMSharedInternals.p;
            ReactDOMSharedInternals.p = 2;
            ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                ReactSharedInternals.T = finishedWork, ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== (pendingEffectsLanes & 3) && flushPendingEffects();
        ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === rootWithNestedUpdates ? nestedUpdateCount++ : (nestedUpdateCount = 0, rootWithNestedUpdates = root) : nestedUpdateCount = 0;
        flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, releaseCache(remainingLanes)));
}
function flushPendingEffects() {
    flushMutationEffects();
    flushLayoutEffects();
    flushSpawnedWork();
    return flushPassiveEffects();
}
function flushPassiveEffects() {
    if (5 !== pendingEffectsStatus) return !1;
    var root = pendingEffectsRoot, remainingLanes = pendingEffectsRemainingLanes;
    pendingEffectsRemainingLanes = 0;
    var renderPriority = lanesToEventPriority(pendingEffectsLanes), prevTransition = ReactSharedInternals.T, previousPriority = ReactDOMSharedInternals.p;
    try {
        ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        ReactSharedInternals.T = null;
        renderPriority = pendingPassiveTransitions;
        pendingPassiveTransitions = null;
        var root$jscomp$0 = pendingEffectsRoot, lanes = pendingEffectsLanes;
        pendingEffectsStatus = 0;
        pendingFinishedWork = pendingEffectsRoot = null;
        pendingEffectsLanes = 0;
        if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(331));
        var prevExecutionContext = executionContext;
        executionContext |= 4;
        commitPassiveUnmountOnFiber(root$jscomp$0.current);
        commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        executionContext = prevExecutionContext;
        flushSyncWorkAcrossRoots_impl(0, !1);
        if (injectedHook && "function" === typeof injectedHook.onPostCommitFiberRoot) try {
            injectedHook.onPostCommitFiberRoot(rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition, releaseRootPooledCache(root, remainingLanes);
    }
}
function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && (markRootUpdated$1(rootFiber, 2), ensureRootIsScheduled(rootFiber));
}
function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
                error = createClassErrorUpdate(2);
                instance = enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && (initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), markRootUpdated$1(instance, 2), ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || (workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    workInProgressRoot === root && (workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === workInProgressRootExitStatus || 3 === workInProgressRootExitStatus && (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes && 300 > now() - globalMostRecentFallbackTime ? 0 === (executionContext & 2) && prepareFreshStack(root, 0) : workInProgressRootPingedLanes |= pingedLanes, workInProgressSuspendedRetryLanes === workInProgressRootRenderLanes && (workInProgressSuspendedRetryLanes = 0));
    ensureRootIsScheduled(root);
}
function retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = claimNextRetryLane());
    boundaryFiber = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && (markRootUpdated$1(boundaryFiber, retryLane), ensureRootIsScheduled(boundaryFiber));
}
function retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    retryTimedOutBoundary(boundaryFiber, retryLane);
}
function resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error(formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    retryTimedOutBoundary(boundaryFiber, retryLane);
}
function scheduleCallback$1(priorityLevel, callback) {
    return scheduleCallback$3(priorityLevel, callback);
}
var firstScheduledRoot = null, lastScheduledRoot = null, didScheduleMicrotask = !1, mightHavePendingSyncWork = !1, isFlushingWork = !1, currentEventTransitionLane = 0;
function ensureRootIsScheduled(root) {
    root !== lastScheduledRoot && null === root.next && (null === lastScheduledRoot ? firstScheduledRoot = lastScheduledRoot = root : lastScheduledRoot = lastScheduledRoot.next = root);
    mightHavePendingSyncWork = !0;
    didScheduleMicrotask || (didScheduleMicrotask = !0, scheduleImmediateRootScheduleTask());
}
function flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!isFlushingWork && mightHavePendingSyncWork) {
        isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = workInProgressRootRenderLanes, JSCompiler_inline_result = getNextLanes(root$170, root$170 === workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        isFlushingWork = !1;
    }
}
function processRootScheduleInImmediateTask() {
    processRootScheduleInMicrotask();
}
function processRootScheduleInMicrotask() {
    mightHavePendingSyncWork = didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== currentEventTransitionLane && shouldAttemptEagerTransition() && (syncTransitionLanes = currentEventTransitionLane);
    for(var currentTime = now(), prev = null, root = firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? firstScheduledRoot = next : prev.next = next, null === next && (lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== pendingEffectsStatus && 5 !== pendingEffectsStatus || flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== currentEventTransitionLane && (currentEventTransitionLane = 0);
}
function scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = workInProgressRoot;
    suspendedLanes = workInProgressRootRenderLanes;
    suspendedLanes = getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === workInProgressSuspendedReason || 9 === workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && cancelCallback$1(pingedLanes);
        switch(lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = IdlePriority;
                break;
            default:
                suspendedLanes = NormalPriority$1;
        }
        pingedLanes = performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== pendingEffectsStatus && 5 !== pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if (flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    scheduleTaskForRootDuringMicrotask(root, now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function performSyncWorkOnRoot(root, lanes) {
    if (flushPendingEffects()) return null;
    performWorkOnRoot(root, lanes, !0);
}
function scheduleImmediateRootScheduleTask() {
    scheduleMicrotask(function() {
        0 !== (executionContext & 6) ? scheduleCallback$3(ImmediatePriority, processRootScheduleInImmediateTask) : processRootScheduleInMicrotask();
    });
}
function requestTransitionLane() {
    if (0 === currentEventTransitionLane) {
        var actionScopeLane = currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = nextTransitionUpdateLane, nextTransitionUpdateLane <<= 1, 0 === (nextTransitionUpdateLane & 261888) && (nextTransitionUpdateLane = 256));
        currentEventTransitionLane = actionScopeLane;
    }
    return currentEventTransitionLane;
}
function coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : sanitizeURL("" + actionProp);
}
function createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = coerceFormActionProp((nativeEventTarget[internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[internalPropsKey] || null) ? coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== currentEventTransitionLane) {
                                var formData = submitter ? createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var i$jscomp$inline_1577 = 0; i$jscomp$inline_1577 < simpleEventPluginEvents.length; i$jscomp$inline_1577++){
    var eventName$jscomp$inline_1578 = simpleEventPluginEvents[i$jscomp$inline_1577], domEventName$jscomp$inline_1579 = eventName$jscomp$inline_1578.toLowerCase(), capitalizedEvent$jscomp$inline_1580 = eventName$jscomp$inline_1578[0].toUpperCase() + eventName$jscomp$inline_1578.slice(1);
    registerSimpleEvent(domEventName$jscomp$inline_1579, "on" + capitalizedEvent$jscomp$inline_1580);
}
registerSimpleEvent(ANIMATION_END, "onAnimationEnd");
registerSimpleEvent(ANIMATION_ITERATION, "onAnimationIteration");
registerSimpleEvent(ANIMATION_START, "onAnimationStart");
registerSimpleEvent("dblclick", "onDoubleClick");
registerSimpleEvent("focusin", "onFocus");
registerSimpleEvent("focusout", "onBlur");
registerSimpleEvent(TRANSITION_RUN, "onTransitionRun");
registerSimpleEvent(TRANSITION_START, "onTransitionStart");
registerSimpleEvent(TRANSITION_CANCEL, "onTransitionCancel");
registerSimpleEvent(TRANSITION_END, "onTransitionEnd");
registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(mediaEventTypes));
function processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || (addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[listeningMarker]) {
        rootContainerElement[listeningMarker] = !0;
        allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && (nonDelegatedEvents.has(domEventName) || listenToNativeEvent(domEventName, !1, rootContainerElement), listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[listeningMarker] || (ownerDocument[listeningMarker] = !0, listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch(getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = SyntheticTouchEvent;
                        break;
                    case ANIMATION_END:
                    case ANIMATION_ITERATION:
                    case ANIMATION_START:
                        SyntheticEventCtor = SyntheticAnimationEvent;
                        break;
                    case TRANSITION_END:
                        SyntheticEventCtor = SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = getListener(instance, reactEventName), null != _instance && inCapturePhase.push(createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && (getClosestInstanceFromNode(reactEventType) || reactEventType[internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = getTargetInstForChangeEvent;
                else if (isTextInputElement(reactName)) {
                    if (isInputEventSupported) getTargetInstFunc = getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = getTargetInstForInputEventPolyfill;
                        var handleEventFunc = handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && isCustomElement(targetInst.elementType) && (getTargetInstFunc = getTargetInstForChangeEvent) : getTargetInstFunc = getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if (isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) activeElement = handleEventFunc, activeElementInst = targetInst, lastSelection = null;
                    break;
                case "focusout":
                    lastSelection = activeElementInst = activeElement = null;
                    break;
                case "mousedown":
                    mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    mouseDown = !1;
                    constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if (skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if (canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else isComposing ? isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && (useFallbackCompositionData && "ko" !== nativeEvent.locale && (isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && isComposing && (fallbackData = getData()) : (root = nativeEventTarget, startText = "value" in root ? root.value : root.textContent, isComposing = !0)), handleEventFunc = accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = canUseTextInputEvent ? getNativeBeforeInputChars(domEventName, nativeEvent) : getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = getListener(targetFiber, captureName), null != _instance2 && listeners.unshift(createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = getListener(targetFiber, reactName), null != _instance2 && listeners.push(createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = getListener(target, registrationName), null != stateNode && listeners.unshift(createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = getListener(target, registrationName), null != stateNode && listeners.push(createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var NORMALIZE_NEWLINES_REGEX = /\r\n?/g, NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace(NORMALIZE_NEWLINES_REGEX, "\n").replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function checkForUnmatchedText(serverText, clientText) {
    clientText = normalizeMarkupForTextOrAttribute(clientText);
    return normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && setTextContent(domElement, "" + value);
            break;
        case "className":
            setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && setProp(domElement, tag, "name", props.name, props, null), setProp(domElement, tag, "formEncType", props.formEncType, props, null), setProp(domElement, tag, "formMethod", props.formMethod, props, null), setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : (setProp(domElement, tag, "encType", props.encType, props, null), setProp(domElement, tag, "method", props.method, props, null), setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = noop$1);
            break;
        case "onScroll":
            null != value && listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error(formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error(formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            listenToNonDelegatedEvent("beforetoggle", domElement);
            listenToNonDelegatedEvent("toggle", domElement);
            setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = aliases.get(key) || key, setValueForAttribute(domElement, key, value);
    }
}
function setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error(formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error(formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : setValueForAttribute(domElement, key, value);
            }
    }
}
function setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            listenToNonDelegatedEvent("error", domElement);
            listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error(formatProdErrorMessage(137, tag));
                    default:
                        setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error(formatProdErrorMessage(137, tag));
                        break;
                    default:
                        setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? updateOptions(domElement, !!hasSrc, tag, !1) : null != props && updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error(formatProdErrorMessage(91));
                    break;
                default:
                    setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            listenToNonDelegatedEvent("beforetoggle", domElement);
            listenToNonDelegatedEvent("toggle", domElement);
            listenToNonDelegatedEvent("cancel", domElement);
            listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < mediaEventTypes.length; hasSrc++)listenToNonDelegatedEvent(mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            listenToNonDelegatedEvent("error", domElement);
            listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            listenToNonDelegatedEvent("error", domElement), listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error(formatProdErrorMessage(137, tag));
                default:
                    setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if (isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error(formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? updateOptions(domElement, !!lastProps, tag, !0) : updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error(formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && setProp(domElement, tag, value, name, nextProps, type);
            }
            updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error(formatProdErrorMessage(137, tag));
                    break;
                default:
                    setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if (isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var eventsEnabled = null, selectionInformation = null;
function getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var currentPopstateTransitionEvent = null;
function shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === currentPopstateTransitionEvent) return !1;
        currentPopstateTransitionEvent = event;
        return !0;
    }
    currentPopstateTransitionEvent = null;
    return !1;
}
var scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, localPromise = "function" === typeof Promise ? Promise : void 0, scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof localPromise ? function(callback) {
    return localPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
} : scheduleTimeout;
function handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function isSingletonScope(type) {
    return "head" === type;
}
function clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    retryIfBlockedOn(hydrationInstance);
}
function hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                clearContainerSparingly(node);
                detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var previousHydratableOnEnteringScopedSingleton = null;
function getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function resolveSingletonInstance(type, props, rootContainerInstance) {
    props = getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error(formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error(formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error(formatProdErrorMessage(454));
            return type;
        default:
            throw Error(formatProdErrorMessage(451));
    }
}
function releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    detachDeletedInstance(instance);
}
var preloadPropsMap = new Map(), preconnectsSet = new Set();
function getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var previousDispatcher = ReactDOMSharedInternals.d;
ReactDOMSharedInternals.d = {
    f: flushSyncWork,
    r: requestFormReset,
    D: prefetchDNS,
    C: preconnect,
    L: preload,
    m: preloadModule,
    X: preinitScript,
    S: preinitStyle,
    M: preinitModuleScript
};
function flushSyncWork() {
    var previousWasRendering = previousDispatcher.f(), wasRendering = flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function requestFormReset(form) {
    var formInst = getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? requestFormReset$1(formInst) : previousDispatcher.r(form);
}
var globalDocument = "undefined" === typeof document ? null : document;
function preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        preconnectsSet.has(limitedEscapedHref) || (preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), setInitialProperties(href, "link", rel), markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function prefetchDNS(href) {
    previousDispatcher.D(href);
    preconnectAs("dns-prefetch", href, null);
}
function preconnect(href, crossOrigin) {
    previousDispatcher.C(href, crossOrigin);
    preconnectAs("preconnect", href, crossOrigin);
}
function preload(href, as, options) {
    previousDispatcher.L(href, as, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = getStyleKey(href);
                break;
            case "script":
                key = getScriptKey(href);
        }
        preloadPropsMap.has(key) || (href = assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector(getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector(getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), setInitialProperties(as, "link", href), markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function preloadModule(href, options) {
    previousDispatcher.m(href, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = getScriptKey(href);
        }
        if (!preloadPropsMap.has(key) && (href = assign({
            rel: "modulepreload",
            href: href
        }, options), preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector(getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            setInitialProperties(as, "link", href);
            markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function preinitStyle(href, precedence, options) {
    previousDispatcher.S(href, precedence, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && href) {
        var styles = getResourcesFromRoot(ownerDocument).hoistableStyles, key = getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector(getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                markNodeAsHoistable(link);
                setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function preinitScript(src, options) {
    previousDispatcher.X(src, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && src) {
        var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector(getScriptSelectorFromKey(key)), resource || (src = assign({
            src: src,
            async: !0
        }, options), (options = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function preinitModuleScript(src, options) {
    previousDispatcher.M(src, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && src) {
        var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector(getScriptSelectorFromKey(key)), resource || (src = assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = rootInstanceStackCursor.current) ? getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error(formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = getStyleKey(pendingProps.href), pendingProps = getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = getStyleKey(pendingProps.href);
                var styles$243 = getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector(getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, preloadPropsMap.set(type, pendingProps), styles$243 || preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error(formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error(formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = getScriptKey(pendingProps), pendingProps = getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error(formatProdErrorMessage(444, type));
    }
}
function getStyleKey(href) {
    return 'href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function stylesheetPropsFromRawProps(rawProps) {
    return assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), setInitialProperties(key, "link", preloadProps), markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function getScriptKey(src) {
    return '[src="' + escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, markNodeAsHoistable(instance), instance;
            var styleProps = assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            markNodeAsHoistable(instance);
            setInitialProperties(instance, "style", styleProps);
            insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector(getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, markNodeAsHoistable(instance$249), instance$249;
            instance = stylesheetPropsFromRawProps(props);
            (styleProps = preloadPropsMap.get(styleProps)) && adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector(getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = preloadPropsMap.get(instance$249)) instance = assign({}, props), adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            markNodeAsHoistable(styleProps);
            setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error(formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var tagCaches = null;
function getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === tagCaches) {
        var cache = new Map();
        var caches = tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[internalHoistableMarker] || node[internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = getStyleKey(props.href), instance = hoistableRoot.querySelector(getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = stylesheetPropsFromRawProps(props);
            (key = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var estimatedBytesWithinLimit = 0;
function waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === estimatedBytesWithinLimit && (estimatedBytesWithinLimit = 62500 * estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var precedencesByRoot = null;
function insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, precedencesByRoot = new Map(), resources.forEach(insertStylesheetIntoRoot, state), precedencesByRoot = null, onUnsuspend.call(state));
}
function insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var HostTransitionContext = {
    $$typeof: REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: sharedNotPendingObject,
    _currentValue2: sharedNotPendingObject,
    _threadCount: 0
};
function FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = createLaneMap(0);
    this.hiddenUpdates = createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function getContextForSubtree(parentComponent) {
    if (!parentComponent) return emptyContextObject;
    parentComponent = emptyContextObject;
    return parentComponent;
}
function updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = enqueueUpdate(rootFiber, container, lane);
    null !== element && (scheduleUpdateOnFiber(element, rootFiber, lane), entangleTransitions(element, rootFiber, lane));
}
function markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function markRetryLaneIfNotHydrated(fiber, retryLane) {
    markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && markRetryLaneImpl(fiber, retryLane);
}
function attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && scheduleUpdateOnFiber(root, fiber, 67108864);
        markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = requestUpdateLane();
        lane = getBumpedLaneForHydrationByLane(lane);
        var root = enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && scheduleUpdateOnFiber(root, fiber, lane);
        markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var _enabled = !0;
function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = ReactSharedInternals.T;
    ReactSharedInternals.T = null;
    var previousPriority = ReactDOMSharedInternals.p;
    try {
        ReactDOMSharedInternals.p = 2, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
    }
}
function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = ReactSharedInternals.T;
    ReactSharedInternals.T = null;
    var previousPriority = ReactDOMSharedInternals.p;
    try {
        ReactDOMSharedInternals.p = 8, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
    }
}
function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (_enabled) {
        var blockedOn = findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer), clearIfContinuousEvent(domEventName, nativeEvent);
        else if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if (clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                ensureRootIsScheduled(fiber);
                                0 === (executionContext & 6) && (workInProgressRootRenderTargetTime = now() + 500, flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = enqueueConcurrentRenderForLane(fiber, 2), null !== root && scheduleUpdateOnFiber(root, fiber, 2), flushSyncWork$1(), markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = findInstanceBlockingEvent(nativeEvent);
                null === fiber && dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = getEventTarget(nativeEvent);
    return findInstanceBlockingTarget(nativeEvent);
}
var return_targetInst = null;
function findInstanceBlockingTarget(targetNode) {
    return_targetInst = null;
    targetNode = getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    return_targetInst = targetNode;
    return null;
}
function getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch(getCurrentPriorityLevel()){
                case ImmediatePriority:
                    return 2;
                case UserBlockingPriority:
                    return 8;
                case NormalPriority$1:
                case LowPriority:
                    return 32;
                case IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var hasScheduledReplayAttempt = !1, queuedFocus = null, queuedDrag = null, queuedMouse = null, queuedPointers = new Map(), queuedPointerCaptures = new Map(), queuedExplicitHydrationTargets = [], discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = getInstanceFromNode(blockedOn), null !== blockedOn && attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, queuedPointerCaptures.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    runWithPriority(queuedTarget.priority, function() {
                        attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    runWithPriority(queuedTarget.priority, function() {
                        attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            currentReplayingEvent = null;
        } else return targetContainers = getInstanceFromNode(nextBlockedOn), null !== targetContainers && attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function replayUnblockedEvents() {
    hasScheduledReplayAttempt = !1;
    null !== queuedFocus && attemptReplayContinuousQueuedEvent(queuedFocus) && (queuedFocus = null);
    null !== queuedDrag && attemptReplayContinuousQueuedEvent(queuedDrag) && (queuedDrag = null);
    null !== queuedMouse && attemptReplayContinuousQueuedEvent(queuedMouse) && (queuedMouse = null);
    queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
    queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
}
function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, hasScheduledReplayAttempt || (hasScheduledReplayAttempt = !0, Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents)));
}
var lastScheduledReplayQueue = null;
function scheduleReplayQueueIfNeeded(formReplayingQueue) {
    lastScheduledReplayQueue !== formReplayingQueue && (lastScheduledReplayQueue = formReplayingQueue, Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, function() {
        lastScheduledReplayQueue === formReplayingQueue && (lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== queuedFocus && scheduleCallbackIfUnblocked(queuedFocus, unblocked);
    null !== queuedDrag && scheduleCallbackIfUnblocked(queuedDrag, unblocked);
    null !== queuedMouse && scheduleCallbackIfUnblocked(queuedMouse, unblocked);
    queuedPointers.forEach(unblock);
    queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < queuedExplicitHydrationTargets.length && (i = queuedExplicitHydrationTargets[0], null === i.blockedOn);)attemptExplicitHydrationTarget(i), null === i.blockedOn && queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            scheduleReplayQueueIfNeeded(i);
        }
    }
}
function defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error(formatProdErrorMessage(409));
    var current = root.current, lane = requestUpdateLane();
    updateContainerImpl(current, lane, children, root, null, null);
};
ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        updateContainerImpl(root.current, 2, null, root, null, null);
        flushSyncWork$1();
        container[internalContainerInstanceKey] = null;
    }
};
function ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < queuedExplicitHydrationTargets[i].priority; i++);
        queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && attemptExplicitHydrationTarget(target);
    }
};
var isomorphicReactPackageVersion$jscomp$inline_1840 = React.version;
if ("19.2.4" !== isomorphicReactPackageVersion$jscomp$inline_1840) throw Error(formatProdErrorMessage(527, isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.4"));
ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error(formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error(formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.4",
    rendererPackageName: "react-dom",
    currentDispatcherRef: ReactSharedInternals,
    reconcilerVersion: "19.2.4"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!hook$jscomp$inline_2348.isDisabled && hook$jscomp$inline_2348.supportsFiber) try {
        rendererID = hook$jscomp$inline_2348.inject(internals$jscomp$inline_2347), injectedHook = hook$jscomp$inline_2348;
    } catch (err) {}
}
exports.createRoot = function(container, options) {
    if (!isValidContainer(container)) throw Error(formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, defaultOnDefaultTransitionIndicator);
    container[internalContainerInstanceKey] = options.current;
    listenToAllSupportedEvents(container);
    return new ReactDOMRoot(options);
};
exports.hydrateRoot = function(container, initialChildren, options) {
    if (!isValidContainer(container)) throw Error(formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, defaultOnDefaultTransitionIndicator);
    initialChildren.context = getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = requestUpdateLane();
    isStrictMode = getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    markRootUpdated$1(initialChildren, options);
    ensureRootIsScheduled(initialChildren);
    container[internalContainerInstanceKey] = initialChildren.current;
    listenToAllSupportedEvents(container);
    return new ReactDOMHydrationRoot(initialChildren);
};
exports.version = "19.2.4";

},{"34889e2d9d2e5ad0":"5hgp2","4ca5dbf165264c00":"7e5Pu","d9c4e38f4a220051":"a0T7s"}],"5hgp2":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("e6285b476bd633d9");

},{"e6285b476bd633d9":"2rXAY"}],"2rXAY":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
function push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > compare(left, last)) rightIndex < length && 0 > compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
exports.unstable_now = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var localPerformance = performance;
    exports.unstable_now = function() {
        return localPerformance.now();
    };
} else {
    var localDate = Date, initialTime = localDate.now();
    exports.unstable_now = function() {
        return localDate.now() - initialTime;
    };
}
var taskQueue = [], timerQueue = [], taskIdCounter = 1, currentTask = null, currentPriorityLevel = 3, isPerformingWork = !1, isHostCallbackScheduled = !1, isHostTimeoutScheduled = !1, needsPaint = !1, localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function advanceTimers(currentTime) {
    for(var timer = peek(timerQueue); null !== timer;){
        if (null === timer.callback) pop(timerQueue);
        else if (timer.startTime <= currentTime) pop(timerQueue), timer.sortIndex = timer.expirationTime, push(taskQueue, timer);
        else break;
        timer = peek(timerQueue);
    }
}
function handleTimeout(currentTime) {
    isHostTimeoutScheduled = !1;
    advanceTimers(currentTime);
    if (!isHostCallbackScheduled) {
        if (null !== peek(taskQueue)) isHostCallbackScheduled = !0, isMessageLoopRunning || (isMessageLoopRunning = !0, schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = peek(timerQueue);
            null !== firstTimer && requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var isMessageLoopRunning = !1, taskTimeoutID = -1, frameInterval = 5, startTime = -1;
function shouldYieldToHost() {
    return needsPaint ? !0 : exports.unstable_now() - startTime < frameInterval ? !1 : !0;
}
function performWorkUntilDeadline() {
    needsPaint = !1;
    if (isMessageLoopRunning) {
        var currentTime = exports.unstable_now();
        startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                isHostCallbackScheduled = !1;
                isHostTimeoutScheduled && (isHostTimeoutScheduled = !1, localClearTimeout(taskTimeoutID), taskTimeoutID = -1);
                isPerformingWork = !0;
                var previousPriorityLevel = currentPriorityLevel;
                try {
                    b: {
                        advanceTimers(currentTime);
                        for(currentTask = peek(taskQueue); null !== currentTask && !(currentTask.expirationTime > currentTime && shouldYieldToHost());){
                            var callback = currentTask.callback;
                            if ("function" === typeof callback) {
                                currentTask.callback = null;
                                currentPriorityLevel = currentTask.priorityLevel;
                                var continuationCallback = callback(currentTask.expirationTime <= currentTime);
                                currentTime = exports.unstable_now();
                                if ("function" === typeof continuationCallback) {
                                    currentTask.callback = continuationCallback;
                                    advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                currentTask === peek(taskQueue) && pop(taskQueue);
                                advanceTimers(currentTime);
                            } else pop(taskQueue);
                            currentTask = peek(taskQueue);
                        }
                        if (null !== currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = peek(timerQueue);
                            null !== firstTimer && requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    currentTask = null, currentPriorityLevel = previousPriorityLevel, isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? schedulePerformWorkUntilDeadline() : isMessageLoopRunning = !1;
        }
    }
}
var schedulePerformWorkUntilDeadline;
if ("function" === typeof localSetImmediate) schedulePerformWorkUntilDeadline = function() {
    localSetImmediate(performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var channel = new MessageChannel(), port = channel.port2;
    channel.port1.onmessage = performWorkUntilDeadline;
    schedulePerformWorkUntilDeadline = function() {
        port.postMessage(null);
    };
} else schedulePerformWorkUntilDeadline = function() {
    localSetTimeout(performWorkUntilDeadline, 0);
};
function requestHostTimeout(callback, ms) {
    taskTimeoutID = localSetTimeout(function() {
        callback(exports.unstable_now());
    }, ms);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(task) {
    task.callback = null;
};
exports.unstable_forceFrameRate = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return currentPriorityLevel;
};
exports.unstable_next = function(eventHandler) {
    switch(currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = currentPriorityLevel;
    }
    var previousPriorityLevel = currentPriorityLevel;
    currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        currentPriorityLevel = previousPriorityLevel;
    }
};
exports.unstable_requestPaint = function() {
    needsPaint = !0;
};
exports.unstable_runWithPriority = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = currentPriorityLevel;
    currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        currentPriorityLevel = previousPriorityLevel;
    }
};
exports.unstable_scheduleCallback = function(priorityLevel, callback, options) {
    var currentTime = exports.unstable_now();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, push(timerQueue, priorityLevel), null === peek(taskQueue) && priorityLevel === peek(timerQueue) && (isHostTimeoutScheduled ? (localClearTimeout(taskTimeoutID), taskTimeoutID = -1) : isHostTimeoutScheduled = !0, requestHostTimeout(handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, push(taskQueue, priorityLevel), isHostCallbackScheduled || isPerformingWork || (isHostCallbackScheduled = !0, isMessageLoopRunning || (isMessageLoopRunning = !0, schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
exports.unstable_shouldYield = shouldYieldToHost;
exports.unstable_wrapCallback = function(callback) {
    var parentPriorityLevel = currentPriorityLevel;
    return function() {
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    };
};

},{}],"7e5Pu":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("6c7cf85beaa2d6d4");

},{"6c7cf85beaa2d6d4":"kCMgC"}],"kCMgC":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, assign = Object.assign, emptyObject = {};
function Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
}
Component.prototype.isReactComponent = {};
Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function ComponentDummy() {}
ComponentDummy.prototype = Component.prototype;
function PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
}
var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
pureComponentPrototype.constructor = PureComponent;
assign(pureComponentPrototype, Component.prototype);
pureComponentPrototype.isPureReactComponent = !0;
var isArrayImpl = Array.isArray;
function noop() {}
var ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, hasOwnProperty = Object.prototype.hasOwnProperty;
function ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function cloneAndReplaceKey(oldElement, newKey) {
    return ReactElement(oldElement.type, newKey, oldElement.props);
}
function isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
}
function escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var userProvidedKeyEscapeRegex = /\/+/g;
function getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? escape("" + element.key) : index.toString(36);
}
function resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then(noop, noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case REACT_LAZY_TYPE:
                    return invokeCallback = children._init, mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + getElementKey(children, 0) : nameSoFar, isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace(userProvidedKeyEscapeRegex, "$&/") + "/"), mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && (isValidElement(callback) && (callback = cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace(userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if (isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + getElementKey(nameSoFar, i), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + getElementKey(nameSoFar, i++), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return mapIntoArray(resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, Children = {
    map: mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
exports.Activity = REACT_ACTIVITY_TYPE;
exports.Children = Children;
exports.Component = Component;
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.Profiler = REACT_PROFILER_TYPE;
exports.PureComponent = PureComponent;
exports.StrictMode = REACT_STRICT_MODE_TYPE;
exports.Suspense = REACT_SUSPENSE_TYPE;
exports.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = ReactSharedInternals;
exports.__COMPILER_RUNTIME = {
    __proto__: null,
    c: function(size) {
        return ReactSharedInternals.H.useMemoCache(size);
    }
};
exports.cache = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
exports.cacheSignal = function() {
    return null;
};
exports.cloneElement = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return ReactElement(element.type, key, props);
};
exports.createContext = function(defaultValue) {
    defaultValue = {
        $$typeof: REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
exports.createElement = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return ReactElement(type, key, props);
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(render) {
    return {
        $$typeof: REACT_FORWARD_REF_TYPE,
        render: render
    };
};
exports.isValidElement = isValidElement;
exports.lazy = function(ctor) {
    return {
        $$typeof: REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: lazyInitializer
    };
};
exports.memo = function(type, compare) {
    return {
        $$typeof: REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
exports.startTransition = function(scope) {
    var prevTransition = ReactSharedInternals.T, currentTransition = {};
    ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then(noop, reportGlobalError);
    } catch (error) {
        reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition;
    }
};
exports.unstable_useCacheRefresh = function() {
    return ReactSharedInternals.H.useCacheRefresh();
};
exports.use = function(usable) {
    return ReactSharedInternals.H.use(usable);
};
exports.useActionState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
exports.useCallback = function(callback, deps) {
    return ReactSharedInternals.H.useCallback(callback, deps);
};
exports.useContext = function(Context) {
    return ReactSharedInternals.H.useContext(Context);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(value, initialValue) {
    return ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
exports.useEffect = function(create, deps) {
    return ReactSharedInternals.H.useEffect(create, deps);
};
exports.useEffectEvent = function(callback) {
    return ReactSharedInternals.H.useEffectEvent(callback);
};
exports.useId = function() {
    return ReactSharedInternals.H.useId();
};
exports.useImperativeHandle = function(ref, create, deps) {
    return ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
exports.useInsertionEffect = function(create, deps) {
    return ReactSharedInternals.H.useInsertionEffect(create, deps);
};
exports.useLayoutEffect = function(create, deps) {
    return ReactSharedInternals.H.useLayoutEffect(create, deps);
};
exports.useMemo = function(create, deps) {
    return ReactSharedInternals.H.useMemo(create, deps);
};
exports.useOptimistic = function(passthrough, reducer) {
    return ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
exports.useReducer = function(reducer, initialArg, init) {
    return ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
exports.useRef = function(initialValue) {
    return ReactSharedInternals.H.useRef(initialValue);
};
exports.useState = function(initialState) {
    return ReactSharedInternals.H.useState(initialState);
};
exports.useSyncExternalStore = function(subscribe, getSnapshot, getServerSnapshot) {
    return ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
exports.useTransition = function() {
    return ReactSharedInternals.H.useTransition();
};
exports.version = "19.2.4";

},{}],"a0T7s":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("f5dc546b1b485681");

},{"f5dc546b1b485681":"ax21t"}],"ax21t":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("cac5e30c76bdcd20");
function formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function noop() {}
var Internals = {
    d: {
        f: noop,
        r: function() {
            throw Error(formatProdErrorMessage(522));
        },
        D: noop,
        C: noop,
        L: noop,
        m: noop,
        X: noop,
        S: noop,
        M: noop
    },
    p: 0,
    findDOMNode: null
}, REACT_PORTAL_TYPE = Symbol.for("react.portal");
function createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
exports.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = Internals;
exports.createPortal = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error(formatProdErrorMessage(299));
    return createPortal$1(children, container, null, key);
};
exports.flushSync = function(fn) {
    var previousTransition = ReactSharedInternals.T, previousUpdatePriority = Internals.p;
    try {
        if (ReactSharedInternals.T = null, Internals.p = 2, fn) return fn();
    } finally{
        ReactSharedInternals.T = previousTransition, Internals.p = previousUpdatePriority, Internals.d.f();
    }
};
exports.preconnect = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, Internals.d.C(href, options));
};
exports.prefetchDNS = function(href) {
    "string" === typeof href && Internals.d.D(href);
};
exports.preinit = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
exports.preinitModule = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
                Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && Internals.d.M(href);
    }
};
exports.preload = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin);
        Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
exports.preloadModule = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
            Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else Internals.d.m(href);
    }
};
exports.requestFormReset = function(form) {
    Internals.d.r(form);
};
exports.unstable_batchedUpdates = function(fn, a) {
    return fn(a);
};
exports.useFormState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
exports.useFormStatus = function() {
    return ReactSharedInternals.H.useHostTransitionStatus();
};
exports.version = "19.2.4";

},{"cac5e30c76bdcd20":"7e5Pu"}],"ceurZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _deckSwitcher = require("./DeckSwitcher");
var _deckSwitcherDefault = parcelHelpers.interopDefault(_deckSwitcher);
var _errorBoundary = require("./ErrorBoundary");
var _errorBoundaryDefault = parcelHelpers.interopDefault(_errorBoundary);
var _help = require("./Help");
var _helpDefault = parcelHelpers.interopDefault(_help);
var _htmlStyler = require("./HtmlStyler");
var _htmlStylerDefault = parcelHelpers.interopDefault(_htmlStyler);
const App = ({ store })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).StrictMode, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorBoundaryDefault.default), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRedux.Provider), {
                store: store,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _htmlStylerDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deckSwitcherDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _helpDefault.default), {})
                ]
            })
        })
    });
exports.default = App;

},{"react/jsx-runtime":"afIHK","react":"7e5Pu","react-redux":"904HS","./DeckSwitcher":"jNAIt","./ErrorBoundary":"lh9XQ","./Help":"lIETM","./HtmlStyler":"9bWnr","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"904HS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Provider", ()=>Provider_default);
parcelHelpers.export(exports, "ReactReduxContext", ()=>ReactReduxContext);
parcelHelpers.export(exports, "batch", ()=>batch);
parcelHelpers.export(exports, "connect", ()=>connect_default);
parcelHelpers.export(exports, "createDispatchHook", ()=>createDispatchHook);
parcelHelpers.export(exports, "createSelectorHook", ()=>createSelectorHook);
parcelHelpers.export(exports, "createStoreHook", ()=>createStoreHook);
parcelHelpers.export(exports, "shallowEqual", ()=>shallowEqual);
parcelHelpers.export(exports, "useDispatch", ()=>useDispatch);
parcelHelpers.export(exports, "useSelector", ()=>useSelector);
parcelHelpers.export(exports, "useStore", ()=>useStore);
// src/utils/react.ts
var _react = require("react");
// src/hooks/useSelector.ts
var _withSelectorJs = require("use-sync-external-store/with-selector.js");
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(b))if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var __spreadProps = (a, b)=>__defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/utils/react-is.ts
var IS_REACT_19 = /* @__PURE__ */ _react.version.startsWith("19");
var REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for(IS_REACT_19 ? "react.transitional.element" : "react.element");
var REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Memo = REACT_MEMO_TYPE;
function isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_OFFSCREEN_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_CONSUMER_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const { $$typeof } = object;
        switch($$typeof){
            case REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case REACT_FRAGMENT_TYPE:
                    case REACT_PROFILER_TYPE:
                    case REACT_STRICT_MODE_TYPE:
                    case REACT_SUSPENSE_TYPE:
                    case REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case REACT_CONTEXT_TYPE:
                            case REACT_FORWARD_REF_TYPE:
                            case REACT_LAZY_TYPE:
                            case REACT_MEMO_TYPE:
                                return object;
                            case REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function isContextConsumer(object) {
    return IS_REACT_19 ? typeOf(object) === REACT_CONSUMER_TYPE : typeOf(object) === REACT_CONTEXT_TYPE;
}
function isMemo(object) {
    return typeOf(object) === REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    verify(mapStateToProps, "mapStateToProps");
    verify(mapDispatchToProps, "mapDispatchToProps");
    verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual, areOwnPropsEqual, areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps, initMapDispatchToProps, initMergeProps } = _b, options = __objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function verifyPlainObject(value, displayName, methodName) {
    if (!isPlainObject(value)) warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? wrapMapToPropsConstant((dispatch)=>({
            dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return __spreadValues(__spreadValues(__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName, areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>defaultMergeProps : typeof mergeProps === "function" ? wrapMergePropsFunc(mergeProps) : createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var nullListeners = {
    notify () {},
    get: ()=>[]
};
function createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub,
        notifyNestedSubs,
        handleChangeWrapper,
        isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var isDOM = /* @__PURE__ */ canUseDOM();
var isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var isReactNative = /* @__PURE__ */ isRunningInReactNative();
var getUseIsomorphicLayoutEffect = ()=>isDOM || isReactNative ? _react.useLayoutEffect : _react.useEffect;
var useIsomorphicLayoutEffect = /* @__PURE__ */ getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function shallowEqual(objA, objB) {
    if (is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var TYPE_STATICS = {
    [ForwardRef]: FORWARD_REF_STATICS,
    [Memo]: MEMO_STATICS
};
function getStatics(component) {
    if (isMemo(component)) return MEMO_STATICS;
    return TYPE_STATICS[component["$$typeof"]] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if (objectPrototype) {
            const inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        const targetStatics = getStatics(targetComponent);
        const sourceStatics = getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function getContext() {
    var _a;
    if (!_react.createContext) return {};
    const contextMap = (_a = gT[ContextKey]) != null ? _a : gT[ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get(_react.createContext);
    if (!realContext) {
        realContext = _react.createContext(null);
        contextMap.set(_react.createContext, realContext);
    }
    return realContext;
}
var ReactReduxContext = /* @__PURE__ */ getContext();
// src/components/connect.tsx
var NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function strictEqual(a, b) {
    return a === b;
}
var hasWarnedAboutDeprecatedPureOption = false;
function connect(mapStateToProps, mapDispatchToProps, mergeProps, { // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual = strictEqual, areOwnPropsEqual = shallowEqual, areStatePropsEqual = shallowEqual, areMergedPropsEqual = shallowEqual, // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, // the context consumer to use
context = ReactReduxContext } = {}) {
    const Context = context;
    const initMapStateToProps = mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges,
            displayName,
            wrappedComponentName,
            WrappedComponent,
            // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps,
            initMergeProps,
            areStatesEqual,
            areStatePropsEqual,
            areOwnPropsEqual,
            areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = _react.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = __objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = _react.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = _react.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = _react.useMemo(()=>{
                return finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = _react.useMemo(()=>{
                if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY;
                const subscription2 = createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = _react.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return __spreadProps(__spreadValues({}, contextValue), {
                    subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = _react.useRef(void 0);
            const lastWrapperProps = _react.useRef(wrapperProps);
            const childPropsFromStoreUpdate = _react.useRef(void 0);
            const renderIsScheduled = _react.useRef(false);
            const isMounted = _react.useRef(false);
            const latestSubscriptionCallbackError = _react.useRef(void 0);
            useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = _react.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = _react.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = _react.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = _react.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ _react.createElement(WrappedComponent, __spreadProps(__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = _react.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ _react.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = _react.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = _react.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ _react.createElement(Connect, __spreadProps(__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var connect_default = connect;
// src/components/Provider.tsx
function Provider(providerProps) {
    const { children, context, serverState, store } = providerProps;
    const contextValue = _react.useMemo(()=>{
        const subscription = createSubscription(store);
        const baseContextValue = {
            store,
            subscription,
            getServerState: serverState ? ()=>serverState : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    const previousState = _react.useMemo(()=>store.getState(), [
        store
    ]);
    useIsomorphicLayoutEffect(()=>{
        const { subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || ReactReduxContext;
    return /* @__PURE__ */ _react.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var Provider_default = Provider;
// src/hooks/useReduxContext.ts
function createReduxContextHook(context = ReactReduxContext) {
    return function useReduxContext2() {
        const contextValue = _react.useContext(context);
        return contextValue;
    };
}
var useReduxContext = /* @__PURE__ */ createReduxContextHook();
// src/hooks/useStore.ts
function createStoreHook(context = ReactReduxContext) {
    const useReduxContext2 = context === ReactReduxContext ? useReduxContext : // @ts-ignore
    createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var useStore = /* @__PURE__ */ createStoreHook();
// src/hooks/useDispatch.ts
function createDispatchHook(context = ReactReduxContext) {
    const useStore2 = context === ReactReduxContext ? useStore : createStoreHook(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var useDispatch = /* @__PURE__ */ createDispatchHook();
var refEquality = (a, b)=>a === b;
function createSelectorHook(context = ReactReduxContext) {
    const useReduxContext2 = context === ReactReduxContext ? useReduxContext : createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn = refEquality } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const reduxContext = useReduxContext2();
        const { store, subscription, getServerState } = reduxContext;
        const firstRun = _react.useRef(true);
        const wrappedSelector = _react.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector
        ]);
        const selectedState = (0, _withSelectorJs.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        _react.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var useSelector = /* @__PURE__ */ createSelectorHook();
// src/exports.ts
var batch = defaultNoopBatch;

},{"react":"7e5Pu","use-sync-external-store/with-selector.js":"ifF0M","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"ifF0M":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("95913a8e57660898");

},{"95913a8e57660898":"3JSeg"}],"3JSeg":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("b0e5b28585d2b8bb");
function is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var objectIs = "function" === typeof Object.is ? Object.is : is, useSyncExternalStore = React.useSyncExternalStore, useRef = React.useRef, useEffect = React.useEffect, useMemo = React.useMemo, useDebugValue = React.useDebugValue;
exports.useSyncExternalStoreWithSelector = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if (objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    useDebugValue(value);
    return value;
};

},{"b0e5b28585d2b8bb":"7e5Pu"}],"jWxmR":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"jNAIt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _deck = require("./Deck");
var _deckDefault = parcelHelpers.interopDefault(_deck);
var _decks = require("./decks");
var _hooks = require("./app/hooks");
const DeckSwitcher = ()=>{
    const deckName = (0, _hooks.useAppSelector)((state)=>state.route.deck);
    const deck = (0, _decks.DECKS)[deckName];
    const Mdx = deck.default;
    (0, _react.useEffect)(()=>{
        const head = window.document.head;
        const title = head.getElementsByTagName("title")[0];
        if (!title) return;
        if (!deck.title) return;
        if (!title.dataset["orig"]) title.dataset["orig"] = title.text;
        const originalTitle = title.dataset["orig"];
        title.text = `${originalTitle} | ${deck.title}`;
        return ()=>{
            title.text = originalTitle;
        };
    }, [
        deck
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deckDefault.default), {
        MdxDocument: Mdx
    });
};
exports.default = DeckSwitcher;

},{"react/jsx-runtime":"afIHK","react":"7e5Pu","./Deck":"4zgfF","./decks":"fVdpz","./app/hooks":"8D69K","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"4zgfF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyLayout", ()=>applyLayout);
parcelHelpers.export(exports, "SlidesContext", ()=>SlidesContext);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _hooks = require("./app/hooks");
var _deckSlice = require("./features/deck/deckSlice");
var _directives = require("./Directives");
var _modeSelect = require("./ModeSelect");
var _modeSelectDefault = parcelHelpers.interopDefault(_modeSelect);
var _default = require("./layout/Default");
var _defaultDefault = parcelHelpers.interopDefault(_default);
var _prism = require("./Prism");
var _prismDefault = parcelHelpers.interopDefault(_prism);
const slideNew = ()=>({
        content: [],
        notes: [],
        layout: (0, _defaultDefault.default)
    });
const slideClone = (slide)=>({
        content: [
            ...slide.content
        ],
        notes: [
            ...slide.notes
        ],
        layout: slide.layout
    });
const applyLayout = (slide)=>slide && /*#__PURE__*/ (0, _jsxRuntime.jsx)(slide.layout, {
        children: slide.content
    });
const parseSlides = (children)=>{
    let location = "content";
    let slide = slideNew();
    const slides = [];
    for (const piece of children)if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(piece)) {
        const { type } = piece;
        if (type === (0, _directives.Notes)) location = "notes";
        else if (type === (0, _directives.Continue)) {
            slides.push(slideClone(slide));
            location = "content";
        } else if (type === (0, _directives.SlideLayout)) {
            const layoutPiece = piece;
            slide.layout = layoutPiece.props.use;
        } else if (type === "hr") {
            slides.push(slide);
            location = "content";
            slide = slideNew();
        } else slide[location].push(piece);
    }
    if (slide.content.length !== 0) slides.push(slide);
    return slides;
};
const SlidesContext = /*#__PURE__*/ (0, _react.createContext)([]);
const SplitSlides = ({ children })=>{
    const slides = (0, _react.useMemo)(()=>parseSlides((0, _reactDefault.default).Children.toArray(children)), [
        children
    ]);
    const dispatch = (0, _hooks.useAppDispatch)();
    (0, _react.useEffect)(()=>{
        dispatch((0, _deckSlice.setSlideCount)(slides.length));
    }, [
        dispatch,
        slides
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SlidesContext.Provider, {
        value: slides,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modeSelectDefault.default), {})
    });
};
const Pre = ({ children })=>{
    const kids = (0, _reactDefault.default).Children.map(children, (child)=>{
        if (!/*#__PURE__*/ ((0, _reactDefault.default).isValidElement(child) && child.props)) return child;
        if (child.type !== "code") return child;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _prismDefault.default), {
            ...child.props
        });
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
        children: kids
    });
};
const Deck = ({ MdxDocument })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(MdxDocument, {
        components: {
            SplitSlides,
            pre: Pre
        }
    });
exports.default = Deck;

},{"react/jsx-runtime":"afIHK","react":"7e5Pu","./app/hooks":"8D69K","./features/deck/deckSlice":"dvasY","./Directives":"6Yemz","./ModeSelect":"9NCi5","./layout/Default":"9KlDt","./Prism":"3bjv6","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"8D69K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAppDispatch", ()=>useAppDispatch);
parcelHelpers.export(exports, "useAppSelector", ()=>useAppSelector);
var _reactRedux = require("react-redux");
const useAppDispatch = ()=>(0, _reactRedux.useDispatch)();
const useAppSelector = (0, _reactRedux.useSelector);

},{"react-redux":"904HS","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"dvasY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deckSlice", ()=>deckSlice);
parcelHelpers.export(exports, "forward", ()=>forward);
parcelHelpers.export(exports, "backward", ()=>backward);
parcelHelpers.export(exports, "firstSlide", ()=>firstSlide);
parcelHelpers.export(exports, "lastSlide", ()=>lastSlide);
parcelHelpers.export(exports, "setSlideIndex", ()=>setSlideIndex);
parcelHelpers.export(exports, "setSlideCount", ()=>setSlideCount);
parcelHelpers.export(exports, "togglePresenter", ()=>togglePresenter);
parcelHelpers.export(exports, "enablePrint", ()=>enablePrint);
parcelHelpers.export(exports, "disablePrint", ()=>disablePrint);
parcelHelpers.export(exports, "toggleAspectRatio", ()=>toggleAspectRatio);
var _toolkit = require("@reduxjs/toolkit");
const initialState = {
    slideIndex: 1,
    slideCount: 0,
    mode: "display",
    aspectRatio: "16x9"
};
const deckSlice = (0, _toolkit.createSlice)({
    name: "deck",
    initialState,
    reducers: {
        forward: (state)=>{
            const { slideCount, slideIndex } = state;
            state.slideIndex = Math.min(slideCount, slideIndex + 1);
        },
        backward: (state)=>{
            const { slideIndex } = state;
            state.slideIndex = Math.max(1, slideIndex - 1);
        },
        firstSlide: (state)=>{
            state.slideIndex = 1;
        },
        lastSlide: (state)=>{
            const { slideCount } = state;
            state.slideIndex = slideCount;
        },
        setSlideIndex: (state, action)=>{
            state.slideIndex = action.payload;
        },
        setSlideCount: (state, action)=>{
            state.slideCount = action.payload;
        },
        togglePresenter: (state)=>{
            if (state.mode === "presenter") state.mode = "display";
            else state.mode = "presenter";
        },
        enablePrint: (state)=>{
            state.mode = "print";
        },
        disablePrint: (state)=>{
            state.mode = "display";
        },
        toggleAspectRatio: (state)=>{
            if (state.aspectRatio === "16x9") state.aspectRatio = "4x3";
            else state.aspectRatio = "16x9";
        }
    }
});
const { forward, backward, firstSlide, lastSlide, setSlideIndex, setSlideCount, togglePresenter, enablePrint, disablePrint, toggleAspectRatio } = deckSlice.actions;
exports.default = deckSlice.reducer;

},{"@reduxjs/toolkit":"4eORJ","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"4eORJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReducerType", ()=>ReducerType);
parcelHelpers.export(exports, "SHOULD_AUTOBATCH", ()=>SHOULD_AUTOBATCH);
parcelHelpers.export(exports, "TaskAbortError", ()=>TaskAbortError);
parcelHelpers.export(exports, "Tuple", ()=>Tuple);
parcelHelpers.export(exports, "addListener", ()=>addListener);
parcelHelpers.export(exports, "asyncThunkCreator", ()=>asyncThunkCreator);
parcelHelpers.export(exports, "autoBatchEnhancer", ()=>autoBatchEnhancer);
parcelHelpers.export(exports, "buildCreateSlice", ()=>buildCreateSlice);
parcelHelpers.export(exports, "clearAllListeners", ()=>clearAllListeners);
parcelHelpers.export(exports, "combineSlices", ()=>combineSlices);
parcelHelpers.export(exports, "configureStore", ()=>configureStore);
parcelHelpers.export(exports, "createAction", ()=>createAction);
parcelHelpers.export(exports, "createActionCreatorInvariantMiddleware", ()=>createActionCreatorInvariantMiddleware);
parcelHelpers.export(exports, "createAsyncThunk", ()=>createAsyncThunk);
parcelHelpers.export(exports, "createDraftSafeSelector", ()=>createDraftSafeSelector);
parcelHelpers.export(exports, "createDraftSafeSelectorCreator", ()=>createDraftSafeSelectorCreator);
parcelHelpers.export(exports, "createDynamicMiddleware", ()=>createDynamicMiddleware);
parcelHelpers.export(exports, "createEntityAdapter", ()=>createEntityAdapter);
parcelHelpers.export(exports, "createImmutableStateInvariantMiddleware", ()=>createImmutableStateInvariantMiddleware);
parcelHelpers.export(exports, "createListenerMiddleware", ()=>createListenerMiddleware);
parcelHelpers.export(exports, "createNextState", ()=>(0, _immer.produce));
parcelHelpers.export(exports, "createReducer", ()=>createReducer);
parcelHelpers.export(exports, "createSelector", ()=>(0, _reselect.createSelector));
parcelHelpers.export(exports, "createSelectorCreator", ()=>(0, _reselect.createSelectorCreator));
parcelHelpers.export(exports, "createSerializableStateInvariantMiddleware", ()=>createSerializableStateInvariantMiddleware);
parcelHelpers.export(exports, "createSlice", ()=>createSlice);
parcelHelpers.export(exports, "current", ()=>(0, _immer.current));
parcelHelpers.export(exports, "findNonSerializableValue", ()=>findNonSerializableValue);
parcelHelpers.export(exports, "formatProdErrorMessage", ()=>formatProdErrorMessage);
parcelHelpers.export(exports, "freeze", ()=>(0, _immer.freeze));
parcelHelpers.export(exports, "isActionCreator", ()=>isActionCreator);
parcelHelpers.export(exports, "isAllOf", ()=>isAllOf);
parcelHelpers.export(exports, "isAnyOf", ()=>isAnyOf);
parcelHelpers.export(exports, "isAsyncThunkAction", ()=>isAsyncThunkAction);
parcelHelpers.export(exports, "isDraft", ()=>(0, _immer.isDraft));
parcelHelpers.export(exports, "isFluxStandardAction", ()=>isFSA);
parcelHelpers.export(exports, "isFulfilled", ()=>isFulfilled);
parcelHelpers.export(exports, "isImmutableDefault", ()=>isImmutableDefault);
parcelHelpers.export(exports, "isPending", ()=>isPending);
parcelHelpers.export(exports, "isPlain", ()=>isPlain);
parcelHelpers.export(exports, "isRejected", ()=>isRejected);
parcelHelpers.export(exports, "isRejectedWithValue", ()=>isRejectedWithValue);
parcelHelpers.export(exports, "lruMemoize", ()=>(0, _reselect.lruMemoize));
parcelHelpers.export(exports, "miniSerializeError", ()=>miniSerializeError);
parcelHelpers.export(exports, "nanoid", ()=>nanoid);
parcelHelpers.export(exports, "original", ()=>(0, _immer.original));
parcelHelpers.export(exports, "prepareAutoBatched", ()=>prepareAutoBatched);
parcelHelpers.export(exports, "removeListener", ()=>removeListener);
parcelHelpers.export(exports, "unwrapResult", ()=>unwrapResult);
parcelHelpers.export(exports, "weakMapMemoize", ()=>(0, _reselect.weakMapMemoize));
// src/index.ts
var _redux = require("redux");
parcelHelpers.exportAll(_redux, exports);
var _immer = require("immer");
// src/index.ts
var _reselect = require("reselect");
// src/getDefaultMiddleware.ts
var _reduxThunk = require("redux-thunk");
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(b))if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var __spreadProps = (a, b)=>__defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var __publicField = (obj, key, value)=>__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
// src/createDraftSafeSelector.ts
var createDraftSafeSelectorCreator = (...args)=>{
    const createSelector2 = (0, _reselect.createSelectorCreator)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, _immer.isDraft)(value) ? (0, _immer.current)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var createDraftSafeSelector = /* @__PURE__ */ createDraftSafeSelectorCreator((0, _reselect.weakMapMemoize));
// src/devtoolsExtension.ts
var composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, _redux.compose;
    return (0, _redux.compose).apply(null, arguments);
};
var devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function createAction(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error(formatProdErrorMessage(0));
            return __spreadValues(__spreadValues({
                type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, _redux.isAction)(action) && action.type === type;
    return actionCreator;
}
function isActionCreator(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    hasMatchFunction(action);
}
function isFSA(action) {
    return (0, _redux.isAction)(action) && Object.keys(action).every(isValidKey);
}
function isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function createActionCreatorInvariantMiddleware(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/utils.ts
function getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
var Tuple = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function freezeDraftable(val) {
    return (0, _immer.isDraftable)(val) ? (0, _immer.produce)(val, ()=>{}) : val;
}
function getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
// src/immutableStateInvariantMiddleware.ts
function isImmutableDefault(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function trackForMutations(isImmutable, ignoredPaths, obj) {
    const trackedProperties = trackProperties(isImmutable, ignoredPaths, obj);
    return {
        detectMutations () {
            return detectMutations(isImmutable, ignoredPaths, trackedProperties, obj);
        }
    };
}
function trackProperties(isImmutable, ignoredPaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        const hasIgnoredPaths = ignoredPaths.length > 0;
        for(const key in obj){
            const nestedPath = path ? path + "." + key : key;
            if (hasIgnoredPaths) {
                const hasMatches = ignoredPaths.some((ignored)=>{
                    if (ignored instanceof RegExp) return ignored.test(nestedPath);
                    return nestedPath === ignored;
                });
                if (hasMatches) continue;
            }
            tracked.children[key] = trackProperties(isImmutable, ignoredPaths, obj[key], nestedPath);
        }
    }
    return tracked;
}
function detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function createImmutableStateInvariantMiddleware(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/serializableStateInvariantMiddleware.ts
function isPlain(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, _redux.isPlainObject)(val);
}
function findNonSerializableValue(value, path = "", isSerializable = isPlain, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = findNonSerializableValue(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && isNestedFrozen(value)) cache.add(value);
    return false;
}
function isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function createSerializableStateInvariantMiddleware(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function isBoolean(x) {
    return typeof x === "boolean";
}
var buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk = true, immutableCheck = true, serializableCheck = true, actionCreatorCheck = true } = options != null ? options : {};
        let middlewareArray = new Tuple();
        if (thunk) {
            if (isBoolean(thunk)) middlewareArray.push((0, _reduxThunk.thunk));
            else middlewareArray.push((0, _reduxThunk.withExtraArgument)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var SHOULD_AUTOBATCH = "RTK_autoBatch";
var prepareAutoBatched = ()=>(payload)=>({
            payload,
            meta: {
                [SHOULD_AUTOBATCH]: true
            }
        });
var createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var autoBatchEnhancer = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
            typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[SHOULD_AUTOBATCH]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch = true } = options != null ? options : {};
        let enhancerArray = new Tuple(middlewareEnhancer);
        if (autoBatch) enhancerArray.push(autoBatchEnhancer(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
function configureStore(options) {
    const getDefaultMiddleware = buildGetDefaultMiddleware();
    const { reducer, middleware, devTools = true, duplicateMiddlewareCheck = true, preloadedState, enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, _redux.isPlainObject)(reducer)) rootReducer = (0, _redux.combineReducers)(reducer);
    else throw new Error(formatProdErrorMessage(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    var middleware2;
    let finalCompose = (0, _redux.compose);
    if (devTools) finalCompose = composeWithDevTools(__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false
    }, typeof devTools === "object" && devTools));
    const middlewareEnhancer = (0, _redux.applyMiddleware)(...finalMiddleware);
    const getDefaultEnhancers = buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, _redux.createStore)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error(formatProdErrorMessage(28));
            if (type in actionsMap) throw new Error(formatProdErrorMessage(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addAsyncThunk (asyncThunk, reducers) {
            if (reducers.pending) actionsMap[asyncThunk.pending.type] = reducers.pending;
            if (reducers.rejected) actionsMap[asyncThunk.rejected.type] = reducers.rejected;
            if (reducers.fulfilled) actionsMap[asyncThunk.fulfilled.type] = reducers.fulfilled;
            if (reducers.settled) actionMatchers.push({
                matcher: asyncThunk.settled,
                reducer: reducers.settled
            });
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher,
                reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function isStateFunction(x) {
    return typeof x === "function";
}
function createReducer(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if (isStateFunction(initialState)) getInitialState = ()=>freezeDraftable(initialState());
    else {
        const frozenInitialState = freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, _immer.isDraft)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, _immer.isDraftable)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, _immer.produce)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var matches = (matcher, action)=>{
    if (hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function isAnyOf(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>matches(matcher, action));
    };
}
function isAllOf(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>matches(matcher, action));
    };
}
function hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function isPending(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!isAsyncThunkArray(asyncThunks)) return isPending()(asyncThunks[0]);
    return isAnyOf(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function isRejected(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!isAsyncThunkArray(asyncThunks)) return isRejected()(asyncThunks[0]);
    return isAnyOf(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function isRejectedWithValue(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return isAllOf(isRejected(...asyncThunks), hasFlag);
    if (!isAsyncThunkArray(asyncThunks)) return isRejectedWithValue()(asyncThunks[0]);
    return isAllOf(isRejected(...asyncThunks), hasFlag);
}
function isFulfilled(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!isAsyncThunkArray(asyncThunks)) return isFulfilled()(asyncThunks[0]);
    return isAnyOf(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function isAsyncThunkAction(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!isAsyncThunkArray(asyncThunks)) return isAsyncThunkAction()(asyncThunks[0]);
    return isAnyOf(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/nanoid.ts
var urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var nanoid = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ __publicField(this, "_type");
    }
};
var FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ __publicField(this, "_type");
    }
};
var miniSerializeError = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var externalAbortMessage = "External signal was aborted";
var createAsyncThunk = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = createAction(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload,
                meta: __spreadProps(__spreadValues({}, meta || {}), {
                    arg,
                    requestId,
                    requestStatus: "fulfilled"
                })
            }));
        const pending = createAction(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: __spreadProps(__spreadValues({}, meta || {}), {
                    arg,
                    requestId,
                    requestStatus: "pending"
                })
            }));
        const rejected = createAction(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload,
                error: (options && options.serializeError || miniSerializeError)(error || "Rejected"),
                meta: __spreadProps(__spreadValues({}, meta || {}), {
                    arg,
                    requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            }));
        function actionCreator(arg, { signal } = {}) {
            return (dispatch, getState, extra)=>{
                const requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : nanoid();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                if (signal) {
                    if (signal.aborted) abort(externalAbortMessage);
                    else signal.addEventListener("abort", ()=>abort(externalAbortMessage), {
                        once: true
                    });
                }
                const promise = async function() {
                    var _a, _b;
                    let finalAction;
                    try {
                        let conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                            getState,
                            extra
                        });
                        if (isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler, {
                                once: true
                            });
                        });
                        dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                            requestId,
                            arg
                        }, {
                            getState,
                            extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch,
                                getState,
                                extra,
                                requestId,
                                signal: abortController.signal,
                                abort,
                                rejectWithValue: (value, meta)=>{
                                    return new RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof RejectWithValue) throw result;
                                if (result instanceof FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort,
                    requestId,
                    arg,
                    unwrap () {
                        return promise.then(unwrapResult);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending,
            rejected,
            fulfilled,
            settled: isAnyOf(rejected, fulfilled),
            typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function unwrapResult(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var asyncThunkCreator = {
    [asyncThunkSymbol]: createAsyncThunk
};
var ReducerType = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})(ReducerType || {});
function getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function buildCreateSlice({ creators } = {}) {
    var _a;
    const cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[asyncThunkSymbol];
    return function createSlice2(options) {
        const { name, reducerPath = name } = options;
        if (!name) throw new Error(formatProdErrorMessage(11));
        const reducers = (typeof options.reducers === "function" ? options.reducers(buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error(formatProdErrorMessage(12));
                if (type in context.sliceCaseReducersByType) throw new Error(formatProdErrorMessage(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName,
                type: getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if (isAsyncThunkSliceReducerDefinition(reducerDefinition)) handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = __spreadValues(__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return createReducer(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        const injectedStateCache = /* @__PURE__ */ new WeakMap();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = getOrInsertComputed(injectedStateCache, selectSlice, getInitialState);
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = getOrInsertComputed(injectedSelectorCache, injected, ()=>/* @__PURE__ */ new WeakMap());
                return getOrInsertComputed(selectorCache, selectState, ()=>{
                    var _a2;
                    const map = {};
                    for (const [name2, selector] of Object.entries((_a2 = options.selectors) != null ? _a2 : {}))map[name2] = wrapSelector(selector, selectState, ()=>getOrInsertComputed(injectedStateCache, selectState, getInitialState), injected);
                    return map;
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice
            };
        }
        const slice = __spreadProps(__spreadValues({
            name,
            reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto (injectable, _a2 = {}) {
                var _b = _a2, { reducerPath: pathOpt } = _b, config = __objRest(_b, [
                    "reducerPath"
                ]);
                const newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer
                }, config);
                return __spreadValues(__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var createSlice = /* @__PURE__ */ buildCreateSlice();
function buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return __spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator
        }, config);
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare,
                reducer
            };
        },
        asyncThunk
    };
}
function handleNormalReducerDefinition({ type, reducerName, createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error(formatProdErrorMessage(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? createAction(type, prepareCallback) : createAction(type));
}
function isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function handleThunkCaseReducerDefinition({ type, reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error(formatProdErrorMessage(18));
    const { payloadCreator, fulfilled, pending, rejected, settled, options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || noop,
        pending: pending || noop,
        rejected: rejected || noop,
        settled: settled || noop
    });
}
function noop() {}
// src/entities/entity_state.ts
function getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign(getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState
    };
}
// src/entities/state_selectors.ts
function createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = createDraftSafeSelector } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds,
            selectEntities,
            selectAll,
            selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors
    };
}
// src/entities/state_adapter.ts
var isDraftTyped = (0, _immer.isDraft);
function createSingleArgumentStateOperator(mutator) {
    const operator = createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return isFSA(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if (isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, _immer.produce)(state, runMutator);
    };
}
// src/entities/utils.ts
function selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function getCurrent(value) {
    return (0, _immer.isDraft)(value) ? (0, _immer.current)(value) : value;
}
function splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = ensureEntitiesArray(newEntities);
    const existingIdsArray = getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const addedIds = /* @__PURE__ */ new Set([]);
    const updated = [];
    for (const entity of newEntities){
        const id = selectIdValue(entity, selectId);
        if (existingIds.has(id) || addedIds.has(id)) updated.push({
            id,
            changes: entity
        });
        else {
            addedIds.add(id);
            added.push(entity);
        }
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: __spreadValues(__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = splitAddedUpdatedEntities(newEntities, selectId, state);
        addManyMutably(added, state);
        updateManyMutably(updated, state);
    }
    return {
        removeAll: createSingleArgumentStateOperator(removeAllMutably),
        addOne: createStateOperator(addOneMutably),
        addMany: createStateOperator(addManyMutably),
        setOne: createStateOperator(setOneMutably),
        setMany: createStateOperator(setManyMutably),
        setAll: createStateOperator(setAllMutably),
        updateOne: createStateOperator(updateOneMutably),
        updateMany: createStateOperator(updateManyMutably),
        upsertOne: createStateOperator(upsertOneMutably),
        upsertMany: createStateOperator(upsertManyMutably),
        removeOne: createStateOperator(removeOneMutably),
        removeMany: createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function createSortedStateAdapter(selectId, comparer) {
    const { removeOne, removeMany, removeAll } = createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds != null ? existingIds : getCurrent(state.ids));
        const addedKeys = /* @__PURE__ */ new Set();
        const models = newEntities.filter((model)=>{
            const modelId = selectIdValue(model, selectId);
            const notAdded = !addedKeys.has(modelId);
            if (notAdded) addedKeys.add(modelId);
            return !existingKeys.has(modelId) && notAdded;
        });
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        let deduplicatedEntities = {};
        newEntities = ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities){
                const entityId = selectId(item);
                deduplicatedEntities[entityId] = item;
                delete state.entities[entityId];
            }
            newEntities = ensureEntitiesArray(deduplicatedEntities);
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = splitAddedUpdatedEntities(newEntities, selectId, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
        if (updated.length) updateManyMutably(updated, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = getCurrent(state.entities);
        const currentIds = getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne,
        removeMany,
        removeAll,
        addOne: createStateOperator(addOneMutably),
        updateOne: createStateOperator(updateOneMutably),
        upsertOne: createStateOperator(upsertOneMutably),
        setOne: createStateOperator(setOneMutably),
        setMany: createStateOperator(setManyMutably),
        setAll: createStateOperator(setAllMutably),
        addMany: createStateOperator(addManyMutably),
        updateMany: createStateOperator(updateManyMutably),
        upsertMany: createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function createEntityAdapter(options = {}) {
    const { selectId, sortComparer } = __spreadValues({
        sortComparer: false,
        selectId: (instance)=>instance.id
    }, options);
    const stateAdapter = sortComparer ? createSortedStateAdapter(selectId, sortComparer) : createUnsortedStateAdapter(selectId);
    const stateFactory = createInitialStateFactory(stateAdapter);
    const selectorsFactory = createSelectorsFactory();
    return __spreadValues(__spreadValues(__spreadValues({
        selectId,
        sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var task = "task";
var listener = "listener";
var completed = "completed";
var cancelled = "cancelled";
var taskCancelled = `task-${cancelled}`;
var taskCompleted = `task-${completed}`;
var listenerCancelled = `${listener}-${cancelled}`;
var listenerCompleted = `${listener}-${completed}`;
var TaskAbortError = class {
    constructor(code){
        this.code = code;
        __publicField(this, "name", "TaskAbortError");
        __publicField(this, "message");
        this.message = `${task} ${cancelled} (reason: ${code})`;
    }
};
// src/listenerMiddleware/utils.ts
var assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new TypeError(formatProdErrorMessage(32));
};
var noop2 = ()=>{};
var catchRejection = (promise, onError = noop2)=>{
    promise.catch(onError);
    return promise;
};
var addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
// src/listenerMiddleware/task.ts
var validateActive = (signal)=>{
    if (signal.aborted) throw new TaskAbortError(signal.reason);
};
function raceWithSignal(signal, promise) {
    let cleanup = noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new TaskAbortError(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = noop2;
    });
}
var runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value
        };
    } catch (error) {
        return {
            status: error instanceof TaskAbortError ? "cancelled" : "rejected",
            error
        };
    } finally{
        cleanUp == null || cleanUp();
    }
};
var createPause = (signal)=>{
    return (promise)=>{
        return catchRejection(raceWithSignal(signal, promise).then((output)=>{
            validateActive(signal);
            return output;
        }));
    };
};
var createDelay = (signal)=>{
    const pause = createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign } = Object;
var INTERNAL_NIL_TOKEN = {};
var alm = "listenerMiddleware";
var createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>addAbortSignalListener(parentAbortSignal, ()=>controller.abort(parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = runTask(async ()=>{
            validateActive(parentAbortSignal);
            validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: createPause(childAbortController.signal),
                delay: createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            validateActive(childAbortController.signal);
            return result2;
        }, ()=>childAbortController.abort(taskCompleted));
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch(noop2));
        return {
            result: createPause(parentAbortSignal)(result),
            cancel () {
                childAbortController.abort(taskCancelled);
            }
        };
    };
};
var createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await raceWithSignal(signal, Promise.race(promises));
            validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>catchRejection(take(predicate, timeout));
};
var getListenerEntryPropsFrom = (options)=>{
    let { type, actionCreator, matcher, predicate, effect } = options;
    if (type) predicate = createAction(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error(formatProdErrorMessage(21));
    assertFunction(effect, "options.listener");
    return {
        predicate,
        type,
        effect
    };
};
var createListenerEntry = /* @__PURE__ */ assign((options)=>{
    const { type, predicate, effect } = getListenerEntryPropsFrom(options);
    const entry = {
        id: nanoid(),
        effect,
        type,
        predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error(formatProdErrorMessage(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>createListenerEntry
});
var findListenerEntry = (listenerMap, options)=>{
    const { type, effect, predicate } = getListenerEntryPropsFrom(options);
    return Array.from(listenerMap.values()).find((entry)=>{
        const matchPredicateOrType = typeof type === "string" ? entry.type === type : entry.predicate === predicate;
        return matchPredicateOrType && entry.effect === effect;
    });
};
var cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        controller.abort(listenerCancelled);
    });
};
var createClearListenerMiddleware = (listenerMap, executingListeners)=>{
    return ()=>{
        for (const listener2 of executingListeners.keys())cancelActiveListeners(listener2);
        listenerMap.clear();
    };
};
var safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var addListener = /* @__PURE__ */ assign(/* @__PURE__ */ createAction(`${alm}/add`), {
    withTypes: ()=>addListener
});
var clearAllListeners = /* @__PURE__ */ createAction(`${alm}/removeAll`);
var removeListener = /* @__PURE__ */ assign(/* @__PURE__ */ createAction(`${alm}/remove`), {
    withTypes: ()=>removeListener
});
var defaultErrorHandler = (...args)=>{
    console.error(`${alm}/error`, ...args);
};
var createListenerMiddleware = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const executingListeners = /* @__PURE__ */ new Map();
    const trackExecutingListener = (entry)=>{
        var _a;
        const count = (_a = executingListeners.get(entry)) != null ? _a : 0;
        executingListeners.set(entry, count + 1);
    };
    const untrackExecutingListener = (entry)=>{
        var _a;
        const count = (_a = executingListeners.get(entry)) != null ? _a : 1;
        if (count === 1) executingListeners.delete(entry);
        else executingListeners.set(entry, count - 1);
    };
    const { extra, onError = defaultErrorHandler } = middlewareOptions;
    assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        var _a;
        const entry = (_a = findListenerEntry(listenerMap, options)) != null ? _a : createListenerEntry(options);
        return insertEntry(entry);
    };
    assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const entry = findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) cancelActiveListeners(entry);
        }
        return !!entry;
    };
    assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            trackExecutingListener(entry);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            assign({}, api, {
                getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take,
                delay: createDelay(internalTaskController.signal),
                pause: createPause(internalTaskController.signal),
                extra,
                signal: internalTaskController.signal,
                fork: createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            controller.abort(listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    internalTaskController.abort(listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof TaskAbortError)) safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            internalTaskController.abort(listenerCompleted);
            untrackExecutingListener(entry);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = createClearListenerMiddleware(listenerMap, executingListeners);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, _redux.isAction)(action)) return next(action);
                if (addListener.match(action)) return startListening(action.payload);
                if (clearAllListeners.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if (removeListener.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === INTERNAL_NIL_TOKEN) throw new Error(formatProdErrorMessage(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware,
        startListening,
        stopListening,
        clearListeners: clearListenerMiddleware
    };
};
// src/dynamicMiddleware/index.ts
var createMiddlewareEntry = (middleware)=>({
        middleware,
        applied: /* @__PURE__ */ new Map()
    });
var matchInstance = (instanceId)=>(action)=>{
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
var createDynamicMiddleware = ()=>{
    const instanceId = nanoid();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign(createAction("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            getOrInsertComputed(middlewareMap, middleware2, createMiddlewareEntry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>getOrInsertComputed(entry.applied, api, entry.middleware));
        return (0, _redux.compose)(...appliedMiddleware);
    };
    const isWithMiddleware = isAllOf(withMiddleware, matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware,
        addMiddleware,
        withMiddleware,
        instanceId
    };
};
var isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var getReducers = (slices)=>slices.flatMap((sliceOrMap)=>isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var isStateProxy = (value)=>!!value && !!value[ORIGINAL_STATE];
var stateProxyMap = /* @__PURE__ */ new WeakMap();
var createStateProxy = (state, reducerMap, initialStateCache)=>getOrInsertComputed(stateProxyMap, state, ()=>new Proxy(state, {
            get: (target, prop, receiver)=>{
                if (prop === ORIGINAL_STATE) return target;
                const result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    const cached = initialStateCache[prop];
                    if (typeof cached !== "undefined") return cached;
                    const reducer = reducerMap[prop];
                    if (reducer) {
                        const reducerResult = reducer(void 0, {
                            type: nanoid()
                        });
                        if (typeof reducerResult === "undefined") throw new Error(formatProdErrorMessage(24));
                        initialStateCache[prop] = reducerResult;
                        return reducerResult;
                    }
                }
                return result;
            }
        }));
var original = (state)=>{
    if (!isStateProxy(state)) throw new Error(formatProdErrorMessage(25));
    return state[ORIGINAL_STATE];
};
var emptyObject = {};
var noopReducer = (state = emptyObject)=>state;
function combineSlices(...slices) {
    const reducerMap = Object.fromEntries(getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, _redux.combineReducers)(reducerMap) : noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const initialStateCache = {};
    const inject = (slice, config = {})=>{
        const { reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) return combinedReducer;
        if (config.overrideExisting && currentReducer !== reducerToInject) delete initialStateCache[reducerPath];
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn(createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap, initialStateCache), ...args);
        };
    }, {
        original
    });
    return Object.assign(combinedReducer, {
        inject,
        selector
    });
}
// src/formatProdErrorMessage.ts
function formatProdErrorMessage(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}

},{"redux":"ey6Uw","immer":"5Dlb5","reselect":"ixVP6","redux-thunk":"h3rB4","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"ey6Uw":[function(require,module,exports,__globalThis) {
// src/utils/formatProdErrorMessage.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__DO_NOT_USE__ActionTypes", ()=>actionTypes_default);
parcelHelpers.export(exports, "applyMiddleware", ()=>applyMiddleware);
parcelHelpers.export(exports, "bindActionCreators", ()=>bindActionCreators);
parcelHelpers.export(exports, "combineReducers", ()=>combineReducers);
parcelHelpers.export(exports, "compose", ()=>compose);
parcelHelpers.export(exports, "createStore", ()=>createStore);
parcelHelpers.export(exports, "isAction", ()=>isAction);
parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
parcelHelpers.export(exports, "legacy_createStore", ()=>legacy_createStore);
function formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var symbol_observable_default = $$observable;
// src/utils/actionTypes.ts
var randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var ActionTypes = {
    INIT: `@@redux/INIT${randomString()}`,
    REPLACE: `@@redux/REPLACE${randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${randomString()}`
};
var actionTypes_default = ActionTypes;
// src/utils/isPlainObject.ts
function isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if (isDate(val)) return "date";
    if (isError(val)) return "error";
    const constructorName = ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function createStore(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error(formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error(formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error(formatProdErrorMessage(1));
        return enhancer(createStore)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error(formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error(formatProdErrorMessage(4));
        if (isDispatching) throw new Error(formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error(formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!isPlainObject(action)) throw new Error(formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error(formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error(formatProdErrorMessage(17));
        if (isDispatching) throw new Error(formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error(formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: actionTypes_default.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error(formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe
                };
            },
            [symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: actionTypes_default.INIT
    });
    const store = {
        dispatch,
        subscribe,
        getState,
        replaceReducer,
        [symbol_observable_default]: observable
    };
    return store;
}
function legacy_createStore(reducer, preloadedState, enhancer) {
    return createStore(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === actionTypes_default.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!isPlainObject(inputState)) return `The ${argumentName} has unexpected type of "${kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === actionTypes_default.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: actionTypes_default.INIT
        });
        if (typeof initialState === "undefined") throw new Error(formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: actionTypes_default.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error(formatProdErrorMessage(13));
    });
}
function combineReducers(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error(formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function bindActionCreators(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error(formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function compose(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function applyMiddleware(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error(formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = compose(...chain)(store.dispatch);
            return {
                ...store,
                dispatch
            };
        };
}
// src/utils/isAction.ts
function isAction(action) {
    return isPlainObject(action) && "type" in action && typeof action.type === "string";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"5Dlb5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Immer", ()=>Immer2);
parcelHelpers.export(exports, "applyPatches", ()=>applyPatches);
parcelHelpers.export(exports, "castDraft", ()=>castDraft);
parcelHelpers.export(exports, "castImmutable", ()=>castImmutable);
parcelHelpers.export(exports, "createDraft", ()=>createDraft);
parcelHelpers.export(exports, "current", ()=>current);
parcelHelpers.export(exports, "enableArrayMethods", ()=>enableArrayMethods);
parcelHelpers.export(exports, "enableMapSet", ()=>enableMapSet);
parcelHelpers.export(exports, "enablePatches", ()=>enablePatches);
parcelHelpers.export(exports, "finishDraft", ()=>finishDraft);
parcelHelpers.export(exports, "freeze", ()=>freeze);
parcelHelpers.export(exports, "immerable", ()=>DRAFTABLE);
parcelHelpers.export(exports, "isDraft", ()=>isDraft);
parcelHelpers.export(exports, "isDraftable", ()=>isDraftable);
parcelHelpers.export(exports, "nothing", ()=>NOTHING);
parcelHelpers.export(exports, "original", ()=>original);
parcelHelpers.export(exports, "produce", ()=>produce);
parcelHelpers.export(exports, "produceWithPatches", ()=>produceWithPatches);
parcelHelpers.export(exports, "setAutoFreeze", ()=>setAutoFreeze);
parcelHelpers.export(exports, "setUseStrictIteration", ()=>setUseStrictIteration);
parcelHelpers.export(exports, "setUseStrictShallowCopy", ()=>setUseStrictShallowCopy);
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(b))if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var NOTHING = Symbol.for("immer-nothing");
var DRAFTABLE = Symbol.for("immer-draftable");
var DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var errors = [];
function die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var O = Object;
var getPrototypeOf = O.getPrototypeOf;
var CONSTRUCTOR = "constructor";
var PROTOTYPE = "prototype";
var CONFIGURABLE = "configurable";
var ENUMERABLE = "enumerable";
var WRITABLE = "writable";
var VALUE = "value";
var isDraft = (value)=>!!value && !!value[DRAFT_STATE];
function isDraftable(value) {
    var _a;
    if (!value) return false;
    return isPlainObject(value) || isArray(value) || !!value[DRAFTABLE] || !!((_a = value[CONSTRUCTOR]) == null ? void 0 : _a[DRAFTABLE]) || isMap(value) || isSet(value);
}
var objectCtorString = O[PROTOTYPE][CONSTRUCTOR].toString();
var cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function isPlainObject(value) {
    if (!value || !isObjectish(value)) return false;
    const proto = getPrototypeOf(value);
    if (proto === null || proto === O[PROTOTYPE]) return true;
    const Ctor = O.hasOwnProperty.call(proto, CONSTRUCTOR) && proto[CONSTRUCTOR];
    if (Ctor === Object) return true;
    if (!isFunction(Ctor)) return false;
    let ctorString = cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === objectCtorString;
}
function original(value) {
    if (!isDraft(value)) die(15, value);
    return value[DRAFT_STATE].base_;
}
function each(obj, iter, strict = true) {
    if (getArchtype(obj) === 0 /* Object */ ) {
        const keys = strict ? Reflect.ownKeys(obj) : O.keys(obj);
        keys.forEach((key)=>{
            iter(key, obj[key], obj);
        });
    } else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function getArchtype(thing) {
    const state = thing[DRAFT_STATE];
    return state ? state.type_ : isArray(thing) ? 1 /* Array */  : isMap(thing) ? 2 /* Map */  : isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
var has = (thing, prop, type = getArchtype(thing))=>type === 2 /* Map */  ? thing.has(prop) : O[PROTOTYPE].hasOwnProperty.call(thing, prop);
var get = (thing, prop, type = getArchtype(thing))=>// @ts-ignore
    type === 2 /* Map */  ? thing.get(prop) : thing[prop];
var set = (thing, propOrOldValue, value, type = getArchtype(thing))=>{
    if (type === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (type === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
};
function is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
var isArray = Array.isArray;
var isMap = (target)=>target instanceof Map;
var isSet = (target)=>target instanceof Set;
var isObjectish = (target)=>typeof target === "object";
var isFunction = (target)=>typeof target === "function";
var isBoolean = (target)=>typeof target === "boolean";
function isArrayIndex(value) {
    const n = +value;
    return Number.isInteger(n) && String(n) === value;
}
var getProxyDraft = (value)=>{
    if (!isObjectish(value)) return null;
    return value == null ? void 0 : value[DRAFT_STATE];
};
var latest = (state)=>state.copy_ || state.base_;
var getValue = (value)=>{
    var _a;
    const proxyDraft = getProxyDraft(value);
    return proxyDraft ? (_a = proxyDraft.copy_) != null ? _a : proxyDraft.base_ : value;
};
var getFinalValue = (state)=>state.modified_ ? state.copy_ : state.base_;
function shallowCopy(base, strict) {
    if (isMap(base)) return new Map(base);
    if (isSet(base)) return new Set(base);
    if (isArray(base)) return Array[PROTOTYPE].slice.call(base);
    const isPlain = isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = O.getOwnPropertyDescriptors(base);
        delete descriptors[DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc[WRITABLE] === false) {
                desc[WRITABLE] = true;
                desc[CONFIGURABLE] = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                [CONFIGURABLE]: true,
                [WRITABLE]: true,
                // could live with !!desc.set as well here...
                [ENUMERABLE]: desc[ENUMERABLE],
                [VALUE]: base[key]
            };
        }
        return O.create(getPrototypeOf(base), descriptors);
    } else {
        const proto = getPrototypeOf(base);
        if (proto !== null && isPlain) return __spreadValues({}, base);
        const obj = O.create(proto);
        return O.assign(obj, base);
    }
}
function freeze(obj, deep = false) {
    if (isFrozen(obj) || isDraft(obj) || !isDraftable(obj)) return obj;
    if (getArchtype(obj) > 1) O.defineProperties(obj, {
        set: dontMutateMethodOverride,
        add: dontMutateMethodOverride,
        clear: dontMutateMethodOverride,
        delete: dontMutateMethodOverride
    });
    O.freeze(obj);
    if (deep) each(obj, (_key, value)=>{
        freeze(value, true);
    }, false);
    return obj;
}
function dontMutateFrozenCollections() {
    die(2);
}
var dontMutateMethodOverride = {
    [VALUE]: dontMutateFrozenCollections
};
function isFrozen(obj) {
    if (obj === null || !isObjectish(obj)) return true;
    return O.isFrozen(obj);
}
// src/utils/plugins.ts
var PluginMapSet = "MapSet";
var PluginPatches = "Patches";
var PluginArrayMethods = "ArrayMethods";
var plugins = {};
function getPlugin(pluginKey) {
    const plugin = plugins[pluginKey];
    if (!plugin) die(0, pluginKey);
    return plugin;
}
var isPluginLoaded = (pluginKey)=>!!plugins[pluginKey];
function loadPlugin(pluginKey, implementation) {
    if (!plugins[pluginKey]) plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var currentScope;
var getCurrentScope = ()=>currentScope;
var createScope = (parent_, immer_)=>({
        drafts_: [],
        parent_,
        immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0,
        handledSet_: /* @__PURE__ */ new Set(),
        processedForPatches_: /* @__PURE__ */ new Set(),
        mapSetPlugin_: isPluginLoaded(PluginMapSet) ? getPlugin(PluginMapSet) : void 0,
        arrayMethodsPlugin_: isPluginLoaded(PluginArrayMethods) ? getPlugin(PluginArrayMethods) : void 0
    });
function usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        scope.patchPlugin_ = getPlugin(PluginPatches);
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function revokeScope(scope) {
    leaveScope(scope);
    scope.drafts_.forEach(revokeDraft);
    scope.drafts_ = null;
}
function leaveScope(scope) {
    if (scope === currentScope) currentScope = scope.parent_;
}
var enterScope = (immer2)=>currentScope = createScope(currentScope, immer2);
function revokeDraft(draft) {
    const state = draft[DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[DRAFT_STATE].modified_) {
            revokeScope(scope);
            die(4);
        }
        if (isDraftable(result)) result = finalize(scope, result);
        const { patchPlugin_ } = scope;
        if (patchPlugin_) patchPlugin_.generateReplacementPatches_(baseDraft[DRAFT_STATE].base_, result, scope);
    } else result = finalize(scope, baseDraft);
    maybeFreeze(scope, result, true);
    revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== NOTHING ? result : void 0;
}
function finalize(rootScope, value) {
    if (isFrozen(value)) return value;
    const state = value[DRAFT_STATE];
    if (!state) {
        const finalValue = handleValue(value, rootScope.handledSet_, rootScope);
        return finalValue;
    }
    if (!isSameScope(state, rootScope)) return value;
    if (!state.modified_) return state.base_;
    if (!state.finalized_) {
        const { callbacks_ } = state;
        if (callbacks_) while(callbacks_.length > 0){
            const callback = callbacks_.pop();
            callback(rootScope);
        }
        generatePatchesAndFinalize(state, rootScope);
    }
    return state.copy_;
}
function maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) freeze(value, deep);
}
function markStateFinalized(state) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
}
var isSameScope = (state, rootScope)=>state.scope_ === rootScope;
var EMPTY_LOCATIONS_RESULT = [];
function updateDraftInParent(parent, draftValue, finalizedValue, originalKey) {
    var _a;
    const parentCopy = latest(parent);
    const parentType = parent.type_;
    if (originalKey !== void 0) {
        const currentValue = get(parentCopy, originalKey, parentType);
        if (currentValue === draftValue) {
            set(parentCopy, originalKey, finalizedValue, parentType);
            return;
        }
    }
    if (!parent.draftLocations_) {
        const draftLocations = parent.draftLocations_ = /* @__PURE__ */ new Map();
        each(parentCopy, (key, value)=>{
            if (isDraft(value)) {
                const keys = draftLocations.get(value) || [];
                keys.push(key);
                draftLocations.set(value, keys);
            }
        });
    }
    const locations = (_a = parent.draftLocations_.get(draftValue)) != null ? _a : EMPTY_LOCATIONS_RESULT;
    for (const location of locations)set(parentCopy, location, finalizedValue, parentType);
}
function registerChildFinalizationCallback(parent, child, key) {
    parent.callbacks_.push(function childCleanup(rootScope) {
        var _a, _b;
        const state = child;
        if (!state || !isSameScope(state, rootScope)) return;
        (_a = rootScope.mapSetPlugin_) == null || _a.fixSetContents(state);
        const finalizedValue = getFinalValue(state);
        updateDraftInParent(parent, (_b = state.draft_) != null ? _b : state, finalizedValue, key);
        generatePatchesAndFinalize(state, rootScope);
    });
}
function generatePatchesAndFinalize(state, rootScope) {
    var _a, _b;
    const shouldFinalize = state.modified_ && !state.finalized_ && (state.type_ === 3 /* Set */  || state.type_ === 1 /* Array */  && state.allIndicesReassigned_ || ((_b = (_a = state.assigned_) == null ? void 0 : _a.size) != null ? _b : 0) > 0);
    if (shouldFinalize) {
        const { patchPlugin_ } = rootScope;
        if (patchPlugin_) {
            const basePath = patchPlugin_.getPath(state);
            if (basePath) patchPlugin_.generatePatches_(state, basePath, rootScope);
        }
        markStateFinalized(state);
    }
}
function handleCrossReference(target, key, value) {
    const { scope_ } = target;
    if (isDraft(value)) {
        const state = value[DRAFT_STATE];
        if (isSameScope(state, scope_)) state.callbacks_.push(function crossReferenceCleanup() {
            prepareCopy(target);
            const finalizedValue = getFinalValue(state);
            updateDraftInParent(target, value, finalizedValue, key);
        });
    } else if (isDraftable(value)) target.callbacks_.push(function nestedDraftCleanup() {
        var _a;
        const targetCopy = latest(target);
        if (target.type_ === 3 /* Set */ ) {
            if (targetCopy.has(value)) handleValue(value, scope_.handledSet_, scope_);
        } else {
            if (get(targetCopy, key, target.type_) === value) {
                if (scope_.drafts_.length > 1 && ((_a = target.assigned_.get(key)) != null ? _a : false) === true && target.copy_) handleValue(get(target.copy_, key, target.type_), scope_.handledSet_, scope_);
            }
        }
    });
}
function handleValue(target, handledSet, rootScope) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return target;
    if (isDraft(target) || handledSet.has(target) || !isDraftable(target) || isFrozen(target)) return target;
    handledSet.add(target);
    each(target, (key, value)=>{
        if (isDraft(value)) {
            const state = value[DRAFT_STATE];
            if (isSameScope(state, rootScope)) {
                const updatedValue = getFinalValue(state);
                set(target, key, updatedValue, target.type_);
                markStateFinalized(state);
            }
        } else if (isDraftable(value)) handleValue(value, handledSet, rootScope);
    });
    return target;
}
// src/core/proxy.ts
function createProxyProxy(base, parent) {
    const baseIsArray = isArray(base);
    const state = {
        type_: baseIsArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        // actually instantiated in `prepareCopy()`
        assigned_: void 0,
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false,
        // `callbacks` actually gets assigned in `createProxy`
        callbacks_: void 0
    };
    let target = state;
    let traps = objectTraps;
    if (baseIsArray) {
        target = [
            state
        ];
        traps = arrayTraps;
    }
    const { revoke, proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return [
        proxy,
        state
    ];
}
var objectTraps = {
    get (state, prop) {
        if (prop === DRAFT_STATE) return state;
        let arrayPlugin = state.scope_.arrayMethodsPlugin_;
        const isArrayWithStringProp = state.type_ === 1 /* Array */  && typeof prop === "string";
        if (isArrayWithStringProp) {
            if (arrayPlugin == null ? void 0 : arrayPlugin.isArrayOperationMethod(prop)) return arrayPlugin.createMethodInterceptor(state, prop);
        }
        const source = latest(state);
        if (!has(source, prop, state.type_)) return readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !isDraftable(value)) return value;
        if (isArrayWithStringProp && state.operationMethod && (arrayPlugin == null ? void 0 : arrayPlugin.isMutatingArrayMethod(state.operationMethod)) && isArrayIndex(prop)) return value;
        if (value === peek(state.base_, prop)) {
            prepareCopy(state);
            const childKey = state.type_ === 1 /* Array */  ? +prop : prop;
            const childDraft = createProxy(state.scope_, value, state, childKey);
            return state.copy_[childKey] = childDraft;
        }
        return value;
    },
    has (state, prop) {
        return prop in latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys(latest(state));
    },
    set (state, prop, value) {
        const desc = getDescriptorFromProto(latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = peek(latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_.set(prop, false);
                return true;
            }
            if (is(value, current2) && (value !== void 0 || has(state.base_, prop, state.type_))) return true;
            prepareCopy(state);
            markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_.set(prop, true);
        handleCrossReference(state, prop, value);
        return true;
    },
    deleteProperty (state, prop) {
        prepareCopy(state);
        if (peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_.set(prop, false);
            markChanged(state);
        } else state.assigned_.delete(prop);
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            [WRITABLE]: true,
            [CONFIGURABLE]: state.type_ !== 1 /* Array */  || prop !== "length",
            [ENUMERABLE]: desc[ENUMERABLE],
            [VALUE]: owner[prop]
        };
    },
    defineProperty () {
        die(11);
    },
    getPrototypeOf (state) {
        return getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        die(12);
    }
};
var arrayTraps = {};
for(let key in objectTraps){
    let fn = objectTraps[key];
    arrayTraps[key] = function() {
        const args = arguments;
        args[0] = args[0][0];
        return fn.apply(this, args);
    };
}
arrayTraps.deleteProperty = function(state, prop) {
    return arrayTraps.set.call(this, state, prop, void 0);
};
arrayTraps.set = function(state, prop, value) {
    return objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function peek(draft, prop) {
    const state = draft[DRAFT_STATE];
    const source = state ? latest(state) : draft;
    return source[prop];
}
function readPropFromProto(state, source, prop) {
    var _a;
    const desc = getDescriptorFromProto(source, prop);
    return desc ? VALUE in desc ? desc[VALUE] : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = getPrototypeOf(proto);
    }
    return void 0;
}
function markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) markChanged(state.parent_);
    }
}
function prepareCopy(state) {
    if (!state.copy_) {
        state.assigned_ = /* @__PURE__ */ new Map();
        state.copy_ = shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
    }
}
// src/core/immerClass.ts
var Immer2 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (isFunction(base) && !isFunction(recipe)) {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (!isFunction(recipe)) die(6);
            if (patchListener !== void 0 && !isFunction(patchListener)) die(7);
            let result;
            if (isDraftable(base)) {
                const scope = enterScope(this);
                const proxy = createProxy(scope, base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) revokeScope(scope);
                    else leaveScope(scope);
                }
                usePatchesInScope(scope, patchListener);
                return processResult(result, scope);
            } else if (!base || !isObjectish(base)) {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === NOTHING) result = void 0;
                if (this.autoFreeze_) freeze(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    getPlugin(PluginPatches).generateReplacementPatches_(base, result, {
                        patches_: p,
                        inversePatches_: ip
                    });
                    patchListener(p, ip);
                }
                return result;
            } else die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (isFunction(base)) return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (isBoolean(config == null ? void 0 : config.autoFreeze)) this.setAutoFreeze(config.autoFreeze);
        if (isBoolean(config == null ? void 0 : config.useStrictShallowCopy)) this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if (isBoolean(config == null ? void 0 : config.useStrictIteration)) this.setUseStrictIteration(config.useStrictIteration);
    }
    createDraft(base) {
        if (!isDraftable(base)) die(8);
        if (isDraft(base)) base = current(base);
        const scope = enterScope(this);
        const proxy = createProxy(scope, base, void 0);
        proxy[DRAFT_STATE].isManual_ = true;
        leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[DRAFT_STATE];
        if (!state || !state.isManual_) die(9);
        const { scope_: scope } = state;
        usePatchesInScope(scope, patchListener);
        return processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(value) {
        this.useStrictIteration_ = value;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = getPlugin(PluginPatches).applyPatches_;
        if (isDraft(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function createProxy(rootScope, value, parent, key) {
    var _a, _b;
    const [draft, state] = isMap(value) ? getPlugin(PluginMapSet).proxyMap_(value, parent) : isSet(value) ? getPlugin(PluginMapSet).proxySet_(value, parent) : createProxyProxy(value, parent);
    const scope = (_a = parent == null ? void 0 : parent.scope_) != null ? _a : getCurrentScope();
    scope.drafts_.push(draft);
    state.callbacks_ = (_b = parent == null ? void 0 : parent.callbacks_) != null ? _b : [];
    state.key_ = key;
    if (parent && key !== void 0) registerChildFinalizationCallback(parent, state, key);
    else state.callbacks_.push(function rootDraftCleanup(rootScope2) {
        var _a2;
        (_a2 = rootScope2.mapSetPlugin_) == null || _a2.fixSetContents(state);
        const { patchPlugin_ } = rootScope2;
        if (state.modified_ && patchPlugin_) patchPlugin_.generatePatches_(state, [], rootScope2);
    });
    return draft;
}
// src/core/current.ts
function current(value) {
    if (!isDraft(value)) die(10, value);
    return currentImpl(value);
}
function currentImpl(value) {
    if (!isDraftable(value) || isFrozen(value)) return value;
    const state = value[DRAFT_STATE];
    let copy;
    let strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = shallowCopy(value, true);
    each(copy, (key, childValue)=>{
        set(copy, key, currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function enablePatches() {
    const errorOffset = 16;
    function getPath(state, path = []) {
        var _a;
        if (state.key_ !== void 0) {
            const parentCopy = (_a = state.parent_.copy_) != null ? _a : state.parent_.base_;
            const proxyDraft = getProxyDraft(get(parentCopy, state.key_));
            const valueAtKey = get(parentCopy, state.key_);
            if (valueAtKey === void 0) return null;
            if (valueAtKey !== state.draft_ && valueAtKey !== state.base_ && valueAtKey !== state.copy_) return null;
            if (proxyDraft != null && proxyDraft.base_ !== state.base_) return null;
            const isSet2 = state.parent_.type_ === 3 /* Set */ ;
            let key;
            if (isSet2) {
                const setParent = state.parent_;
                key = Array.from(setParent.drafts_.keys()).indexOf(state.key_);
            } else key = state.key_;
            if (!(isSet2 && parentCopy.size > key || has(parentCopy, key))) return null;
            path.push(key);
        }
        if (state.parent_) return getPath(state.parent_, path);
        path.reverse();
        try {
            resolvePath(state.copy_, path);
        } catch (e) {
            return null;
        }
        return path;
    }
    function resolvePath(base, path) {
        let current2 = base;
        for(let i = 0; i < path.length - 1; i++){
            const key = path[i];
            current2 = get(current2, key);
            if (!isObjectish(current2) || current2 === null) throw new Error(`Cannot resolve path at '${path.join("/")}'`);
        }
        return current2;
    }
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, scope) {
        if (state.scope_.processedForPatches_.has(state)) return;
        state.scope_.processedForPatches_.add(state);
        const { patches_, inversePatches_ } = scope;
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches_, inversePatches_);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches_, inversePatches_);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches_, inversePatches_);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_, assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        const allReassigned = state.allIndicesReassigned_ === true;
        for(let i = 0; i < base_.length; i++){
            const copiedItem = copy_[i];
            const baseItem = base_[i];
            const isAssigned = allReassigned || (assigned_ == null ? void 0 : assigned_.get(i.toString()));
            if (isAssigned && copiedItem !== baseItem) {
                const childState = copiedItem == null ? void 0 : copiedItem[DRAFT_STATE];
                if (childState && childState.modified_) continue;
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REPLACE,
                    path,
                    // Need to maybe clone it, as it can in fact be the original value
                    // due to the base/copy inversion at the start of this function
                    value: clonePatchValueIfNeeded(copiedItem)
                });
                inversePatches.push({
                    op: REPLACE,
                    path,
                    value: clonePatchValueIfNeeded(baseItem)
                });
            }
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_, copy_, type_ } = state;
        each(state.assigned_, (key, assignedValue)=>{
            const origValue = get(base_, key, type_);
            const value = get(copy_, key, type_);
            const op = !assignedValue ? REMOVE : has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op,
                path
            } : {
                op,
                path,
                value: clonePatchValueIfNeeded(value)
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path
            } : op === REMOVE ? {
                op: ADD,
                path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_, copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path,
                    value
                });
                inversePatches.unshift({
                    op: ADD,
                    path,
                    value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path,
                    value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path,
                    value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, scope) {
        const { patches_, inversePatches_ } = scope;
        patches_.push({
            op: REPLACE,
            path: [],
            value: replacement === NOTHING ? void 0 : replacement
        });
        inversePatches_.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path, op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === CONSTRUCTOR)) die(errorOffset + 3);
                if (isFunction(base) && p === PROTOTYPE) die(errorOffset + 3);
                base = get(base, p);
                if (!isObjectish(base)) die(errorOffset + 2, path.join("/"));
            }
            const type = getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!isDraftable(obj)) return obj;
        if (isArray(obj)) return obj.map(deepClonePatchValue);
        if (isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if (isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create(getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if (has(obj, DRAFTABLE)) cloned[DRAFTABLE] = obj[DRAFTABLE];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if (isDraft(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    loadPlugin(PluginPatches, {
        applyPatches_,
        generatePatches_,
        generateReplacementPatches_,
        getPath
    });
}
// src/plugins/mapset.ts
function enableMapSet() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false,
                callbacks_: []
            };
        }
        get size() {
            return latest(this[DRAFT_STATE]).size;
        }
        has(key) {
            return latest(this[DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            if (!latest(state).has(key) || latest(state).get(key) !== value) {
                prepareMapCopy(state);
                markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
                handleCrossReference(state, key, value);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            if (latest(state).size) {
                prepareMapCopy(state);
                markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[DRAFT_STATE];
            latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            const value = latest(state).get(key);
            if (state.finalized_ || !isDraftable(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = createProxy(state.scope_, value, state, key);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return latest(this[DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [(DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        const map = new DraftMap(target, parent);
        return [
            map,
            map[DRAFT_STATE]
        ];
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false,
                assigned_: void 0,
                callbacks_: []
            };
        }
        get size() {
            return latest(this[DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                markChanged(state);
                state.copy_.add(value);
                handleCrossReference(state, value, value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            if (latest(state).size) {
                prepareSetCopy(state);
                markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [(DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        const set2 = new DraftSet(target, parent);
        return [
            set2,
            set2[DRAFT_STATE]
        ];
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if (isDraftable(value)) {
                    const draft = createProxy(state.scope_, value, state, value);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) die(3, JSON.stringify(latest(state)));
    }
    function fixSetContents(target) {
        if (target.type_ === 3 /* Set */  && target.copy_) {
            const copy = new Set(target.copy_);
            target.copy_.clear();
            copy.forEach((value)=>{
                target.copy_.add(getValue(value));
            });
        }
    }
    loadPlugin(PluginMapSet, {
        proxyMap_,
        proxySet_,
        fixSetContents
    });
}
// src/plugins/arrayMethods.ts
function enableArrayMethods() {
    const SHIFTING_METHODS = /* @__PURE__ */ new Set([
        "shift",
        "unshift"
    ]);
    const QUEUE_METHODS = /* @__PURE__ */ new Set([
        "push",
        "pop"
    ]);
    const RESULT_RETURNING_METHODS = /* @__PURE__ */ new Set([
        ...QUEUE_METHODS,
        ...SHIFTING_METHODS
    ]);
    const REORDERING_METHODS = /* @__PURE__ */ new Set([
        "reverse",
        "sort"
    ]);
    const MUTATING_METHODS = /* @__PURE__ */ new Set([
        ...RESULT_RETURNING_METHODS,
        ...REORDERING_METHODS,
        "splice"
    ]);
    const FIND_METHODS = /* @__PURE__ */ new Set([
        "find",
        "findLast"
    ]);
    const NON_MUTATING_METHODS = /* @__PURE__ */ new Set([
        "filter",
        "slice",
        "concat",
        "flat",
        ...FIND_METHODS,
        "findIndex",
        "findLastIndex",
        "some",
        "every",
        "indexOf",
        "lastIndexOf",
        "includes",
        "join",
        "toString",
        "toLocaleString"
    ]);
    function isMutatingArrayMethod(method) {
        return MUTATING_METHODS.has(method);
    }
    function isNonMutatingArrayMethod(method) {
        return NON_MUTATING_METHODS.has(method);
    }
    function isArrayOperationMethod(method) {
        return isMutatingArrayMethod(method) || isNonMutatingArrayMethod(method);
    }
    function enterOperation(state, method) {
        state.operationMethod = method;
    }
    function exitOperation(state) {
        state.operationMethod = void 0;
    }
    function executeArrayMethod(state, operation, markLength = true) {
        prepareCopy(state);
        const result = operation();
        markChanged(state);
        if (markLength) state.assigned_.set("length", true);
        return result;
    }
    function markAllIndicesReassigned(state) {
        state.allIndicesReassigned_ = true;
    }
    function normalizeSliceIndex(index, length) {
        if (index < 0) return Math.max(length + index, 0);
        return Math.min(index, length);
    }
    function handleInsertedValues(state, startIndex, values) {
        for(let i = 0; i < values.length; i++){
            const index = startIndex + i;
            state.assigned_.set(index, true);
            handleCrossReference(state, index, values[i]);
        }
    }
    function handleSimpleOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            const lengthBefore = state.copy_.length;
            const result = state.copy_[method](...args);
            if (SHIFTING_METHODS.has(method)) markAllIndicesReassigned(state);
            if (method === "push" && args.length > 0) handleInsertedValues(state, lengthBefore, args);
            else if (method === "unshift" && args.length > 0) handleInsertedValues(state, 0, args);
            return RESULT_RETURNING_METHODS.has(method) ? result : state.draft_;
        });
    }
    function handleReorderingOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            state.copy_[method](...args);
            markAllIndicesReassigned(state);
            return state.draft_;
        }, false);
    }
    function createMethodInterceptor(state, originalMethod) {
        return function interceptedMethod(...args) {
            var _a;
            const method = originalMethod;
            enterOperation(state, method);
            try {
                if (isMutatingArrayMethod(method)) {
                    if (RESULT_RETURNING_METHODS.has(method)) return handleSimpleOperation(state, method, args);
                    if (REORDERING_METHODS.has(method)) return handleReorderingOperation(state, method, args);
                    if (method === "splice") {
                        const res = executeArrayMethod(state, ()=>state.copy_.splice(...args));
                        markAllIndicesReassigned(state);
                        if (args.length > 2) {
                            const startIndex = normalizeSliceIndex((_a = args[0]) != null ? _a : 0, state.copy_.length);
                            handleInsertedValues(state, startIndex, args.slice(2));
                        }
                        return res;
                    }
                } else return handleNonMutatingOperation(state, method, args);
            } finally{
                exitOperation(state);
            }
        };
    }
    function handleNonMutatingOperation(state, method, args) {
        var _a, _b;
        const source = latest(state);
        if (method === "filter") {
            const predicate = args[0];
            const result = [];
            for(let i = 0; i < source.length; i++)if (predicate(source[i], i, source)) result.push(state.draft_[i]);
            return result;
        }
        if (FIND_METHODS.has(method)) {
            const predicate = args[0];
            const isForward = method === "find";
            const step = isForward ? 1 : -1;
            const start = isForward ? 0 : source.length - 1;
            for(let i = start; i >= 0 && i < source.length; i += step){
                if (predicate(source[i], i, source)) return state.draft_[i];
            }
            return void 0;
        }
        if (method === "slice") {
            const rawStart = (_a = args[0]) != null ? _a : 0;
            const rawEnd = (_b = args[1]) != null ? _b : source.length;
            const start = normalizeSliceIndex(rawStart, source.length);
            const end = normalizeSliceIndex(rawEnd, source.length);
            const result = [];
            for(let i = start; i < end; i++)result.push(state.draft_[i]);
            return result;
        }
        return source[method](...args);
    }
    loadPlugin(PluginArrayMethods, {
        createMethodInterceptor,
        isArrayOperationMethod,
        isMutatingArrayMethod
    });
}
// src/immer.ts
var immer = new Immer2();
var produce = immer.produce;
var produceWithPatches = /* @__PURE__ */ immer.produceWithPatches.bind(immer);
var setAutoFreeze = /* @__PURE__ */ immer.setAutoFreeze.bind(immer);
var setUseStrictShallowCopy = /* @__PURE__ */ immer.setUseStrictShallowCopy.bind(immer);
var setUseStrictIteration = /* @__PURE__ */ immer.setUseStrictIteration.bind(immer);
var applyPatches = /* @__PURE__ */ immer.applyPatches.bind(immer);
var createDraft = /* @__PURE__ */ immer.createDraft.bind(immer);
var finishDraft = /* @__PURE__ */ immer.finishDraft.bind(immer);
var castDraft = (value)=>value;
var castImmutable = (value)=>value;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"ixVP6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSelector", ()=>createSelector);
parcelHelpers.export(exports, "createSelectorCreator", ()=>createSelectorCreator);
parcelHelpers.export(exports, "createStructuredSelector", ()=>createStructuredSelector);
parcelHelpers.export(exports, "lruMemoize", ()=>lruMemoize);
parcelHelpers.export(exports, "referenceEqualityCheck", ()=>referenceEqualityCheck);
parcelHelpers.export(exports, "setGlobalDevModeChecks", ()=>setGlobalDevModeChecks);
parcelHelpers.export(exports, "unstable_autotrackMemoize", ()=>autotrackMemoize);
parcelHelpers.export(exports, "weakMapMemoize", ()=>weakMapMemoize);
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(b))if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var __publicField = (obj, key, value)=>{
    __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize, memoizeOptions } = options;
    const { inputSelectorResults, inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var setGlobalDevModeChecks = (devModeChecks)=>{
    Object.assign(globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck, inputStabilityCheck } = __spreadValues(__spreadValues({}, globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $REVISION = 0;
var CURRENT_TRACKER = null;
var Cell = class {
    constructor(initialValue, isEqual = tripleEq){
        __publicField(this, "revision", $REVISION);
        __publicField(this, "_value");
        __publicField(this, "_lastValue");
        __publicField(this, "_isEqual", tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        CURRENT_TRACKER == null || CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$REVISION;
    }
};
function tripleEq(a, b) {
    return a === b;
}
var TrackingCache = class {
    constructor(fn){
        __publicField(this, "_cachedValue");
        __publicField(this, "_cachedRevision", -1);
        __publicField(this, "_deps", []);
        __publicField(this, "hits", 0);
        __publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = CURRENT_TRACKER;
            CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        CURRENT_TRACKER == null || CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function getValue(cell) {
    if (!(cell instanceof Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function setValue(storage, value) {
    if (!(storage instanceof Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function createCell(initialValue, isEqual = tripleEq) {
    return new Cell(initialValue, isEqual);
}
function createCache(fn) {
    assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var neverEq = (a, b)=>false;
function createTag() {
    return createCell(null, neverEq);
}
function dirtyTag(tag, value) {
    setValue(tag, value);
}
var consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = createTag();
    getValue(tag);
};
var dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var REDUX_PROXY_LABEL = Symbol();
var nextId = 0;
var proto = Object.getPrototypeOf({});
var ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        __publicField(this, "proxy", new Proxy(this, objectProxyHandler));
        __publicField(this, "tag", createTag());
        __publicField(this, "tags", {});
        __publicField(this, "children", {});
        __publicField(this, "collectionTag", null);
        __publicField(this, "id", nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = createNode(childValue);
                if (childNode.tag) getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = createTag();
                    tag.value = childValue;
                }
                getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        __publicField(this, "proxy", new Proxy([
            this
        ], arrayProxyHandler));
        __publicField(this, "tag", createTag());
        __publicField(this, "tags", {});
        __publicField(this, "children", {});
        __publicField(this, "collectionTag", null);
        __publicField(this, "id", nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") consumeCollection(node);
        return objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return objectProxyHandler.has(node, prop);
    }
};
function createNode(value) {
    if (Array.isArray(value)) return new ArrayTreeNode(value);
    return new ObjectTreeNode(value);
}
function updateNode(node, newValue) {
    const { value, tags, children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            dirtyCollection(node);
            dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) updateNode(childNode, newChildValue);
        else {
            deleteNode(childNode);
            delete children[key];
        }
    }
}
function deleteNode(node) {
    if (node.tag) dirtyTag(node.tag, null);
    dirtyCollection(node);
    for(const key in node.tags)dirtyTag(node.tags[key], null);
    for(const key in node.children)deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key,
                value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === NOT_FOUND) {
            entries.unshift({
                key,
                value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get,
        put,
        getEntries,
        clear
    };
}
var referenceEqualityCheck = (a, b)=>a === b;
function createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function lruMemoize(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck = referenceEqualityCheck, maxSize = 1, resultEqualityCheck } = providedOptions;
    const comparator = createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function autotrackMemoize(func) {
    const node = createNode([]);
    let lastArgs = null;
    const shallowEqual = createCacheKeyComparator(referenceEqualityCheck);
    const cache = createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var Ref = typeof WeakRef !== "undefined" ? WeakRef : StrongRef;
var UNTERMINATED = 0;
var TERMINATED = 1;
function createCacheNode() {
    return {
        s: UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function weakMapMemoize(func, options = {}) {
    let fnNode = createCacheNode();
    const { resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new Ref(result) : result;
            }
        }
        terminatedNode.s = TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function createSelectorCreator(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = __spreadValues(__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize, memoizeOptions = [], argsMemoize = weakMapMemoize, argsMemoizeOptions = [], devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = ensureIsArray(argsMemoizeOptions);
        const dependencies = getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc,
            memoizedResultFunc,
            dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize,
            argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var createSelector = /* @__PURE__ */ createSelectorCreator(weakMapMemoize);
// src/createStructuredSelector.ts
var createStructuredSelector = Object.assign((inputSelectorsObject, selectorCreator = createSelector)=>{
    assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>createStructuredSelector
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"h3rB4":[function(require,module,exports,__globalThis) {
// src/index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "thunk", ()=>thunk);
parcelHelpers.export(exports, "withExtraArgument", ()=>withExtraArgument);
function createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch, getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var thunk = createThunkMiddleware();
var withExtraArgument = createThunkMiddleware;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"6Yemz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Notes", ()=>Notes);
parcelHelpers.export(exports, "Continue", ()=>Continue);
parcelHelpers.export(exports, "SlideLayout", ()=>SlideLayout);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const Notes = ()=>null;
const Continue = ()=>null;
const SlideLayout = ()=>null;

},{"react":"7e5Pu","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"9NCi5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("./app/hooks");
var _presenter = require("./Presenter");
var _presenterDefault = parcelHelpers.interopDefault(_presenter);
var _display = require("./Display");
var _displayDefault = parcelHelpers.interopDefault(_display);
var _print = require("./Print");
var _printDefault = parcelHelpers.interopDefault(_print);
var _modeSelectModuleCss = require("./ModeSelect.module.css");
const DISPATCH = {
    display: (0, _displayDefault.default),
    presenter: (0, _presenterDefault.default),
    print: (0, _printDefault.default)
};
const ModeSelect = ()=>{
    const mode = (0, _hooks.useAppSelector)((state)=>state.deck.mode);
    const Child = DISPATCH[mode];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: _modeSelectModuleCss.container,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Child, {})
    });
};
exports.default = ModeSelect;

},{"react/jsx-runtime":"afIHK","./app/hooks":"8D69K","./Presenter":"lNcVO","./Display":"d07DX","./Print":"fd8qW","./ModeSelect.module.css":"g3ODB","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"lNcVO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _hooks = require("./app/hooks");
var _deck = require("./Deck");
var _presenterModuleCss = require("./Presenter.module.css");
const Presenter = ()=>{
    const slides = (0, _react.useContext)((0, _deck.SlidesContext));
    const slideIndex = (0, _hooks.useAppSelector)((state)=>state.deck.slideIndex);
    const slide = slides[slideIndex - 1];
    const nextSlide = slides[slideIndex];
    const notes = slide.notes;
    const slideContent = (0, _deck.applyLayout)(slide);
    const nextSlideContent = (0, _deck.applyLayout)(nextSlide);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: _presenterModuleCss.container,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: _presenterModuleCss.slideCurrent,
                children: slideContent
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                className: _presenterModuleCss.labelLeft,
                children: "Notes"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: _presenterModuleCss.notes,
                children: notes
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                className: _presenterModuleCss.labelRight,
                children: "Next"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: _presenterModuleCss.slideNext,
                children: nextSlideContent
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: _presenterModuleCss.timer,
                children: "A timer or whatever"
            })
        ]
    });
};
exports.default = Presenter;

},{"react/jsx-runtime":"afIHK","react":"7e5Pu","./app/hooks":"8D69K","./Deck":"4zgfF","./Presenter.module.css":"9jhx0","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"9jhx0":[function(require,module,exports,__globalThis) {
var _utilModuleCss = require("./util.module.css");
module.exports["-label"] = `gj9EtG_-label`;
module.exports["-meta"] = `gj9EtG_-meta`;
module.exports["-resizingSlideContainer"] = `gj9EtG_-resizingSlideContainer`;
module.exports["container"] = `gj9EtG_container ${_utilModuleCss["-expand"]}`;
module.exports["curr"] = `gj9EtG_curr`;
module.exports["labelLeft"] = `gj9EtG_labelLeft ${module.exports["-meta"]} ${module.exports["-label"]}`;
module.exports["labelRight"] = `gj9EtG_labelRight ${module.exports["-meta"]} ${module.exports["-label"]}`;
module.exports["lbll"] = `gj9EtG_lbll`;
module.exports["lblr"] = `gj9EtG_lblr`;
module.exports["next"] = `gj9EtG_next`;
module.exports["note"] = `gj9EtG_note`;
module.exports["notes"] = `gj9EtG_notes ${module.exports["-meta"]}`;
module.exports["slideCurrent"] = `gj9EtG_slideCurrent ${_utilModuleCss["-center"]} ${module.exports["-resizingSlideContainer"]}`;
module.exports["slideNext"] = `gj9EtG_slideNext ${_utilModuleCss["-center"]} ${module.exports["-meta"]} ${module.exports["-resizingSlideContainer"]}`;
module.exports["time"] = `gj9EtG_time`;
module.exports["timer"] = `gj9EtG_timer ${module.exports["-meta"]}`;

},{"./util.module.css":"lqfZi"}],"lqfZi":[function(require,module,exports,__globalThis) {
module.exports["-center"] = `e4Rufq_-center`;
module.exports["-chunkyImage"] = `e4Rufq_-chunkyImage`;
module.exports["-expand"] = `e4Rufq_-expand`;
module.exports["-fullImage"] = `e4Rufq_-fullImage ${module.exports["-expand"]}`;

},{}],"d07DX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _deck = require("./Deck");
var _hooks = require("./app/hooks");
var _displayModuleCss = require("./Display.module.css");
const Display = ()=>{
    const slides = (0, _react.useContext)((0, _deck.SlidesContext));
    const slideIndex = (0, _hooks.useAppSelector)((state)=>state.deck.slideIndex);
    const wrappedSlides = slides.map((s, i)=>{
        const className = i === slideIndex - 1 ? _displayModuleCss.container : _displayModuleCss.hidden;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: className,
            children: (0, _deck.applyLayout)(s)
        }, i);
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: wrappedSlides
    });
};
exports.default = Display;

},{"react/jsx-runtime":"afIHK","react":"7e5Pu","./Deck":"4zgfF","./app/hooks":"8D69K","./Display.module.css":"et02O","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"et02O":[function(require,module,exports,__globalThis) {
var _utilModuleCss = require("./util.module.css");
module.exports["container"] = `_7OtJqa_container ${_utilModuleCss["-expand"]}`;
module.exports["hidden"] = `_7OtJqa_hidden ${module.exports["container"]}`;

},{"./util.module.css":"lqfZi"}],"fd8qW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _deck = require("./Deck");
var _printModuleCss = require("./Print.module.css");
const One = ({ slide })=>{
    const slideContent = (0, _deck.applyLayout)(slide);
    const notes = slide.notes;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: _printModuleCss.container,
        children: [
            slideContent,
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: _printModuleCss.notes,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        children: "Speaker Notes"
                    }),
                    notes
                ]
            })
        ]
    });
};
const Print = ()=>{
    const slides = (0, _react.useContext)((0, _deck.SlidesContext));
    const slidesContent = slides.map((slide, key)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(One, {
            slide: slide
        }, key));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: slidesContent
    });
};
exports.default = Print;

},{"react/jsx-runtime":"afIHK","react":"7e5Pu","./Deck":"4zgfF","./Print.module.css":"jvyMD","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"jvyMD":[function(require,module,exports,__globalThis) {
module.exports["container"] = `pj8KFq_container`;
module.exports["notes"] = `pj8KFq_notes`;

},{}],"g3ODB":[function(require,module,exports,__globalThis) {
module.exports["container"] = `cCiXQq_container`;

},{}],"9KlDt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _scaler = require("./Scaler");
var _scalerDefault = parcelHelpers.interopDefault(_scaler);
var _defaultModuleCss = require("./Default.module.css");
var _hooks = require("../app/hooks");
const SlidePosition = ()=>{
    const index = (0, _hooks.useAppSelector)((state)=>state.deck.slideIndex);
    const count = (0, _hooks.useAppSelector)((state)=>state.deck.slideCount);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: _defaultModuleCss.pageNumber,
        children: [
            index,
            " / ",
            count
        ]
    });
};
const Default = ({ children })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: _defaultModuleCss.outer,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _scalerDefault.default), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: _defaultModuleCss.container,
                children: [
                    children,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SlidePosition, {})
                ]
            })
        })
    });
exports.default = Default;

},{"react/jsx-runtime":"afIHK","./Scaler":"jGhNM","./Default.module.css":"97R9n","../app/hooks":"8D69K","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"jGhNM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _hooks = require("../app/hooks");
var _scalerModuleCss = require("./Scaler.module.css");
// https://stackoverflow.com/questions/61533780/
const applyScaling = (outer, inner)=>{
    // Reset the values to get the unmodified bounds
    inner.style.transform = "scale(1)";
    outer.style.width = "";
    outer.style.height = "";
    const { width: ow, height: oh } = outer.getBoundingClientRect();
    const { width: iw, height: ih } = inner.getBoundingClientRect();
    const widthScale = ow / iw;
    const heightScale = oh / ih;
    const scaleFactor = Math.min(widthScale, heightScale);
    inner.style.transform = `scale(${scaleFactor})`;
    // Set the outer size explicitly to allow parents to position it accurately
    const { width: iwUpdated, height: ihUpdated } = inner.getBoundingClientRect();
    outer.style.width = `${iwUpdated}px`;
    outer.style.height = `${ihUpdated}px`;
};
const Scaler = ({ children })=>{
    const outer = (0, _react.useRef)(null);
    const inner = (0, _react.useRef)(null);
    const isPrint = (0, _hooks.useAppSelector)((state)=>state.deck.mode === "print");
    const aspectRatio = (0, _hooks.useAppSelector)((state)=>state.deck.aspectRatio);
    const aspectClass = aspectRatio === "16x9" ? _scalerModuleCss.inner16x9 : _scalerModuleCss.inner4x3;
    (0, _react.useEffect)(()=>{
        if (isPrint) return;
        const maybeApplyScaling = ()=>{
            if (outer.current && inner.current) applyScaling(outer.current, inner.current);
        };
        maybeApplyScaling();
        const observer = new ResizeObserver(maybeApplyScaling);
        // When the thing containing us resizes, we need to adjust our scaling
        const parent = outer?.current?.parentElement;
        if (parent) observer.observe(parent);
        // When the aspect ratio changes, we need to adjust our scaling
        const content = inner?.current;
        if (content) observer.observe(content);
        return ()=>observer.disconnect();
    }, [
        outer,
        inner,
        isPrint
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: outer,
        className: _scalerModuleCss.outer,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            ref: inner,
            className: aspectClass,
            children: children
        })
    });
};
exports.default = Scaler;

},{"react/jsx-runtime":"afIHK","react":"7e5Pu","../app/hooks":"8D69K","./Scaler.module.css":"lUNEy","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"lUNEy":[function(require,module,exports,__globalThis) {
var _utilModuleCss = require("../util.module.css");
module.exports["-inner"] = `IZYkyq_-inner`;
module.exports["inner16x9"] = `IZYkyq_inner16x9 ${module.exports["-inner"]}`;
module.exports["inner4x3"] = `IZYkyq_inner4x3 ${module.exports["-inner"]}`;
module.exports["outer"] = `IZYkyq_outer ${_utilModuleCss["-expand"]}`;

},{"../util.module.css":"lqfZi"}],"97R9n":[function(require,module,exports,__globalThis) {
var _utilModuleCss = require("../util.module.css");
module.exports["container"] = `aBfWRG_container ${_utilModuleCss["-expand"]}`;
module.exports["outer"] = `aBfWRG_outer ${_utilModuleCss["-center"]} ${_utilModuleCss["-expand"]}`;
module.exports["pageNumber"] = `aBfWRG_pageNumber`;

},{"../util.module.css":"lqfZi"}],"3bjv6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _prismShim = require("./prism-shim");
var _prismShimDefault = parcelHelpers.interopDefault(_prismShim);
const Prism = ({ children, className })=>{
    const codeRef = (0, _react.useRef)(null);
    const highlightRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        const code = codeRef.current;
        const highlight = highlightRef.current;
        if (code && highlight) {
            const codeChildren = code.cloneNode(true).childNodes;
            highlight.replaceChildren(...codeChildren);
            code.style.display = "none";
            (0, _prismShimDefault.default).highlightElement(highlight);
        }
    }, [
        codeRef,
        highlightRef,
        children,
        className
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                className: className,
                ref: codeRef,
                children: children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                className: className,
                ref: highlightRef
            })
        ]
    });
};
exports.default = Prism;

},{"react/jsx-runtime":"afIHK","react":"7e5Pu","./prism-shim":"fK75d","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"fK75d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _prismjs = require("prismjs");
var _prismjsDefault = parcelHelpers.interopDefault(_prismjs);
var _prismC = require("prismjs/components/prism-c");
var _prismRust = require("prismjs/components/prism-rust");
var _prismToml = require("prismjs/components/prism-toml");
var _prismKeepMarkup = require("prismjs/plugins/keep-markup/prism-keep-markup");
if (typeof window !== "undefined") {
    window.Prism = window.Prism || {};
    window.Prism.manual = true;
}
exports.default = (0, _prismjsDefault.default);

},{"prismjs":"8YxG6","prismjs/components/prism-c":"5qlTb","prismjs/components/prism-rust":"DzzSW","prismjs/components/prism-toml":"4UXjg","prismjs/plugins/keep-markup/prism-keep-markup":"q494w","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"8YxG6":[function(require,module,exports,__globalThis) {
/* **********************************************
     Begin prism-core.js
********************************************** */ /// <reference lib="WebWorker"/>
var global = arguments[3];
var _self = typeof window !== 'undefined' ? window // if in browser
 : typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope ? self // if in worker
 : {} // if in node js
;
/**
 * Prism: Lightweight, robust, elegant syntax highlighting
 *
 * @license MIT <https://opensource.org/licenses/MIT>
 * @author Lea Verou <https://lea.verou.me>
 * @namespace
 * @public
 */ var Prism = function(_self) {
    // Private helper vars
    var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
    var uniqueId = 0;
    // The grammar object for plaintext
    var plainTextGrammar = {};
    var _ = {
        /**
		 * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
		 * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
		 * additional languages or plugins yourself.
		 *
		 * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
		 *
		 * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.manual = true;
		 * // add a new <script> to load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */ manual: _self.Prism && _self.Prism.manual,
        /**
		 * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
		 * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
		 * own worker, you don't want it to do this.
		 *
		 * By setting this value to `true`, Prism will not add its own listeners to the worker.
		 *
		 * You obviously have to change this value before Prism executes. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.disableWorkerMessageHandler = true;
		 * // Load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */ disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,
        /**
		 * A namespace for utility methods.
		 *
		 * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
		 * change or disappear at any time.
		 *
		 * @namespace
		 * @memberof Prism
		 */ util: {
            encode: function encode(tokens) {
                if (tokens instanceof Token) return new Token(tokens.type, encode(tokens.content), tokens.alias);
                else if (Array.isArray(tokens)) return tokens.map(encode);
                else return tokens.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\u00a0/g, ' ');
            },
            /**
			 * Returns the name of the type of the given value.
			 *
			 * @param {any} o
			 * @returns {string}
			 * @example
			 * type(null)      === 'Null'
			 * type(undefined) === 'Undefined'
			 * type(123)       === 'Number'
			 * type('foo')     === 'String'
			 * type(true)      === 'Boolean'
			 * type([1, 2])    === 'Array'
			 * type({})        === 'Object'
			 * type(String)    === 'Function'
			 * type(/abc+/)    === 'RegExp'
			 */ type: function(o) {
                return Object.prototype.toString.call(o).slice(8, -1);
            },
            /**
			 * Returns a unique number for the given object. Later calls will still return the same number.
			 *
			 * @param {Object} obj
			 * @returns {number}
			 */ objId: function(obj) {
                if (!obj['__id']) Object.defineProperty(obj, '__id', {
                    value: ++uniqueId
                });
                return obj['__id'];
            },
            /**
			 * Creates a deep clone of the given object.
			 *
			 * The main intended use of this function is to clone language definitions.
			 *
			 * @param {T} o
			 * @param {Record<number, any>} [visited]
			 * @returns {T}
			 * @template T
			 */ clone: function deepClone(o, visited) {
                visited = visited || {};
                var clone;
                var id;
                switch(_.util.type(o)){
                    case 'Object':
                        id = _.util.objId(o);
                        if (visited[id]) return visited[id];
                        clone = /** @type {Record<string, any>} */ {};
                        visited[id] = clone;
                        for(var key in o)if (o.hasOwnProperty(key)) clone[key] = deepClone(o[key], visited);
                        return /** @type {any} */ clone;
                    case 'Array':
                        id = _.util.objId(o);
                        if (visited[id]) return visited[id];
                        clone = [];
                        visited[id] = clone;
                        /** @type {any} */ o.forEach(function(v, i) {
                            clone[i] = deepClone(v, visited);
                        });
                        return /** @type {any} */ clone;
                    default:
                        return o;
                }
            },
            /**
			 * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
			 *
			 * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
			 *
			 * @param {Element} element
			 * @returns {string}
			 */ getLanguage: function(element) {
                while(element){
                    var m = lang.exec(element.className);
                    if (m) return m[1].toLowerCase();
                    element = element.parentElement;
                }
                return 'none';
            },
            /**
			 * Sets the Prism `language-xxxx` class of the given element.
			 *
			 * @param {Element} element
			 * @param {string} language
			 * @returns {void}
			 */ setLanguage: function(element, language) {
                // remove all `language-xxxx` classes
                // (this might leave behind a leading space)
                element.className = element.className.replace(RegExp(lang, 'gi'), '');
                // add the new `language-xxxx` class
                // (using `classList` will automatically clean up spaces for us)
                element.classList.add('language-' + language);
            },
            /**
			 * Returns the script element that is currently executing.
			 *
			 * This does __not__ work for line script element.
			 *
			 * @returns {HTMLScriptElement | null}
			 */ currentScript: function() {
                if (typeof document === 'undefined') return null;
                if (document.currentScript && document.currentScript.tagName === 'SCRIPT' && true /* hack to trip TS' flow analysis */ ) return /** @type {any} */ document.currentScript;
                // IE11 workaround
                // we'll get the src of the current script by parsing IE11's error stack trace
                // this will not work for inline scripts
                try {
                    throw new Error();
                } catch (err) {
                    // Get file src url from stack. Specifically works with the format of stack traces in IE.
                    // A stack will look like this:
                    //
                    // Error
                    //    at _.util.currentScript (http://localhost/components/prism-core.js:119:5)
                    //    at Global code (http://localhost/components/prism-core.js:606:1)
                    var src = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(err.stack) || [])[1];
                    if (src) {
                        var scripts = document.getElementsByTagName('script');
                        for(var i in scripts){
                            if (scripts[i].src == src) return scripts[i];
                        }
                    }
                    return null;
                }
            },
            /**
			 * Returns whether a given class is active for `element`.
			 *
			 * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
			 * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
			 * given class is just the given class with a `no-` prefix.
			 *
			 * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
			 * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
			 * ancestors have the given class or the negated version of it, then the default activation will be returned.
			 *
			 * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
			 * version of it, the class is considered active.
			 *
			 * @param {Element} element
			 * @param {string} className
			 * @param {boolean} [defaultActivation=false]
			 * @returns {boolean}
			 */ isActive: function(element, className, defaultActivation) {
                var no = 'no-' + className;
                while(element){
                    var classList = element.classList;
                    if (classList.contains(className)) return true;
                    if (classList.contains(no)) return false;
                    element = element.parentElement;
                }
                return !!defaultActivation;
            }
        },
        /**
		 * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
		 *
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ languages: {
            /**
			 * The grammar for plain, unformatted text.
			 */ plain: plainTextGrammar,
            plaintext: plainTextGrammar,
            text: plainTextGrammar,
            txt: plainTextGrammar,
            /**
			 * Creates a deep copy of the language with the given id and appends the given tokens.
			 *
			 * If a token in `redef` also appears in the copied language, then the existing token in the copied language
			 * will be overwritten at its original position.
			 *
			 * ## Best practices
			 *
			 * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
			 * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
			 * understand the language definition because, normally, the order of tokens matters in Prism grammars.
			 *
			 * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
			 * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
			 *
			 * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
			 * @param {Grammar} redef The new tokens to append.
			 * @returns {Grammar} The new language created.
			 * @public
			 * @example
			 * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
			 *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
			 *     // at its original position
			 *     'comment': { ... },
			 *     // CSS doesn't have a 'color' token, so this token will be appended
			 *     'color': /\b(?:red|green|blue)\b/
			 * });
			 */ extend: function(id, redef) {
                var lang = _.util.clone(_.languages[id]);
                for(var key in redef)lang[key] = redef[key];
                return lang;
            },
            /**
			 * Inserts tokens _before_ another token in a language definition or any other grammar.
			 *
			 * ## Usage
			 *
			 * This helper method makes it easy to modify existing languages. For example, the CSS language definition
			 * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
			 * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
			 * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
			 * this:
			 *
			 * ```js
			 * Prism.languages.markup.style = {
			 *     // token
			 * };
			 * ```
			 *
			 * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
			 * before existing tokens. For the CSS example above, you would use it like this:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'cdata', {
			 *     'style': {
			 *         // token
			 *     }
			 * });
			 * ```
			 *
			 * ## Special cases
			 *
			 * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
			 * will be ignored.
			 *
			 * This behavior can be used to insert tokens after `before`:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'comment', {
			 *     'comment': Prism.languages.markup.comment,
			 *     // tokens after 'comment'
			 * });
			 * ```
			 *
			 * ## Limitations
			 *
			 * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
			 * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
			 * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
			 * deleting properties which is necessary to insert at arbitrary positions.
			 *
			 * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
			 * Instead, it will create a new object and replace all references to the target object with the new one. This
			 * can be done without temporarily deleting properties, so the iteration order is well-defined.
			 *
			 * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
			 * you hold the target object in a variable, then the value of the variable will not change.
			 *
			 * ```js
			 * var oldMarkup = Prism.languages.markup;
			 * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
			 *
			 * assert(oldMarkup !== Prism.languages.markup);
			 * assert(newMarkup === Prism.languages.markup);
			 * ```
			 *
			 * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
			 * object to be modified.
			 * @param {string} before The key to insert before.
			 * @param {Grammar} insert An object containing the key-value pairs to be inserted.
			 * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
			 * object to be modified.
			 *
			 * Defaults to `Prism.languages`.
			 * @returns {Grammar} The new grammar object.
			 * @public
			 */ insertBefore: function(inside, before, insert, root) {
                root = root || /** @type {any} */ _.languages;
                var grammar = root[inside];
                /** @type {Grammar} */ var ret = {};
                for(var token in grammar)if (grammar.hasOwnProperty(token)) {
                    if (token == before) {
                        for(var newToken in insert)if (insert.hasOwnProperty(newToken)) ret[newToken] = insert[newToken];
                    }
                    // Do not insert token which also occur in insert. See #1525
                    if (!insert.hasOwnProperty(token)) ret[token] = grammar[token];
                }
                var old = root[inside];
                root[inside] = ret;
                // Update references in other language definitions
                _.languages.DFS(_.languages, function(key, value) {
                    if (value === old && key != inside) this[key] = ret;
                });
                return ret;
            },
            // Traverse a language definition with Depth First Search
            DFS: function DFS(o, callback, type, visited) {
                visited = visited || {};
                var objId = _.util.objId;
                for(var i in o)if (o.hasOwnProperty(i)) {
                    callback.call(o, i, o[i], type || i);
                    var property = o[i];
                    var propertyType = _.util.type(property);
                    if (propertyType === 'Object' && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, null, visited);
                    } else if (propertyType === 'Array' && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, i, visited);
                    }
                }
            }
        },
        plugins: {},
        /**
		 * This is the most high-level function in Prism’s API.
		 * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
		 * each one of them.
		 *
		 * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
		 *
		 * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
		 * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
		 * @memberof Prism
		 * @public
		 */ highlightAll: function(async, callback) {
            _.highlightAllUnder(document, async, callback);
        },
        /**
		 * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
		 * {@link Prism.highlightElement} on each one of them.
		 *
		 * The following hooks will be run:
		 * 1. `before-highlightall`
		 * 2. `before-all-elements-highlight`
		 * 3. All hooks of {@link Prism.highlightElement} for each element.
		 *
		 * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
		 * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
		 * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
		 * @memberof Prism
		 * @public
		 */ highlightAllUnder: function(container, async, callback) {
            var env = {
                callback: callback,
                container: container,
                selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
            };
            _.hooks.run('before-highlightall', env);
            env.elements = Array.prototype.slice.apply(env.container.querySelectorAll(env.selector));
            _.hooks.run('before-all-elements-highlight', env);
            for(var i = 0, element; element = env.elements[i++];)_.highlightElement(element, async === true, env.callback);
        },
        /**
		 * Highlights the code inside a single element.
		 *
		 * The following hooks will be run:
		 * 1. `before-sanity-check`
		 * 2. `before-highlight`
		 * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
		 * 4. `before-insert`
		 * 5. `after-highlight`
		 * 6. `complete`
		 *
		 * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
		 * the element's language.
		 *
		 * @param {Element} element The element containing the code.
		 * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
		 * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
		 * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
		 * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
		 *
		 * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
		 * asynchronous highlighting to work. You can build your own bundle on the
		 * [Download page](https://prismjs.com/download.html).
		 * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
		 * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
		 * @memberof Prism
		 * @public
		 */ highlightElement: function(element, async, callback) {
            // Find language
            var language = _.util.getLanguage(element);
            var grammar = _.languages[language];
            // Set language on the element, if not present
            _.util.setLanguage(element, language);
            // Set language on the parent, for styling
            var parent = element.parentElement;
            if (parent && parent.nodeName.toLowerCase() === 'pre') _.util.setLanguage(parent, language);
            var code = element.textContent;
            var env = {
                element: element,
                language: language,
                grammar: grammar,
                code: code
            };
            function insertHighlightedCode(highlightedCode) {
                env.highlightedCode = highlightedCode;
                _.hooks.run('before-insert', env);
                env.element.innerHTML = env.highlightedCode;
                _.hooks.run('after-highlight', env);
                _.hooks.run('complete', env);
                callback && callback.call(env.element);
            }
            _.hooks.run('before-sanity-check', env);
            // plugins may change/add the parent/element
            parent = env.element.parentElement;
            if (parent && parent.nodeName.toLowerCase() === 'pre' && !parent.hasAttribute('tabindex')) parent.setAttribute('tabindex', '0');
            if (!env.code) {
                _.hooks.run('complete', env);
                callback && callback.call(env.element);
                return;
            }
            _.hooks.run('before-highlight', env);
            if (!env.grammar) {
                insertHighlightedCode(_.util.encode(env.code));
                return;
            }
            if (async && _self.Worker) {
                var worker = new Worker(_.filename);
                worker.onmessage = function(evt) {
                    insertHighlightedCode(evt.data);
                };
                worker.postMessage(JSON.stringify({
                    language: env.language,
                    code: env.code,
                    immediateClose: true
                }));
            } else insertHighlightedCode(_.highlight(env.code, env.grammar, env.language));
        },
        /**
		 * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
		 * and the language definitions to use, and returns a string with the HTML produced.
		 *
		 * The following hooks will be run:
		 * 1. `before-tokenize`
		 * 2. `after-tokenize`
		 * 3. `wrap`: On each {@link Token}.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @param {string} language The name of the language definition passed to `grammar`.
		 * @returns {string} The highlighted HTML.
		 * @memberof Prism
		 * @public
		 * @example
		 * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
		 */ highlight: function(text, grammar, language) {
            var env = {
                code: text,
                grammar: grammar,
                language: language
            };
            _.hooks.run('before-tokenize', env);
            if (!env.grammar) throw new Error('The language "' + env.language + '" has no grammar.');
            env.tokens = _.tokenize(env.code, env.grammar);
            _.hooks.run('after-tokenize', env);
            return Token.stringify(_.util.encode(env.tokens), env.language);
        },
        /**
		 * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
		 * and the language definitions to use, and returns an array with the tokenized code.
		 *
		 * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
		 *
		 * This method could be useful in other contexts as well, as a very crude parser.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @returns {TokenStream} An array of strings and tokens, a token stream.
		 * @memberof Prism
		 * @public
		 * @example
		 * let code = `var foo = 0;`;
		 * let tokens = Prism.tokenize(code, Prism.languages.javascript);
		 * tokens.forEach(token => {
		 *     if (token instanceof Prism.Token && token.type === 'number') {
		 *         console.log(`Found numeric literal: ${token.content}`);
		 *     }
		 * });
		 */ tokenize: function(text, grammar) {
            var rest = grammar.rest;
            if (rest) {
                for(var token in rest)grammar[token] = rest[token];
                delete grammar.rest;
            }
            var tokenList = new LinkedList();
            addAfter(tokenList, tokenList.head, text);
            matchGrammar(text, tokenList, grammar, tokenList.head, 0);
            return toArray(tokenList);
        },
        /**
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ hooks: {
            all: {},
            /**
			 * Adds the given callback to the list of callbacks for the given hook.
			 *
			 * The callback will be invoked when the hook it is registered for is run.
			 * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
			 *
			 * One callback function can be registered to multiple hooks and the same hook multiple times.
			 *
			 * @param {string} name The name of the hook.
			 * @param {HookCallback} callback The callback function which is given environment variables.
			 * @public
			 */ add: function(name, callback) {
                var hooks = _.hooks.all;
                hooks[name] = hooks[name] || [];
                hooks[name].push(callback);
            },
            /**
			 * Runs a hook invoking all registered callbacks with the given environment variables.
			 *
			 * Callbacks will be invoked synchronously and in the order in which they were registered.
			 *
			 * @param {string} name The name of the hook.
			 * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
			 * @public
			 */ run: function(name, env) {
                var callbacks = _.hooks.all[name];
                if (!callbacks || !callbacks.length) return;
                for(var i = 0, callback; callback = callbacks[i++];)callback(env);
            }
        },
        Token: Token
    };
    _self.Prism = _;
    // Typescript note:
    // The following can be used to import the Token type in JSDoc:
    //
    //   @typedef {InstanceType<import("./prism-core")["Token"]>} Token
    /**
	 * Creates a new token.
	 *
	 * @param {string} type See {@link Token#type type}
	 * @param {string | TokenStream} content See {@link Token#content content}
	 * @param {string|string[]} [alias] The alias(es) of the token.
	 * @param {string} [matchedStr=""] A copy of the full string this token was created from.
	 * @class
	 * @global
	 * @public
	 */ function Token(type, content, alias, matchedStr) {
        /**
		 * The type of the token.
		 *
		 * This is usually the key of a pattern in a {@link Grammar}.
		 *
		 * @type {string}
		 * @see GrammarToken
		 * @public
		 */ this.type = type;
        /**
		 * The strings or tokens contained by this token.
		 *
		 * This will be a token stream if the pattern matched also defined an `inside` grammar.
		 *
		 * @type {string | TokenStream}
		 * @public
		 */ this.content = content;
        /**
		 * The alias(es) of the token.
		 *
		 * @type {string|string[]}
		 * @see GrammarToken
		 * @public
		 */ this.alias = alias;
        // Copy of the full string this token was created from
        this.length = (matchedStr || '').length | 0;
    }
    /**
	 * A token stream is an array of strings and {@link Token Token} objects.
	 *
	 * Token streams have to fulfill a few properties that are assumed by most functions (mostly internal ones) that process
	 * them.
	 *
	 * 1. No adjacent strings.
	 * 2. No empty strings.
	 *
	 *    The only exception here is the token stream that only contains the empty string and nothing else.
	 *
	 * @typedef {Array<string | Token>} TokenStream
	 * @global
	 * @public
	 */ /**
	 * Converts the given token or token stream to an HTML representation.
	 *
	 * The following hooks will be run:
	 * 1. `wrap`: On each {@link Token}.
	 *
	 * @param {string | Token | TokenStream} o The token or token stream to be converted.
	 * @param {string} language The name of current language.
	 * @returns {string} The HTML representation of the token or token stream.
	 * @memberof Token
	 * @static
	 */ Token.stringify = function stringify(o, language) {
        if (typeof o == 'string') return o;
        if (Array.isArray(o)) {
            var s = '';
            o.forEach(function(e) {
                s += stringify(e, language);
            });
            return s;
        }
        var env = {
            type: o.type,
            content: stringify(o.content, language),
            tag: 'span',
            classes: [
                'token',
                o.type
            ],
            attributes: {},
            language: language
        };
        var aliases = o.alias;
        if (aliases) {
            if (Array.isArray(aliases)) Array.prototype.push.apply(env.classes, aliases);
            else env.classes.push(aliases);
        }
        _.hooks.run('wrap', env);
        var attributes = '';
        for(var name in env.attributes)attributes += ' ' + name + '="' + (env.attributes[name] || '').replace(/"/g, '&quot;') + '"';
        return '<' + env.tag + ' class="' + env.classes.join(' ') + '"' + attributes + '>' + env.content + '</' + env.tag + '>';
    };
    /**
	 * @param {RegExp} pattern
	 * @param {number} pos
	 * @param {string} text
	 * @param {boolean} lookbehind
	 * @returns {RegExpExecArray | null}
	 */ function matchPattern(pattern, pos, text, lookbehind) {
        pattern.lastIndex = pos;
        var match = pattern.exec(text);
        if (match && lookbehind && match[1]) {
            // change the match to remove the text matched by the Prism lookbehind group
            var lookbehindLength = match[1].length;
            match.index += lookbehindLength;
            match[0] = match[0].slice(lookbehindLength);
        }
        return match;
    }
    /**
	 * @param {string} text
	 * @param {LinkedList<string | Token>} tokenList
	 * @param {any} grammar
	 * @param {LinkedListNode<string | Token>} startNode
	 * @param {number} startPos
	 * @param {RematchOptions} [rematch]
	 * @returns {void}
	 * @private
	 *
	 * @typedef RematchOptions
	 * @property {string} cause
	 * @property {number} reach
	 */ function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
        for(var token in grammar){
            if (!grammar.hasOwnProperty(token) || !grammar[token]) continue;
            var patterns = grammar[token];
            patterns = Array.isArray(patterns) ? patterns : [
                patterns
            ];
            for(var j = 0; j < patterns.length; ++j){
                if (rematch && rematch.cause == token + ',' + j) return;
                var patternObj = patterns[j];
                var inside = patternObj.inside;
                var lookbehind = !!patternObj.lookbehind;
                var greedy = !!patternObj.greedy;
                var alias = patternObj.alias;
                if (greedy && !patternObj.pattern.global) {
                    // Without the global flag, lastIndex won't work
                    var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
                    patternObj.pattern = RegExp(patternObj.pattern.source, flags + 'g');
                }
                /** @type {RegExp} */ var pattern = patternObj.pattern || patternObj;
                for(var currentNode = startNode.next, pos = startPos; currentNode !== tokenList.tail; pos += currentNode.value.length, currentNode = currentNode.next){
                    if (rematch && pos >= rematch.reach) break;
                    var str = currentNode.value;
                    if (tokenList.length > text.length) // Something went terribly wrong, ABORT, ABORT!
                    return;
                    if (str instanceof Token) continue;
                    var removeCount = 1; // this is the to parameter of removeBetween
                    var match;
                    if (greedy) {
                        match = matchPattern(pattern, pos, text, lookbehind);
                        if (!match || match.index >= text.length) break;
                        var from = match.index;
                        var to = match.index + match[0].length;
                        var p = pos;
                        // find the node that contains the match
                        p += currentNode.value.length;
                        while(from >= p){
                            currentNode = currentNode.next;
                            p += currentNode.value.length;
                        }
                        // adjust pos (and p)
                        p -= currentNode.value.length;
                        pos = p;
                        // the current node is a Token, then the match starts inside another Token, which is invalid
                        if (currentNode.value instanceof Token) continue;
                        // find the last node which is affected by this match
                        for(var k = currentNode; k !== tokenList.tail && (p < to || typeof k.value === 'string'); k = k.next){
                            removeCount++;
                            p += k.value.length;
                        }
                        removeCount--;
                        // replace with the new match
                        str = text.slice(pos, p);
                        match.index -= pos;
                    } else {
                        match = matchPattern(pattern, 0, str, lookbehind);
                        if (!match) continue;
                    }
                    // eslint-disable-next-line no-redeclare
                    var from = match.index;
                    var matchStr = match[0];
                    var before = str.slice(0, from);
                    var after = str.slice(from + matchStr.length);
                    var reach = pos + str.length;
                    if (rematch && reach > rematch.reach) rematch.reach = reach;
                    var removeFrom = currentNode.prev;
                    if (before) {
                        removeFrom = addAfter(tokenList, removeFrom, before);
                        pos += before.length;
                    }
                    removeRange(tokenList, removeFrom, removeCount);
                    var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
                    currentNode = addAfter(tokenList, removeFrom, wrapped);
                    if (after) addAfter(tokenList, currentNode, after);
                    if (removeCount > 1) {
                        // at least one Token object was removed, so we have to do some rematching
                        // this can only happen if the current pattern is greedy
                        /** @type {RematchOptions} */ var nestedRematch = {
                            cause: token + ',' + j,
                            reach: reach
                        };
                        matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);
                        // the reach might have been extended because of the rematching
                        if (rematch && nestedRematch.reach > rematch.reach) rematch.reach = nestedRematch.reach;
                    }
                }
            }
        }
    }
    /**
	 * @typedef LinkedListNode
	 * @property {T} value
	 * @property {LinkedListNode<T> | null} prev The previous node.
	 * @property {LinkedListNode<T> | null} next The next node.
	 * @template T
	 * @private
	 */ /**
	 * @template T
	 * @private
	 */ function LinkedList() {
        /** @type {LinkedListNode<T>} */ var head = {
            value: null,
            prev: null,
            next: null
        };
        /** @type {LinkedListNode<T>} */ var tail = {
            value: null,
            prev: head,
            next: null
        };
        head.next = tail;
        /** @type {LinkedListNode<T>} */ this.head = head;
        /** @type {LinkedListNode<T>} */ this.tail = tail;
        this.length = 0;
    }
    /**
	 * Adds a new node with the given value to the list.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {T} value
	 * @returns {LinkedListNode<T>} The added node.
	 * @template T
	 */ function addAfter(list, node, value) {
        // assumes that node != list.tail && values.length >= 0
        var next = node.next;
        var newNode = {
            value: value,
            prev: node,
            next: next
        };
        node.next = newNode;
        next.prev = newNode;
        list.length++;
        return newNode;
    }
    /**
	 * Removes `count` nodes after the given node. The given node will not be removed.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {number} count
	 * @template T
	 */ function removeRange(list, node, count) {
        var next = node.next;
        for(var i = 0; i < count && next !== list.tail; i++)next = next.next;
        node.next = next;
        next.prev = node;
        list.length -= i;
    }
    /**
	 * @param {LinkedList<T>} list
	 * @returns {T[]}
	 * @template T
	 */ function toArray(list) {
        var array = [];
        var node = list.head.next;
        while(node !== list.tail){
            array.push(node.value);
            node = node.next;
        }
        return array;
    }
    if (!_self.document) {
        if (!_self.addEventListener) // in Node.js
        return _;
        if (!_.disableWorkerMessageHandler) // In worker
        _self.addEventListener('message', function(evt) {
            var message = JSON.parse(evt.data);
            var lang = message.language;
            var code = message.code;
            var immediateClose = message.immediateClose;
            _self.postMessage(_.highlight(code, _.languages[lang], lang));
            if (immediateClose) _self.close();
        }, false);
        return _;
    }
    // Get current script and highlight
    var script = _.util.currentScript();
    if (script) {
        _.filename = script.src;
        if (script.hasAttribute('data-manual')) _.manual = true;
    }
    function highlightAutomaticallyCallback() {
        if (!_.manual) _.highlightAll();
    }
    if (!_.manual) {
        // If the document state is "loading", then we'll use DOMContentLoaded.
        // If the document state is "interactive" and the prism.js script is deferred, then we'll also use the
        // DOMContentLoaded event because there might be some plugins or languages which have also been deferred and they
        // might take longer one animation frame to execute which can create a race condition where only some plugins have
        // been loaded when Prism.highlightAll() is executed, depending on how fast resources are loaded.
        // See https://github.com/PrismJS/prism/issues/2102
        var readyState = document.readyState;
        if (readyState === 'loading' || readyState === 'interactive' && script && script.defer) document.addEventListener('DOMContentLoaded', highlightAutomaticallyCallback);
        else if (window.requestAnimationFrame) window.requestAnimationFrame(highlightAutomaticallyCallback);
        else window.setTimeout(highlightAutomaticallyCallback, 16);
    }
    return _;
}(_self);
if (module.exports) module.exports = Prism;
// hack for components to work correctly in node.js
if (typeof global !== 'undefined') global.Prism = Prism;
// some additional documentation/types
/**
 * The expansion of a simple `RegExp` literal to support additional properties.
 *
 * @typedef GrammarToken
 * @property {RegExp} pattern The regular expression of the token.
 * @property {boolean} [lookbehind=false] If `true`, then the first capturing group of `pattern` will (effectively)
 * behave as a lookbehind group meaning that the captured text will not be part of the matched text of the new token.
 * @property {boolean} [greedy=false] Whether the token is greedy.
 * @property {string|string[]} [alias] An optional alias or list of aliases.
 * @property {Grammar} [inside] The nested grammar of this token.
 *
 * The `inside` grammar will be used to tokenize the text value of each token of this kind.
 *
 * This can be used to make nested and even recursive language definitions.
 *
 * Note: This can cause infinite recursion. Be careful when you embed different languages or even the same language into
 * each another.
 * @global
 * @public
 */ /**
 * @typedef Grammar
 * @type {Object<string, RegExp | GrammarToken | Array<RegExp | GrammarToken>>}
 * @property {Grammar} [rest] An optional grammar object that will be appended to this grammar.
 * @global
 * @public
 */ /**
 * A function which will invoked after an element was successfully highlighted.
 *
 * @callback HighlightCallback
 * @param {Element} element The element successfully highlighted.
 * @returns {void}
 * @global
 * @public
 */ /**
 * @callback HookCallback
 * @param {Object<string, any>} env The environment variables of the hook.
 * @returns {void}
 * @global
 * @public
 */ /* **********************************************
     Begin prism-markup.js
********************************************** */ Prism.languages.markup = {
    'comment': {
        pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
        greedy: true
    },
    'prolog': {
        pattern: /<\?[\s\S]+?\?>/,
        greedy: true
    },
    'doctype': {
        // https://www.w3.org/TR/xml/#NT-doctypedecl
        pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
        greedy: true,
        inside: {
            'internal-subset': {
                pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
                lookbehind: true,
                greedy: true,
                inside: null // see below
            },
            'string': {
                pattern: /"[^"]*"|'[^']*'/,
                greedy: true
            },
            'punctuation': /^<!|>$|[[\]]/,
            'doctype-tag': /^DOCTYPE/i,
            'name': /[^\s<>'"]+/
        }
    },
    'cdata': {
        pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
        greedy: true
    },
    'tag': {
        pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
        greedy: true,
        inside: {
            'tag': {
                pattern: /^<\/?[^\s>\/]+/,
                inside: {
                    'punctuation': /^<\/?/,
                    'namespace': /^[^\s>\/:]+:/
                }
            },
            'special-attr': [],
            'attr-value': {
                pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
                inside: {
                    'punctuation': [
                        {
                            pattern: /^=/,
                            alias: 'attr-equals'
                        },
                        {
                            pattern: /^(\s*)["']|["']$/,
                            lookbehind: true
                        }
                    ]
                }
            },
            'punctuation': /\/?>/,
            'attr-name': {
                pattern: /[^\s>\/]+/,
                inside: {
                    'namespace': /^[^\s>\/:]+:/
                }
            }
        }
    },
    'entity': [
        {
            pattern: /&[\da-z]{1,8};/i,
            alias: 'named-entity'
        },
        /&#x?[\da-f]{1,8};/i
    ]
};
Prism.languages.markup['tag'].inside['attr-value'].inside['entity'] = Prism.languages.markup['entity'];
Prism.languages.markup['doctype'].inside['internal-subset'].inside = Prism.languages.markup;
// Plugin to make entity title show the real entity, idea by Roman Komarov
Prism.hooks.add('wrap', function(env) {
    if (env.type === 'entity') env.attributes['title'] = env.content.replace(/&amp;/, '&');
});
Object.defineProperty(Prism.languages.markup.tag, 'addInlined', {
    /**
	 * Adds an inlined language to markup.
	 *
	 * An example of an inlined language is CSS with `<style>` tags.
	 *
	 * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addInlined('style', 'css');
	 */ value: function addInlined(tagName, lang) {
        var includedCdataInside = {};
        includedCdataInside['language-' + lang] = {
            pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
            lookbehind: true,
            inside: Prism.languages[lang]
        };
        includedCdataInside['cdata'] = /^<!\[CDATA\[|\]\]>$/i;
        var inside = {
            'included-cdata': {
                pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
                inside: includedCdataInside
            }
        };
        inside['language-' + lang] = {
            pattern: /[\s\S]+/,
            inside: Prism.languages[lang]
        };
        var def = {};
        def[tagName] = {
            pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
                return tagName;
            }), 'i'),
            lookbehind: true,
            greedy: true,
            inside: inside
        };
        Prism.languages.insertBefore('markup', 'cdata', def);
    }
});
Object.defineProperty(Prism.languages.markup.tag, 'addAttribute', {
    /**
	 * Adds an pattern to highlight languages embedded in HTML attributes.
	 *
	 * An example of an inlined language is CSS with `style` attributes.
	 *
	 * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addAttribute('style', 'css');
	 */ value: function(attrName, lang) {
        Prism.languages.markup.tag.inside['special-attr'].push({
            pattern: RegExp(/(^|["'\s])/.source + '(?:' + attrName + ')' + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, 'i'),
            lookbehind: true,
            inside: {
                'attr-name': /^[^\s=]+/,
                'attr-value': {
                    pattern: /=[\s\S]+/,
                    inside: {
                        'value': {
                            pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                            lookbehind: true,
                            alias: [
                                lang,
                                'language-' + lang
                            ],
                            inside: Prism.languages[lang]
                        },
                        'punctuation': [
                            {
                                pattern: /^=/,
                                alias: 'attr-equals'
                            },
                            /"|'/
                        ]
                    }
                }
            }
        });
    }
});
Prism.languages.html = Prism.languages.markup;
Prism.languages.mathml = Prism.languages.markup;
Prism.languages.svg = Prism.languages.markup;
Prism.languages.xml = Prism.languages.extend('markup', {});
Prism.languages.ssml = Prism.languages.xml;
Prism.languages.atom = Prism.languages.xml;
Prism.languages.rss = Prism.languages.xml;
/* **********************************************
     Begin prism-css.js
********************************************** */ (function(Prism) {
    var string = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
    Prism.languages.css = {
        'comment': /\/\*[\s\S]*?\*\//,
        'atrule': {
            pattern: RegExp('@[\\w-](?:' + /[^;{\s"']|\s+(?!\s)/.source + '|' + string.source + ')*?' + /(?:;|(?=\s*\{))/.source),
            inside: {
                'rule': /^@[\w-]+/,
                'selector-function-argument': {
                    pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
                    lookbehind: true,
                    alias: 'selector'
                },
                'keyword': {
                    pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
                    lookbehind: true
                }
            }
        },
        'url': {
            // https://drafts.csswg.org/css-values-3/#urls
            pattern: RegExp('\\burl\\((?:' + string.source + '|' + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ')\\)', 'i'),
            greedy: true,
            inside: {
                'function': /^url/i,
                'punctuation': /^\(|\)$/,
                'string': {
                    pattern: RegExp('^' + string.source + '$'),
                    alias: 'url'
                }
            }
        },
        'selector': {
            pattern: RegExp('(^|[{}\\s])[^{}\\s](?:[^{};"\'\\s]|\\s+(?![\\s{])|' + string.source + ')*(?=\\s*\\{)'),
            lookbehind: true
        },
        'string': {
            pattern: string,
            greedy: true
        },
        'property': {
            pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
            lookbehind: true
        },
        'important': /!important\b/i,
        'function': {
            pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
            lookbehind: true
        },
        'punctuation': /[(){};:,]/
    };
    Prism.languages.css['atrule'].inside.rest = Prism.languages.css;
    var markup = Prism.languages.markup;
    if (markup) {
        markup.tag.addInlined('style', 'css');
        markup.tag.addAttribute('style', 'css');
    }
})(Prism);
/* **********************************************
     Begin prism-clike.js
********************************************** */ Prism.languages.clike = {
    'comment': [
        {
            pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
            lookbehind: true,
            greedy: true
        },
        {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: true,
            greedy: true
        }
    ],
    'string': {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: true
    },
    'class-name': {
        pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
        lookbehind: true,
        inside: {
            'punctuation': /[.\\]/
        }
    },
    'keyword': /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
    'boolean': /\b(?:false|true)\b/,
    'function': /\b\w+(?=\()/,
    'number': /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    'operator': /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
    'punctuation': /[{}[\];(),.:]/
};
/* **********************************************
     Begin prism-javascript.js
********************************************** */ Prism.languages.javascript = Prism.languages.extend('clike', {
    'class-name': [
        Prism.languages.clike['class-name'],
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
            lookbehind: true
        }
    ],
    'keyword': [
        {
            pattern: /((?:^|\})\s*)catch\b/,
            lookbehind: true
        },
        {
            pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
            lookbehind: true
        }
    ],
    // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
    'function': /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    'number': {
        pattern: RegExp(/(^|[^\w$])/.source + '(?:' + // constant
        (/NaN|Infinity/.source + '|' + // binary integer
        /0[bB][01]+(?:_[01]+)*n?/.source + '|' + // octal integer
        /0[oO][0-7]+(?:_[0-7]+)*n?/.source + '|' + // hexadecimal integer
        /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + '|' + // decimal bigint
        /\d+(?:_\d+)*n/.source + '|' + // decimal number (integer or float) but no bigint
        /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ')' + /(?![\w$])/.source),
        lookbehind: true
    },
    'operator': /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
});
Prism.languages.javascript['class-name'][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;
Prism.languages.insertBefore('javascript', 'keyword', {
    'regex': {
        pattern: RegExp(// lookbehind
        // eslint-disable-next-line regexp/no-dupe-characters-character-class
        /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + // Regex pattern:
        // There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
        // classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
        // with the only syntax, so we have to define 2 different regex patterns.
        /\//.source + '(?:' + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + '|' + // `v` flag syntax. This supports 3 levels of nested character classes.
        /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ')' + // lookahead
        /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source),
        lookbehind: true,
        greedy: true,
        inside: {
            'regex-source': {
                pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                lookbehind: true,
                alias: 'language-regex',
                inside: Prism.languages.regex
            },
            'regex-delimiter': /^\/|\/$/,
            'regex-flags': /^[a-z]+$/
        }
    },
    // This must be declared before keyword because we use "function" inside the look-forward
    'function-variable': {
        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
        alias: 'function'
    },
    'parameter': [
        {
            pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
            lookbehind: true,
            inside: Prism.languages.javascript
        },
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
            lookbehind: true,
            inside: Prism.languages.javascript
        },
        {
            pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
            lookbehind: true,
            inside: Prism.languages.javascript
        },
        {
            pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
            lookbehind: true,
            inside: Prism.languages.javascript
        }
    ],
    'constant': /\b[A-Z](?:[A-Z_]|\dx?)*\b/
});
Prism.languages.insertBefore('javascript', 'string', {
    'hashbang': {
        pattern: /^#!.*/,
        greedy: true,
        alias: 'comment'
    },
    'template-string': {
        pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
        greedy: true,
        inside: {
            'template-punctuation': {
                pattern: /^`|`$/,
                alias: 'string'
            },
            'interpolation': {
                pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                lookbehind: true,
                inside: {
                    'interpolation-punctuation': {
                        pattern: /^\$\{|\}$/,
                        alias: 'punctuation'
                    },
                    rest: Prism.languages.javascript
                }
            },
            'string': /[\s\S]+/
        }
    },
    'string-property': {
        pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
        lookbehind: true,
        greedy: true,
        alias: 'property'
    }
});
Prism.languages.insertBefore('javascript', 'operator', {
    'literal-property': {
        pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
        lookbehind: true,
        alias: 'property'
    }
});
if (Prism.languages.markup) {
    Prism.languages.markup.tag.addInlined('script', 'javascript');
    // add attribute support for all DOM events.
    // https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
    Prism.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, 'javascript');
}
Prism.languages.js = Prism.languages.javascript;
/* **********************************************
     Begin prism-file-highlight.js
********************************************** */ (function() {
    if (typeof Prism === 'undefined' || typeof document === 'undefined') return;
    // https://developer.mozilla.org/en-US/docs/Web/API/Element/matches#Polyfill
    if (!Element.prototype.matches) Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    var LOADING_MESSAGE = "Loading\u2026";
    var FAILURE_MESSAGE = function(status, message) {
        return "\u2716 Error " + status + ' while fetching file: ' + message;
    };
    var FAILURE_EMPTY_MESSAGE = "\u2716 Error: File does not exist or is empty";
    var EXTENSIONS = {
        'js': 'javascript',
        'py': 'python',
        'rb': 'ruby',
        'ps1': 'powershell',
        'psm1': 'powershell',
        'sh': 'bash',
        'bat': 'batch',
        'h': 'c',
        'tex': 'latex'
    };
    var STATUS_ATTR = 'data-src-status';
    var STATUS_LOADING = 'loading';
    var STATUS_LOADED = 'loaded';
    var STATUS_FAILED = 'failed';
    var SELECTOR = 'pre[data-src]:not([' + STATUS_ATTR + '="' + STATUS_LOADED + '"])' + ':not([' + STATUS_ATTR + '="' + STATUS_LOADING + '"])';
    /**
	 * Loads the given file.
	 *
	 * @param {string} src The URL or path of the source file to load.
	 * @param {(result: string) => void} success
	 * @param {(reason: string) => void} error
	 */ function loadFile(src, success, error) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', src, true);
        xhr.onreadystatechange = function() {
            if (xhr.readyState == 4) {
                if (xhr.status < 400 && xhr.responseText) success(xhr.responseText);
                else if (xhr.status >= 400) error(FAILURE_MESSAGE(xhr.status, xhr.statusText));
                else error(FAILURE_EMPTY_MESSAGE);
            }
        };
        xhr.send(null);
    }
    /**
	 * Parses the given range.
	 *
	 * This returns a range with inclusive ends.
	 *
	 * @param {string | null | undefined} range
	 * @returns {[number, number | undefined] | undefined}
	 */ function parseRange(range) {
        var m = /^\s*(\d+)\s*(?:(,)\s*(?:(\d+)\s*)?)?$/.exec(range || '');
        if (m) {
            var start = Number(m[1]);
            var comma = m[2];
            var end = m[3];
            if (!comma) return [
                start,
                start
            ];
            if (!end) return [
                start,
                undefined
            ];
            return [
                start,
                Number(end)
            ];
        }
        return undefined;
    }
    Prism.hooks.add('before-highlightall', function(env) {
        env.selector += ', ' + SELECTOR;
    });
    Prism.hooks.add('before-sanity-check', function(env) {
        var pre = /** @type {HTMLPreElement} */ env.element;
        if (pre.matches(SELECTOR)) {
            env.code = ''; // fast-path the whole thing and go to complete
            pre.setAttribute(STATUS_ATTR, STATUS_LOADING); // mark as loading
            // add code element with loading message
            var code = pre.appendChild(document.createElement('CODE'));
            code.textContent = LOADING_MESSAGE;
            var src = pre.getAttribute('data-src');
            var language = env.language;
            if (language === 'none') {
                // the language might be 'none' because there is no language set;
                // in this case, we want to use the extension as the language
                var extension = (/\.(\w+)$/.exec(src) || [
                    ,
                    'none'
                ])[1];
                language = EXTENSIONS[extension] || extension;
            }
            // set language classes
            Prism.util.setLanguage(code, language);
            Prism.util.setLanguage(pre, language);
            // preload the language
            var autoloader = Prism.plugins.autoloader;
            if (autoloader) autoloader.loadLanguages(language);
            // load file
            loadFile(src, function(text) {
                // mark as loaded
                pre.setAttribute(STATUS_ATTR, STATUS_LOADED);
                // handle data-range
                var range = parseRange(pre.getAttribute('data-range'));
                if (range) {
                    var lines = text.split(/\r\n?|\n/g);
                    // the range is one-based and inclusive on both ends
                    var start = range[0];
                    var end = range[1] == null ? lines.length : range[1];
                    if (start < 0) start += lines.length;
                    start = Math.max(0, Math.min(start - 1, lines.length));
                    if (end < 0) end += lines.length;
                    end = Math.max(0, Math.min(end, lines.length));
                    text = lines.slice(start, end).join('\n');
                    // add data-start for line numbers
                    if (!pre.hasAttribute('data-start')) pre.setAttribute('data-start', String(start + 1));
                }
                // highlight code
                code.textContent = text;
                Prism.highlightElement(code);
            }, function(error) {
                // mark as failed
                pre.setAttribute(STATUS_ATTR, STATUS_FAILED);
                code.textContent = error;
            });
        }
    });
    Prism.plugins.fileHighlight = {
        /**
		 * Executes the File Highlight plugin for all matching `pre` elements under the given container.
		 *
		 * Note: Elements which are already loaded or currently loading will not be touched by this method.
		 *
		 * @param {ParentNode} [container=document]
		 */ highlight: function highlight(container) {
            var elements = (container || document).querySelectorAll(SELECTOR);
            for(var i = 0, element; element = elements[i++];)Prism.highlightElement(element);
        }
    };
    var logged = false;
    /** @deprecated Use `Prism.plugins.fileHighlight.highlight` instead. */ Prism.fileHighlight = function() {
        if (!logged) {
            console.warn('Prism.fileHighlight is deprecated. Use `Prism.plugins.fileHighlight.highlight` instead.');
            logged = true;
        }
        Prism.plugins.fileHighlight.highlight.apply(this, arguments);
    };
})();

},{}],"5qlTb":[function(require,module,exports,__globalThis) {
Prism.languages.c = Prism.languages.extend('clike', {
    'comment': {
        pattern: /\/\/(?:[^\r\n\\]|\\(?:\r\n?|\n|(?![\r\n])))*|\/\*[\s\S]*?(?:\*\/|$)/,
        greedy: true
    },
    'string': {
        // https://en.cppreference.com/w/c/language/string_literal
        pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
        greedy: true
    },
    'class-name': {
        pattern: /(\b(?:enum|struct)\s+(?:__attribute__\s*\(\([\s\S]*?\)\)\s*)?)\w+|\b[a-z]\w*_t\b/,
        lookbehind: true
    },
    'keyword': /\b(?:_Alignas|_Alignof|_Atomic|_Bool|_Complex|_Generic|_Imaginary|_Noreturn|_Static_assert|_Thread_local|__attribute__|asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|inline|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|typeof|union|unsigned|void|volatile|while)\b/,
    'function': /\b[a-z_]\w*(?=\s*\()/i,
    'number': /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i,
    'operator': />>=?|<<=?|->|([-+&|:])\1|[?:~]|[-+*/%&|^!=<>]=?/
});
Prism.languages.insertBefore('c', 'string', {
    'char': {
        // https://en.cppreference.com/w/c/language/character_constant
        pattern: /'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n]){0,32}'/,
        greedy: true
    }
});
Prism.languages.insertBefore('c', 'string', {
    'macro': {
        // allow for multiline macro definitions
        // spaces after the # character compile fine with gcc
        pattern: /(^[\t ]*)#\s*[a-z](?:[^\r\n\\/]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|\\(?:\r\n|[\s\S]))*/im,
        lookbehind: true,
        greedy: true,
        alias: 'property',
        inside: {
            'string': [
                {
                    // highlight the path of the include statement as a string
                    pattern: /^(#\s*include\s*)<[^>]+>/,
                    lookbehind: true
                },
                Prism.languages.c['string']
            ],
            'char': Prism.languages.c['char'],
            'comment': Prism.languages.c['comment'],
            'macro-name': [
                {
                    pattern: /(^#\s*define\s+)\w+\b(?!\()/i,
                    lookbehind: true
                },
                {
                    pattern: /(^#\s*define\s+)\w+\b(?=\()/i,
                    lookbehind: true,
                    alias: 'function'
                }
            ],
            // highlight macro directives as keywords
            'directive': {
                pattern: /^(#\s*)[a-z]+/,
                lookbehind: true,
                alias: 'keyword'
            },
            'directive-hash': /^#/,
            'punctuation': /##|\\(?=[\r\n])/,
            'expression': {
                pattern: /\S[\s\S]*/,
                inside: Prism.languages.c
            }
        }
    }
});
Prism.languages.insertBefore('c', 'function', {
    // highlight predefined macros as constants
    'constant': /\b(?:EOF|NULL|SEEK_CUR|SEEK_END|SEEK_SET|__DATE__|__FILE__|__LINE__|__TIMESTAMP__|__TIME__|__func__|stderr|stdin|stdout)\b/
});
delete Prism.languages.c['boolean'];

},{}],"DzzSW":[function(require,module,exports,__globalThis) {
(function(Prism1) {
    var multilineComment = /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\//.source;
    for(var i = 0; i < 2; i++)// support 4 levels of nested comments
    multilineComment = multilineComment.replace(/<self>/g, function() {
        return multilineComment;
    });
    multilineComment = multilineComment.replace(/<self>/g, function() {
        return /[^\s\S]/.source;
    });
    Prism1.languages.rust = {
        'comment': [
            {
                pattern: RegExp(/(^|[^\\])/.source + multilineComment),
                lookbehind: true,
                greedy: true
            },
            {
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        'string': {
            pattern: /b?"(?:\\[\s\S]|[^\\"])*"|b?r(#*)"(?:[^"]|"(?!\1))*"\1/,
            greedy: true
        },
        'char': {
            pattern: /b?'(?:\\(?:x[0-7][\da-fA-F]|u\{(?:[\da-fA-F]_*){1,6}\}|.)|[^\\\r\n\t'])'/,
            greedy: true
        },
        'attribute': {
            pattern: /#!?\[(?:[^\[\]"]|"(?:\\[\s\S]|[^\\"])*")*\]/,
            greedy: true,
            alias: 'attr-name',
            inside: {
                'string': null // see below
            }
        },
        // Closure params should not be confused with bitwise OR |
        'closure-params': {
            pattern: /([=(,:]\s*|\bmove\s*)\|[^|]*\||\|[^|]*\|(?=\s*(?:\{|->))/,
            lookbehind: true,
            greedy: true,
            inside: {
                'closure-punctuation': {
                    pattern: /^\||\|$/,
                    alias: 'punctuation'
                },
                rest: null // see below
            }
        },
        'lifetime-annotation': {
            pattern: /'\w+/,
            alias: 'symbol'
        },
        'fragment-specifier': {
            pattern: /(\$\w+:)[a-z]+/,
            lookbehind: true,
            alias: 'punctuation'
        },
        'variable': /\$\w+/,
        'function-definition': {
            pattern: /(\bfn\s+)\w+/,
            lookbehind: true,
            alias: 'function'
        },
        'type-definition': {
            pattern: /(\b(?:enum|struct|trait|type|union)\s+)\w+/,
            lookbehind: true,
            alias: 'class-name'
        },
        'module-declaration': [
            {
                pattern: /(\b(?:crate|mod)\s+)[a-z][a-z_\d]*/,
                lookbehind: true,
                alias: 'namespace'
            },
            {
                pattern: /(\b(?:crate|self|super)\s*)::\s*[a-z][a-z_\d]*\b(?:\s*::(?:\s*[a-z][a-z_\d]*\s*::)*)?/,
                lookbehind: true,
                alias: 'namespace',
                inside: {
                    'punctuation': /::/
                }
            }
        ],
        'keyword': [
            // https://github.com/rust-lang/reference/blob/master/src/keywords.md
            /\b(?:Self|abstract|as|async|await|become|box|break|const|continue|crate|do|dyn|else|enum|extern|final|fn|for|if|impl|in|let|loop|macro|match|mod|move|mut|override|priv|pub|ref|return|self|static|struct|super|trait|try|type|typeof|union|unsafe|unsized|use|virtual|where|while|yield)\b/,
            // primitives and str
            // https://doc.rust-lang.org/stable/rust-by-example/primitives.html
            /\b(?:bool|char|f(?:32|64)|[ui](?:8|16|32|64|128|size)|str)\b/
        ],
        // functions can technically start with an upper-case letter, but this will introduce a lot of false positives
        // and Rust's naming conventions recommend snake_case anyway.
        // https://doc.rust-lang.org/1.0.0/style/style/naming/README.html
        'function': /\b[a-z_]\w*(?=\s*(?:::\s*<|\())/,
        'macro': {
            pattern: /\b\w+!/,
            alias: 'property'
        },
        'constant': /\b[A-Z_][A-Z_\d]+\b/,
        'class-name': /\b[A-Z]\w*\b/,
        'namespace': {
            pattern: /(?:\b[a-z][a-z_\d]*\s*::\s*)*\b[a-z][a-z_\d]*\s*::(?!\s*<)/,
            inside: {
                'punctuation': /::/
            }
        },
        // Hex, oct, bin, dec numbers with visual separators and type suffix
        'number': /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0o[0-7](?:_?[0-7])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)(?:_?(?:f32|f64|[iu](?:8|16|32|64|size)?))?\b/,
        'boolean': /\b(?:false|true)\b/,
        'punctuation': /->|\.\.=|\.{1,3}|::|[{}[\];(),:]/,
        'operator': /[-+*\/%!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?=?|[@?]/
    };
    Prism1.languages.rust['closure-params'].inside.rest = Prism1.languages.rust;
    Prism1.languages.rust['attribute'].inside['string'] = Prism1.languages.rust['string'];
})(Prism);

},{}],"4UXjg":[function(require,module,exports,__globalThis) {
(function(Prism1) {
    var key = /(?:[\w-]+|'[^'\n\r]*'|"(?:\\.|[^\\"\r\n])*")/.source;
    /**
	 * @param {string} pattern
	 */ function insertKey(pattern) {
        return pattern.replace(/__/g, function() {
            return key;
        });
    }
    Prism1.languages.toml = {
        'comment': {
            pattern: /#.*/,
            greedy: true
        },
        'table': {
            pattern: RegExp(insertKey(/(^[\t ]*\[\s*(?:\[\s*)?)__(?:\s*\.\s*__)*(?=\s*\])/.source), 'm'),
            lookbehind: true,
            greedy: true,
            alias: 'class-name'
        },
        'key': {
            pattern: RegExp(insertKey(/(^[\t ]*|[{,]\s*)__(?:\s*\.\s*__)*(?=\s*=)/.source), 'm'),
            lookbehind: true,
            greedy: true,
            alias: 'property'
        },
        'string': {
            pattern: /"""(?:\\[\s\S]|[^\\])*?"""|'''[\s\S]*?'''|'[^'\n\r]*'|"(?:\\.|[^\\"\r\n])*"/,
            greedy: true
        },
        'date': [
            {
                // Offset Date-Time, Local Date-Time, Local Date
                pattern: /\b\d{4}-\d{2}-\d{2}(?:[T\s]\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})?)?\b/i,
                alias: 'number'
            },
            {
                // Local Time
                pattern: /\b\d{2}:\d{2}:\d{2}(?:\.\d+)?\b/,
                alias: 'number'
            }
        ],
        'number': /(?:\b0(?:x[\da-zA-Z]+(?:_[\da-zA-Z]+)*|o[0-7]+(?:_[0-7]+)*|b[10]+(?:_[10]+)*))\b|[-+]?\b\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?(?:[eE][+-]?\d+(?:_\d+)*)?\b|[-+]?\b(?:inf|nan)\b/,
        'boolean': /\b(?:false|true)\b/,
        'punctuation': /[.,=[\]{}]/
    };
})(Prism);

},{}],"q494w":[function(require,module,exports,__globalThis) {
(function() {
    if (typeof Prism === 'undefined' || typeof document === 'undefined' || !document.createRange) return;
    Prism.plugins.KeepMarkup = true;
    Prism.hooks.add('before-highlight', function(env) {
        if (!env.element.children.length) return;
        if (!Prism.util.isActive(env.element, 'keep-markup', true)) return;
        var dropTokens = Prism.util.isActive(env.element, 'drop-tokens', false);
        /**
		 * Returns whether the given element should be kept.
		 *
		 * @param {HTMLElement} element
		 * @returns {boolean}
		 */ function shouldKeep(element) {
            if (dropTokens && element.nodeName.toLowerCase() === 'span' && element.classList.contains('token')) return false;
            return true;
        }
        var pos = 0;
        var data = [];
        function processElement(element) {
            if (!shouldKeep(element)) {
                // don't keep this element and just process its children
                processChildren(element);
                return;
            }
            var o = {
                // Store original element so we can restore it after highlighting
                element: element,
                posOpen: pos
            };
            data.push(o);
            processChildren(element);
            o.posClose = pos;
        }
        function processChildren(element) {
            for(var i = 0, l = element.childNodes.length; i < l; i++){
                var child = element.childNodes[i];
                if (child.nodeType === 1) processElement(child);
                else if (child.nodeType === 3) pos += child.data.length;
            }
        }
        processChildren(env.element);
        if (data.length) // data is an array of all existing tags
        env.keepMarkup = data;
    });
    Prism.hooks.add('after-highlight', function(env) {
        if (env.keepMarkup && env.keepMarkup.length) {
            var walk = function(elt, nodeState) {
                for(var i = 0, l = elt.childNodes.length; i < l; i++){
                    var child = elt.childNodes[i];
                    if (child.nodeType === 1) {
                        if (!walk(child, nodeState)) return false;
                    } else if (child.nodeType === 3) {
                        if (!nodeState.nodeStart && nodeState.pos + child.data.length > nodeState.node.posOpen) {
                            // We found the start position
                            nodeState.nodeStart = child;
                            nodeState.nodeStartPos = nodeState.node.posOpen - nodeState.pos;
                        }
                        if (nodeState.nodeStart && nodeState.pos + child.data.length >= nodeState.node.posClose) {
                            // We found the end position
                            nodeState.nodeEnd = child;
                            nodeState.nodeEndPos = nodeState.node.posClose - nodeState.pos;
                        }
                        nodeState.pos += child.data.length;
                    }
                    if (nodeState.nodeStart && nodeState.nodeEnd) {
                        // Select the range and wrap it with the element
                        var range = document.createRange();
                        range.setStart(nodeState.nodeStart, nodeState.nodeStartPos);
                        range.setEnd(nodeState.nodeEnd, nodeState.nodeEndPos);
                        nodeState.node.element.innerHTML = '';
                        nodeState.node.element.appendChild(range.extractContents());
                        range.insertNode(nodeState.node.element);
                        range.detach();
                        // Process is over
                        return false;
                    }
                }
                return true;
            };
            // For each tag, we walk the DOM to reinsert it
            env.keepMarkup.forEach(function(node) {
                walk(env.element, {
                    node: node,
                    pos: 0
                });
            });
            // Store new highlightedCode for later hooks calls
            env.highlightedCode = env.element.innerHTML;
        }
    });
})();

},{}],"fVdpz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DECKS", ()=>DECKS);
parcelHelpers.export(exports, "validateDeckType", ()=>validateDeckType);
var _overviewMdx = require("./overview.mdx");
var _introMdx = require("./intro.mdx");
var _ownershipMdx = require("./ownership.mdx");
var _optionAndResultMdx = require("./option-and-result.mdx");
var _errorHandlingMdx = require("./error-handling.mdx");
var _iteratorsMdx = require("./iterators.mdx");
var _typesMdx = require("./types.mdx");
var _concurrencyMdx = require("./concurrency.mdx");
var _asyncMdx = require("./async.mdx");
var _fromDynamicLanguagesMdx = require("./from-dynamic-languages.mdx");
var _reliableCodeUsingTypesMdx = require("./reliable-code-using-types.mdx");
var _testingMdx = require("./testing.mdx");
var _stringsVsBytesMdx = require("./strings-vs-bytes.mdx");
var _macrosMdx = require("./macros.mdx");
var _ffiMdx = require("./ffi.mdx");
var _embeddedMdx = require("./embedded.mdx");
var _tetramemMdx = require("./tetramem.mdx");
const DECKS = {
    overview: _overviewMdx,
    intro: _introMdx,
    ownership: _ownershipMdx,
    "option-and-result": _optionAndResultMdx,
    "error-handling": _errorHandlingMdx,
    iterators: _iteratorsMdx,
    types: _typesMdx,
    concurrency: _concurrencyMdx,
    async: _asyncMdx,
    "from-dynamic-languages": _fromDynamicLanguagesMdx,
    "reliable-code-using-types": _reliableCodeUsingTypesMdx,
    testing: _testingMdx,
    "strings-vs-bytes": _stringsVsBytesMdx,
    macros: _macrosMdx,
    ffi: _ffiMdx,
    embedded: _embeddedMdx,
    tetramem: _tetramemMdx
};
const DECK_IDS = Object.keys(DECKS);
const DEFAULT_DECK = "overview";
const isValidDeckType = (s)=>DECK_IDS.includes(s);
const validateDeckType = (s)=>s && isValidDeckType(s) ? s : DEFAULT_DECK;

},{"./overview.mdx":"9pO9n","./intro.mdx":"2NUMX","./ownership.mdx":"gKxBG","./option-and-result.mdx":"kfwT8","./error-handling.mdx":"bhVWw","./iterators.mdx":"4E2OQ","./types.mdx":"6MTJf","./concurrency.mdx":"1s6WQ","./async.mdx":"iXvhc","./from-dynamic-languages.mdx":"3REJc","./reliable-code-using-types.mdx":"gQf7s","./testing.mdx":"g1UBA","./strings-vs-bytes.mdx":"lLpkf","./macros.mdx":"pP6XZ","./ffi.mdx":"NpCky","./embedded.mdx":"klxCd","./tetramem.mdx":"60Nom","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"9pO9n":[function(require,module,exports,__globalThis) {
/*@jsxRuntime automatic*/ /*@jsxImportSource react*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MDXContent);
var _jsxRuntime = require("react/jsx-runtime");
var _directives = require("./Directives");
var _changeDeck = require("./ChangeDeck");
var _changeDeckDefault = parcelHelpers.interopDefault(_changeDeck);
var _testPattern = require("./TestPattern");
var _testPatternDefault = parcelHelpers.interopDefault(_testPattern);
function _createMdxContent(props) {
    const _components = {
        a: "a",
        h1: "h1",
        hr: "hr",
        li: "li",
        p: "p",
        ul: "ul",
        ...props.components
    }, { SplitSlides } = _components;
    if (!SplitSlides) _missingMdxReference("SplitSlides", true);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SplitSlides, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _testPatternDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Agenda"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _changeDeckDefault.default), {
                                deck: "intro",
                                children: "Introduction"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _changeDeckDefault.default), {
                                deck: "ownership",
                                children: "Ownership and borrowing"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _changeDeckDefault.default), {
                                deck: "option-and-result",
                                children: "Option and Result"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _changeDeckDefault.default), {
                                deck: "error-handling",
                                children: "Error handling"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _changeDeckDefault.default), {
                                deck: "iterators",
                                children: "Iterators"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _changeDeckDefault.default), {
                                deck: "types",
                                children: "Types"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _changeDeckDefault.default), {
                                deck: "concurrency",
                                children: "Concurrency"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _changeDeckDefault.default), {
                                deck: "from-dynamic-languages",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                    children: "Coming from dynamic languages"
                                })
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _changeDeckDefault.default), {
                                deck: "reliable-code-using-types",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                    children: "Reliable code using types"
                                })
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _changeDeckDefault.default), {
                                deck: "testing",
                                children: "Testing"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _changeDeckDefault.default), {
                                deck: "ffi",
                                children: "Unsafe and FFI"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _changeDeckDefault.default), {
                                deck: "tetramem",
                                children: "TetraMem"
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Resources"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                            href: "https://www.rust-lang.org/",
                            children: "Rust website"
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                            href: "https://doc.rust-lang.org/",
                            children: "Rust documentation"
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                            href: "https://play.rust-lang.org",
                            children: "Rust playground"
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                            href: "https://crates.io",
                            children: "crates.io"
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                            href: "https://docs.rs",
                            children: "docs.rs"
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                            href: "https://users.rust-lang.org",
                            children: "User's forum"
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                            href: "https://discord.com/invite/rust-lang-community",
                            children: "Discord"
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                            href: "https://stackoverflow.com/questions/tagged/rust",
                            children: "Stack Overflow"
                        })
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "More topics"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _changeDeckDefault.default), {
                                deck: "strings-vs-bytes",
                                children: "Strings vs. bytes"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _changeDeckDefault.default), {
                                deck: "macros",
                                children: "Macros"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _changeDeckDefault.default), {
                                deck: "embedded",
                                children: "Embedded"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _changeDeckDefault.default), {
                                deck: "async",
                                children: "Asynchronous programming"
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Feedback"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                    href: "https://docs.google.com/forms/d/e/1FAIpQLScKj9DoHFosn_uUXl1UHYr4JLxUtFztxAvTN5d8Cx7V0qo2vQ/viewform?usp=header",
                    children: "Feedback Form"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                    href: "mailto:jake.goulding@integer32.com?subject=Rust%20Training%20Feedback",
                    children: "jake.goulding@integer32.com"
                })
            })
        ]
    });
}
function MDXContent(props = {}) {
    const { wrapper: MDXLayout } = props.components || {};
    return MDXLayout ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(MDXLayout, {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_createMdxContent, {
            ...props
        })
    }) : _createMdxContent(props);
}
function _missingMdxReference(id, component, place) {
    throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it." + (place ? "\nIt\u2019s referenced in your code at `" + place + "`" : ""));
}

},{"react/jsx-runtime":"afIHK","./Directives":"6Yemz","./ChangeDeck":"29Jlq","./TestPattern":"g0BPT","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"29Jlq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _hooks = require("./app/hooks");
var _routeSlice = require("./features/route/routeSlice");
var _deckSlice = require("./features/deck/deckSlice");
var _broadcast = require("./app/broadcast");
const ChangeDeck = ({ children, deck })=>{
    const dispatch = (0, _hooks.useAppDispatch)();
    const onClick = (0, _react.useCallback)((e)=>{
        e.preventDefault();
        dispatch((0, _broadcast.broadcast)((0, _routeSlice.setDeck)(deck), (0, _deckSlice.setSlideIndex)(1)));
    }, [
        dispatch,
        deck
    ]);
    if (typeof window === "undefined") return children;
    const url = new URL(window.location.toString());
    url.searchParams.set("deck", deck);
    url.searchParams.set("page", 1..toString());
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
        href: url.toString(),
        onClick: onClick,
        children: children
    });
};
exports.default = ChangeDeck;

},{"react/jsx-runtime":"afIHK","react":"7e5Pu","./app/hooks":"8D69K","./features/route/routeSlice":"2FQD2","./features/deck/deckSlice":"dvasY","./app/broadcast":"eOCff","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"2FQD2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "routeSlice", ()=>routeSlice);
parcelHelpers.export(exports, "setDeck", ()=>setDeck);
var _toolkit = require("@reduxjs/toolkit");
// Duplicated to avoid a circular reference
const DEFAULT_DECK = "overview";
const initialState = {
    deck: DEFAULT_DECK
};
const routeSlice = (0, _toolkit.createSlice)({
    name: "route",
    initialState,
    reducers: {
        setDeck: (state, action)=>{
            state.deck = action.payload;
        }
    }
});
const { setDeck } = routeSlice.actions;
exports.default = routeSlice.reducer;

},{"@reduxjs/toolkit":"4eORJ","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"eOCff":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "broadcast", ()=>broadcast);
var _toolkit = require("@reduxjs/toolkit");
const broadcast = (0, _toolkit.createAction)("broadcast", (...payload)=>({
        payload
    }));

},{"@reduxjs/toolkit":"4eORJ","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"g0BPT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _rustTestPatternJpg = require("./assets/rust-test-pattern.jpg");
var _rustTestPatternJpgDefault = parcelHelpers.interopDefault(_rustTestPatternJpg);
var _testPatternModuleCss = require("./TestPattern.module.css");
const TestPattern = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
        className: _testPatternModuleCss.container,
        src: (0, _rustTestPatternJpgDefault.default)
    });
exports.default = TestPattern;

},{"react/jsx-runtime":"afIHK","./assets/rust-test-pattern.jpg":"37dZ6","./TestPattern.module.css":"lNThP","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"37dZ6":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("5g9Vq");

},{}],"lNThP":[function(require,module,exports,__globalThis) {
var _utilModuleCss = require("./util.module.css");
module.exports["container"] = `ySmK_a_container ${_utilModuleCss["-expand"]}`;

},{"./util.module.css":"lqfZi"}],"2NUMX":[function(require,module,exports,__globalThis) {
/*@jsxRuntime automatic*/ /*@jsxImportSource react*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "title", ()=>title);
parcelHelpers.export(exports, "default", ()=>MDXContent);
var _jsxRuntime = require("react/jsx-runtime");
var _directives = require("./Directives");
var _changeDeck = require("./ChangeDeck");
var _changeDeckDefault = parcelHelpers.interopDefault(_changeDeck);
var _skip = require("./layout/Skip");
var _skipDefault = parcelHelpers.interopDefault(_skip);
var _splash = require("./layout/Splash");
var _splashDefault = parcelHelpers.interopDefault(_splash);
var _testPattern = require("./TestPattern");
var _testPatternDefault = parcelHelpers.interopDefault(_testPattern);
var _transclude = require("./Transclude");
var _transcludeDefault = parcelHelpers.interopDefault(_transclude);
var _introModuleCss = require("./intro.module.css");
var _integer32Png = require("./assets/intro/integer32.png");
var _integer32PngDefault = parcelHelpers.interopDefault(_integer32Png);
var _kirbyPng = require("./assets/intro/kirby.png");
var _kirbyPngDefault = parcelHelpers.interopDefault(_kirbyPng);
var _playgroundPng = require("./assets/intro/playground.png");
var _playgroundPngDefault = parcelHelpers.interopDefault(_playgroundPng);
var _helloWorld = require("rust:intro/hello-world");
var _helloWorldDefault = parcelHelpers.interopDefault(_helloWorld);
var _printingOutput = require("rust:intro/printing-output");
var _printingOutputDefault = parcelHelpers.interopDefault(_printingOutput);
var _comments = require("rust:intro/comments");
var _commentsDefault = parcelHelpers.interopDefault(_comments);
var _functions = require("rust:intro/functions");
var _functionsDefault = parcelHelpers.interopDefault(_functions);
var _functionsRev1 = require("rust:intro/functions?rev=1");
var _functionsRev1Default = parcelHelpers.interopDefault(_functionsRev1);
var _variables = require("rust:intro/variables");
var _variablesDefault = parcelHelpers.interopDefault(_variables);
var _variablesRev1 = require("rust:intro/variables?rev=1");
var _variablesRev1Default = parcelHelpers.interopDefault(_variablesRev1);
var _variablesRev11 = require("stderr:intro/variables?rev=1");
var _variablesRev1Default1 = parcelHelpers.interopDefault(_variablesRev11);
var _variablesRev2 = require("rust:intro/variables?rev=2");
var _variablesRev2Default = parcelHelpers.interopDefault(_variablesRev2);
var _conditionals = require("rust:intro/conditionals");
var _conditionalsDefault = parcelHelpers.interopDefault(_conditionals);
var _fibonacci = require("rust:intro/fibonacci");
var _fibonacciDefault = parcelHelpers.interopDefault(_fibonacci);
var _fibonacciRev1 = require("rust:intro/fibonacci?rev=1");
var _fibonacciRev1Default = parcelHelpers.interopDefault(_fibonacciRev1);
var _vectorIteration = require("rust:intro/vector-iteration");
var _vectorIterationDefault = parcelHelpers.interopDefault(_vectorIteration);
var _vectorIteration1 = require("stderr:intro/vector-iteration");
var _vectorIterationDefault1 = parcelHelpers.interopDefault(_vectorIteration1);
var _vectorIterationRev1 = require("rust:intro/vector-iteration?rev=1");
var _vectorIterationRev1Default = parcelHelpers.interopDefault(_vectorIterationRev1);
var _iterators = require("rust:intro/iterators");
var _iteratorsDefault = parcelHelpers.interopDefault(_iterators);
var _iteratorExample = require("rust:intro/iterator-example");
var _iteratorExampleDefault = parcelHelpers.interopDefault(_iteratorExample);
var _iteratorExampleRev1 = require("rust:intro/iterator-example?rev=1");
var _iteratorExampleRev1Default = parcelHelpers.interopDefault(_iteratorExampleRev1);
var _structs = require("rust:intro/structs");
var _structsDefault = parcelHelpers.interopDefault(_structs);
var _enums = require("rust:intro/enums");
var _enumsDefault = parcelHelpers.interopDefault(_enums);
var _unions = require("rust:intro/unions");
var _unionsDefault = parcelHelpers.interopDefault(_unions);
var _deriveDebug = require("rust:intro/derive-debug");
var _deriveDebugDefault = parcelHelpers.interopDefault(_deriveDebug);
var _temperatureFunction = require("rust:intro/temperature-function");
var _temperatureFunctionDefault = parcelHelpers.interopDefault(_temperatureFunction);
var _associatedFunctions = require("rust:intro/associated-functions");
var _associatedFunctionsDefault = parcelHelpers.interopDefault(_associatedFunctions);
var _methods = require("rust:intro/methods");
var _methodsDefault = parcelHelpers.interopDefault(_methods);
var _temperatureMethod = require("rust:intro/temperature-method");
var _temperatureMethodDefault = parcelHelpers.interopDefault(_temperatureMethod);
var _strings = require("rust:intro/strings");
var _stringsDefault = parcelHelpers.interopDefault(_strings);
var _fizzBuzz = require("rust:intro/fizz-buzz");
var _fizzBuzzDefault = parcelHelpers.interopDefault(_fizzBuzz);
var _fizzBuzz1 = require("stdout:intro/fizz-buzz");
var _fizzBuzzDefault1 = parcelHelpers.interopDefault(_fizzBuzz1);
var _inputStdin = require("rust:intro/input-stdin");
var _inputStdinDefault = parcelHelpers.interopDefault(_inputStdin);
var _inputFile = require("rust:intro/input-file");
var _inputFileDefault = parcelHelpers.interopDefault(_inputFile);
var _outputFile = require("rust:intro/output-file");
var _outputFileDefault = parcelHelpers.interopDefault(_outputFile);
var _stringParsing = require("rust:intro/string-parsing");
var _stringParsingDefault = parcelHelpers.interopDefault(_stringParsing);
var _temperatureInput = require("rust:intro/temperature-input");
var _temperatureInputDefault = parcelHelpers.interopDefault(_temperatureInput);
var _modules = require("rust:intro/modules");
var _modulesDefault = parcelHelpers.interopDefault(_modules);
var _modules1 = require("stderr:intro/modules");
var _modulesDefault1 = parcelHelpers.interopDefault(_modules1);
var _visibilitySibling = require("rust:intro/visibility-sibling");
var _visibilitySiblingDefault = parcelHelpers.interopDefault(_visibilitySibling);
var _visibilityAncestor = require("rust:intro/visibility-ancestor");
var _visibilityAncestorDefault = parcelHelpers.interopDefault(_visibilityAncestor);
var _visibilityChild = require("rust:intro/visibility-child");
var _visibilityChildDefault = parcelHelpers.interopDefault(_visibilityChild);
var _visibilityChained = require("rust:intro/visibility-chained");
var _visibilityChainedDefault = parcelHelpers.interopDefault(_visibilityChained);
var _visibilityModifiers = require("rust:intro/visibility-modifiers");
var _visibilityModifiersDefault = parcelHelpers.interopDefault(_visibilityModifiers);
var _moduleImport = require("rust:intro/module-import");
var _moduleImportDefault = parcelHelpers.interopDefault(_moduleImport);
var _moduleImportRev1 = require("rust:intro/module-import?rev=1");
var _moduleImportRev1Default = parcelHelpers.interopDefault(_moduleImportRev1);
const title = "Hands-on introduction to Rust";
function _createMdxContent(props) {
    const _components = {
        a: "a",
        code: "code",
        em: "em",
        h1: "h1",
        h2: "h2",
        h3: "h3",
        hr: "hr",
        li: "li",
        ol: "ol",
        p: "p",
        pre: "pre",
        strong: "strong",
        ul: "ul",
        ...props.components
    }, { SplitSlides } = _components;
    if (!SplitSlides) _missingMdxReference("SplitSlides", true);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SplitSlides, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _testPatternDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Hands-on introduction to Rust"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Agenda"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ol, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Rustup and Cargo"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Basics and documentation"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Iterating"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Making our own types"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Strings and user input"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Modules"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                className: _introModuleCss.fullImage,
                src: (0, _integer32PngDefault.default),
                alt: "i32 logo"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Cofounder"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Stack Overflow"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                className: _introModuleCss.fullImage,
                src: (0, _kirbyPngDefault.default),
                alt: "gravatar"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "#1 answerer on Stack Overflow for Rust tag"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Rust Playground"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                className: _introModuleCss.fullImage,
                src: (0, _playgroundPngDefault.default),
                alt: "playground screenshot"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                    href: "https://play.rust-lang.org",
                    children: "play.rust-lang.org"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "maintainer"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Jake Goulding"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Rust infrastructure team"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Collaborated on a Rust video course for Manning"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "A handful of crates"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "C background"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "crates: error-handling, XML, parsing, low-level assembly"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Helped out with AVR-Rust"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Who are you?"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Who is a programmer?"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "What languages?"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Used Rust at all?"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Why Rust?"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Rustup"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Toolchain manager",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Installs Rust"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Keeps it updated"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Allows multiple concurrent versions"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Basic usage"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Installation"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                    href: "https://rustup.rs/",
                    children: "rustup.rs"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Upgrading"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "rustup update"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Cargo"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Package manager"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Build tool",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Code"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Tests"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Docs"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Cargo"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "cargo new --bin name-of-crate"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Have students list the directory"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-compiler-output",
                    children: ".\n\u251C\u2500\u2500 Cargo.toml\n\u2514\u2500\u2500 src\n    \u2514\u2500\u2500 main.rs\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "--bin"
                            }),
                            " is the default"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Can also make reusable libraries with ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "--lib"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Cargo"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "cargo run"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Have students list the directory"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-compiler-output",
                    children: ".\n\u251C\u2500\u2500 Cargo.lock\n\u2514\u2500\u2500 target\n    \u2514\u2500\u2500 debug\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Hello, world!"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _helloWorldDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "fn"
                            }),
                            " keyword"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "main"
                            }),
                            " is entry point for an executable"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "parenthesis"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "curly braces"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "4 space indent"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "println is a macro, don't worry too much about that"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "semicolons"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Printing values"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _printingOutputDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "{}"
                            }),
                            " prints something intended for an end-user"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "{:?}"
                            }),
                            " prints something for a developer"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Only single ident is valid for the inline format"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Can also print to stderr"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Rust does work with debuggers, but print debugging is so common"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Comments"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _commentsDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "API Documentation"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                                href: "https://doc.rust-lang.org/",
                                children: "doc.rust-lang.org"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "\"The Standard Library\""
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "rustup doc"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                            children: "rustup doc --std"
                                        })
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Functions"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _functionsDefault.default),
                focusOn: "1+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "statement has a semicolon at the end"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "expression doesn't"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "a block can have many statements, last may be expression"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "final expression of a block is the value of the block"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Return type is optional"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _functionsRev1Default.default),
                focusOn: "1+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Can use ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "return"
                            }),
                            " to exit from a function early"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Variables"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _variablesDefault.default),
                focusOn: "2+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "keyword ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "let"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "every variable has a type"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "type is inferred"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Variables"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _variablesRev1Default.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Try this"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _variablesRev1Default1.default),
                lang: "compiler-error",
                focusOn: "1+13"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Variables are immutable by default"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _variablesRev2Default.default),
                emphasize: "2[8+3]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Lots of functional languages do this"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Reduces places to reason about accidental changes"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Ever passed a collection to a function and it modified it?"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Default encourages usage"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Possible for the compiler to make some optimizations"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Built-in types"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "u32"
                            }),
                            ": unsigned 32-bit integer"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "i32"
                            }),
                            ": signed 32-bit integer"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "f64"
                            }),
                            ": floating point number"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "String"
                            }),
                            " and/or ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "&str"
                            }),
                            ": more on these later"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "bool"
                            }),
                            ": a boolean"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "(T1, T2, ...)"
                            }),
                            ": a tuple"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Different sizes of numeric types (",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "i32"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "u8"
                            }),
                            ", etc.)"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Vec"
                            }),
                            " / ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "[T]"
                            }),
                            " / ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "[T; N]"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Type inference / explicit types"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Most of the time, you don't need to specify the type"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "You can choose to if it helps you learn"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-rust",
                    children: "let name: Type = value;\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Can use the empty tuple to get a compile error with the real type"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "if"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _conditionalsDefault.default),
                focusOn: "7+13"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "No parenthesis on condition"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Evaluates to value of chosen block"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "match"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _conditionalsDefault.default),
                focusOn: "26+9"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "can have multiple patterns"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "first that matches is applied"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "can have single expression or curly braces"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "catch-all pattern of ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "_"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "patterns must be exhaustive, compiler warns about unreachable arms"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Exercise"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Create a ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "fibonacci"
                            }),
                            " function",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                            children: "F(n) = F(n-1) + F(n-2)"
                                        })
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                            children: "F(0) = 0"
                                        })
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                            children: "F(1) = 1"
                                        })
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Print out the result of calling the function with ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "10"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One answer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _fibonacciDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Another answer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _fibonacciRev1Default.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Vectors"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _vectorIterationDefault.default),
                focusOn: "2+4"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Declare using the ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "vec!"
                            }),
                            " macro"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Access an item with ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "[]"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Lots of methods available; check API for ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Vec"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Rust also has arrays, but they are fairly limited compared to ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Vec"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "for"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _vectorIterationDefault.default),
                focusOn: "11+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "expression"
                            }),
                            " can be anything that creates an iterator"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: "Expressions can be things like:"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "0..10"
                            }),
                            " or ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "0..=9"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                            children: "vector.iter()"
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                            children: "&vector"
                        })
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Iterating"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _vectorIterationDefault.default),
                focusOn: "17+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _vectorIterationDefault.default),
                focusOn: "23+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Have students try to do the loop twice."
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Iterating"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _vectorIterationDefault1.default),
                lang: "compiler-error",
                focusOn: "1+23"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Iterating"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _vectorIterationRev1Default.default),
                focusOn: "17+9",
                emphasize: "3[13+7]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Iterating over ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "scores"
                            }),
                            " takes ownership, ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "&scores"
                            }),
                            " does not"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Iterators"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _iteratorsDefault.default),
                focusOn: "2+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Iterator adapters like ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "map"
                            }),
                            " or ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "filter"
                            }),
                            " produce new iterators"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Check the docs for ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Iterator"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _iteratorsDefault.default),
                focusOn: "6+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _iteratorsDefault.default),
                focusOn: "10+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Iterators"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _iteratorsDefault.default),
                focusOn: "14"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Iterator consumers convert to something else"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _iteratorsDefault.default),
                focusOn: "16"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Exercise"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Print out the values from 0 (inclusive) to 100 (exclusive)"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "That are divisible by 3"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "And divisible by 7"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "0, 21, ..."
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Bonus"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Instead of printing them out, try adding them up"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Print them out ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.strong, {
                                children: "and"
                            }),
                            " add them up in one iteration"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One answer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _iteratorExampleDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Another answer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _iteratorExampleRev1Default.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Structs"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _structsDefault.default),
                focusOn: "5+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "structs allow us to group related data together"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _structsDefault.default),
                focusOn: "9+7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "if variable and field names match, can use shorthand"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Tuple structs"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _structsDefault.default),
                focusOn: "19+1"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _structsDefault.default),
                focusOn: "21+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Unit structs"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _structsDefault.default),
                focusOn: "27+1"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _structsDefault.default),
                focusOn: "29+1"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "May seem useless, but will be useful when we talk about traits"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Enums"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _enumsDefault.default),
                focusOn: "5+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "enums allow us to model mutually exclusive choices, known as ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.em, {
                                children: "variants"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "some languages might call this a \"discriminated union\""
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _enumsDefault.default),
                focusOn: "11+11"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "often used with a ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "match"
                            }),
                            " statement"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Unions"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _unionsDefault.default),
                focusOn: "5+4"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Very rarely seen."
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Mostly used for C FFI and weird tricks"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _unionsDefault.default),
                focusOn: "10+2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Accessing a union's field is not allowed in safe Rust"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "#[derive(Debug)]"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Add this to every type you create:"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                                src: (0, _deriveDebugDefault.default),
                                focusOn: "1+5",
                                emphasize: "1,4"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.p, {
                                children: [
                                    "This will allow you to print a value with ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                        children: "{:?}"
                                    })
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Exercise"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Create ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Fahrenheit"
                            }),
                            " and ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Celsius"
                            }),
                            " structs"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Create a function that converts ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Fahrenheit"
                            }),
                            " to ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Celsius"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                            children: "C = (F - 32.0) / 1.8"
                        })
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Bonus"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Instead of structs, do it with a single enum"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One answer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _temperatureFunctionDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "ownership of temperature is taken"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "derive ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Copy"
                            }),
                            "?"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Associated functions"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _associatedFunctionsDefault.default),
                focusOn: "1+4"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _associatedFunctionsDefault.default),
                focusOn: "6+1,21+4"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "associate a function with a specific type (struct or enum)"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "doesn't have to use an instance of the type"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _associatedFunctionsDefault.default),
                focusOn: "27+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Associated functions as constructors"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _associatedFunctionsDefault.default),
                focusOn: "1+4"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _associatedFunctionsDefault.default),
                focusOn: "6+1,7+6,24+1"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Rust doesn't have special constructors"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Sometimes called the \"named constructor pattern\""
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Self"
                            }),
                            " is a special alias for whatever type being implemented"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _associatedFunctionsDefault.default),
                focusOn: "31+1"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Associated functions as constructors"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _associatedFunctionsDefault.default),
                focusOn: "1+4"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _associatedFunctionsDefault.default),
                focusOn: "6+1,14+6,24+1"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _associatedFunctionsDefault.default),
                focusOn: "33+1"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Doesn't have to be called ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "new"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Can take arguments"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Doesn't have to return ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Self"
                            }),
                            ", e.g. if it's fallible"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Methods"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _methodsDefault.default),
                focusOn: "6+5",
                emphasize: "2[16+5]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "methods allow us to associate functions with a specific set of data (struct or enum)"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "name ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "self"
                            }),
                            " is special"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "non-",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "self"
                            }),
                            " associated functions aren't available with method syntax"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _methodsDefault.default),
                focusOn: "12+5",
                emphasize: "2[16+9]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _methodsDefault.default),
                focusOn: "18+5",
                emphasize: "2[16+4]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Method calls"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _methodsDefault.default),
                focusOn: "24+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "self"
                            }),
                            " argument is implicit"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _methodsDefault.default),
                focusOn: "28+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _methodsDefault.default),
                focusOn: "32+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Exercise"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Create a method that converts ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Celsius"
                            }),
                            " to ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Fahrenheit"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                            children: "F = C * 1.8 + 32.0"
                        })
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One answer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _temperatureMethodDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Strings"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Rust has two primary string types:"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "String"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Owns the data"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Can be extended or reduced"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "&str"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "References existing data"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Cannot change length"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Strings"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.p, {
                                children: [
                                    "Can convert from a ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                        children: "&str"
                                    }),
                                    " to a ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                        children: "String"
                                    }),
                                    " via ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                        children: "to_string()"
                                    })
                                ]
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                                src: (0, _stringsDefault.default),
                                focusOn: "2"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.p, {
                                children: [
                                    "Can get a ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                        children: "&str"
                                    }),
                                    " from a ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                        children: "String"
                                    }),
                                    " via ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                        children: "as_str()"
                                    })
                                ]
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                                src: (0, _stringsDefault.default),
                                focusOn: "3"
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Can use ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "to_string"
                            }),
                            " to convert lots of types to a String, actually"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Exercise"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Create a function that accepts a number and prints it"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Multiples of three print \u201CFizz\u201D instead of the number"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Multiples of five print \u201CBuzz\u201D instead of the number"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Multiples of both three and five print \u201CFizzBuzz\u201D"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Call the function with the numbers from 1 to 100"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Bonus"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Change the function to return a string instead of printing"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One answer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _fizzBuzzDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _fizzBuzzDefault1.default),
                lang: "compiler-output",
                focusOn: "1+15"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "match"
                            }),
                            " is useful for exhaustive and unreachable code"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                            href: "https://chrismorgan.info/blog/rust-fizzbuzz/",
                            children: "Chris Morgan's overview"
                        })
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Reading user input"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _inputStdinDefault.default),
                focus: ""
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Warning: the string has the trailing newline from hitting enter!"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Use ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "trim"
                            }),
                            " to remove it."
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "expect"
                            }),
                            " is for error handling; will talk more later"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Reading from files"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _inputFileDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "There's also ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "fs::read"
                            }),
                            " which just gets the bytes"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "This is the easy function, if you need more control it's available"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Writing to files"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _outputFileDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "This is the easy function, if you need more control it's available"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Parsing strings"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "With a type on the variable"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _stringParsingDefault.default),
                focusOn: "2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Can parse to multiple types, so we need to specify what we want."
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "With a type on the function call"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _stringParsingDefault.default),
                focusOn: "3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Turbofish specifies what target type"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                            href: "https://turbo.fish",
                            children: "What the turbofish?"
                        })
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Exercise"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Read user input of a temperature and convert it"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                            children: "C = (F - 32.0) / 1.8"
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                            children: "F = C * 1.8 + 32.0"
                        })
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Hints"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Remember to ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "trim"
                            }),
                            " your input"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Bonus"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Ask if it's Celsius or Fahrenheit (good use for an enum)"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Read a file of temperatures, convert, write to new file"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One answer (1/2)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _temperatureInputDefault.default),
                focusOn: "1+17"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One answer (2/2)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _temperatureInputDefault.default),
                focusOn: "19+26"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Modules"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _modulesDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "mod"
                            }),
                            " keyword"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _modulesDefault1.default),
                lang: "compiler-error",
                focusOn: "1+11"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Siblings can access each other"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _visibilitySiblingDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Children can access ancestors"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _visibilityAncestorDefault.default),
                focusOn: "1+7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "This ability is commonly used for unit tests"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Making items accessible to their parent"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _visibilityChildDefault.default),
                emphasize: "6[4+3]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Anything that can access ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "inner"
                            }),
                            " can now access ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "beta"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "main"
                            }),
                            " and ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "inner"
                            }),
                            " are siblings"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "If ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "pub"
                            }),
                            " used at the root of a library crate, then other crates can access"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Access is chained"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _visibilityChainedDefault.default),
                emphasize: "7[4+3],11[4+3],12[8+3]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "If ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "A"
                            }),
                            " can access ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "B"
                            }),
                            ", and ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "B"
                            }),
                            " can access ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "C"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "A"
                            }),
                            " can access ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "C"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Visibility modifier locations"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _visibilityModifiersDefault.default),
                focusOn: "1+18",
                emphasize: "1[0+3],3[0+3],4[4+3],7[0+3],12[0+3],14[0+3],16[0+3],18[0+3]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Notably not on enum variants"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "pub(crate)"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Can be seen anywhere in the entire crate"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Cannot be seen outside the crate"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "There are other nuanced modifiers (e.g. ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "pub(super)"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "pub(in path)"
                            }),
                            ")"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Importing items from other modules"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _moduleImportDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Importing items from other modules"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _moduleImportRev1Default.default),
                emphasize: "11,14"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Import paths"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Child"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-rust",
                    children: "use module_name::thing;\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Parent"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-rust",
                    children: "use super::thing;\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Crate root"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-rust",
                    children: "use crate::thing;\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "There are other less common ones, like ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "self"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Import selectors"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Single"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-rust",
                    children: "use foo::Bar;\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Multiple"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-rust",
                    children: "use foo::{Bar, Baz};\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Glob"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-rust",
                    children: "use foo::*;\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Renaming"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-rust",
                    children: "use foo::Bar as MyName;\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Can be combined and nested, where it makes sense"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Inline modules"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.strong, {
                    children: "src/main.rs"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-rust",
                    children: "mod example {\n    pub fn in_module() {\n        println!(\"I'm inside a module\");\n    }\n}\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "This seems to be a complicated aspect for many people."
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Modules in files"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.strong, {
                    children: "src/main.rs"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-rust",
                    children: "mod example;\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.strong, {
                    children: "src/example.rs"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-rust",
                    children: "pub fn in_module() {\n    println!(\"I'm inside a module\");\n}\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "No need to put ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "mod"
                            }),
                            " in ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.strong, {
                                children: "example.rs"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Deeply nested modules (Modern)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-compiler-output",
                    children: "src\n\u251C\u2500\u2500 main.rs\n\u251C\u2500\u2500 example.rs\n\u2514\u2500\u2500 example\n    \u2514\u2500\u2500 nested.rs\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "src/main.rs"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-rust",
                    children: "mod example;\n\nfn main() {\n    example::nested::foo();\n}\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "src/example.rs"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-rust",
                    children: "pub mod nested;\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "src/example/nested.rs"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-rust",
                    children: "pub fn foo() {\n    println!(\"Hello, world!\");\n}\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Deeply nested modules (Legacy)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-output",
                emphasize: "4[8+6]",
                children: `src
\u{251C}\u{2500}\u{2500} main.rs
\u{2514}\u{2500}\u{2500} example
\xa0\xa0\xa0\xa0\u{251C}\u{2500}\u{2500} mod.rs
\xa0\xa0\xa0\xa0\u{2514}\u{2500}\u{2500} nested.rs
`
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "src/main.rs"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-rust",
                    children: "mod example;\n\nfn main() {\n    example::nested::foo();\n}\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "src/example/mod.rs"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-rust",
                    children: "pub mod nested;\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "src/example/nested.rs"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-rust",
                    children: "pub fn foo() {\n    println!(\"Hello, world!\");\n}\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Exercise"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Create a function in a module which calls two others."
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Each function returns a number."
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.p, {
                                children: [
                                    "The parent function should be called in ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                        children: "main"
                                    })
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Code like this should run:"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                    className: "language-rust",
                                    children: "fn main() {\n    println!(\"{}\", secret::code());\n    // secret::key(); // Has an error!\n    // secret::signature(); // Has an error!\n}\n"
                                })
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Bonus"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Extract the module to a separate file"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One answer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-rust",
                    children: "fn main() {\n    println!(\"{}\", secret::code());\n    // secret::key(); // Has an error!\n    // secret::signature(); // Has an error!\n}\n\nmod secret {\n    pub fn code() -> i32 {\n        key() + signature()\n    }\n\n    fn key() -> i32 {\n        1\n    }\n\n    fn signature() -> i32 {\n        2\n    }\n}\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Rust's development"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Shipped 1.0 on 2015-05-15"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "New stable release every 6 weeks",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "nightly builds"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "beta candidates"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "stable releases"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Current stable is 1.97.0"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Process designed to be as open as possible"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "New feature genesis"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Start life in forums / chat servers"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "An RFC is created"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Appropriate teams",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "debate and refine"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "approve or reject"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Some teams have simpler paths, such as libs ACP"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Feature implementation"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Working group forms"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Development is done"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Proposal to stabilize"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Prototyping"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Once a feature has reached some usable state, you can opt-in to using it"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Feature flags are available only in nightly Rust"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Editions"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "\"Stability without stagnation\""
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Editions are completely compatible with each other"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Each crate decides what edition it wants"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "The Rust Edition Guide explains all the differences"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Rust 2018"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Stabilized in Rust 1.31"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Reserves new keywords like ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "async"
                            }),
                            " and ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "await"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Changed some module / path behaviors"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Removed anonymous function parameters in traits"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Enabled NLL, but eventually enabled in Rust 2015 as well"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Rust 2021"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Stabilized in Rust 1.56"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Traits like ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "TryFrom"
                            }),
                            " / ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "TryInto"
                            }),
                            " added to the prelude"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "IntoIterator"
                            }),
                            " fully implemented for arrays"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Closures now capture less aggressively"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Some warnings promoted to errors"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Rust 2024"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Stabilized in Rust 1.85"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "impl Trait"
                            }),
                            " captures lifetimes when no ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "use<..>"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Temporary scopes of ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "if let"
                            }),
                            " and trailing expressions changed"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Match ergonomics a bit more explicit"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "unsafe"
                            }),
                            " required in a few more places"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "IntoIterator"
                            }),
                            " fully implemented for ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Box<[T]>"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Reserves new keyword ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "gen"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Default formatting changes"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                    href: "https://docs.google.com/forms/d/e/1FAIpQLSfYYI0Zfem_tm8c3uDCn28B5L09N8nrU4lWxT0X2eVTiMslvQ/viewform?usp=publish-editor",
                    children: "Quiz"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _changeDeckDefault.default), {
                    deck: "overview",
                    children: "Return"
                })
            })
        ]
    });
}
function MDXContent(props = {}) {
    const { wrapper: MDXLayout } = props.components || {};
    return MDXLayout ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(MDXLayout, {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_createMdxContent, {
            ...props
        })
    }) : _createMdxContent(props);
}
function _missingMdxReference(id, component, place) {
    throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it." + (place ? "\nIt\u2019s referenced in your code at `" + place + "`" : ""));
}

},{"react/jsx-runtime":"afIHK","./Directives":"6Yemz","./ChangeDeck":"29Jlq","./layout/Skip":"1ziV3","./layout/Splash":"1mDy7","./TestPattern":"g0BPT","./Transclude":"fUgcm","./intro.module.css":"3lY8x","./assets/intro/integer32.png":"Is762","./assets/intro/kirby.png":"2yzeV","./assets/intro/playground.png":"6mSjC","rust:intro/hello-world":"gojqf","rust:intro/printing-output":"4R6QU","rust:intro/comments":"9XC6C","rust:intro/functions":"c44s6","rust:intro/functions?rev=1":"77FEt","rust:intro/variables":"6dBHB","rust:intro/variables?rev=1":"fEWMT","stderr:intro/variables?rev=1":"eilMS","rust:intro/variables?rev=2":"cYCTJ","rust:intro/conditionals":"f56C6","rust:intro/fibonacci":"7COaK","rust:intro/fibonacci?rev=1":"4pcK5","rust:intro/vector-iteration":"iVkxv","stderr:intro/vector-iteration":"lXgI6","rust:intro/vector-iteration?rev=1":"afREe","rust:intro/iterators":"hzKDJ","rust:intro/iterator-example":"aO969","rust:intro/iterator-example?rev=1":"4qeyu","rust:intro/structs":"gAAhJ","rust:intro/enums":"6gauq","rust:intro/unions":"cCoBC","rust:intro/derive-debug":"cVaUh","rust:intro/temperature-function":"2l3Tm","rust:intro/associated-functions":"cu7Oh","rust:intro/methods":"l4Lpp","rust:intro/temperature-method":"5i4X4","rust:intro/strings":"i02H4","rust:intro/fizz-buzz":"afZHL","stdout:intro/fizz-buzz":"4PZKY","rust:intro/input-stdin":"4lGdI","rust:intro/input-file":"cgKSR","rust:intro/output-file":"fl2ej","rust:intro/string-parsing":"5t3UU","rust:intro/temperature-input":"kA0mp","rust:intro/modules":"8xnEN","stderr:intro/modules":"yf33u","rust:intro/visibility-sibling":"fUec7","rust:intro/visibility-ancestor":"aFx7t","rust:intro/visibility-child":"baz7p","rust:intro/visibility-chained":"5Lmt2","rust:intro/visibility-modifiers":"bv3Dh","rust:intro/module-import":"7PZ5q","rust:intro/module-import?rev=1":"lrlkv","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"1ziV3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _default = require("./Default");
var _defaultDefault = parcelHelpers.interopDefault(_default);
var _skipModuleCss = require("./Skip.module.css");
var _hooks = require("../app/hooks");
const Skip = ({ children })=>{
    const showSkipped = (0, _hooks.useAppSelector)((state)=>state.skipped.showSkipped);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: _skipModuleCss.outer,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _defaultDefault.default), {
                children: children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Activity), {
                mode: showSkipped ? "visible" : "hidden",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: _skipModuleCss.overlay,
                    children: "Skipping"
                })
            })
        ]
    });
};
exports.default = Skip;

},{"react/jsx-runtime":"afIHK","react":"7e5Pu","./Default":"9KlDt","./Skip.module.css":"f6wXU","../app/hooks":"8D69K","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"f6wXU":[function(require,module,exports,__globalThis) {
var _utilModuleCss = require("../util.module.css");
module.exports["outer"] = `KoYL2a_outer ${_utilModuleCss["-center"]} ${_utilModuleCss["-expand"]}`;
module.exports["overlay"] = `KoYL2a_overlay ${_utilModuleCss["-center"]} ${_utilModuleCss["-expand"]}`;

},{"../util.module.css":"lqfZi"}],"1mDy7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _scaler = require("./Scaler");
var _scalerDefault = parcelHelpers.interopDefault(_scaler);
var _splashModuleCss = require("./Splash.module.css");
const Splash = ({ children })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: _splashModuleCss.outer,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _scalerDefault.default), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: _splashModuleCss.container,
                children: children
            })
        })
    });
exports.default = Splash;

},{"react/jsx-runtime":"afIHK","./Scaler":"jGhNM","./Splash.module.css":"iYMVb","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"iYMVb":[function(require,module,exports,__globalThis) {
var _utilModuleCss = require("../util.module.css");
module.exports["container"] = `hQx4Ja_container ${_utilModuleCss["-expand"]}`;
module.exports["outer"] = `hQx4Ja_outer ${_utilModuleCss["-center"]} ${_utilModuleCss["-expand"]}`;

},{"../util.module.css":"lqfZi"}],"fUgcm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _hooks = require("./app/hooks");
var _prism = require("./Prism");
var _prismDefault = parcelHelpers.interopDefault(_prism);
var _transcludeModuleCss = require("./Transclude.module.css");
const leadingWhitespace = (str)=>{
    const match = str.match(/^\s+/);
    return match ? match[0].length : 0;
};
const minOfTwo = (a, b)=>Math.min(a, b);
const parseBase10 = (s)=>parseInt(s, 10);
const oneBasedLineIndex = (n)=>n - 1;
const parseOneBasedLine = (s)=>oneBasedLineIndex(parseBase10(s));
const parseExplicitRange = (focusOn)=>{
    const [innerStart, innerEnd = innerStart] = focusOn.split("-").map(parseOneBasedLine);
    return [
        innerStart,
        innerEnd + 1
    ];
};
const parseWidthRange = (focusOn)=>{
    const [innerStartStr, innerWidthStr] = focusOn.split("+");
    const innerStart = parseOneBasedLine(innerStartStr);
    const innerWidth = innerWidthStr ? parseBase10(innerWidthStr) : 1;
    return [
        innerStart,
        innerStart + innerWidth
    ];
};
const applyFocus = (src, focusOn)=>{
    const lines = src.split("\n");
    const focusedLines = focusOn.split(",").flatMap((focusCommand)=>{
        const parser = focusCommand.includes("-") ? parseExplicitRange : parseWidthRange;
        const [start, end] = parser(focusCommand);
        return lines.slice(start, end);
    });
    if (focusedLines.length === 0) throw "The focus resulted in no lines";
    const spaceToRemove = focusedLines.filter((l)=>l.length > 0).map(leadingWhitespace).reduce(minOfTwo);
    return focusedLines.map((l)=>l.slice(spaceToRemove)).join("\n");
};
const applyTransform = (src, transforms)=>{
    const lines = src.split("\n");
    for(const userLineNumberS in transforms){
        const userLineNumber = parseBase10(userLineNumberS);
        const [find, replace] = transforms[userLineNumber];
        const lineNumber = oneBasedLineIndex(userLineNumber);
        lines[lineNumber] = lines[lineNumber].replace(find, replace);
    }
    return lines.join("\n");
};
const applyInsert = (src, inserts)=>{
    const lines = src.split("\n");
    // Apply inserts backwards to preserve line numbers
    const lineNumbers = Object.keys(inserts).map(parseBase10).sort((a, b)=>b - a);
    lineNumbers.forEach((userLineNumber)=>{
        const inserted = inserts[userLineNumber];
        const lineNumber = oneBasedLineIndex(userLineNumber);
        lines.splice(lineNumber, 0, inserted);
    });
    return lines.join("\n");
};
// https://stackoverflow.com/a/59322890/155423
const toWindows = (inputArray, size)=>Array.from({
        length: inputArray.length - (size - 1)
    }, (_, index)=>inputArray.slice(index, index + size));
const applyEmphasis = (src, emphasize)=>{
    const highlightLines = emphasize.split(",").map((highlightSpec)=>{
        // LINE
        // LINE[COLSTART-COLEND]
        // LINE[COLSTART+COLWIDTH]
        const match = highlightSpec.match(/(\d+)\[([^\]]+)\]/);
        if (match) {
            const [_, lineTxt, body] = match;
            const line = parseOneBasedLine(lineTxt);
            if (body.includes("-")) {
                const [start, end = start + 1] = body.split("-").map(parseBase10);
                return {
                    line,
                    columns: [
                        start,
                        end
                    ]
                };
            } else {
                const [start, width = 1] = body.split("+").map(parseBase10);
                return {
                    line,
                    columns: [
                        start,
                        start + width
                    ]
                };
            }
        } else {
            const line = parseOneBasedLine(highlightSpec);
            return {
                line
            };
        }
    });
    let lineOffset = 0;
    const lineOffsets = [];
    for (const match of src.matchAll(/\n/g))if (match.index) {
        const newlineOffset = match.index + 1;
        lineOffsets.push([
            lineOffset,
            newlineOffset
        ]);
        lineOffset = newlineOffset;
    }
    // If our input string doesn't end in a newline, include it
    lineOffsets.push([
        lineOffset,
        src.length
    ]);
    const offsetsForHighlight = ({ line, columns })=>{
        const offsets = lineOffsets[line];
        const [lineStart, _] = offsets;
        if (columns) return columns.map((c)=>c + lineStart);
        else return offsets;
    };
    const locations = [
        0
    ];
    for (const highlightLine of highlightLines)locations.push(...offsetsForHighlight(highlightLine));
    locations.push(src.length);
    let addEmphasis = false;
    return toWindows(locations, 2).map(([a, b], idx)=>{
        const chunk = src.slice(a, b);
        const value = addEmphasis ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("mark", {
            children: chunk
        }, idx) : chunk;
        addEmphasis = !addEmphasis;
        return value;
    });
};
const Transclude = ({ children, src, focusOn, transform, insert, emphasize, copyAllCode = true, lang = "rust" })=>{
    const showCopy = (0, _hooks.useAppSelector)((state)=>state.transclude.showCopy);
    const showEmphasis = (0, _hooks.useAppSelector)((state)=>state.transclude.showEmphasis);
    let originalCode = "";
    if (typeof children == "string") originalCode = children;
    if (src) originalCode = src;
    let manipulatedCode = originalCode;
    if (focusOn) manipulatedCode = applyFocus(manipulatedCode, focusOn);
    if (transform) manipulatedCode = applyTransform(manipulatedCode, transform);
    if (insert) manipulatedCode = applyInsert(manipulatedCode, insert);
    let formattedCode = manipulatedCode;
    if (emphasize) formattedCode = applyEmphasis(manipulatedCode, emphasize);
    const className = `language-${lang}`;
    const codeToCopy = copyAllCode ? originalCode : manipulatedCode;
    const doCopy = (0, _react.useCallback)(()=>{
        navigator.clipboard.writeText(codeToCopy);
    }, [
        codeToCopy
    ]);
    const Content = [
        "rust",
        "toml"
    ].includes(lang) ? (0, _prismDefault.default) : "code";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: _transcludeModuleCss.outer,
        "data-show-copy": showCopy ? true : null,
        "data-show-emphasis": showEmphasis ? true : null,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
                className: className,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Content, {
                    className: className,
                    children: formattedCode
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                className: _transcludeModuleCss.copy,
                onClick: doCopy,
                children: "Copy"
            })
        ]
    });
};
exports.default = Transclude;

},{"react/jsx-runtime":"afIHK","react":"7e5Pu","./app/hooks":"8D69K","./Prism":"3bjv6","./Transclude.module.css":"2ffCN","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"2ffCN":[function(require,module,exports,__globalThis) {
module.exports["copy"] = `tolyLa_copy`;
module.exports["outer"] = `tolyLa_outer`;

},{}],"3lY8x":[function(require,module,exports,__globalThis) {
var _utilModuleCss = require("./util.module.css");
module.exports["fullImage"] = `YASdAa_fullImage ${_utilModuleCss["-fullImage"]}`;

},{"./util.module.css":"lqfZi"}],"Is762":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("7Lv6c");

},{}],"2yzeV":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("2K7Dj");

},{}],"6mSjC":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("2kRzM");

},{}],"gojqf":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    println!(\"Hello, world!\");\n}\n";

},{}],"4R6QU":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    println!(\"Hello, {}\", \"alice\");\n    println!(\"Hello, {:?}\", \"bob\");\n\n    let name = \"coraline\";\n    println!(\"Hello, {name}\");\n    println!(\"Hello, {name:?}\");\n}\n";

},{}],"9XC6C":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    // println!(\"Hello, {}\", \"alice\");\n    /* println!(\"Hello, {:?}\", \"bob\"); */\n}\n";

},{}],"c44s6":[function(require,module,exports,__globalThis) {
module.exports = "fn the_name(arg1: Type1, arg2: Type2 /* ... */) -> ReturnType {\n    statement;\n    statement;\n    expression\n}\n\nfn main() {}\n";

},{}],"77FEt":[function(require,module,exports,__globalThis) {
module.exports = "fn the_name(arg1: Type1, arg2: Type2 /* ... */) -> ReturnType {\n    return expression;\n}\n\nfn main() {}\n";

},{}],"6dBHB":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let age = 21;\n    let is_enabled = true;\n    let emoji = '🌍';\n}\n";

},{}],"fEWMT":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let age = 21;\n    age += 1;\n}\n";

},{}],"eilMS":[function(require,module,exports,__globalThis) {
module.exports = "error[E0384]: cannot assign twice to immutable variable `age`\n  --> variables/src/main.rs:11:5\n   |\n10 |     let age = 21;\n   |         --- first assignment to `age`\n11 |     age += 1;\n   |     ^^^^^^^^ cannot assign twice to immutable variable\n   |\nhelp: consider making this binding mutable\n   |\n10 |     let mut age = 21;\n   |         +++\n\nwarning: value assigned to `age` is never read\n  --> variables/src/main.rs:11:5\n   |\n11 |     age += 1;\n   |     ^^^^^^^^\n   |\n   = help: maybe it is overwritten before being read?\n   = note: `#[warn(unused_assignments)]` (part of `#[warn(unused)]`) on by default\n\nFor more information about this error, try `rustc --explain E0384`.\nerror: could not compile `variables` (bin \"variables\") due to 1 previous error; 1 warning\n       emitted\n";

},{}],"cYCTJ":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let mut age = 21;\n    age += 1;\n}\n";

},{}],"f56C6":[function(require,module,exports,__globalThis) {
module.exports = "fn if_example() -> i32 {\n    let condition = true;\n    let another_condition = true;\n    let statement = 1;\n    let expression = 1;\n\n    if condition {\n        statement;\n        statement;\n        expression\n    } else if another_condition {\n        statement;\n        statement;\n        expression\n    } else {\n        statement;\n        statement;\n        expression\n    }\n}\n\nfn match_example() -> i32 {\n    let statement = 1;\n    let expression = 1;\n\n    match expression {\n        pattern_1 => expression,\n        pattern_2 => {\n            statement;\n            statement;\n            expression\n        }\n        _ => expression,\n    }\n}\n\nfn main() {}\n";

},{}],"7COaK":[function(require,module,exports,__globalThis) {
module.exports = "fn fibonacci(a: u32) -> u32 {\n    if a == 0 {\n        0\n    } else if a == 1 {\n        1\n    } else {\n        fibonacci(a - 1) + fibonacci(a - 2)\n    }\n}\n\nfn main() {\n    println!(\"{} -> {}\", 10, fibonacci(10));\n}\n";

},{}],"4pcK5":[function(require,module,exports,__globalThis) {
module.exports = "fn fibonacci(a: u32) -> u32 {\n    match a {\n        0 => 0,\n        1 => 1,\n        _ => fibonacci(a - 1) + fibonacci(a - 2),\n    }\n}\n\nfn main() {\n    println!(\"{} -> {}\", 10, fibonacci(10));\n}\n";

},{}],"iVkxv":[function(require,module,exports,__globalThis) {
module.exports = "fn vector_intro() {\n    let mut scores = vec![100, 90, 85];\n    scores[0] -= 10;\n    scores.push(100);\n    println!(\"scores: {scores:?}\");\n}\n\nfn for_loop_example() {\n    let expression = [1];\n\n    for pattern in expression {\n        // use variables created in pattern\n    }\n}\n\nfn the_borrow_checker() {\n    let scores = vec![100, 90, 85];\n\n    for score in scores {\n        println!(\"score: {score}\");\n    }\n\n    for score in scores {\n        println!(\"score: {score}\");\n    }\n}\n\nfn main() {}\n";

},{}],"lXgI6":[function(require,module,exports,__globalThis) {
module.exports = "error[E0382]: use of moved value: `scores`\n   --> vector-iteration/src/main.rs:24:18\n    |\n 18 |     let scores = vec![100, 90, 85];\n    |         ------ move occurs because `scores` has type `Vec<i32>`, which does not\n    |                implement the `Copy` trait\n 19 |\n 20 |     for score in scores {\n    |                  ------ `scores` moved due to this implicit call to `.into_iter()`\n...\n 24 |     for score in scores {\n    |                  ^^^^^^ value used here after move\n    |\nnote: `into_iter` takes ownership of the receiver `self`, which moves `scores`\n   --> core/src/iter/traits/collect.rs:312:18\n    |\n312 |     fn into_iter(self) -> Self::IntoIter;\n    |                  ^^^^\nhelp: consider iterating over a slice of the `Vec<i32>`'s content to avoid moving into the\n    | `for` loop\n    |\n 20 |     for score in &scores {\n    |                  +\n\nFor more information about this error, try `rustc --explain E0382`.\nerror: could not compile `vector-iteration` (bin \"vector-iteration\") due to 1 previous error\n";

},{}],"afREe":[function(require,module,exports,__globalThis) {
module.exports = "fn vector_intro() {\n    let mut scores = vec![100, 90, 85];\n    scores[0] -= 10;\n    scores.push(100);\n    println!(\"scores: {scores:?}\");\n}\n\nfn for_loop_example() {\n    let expression = [1];\n\n    for pattern in expression {\n        // use variables created in pattern\n    }\n}\n\nfn the_borrow_checker() {\n    let scores = vec![100, 90, 85];\n\n    for score in &scores {\n        println!(\"score: {score}\");\n    }\n\n    for score in scores {\n        println!(\"score: {score}\");\n    }\n}\n\nfn main() {}\n";

},{}],"hzKDJ":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    for i in 0..10 {\n        println!(\"{i}\");\n    }\n\n    for i in (0..10).map(|x| x * 2) {\n        println!(\"{i}\");\n    }\n\n    for i in (0..10).filter(|y| y % 2 == 0).map(|x| x * 2) {\n        println!(\"{i}\");\n    }\n\n    let values: Vec<i32> = (0..10).collect();\n\n    let total: i32 = (0..10).sum();\n}\n";

},{}],"aO969":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let iter = (0..100)\n        .filter(|y| y % 3 == 0)\n        .filter(|y| y % 7 == 0);\n\n    for i in iter {\n        println!(\"{i}\");\n    }\n}\n";

},{}],"4qeyu":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    for i in (0..100).filter(|y| y % 3 == 0 && y % 7 == 0) {\n        println!(\"{i}\");\n    }\n}\n";

},{}],"gAAhJ":[function(require,module,exports,__globalThis) {
module.exports = "type MemberType = u8;\ntype AnotherType = u8;\n\nfn named(member_value: MemberType, member_name: MemberType) {\n    struct TypeName {\n        member_name: MemberType,\n    }\n\n    let val_1 = TypeName {\n        member_name: member_value,\n    };\n    let val_2 = TypeName { member_name };\n\n    val_1.member_name;\n    val_2.member_name;\n}\n\nfn tuple(member_value: MemberType, another_value: AnotherType) {\n    struct TypeName(MemberType, AnotherType);\n\n    let val = TypeName(member_value, another_value);\n\n    val.0;\n}\n\nfn unit() {\n    struct TypeName;\n\n    let val = TypeName;\n}\n\nfn main() {\n    named(1, 1);\n    tuple(1, 1);\n    unit();\n}\n";

},{}],"6gauq":[function(require,module,exports,__globalThis) {
module.exports = "type MemberType = u8;\ntype AnotherType = u8;\n\nfn enum_types(some_value: MemberType, another_value: AnotherType) {\n    enum TypeName {\n        VariantOne,\n        VariantTwo(MemberType),\n        VariantThree { member_name: AnotherType },\n    }\n\n    let val_1 = TypeName::VariantOne;\n    let val_2 = TypeName::VariantTwo(some_value);\n    let val_3 = TypeName::VariantThree {\n        member_name: another_value,\n    };\n\n    match val_2 {\n        TypeName::VariantOne => println!(\"one\"),\n        TypeName::VariantTwo(v) => println!(\"two {v}\"),\n        TypeName::VariantThree { member_name } => println!(\"three {member_name}\"),\n    }\n}\n\nfn main() {\n    enum_types(1, 1);\n}\n";

},{}],"cCoBC":[function(require,module,exports,__globalThis) {
module.exports = "type Type1 = u16;\ntype Type2 = [u8; 2];\n\nfn union_example(value_1: Type1, value_2: Type2) {\n    union TypeName {\n        field_one: Type1,\n        field_two: Type2,\n    }\n\n    let val_1 = TypeName { field_one: value_1 };\n    let val_2 = TypeName { field_two: value_2 };\n\n    unsafe {\n        println!(\"{}\", l.field_one);\n    }\n}\n\nfn main() {\n    union_example(0, [1, 1]);\n}\n";

},{}],"cVaUh":[function(require,module,exports,__globalThis) {
module.exports = "#[derive(Debug)]\nstruct MyStruct { /* ... */ }\n\n#[derive(Debug)]\nenum MyEnum { /* ... */ }\n\nfn main() {}\n";

},{}],"2l3Tm":[function(require,module,exports,__globalThis) {
module.exports = "#[derive(Debug)]\nstruct Fahrenheit {\n    value: f64,\n}\n\n#[derive(Debug)]\nstruct Celsius {\n    value: f64,\n}\n\nfn fahrenheit_to_celsius(temperature: Fahrenheit) -> Celsius {\n    Celsius {\n        value: (temperature.value - 32.0) / 1.8,\n    }\n}\n\nfn main() {\n    let f = Fahrenheit { value: 70.0 };\n    let c = fahrenheit_to_celsius(f);\n    println!(\"is {c:?}\");\n}\n";

},{}],"cu7Oh":[function(require,module,exports,__globalThis) {
module.exports = "struct Monster {\n    hit_points: u8,\n    poisonous: bool,\n}\n\nimpl Monster {\n    fn new() -> Self {\n        Self {\n            hit_points: 128,\n            poisonous: false,\n        }\n    }\n\n    fn new_poisonous(hit_points: u8) -> Self {\n        Self {\n            hit_points,\n            poisonous: true,\n        }\n    }\n\n    fn is_scary() -> bool {\n        true\n    }\n}\n\nfn main() {\n    if Monster::is_scary() {\n        println!(\"Ahhh!\");\n    }\n\n    let m = Monster::new();\n\n    let m = Monster::new_poisonous(42);\n}\n";

},{}],"l4Lpp":[function(require,module,exports,__globalThis) {
module.exports = "type Type1 = u8;\ntype ReturnType = u8;\n\nstruct TypeName;\n\nimpl TypeName {\n    fn method_1(&self, arg1: Type1) -> ReturnType {\n        todo!()\n    }\n}\n\nimpl TypeName {\n    fn method_2(&mut self, arg1: Type1) -> ReturnType {\n        todo!()\n    }\n}\n\nimpl TypeName {\n    fn method_3(self, arg1: Type1) -> ReturnType {\n        todo!()\n    }\n}\n\nfn example_1(value: &TypeName, arg1: Type1) {\n    value.method_1(arg1);\n}\n\nfn example_2(value: &mut TypeName, arg1: Type1) {\n    value.method_2(arg1);\n}\n\nfn example_3(value: TypeName, arg1: Type1) {\n    value.method_3(arg1);\n}\n\nfn main() {}\n";

},{}],"5i4X4":[function(require,module,exports,__globalThis) {
module.exports = "#[derive(Debug)]\nstruct Fahrenheit {\n    value: f64,\n}\n\n#[derive(Debug)]\nstruct Celsius {\n    value: f64,\n}\n\nimpl Celsius {\n    fn to_fahrenheit(&self) -> Fahrenheit {\n        Fahrenheit {\n            value: (self.value * 1.8) + 32.0,\n        }\n    }\n}\n\nfn main() {\n    let c = Celsius { value: 100.0 };\n    let f = c.to_fahrenheit();\n    println!(\"is {f:?}\");\n}\n";

},{}],"i02H4":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    \"hello\".to_string();\n    String::new().as_str();\n}\n";

},{}],"afZHL":[function(require,module,exports,__globalThis) {
module.exports = "fn fizz_buzz(i: u32) -> String {\n    match (i.is_multiple_of(3), i.is_multiple_of(5)) {\n        (true, true) => \"FizzBuzz\".to_string(),\n        (true, false) => \"Fizz\".to_string(),\n        (false, true) => \"Buzz\".to_string(),\n        (false, false) => i.to_string(),\n    }\n}\n\nfn main() {\n    for i in 1..=100 {\n        println!(\"{}\", fizz_buzz(i));\n    }\n}\n";

},{}],"4PZKY":[function(require,module,exports,__globalThis) {
module.exports = "1\n2\nFizz\n4\nBuzz\nFizz\n7\n8\nFizz\nBuzz\n11\nFizz\n13\n14\nFizzBuzz\n16\n17\nFizz\n19\nBuzz\nFizz\n22\n23\nFizz\nBuzz\n26\nFizz\n28\n29\nFizzBuzz\n31\n32\nFizz\n34\nBuzz\nFizz\n37\n38\nFizz\nBuzz\n41\nFizz\n43\n44\nFizzBuzz\n46\n47\nFizz\n49\nBuzz\nFizz\n52\n53\nFizz\nBuzz\n56\nFizz\n58\n59\nFizzBuzz\n61\n62\nFizz\n64\nBuzz\nFizz\n67\n68\nFizz\nBuzz\n71\nFizz\n73\n74\nFizzBuzz\n76\n77\nFizz\n79\nBuzz\nFizz\n82\n83\nFizz\nBuzz\n86\nFizz\n88\n89\nFizzBuzz\n91\n92\nFizz\n94\nBuzz\nFizz\n97\n98\nFizz\nBuzz\n";

},{}],"4lGdI":[function(require,module,exports,__globalThis) {
module.exports = "use std::io;\n\nfn main() {\n    let mut input = String::new();\n    io::stdin()\n        .read_line(&mut input)\n        .expect(\"Couldn't read from stdin\");\n    println!(\"Read: {input:?}\");\n}\n";

},{}],"cgKSR":[function(require,module,exports,__globalThis) {
module.exports = "use std::fs;\n\nfn main() {\n    let data = fs::read_to_string(\"/path/to/file\")\n        .expect(\"Couldn't read the file\");\n    println!(\"Read: {data:?}\");\n}\n";

},{}],"fl2ej":[function(require,module,exports,__globalThis) {
module.exports = "use std::fs;\n\nfn main() {\n    fs::write(\"/path/to/file\", \"This is now in a file\")\n        .expect(\"Unable to write to the file\");\n}\n";

},{}],"5t3UU":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let a: i32 = \"42\".parse().expect(\"Not an integer\");\n    let a = \"42\".parse::<i32>().expect(\"Not an integer\");\n}\n";

},{}],"kA0mp":[function(require,module,exports,__globalThis) {
module.exports = "use std::io;\n\n#[derive(Debug)]\nenum Temperature {\n    Fahrenheit(f64),\n    Celsius(f64),\n}\n\nimpl Temperature {\n    fn convert(&self) -> Self {\n        use Temperature::*;\n        match self {\n            Fahrenheit(f) => Celsius((f - 32.0) / 1.8),\n            Celsius(c) => Fahrenheit(c * 1.8 + 32.0),\n        }\n    }\n}\n\nfn main() {\n    println!(\"Please enter a temperature:\");\n    let mut input = String::new();\n    io::stdin()\n        .read_line(&mut input)\n        .expect(\"Unable to read from stdin\");\n\n    let value = input\n        .trim()\n        .parse()\n        .expect(\"Temperature was not a floating point\");\n\n    println!(\"Is this Fahrenheit (F) or Celsius (C)?\");\n    input.clear();\n    io::stdin()\n        .read_line(&mut input)\n        .expect(\"Unable to read from stdin\");\n\n    let temperature = if input.trim().starts_with(\"C\") {\n        Temperature::Celsius(value)\n    } else {\n        Temperature::Fahrenheit(value)\n    };\n\n    println!(\"{temperature:?} is {:?}\", temperature.convert());\n}\n";

},{}],"8xnEN":[function(require,module,exports,__globalThis) {
module.exports = "mod example {\n    fn in_module() {\n        println!(\"I'm inside a module\");\n    }\n}\n\nfn main() {\n    example::in_module();\n}\n";

},{}],"yf33u":[function(require,module,exports,__globalThis) {
module.exports = "error[E0603]: function `in_module` is private\n --> modules/src/main.rs:8:14\n  |\n8 |     example::in_module();\n  |              ^^^^^^^^^ private function\n  |\nnote: the function `in_module` is defined here\n --> modules/src/main.rs:2:5\n  |\n2 |     fn in_module() {\n  |     ^^^^^^^^^^^^^^\n\nFor more information about this error, try `rustc --explain E0603`.\nerror: could not compile `modules` (bin \"modules\") due to 1 previous error\n";

},{}],"fUec7":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    alpha();\n}\n\nfn alpha() {\n    beta();\n}\n\nfn beta() {}\n";

},{}],"aFx7t":[function(require,module,exports,__globalThis) {
module.exports = "fn i_am_not_public() {}\n\nmod inner {\n    fn can_access_ancestor() {\n        super::i_am_not_public()\n    }\n}\n\nfn main() {}\n";

},{}],"baz7p":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    inner::alpha();\n}\n\nmod inner {\n    pub fn alpha() {}\n}\n";

},{}],"5Lmt2":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    level_one::alpha();\n    level_one::level_two::beta();\n}\n\nmod level_one {\n    pub fn alpha() {\n        level_two::beta()\n    }\n\n    pub mod level_two {\n        pub fn beta() {}\n    }\n}\n";

},{}],"bv3Dh":[function(require,module,exports,__globalThis) {
module.exports = "pub fn call_me() {}\n\npub struct Monster {\n    pub hit_points: u8,\n}\n\npub enum State {\n    OnFire,\n    Electrified,\n}\n\npub mod example {}\n\npub const CONSTANT: u8 = 1;\n\npub static STATIC: u8 = 2;\n\npub use some::import;\n\nmod some {\n    pub mod import {}\n}\n\nfn main() {}\n";

},{}],"7PZ5q":[function(require,module,exports,__globalThis) {
module.exports = "mod inner {\n    pub struct Example;\n\n    impl Example {\n        pub fn greet(&self) {\n            println!(\"Hello!\");\n        }\n    }\n}\n\nfn main() {\n    inner::Example.greet();\n}\n";

},{}],"lrlkv":[function(require,module,exports,__globalThis) {
module.exports = "mod inner {\n    pub struct Example;\n\n    impl Example {\n        pub fn greet(&self) {\n            println!(\"Hello!\");\n        }\n    }\n}\n\nuse inner::Example;\n\nfn main() {\n    Example.greet();\n}\n";

},{}],"gKxBG":[function(require,module,exports,__globalThis) {
/*@jsxRuntime automatic*/ /*@jsxImportSource react*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "title", ()=>title);
parcelHelpers.export(exports, "default", ()=>MDXContent);
var _jsxRuntime = require("react/jsx-runtime");
var _directives = require("./Directives");
var _changeDeck = require("./ChangeDeck");
var _changeDeckDefault = parcelHelpers.interopDefault(_changeDeck);
var _splash = require("./layout/Splash");
var _splashDefault = parcelHelpers.interopDefault(_splash);
var _skip = require("./layout/Skip");
var _skipDefault = parcelHelpers.interopDefault(_skip);
var _testPattern = require("./TestPattern");
var _testPatternDefault = parcelHelpers.interopDefault(_testPattern);
var _transclude = require("./Transclude");
var _transcludeDefault = parcelHelpers.interopDefault(_transclude);
var _ownershipModuleCss = require("./ownership.module.css");
var _basic = require("rust:ownership/basic");
var _basicDefault = parcelHelpers.interopDefault(_basic);
var _borrowing = require("rust:ownership/borrowing");
var _borrowingDefault = parcelHelpers.interopDefault(_borrowing);
var _valueSvg = require("url:./assets/ownership/value.svg");
var _valueSvgDefault = parcelHelpers.interopDefault(_valueSvg);
var _referenceSvg = require("url:./assets/ownership/reference.svg");
var _referenceSvgDefault = parcelHelpers.interopDefault(_referenceSvg);
var _borrowKinds = require("rust:ownership/borrow-kinds");
var _borrowKindsDefault = parcelHelpers.interopDefault(_borrowKinds);
var _immutableWhileMutable = require("rust:ownership/immutable-while-mutable");
var _immutableWhileMutableDefault = parcelHelpers.interopDefault(_immutableWhileMutable);
var _immutableWhileMutable1 = require("stderr:ownership/immutable-while-mutable");
var _immutableWhileMutableDefault1 = parcelHelpers.interopDefault(_immutableWhileMutable1);
var _methodImplicitBorrow = require("rust:ownership/method-implicit-borrow");
var _methodImplicitBorrowDefault = parcelHelpers.interopDefault(_methodImplicitBorrow);
var _methodImplicitBorrowRev1 = require("rust:ownership/method-implicit-borrow?rev=1");
var _methodImplicitBorrowRev1Default = parcelHelpers.interopDefault(_methodImplicitBorrowRev1);
var _slices = require("rust:ownership/slices");
var _slicesDefault = parcelHelpers.interopDefault(_slices);
var _vecSvg = require("url:./assets/ownership/vec.svg");
var _vecSvgDefault = parcelHelpers.interopDefault(_vecSvg);
var _sliceSvg = require("url:./assets/ownership/slice.svg");
var _sliceSvgDefault = parcelHelpers.interopDefault(_sliceSvg);
var _stringSlices = require("rust:ownership/string-slices");
var _stringSlicesDefault = parcelHelpers.interopDefault(_stringSlices);
var _stringSvg = require("url:./assets/ownership/string.svg");
var _stringSvgDefault = parcelHelpers.interopDefault(_stringSvg);
var _stringSliceSvg = require("url:./assets/ownership/string-slice.svg");
var _stringSliceSvgDefault = parcelHelpers.interopDefault(_stringSliceSvg);
var _strings = require("rust:ownership/strings");
var _stringsDefault = parcelHelpers.interopDefault(_strings);
var _derefCoercion = require("rust:ownership/deref-coercion");
var _derefCoercionDefault = parcelHelpers.interopDefault(_derefCoercion);
var _borrowChecker = require("rust:ownership/borrow-checker");
var _borrowCheckerDefault = parcelHelpers.interopDefault(_borrowChecker);
var _borrowChecker1 = require("stderr:ownership/borrow-checker");
var _borrowCheckerDefault1 = parcelHelpers.interopDefault(_borrowChecker1);
var _moveSemantics = require("rust:ownership/move-semantics");
var _moveSemanticsDefault = parcelHelpers.interopDefault(_moveSemantics);
var _moveSemantics1 = require("stderr:ownership/move-semantics");
var _moveSemanticsDefault1 = parcelHelpers.interopDefault(_moveSemantics1);
var _moveSemanticsRev1 = require("rust:ownership/move-semantics?rev=1");
var _moveSemanticsRev1Default = parcelHelpers.interopDefault(_moveSemanticsRev1);
var _moveSemanticsRev11 = require("stderr:ownership/move-semantics?rev=1");
var _moveSemanticsRev1Default1 = parcelHelpers.interopDefault(_moveSemanticsRev11);
var _copy = require("rust:ownership/copy");
var _copyDefault = parcelHelpers.interopDefault(_copy);
var _clone = require("rust:ownership/clone");
var _cloneDefault = parcelHelpers.interopDefault(_clone);
var _concreteLifetimes = require("rust:ownership/concrete-lifetimes");
var _concreteLifetimesDefault = parcelHelpers.interopDefault(_concreteLifetimes);
var _genericLifetimes = require("rust:ownership/generic-lifetimes");
var _genericLifetimesDefault = parcelHelpers.interopDefault(_genericLifetimes);
var _shorterString = require("rust:ownership/shorter-string");
var _shorterStringDefault = parcelHelpers.interopDefault(_shorterString);
var _differingLifetimes = require("rust:ownership/differing-lifetimes");
var _differingLifetimesDefault = parcelHelpers.interopDefault(_differingLifetimes);
var _staticLifetime = require("rust:ownership/static-lifetime");
var _staticLifetimeDefault = parcelHelpers.interopDefault(_staticLifetime);
var _uniqueLines = require("rust:ownership/unique-lines");
var _uniqueLinesDefault = parcelHelpers.interopDefault(_uniqueLines);
var _dropOrder = require("rust:ownership/drop-order");
var _dropOrderDefault = parcelHelpers.interopDefault(_dropOrder);
var _dropOrder1 = require("stdout:ownership/drop-order");
var _dropOrderDefault1 = parcelHelpers.interopDefault(_dropOrder1);
var _dropOrderRev1 = require("rust:ownership/drop-order?rev=1");
var _dropOrderRev1Default = parcelHelpers.interopDefault(_dropOrderRev1);
var _dropOrderRev11 = require("stdout:ownership/drop-order?rev=1");
var _dropOrderRev1Default1 = parcelHelpers.interopDefault(_dropOrderRev11);
var _dropOrderRev2 = require("rust:ownership/drop-order?rev=2");
var _dropOrderRev2Default = parcelHelpers.interopDefault(_dropOrderRev2);
var _dropOrderRev21 = require("stdout:ownership/drop-order?rev=2");
var _dropOrderRev2Default1 = parcelHelpers.interopDefault(_dropOrderRev21);
var _sharedOwnership = require("rust:ownership/shared-ownership");
var _sharedOwnershipDefault = parcelHelpers.interopDefault(_sharedOwnership);
var _disjointBorrows = require("rust:ownership/disjoint-borrows");
var _disjointBorrowsDefault = parcelHelpers.interopDefault(_disjointBorrows);
var _disjointBorrowsRev1 = require("rust:ownership/disjoint-borrows?rev=1");
var _disjointBorrowsRev1Default = parcelHelpers.interopDefault(_disjointBorrowsRev1);
var _disjointBorrowsRev11 = require("stderr:ownership/disjoint-borrows?rev=1");
var _disjointBorrowsRev1Default1 = parcelHelpers.interopDefault(_disjointBorrowsRev11);
var _disjointBorrowsRev2 = require("rust:ownership/disjoint-borrows?rev=2");
var _disjointBorrowsRev2Default = parcelHelpers.interopDefault(_disjointBorrowsRev2);
var _ownedOrBorrowed = require("rust:ownership/owned-or-borrowed");
var _ownedOrBorrowedDefault = parcelHelpers.interopDefault(_ownedOrBorrowed);
var _cow = require("rust:ownership/cow");
var _cowDefault = parcelHelpers.interopDefault(_cow);
const title = "Ownership and borrowing";
function _createMdxContent(props) {
    const _components = {
        a: "a",
        code: "code",
        em: "em",
        h1: "h1",
        h2: "h2",
        hr: "hr",
        li: "li",
        p: "p",
        pre: "pre",
        strong: "strong",
        ul: "ul",
        ...props.components
    }, { SplitSlides } = _components;
    if (!SplitSlides) _missingMdxReference("SplitSlides", true);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SplitSlides, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _testPatternDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Ownership and borrowing"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Ownership"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _basicDefault.default),
                focusOn: "1+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Owner controls mutability"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "When a value has no owner, it's cleaned up at the end of scope"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Borrowing"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _borrowingDefault.default),
                focusOn: "2+2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Borrowing"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _borrowingDefault.default),
                focusOn: "2+2",
                emphasize: "2[31+1]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "All thanks to the humble ampersand"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Ownership and borrowing"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _borrowingDefault.default),
                focusOn: "2+2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                className: _ownershipModuleCss.chunkyImage,
                src: (0, _valueSvgDefault.default),
                alt: "value analogy"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "knowledge"
                            }),
                            " is something we don't want to duplicate needlessly"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Maybe it takes a lot of memory?"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Ownership and borrowing"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _borrowingDefault.default),
                focusOn: "2+2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                className: _ownershipModuleCss.chunkyImage,
                src: (0, _referenceSvgDefault.default),
                alt: "reference analogy"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "a_reference_to_knowledge"
                            }),
                            " points to the same memory"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "It's not a copy, so it's very lightweight"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Borrowing"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Immutable"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _borrowKindsDefault.default),
                focusOn: "2+2",
                emphasize: "2[13+1]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Mutable"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _borrowKindsDefault.default),
                focusOn: "5+2",
                emphasize: "1[4+3],2[13+4]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Requires that the variable be mutable"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Rules of references"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Either",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "one mutable reference"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "any number of immutable references"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "References must always be valid"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Immutable and mutable borrowing"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _immutableWhileMutableDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _immutableWhileMutableDefault1.default),
                focusOn: "1+10"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "If you have a mutable reference, no other references of any kind"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "If you have immutable references, as many as you want"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Definitely cannot have both at the same time"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "You've been borrowing all along"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _methodImplicitBorrowDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Equivalent"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _methodImplicitBorrowRev1Default.default),
                focusOn: "11+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "The compiler automatically borrows for you on method calls"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Slices"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _slicesDefault.default),
                focusOn: "2+2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Special kind of reference"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Slices"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                className: _ownershipModuleCss.chunkyImage,
                src: (0, _vecSvgDefault.default),
                alt: "memory of Vec"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Slices"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                className: _ownershipModuleCss.chunkyImage,
                src: (0, _sliceSvgDefault.default),
                alt: "memory of slice"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Points to the start of some data and knows how many items there are"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Not ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.em, {
                                children: "that"
                            }),
                            " unique, but the usability and safety comes from borrowing"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "String slices"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _stringSlicesDefault.default),
                focusOn: "2+2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Special kind of slice"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Always guaranteed to be UTF-8"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "String slices"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                className: _ownershipModuleCss.chunkyImage,
                src: (0, _stringSvgDefault.default),
                alt: "memory of String"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "String slices"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                className: _ownershipModuleCss.chunkyImage,
                src: (0, _stringSliceSvgDefault.default),
                alt: "memory of &str"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Exercise: Strings"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Create a function that accepts a string"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "return that string wrapped in parenthesis"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Code like this should run:"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                                src: (0, _stringsDefault.default),
                                focusOn: "6+1",
                                copyAllCode: false
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One answer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _stringsDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Any disquiet about this solution?"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Aside: Deref coercions"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "String"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Vec"
                            }),
                            " and other smart pointers implement ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Deref"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "&String"
                                            }),
                                            " can be treated as ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "&str"
                                            })
                                        ]
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "&Vec<T>"
                                            }),
                                            " can be treated as ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "&[T]"
                                            })
                                        ]
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "&Box<T>"
                                            }),
                                            " can be treated as ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "&T"
                                            })
                                        ]
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Aside: Deref coercions"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _derefCoercionDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "The borrow checker"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _borrowCheckerDefault.default),
                focusOn: "2+4"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _borrowCheckerDefault1.default),
                focusOn: "1+11"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "We take a reference to the same book, but it is destroyed before we use it"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "This is caught at compile time"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "No dangling pointers (and all the security holes)"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Many people refer to this as \"fighting\" the borrow checker"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Move semantics"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _moveSemanticsDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _moveSemanticsDefault1.default),
                focusOn: "1+15"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Move semantics"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _moveSemanticsRev1Default.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _moveSemanticsRev1Default1.default),
                focusOn: "1+11"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "The previous example (being dropped) was a special case of a move"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Copy"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "A fundamental trait"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Indicates that it's safe and cheap to perform a bitwise copy"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Compiler will automatically insert these copies as needed"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Can only be implemented if all members are ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Copy"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Copy"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _copyDefault.default),
                focusOn: "2+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Integers implement ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Copy"
                            }),
                            ", so this code will compile fine"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Clone"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Indicates that it's possible to perform a copy"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Implementor determines what the behavior is"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Usually derive ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Clone"
                            }),
                            " which just clones all fields"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Explicit method call is required"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.strong, {
                                children: "PROTIP"
                            }),
                            ": No shame in using ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Clone"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "or any other ownership"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Clone"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _cloneDefault.default),
                focusOn: "2+3",
                emphasize: "2[25+8]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Make a clone before moving it"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "a_book"
                            }),
                            " is still valid"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Lifetimes"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Ask what people think \"lifetime\" means"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "The region of the code where a value exists at a specific address"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Common misconception: time between when a value is created and destroyed"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Maybe Rust picked the wrong term here"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "My favorite lifetime analogy"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "A value is your home"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Moving changes your address"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Dying also changes your address"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "A reference is a piece of paper with your address"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "When you use a reference, you go to the address"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Walk in the door without asking and start poking around"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Breaks down a bit here"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Concrete lifetimes"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _concreteLifetimesDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Generic lifetimes"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _genericLifetimesDefault.default),
                focusOn: "2+6",
                emphasize: "1[25+2],1[36+2],1[48+2]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Lifetimes go hand-in-hand with the borrow checker"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Generic lifetimes let us connect input and output references"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Exercise: Shorter string"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Write a function that takes two string slices"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.p, {
                                children: [
                                    "Returns the shorter string (compared via ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                        children: "len"
                                    }),
                                    ")"
                                ]
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Pick whichever when equal length"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Code like this should run:"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                                src: (0, _shorterStringDefault.default),
                                focusOn: "10+1",
                                copyAllCode: false
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One answer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _shorterStringDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Differing lifetimes"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _differingLifetimesDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Will this compile?"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "If so, where would it be valid to declare ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "shorter"
                            }),
                            "?"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Lifetimes are unified"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _differingLifetimesDefault.default),
                emphasize: "6[57+1],7[57+1],8[57+1],9[57+1],10[57+1]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "When two concrete lifetimes share a generic lifetime, ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                            " the intersection of them is chosen."
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Lifetime elision"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Each reference parameter gets a unique lifetime parameter"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                    className: "language-rust",
                                    children: "fn bar(x: &i32, y: &i32)\nfn bar<'a, 'b>(x: &'a i32, y: &'b i32)\n"
                                })
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "If only one reference parameter, assign to all output lifetimes"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                    className: "language-rust",
                                    children: "fn foo(x: &i32) -> &i32\nfn foo<'a>(x: &'a i32) -> &'a i32\n"
                                })
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.p, {
                                children: [
                                    "If ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                        children: "&self"
                                    }),
                                    " or ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                        children: "&mut self"
                                    }),
                                    ", assign to all output lifetimes"
                                ]
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                    className: "language-rust",
                                    children: "fn quux(&self, x: &i32) -> &i32\nfn quux<'a, 'b>(&'a self, x: &'b i32) -> &'a i32\n"
                                })
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Elision may be confusing"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Especially when a lifetime parameter is inside of another type:"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                    className: "language-rust",
                                    children: "pub fn iter(&self) -> Iter<T>\n"
                                })
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                    className: "language-rust",
                                    children: "pub fn iter<'a>(&'a self) -> Iter<'a, T>\n"
                                })
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                    className: "language-rust",
                                    children: "pub fn iter(&self) -> Iter<'_, T>\n"
                                })
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Opt in to a warning when elision occurs in this case"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                    className: "language-rust",
                                    children: "#![deny(rust_2018_idioms)]\n"
                                })
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "rust_2018_idioms"
                            }),
                            " is less needed as of Rust 1.89"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "The ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "'static"
                    }),
                    " lifetime"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "The only pre-defined lifetime"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "The referred-to value must be valid until the program ends"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "The ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "'static"
                    }),
                    " lifetime"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _staticLifetimeDefault.default),
                focusOn: "2+2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "String literals are the most common ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "'static"
                            }),
                            " reference"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "String literals are not on the stack ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.em, {
                                children: "or"
                            }),
                            " heap, but in the binary itself"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "static"
                    }),
                    " and ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "const"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "static"
                            }),
                            " variables",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "created exactly once"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "have a stable address"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "const"
                            }),
                            " variables",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "inlines a unique copy at each usage"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Literal values or ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "const fn"
                            }),
                            " needed"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Consider",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "size of value"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "if value is used at runtime or compile time"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "static"
                    }),
                    " and ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "const"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _staticLifetimeDefault.default),
                focusOn: "5+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.p, {
                children: [
                    "Compiler effectively makes ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "static"
                    }),
                    "s for you when needed"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _staticLifetimeDefault.default),
                focusOn: "3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _staticLifetimeDefault.default),
                focusOn: "13+2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Exercise: Count the unique lines in a file"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.p, {
                                children: [
                                    "Create a function that takes a path to a file and returns a ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                        children: "HashMap"
                                    })
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Code like this should run:"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                                src: (0, _uniqueLinesDefault.default),
                                focusOn: "16+4",
                                copyAllCode: false
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Hints"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                            children: "std::collections::HashMap::entry"
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                            children: "std::fs::read_to_string"
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Return a ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "HashMap<..., usize>"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Bonus"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Do it for words instead of lines"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Do it without reading the entire file at once"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One answer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _uniqueLinesDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Cleaning up a value"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "A type defines what to do when it is cleaned up"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Provided by compiler if not explicit"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "The destructor of a type is automatically called when no owner"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Leaking memory is ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.strong, {
                                children: "safe"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Deliberately leaking memory is one way to get a ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "'static"
                            }),
                            " reference"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Implementing ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "Drop"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _dropOrderDefault.default),
                focusOn: "1+7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Drop order"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _dropOrderDefault.default),
                focusOn: "10+2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-output",
                src: (0, _dropOrderDefault1.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Drop order"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _dropOrderRev1Default.default),
                focusOn: "10+2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-output",
                src: (0, _dropOrderRev1Default1.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Variables are dropped in reverse declaration order"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Drop order"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _dropOrderRev2Default.default),
                focusOn: "10+4"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-output",
                src: (0, _dropOrderRev2Default1.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Not often needed, but good to know about"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Shared ownership"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Sometimes need to model multiple owners of a single value"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Specific types provide this ability",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "Rc"
                                            }),
                                            ": reference-counted"
                                        ]
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "Arc"
                                            }),
                                            ": atomically reference-counted"
                                        ]
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Slightly heavier than a reference, performs runtime checks"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "May be lighter than a \"real\" clone"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Allows cloning the unclonable"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "TODO: x-ref with concurrency"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Using ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "Rc"
                    }),
                    " for shared ownership"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _sharedOwnershipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Disjoint borrows"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _disjointBorrowsDefault.default),
                focusOn: "1+12"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "This works fine"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Disjoint borrows"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _disjointBorrowsRev1Default.default),
                focusOn: "6+15"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "You refactor a bit..."
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Copy-paste error: ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "self.a"
                            }),
                            " in both functions"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _disjointBorrowsRev1Default1.default),
                focusOn: "1+12"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "And bam, error"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Function signatures are the key"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Rust only cares about the function signature"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "When a function is compiled, it's",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "checked against signatures of functions it calls"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "checked against its signature"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "The signature is part of your public API"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Makes reasoning about the code simpler"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Function signatures are the key"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _disjointBorrowsRev2Default.default),
                focusOn: "1+28"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Either owned or borrowed"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _ownedOrBorrowedDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Non-optimal when we don't need to add anything"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Clone-on-write \uD83D\uDC2E"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Holds either a reference or an owned value"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Both types are related"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "When mutation is needed, can \"upgrade\" to an owned value"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Using a ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "Cow"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _cowDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                    href: "https://docs.google.com/forms/d/e/1FAIpQLScun15TX1AqX4wX2Nf02JSk4pqrQhpyXjuzMRl9t2VazmoGuw/viewform?usp=publish-editor",
                    children: "Quiz"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _changeDeckDefault.default), {
                    deck: "overview",
                    children: "Return"
                })
            })
        ]
    });
}
function MDXContent(props = {}) {
    const { wrapper: MDXLayout } = props.components || {};
    return MDXLayout ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(MDXLayout, {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_createMdxContent, {
            ...props
        })
    }) : _createMdxContent(props);
}
function _missingMdxReference(id, component, place) {
    throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it." + (place ? "\nIt\u2019s referenced in your code at `" + place + "`" : ""));
}

},{"react/jsx-runtime":"afIHK","./Directives":"6Yemz","./ChangeDeck":"29Jlq","./layout/Splash":"1mDy7","./layout/Skip":"1ziV3","./TestPattern":"g0BPT","./Transclude":"fUgcm","./ownership.module.css":"bUm4p","rust:ownership/basic":"h1aCV","rust:ownership/borrowing":"5ENR3","url:./assets/ownership/value.svg":"aEJBx","url:./assets/ownership/reference.svg":"91XvI","rust:ownership/borrow-kinds":"9EsaQ","rust:ownership/immutable-while-mutable":"3BUV5","stderr:ownership/immutable-while-mutable":"8zYBY","rust:ownership/method-implicit-borrow":"298Bs","rust:ownership/method-implicit-borrow?rev=1":"kdHuk","rust:ownership/slices":"kbVIo","url:./assets/ownership/vec.svg":"4YYPw","url:./assets/ownership/slice.svg":"cxN72","rust:ownership/string-slices":"3tucs","url:./assets/ownership/string.svg":"iUNNA","url:./assets/ownership/string-slice.svg":"cNaiv","rust:ownership/strings":"17O1j","rust:ownership/deref-coercion":"5049S","rust:ownership/borrow-checker":"kWGpz","stderr:ownership/borrow-checker":"9Xe1w","rust:ownership/move-semantics":"4xy8O","stderr:ownership/move-semantics":"7nkEt","rust:ownership/move-semantics?rev=1":"hSWZv","stderr:ownership/move-semantics?rev=1":"9Ztq0","rust:ownership/copy":"fMv3w","rust:ownership/clone":"3mPLh","rust:ownership/concrete-lifetimes":"lr1Fc","rust:ownership/generic-lifetimes":"kRD7A","rust:ownership/shorter-string":"62o2L","rust:ownership/differing-lifetimes":"eEH8S","rust:ownership/static-lifetime":"grcvD","rust:ownership/unique-lines":"kROSI","rust:ownership/drop-order":"3hAA3","stdout:ownership/drop-order":"jhJgr","rust:ownership/drop-order?rev=1":"eeB3H","stdout:ownership/drop-order?rev=1":"2OjnH","rust:ownership/drop-order?rev=2":"8SDwg","stdout:ownership/drop-order?rev=2":"g4p5H","rust:ownership/shared-ownership":"b4lLN","rust:ownership/disjoint-borrows":"dwXvh","rust:ownership/disjoint-borrows?rev=1":"dKabZ","stderr:ownership/disjoint-borrows?rev=1":"8etZV","rust:ownership/disjoint-borrows?rev=2":"fAChY","rust:ownership/owned-or-borrowed":"2wlK6","rust:ownership/cow":"i33s1","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"bUm4p":[function(require,module,exports,__globalThis) {
var _utilModuleCss = require("./util.module.css");
module.exports["chunkyImage"] = `vmDZ2q_chunkyImage ${_utilModuleCss["-chunkyImage"]}`;

},{"./util.module.css":"lqfZi"}],"h1aCV":[function(require,module,exports,__globalThis) {
module.exports = "fn do_tough_work() {\n    let mut powers = vec![1, 2, 4, 8];\n}\n\nfn main() {}\n";

},{}],"5ENR3":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let knowledge = Wikipedia::download();\n    let a_reference_to_knowledge = &knowledge;\n}\n\nstruct Wikipedia;\nimpl Wikipedia {\n    fn download() {}\n}\n";

},{}],"aEJBx":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("aa1xN");

},{}],"91XvI":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("jKuEM");

},{}],"9EsaQ":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let a_book = String::new();\n    let reader = &a_book;\n\n    let mut a_book = String::new();\n    let author = &mut a_book;\n}\n";

},{}],"3BUV5":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let mut a_book = String::new();\n    let author = &mut a_book;\n    let reader = &a_book;\n    println!(\"{author}, {reader}\");\n}\n";

},{}],"8zYBY":[function(require,module,exports,__globalThis) {
module.exports = "error[E0502]: cannot borrow `a_book` as immutable because it is also borrowed as mutable\n --> immutable-while-mutable/src/main.rs:4:18\n  |\n3 |     let author = &mut a_book;\n  |                  ----------- mutable borrow occurs here\n4 |     let reader = &a_book;\n  |                  ^^^^^^^ immutable borrow occurs here\n5 |     println!(\"{author}, {reader}\");\n  |                ------ mutable borrow later used here\n\nFor more information about this error, try `rustc --explain E0502`.\nerror: could not compile `immutable-while-mutable` (bin \"immutable-while-mutable\") due to 1\n       previous error\n";

},{}],"298Bs":[function(require,module,exports,__globalThis) {
module.exports = "struct Example {\n    score: i32,\n}\n\nimpl Example {\n    fn print(&self) {\n        println!(\"{}\", self.score);\n    }\n}\n\nfn main() {\n    let example = Example { score: 99 };\n    example.print();\n    example.print();\n}\n";

},{}],"kdHuk":[function(require,module,exports,__globalThis) {
module.exports = "struct Example {\n    score: i32,\n}\n\nimpl Example {\n    fn print(&self) {\n        println!(\"{}\", self.score);\n    }\n}\n\nfn main() {\n    let example = Example { score: 99 };\n    Example::print(&example);\n    Example::print(&example);\n}\n";

},{}],"kbVIo":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let scores = vec![1, 2, 3];\n    let some_scores = &scores[1..];\n}\n";

},{}],"4YYPw":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("cq0Nq");

},{}],"cxN72":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("g0vm6");

},{}],"3tucs":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let novel = \"hello, world!\";\n    let chapter_1 = &novel[..5];\n}\n";

},{}],"iUNNA":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("96BXI");

},{}],"cNaiv":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("2mj04");

},{}],"17O1j":[function(require,module,exports,__globalThis) {
module.exports = "fn fake_lisp(s: String) -> String {\n    String::from(\"(\") + &s + \")\"\n}\n\nfn main() {\n    assert_eq!(fake_lisp(String::from(\"first\")), \"(first)\")\n}\n";

},{}],"5049S":[function(require,module,exports,__globalThis) {
module.exports = "fn fake_lisp(s: &str) -> String {\n    String::from(\"(\") + s + \")\"\n}\n\nfn main() {\n    assert_eq!(fake_lisp(\"first\"), \"(first)\");\n    assert_eq!(fake_lisp(&String::from(\"first\")), \"(first)\");\n}\n";

},{}],"kWGpz":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let a_reference_to_the_book = {\n        let a_book = String::new();\n        &a_book\n    };\n}\n";

},{}],"9Xe1w":[function(require,module,exports,__globalThis) {
module.exports = "error[E0597]: `a_book` does not live long enough\n --> borrow-checker/src/main.rs:4:9\n  |\n2 |     let a_reference_to_the_book = {\n  |         ----------------------- borrow later stored here\n3 |         let a_book = String::new();\n  |             ------ binding `a_book` declared here\n4 |         &a_book\n  |         ^^^^^^^ borrowed value does not live long enough\n5 |     };\n  |     - `a_book` dropped here while still borrowed\n\nFor more information about this error, try `rustc --explain E0597`.\nerror: could not compile `borrow-checker` (bin \"borrow-checker\") due to 1 previous error\n";

},{}],"4xy8O":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let a_book = String::new();\n    let a_moved_book = a_book;\n    let what_is_this = a_book;\n}\n";

},{}],"7nkEt":[function(require,module,exports,__globalThis) {
module.exports = "error[E0382]: use of moved value: `a_book`\n --> move-semantics/src/main.rs:5:24\n  |\n3 |     let a_book = String::new();\n  |         ------ move occurs because `a_book` has type `String`, which does not implement\n  |                the `Copy` trait\n4 |     let a_moved_book = a_book;\n  |                        ------ value moved here\n5 |     let what_is_this = a_book;\n  |                        ^^^^^^ value used here after move\n  |\nhelp: consider cloning the value if the performance cost is acceptable\n  |\n4 |     let a_moved_book = a_book.clone();\n  |                              ++++++++\n\nFor more information about this error, try `rustc --explain E0382`.\nerror: could not compile `move-semantics` (bin \"move-semantics\") due to 1 previous error\n";

},{}],"hSWZv":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let a_book = String::new();\n    let ref_to_the_book = &a_book;\n    let a_moved_book = a_book;\n    println!(\"{ref_to_the_book}\");\n}\n";

},{}],"9Ztq0":[function(require,module,exports,__globalThis) {
module.exports = "error[E0505]: cannot move out of `a_book` because it is borrowed\n  --> move-semantics/src/main.rs:12:24\n   |\n10 |     let a_book = String::new();\n   |         ------ binding `a_book` declared here\n11 |     let ref_to_the_book = &a_book;\n   |                           ------- borrow of `a_book` occurs here\n12 |     let a_moved_book = a_book;\n   |                        ^^^^^^ move out of `a_book` occurs here\n13 |     println!(\"{ref_to_the_book}\");\n   |                --------------- borrow later used here\n   |\nhelp: consider cloning the value if the performance cost is acceptable\n   |\n11 |     let ref_to_the_book = &a_book.clone();\n   |                                  ++++++++\n\nFor more information about this error, try `rustc --explain E0505`.\nerror: could not compile `move-semantics` (bin \"move-semantics\") due to 1 previous error\n";

},{}],"fMv3w":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let a = 42;\n    let b = a;\n    println!(\"{a}\");\n}\n";

},{}],"3mPLh":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let a_book = String::new();\n    let a_moved_book = a_book.clone();\n    let what_is_this = a_book;\n}\n";

},{}],"lr1Fc":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let val_1 = String::new(); // 1\n    println!(\"{val_1}\");       // |\n    let val_2 = val_1;         // X (moved)     2\n    println!(\"{val_2}\");       //               |\n}                              //               X (out of scope)\n";

},{}],"kRD7A":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    fn a_chapter_of_the_book<'a>(book: &'a str) -> &'a str {\n        &book[100..]\n    }\n\n    let an_entire_book = String::new();\n    let a_chapter = a_chapter_of_the_book(&an_entire_book);\n}\n";

},{}],"62o2L":[function(require,module,exports,__globalThis) {
module.exports = "fn shorter<'a>(a: &'a str, b: &'a str) -> &'a str {\n    if a.len() < b.len() {\n        a\n    } else {\n        b\n    }\n}\n\nfn main() {\n    assert_eq!(\"a\", shorter(\"a\", \"bb\"));\n}\n";

},{}],"eEH8S":[function(require,module,exports,__globalThis) {
module.exports = "fn shorter<'a>(a: &'a str, b: &'a str) -> &'a str { todo!() }\n\nfn main() {\n    let outer = String::from(\"outer\");            // O\n    {                                             // |\n        let inner = String::from(\"inner\");        // |   I\n        {                                         // |   |\n            let result = shorter(&outer, &inner); // |   |\n        }                                         // |   |\n    }                                             // |   X\n}                                                 // X\n";

},{}],"grcvD":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let name: &'static str = \"Hello, world!\";\n    let age: &'static u8 = &42;\n\n    static VERSION_NUMBER: [u8; 3] = [1, 0, 0];\n    let version: &'static [u8] = &VERSION_NUMBER;\n\n    const LOOKUP_TABLE: [bool; 3] = [true, false, true];\n    let table: &'static [bool] = &LOOKUP_TABLE;\n}\n\nfn age_expansion() {\n    static GENERATED_BY_COMPILER: u8 = 42;\n    let age: &'static u8 = &GENERATED_BY_COMPILER;\n}\n";

},{}],"kROSI":[function(require,module,exports,__globalThis) {
module.exports = "use std::{collections::HashMap, fs};\n\nfn counts(path: &str) -> HashMap<String, usize> {\n    let s = fs::read_to_string(path).expect(\"Couldn't read file\");\n    let mut counts = HashMap::new();\n\n    for line in s.lines() {\n        for word in line.split_whitespace() {\n            *counts.entry(word.to_string()).or_insert(0) += 1;\n        }\n    }\n\n    counts\n}\n\nfn main() {\n    let map = counts(\"src/main.rs\");\n    println!(\"{map:?}\");\n}\n";

},{}],"3hAA3":[function(require,module,exports,__globalThis) {
module.exports = "struct Count(i32);\n\nimpl Drop for Count {\n    fn drop(&mut self) {\n        println!(\"Dropping count of: {}\", self.0)\n    }\n}\n\nfn main() {\n    Count(1);\n    Count(99);\n}\n";

},{}],"jhJgr":[function(require,module,exports,__globalThis) {
module.exports = "Dropping count of: 1\nDropping count of: 99\n";

},{}],"eeB3H":[function(require,module,exports,__globalThis) {
module.exports = "struct Count(i32);\n\nimpl Drop for Count {\n    fn drop(&mut self) {\n        println!(\"Dropping count of: {}\", self.0)\n    }\n}\n\nfn main() {\n    let a = Count(1);\n    let b = Count(99);\n}\n";

},{}],"2OjnH":[function(require,module,exports,__globalThis) {
module.exports = "Dropping count of: 99\nDropping count of: 1\n";

},{}],"8SDwg":[function(require,module,exports,__globalThis) {
module.exports = "struct Count(i32);\n\nimpl Drop for Count {\n    fn drop(&mut self) {\n        println!(\"Dropping count of: {}\", self.0)\n    }\n}\n\nfn main() {\n    let a;\n    let b;\n    b = Count(99);\n    a = Count(1);\n}\n";

},{}],"g4p5H":[function(require,module,exports,__globalThis) {
module.exports = "Dropping count of: 99\nDropping count of: 1\n";

},{}],"b4lLN":[function(require,module,exports,__globalThis) {
module.exports = "use std::rc::Rc;\n\nstruct CannotClone;\n\nfn main() {\n    let value = Rc::new(CannotClone);\n    let another_reference = value.clone();\n}\n";

},{}],"dwXvh":[function(require,module,exports,__globalThis) {
module.exports = "struct Thing {\n    a: i32,\n    b: i32,\n}\n\nimpl Thing {\n    fn get_both(&mut self) -> (&mut i32, &mut i32) {\n        let a = &mut self.a;\n        let b = &mut self.b;\n        (a, b)\n    }\n}\n\nfn main() {}\n";

},{}],"dKabZ":[function(require,module,exports,__globalThis) {
module.exports = "struct Thing {\n    a: i32,\n    b: i32,\n}\n\nimpl Thing {\n    fn get_mut_a(&mut self) -> &mut i32 {\n        &mut self.a\n    }\n\n    fn get_mut_b(&mut self) -> &mut i32 {\n        &mut self.a\n    }\n\n    fn get_both(&mut self) -> (&mut i32, &mut i32) {\n        let a = self.get_mut_a();\n        let b = self.get_mut_b();\n        (a, b)\n    }\n}\n\nfn main() {}\n";

},{}],"8etZV":[function(require,module,exports,__globalThis) {
module.exports = "error[E0499]: cannot borrow `*self` as mutable more than once at a time\n  --> disjoint-borrows/src/main.rs:28:17\n   |\n26 |     fn get_both(&mut self) -> (&mut i32, &mut i32) {\n   |                 - let's call the lifetime of this reference `'1`\n27 |         let a = self.get_mut_a();\n   |                 ---- first mutable borrow occurs here\n28 |         let b = self.get_mut_b();\n   |                 ^^^^ second mutable borrow occurs here\n29 |         (a, b)\n   |         ------ returning this value requires that `*self` is borrowed for `'1`\n\nFor more information about this error, try `rustc --explain E0499`.\nerror: could not compile `disjoint-borrows` (bin \"disjoint-borrows\") due to 1 previous error\n";

},{}],"fAChY":[function(require,module,exports,__globalThis) {
module.exports = "struct Inner(i32);\n\nimpl Inner {\n    fn get(&mut self) -> &mut i32 {\n        &mut self.0\n    }\n}\n\nstruct Thing {\n    a: Inner,\n    b: Inner,\n}\n\nimpl Thing {\n    fn get_mut_a(&mut self) -> &mut i32 {\n        self.a.get()\n    }\n\n    fn get_mut_b(&mut self) -> &mut i32 {\n        self.b.get()\n    }\n\n    fn get_both(&mut self) -> (&mut i32, &mut i32) {\n        let a = self.a.get();\n        let b = self.b.get();\n        (a, b)\n    }\n}\n\nfn main() {}\n";

},{}],"2wlK6":[function(require,module,exports,__globalThis) {
module.exports = "fn add_suffix_if_missing(name: &str) -> String {\n    if !name.ends_with(\"Jr\") {\n        format!(\"{name} Jr\")\n    } else {\n        name.to_string()\n    }\n}\n\nfn main() {\n    assert_eq!(\"Bill Jr\", add_suffix_if_missing(\"Bill\"));\n    assert_eq!(\"Bill Jr\", add_suffix_if_missing(\"Bill Jr\"));\n}\n";

},{}],"i33s1":[function(require,module,exports,__globalThis) {
module.exports = "use std::borrow::Cow;\n\nfn add_suffix_if_missing(name: &str) -> Cow<'_, str> {\n    let mut name = Cow::from(name);\n    if !name.ends_with(\"Jr\") {\n        name.to_mut().push_str(\" Jr\");\n    }\n    name\n}\n\nfn main() {\n    assert_eq!(\"Bill Jr\", add_suffix_if_missing(\"Bill\"));\n    assert_eq!(\"Bill Jr\", add_suffix_if_missing(\"Bill Jr\"));\n}\n";

},{}],"kfwT8":[function(require,module,exports,__globalThis) {
/*@jsxRuntime automatic*/ /*@jsxImportSource react*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "title", ()=>title);
parcelHelpers.export(exports, "default", ()=>MDXContent);
var _jsxRuntime = require("react/jsx-runtime");
var _directives = require("./Directives");
var _changeDeck = require("./ChangeDeck");
var _changeDeckDefault = parcelHelpers.interopDefault(_changeDeck);
var _splash = require("./layout/Splash");
var _splashDefault = parcelHelpers.interopDefault(_splash);
var _testPattern = require("./TestPattern");
var _testPatternDefault = parcelHelpers.interopDefault(_testPattern);
var _transclude = require("./Transclude");
var _transcludeDefault = parcelHelpers.interopDefault(_transclude);
var _useOption = require("rust:option-and-result/use-option");
var _useOptionDefault = parcelHelpers.interopDefault(_useOption);
var _useOptionRev1 = require("rust:option-and-result/use-option?rev=1");
var _useOptionRev1Default = parcelHelpers.interopDefault(_useOptionRev1);
var _useOptionRev11 = require("stderr:option-and-result/use-option?rev=1");
var _useOptionRev1Default1 = parcelHelpers.interopDefault(_useOptionRev11);
var _useOptionRev2 = require("rust:option-and-result/use-option?rev=2");
var _useOptionRev2Default = parcelHelpers.interopDefault(_useOptionRev2);
var _useOptionRev3 = require("rust:option-and-result/use-option?rev=3");
var _useOptionRev3Default = parcelHelpers.interopDefault(_useOptionRev3);
var _useResult = require("rust:option-and-result/use-result");
var _useResultDefault = parcelHelpers.interopDefault(_useResult);
var _useResultRev1 = require("rust:option-and-result/use-result?rev=1");
var _useResultRev1Default = parcelHelpers.interopDefault(_useResultRev1);
var _useResultRev2 = require("rust:option-and-result/use-result?rev=2");
var _useResultRev2Default = parcelHelpers.interopDefault(_useResultRev2);
var _propagate = require("rust:option-and-result/propagate");
var _propagateDefault = parcelHelpers.interopDefault(_propagate);
var _exerciseCreateAndPropagate = require("rust:option-and-result/exercise-create-and-propagate");
var _exerciseCreateAndPropagateDefault = parcelHelpers.interopDefault(_exerciseCreateAndPropagate);
var _patternUnwrap = require("rust:option-and-result/pattern-unwrap");
var _patternUnwrapDefault = parcelHelpers.interopDefault(_patternUnwrap);
var _patternUnwrapRev1 = require("rust:option-and-result/pattern-unwrap?rev=1");
var _patternUnwrapRev1Default = parcelHelpers.interopDefault(_patternUnwrapRev1);
var _patternDefault = require("rust:option-and-result/pattern-default");
var _patternDefaultDefault = parcelHelpers.interopDefault(_patternDefault);
var _patternDefaultRev1 = require("rust:option-and-result/pattern-default?rev=1");
var _patternDefaultRev1Default = parcelHelpers.interopDefault(_patternDefaultRev1);
var _patternDefaultLazy = require("rust:option-and-result/pattern-default-lazy");
var _patternDefaultLazyDefault = parcelHelpers.interopDefault(_patternDefaultLazy);
var _patternDefaultLazy1 = require("stdout:option-and-result/pattern-default-lazy");
var _patternDefaultLazyDefault1 = parcelHelpers.interopDefault(_patternDefaultLazy1);
var _patternDefaultLazyRev1 = require("rust:option-and-result/pattern-default-lazy?rev=1");
var _patternDefaultLazyRev1Default = parcelHelpers.interopDefault(_patternDefaultLazyRev1);
var _patternDefaultLazyRev11 = require("stdout:option-and-result/pattern-default-lazy?rev=1");
var _patternDefaultLazyRev1Default1 = parcelHelpers.interopDefault(_patternDefaultLazyRev11);
var _patternDefaultReference = require("rust:option-and-result/pattern-default-reference");
var _patternDefaultReferenceDefault = parcelHelpers.interopDefault(_patternDefaultReference);
var _patternDefaultReferenceRev1 = require("rust:option-and-result/pattern-default-reference?rev=1");
var _patternDefaultReferenceRev1Default = parcelHelpers.interopDefault(_patternDefaultReferenceRev1);
var _patternDefaultReferenceRev11 = require("stderr:option-and-result/pattern-default-reference?rev=1");
var _patternDefaultReferenceRev1Default1 = parcelHelpers.interopDefault(_patternDefaultReferenceRev11);
var _patternDefaultReferenceRev2 = require("rust:option-and-result/pattern-default-reference?rev=2");
var _patternDefaultReferenceRev2Default = parcelHelpers.interopDefault(_patternDefaultReferenceRev2);
var _patternMap = require("rust:option-and-result/pattern-map");
var _patternMapDefault = parcelHelpers.interopDefault(_patternMap);
var _patternMapRev1 = require("rust:option-and-result/pattern-map?rev=1");
var _patternMapRev1Default = parcelHelpers.interopDefault(_patternMapRev1);
var _patternMapRev2 = require("rust:option-and-result/pattern-map?rev=2");
var _patternMapRev2Default = parcelHelpers.interopDefault(_patternMapRev2);
var _patternResultToOption = require("rust:option-and-result/pattern-result-to-option");
var _patternResultToOptionDefault = parcelHelpers.interopDefault(_patternResultToOption);
var _patternResultToOptionRev1 = require("rust:option-and-result/pattern-result-to-option?rev=1");
var _patternResultToOptionRev1Default = parcelHelpers.interopDefault(_patternResultToOptionRev1);
var _patternOptionToResult = require("rust:option-and-result/pattern-option-to-result");
var _patternOptionToResultDefault = parcelHelpers.interopDefault(_patternOptionToResult);
var _patternOptionToResultRev1 = require("rust:option-and-result/pattern-option-to-result?rev=1");
var _patternOptionToResultRev1Default = parcelHelpers.interopDefault(_patternOptionToResultRev1);
var _exerciseEnvVar = require("rust:option-and-result/exercise-env-var");
var _exerciseEnvVarDefault = parcelHelpers.interopDefault(_exerciseEnvVar);
var _exerciseEnvVarRev1 = require("rust:option-and-result/exercise-env-var?rev=1");
var _exerciseEnvVarRev1Default = parcelHelpers.interopDefault(_exerciseEnvVarRev1);
const title = "Option and Result";
function _createMdxContent(props) {
    const _components = {
        a: "a",
        code: "code",
        h1: "h1",
        h2: "h2",
        hr: "hr",
        li: "li",
        p: "p",
        pre: "pre",
        ul: "ul",
        ...props.components
    }, { SplitSlides } = _components;
    if (!SplitSlides) _missingMdxReference("SplitSlides", true);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SplitSlides, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _testPatternDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "Option"
                    }),
                    " and ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "Result"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Optional values"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.p, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                        children: "Option"
                                    }),
                                    " is an enum"
                                ]
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                    className: "language-rust",
                                    children: "enum Option<T> {\n    Some(T),\n    None,\n}\n"
                                })
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Generic type for presence case"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "So prevalent that ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Some"
                            }),
                            " and ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "None"
                            }),
                            " are imported by default"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "This is why Rust does not have ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "NULL"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Constructing an ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "Option"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _useOptionDefault.default),
                focusOn: "1+7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Constructing an ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "Option"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _useOptionRev1Default.default),
                focusOn: "1+7",
                emphasize: "1[34+7],1[53+1],3[13+5],3[24+1],4[13+5],4[23+1],5[13+4]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Not obviously better than a ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "NULL"
                            }),
                            ", yet."
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Using an ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "Option"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _useOptionRev1Default.default),
                focusOn: "9+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _useOptionRev1Default1.default),
                focusOn: "1+12"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Option<T>"
                            }),
                            " is a different type from ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "T"
                            }),
                            " with different methods"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Prevented from accessing the inner type without checking"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Using an ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "Option"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Do something in both cases"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _useOptionRev2Default.default),
                focusOn: "9+6"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Do something in one case"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _useOptionRev3Default.default),
                focusOn: "9+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Success or failure values"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.p, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                        children: "Result"
                                    }),
                                    " is an enum"
                                ]
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                    className: "language-rust",
                                    children: "enum Result<T, E> {\n    Ok(T),\n    Err(E),\n}\n"
                                })
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Generic types for success and failure cases"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "So prevalent that ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Ok"
                            }),
                            " and ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Err"
                            }),
                            " are imported by default"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Constructing a ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "Result"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _useResultDefault.default),
                focusOn: "1+11"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Constructing a ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "Result"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _useResultRev1Default.default),
                focusOn: "1+11",
                emphasize: "1[54+7],1[64+15],3,7,10[4+3],10[16+1]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Using a ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "Result"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Do something in both cases"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _useResultRev1Default.default),
                focusOn: "13+6"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Do something in one case"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _useResultRev2Default.default),
                focusOn: "13+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Propagating errors"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.p, {
                children: [
                    "The ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "?"
                    }),
                    " operator is syntax sugar for getting the success value or returning."
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "Option"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _propagateDefault.default),
                focusOn: "1+6"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "Result"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _propagateDefault.default),
                focusOn: "8+6"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Exercise: Error creation and propagation"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Write a function that adds two ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "i32"
                            }),
                            " values"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "If either of the values are greater than ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "10"
                            }),
                            ", return an error"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "If the sum is greater than ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "15"
                            }),
                            ", return an error"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Call the function from main and print a successful result"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Hints"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Write a helper function for the repeated logic and use ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "?"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Use ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "()"
                            }),
                            " as your",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "error type: ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "Result<\u2026, ()>"
                                            })
                                        ]
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "error value: ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "Err(())"
                                            })
                                        ]
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One answer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _exerciseCreateAndPropagateDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Why don't we use ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "Result"
                    }),
                    " with a dummy error value?"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Semantics"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Option"
                            }),
                            " is the presence of data"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Result"
                            }),
                            " is only the outcome of an action"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Option"
                            }),
                            " can also be the outcome"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "Option"
                    }),
                    " vs ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "Result"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "Option"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Field or function argument"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Retrieving values from collections"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "\"Null\" pointers"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "Result"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Return value of a function"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Annotated such that they must be used"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Common patterns"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Option"
                            }),
                            " and ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Result"
                            }),
                            " are pervasive"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Patterns emerge and are added to the standard library"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Require successful values"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _patternUnwrapDefault.default),
                focusOn: "1+6"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Haven't talked about ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "panic!"
                            }),
                            ", yet; it stops execution"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Taking an ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Option"
                            }),
                            " and unwrapping it like this is probably an antipattern"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h2, {
                children: [
                    "Use ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "expect"
                    }),
                    " or ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "unwrap"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _patternUnwrapRev1Default.default),
                focusOn: "1+4"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Same methods exist on ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Result"
                            }),
                            ", will print the error value"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "unwrap"
                            }),
                            " is the same, but doesn't take a string"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Note that we shadow the variable name"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Get the value or default"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _patternDefaultDefault.default),
                focusOn: "1+7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h2, {
                children: [
                    "Use ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "unwrap_or"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _patternDefaultRev1Default.default),
                focusOn: "1+4"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Same method exists on ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Option"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Side note: Lazy evaluation"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _patternDefaultLazyDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-output",
                src: (0, _patternDefaultLazyDefault1.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Lazy variants"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h2, {
                children: [
                    "Use ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "unwrap_or_else"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _patternDefaultLazyRev1Default.default),
                focusOn: "1+7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-output",
                src: (0, _patternDefaultLazyRev1Default1.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "You will see ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "_else"
                            }),
                            " / ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "_then"
                            }),
                            " / ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "_with"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "These suffixes are common patterns in Rust"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Side note: References"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _patternDefaultReferenceDefault.default),
                focusOn: "1+8"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _patternDefaultReferenceRev1Default.default),
                focusOn: "1+7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _patternDefaultReferenceRev1Default1.default),
                focusOn: "1+8"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Many methods consume the ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "Option"
                    }),
                    " or ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "Result"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.p, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "unwrap_or"
                    }),
                    " takes ownership of ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "self"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _patternDefaultReferenceRev1Default1.default),
                focusOn: "10+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.p, {
                children: [
                    "We don't have ownership of the ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "Option"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _patternDefaultReferenceRev1Default.default),
                focusOn: "3",
                emphasize: "1[32+1]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Converting references to values to values of references"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h2, {
                children: [
                    "Use ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "as_ref"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _patternDefaultReferenceRev1Default1.default),
                focusOn: "23+8"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _patternDefaultReferenceRev2Default.default),
                focusOn: "3+4",
                emphasize: "2[21+9],2[41+1]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "We also changed this to have a reference to a literal ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Score"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "You may also be able to clone the ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Option"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Converting success values to different types"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _patternMapDefault.default),
                focusOn: "1+6"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h2, {
                children: [
                    "Use ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "map"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _patternMapRev1Default.default),
                focusOn: "1+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h2, {
                children: [
                    "Or ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "?"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _patternMapRev2Default.default),
                focusOn: "1+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Converting from ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "Result"
                    }),
                    " to ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "Option"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _patternResultToOptionDefault.default),
                focusOn: "1+6"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h2, {
                children: [
                    "Use ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "ok"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _patternResultToOptionRev1Default.default),
                focusOn: "1+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Converting from ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "Option"
                    }),
                    " to ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "Result"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _patternOptionToResultDefault.default),
                focusOn: "1+6"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h2, {
                children: [
                    "Use ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "ok_or"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _patternOptionToResultRev1Default.default),
                focusOn: "1+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "There is also ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "ok_or_else"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Exercise: Parsing environment variables with fallback"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "std::env::var"
                            }),
                            " gets an environment variable or an error"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "If environment variable ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "PORT_NEW"
                            }),
                            " is set, use it, otherwise use ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "PORT_OLD"
                            }),
                            "."
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Parse the string to a number.",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "If it's not set or unable to be parsed, use ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "8080"
                                            }),
                                            " as a default."
                                        ]
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Bonus"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Use ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "match"
                            }),
                            " instead of combinators (or vice versa)"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One answer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _exerciseEnvVarDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Another answer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _exerciseEnvVarRev1Default.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "There's more!"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "\"memorize\" what's available"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.a, {
                            href: "https://doc.rust-lang.org/std/option/enum.Option.html",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                    children: "Option"
                                }),
                                " docs"
                            ]
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.a, {
                            href: "https://doc.rust-lang.org/std/result/enum.Result.html",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                    children: "Result"
                                }),
                                " docs"
                            ]
                        })
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "... just monoids in the category of endofunctors"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "You'll see these patterns across a number of different types",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "Option"
                                            }),
                                            " / ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "Result"
                                            })
                                        ]
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                            children: "Iterator"
                                        })
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "Future"
                                            }),
                                            " / ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "Stream"
                                            })
                                        ]
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                    href: "https://docs.google.com/forms/d/e/1FAIpQLSet7-plfNXe53FNERMpNmig78XUu3eEQt3cRdWmtUjo5Y0Zow/viewform?usp=publish-editor",
                    children: "Quiz"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _changeDeckDefault.default), {
                    deck: "overview",
                    children: "Return"
                })
            })
        ]
    });
}
function MDXContent(props = {}) {
    const { wrapper: MDXLayout } = props.components || {};
    return MDXLayout ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(MDXLayout, {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_createMdxContent, {
            ...props
        })
    }) : _createMdxContent(props);
}
function _missingMdxReference(id, component, place) {
    throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it." + (place ? "\nIt\u2019s referenced in your code at `" + place + "`" : ""));
}

},{"react/jsx-runtime":"afIHK","./Directives":"6Yemz","./ChangeDeck":"29Jlq","./layout/Splash":"1mDy7","./TestPattern":"g0BPT","./Transclude":"fUgcm","rust:option-and-result/use-option":"3hEPl","rust:option-and-result/use-option?rev=1":"354Z4","stderr:option-and-result/use-option?rev=1":"daQzg","rust:option-and-result/use-option?rev=2":"cu1Wh","rust:option-and-result/use-option?rev=3":"5BzdR","rust:option-and-result/use-result":"k6YNn","rust:option-and-result/use-result?rev=1":"3QHrW","rust:option-and-result/use-result?rev=2":"lnsf1","rust:option-and-result/propagate":"1EJTE","rust:option-and-result/exercise-create-and-propagate":"50Fpu","rust:option-and-result/pattern-unwrap":"4XL2U","rust:option-and-result/pattern-unwrap?rev=1":"2r0sK","rust:option-and-result/pattern-default":"gLkb0","rust:option-and-result/pattern-default?rev=1":"5Xyxn","rust:option-and-result/pattern-default-lazy":"6gq8u","stdout:option-and-result/pattern-default-lazy":"l0Shd","rust:option-and-result/pattern-default-lazy?rev=1":"cpGE2","stdout:option-and-result/pattern-default-lazy?rev=1":"cAS4j","rust:option-and-result/pattern-default-reference":"1ZijL","rust:option-and-result/pattern-default-reference?rev=1":"6qleC","stderr:option-and-result/pattern-default-reference?rev=1":"fUGcU","rust:option-and-result/pattern-default-reference?rev=2":"jDGcg","rust:option-and-result/pattern-map":"hxgV9","rust:option-and-result/pattern-map?rev=1":"iXlbC","rust:option-and-result/pattern-map?rev=2":"b66As","rust:option-and-result/pattern-result-to-option":"3wC4S","rust:option-and-result/pattern-result-to-option?rev=1":"gkUNe","rust:option-and-result/pattern-option-to-result":"cQHKV","rust:option-and-result/pattern-option-to-result?rev=1":"5J5Zo","rust:option-and-result/exercise-env-var":"8Jikd","rust:option-and-result/exercise-env-var?rev=1":"aS0g1","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"3hEPl":[function(require,module,exports,__globalThis) {
module.exports = "fn word_for_zero_or_one(v: u8) -> &'static str {\n    match v {\n        0 => \"zero\",\n        1 => \"one\",\n        _ => todo!(\"What goes here?\"),\n    }\n}\n\nfn main() {\n    println!(\"The word is {}\", word_for_zero_or_one(42));\n}\n";

},{}],"354Z4":[function(require,module,exports,__globalThis) {
module.exports = "fn word_for_zero_or_one(v: u8) -> Option<&'static str> {\n    match v {\n        0 => Some(\"zero\"),\n        1 => Some(\"one\"),\n        _ => None,\n    }\n}\n\nfn main() {\n    println!(\"The word is {}\", word_for_zero_or_one(42));\n}\n";

},{}],"daQzg":[function(require,module,exports,__globalThis) {
module.exports = "error[E0277]: `Option<&str>` doesn't implement `std::fmt::Display`\n  --> use-option/src/main.rs:21:32\n   |\n21 |     println!(\"The word is {}\", word_for_zero_or_one(42));\n   |                           --   ^^^^^^^^^^^^^^^^^^^^^^^^ `Option<&str>` cannot be\n   |                           |                             formatted with the default\n   |                           |                             formatter\n   |                           |\n   |                           required by this formatting parameter\n   |\n   = help: the trait `std::fmt::Display` is not implemented for `Option<&str>`\n   = note: in format strings you may be able to use `{:?}` (or {:#?} for pretty-print) instead\n\nFor more information about this error, try `rustc --explain E0277`.\nerror: could not compile `use-option` (bin \"use-option\") due to 1 previous error\n";

},{}],"cu1Wh":[function(require,module,exports,__globalThis) {
module.exports = "fn word_for_zero_or_one(v: u8) -> Option<&'static str> {\n    match v {\n        0 => Some(\"zero\"),\n        1 => Some(\"one\"),\n        _ => None,\n    }\n}\n\nfn main() {\n    match word_for_zero_or_one(42) {\n        Some(word) => println!(\"The word is {word}\"),\n        None => println!(\"This word is unknown\"),\n    }\n}\n";

},{}],"5BzdR":[function(require,module,exports,__globalThis) {
module.exports = "fn word_for_zero_or_one(v: u8) -> Option<&'static str> {\n    match v {\n        0 => Some(\"zero\"),\n        1 => Some(\"one\"),\n        _ => None,\n    }\n}\n\nfn main() {\n    if let Some(word) = word_for_zero_or_one(42) {\n        println!(\"The word is {word}\");\n    }\n}\n";

},{}],"k6YNn":[function(require,module,exports,__globalThis) {
module.exports = "fn account_balance(username: &str, password: &str) -> u32 {\n    if username != \"admin\" {\n        todo!(\"What goes here?\");\n    }\n\n    if password != \"baseball\" {\n        todo!(\"What goes here?\");\n    }\n\n    1_000_000\n}\n\nfn main() {}\n";

},{}],"3QHrW":[function(require,module,exports,__globalThis) {
module.exports = "fn account_balance(username: &str, password: &str) -> Result<u32, &'static str> {\n    if username != \"admin\" {\n        return Err(\"Unknown username\");\n    }\n\n    if password != \"baseball\" {\n        return Err(\"Invalid password\");\n    }\n\n    Ok(1_000_000)\n}\n\nfn main() {\n    match account_balance(\"vivian\", \"hackerman\") {\n        Ok(balance) => println!(\"I'm going to steal {balance} bitcoin\"),\n        Err(why) => println!(\"Access denied: {why}\"),\n    }\n}\n";

},{}],"lnsf1":[function(require,module,exports,__globalThis) {
module.exports = "fn account_balance(username: &str, password: &str) -> Result<u32, &'static str> {\n    if username != \"admin\" {\n        return Err(\"Unknown username\");\n    }\n\n    if password != \"baseball\" {\n        return Err(\"Invalid password\");\n    }\n\n    Ok(1_000_000)\n}\n\nfn main() {\n    if let Ok(balance) = account_balance(\"vivian\", \"hackerman\") {\n        println!(\"I'm going to steal {balance} bitcoin\");\n    }\n}\n";

},{}],"1EJTE":[function(require,module,exports,__globalThis) {
module.exports = "fn may_be_missing() -> Option<i32> { todo!() }\n\nfn calls_may_be_missing() -> Option<i32> {\n    let val = may_be_missing()?;\n    Some(val * 2)\n}\n\nfn may_error() -> Result<i32, bool> { todo!() }\n\nfn calls_may_error() -> Result<i32, bool> {\n    let val = may_error()?;\n    Ok(val * 2)\n}\n\nfn main() {}\n";

},{}],"50Fpu":[function(require,module,exports,__globalThis) {
module.exports = "fn acceptable_number(n: i32, max: i32) -> Result<i32, ()> {\n    if n > max {\n        Err(())\n    } else {\n        Ok(n)\n    }\n}\n\nfn strange_adder(a: i32, b: i32) -> Result<i32, ()> {\n    let sum = acceptable_number(a, 10)? + acceptable_number(b, 10)?;\n    acceptable_number(sum, 15)\n}\n\nfn main() {\n    if let Ok(v) = strange_adder(10, 10) {\n        println!(\"The value was {v}\");\n    }\n}\n";

},{}],"4XL2U":[function(require,module,exports,__globalThis) {
module.exports = "fn must_have_name(name: Option<String>) {\n    match name {\n        Some(name) => println!(\"Hello, {name}!\"),\n        None => panic!(\"We need a name!\"),\n    }\n}\n\nfn main() {}\n";

},{}],"2r0sK":[function(require,module,exports,__globalThis) {
module.exports = "fn must_have_name(name: Option<String>) {\n    let name = name.expect(\"We need a name!\");\n    println!(\"Hello, {name}!\");\n}\n\nfn main() {}\n";

},{}],"gLkb0":[function(require,module,exports,__globalThis) {
module.exports = "fn enable_light(value: Result<bool, String>) {\n    let value = match value {\n        Ok(on) => on,\n        Err(_) => false,\n    };\n    println!(\"Turning the light {}\", if value { \"on\" } else { \"off\" });\n}\n\nfn main() {}\n";

},{}],"5Xyxn":[function(require,module,exports,__globalThis) {
module.exports = "fn enable_light(value: Result<bool, String>) {\n    let value = value.unwrap_or(false);\n    println!(\"Turning the light {}\", if value { \"on\" } else { \"off\" });\n}\n\nfn main() {}\n";

},{}],"6gq8u":[function(require,module,exports,__globalThis) {
module.exports = "fn enable_light(value: Result<bool, String>) {\n    let value = value.unwrap_or({\n        println!(\"Calculating the default...\");\n        false\n    });\n    println!(\"Turning the light {}\", if value { \"on\" } else { \"off\" });\n}\n\nfn main() {\n    enable_light(Ok(true));\n}\n";

},{}],"l0Shd":[function(require,module,exports,__globalThis) {
module.exports = "Calculating the default...\nTurning the light on\n";

},{}],"cpGE2":[function(require,module,exports,__globalThis) {
module.exports = "fn enable_light(value: Result<bool, String>) {\n    let value = value.unwrap_or_else(|_| {\n        println!(\"Calculating the default...\");\n        false\n    });\n    println!(\"Turning the light {}\", if value { \"on\" } else { \"off\" });\n}\n\nfn main() {\n    enable_light(Ok(true));\n}\n";

},{}],"cAS4j":[function(require,module,exports,__globalThis) {
module.exports = "Turning the light on\n";

},{}],"1ZijL":[function(require,module,exports,__globalThis) {
module.exports = "struct Score(u16);\n\nfn award_bonus_multiball(score: &Option<Score>) -> bool {\n    match score {\n        Some(score) => score.0 % 100 == 0,\n        None => true,\n    }\n}\n\nfn main() {}\n";

},{}],"6qleC":[function(require,module,exports,__globalThis) {
module.exports = "struct Score(u16);\n\nfn award_bonus_multiball(score: &Option<Score>) -> bool {\n    let score = score.unwrap_or(Score(0));\n    score.0 % 100 == 0\n}\n\nfn main() {}\n";

},{}],"fUGcU":[function(require,module,exports,__globalThis) {
module.exports = "error[E0507]: cannot move out of `*score` which is behind a shared reference\n    --> pattern-default-reference/src/main.rs:13:17\n     |\n  13 |     let score = score.unwrap_or(Score(0));\n     |                 ^^^^^ ------------------- `*score` moved due to this method call\n     |                 |\n     |                 move occurs because `*score` has type `Option<Score>`, which does not\n     |                 implement the `Copy` trait\n     |\nnote: `Option::<T>::unwrap_or` takes ownership of the receiver `self`, which moves `*score`\n    --> core/src/option.rs:1035:28\n     |\n1035 |     pub const fn unwrap_or(self, default: T) -> T\n     |                            ^^^^\nnote: if `Score` implemented `Clone`, you could clone the value\n    --> pattern-default-reference/src/main.rs:1:1\n     |\n   1 | struct Score(u16);\n     | ^^^^^^^^^^^^ consider implementing `Clone` for this type\n...\n  13 |     let score = score.unwrap_or(Score(0));\n     |                 ----- you could clone this value\nhelp: consider calling `.as_ref()` to borrow the value's contents\n     |\n  13 |     let score = score.as_ref().unwrap_or(Score(0));\n     |                      +++++++++\nhelp: consider calling `.as_mut()` to mutably borrow the value's contents\n     |\n  13 |     let score = score.as_mut().unwrap_or(Score(0));\n     |                      +++++++++\nhelp: you could `clone` the value and consume it, if the `Score: Clone` trait bound could be\n     |satisfied\n     |\n  13 |     let score = <Option<Score> as Clone>::clone(&score).unwrap_or(Score(0));\n     |                 +++++++++++++++++++++++++++++++++     +\nhelp: consider annotating `Score` with `#[derive(Clone)]`\n     |\n   1 + #[derive(Clone)]\n   2 | struct Score(u16);\n     |\n\nFor more information about this error, try `rustc --explain E0507`.\nerror: could not compile `pattern-default-reference` (bin \"pattern-default-reference\") due to\n       1 previous error\n";

},{}],"jDGcg":[function(require,module,exports,__globalThis) {
module.exports = "struct Score(u16);\n\nfn award_bonus_multiball(score: &Option<Score>) -> bool {\n    let score = score.as_ref().unwrap_or(&Score(0));\n    score.0 % 100 == 0\n}\n\nfn main() {}\n";

},{}],"hxgV9":[function(require,module,exports,__globalThis) {
module.exports = "fn is_even(value: Result<i32, String>) -> Result<bool, String> {\n    match value {\n        Ok(value) => Ok(value % 2 == 0),\n        Err(e) => Err(e),\n    }\n}\n\nfn main() {}\n";

},{}],"iXlbC":[function(require,module,exports,__globalThis) {
module.exports = "fn is_even(value: Result<i32, String>) -> Result<bool, String> {\n    value.map(|v| v % 2 == 0)\n}\n\nfn main() {}\n";

},{}],"b66As":[function(require,module,exports,__globalThis) {
module.exports = "fn is_even(value: Result<i32, String>) -> Result<bool, String> {\n    Ok(value? % 2 == 0)\n}\n\nfn main() {}\n";

},{}],"3wC4S":[function(require,module,exports,__globalThis) {
module.exports = "fn name(name: Result<String, SomeError>) -> Option<String> {\n    match name {\n        Ok(v) => Some(v),\n        Err(_) => None,\n    }\n}\n\nstruct SomeError;\n\nfn main() {}\n";

},{}],"gkUNe":[function(require,module,exports,__globalThis) {
module.exports = "fn name(name: Result<String, SomeError>) -> Option<String> {\n    name.ok()\n}\n\nstruct SomeError;\n\nfn main() {}\n";

},{}],"cQHKV":[function(require,module,exports,__globalThis) {
module.exports = "fn name(name: Option<String>) -> Result<String, SomeError> {\n    match name {\n        Some(v) => Ok(v),\n        None => Err(SomeError),\n    }\n}\n\nstruct SomeError;\n\nfn main() {}\n";

},{}],"5J5Zo":[function(require,module,exports,__globalThis) {
module.exports = "fn name(name: Option<String>) -> Result<String, SomeError> {\n    name.ok_or(SomeError)\n}\n\nstruct SomeError;\n\nfn main() {}\n";

},{}],"8Jikd":[function(require,module,exports,__globalThis) {
module.exports = "use std::env;\n\nfn main() {\n    let value = env::var(\"PORT_NEW\").or_else(|_e| env::var(\"PORT_OLD\")).ok();\n    let port: u16 = value.and_then(|value| value.parse().ok()).unwrap_or(8080);\n    println!(\"{port}\");\n}\n";

},{}],"aS0g1":[function(require,module,exports,__globalThis) {
module.exports = "use std::env;\n\nfn main() {\n    let value = match env::var(\"PORT_NEW\") {\n        Ok(v) => Some(v),\n        Err(_e) => match env::var(\"PORT_OLD\") {\n            Ok(v) => Some(v),\n            Err(_e) => None,\n        }\n    };\n\n    let maybe_port = match value {\n        Some(value) => match value.parse() {\n            Ok(v) => Some(v),\n            Err(_e) => None,\n        }\n        None => None,\n    };\n\n    let port: u16 = match maybe_port {\n        Some(port) => port,\n        None => 8080,\n    };\n\n    println!(\"{port}\");\n}\n";

},{}],"bhVWw":[function(require,module,exports,__globalThis) {
/*@jsxRuntime automatic*/ /*@jsxImportSource react*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "title", ()=>title);
parcelHelpers.export(exports, "default", ()=>MDXContent);
var _jsxRuntime = require("react/jsx-runtime");
var _directives = require("./Directives");
var _changeDeck = require("./ChangeDeck");
var _changeDeckDefault = parcelHelpers.interopDefault(_changeDeck);
var _splash = require("./layout/Splash");
var _splashDefault = parcelHelpers.interopDefault(_splash);
var _testPattern = require("./TestPattern");
var _testPatternDefault = parcelHelpers.interopDefault(_testPattern);
var _transclude = require("./Transclude");
var _transcludeDefault = parcelHelpers.interopDefault(_transclude);
var _kindsOfPanics = require("rust:error-handling/kinds-of-panics");
var _kindsOfPanicsDefault = parcelHelpers.interopDefault(_kindsOfPanics);
var _unifyingErrors = require("rust:error-handling/unifying-errors");
var _unifyingErrorsDefault = parcelHelpers.interopDefault(_unifyingErrors);
var _unifyingErrorsRev1 = require("rust:error-handling/unifying-errors?rev=1");
var _unifyingErrorsRev1Default = parcelHelpers.interopDefault(_unifyingErrorsRev1);
var _exerciseUnifyingErrors = require("rust:error-handling/exercise-unifying-errors");
var _exerciseUnifyingErrorsDefault = parcelHelpers.interopDefault(_exerciseUnifyingErrors);
var _returnFromMainAndTest = require("rust:error-handling/return-from-main-and-test");
var _returnFromMainAndTestDefault = parcelHelpers.interopDefault(_returnFromMainAndTest);
var _stringErrors = require("rust:error-handling/string-errors");
var _stringErrorsDefault = parcelHelpers.interopDefault(_stringErrors);
var _resultTypeAlias = require("rust:error-handling/result-type-alias");
var _resultTypeAliasDefault = parcelHelpers.interopDefault(_resultTypeAlias);
var _resultTypeAliasRev1 = require("rust:error-handling/result-type-alias?rev=1");
var _resultTypeAliasRev1Default = parcelHelpers.interopDefault(_resultTypeAliasRev1);
var _customError = require("rust:error-handling/custom-error");
var _customErrorDefault = parcelHelpers.interopDefault(_customError);
var _customErrorRev1 = require("rust:error-handling/custom-error?rev=1");
var _customErrorRev1Default = parcelHelpers.interopDefault(_customErrorRev1);
var _customErrorRev2 = require("rust:error-handling/custom-error?rev=2");
var _customErrorRev2Default = parcelHelpers.interopDefault(_customErrorRev2);
var _usingSnafu = require("rust:error-handling/using-snafu");
var _usingSnafuDefault = parcelHelpers.interopDefault(_usingSnafu);
const title = "Error handling";
function _createMdxContent(props) {
    const _components = {
        a: "a",
        code: "code",
        h1: "h1",
        h2: "h2",
        hr: "hr",
        li: "li",
        p: "p",
        pre: "pre",
        ul: "ul",
        ...props.components
    }, { SplitSlides } = _components;
    if (!SplitSlides) _missingMdxReference("SplitSlides", true);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SplitSlides, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _testPatternDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Error handling"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Handling errors"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Rust does not have exceptions"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "You can:",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "return an error (",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "Option"
                                            }),
                                            ", ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "Result"
                                            }),
                                            ")"
                                        ]
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "panic"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Panicking"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Tears down the current thread",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "If it's the main thread, program exits"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Safe to do, in Rust terms"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Direct panics"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _kindsOfPanicsDefault.default),
                focusOn: "2+1"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _kindsOfPanicsDefault.default),
                focusOn: "3+1"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _kindsOfPanicsDefault.default),
                focusOn: "4+2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _kindsOfPanicsDefault.default),
                focusOn: "6+2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "All do the same, different meaning for the programmer"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Indirect panics"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Option::unwrap()"
                            }),
                            " / ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Result::unwrap()"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Option::expect(\"reason\")"
                            }),
                            " / ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Result::expect(\"reason\")"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Indexing out of bounds (",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "foo[1000]"
                            }),
                            ")"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "These exist for convenience"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Ways to avoid the panic exist"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Recovering from a panic"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                            children: "std::panic::catch_unwind"
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Really only useful for bigger frameworks",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Web server"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "When is a panic not a panic?"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Can add ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "panic = \"abort\""
                            }),
                            " to your Cargo.toml",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Any panic will abort the process"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Panicking during another panic also causes an abort"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Call ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "std::process::abort"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Panic vs returning an error"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "When in doubt, prefer returning an ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Option"
                            }),
                            " or ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Result"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "When to panic:",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Great for prototyping and \"learning Rust\" workshops"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "OK for tests"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "OK for an executable"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "Not good for a library",
                                            "\n",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                                children: [
                                                    "\n",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                                        children: "Unless there's an error from the library writer"
                                                    }),
                                                    "\n",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                                        children: [
                                                            "Or a convenience function, equivalent to ",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                                children: "[]"
                                                            })
                                                        ]
                                                    }),
                                                    "\n"
                                                ]
                                            }),
                                            "\n"
                                        ]
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "The type inside ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "Result::Err"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Well-designed APIs usually use an error type that implements ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "std::error::Error"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "std::error::Error"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-rust",
                    children: "pub trait Error: Debug + Display {\n    fn source(&self) -> Option<&(dyn Error + 'static)> { /* ... */ }\n}\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Can be printed"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Can get the underlying cause"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Other methods, but they are deprecated."
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Unifying errors"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _unifyingErrorsDefault.default),
                focusOn: "1+11"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "We want to be able to report either type of error"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "But can only use one return type"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "The ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "std::error::Error"
                    }),
                    " trait object"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _unifyingErrorsRev1Default.default),
                focusOn: "1+11",
                emphasize: "1[34+26]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Any type that implements ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Error"
                            }),
                            " can be put into this trait object"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Downside is that you lose ability to easily access any details"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "There's also a thread-safe variant of this: ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Box<dyn std::error::Error + Send + Sync + 'static>"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Exercise: Unify different error types"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Write a function that accepts two strings"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Parse one string as a ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "bool"
                            }),
                            ", the other as an ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "i32"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Use ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "?"
                            }),
                            " to return in case of error"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "If the boolean is true, multiply the number by 2, otherwise by 3"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Return a unified ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Result"
                            }),
                            " to ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "main"
                            }),
                            " and print out the success or failure"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Hints"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Use a return type like ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "-> Result<..., Box<dyn Error>>"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One answer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _exerciseUnifyingErrorsDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Returning errors from ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "main"
                    }),
                    " and tests"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _returnFromMainAndTestDefault.default),
                focusOn: "1+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _returnFromMainAndTestDefault.default),
                focusOn: "5+4"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "These use ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Debug"
                            }),
                            " formatting, which means they aren't great for end users"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Easy custom error messages with strings"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _stringErrorsDefault.default),
                focusOn: "1+15"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Easy custom error messages with strings"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _stringErrorsDefault.default),
                focusOn: "1+15",
                emphasize: "3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Easy custom error messages with strings"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _stringErrorsDefault.default),
                focusOn: "1+15",
                emphasize: "7,8,9"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Repetitive return types"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _resultTypeAliasDefault.default),
                focusOn: "1+11"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Takes up visual space, is repetitive, and hard to change at once"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "Result"
                    }),
                    " type aliases"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _resultTypeAliasRev1Default.default),
                focusOn: "1+15"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Common in libraries where many functions return the same error"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "May be confusing when seen in the documentation"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "Result"
                    }),
                    " type aliases"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _resultTypeAliasRev1Default.default),
                focusOn: "1+15",
                emphasize: "13,14,15"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Common in libraries where many functions return the same error"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "May be confusing when seen in the documentation"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "Result"
                    }),
                    " type aliases"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _resultTypeAliasRev1Default.default),
                focusOn: "1+15",
                emphasize: "1[17+12],5[22+12],9[18+12]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Common in libraries where many functions return the same error"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "May be confusing when seen in the documentation"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Custom error types"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: "Production code is likely to have custom error types"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _customErrorDefault.default),
                focusOn: "1+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "A part of your public API"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Can have methods",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "further details"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "recover original values"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Custom error types"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: "Common implementation is an enum, one variant per possible error"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _customErrorRev1Default.default),
                focusOn: "1+8"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Implementing std::error:Error"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _customErrorRev2Default.default),
                focusOn: "1+12"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Implementing std::error:Error"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _customErrorRev2Default.default),
                focusOn: "1+12",
                emphasize: "3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Implementing std::error:Error"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _customErrorRev2Default.default),
                focusOn: "1+12",
                emphasize: "6,7,8,9,10,11"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Implementing std::error:Error"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _customErrorRev2Default.default),
                focusOn: "1+12",
                emphasize: "12[0+46]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Crates help with this"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "SNAFU"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "anyhow"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "thiserror"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "quick-error"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "failure"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "error-chain"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "SNAFU"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _usingSnafuDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                    href: "https://docs.google.com/forms/d/e/1FAIpQLScPWtiGMKWwfjlEuKN5yjk1vJ7okg4NaLNUmfolP93jcFChlg/viewform?usp=publish-editor",
                    children: "Quiz"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _changeDeckDefault.default), {
                    deck: "overview",
                    children: "Return"
                })
            })
        ]
    });
}
function MDXContent(props = {}) {
    const { wrapper: MDXLayout } = props.components || {};
    return MDXLayout ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(MDXLayout, {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_createMdxContent, {
            ...props
        })
    }) : _createMdxContent(props);
}
function _missingMdxReference(id, component, place) {
    throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it." + (place ? "\nIt\u2019s referenced in your code at `" + place + "`" : ""));
}

},{"react/jsx-runtime":"afIHK","./Directives":"6Yemz","./ChangeDeck":"29Jlq","./layout/Splash":"1mDy7","./TestPattern":"g0BPT","./Transclude":"fUgcm","rust:error-handling/kinds-of-panics":"g7FEV","rust:error-handling/unifying-errors":"ln1wC","rust:error-handling/unifying-errors?rev=1":"kzE7a","rust:error-handling/exercise-unifying-errors":"cIFlt","rust:error-handling/return-from-main-and-test":"jmJXH","rust:error-handling/string-errors":"3CJNB","rust:error-handling/result-type-alias":"gK1hK","rust:error-handling/result-type-alias?rev=1":"jbsb9","rust:error-handling/custom-error":"7SThQ","rust:error-handling/custom-error?rev=1":"gfydJ","rust:error-handling/custom-error?rev=2":"3DPmr","rust:error-handling/using-snafu":"9CcAJ","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"g7FEV":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    panic!(\"This shouldn't happen\");\n    unreachable!(\"This code can't be run but it is\");\n    unimplemented!(\"This code hasn't been written yet\");\n    todo!(\"This code hasn't been written yet\");\n    assert!(1 > 2, \"This condition failed\");\n    assert_eq!(42, 0, \"This equality failed\");\n}\n";

},{}],"ln1wC":[function(require,module,exports,__globalThis) {
module.exports = "fn compute_value() -> Result<i32, WhatTypeGoesHere> {\n    Ok(read_db()? + read_redis()?)\n}\n\nfn read_db() -> Result<i32, DatabaseError> {\n    Ok(1)\n}\n\nfn read_redis() -> Result<i32, RedisError> {\n    Ok(2)\n}\n\ntype WhatTypeGoesHere = Box<dyn std::error::Error>;\n\ntype RedisError = std::io::Error;\ntype DatabaseError = std::fmt::Error;\n\nfn main() -> Result<(), Box<dyn std::error::Error>> {\n    compute_value()?;\n    Ok(())\n}\n";

},{}],"kzE7a":[function(require,module,exports,__globalThis) {
module.exports = "fn compute_value() -> Result<i32, Box<dyn std::error::Error>> {\n    Ok(read_db()? + read_redis()?)\n}\n\nfn read_db() -> Result<i32, DatabaseError> {\n    Ok(1)\n}\n\nfn read_redis() -> Result<i32, RedisError> {\n    Ok(2)\n}\n\ntype RedisError = std::io::Error;\ntype DatabaseError = std::fmt::Error;\n\nfn main() -> Result<(), Box<dyn std::error::Error>> {\n    compute_value()?;\n    Ok(())\n}\n";

},{}],"cIFlt":[function(require,module,exports,__globalThis) {
module.exports = "fn maths(condition: &str, value: &str) -> Result<i32, Box<dyn std::error::Error>> {\n    let condition: bool = condition.parse()?;\n    let value: i32 = value.parse()?;\n\n    Ok(if condition { value * 2 } else { value * 3 })\n}\n\nfn main() {\n    match maths(\"true\", \"42\") {\n        Ok(v) => println!(\"The result was {v}\"),\n        Err(e) => println!(\"There was an error: {e}\"),\n    }\n}\n";

},{}],"jmJXH":[function(require,module,exports,__globalThis) {
module.exports = "fn main() -> Result<(), &'static str> {\n    Err(\"This is a failure\")\n}\n\n#[test]\nfn example() -> Result<(), &'static str> {\n    Err(\"This is a failure\")\n}\n";

},{}],"3CJNB":[function(require,module,exports,__globalThis) {
module.exports = "fn print() -> Result<(), Box<dyn std::error::Error>> {\n    if printer_on_fire() {\n        Err(\"Try again later\")?;\n    }\n\n    if toner_less_than_75_percent() {\n        Err(format!(\n            \"Printer disabled. Buy another from {PARTNER_STORE} immediately\",\n        ))?;\n    }\n\n    println!(\"Howdy!\");\n\n    Ok(())\n}\n\nconst PARTNER_STORE: &str = \"big bix co\";\n\nfn printer_on_fire() -> bool {\n    false\n}\nfn toner_less_than_75_percent() -> bool {\n    false\n}\n\nfn main() -> Result<(), Box<dyn std::error::Error>> {\n    print()\n}\n";

},{}],"gK1hK":[function(require,module,exports,__globalThis) {
module.exports = "fn is_lorax() -> Result<bool, Box<dyn std::error::Error>> {\n    Ok(false)\n}\n\nfn is_cat_in_hat() -> Result<bool, Box<dyn std::error::Error>> {\n    Ok(false)\n}\n\nfn is_horton() -> Result<bool, Box<dyn std::error::Error>> {\n    Ok(false)\n}\n\nfn main() -> Result<(), Box<dyn std::error::Error>> {\n    let _ = is_lorax()? || is_cat_in_hat()? || is_horton()?;\n    Ok(())\n}\n";

},{}],"jbsb9":[function(require,module,exports,__globalThis) {
module.exports = "fn is_lorax() -> Result<bool> {\n    Ok(false)\n}\n\nfn is_cat_in_hat() -> Result<bool> {\n    Ok(false)\n}\n\nfn is_horton() -> Result<bool> {\n    Ok(false)\n}\n\ntype Error = Box<dyn std::error::Error>;\n\ntype Result<T, E = Error> = std::result::Result<T, E>;\n\nfn main() -> Result<(), Box<dyn std::error::Error>> {\n    let _ = is_lorax()? || is_cat_in_hat()? || is_horton()?;\n    Ok(())\n}\n";

},{}],"7SThQ":[function(require,module,exports,__globalThis) {
module.exports = "struct ReticulateSplineError;\n\nfn reticulate_splines() -> Result<bool, ReticulateSplineError> {\n    Ok(true)\n}\n\nfn main() {\n    reticulate_splines().ok();\n}\n";

},{}],"gfydJ":[function(require,module,exports,__globalThis) {
module.exports = "enum ReticulateSplineError {\n    SplineTooBig,\n    NotEnoughSplines(u32),\n}\n\nfn reticulate_splines() -> Result<bool, ReticulateSplineError> {\n    Ok(true)\n}\n\nfn main() {\n    reticulate_splines().ok();\n}\n";

},{}],"3DPmr":[function(require,module,exports,__globalThis) {
module.exports = "use std::{error, fmt};\n\n#[derive(Debug)]\nstruct ReticulateSplineError;\n\nimpl fmt::Display for ReticulateSplineError {\n    fn fmt(&self, f: &mut fmt::Formatter) -> fmt::Result {\n        write!(f, \"Unable to reticulate the splines\")\n    }\n}\n\nimpl error::Error for ReticulateSplineError {}\n\nfn reticulate_splines() -> Result<bool, ReticulateSplineError> {\n    Ok(true)\n}\n\nfn main() {\n    reticulate_splines().ok();\n}\n";

},{}],"9CcAJ":[function(require,module,exports,__globalThis) {
module.exports = "use snafu::prelude::*;\nuse std::{fs, path::PathBuf};\n\n#[derive(Debug, Snafu)]\nenum Error {\n    #[snafu(display(\"Unable to reticulate the splines; have {count}\"))]\n    ReticulateSpline { count: i32 },\n\n    CantReadConfig {\n        source: std::io::Error,\n        path: PathBuf,\n    },\n}\n\nfn usage(count: i32) -> Result<(), Error> {\n    ensure!(count > 10, ReticulateSplineSnafu { count });\n\n    let path = \"/path/to/config.txt\";\n    fs::read_to_string(path).context(CantReadConfigSnafu { path })?;\n\n    Ok(())\n}\n\n#[snafu::report]\nfn main() -> Result<(), Error> {\n    usage(100)\n}\n";

},{}],"4E2OQ":[function(require,module,exports,__globalThis) {
/*@jsxRuntime automatic*/ /*@jsxImportSource react*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "title", ()=>title);
parcelHelpers.export(exports, "default", ()=>MDXContent);
var _jsxRuntime = require("react/jsx-runtime");
var _directives = require("./Directives");
var _changeDeck = require("./ChangeDeck");
var _changeDeckDefault = parcelHelpers.interopDefault(_changeDeck);
var _splash = require("./layout/Splash");
var _splashDefault = parcelHelpers.interopDefault(_splash);
var _testPattern = require("./TestPattern");
var _testPatternDefault = parcelHelpers.interopDefault(_testPattern);
var _transclude = require("./Transclude");
var _transcludeDefault = parcelHelpers.interopDefault(_transclude);
var _excerpts = require("./Excerpts");
var _implementsIteratorDocsPng = require("./assets/iterators/implements-iterator-docs.png");
var _implementsIteratorDocsPngDefault = parcelHelpers.interopDefault(_implementsIteratorDocsPng);
var _importantTraitIndicatorPng = require("./assets/iterators/important-trait-indicator.png");
var _importantTraitIndicatorPngDefault = parcelHelpers.interopDefault(_importantTraitIndicatorPng);
var _importantTraitListPng = require("./assets/iterators/important-trait-list.png");
var _importantTraitListPngDefault = parcelHelpers.interopDefault(_importantTraitListPng);
var _forLoopSugar = require("rust:iterators/for-loop-sugar");
var _forLoopSugarDefault = parcelHelpers.interopDefault(_forLoopSugar);
var _closure = require("rust:iterators/closure");
var _closureDefault = parcelHelpers.interopDefault(_closure);
var _iteratorMap = require("rust:iterators/iterator-map");
var _iteratorMapDefault = parcelHelpers.interopDefault(_iteratorMap);
var _iteratorFilter = require("rust:iterators/iterator-filter");
var _iteratorFilterDefault = parcelHelpers.interopDefault(_iteratorFilter);
var _iteratorCollect = require("rust:iterators/iterator-collect");
var _iteratorCollectDefault = parcelHelpers.interopDefault(_iteratorCollect);
var _exampleCombinators = require("rust:iterators/example-combinators");
var _exampleCombinatorsDefault = parcelHelpers.interopDefault(_exampleCombinators);
var _optimizeToConstant = require("rust:iterators/optimize-to-constant");
var _optimizeToConstantDefault = parcelHelpers.interopDefault(_optimizeToConstant);
var _iteratorVsIndex = require("rust:iterators/iterator-vs-index");
var _iteratorVsIndexDefault = parcelHelpers.interopDefault(_iteratorVsIndex);
var _returningIterators = require("rust:iterators/returning-iterators");
var _returningIteratorsDefault = parcelHelpers.interopDefault(_returningIterators);
var _returningIteratorsRev1 = require("rust:iterators/returning-iterators?rev=1");
var _returningIteratorsRev1Default = parcelHelpers.interopDefault(_returningIteratorsRev1);
var _returningIteratorsRev11 = require("stderr:iterators/returning-iterators?rev=1");
var _returningIteratorsRev1Default1 = parcelHelpers.interopDefault(_returningIteratorsRev11);
var _returningIteratorsRev2 = require("rust:iterators/returning-iterators?rev=2");
var _returningIteratorsRev2Default = parcelHelpers.interopDefault(_returningIteratorsRev2);
var _returningIteratorsRev3 = require("rust:iterators/returning-iterators?rev=3");
var _returningIteratorsRev3Default = parcelHelpers.interopDefault(_returningIteratorsRev3);
var _returningIteratorsRev31 = require("stderr:iterators/returning-iterators?rev=3");
var _returningIteratorsRev3Default1 = parcelHelpers.interopDefault(_returningIteratorsRev31);
var _returningIteratorsRev4 = require("rust:iterators/returning-iterators?rev=4");
var _returningIteratorsRev4Default = parcelHelpers.interopDefault(_returningIteratorsRev4);
var _conditionallyReturningIterators = require("rust:iterators/conditionally-returning-iterators");
var _conditionallyReturningIteratorsDefault = parcelHelpers.interopDefault(_conditionallyReturningIterators);
var _conditionallyReturningIterators1 = require("stderr:iterators/conditionally-returning-iterators");
var _conditionallyReturningIteratorsDefault1 = parcelHelpers.interopDefault(_conditionallyReturningIterators1);
var _conditionallyReturningIteratorsRev1 = require("rust:iterators/conditionally-returning-iterators?rev=1");
var _conditionallyReturningIteratorsRev1Default = parcelHelpers.interopDefault(_conditionallyReturningIteratorsRev1);
var _implementingIterator = require("rust:iterators/implementing-iterator");
var _implementingIteratorDefault = parcelHelpers.interopDefault(_implementingIterator);
var _exercisePowersOfTwo = require("rust:iterators/exercise-powers-of-two");
var _exercisePowersOfTwoDefault = parcelHelpers.interopDefault(_exercisePowersOfTwo);
var _ownershipTransfer = require("rust:iterators/ownership-transfer");
var _ownershipTransferDefault = parcelHelpers.interopDefault(_ownershipTransfer);
var _ownershipTransfer1 = require("stderr:iterators/ownership-transfer");
var _ownershipTransferDefault1 = parcelHelpers.interopDefault(_ownershipTransfer1);
var _ownershipTransferRev1 = require("rust:iterators/ownership-transfer?rev=1");
var _ownershipTransferRev1Default = parcelHelpers.interopDefault(_ownershipTransferRev1);
var _ownershipTransferRev2 = require("rust:iterators/ownership-transfer?rev=2");
var _ownershipTransferRev2Default = parcelHelpers.interopDefault(_ownershipTransferRev2);
var _usingItertools = require("toml:iterators/using-itertools");
var _usingItertoolsDefault = parcelHelpers.interopDefault(_usingItertools);
var _usingItertools1 = require("rust:iterators/using-itertools");
var _usingItertoolsDefault1 = parcelHelpers.interopDefault(_usingItertools1);
var _usingRayon = require("toml:iterators/using-rayon");
var _usingRayonDefault = parcelHelpers.interopDefault(_usingRayon);
var _usingRayon1 = require("rust:iterators/using-rayon");
var _usingRayonDefault1 = parcelHelpers.interopDefault(_usingRayon1);
var _multipleReferences = require("rust:iterators/multiple-references");
var _multipleReferencesDefault = parcelHelpers.interopDefault(_multipleReferences);
var _multipleReferences1 = require("stderr:iterators/multiple-references");
var _multipleReferencesDefault1 = parcelHelpers.interopDefault(_multipleReferences1);
var _multipleReferencesRev1 = require("rust:iterators/multiple-references?rev=1");
var _multipleReferencesRev1Default = parcelHelpers.interopDefault(_multipleReferencesRev1);
var _eagerCollection = require("rust:iterators/eager-collection");
var _eagerCollectionDefault = parcelHelpers.interopDefault(_eagerCollection);
var _eagerCollectionRev1 = require("rust:iterators/eager-collection?rev=1");
var _eagerCollectionRev1Default = parcelHelpers.interopDefault(_eagerCollectionRev1);
var _nonEagerCollection = require("rust:iterators/non-eager-collection");
var _nonEagerCollectionDefault = parcelHelpers.interopDefault(_nonEagerCollection);
var _nonEagerCollection1 = require("stderr:iterators/non-eager-collection");
var _nonEagerCollectionDefault1 = parcelHelpers.interopDefault(_nonEagerCollection1);
var _nonEagerCollectionRev1 = require("rust:iterators/non-eager-collection?rev=1");
var _nonEagerCollectionRev1Default = parcelHelpers.interopDefault(_nonEagerCollectionRev1);
var _itemRefersToIterator = require("rust:iterators/item-refers-to-iterator");
var _itemRefersToIteratorDefault = parcelHelpers.interopDefault(_itemRefersToIterator);
var _itemRefersToIterator1 = require("stderr:iterators/item-refers-to-iterator");
var _itemRefersToIteratorDefault1 = parcelHelpers.interopDefault(_itemRefersToIterator1);
var _itemRefersToIteratorRev1 = require("rust:iterators/item-refers-to-iterator?rev=1");
var _itemRefersToIteratorRev1Default = parcelHelpers.interopDefault(_itemRefersToIteratorRev1);
var _coroutines = require("rust:iterators/coroutines");
var _coroutinesDefault = parcelHelpers.interopDefault(_coroutines);
const title = "Iterators";
function _createMdxContent(props) {
    const _components = {
        a: "a",
        code: "code",
        em: "em",
        h1: "h1",
        h2: "h2",
        h3: "h3",
        hr: "hr",
        li: "li",
        p: "p",
        ul: "ul",
        ...props.components
    }, { SplitSlides } = _components;
    if (!SplitSlides) _missingMdxReference("SplitSlides", true);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SplitSlides, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _testPatternDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Iterators"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "The ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "Iterator"
                    }),
                    " trait"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.IteratorTrait), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "The ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "Iterator"
                    }),
                    " trait"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.IteratorTrait), {
                emphasize: "2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "An associated type is a type that the implementor of the trait picks."
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "The ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "Iterator"
                    }),
                    " trait"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.IteratorTrait), {
                emphasize: "4"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "next"
                            }),
                            " returns the next value or ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "None"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Option"
                            }),
                            " prevents the need for a ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "has_next"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "self"
                            }),
                            " is mutable to update the state"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Iterators are pervasive"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "\"memorize\" what's available"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.a, {
                            href: "https://doc.rust-lang.org/std/iter/trait.Iterator.html",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                    children: "Iterator"
                                }),
                                " docs"
                            ]
                        })
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Getting an iterator"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Some types are inherently iterators",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "Ranges (",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "0.."
                                            }),
                                            " / ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "10..=20"
                                            }),
                                            " / etc.)"
                                        ]
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "std::iter"
                            }),
                            " contains some free functions"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Some types provide methods to return an iterator",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "specialty iterators (",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "str::chars"
                                            }),
                                            ", ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "HashMap::keys"
                                            }),
                                            ")"
                                        ]
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "iter()"
                                            }),
                                            " / ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "iter_mut()"
                                            }),
                                            " / ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "into_iter()"
                                            })
                                        ]
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "The ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "IntoIterator"
                            }),
                            " trait",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "&foo"
                                            }),
                                            " / ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "&mut foo"
                                            }),
                                            " / ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "foo"
                                            })
                                        ]
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Identifying types that are iterators"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                src: (0, _implementsIteratorDocsPngDefault.default),
                alt: "list of traits a type implements"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: "Left-hand side of the documentation lists all the traits the type implements"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Identifying methods that return iterators"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                src: (0, _importantTraitIndicatorPngDefault.default),
                alt: "indication that return type has useful traits"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                src: (0, _importantTraitListPngDefault.default),
                alt: "list of useful traits of return type"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "IntoIterator"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.IntoIteratorTrait), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Nastier type signature, but conceptually simpler - any type that can be converted into an iterator"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "for"
                    }),
                    " loops use ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "IntoIterator"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _forLoopSugarDefault.default),
                focusOn: "2+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _forLoopSugarDefault.default),
                focusOn: "6+4"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "This can be confusing, as a ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Vec"
                            }),
                            " is not an iterator itself, but can be transformed into one"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Can't call iterator methods on the collection directly though"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Closures"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Allow providing small bits of code"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Sometimes called anonymous functions or lambdas"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Closures in Rust"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Fn"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Can be called multiple times"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Can not mutate the closure's environment"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "FnMut"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Can be called multiple times"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Can mutate the closure's environment"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "FnOnce"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Can be called only once"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Can take ownership of the closure's environment"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "There's also ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "AsyncFn"
                            }),
                            " / ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "AsyncFnMut"
                            }),
                            " / ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "AsyncFnOnce"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Closures in Rust"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _closureDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Closures in Rust"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _closureDefault.default),
                emphasize: "1[20+1],1[30+1]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Introduce a generic type and use it as an argument"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Closures in Rust"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _closureDefault.default),
                emphasize: "2,3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Constrain the generic type to implement a specific closure trait"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Closures in Rust"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _closureDefault.default),
                emphasize: "5,6,7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Call the closure like a regular function"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Closures in Rust"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _closureDefault.default),
                emphasize: "11[21+21]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Closure arguments are in pipes"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "Iterator::map"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.IteratorMap), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: "Closure given an item, returns a new item."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Maybe ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.em, {
                                children: "the"
                            }),
                            " most used iterator adapter"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Example"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _iteratorMapDefault.default),
                focusOn: "2+3",
                emphasize: "1[16+15]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "Iterator::filter"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.IteratorFilter), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.p, {
                children: [
                    "Closure given a reference to an item, returns ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "false"
                    }),
                    " if this item should be discarded."
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "I always find myself confused by the polarity of this, so don't feel bad"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Any thoughts on why it's a reference?"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Example"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _iteratorFilterDefault.default),
                focusOn: "2+3",
                emphasize: "1[16+19]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _iteratorFilterDefault.default),
                focusOn: "6+3",
                emphasize: "1[16+19]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _iteratorFilterDefault.default),
                focusOn: "10+3",
                emphasize: "1[16+19]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Since you have a reference, need to dereference to compare it"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "Iterator::collect"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.IteratorCollect), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: "Builds a collection of values from the iterator."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Note that the return type is a generic"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Example"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _iteratorCollectDefault.default),
                focusOn: "4"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _iteratorCollectDefault.default),
                focusOn: "5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _iteratorCollectDefault.default),
                focusOn: "6"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Exercise"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Take the values from 0 (inclusive) to 10 (exclusive)"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Square them"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Remove the results that are larger than 50"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Store them into a ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Vec"
                            }),
                            " and print it"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One answer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _exampleCombinatorsDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Iterators are efficient"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "They are lazy",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Only enough work done to return the next element"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Closures are inlined",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Optimizer can see the entire computation"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Can hint how many elements remain",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Used to avoid reallocating collections"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Lazy means that if it's never used, no work is done other than to construct it"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.p, {
                                children: [
                                    "Optimized to ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                        children: "140"
                                    })
                                ]
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                                src: (0, _optimizeToConstantDefault.default),
                                focusOn: "1+3"
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Iterators vs indexing"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Avoid"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _iteratorVsIndexDefault.default),
                focusOn: "2+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Prefer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _iteratorVsIndexDefault.default),
                focusOn: "10+4"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "More idiomatic and concise"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Use ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "enumerate"
                            }),
                            " if you also need an index"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Not ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.em, {
                                children: "always"
                            }),
                            " better, as the borrowing is different"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Returning iterators"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _returningIteratorsDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Returning iterators"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _returningIteratorsRev1Default.default),
                focusOn: "1+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "We could convert the ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Vec"
                            }),
                            " into an iterator and return it"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _returningIteratorsRev1Default1.default),
                focusOn: "1+17",
                emphasize: "14,15,16,17"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Returning iterators"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _returningIteratorsRev2Default.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "But now it's part of our API, can't change it"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Returning iterators"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _returningIteratorsRev3Default.default),
                focusOn: "5+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _returningIteratorsRev3Default1.default),
                focusOn: "1+19",
                emphasize: "16,17,18,19"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "You can't actually name the type of a closure"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Returning iterators using ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "impl Trait"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _returningIteratorsRev4Default.default),
                emphasize: "1[19+34],5[25+34]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "The compiler knows the concrete type that the function will return"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "The calling code can not rely on anything beyond the signature"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Conditionally returning iterators"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _conditionallyReturningIteratorsDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Conditionally returning iterators"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _conditionallyReturningIteratorsDefault1.default),
                focusOn: "1+28"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Conditionally returning iterators"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _conditionallyReturningIteratorsDefault1.default),
                focusOn: "29+11"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Conditionally returning iterators using trait objects"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _conditionallyReturningIteratorsRev1Default.default),
                emphasize: "5[35+38],7[8+9],7[59+1],9[8+9],9[59+1]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Implementing an iterator"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Trait definition"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.IteratorTrait), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Trait implementation"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _implementingIteratorDefault.default),
                focusOn: "1+7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Implementing an iterator"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Trait definition"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.IteratorTrait), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Trait implementation"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _implementingIteratorDefault.default),
                focusOn: "1+7",
                emphasize: "1"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Implementing an iterator"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Trait definition"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.IteratorTrait), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Trait implementation"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _implementingIteratorDefault.default),
                focusOn: "1+7",
                emphasize: "2[16+20]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Implementing an iterator"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Trait definition"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.IteratorTrait), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Trait implementation"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _implementingIteratorDefault.default),
                focusOn: "1+7",
                emphasize: "5[8+4]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Iterator implementation examples"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Returning an integer forever"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _implementingIteratorDefault.default),
                focusOn: "12+9"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Already exists as ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "iter::repeat"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _implementingIteratorDefault.default),
                focusOn: "36+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Note that we call ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "take"
                            }),
                            " to limit the infinite iterator"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Iterator implementation examples"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Returning an incrementing value"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _implementingIteratorDefault.default),
                focusOn: "22+10"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Already exists as a range"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Making use of mutable ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "self"
                            }),
                            " to update our state"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _implementingIteratorDefault.default),
                focusOn: "40+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Exercise"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Create an iterator that returns the powers of two"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Code like this should pass:"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                                src: (0, _exercisePowersOfTwoDefault.default),
                                focusOn: "20+4",
                                copyAllCode: false
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Bonus"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Create a function called ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "powers_of_two"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Use only existing iterators and adapters from the standard library"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One answer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _exercisePowersOfTwoDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Iterators are standalone types"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "They can have public fields or methods"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "They can implement other traits besides ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Iterator"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "std::str::Chars"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.CharsIterator), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Ownership of iterators is often transferred"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _ownershipTransferDefault.default),
                focusOn: "1+10"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "This isn't necessarily the best way of doing this!"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _ownershipTransferDefault1.default),
                focusOn: "1+12"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Preventing ownership transfers"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.IteratorByRef), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _ownershipTransferRev1Default.default),
                focusOn: "1+10",
                emphasize: "3[8+3],4[20+9]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _ownershipTransferRev2Default.default),
                focusOn: "1+10",
                emphasize: "3[8+3],4[13+4]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Some methods have stricter requirements"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.IteratorCycle), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.IteratorRev), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.IteratorRposition), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Some methods have stricter requirements"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.IteratorCycle), {
                emphasize: "4[22+5]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.IteratorRev), {
                emphasize: "4[22+19]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.IteratorRposition), {
                emphasize: "5[22+39]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Itertools"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Extra iterator adaptors and methods"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Free functions to start from"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "toml",
                src: (0, _usingItertoolsDefault.default),
                focusOn: "8+2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _usingItertoolsDefault1.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Rayon"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Provides parallel iterators"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "toml",
                src: (0, _usingRayonDefault.default),
                focusOn: "8+2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _usingRayonDefault1.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Also does some other things; just known for parallel iterators"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Common issues"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Multiple references"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Over- and under-eager collection"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Iterators returning references to themselves"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Multiple references"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _multipleReferencesDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _multipleReferencesDefault1.default),
                focusOn: "1+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Multiple references"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _multipleReferencesDefault.default),
                emphasize: "3[10+7]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "iter"
                            }),
                            " returns an iterator that implements ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Iterator<Item = &T>"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "T"
                            }),
                            " is ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "i32"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Multiple references"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _multipleReferencesDefault.default),
                emphasize: "3[17+19]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "filter"
                            }),
                            " accepts a closure like ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Fn(&Self::Item) -> bool"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Self::Item"
                            }),
                            " is ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "&i32"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Solutions for multiple references"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Do nothing"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                                src: (0, _multipleReferencesRev1Default.default),
                                focusOn: "4"
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Not usually needed when calling a method because methods automatically dereference"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Dereference once"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                                src: (0, _multipleReferencesRev1Default.default),
                                focusOn: "6",
                                emphasize: "1[22+1]"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                                src: (0, _multipleReferencesRev1Default.default),
                                focusOn: "7",
                                emphasize: "1[26+1]"
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Both are valid, but the former is more idiomatic"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Dereference multiple times"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                                src: (0, _multipleReferencesRev1Default.default),
                                focusOn: "9",
                                emphasize: "1[22+2]"
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Generally only dereference \"all the way\" for types that implement ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Copy"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Over-eager collection"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _eagerCollectionDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Over-eager collection"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _eagerCollectionDefault.default),
                emphasize: "2[15+8],2[48+10]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Unneeded memory allocation; loss of performance for no reason"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Over-eager collection"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _eagerCollectionRev1Default.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Under-eager collection"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _nonEagerCollectionDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "flat_map"
                            }),
                            "'s closure takes ownership of the iterator item, but ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "chars"
                            }),
                            " returns references to it"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _nonEagerCollectionDefault1.default),
                focusOn: "1+10"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Under-eager collection"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _nonEagerCollectionRev1Default.default),
                emphasize: "5[39+20]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Can eagerly collect the inner iterator so no references outlive the closure"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Iterators that reference themselves"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _itemRefersToIteratorDefault.default),
                focusOn: "1+12"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _itemRefersToIteratorDefault1.default),
                focusOn: "1+15"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Iterators that reference themselves"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _itemRefersToIteratorRev1Default.default),
                focusOn: "6+7",
                emphasize: "2[13+4]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _itemRefersToIteratorRev1Default.default),
                focusOn: "14+7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "This is a completely different trait, not ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Iterator"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Uses GATs to have a generic lifetime for the associated type"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Calling code must guarantee that the item is only used until call to ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "next"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "In the future: Coroutines"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _coroutinesDefault.default),
                focusOn: "3+7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Not valid in stable Rust"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Coroutines are the implementation underlying Rust's async/await"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                    href: "https://docs.google.com/forms/d/e/1FAIpQLSdMJk31CnDIfg58PZ_kpszYHFXvP2WJUx9gEPq7r-UKKSB1Sg/viewform?usp=publish-editor",
                    children: "Quiz"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _changeDeckDefault.default), {
                    deck: "overview",
                    children: "Return"
                })
            })
        ]
    });
}
function MDXContent(props = {}) {
    const { wrapper: MDXLayout } = props.components || {};
    return MDXLayout ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(MDXLayout, {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_createMdxContent, {
            ...props
        })
    }) : _createMdxContent(props);
}
function _missingMdxReference(id, component, place) {
    throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it." + (place ? "\nIt\u2019s referenced in your code at `" + place + "`" : ""));
}

},{"react/jsx-runtime":"afIHK","./Directives":"6Yemz","./ChangeDeck":"29Jlq","./layout/Splash":"1mDy7","./TestPattern":"g0BPT","./Transclude":"fUgcm","./Excerpts":"5uobq","./assets/iterators/implements-iterator-docs.png":"cDzyF","./assets/iterators/important-trait-indicator.png":"fWTUT","./assets/iterators/important-trait-list.png":"azG9c","rust:iterators/for-loop-sugar":"i9tZV","rust:iterators/closure":"j1r0Q","rust:iterators/iterator-map":"kE3Pq","rust:iterators/iterator-filter":"96CT0","rust:iterators/iterator-collect":"4NBD0","rust:iterators/example-combinators":"7911h","rust:iterators/optimize-to-constant":"aZ7lg","rust:iterators/iterator-vs-index":"erTHK","rust:iterators/returning-iterators":"lR11Q","rust:iterators/returning-iterators?rev=1":"f3Uew","stderr:iterators/returning-iterators?rev=1":"Xkfn6","rust:iterators/returning-iterators?rev=2":"8VIIu","rust:iterators/returning-iterators?rev=3":"bYvp1","stderr:iterators/returning-iterators?rev=3":"ie6w9","rust:iterators/returning-iterators?rev=4":"aBQuT","rust:iterators/conditionally-returning-iterators":"lsep9","stderr:iterators/conditionally-returning-iterators":"gcKVD","rust:iterators/conditionally-returning-iterators?rev=1":"85CuL","rust:iterators/implementing-iterator":"5nO3S","rust:iterators/exercise-powers-of-two":"8bgKp","rust:iterators/ownership-transfer":"fEUkh","stderr:iterators/ownership-transfer":"cA2iU","rust:iterators/ownership-transfer?rev=1":"ajGsn","rust:iterators/ownership-transfer?rev=2":"2WQVv","toml:iterators/using-itertools":"dn317","rust:iterators/using-itertools":"6HNK8","toml:iterators/using-rayon":"h1okP","rust:iterators/using-rayon":"gggha","rust:iterators/multiple-references":"5g7WI","stderr:iterators/multiple-references":"dcKQD","rust:iterators/multiple-references?rev=1":"1tfM0","rust:iterators/eager-collection":"f1fxP","rust:iterators/eager-collection?rev=1":"5P3aC","rust:iterators/non-eager-collection":"l3NzU","stderr:iterators/non-eager-collection":"kqBU7","rust:iterators/non-eager-collection?rev=1":"7NJ5J","rust:iterators/item-refers-to-iterator":"4cRxL","stderr:iterators/item-refers-to-iterator":"bgF63","rust:iterators/item-refers-to-iterator?rev=1":"ao7DP","rust:iterators/coroutines":"eLVDB","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"5uobq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "String", ()=>String);
parcelHelpers.export(exports, "StringFromUtf8", ()=>StringFromUtf8);
parcelHelpers.export(exports, "FutureTrait", ()=>FutureTrait);
parcelHelpers.export(exports, "IteratorTrait", ()=>IteratorTrait);
parcelHelpers.export(exports, "IteratorByRef", ()=>IteratorByRef);
parcelHelpers.export(exports, "IteratorCollect", ()=>IteratorCollect);
parcelHelpers.export(exports, "IteratorCycle", ()=>IteratorCycle);
parcelHelpers.export(exports, "IteratorFilter", ()=>IteratorFilter);
parcelHelpers.export(exports, "IteratorMap", ()=>IteratorMap);
parcelHelpers.export(exports, "IteratorRev", ()=>IteratorRev);
parcelHelpers.export(exports, "IteratorRposition", ()=>IteratorRposition);
parcelHelpers.export(exports, "IntoIteratorTrait", ()=>IntoIteratorTrait);
parcelHelpers.export(exports, "OptionEnum", ()=>OptionEnum);
parcelHelpers.export(exports, "SliceSplitAtMut", ()=>SliceSplitAtMut);
parcelHelpers.export(exports, "SliceSplitAtMutChecked", ()=>SliceSplitAtMutChecked);
parcelHelpers.export(exports, "SliceSplitAtMutUnchecked", ()=>SliceSplitAtMutUnchecked);
parcelHelpers.export(exports, "SliceFromRawParts", ()=>SliceFromRawParts);
parcelHelpers.export(exports, "SliceFromRawPartsMut", ()=>SliceFromRawPartsMut);
parcelHelpers.export(exports, "StrFromUtf8", ()=>StrFromUtf8);
parcelHelpers.export(exports, "CharsIterator", ()=>CharsIterator);
parcelHelpers.export(exports, "PollEnum", ()=>PollEnum);
parcelHelpers.export(exports, "ThreadSpawn", ()=>ThreadSpawn);
parcelHelpers.export(exports, "ThreadScopedScope", ()=>ThreadScopedScope);
parcelHelpers.export(exports, "ThreadScopedSpawn", ()=>ThreadScopedSpawn);
parcelHelpers.export(exports, "TryFutureTrait", ()=>TryFutureTrait);
parcelHelpers.export(exports, "StreamTrait", ()=>StreamTrait);
parcelHelpers.export(exports, "TryStreamTrait", ()=>TryStreamTrait);
parcelHelpers.export(exports, "FuturesIoAsyncReadPollRead", ()=>FuturesIoAsyncReadPollRead);
parcelHelpers.export(exports, "FuturesAsyncReadExtRead", ()=>FuturesAsyncReadExtRead);
parcelHelpers.export(exports, "FutureExtTrait", ()=>FutureExtTrait);
parcelHelpers.export(exports, "TryFutureExtTrait", ()=>TryFutureExtTrait);
parcelHelpers.export(exports, "StreamExtTrait", ()=>StreamExtTrait);
parcelHelpers.export(exports, "TryStreamExtTrait", ()=>TryStreamExtTrait);
parcelHelpers.export(exports, "DeriveInput", ()=>DeriveInput);
parcelHelpers.export(exports, "Data", ()=>Data);
parcelHelpers.export(exports, "DataStruct", ()=>DataStruct);
parcelHelpers.export(exports, "TokioAsyncReadPollRead", ()=>TokioAsyncReadPollRead);
parcelHelpers.export(exports, "TokioAsyncReadExtRead", ()=>TokioAsyncReadExtRead);
var _jsxRuntime = require("react/jsx-runtime");
var _transclude = require("./Transclude");
var _transcludeDefault = parcelHelpers.interopDefault(_transclude);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// ----------
var _stringRs = require("rust:extracted/alloc/src/string.rs");
var _stringRsDefault = parcelHelpers.interopDefault(_stringRs);
// ----------
var _futureRs = require("rust:extracted/core/src/future/future.rs");
var _futureRsDefault = parcelHelpers.interopDefault(_futureRs);
// ----------
var _iteratorRs = require("rust:extracted/core/src/iter/traits/iterator.rs");
var _iteratorRsDefault = parcelHelpers.interopDefault(_iteratorRs);
// ----------
var _collectRs = require("rust:extracted/core/src/iter/traits/collect.rs");
var _collectRsDefault = parcelHelpers.interopDefault(_collectRs);
// ----------
var _optionRs = require("rust:extracted/core/src/option.rs");
var _optionRsDefault = parcelHelpers.interopDefault(_optionRs);
// ----------
var _modRs = require("rust:extracted/core/src/slice/mod.rs");
var _modRsDefault = parcelHelpers.interopDefault(_modRs);
// ----------
var _rawRs = require("rust:extracted/core/src/slice/raw.rs");
var _rawRsDefault = parcelHelpers.interopDefault(_rawRs);
// ----------
var _convertsRs = require("rust:extracted/core/src/str/converts.rs");
var _convertsRsDefault = parcelHelpers.interopDefault(_convertsRs);
// ----------
var _iterRs = require("rust:extracted/core/src/str/iter.rs");
var _iterRsDefault = parcelHelpers.interopDefault(_iterRs);
// ----------
var _pollRs = require("rust:extracted/core/src/task/poll.rs");
var _pollRsDefault = parcelHelpers.interopDefault(_pollRs);
// ----------
var _functionsRs = require("rust:extracted/std/src/thread/functions.rs");
var _functionsRsDefault = parcelHelpers.interopDefault(_functionsRs);
// ----------
var _scopedRs = require("rust:extracted/std/src/thread/scoped.rs");
var _scopedRsDefault = parcelHelpers.interopDefault(_scopedRs);
// ----------
var _futureRs1 = require("rust:extracted/futures-core-0.3.32/src/future.rs");
var _futureRsDefault1 = parcelHelpers.interopDefault(_futureRs1);
// ----------
var _streamRs = require("rust:extracted/futures-core-0.3.32/src/stream.rs");
var _streamRsDefault = parcelHelpers.interopDefault(_streamRs);
// ----------
var _libRs = require("rust:extracted/futures-io-0.3.32/src/lib.rs");
var _libRsDefault = parcelHelpers.interopDefault(_libRs);
// ----------
var _modRs1 = require("rust:extracted/futures-util-0.3.32/src/io/mod.rs");
var _modRsDefault1 = parcelHelpers.interopDefault(_modRs1);
// ----------
var _modRs2 = require("rust:extracted/futures-util-0.3.32/src/future/future/mod.rs");
var _modRsDefault2 = parcelHelpers.interopDefault(_modRs2);
// ----------
var _modRs3 = require("rust:extracted/futures-util-0.3.32/src/future/try_future/mod.rs");
var _modRsDefault3 = parcelHelpers.interopDefault(_modRs3);
// ----------
var _modRs4 = require("rust:extracted/futures-util-0.3.32/src/stream/stream/mod.rs");
var _modRsDefault4 = parcelHelpers.interopDefault(_modRs4);
// ----------
var _modRs5 = require("rust:extracted/futures-util-0.3.32/src/stream/try_stream/mod.rs");
var _modRsDefault5 = parcelHelpers.interopDefault(_modRs5);
// ----------
var _deriveRs = require("rust:extracted/syn-2.0.117/src/derive.rs");
var _deriveRsDefault = parcelHelpers.interopDefault(_deriveRs);
// ----------
var _asyncReadRs = require("rust:extracted/tokio-1.50.0/src/io/async_read.rs");
var _asyncReadRsDefault = parcelHelpers.interopDefault(_asyncReadRs);
// ----------
var _asyncReadExtRs = require("rust:extracted/tokio-1.50.0/src/io/util/async_read_ext.rs");
var _asyncReadExtRsDefault = parcelHelpers.interopDefault(_asyncReadExtRs);
const excerpt = (src, focusOn, extra = {})=>{
    const Excerpt = ({ emphasize })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
            src: src,
            focusOn: focusOn,
            emphasize: emphasize,
            transform: extra.transform,
            insert: extra.insert,
            copyAllCode: false
        });
    return Excerpt;
};
const String = excerpt((0, _stringRsDefault.default), "353+3");
const StringFromUtf8 = excerpt((0, _stringRsDefault.default), "415,560,565,2206", {
    insert: {
        3: "        // ..."
    }
});
const FutureTrait = excerpt((0, _futureRsDefault.default), "37,41+2,113+2");
const IteratorTrait = excerpt((0, _iteratorRsDefault.default), "40,44+2,76,4037");
const IteratorByRef = excerpt((0, _iteratorRsDefault.default), "40,1896+3,4037");
const IteratorCollect = excerpt((0, _iteratorRsDefault.default), "40,2015+3,4037");
const IteratorCycle = excerpt((0, _iteratorRsDefault.default), "40,3497+3,4037");
const IteratorFilter = excerpt((0, _iteratorRsDefault.default), "40,893+4,4037");
const IteratorMap = excerpt((0, _iteratorRsDefault.default), "40,773+4,4037");
const IteratorRev = excerpt((0, _iteratorRsDefault.default), "40,3351+3,4037");
const IteratorRposition = excerpt((0, _iteratorRsDefault.default), "40,3114+4,4037");
const IntoIteratorTrait = excerpt((0, _collectRsDefault.default), "282,285,289+2,310+2");
const OptionEnum = excerpt((0, _optionRsDefault.default), "600,604,608+2", {
    transform: {
        3: [
            /#\[.*\] /,
            ""
        ]
    }
});
const SliceSplitAtMut = excerpt((0, _modRsDefault.default), "1983+6");
const SliceSplitAtMutChecked = excerpt((0, _modRsDefault.default), "2189+2,2193+5");
const SliceSplitAtMutUnchecked = excerpt((0, _modRsDefault.default), "2089+9,2103+7");
const SliceFromRawParts = excerpt((0, _rawRsDefault.default), "124,141", {
    insert: {
        2: "    // ..."
    }
});
const SliceFromRawPartsMut = excerpt((0, _rawRsDefault.default), "179,196", {
    insert: {
        2: "    // ..."
    }
});
const StrFromUtf8 = excerpt((0, _convertsRsDefault.default), "89,98", {
    insert: {
        2: "    // ..."
    }
});
const CharsIterator = excerpt((0, _iterRsDefault.default), "138,159,162+2", {
    insert: {
        3: "        // ..."
    }
});
const PollEnum = excerpt((0, _pollRsDefault.default), "14,18,27+2", {
    transform: {
        2: [
            /#\[.*\] /,
            ""
        ]
    }
});
const ThreadSpawn = excerpt((0, _functionsRsDefault.default), "125+5");
const ThreadScopedScope = excerpt((0, _scopedRsDefault.default), "138-140");
const ThreadScopedSpawn = excerpt((0, _scopedRsDefault.default), "173,198-201,205");
const TryFutureTrait = excerpt((0, _futureRsDefault1.default), "68,70,73+2,80+2");
const StreamTrait = excerpt((0, _streamRsDefault.default), "37,39+2,76,108");
const TryStreamTrait = excerpt((0, _streamRsDefault.default), "177,179,182+2,189+5");
const FuturesIoAsyncReadPollRead = excerpt((0, _libRsDefault.default), "63+5");
const FuturesAsyncReadExtRead = excerpt((0, _modRsDefault1.default), "196+3");
const FutureExtTrait = excerpt((0, _modRsDefault2.default), "121,603", {
    insert: {
        2: "    // 19 methods"
    }
});
const TryFutureExtTrait = excerpt((0, _modRsDefault3.default), "137,625", {
    insert: {
        2: "    // 16 methods"
    }
});
const StreamExtTrait = excerpt((0, _modRsDefault4.default), "249,1697", {
    insert: {
        2: "    // 46 methods"
    }
});
const TryStreamExtTrait = excerpt((0, _modRsDefault5.default), "180,1254", {
    insert: {
        2: "    // 29 methods"
    }
});
const DeriveInput = excerpt((0, _deriveRsDefault.default), "13-19");
const Data = excerpt((0, _deriveRsDefault.default), "31-35");
const DataStruct = excerpt((0, _deriveRsDefault.default), "41-45");
const TokioAsyncReadPollRead = excerpt((0, _asyncReadRsDefault.default), "55+5");
const TokioAsyncReadExtRead = excerpt((0, _asyncReadExtRsDefault.default), "177+3");

},{"react/jsx-runtime":"afIHK","./Transclude":"fUgcm","react":"7e5Pu","rust:extracted/alloc/src/string.rs":"9rB8g","rust:extracted/core/src/future/future.rs":"2QWxh","rust:extracted/core/src/iter/traits/iterator.rs":"cbvH5","rust:extracted/core/src/iter/traits/collect.rs":"eBMp8","rust:extracted/core/src/option.rs":"cQfst","rust:extracted/core/src/slice/mod.rs":"4dkmE","rust:extracted/core/src/slice/raw.rs":"k2q2c","rust:extracted/core/src/str/converts.rs":"7EVRd","rust:extracted/core/src/str/iter.rs":"c0j3E","rust:extracted/core/src/task/poll.rs":"2KtSE","rust:extracted/std/src/thread/functions.rs":"5ZDWt","rust:extracted/std/src/thread/scoped.rs":"idCyy","rust:extracted/futures-core-0.3.32/src/future.rs":"6rN9e","rust:extracted/futures-core-0.3.32/src/stream.rs":"8UBmk","rust:extracted/futures-io-0.3.32/src/lib.rs":"8CCFF","rust:extracted/futures-util-0.3.32/src/io/mod.rs":"14PiQ","rust:extracted/futures-util-0.3.32/src/future/future/mod.rs":"cpBA8","rust:extracted/futures-util-0.3.32/src/future/try_future/mod.rs":"d7KkU","rust:extracted/futures-util-0.3.32/src/stream/stream/mod.rs":"i2MCQ","rust:extracted/futures-util-0.3.32/src/stream/try_stream/mod.rs":"bI0yc","rust:extracted/syn-2.0.117/src/derive.rs":"2LOB4","rust:extracted/tokio-1.50.0/src/io/async_read.rs":"2jMSg","rust:extracted/tokio-1.50.0/src/io/util/async_read_ext.rs":"bh2f9","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"9rB8g":[function(require,module,exports,__globalThis) {
module.exports = "//! A UTF-8–encoded, growable string.\n//!\n//! This module contains the [`String`] type, the [`ToString`] trait for\n//! converting to strings, and several error types that may result from\n//! working with [`String`]s.\n//!\n//! # Examples\n//!\n//! There are multiple ways to create a new [`String`] from a string literal:\n//!\n//! ```\n//! let s = \"Hello\".to_string();\n//!\n//! let s = String::from(\"world\");\n//! let s: String = \"also this\".into();\n//! ```\n//!\n//! You can create a new [`String`] from an existing one by concatenating with\n//! `+`:\n//!\n//! ```\n//! let s = \"Hello\".to_string();\n//!\n//! let message = s + \" world!\";\n//! ```\n//!\n//! If you have a vector of valid UTF-8 bytes, you can make a [`String`] out of\n//! it. You can do the reverse too.\n//!\n//! ```\n//! let sparkle_heart = vec![240, 159, 146, 150];\n//!\n//! // We know these bytes are valid, so we'll use `unwrap()`.\n//! let sparkle_heart = String::from_utf8(sparkle_heart).unwrap();\n//!\n//! assert_eq!(\"💖\", sparkle_heart);\n//!\n//! let bytes = sparkle_heart.into_bytes();\n//!\n//! assert_eq!(bytes, [240, 159, 146, 150]);\n//! ```\n\n#![stable(feature = \"rust1\", since = \"1.0.0\")]\n\nuse core::error::Error;\nuse core::iter::FusedIterator;\n#[cfg(not(no_global_oom_handling))]\nuse core::iter::from_fn;\n#[cfg(not(no_global_oom_handling))]\nuse core::ops::Add;\n#[cfg(not(no_global_oom_handling))]\nuse core::ops::AddAssign;\n#[cfg(not(no_global_oom_handling))]\nuse core::ops::Bound::{Excluded, Included, Unbounded};\nuse core::ops::{self, Range, RangeBounds};\nuse core::str::pattern::{Pattern, Utf8Pattern};\nuse core::{fmt, hash, ptr, slice};\n\n#[cfg(not(no_global_oom_handling))]\nuse crate::alloc::Allocator;\n#[cfg(not(no_global_oom_handling))]\nuse crate::borrow::{Cow, ToOwned};\nuse crate::boxed::Box;\nuse crate::collections::TryReserveError;\nuse crate::str::{self, CharIndices, Chars, Utf8Error, from_utf8_unchecked_mut};\n#[cfg(not(no_global_oom_handling))]\nuse crate::str::{FromStr, from_boxed_utf8_unchecked};\nuse crate::vec::{self, Vec};\n\n/// A UTF-8–encoded, growable string.\n///\n/// `String` is the most common string type. It has ownership over the contents\n/// of the string, stored in a heap-allocated buffer (see [Representation](#representation)).\n/// It is closely related to its borrowed counterpart, the primitive [`str`].\n///\n/// # Examples\n///\n/// You can create a `String` from [a literal string][`&str`] with [`String::from`]:\n///\n/// [`String::from`]: From::from\n///\n/// ```\n/// let hello = String::from(\"Hello, world!\");\n/// ```\n///\n/// You can append a [`char`] to a `String` with the [`push`] method, and\n/// append a [`&str`] with the [`push_str`] method:\n///\n/// ```\n/// let mut hello = String::from(\"Hello, \");\n///\n/// hello.push('w');\n/// hello.push_str(\"orld!\");\n/// ```\n///\n/// [`push`]: String::push\n/// [`push_str`]: String::push_str\n///\n/// If you have a vector of UTF-8 bytes, you can create a `String` from it with\n/// the [`from_utf8`] method:\n///\n/// ```\n/// // some bytes, in a vector\n/// let sparkle_heart = vec![240, 159, 146, 150];\n///\n/// // We know these bytes are valid, so we'll use `unwrap()`.\n/// let sparkle_heart = String::from_utf8(sparkle_heart).unwrap();\n///\n/// assert_eq!(\"💖\", sparkle_heart);\n/// ```\n///\n/// [`from_utf8`]: String::from_utf8\n///\n/// # UTF-8\n///\n/// `String`s are always valid UTF-8. If you need a non-UTF-8 string, consider\n/// [`OsString`]. It is similar, but without the UTF-8 constraint. Because UTF-8\n/// is a variable width encoding, `String`s are typically smaller than an array of\n/// the same `char`s:\n///\n/// ```\n/// // `s` is ASCII which represents each `char` as one byte\n/// let s = \"hello\";\n/// assert_eq!(s.len(), 5);\n///\n/// // A `char` array with the same contents would be longer because\n/// // every `char` is four bytes\n/// let s = ['h', 'e', 'l', 'l', 'o'];\n/// let size: usize = s.into_iter().map(|c| size_of_val(&c)).sum();\n/// assert_eq!(size, 20);\n///\n/// // However, for non-ASCII strings, the difference will be smaller\n/// // and sometimes they are the same\n/// let s = \"💖💖💖💖💖\";\n/// assert_eq!(s.len(), 20);\n///\n/// let s = ['💖', '💖', '💖', '💖', '💖'];\n/// let size: usize = s.into_iter().map(|c| size_of_val(&c)).sum();\n/// assert_eq!(size, 20);\n/// ```\n///\n/// This raises interesting questions as to how `s[i]` should work.\n/// What should `i` be here? Several options include byte indices and\n/// `char` indices but, because of UTF-8 encoding, only byte indices\n/// would provide constant time indexing. Getting the `i`th `char`, for\n/// example, is available using [`chars`]:\n///\n/// ```\n/// let s = \"hello\";\n/// let third_character = s.chars().nth(2);\n/// assert_eq!(third_character, Some('l'));\n///\n/// let s = \"💖💖💖💖💖\";\n/// let third_character = s.chars().nth(2);\n/// assert_eq!(third_character, Some('💖'));\n/// ```\n///\n/// Next, what should `s[i]` return? Because indexing returns a reference\n/// to underlying data it could be `&u8`, `&[u8]`, or something similar.\n/// Since we're only providing one index, `&u8` makes the most sense but that\n/// might not be what the user expects and can be explicitly achieved with\n/// [`as_bytes()`]:\n///\n/// ```\n/// // The first byte is 104 - the byte value of `'h'`\n/// let s = \"hello\";\n/// assert_eq!(s.as_bytes()[0], 104);\n/// // or\n/// assert_eq!(s.as_bytes()[0], b'h');\n///\n/// // The first byte is 240 which isn't obviously useful\n/// let s = \"💖💖💖💖💖\";\n/// assert_eq!(s.as_bytes()[0], 240);\n/// ```\n///\n/// Due to these ambiguities/restrictions, indexing with a `usize` is simply\n/// forbidden:\n///\n/// ```compile_fail,E0277\n/// let s = \"hello\";\n///\n/// // The following will not compile!\n/// println!(\"The first letter of s is {}\", s[0]);\n/// ```\n///\n/// It is more clear, however, how `&s[i..j]` should work (that is,\n/// indexing with a range). It should accept byte indices (to be constant-time)\n/// and return a `&str` which is UTF-8 encoded. This is also called \"string slicing\".\n/// Note this will panic if the byte indices provided are not character\n/// boundaries - see [`is_char_boundary`] for more details. See the implementations\n/// for [`SliceIndex<str>`] for more details on string slicing. For a non-panicking\n/// version of string slicing, see [`get`].\n///\n/// [`OsString`]: ../../std/ffi/struct.OsString.html \"ffi::OsString\"\n/// [`SliceIndex<str>`]: core::slice::SliceIndex\n/// [`as_bytes()`]: str::as_bytes\n/// [`get`]: str::get\n/// [`is_char_boundary`]: str::is_char_boundary\n///\n/// The [`bytes`] and [`chars`] methods return iterators over the bytes and\n/// codepoints of the string, respectively. To iterate over codepoints along\n/// with byte indices, use [`char_indices`].\n///\n/// [`bytes`]: str::bytes\n/// [`chars`]: str::chars\n/// [`char_indices`]: str::char_indices\n///\n/// # Deref\n///\n/// `String` implements <code>[Deref]<Target = [str]></code>, and so inherits all of [`str`]'s\n/// methods. In addition, this means that you can pass a `String` to a\n/// function which takes a [`&str`] by using an ampersand (`&`):\n///\n/// ```\n/// fn takes_str(s: &str) { }\n///\n/// let s = String::from(\"Hello\");\n///\n/// takes_str(&s);\n/// ```\n///\n/// This will create a [`&str`] from the `String` and pass it in. This\n/// conversion is very inexpensive, and so generally, functions will accept\n/// [`&str`]s as arguments unless they need a `String` for some specific\n/// reason.\n///\n/// In certain cases Rust doesn't have enough information to make this\n/// conversion, known as [`Deref`] coercion. In the following example a string\n/// slice [`&'a str`][`&str`] implements the trait `TraitExample`, and the function\n/// `example_func` takes anything that implements the trait. In this case Rust\n/// would need to make two implicit conversions, which Rust doesn't have the\n/// means to do. For that reason, the following example will not compile.\n///\n/// ```compile_fail,E0277\n/// trait TraitExample {}\n///\n/// impl<'a> TraitExample for &'a str {}\n///\n/// fn example_func<A: TraitExample>(example_arg: A) {}\n///\n/// let example_string = String::from(\"example_string\");\n/// example_func(&example_string);\n/// ```\n///\n/// There are two options that would work instead. The first would be to\n/// change the line `example_func(&example_string);` to\n/// `example_func(example_string.as_str());`, using the method [`as_str()`]\n/// to explicitly extract the string slice containing the string. The second\n/// way changes `example_func(&example_string);` to\n/// `example_func(&*example_string);`. In this case we are dereferencing a\n/// `String` to a [`str`], then referencing the [`str`] back to\n/// [`&str`]. The second way is more idiomatic, however both work to do the\n/// conversion explicitly rather than relying on the implicit conversion.\n///\n/// # Representation\n///\n/// A `String` is made up of three components: a pointer to some bytes, a\n/// length, and a capacity. The pointer points to the internal buffer which `String`\n/// uses to store its data. The length is the number of bytes currently stored\n/// in the buffer, and the capacity is the size of the buffer in bytes. As such,\n/// the length will always be less than or equal to the capacity.\n///\n/// This buffer is always stored on the heap.\n///\n/// You can look at these with the [`as_ptr`], [`len`], and [`capacity`]\n/// methods:\n///\n/// ```\n/// let story = String::from(\"Once upon a time...\");\n///\n/// // Deconstruct the String into parts.\n/// let (ptr, len, capacity) = story.into_raw_parts();\n///\n/// // story has nineteen bytes\n/// assert_eq!(19, len);\n///\n/// // We can re-build a String out of ptr, len, and capacity. This is all\n/// // unsafe because we are responsible for making sure the components are\n/// // valid:\n/// let s = unsafe { String::from_raw_parts(ptr, len, capacity) } ;\n///\n/// assert_eq!(String::from(\"Once upon a time...\"), s);\n/// ```\n///\n/// [`as_ptr`]: str::as_ptr\n/// [`len`]: String::len\n/// [`capacity`]: String::capacity\n///\n/// If a `String` has enough capacity, adding elements to it will not\n/// re-allocate. For example, consider this program:\n///\n/// ```\n/// let mut s = String::new();\n///\n/// println!(\"{}\", s.capacity());\n///\n/// for _ in 0..5 {\n///     s.push_str(\"hello\");\n///     println!(\"{}\", s.capacity());\n/// }\n/// ```\n///\n/// This will output the following:\n///\n/// ```text\n/// 0\n/// 8\n/// 16\n/// 16\n/// 32\n/// 32\n/// ```\n///\n/// At first, we have no memory allocated at all, but as we append to the\n/// string, it increases its capacity appropriately. If we instead use the\n/// [`with_capacity`] method to allocate the correct capacity initially:\n///\n/// ```\n/// let mut s = String::with_capacity(25);\n///\n/// println!(\"{}\", s.capacity());\n///\n/// for _ in 0..5 {\n///     s.push_str(\"hello\");\n///     println!(\"{}\", s.capacity());\n/// }\n/// ```\n///\n/// [`with_capacity`]: String::with_capacity\n///\n/// We end up with a different output:\n///\n/// ```text\n/// 25\n/// 25\n/// 25\n/// 25\n/// 25\n/// 25\n/// ```\n///\n/// Here, there's no need to allocate more memory inside the loop.\n///\n/// [str]: prim@str \"str\"\n/// [`str`]: prim@str \"str\"\n/// [`&str`]: prim@str \"&str\"\n/// [Deref]: core::ops::Deref \"ops::Deref\"\n/// [`Deref`]: core::ops::Deref \"ops::Deref\"\n/// [`as_str()`]: String::as_str\n#[derive(PartialEq, PartialOrd, Eq, Ord)]\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\n#[lang = \"String\"]\npub struct String {\n    vec: Vec<u8>,\n}\n\n/// A possible error value when converting a `String` from a UTF-8 byte vector.\n///\n/// This type is the error type for the [`from_utf8`] method on [`String`]. It\n/// is designed in such a way to carefully avoid reallocations: the\n/// [`into_bytes`] method will give back the byte vector that was used in the\n/// conversion attempt.\n///\n/// [`from_utf8`]: String::from_utf8\n/// [`into_bytes`]: FromUtf8Error::into_bytes\n///\n/// The [`Utf8Error`] type provided by [`std::str`] represents an error that may\n/// occur when converting a slice of [`u8`]s to a [`&str`]. In this sense, it's\n/// an analogue to `FromUtf8Error`, and you can get one from a `FromUtf8Error`\n/// through the [`utf8_error`] method.\n///\n/// [`Utf8Error`]: str::Utf8Error \"std::str::Utf8Error\"\n/// [`std::str`]: core::str \"std::str\"\n/// [`&str`]: prim@str \"&str\"\n/// [`utf8_error`]: FromUtf8Error::utf8_error\n///\n/// # Examples\n///\n/// ```\n/// // some invalid bytes, in a vector\n/// let bytes = vec![0, 159];\n///\n/// let value = String::from_utf8(bytes);\n///\n/// assert!(value.is_err());\n/// assert_eq!(vec![0, 159], value.unwrap_err().into_bytes());\n/// ```\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\n#[cfg_attr(not(no_global_oom_handling), derive(Clone))]\n#[derive(Debug, PartialEq, Eq)]\npub struct FromUtf8Error {\n    bytes: Vec<u8>,\n    error: Utf8Error,\n}\n\n/// A possible error value when converting a `String` from a UTF-16 byte slice.\n///\n/// This type is the error type for the [`from_utf16`] method on [`String`].\n///\n/// [`from_utf16`]: String::from_utf16\n///\n/// # Examples\n///\n/// ```\n/// // 𝄞mu<invalid>ic\n/// let v = &[0xD834, 0xDD1E, 0x006d, 0x0075,\n///           0xD800, 0x0069, 0x0063];\n///\n/// assert!(String::from_utf16(v).is_err());\n/// ```\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\n#[derive(Debug)]\npub struct FromUtf16Error(());\n\nimpl String {\n    /// Creates a new empty `String`.\n    ///\n    /// Given that the `String` is empty, this will not allocate any initial\n    /// buffer. While that means that this initial operation is very\n    /// inexpensive, it may cause excessive allocation later when you add\n    /// data. If you have an idea of how much data the `String` will hold,\n    /// consider the [`with_capacity`] method to prevent excessive\n    /// re-allocation.\n    ///\n    /// [`with_capacity`]: String::with_capacity\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let s = String::new();\n    /// ```\n    #[inline]\n    #[rustc_const_stable(feature = \"const_string_new\", since = \"1.39.0\")]\n    #[rustc_diagnostic_item = \"string_new\"]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[must_use]\n    pub const fn new() -> String {\n        String { vec: Vec::new() }\n    }\n\n    /// Creates a new empty `String` with at least the specified capacity.\n    ///\n    /// `String`s have an internal buffer to hold their data. The capacity is\n    /// the length of that buffer, and can be queried with the [`capacity`]\n    /// method. This method creates an empty `String`, but one with an initial\n    /// buffer that can hold at least `capacity` bytes. This is useful when you\n    /// may be appending a bunch of data to the `String`, reducing the number of\n    /// reallocations it needs to do.\n    ///\n    /// [`capacity`]: String::capacity\n    ///\n    /// If the given capacity is `0`, no allocation will occur, and this method\n    /// is identical to the [`new`] method.\n    ///\n    /// [`new`]: String::new\n    ///\n    /// # Panics\n    ///\n    /// Panics if the capacity exceeds `isize::MAX` _bytes_.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut s = String::with_capacity(10);\n    ///\n    /// // The String contains no chars, even though it has capacity for more\n    /// assert_eq!(s.len(), 0);\n    ///\n    /// // These are all done without reallocating...\n    /// let cap = s.capacity();\n    /// for _ in 0..10 {\n    ///     s.push('a');\n    /// }\n    ///\n    /// assert_eq!(s.capacity(), cap);\n    ///\n    /// // ...but this may make the string reallocate\n    /// s.push('a');\n    /// ```\n    #[cfg(not(no_global_oom_handling))]\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[must_use]\n    pub fn with_capacity(capacity: usize) -> String {\n        String { vec: Vec::with_capacity(capacity) }\n    }\n\n    /// Creates a new empty `String` with at least the specified capacity.\n    ///\n    /// # Errors\n    ///\n    /// Returns [`Err`] if the capacity exceeds `isize::MAX` bytes,\n    /// or if the memory allocator reports failure.\n    ///\n    #[inline]\n    #[unstable(feature = \"try_with_capacity\", issue = \"91913\")]\n    pub fn try_with_capacity(capacity: usize) -> Result<String, TryReserveError> {\n        Ok(String { vec: Vec::try_with_capacity(capacity)? })\n    }\n\n    /// Converts a vector of bytes to a `String`.\n    ///\n    /// A string ([`String`]) is made of bytes ([`u8`]), and a vector of bytes\n    /// ([`Vec<u8>`]) is made of bytes, so this function converts between the\n    /// two. Not all byte slices are valid `String`s, however: `String`\n    /// requires that it is valid UTF-8. `from_utf8()` checks to ensure that\n    /// the bytes are valid UTF-8, and then does the conversion.\n    ///\n    /// If you are sure that the byte slice is valid UTF-8, and you don't want\n    /// to incur the overhead of the validity check, there is an unsafe version\n    /// of this function, [`from_utf8_unchecked`], which has the same behavior\n    /// but skips the check.\n    ///\n    /// This method will take care to not copy the vector, for efficiency's\n    /// sake.\n    ///\n    /// If you need a [`&str`] instead of a `String`, consider\n    /// [`str::from_utf8`].\n    ///\n    /// The inverse of this method is [`into_bytes`].\n    ///\n    /// # Errors\n    ///\n    /// Returns [`Err`] if the slice is not UTF-8 with a description as to why the\n    /// provided bytes are not UTF-8. The vector you moved in is also included.\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// // some bytes, in a vector\n    /// let sparkle_heart = vec![240, 159, 146, 150];\n    ///\n    /// // We know these bytes are valid, so we'll use `unwrap()`.\n    /// let sparkle_heart = String::from_utf8(sparkle_heart).unwrap();\n    ///\n    /// assert_eq!(\"💖\", sparkle_heart);\n    /// ```\n    ///\n    /// Incorrect bytes:\n    ///\n    /// ```\n    /// // some invalid bytes, in a vector\n    /// let sparkle_heart = vec![0, 159, 146, 150];\n    ///\n    /// assert!(String::from_utf8(sparkle_heart).is_err());\n    /// ```\n    ///\n    /// See the docs for [`FromUtf8Error`] for more details on what you can do\n    /// with this error.\n    ///\n    /// [`from_utf8_unchecked`]: String::from_utf8_unchecked\n    /// [`Vec<u8>`]: crate::vec::Vec \"Vec\"\n    /// [`&str`]: prim@str \"&str\"\n    /// [`into_bytes`]: String::into_bytes\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_diagnostic_item = \"string_from_utf8\"]\n    pub fn from_utf8(vec: Vec<u8>) -> Result<String, FromUtf8Error> {\n        match str::from_utf8(&vec) {\n            Ok(..) => Ok(String { vec }),\n            Err(e) => Err(FromUtf8Error { bytes: vec, error: e }),\n        }\n    }\n\n    /// Converts a slice of bytes to a string, including invalid characters.\n    ///\n    /// Strings are made of bytes ([`u8`]), and a slice of bytes\n    /// ([`&[u8]`][byteslice]) is made of bytes, so this function converts\n    /// between the two. Not all byte slices are valid strings, however: strings\n    /// are required to be valid UTF-8. During this conversion,\n    /// `from_utf8_lossy()` will replace any invalid UTF-8 sequences with\n    /// [`U+FFFD REPLACEMENT CHARACTER`][U+FFFD], which looks like this: �\n    ///\n    /// [byteslice]: prim@slice\n    /// [U+FFFD]: core::char::REPLACEMENT_CHARACTER\n    ///\n    /// If you are sure that the byte slice is valid UTF-8, and you don't want\n    /// to incur the overhead of the conversion, there is an unsafe version\n    /// of this function, [`from_utf8_unchecked`], which has the same behavior\n    /// but skips the checks.\n    ///\n    /// [`from_utf8_unchecked`]: String::from_utf8_unchecked\n    ///\n    /// This function returns a [`Cow<'a, str>`]. If our byte slice is invalid\n    /// UTF-8, then we need to insert the replacement characters, which will\n    /// change the size of the string, and hence, require a `String`. But if\n    /// it's already valid UTF-8, we don't need a new allocation. This return\n    /// type allows us to handle both cases.\n    ///\n    /// [`Cow<'a, str>`]: crate::borrow::Cow \"borrow::Cow\"\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// // some bytes, in a vector\n    /// let sparkle_heart = vec![240, 159, 146, 150];\n    ///\n    /// let sparkle_heart = String::from_utf8_lossy(&sparkle_heart);\n    ///\n    /// assert_eq!(\"💖\", sparkle_heart);\n    /// ```\n    ///\n    /// Incorrect bytes:\n    ///\n    /// ```\n    /// // some invalid bytes\n    /// let input = b\"Hello \\xF0\\x90\\x80World\";\n    /// let output = String::from_utf8_lossy(input);\n    ///\n    /// assert_eq!(\"Hello �World\", output);\n    /// ```\n    #[must_use]\n    #[cfg(not(no_global_oom_handling))]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    pub fn from_utf8_lossy(v: &[u8]) -> Cow<'_, str> {\n        let mut iter = v.utf8_chunks();\n\n        let first_valid = if let Some(chunk) = iter.next() {\n            let valid = chunk.valid();\n            if chunk.invalid().is_empty() {\n                debug_assert_eq!(valid.len(), v.len());\n                return Cow::Borrowed(valid);\n            }\n            valid\n        } else {\n            return Cow::Borrowed(\"\");\n        };\n\n        const REPLACEMENT: &str = \"\\u{FFFD}\";\n\n        let mut res = String::with_capacity(v.len());\n        res.push_str(first_valid);\n        res.push_str(REPLACEMENT);\n\n        for chunk in iter {\n            res.push_str(chunk.valid());\n            if !chunk.invalid().is_empty() {\n                res.push_str(REPLACEMENT);\n            }\n        }\n\n        Cow::Owned(res)\n    }\n\n    /// Converts a [`Vec<u8>`] to a `String`, substituting invalid UTF-8\n    /// sequences with replacement characters.\n    ///\n    /// See [`from_utf8_lossy`] for more details.\n    ///\n    /// [`from_utf8_lossy`]: String::from_utf8_lossy\n    ///\n    /// Note that this function does not guarantee reuse of the original `Vec`\n    /// allocation.\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// #![feature(string_from_utf8_lossy_owned)]\n    /// // some bytes, in a vector\n    /// let sparkle_heart = vec![240, 159, 146, 150];\n    ///\n    /// let sparkle_heart = String::from_utf8_lossy_owned(sparkle_heart);\n    ///\n    /// assert_eq!(String::from(\"💖\"), sparkle_heart);\n    /// ```\n    ///\n    /// Incorrect bytes:\n    ///\n    /// ```\n    /// #![feature(string_from_utf8_lossy_owned)]\n    /// // some invalid bytes\n    /// let input: Vec<u8> = b\"Hello \\xF0\\x90\\x80World\".into();\n    /// let output = String::from_utf8_lossy_owned(input);\n    ///\n    /// assert_eq!(String::from(\"Hello �World\"), output);\n    /// ```\n    #[must_use]\n    #[cfg(not(no_global_oom_handling))]\n    #[unstable(feature = \"string_from_utf8_lossy_owned\", issue = \"129436\")]\n    pub fn from_utf8_lossy_owned(v: Vec<u8>) -> String {\n        if let Cow::Owned(string) = String::from_utf8_lossy(&v) {\n            string\n        } else {\n            // SAFETY: `String::from_utf8_lossy`'s contract ensures that if\n            // it returns a `Cow::Borrowed`, it is a valid UTF-8 string.\n            // Otherwise, it returns a new allocation of an owned `String`, with\n            // replacement characters for invalid sequences, which is returned\n            // above.\n            unsafe { String::from_utf8_unchecked(v) }\n        }\n    }\n\n    /// Decode a native endian UTF-16–encoded vector `v` into a `String`,\n    /// returning [`Err`] if `v` contains any invalid data.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// // 𝄞music\n    /// let v = &[0xD834, 0xDD1E, 0x006d, 0x0075,\n    ///           0x0073, 0x0069, 0x0063];\n    /// assert_eq!(String::from(\"𝄞music\"),\n    ///            String::from_utf16(v).unwrap());\n    ///\n    /// // 𝄞mu<invalid>ic\n    /// let v = &[0xD834, 0xDD1E, 0x006d, 0x0075,\n    ///           0xD800, 0x0069, 0x0063];\n    /// assert!(String::from_utf16(v).is_err());\n    /// ```\n    #[cfg(not(no_global_oom_handling))]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    pub fn from_utf16(v: &[u16]) -> Result<String, FromUtf16Error> {\n        // This isn't done via collect::<Result<_, _>>() for performance reasons.\n        // FIXME: the function can be simplified again when #48994 is closed.\n        let mut ret = String::with_capacity(v.len());\n        for c in char::decode_utf16(v.iter().cloned()) {\n            if let Ok(c) = c {\n                ret.push(c);\n            } else {\n                return Err(FromUtf16Error(()));\n            }\n        }\n        Ok(ret)\n    }\n\n    /// Decode a native endian UTF-16–encoded slice `v` into a `String`,\n    /// replacing invalid data with [the replacement character (`U+FFFD`)][U+FFFD].\n    ///\n    /// Unlike [`from_utf8_lossy`] which returns a [`Cow<'a, str>`],\n    /// `from_utf16_lossy` returns a `String` since the UTF-16 to UTF-8\n    /// conversion requires a memory allocation.\n    ///\n    /// [`from_utf8_lossy`]: String::from_utf8_lossy\n    /// [`Cow<'a, str>`]: crate::borrow::Cow \"borrow::Cow\"\n    /// [U+FFFD]: core::char::REPLACEMENT_CHARACTER\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// // 𝄞mus<invalid>ic<invalid>\n    /// let v = &[0xD834, 0xDD1E, 0x006d, 0x0075,\n    ///           0x0073, 0xDD1E, 0x0069, 0x0063,\n    ///           0xD834];\n    ///\n    /// assert_eq!(String::from(\"𝄞mus\\u{FFFD}ic\\u{FFFD}\"),\n    ///            String::from_utf16_lossy(v));\n    /// ```\n    #[cfg(not(no_global_oom_handling))]\n    #[must_use]\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    pub fn from_utf16_lossy(v: &[u16]) -> String {\n        char::decode_utf16(v.iter().cloned())\n            .map(|r| r.unwrap_or(char::REPLACEMENT_CHARACTER))\n            .collect()\n    }\n\n    /// Decode a UTF-16LE–encoded vector `v` into a `String`,\n    /// returning [`Err`] if `v` contains any invalid data.\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// #![feature(str_from_utf16_endian)]\n    /// // 𝄞music\n    /// let v = &[0x34, 0xD8, 0x1E, 0xDD, 0x6d, 0x00, 0x75, 0x00,\n    ///           0x73, 0x00, 0x69, 0x00, 0x63, 0x00];\n    /// assert_eq!(String::from(\"𝄞music\"),\n    ///            String::from_utf16le(v).unwrap());\n    ///\n    /// // 𝄞mu<invalid>ic\n    /// let v = &[0x34, 0xD8, 0x1E, 0xDD, 0x6d, 0x00, 0x75, 0x00,\n    ///           0x00, 0xD8, 0x69, 0x00, 0x63, 0x00];\n    /// assert!(String::from_utf16le(v).is_err());\n    /// ```\n    #[cfg(not(no_global_oom_handling))]\n    #[unstable(feature = \"str_from_utf16_endian\", issue = \"116258\")]\n    pub fn from_utf16le(v: &[u8]) -> Result<String, FromUtf16Error> {\n        let (chunks, []) = v.as_chunks::<2>() else {\n            return Err(FromUtf16Error(()));\n        };\n        match (cfg!(target_endian = \"little\"), unsafe { v.align_to::<u16>() }) {\n            (true, ([], v, [])) => Self::from_utf16(v),\n            _ => char::decode_utf16(chunks.iter().copied().map(u16::from_le_bytes))\n                .collect::<Result<_, _>>()\n                .map_err(|_| FromUtf16Error(())),\n        }\n    }\n\n    /// Decode a UTF-16LE–encoded slice `v` into a `String`, replacing\n    /// invalid data with [the replacement character (`U+FFFD`)][U+FFFD].\n    ///\n    /// Unlike [`from_utf8_lossy`] which returns a [`Cow<'a, str>`],\n    /// `from_utf16le_lossy` returns a `String` since the UTF-16 to UTF-8\n    /// conversion requires a memory allocation.\n    ///\n    /// [`from_utf8_lossy`]: String::from_utf8_lossy\n    /// [`Cow<'a, str>`]: crate::borrow::Cow \"borrow::Cow\"\n    /// [U+FFFD]: core::char::REPLACEMENT_CHARACTER\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// #![feature(str_from_utf16_endian)]\n    /// // 𝄞mus<invalid>ic<invalid>\n    /// let v = &[0x34, 0xD8, 0x1E, 0xDD, 0x6d, 0x00, 0x75, 0x00,\n    ///           0x73, 0x00, 0x1E, 0xDD, 0x69, 0x00, 0x63, 0x00,\n    ///           0x34, 0xD8];\n    ///\n    /// assert_eq!(String::from(\"𝄞mus\\u{FFFD}ic\\u{FFFD}\"),\n    ///            String::from_utf16le_lossy(v));\n    /// ```\n    #[cfg(not(no_global_oom_handling))]\n    #[unstable(feature = \"str_from_utf16_endian\", issue = \"116258\")]\n    pub fn from_utf16le_lossy(v: &[u8]) -> String {\n        match (cfg!(target_endian = \"little\"), unsafe { v.align_to::<u16>() }) {\n            (true, ([], v, [])) => Self::from_utf16_lossy(v),\n            (true, ([], v, [_remainder])) => Self::from_utf16_lossy(v) + \"\\u{FFFD}\",\n            _ => {\n                let (chunks, remainder) = v.as_chunks::<2>();\n                let string = char::decode_utf16(chunks.iter().copied().map(u16::from_le_bytes))\n                    .map(|r| r.unwrap_or(char::REPLACEMENT_CHARACTER))\n                    .collect();\n                if remainder.is_empty() { string } else { string + \"\\u{FFFD}\" }\n            }\n        }\n    }\n\n    /// Decode a UTF-16BE–encoded vector `v` into a `String`,\n    /// returning [`Err`] if `v` contains any invalid data.\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// #![feature(str_from_utf16_endian)]\n    /// // 𝄞music\n    /// let v = &[0xD8, 0x34, 0xDD, 0x1E, 0x00, 0x6d, 0x00, 0x75,\n    ///           0x00, 0x73, 0x00, 0x69, 0x00, 0x63];\n    /// assert_eq!(String::from(\"𝄞music\"),\n    ///            String::from_utf16be(v).unwrap());\n    ///\n    /// // 𝄞mu<invalid>ic\n    /// let v = &[0xD8, 0x34, 0xDD, 0x1E, 0x00, 0x6d, 0x00, 0x75,\n    ///           0xD8, 0x00, 0x00, 0x69, 0x00, 0x63];\n    /// assert!(String::from_utf16be(v).is_err());\n    /// ```\n    #[cfg(not(no_global_oom_handling))]\n    #[unstable(feature = \"str_from_utf16_endian\", issue = \"116258\")]\n    pub fn from_utf16be(v: &[u8]) -> Result<String, FromUtf16Error> {\n        let (chunks, []) = v.as_chunks::<2>() else {\n            return Err(FromUtf16Error(()));\n        };\n        match (cfg!(target_endian = \"big\"), unsafe { v.align_to::<u16>() }) {\n            (true, ([], v, [])) => Self::from_utf16(v),\n            _ => char::decode_utf16(chunks.iter().copied().map(u16::from_be_bytes))\n                .collect::<Result<_, _>>()\n                .map_err(|_| FromUtf16Error(())),\n        }\n    }\n\n    /// Decode a UTF-16BE–encoded slice `v` into a `String`, replacing\n    /// invalid data with [the replacement character (`U+FFFD`)][U+FFFD].\n    ///\n    /// Unlike [`from_utf8_lossy`] which returns a [`Cow<'a, str>`],\n    /// `from_utf16le_lossy` returns a `String` since the UTF-16 to UTF-8\n    /// conversion requires a memory allocation.\n    ///\n    /// [`from_utf8_lossy`]: String::from_utf8_lossy\n    /// [`Cow<'a, str>`]: crate::borrow::Cow \"borrow::Cow\"\n    /// [U+FFFD]: core::char::REPLACEMENT_CHARACTER\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// #![feature(str_from_utf16_endian)]\n    /// // 𝄞mus<invalid>ic<invalid>\n    /// let v = &[0xD8, 0x34, 0xDD, 0x1E, 0x00, 0x6d, 0x00, 0x75,\n    ///           0x00, 0x73, 0xDD, 0x1E, 0x00, 0x69, 0x00, 0x63,\n    ///           0xD8, 0x34];\n    ///\n    /// assert_eq!(String::from(\"𝄞mus\\u{FFFD}ic\\u{FFFD}\"),\n    ///            String::from_utf16be_lossy(v));\n    /// ```\n    #[cfg(not(no_global_oom_handling))]\n    #[unstable(feature = \"str_from_utf16_endian\", issue = \"116258\")]\n    pub fn from_utf16be_lossy(v: &[u8]) -> String {\n        match (cfg!(target_endian = \"big\"), unsafe { v.align_to::<u16>() }) {\n            (true, ([], v, [])) => Self::from_utf16_lossy(v),\n            (true, ([], v, [_remainder])) => Self::from_utf16_lossy(v) + \"\\u{FFFD}\",\n            _ => {\n                let (chunks, remainder) = v.as_chunks::<2>();\n                let string = char::decode_utf16(chunks.iter().copied().map(u16::from_be_bytes))\n                    .map(|r| r.unwrap_or(char::REPLACEMENT_CHARACTER))\n                    .collect();\n                if remainder.is_empty() { string } else { string + \"\\u{FFFD}\" }\n            }\n        }\n    }\n\n    /// Decomposes a `String` into its raw components: `(pointer, length, capacity)`.\n    ///\n    /// Returns the raw pointer to the underlying data, the length of\n    /// the string (in bytes), and the allocated capacity of the data\n    /// (in bytes). These are the same arguments in the same order as\n    /// the arguments to [`from_raw_parts`].\n    ///\n    /// After calling this function, the caller is responsible for the\n    /// memory previously managed by the `String`. The only way to do\n    /// this is to convert the raw pointer, length, and capacity back\n    /// into a `String` with the [`from_raw_parts`] function, allowing\n    /// the destructor to perform the cleanup.\n    ///\n    /// [`from_raw_parts`]: String::from_raw_parts\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let s = String::from(\"hello\");\n    ///\n    /// let (ptr, len, cap) = s.into_raw_parts();\n    ///\n    /// let rebuilt = unsafe { String::from_raw_parts(ptr, len, cap) };\n    /// assert_eq!(rebuilt, \"hello\");\n    /// ```\n    #[must_use = \"losing the pointer will leak memory\"]\n    #[stable(feature = \"vec_into_raw_parts\", since = \"1.93.0\")]\n    pub fn into_raw_parts(self) -> (*mut u8, usize, usize) {\n        self.vec.into_raw_parts()\n    }\n\n    /// Creates a new `String` from a pointer, a length and a capacity.\n    ///\n    /// # Safety\n    ///\n    /// This is highly unsafe, due to the number of invariants that aren't\n    /// checked:\n    ///\n    /// * all safety requirements for [`Vec::<u8>::from_raw_parts`].\n    /// * all safety requirements for [`String::from_utf8_unchecked`].\n    ///\n    /// Violating these may cause problems like corrupting the allocator's\n    /// internal data structures. For example, it is normally **not** safe to\n    /// build a `String` from a pointer to a C `char` array containing UTF-8\n    /// _unless_ you are certain that array was originally allocated by the\n    /// Rust standard library's allocator.\n    ///\n    /// The ownership of `buf` is effectively transferred to the\n    /// `String` which may then deallocate, reallocate or change the\n    /// contents of memory pointed to by the pointer at will. Ensure\n    /// that nothing else uses the pointer after calling this\n    /// function.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// unsafe {\n    ///     let s = String::from(\"hello\");\n    ///\n    ///     // Deconstruct the String into parts.\n    ///     let (ptr, len, capacity) = s.into_raw_parts();\n    ///\n    ///     let s = String::from_raw_parts(ptr, len, capacity);\n    ///\n    ///     assert_eq!(String::from(\"hello\"), s);\n    /// }\n    /// ```\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    pub unsafe fn from_raw_parts(buf: *mut u8, length: usize, capacity: usize) -> String {\n        unsafe { String { vec: Vec::from_raw_parts(buf, length, capacity) } }\n    }\n\n    /// Converts a vector of bytes to a `String` without checking that the\n    /// string contains valid UTF-8.\n    ///\n    /// See the safe version, [`from_utf8`], for more details.\n    ///\n    /// [`from_utf8`]: String::from_utf8\n    ///\n    /// # Safety\n    ///\n    /// This function is unsafe because it does not check that the bytes passed\n    /// to it are valid UTF-8. If this constraint is violated, it may cause\n    /// memory unsafety issues with future users of the `String`, as the rest of\n    /// the standard library assumes that `String`s are valid UTF-8.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// // some bytes, in a vector\n    /// let sparkle_heart = vec![240, 159, 146, 150];\n    ///\n    /// let sparkle_heart = unsafe {\n    ///     String::from_utf8_unchecked(sparkle_heart)\n    /// };\n    ///\n    /// assert_eq!(\"💖\", sparkle_heart);\n    /// ```\n    #[inline]\n    #[must_use]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    pub unsafe fn from_utf8_unchecked(bytes: Vec<u8>) -> String {\n        String { vec: bytes }\n    }\n\n    /// Converts a `String` into a byte vector.\n    ///\n    /// This consumes the `String`, so we do not need to copy its contents.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let s = String::from(\"hello\");\n    /// let bytes = s.into_bytes();\n    ///\n    /// assert_eq!(&[104, 101, 108, 108, 111][..], &bytes[..]);\n    /// ```\n    #[inline]\n    #[must_use = \"`self` will be dropped if the result is not used\"]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_const_stable(feature = \"const_vec_string_slice\", since = \"1.87.0\")]\n    #[rustc_allow_const_fn_unstable(const_precise_live_drops)]\n    pub const fn into_bytes(self) -> Vec<u8> {\n        self.vec\n    }\n\n    /// Extracts a string slice containing the entire `String`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let s = String::from(\"foo\");\n    ///\n    /// assert_eq!(\"foo\", s.as_str());\n    /// ```\n    #[inline]\n    #[must_use]\n    #[stable(feature = \"string_as_str\", since = \"1.7.0\")]\n    #[rustc_diagnostic_item = \"string_as_str\"]\n    #[rustc_const_stable(feature = \"const_vec_string_slice\", since = \"1.87.0\")]\n    pub const fn as_str(&self) -> &str {\n        // SAFETY: String contents are stipulated to be valid UTF-8, invalid contents are an error\n        // at construction.\n        unsafe { str::from_utf8_unchecked(self.vec.as_slice()) }\n    }\n\n    /// Converts a `String` into a mutable string slice.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut s = String::from(\"foobar\");\n    /// let s_mut_str = s.as_mut_str();\n    ///\n    /// s_mut_str.make_ascii_uppercase();\n    ///\n    /// assert_eq!(\"FOOBAR\", s_mut_str);\n    /// ```\n    #[inline]\n    #[must_use]\n    #[stable(feature = \"string_as_str\", since = \"1.7.0\")]\n    #[rustc_diagnostic_item = \"string_as_mut_str\"]\n    #[rustc_const_stable(feature = \"const_vec_string_slice\", since = \"1.87.0\")]\n    pub const fn as_mut_str(&mut self) -> &mut str {\n        // SAFETY: String contents are stipulated to be valid UTF-8, invalid contents are an error\n        // at construction.\n        unsafe { str::from_utf8_unchecked_mut(self.vec.as_mut_slice()) }\n    }\n\n    /// Appends a given string slice onto the end of this `String`.\n    ///\n    /// # Panics\n    ///\n    /// Panics if the new capacity exceeds `isize::MAX` _bytes_.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut s = String::from(\"foo\");\n    ///\n    /// s.push_str(\"bar\");\n    ///\n    /// assert_eq!(\"foobar\", s);\n    /// ```\n    #[cfg(not(no_global_oom_handling))]\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_confusables(\"append\", \"push\")]\n    #[rustc_diagnostic_item = \"string_push_str\"]\n    pub fn push_str(&mut self, string: &str) {\n        self.vec.extend_from_slice(string.as_bytes())\n    }\n\n    /// Copies elements from `src` range to the end of the string.\n    ///\n    /// # Panics\n    ///\n    /// Panics if the range has `start_bound > end_bound`, if the range is\n    /// bounded on either end and does not lie on a [`char`] boundary, or if the\n    /// new capacity exceeds `isize::MAX` bytes.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut string = String::from(\"abcde\");\n    ///\n    /// string.extend_from_within(2..);\n    /// assert_eq!(string, \"abcdecde\");\n    ///\n    /// string.extend_from_within(..2);\n    /// assert_eq!(string, \"abcdecdeab\");\n    ///\n    /// string.extend_from_within(4..8);\n    /// assert_eq!(string, \"abcdecdeabecde\");\n    /// ```\n    #[cfg(not(no_global_oom_handling))]\n    #[stable(feature = \"string_extend_from_within\", since = \"1.87.0\")]\n    #[track_caller]\n    pub fn extend_from_within<R>(&mut self, src: R)\n    where\n        R: RangeBounds<usize>,\n    {\n        let src @ Range { start, end } = slice::range(src, ..self.len());\n\n        assert!(self.is_char_boundary(start));\n        assert!(self.is_char_boundary(end));\n\n        self.vec.extend_from_within(src);\n    }\n\n    /// Returns this `String`'s capacity, in bytes.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let s = String::with_capacity(10);\n    ///\n    /// assert!(s.capacity() >= 10);\n    /// ```\n    #[inline]\n    #[must_use]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_const_stable(feature = \"const_vec_string_slice\", since = \"1.87.0\")]\n    pub const fn capacity(&self) -> usize {\n        self.vec.capacity()\n    }\n\n    /// Reserves capacity for at least `additional` bytes more than the\n    /// current length. The allocator may reserve more space to speculatively\n    /// avoid frequent allocations. After calling `reserve`,\n    /// capacity will be greater than or equal to `self.len() + additional`.\n    /// Does nothing if capacity is already sufficient.\n    ///\n    /// # Panics\n    ///\n    /// Panics if the new capacity exceeds `isize::MAX` _bytes_.\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// let mut s = String::new();\n    ///\n    /// s.reserve(10);\n    ///\n    /// assert!(s.capacity() >= 10);\n    /// ```\n    ///\n    /// This might not actually increase the capacity:\n    ///\n    /// ```\n    /// let mut s = String::with_capacity(10);\n    /// s.push('a');\n    /// s.push('b');\n    ///\n    /// // s now has a length of 2 and a capacity of at least 10\n    /// let capacity = s.capacity();\n    /// assert_eq!(2, s.len());\n    /// assert!(capacity >= 10);\n    ///\n    /// // Since we already have at least an extra 8 capacity, calling this...\n    /// s.reserve(8);\n    ///\n    /// // ... doesn't actually increase.\n    /// assert_eq!(capacity, s.capacity());\n    /// ```\n    #[cfg(not(no_global_oom_handling))]\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    pub fn reserve(&mut self, additional: usize) {\n        self.vec.reserve(additional)\n    }\n\n    /// Reserves the minimum capacity for at least `additional` bytes more than\n    /// the current length. Unlike [`reserve`], this will not\n    /// deliberately over-allocate to speculatively avoid frequent allocations.\n    /// After calling `reserve_exact`, capacity will be greater than or equal to\n    /// `self.len() + additional`. Does nothing if the capacity is already\n    /// sufficient.\n    ///\n    /// [`reserve`]: String::reserve\n    ///\n    /// # Panics\n    ///\n    /// Panics if the new capacity exceeds `isize::MAX` _bytes_.\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// let mut s = String::new();\n    ///\n    /// s.reserve_exact(10);\n    ///\n    /// assert!(s.capacity() >= 10);\n    /// ```\n    ///\n    /// This might not actually increase the capacity:\n    ///\n    /// ```\n    /// let mut s = String::with_capacity(10);\n    /// s.push('a');\n    /// s.push('b');\n    ///\n    /// // s now has a length of 2 and a capacity of at least 10\n    /// let capacity = s.capacity();\n    /// assert_eq!(2, s.len());\n    /// assert!(capacity >= 10);\n    ///\n    /// // Since we already have at least an extra 8 capacity, calling this...\n    /// s.reserve_exact(8);\n    ///\n    /// // ... doesn't actually increase.\n    /// assert_eq!(capacity, s.capacity());\n    /// ```\n    #[cfg(not(no_global_oom_handling))]\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    pub fn reserve_exact(&mut self, additional: usize) {\n        self.vec.reserve_exact(additional)\n    }\n\n    /// Tries to reserve capacity for at least `additional` bytes more than the\n    /// current length. The allocator may reserve more space to speculatively\n    /// avoid frequent allocations. After calling `try_reserve`, capacity will be\n    /// greater than or equal to `self.len() + additional` if it returns\n    /// `Ok(())`. Does nothing if capacity is already sufficient. This method\n    /// preserves the contents even if an error occurs.\n    ///\n    /// # Errors\n    ///\n    /// If the capacity overflows, or the allocator reports a failure, then an error\n    /// is returned.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// use std::collections::TryReserveError;\n    ///\n    /// fn process_data(data: &str) -> Result<String, TryReserveError> {\n    ///     let mut output = String::new();\n    ///\n    ///     // Pre-reserve the memory, exiting if we can't\n    ///     output.try_reserve(data.len())?;\n    ///\n    ///     // Now we know this can't OOM in the middle of our complex work\n    ///     output.push_str(data);\n    ///\n    ///     Ok(output)\n    /// }\n    /// # process_data(\"rust\").expect(\"why is the test harness OOMing on 4 bytes?\");\n    /// ```\n    #[stable(feature = \"try_reserve\", since = \"1.57.0\")]\n    pub fn try_reserve(&mut self, additional: usize) -> Result<(), TryReserveError> {\n        self.vec.try_reserve(additional)\n    }\n\n    /// Tries to reserve the minimum capacity for at least `additional` bytes\n    /// more than the current length. Unlike [`try_reserve`], this will not\n    /// deliberately over-allocate to speculatively avoid frequent allocations.\n    /// After calling `try_reserve_exact`, capacity will be greater than or\n    /// equal to `self.len() + additional` if it returns `Ok(())`.\n    /// Does nothing if the capacity is already sufficient.\n    ///\n    /// Note that the allocator may give the collection more space than it\n    /// requests. Therefore, capacity can not be relied upon to be precisely\n    /// minimal. Prefer [`try_reserve`] if future insertions are expected.\n    ///\n    /// [`try_reserve`]: String::try_reserve\n    ///\n    /// # Errors\n    ///\n    /// If the capacity overflows, or the allocator reports a failure, then an error\n    /// is returned.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// use std::collections::TryReserveError;\n    ///\n    /// fn process_data(data: &str) -> Result<String, TryReserveError> {\n    ///     let mut output = String::new();\n    ///\n    ///     // Pre-reserve the memory, exiting if we can't\n    ///     output.try_reserve_exact(data.len())?;\n    ///\n    ///     // Now we know this can't OOM in the middle of our complex work\n    ///     output.push_str(data);\n    ///\n    ///     Ok(output)\n    /// }\n    /// # process_data(\"rust\").expect(\"why is the test harness OOMing on 4 bytes?\");\n    /// ```\n    #[stable(feature = \"try_reserve\", since = \"1.57.0\")]\n    pub fn try_reserve_exact(&mut self, additional: usize) -> Result<(), TryReserveError> {\n        self.vec.try_reserve_exact(additional)\n    }\n\n    /// Shrinks the capacity of this `String` to match its length.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut s = String::from(\"foo\");\n    ///\n    /// s.reserve(100);\n    /// assert!(s.capacity() >= 100);\n    ///\n    /// s.shrink_to_fit();\n    /// assert_eq!(3, s.capacity());\n    /// ```\n    #[cfg(not(no_global_oom_handling))]\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    pub fn shrink_to_fit(&mut self) {\n        self.vec.shrink_to_fit()\n    }\n\n    /// Shrinks the capacity of this `String` with a lower bound.\n    ///\n    /// The capacity will remain at least as large as both the length\n    /// and the supplied value.\n    ///\n    /// If the current capacity is less than the lower limit, this is a no-op.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut s = String::from(\"foo\");\n    ///\n    /// s.reserve(100);\n    /// assert!(s.capacity() >= 100);\n    ///\n    /// s.shrink_to(10);\n    /// assert!(s.capacity() >= 10);\n    /// s.shrink_to(0);\n    /// assert!(s.capacity() >= 3);\n    /// ```\n    #[cfg(not(no_global_oom_handling))]\n    #[inline]\n    #[stable(feature = \"shrink_to\", since = \"1.56.0\")]\n    pub fn shrink_to(&mut self, min_capacity: usize) {\n        self.vec.shrink_to(min_capacity)\n    }\n\n    /// Appends the given [`char`] to the end of this `String`.\n    ///\n    /// # Panics\n    ///\n    /// Panics if the new capacity exceeds `isize::MAX` _bytes_.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut s = String::from(\"abc\");\n    ///\n    /// s.push('1');\n    /// s.push('2');\n    /// s.push('3');\n    ///\n    /// assert_eq!(\"abc123\", s);\n    /// ```\n    #[cfg(not(no_global_oom_handling))]\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    pub fn push(&mut self, ch: char) {\n        let len = self.len();\n        let ch_len = ch.len_utf8();\n        self.reserve(ch_len);\n\n        // SAFETY: Just reserved capacity for at least the length needed to encode `ch`.\n        unsafe {\n            core::char::encode_utf8_raw_unchecked(ch as u32, self.vec.as_mut_ptr().add(self.len()));\n            self.vec.set_len(len + ch_len);\n        }\n    }\n\n    /// Returns a byte slice of this `String`'s contents.\n    ///\n    /// The inverse of this method is [`from_utf8`].\n    ///\n    /// [`from_utf8`]: String::from_utf8\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let s = String::from(\"hello\");\n    ///\n    /// assert_eq!(&[104, 101, 108, 108, 111], s.as_bytes());\n    /// ```\n    #[inline]\n    #[must_use]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_const_stable(feature = \"const_vec_string_slice\", since = \"1.87.0\")]\n    pub const fn as_bytes(&self) -> &[u8] {\n        self.vec.as_slice()\n    }\n\n    /// Shortens this `String` to the specified length.\n    ///\n    /// If `new_len` is greater than or equal to the string's current length, this has no\n    /// effect.\n    ///\n    /// Note that this method has no effect on the allocated capacity\n    /// of the string\n    ///\n    /// # Panics\n    ///\n    /// Panics if `new_len` does not lie on a [`char`] boundary.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut s = String::from(\"hello\");\n    ///\n    /// s.truncate(2);\n    ///\n    /// assert_eq!(\"he\", s);\n    /// ```\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[track_caller]\n    pub fn truncate(&mut self, new_len: usize) {\n        if new_len <= self.len() {\n            assert!(self.is_char_boundary(new_len));\n            self.vec.truncate(new_len)\n        }\n    }\n\n    /// Removes the last character from the string buffer and returns it.\n    ///\n    /// Returns [`None`] if this `String` is empty.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut s = String::from(\"abč\");\n    ///\n    /// assert_eq!(s.pop(), Some('č'));\n    /// assert_eq!(s.pop(), Some('b'));\n    /// assert_eq!(s.pop(), Some('a'));\n    ///\n    /// assert_eq!(s.pop(), None);\n    /// ```\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    pub fn pop(&mut self) -> Option<char> {\n        let ch = self.chars().rev().next()?;\n        let newlen = self.len() - ch.len_utf8();\n        unsafe {\n            self.vec.set_len(newlen);\n        }\n        Some(ch)\n    }\n\n    /// Removes a [`char`] from this `String` at byte position `idx` and returns it.\n    ///\n    /// Copies all bytes after the removed char to new positions.\n    ///\n    /// Note that calling this in a loop can result in quadratic behavior.\n    ///\n    /// # Panics\n    ///\n    /// Panics if `idx` is larger than or equal to the `String`'s length,\n    /// or if it does not lie on a [`char`] boundary.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut s = String::from(\"abç\");\n    ///\n    /// assert_eq!(s.remove(0), 'a');\n    /// assert_eq!(s.remove(1), 'ç');\n    /// assert_eq!(s.remove(0), 'b');\n    /// ```\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[track_caller]\n    #[rustc_confusables(\"delete\", \"take\")]\n    pub fn remove(&mut self, idx: usize) -> char {\n        let ch = match self[idx..].chars().next() {\n            Some(ch) => ch,\n            None => panic!(\"cannot remove a char from the end of a string\"),\n        };\n\n        let next = idx + ch.len_utf8();\n        let len = self.len();\n        unsafe {\n            ptr::copy(self.vec.as_ptr().add(next), self.vec.as_mut_ptr().add(idx), len - next);\n            self.vec.set_len(len - (next - idx));\n        }\n        ch\n    }\n\n    /// Remove all matches of pattern `pat` in the `String`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(string_remove_matches)]\n    /// let mut s = String::from(\"Trees are not green, the sky is not blue.\");\n    /// s.remove_matches(\"not \");\n    /// assert_eq!(\"Trees are green, the sky is blue.\", s);\n    /// ```\n    ///\n    /// Matches will be detected and removed iteratively, so in cases where\n    /// patterns overlap, only the first pattern will be removed:\n    ///\n    /// ```\n    /// #![feature(string_remove_matches)]\n    /// let mut s = String::from(\"banana\");\n    /// s.remove_matches(\"ana\");\n    /// assert_eq!(\"bna\", s);\n    /// ```\n    #[cfg(not(no_global_oom_handling))]\n    #[unstable(feature = \"string_remove_matches\", reason = \"new API\", issue = \"72826\")]\n    pub fn remove_matches<P: Pattern>(&mut self, pat: P) {\n        use core::str::pattern::Searcher;\n\n        let rejections = {\n            let mut searcher = pat.into_searcher(self);\n            // Per Searcher::next:\n            //\n            // A Match result needs to contain the whole matched pattern,\n            // however Reject results may be split up into arbitrary many\n            // adjacent fragments. Both ranges may have zero length.\n            //\n            // In practice the implementation of Searcher::next_match tends to\n            // be more efficient, so we use it here and do some work to invert\n            // matches into rejections since that's what we want to copy below.\n            let mut front = 0;\n            let rejections: Vec<_> = from_fn(|| {\n                let (start, end) = searcher.next_match()?;\n                let prev_front = front;\n                front = end;\n                Some((prev_front, start))\n            })\n            .collect();\n            rejections.into_iter().chain(core::iter::once((front, self.len())))\n        };\n\n        let mut len = 0;\n        let ptr = self.vec.as_mut_ptr();\n\n        for (start, end) in rejections {\n            let count = end - start;\n            if start != len {\n                // SAFETY: per Searcher::next:\n                //\n                // The stream of Match and Reject values up to a Done will\n                // contain index ranges that are adjacent, non-overlapping,\n                // covering the whole haystack, and laying on utf8\n                // boundaries.\n                unsafe {\n                    ptr::copy(ptr.add(start), ptr.add(len), count);\n                }\n            }\n            len += count;\n        }\n\n        unsafe {\n            self.vec.set_len(len);\n        }\n    }\n\n    /// Retains only the characters specified by the predicate.\n    ///\n    /// In other words, remove all characters `c` such that `f(c)` returns `false`.\n    /// This method operates in place, visiting each character exactly once in the\n    /// original order, and preserves the order of the retained characters.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut s = String::from(\"f_o_ob_ar\");\n    ///\n    /// s.retain(|c| c != '_');\n    ///\n    /// assert_eq!(s, \"foobar\");\n    /// ```\n    ///\n    /// Because the elements are visited exactly once in the original order,\n    /// external state may be used to decide which elements to keep.\n    ///\n    /// ```\n    /// let mut s = String::from(\"abcde\");\n    /// let keep = [false, true, true, false, true];\n    /// let mut iter = keep.iter();\n    /// s.retain(|_| *iter.next().unwrap());\n    /// assert_eq!(s, \"bce\");\n    /// ```\n    #[inline]\n    #[stable(feature = \"string_retain\", since = \"1.26.0\")]\n    pub fn retain<F>(&mut self, mut f: F)\n    where\n        F: FnMut(char) -> bool,\n    {\n        struct SetLenOnDrop<'a> {\n            s: &'a mut String,\n            idx: usize,\n            del_bytes: usize,\n        }\n\n        impl<'a> Drop for SetLenOnDrop<'a> {\n            fn drop(&mut self) {\n                let new_len = self.idx - self.del_bytes;\n                debug_assert!(new_len <= self.s.len());\n                unsafe { self.s.vec.set_len(new_len) };\n            }\n        }\n\n        let len = self.len();\n        let mut guard = SetLenOnDrop { s: self, idx: 0, del_bytes: 0 };\n\n        while guard.idx < len {\n            let ch =\n                // SAFETY: `guard.idx` is positive-or-zero and less that len so the `get_unchecked`\n                // is in bound. `self` is valid UTF-8 like string and the returned slice starts at\n                // a unicode code point so the `Chars` always return one character.\n                unsafe { guard.s.get_unchecked(guard.idx..len).chars().next().unwrap_unchecked() };\n            let ch_len = ch.len_utf8();\n\n            if !f(ch) {\n                guard.del_bytes += ch_len;\n            } else if guard.del_bytes > 0 {\n                // SAFETY: `guard.idx` is in bound and `guard.del_bytes` represent the number of\n                // bytes that are erased from the string so the resulting `guard.idx -\n                // guard.del_bytes` always represent a valid unicode code point.\n                //\n                // `guard.del_bytes` >= `ch.len_utf8()`, so taking a slice with `ch.len_utf8()` len\n                // is safe.\n                ch.encode_utf8(unsafe {\n                    crate::slice::from_raw_parts_mut(\n                        guard.s.as_mut_ptr().add(guard.idx - guard.del_bytes),\n                        ch.len_utf8(),\n                    )\n                });\n            }\n\n            // Point idx to the next char\n            guard.idx += ch_len;\n        }\n\n        drop(guard);\n    }\n\n    /// Inserts a character into this `String` at byte position `idx`.\n    ///\n    /// Reallocates if `self.capacity()` is insufficient, which may involve copying all\n    /// `self.capacity()` bytes. Makes space for the insertion by copying all bytes of\n    /// `&self[idx..]` to new positions.\n    ///\n    /// Note that calling this in a loop can result in quadratic behavior.\n    ///\n    /// # Panics\n    ///\n    /// Panics if `idx` is larger than the `String`'s length, or if it does not\n    /// lie on a [`char`] boundary.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut s = String::with_capacity(3);\n    ///\n    /// s.insert(0, 'f');\n    /// s.insert(1, 'o');\n    /// s.insert(2, 'o');\n    ///\n    /// assert_eq!(\"foo\", s);\n    /// ```\n    #[cfg(not(no_global_oom_handling))]\n    #[inline]\n    #[track_caller]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_confusables(\"set\")]\n    pub fn insert(&mut self, idx: usize, ch: char) {\n        assert!(self.is_char_boundary(idx));\n\n        let len = self.len();\n        let ch_len = ch.len_utf8();\n        self.reserve(ch_len);\n\n        // SAFETY: Move the bytes starting from `idx` to their new location `ch_len`\n        // bytes ahead. This is safe because sufficient capacity was reserved, and `idx`\n        // is a char boundary.\n        unsafe {\n            ptr::copy(\n                self.vec.as_ptr().add(idx),\n                self.vec.as_mut_ptr().add(idx + ch_len),\n                len - idx,\n            );\n        }\n\n        // SAFETY: Encode the character into the vacated region if `idx != len`,\n        // or into the uninitialized spare capacity otherwise.\n        unsafe {\n            core::char::encode_utf8_raw_unchecked(ch as u32, self.vec.as_mut_ptr().add(idx));\n        }\n\n        // SAFETY: Update the length to include the newly added bytes.\n        unsafe {\n            self.vec.set_len(len + ch_len);\n        }\n    }\n\n    /// Inserts a string slice into this `String` at byte position `idx`.\n    ///\n    /// Reallocates if `self.capacity()` is insufficient, which may involve copying all\n    /// `self.capacity()` bytes. Makes space for the insertion by copying all bytes of\n    /// `&self[idx..]` to new positions.\n    ///\n    /// Note that calling this in a loop can result in quadratic behavior.\n    ///\n    /// # Panics\n    ///\n    /// Panics if `idx` is larger than the `String`'s length, or if it does not\n    /// lie on a [`char`] boundary.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut s = String::from(\"bar\");\n    ///\n    /// s.insert_str(0, \"foo\");\n    ///\n    /// assert_eq!(\"foobar\", s);\n    /// ```\n    #[cfg(not(no_global_oom_handling))]\n    #[inline]\n    #[track_caller]\n    #[stable(feature = \"insert_str\", since = \"1.16.0\")]\n    #[rustc_diagnostic_item = \"string_insert_str\"]\n    pub fn insert_str(&mut self, idx: usize, string: &str) {\n        assert!(self.is_char_boundary(idx));\n\n        let len = self.len();\n        let amt = string.len();\n        self.reserve(amt);\n\n        // SAFETY: Move the bytes starting from `idx` to their new location `amt` bytes\n        // ahead. This is safe because sufficient capacity was just reserved, and `idx`\n        // is a char boundary.\n        unsafe {\n            ptr::copy(self.vec.as_ptr().add(idx), self.vec.as_mut_ptr().add(idx + amt), len - idx);\n        }\n\n        // SAFETY: Copy the new string slice into the vacated region if `idx != len`,\n        // or into the uninitialized spare capacity otherwise. The borrow checker\n        // ensures that the source and destination do not overlap.\n        unsafe {\n            ptr::copy_nonoverlapping(string.as_ptr(), self.vec.as_mut_ptr().add(idx), amt);\n        }\n\n        // SAFETY: Update the length to include the newly added bytes.\n        unsafe {\n            self.vec.set_len(len + amt);\n        }\n    }\n\n    /// Returns a mutable reference to the contents of this `String`.\n    ///\n    /// # Safety\n    ///\n    /// This function is unsafe because the returned `&mut Vec` allows writing\n    /// bytes which are not valid UTF-8. If this constraint is violated, using\n    /// the original `String` after dropping the `&mut Vec` may violate memory\n    /// safety, as the rest of the standard library assumes that `String`s are\n    /// valid UTF-8.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut s = String::from(\"hello\");\n    ///\n    /// unsafe {\n    ///     let vec = s.as_mut_vec();\n    ///     assert_eq!(&[104, 101, 108, 108, 111][..], &vec[..]);\n    ///\n    ///     vec.reverse();\n    /// }\n    /// assert_eq!(s, \"olleh\");\n    /// ```\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_const_stable(feature = \"const_vec_string_slice\", since = \"1.87.0\")]\n    pub const unsafe fn as_mut_vec(&mut self) -> &mut Vec<u8> {\n        &mut self.vec\n    }\n\n    /// Returns the length of this `String`, in bytes, not [`char`]s or\n    /// graphemes. In other words, it might not be what a human considers the\n    /// length of the string.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let a = String::from(\"foo\");\n    /// assert_eq!(a.len(), 3);\n    ///\n    /// let fancy_f = String::from(\"ƒoo\");\n    /// assert_eq!(fancy_f.len(), 4);\n    /// assert_eq!(fancy_f.chars().count(), 3);\n    /// ```\n    #[inline]\n    #[must_use]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_const_stable(feature = \"const_vec_string_slice\", since = \"1.87.0\")]\n    #[rustc_confusables(\"length\", \"size\")]\n    #[rustc_no_implicit_autorefs]\n    pub const fn len(&self) -> usize {\n        self.vec.len()\n    }\n\n    /// Returns `true` if this `String` has a length of zero, and `false` otherwise.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut v = String::new();\n    /// assert!(v.is_empty());\n    ///\n    /// v.push('a');\n    /// assert!(!v.is_empty());\n    /// ```\n    #[inline]\n    #[must_use]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_const_stable(feature = \"const_vec_string_slice\", since = \"1.87.0\")]\n    #[rustc_no_implicit_autorefs]\n    pub const fn is_empty(&self) -> bool {\n        self.len() == 0\n    }\n\n    /// Splits the string into two at the given byte index.\n    ///\n    /// Returns a newly allocated `String`. `self` contains bytes `[0, at)`, and\n    /// the returned `String` contains bytes `[at, len)`. `at` must be on the\n    /// boundary of a UTF-8 code point.\n    ///\n    /// Note that the capacity of `self` does not change.\n    ///\n    /// # Panics\n    ///\n    /// Panics if `at` is not on a `UTF-8` code point boundary, or if it is beyond the last\n    /// code point of the string.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # fn main() {\n    /// let mut hello = String::from(\"Hello, World!\");\n    /// let world = hello.split_off(7);\n    /// assert_eq!(hello, \"Hello, \");\n    /// assert_eq!(world, \"World!\");\n    /// # }\n    /// ```\n    #[cfg(not(no_global_oom_handling))]\n    #[inline]\n    #[track_caller]\n    #[stable(feature = \"string_split_off\", since = \"1.16.0\")]\n    #[must_use = \"use `.truncate()` if you don't need the other half\"]\n    pub fn split_off(&mut self, at: usize) -> String {\n        assert!(self.is_char_boundary(at));\n        let other = self.vec.split_off(at);\n        unsafe { String::from_utf8_unchecked(other) }\n    }\n\n    /// Truncates this `String`, removing all contents.\n    ///\n    /// While this means the `String` will have a length of zero, it does not\n    /// touch its capacity.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut s = String::from(\"foo\");\n    ///\n    /// s.clear();\n    ///\n    /// assert!(s.is_empty());\n    /// assert_eq!(0, s.len());\n    /// assert_eq!(3, s.capacity());\n    /// ```\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    pub fn clear(&mut self) {\n        self.vec.clear()\n    }\n\n    /// Removes the specified range from the string in bulk, returning all\n    /// removed characters as an iterator.\n    ///\n    /// The returned iterator keeps a mutable borrow on the string to optimize\n    /// its implementation.\n    ///\n    /// # Panics\n    ///\n    /// Panics if the range has `start_bound > end_bound`, or, if the range is\n    /// bounded on either end and does not lie on a [`char`] boundary.\n    ///\n    /// # Leaking\n    ///\n    /// If the returned iterator goes out of scope without being dropped (due to\n    /// [`core::mem::forget`], for example), the string may still contain a copy\n    /// of any drained characters, or may have lost characters arbitrarily,\n    /// including characters outside the range.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut s = String::from(\"α is alpha, β is beta\");\n    /// let beta_offset = s.find('β').unwrap_or(s.len());\n    ///\n    /// // Remove the range up until the β from the string\n    /// let t: String = s.drain(..beta_offset).collect();\n    /// assert_eq!(t, \"α is alpha, \");\n    /// assert_eq!(s, \"β is beta\");\n    ///\n    /// // A full range clears the string, like `clear()` does\n    /// s.drain(..);\n    /// assert_eq!(s, \"\");\n    /// ```\n    #[stable(feature = \"drain\", since = \"1.6.0\")]\n    #[track_caller]\n    pub fn drain<R>(&mut self, range: R) -> Drain<'_>\n    where\n        R: RangeBounds<usize>,\n    {\n        // Memory safety\n        //\n        // The String version of Drain does not have the memory safety issues\n        // of the vector version. The data is just plain bytes.\n        // Because the range removal happens in Drop, if the Drain iterator is leaked,\n        // the removal will not happen.\n        let Range { start, end } = slice::range(range, ..self.len());\n        assert!(self.is_char_boundary(start));\n        assert!(self.is_char_boundary(end));\n\n        // Take out two simultaneous borrows. The &mut String won't be accessed\n        // until iteration is over, in Drop.\n        let self_ptr = self as *mut _;\n        // SAFETY: `slice::range` and `is_char_boundary` do the appropriate bounds checks.\n        let chars_iter = unsafe { self.get_unchecked(start..end) }.chars();\n\n        Drain { start, end, iter: chars_iter, string: self_ptr }\n    }\n\n    /// Converts a `String` into an iterator over the [`char`]s of the string.\n    ///\n    /// As a string consists of valid UTF-8, we can iterate through a string\n    /// by [`char`]. This method returns such an iterator.\n    ///\n    /// It's important to remember that [`char`] represents a Unicode Scalar\n    /// Value, and might not match your idea of what a 'character' is. Iteration\n    /// over grapheme clusters may be what you actually want. That functionality\n    /// is not provided by Rust's standard library, check crates.io instead.\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// #![feature(string_into_chars)]\n    ///\n    /// let word = String::from(\"goodbye\");\n    ///\n    /// let mut chars = word.into_chars();\n    ///\n    /// assert_eq!(Some('g'), chars.next());\n    /// assert_eq!(Some('o'), chars.next());\n    /// assert_eq!(Some('o'), chars.next());\n    /// assert_eq!(Some('d'), chars.next());\n    /// assert_eq!(Some('b'), chars.next());\n    /// assert_eq!(Some('y'), chars.next());\n    /// assert_eq!(Some('e'), chars.next());\n    ///\n    /// assert_eq!(None, chars.next());\n    /// ```\n    ///\n    /// Remember, [`char`]s might not match your intuition about characters:\n    ///\n    /// ```\n    /// #![feature(string_into_chars)]\n    ///\n    /// let y = String::from(\"y̆\");\n    ///\n    /// let mut chars = y.into_chars();\n    ///\n    /// assert_eq!(Some('y'), chars.next()); // not 'y̆'\n    /// assert_eq!(Some('\\u{0306}'), chars.next());\n    ///\n    /// assert_eq!(None, chars.next());\n    /// ```\n    ///\n    /// [`char`]: prim@char\n    #[inline]\n    #[must_use = \"`self` will be dropped if the result is not used\"]\n    #[unstable(feature = \"string_into_chars\", issue = \"133125\")]\n    pub fn into_chars(self) -> IntoChars {\n        IntoChars { bytes: self.into_bytes().into_iter() }\n    }\n\n    /// Removes the specified range in the string,\n    /// and replaces it with the given string.\n    /// The given string doesn't need to be the same length as the range.\n    ///\n    /// # Panics\n    ///\n    /// Panics if the range has `start_bound > end_bound`, or, if the range is\n    /// bounded on either end and does not lie on a [`char`] boundary.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut s = String::from(\"α is alpha, β is beta\");\n    /// let beta_offset = s.find('β').unwrap_or(s.len());\n    ///\n    /// // Replace the range up until the β from the string\n    /// s.replace_range(..beta_offset, \"Α is capital alpha; \");\n    /// assert_eq!(s, \"Α is capital alpha; β is beta\");\n    /// ```\n    #[cfg(not(no_global_oom_handling))]\n    #[stable(feature = \"splice\", since = \"1.27.0\")]\n    #[track_caller]\n    pub fn replace_range<R>(&mut self, range: R, replace_with: &str)\n    where\n        R: RangeBounds<usize>,\n    {\n        // Memory safety\n        //\n        // Replace_range does not have the memory safety issues of a vector Splice.\n        // of the vector version. The data is just plain bytes.\n\n        // WARNING: Inlining this variable would be unsound (#81138)\n        let start = range.start_bound();\n        match start {\n            Included(&n) => assert!(self.is_char_boundary(n)),\n            Excluded(&n) => assert!(self.is_char_boundary(n + 1)),\n            Unbounded => {}\n        };\n        // WARNING: Inlining this variable would be unsound (#81138)\n        let end = range.end_bound();\n        match end {\n            Included(&n) => assert!(self.is_char_boundary(n + 1)),\n            Excluded(&n) => assert!(self.is_char_boundary(n)),\n            Unbounded => {}\n        };\n\n        // Using `range` again would be unsound (#81138)\n        // We assume the bounds reported by `range` remain the same, but\n        // an adversarial implementation could change between calls\n        unsafe { self.as_mut_vec() }.splice((start, end), replace_with.bytes());\n    }\n\n    /// Replaces the leftmost occurrence of a pattern with another string, in-place.\n    ///\n    /// This method can be preferred over [`string = string.replacen(..., 1);`][replacen],\n    /// as it can use the `String`'s existing capacity to prevent a reallocation if\n    /// sufficient space is available.\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// #![feature(string_replace_in_place)]\n    ///\n    /// let mut s = String::from(\"Test Results: ❌❌❌\");\n    ///\n    /// // Replace the leftmost ❌ with a ✅\n    /// s.replace_first('❌', \"✅\");\n    /// assert_eq!(s, \"Test Results: ✅❌❌\");\n    /// ```\n    ///\n    /// [replacen]: ../../std/primitive.str.html#method.replacen\n    #[cfg(not(no_global_oom_handling))]\n    #[unstable(feature = \"string_replace_in_place\", issue = \"147949\")]\n    pub fn replace_first<P: Pattern>(&mut self, from: P, to: &str) {\n        let range = match self.match_indices(from).next() {\n            Some((start, match_str)) => start..start + match_str.len(),\n            None => return,\n        };\n\n        self.replace_range(range, to);\n    }\n\n    /// Replaces the rightmost occurrence of a pattern with another string, in-place.\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// #![feature(string_replace_in_place)]\n    ///\n    /// let mut s = String::from(\"Test Results: ❌❌❌\");\n    ///\n    /// // Replace the rightmost ❌ with a ✅\n    /// s.replace_last('❌', \"✅\");\n    /// assert_eq!(s, \"Test Results: ❌❌✅\");\n    /// ```\n    #[cfg(not(no_global_oom_handling))]\n    #[unstable(feature = \"string_replace_in_place\", issue = \"147949\")]\n    pub fn replace_last<P: Pattern>(&mut self, from: P, to: &str)\n    where\n        for<'a> P::Searcher<'a>: core::str::pattern::ReverseSearcher<'a>,\n    {\n        let range = match self.rmatch_indices(from).next() {\n            Some((start, match_str)) => start..start + match_str.len(),\n            None => return,\n        };\n\n        self.replace_range(range, to);\n    }\n\n    /// Converts this `String` into a <code>[Box]<[str]></code>.\n    ///\n    /// Before doing the conversion, this method discards excess capacity like [`shrink_to_fit`].\n    /// Note that this call may reallocate and copy the bytes of the string.\n    ///\n    /// [`shrink_to_fit`]: String::shrink_to_fit\n    /// [str]: prim@str \"str\"\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let s = String::from(\"hello\");\n    ///\n    /// let b = s.into_boxed_str();\n    /// ```\n    #[cfg(not(no_global_oom_handling))]\n    #[stable(feature = \"box_str\", since = \"1.4.0\")]\n    #[must_use = \"`self` will be dropped if the result is not used\"]\n    #[inline]\n    pub fn into_boxed_str(self) -> Box<str> {\n        let slice = self.vec.into_boxed_slice();\n        unsafe { from_boxed_utf8_unchecked(slice) }\n    }\n\n    /// Consumes and leaks the `String`, returning a mutable reference to the contents,\n    /// `&'a mut str`.\n    ///\n    /// The caller has free choice over the returned lifetime, including `'static`. Indeed,\n    /// this function is ideally used for data that lives for the remainder of the program's life,\n    /// as dropping the returned reference will cause a memory leak.\n    ///\n    /// It does not reallocate or shrink the `String`, so the leaked allocation may include unused\n    /// capacity that is not part of the returned slice. If you want to discard excess capacity,\n    /// call [`into_boxed_str`], and then [`Box::leak`] instead. However, keep in mind that\n    /// trimming the capacity may result in a reallocation and copy.\n    ///\n    /// [`into_boxed_str`]: Self::into_boxed_str\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x = String::from(\"bucket\");\n    /// let static_ref: &'static mut str = x.leak();\n    /// assert_eq!(static_ref, \"bucket\");\n    /// # // FIXME(https://github.com/rust-lang/miri/issues/3670):\n    /// # // use -Zmiri-disable-leak-check instead of unleaking in tests meant to leak.\n    /// # drop(unsafe { Box::from_raw(static_ref) });\n    /// ```\n    #[stable(feature = \"string_leak\", since = \"1.72.0\")]\n    #[inline]\n    pub fn leak<'a>(self) -> &'a mut str {\n        let slice = self.vec.leak();\n        unsafe { from_utf8_unchecked_mut(slice) }\n    }\n}\n\nimpl FromUtf8Error {\n    /// Returns a slice of [`u8`]s bytes that were attempted to convert to a `String`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// // some invalid bytes, in a vector\n    /// let bytes = vec![0, 159];\n    ///\n    /// let value = String::from_utf8(bytes);\n    ///\n    /// assert_eq!(&[0, 159], value.unwrap_err().as_bytes());\n    /// ```\n    #[must_use]\n    #[stable(feature = \"from_utf8_error_as_bytes\", since = \"1.26.0\")]\n    pub fn as_bytes(&self) -> &[u8] {\n        &self.bytes[..]\n    }\n\n    /// Converts the bytes into a `String` lossily, substituting invalid UTF-8\n    /// sequences with replacement characters.\n    ///\n    /// See [`String::from_utf8_lossy`] for more details on replacement of\n    /// invalid sequences, and [`String::from_utf8_lossy_owned`] for the\n    /// `String` function which corresponds to this function.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(string_from_utf8_lossy_owned)]\n    /// // some invalid bytes\n    /// let input: Vec<u8> = b\"Hello \\xF0\\x90\\x80World\".into();\n    /// let output = String::from_utf8(input).unwrap_or_else(|e| e.into_utf8_lossy());\n    ///\n    /// assert_eq!(String::from(\"Hello �World\"), output);\n    /// ```\n    #[must_use]\n    #[cfg(not(no_global_oom_handling))]\n    #[unstable(feature = \"string_from_utf8_lossy_owned\", issue = \"129436\")]\n    pub fn into_utf8_lossy(self) -> String {\n        const REPLACEMENT: &str = \"\\u{FFFD}\";\n\n        let mut res = {\n            let mut v = Vec::with_capacity(self.bytes.len());\n\n            // `Utf8Error::valid_up_to` returns the maximum index of validated\n            // UTF-8 bytes. Copy the valid bytes into the output buffer.\n            v.extend_from_slice(&self.bytes[..self.error.valid_up_to()]);\n\n            // SAFETY: This is safe because the only bytes present in the buffer\n            // were validated as UTF-8 by the call to `String::from_utf8` which\n            // produced this `FromUtf8Error`.\n            unsafe { String::from_utf8_unchecked(v) }\n        };\n\n        let iter = self.bytes[self.error.valid_up_to()..].utf8_chunks();\n\n        for chunk in iter {\n            res.push_str(chunk.valid());\n            if !chunk.invalid().is_empty() {\n                res.push_str(REPLACEMENT);\n            }\n        }\n\n        res\n    }\n\n    /// Returns the bytes that were attempted to convert to a `String`.\n    ///\n    /// This method is carefully constructed to avoid allocation. It will\n    /// consume the error, moving out the bytes, so that a copy of the bytes\n    /// does not need to be made.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// // some invalid bytes, in a vector\n    /// let bytes = vec![0, 159];\n    ///\n    /// let value = String::from_utf8(bytes);\n    ///\n    /// assert_eq!(vec![0, 159], value.unwrap_err().into_bytes());\n    /// ```\n    #[must_use = \"`self` will be dropped if the result is not used\"]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    pub fn into_bytes(self) -> Vec<u8> {\n        self.bytes\n    }\n\n    /// Fetch a `Utf8Error` to get more details about the conversion failure.\n    ///\n    /// The [`Utf8Error`] type provided by [`std::str`] represents an error that may\n    /// occur when converting a slice of [`u8`]s to a [`&str`]. In this sense, it's\n    /// an analogue to `FromUtf8Error`. See its documentation for more details\n    /// on using it.\n    ///\n    /// [`std::str`]: core::str \"std::str\"\n    /// [`&str`]: prim@str \"&str\"\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// // some invalid bytes, in a vector\n    /// let bytes = vec![0, 159];\n    ///\n    /// let error = String::from_utf8(bytes).unwrap_err().utf8_error();\n    ///\n    /// // the first byte is invalid here\n    /// assert_eq!(1, error.valid_up_to());\n    /// ```\n    #[must_use]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    pub fn utf8_error(&self) -> Utf8Error {\n        self.error\n    }\n}\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl fmt::Display for FromUtf8Error {\n    fn fmt(&self, f: &mut fmt::Formatter<'_>) -> fmt::Result {\n        fmt::Display::fmt(&self.error, f)\n    }\n}\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl fmt::Display for FromUtf16Error {\n    fn fmt(&self, f: &mut fmt::Formatter<'_>) -> fmt::Result {\n        fmt::Display::fmt(\"invalid utf-16: lone surrogate found\", f)\n    }\n}\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl Error for FromUtf8Error {}\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl Error for FromUtf16Error {}\n\n#[cfg(not(no_global_oom_handling))]\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl Clone for String {\n    fn clone(&self) -> Self {\n        String { vec: self.vec.clone() }\n    }\n\n    /// Clones the contents of `source` into `self`.\n    ///\n    /// This method is preferred over simply assigning `source.clone()` to `self`,\n    /// as it avoids reallocation if possible.\n    fn clone_from(&mut self, source: &Self) {\n        self.vec.clone_from(&source.vec);\n    }\n}\n\n#[cfg(not(no_global_oom_handling))]\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl FromIterator<char> for String {\n    fn from_iter<I: IntoIterator<Item = char>>(iter: I) -> String {\n        let mut buf = String::new();\n        buf.extend(iter);\n        buf\n    }\n}\n\n#[cfg(not(no_global_oom_handling))]\n#[stable(feature = \"string_from_iter_by_ref\", since = \"1.17.0\")]\nimpl<'a> FromIterator<&'a char> for String {\n    fn from_iter<I: IntoIterator<Item = &'a char>>(iter: I) -> String {\n        let mut buf = String::new();\n        buf.extend(iter);\n        buf\n    }\n}\n\n#[cfg(not(no_global_oom_handling))]\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl<'a> FromIterator<&'a str> for String {\n    fn from_iter<I: IntoIterator<Item = &'a str>>(iter: I) -> String {\n        let mut buf = String::new();\n        buf.extend(iter);\n        buf\n    }\n}\n\n#[cfg(not(no_global_oom_handling))]\n#[stable(feature = \"extend_string\", since = \"1.4.0\")]\nimpl FromIterator<String> for String {\n    fn from_iter<I: IntoIterator<Item = String>>(iter: I) -> String {\n        let mut iterator = iter.into_iter();\n\n        // Because we're iterating over `String`s, we can avoid at least\n        // one allocation by getting the first string from the iterator\n        // and appending to it all the subsequent strings.\n        match iterator.next() {\n            None => String::new(),\n            Some(mut buf) => {\n                buf.extend(iterator);\n                buf\n            }\n        }\n    }\n}\n\n#[cfg(not(no_global_oom_handling))]\n#[stable(feature = \"box_str2\", since = \"1.45.0\")]\nimpl<A: Allocator> FromIterator<Box<str, A>> for String {\n    fn from_iter<I: IntoIterator<Item = Box<str, A>>>(iter: I) -> String {\n        let mut buf = String::new();\n        buf.extend(iter);\n        buf\n    }\n}\n\n#[cfg(not(no_global_oom_handling))]\n#[stable(feature = \"herd_cows\", since = \"1.19.0\")]\nimpl<'a> FromIterator<Cow<'a, str>> for String {\n    fn from_iter<I: IntoIterator<Item = Cow<'a, str>>>(iter: I) -> String {\n        let mut iterator = iter.into_iter();\n\n        // Because we're iterating over CoWs, we can (potentially) avoid at least\n        // one allocation by getting the first item and appending to it all the\n        // subsequent items.\n        match iterator.next() {\n            None => String::new(),\n            Some(cow) => {\n                let mut buf = cow.into_owned();\n                buf.extend(iterator);\n                buf\n            }\n        }\n    }\n}\n\n#[cfg(not(no_global_oom_handling))]\n#[unstable(feature = \"ascii_char\", issue = \"110998\")]\nimpl FromIterator<core::ascii::Char> for String {\n    fn from_iter<T: IntoIterator<Item = core::ascii::Char>>(iter: T) -> Self {\n        let buf = iter.into_iter().map(core::ascii::Char::to_u8).collect();\n        // SAFETY: `buf` is guaranteed to be valid UTF-8 because the `core::ascii::Char` type\n        // only contains ASCII values (0x00-0x7F), which are valid UTF-8.\n        unsafe { String::from_utf8_unchecked(buf) }\n    }\n}\n\n#[cfg(not(no_global_oom_handling))]\n#[unstable(feature = \"ascii_char\", issue = \"110998\")]\nimpl<'a> FromIterator<&'a core::ascii::Char> for String {\n    fn from_iter<T: IntoIterator<Item = &'a core::ascii::Char>>(iter: T) -> Self {\n        let buf = iter.into_iter().copied().map(core::ascii::Char::to_u8).collect();\n        // SAFETY: `buf` is guaranteed to be valid UTF-8 because the `core::ascii::Char` type\n        // only contains ASCII values (0x00-0x7F), which are valid UTF-8.\n        unsafe { String::from_utf8_unchecked(buf) }\n    }\n}\n\n#[cfg(not(no_global_oom_handling))]\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl Extend<char> for String {\n    fn extend<I: IntoIterator<Item = char>>(&mut self, iter: I) {\n        let iterator = iter.into_iter();\n        let (lower_bound, _) = iterator.size_hint();\n        self.reserve(lower_bound);\n        iterator.for_each(move |c| self.push(c));\n    }\n\n    #[inline]\n    fn extend_one(&mut self, c: char) {\n        self.push(c);\n    }\n\n    #[inline]\n    fn extend_reserve(&mut self, additional: usize) {\n        self.reserve(additional);\n    }\n}\n\n#[cfg(not(no_global_oom_handling))]\n#[stable(feature = \"extend_ref\", since = \"1.2.0\")]\nimpl<'a> Extend<&'a char> for String {\n    fn extend<I: IntoIterator<Item = &'a char>>(&mut self, iter: I) {\n        self.extend(iter.into_iter().cloned());\n    }\n\n    #[inline]\n    fn extend_one(&mut self, &c: &'a char) {\n        self.push(c);\n    }\n\n    #[inline]\n    fn extend_reserve(&mut self, additional: usize) {\n        self.reserve(additional);\n    }\n}\n\n#[cfg(not(no_global_oom_handling))]\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl<'a> Extend<&'a str> for String {\n    fn extend<I: IntoIterator<Item = &'a str>>(&mut self, iter: I) {\n        iter.into_iter().for_each(move |s| self.push_str(s));\n    }\n\n    #[inline]\n    fn extend_one(&mut self, s: &'a str) {\n        self.push_str(s);\n    }\n}\n\n#[cfg(not(no_global_oom_handling))]\n#[stable(feature = \"box_str2\", since = \"1.45.0\")]\nimpl<A: Allocator> Extend<Box<str, A>> for String {\n    fn extend<I: IntoIterator<Item = Box<str, A>>>(&mut self, iter: I) {\n        iter.into_iter().for_each(move |s| self.push_str(&s));\n    }\n}\n\n#[cfg(not(no_global_oom_handling))]\n#[stable(feature = \"extend_string\", since = \"1.4.0\")]\nimpl Extend<String> for String {\n    fn extend<I: IntoIterator<Item = String>>(&mut self, iter: I) {\n        iter.into_iter().for_each(move |s| self.push_str(&s));\n    }\n\n    #[inline]\n    fn extend_one(&mut self, s: String) {\n        self.push_str(&s);\n    }\n}\n\n#[cfg(not(no_global_oom_handling))]\n#[stable(feature = \"herd_cows\", since = \"1.19.0\")]\nimpl<'a> Extend<Cow<'a, str>> for String {\n    fn extend<I: IntoIterator<Item = Cow<'a, str>>>(&mut self, iter: I) {\n        iter.into_iter().for_each(move |s| self.push_str(&s));\n    }\n\n    #[inline]\n    fn extend_one(&mut self, s: Cow<'a, str>) {\n        self.push_str(&s);\n    }\n}\n\n#[cfg(not(no_global_oom_handling))]\n#[unstable(feature = \"ascii_char\", issue = \"110998\")]\nimpl Extend<core::ascii::Char> for String {\n    #[inline]\n    fn extend<I: IntoIterator<Item = core::ascii::Char>>(&mut self, iter: I) {\n        self.vec.extend(iter.into_iter().map(|c| c.to_u8()));\n    }\n\n    #[inline]\n    fn extend_one(&mut self, c: core::ascii::Char) {\n        self.vec.push(c.to_u8());\n    }\n}\n\n#[cfg(not(no_global_oom_handling))]\n#[unstable(feature = \"ascii_char\", issue = \"110998\")]\nimpl<'a> Extend<&'a core::ascii::Char> for String {\n    #[inline]\n    fn extend<I: IntoIterator<Item = &'a core::ascii::Char>>(&mut self, iter: I) {\n        self.extend(iter.into_iter().cloned());\n    }\n\n    #[inline]\n    fn extend_one(&mut self, c: &'a core::ascii::Char) {\n        self.vec.push(c.to_u8());\n    }\n}\n\n/// A convenience impl that delegates to the impl for `&str`.\n///\n/// # Examples\n///\n/// ```\n/// assert_eq!(String::from(\"Hello world\").find(\"world\"), Some(6));\n/// ```\n#[unstable(\n    feature = \"pattern\",\n    reason = \"API not fully fleshed out and ready to be stabilized\",\n    issue = \"27721\"\n)]\nimpl<'b> Pattern for &'b String {\n    type Searcher<'a> = <&'b str as Pattern>::Searcher<'a>;\n\n    fn into_searcher(self, haystack: &str) -> <&'b str as Pattern>::Searcher<'_> {\n        self[..].into_searcher(haystack)\n    }\n\n    #[inline]\n    fn is_contained_in(self, haystack: &str) -> bool {\n        self[..].is_contained_in(haystack)\n    }\n\n    #[inline]\n    fn is_prefix_of(self, haystack: &str) -> bool {\n        self[..].is_prefix_of(haystack)\n    }\n\n    #[inline]\n    fn strip_prefix_of(self, haystack: &str) -> Option<&str> {\n        self[..].strip_prefix_of(haystack)\n    }\n\n    #[inline]\n    fn is_suffix_of<'a>(self, haystack: &'a str) -> bool\n    where\n        Self::Searcher<'a>: core::str::pattern::ReverseSearcher<'a>,\n    {\n        self[..].is_suffix_of(haystack)\n    }\n\n    #[inline]\n    fn strip_suffix_of<'a>(self, haystack: &'a str) -> Option<&'a str>\n    where\n        Self::Searcher<'a>: core::str::pattern::ReverseSearcher<'a>,\n    {\n        self[..].strip_suffix_of(haystack)\n    }\n\n    #[inline]\n    fn as_utf8_pattern(&self) -> Option<Utf8Pattern<'_>> {\n        Some(Utf8Pattern::StringPattern(self.as_bytes()))\n    }\n}\n\nmacro_rules! impl_eq {\n    ($lhs:ty, $rhs: ty) => {\n        #[stable(feature = \"rust1\", since = \"1.0.0\")]\n        #[allow(unused_lifetimes)]\n        impl<'a, 'b> PartialEq<$rhs> for $lhs {\n            #[inline]\n            fn eq(&self, other: &$rhs) -> bool {\n                PartialEq::eq(&self[..], &other[..])\n            }\n            #[inline]\n            fn ne(&self, other: &$rhs) -> bool {\n                PartialEq::ne(&self[..], &other[..])\n            }\n        }\n\n        #[stable(feature = \"rust1\", since = \"1.0.0\")]\n        #[allow(unused_lifetimes)]\n        impl<'a, 'b> PartialEq<$lhs> for $rhs {\n            #[inline]\n            fn eq(&self, other: &$lhs) -> bool {\n                PartialEq::eq(&self[..], &other[..])\n            }\n            #[inline]\n            fn ne(&self, other: &$lhs) -> bool {\n                PartialEq::ne(&self[..], &other[..])\n            }\n        }\n    };\n}\n\nimpl_eq! { String, str }\nimpl_eq! { String, &'a str }\n#[cfg(not(no_global_oom_handling))]\nimpl_eq! { Cow<'a, str>, str }\n#[cfg(not(no_global_oom_handling))]\nimpl_eq! { Cow<'a, str>, &'b str }\n#[cfg(not(no_global_oom_handling))]\nimpl_eq! { Cow<'a, str>, String }\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\n#[rustc_const_unstable(feature = \"const_default\", issue = \"143894\")]\nimpl const Default for String {\n    /// Creates an empty `String`.\n    #[inline]\n    fn default() -> String {\n        String::new()\n    }\n}\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl fmt::Display for String {\n    #[inline]\n    fn fmt(&self, f: &mut fmt::Formatter<'_>) -> fmt::Result {\n        fmt::Display::fmt(&**self, f)\n    }\n}\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl fmt::Debug for String {\n    #[inline]\n    fn fmt(&self, f: &mut fmt::Formatter<'_>) -> fmt::Result {\n        fmt::Debug::fmt(&**self, f)\n    }\n}\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl hash::Hash for String {\n    #[inline]\n    fn hash<H: hash::Hasher>(&self, hasher: &mut H) {\n        (**self).hash(hasher)\n    }\n}\n\n/// Implements the `+` operator for concatenating two strings.\n///\n/// This consumes the `String` on the left-hand side and re-uses its buffer (growing it if\n/// necessary). This is done to avoid allocating a new `String` and copying the entire contents on\n/// every operation, which would lead to *O*(*n*^2) running time when building an *n*-byte string by\n/// repeated concatenation.\n///\n/// The string on the right-hand side is only borrowed; its contents are copied into the returned\n/// `String`.\n///\n/// # Examples\n///\n/// Concatenating two `String`s takes the first by value and borrows the second:\n///\n/// ```\n/// let a = String::from(\"hello\");\n/// let b = String::from(\" world\");\n/// let c = a + &b;\n/// // `a` is moved and can no longer be used here.\n/// ```\n///\n/// If you want to keep using the first `String`, you can clone it and append to the clone instead:\n///\n/// ```\n/// let a = String::from(\"hello\");\n/// let b = String::from(\" world\");\n/// let c = a.clone() + &b;\n/// // `a` is still valid here.\n/// ```\n///\n/// Concatenating `&str` slices can be done by converting the first to a `String`:\n///\n/// ```\n/// let a = \"hello\";\n/// let b = \" world\";\n/// let c = a.to_string() + b;\n/// ```\n#[cfg(not(no_global_oom_handling))]\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl Add<&str> for String {\n    type Output = String;\n\n    #[inline]\n    fn add(mut self, other: &str) -> String {\n        self.push_str(other);\n        self\n    }\n}\n\n/// Implements the `+=` operator for appending to a `String`.\n///\n/// This has the same behavior as the [`push_str`][String::push_str] method.\n#[cfg(not(no_global_oom_handling))]\n#[stable(feature = \"stringaddassign\", since = \"1.12.0\")]\nimpl AddAssign<&str> for String {\n    #[inline]\n    fn add_assign(&mut self, other: &str) {\n        self.push_str(other);\n    }\n}\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl<I> ops::Index<I> for String\nwhere\n    I: slice::SliceIndex<str>,\n{\n    type Output = I::Output;\n\n    #[inline]\n    fn index(&self, index: I) -> &I::Output {\n        index.index(self.as_str())\n    }\n}\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl<I> ops::IndexMut<I> for String\nwhere\n    I: slice::SliceIndex<str>,\n{\n    #[inline]\n    fn index_mut(&mut self, index: I) -> &mut I::Output {\n        index.index_mut(self.as_mut_str())\n    }\n}\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl ops::Deref for String {\n    type Target = str;\n\n    #[inline]\n    fn deref(&self) -> &str {\n        self.as_str()\n    }\n}\n\n#[unstable(feature = \"deref_pure_trait\", issue = \"87121\")]\nunsafe impl ops::DerefPure for String {}\n\n#[stable(feature = \"derefmut_for_string\", since = \"1.3.0\")]\nimpl ops::DerefMut for String {\n    #[inline]\n    fn deref_mut(&mut self) -> &mut str {\n        self.as_mut_str()\n    }\n}\n\n/// A type alias for [`Infallible`].\n///\n/// This alias exists for backwards compatibility, and may be eventually deprecated.\n///\n/// [`Infallible`]: core::convert::Infallible \"convert::Infallible\"\n#[stable(feature = \"str_parse_error\", since = \"1.5.0\")]\npub type ParseError = core::convert::Infallible;\n\n#[cfg(not(no_global_oom_handling))]\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl FromStr for String {\n    type Err = core::convert::Infallible;\n    #[inline]\n    fn from_str(s: &str) -> Result<String, Self::Err> {\n        Ok(String::from(s))\n    }\n}\n\n/// A trait for converting a value to a `String`.\n///\n/// This trait is automatically implemented for any type which implements the\n/// [`Display`] trait. As such, `ToString` shouldn't be implemented directly:\n/// [`Display`] should be implemented instead, and you get the `ToString`\n/// implementation for free.\n///\n/// [`Display`]: fmt::Display\n#[rustc_diagnostic_item = \"ToString\"]\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\npub trait ToString {\n    /// Converts the given value to a `String`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let i = 5;\n    /// let five = String::from(\"5\");\n    ///\n    /// assert_eq!(five, i.to_string());\n    /// ```\n    #[rustc_conversion_suggestion]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_diagnostic_item = \"to_string_method\"]\n    fn to_string(&self) -> String;\n}\n\n/// # Panics\n///\n/// In this implementation, the `to_string` method panics\n/// if the `Display` implementation returns an error.\n/// This indicates an incorrect `Display` implementation\n/// since `fmt::Write for String` never returns an error itself.\n#[cfg(not(no_global_oom_handling))]\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl<T: fmt::Display + ?Sized> ToString for T {\n    #[inline]\n    fn to_string(&self) -> String {\n        <Self as SpecToString>::spec_to_string(self)\n    }\n}\n\n#[cfg(not(no_global_oom_handling))]\ntrait SpecToString {\n    fn spec_to_string(&self) -> String;\n}\n\n#[cfg(not(no_global_oom_handling))]\nimpl<T: fmt::Display + ?Sized> SpecToString for T {\n    // A common guideline is to not inline generic functions. However,\n    // removing `#[inline]` from this method causes non-negligible regressions.\n    // See <https://github.com/rust-lang/rust/pull/74852>, the last attempt\n    // to try to remove it.\n    #[inline]\n    default fn spec_to_string(&self) -> String {\n        let mut buf = String::new();\n        let mut formatter =\n            core::fmt::Formatter::new(&mut buf, core::fmt::FormattingOptions::new());\n        // Bypass format_args!() to avoid write_str with zero-length strs\n        fmt::Display::fmt(self, &mut formatter)\n            .expect(\"a Display implementation returned an error unexpectedly\");\n        buf\n    }\n}\n\n#[cfg(not(no_global_oom_handling))]\nimpl SpecToString for core::ascii::Char {\n    #[inline]\n    fn spec_to_string(&self) -> String {\n        self.as_str().to_owned()\n    }\n}\n\n#[cfg(not(no_global_oom_handling))]\nimpl SpecToString for char {\n    #[inline]\n    fn spec_to_string(&self) -> String {\n        String::from(self.encode_utf8(&mut [0; char::MAX_LEN_UTF8]))\n    }\n}\n\n#[cfg(not(no_global_oom_handling))]\nimpl SpecToString for bool {\n    #[inline]\n    fn spec_to_string(&self) -> String {\n        String::from(if *self { \"true\" } else { \"false\" })\n    }\n}\n\nmacro_rules! impl_to_string {\n    ($($signed:ident, $unsigned:ident,)*) => {\n        $(\n        #[cfg(not(no_global_oom_handling))]\n        #[cfg(not(feature = \"optimize_for_size\"))]\n        impl SpecToString for $signed {\n            #[inline]\n            fn spec_to_string(&self) -> String {\n                const SIZE: usize = $signed::MAX.ilog10() as usize + 1;\n                let mut buf = [core::mem::MaybeUninit::<u8>::uninit(); SIZE];\n                // Only difference between signed and unsigned are these 8 lines.\n                let mut out;\n                if *self < 0 {\n                    out = String::with_capacity(SIZE + 1);\n                    out.push('-');\n                } else {\n                    out = String::with_capacity(SIZE);\n                }\n\n                // SAFETY: `buf` is always big enough to contain all the digits.\n                unsafe { out.push_str(self.unsigned_abs()._fmt(&mut buf)); }\n                out\n            }\n        }\n        #[cfg(not(no_global_oom_handling))]\n        #[cfg(not(feature = \"optimize_for_size\"))]\n        impl SpecToString for $unsigned {\n            #[inline]\n            fn spec_to_string(&self) -> String {\n                const SIZE: usize = $unsigned::MAX.ilog10() as usize + 1;\n                let mut buf = [core::mem::MaybeUninit::<u8>::uninit(); SIZE];\n\n                // SAFETY: `buf` is always big enough to contain all the digits.\n                unsafe { self._fmt(&mut buf).to_string() }\n            }\n        }\n        )*\n    }\n}\n\nimpl_to_string! {\n    i8, u8,\n    i16, u16,\n    i32, u32,\n    i64, u64,\n    isize, usize,\n    i128, u128,\n}\n\n#[cfg(not(no_global_oom_handling))]\n#[cfg(feature = \"optimize_for_size\")]\nimpl SpecToString for u8 {\n    #[inline]\n    fn spec_to_string(&self) -> String {\n        let mut buf = String::with_capacity(3);\n        let mut n = *self;\n        if n >= 10 {\n            if n >= 100 {\n                buf.push((b'0' + n / 100) as char);\n                n %= 100;\n            }\n            buf.push((b'0' + n / 10) as char);\n            n %= 10;\n        }\n        buf.push((b'0' + n) as char);\n        buf\n    }\n}\n\n#[cfg(not(no_global_oom_handling))]\n#[cfg(feature = \"optimize_for_size\")]\nimpl SpecToString for i8 {\n    #[inline]\n    fn spec_to_string(&self) -> String {\n        let mut buf = String::with_capacity(4);\n        if self.is_negative() {\n            buf.push('-');\n        }\n        let mut n = self.unsigned_abs();\n        if n >= 10 {\n            if n >= 100 {\n                buf.push('1');\n                n -= 100;\n            }\n            buf.push((b'0' + n / 10) as char);\n            n %= 10;\n        }\n        buf.push((b'0' + n) as char);\n        buf\n    }\n}\n\n#[cfg(not(no_global_oom_handling))]\nmacro_rules! to_string_str {\n    {$($type:ty,)*} => {\n        $(\n            impl SpecToString for $type {\n                #[inline]\n                fn spec_to_string(&self) -> String {\n                    let s: &str = self;\n                    String::from(s)\n                }\n            }\n        )*\n    };\n}\n\n#[cfg(not(no_global_oom_handling))]\nto_string_str! {\n    Cow<'_, str>,\n    String,\n    // Generic/generated code can sometimes have multiple, nested references\n    // for strings, including `&&&str`s that would never be written\n    // by hand.\n    &&&&&&&&&&&&str,\n    &&&&&&&&&&&str,\n    &&&&&&&&&&str,\n    &&&&&&&&&str,\n    &&&&&&&&str,\n    &&&&&&&str,\n    &&&&&&str,\n    &&&&&str,\n    &&&&str,\n    &&&str,\n    &&str,\n    &str,\n    str,\n}\n\n#[cfg(not(no_global_oom_handling))]\nimpl SpecToString for fmt::Arguments<'_> {\n    #[inline]\n    fn spec_to_string(&self) -> String {\n        crate::fmt::format(*self)\n    }\n}\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl AsRef<str> for String {\n    #[inline]\n    fn as_ref(&self) -> &str {\n        self\n    }\n}\n\n#[stable(feature = \"string_as_mut\", since = \"1.43.0\")]\nimpl AsMut<str> for String {\n    #[inline]\n    fn as_mut(&mut self) -> &mut str {\n        self\n    }\n}\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl AsRef<[u8]> for String {\n    #[inline]\n    fn as_ref(&self) -> &[u8] {\n        self.as_bytes()\n    }\n}\n\n#[cfg(not(no_global_oom_handling))]\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl From<&str> for String {\n    /// Converts a `&str` into a [`String`].\n    ///\n    /// The result is allocated on the heap.\n    #[inline]\n    fn from(s: &str) -> String {\n        s.to_owned()\n    }\n}\n\n#[cfg(not(no_global_oom_handling))]\n#[stable(feature = \"from_mut_str_for_string\", since = \"1.44.0\")]\nimpl From<&mut str> for String {\n    /// Converts a `&mut str` into a [`String`].\n    ///\n    /// The result is allocated on the heap.\n    #[inline]\n    fn from(s: &mut str) -> String {\n        s.to_owned()\n    }\n}\n\n#[cfg(not(no_global_oom_handling))]\n#[stable(feature = \"from_ref_string\", since = \"1.35.0\")]\nimpl From<&String> for String {\n    /// Converts a `&String` into a [`String`].\n    ///\n    /// This clones `s` and returns the clone.\n    #[inline]\n    fn from(s: &String) -> String {\n        s.clone()\n    }\n}\n\n// note: test pulls in std, which causes errors here\n#[stable(feature = \"string_from_box\", since = \"1.18.0\")]\nimpl From<Box<str>> for String {\n    /// Converts the given boxed `str` slice to a [`String`].\n    /// It is notable that the `str` slice is owned.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let s1: String = String::from(\"hello world\");\n    /// let s2: Box<str> = s1.into_boxed_str();\n    /// let s3: String = String::from(s2);\n    ///\n    /// assert_eq!(\"hello world\", s3)\n    /// ```\n    fn from(s: Box<str>) -> String {\n        s.into_string()\n    }\n}\n\n#[cfg(not(no_global_oom_handling))]\n#[stable(feature = \"box_from_str\", since = \"1.20.0\")]\nimpl From<String> for Box<str> {\n    /// Converts the given [`String`] to a boxed `str` slice that is owned.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let s1: String = String::from(\"hello world\");\n    /// let s2: Box<str> = Box::from(s1);\n    /// let s3: String = String::from(s2);\n    ///\n    /// assert_eq!(\"hello world\", s3)\n    /// ```\n    fn from(s: String) -> Box<str> {\n        s.into_boxed_str()\n    }\n}\n\n#[cfg(not(no_global_oom_handling))]\n#[stable(feature = \"string_from_cow_str\", since = \"1.14.0\")]\nimpl<'a> From<Cow<'a, str>> for String {\n    /// Converts a clone-on-write string to an owned\n    /// instance of [`String`].\n    ///\n    /// This extracts the owned string,\n    /// clones the string if it is not already owned.\n    ///\n    /// # Example\n    ///\n    /// ```\n    /// # use std::borrow::Cow;\n    /// // If the string is not owned...\n    /// let cow: Cow<'_, str> = Cow::Borrowed(\"eggplant\");\n    /// // It will allocate on the heap and copy the string.\n    /// let owned: String = String::from(cow);\n    /// assert_eq!(&owned[..], \"eggplant\");\n    /// ```\n    fn from(s: Cow<'a, str>) -> String {\n        s.into_owned()\n    }\n}\n\n#[cfg(not(no_global_oom_handling))]\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl<'a> From<&'a str> for Cow<'a, str> {\n    /// Converts a string slice into a [`Borrowed`] variant.\n    /// No heap allocation is performed, and the string\n    /// is not copied.\n    ///\n    /// # Example\n    ///\n    /// ```\n    /// # use std::borrow::Cow;\n    /// assert_eq!(Cow::from(\"eggplant\"), Cow::Borrowed(\"eggplant\"));\n    /// ```\n    ///\n    /// [`Borrowed`]: crate::borrow::Cow::Borrowed \"borrow::Cow::Borrowed\"\n    #[inline]\n    fn from(s: &'a str) -> Cow<'a, str> {\n        Cow::Borrowed(s)\n    }\n}\n\n#[cfg(not(no_global_oom_handling))]\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl<'a> From<String> for Cow<'a, str> {\n    /// Converts a [`String`] into an [`Owned`] variant.\n    /// No heap allocation is performed, and the string\n    /// is not copied.\n    ///\n    /// # Example\n    ///\n    /// ```\n    /// # use std::borrow::Cow;\n    /// let s = \"eggplant\".to_string();\n    /// let s2 = \"eggplant\".to_string();\n    /// assert_eq!(Cow::from(s), Cow::<'static, str>::Owned(s2));\n    /// ```\n    ///\n    /// [`Owned`]: crate::borrow::Cow::Owned \"borrow::Cow::Owned\"\n    #[inline]\n    fn from(s: String) -> Cow<'a, str> {\n        Cow::Owned(s)\n    }\n}\n\n#[cfg(not(no_global_oom_handling))]\n#[stable(feature = \"cow_from_string_ref\", since = \"1.28.0\")]\nimpl<'a> From<&'a String> for Cow<'a, str> {\n    /// Converts a [`String`] reference into a [`Borrowed`] variant.\n    /// No heap allocation is performed, and the string\n    /// is not copied.\n    ///\n    /// # Example\n    ///\n    /// ```\n    /// # use std::borrow::Cow;\n    /// let s = \"eggplant\".to_string();\n    /// assert_eq!(Cow::from(&s), Cow::Borrowed(\"eggplant\"));\n    /// ```\n    ///\n    /// [`Borrowed`]: crate::borrow::Cow::Borrowed \"borrow::Cow::Borrowed\"\n    #[inline]\n    fn from(s: &'a String) -> Cow<'a, str> {\n        Cow::Borrowed(s.as_str())\n    }\n}\n\n#[cfg(not(no_global_oom_handling))]\n#[stable(feature = \"cow_str_from_iter\", since = \"1.12.0\")]\nimpl<'a> FromIterator<char> for Cow<'a, str> {\n    fn from_iter<I: IntoIterator<Item = char>>(it: I) -> Cow<'a, str> {\n        Cow::Owned(FromIterator::from_iter(it))\n    }\n}\n\n#[cfg(not(no_global_oom_handling))]\n#[stable(feature = \"cow_str_from_iter\", since = \"1.12.0\")]\nimpl<'a, 'b> FromIterator<&'b str> for Cow<'a, str> {\n    fn from_iter<I: IntoIterator<Item = &'b str>>(it: I) -> Cow<'a, str> {\n        Cow::Owned(FromIterator::from_iter(it))\n    }\n}\n\n#[cfg(not(no_global_oom_handling))]\n#[stable(feature = \"cow_str_from_iter\", since = \"1.12.0\")]\nimpl<'a> FromIterator<String> for Cow<'a, str> {\n    fn from_iter<I: IntoIterator<Item = String>>(it: I) -> Cow<'a, str> {\n        Cow::Owned(FromIterator::from_iter(it))\n    }\n}\n\n#[cfg(not(no_global_oom_handling))]\n#[unstable(feature = \"ascii_char\", issue = \"110998\")]\nimpl<'a> FromIterator<core::ascii::Char> for Cow<'a, str> {\n    fn from_iter<T: IntoIterator<Item = core::ascii::Char>>(it: T) -> Self {\n        Cow::Owned(FromIterator::from_iter(it))\n    }\n}\n\n#[stable(feature = \"from_string_for_vec_u8\", since = \"1.14.0\")]\nimpl From<String> for Vec<u8> {\n    /// Converts the given [`String`] to a vector [`Vec`] that holds values of type [`u8`].\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let s1 = String::from(\"hello world\");\n    /// let v1 = Vec::from(s1);\n    ///\n    /// for b in v1 {\n    ///     println!(\"{b}\");\n    /// }\n    /// ```\n    fn from(string: String) -> Vec<u8> {\n        string.into_bytes()\n    }\n}\n\n#[stable(feature = \"try_from_vec_u8_for_string\", since = \"1.87.0\")]\nimpl TryFrom<Vec<u8>> for String {\n    type Error = FromUtf8Error;\n    /// Converts the given [`Vec<u8>`] into a  [`String`] if it contains valid UTF-8 data.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let s1 = b\"hello world\".to_vec();\n    /// let v1 = String::try_from(s1).unwrap();\n    /// assert_eq!(v1, \"hello world\");\n    ///\n    /// ```\n    fn try_from(bytes: Vec<u8>) -> Result<Self, Self::Error> {\n        Self::from_utf8(bytes)\n    }\n}\n\n#[cfg(not(no_global_oom_handling))]\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl fmt::Write for String {\n    #[inline]\n    fn write_str(&mut self, s: &str) -> fmt::Result {\n        self.push_str(s);\n        Ok(())\n    }\n\n    #[inline]\n    fn write_char(&mut self, c: char) -> fmt::Result {\n        self.push(c);\n        Ok(())\n    }\n}\n\n/// An iterator over the [`char`]s of a string.\n///\n/// This struct is created by the [`into_chars`] method on [`String`].\n/// See its documentation for more.\n///\n/// [`char`]: prim@char\n/// [`into_chars`]: String::into_chars\n#[cfg_attr(not(no_global_oom_handling), derive(Clone))]\n#[must_use = \"iterators are lazy and do nothing unless consumed\"]\n#[unstable(feature = \"string_into_chars\", issue = \"133125\")]\npub struct IntoChars {\n    bytes: vec::IntoIter<u8>,\n}\n\n#[unstable(feature = \"string_into_chars\", issue = \"133125\")]\nimpl fmt::Debug for IntoChars {\n    fn fmt(&self, f: &mut fmt::Formatter<'_>) -> fmt::Result {\n        f.debug_tuple(\"IntoChars\").field(&self.as_str()).finish()\n    }\n}\n\nimpl IntoChars {\n    /// Views the underlying data as a subslice of the original data.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(string_into_chars)]\n    ///\n    /// let mut chars = String::from(\"abc\").into_chars();\n    ///\n    /// assert_eq!(chars.as_str(), \"abc\");\n    /// chars.next();\n    /// assert_eq!(chars.as_str(), \"bc\");\n    /// chars.next();\n    /// chars.next();\n    /// assert_eq!(chars.as_str(), \"\");\n    /// ```\n    #[unstable(feature = \"string_into_chars\", issue = \"133125\")]\n    #[must_use]\n    #[inline]\n    pub fn as_str(&self) -> &str {\n        // SAFETY: `bytes` is a valid UTF-8 string.\n        unsafe { str::from_utf8_unchecked(self.bytes.as_slice()) }\n    }\n\n    /// Consumes the `IntoChars`, returning the remaining string.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(string_into_chars)]\n    ///\n    /// let chars = String::from(\"abc\").into_chars();\n    /// assert_eq!(chars.into_string(), \"abc\");\n    ///\n    /// let mut chars = String::from(\"def\").into_chars();\n    /// chars.next();\n    /// assert_eq!(chars.into_string(), \"ef\");\n    /// ```\n    #[cfg(not(no_global_oom_handling))]\n    #[unstable(feature = \"string_into_chars\", issue = \"133125\")]\n    #[inline]\n    pub fn into_string(self) -> String {\n        // Safety: `bytes` are kept in UTF-8 form, only removing whole `char`s at a time.\n        unsafe { String::from_utf8_unchecked(self.bytes.collect()) }\n    }\n\n    #[inline]\n    fn iter(&self) -> CharIndices<'_> {\n        self.as_str().char_indices()\n    }\n}\n\n#[unstable(feature = \"string_into_chars\", issue = \"133125\")]\nimpl Iterator for IntoChars {\n    type Item = char;\n\n    #[inline]\n    fn next(&mut self) -> Option<char> {\n        let mut iter = self.iter();\n        match iter.next() {\n            None => None,\n            Some((_, ch)) => {\n                let offset = iter.offset();\n                // `offset` is a valid index.\n                let _ = self.bytes.advance_by(offset);\n                Some(ch)\n            }\n        }\n    }\n\n    #[inline]\n    fn count(self) -> usize {\n        self.iter().count()\n    }\n\n    #[inline]\n    fn size_hint(&self) -> (usize, Option<usize>) {\n        self.iter().size_hint()\n    }\n\n    #[inline]\n    fn last(mut self) -> Option<char> {\n        self.next_back()\n    }\n}\n\n#[unstable(feature = \"string_into_chars\", issue = \"133125\")]\nimpl DoubleEndedIterator for IntoChars {\n    #[inline]\n    fn next_back(&mut self) -> Option<char> {\n        let len = self.as_str().len();\n        let mut iter = self.iter();\n        match iter.next_back() {\n            None => None,\n            Some((idx, ch)) => {\n                // `idx` is a valid index.\n                let _ = self.bytes.advance_back_by(len - idx);\n                Some(ch)\n            }\n        }\n    }\n}\n\n#[unstable(feature = \"string_into_chars\", issue = \"133125\")]\nimpl FusedIterator for IntoChars {}\n\n/// A draining iterator for `String`.\n///\n/// This struct is created by the [`drain`] method on [`String`]. See its\n/// documentation for more.\n///\n/// [`drain`]: String::drain\n#[stable(feature = \"drain\", since = \"1.6.0\")]\npub struct Drain<'a> {\n    /// Will be used as &'a mut String in the destructor\n    string: *mut String,\n    /// Start of part to remove\n    start: usize,\n    /// End of part to remove\n    end: usize,\n    /// Current remaining range to remove\n    iter: Chars<'a>,\n}\n\n#[stable(feature = \"collection_debug\", since = \"1.17.0\")]\nimpl fmt::Debug for Drain<'_> {\n    fn fmt(&self, f: &mut fmt::Formatter<'_>) -> fmt::Result {\n        f.debug_tuple(\"Drain\").field(&self.as_str()).finish()\n    }\n}\n\n#[stable(feature = \"drain\", since = \"1.6.0\")]\nunsafe impl Sync for Drain<'_> {}\n#[stable(feature = \"drain\", since = \"1.6.0\")]\nunsafe impl Send for Drain<'_> {}\n\n#[stable(feature = \"drain\", since = \"1.6.0\")]\nimpl Drop for Drain<'_> {\n    fn drop(&mut self) {\n        unsafe {\n            // Use Vec::drain. \"Reaffirm\" the bounds checks to avoid\n            // panic code being inserted again.\n            let self_vec = (*self.string).as_mut_vec();\n            if self.start <= self.end && self.end <= self_vec.len() {\n                self_vec.drain(self.start..self.end);\n            }\n        }\n    }\n}\n\nimpl<'a> Drain<'a> {\n    /// Returns the remaining (sub)string of this iterator as a slice.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut s = String::from(\"abc\");\n    /// let mut drain = s.drain(..);\n    /// assert_eq!(drain.as_str(), \"abc\");\n    /// let _ = drain.next().unwrap();\n    /// assert_eq!(drain.as_str(), \"bc\");\n    /// ```\n    #[must_use]\n    #[stable(feature = \"string_drain_as_str\", since = \"1.55.0\")]\n    pub fn as_str(&self) -> &str {\n        self.iter.as_str()\n    }\n}\n\n#[stable(feature = \"string_drain_as_str\", since = \"1.55.0\")]\nimpl<'a> AsRef<str> for Drain<'a> {\n    fn as_ref(&self) -> &str {\n        self.as_str()\n    }\n}\n\n#[stable(feature = \"string_drain_as_str\", since = \"1.55.0\")]\nimpl<'a> AsRef<[u8]> for Drain<'a> {\n    fn as_ref(&self) -> &[u8] {\n        self.as_str().as_bytes()\n    }\n}\n\n#[stable(feature = \"drain\", since = \"1.6.0\")]\nimpl Iterator for Drain<'_> {\n    type Item = char;\n\n    #[inline]\n    fn next(&mut self) -> Option<char> {\n        self.iter.next()\n    }\n\n    fn size_hint(&self) -> (usize, Option<usize>) {\n        self.iter.size_hint()\n    }\n\n    #[inline]\n    fn last(mut self) -> Option<char> {\n        self.next_back()\n    }\n}\n\n#[stable(feature = \"drain\", since = \"1.6.0\")]\nimpl DoubleEndedIterator for Drain<'_> {\n    #[inline]\n    fn next_back(&mut self) -> Option<char> {\n        self.iter.next_back()\n    }\n}\n\n#[stable(feature = \"fused\", since = \"1.26.0\")]\nimpl FusedIterator for Drain<'_> {}\n\n#[cfg(not(no_global_oom_handling))]\n#[stable(feature = \"from_char_for_string\", since = \"1.46.0\")]\nimpl From<char> for String {\n    /// Allocates an owned [`String`] from a single character.\n    ///\n    /// # Example\n    /// ```rust\n    /// let c: char = 'a';\n    /// let s: String = String::from(c);\n    /// assert_eq!(\"a\", &s[..]);\n    /// ```\n    #[inline]\n    fn from(c: char) -> Self {\n        c.to_string()\n    }\n}\n";

},{}],"2QWxh":[function(require,module,exports,__globalThis) {
module.exports = "#![stable(feature = \"futures_api\", since = \"1.36.0\")]\n\nuse crate::ops;\nuse crate::pin::Pin;\nuse crate::task::{Context, Poll};\n\n/// A future represents an asynchronous computation, commonly obtained by use of\n/// [`async`].\n///\n/// A future is a value that might not have finished computing yet. This kind of\n/// \"asynchronous value\" makes it possible for a thread to continue doing useful\n/// work while it waits for the value to become available.\n///\n/// # The `poll` method\n///\n/// The core method of future, `poll`, *attempts* to resolve the future into a\n/// final value. This method does not block if the value is not ready. Instead,\n/// the current task is scheduled to be woken up when it's possible to make\n/// further progress by `poll`ing again. The `context` passed to the `poll`\n/// method can provide a [`Waker`], which is a handle for waking up the current\n/// task.\n///\n/// When using a future, you generally won't call `poll` directly, but instead\n/// `.await` the value.\n///\n/// [`async`]: ../../std/keyword.async.html\n/// [`Waker`]: crate::task::Waker\n#[doc(notable_trait)]\n#[doc(search_unbox)]\n#[must_use = \"futures do nothing unless you `.await` or poll them\"]\n#[stable(feature = \"futures_api\", since = \"1.36.0\")]\n#[lang = \"future_trait\"]\n#[diagnostic::on_unimplemented(\n    label = \"`{Self}` is not a future\",\n    message = \"`{Self}` is not a future\"\n)]\npub trait Future {\n    /// The type of value produced on completion.\n    #[stable(feature = \"futures_api\", since = \"1.36.0\")]\n    #[lang = \"future_output\"]\n    type Output;\n\n    /// Attempts to resolve the future to a final value, registering\n    /// the current task for wakeup if the value is not yet available.\n    ///\n    /// # Return value\n    ///\n    /// This function returns:\n    ///\n    /// - [`Poll::Pending`] if the future is not ready yet\n    /// - [`Poll::Ready(val)`] with the result `val` of this future if it\n    ///   finished successfully.\n    ///\n    /// Once a future has finished, clients should not `poll` it again.\n    ///\n    /// When a future is not ready yet, `poll` returns `Poll::Pending` and\n    /// stores a clone of the [`Waker`] copied from the current [`Context`].\n    /// This [`Waker`] is then woken once the future can make progress.\n    /// For example, a future waiting for a socket to become\n    /// readable would call `.clone()` on the [`Waker`] and store it.\n    /// When a signal arrives elsewhere indicating that the socket is readable,\n    /// [`Waker::wake`] is called and the socket future's task is awoken.\n    /// Once a task has been woken up, it should attempt to `poll` the future\n    /// again, which may or may not produce a final value.\n    ///\n    /// Note that on multiple calls to `poll`, only the [`Waker`] from the\n    /// [`Context`] passed to the most recent call should be scheduled to\n    /// receive a wakeup.\n    ///\n    /// # Runtime characteristics\n    ///\n    /// Futures alone are *inert*; they must be *actively* `poll`ed for the\n    /// underlying computation to make progress, meaning that each time the\n    /// current task is woken up, it should actively re-`poll` pending futures\n    /// that it still has an interest in.\n    ///\n    /// Having said that, some Futures may represent a value that is being\n    /// computed in a different task. In this case, the future's underlying\n    /// computation is simply acting as a conduit for a value being computed\n    /// by that other task, which will proceed independently of the Future.\n    /// Futures of this kind are typically obtained when spawning a new task into an\n    /// async runtime.\n    ///\n    /// The `poll` function should not be called repeatedly in a tight loop --\n    /// instead, it should only be called when the future indicates that it is\n    /// ready to make progress (by calling `wake()`). If you're familiar with the\n    /// `poll(2)` or `select(2)` syscalls on Unix it's worth noting that futures\n    /// typically do *not* suffer the same problems of \"all wakeups must poll\n    /// all events\"; they are more like `epoll(4)`.\n    ///\n    /// An implementation of `poll` should strive to return quickly, and should\n    /// not block. Returning quickly prevents unnecessarily clogging up\n    /// threads or event loops. If it is known ahead of time that a call to\n    /// `poll` may end up taking a while, the work should be offloaded to a\n    /// thread pool (or something similar) to ensure that `poll` can return\n    /// quickly.\n    ///\n    /// # Panics\n    ///\n    /// Once a future has completed (returned `Ready` from `poll`), calling its\n    /// `poll` method again may panic, block forever, or cause other kinds of\n    /// problems; the `Future` trait places no requirements on the effects of\n    /// such a call. However, as the `poll` method is not marked `unsafe`,\n    /// Rust's usual rules apply: calls must never cause undefined behavior\n    /// (memory corruption, incorrect use of `unsafe` functions, or the like),\n    /// regardless of the future's state.\n    ///\n    /// [`Poll::Ready(val)`]: Poll::Ready\n    /// [`Waker`]: crate::task::Waker\n    /// [`Waker::wake`]: crate::task::Waker::wake\n    #[lang = \"poll\"]\n    #[stable(feature = \"futures_api\", since = \"1.36.0\")]\n    fn poll(self: Pin<&mut Self>, cx: &mut Context<'_>) -> Poll<Self::Output>;\n}\n\n#[stable(feature = \"futures_api\", since = \"1.36.0\")]\nimpl<F: ?Sized + Future + Unpin> Future for &mut F {\n    type Output = F::Output;\n\n    fn poll(mut self: Pin<&mut Self>, cx: &mut Context<'_>) -> Poll<Self::Output> {\n        F::poll(Pin::new(&mut **self), cx)\n    }\n}\n\n#[stable(feature = \"futures_api\", since = \"1.36.0\")]\nimpl<P> Future for Pin<P>\nwhere\n    P: ops::DerefMut<Target: Future>,\n{\n    type Output = <<P as ops::Deref>::Target as Future>::Output;\n\n    fn poll(self: Pin<&mut Self>, cx: &mut Context<'_>) -> Poll<Self::Output> {\n        <P::Target as Future>::poll(self.as_deref_mut(), cx)\n    }\n}\n";

},{}],"cbvH5":[function(require,module,exports,__globalThis) {
module.exports = "use super::super::{\n    ArrayChunks, ByRefSized, Chain, Cloned, Copied, Cycle, Enumerate, Filter, FilterMap, FlatMap,\n    Flatten, Fuse, Inspect, Intersperse, IntersperseWith, Map, MapWhile, MapWindows, Peekable,\n    Product, Rev, Scan, Skip, SkipWhile, StepBy, Sum, Take, TakeWhile, TrustedRandomAccessNoCoerce,\n    Zip, try_process,\n};\nuse super::TrustedLen;\nuse crate::array;\nuse crate::cmp::{self, Ordering};\nuse crate::num::NonZero;\nuse crate::ops::{ChangeOutputType, ControlFlow, FromResidual, Residual, Try};\n\nfn _assert_is_dyn_compatible(_: &dyn Iterator<Item = ()>) {}\n\n/// A trait for dealing with iterators.\n///\n/// This is the main iterator trait. For more about the concept of iterators\n/// generally, please see the [module-level documentation]. In particular, you\n/// may want to know how to [implement `Iterator`][impl].\n///\n/// [module-level documentation]: crate::iter\n/// [impl]: crate::iter#implementing-iterator\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\n#[rustc_on_unimplemented(\n    on(\n        Self = \"core::ops::range::RangeTo<Idx>\",\n        note = \"you might have meant to use a bounded `Range`\"\n    ),\n    on(\n        Self = \"core::ops::range::RangeToInclusive<Idx>\",\n        note = \"you might have meant to use a bounded `RangeInclusive`\"\n    ),\n    label = \"`{Self}` is not an iterator\",\n    message = \"`{Self}` is not an iterator\"\n)]\n#[doc(notable_trait)]\n#[lang = \"iterator\"]\n#[rustc_diagnostic_item = \"Iterator\"]\n#[must_use = \"iterators are lazy and do nothing unless consumed\"]\npub trait Iterator {\n    /// The type of the elements being iterated over.\n    #[rustc_diagnostic_item = \"IteratorItem\"]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    type Item;\n\n    /// Advances the iterator and returns the next value.\n    ///\n    /// Returns [`None`] when iteration is finished. Individual iterator\n    /// implementations may choose to resume iteration, and so calling `next()`\n    /// again may or may not eventually start returning [`Some(Item)`] again at some\n    /// point.\n    ///\n    /// [`Some(Item)`]: Some\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let a = [1, 2, 3];\n    ///\n    /// let mut iter = a.into_iter();\n    ///\n    /// // A call to next() returns the next value...\n    /// assert_eq!(Some(1), iter.next());\n    /// assert_eq!(Some(2), iter.next());\n    /// assert_eq!(Some(3), iter.next());\n    ///\n    /// // ... and then None once it's over.\n    /// assert_eq!(None, iter.next());\n    ///\n    /// // More calls may or may not return `None`. Here, they always will.\n    /// assert_eq!(None, iter.next());\n    /// assert_eq!(None, iter.next());\n    /// ```\n    #[lang = \"next\"]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    fn next(&mut self) -> Option<Self::Item>;\n\n    /// Advances the iterator and returns an array containing the next `N` values.\n    ///\n    /// If there are not enough elements to fill the array then `Err` is returned\n    /// containing an iterator over the remaining elements.\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// #![feature(iter_next_chunk)]\n    ///\n    /// let mut iter = \"lorem\".chars();\n    ///\n    /// assert_eq!(iter.next_chunk().unwrap(), ['l', 'o']);              // N is inferred as 2\n    /// assert_eq!(iter.next_chunk().unwrap(), ['r', 'e', 'm']);         // N is inferred as 3\n    /// assert_eq!(iter.next_chunk::<4>().unwrap_err().as_slice(), &[]); // N is explicitly 4\n    /// ```\n    ///\n    /// Split a string and get the first three items.\n    ///\n    /// ```\n    /// #![feature(iter_next_chunk)]\n    ///\n    /// let quote = \"not all those who wander are lost\";\n    /// let [first, second, third] = quote.split_whitespace().next_chunk().unwrap();\n    /// assert_eq!(first, \"not\");\n    /// assert_eq!(second, \"all\");\n    /// assert_eq!(third, \"those\");\n    /// ```\n    #[inline]\n    #[unstable(feature = \"iter_next_chunk\", reason = \"recently added\", issue = \"98326\")]\n    fn next_chunk<const N: usize>(\n        &mut self,\n    ) -> Result<[Self::Item; N], array::IntoIter<Self::Item, N>>\n    where\n        Self: Sized,\n    {\n        array::iter_next_chunk(self)\n    }\n\n    /// Returns the bounds on the remaining length of the iterator.\n    ///\n    /// Specifically, `size_hint()` returns a tuple where the first element\n    /// is the lower bound, and the second element is the upper bound.\n    ///\n    /// The second half of the tuple that is returned is an <code>[Option]<[usize]></code>.\n    /// A [`None`] here means that either there is no known upper bound, or the\n    /// upper bound is larger than [`usize`].\n    ///\n    /// # Implementation notes\n    ///\n    /// It is not enforced that an iterator implementation yields the declared\n    /// number of elements. A buggy iterator may yield less than the lower bound\n    /// or more than the upper bound of elements.\n    ///\n    /// `size_hint()` is primarily intended to be used for optimizations such as\n    /// reserving space for the elements of the iterator, but must not be\n    /// trusted to e.g., omit bounds checks in unsafe code. An incorrect\n    /// implementation of `size_hint()` should not lead to memory safety\n    /// violations.\n    ///\n    /// That said, the implementation should provide a correct estimation,\n    /// because otherwise it would be a violation of the trait's protocol.\n    ///\n    /// The default implementation returns <code>(0, [None])</code> which is correct for any\n    /// iterator.\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// let a = [1, 2, 3];\n    /// let mut iter = a.iter();\n    ///\n    /// assert_eq!((3, Some(3)), iter.size_hint());\n    /// let _ = iter.next();\n    /// assert_eq!((2, Some(2)), iter.size_hint());\n    /// ```\n    ///\n    /// A more complex example:\n    ///\n    /// ```\n    /// // The even numbers in the range of zero to nine.\n    /// let iter = (0..10).filter(|x| x % 2 == 0);\n    ///\n    /// // We might iterate from zero to ten times. Knowing that it's five\n    /// // exactly wouldn't be possible without executing filter().\n    /// assert_eq!((0, Some(10)), iter.size_hint());\n    ///\n    /// // Let's add five more numbers with chain()\n    /// let iter = (0..10).filter(|x| x % 2 == 0).chain(15..20);\n    ///\n    /// // now both bounds are increased by five\n    /// assert_eq!((5, Some(15)), iter.size_hint());\n    /// ```\n    ///\n    /// Returning `None` for an upper bound:\n    ///\n    /// ```\n    /// // an infinite iterator has no upper bound\n    /// // and the maximum possible lower bound\n    /// let iter = 0..;\n    ///\n    /// assert_eq!((usize::MAX, None), iter.size_hint());\n    /// ```\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    fn size_hint(&self) -> (usize, Option<usize>) {\n        (0, None)\n    }\n\n    /// Consumes the iterator, counting the number of iterations and returning it.\n    ///\n    /// This method will call [`next`] repeatedly until [`None`] is encountered,\n    /// returning the number of times it saw [`Some`]. Note that [`next`] has to be\n    /// called at least once even if the iterator does not have any elements.\n    ///\n    /// [`next`]: Iterator::next\n    ///\n    /// # Overflow Behavior\n    ///\n    /// The method does no guarding against overflows, so counting elements of\n    /// an iterator with more than [`usize::MAX`] elements either produces the\n    /// wrong result or panics. If overflow checks are enabled, a panic is\n    /// guaranteed.\n    ///\n    /// # Panics\n    ///\n    /// This function might panic if the iterator has more than [`usize::MAX`]\n    /// elements.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let a = [1, 2, 3];\n    /// assert_eq!(a.iter().count(), 3);\n    ///\n    /// let a = [1, 2, 3, 4, 5];\n    /// assert_eq!(a.iter().count(), 5);\n    /// ```\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    fn count(self) -> usize\n    where\n        Self: Sized,\n    {\n        self.fold(\n            0,\n            #[rustc_inherit_overflow_checks]\n            |count, _| count + 1,\n        )\n    }\n\n    /// Consumes the iterator, returning the last element.\n    ///\n    /// This method will evaluate the iterator until it returns [`None`]. While\n    /// doing so, it keeps track of the current element. After [`None`] is\n    /// returned, `last()` will then return the last element it saw.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let a = [1, 2, 3];\n    /// assert_eq!(a.into_iter().last(), Some(3));\n    ///\n    /// let a = [1, 2, 3, 4, 5];\n    /// assert_eq!(a.into_iter().last(), Some(5));\n    /// ```\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    fn last(self) -> Option<Self::Item>\n    where\n        Self: Sized,\n    {\n        #[inline]\n        fn some<T>(_: Option<T>, x: T) -> Option<T> {\n            Some(x)\n        }\n\n        self.fold(None, some)\n    }\n\n    /// Advances the iterator by `n` elements.\n    ///\n    /// This method will eagerly skip `n` elements by calling [`next`] up to `n`\n    /// times until [`None`] is encountered.\n    ///\n    /// `advance_by(n)` will return `Ok(())` if the iterator successfully advances by\n    /// `n` elements, or a `Err(NonZero<usize>)` with value `k` if [`None`] is encountered,\n    /// where `k` is remaining number of steps that could not be advanced because the iterator ran out.\n    /// If `self` is empty and `n` is non-zero, then this returns `Err(n)`.\n    /// Otherwise, `k` is always less than `n`.\n    ///\n    /// Calling `advance_by(0)` can do meaningful work, for example [`Flatten`]\n    /// can advance its outer iterator until it finds an inner iterator that is not empty, which\n    /// then often allows it to return a more accurate `size_hint()` than in its initial state.\n    ///\n    /// [`Flatten`]: crate::iter::Flatten\n    /// [`next`]: Iterator::next\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(iter_advance_by)]\n    ///\n    /// use std::num::NonZero;\n    ///\n    /// let a = [1, 2, 3, 4];\n    /// let mut iter = a.into_iter();\n    ///\n    /// assert_eq!(iter.advance_by(2), Ok(()));\n    /// assert_eq!(iter.next(), Some(3));\n    /// assert_eq!(iter.advance_by(0), Ok(()));\n    /// assert_eq!(iter.advance_by(100), Err(NonZero::new(99).unwrap())); // only `4` was skipped\n    /// ```\n    #[inline]\n    #[unstable(feature = \"iter_advance_by\", reason = \"recently added\", issue = \"77404\")]\n    fn advance_by(&mut self, n: usize) -> Result<(), NonZero<usize>> {\n        /// Helper trait to specialize `advance_by` via `try_fold` for `Sized` iterators.\n        trait SpecAdvanceBy {\n            fn spec_advance_by(&mut self, n: usize) -> Result<(), NonZero<usize>>;\n        }\n\n        impl<I: Iterator + ?Sized> SpecAdvanceBy for I {\n            default fn spec_advance_by(&mut self, n: usize) -> Result<(), NonZero<usize>> {\n                for i in 0..n {\n                    if self.next().is_none() {\n                        // SAFETY: `i` is always less than `n`.\n                        return Err(unsafe { NonZero::new_unchecked(n - i) });\n                    }\n                }\n                Ok(())\n            }\n        }\n\n        impl<I: Iterator> SpecAdvanceBy for I {\n            fn spec_advance_by(&mut self, n: usize) -> Result<(), NonZero<usize>> {\n                let Some(n) = NonZero::new(n) else {\n                    return Ok(());\n                };\n\n                let res = self.try_fold(n, |n, _| NonZero::new(n.get() - 1));\n\n                match res {\n                    None => Ok(()),\n                    Some(n) => Err(n),\n                }\n            }\n        }\n\n        self.spec_advance_by(n)\n    }\n\n    /// Returns the `n`th element of the iterator.\n    ///\n    /// Like most indexing operations, the count starts from zero, so `nth(0)`\n    /// returns the first value, `nth(1)` the second, and so on.\n    ///\n    /// Note that all preceding elements, as well as the returned element, will be\n    /// consumed from the iterator. That means that the preceding elements will be\n    /// discarded, and also that calling `nth(0)` multiple times on the same iterator\n    /// will return different elements.\n    ///\n    /// `nth()` will return [`None`] if `n` is greater than or equal to the length of the\n    /// iterator.\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// let a = [1, 2, 3];\n    /// assert_eq!(a.into_iter().nth(1), Some(2));\n    /// ```\n    ///\n    /// Calling `nth()` multiple times doesn't rewind the iterator:\n    ///\n    /// ```\n    /// let a = [1, 2, 3];\n    ///\n    /// let mut iter = a.into_iter();\n    ///\n    /// assert_eq!(iter.nth(1), Some(2));\n    /// assert_eq!(iter.nth(1), None);\n    /// ```\n    ///\n    /// Returning `None` if there are less than `n + 1` elements:\n    ///\n    /// ```\n    /// let a = [1, 2, 3];\n    /// assert_eq!(a.into_iter().nth(10), None);\n    /// ```\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    fn nth(&mut self, n: usize) -> Option<Self::Item> {\n        self.advance_by(n).ok()?;\n        self.next()\n    }\n\n    /// Creates an iterator starting at the same point, but stepping by\n    /// the given amount at each iteration.\n    ///\n    /// Note 1: The first element of the iterator will always be returned,\n    /// regardless of the step given.\n    ///\n    /// Note 2: The time at which ignored elements are pulled is not fixed.\n    /// `StepBy` behaves like the sequence `self.next()`, `self.nth(step-1)`,\n    /// `self.nth(step-1)`, …, but is also free to behave like the sequence\n    /// `advance_n_and_return_first(&mut self, step)`,\n    /// `advance_n_and_return_first(&mut self, step)`, …\n    /// Which way is used may change for some iterators for performance reasons.\n    /// The second way will advance the iterator earlier and may consume more items.\n    ///\n    /// `advance_n_and_return_first` is the equivalent of:\n    /// ```\n    /// fn advance_n_and_return_first<I>(iter: &mut I, n: usize) -> Option<I::Item>\n    /// where\n    ///     I: Iterator,\n    /// {\n    ///     let next = iter.next();\n    ///     if n > 1 {\n    ///         iter.nth(n - 2);\n    ///     }\n    ///     next\n    /// }\n    /// ```\n    ///\n    /// # Panics\n    ///\n    /// The method will panic if the given step is `0`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let a = [0, 1, 2, 3, 4, 5];\n    /// let mut iter = a.into_iter().step_by(2);\n    ///\n    /// assert_eq!(iter.next(), Some(0));\n    /// assert_eq!(iter.next(), Some(2));\n    /// assert_eq!(iter.next(), Some(4));\n    /// assert_eq!(iter.next(), None);\n    /// ```\n    #[inline]\n    #[stable(feature = \"iterator_step_by\", since = \"1.28.0\")]\n    fn step_by(self, step: usize) -> StepBy<Self>\n    where\n        Self: Sized,\n    {\n        StepBy::new(self, step)\n    }\n\n    /// Takes two iterators and creates a new iterator over both in sequence.\n    ///\n    /// `chain()` will return a new iterator which will first iterate over\n    /// values from the first iterator and then over values from the second\n    /// iterator.\n    ///\n    /// In other words, it links two iterators together, in a chain. 🔗\n    ///\n    /// [`once`] is commonly used to adapt a single value into a chain of\n    /// other kinds of iteration.\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// let s1 = \"abc\".chars();\n    /// let s2 = \"def\".chars();\n    ///\n    /// let mut iter = s1.chain(s2);\n    ///\n    /// assert_eq!(iter.next(), Some('a'));\n    /// assert_eq!(iter.next(), Some('b'));\n    /// assert_eq!(iter.next(), Some('c'));\n    /// assert_eq!(iter.next(), Some('d'));\n    /// assert_eq!(iter.next(), Some('e'));\n    /// assert_eq!(iter.next(), Some('f'));\n    /// assert_eq!(iter.next(), None);\n    /// ```\n    ///\n    /// Since the argument to `chain()` uses [`IntoIterator`], we can pass\n    /// anything that can be converted into an [`Iterator`], not just an\n    /// [`Iterator`] itself. For example, arrays (`[T]`) implement\n    /// [`IntoIterator`], and so can be passed to `chain()` directly:\n    ///\n    /// ```\n    /// let a1 = [1, 2, 3];\n    /// let a2 = [4, 5, 6];\n    ///\n    /// let mut iter = a1.into_iter().chain(a2);\n    ///\n    /// assert_eq!(iter.next(), Some(1));\n    /// assert_eq!(iter.next(), Some(2));\n    /// assert_eq!(iter.next(), Some(3));\n    /// assert_eq!(iter.next(), Some(4));\n    /// assert_eq!(iter.next(), Some(5));\n    /// assert_eq!(iter.next(), Some(6));\n    /// assert_eq!(iter.next(), None);\n    /// ```\n    ///\n    /// If you work with Windows API, you may wish to convert [`OsStr`] to `Vec<u16>`:\n    ///\n    /// ```\n    /// #[cfg(windows)]\n    /// fn os_str_to_utf16(s: &std::ffi::OsStr) -> Vec<u16> {\n    ///     use std::os::windows::ffi::OsStrExt;\n    ///     s.encode_wide().chain(std::iter::once(0)).collect()\n    /// }\n    /// ```\n    ///\n    /// [`once`]: crate::iter::once\n    /// [`OsStr`]: ../../std/ffi/struct.OsStr.html\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    fn chain<U>(self, other: U) -> Chain<Self, U::IntoIter>\n    where\n        Self: Sized,\n        U: IntoIterator<Item = Self::Item>,\n    {\n        Chain::new(self, other.into_iter())\n    }\n\n    /// 'Zips up' two iterators into a single iterator of pairs.\n    ///\n    /// `zip()` returns a new iterator that will iterate over two other\n    /// iterators, returning a tuple where the first element comes from the\n    /// first iterator, and the second element comes from the second iterator.\n    ///\n    /// In other words, it zips two iterators together, into a single one.\n    ///\n    /// If either iterator returns [`None`], [`next`] from the zipped iterator\n    /// will return [`None`].\n    /// If the zipped iterator has no more elements to return then each further attempt to advance\n    /// it will first try to advance the first iterator at most one time and if it still yielded an item\n    /// try to advance the second iterator at most one time.\n    ///\n    /// To 'undo' the result of zipping up two iterators, see [`unzip`].\n    ///\n    /// [`unzip`]: Iterator::unzip\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// let s1 = \"abc\".chars();\n    /// let s2 = \"def\".chars();\n    ///\n    /// let mut iter = s1.zip(s2);\n    ///\n    /// assert_eq!(iter.next(), Some(('a', 'd')));\n    /// assert_eq!(iter.next(), Some(('b', 'e')));\n    /// assert_eq!(iter.next(), Some(('c', 'f')));\n    /// assert_eq!(iter.next(), None);\n    /// ```\n    ///\n    /// Since the argument to `zip()` uses [`IntoIterator`], we can pass\n    /// anything that can be converted into an [`Iterator`], not just an\n    /// [`Iterator`] itself. For example, arrays (`[T]`) implement\n    /// [`IntoIterator`], and so can be passed to `zip()` directly:\n    ///\n    /// ```\n    /// let a1 = [1, 2, 3];\n    /// let a2 = [4, 5, 6];\n    ///\n    /// let mut iter = a1.into_iter().zip(a2);\n    ///\n    /// assert_eq!(iter.next(), Some((1, 4)));\n    /// assert_eq!(iter.next(), Some((2, 5)));\n    /// assert_eq!(iter.next(), Some((3, 6)));\n    /// assert_eq!(iter.next(), None);\n    /// ```\n    ///\n    /// `zip()` is often used to zip an infinite iterator to a finite one.\n    /// This works because the finite iterator will eventually return [`None`],\n    /// ending the zipper. Zipping with `(0..)` can look a lot like [`enumerate`]:\n    ///\n    /// ```\n    /// let enumerate: Vec<_> = \"foo\".chars().enumerate().collect();\n    ///\n    /// let zipper: Vec<_> = (0..).zip(\"foo\".chars()).collect();\n    ///\n    /// assert_eq!((0, 'f'), enumerate[0]);\n    /// assert_eq!((0, 'f'), zipper[0]);\n    ///\n    /// assert_eq!((1, 'o'), enumerate[1]);\n    /// assert_eq!((1, 'o'), zipper[1]);\n    ///\n    /// assert_eq!((2, 'o'), enumerate[2]);\n    /// assert_eq!((2, 'o'), zipper[2]);\n    /// ```\n    ///\n    /// If both iterators have roughly equivalent syntax, it may be more readable to use [`zip`]:\n    ///\n    /// ```\n    /// use std::iter::zip;\n    ///\n    /// let a = [1, 2, 3];\n    /// let b = [2, 3, 4];\n    ///\n    /// let mut zipped = zip(\n    ///     a.into_iter().map(|x| x * 2).skip(1),\n    ///     b.into_iter().map(|x| x * 2).skip(1),\n    /// );\n    ///\n    /// assert_eq!(zipped.next(), Some((4, 6)));\n    /// assert_eq!(zipped.next(), Some((6, 8)));\n    /// assert_eq!(zipped.next(), None);\n    /// ```\n    ///\n    /// compared to:\n    ///\n    /// ```\n    /// # let a = [1, 2, 3];\n    /// # let b = [2, 3, 4];\n    /// #\n    /// let mut zipped = a\n    ///     .into_iter()\n    ///     .map(|x| x * 2)\n    ///     .skip(1)\n    ///     .zip(b.into_iter().map(|x| x * 2).skip(1));\n    /// #\n    /// # assert_eq!(zipped.next(), Some((4, 6)));\n    /// # assert_eq!(zipped.next(), Some((6, 8)));\n    /// # assert_eq!(zipped.next(), None);\n    /// ```\n    ///\n    /// [`enumerate`]: Iterator::enumerate\n    /// [`next`]: Iterator::next\n    /// [`zip`]: crate::iter::zip\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    fn zip<U>(self, other: U) -> Zip<Self, U::IntoIter>\n    where\n        Self: Sized,\n        U: IntoIterator,\n    {\n        Zip::new(self, other.into_iter())\n    }\n\n    /// Creates a new iterator which places a copy of `separator` between adjacent\n    /// items of the original iterator.\n    ///\n    /// In case `separator` does not implement [`Clone`] or needs to be\n    /// computed every time, use [`intersperse_with`].\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// #![feature(iter_intersperse)]\n    ///\n    /// let mut a = [0, 1, 2].into_iter().intersperse(100);\n    /// assert_eq!(a.next(), Some(0));   // The first element from `a`.\n    /// assert_eq!(a.next(), Some(100)); // The separator.\n    /// assert_eq!(a.next(), Some(1));   // The next element from `a`.\n    /// assert_eq!(a.next(), Some(100)); // The separator.\n    /// assert_eq!(a.next(), Some(2));   // The last element from `a`.\n    /// assert_eq!(a.next(), None);       // The iterator is finished.\n    /// ```\n    ///\n    /// `intersperse` can be very useful to join an iterator's items using a common element:\n    /// ```\n    /// #![feature(iter_intersperse)]\n    ///\n    /// let words = [\"Hello\", \"World\", \"!\"];\n    /// let hello: String = words.into_iter().intersperse(\" \").collect();\n    /// assert_eq!(hello, \"Hello World !\");\n    /// ```\n    ///\n    /// [`Clone`]: crate::clone::Clone\n    /// [`intersperse_with`]: Iterator::intersperse_with\n    #[inline]\n    #[unstable(feature = \"iter_intersperse\", reason = \"recently added\", issue = \"79524\")]\n    fn intersperse(self, separator: Self::Item) -> Intersperse<Self>\n    where\n        Self: Sized,\n        Self::Item: Clone,\n    {\n        Intersperse::new(self, separator)\n    }\n\n    /// Creates a new iterator which places an item generated by `separator`\n    /// between adjacent items of the original iterator.\n    ///\n    /// The closure will be called exactly once each time an item is placed\n    /// between two adjacent items from the underlying iterator; specifically,\n    /// the closure is not called if the underlying iterator yields less than\n    /// two items and after the last item is yielded.\n    ///\n    /// If the iterator's item implements [`Clone`], it may be easier to use\n    /// [`intersperse`].\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// #![feature(iter_intersperse)]\n    ///\n    /// #[derive(PartialEq, Debug)]\n    /// struct NotClone(usize);\n    ///\n    /// let v = [NotClone(0), NotClone(1), NotClone(2)];\n    /// let mut it = v.into_iter().intersperse_with(|| NotClone(99));\n    ///\n    /// assert_eq!(it.next(), Some(NotClone(0)));  // The first element from `v`.\n    /// assert_eq!(it.next(), Some(NotClone(99))); // The separator.\n    /// assert_eq!(it.next(), Some(NotClone(1)));  // The next element from `v`.\n    /// assert_eq!(it.next(), Some(NotClone(99))); // The separator.\n    /// assert_eq!(it.next(), Some(NotClone(2)));  // The last element from `v`.\n    /// assert_eq!(it.next(), None);               // The iterator is finished.\n    /// ```\n    ///\n    /// `intersperse_with` can be used in situations where the separator needs\n    /// to be computed:\n    /// ```\n    /// #![feature(iter_intersperse)]\n    ///\n    /// let src = [\"Hello\", \"to\", \"all\", \"people\", \"!!\"].iter().copied();\n    ///\n    /// // The closure mutably borrows its context to generate an item.\n    /// let mut happy_emojis = [\" ❤️ \", \" 😀 \"].into_iter();\n    /// let separator = || happy_emojis.next().unwrap_or(\" 🦀 \");\n    ///\n    /// let result = src.intersperse_with(separator).collect::<String>();\n    /// assert_eq!(result, \"Hello ❤️ to 😀 all 🦀 people 🦀 !!\");\n    /// ```\n    /// [`Clone`]: crate::clone::Clone\n    /// [`intersperse`]: Iterator::intersperse\n    #[inline]\n    #[unstable(feature = \"iter_intersperse\", reason = \"recently added\", issue = \"79524\")]\n    fn intersperse_with<G>(self, separator: G) -> IntersperseWith<Self, G>\n    where\n        Self: Sized,\n        G: FnMut() -> Self::Item,\n    {\n        IntersperseWith::new(self, separator)\n    }\n\n    /// Takes a closure and creates an iterator which calls that closure on each\n    /// element.\n    ///\n    /// `map()` transforms one iterator into another, by means of its argument:\n    /// something that implements [`FnMut`]. It produces a new iterator which\n    /// calls this closure on each element of the original iterator.\n    ///\n    /// If you are good at thinking in types, you can think of `map()` like this:\n    /// If you have an iterator that gives you elements of some type `A`, and\n    /// you want an iterator of some other type `B`, you can use `map()`,\n    /// passing a closure that takes an `A` and returns a `B`.\n    ///\n    /// `map()` is conceptually similar to a [`for`] loop. However, as `map()` is\n    /// lazy, it is best used when you're already working with other iterators.\n    /// If you're doing some sort of looping for a side effect, it's considered\n    /// more idiomatic to use [`for`] than `map()`.\n    ///\n    /// [`for`]: ../../book/ch03-05-control-flow.html#looping-through-a-collection-with-for\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// let a = [1, 2, 3];\n    ///\n    /// let mut iter = a.iter().map(|x| 2 * x);\n    ///\n    /// assert_eq!(iter.next(), Some(2));\n    /// assert_eq!(iter.next(), Some(4));\n    /// assert_eq!(iter.next(), Some(6));\n    /// assert_eq!(iter.next(), None);\n    /// ```\n    ///\n    /// If you're doing some sort of side effect, prefer [`for`] to `map()`:\n    ///\n    /// ```\n    /// # #![allow(unused_must_use)]\n    /// // don't do this:\n    /// (0..5).map(|x| println!(\"{x}\"));\n    ///\n    /// // it won't even execute, as it is lazy. Rust will warn you about this.\n    ///\n    /// // Instead, use a for-loop:\n    /// for x in 0..5 {\n    ///     println!(\"{x}\");\n    /// }\n    /// ```\n    #[rustc_diagnostic_item = \"IteratorMap\"]\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    fn map<B, F>(self, f: F) -> Map<Self, F>\n    where\n        Self: Sized,\n        F: FnMut(Self::Item) -> B,\n    {\n        Map::new(self, f)\n    }\n\n    /// Calls a closure on each element of an iterator.\n    ///\n    /// This is equivalent to using a [`for`] loop on the iterator, although\n    /// `break` and `continue` are not possible from a closure. It's generally\n    /// more idiomatic to use a `for` loop, but `for_each` may be more legible\n    /// when processing items at the end of longer iterator chains. In some\n    /// cases `for_each` may also be faster than a loop, because it will use\n    /// internal iteration on adapters like `Chain`.\n    ///\n    /// [`for`]: ../../book/ch03-05-control-flow.html#looping-through-a-collection-with-for\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// use std::sync::mpsc::channel;\n    ///\n    /// let (tx, rx) = channel();\n    /// (0..5).map(|x| x * 2 + 1)\n    ///       .for_each(move |x| tx.send(x).unwrap());\n    ///\n    /// let v: Vec<_> = rx.iter().collect();\n    /// assert_eq!(v, vec![1, 3, 5, 7, 9]);\n    /// ```\n    ///\n    /// For such a small example, a `for` loop may be cleaner, but `for_each`\n    /// might be preferable to keep a functional style with longer iterators:\n    ///\n    /// ```\n    /// (0..5).flat_map(|x| (x * 100)..(x * 110))\n    ///       .enumerate()\n    ///       .filter(|&(i, x)| (i + x) % 3 == 0)\n    ///       .for_each(|(i, x)| println!(\"{i}:{x}\"));\n    /// ```\n    #[inline]\n    #[stable(feature = \"iterator_for_each\", since = \"1.21.0\")]\n    fn for_each<F>(self, f: F)\n    where\n        Self: Sized,\n        F: FnMut(Self::Item),\n    {\n        #[inline]\n        fn call<T>(mut f: impl FnMut(T)) -> impl FnMut((), T) {\n            move |(), item| f(item)\n        }\n\n        self.fold((), call(f));\n    }\n\n    /// Creates an iterator which uses a closure to determine if an element\n    /// should be yielded.\n    ///\n    /// Given an element the closure must return `true` or `false`. The returned\n    /// iterator will yield only the elements for which the closure returns\n    /// `true`.\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// let a = [0i32, 1, 2];\n    ///\n    /// let mut iter = a.into_iter().filter(|x| x.is_positive());\n    ///\n    /// assert_eq!(iter.next(), Some(1));\n    /// assert_eq!(iter.next(), Some(2));\n    /// assert_eq!(iter.next(), None);\n    /// ```\n    ///\n    /// Because the closure passed to `filter()` takes a reference, and many\n    /// iterators iterate over references, this leads to a possibly confusing\n    /// situation, where the type of the closure is a double reference:\n    ///\n    /// ```\n    /// let s = &[0, 1, 2];\n    ///\n    /// let mut iter = s.iter().filter(|x| **x > 1); // needs two *s!\n    ///\n    /// assert_eq!(iter.next(), Some(&2));\n    /// assert_eq!(iter.next(), None);\n    /// ```\n    ///\n    /// It's common to instead use destructuring on the argument to strip away one:\n    ///\n    /// ```\n    /// let s = &[0, 1, 2];\n    ///\n    /// let mut iter = s.iter().filter(|&x| *x > 1); // both & and *\n    ///\n    /// assert_eq!(iter.next(), Some(&2));\n    /// assert_eq!(iter.next(), None);\n    /// ```\n    ///\n    /// or both:\n    ///\n    /// ```\n    /// let s = &[0, 1, 2];\n    ///\n    /// let mut iter = s.iter().filter(|&&x| x > 1); // two &s\n    ///\n    /// assert_eq!(iter.next(), Some(&2));\n    /// assert_eq!(iter.next(), None);\n    /// ```\n    ///\n    /// of these layers.\n    ///\n    /// Note that `iter.filter(f).next()` is equivalent to `iter.find(f)`.\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_diagnostic_item = \"iter_filter\"]\n    fn filter<P>(self, predicate: P) -> Filter<Self, P>\n    where\n        Self: Sized,\n        P: FnMut(&Self::Item) -> bool,\n    {\n        Filter::new(self, predicate)\n    }\n\n    /// Creates an iterator that both filters and maps.\n    ///\n    /// The returned iterator yields only the `value`s for which the supplied\n    /// closure returns `Some(value)`.\n    ///\n    /// `filter_map` can be used to make chains of [`filter`] and [`map`] more\n    /// concise. The example below shows how a `map().filter().map()` can be\n    /// shortened to a single call to `filter_map`.\n    ///\n    /// [`filter`]: Iterator::filter\n    /// [`map`]: Iterator::map\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// let a = [\"1\", \"two\", \"NaN\", \"four\", \"5\"];\n    ///\n    /// let mut iter = a.iter().filter_map(|s| s.parse().ok());\n    ///\n    /// assert_eq!(iter.next(), Some(1));\n    /// assert_eq!(iter.next(), Some(5));\n    /// assert_eq!(iter.next(), None);\n    /// ```\n    ///\n    /// Here's the same example, but with [`filter`] and [`map`]:\n    ///\n    /// ```\n    /// let a = [\"1\", \"two\", \"NaN\", \"four\", \"5\"];\n    /// let mut iter = a.iter().map(|s| s.parse()).filter(|s| s.is_ok()).map(|s| s.unwrap());\n    /// assert_eq!(iter.next(), Some(1));\n    /// assert_eq!(iter.next(), Some(5));\n    /// assert_eq!(iter.next(), None);\n    /// ```\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    fn filter_map<B, F>(self, f: F) -> FilterMap<Self, F>\n    where\n        Self: Sized,\n        F: FnMut(Self::Item) -> Option<B>,\n    {\n        FilterMap::new(self, f)\n    }\n\n    /// Creates an iterator which gives the current iteration count as well as\n    /// the next value.\n    ///\n    /// The iterator returned yields pairs `(i, val)`, where `i` is the\n    /// current index of iteration and `val` is the value returned by the\n    /// iterator.\n    ///\n    /// `enumerate()` keeps its count as a [`usize`]. If you want to count by a\n    /// different sized integer, the [`zip`] function provides similar\n    /// functionality.\n    ///\n    /// # Overflow Behavior\n    ///\n    /// The method does no guarding against overflows, so enumerating more than\n    /// [`usize::MAX`] elements either produces the wrong result or panics. If\n    /// overflow checks are enabled, a panic is guaranteed.\n    ///\n    /// # Panics\n    ///\n    /// The returned iterator might panic if the to-be-returned index would\n    /// overflow a [`usize`].\n    ///\n    /// [`zip`]: Iterator::zip\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let a = ['a', 'b', 'c'];\n    ///\n    /// let mut iter = a.into_iter().enumerate();\n    ///\n    /// assert_eq!(iter.next(), Some((0, 'a')));\n    /// assert_eq!(iter.next(), Some((1, 'b')));\n    /// assert_eq!(iter.next(), Some((2, 'c')));\n    /// assert_eq!(iter.next(), None);\n    /// ```\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_diagnostic_item = \"enumerate_method\"]\n    fn enumerate(self) -> Enumerate<Self>\n    where\n        Self: Sized,\n    {\n        Enumerate::new(self)\n    }\n\n    /// Creates an iterator which can use the [`peek`] and [`peek_mut`] methods\n    /// to look at the next element of the iterator without consuming it. See\n    /// their documentation for more information.\n    ///\n    /// Note that the underlying iterator is still advanced when [`peek`] or\n    /// [`peek_mut`] are called for the first time: In order to retrieve the\n    /// next element, [`next`] is called on the underlying iterator, hence any\n    /// side effects (i.e. anything other than fetching the next value) of\n    /// the [`next`] method will occur.\n    ///\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// let xs = [1, 2, 3];\n    ///\n    /// let mut iter = xs.into_iter().peekable();\n    ///\n    /// // peek() lets us see into the future\n    /// assert_eq!(iter.peek(), Some(&1));\n    /// assert_eq!(iter.next(), Some(1));\n    ///\n    /// assert_eq!(iter.next(), Some(2));\n    ///\n    /// // we can peek() multiple times, the iterator won't advance\n    /// assert_eq!(iter.peek(), Some(&3));\n    /// assert_eq!(iter.peek(), Some(&3));\n    ///\n    /// assert_eq!(iter.next(), Some(3));\n    ///\n    /// // after the iterator is finished, so is peek()\n    /// assert_eq!(iter.peek(), None);\n    /// assert_eq!(iter.next(), None);\n    /// ```\n    ///\n    /// Using [`peek_mut`] to mutate the next item without advancing the\n    /// iterator:\n    ///\n    /// ```\n    /// let xs = [1, 2, 3];\n    ///\n    /// let mut iter = xs.into_iter().peekable();\n    ///\n    /// // `peek_mut()` lets us see into the future\n    /// assert_eq!(iter.peek_mut(), Some(&mut 1));\n    /// assert_eq!(iter.peek_mut(), Some(&mut 1));\n    /// assert_eq!(iter.next(), Some(1));\n    ///\n    /// if let Some(p) = iter.peek_mut() {\n    ///     assert_eq!(*p, 2);\n    ///     // put a value into the iterator\n    ///     *p = 1000;\n    /// }\n    ///\n    /// // The value reappears as the iterator continues\n    /// assert_eq!(iter.collect::<Vec<_>>(), vec![1000, 3]);\n    /// ```\n    /// [`peek`]: Peekable::peek\n    /// [`peek_mut`]: Peekable::peek_mut\n    /// [`next`]: Iterator::next\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    fn peekable(self) -> Peekable<Self>\n    where\n        Self: Sized,\n    {\n        Peekable::new(self)\n    }\n\n    /// Creates an iterator that [`skip`]s elements based on a predicate.\n    ///\n    /// [`skip`]: Iterator::skip\n    ///\n    /// `skip_while()` takes a closure as an argument. It will call this\n    /// closure on each element of the iterator, and ignore elements\n    /// until it returns `false`.\n    ///\n    /// After `false` is returned, `skip_while()`'s job is over, and the\n    /// rest of the elements are yielded.\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// let a = [-1i32, 0, 1];\n    ///\n    /// let mut iter = a.into_iter().skip_while(|x| x.is_negative());\n    ///\n    /// assert_eq!(iter.next(), Some(0));\n    /// assert_eq!(iter.next(), Some(1));\n    /// assert_eq!(iter.next(), None);\n    /// ```\n    ///\n    /// Because the closure passed to `skip_while()` takes a reference, and many\n    /// iterators iterate over references, this leads to a possibly confusing\n    /// situation, where the type of the closure argument is a double reference:\n    ///\n    /// ```\n    /// let s = &[-1, 0, 1];\n    ///\n    /// let mut iter = s.iter().skip_while(|x| **x < 0); // need two *s!\n    ///\n    /// assert_eq!(iter.next(), Some(&0));\n    /// assert_eq!(iter.next(), Some(&1));\n    /// assert_eq!(iter.next(), None);\n    /// ```\n    ///\n    /// Stopping after an initial `false`:\n    ///\n    /// ```\n    /// let a = [-1, 0, 1, -2];\n    ///\n    /// let mut iter = a.into_iter().skip_while(|&x| x < 0);\n    ///\n    /// assert_eq!(iter.next(), Some(0));\n    /// assert_eq!(iter.next(), Some(1));\n    ///\n    /// // while this would have been false, since we already got a false,\n    /// // skip_while() isn't used any more\n    /// assert_eq!(iter.next(), Some(-2));\n    ///\n    /// assert_eq!(iter.next(), None);\n    /// ```\n    #[inline]\n    #[doc(alias = \"drop_while\")]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    fn skip_while<P>(self, predicate: P) -> SkipWhile<Self, P>\n    where\n        Self: Sized,\n        P: FnMut(&Self::Item) -> bool,\n    {\n        SkipWhile::new(self, predicate)\n    }\n\n    /// Creates an iterator that yields elements based on a predicate.\n    ///\n    /// `take_while()` takes a closure as an argument. It will call this\n    /// closure on each element of the iterator, and yield elements\n    /// while it returns `true`.\n    ///\n    /// After `false` is returned, `take_while()`'s job is over, and the\n    /// rest of the elements are ignored.\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// let a = [-1i32, 0, 1];\n    ///\n    /// let mut iter = a.into_iter().take_while(|x| x.is_negative());\n    ///\n    /// assert_eq!(iter.next(), Some(-1));\n    /// assert_eq!(iter.next(), None);\n    /// ```\n    ///\n    /// Because the closure passed to `take_while()` takes a reference, and many\n    /// iterators iterate over references, this leads to a possibly confusing\n    /// situation, where the type of the closure is a double reference:\n    ///\n    /// ```\n    /// let s = &[-1, 0, 1];\n    ///\n    /// let mut iter = s.iter().take_while(|x| **x < 0); // need two *s!\n    ///\n    /// assert_eq!(iter.next(), Some(&-1));\n    /// assert_eq!(iter.next(), None);\n    /// ```\n    ///\n    /// Stopping after an initial `false`:\n    ///\n    /// ```\n    /// let a = [-1, 0, 1, -2];\n    ///\n    /// let mut iter = a.into_iter().take_while(|&x| x < 0);\n    ///\n    /// assert_eq!(iter.next(), Some(-1));\n    ///\n    /// // We have more elements that are less than zero, but since we already\n    /// // got a false, take_while() ignores the remaining elements.\n    /// assert_eq!(iter.next(), None);\n    /// ```\n    ///\n    /// Because `take_while()` needs to look at the value in order to see if it\n    /// should be included or not, consuming iterators will see that it is\n    /// removed:\n    ///\n    /// ```\n    /// let a = [1, 2, 3, 4];\n    /// let mut iter = a.into_iter();\n    ///\n    /// let result: Vec<i32> = iter.by_ref().take_while(|&n| n != 3).collect();\n    ///\n    /// assert_eq!(result, [1, 2]);\n    ///\n    /// let result: Vec<i32> = iter.collect();\n    ///\n    /// assert_eq!(result, [4]);\n    /// ```\n    ///\n    /// The `3` is no longer there, because it was consumed in order to see if\n    /// the iteration should stop, but wasn't placed back into the iterator.\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    fn take_while<P>(self, predicate: P) -> TakeWhile<Self, P>\n    where\n        Self: Sized,\n        P: FnMut(&Self::Item) -> bool,\n    {\n        TakeWhile::new(self, predicate)\n    }\n\n    /// Creates an iterator that both yields elements based on a predicate and maps.\n    ///\n    /// `map_while()` takes a closure as an argument. It will call this\n    /// closure on each element of the iterator, and yield elements\n    /// while it returns [`Some(_)`][`Some`].\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// let a = [-1i32, 4, 0, 1];\n    ///\n    /// let mut iter = a.into_iter().map_while(|x| 16i32.checked_div(x));\n    ///\n    /// assert_eq!(iter.next(), Some(-16));\n    /// assert_eq!(iter.next(), Some(4));\n    /// assert_eq!(iter.next(), None);\n    /// ```\n    ///\n    /// Here's the same example, but with [`take_while`] and [`map`]:\n    ///\n    /// [`take_while`]: Iterator::take_while\n    /// [`map`]: Iterator::map\n    ///\n    /// ```\n    /// let a = [-1i32, 4, 0, 1];\n    ///\n    /// let mut iter = a.into_iter()\n    ///                 .map(|x| 16i32.checked_div(x))\n    ///                 .take_while(|x| x.is_some())\n    ///                 .map(|x| x.unwrap());\n    ///\n    /// assert_eq!(iter.next(), Some(-16));\n    /// assert_eq!(iter.next(), Some(4));\n    /// assert_eq!(iter.next(), None);\n    /// ```\n    ///\n    /// Stopping after an initial [`None`]:\n    ///\n    /// ```\n    /// let a = [0, 1, 2, -3, 4, 5, -6];\n    ///\n    /// let iter = a.into_iter().map_while(|x| u32::try_from(x).ok());\n    /// let vec: Vec<_> = iter.collect();\n    ///\n    /// // We have more elements that could fit in u32 (such as 4, 5), but `map_while` returned `None` for `-3`\n    /// // (as the `predicate` returned `None`) and `collect` stops at the first `None` encountered.\n    /// assert_eq!(vec, [0, 1, 2]);\n    /// ```\n    ///\n    /// Because `map_while()` needs to look at the value in order to see if it\n    /// should be included or not, consuming iterators will see that it is\n    /// removed:\n    ///\n    /// ```\n    /// let a = [1, 2, -3, 4];\n    /// let mut iter = a.into_iter();\n    ///\n    /// let result: Vec<u32> = iter.by_ref()\n    ///                            .map_while(|n| u32::try_from(n).ok())\n    ///                            .collect();\n    ///\n    /// assert_eq!(result, [1, 2]);\n    ///\n    /// let result: Vec<i32> = iter.collect();\n    ///\n    /// assert_eq!(result, [4]);\n    /// ```\n    ///\n    /// The `-3` is no longer there, because it was consumed in order to see if\n    /// the iteration should stop, but wasn't placed back into the iterator.\n    ///\n    /// Note that unlike [`take_while`] this iterator is **not** fused.\n    /// It is also not specified what this iterator returns after the first [`None`] is returned.\n    /// If you need a fused iterator, use [`fuse`].\n    ///\n    /// [`fuse`]: Iterator::fuse\n    #[inline]\n    #[stable(feature = \"iter_map_while\", since = \"1.57.0\")]\n    fn map_while<B, P>(self, predicate: P) -> MapWhile<Self, P>\n    where\n        Self: Sized,\n        P: FnMut(Self::Item) -> Option<B>,\n    {\n        MapWhile::new(self, predicate)\n    }\n\n    /// Creates an iterator that skips the first `n` elements.\n    ///\n    /// `skip(n)` skips elements until `n` elements are skipped or the end of the\n    /// iterator is reached (whichever happens first). After that, all the remaining\n    /// elements are yielded. In particular, if the original iterator is too short,\n    /// then the returned iterator is empty.\n    ///\n    /// Rather than overriding this method directly, instead override the `nth` method.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let a = [1, 2, 3];\n    ///\n    /// let mut iter = a.into_iter().skip(2);\n    ///\n    /// assert_eq!(iter.next(), Some(3));\n    /// assert_eq!(iter.next(), None);\n    /// ```\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    fn skip(self, n: usize) -> Skip<Self>\n    where\n        Self: Sized,\n    {\n        Skip::new(self, n)\n    }\n\n    /// Creates an iterator that yields the first `n` elements, or fewer\n    /// if the underlying iterator ends sooner.\n    ///\n    /// `take(n)` yields elements until `n` elements are yielded or the end of\n    /// the iterator is reached (whichever happens first).\n    /// The returned iterator is a prefix of length `n` if the original iterator\n    /// contains at least `n` elements, otherwise it contains all of the\n    /// (fewer than `n`) elements of the original iterator.\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// let a = [1, 2, 3];\n    ///\n    /// let mut iter = a.into_iter().take(2);\n    ///\n    /// assert_eq!(iter.next(), Some(1));\n    /// assert_eq!(iter.next(), Some(2));\n    /// assert_eq!(iter.next(), None);\n    /// ```\n    ///\n    /// `take()` is often used with an infinite iterator, to make it finite:\n    ///\n    /// ```\n    /// let mut iter = (0..).take(3);\n    ///\n    /// assert_eq!(iter.next(), Some(0));\n    /// assert_eq!(iter.next(), Some(1));\n    /// assert_eq!(iter.next(), Some(2));\n    /// assert_eq!(iter.next(), None);\n    /// ```\n    ///\n    /// If less than `n` elements are available,\n    /// `take` will limit itself to the size of the underlying iterator:\n    ///\n    /// ```\n    /// let v = [1, 2];\n    /// let mut iter = v.into_iter().take(5);\n    /// assert_eq!(iter.next(), Some(1));\n    /// assert_eq!(iter.next(), Some(2));\n    /// assert_eq!(iter.next(), None);\n    /// ```\n    ///\n    /// Use [`by_ref`] to take from the iterator without consuming it, and then\n    /// continue using the original iterator:\n    ///\n    /// ```\n    /// let mut words = [\"hello\", \"world\", \"of\", \"Rust\"].into_iter();\n    ///\n    /// // Take the first two words.\n    /// let hello_world: Vec<_> = words.by_ref().take(2).collect();\n    /// assert_eq!(hello_world, vec![\"hello\", \"world\"]);\n    ///\n    /// // Collect the rest of the words.\n    /// // We can only do this because we used `by_ref` earlier.\n    /// let of_rust: Vec<_> = words.collect();\n    /// assert_eq!(of_rust, vec![\"of\", \"Rust\"]);\n    /// ```\n    ///\n    /// [`by_ref`]: Iterator::by_ref\n    #[doc(alias = \"limit\")]\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    fn take(self, n: usize) -> Take<Self>\n    where\n        Self: Sized,\n    {\n        Take::new(self, n)\n    }\n\n    /// An iterator adapter which, like [`fold`], holds internal state, but\n    /// unlike [`fold`], produces a new iterator.\n    ///\n    /// [`fold`]: Iterator::fold\n    ///\n    /// `scan()` takes two arguments: an initial value which seeds the internal\n    /// state, and a closure with two arguments, the first being a mutable\n    /// reference to the internal state and the second an iterator element.\n    /// The closure can assign to the internal state to share state between\n    /// iterations.\n    ///\n    /// On iteration, the closure will be applied to each element of the\n    /// iterator and the return value from the closure, an [`Option`], is\n    /// returned by the `next` method. Thus the closure can return\n    /// `Some(value)` to yield `value`, or `None` to end the iteration.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let a = [1, 2, 3, 4];\n    ///\n    /// let mut iter = a.into_iter().scan(1, |state, x| {\n    ///     // each iteration, we'll multiply the state by the element ...\n    ///     *state = *state * x;\n    ///\n    ///     // ... and terminate if the state exceeds 6\n    ///     if *state > 6 {\n    ///         return None;\n    ///     }\n    ///     // ... else yield the negation of the state\n    ///     Some(-*state)\n    /// });\n    ///\n    /// assert_eq!(iter.next(), Some(-1));\n    /// assert_eq!(iter.next(), Some(-2));\n    /// assert_eq!(iter.next(), Some(-6));\n    /// assert_eq!(iter.next(), None);\n    /// ```\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    fn scan<St, B, F>(self, initial_state: St, f: F) -> Scan<Self, St, F>\n    where\n        Self: Sized,\n        F: FnMut(&mut St, Self::Item) -> Option<B>,\n    {\n        Scan::new(self, initial_state, f)\n    }\n\n    /// Creates an iterator that works like map, but flattens nested structure.\n    ///\n    /// The [`map`] adapter is very useful, but only when the closure\n    /// argument produces values. If it produces an iterator instead, there's\n    /// an extra layer of indirection. `flat_map()` will remove this extra layer\n    /// on its own.\n    ///\n    /// You can think of `flat_map(f)` as the semantic equivalent\n    /// of [`map`]ping, and then [`flatten`]ing as in `map(f).flatten()`.\n    ///\n    /// Another way of thinking about `flat_map()`: [`map`]'s closure returns\n    /// one item for each element, and `flat_map()`'s closure returns an\n    /// iterator for each element.\n    ///\n    /// [`map`]: Iterator::map\n    /// [`flatten`]: Iterator::flatten\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let words = [\"alpha\", \"beta\", \"gamma\"];\n    ///\n    /// // chars() returns an iterator\n    /// let merged: String = words.iter()\n    ///                           .flat_map(|s| s.chars())\n    ///                           .collect();\n    /// assert_eq!(merged, \"alphabetagamma\");\n    /// ```\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    fn flat_map<U, F>(self, f: F) -> FlatMap<Self, U, F>\n    where\n        Self: Sized,\n        U: IntoIterator,\n        F: FnMut(Self::Item) -> U,\n    {\n        FlatMap::new(self, f)\n    }\n\n    /// Creates an iterator that flattens nested structure.\n    ///\n    /// This is useful when you have an iterator of iterators or an iterator of\n    /// things that can be turned into iterators and you want to remove one\n    /// level of indirection.\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// let data = vec![vec![1, 2, 3, 4], vec![5, 6]];\n    /// let flattened: Vec<_> = data.into_iter().flatten().collect();\n    /// assert_eq!(flattened, [1, 2, 3, 4, 5, 6]);\n    /// ```\n    ///\n    /// Mapping and then flattening:\n    ///\n    /// ```\n    /// let words = [\"alpha\", \"beta\", \"gamma\"];\n    ///\n    /// // chars() returns an iterator\n    /// let merged: String = words.iter()\n    ///                           .map(|s| s.chars())\n    ///                           .flatten()\n    ///                           .collect();\n    /// assert_eq!(merged, \"alphabetagamma\");\n    /// ```\n    ///\n    /// You can also rewrite this in terms of [`flat_map()`], which is preferable\n    /// in this case since it conveys intent more clearly:\n    ///\n    /// ```\n    /// let words = [\"alpha\", \"beta\", \"gamma\"];\n    ///\n    /// // chars() returns an iterator\n    /// let merged: String = words.iter()\n    ///                           .flat_map(|s| s.chars())\n    ///                           .collect();\n    /// assert_eq!(merged, \"alphabetagamma\");\n    /// ```\n    ///\n    /// Flattening works on any `IntoIterator` type, including `Option` and `Result`:\n    ///\n    /// ```\n    /// let options = vec![Some(123), Some(321), None, Some(231)];\n    /// let flattened_options: Vec<_> = options.into_iter().flatten().collect();\n    /// assert_eq!(flattened_options, [123, 321, 231]);\n    ///\n    /// let results = vec![Ok(123), Ok(321), Err(456), Ok(231)];\n    /// let flattened_results: Vec<_> = results.into_iter().flatten().collect();\n    /// assert_eq!(flattened_results, [123, 321, 231]);\n    /// ```\n    ///\n    /// Flattening only removes one level of nesting at a time:\n    ///\n    /// ```\n    /// let d3 = [[[1, 2], [3, 4]], [[5, 6], [7, 8]]];\n    ///\n    /// let d2: Vec<_> = d3.into_iter().flatten().collect();\n    /// assert_eq!(d2, [[1, 2], [3, 4], [5, 6], [7, 8]]);\n    ///\n    /// let d1: Vec<_> = d3.into_iter().flatten().flatten().collect();\n    /// assert_eq!(d1, [1, 2, 3, 4, 5, 6, 7, 8]);\n    /// ```\n    ///\n    /// Here we see that `flatten()` does not perform a \"deep\" flatten.\n    /// Instead, only one level of nesting is removed. That is, if you\n    /// `flatten()` a three-dimensional array, the result will be\n    /// two-dimensional and not one-dimensional. To get a one-dimensional\n    /// structure, you have to `flatten()` again.\n    ///\n    /// [`flat_map()`]: Iterator::flat_map\n    #[inline]\n    #[stable(feature = \"iterator_flatten\", since = \"1.29.0\")]\n    fn flatten(self) -> Flatten<Self>\n    where\n        Self: Sized,\n        Self::Item: IntoIterator,\n    {\n        Flatten::new(self)\n    }\n\n    /// Calls the given function `f` for each contiguous window of size `N` over\n    /// `self` and returns an iterator over the outputs of `f`. Like [`slice::windows()`],\n    /// the windows during mapping overlap as well.\n    ///\n    /// In the following example, the closure is called three times with the\n    /// arguments `&['a', 'b']`, `&['b', 'c']` and `&['c', 'd']` respectively.\n    ///\n    /// ```\n    /// #![feature(iter_map_windows)]\n    ///\n    /// let strings = \"abcd\".chars()\n    ///     .map_windows(|[x, y]| format!(\"{}+{}\", x, y))\n    ///     .collect::<Vec<String>>();\n    ///\n    /// assert_eq!(strings, vec![\"a+b\", \"b+c\", \"c+d\"]);\n    /// ```\n    ///\n    /// Note that the const parameter `N` is usually inferred by the\n    /// destructured argument in the closure.\n    ///\n    /// The returned iterator yields 𝑘 − `N` + 1 items (where 𝑘 is the number of\n    /// items yielded by `self`). If 𝑘 is less than `N`, this method yields an\n    /// empty iterator.\n    ///\n    /// The returned iterator implements [`FusedIterator`], because once `self`\n    /// returns `None`, even if it returns a `Some(T)` again in the next iterations,\n    /// we cannot put it into a contiguous array buffer, and thus the returned iterator\n    /// should be fused.\n    ///\n    /// [`slice::windows()`]: slice::windows\n    /// [`FusedIterator`]: crate::iter::FusedIterator\n    ///\n    /// # Panics\n    ///\n    /// Panics if `N` is zero. This check will most probably get changed to a\n    /// compile time error before this method gets stabilized.\n    ///\n    /// ```should_panic\n    /// #![feature(iter_map_windows)]\n    ///\n    /// let iter = std::iter::repeat(0).map_windows(|&[]| ());\n    /// ```\n    ///\n    /// # Examples\n    ///\n    /// Building the sums of neighboring numbers.\n    ///\n    /// ```\n    /// #![feature(iter_map_windows)]\n    ///\n    /// let mut it = [1, 3, 8, 1].iter().map_windows(|&[a, b]| a + b);\n    /// assert_eq!(it.next(), Some(4));  // 1 + 3\n    /// assert_eq!(it.next(), Some(11)); // 3 + 8\n    /// assert_eq!(it.next(), Some(9));  // 8 + 1\n    /// assert_eq!(it.next(), None);\n    /// ```\n    ///\n    /// Since the elements in the following example implement `Copy`, we can\n    /// just copy the array and get an iterator over the windows.\n    ///\n    /// ```\n    /// #![feature(iter_map_windows)]\n    ///\n    /// let mut it = \"ferris\".chars().map_windows(|w: &[_; 3]| *w);\n    /// assert_eq!(it.next(), Some(['f', 'e', 'r']));\n    /// assert_eq!(it.next(), Some(['e', 'r', 'r']));\n    /// assert_eq!(it.next(), Some(['r', 'r', 'i']));\n    /// assert_eq!(it.next(), Some(['r', 'i', 's']));\n    /// assert_eq!(it.next(), None);\n    /// ```\n    ///\n    /// You can also use this function to check the sortedness of an iterator.\n    /// For the simple case, rather use [`Iterator::is_sorted`].\n    ///\n    /// ```\n    /// #![feature(iter_map_windows)]\n    ///\n    /// let mut it = [0.5, 1.0, 3.5, 3.0, 8.5, 8.5, f32::NAN].iter()\n    ///     .map_windows(|[a, b]| a <= b);\n    ///\n    /// assert_eq!(it.next(), Some(true));  // 0.5 <= 1.0\n    /// assert_eq!(it.next(), Some(true));  // 1.0 <= 3.5\n    /// assert_eq!(it.next(), Some(false)); // 3.5 <= 3.0\n    /// assert_eq!(it.next(), Some(true));  // 3.0 <= 8.5\n    /// assert_eq!(it.next(), Some(true));  // 8.5 <= 8.5\n    /// assert_eq!(it.next(), Some(false)); // 8.5 <= NAN\n    /// assert_eq!(it.next(), None);\n    /// ```\n    ///\n    /// For non-fused iterators, they are fused after `map_windows`.\n    ///\n    /// ```\n    /// #![feature(iter_map_windows)]\n    ///\n    /// #[derive(Default)]\n    /// struct NonFusedIterator {\n    ///     state: i32,\n    /// }\n    ///\n    /// impl Iterator for NonFusedIterator {\n    ///     type Item = i32;\n    ///\n    ///     fn next(&mut self) -> Option<i32> {\n    ///         let val = self.state;\n    ///         self.state = self.state + 1;\n    ///\n    ///         // yields `0..5` first, then only even numbers since `6..`.\n    ///         if val < 5 || val % 2 == 0 {\n    ///             Some(val)\n    ///         } else {\n    ///             None\n    ///         }\n    ///     }\n    /// }\n    ///\n    ///\n    /// let mut iter = NonFusedIterator::default();\n    ///\n    /// // yields 0..5 first.\n    /// assert_eq!(iter.next(), Some(0));\n    /// assert_eq!(iter.next(), Some(1));\n    /// assert_eq!(iter.next(), Some(2));\n    /// assert_eq!(iter.next(), Some(3));\n    /// assert_eq!(iter.next(), Some(4));\n    /// // then we can see our iterator going back and forth\n    /// assert_eq!(iter.next(), None);\n    /// assert_eq!(iter.next(), Some(6));\n    /// assert_eq!(iter.next(), None);\n    /// assert_eq!(iter.next(), Some(8));\n    /// assert_eq!(iter.next(), None);\n    ///\n    /// // however, with `.map_windows()`, it is fused.\n    /// let mut iter = NonFusedIterator::default()\n    ///     .map_windows(|arr: &[_; 2]| *arr);\n    ///\n    /// assert_eq!(iter.next(), Some([0, 1]));\n    /// assert_eq!(iter.next(), Some([1, 2]));\n    /// assert_eq!(iter.next(), Some([2, 3]));\n    /// assert_eq!(iter.next(), Some([3, 4]));\n    /// assert_eq!(iter.next(), None);\n    ///\n    /// // it will always return `None` after the first time.\n    /// assert_eq!(iter.next(), None);\n    /// assert_eq!(iter.next(), None);\n    /// assert_eq!(iter.next(), None);\n    /// ```\n    #[inline]\n    #[unstable(feature = \"iter_map_windows\", reason = \"recently added\", issue = \"87155\")]\n    fn map_windows<F, R, const N: usize>(self, f: F) -> MapWindows<Self, F, N>\n    where\n        Self: Sized,\n        F: FnMut(&[Self::Item; N]) -> R,\n    {\n        MapWindows::new(self, f)\n    }\n\n    /// Creates an iterator which ends after the first [`None`].\n    ///\n    /// After an iterator returns [`None`], future calls may or may not yield\n    /// [`Some(T)`] again. `fuse()` adapts an iterator, ensuring that after a\n    /// [`None`] is given, it will always return [`None`] forever.\n    ///\n    /// Note that the [`Fuse`] wrapper is a no-op on iterators that implement\n    /// the [`FusedIterator`] trait. `fuse()` may therefore behave incorrectly\n    /// if the [`FusedIterator`] trait is improperly implemented.\n    ///\n    /// [`Some(T)`]: Some\n    /// [`FusedIterator`]: crate::iter::FusedIterator\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// // an iterator which alternates between Some and None\n    /// struct Alternate {\n    ///     state: i32,\n    /// }\n    ///\n    /// impl Iterator for Alternate {\n    ///     type Item = i32;\n    ///\n    ///     fn next(&mut self) -> Option<i32> {\n    ///         let val = self.state;\n    ///         self.state = self.state + 1;\n    ///\n    ///         // if it's even, Some(i32), else None\n    ///         (val % 2 == 0).then_some(val)\n    ///     }\n    /// }\n    ///\n    /// let mut iter = Alternate { state: 0 };\n    ///\n    /// // we can see our iterator going back and forth\n    /// assert_eq!(iter.next(), Some(0));\n    /// assert_eq!(iter.next(), None);\n    /// assert_eq!(iter.next(), Some(2));\n    /// assert_eq!(iter.next(), None);\n    ///\n    /// // however, once we fuse it...\n    /// let mut iter = iter.fuse();\n    ///\n    /// assert_eq!(iter.next(), Some(4));\n    /// assert_eq!(iter.next(), None);\n    ///\n    /// // it will always return `None` after the first time.\n    /// assert_eq!(iter.next(), None);\n    /// assert_eq!(iter.next(), None);\n    /// assert_eq!(iter.next(), None);\n    /// ```\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    fn fuse(self) -> Fuse<Self>\n    where\n        Self: Sized,\n    {\n        Fuse::new(self)\n    }\n\n    /// Does something with each element of an iterator, passing the value on.\n    ///\n    /// When using iterators, you'll often chain several of them together.\n    /// While working on such code, you might want to check out what's\n    /// happening at various parts in the pipeline. To do that, insert\n    /// a call to `inspect()`.\n    ///\n    /// It's more common for `inspect()` to be used as a debugging tool than to\n    /// exist in your final code, but applications may find it useful in certain\n    /// situations when errors need to be logged before being discarded.\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// let a = [1, 4, 2, 3];\n    ///\n    /// // this iterator sequence is complex.\n    /// let sum = a.iter()\n    ///     .cloned()\n    ///     .filter(|x| x % 2 == 0)\n    ///     .fold(0, |sum, i| sum + i);\n    ///\n    /// println!(\"{sum}\");\n    ///\n    /// // let's add some inspect() calls to investigate what's happening\n    /// let sum = a.iter()\n    ///     .cloned()\n    ///     .inspect(|x| println!(\"about to filter: {x}\"))\n    ///     .filter(|x| x % 2 == 0)\n    ///     .inspect(|x| println!(\"made it through filter: {x}\"))\n    ///     .fold(0, |sum, i| sum + i);\n    ///\n    /// println!(\"{sum}\");\n    /// ```\n    ///\n    /// This will print:\n    ///\n    /// ```text\n    /// 6\n    /// about to filter: 1\n    /// about to filter: 4\n    /// made it through filter: 4\n    /// about to filter: 2\n    /// made it through filter: 2\n    /// about to filter: 3\n    /// 6\n    /// ```\n    ///\n    /// Logging errors before discarding them:\n    ///\n    /// ```\n    /// let lines = [\"1\", \"2\", \"a\"];\n    ///\n    /// let sum: i32 = lines\n    ///     .iter()\n    ///     .map(|line| line.parse::<i32>())\n    ///     .inspect(|num| {\n    ///         if let Err(ref e) = *num {\n    ///             println!(\"Parsing error: {e}\");\n    ///         }\n    ///     })\n    ///     .filter_map(Result::ok)\n    ///     .sum();\n    ///\n    /// println!(\"Sum: {sum}\");\n    /// ```\n    ///\n    /// This will print:\n    ///\n    /// ```text\n    /// Parsing error: invalid digit found in string\n    /// Sum: 3\n    /// ```\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    fn inspect<F>(self, f: F) -> Inspect<Self, F>\n    where\n        Self: Sized,\n        F: FnMut(&Self::Item),\n    {\n        Inspect::new(self, f)\n    }\n\n    /// Creates a \"by reference\" adapter for this instance of `Iterator`.\n    ///\n    /// Consuming method calls (direct or indirect calls to `next`)\n    /// on the \"by reference\" adapter will consume the original iterator,\n    /// but ownership-taking methods (those with a `self` parameter)\n    /// only take ownership of the \"by reference\" iterator.\n    ///\n    /// This is useful for applying ownership-taking methods\n    /// (such as `take` in the example below)\n    /// without giving up ownership of the original iterator,\n    /// so you can use the original iterator afterwards.\n    ///\n    /// Uses [`impl<I: Iterator + ?Sized> Iterator for &mut I { type Item = I::Item; ...}`](https://doc.rust-lang.org/nightly/std/iter/trait.Iterator.html#impl-Iterator-for-%26mut+I).\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut words = [\"hello\", \"world\", \"of\", \"Rust\"].into_iter();\n    ///\n    /// // Take the first two words.\n    /// let hello_world: Vec<_> = words.by_ref().take(2).collect();\n    /// assert_eq!(hello_world, vec![\"hello\", \"world\"]);\n    ///\n    /// // Collect the rest of the words.\n    /// // We can only do this because we used `by_ref` earlier.\n    /// let of_rust: Vec<_> = words.collect();\n    /// assert_eq!(of_rust, vec![\"of\", \"Rust\"]);\n    /// ```\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    fn by_ref(&mut self) -> &mut Self\n    where\n        Self: Sized,\n    {\n        self\n    }\n\n    /// Transforms an iterator into a collection.\n    ///\n    /// `collect()` can take anything iterable, and turn it into a relevant\n    /// collection. This is one of the more powerful methods in the standard\n    /// library, used in a variety of contexts.\n    ///\n    /// The most basic pattern in which `collect()` is used is to turn one\n    /// collection into another. You take a collection, call [`iter`] on it,\n    /// do a bunch of transformations, and then `collect()` at the end.\n    ///\n    /// `collect()` can also create instances of types that are not typical\n    /// collections. For example, a [`String`] can be built from [`char`]s,\n    /// and an iterator of [`Result<T, E>`][`Result`] items can be collected\n    /// into `Result<Collection<T>, E>`. See the examples below for more.\n    ///\n    /// Because `collect()` is so general, it can cause problems with type\n    /// inference. As such, `collect()` is one of the few times you'll see\n    /// the syntax affectionately known as the 'turbofish': `::<>`. This\n    /// helps the inference algorithm understand specifically which collection\n    /// you're trying to collect into.\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// let a = [1, 2, 3];\n    ///\n    /// let doubled: Vec<i32> = a.iter()\n    ///                          .map(|x| x * 2)\n    ///                          .collect();\n    ///\n    /// assert_eq!(vec![2, 4, 6], doubled);\n    /// ```\n    ///\n    /// Note that we needed the `: Vec<i32>` on the left-hand side. This is because\n    /// we could collect into, for example, a [`VecDeque<T>`] instead:\n    ///\n    /// [`VecDeque<T>`]: ../../std/collections/struct.VecDeque.html\n    ///\n    /// ```\n    /// use std::collections::VecDeque;\n    ///\n    /// let a = [1, 2, 3];\n    ///\n    /// let doubled: VecDeque<i32> = a.iter().map(|x| x * 2).collect();\n    ///\n    /// assert_eq!(2, doubled[0]);\n    /// assert_eq!(4, doubled[1]);\n    /// assert_eq!(6, doubled[2]);\n    /// ```\n    ///\n    /// Using the 'turbofish' instead of annotating `doubled`:\n    ///\n    /// ```\n    /// let a = [1, 2, 3];\n    ///\n    /// let doubled = a.iter().map(|x| x * 2).collect::<Vec<i32>>();\n    ///\n    /// assert_eq!(vec![2, 4, 6], doubled);\n    /// ```\n    ///\n    /// Because `collect()` only cares about what you're collecting into, you can\n    /// still use a partial type hint, `_`, with the turbofish:\n    ///\n    /// ```\n    /// let a = [1, 2, 3];\n    ///\n    /// let doubled = a.iter().map(|x| x * 2).collect::<Vec<_>>();\n    ///\n    /// assert_eq!(vec![2, 4, 6], doubled);\n    /// ```\n    ///\n    /// Using `collect()` to make a [`String`]:\n    ///\n    /// ```\n    /// let chars = ['g', 'd', 'k', 'k', 'n'];\n    ///\n    /// let hello: String = chars.into_iter()\n    ///     .map(|x| x as u8)\n    ///     .map(|x| (x + 1) as char)\n    ///     .collect();\n    ///\n    /// assert_eq!(\"hello\", hello);\n    /// ```\n    ///\n    /// If you have a list of [`Result<T, E>`][`Result`]s, you can use `collect()` to\n    /// see if any of them failed:\n    ///\n    /// ```\n    /// let results = [Ok(1), Err(\"nope\"), Ok(3), Err(\"bad\")];\n    ///\n    /// let result: Result<Vec<_>, &str> = results.into_iter().collect();\n    ///\n    /// // gives us the first error\n    /// assert_eq!(Err(\"nope\"), result);\n    ///\n    /// let results = [Ok(1), Ok(3)];\n    ///\n    /// let result: Result<Vec<_>, &str> = results.into_iter().collect();\n    ///\n    /// // gives us the list of answers\n    /// assert_eq!(Ok(vec![1, 3]), result);\n    /// ```\n    ///\n    /// [`iter`]: Iterator::next\n    /// [`String`]: ../../std/string/struct.String.html\n    /// [`char`]: type@char\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[must_use = \"if you really need to exhaust the iterator, consider `.for_each(drop)` instead\"]\n    #[rustc_diagnostic_item = \"iterator_collect_fn\"]\n    fn collect<B: FromIterator<Self::Item>>(self) -> B\n    where\n        Self: Sized,\n    {\n        // This is too aggressive to turn on for everything all the time, but PR#137908\n        // accidentally noticed that some rustc iterators had malformed `size_hint`s,\n        // so this will help catch such things in debug-assertions-std runners,\n        // even if users won't actually ever see it.\n        if cfg!(debug_assertions) {\n            let hint = self.size_hint();\n            assert!(hint.1.is_none_or(|high| high >= hint.0), \"Malformed size_hint {hint:?}\");\n        }\n\n        FromIterator::from_iter(self)\n    }\n\n    /// Fallibly transforms an iterator into a collection, short circuiting if\n    /// a failure is encountered.\n    ///\n    /// `try_collect()` is a variation of [`collect()`][`collect`] that allows fallible\n    /// conversions during collection. Its main use case is simplifying conversions from\n    /// iterators yielding [`Option<T>`][`Option`] into `Option<Collection<T>>`, or similarly for other [`Try`]\n    /// types (e.g. [`Result`]).\n    ///\n    /// Importantly, `try_collect()` doesn't require that the outer [`Try`] type also implements [`FromIterator`];\n    /// only the inner type produced on `Try::Output` must implement it. Concretely,\n    /// this means that collecting into `ControlFlow<_, Vec<i32>>` is valid because `Vec<i32>` implements\n    /// [`FromIterator`], even though [`ControlFlow`] doesn't.\n    ///\n    /// Also, if a failure is encountered during `try_collect()`, the iterator is still valid and\n    /// may continue to be used, in which case it will continue iterating starting after the element that\n    /// triggered the failure. See the last example below for an example of how this works.\n    ///\n    /// # Examples\n    /// Successfully collecting an iterator of `Option<i32>` into `Option<Vec<i32>>`:\n    /// ```\n    /// #![feature(iterator_try_collect)]\n    ///\n    /// let u = vec![Some(1), Some(2), Some(3)];\n    /// let v = u.into_iter().try_collect::<Vec<i32>>();\n    /// assert_eq!(v, Some(vec![1, 2, 3]));\n    /// ```\n    ///\n    /// Failing to collect in the same way:\n    /// ```\n    /// #![feature(iterator_try_collect)]\n    ///\n    /// let u = vec![Some(1), Some(2), None, Some(3)];\n    /// let v = u.into_iter().try_collect::<Vec<i32>>();\n    /// assert_eq!(v, None);\n    /// ```\n    ///\n    /// A similar example, but with `Result`:\n    /// ```\n    /// #![feature(iterator_try_collect)]\n    ///\n    /// let u: Vec<Result<i32, ()>> = vec![Ok(1), Ok(2), Ok(3)];\n    /// let v = u.into_iter().try_collect::<Vec<i32>>();\n    /// assert_eq!(v, Ok(vec![1, 2, 3]));\n    ///\n    /// let u = vec![Ok(1), Ok(2), Err(()), Ok(3)];\n    /// let v = u.into_iter().try_collect::<Vec<i32>>();\n    /// assert_eq!(v, Err(()));\n    /// ```\n    ///\n    /// Finally, even [`ControlFlow`] works, despite the fact that it\n    /// doesn't implement [`FromIterator`]. Note also that the iterator can\n    /// continue to be used, even if a failure is encountered:\n    ///\n    /// ```\n    /// #![feature(iterator_try_collect)]\n    ///\n    /// use core::ops::ControlFlow::{Break, Continue};\n    ///\n    /// let u = [Continue(1), Continue(2), Break(3), Continue(4), Continue(5)];\n    /// let mut it = u.into_iter();\n    ///\n    /// let v = it.try_collect::<Vec<_>>();\n    /// assert_eq!(v, Break(3));\n    ///\n    /// let v = it.try_collect::<Vec<_>>();\n    /// assert_eq!(v, Continue(vec![4, 5]));\n    /// ```\n    ///\n    /// [`collect`]: Iterator::collect\n    #[inline]\n    #[unstable(feature = \"iterator_try_collect\", issue = \"94047\")]\n    fn try_collect<B>(&mut self) -> ChangeOutputType<Self::Item, B>\n    where\n        Self: Sized,\n        Self::Item: Try<Residual: Residual<B>>,\n        B: FromIterator<<Self::Item as Try>::Output>,\n    {\n        try_process(ByRefSized(self), |i| i.collect())\n    }\n\n    /// Collects all the items from an iterator into a collection.\n    ///\n    /// This method consumes the iterator and adds all its items to the\n    /// passed collection. The collection is then returned, so the call chain\n    /// can be continued.\n    ///\n    /// This is useful when you already have a collection and want to add\n    /// the iterator items to it.\n    ///\n    /// This method is a convenience method to call [Extend::extend](trait.Extend.html),\n    /// but instead of being called on a collection, it's called on an iterator.\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// #![feature(iter_collect_into)]\n    ///\n    /// let a = [1, 2, 3];\n    /// let mut vec: Vec::<i32> = vec![0, 1];\n    ///\n    /// a.iter().map(|x| x * 2).collect_into(&mut vec);\n    /// a.iter().map(|x| x * 10).collect_into(&mut vec);\n    ///\n    /// assert_eq!(vec, vec![0, 1, 2, 4, 6, 10, 20, 30]);\n    /// ```\n    ///\n    /// `Vec` can have a manual set capacity to avoid reallocating it:\n    ///\n    /// ```\n    /// #![feature(iter_collect_into)]\n    ///\n    /// let a = [1, 2, 3];\n    /// let mut vec: Vec::<i32> = Vec::with_capacity(6);\n    ///\n    /// a.iter().map(|x| x * 2).collect_into(&mut vec);\n    /// a.iter().map(|x| x * 10).collect_into(&mut vec);\n    ///\n    /// assert_eq!(6, vec.capacity());\n    /// assert_eq!(vec, vec![2, 4, 6, 10, 20, 30]);\n    /// ```\n    ///\n    /// The returned mutable reference can be used to continue the call chain:\n    ///\n    /// ```\n    /// #![feature(iter_collect_into)]\n    ///\n    /// let a = [1, 2, 3];\n    /// let mut vec: Vec::<i32> = Vec::with_capacity(6);\n    ///\n    /// let count = a.iter().collect_into(&mut vec).iter().count();\n    ///\n    /// assert_eq!(count, vec.len());\n    /// assert_eq!(vec, vec![1, 2, 3]);\n    ///\n    /// let count = a.iter().collect_into(&mut vec).iter().count();\n    ///\n    /// assert_eq!(count, vec.len());\n    /// assert_eq!(vec, vec![1, 2, 3, 1, 2, 3]);\n    /// ```\n    #[inline]\n    #[unstable(feature = \"iter_collect_into\", reason = \"new API\", issue = \"94780\")]\n    fn collect_into<E: Extend<Self::Item>>(self, collection: &mut E) -> &mut E\n    where\n        Self: Sized,\n    {\n        collection.extend(self);\n        collection\n    }\n\n    /// Consumes an iterator, creating two collections from it.\n    ///\n    /// The predicate passed to `partition()` can return `true`, or `false`.\n    /// `partition()` returns a pair, all of the elements for which it returned\n    /// `true`, and all of the elements for which it returned `false`.\n    ///\n    /// See also [`is_partitioned()`] and [`partition_in_place()`].\n    ///\n    /// [`is_partitioned()`]: Iterator::is_partitioned\n    /// [`partition_in_place()`]: Iterator::partition_in_place\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let a = [1, 2, 3];\n    ///\n    /// let (even, odd): (Vec<_>, Vec<_>) = a\n    ///     .into_iter()\n    ///     .partition(|n| n % 2 == 0);\n    ///\n    /// assert_eq!(even, [2]);\n    /// assert_eq!(odd, [1, 3]);\n    /// ```\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    fn partition<B, F>(self, f: F) -> (B, B)\n    where\n        Self: Sized,\n        B: Default + Extend<Self::Item>,\n        F: FnMut(&Self::Item) -> bool,\n    {\n        #[inline]\n        fn extend<'a, T, B: Extend<T>>(\n            mut f: impl FnMut(&T) -> bool + 'a,\n            left: &'a mut B,\n            right: &'a mut B,\n        ) -> impl FnMut((), T) + 'a {\n            move |(), x| {\n                if f(&x) {\n                    left.extend_one(x);\n                } else {\n                    right.extend_one(x);\n                }\n            }\n        }\n\n        let mut left: B = Default::default();\n        let mut right: B = Default::default();\n\n        self.fold((), extend(f, &mut left, &mut right));\n\n        (left, right)\n    }\n\n    /// Reorders the elements of this iterator *in-place* according to the given predicate,\n    /// such that all those that return `true` precede all those that return `false`.\n    /// Returns the number of `true` elements found.\n    ///\n    /// The relative order of partitioned items is not maintained.\n    ///\n    /// # Current implementation\n    ///\n    /// The current algorithm tries to find the first element for which the predicate evaluates\n    /// to false and the last element for which it evaluates to true, and repeatedly swaps them.\n    ///\n    /// Time complexity: *O*(*n*)\n    ///\n    /// See also [`is_partitioned()`] and [`partition()`].\n    ///\n    /// [`is_partitioned()`]: Iterator::is_partitioned\n    /// [`partition()`]: Iterator::partition\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(iter_partition_in_place)]\n    ///\n    /// let mut a = [1, 2, 3, 4, 5, 6, 7];\n    ///\n    /// // Partition in-place between evens and odds\n    /// let i = a.iter_mut().partition_in_place(|n| n % 2 == 0);\n    ///\n    /// assert_eq!(i, 3);\n    /// assert!(a[..i].iter().all(|n| n % 2 == 0)); // evens\n    /// assert!(a[i..].iter().all(|n| n % 2 == 1)); // odds\n    /// ```\n    #[unstable(feature = \"iter_partition_in_place\", reason = \"new API\", issue = \"62543\")]\n    fn partition_in_place<'a, T: 'a, P>(mut self, ref mut predicate: P) -> usize\n    where\n        Self: Sized + DoubleEndedIterator<Item = &'a mut T>,\n        P: FnMut(&T) -> bool,\n    {\n        // FIXME: should we worry about the count overflowing? The only way to have more than\n        // `usize::MAX` mutable references is with ZSTs, which aren't useful to partition...\n\n        // These closure \"factory\" functions exist to avoid genericity in `Self`.\n\n        #[inline]\n        fn is_false<'a, T>(\n            predicate: &'a mut impl FnMut(&T) -> bool,\n            true_count: &'a mut usize,\n        ) -> impl FnMut(&&mut T) -> bool + 'a {\n            move |x| {\n                let p = predicate(&**x);\n                *true_count += p as usize;\n                !p\n            }\n        }\n\n        #[inline]\n        fn is_true<T>(predicate: &mut impl FnMut(&T) -> bool) -> impl FnMut(&&mut T) -> bool + '_ {\n            move |x| predicate(&**x)\n        }\n\n        // Repeatedly find the first `false` and swap it with the last `true`.\n        let mut true_count = 0;\n        while let Some(head) = self.find(is_false(predicate, &mut true_count)) {\n            if let Some(tail) = self.rfind(is_true(predicate)) {\n                crate::mem::swap(head, tail);\n                true_count += 1;\n            } else {\n                break;\n            }\n        }\n        true_count\n    }\n\n    /// Checks if the elements of this iterator are partitioned according to the given predicate,\n    /// such that all those that return `true` precede all those that return `false`.\n    ///\n    /// See also [`partition()`] and [`partition_in_place()`].\n    ///\n    /// [`partition()`]: Iterator::partition\n    /// [`partition_in_place()`]: Iterator::partition_in_place\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(iter_is_partitioned)]\n    ///\n    /// assert!(\"Iterator\".chars().is_partitioned(char::is_uppercase));\n    /// assert!(!\"IntoIterator\".chars().is_partitioned(char::is_uppercase));\n    /// ```\n    #[unstable(feature = \"iter_is_partitioned\", reason = \"new API\", issue = \"62544\")]\n    fn is_partitioned<P>(mut self, mut predicate: P) -> bool\n    where\n        Self: Sized,\n        P: FnMut(Self::Item) -> bool,\n    {\n        // Either all items test `true`, or the first clause stops at `false`\n        // and we check that there are no more `true` items after that.\n        self.all(&mut predicate) || !self.any(predicate)\n    }\n\n    /// An iterator method that applies a function as long as it returns\n    /// successfully, producing a single, final value.\n    ///\n    /// `try_fold()` takes two arguments: an initial value, and a closure with\n    /// two arguments: an 'accumulator', and an element. The closure either\n    /// returns successfully, with the value that the accumulator should have\n    /// for the next iteration, or it returns failure, with an error value that\n    /// is propagated back to the caller immediately (short-circuiting).\n    ///\n    /// The initial value is the value the accumulator will have on the first\n    /// call. If applying the closure succeeded against every element of the\n    /// iterator, `try_fold()` returns the final accumulator as success.\n    ///\n    /// Folding is useful whenever you have a collection of something, and want\n    /// to produce a single value from it.\n    ///\n    /// # Note to Implementors\n    ///\n    /// Several of the other (forward) methods have default implementations in\n    /// terms of this one, so try to implement this explicitly if it can\n    /// do something better than the default `for` loop implementation.\n    ///\n    /// In particular, try to have this call `try_fold()` on the internal parts\n    /// from which this iterator is composed. If multiple calls are needed,\n    /// the `?` operator may be convenient for chaining the accumulator value\n    /// along, but beware any invariants that need to be upheld before those\n    /// early returns. This is a `&mut self` method, so iteration needs to be\n    /// resumable after hitting an error here.\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// let a = [1, 2, 3];\n    ///\n    /// // the checked sum of all of the elements of the array\n    /// let sum = a.into_iter().try_fold(0i8, |acc, x| acc.checked_add(x));\n    ///\n    /// assert_eq!(sum, Some(6));\n    /// ```\n    ///\n    /// Short-circuiting:\n    ///\n    /// ```\n    /// let a = [10, 20, 30, 100, 40, 50];\n    /// let mut iter = a.into_iter();\n    ///\n    /// // This sum overflows when adding the 100 element\n    /// let sum = iter.try_fold(0i8, |acc, x| acc.checked_add(x));\n    /// assert_eq!(sum, None);\n    ///\n    /// // Because it short-circuited, the remaining elements are still\n    /// // available through the iterator.\n    /// assert_eq!(iter.len(), 2);\n    /// assert_eq!(iter.next(), Some(40));\n    /// ```\n    ///\n    /// While you cannot `break` from a closure, the [`ControlFlow`] type allows\n    /// a similar idea:\n    ///\n    /// ```\n    /// use std::ops::ControlFlow;\n    ///\n    /// let triangular = (1..30).try_fold(0_i8, |prev, x| {\n    ///     if let Some(next) = prev.checked_add(x) {\n    ///         ControlFlow::Continue(next)\n    ///     } else {\n    ///         ControlFlow::Break(prev)\n    ///     }\n    /// });\n    /// assert_eq!(triangular, ControlFlow::Break(120));\n    ///\n    /// let triangular = (1..30).try_fold(0_u64, |prev, x| {\n    ///     if let Some(next) = prev.checked_add(x) {\n    ///         ControlFlow::Continue(next)\n    ///     } else {\n    ///         ControlFlow::Break(prev)\n    ///     }\n    /// });\n    /// assert_eq!(triangular, ControlFlow::Continue(435));\n    /// ```\n    #[inline]\n    #[stable(feature = \"iterator_try_fold\", since = \"1.27.0\")]\n    fn try_fold<B, F, R>(&mut self, init: B, mut f: F) -> R\n    where\n        Self: Sized,\n        F: FnMut(B, Self::Item) -> R,\n        R: Try<Output = B>,\n    {\n        let mut accum = init;\n        while let Some(x) = self.next() {\n            accum = f(accum, x)?;\n        }\n        try { accum }\n    }\n\n    /// An iterator method that applies a fallible function to each item in the\n    /// iterator, stopping at the first error and returning that error.\n    ///\n    /// This can also be thought of as the fallible form of [`for_each()`]\n    /// or as the stateless version of [`try_fold()`].\n    ///\n    /// [`for_each()`]: Iterator::for_each\n    /// [`try_fold()`]: Iterator::try_fold\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// use std::fs::rename;\n    /// use std::io::{stdout, Write};\n    /// use std::path::Path;\n    ///\n    /// let data = [\"no_tea.txt\", \"stale_bread.json\", \"torrential_rain.png\"];\n    ///\n    /// let res = data.iter().try_for_each(|x| writeln!(stdout(), \"{x}\"));\n    /// assert!(res.is_ok());\n    ///\n    /// let mut it = data.iter().cloned();\n    /// let res = it.try_for_each(|x| rename(x, Path::new(x).with_extension(\"old\")));\n    /// assert!(res.is_err());\n    /// // It short-circuited, so the remaining items are still in the iterator:\n    /// assert_eq!(it.next(), Some(\"stale_bread.json\"));\n    /// ```\n    ///\n    /// The [`ControlFlow`] type can be used with this method for the situations\n    /// in which you'd use `break` and `continue` in a normal loop:\n    ///\n    /// ```\n    /// use std::ops::ControlFlow;\n    ///\n    /// let r = (2..100).try_for_each(|x| {\n    ///     if 323 % x == 0 {\n    ///         return ControlFlow::Break(x)\n    ///     }\n    ///\n    ///     ControlFlow::Continue(())\n    /// });\n    /// assert_eq!(r, ControlFlow::Break(17));\n    /// ```\n    #[inline]\n    #[stable(feature = \"iterator_try_fold\", since = \"1.27.0\")]\n    fn try_for_each<F, R>(&mut self, f: F) -> R\n    where\n        Self: Sized,\n        F: FnMut(Self::Item) -> R,\n        R: Try<Output = ()>,\n    {\n        #[inline]\n        fn call<T, R>(mut f: impl FnMut(T) -> R) -> impl FnMut((), T) -> R {\n            move |(), x| f(x)\n        }\n\n        self.try_fold((), call(f))\n    }\n\n    /// Folds every element into an accumulator by applying an operation,\n    /// returning the final result.\n    ///\n    /// `fold()` takes two arguments: an initial value, and a closure with two\n    /// arguments: an 'accumulator', and an element. The closure returns the value that\n    /// the accumulator should have for the next iteration.\n    ///\n    /// The initial value is the value the accumulator will have on the first\n    /// call.\n    ///\n    /// After applying this closure to every element of the iterator, `fold()`\n    /// returns the accumulator.\n    ///\n    /// This operation is sometimes called 'reduce' or 'inject'.\n    ///\n    /// Folding is useful whenever you have a collection of something, and want\n    /// to produce a single value from it.\n    ///\n    /// Note: `fold()`, and similar methods that traverse the entire iterator,\n    /// might not terminate for infinite iterators, even on traits for which a\n    /// result is determinable in finite time.\n    ///\n    /// Note: [`reduce()`] can be used to use the first element as the initial\n    /// value, if the accumulator type and item type is the same.\n    ///\n    /// Note: `fold()` combines elements in a *left-associative* fashion. For associative\n    /// operators like `+`, the order the elements are combined in is not important, but for non-associative\n    /// operators like `-` the order will affect the final result.\n    /// For a *right-associative* version of `fold()`, see [`DoubleEndedIterator::rfold()`].\n    ///\n    /// # Note to Implementors\n    ///\n    /// Several of the other (forward) methods have default implementations in\n    /// terms of this one, so try to implement this explicitly if it can\n    /// do something better than the default `for` loop implementation.\n    ///\n    /// In particular, try to have this call `fold()` on the internal parts\n    /// from which this iterator is composed.\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// let a = [1, 2, 3];\n    ///\n    /// // the sum of all of the elements of the array\n    /// let sum = a.iter().fold(0, |acc, x| acc + x);\n    ///\n    /// assert_eq!(sum, 6);\n    /// ```\n    ///\n    /// Let's walk through each step of the iteration here:\n    ///\n    /// | element | acc | x | result |\n    /// |---------|-----|---|--------|\n    /// |         | 0   |   |        |\n    /// | 1       | 0   | 1 | 1      |\n    /// | 2       | 1   | 2 | 3      |\n    /// | 3       | 3   | 3 | 6      |\n    ///\n    /// And so, our final result, `6`.\n    ///\n    /// This example demonstrates the left-associative nature of `fold()`:\n    /// it builds a string, starting with an initial value\n    /// and continuing with each element from the front until the back:\n    ///\n    /// ```\n    /// let numbers = [1, 2, 3, 4, 5];\n    ///\n    /// let zero = \"0\".to_string();\n    ///\n    /// let result = numbers.iter().fold(zero, |acc, &x| {\n    ///     format!(\"({acc} + {x})\")\n    /// });\n    ///\n    /// assert_eq!(result, \"(((((0 + 1) + 2) + 3) + 4) + 5)\");\n    /// ```\n    /// It's common for people who haven't used iterators a lot to\n    /// use a `for` loop with a list of things to build up a result. Those\n    /// can be turned into `fold()`s:\n    ///\n    /// [`for`]: ../../book/ch03-05-control-flow.html#looping-through-a-collection-with-for\n    ///\n    /// ```\n    /// let numbers = [1, 2, 3, 4, 5];\n    ///\n    /// let mut result = 0;\n    ///\n    /// // for loop:\n    /// for i in &numbers {\n    ///     result = result + i;\n    /// }\n    ///\n    /// // fold:\n    /// let result2 = numbers.iter().fold(0, |acc, &x| acc + x);\n    ///\n    /// // they're the same\n    /// assert_eq!(result, result2);\n    /// ```\n    ///\n    /// [`reduce()`]: Iterator::reduce\n    #[doc(alias = \"inject\", alias = \"foldl\")]\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    fn fold<B, F>(mut self, init: B, mut f: F) -> B\n    where\n        Self: Sized,\n        F: FnMut(B, Self::Item) -> B,\n    {\n        let mut accum = init;\n        while let Some(x) = self.next() {\n            accum = f(accum, x);\n        }\n        accum\n    }\n\n    /// Reduces the elements to a single one, by repeatedly applying a reducing\n    /// operation.\n    ///\n    /// If the iterator is empty, returns [`None`]; otherwise, returns the\n    /// result of the reduction.\n    ///\n    /// The reducing function is a closure with two arguments: an 'accumulator', and an element.\n    /// For iterators with at least one element, this is the same as [`fold()`]\n    /// with the first element of the iterator as the initial accumulator value, folding\n    /// every subsequent element into it.\n    ///\n    /// [`fold()`]: Iterator::fold\n    ///\n    /// # Example\n    ///\n    /// ```\n    /// let reduced: i32 = (1..10).reduce(|acc, e| acc + e).unwrap_or(0);\n    /// assert_eq!(reduced, 45);\n    ///\n    /// // Which is equivalent to doing it with `fold`:\n    /// let folded: i32 = (1..10).fold(0, |acc, e| acc + e);\n    /// assert_eq!(reduced, folded);\n    /// ```\n    #[inline]\n    #[stable(feature = \"iterator_fold_self\", since = \"1.51.0\")]\n    fn reduce<F>(mut self, f: F) -> Option<Self::Item>\n    where\n        Self: Sized,\n        F: FnMut(Self::Item, Self::Item) -> Self::Item,\n    {\n        let first = self.next()?;\n        Some(self.fold(first, f))\n    }\n\n    /// Reduces the elements to a single one by repeatedly applying a reducing operation. If the\n    /// closure returns a failure, the failure is propagated back to the caller immediately.\n    ///\n    /// The return type of this method depends on the return type of the closure. If the closure\n    /// returns `Result<Self::Item, E>`, then this function will return `Result<Option<Self::Item>,\n    /// E>`. If the closure returns `Option<Self::Item>`, then this function will return\n    /// `Option<Option<Self::Item>>`.\n    ///\n    /// When called on an empty iterator, this function will return either `Some(None)` or\n    /// `Ok(None)` depending on the type of the provided closure.\n    ///\n    /// For iterators with at least one element, this is essentially the same as calling\n    /// [`try_fold()`] with the first element of the iterator as the initial accumulator value.\n    ///\n    /// [`try_fold()`]: Iterator::try_fold\n    ///\n    /// # Examples\n    ///\n    /// Safely calculate the sum of a series of numbers:\n    ///\n    /// ```\n    /// #![feature(iterator_try_reduce)]\n    ///\n    /// let numbers: Vec<usize> = vec![10, 20, 5, 23, 0];\n    /// let sum = numbers.into_iter().try_reduce(|x, y| x.checked_add(y));\n    /// assert_eq!(sum, Some(Some(58)));\n    /// ```\n    ///\n    /// Determine when a reduction short circuited:\n    ///\n    /// ```\n    /// #![feature(iterator_try_reduce)]\n    ///\n    /// let numbers = vec![1, 2, 3, usize::MAX, 4, 5];\n    /// let sum = numbers.into_iter().try_reduce(|x, y| x.checked_add(y));\n    /// assert_eq!(sum, None);\n    /// ```\n    ///\n    /// Determine when a reduction was not performed because there are no elements:\n    ///\n    /// ```\n    /// #![feature(iterator_try_reduce)]\n    ///\n    /// let numbers: Vec<usize> = Vec::new();\n    /// let sum = numbers.into_iter().try_reduce(|x, y| x.checked_add(y));\n    /// assert_eq!(sum, Some(None));\n    /// ```\n    ///\n    /// Use a [`Result`] instead of an [`Option`]:\n    ///\n    /// ```\n    /// #![feature(iterator_try_reduce)]\n    ///\n    /// let numbers = vec![\"1\", \"2\", \"3\", \"4\", \"5\"];\n    /// let max: Result<Option<_>, <usize as std::str::FromStr>::Err> =\n    ///     numbers.into_iter().try_reduce(|x, y| {\n    ///         if x.parse::<usize>()? > y.parse::<usize>()? { Ok(x) } else { Ok(y) }\n    ///     });\n    /// assert_eq!(max, Ok(Some(\"5\")));\n    /// ```\n    #[inline]\n    #[unstable(feature = \"iterator_try_reduce\", reason = \"new API\", issue = \"87053\")]\n    fn try_reduce<R>(\n        &mut self,\n        f: impl FnMut(Self::Item, Self::Item) -> R,\n    ) -> ChangeOutputType<R, Option<R::Output>>\n    where\n        Self: Sized,\n        R: Try<Output = Self::Item, Residual: Residual<Option<Self::Item>>>,\n    {\n        let first = match self.next() {\n            Some(i) => i,\n            None => return Try::from_output(None),\n        };\n\n        match self.try_fold(first, f).branch() {\n            ControlFlow::Break(r) => FromResidual::from_residual(r),\n            ControlFlow::Continue(i) => Try::from_output(Some(i)),\n        }\n    }\n\n    /// Tests if every element of the iterator matches a predicate.\n    ///\n    /// `all()` takes a closure that returns `true` or `false`. It applies\n    /// this closure to each element of the iterator, and if they all return\n    /// `true`, then so does `all()`. If any of them return `false`, it\n    /// returns `false`.\n    ///\n    /// `all()` is short-circuiting; in other words, it will stop processing\n    /// as soon as it finds a `false`, given that no matter what else happens,\n    /// the result will also be `false`.\n    ///\n    /// An empty iterator returns `true`.\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// let a = [1, 2, 3];\n    ///\n    /// assert!(a.into_iter().all(|x| x > 0));\n    ///\n    /// assert!(!a.into_iter().all(|x| x > 2));\n    /// ```\n    ///\n    /// Stopping at the first `false`:\n    ///\n    /// ```\n    /// let a = [1, 2, 3];\n    ///\n    /// let mut iter = a.into_iter();\n    ///\n    /// assert!(!iter.all(|x| x != 2));\n    ///\n    /// // we can still use `iter`, as there are more elements.\n    /// assert_eq!(iter.next(), Some(3));\n    /// ```\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    fn all<F>(&mut self, f: F) -> bool\n    where\n        Self: Sized,\n        F: FnMut(Self::Item) -> bool,\n    {\n        #[inline]\n        fn check<T>(mut f: impl FnMut(T) -> bool) -> impl FnMut((), T) -> ControlFlow<()> {\n            move |(), x| {\n                if f(x) { ControlFlow::Continue(()) } else { ControlFlow::Break(()) }\n            }\n        }\n        self.try_fold((), check(f)) == ControlFlow::Continue(())\n    }\n\n    /// Tests if any element of the iterator matches a predicate.\n    ///\n    /// `any()` takes a closure that returns `true` or `false`. It applies\n    /// this closure to each element of the iterator, and if any of them return\n    /// `true`, then so does `any()`. If they all return `false`, it\n    /// returns `false`.\n    ///\n    /// `any()` is short-circuiting; in other words, it will stop processing\n    /// as soon as it finds a `true`, given that no matter what else happens,\n    /// the result will also be `true`.\n    ///\n    /// An empty iterator returns `false`.\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// let a = [1, 2, 3];\n    ///\n    /// assert!(a.into_iter().any(|x| x > 0));\n    ///\n    /// assert!(!a.into_iter().any(|x| x > 5));\n    /// ```\n    ///\n    /// Stopping at the first `true`:\n    ///\n    /// ```\n    /// let a = [1, 2, 3];\n    ///\n    /// let mut iter = a.into_iter();\n    ///\n    /// assert!(iter.any(|x| x != 2));\n    ///\n    /// // we can still use `iter`, as there are more elements.\n    /// assert_eq!(iter.next(), Some(2));\n    /// ```\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    fn any<F>(&mut self, f: F) -> bool\n    where\n        Self: Sized,\n        F: FnMut(Self::Item) -> bool,\n    {\n        #[inline]\n        fn check<T>(mut f: impl FnMut(T) -> bool) -> impl FnMut((), T) -> ControlFlow<()> {\n            move |(), x| {\n                if f(x) { ControlFlow::Break(()) } else { ControlFlow::Continue(()) }\n            }\n        }\n\n        self.try_fold((), check(f)) == ControlFlow::Break(())\n    }\n\n    /// Searches for an element of an iterator that satisfies a predicate.\n    ///\n    /// `find()` takes a closure that returns `true` or `false`. It applies\n    /// this closure to each element of the iterator, and if any of them return\n    /// `true`, then `find()` returns [`Some(element)`]. If they all return\n    /// `false`, it returns [`None`].\n    ///\n    /// `find()` is short-circuiting; in other words, it will stop processing\n    /// as soon as the closure returns `true`.\n    ///\n    /// Because `find()` takes a reference, and many iterators iterate over\n    /// references, this leads to a possibly confusing situation where the\n    /// argument is a double reference. You can see this effect in the\n    /// examples below, with `&&x`.\n    ///\n    /// If you need the index of the element, see [`position()`].\n    ///\n    /// [`Some(element)`]: Some\n    /// [`position()`]: Iterator::position\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// let a = [1, 2, 3];\n    ///\n    /// assert_eq!(a.into_iter().find(|&x| x == 2), Some(2));\n    /// assert_eq!(a.into_iter().find(|&x| x == 5), None);\n    /// ```\n    ///\n    /// Stopping at the first `true`:\n    ///\n    /// ```\n    /// let a = [1, 2, 3];\n    ///\n    /// let mut iter = a.into_iter();\n    ///\n    /// assert_eq!(iter.find(|&x| x == 2), Some(2));\n    ///\n    /// // we can still use `iter`, as there are more elements.\n    /// assert_eq!(iter.next(), Some(3));\n    /// ```\n    ///\n    /// Note that `iter.find(f)` is equivalent to `iter.filter(f).next()`.\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    fn find<P>(&mut self, predicate: P) -> Option<Self::Item>\n    where\n        Self: Sized,\n        P: FnMut(&Self::Item) -> bool,\n    {\n        #[inline]\n        fn check<T>(mut predicate: impl FnMut(&T) -> bool) -> impl FnMut((), T) -> ControlFlow<T> {\n            move |(), x| {\n                if predicate(&x) { ControlFlow::Break(x) } else { ControlFlow::Continue(()) }\n            }\n        }\n\n        self.try_fold((), check(predicate)).break_value()\n    }\n\n    /// Applies function to the elements of iterator and returns\n    /// the first non-none result.\n    ///\n    /// `iter.find_map(f)` is equivalent to `iter.filter_map(f).next()`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let a = [\"lol\", \"NaN\", \"2\", \"5\"];\n    ///\n    /// let first_number = a.iter().find_map(|s| s.parse().ok());\n    ///\n    /// assert_eq!(first_number, Some(2));\n    /// ```\n    #[inline]\n    #[stable(feature = \"iterator_find_map\", since = \"1.30.0\")]\n    fn find_map<B, F>(&mut self, f: F) -> Option<B>\n    where\n        Self: Sized,\n        F: FnMut(Self::Item) -> Option<B>,\n    {\n        #[inline]\n        fn check<T, B>(mut f: impl FnMut(T) -> Option<B>) -> impl FnMut((), T) -> ControlFlow<B> {\n            move |(), x| match f(x) {\n                Some(x) => ControlFlow::Break(x),\n                None => ControlFlow::Continue(()),\n            }\n        }\n\n        self.try_fold((), check(f)).break_value()\n    }\n\n    /// Applies function to the elements of iterator and returns\n    /// the first true result or the first error.\n    ///\n    /// The return type of this method depends on the return type of the closure.\n    /// If you return `Result<bool, E>` from the closure, you'll get a `Result<Option<Self::Item>, E>`.\n    /// If you return `Option<bool>` from the closure, you'll get an `Option<Option<Self::Item>>`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(try_find)]\n    ///\n    /// let a = [\"1\", \"2\", \"lol\", \"NaN\", \"5\"];\n    ///\n    /// let is_my_num = |s: &str, search: i32| -> Result<bool, std::num::ParseIntError> {\n    ///     Ok(s.parse::<i32>()? == search)\n    /// };\n    ///\n    /// let result = a.into_iter().try_find(|&s| is_my_num(s, 2));\n    /// assert_eq!(result, Ok(Some(\"2\")));\n    ///\n    /// let result = a.into_iter().try_find(|&s| is_my_num(s, 5));\n    /// assert!(result.is_err());\n    /// ```\n    ///\n    /// This also supports other types which implement [`Try`], not just [`Result`].\n    ///\n    /// ```\n    /// #![feature(try_find)]\n    ///\n    /// use std::num::NonZero;\n    ///\n    /// let a = [3, 5, 7, 4, 9, 0, 11u32];\n    /// let result = a.into_iter().try_find(|&x| NonZero::new(x).map(|y| y.is_power_of_two()));\n    /// assert_eq!(result, Some(Some(4)));\n    /// let result = a.into_iter().take(3).try_find(|&x| NonZero::new(x).map(|y| y.is_power_of_two()));\n    /// assert_eq!(result, Some(None));\n    /// let result = a.into_iter().rev().try_find(|&x| NonZero::new(x).map(|y| y.is_power_of_two()));\n    /// assert_eq!(result, None);\n    /// ```\n    #[inline]\n    #[unstable(feature = \"try_find\", reason = \"new API\", issue = \"63178\")]\n    fn try_find<R>(\n        &mut self,\n        f: impl FnMut(&Self::Item) -> R,\n    ) -> ChangeOutputType<R, Option<Self::Item>>\n    where\n        Self: Sized,\n        R: Try<Output = bool, Residual: Residual<Option<Self::Item>>>,\n    {\n        #[inline]\n        fn check<I, V, R>(\n            mut f: impl FnMut(&I) -> V,\n        ) -> impl FnMut((), I) -> ControlFlow<R::TryType>\n        where\n            V: Try<Output = bool, Residual = R>,\n            R: Residual<Option<I>>,\n        {\n            move |(), x| match f(&x).branch() {\n                ControlFlow::Continue(false) => ControlFlow::Continue(()),\n                ControlFlow::Continue(true) => ControlFlow::Break(Try::from_output(Some(x))),\n                ControlFlow::Break(r) => ControlFlow::Break(FromResidual::from_residual(r)),\n            }\n        }\n\n        match self.try_fold((), check(f)) {\n            ControlFlow::Break(x) => x,\n            ControlFlow::Continue(()) => Try::from_output(None),\n        }\n    }\n\n    /// Searches for an element in an iterator, returning its index.\n    ///\n    /// `position()` takes a closure that returns `true` or `false`. It applies\n    /// this closure to each element of the iterator, and if one of them\n    /// returns `true`, then `position()` returns [`Some(index)`]. If all of\n    /// them return `false`, it returns [`None`].\n    ///\n    /// `position()` is short-circuiting; in other words, it will stop\n    /// processing as soon as it finds a `true`.\n    ///\n    /// # Overflow Behavior\n    ///\n    /// The method does no guarding against overflows, so if there are more\n    /// than [`usize::MAX`] non-matching elements, it either produces the wrong\n    /// result or panics. If overflow checks are enabled, a panic is\n    /// guaranteed.\n    ///\n    /// # Panics\n    ///\n    /// This function might panic if the iterator has more than `usize::MAX`\n    /// non-matching elements.\n    ///\n    /// [`Some(index)`]: Some\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// let a = [1, 2, 3];\n    ///\n    /// assert_eq!(a.into_iter().position(|x| x == 2), Some(1));\n    ///\n    /// assert_eq!(a.into_iter().position(|x| x == 5), None);\n    /// ```\n    ///\n    /// Stopping at the first `true`:\n    ///\n    /// ```\n    /// let a = [1, 2, 3, 4];\n    ///\n    /// let mut iter = a.into_iter();\n    ///\n    /// assert_eq!(iter.position(|x| x >= 2), Some(1));\n    ///\n    /// // we can still use `iter`, as there are more elements.\n    /// assert_eq!(iter.next(), Some(3));\n    ///\n    /// // The returned index depends on iterator state\n    /// assert_eq!(iter.position(|x| x == 4), Some(0));\n    ///\n    /// ```\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    fn position<P>(&mut self, predicate: P) -> Option<usize>\n    where\n        Self: Sized,\n        P: FnMut(Self::Item) -> bool,\n    {\n        #[inline]\n        fn check<'a, T>(\n            mut predicate: impl FnMut(T) -> bool + 'a,\n            acc: &'a mut usize,\n        ) -> impl FnMut((), T) -> ControlFlow<usize, ()> + 'a {\n            #[rustc_inherit_overflow_checks]\n            move |_, x| {\n                if predicate(x) {\n                    ControlFlow::Break(*acc)\n                } else {\n                    *acc += 1;\n                    ControlFlow::Continue(())\n                }\n            }\n        }\n\n        let mut acc = 0;\n        self.try_fold((), check(predicate, &mut acc)).break_value()\n    }\n\n    /// Searches for an element in an iterator from the right, returning its\n    /// index.\n    ///\n    /// `rposition()` takes a closure that returns `true` or `false`. It applies\n    /// this closure to each element of the iterator, starting from the end,\n    /// and if one of them returns `true`, then `rposition()` returns\n    /// [`Some(index)`]. If all of them return `false`, it returns [`None`].\n    ///\n    /// `rposition()` is short-circuiting; in other words, it will stop\n    /// processing as soon as it finds a `true`.\n    ///\n    /// [`Some(index)`]: Some\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// let a = [1, 2, 3];\n    ///\n    /// assert_eq!(a.into_iter().rposition(|x| x == 3), Some(2));\n    ///\n    /// assert_eq!(a.into_iter().rposition(|x| x == 5), None);\n    /// ```\n    ///\n    /// Stopping at the first `true`:\n    ///\n    /// ```\n    /// let a = [-1, 2, 3, 4];\n    ///\n    /// let mut iter = a.into_iter();\n    ///\n    /// assert_eq!(iter.rposition(|x| x >= 2), Some(3));\n    ///\n    /// // we can still use `iter`, as there are more elements.\n    /// assert_eq!(iter.next(), Some(-1));\n    /// assert_eq!(iter.next_back(), Some(3));\n    /// ```\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    fn rposition<P>(&mut self, predicate: P) -> Option<usize>\n    where\n        P: FnMut(Self::Item) -> bool,\n        Self: Sized + ExactSizeIterator + DoubleEndedIterator,\n    {\n        // No need for an overflow check here, because `ExactSizeIterator`\n        // implies that the number of elements fits into a `usize`.\n        #[inline]\n        fn check<T>(\n            mut predicate: impl FnMut(T) -> bool,\n        ) -> impl FnMut(usize, T) -> ControlFlow<usize, usize> {\n            move |i, x| {\n                let i = i - 1;\n                if predicate(x) { ControlFlow::Break(i) } else { ControlFlow::Continue(i) }\n            }\n        }\n\n        let n = self.len();\n        self.try_rfold(n, check(predicate)).break_value()\n    }\n\n    /// Returns the maximum element of an iterator.\n    ///\n    /// If several elements are equally maximum, the last element is\n    /// returned. If the iterator is empty, [`None`] is returned.\n    ///\n    /// Note that [`f32`]/[`f64`] doesn't implement [`Ord`] due to NaN being\n    /// incomparable. You can work around this by using [`Iterator::reduce`]:\n    /// ```\n    /// assert_eq!(\n    ///     [2.4, f32::NAN, 1.3]\n    ///         .into_iter()\n    ///         .reduce(f32::max)\n    ///         .unwrap_or(0.),\n    ///     2.4\n    /// );\n    /// ```\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let a = [1, 2, 3];\n    /// let b: [u32; 0] = [];\n    ///\n    /// assert_eq!(a.into_iter().max(), Some(3));\n    /// assert_eq!(b.into_iter().max(), None);\n    /// ```\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    fn max(self) -> Option<Self::Item>\n    where\n        Self: Sized,\n        Self::Item: Ord,\n    {\n        self.max_by(Ord::cmp)\n    }\n\n    /// Returns the minimum element of an iterator.\n    ///\n    /// If several elements are equally minimum, the first element is returned.\n    /// If the iterator is empty, [`None`] is returned.\n    ///\n    /// Note that [`f32`]/[`f64`] doesn't implement [`Ord`] due to NaN being\n    /// incomparable. You can work around this by using [`Iterator::reduce`]:\n    /// ```\n    /// assert_eq!(\n    ///     [2.4, f32::NAN, 1.3]\n    ///         .into_iter()\n    ///         .reduce(f32::min)\n    ///         .unwrap_or(0.),\n    ///     1.3\n    /// );\n    /// ```\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let a = [1, 2, 3];\n    /// let b: [u32; 0] = [];\n    ///\n    /// assert_eq!(a.into_iter().min(), Some(1));\n    /// assert_eq!(b.into_iter().min(), None);\n    /// ```\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    fn min(self) -> Option<Self::Item>\n    where\n        Self: Sized,\n        Self::Item: Ord,\n    {\n        self.min_by(Ord::cmp)\n    }\n\n    /// Returns the element that gives the maximum value from the\n    /// specified function.\n    ///\n    /// If several elements are equally maximum, the last element is\n    /// returned. If the iterator is empty, [`None`] is returned.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let a = [-3_i32, 0, 1, 5, -10];\n    /// assert_eq!(a.into_iter().max_by_key(|x| x.abs()).unwrap(), -10);\n    /// ```\n    #[inline]\n    #[stable(feature = \"iter_cmp_by_key\", since = \"1.6.0\")]\n    fn max_by_key<B: Ord, F>(self, f: F) -> Option<Self::Item>\n    where\n        Self: Sized,\n        F: FnMut(&Self::Item) -> B,\n    {\n        #[inline]\n        fn key<T, B>(mut f: impl FnMut(&T) -> B) -> impl FnMut(T) -> (B, T) {\n            move |x| (f(&x), x)\n        }\n\n        #[inline]\n        fn compare<T, B: Ord>((x_p, _): &(B, T), (y_p, _): &(B, T)) -> Ordering {\n            x_p.cmp(y_p)\n        }\n\n        let (_, x) = self.map(key(f)).max_by(compare)?;\n        Some(x)\n    }\n\n    /// Returns the element that gives the maximum value with respect to the\n    /// specified comparison function.\n    ///\n    /// If several elements are equally maximum, the last element is\n    /// returned. If the iterator is empty, [`None`] is returned.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let a = [-3_i32, 0, 1, 5, -10];\n    /// assert_eq!(a.into_iter().max_by(|x, y| x.cmp(y)).unwrap(), 5);\n    /// ```\n    #[inline]\n    #[stable(feature = \"iter_max_by\", since = \"1.15.0\")]\n    fn max_by<F>(self, compare: F) -> Option<Self::Item>\n    where\n        Self: Sized,\n        F: FnMut(&Self::Item, &Self::Item) -> Ordering,\n    {\n        #[inline]\n        fn fold<T>(mut compare: impl FnMut(&T, &T) -> Ordering) -> impl FnMut(T, T) -> T {\n            move |x, y| cmp::max_by(x, y, &mut compare)\n        }\n\n        self.reduce(fold(compare))\n    }\n\n    /// Returns the element that gives the minimum value from the\n    /// specified function.\n    ///\n    /// If several elements are equally minimum, the first element is\n    /// returned. If the iterator is empty, [`None`] is returned.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let a = [-3_i32, 0, 1, 5, -10];\n    /// assert_eq!(a.into_iter().min_by_key(|x| x.abs()).unwrap(), 0);\n    /// ```\n    #[inline]\n    #[stable(feature = \"iter_cmp_by_key\", since = \"1.6.0\")]\n    fn min_by_key<B: Ord, F>(self, f: F) -> Option<Self::Item>\n    where\n        Self: Sized,\n        F: FnMut(&Self::Item) -> B,\n    {\n        #[inline]\n        fn key<T, B>(mut f: impl FnMut(&T) -> B) -> impl FnMut(T) -> (B, T) {\n            move |x| (f(&x), x)\n        }\n\n        #[inline]\n        fn compare<T, B: Ord>((x_p, _): &(B, T), (y_p, _): &(B, T)) -> Ordering {\n            x_p.cmp(y_p)\n        }\n\n        let (_, x) = self.map(key(f)).min_by(compare)?;\n        Some(x)\n    }\n\n    /// Returns the element that gives the minimum value with respect to the\n    /// specified comparison function.\n    ///\n    /// If several elements are equally minimum, the first element is\n    /// returned. If the iterator is empty, [`None`] is returned.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let a = [-3_i32, 0, 1, 5, -10];\n    /// assert_eq!(a.into_iter().min_by(|x, y| x.cmp(y)).unwrap(), -10);\n    /// ```\n    #[inline]\n    #[stable(feature = \"iter_min_by\", since = \"1.15.0\")]\n    fn min_by<F>(self, compare: F) -> Option<Self::Item>\n    where\n        Self: Sized,\n        F: FnMut(&Self::Item, &Self::Item) -> Ordering,\n    {\n        #[inline]\n        fn fold<T>(mut compare: impl FnMut(&T, &T) -> Ordering) -> impl FnMut(T, T) -> T {\n            move |x, y| cmp::min_by(x, y, &mut compare)\n        }\n\n        self.reduce(fold(compare))\n    }\n\n    /// Reverses an iterator's direction.\n    ///\n    /// Usually, iterators iterate from left to right. After using `rev()`,\n    /// an iterator will instead iterate from right to left.\n    ///\n    /// This is only possible if the iterator has an end, so `rev()` only\n    /// works on [`DoubleEndedIterator`]s.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let a = [1, 2, 3];\n    ///\n    /// let mut iter = a.into_iter().rev();\n    ///\n    /// assert_eq!(iter.next(), Some(3));\n    /// assert_eq!(iter.next(), Some(2));\n    /// assert_eq!(iter.next(), Some(1));\n    ///\n    /// assert_eq!(iter.next(), None);\n    /// ```\n    #[inline]\n    #[doc(alias = \"reverse\")]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    fn rev(self) -> Rev<Self>\n    where\n        Self: Sized + DoubleEndedIterator,\n    {\n        Rev::new(self)\n    }\n\n    /// Converts an iterator of pairs into a pair of containers.\n    ///\n    /// `unzip()` consumes an entire iterator of pairs, producing two\n    /// collections: one from the left elements of the pairs, and one\n    /// from the right elements.\n    ///\n    /// This function is, in some sense, the opposite of [`zip`].\n    ///\n    /// [`zip`]: Iterator::zip\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let a = [(1, 2), (3, 4), (5, 6)];\n    ///\n    /// let (left, right): (Vec<_>, Vec<_>) = a.into_iter().unzip();\n    ///\n    /// assert_eq!(left, [1, 3, 5]);\n    /// assert_eq!(right, [2, 4, 6]);\n    ///\n    /// // you can also unzip multiple nested tuples at once\n    /// let a = [(1, (2, 3)), (4, (5, 6))];\n    ///\n    /// let (x, (y, z)): (Vec<_>, (Vec<_>, Vec<_>)) = a.into_iter().unzip();\n    /// assert_eq!(x, [1, 4]);\n    /// assert_eq!(y, [2, 5]);\n    /// assert_eq!(z, [3, 6]);\n    /// ```\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    fn unzip<A, B, FromA, FromB>(self) -> (FromA, FromB)\n    where\n        FromA: Default + Extend<A>,\n        FromB: Default + Extend<B>,\n        Self: Sized + Iterator<Item = (A, B)>,\n    {\n        let mut unzipped: (FromA, FromB) = Default::default();\n        unzipped.extend(self);\n        unzipped\n    }\n\n    /// Creates an iterator which copies all of its elements.\n    ///\n    /// This is useful when you have an iterator over `&T`, but you need an\n    /// iterator over `T`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let a = [1, 2, 3];\n    ///\n    /// let v_copied: Vec<_> = a.iter().copied().collect();\n    ///\n    /// // copied is the same as .map(|&x| x)\n    /// let v_map: Vec<_> = a.iter().map(|&x| x).collect();\n    ///\n    /// assert_eq!(v_copied, [1, 2, 3]);\n    /// assert_eq!(v_map, [1, 2, 3]);\n    /// ```\n    #[stable(feature = \"iter_copied\", since = \"1.36.0\")]\n    #[rustc_diagnostic_item = \"iter_copied\"]\n    fn copied<'a, T>(self) -> Copied<Self>\n    where\n        T: Copy + 'a,\n        Self: Sized + Iterator<Item = &'a T>,\n    {\n        Copied::new(self)\n    }\n\n    /// Creates an iterator which [`clone`]s all of its elements.\n    ///\n    /// This is useful when you have an iterator over `&T`, but you need an\n    /// iterator over `T`.\n    ///\n    /// There is no guarantee whatsoever about the `clone` method actually\n    /// being called *or* optimized away. So code should not depend on\n    /// either.\n    ///\n    /// [`clone`]: Clone::clone\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// let a = [1, 2, 3];\n    ///\n    /// let v_cloned: Vec<_> = a.iter().cloned().collect();\n    ///\n    /// // cloned is the same as .map(|&x| x), for integers\n    /// let v_map: Vec<_> = a.iter().map(|&x| x).collect();\n    ///\n    /// assert_eq!(v_cloned, [1, 2, 3]);\n    /// assert_eq!(v_map, [1, 2, 3]);\n    /// ```\n    ///\n    /// To get the best performance, try to clone late:\n    ///\n    /// ```\n    /// let a = [vec![0_u8, 1, 2], vec![3, 4], vec![23]];\n    /// // don't do this:\n    /// let slower: Vec<_> = a.iter().cloned().filter(|s| s.len() == 1).collect();\n    /// assert_eq!(&[vec![23]], &slower[..]);\n    /// // instead call `cloned` late\n    /// let faster: Vec<_> = a.iter().filter(|s| s.len() == 1).cloned().collect();\n    /// assert_eq!(&[vec![23]], &faster[..]);\n    /// ```\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_diagnostic_item = \"iter_cloned\"]\n    fn cloned<'a, T>(self) -> Cloned<Self>\n    where\n        T: Clone + 'a,\n        Self: Sized + Iterator<Item = &'a T>,\n    {\n        Cloned::new(self)\n    }\n\n    /// Repeats an iterator endlessly.\n    ///\n    /// Instead of stopping at [`None`], the iterator will instead start again,\n    /// from the beginning. After iterating again, it will start at the\n    /// beginning again. And again. And again. Forever. Note that in case the\n    /// original iterator is empty, the resulting iterator will also be empty.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let a = [1, 2, 3];\n    ///\n    /// let mut iter = a.into_iter().cycle();\n    ///\n    /// loop {\n    ///     assert_eq!(iter.next(), Some(1));\n    ///     assert_eq!(iter.next(), Some(2));\n    ///     assert_eq!(iter.next(), Some(3));\n    /// #   break;\n    /// }\n    /// ```\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[inline]\n    fn cycle(self) -> Cycle<Self>\n    where\n        Self: Sized + Clone,\n    {\n        Cycle::new(self)\n    }\n\n    /// Returns an iterator over `N` elements of the iterator at a time.\n    ///\n    /// The chunks do not overlap. If `N` does not divide the length of the\n    /// iterator, then the last up to `N-1` elements will be omitted and can be\n    /// retrieved from the [`.into_remainder()`][ArrayChunks::into_remainder]\n    /// function of the iterator.\n    ///\n    /// # Panics\n    ///\n    /// Panics if `N` is zero.\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// #![feature(iter_array_chunks)]\n    ///\n    /// let mut iter = \"lorem\".chars().array_chunks();\n    /// assert_eq!(iter.next(), Some(['l', 'o']));\n    /// assert_eq!(iter.next(), Some(['r', 'e']));\n    /// assert_eq!(iter.next(), None);\n    /// assert_eq!(iter.into_remainder().as_slice(), &['m']);\n    /// ```\n    ///\n    /// ```\n    /// #![feature(iter_array_chunks)]\n    ///\n    /// let data = [1, 1, 2, -2, 6, 0, 3, 1];\n    /// //          ^-----^  ^------^\n    /// for [x, y, z] in data.iter().array_chunks() {\n    ///     assert_eq!(x + y + z, 4);\n    /// }\n    /// ```\n    #[track_caller]\n    #[unstable(feature = \"iter_array_chunks\", reason = \"recently added\", issue = \"100450\")]\n    fn array_chunks<const N: usize>(self) -> ArrayChunks<Self, N>\n    where\n        Self: Sized,\n    {\n        ArrayChunks::new(self)\n    }\n\n    /// Sums the elements of an iterator.\n    ///\n    /// Takes each element, adds them together, and returns the result.\n    ///\n    /// An empty iterator returns the *additive identity* (\"zero\") of the type,\n    /// which is `0` for integers and `-0.0` for floats.\n    ///\n    /// `sum()` can be used to sum any type implementing [`Sum`][`core::iter::Sum`],\n    /// including [`Option`][`Option::sum`] and [`Result`][`Result::sum`].\n    ///\n    /// # Panics\n    ///\n    /// When calling `sum()` and a primitive integer type is being returned, this\n    /// method will panic if the computation overflows and overflow checks are\n    /// enabled.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let a = [1, 2, 3];\n    /// let sum: i32 = a.iter().sum();\n    ///\n    /// assert_eq!(sum, 6);\n    ///\n    /// let b: Vec<f32> = vec![];\n    /// let sum: f32 = b.iter().sum();\n    /// assert_eq!(sum, -0.0_f32);\n    /// ```\n    #[stable(feature = \"iter_arith\", since = \"1.11.0\")]\n    fn sum<S>(self) -> S\n    where\n        Self: Sized,\n        S: Sum<Self::Item>,\n    {\n        Sum::sum(self)\n    }\n\n    /// Iterates over the entire iterator, multiplying all the elements\n    ///\n    /// An empty iterator returns the one value of the type.\n    ///\n    /// `product()` can be used to multiply any type implementing [`Product`][`core::iter::Product`],\n    /// including [`Option`][`Option::product`] and [`Result`][`Result::product`].\n    ///\n    /// # Panics\n    ///\n    /// When calling `product()` and a primitive integer type is being returned,\n    /// method will panic if the computation overflows and overflow checks are\n    /// enabled.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// fn factorial(n: u32) -> u32 {\n    ///     (1..=n).product()\n    /// }\n    /// assert_eq!(factorial(0), 1);\n    /// assert_eq!(factorial(1), 1);\n    /// assert_eq!(factorial(5), 120);\n    /// ```\n    #[stable(feature = \"iter_arith\", since = \"1.11.0\")]\n    fn product<P>(self) -> P\n    where\n        Self: Sized,\n        P: Product<Self::Item>,\n    {\n        Product::product(self)\n    }\n\n    /// [Lexicographically](Ord#lexicographical-comparison) compares the elements of this [`Iterator`] with those\n    /// of another.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// use std::cmp::Ordering;\n    ///\n    /// assert_eq!([1].iter().cmp([1].iter()), Ordering::Equal);\n    /// assert_eq!([1].iter().cmp([1, 2].iter()), Ordering::Less);\n    /// assert_eq!([1, 2].iter().cmp([1].iter()), Ordering::Greater);\n    /// ```\n    #[stable(feature = \"iter_order\", since = \"1.5.0\")]\n    fn cmp<I>(self, other: I) -> Ordering\n    where\n        I: IntoIterator<Item = Self::Item>,\n        Self::Item: Ord,\n        Self: Sized,\n    {\n        self.cmp_by(other, |x, y| x.cmp(&y))\n    }\n\n    /// [Lexicographically](Ord#lexicographical-comparison) compares the elements of this [`Iterator`] with those\n    /// of another with respect to the specified comparison function.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(iter_order_by)]\n    ///\n    /// use std::cmp::Ordering;\n    ///\n    /// let xs = [1, 2, 3, 4];\n    /// let ys = [1, 4, 9, 16];\n    ///\n    /// assert_eq!(xs.into_iter().cmp_by(ys, |x, y| x.cmp(&y)), Ordering::Less);\n    /// assert_eq!(xs.into_iter().cmp_by(ys, |x, y| (x * x).cmp(&y)), Ordering::Equal);\n    /// assert_eq!(xs.into_iter().cmp_by(ys, |x, y| (2 * x).cmp(&y)), Ordering::Greater);\n    /// ```\n    #[unstable(feature = \"iter_order_by\", issue = \"64295\")]\n    fn cmp_by<I, F>(self, other: I, cmp: F) -> Ordering\n    where\n        Self: Sized,\n        I: IntoIterator,\n        F: FnMut(Self::Item, I::Item) -> Ordering,\n    {\n        #[inline]\n        fn compare<X, Y, F>(mut cmp: F) -> impl FnMut(X, Y) -> ControlFlow<Ordering>\n        where\n            F: FnMut(X, Y) -> Ordering,\n        {\n            move |x, y| match cmp(x, y) {\n                Ordering::Equal => ControlFlow::Continue(()),\n                non_eq => ControlFlow::Break(non_eq),\n            }\n        }\n\n        match iter_compare(self, other.into_iter(), compare(cmp)) {\n            ControlFlow::Continue(ord) => ord,\n            ControlFlow::Break(ord) => ord,\n        }\n    }\n\n    /// [Lexicographically](Ord#lexicographical-comparison) compares the [`PartialOrd`] elements of\n    /// this [`Iterator`] with those of another. The comparison works like short-circuit\n    /// evaluation, returning a result without comparing the remaining elements.\n    /// As soon as an order can be determined, the evaluation stops and a result is returned.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// use std::cmp::Ordering;\n    ///\n    /// assert_eq!([1.].iter().partial_cmp([1.].iter()), Some(Ordering::Equal));\n    /// assert_eq!([1.].iter().partial_cmp([1., 2.].iter()), Some(Ordering::Less));\n    /// assert_eq!([1., 2.].iter().partial_cmp([1.].iter()), Some(Ordering::Greater));\n    /// ```\n    ///\n    /// For floating-point numbers, NaN does not have a total order and will result\n    /// in `None` when compared:\n    ///\n    /// ```\n    /// assert_eq!([f64::NAN].iter().partial_cmp([1.].iter()), None);\n    /// ```\n    ///\n    /// The results are determined by the order of evaluation.\n    ///\n    /// ```\n    /// use std::cmp::Ordering;\n    ///\n    /// assert_eq!([1.0, f64::NAN].iter().partial_cmp([2.0, f64::NAN].iter()), Some(Ordering::Less));\n    /// assert_eq!([2.0, f64::NAN].iter().partial_cmp([1.0, f64::NAN].iter()), Some(Ordering::Greater));\n    /// assert_eq!([f64::NAN, 1.0].iter().partial_cmp([f64::NAN, 2.0].iter()), None);\n    /// ```\n    ///\n    #[stable(feature = \"iter_order\", since = \"1.5.0\")]\n    fn partial_cmp<I>(self, other: I) -> Option<Ordering>\n    where\n        I: IntoIterator,\n        Self::Item: PartialOrd<I::Item>,\n        Self: Sized,\n    {\n        self.partial_cmp_by(other, |x, y| x.partial_cmp(&y))\n    }\n\n    /// [Lexicographically](Ord#lexicographical-comparison) compares the elements of this [`Iterator`] with those\n    /// of another with respect to the specified comparison function.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(iter_order_by)]\n    ///\n    /// use std::cmp::Ordering;\n    ///\n    /// let xs = [1.0, 2.0, 3.0, 4.0];\n    /// let ys = [1.0, 4.0, 9.0, 16.0];\n    ///\n    /// assert_eq!(\n    ///     xs.iter().partial_cmp_by(ys, |x, y| x.partial_cmp(&y)),\n    ///     Some(Ordering::Less)\n    /// );\n    /// assert_eq!(\n    ///     xs.iter().partial_cmp_by(ys, |x, y| (x * x).partial_cmp(&y)),\n    ///     Some(Ordering::Equal)\n    /// );\n    /// assert_eq!(\n    ///     xs.iter().partial_cmp_by(ys, |x, y| (2.0 * x).partial_cmp(&y)),\n    ///     Some(Ordering::Greater)\n    /// );\n    /// ```\n    #[unstable(feature = \"iter_order_by\", issue = \"64295\")]\n    fn partial_cmp_by<I, F>(self, other: I, partial_cmp: F) -> Option<Ordering>\n    where\n        Self: Sized,\n        I: IntoIterator,\n        F: FnMut(Self::Item, I::Item) -> Option<Ordering>,\n    {\n        #[inline]\n        fn compare<X, Y, F>(mut partial_cmp: F) -> impl FnMut(X, Y) -> ControlFlow<Option<Ordering>>\n        where\n            F: FnMut(X, Y) -> Option<Ordering>,\n        {\n            move |x, y| match partial_cmp(x, y) {\n                Some(Ordering::Equal) => ControlFlow::Continue(()),\n                non_eq => ControlFlow::Break(non_eq),\n            }\n        }\n\n        match iter_compare(self, other.into_iter(), compare(partial_cmp)) {\n            ControlFlow::Continue(ord) => Some(ord),\n            ControlFlow::Break(ord) => ord,\n        }\n    }\n\n    /// Determines if the elements of this [`Iterator`] are equal to those of\n    /// another.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// assert_eq!([1].iter().eq([1].iter()), true);\n    /// assert_eq!([1].iter().eq([1, 2].iter()), false);\n    /// ```\n    #[stable(feature = \"iter_order\", since = \"1.5.0\")]\n    fn eq<I>(self, other: I) -> bool\n    where\n        I: IntoIterator,\n        Self::Item: PartialEq<I::Item>,\n        Self: Sized,\n    {\n        self.eq_by(other, |x, y| x == y)\n    }\n\n    /// Determines if the elements of this [`Iterator`] are equal to those of\n    /// another with respect to the specified equality function.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(iter_order_by)]\n    ///\n    /// let xs = [1, 2, 3, 4];\n    /// let ys = [1, 4, 9, 16];\n    ///\n    /// assert!(xs.iter().eq_by(ys, |x, y| x * x == y));\n    /// ```\n    #[unstable(feature = \"iter_order_by\", issue = \"64295\")]\n    fn eq_by<I, F>(self, other: I, eq: F) -> bool\n    where\n        Self: Sized,\n        I: IntoIterator,\n        F: FnMut(Self::Item, I::Item) -> bool,\n    {\n        #[inline]\n        fn compare<X, Y, F>(mut eq: F) -> impl FnMut(X, Y) -> ControlFlow<()>\n        where\n            F: FnMut(X, Y) -> bool,\n        {\n            move |x, y| {\n                if eq(x, y) { ControlFlow::Continue(()) } else { ControlFlow::Break(()) }\n            }\n        }\n\n        SpecIterEq::spec_iter_eq(self, other.into_iter(), compare(eq))\n    }\n\n    /// Determines if the elements of this [`Iterator`] are not equal to those of\n    /// another.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// assert_eq!([1].iter().ne([1].iter()), false);\n    /// assert_eq!([1].iter().ne([1, 2].iter()), true);\n    /// ```\n    #[stable(feature = \"iter_order\", since = \"1.5.0\")]\n    fn ne<I>(self, other: I) -> bool\n    where\n        I: IntoIterator,\n        Self::Item: PartialEq<I::Item>,\n        Self: Sized,\n    {\n        !self.eq(other)\n    }\n\n    /// Determines if the elements of this [`Iterator`] are [lexicographically](Ord#lexicographical-comparison)\n    /// less than those of another.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// assert_eq!([1].iter().lt([1].iter()), false);\n    /// assert_eq!([1].iter().lt([1, 2].iter()), true);\n    /// assert_eq!([1, 2].iter().lt([1].iter()), false);\n    /// assert_eq!([1, 2].iter().lt([1, 2].iter()), false);\n    /// ```\n    #[stable(feature = \"iter_order\", since = \"1.5.0\")]\n    fn lt<I>(self, other: I) -> bool\n    where\n        I: IntoIterator,\n        Self::Item: PartialOrd<I::Item>,\n        Self: Sized,\n    {\n        self.partial_cmp(other) == Some(Ordering::Less)\n    }\n\n    /// Determines if the elements of this [`Iterator`] are [lexicographically](Ord#lexicographical-comparison)\n    /// less or equal to those of another.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// assert_eq!([1].iter().le([1].iter()), true);\n    /// assert_eq!([1].iter().le([1, 2].iter()), true);\n    /// assert_eq!([1, 2].iter().le([1].iter()), false);\n    /// assert_eq!([1, 2].iter().le([1, 2].iter()), true);\n    /// ```\n    #[stable(feature = \"iter_order\", since = \"1.5.0\")]\n    fn le<I>(self, other: I) -> bool\n    where\n        I: IntoIterator,\n        Self::Item: PartialOrd<I::Item>,\n        Self: Sized,\n    {\n        matches!(self.partial_cmp(other), Some(Ordering::Less | Ordering::Equal))\n    }\n\n    /// Determines if the elements of this [`Iterator`] are [lexicographically](Ord#lexicographical-comparison)\n    /// greater than those of another.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// assert_eq!([1].iter().gt([1].iter()), false);\n    /// assert_eq!([1].iter().gt([1, 2].iter()), false);\n    /// assert_eq!([1, 2].iter().gt([1].iter()), true);\n    /// assert_eq!([1, 2].iter().gt([1, 2].iter()), false);\n    /// ```\n    #[stable(feature = \"iter_order\", since = \"1.5.0\")]\n    fn gt<I>(self, other: I) -> bool\n    where\n        I: IntoIterator,\n        Self::Item: PartialOrd<I::Item>,\n        Self: Sized,\n    {\n        self.partial_cmp(other) == Some(Ordering::Greater)\n    }\n\n    /// Determines if the elements of this [`Iterator`] are [lexicographically](Ord#lexicographical-comparison)\n    /// greater than or equal to those of another.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// assert_eq!([1].iter().ge([1].iter()), true);\n    /// assert_eq!([1].iter().ge([1, 2].iter()), false);\n    /// assert_eq!([1, 2].iter().ge([1].iter()), true);\n    /// assert_eq!([1, 2].iter().ge([1, 2].iter()), true);\n    /// ```\n    #[stable(feature = \"iter_order\", since = \"1.5.0\")]\n    fn ge<I>(self, other: I) -> bool\n    where\n        I: IntoIterator,\n        Self::Item: PartialOrd<I::Item>,\n        Self: Sized,\n    {\n        matches!(self.partial_cmp(other), Some(Ordering::Greater | Ordering::Equal))\n    }\n\n    /// Checks if the elements of this iterator are sorted.\n    ///\n    /// That is, for each element `a` and its following element `b`, `a <= b` must hold. If the\n    /// iterator yields exactly zero or one element, `true` is returned.\n    ///\n    /// Note that if `Self::Item` is only `PartialOrd`, but not `Ord`, the above definition\n    /// implies that this function returns `false` if any two consecutive items are not\n    /// comparable.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// assert!([1, 2, 2, 9].iter().is_sorted());\n    /// assert!(![1, 3, 2, 4].iter().is_sorted());\n    /// assert!([0].iter().is_sorted());\n    /// assert!(std::iter::empty::<i32>().is_sorted());\n    /// assert!(![0.0, 1.0, f32::NAN].iter().is_sorted());\n    /// ```\n    #[inline]\n    #[stable(feature = \"is_sorted\", since = \"1.82.0\")]\n    fn is_sorted(self) -> bool\n    where\n        Self: Sized,\n        Self::Item: PartialOrd,\n    {\n        self.is_sorted_by(|a, b| a <= b)\n    }\n\n    /// Checks if the elements of this iterator are sorted using the given comparator function.\n    ///\n    /// Instead of using `PartialOrd::partial_cmp`, this function uses the given `compare`\n    /// function to determine whether two elements are to be considered in sorted order.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// assert!([1, 2, 2, 9].iter().is_sorted_by(|a, b| a <= b));\n    /// assert!(![1, 2, 2, 9].iter().is_sorted_by(|a, b| a < b));\n    ///\n    /// assert!([0].iter().is_sorted_by(|a, b| true));\n    /// assert!([0].iter().is_sorted_by(|a, b| false));\n    ///\n    /// assert!(std::iter::empty::<i32>().is_sorted_by(|a, b| false));\n    /// assert!(std::iter::empty::<i32>().is_sorted_by(|a, b| true));\n    /// ```\n    #[stable(feature = \"is_sorted\", since = \"1.82.0\")]\n    fn is_sorted_by<F>(mut self, compare: F) -> bool\n    where\n        Self: Sized,\n        F: FnMut(&Self::Item, &Self::Item) -> bool,\n    {\n        #[inline]\n        fn check<'a, T>(\n            last: &'a mut T,\n            mut compare: impl FnMut(&T, &T) -> bool + 'a,\n        ) -> impl FnMut(T) -> bool + 'a {\n            move |curr| {\n                if !compare(&last, &curr) {\n                    return false;\n                }\n                *last = curr;\n                true\n            }\n        }\n\n        let mut last = match self.next() {\n            Some(e) => e,\n            None => return true,\n        };\n\n        self.all(check(&mut last, compare))\n    }\n\n    /// Checks if the elements of this iterator are sorted using the given key extraction\n    /// function.\n    ///\n    /// Instead of comparing the iterator's elements directly, this function compares the keys of\n    /// the elements, as determined by `f`. Apart from that, it's equivalent to [`is_sorted`]; see\n    /// its documentation for more information.\n    ///\n    /// [`is_sorted`]: Iterator::is_sorted\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// assert!([\"c\", \"bb\", \"aaa\"].iter().is_sorted_by_key(|s| s.len()));\n    /// assert!(![-2i32, -1, 0, 3].iter().is_sorted_by_key(|n| n.abs()));\n    /// ```\n    #[inline]\n    #[stable(feature = \"is_sorted\", since = \"1.82.0\")]\n    fn is_sorted_by_key<F, K>(self, f: F) -> bool\n    where\n        Self: Sized,\n        F: FnMut(Self::Item) -> K,\n        K: PartialOrd,\n    {\n        self.map(f).is_sorted()\n    }\n\n    /// See [TrustedRandomAccess][super::super::TrustedRandomAccess]\n    // The unusual name is to avoid name collisions in method resolution\n    // see #76479.\n    #[inline]\n    #[doc(hidden)]\n    #[unstable(feature = \"trusted_random_access\", issue = \"none\")]\n    unsafe fn __iterator_get_unchecked(&mut self, _idx: usize) -> Self::Item\n    where\n        Self: TrustedRandomAccessNoCoerce,\n    {\n        unreachable!(\"Always specialized\");\n    }\n}\n\ntrait SpecIterEq<B: Iterator>: Iterator {\n    fn spec_iter_eq<F>(self, b: B, f: F) -> bool\n    where\n        F: FnMut(Self::Item, <B as Iterator>::Item) -> ControlFlow<()>;\n}\n\nimpl<A: Iterator, B: Iterator> SpecIterEq<B> for A {\n    #[inline]\n    default fn spec_iter_eq<F>(self, b: B, f: F) -> bool\n    where\n        F: FnMut(Self::Item, <B as Iterator>::Item) -> ControlFlow<()>,\n    {\n        iter_eq(self, b, f)\n    }\n}\n\nimpl<A: Iterator + TrustedLen, B: Iterator + TrustedLen> SpecIterEq<B> for A {\n    #[inline]\n    fn spec_iter_eq<F>(self, b: B, f: F) -> bool\n    where\n        F: FnMut(Self::Item, <B as Iterator>::Item) -> ControlFlow<()>,\n    {\n        // we *can't* short-circuit if:\n        match (self.size_hint(), b.size_hint()) {\n            // ... both iterators have the same length\n            ((_, Some(a)), (_, Some(b))) if a == b => {}\n            // ... or both of them are longer than `usize::MAX` (i.e. have an unknown length).\n            ((_, None), (_, None)) => {}\n            // otherwise, we can ascertain that they are unequal without actually comparing items\n            _ => return false,\n        }\n\n        iter_eq(self, b, f)\n    }\n}\n\n/// Compares two iterators element-wise using the given function.\n///\n/// If `ControlFlow::Continue(())` is returned from the function, the comparison moves on to the next\n/// elements of both iterators. Returning `ControlFlow::Break(x)` short-circuits the iteration and\n/// returns `ControlFlow::Break(x)`. If one of the iterators runs out of elements,\n/// `ControlFlow::Continue(ord)` is returned where `ord` is the result of comparing the lengths of\n/// the iterators.\n///\n/// Isolates the logic shared by ['cmp_by'](Iterator::cmp_by),\n/// ['partial_cmp_by'](Iterator::partial_cmp_by), and ['eq_by'](Iterator::eq_by).\n#[inline]\nfn iter_compare<A, B, F, T>(mut a: A, mut b: B, f: F) -> ControlFlow<T, Ordering>\nwhere\n    A: Iterator,\n    B: Iterator,\n    F: FnMut(A::Item, B::Item) -> ControlFlow<T>,\n{\n    #[inline]\n    fn compare<'a, B, X, T>(\n        b: &'a mut B,\n        mut f: impl FnMut(X, B::Item) -> ControlFlow<T> + 'a,\n    ) -> impl FnMut(X) -> ControlFlow<ControlFlow<T, Ordering>> + 'a\n    where\n        B: Iterator,\n    {\n        move |x| match b.next() {\n            None => ControlFlow::Break(ControlFlow::Continue(Ordering::Greater)),\n            Some(y) => f(x, y).map_break(ControlFlow::Break),\n        }\n    }\n\n    match a.try_for_each(compare(&mut b, f)) {\n        ControlFlow::Continue(()) => ControlFlow::Continue(match b.next() {\n            None => Ordering::Equal,\n            Some(_) => Ordering::Less,\n        }),\n        ControlFlow::Break(x) => x,\n    }\n}\n\n#[inline]\nfn iter_eq<A, B, F>(a: A, b: B, f: F) -> bool\nwhere\n    A: Iterator,\n    B: Iterator,\n    F: FnMut(A::Item, B::Item) -> ControlFlow<()>,\n{\n    iter_compare(a, b, f).continue_value().is_some_and(|ord| ord == Ordering::Equal)\n}\n\n/// Implements `Iterator` for mutable references to iterators, such as those produced by [`Iterator::by_ref`].\n///\n/// This implementation passes all method calls on to the original iterator.\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl<I: Iterator + ?Sized> Iterator for &mut I {\n    type Item = I::Item;\n    #[inline]\n    fn next(&mut self) -> Option<I::Item> {\n        (**self).next()\n    }\n    fn size_hint(&self) -> (usize, Option<usize>) {\n        (**self).size_hint()\n    }\n    fn advance_by(&mut self, n: usize) -> Result<(), NonZero<usize>> {\n        (**self).advance_by(n)\n    }\n    fn nth(&mut self, n: usize) -> Option<Self::Item> {\n        (**self).nth(n)\n    }\n    fn fold<B, F>(self, init: B, f: F) -> B\n    where\n        F: FnMut(B, Self::Item) -> B,\n    {\n        self.spec_fold(init, f)\n    }\n    fn try_fold<B, F, R>(&mut self, init: B, f: F) -> R\n    where\n        F: FnMut(B, Self::Item) -> R,\n        R: Try<Output = B>,\n    {\n        self.spec_try_fold(init, f)\n    }\n}\n\n/// Helper trait to specialize `fold` and `try_fold` for `&mut I where I: Sized`\ntrait IteratorRefSpec: Iterator {\n    fn spec_fold<B, F>(self, init: B, f: F) -> B\n    where\n        F: FnMut(B, Self::Item) -> B;\n\n    fn spec_try_fold<B, F, R>(&mut self, init: B, f: F) -> R\n    where\n        F: FnMut(B, Self::Item) -> R,\n        R: Try<Output = B>;\n}\n\nimpl<I: Iterator + ?Sized> IteratorRefSpec for &mut I {\n    default fn spec_fold<B, F>(self, init: B, mut f: F) -> B\n    where\n        F: FnMut(B, Self::Item) -> B,\n    {\n        let mut accum = init;\n        while let Some(x) = self.next() {\n            accum = f(accum, x);\n        }\n        accum\n    }\n\n    default fn spec_try_fold<B, F, R>(&mut self, init: B, mut f: F) -> R\n    where\n        F: FnMut(B, Self::Item) -> R,\n        R: Try<Output = B>,\n    {\n        let mut accum = init;\n        while let Some(x) = self.next() {\n            accum = f(accum, x)?;\n        }\n        try { accum }\n    }\n}\n\nimpl<I: Iterator> IteratorRefSpec for &mut I {\n    impl_fold_via_try_fold! { spec_fold -> spec_try_fold }\n\n    fn spec_try_fold<B, F, R>(&mut self, init: B, f: F) -> R\n    where\n        F: FnMut(B, Self::Item) -> R,\n        R: Try<Output = B>,\n    {\n        (**self).try_fold(init, f)\n    }\n}\n";

},{}],"eBMp8":[function(require,module,exports,__globalThis) {
module.exports = "use super::TrustedLen;\n\n/// Conversion from an [`Iterator`].\n///\n/// By implementing `FromIterator` for a type, you define how it will be\n/// created from an iterator. This is common for types which describe a\n/// collection of some kind.\n///\n/// If you want to create a collection from the contents of an iterator, the\n/// [`Iterator::collect()`] method is preferred. However, when you need to\n/// specify the container type, [`FromIterator::from_iter()`] can be more\n/// readable than using a turbofish (e.g. `::<Vec<_>>()`). See the\n/// [`Iterator::collect()`] documentation for more examples of its use.\n///\n/// See also: [`IntoIterator`].\n///\n/// # Examples\n///\n/// Basic usage:\n///\n/// ```\n/// let five_fives = std::iter::repeat(5).take(5);\n///\n/// let v = Vec::from_iter(five_fives);\n///\n/// assert_eq!(v, vec![5, 5, 5, 5, 5]);\n/// ```\n///\n/// Using [`Iterator::collect()`] to implicitly use `FromIterator`:\n///\n/// ```\n/// let five_fives = std::iter::repeat(5).take(5);\n///\n/// let v: Vec<i32> = five_fives.collect();\n///\n/// assert_eq!(v, vec![5, 5, 5, 5, 5]);\n/// ```\n///\n/// Using [`FromIterator::from_iter()`] as a more readable alternative to\n/// [`Iterator::collect()`]:\n///\n/// ```\n/// use std::collections::VecDeque;\n/// let first = (0..10).collect::<VecDeque<i32>>();\n/// let second = VecDeque::from_iter(0..10);\n///\n/// assert_eq!(first, second);\n/// ```\n///\n/// Implementing `FromIterator` for your type:\n///\n/// ```\n/// // A sample collection, that's just a wrapper over Vec<T>\n/// #[derive(Debug)]\n/// struct MyCollection(Vec<i32>);\n///\n/// // Let's give it some methods so we can create one and add things\n/// // to it.\n/// impl MyCollection {\n///     fn new() -> MyCollection {\n///         MyCollection(Vec::new())\n///     }\n///\n///     fn add(&mut self, elem: i32) {\n///         self.0.push(elem);\n///     }\n/// }\n///\n/// // and we'll implement FromIterator\n/// impl FromIterator<i32> for MyCollection {\n///     fn from_iter<I: IntoIterator<Item=i32>>(iter: I) -> Self {\n///         let mut c = MyCollection::new();\n///\n///         for i in iter {\n///             c.add(i);\n///         }\n///\n///         c\n///     }\n/// }\n///\n/// // Now we can make a new iterator...\n/// let iter = (0..5).into_iter();\n///\n/// // ... and make a MyCollection out of it\n/// let c = MyCollection::from_iter(iter);\n///\n/// assert_eq!(c.0, vec![0, 1, 2, 3, 4]);\n///\n/// // collect works too!\n///\n/// let iter = (0..5).into_iter();\n/// let c: MyCollection = iter.collect();\n///\n/// assert_eq!(c.0, vec![0, 1, 2, 3, 4]);\n/// ```\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\n#[rustc_on_unimplemented(\n    on(\n        Self = \"&[{A}]\",\n        message = \"a slice of type `{Self}` cannot be built since we need to store the elements somewhere\",\n        label = \"try explicitly collecting into a `Vec<{A}>`\",\n    ),\n    on(\n        all(A = \"{integer}\", any(Self = \"&[{integral}]\",)),\n        message = \"a slice of type `{Self}` cannot be built since we need to store the elements somewhere\",\n        label = \"try explicitly collecting into a `Vec<{A}>`\",\n    ),\n    on(\n        Self = \"[{A}]\",\n        message = \"a slice of type `{Self}` cannot be built since `{Self}` has no definite size\",\n        label = \"try explicitly collecting into a `Vec<{A}>`\",\n    ),\n    on(\n        all(A = \"{integer}\", any(Self = \"[{integral}]\",)),\n        message = \"a slice of type `{Self}` cannot be built since `{Self}` has no definite size\",\n        label = \"try explicitly collecting into a `Vec<{A}>`\",\n    ),\n    on(\n        Self = \"[{A}; _]\",\n        message = \"an array of type `{Self}` cannot be built directly from an iterator\",\n        label = \"try collecting into a `Vec<{A}>`, then using `.try_into()`\",\n    ),\n    on(\n        all(A = \"{integer}\", any(Self = \"[{integral}; _]\",)),\n        message = \"an array of type `{Self}` cannot be built directly from an iterator\",\n        label = \"try collecting into a `Vec<{A}>`, then using `.try_into()`\",\n    ),\n    message = \"a value of type `{Self}` cannot be built from an iterator \\\n               over elements of type `{A}`\",\n    label = \"value of type `{Self}` cannot be built from `std::iter::Iterator<Item={A}>`\"\n)]\n#[rustc_diagnostic_item = \"FromIterator\"]\npub trait FromIterator<A>: Sized {\n    /// Creates a value from an iterator.\n    ///\n    /// See the [module-level documentation] for more.\n    ///\n    /// [module-level documentation]: crate::iter\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let five_fives = std::iter::repeat(5).take(5);\n    ///\n    /// let v = Vec::from_iter(five_fives);\n    ///\n    /// assert_eq!(v, vec![5, 5, 5, 5, 5]);\n    /// ```\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_diagnostic_item = \"from_iter_fn\"]\n    fn from_iter<T: IntoIterator<Item = A>>(iter: T) -> Self;\n}\n\n/// Conversion into an [`Iterator`].\n///\n/// By implementing `IntoIterator` for a type, you define how it will be\n/// converted to an iterator. This is common for types which describe a\n/// collection of some kind.\n///\n/// One benefit of implementing `IntoIterator` is that your type will [work\n/// with Rust's `for` loop syntax](crate::iter#for-loops-and-intoiterator).\n///\n/// See also: [`FromIterator`].\n///\n/// # Examples\n///\n/// Basic usage:\n///\n/// ```\n/// let v = [1, 2, 3];\n/// let mut iter = v.into_iter();\n///\n/// assert_eq!(Some(1), iter.next());\n/// assert_eq!(Some(2), iter.next());\n/// assert_eq!(Some(3), iter.next());\n/// assert_eq!(None, iter.next());\n/// ```\n/// Implementing `IntoIterator` for your type:\n///\n/// ```\n/// // A sample collection, that's just a wrapper over Vec<T>\n/// #[derive(Debug)]\n/// struct MyCollection(Vec<i32>);\n///\n/// // Let's give it some methods so we can create one and add things\n/// // to it.\n/// impl MyCollection {\n///     fn new() -> MyCollection {\n///         MyCollection(Vec::new())\n///     }\n///\n///     fn add(&mut self, elem: i32) {\n///         self.0.push(elem);\n///     }\n/// }\n///\n/// // and we'll implement IntoIterator\n/// impl IntoIterator for MyCollection {\n///     type Item = i32;\n///     type IntoIter = std::vec::IntoIter<Self::Item>;\n///\n///     fn into_iter(self) -> Self::IntoIter {\n///         self.0.into_iter()\n///     }\n/// }\n///\n/// // Now we can make a new collection...\n/// let mut c = MyCollection::new();\n///\n/// // ... add some stuff to it ...\n/// c.add(0);\n/// c.add(1);\n/// c.add(2);\n///\n/// // ... and then turn it into an Iterator:\n/// for (i, n) in c.into_iter().enumerate() {\n///     assert_eq!(i as i32, n);\n/// }\n/// ```\n///\n/// It is common to use `IntoIterator` as a trait bound. This allows\n/// the input collection type to change, so long as it is still an\n/// iterator. Additional bounds can be specified by restricting on\n/// `Item`:\n///\n/// ```rust\n/// fn collect_as_strings<T>(collection: T) -> Vec<String>\n/// where\n///     T: IntoIterator,\n///     T::Item: std::fmt::Debug,\n/// {\n///     collection\n///         .into_iter()\n///         .map(|item| format!(\"{item:?}\"))\n///         .collect()\n/// }\n/// ```\n#[rustc_diagnostic_item = \"IntoIterator\"]\n#[rustc_on_unimplemented(\n    on(\n        Self = \"core::ops::range::RangeTo<Idx>\",\n        label = \"if you meant to iterate until a value, add a starting value\",\n        note = \"`..end` is a `RangeTo`, which cannot be iterated on; you might have meant to have a \\\n              bounded `Range`: `0..end`\"\n    ),\n    on(\n        Self = \"core::ops::range::RangeToInclusive<Idx>\",\n        label = \"if you meant to iterate until a value (including it), add a starting value\",\n        note = \"`..=end` is a `RangeToInclusive`, which cannot be iterated on; you might have meant \\\n              to have a bounded `RangeInclusive`: `0..=end`\"\n    ),\n    on(\n        Self = \"[]\",\n        label = \"`{Self}` is not an iterator; try calling `.into_iter()` or `.iter()`\"\n    ),\n    on(Self = \"&[]\", label = \"`{Self}` is not an iterator; try calling `.iter()`\"),\n    on(\n        Self = \"alloc::vec::Vec<T, A>\",\n        label = \"`{Self}` is not an iterator; try calling `.into_iter()` or `.iter()`\"\n    ),\n    on(Self = \"&str\", label = \"`{Self}` is not an iterator; try calling `.chars()` or `.bytes()`\"),\n    on(\n        Self = \"alloc::string::String\",\n        label = \"`{Self}` is not an iterator; try calling `.chars()` or `.bytes()`\"\n    ),\n    on(\n        Self = \"{integral}\",\n        note = \"if you want to iterate between `start` until a value `end`, use the exclusive range \\\n              syntax `start..end` or the inclusive range syntax `start..=end`\"\n    ),\n    on(\n        Self = \"{float}\",\n        note = \"if you want to iterate between `start` until a value `end`, use the exclusive range \\\n              syntax `start..end` or the inclusive range syntax `start..=end`\"\n    ),\n    label = \"`{Self}` is not an iterator\",\n    message = \"`{Self}` is not an iterator\"\n)]\n#[rustc_skip_during_method_dispatch(array, boxed_slice)]\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\npub trait IntoIterator {\n    /// The type of the elements being iterated over.\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    type Item;\n\n    /// Which kind of iterator are we turning this into?\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    type IntoIter: Iterator<Item = Self::Item>;\n\n    /// Creates an iterator from a value.\n    ///\n    /// See the [module-level documentation] for more.\n    ///\n    /// [module-level documentation]: crate::iter\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let v = [1, 2, 3];\n    /// let mut iter = v.into_iter();\n    ///\n    /// assert_eq!(Some(1), iter.next());\n    /// assert_eq!(Some(2), iter.next());\n    /// assert_eq!(Some(3), iter.next());\n    /// assert_eq!(None, iter.next());\n    /// ```\n    #[lang = \"into_iter\"]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    fn into_iter(self) -> Self::IntoIter;\n}\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl<I: Iterator> IntoIterator for I {\n    type Item = I::Item;\n    type IntoIter = I;\n\n    #[inline]\n    fn into_iter(self) -> I {\n        self\n    }\n}\n\n/// Extend a collection with the contents of an iterator.\n///\n/// Iterators produce a series of values, and collections can also be thought\n/// of as a series of values. The `Extend` trait bridges this gap, allowing you\n/// to extend a collection by including the contents of that iterator. When\n/// extending a collection with an already existing key, that entry is updated\n/// or, in the case of collections that permit multiple entries with equal\n/// keys, that entry is inserted.\n///\n/// # Examples\n///\n/// Basic usage:\n///\n/// ```\n/// // You can extend a String with some chars:\n/// let mut message = String::from(\"The first three letters are: \");\n///\n/// message.extend(&['a', 'b', 'c']);\n///\n/// assert_eq!(\"abc\", &message[29..32]);\n/// ```\n///\n/// Implementing `Extend`:\n///\n/// ```\n/// // A sample collection, that's just a wrapper over Vec<T>\n/// #[derive(Debug)]\n/// struct MyCollection(Vec<i32>);\n///\n/// // Let's give it some methods so we can create one and add things\n/// // to it.\n/// impl MyCollection {\n///     fn new() -> MyCollection {\n///         MyCollection(Vec::new())\n///     }\n///\n///     fn add(&mut self, elem: i32) {\n///         self.0.push(elem);\n///     }\n/// }\n///\n/// // since MyCollection has a list of i32s, we implement Extend for i32\n/// impl Extend<i32> for MyCollection {\n///\n///     // This is a bit simpler with the concrete type signature: we can call\n///     // extend on anything which can be turned into an Iterator which gives\n///     // us i32s. Because we need i32s to put into MyCollection.\n///     fn extend<T: IntoIterator<Item=i32>>(&mut self, iter: T) {\n///\n///         // The implementation is very straightforward: loop through the\n///         // iterator, and add() each element to ourselves.\n///         for elem in iter {\n///             self.add(elem);\n///         }\n///     }\n/// }\n///\n/// let mut c = MyCollection::new();\n///\n/// c.add(5);\n/// c.add(6);\n/// c.add(7);\n///\n/// // let's extend our collection with three more numbers\n/// c.extend(vec![1, 2, 3]);\n///\n/// // we've added these elements onto the end\n/// assert_eq!(\"MyCollection([5, 6, 7, 1, 2, 3])\", format!(\"{c:?}\"));\n/// ```\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\npub trait Extend<A> {\n    /// Extends a collection with the contents of an iterator.\n    ///\n    /// As this is the only required method for this trait, the [trait-level] docs\n    /// contain more details.\n    ///\n    /// [trait-level]: Extend\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// // You can extend a String with some chars:\n    /// let mut message = String::from(\"abc\");\n    ///\n    /// message.extend(['d', 'e', 'f'].iter());\n    ///\n    /// assert_eq!(\"abcdef\", &message);\n    /// ```\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    fn extend<T: IntoIterator<Item = A>>(&mut self, iter: T);\n\n    /// Extends a collection with exactly one element.\n    #[unstable(feature = \"extend_one\", issue = \"72631\")]\n    fn extend_one(&mut self, item: A) {\n        self.extend(Some(item));\n    }\n\n    /// Reserves capacity in a collection for the given number of additional elements.\n    ///\n    /// The default implementation does nothing.\n    #[unstable(feature = \"extend_one\", issue = \"72631\")]\n    fn extend_reserve(&mut self, additional: usize) {\n        let _ = additional;\n    }\n\n    /// Extends a collection with one element, without checking there is enough capacity for it.\n    ///\n    /// # Safety\n    ///\n    /// **For callers:** This must only be called when we know the collection has enough capacity\n    /// to contain the new item, for example because we previously called `extend_reserve`.\n    ///\n    /// **For implementors:** For a collection to unsafely rely on this method's safety precondition (that is,\n    /// invoke UB if they are violated), it must implement `extend_reserve` correctly. In other words,\n    /// callers may assume that if they `extend_reserve`ed enough space they can call this method.\n    // This method is for internal usage only. It is only on the trait because of specialization's limitations.\n    #[unstable(feature = \"extend_one_unchecked\", issue = \"none\")]\n    #[doc(hidden)]\n    unsafe fn extend_one_unchecked(&mut self, item: A)\n    where\n        Self: Sized,\n    {\n        self.extend_one(item);\n    }\n}\n\n#[stable(feature = \"extend_for_unit\", since = \"1.28.0\")]\nimpl Extend<()> for () {\n    fn extend<T: IntoIterator<Item = ()>>(&mut self, iter: T) {\n        iter.into_iter().for_each(drop)\n    }\n    fn extend_one(&mut self, _item: ()) {}\n}\n\n/// This trait is implemented for tuples up to twelve items long. The `impl`s for\n/// 1- and 3- through 12-ary tuples were stabilized after 2-tuples, in 1.85.0.\n#[doc(fake_variadic)] // the other implementations are below.\n#[stable(feature = \"extend_for_tuple\", since = \"1.56.0\")]\nimpl<T, ExtendT> Extend<(T,)> for (ExtendT,)\nwhere\n    ExtendT: Extend<T>,\n{\n    /// Allows to `extend` a tuple of collections that also implement `Extend`.\n    ///\n    /// See also: [`Iterator::unzip`]\n    ///\n    /// # Examples\n    /// ```\n    /// // Example given for a 2-tuple, but 1- through 12-tuples are supported\n    /// let mut tuple = (vec![0], vec![1]);\n    /// tuple.extend([(2, 3), (4, 5), (6, 7)]);\n    /// assert_eq!(tuple.0, [0, 2, 4, 6]);\n    /// assert_eq!(tuple.1, [1, 3, 5, 7]);\n    ///\n    /// // also allows for arbitrarily nested tuples as elements\n    /// let mut nested_tuple = (vec![1], (vec![2], vec![3]));\n    /// nested_tuple.extend([(4, (5, 6)), (7, (8, 9))]);\n    ///\n    /// let (a, (b, c)) = nested_tuple;\n    /// assert_eq!(a, [1, 4, 7]);\n    /// assert_eq!(b, [2, 5, 8]);\n    /// assert_eq!(c, [3, 6, 9]);\n    /// ```\n    fn extend<I: IntoIterator<Item = (T,)>>(&mut self, iter: I) {\n        self.0.extend(iter.into_iter().map(|t| t.0));\n    }\n\n    fn extend_one(&mut self, item: (T,)) {\n        self.0.extend_one(item.0)\n    }\n\n    fn extend_reserve(&mut self, additional: usize) {\n        self.0.extend_reserve(additional)\n    }\n\n    unsafe fn extend_one_unchecked(&mut self, item: (T,)) {\n        // SAFETY: the caller guarantees all preconditions.\n        unsafe { self.0.extend_one_unchecked(item.0) }\n    }\n}\n\n/// This implementation turns an iterator of tuples into a tuple of types which implement\n/// [`Default`] and [`Extend`].\n///\n/// This is similar to [`Iterator::unzip`], but is also composable with other [`FromIterator`]\n/// implementations:\n///\n/// ```rust\n/// # fn main() -> Result<(), core::num::ParseIntError> {\n/// let string = \"1,2,123,4\";\n///\n/// // Example given for a 2-tuple, but 1- through 12-tuples are supported\n/// let (numbers, lengths): (Vec<_>, Vec<_>) = string\n///     .split(',')\n///     .map(|s| s.parse().map(|n: u32| (n, s.len())))\n///     .collect::<Result<_, _>>()?;\n///\n/// assert_eq!(numbers, [1, 2, 123, 4]);\n/// assert_eq!(lengths, [1, 1, 3, 1]);\n/// # Ok(()) }\n/// ```\n#[doc(fake_variadic)] // the other implementations are below.\n#[stable(feature = \"from_iterator_for_tuple\", since = \"1.79.0\")]\nimpl<T, ExtendT> FromIterator<(T,)> for (ExtendT,)\nwhere\n    ExtendT: Default + Extend<T>,\n{\n    fn from_iter<Iter: IntoIterator<Item = (T,)>>(iter: Iter) -> Self {\n        let mut res = ExtendT::default();\n        res.extend(iter.into_iter().map(|t| t.0));\n        (res,)\n    }\n}\n\n/// An implementation of [`extend`](Extend::extend) that calls `extend_one` or\n/// `extend_one_unchecked` for each element of the iterator.\nfn default_extend<ExtendT, I, T>(collection: &mut ExtendT, iter: I)\nwhere\n    ExtendT: Extend<T>,\n    I: IntoIterator<Item = T>,\n{\n    // Specialize on `TrustedLen` and call `extend_one_unchecked` where\n    // applicable.\n    trait SpecExtend<I> {\n        fn extend(&mut self, iter: I);\n    }\n\n    // Extracting these to separate functions avoid monomorphising the closures\n    // for every iterator type.\n    fn extender<ExtendT, T>(collection: &mut ExtendT) -> impl FnMut(T) + use<'_, ExtendT, T>\n    where\n        ExtendT: Extend<T>,\n    {\n        move |item| collection.extend_one(item)\n    }\n\n    unsafe fn unchecked_extender<ExtendT, T>(\n        collection: &mut ExtendT,\n    ) -> impl FnMut(T) + use<'_, ExtendT, T>\n    where\n        ExtendT: Extend<T>,\n    {\n        // SAFETY: we make sure that there is enough space at the callsite of\n        // this function.\n        move |item| unsafe { collection.extend_one_unchecked(item) }\n    }\n\n    impl<ExtendT, I, T> SpecExtend<I> for ExtendT\n    where\n        ExtendT: Extend<T>,\n        I: Iterator<Item = T>,\n    {\n        default fn extend(&mut self, iter: I) {\n            let (lower_bound, _) = iter.size_hint();\n            if lower_bound > 0 {\n                self.extend_reserve(lower_bound);\n            }\n\n            iter.for_each(extender(self))\n        }\n    }\n\n    impl<ExtendT, I, T> SpecExtend<I> for ExtendT\n    where\n        ExtendT: Extend<T>,\n        I: TrustedLen<Item = T>,\n    {\n        fn extend(&mut self, iter: I) {\n            let (lower_bound, upper_bound) = iter.size_hint();\n            if lower_bound > 0 {\n                self.extend_reserve(lower_bound);\n            }\n\n            if upper_bound.is_none() {\n                // We cannot reserve more than `usize::MAX` items, and this is likely to go out of memory anyway.\n                iter.for_each(extender(self))\n            } else {\n                // SAFETY: We reserve enough space for the `size_hint`, and the iterator is\n                // `TrustedLen` so its `size_hint` is exact.\n                iter.for_each(unsafe { unchecked_extender(self) })\n            }\n        }\n    }\n\n    SpecExtend::extend(collection, iter.into_iter());\n}\n\n// Implements `Extend` and `FromIterator` for tuples with length larger than one.\nmacro_rules! impl_extend_tuple {\n    ($(($ty:tt, $extend_ty:tt, $index:tt)),+) => {\n        #[doc(hidden)]\n        #[stable(feature = \"extend_for_tuple\", since = \"1.56.0\")]\n        impl<$($ty,)+ $($extend_ty,)+> Extend<($($ty,)+)> for ($($extend_ty,)+)\n        where\n            $($extend_ty: Extend<$ty>,)+\n        {\n            fn extend<T: IntoIterator<Item = ($($ty,)+)>>(&mut self, iter: T) {\n                default_extend(self, iter)\n            }\n\n            fn extend_one(&mut self, item: ($($ty,)+)) {\n                $(self.$index.extend_one(item.$index);)+\n            }\n\n            fn extend_reserve(&mut self, additional: usize) {\n                $(self.$index.extend_reserve(additional);)+\n            }\n\n            unsafe fn extend_one_unchecked(&mut self, item: ($($ty,)+)) {\n                // SAFETY: Those are our safety preconditions, and we correctly forward `extend_reserve`.\n                unsafe {\n                    $(self.$index.extend_one_unchecked(item.$index);)+\n                }\n            }\n        }\n\n        #[doc(hidden)]\n        #[stable(feature = \"from_iterator_for_tuple\", since = \"1.79.0\")]\n        impl<$($ty,)+ $($extend_ty,)+> FromIterator<($($ty,)+)> for ($($extend_ty,)+)\n        where\n            $($extend_ty: Default + Extend<$ty>,)+\n        {\n            fn from_iter<Iter: IntoIterator<Item = ($($ty,)+)>>(iter: Iter) -> Self {\n                let mut res = Self::default();\n                res.extend(iter);\n                res\n            }\n        }\n    };\n}\n\nimpl_extend_tuple!((A, ExA, 0), (B, ExB, 1));\nimpl_extend_tuple!((A, ExA, 0), (B, ExB, 1), (C, ExC, 2));\nimpl_extend_tuple!((A, ExA, 0), (B, ExB, 1), (C, ExC, 2), (D, ExD, 3));\nimpl_extend_tuple!((A, ExA, 0), (B, ExB, 1), (C, ExC, 2), (D, ExD, 3), (E, ExE, 4));\nimpl_extend_tuple!((A, ExA, 0), (B, ExB, 1), (C, ExC, 2), (D, ExD, 3), (E, ExE, 4), (F, ExF, 5));\nimpl_extend_tuple!(\n    (A, ExA, 0),\n    (B, ExB, 1),\n    (C, ExC, 2),\n    (D, ExD, 3),\n    (E, ExE, 4),\n    (F, ExF, 5),\n    (G, ExG, 6)\n);\nimpl_extend_tuple!(\n    (A, ExA, 0),\n    (B, ExB, 1),\n    (C, ExC, 2),\n    (D, ExD, 3),\n    (E, ExE, 4),\n    (F, ExF, 5),\n    (G, ExG, 6),\n    (H, ExH, 7)\n);\nimpl_extend_tuple!(\n    (A, ExA, 0),\n    (B, ExB, 1),\n    (C, ExC, 2),\n    (D, ExD, 3),\n    (E, ExE, 4),\n    (F, ExF, 5),\n    (G, ExG, 6),\n    (H, ExH, 7),\n    (I, ExI, 8)\n);\nimpl_extend_tuple!(\n    (A, ExA, 0),\n    (B, ExB, 1),\n    (C, ExC, 2),\n    (D, ExD, 3),\n    (E, ExE, 4),\n    (F, ExF, 5),\n    (G, ExG, 6),\n    (H, ExH, 7),\n    (I, ExI, 8),\n    (J, ExJ, 9)\n);\nimpl_extend_tuple!(\n    (A, ExA, 0),\n    (B, ExB, 1),\n    (C, ExC, 2),\n    (D, ExD, 3),\n    (E, ExE, 4),\n    (F, ExF, 5),\n    (G, ExG, 6),\n    (H, ExH, 7),\n    (I, ExI, 8),\n    (J, ExJ, 9),\n    (K, ExK, 10)\n);\nimpl_extend_tuple!(\n    (A, ExA, 0),\n    (B, ExB, 1),\n    (C, ExC, 2),\n    (D, ExD, 3),\n    (E, ExE, 4),\n    (F, ExF, 5),\n    (G, ExG, 6),\n    (H, ExH, 7),\n    (I, ExI, 8),\n    (J, ExJ, 9),\n    (K, ExK, 10),\n    (L, ExL, 11)\n);\n";

},{}],"cQfst":[function(require,module,exports,__globalThis) {
module.exports = "//! Optional values.\n//!\n//! Type [`Option`] represents an optional value: every [`Option`]\n//! is either [`Some`] and contains a value, or [`None`], and\n//! does not. [`Option`] types are very common in Rust code, as\n//! they have a number of uses:\n//!\n//! * Initial values\n//! * Return values for functions that are not defined\n//!   over their entire input range (partial functions)\n//! * Return value for otherwise reporting simple errors, where [`None`] is\n//!   returned on error\n//! * Optional struct fields\n//! * Struct fields that can be loaned or \"taken\"\n//! * Optional function arguments\n//! * Nullable pointers\n//! * Swapping things out of difficult situations\n//!\n//! [`Option`]s are commonly paired with pattern matching to query the presence\n//! of a value and take action, always accounting for the [`None`] case.\n//!\n//! ```\n//! fn divide(numerator: f64, denominator: f64) -> Option<f64> {\n//!     if denominator == 0.0 {\n//!         None\n//!     } else {\n//!         Some(numerator / denominator)\n//!     }\n//! }\n//!\n//! // The return value of the function is an option\n//! let result = divide(2.0, 3.0);\n//!\n//! // Pattern match to retrieve the value\n//! match result {\n//!     // The division was valid\n//!     Some(x) => println!(\"Result: {x}\"),\n//!     // The division was invalid\n//!     None    => println!(\"Cannot divide by 0\"),\n//! }\n//! ```\n//!\n//\n// FIXME: Show how `Option` is used in practice, with lots of methods\n//\n//! # Options and pointers (\"nullable\" pointers)\n//!\n//! Rust's pointer types must always point to a valid location; there are\n//! no \"null\" references. Instead, Rust has *optional* pointers, like\n//! the optional owned box, <code>[Option]<[Box\\<T>]></code>.\n//!\n//! [Box\\<T>]: ../../std/boxed/struct.Box.html\n//!\n//! The following example uses [`Option`] to create an optional box of\n//! [`i32`]. Notice that in order to use the inner [`i32`] value, the\n//! `check_optional` function first needs to use pattern matching to\n//! determine whether the box has a value (i.e., it is [`Some(...)`][`Some`]) or\n//! not ([`None`]).\n//!\n//! ```\n//! let optional = None;\n//! check_optional(optional);\n//!\n//! let optional = Some(Box::new(9000));\n//! check_optional(optional);\n//!\n//! fn check_optional(optional: Option<Box<i32>>) {\n//!     match optional {\n//!         Some(p) => println!(\"has value {p}\"),\n//!         None => println!(\"has no value\"),\n//!     }\n//! }\n//! ```\n//!\n//! # The question mark operator, `?`\n//!\n//! Similar to the [`Result`] type, when writing code that calls many functions that return the\n//! [`Option`] type, handling `Some`/`None` can be tedious. The question mark\n//! operator, [`?`], hides some of the boilerplate of propagating values\n//! up the call stack.\n//!\n//! It replaces this:\n//!\n//! ```\n//! # #![allow(dead_code)]\n//! fn add_last_numbers(stack: &mut Vec<i32>) -> Option<i32> {\n//!     let a = stack.pop();\n//!     let b = stack.pop();\n//!\n//!     match (a, b) {\n//!         (Some(x), Some(y)) => Some(x + y),\n//!         _ => None,\n//!     }\n//! }\n//!\n//! ```\n//!\n//! With this:\n//!\n//! ```\n//! # #![allow(dead_code)]\n//! fn add_last_numbers(stack: &mut Vec<i32>) -> Option<i32> {\n//!     Some(stack.pop()? + stack.pop()?)\n//! }\n//! ```\n//!\n//! *It's much nicer!*\n//!\n//! Ending the expression with [`?`] will result in the [`Some`]'s unwrapped value, unless the\n//! result is [`None`], in which case [`None`] is returned early from the enclosing function.\n//!\n//! [`?`] can be used in functions that return [`Option`] because of the\n//! early return of [`None`] that it provides.\n//!\n//! [`?`]: crate::ops::Try\n//! [`Some`]: Some\n//! [`None`]: None\n//!\n//! # Representation\n//!\n//! Rust guarantees to optimize the following types `T` such that [`Option<T>`]\n//! has the same size, alignment, and [function call ABI] as `T`. It is\n//! therefore sound, when `T` is one of these types, to transmute a value `t` of\n//! type `T` to type `Option<T>` (producing the value `Some(t)`) and to\n//! transmute a value `Some(t)` of type `Option<T>` to type `T` (producing the\n//! value `t`).\n//!\n//! In some of these cases, Rust further guarantees the following:\n//! - `transmute::<_, Option<T>>([0u8; size_of::<T>()])` is sound and produces\n//!   `Option::<T>::None`\n//! - `transmute::<_, [u8; size_of::<T>()]>(Option::<T>::None)` is sound and produces\n//!   `[0u8; size_of::<T>()]`\n//!\n//! These cases are identified by the second column:\n//!\n//! | `T`                                                                 | Transmuting between `[0u8; size_of::<T>()]` and `Option::<T>::None` sound? |\n//! |---------------------------------------------------------------------|----------------------------------------------------------------------------|\n//! | [`Box<U>`] (specifically, only `Box<U, Global>`)                    | when `U: Sized`                                                            |\n//! | `&U`                                                                | when `U: Sized`                                                            |\n//! | `&mut U`                                                            | when `U: Sized`                                                            |\n//! | `fn`, `extern \"C\" fn`[^extern_fn]                                   | always                                                                     |\n//! | [`num::NonZero*`]                                                   | always                                                                     |\n//! | [`ptr::NonNull<U>`]                                                 | when `U: Sized`                                                            |\n//! | `#[repr(transparent)]` struct around one of the types in this list. | when it holds for the inner type                                           |\n//!\n//! [^extern_fn]: this remains true for `unsafe` variants, any argument/return types, and any other ABI: `[unsafe] extern \"abi\" fn` (_e.g._, `extern \"system\" fn`)\n//!\n//! Under some conditions the above types `T` are also null pointer optimized when wrapped in a [`Result`][result_repr].\n//!\n//! [`Box<U>`]: ../../std/boxed/struct.Box.html\n//! [`num::NonZero*`]: crate::num\n//! [`ptr::NonNull<U>`]: crate::ptr::NonNull\n//! [function call ABI]: ../primitive.fn.html#abi-compatibility\n//! [result_repr]: crate::result#representation\n//!\n//! This is called the \"null pointer optimization\" or NPO.\n//!\n//! It is further guaranteed that, for the cases above, one can\n//! [`mem::transmute`] from all valid values of `T` to `Option<T>` and\n//! from `Some::<T>(_)` to `T` (but transmuting `None::<T>` to `T`\n//! is undefined behavior).\n//!\n//! # Method overview\n//!\n//! In addition to working with pattern matching, [`Option`] provides a wide\n//! variety of different methods.\n//!\n//! ## Querying the variant\n//!\n//! The [`is_some`] and [`is_none`] methods return [`true`] if the [`Option`]\n//! is [`Some`] or [`None`], respectively.\n//!\n//! The [`is_some_and`] and [`is_none_or`] methods apply the provided function\n//! to the contents of the [`Option`] to produce a boolean value.\n//! If this is [`None`] then a default result is returned instead without executing the function.\n//!\n//! [`is_none`]: Option::is_none\n//! [`is_some`]: Option::is_some\n//! [`is_some_and`]: Option::is_some_and\n//! [`is_none_or`]: Option::is_none_or\n//!\n//! ## Adapters for working with references\n//!\n//! * [`as_ref`] converts from <code>[&][][Option]\\<T></code> to <code>[Option]<[&]T></code>\n//! * [`as_mut`] converts from <code>[&mut] [Option]\\<T></code> to <code>[Option]<[&mut] T></code>\n//! * [`as_deref`] converts from <code>[&][][Option]\\<T></code> to\n//!   <code>[Option]<[&]T::[Target]></code>\n//! * [`as_deref_mut`] converts from <code>[&mut] [Option]\\<T></code> to\n//!   <code>[Option]<[&mut] T::[Target]></code>\n//! * [`as_pin_ref`] converts from <code>[Pin]<[&][][Option]\\<T>></code> to\n//!   <code>[Option]<[Pin]<[&]T>></code>\n//! * [`as_pin_mut`] converts from <code>[Pin]<[&mut] [Option]\\<T>></code> to\n//!   <code>[Option]<[Pin]<[&mut] T>></code>\n//! * [`as_slice`] returns a one-element slice of the contained value, if any.\n//!   If this is [`None`], an empty slice is returned.\n//! * [`as_mut_slice`] returns a mutable one-element slice of the contained value, if any.\n//!   If this is [`None`], an empty slice is returned.\n//!\n//! [&]: reference \"shared reference\"\n//! [&mut]: reference \"mutable reference\"\n//! [Target]: Deref::Target \"ops::Deref::Target\"\n//! [`as_deref`]: Option::as_deref\n//! [`as_deref_mut`]: Option::as_deref_mut\n//! [`as_mut`]: Option::as_mut\n//! [`as_pin_mut`]: Option::as_pin_mut\n//! [`as_pin_ref`]: Option::as_pin_ref\n//! [`as_ref`]: Option::as_ref\n//! [`as_slice`]: Option::as_slice\n//! [`as_mut_slice`]: Option::as_mut_slice\n//!\n//! ## Extracting the contained value\n//!\n//! These methods extract the contained value in an [`Option<T>`] when it\n//! is the [`Some`] variant. If the [`Option`] is [`None`]:\n//!\n//! * [`expect`] panics with a provided custom message\n//! * [`unwrap`] panics with a generic message\n//! * [`unwrap_or`] returns the provided default value\n//! * [`unwrap_or_default`] returns the default value of the type `T`\n//!   (which must implement the [`Default`] trait)\n//! * [`unwrap_or_else`] returns the result of evaluating the provided\n//!   function\n//! * [`unwrap_unchecked`] produces *[undefined behavior]*\n//!\n//! [`expect`]: Option::expect\n//! [`unwrap`]: Option::unwrap\n//! [`unwrap_or`]: Option::unwrap_or\n//! [`unwrap_or_default`]: Option::unwrap_or_default\n//! [`unwrap_or_else`]: Option::unwrap_or_else\n//! [`unwrap_unchecked`]: Option::unwrap_unchecked\n//! [undefined behavior]: https://doc.rust-lang.org/reference/behavior-considered-undefined.html\n//!\n//! ## Transforming contained values\n//!\n//! These methods transform [`Option`] to [`Result`]:\n//!\n//! * [`ok_or`] transforms [`Some(v)`] to [`Ok(v)`], and [`None`] to\n//!   [`Err(err)`] using the provided default `err` value\n//! * [`ok_or_else`] transforms [`Some(v)`] to [`Ok(v)`], and [`None`] to\n//!   a value of [`Err`] using the provided function\n//! * [`transpose`] transposes an [`Option`] of a [`Result`] into a\n//!   [`Result`] of an [`Option`]\n//!\n//! [`Err(err)`]: Err\n//! [`Ok(v)`]: Ok\n//! [`Some(v)`]: Some\n//! [`ok_or`]: Option::ok_or\n//! [`ok_or_else`]: Option::ok_or_else\n//! [`transpose`]: Option::transpose\n//!\n//! These methods transform the [`Some`] variant:\n//!\n//! * [`filter`] calls the provided predicate function on the contained\n//!   value `t` if the [`Option`] is [`Some(t)`], and returns [`Some(t)`]\n//!   if the function returns `true`; otherwise, returns [`None`]\n//! * [`flatten`] removes one level of nesting from an [`Option<Option<T>>`]\n//! * [`inspect`] method takes ownership of the [`Option`] and applies\n//!   the provided function to the contained value by reference if [`Some`]\n//! * [`map`] transforms [`Option<T>`] to [`Option<U>`] by applying the\n//!   provided function to the contained value of [`Some`] and leaving\n//!   [`None`] values unchanged\n//!\n//! [`Some(t)`]: Some\n//! [`filter`]: Option::filter\n//! [`flatten`]: Option::flatten\n//! [`inspect`]: Option::inspect\n//! [`map`]: Option::map\n//!\n//! These methods transform [`Option<T>`] to a value of a possibly\n//! different type `U`:\n//!\n//! * [`map_or`] applies the provided function to the contained value of\n//!   [`Some`], or returns the provided default value if the [`Option`] is\n//!   [`None`]\n//! * [`map_or_else`] applies the provided function to the contained value\n//!   of [`Some`], or returns the result of evaluating the provided\n//!   fallback function if the [`Option`] is [`None`]\n//!\n//! [`map_or`]: Option::map_or\n//! [`map_or_else`]: Option::map_or_else\n//!\n//! These methods combine the [`Some`] variants of two [`Option`] values:\n//!\n//! * [`zip`] returns [`Some((s, o))`] if `self` is [`Some(s)`] and the\n//!   provided [`Option`] value is [`Some(o)`]; otherwise, returns [`None`]\n//! * [`zip_with`] calls the provided function `f` and returns\n//!   [`Some(f(s, o))`] if `self` is [`Some(s)`] and the provided\n//!   [`Option`] value is [`Some(o)`]; otherwise, returns [`None`]\n//!\n//! [`Some(f(s, o))`]: Some\n//! [`Some(o)`]: Some\n//! [`Some(s)`]: Some\n//! [`Some((s, o))`]: Some\n//! [`zip`]: Option::zip\n//! [`zip_with`]: Option::zip_with\n//!\n//! ## Boolean operators\n//!\n//! These methods treat the [`Option`] as a boolean value, where [`Some`]\n//! acts like [`true`] and [`None`] acts like [`false`]. There are two\n//! categories of these methods: ones that take an [`Option`] as input, and\n//! ones that take a function as input (to be lazily evaluated).\n//!\n//! The [`and`], [`or`], and [`xor`] methods take another [`Option`] as\n//! input, and produce an [`Option`] as output. Only the [`and`] method can\n//! produce an [`Option<U>`] value having a different inner type `U` than\n//! [`Option<T>`].\n//!\n//! | method  | self      | input     | output    |\n//! |---------|-----------|-----------|-----------|\n//! | [`and`] | `None`    | (ignored) | `None`    |\n//! | [`and`] | `Some(x)` | `None`    | `None`    |\n//! | [`and`] | `Some(x)` | `Some(y)` | `Some(y)` |\n//! | [`or`]  | `None`    | `None`    | `None`    |\n//! | [`or`]  | `None`    | `Some(y)` | `Some(y)` |\n//! | [`or`]  | `Some(x)` | (ignored) | `Some(x)` |\n//! | [`xor`] | `None`    | `None`    | `None`    |\n//! | [`xor`] | `None`    | `Some(y)` | `Some(y)` |\n//! | [`xor`] | `Some(x)` | `None`    | `Some(x)` |\n//! | [`xor`] | `Some(x)` | `Some(y)` | `None`    |\n//!\n//! [`and`]: Option::and\n//! [`or`]: Option::or\n//! [`xor`]: Option::xor\n//!\n//! The [`and_then`] and [`or_else`] methods take a function as input, and\n//! only evaluate the function when they need to produce a new value. Only\n//! the [`and_then`] method can produce an [`Option<U>`] value having a\n//! different inner type `U` than [`Option<T>`].\n//!\n//! | method       | self      | function input | function result | output    |\n//! |--------------|-----------|----------------|-----------------|-----------|\n//! | [`and_then`] | `None`    | (not provided) | (not evaluated) | `None`    |\n//! | [`and_then`] | `Some(x)` | `x`            | `None`          | `None`    |\n//! | [`and_then`] | `Some(x)` | `x`            | `Some(y)`       | `Some(y)` |\n//! | [`or_else`]  | `None`    | (not provided) | `None`          | `None`    |\n//! | [`or_else`]  | `None`    | (not provided) | `Some(y)`       | `Some(y)` |\n//! | [`or_else`]  | `Some(x)` | (not provided) | (not evaluated) | `Some(x)` |\n//!\n//! [`and_then`]: Option::and_then\n//! [`or_else`]: Option::or_else\n//!\n//! This is an example of using methods like [`and_then`] and [`or`] in a\n//! pipeline of method calls. Early stages of the pipeline pass failure\n//! values ([`None`]) through unchanged, and continue processing on\n//! success values ([`Some`]). Toward the end, [`or`] substitutes an error\n//! message if it receives [`None`].\n//!\n//! ```\n//! # use std::collections::BTreeMap;\n//! let mut bt = BTreeMap::new();\n//! bt.insert(20u8, \"foo\");\n//! bt.insert(42u8, \"bar\");\n//! let res = [0u8, 1, 11, 200, 22]\n//!     .into_iter()\n//!     .map(|x| {\n//!         // `checked_sub()` returns `None` on error\n//!         x.checked_sub(1)\n//!             // same with `checked_mul()`\n//!             .and_then(|x| x.checked_mul(2))\n//!             // `BTreeMap::get` returns `None` on error\n//!             .and_then(|x| bt.get(&x))\n//!             // Substitute an error message if we have `None` so far\n//!             .or(Some(&\"error!\"))\n//!             .copied()\n//!             // Won't panic because we unconditionally used `Some` above\n//!             .unwrap()\n//!     })\n//!     .collect::<Vec<_>>();\n//! assert_eq!(res, [\"error!\", \"error!\", \"foo\", \"error!\", \"bar\"]);\n//! ```\n//!\n//! ## Comparison operators\n//!\n//! If `T` implements [`PartialOrd`] then [`Option<T>`] will derive its\n//! [`PartialOrd`] implementation.  With this order, [`None`] compares as\n//! less than any [`Some`], and two [`Some`] compare the same way as their\n//! contained values would in `T`.  If `T` also implements\n//! [`Ord`], then so does [`Option<T>`].\n//!\n//! ```\n//! assert!(None < Some(0));\n//! assert!(Some(0) < Some(1));\n//! ```\n//!\n//! ## Iterating over `Option`\n//!\n//! An [`Option`] can be iterated over. This can be helpful if you need an\n//! iterator that is conditionally empty. The iterator will either produce\n//! a single value (when the [`Option`] is [`Some`]), or produce no values\n//! (when the [`Option`] is [`None`]). For example, [`into_iter`] acts like\n//! [`once(v)`] if the [`Option`] is [`Some(v)`], and like [`empty()`] if\n//! the [`Option`] is [`None`].\n//!\n//! [`Some(v)`]: Some\n//! [`empty()`]: crate::iter::empty\n//! [`once(v)`]: crate::iter::once\n//!\n//! Iterators over [`Option<T>`] come in three types:\n//!\n//! * [`into_iter`] consumes the [`Option`] and produces the contained\n//!   value\n//! * [`iter`] produces an immutable reference of type `&T` to the\n//!   contained value\n//! * [`iter_mut`] produces a mutable reference of type `&mut T` to the\n//!   contained value\n//!\n//! [`into_iter`]: Option::into_iter\n//! [`iter`]: Option::iter\n//! [`iter_mut`]: Option::iter_mut\n//!\n//! An iterator over [`Option`] can be useful when chaining iterators, for\n//! example, to conditionally insert items. (It's not always necessary to\n//! explicitly call an iterator constructor: many [`Iterator`] methods that\n//! accept other iterators will also accept iterable types that implement\n//! [`IntoIterator`], which includes [`Option`].)\n//!\n//! ```\n//! let yep = Some(42);\n//! let nope = None;\n//! // chain() already calls into_iter(), so we don't have to do so\n//! let nums: Vec<i32> = (0..4).chain(yep).chain(4..8).collect();\n//! assert_eq!(nums, [0, 1, 2, 3, 42, 4, 5, 6, 7]);\n//! let nums: Vec<i32> = (0..4).chain(nope).chain(4..8).collect();\n//! assert_eq!(nums, [0, 1, 2, 3, 4, 5, 6, 7]);\n//! ```\n//!\n//! One reason to chain iterators in this way is that a function returning\n//! `impl Iterator` must have all possible return values be of the same\n//! concrete type. Chaining an iterated [`Option`] can help with that.\n//!\n//! ```\n//! fn make_iter(do_insert: bool) -> impl Iterator<Item = i32> {\n//!     // Explicit returns to illustrate return types matching\n//!     match do_insert {\n//!         true => return (0..4).chain(Some(42)).chain(4..8),\n//!         false => return (0..4).chain(None).chain(4..8),\n//!     }\n//! }\n//! println!(\"{:?}\", make_iter(true).collect::<Vec<_>>());\n//! println!(\"{:?}\", make_iter(false).collect::<Vec<_>>());\n//! ```\n//!\n//! If we try to do the same thing, but using [`once()`] and [`empty()`],\n//! we can't return `impl Iterator` anymore because the concrete types of\n//! the return values differ.\n//!\n//! [`empty()`]: crate::iter::empty\n//! [`once()`]: crate::iter::once\n//!\n//! ```compile_fail,E0308\n//! # use std::iter::{empty, once};\n//! // This won't compile because all possible returns from the function\n//! // must have the same concrete type.\n//! fn make_iter(do_insert: bool) -> impl Iterator<Item = i32> {\n//!     // Explicit returns to illustrate return types not matching\n//!     match do_insert {\n//!         true => return (0..4).chain(once(42)).chain(4..8),\n//!         false => return (0..4).chain(empty()).chain(4..8),\n//!     }\n//! }\n//! ```\n//!\n//! ## Collecting into `Option`\n//!\n//! [`Option`] implements the [`FromIterator`][impl-FromIterator] trait,\n//! which allows an iterator over [`Option`] values to be collected into an\n//! [`Option`] of a collection of each contained value of the original\n//! [`Option`] values, or [`None`] if any of the elements was [`None`].\n//!\n//! [impl-FromIterator]: Option#impl-FromIterator%3COption%3CA%3E%3E-for-Option%3CV%3E\n//!\n//! ```\n//! let v = [Some(2), Some(4), None, Some(8)];\n//! let res: Option<Vec<_>> = v.into_iter().collect();\n//! assert_eq!(res, None);\n//! let v = [Some(2), Some(4), Some(8)];\n//! let res: Option<Vec<_>> = v.into_iter().collect();\n//! assert_eq!(res, Some(vec![2, 4, 8]));\n//! ```\n//!\n//! [`Option`] also implements the [`Product`][impl-Product] and\n//! [`Sum`][impl-Sum] traits, allowing an iterator over [`Option`] values\n//! to provide the [`product`][Iterator::product] and\n//! [`sum`][Iterator::sum] methods.\n//!\n//! [impl-Product]: Option#impl-Product%3COption%3CU%3E%3E-for-Option%3CT%3E\n//! [impl-Sum]: Option#impl-Sum%3COption%3CU%3E%3E-for-Option%3CT%3E\n//!\n//! ```\n//! let v = [None, Some(1), Some(2), Some(3)];\n//! let res: Option<i32> = v.into_iter().sum();\n//! assert_eq!(res, None);\n//! let v = [Some(1), Some(2), Some(21)];\n//! let res: Option<i32> = v.into_iter().product();\n//! assert_eq!(res, Some(42));\n//! ```\n//!\n//! ## Modifying an [`Option`] in-place\n//!\n//! These methods return a mutable reference to the contained value of an\n//! [`Option<T>`]:\n//!\n//! * [`insert`] inserts a value, dropping any old contents\n//! * [`get_or_insert`] gets the current value, inserting a provided\n//!   default value if it is [`None`]\n//! * [`get_or_insert_default`] gets the current value, inserting the\n//!   default value of type `T` (which must implement [`Default`]) if it is\n//!   [`None`]\n//! * [`get_or_insert_with`] gets the current value, inserting a default\n//!   computed by the provided function if it is [`None`]\n//!\n//! [`get_or_insert`]: Option::get_or_insert\n//! [`get_or_insert_default`]: Option::get_or_insert_default\n//! [`get_or_insert_with`]: Option::get_or_insert_with\n//! [`insert`]: Option::insert\n//!\n//! These methods transfer ownership of the contained value of an\n//! [`Option`]:\n//!\n//! * [`take`] takes ownership of the contained value of an [`Option`], if\n//!   any, replacing the [`Option`] with [`None`]\n//! * [`replace`] takes ownership of the contained value of an [`Option`],\n//!   if any, replacing the [`Option`] with a [`Some`] containing the\n//!   provided value\n//!\n//! [`replace`]: Option::replace\n//! [`take`]: Option::take\n//!\n//! # Examples\n//!\n//! Basic pattern matching on [`Option`]:\n//!\n//! ```\n//! let msg = Some(\"howdy\");\n//!\n//! // Take a reference to the contained string\n//! if let Some(m) = &msg {\n//!     println!(\"{}\", *m);\n//! }\n//!\n//! // Remove the contained string, destroying the Option\n//! let unwrapped_msg = msg.unwrap_or(\"default message\");\n//! ```\n//!\n//! Initialize a result to [`None`] before a loop:\n//!\n//! ```\n//! enum Kingdom { Plant(u32, &'static str), Animal(u32, &'static str) }\n//!\n//! // A list of data to search through.\n//! let all_the_big_things = [\n//!     Kingdom::Plant(250, \"redwood\"),\n//!     Kingdom::Plant(230, \"noble fir\"),\n//!     Kingdom::Plant(229, \"sugar pine\"),\n//!     Kingdom::Animal(25, \"blue whale\"),\n//!     Kingdom::Animal(19, \"fin whale\"),\n//!     Kingdom::Animal(15, \"north pacific right whale\"),\n//! ];\n//!\n//! // We're going to search for the name of the biggest animal,\n//! // but to start with we've just got `None`.\n//! let mut name_of_biggest_animal = None;\n//! let mut size_of_biggest_animal = 0;\n//! for big_thing in &all_the_big_things {\n//!     match *big_thing {\n//!         Kingdom::Animal(size, name) if size > size_of_biggest_animal => {\n//!             // Now we've found the name of some big animal\n//!             size_of_biggest_animal = size;\n//!             name_of_biggest_animal = Some(name);\n//!         }\n//!         Kingdom::Animal(..) | Kingdom::Plant(..) => ()\n//!     }\n//! }\n//!\n//! match name_of_biggest_animal {\n//!     Some(name) => println!(\"the biggest animal is {name}\"),\n//!     None => println!(\"there are no animals :(\"),\n//! }\n//! ```\n\n#![stable(feature = \"rust1\", since = \"1.0.0\")]\n\nuse crate::clone::TrivialClone;\nuse crate::iter::{self, FusedIterator, TrustedLen};\nuse crate::marker::Destruct;\nuse crate::ops::{self, ControlFlow, Deref, DerefMut};\nuse crate::panicking::{panic, panic_display};\nuse crate::pin::Pin;\nuse crate::{cmp, convert, hint, mem, slice};\n\n/// The `Option` type. See [the module level documentation](self) for more.\n#[doc(search_unbox)]\n#[derive(Copy, Debug, Hash)]\n#[derive_const(Eq)]\n#[rustc_diagnostic_item = \"Option\"]\n#[lang = \"Option\"]\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\n#[allow(clippy::derived_hash_with_manual_eq)] // PartialEq is manually implemented equivalently\npub enum Option<T> {\n    /// No value.\n    #[lang = \"None\"]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    None,\n    /// Some value of type `T`.\n    #[lang = \"Some\"]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    Some(#[stable(feature = \"rust1\", since = \"1.0.0\")] T),\n}\n\n/////////////////////////////////////////////////////////////////////////////\n// Type implementation\n/////////////////////////////////////////////////////////////////////////////\n\nimpl<T> Option<T> {\n    /////////////////////////////////////////////////////////////////////////\n    // Querying the contained values\n    /////////////////////////////////////////////////////////////////////////\n\n    /// Returns `true` if the option is a [`Some`] value.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x: Option<u32> = Some(2);\n    /// assert_eq!(x.is_some(), true);\n    ///\n    /// let x: Option<u32> = None;\n    /// assert_eq!(x.is_some(), false);\n    /// ```\n    #[must_use = \"if you intended to assert that this has a value, consider `.unwrap()` instead\"]\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_const_stable(feature = \"const_option_basics\", since = \"1.48.0\")]\n    pub const fn is_some(&self) -> bool {\n        matches!(*self, Some(_))\n    }\n\n    /// Returns `true` if the option is a [`Some`] and the value inside of it matches a predicate.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x: Option<u32> = Some(2);\n    /// assert_eq!(x.is_some_and(|x| x > 1), true);\n    ///\n    /// let x: Option<u32> = Some(0);\n    /// assert_eq!(x.is_some_and(|x| x > 1), false);\n    ///\n    /// let x: Option<u32> = None;\n    /// assert_eq!(x.is_some_and(|x| x > 1), false);\n    ///\n    /// let x: Option<String> = Some(\"ownership\".to_string());\n    /// assert_eq!(x.as_ref().is_some_and(|x| x.len() > 1), true);\n    /// println!(\"still alive {:?}\", x);\n    /// ```\n    #[must_use]\n    #[inline]\n    #[stable(feature = \"is_some_and\", since = \"1.70.0\")]\n    #[rustc_const_unstable(feature = \"const_option_ops\", issue = \"143956\")]\n    pub const fn is_some_and(self, f: impl [const] FnOnce(T) -> bool + [const] Destruct) -> bool {\n        match self {\n            None => false,\n            Some(x) => f(x),\n        }\n    }\n\n    /// Returns `true` if the option is a [`None`] value.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x: Option<u32> = Some(2);\n    /// assert_eq!(x.is_none(), false);\n    ///\n    /// let x: Option<u32> = None;\n    /// assert_eq!(x.is_none(), true);\n    /// ```\n    #[must_use = \"if you intended to assert that this doesn't have a value, consider \\\n                  wrapping this in an `assert!()` instead\"]\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_const_stable(feature = \"const_option_basics\", since = \"1.48.0\")]\n    pub const fn is_none(&self) -> bool {\n        !self.is_some()\n    }\n\n    /// Returns `true` if the option is a [`None`] or the value inside of it matches a predicate.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x: Option<u32> = Some(2);\n    /// assert_eq!(x.is_none_or(|x| x > 1), true);\n    ///\n    /// let x: Option<u32> = Some(0);\n    /// assert_eq!(x.is_none_or(|x| x > 1), false);\n    ///\n    /// let x: Option<u32> = None;\n    /// assert_eq!(x.is_none_or(|x| x > 1), true);\n    ///\n    /// let x: Option<String> = Some(\"ownership\".to_string());\n    /// assert_eq!(x.as_ref().is_none_or(|x| x.len() > 1), true);\n    /// println!(\"still alive {:?}\", x);\n    /// ```\n    #[must_use]\n    #[inline]\n    #[stable(feature = \"is_none_or\", since = \"1.82.0\")]\n    #[rustc_const_unstable(feature = \"const_option_ops\", issue = \"143956\")]\n    pub const fn is_none_or(self, f: impl [const] FnOnce(T) -> bool + [const] Destruct) -> bool {\n        match self {\n            None => true,\n            Some(x) => f(x),\n        }\n    }\n\n    /////////////////////////////////////////////////////////////////////////\n    // Adapter for working with references\n    /////////////////////////////////////////////////////////////////////////\n\n    /// Converts from `&Option<T>` to `Option<&T>`.\n    ///\n    /// # Examples\n    ///\n    /// Calculates the length of an <code>Option<[String]></code> as an <code>Option<[usize]></code>\n    /// without moving the [`String`]. The [`map`] method takes the `self` argument by value,\n    /// consuming the original, so this technique uses `as_ref` to first take an `Option` to a\n    /// reference to the value inside the original.\n    ///\n    /// [`map`]: Option::map\n    /// [String]: ../../std/string/struct.String.html \"String\"\n    /// [`String`]: ../../std/string/struct.String.html \"String\"\n    ///\n    /// ```\n    /// let text: Option<String> = Some(\"Hello, world!\".to_string());\n    /// // First, cast `Option<String>` to `Option<&String>` with `as_ref`,\n    /// // then consume *that* with `map`, leaving `text` on the stack.\n    /// let text_length: Option<usize> = text.as_ref().map(|s| s.len());\n    /// println!(\"still can print text: {text:?}\");\n    /// ```\n    #[inline]\n    #[rustc_const_stable(feature = \"const_option_basics\", since = \"1.48.0\")]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    pub const fn as_ref(&self) -> Option<&T> {\n        match *self {\n            Some(ref x) => Some(x),\n            None => None,\n        }\n    }\n\n    /// Converts from `&mut Option<T>` to `Option<&mut T>`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut x = Some(2);\n    /// match x.as_mut() {\n    ///     Some(v) => *v = 42,\n    ///     None => {},\n    /// }\n    /// assert_eq!(x, Some(42));\n    /// ```\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_const_stable(feature = \"const_option\", since = \"1.83.0\")]\n    pub const fn as_mut(&mut self) -> Option<&mut T> {\n        match *self {\n            Some(ref mut x) => Some(x),\n            None => None,\n        }\n    }\n\n    /// Converts from <code>[Pin]<[&]Option\\<T>></code> to <code>Option<[Pin]<[&]T>></code>.\n    ///\n    /// [&]: reference \"shared reference\"\n    #[inline]\n    #[must_use]\n    #[stable(feature = \"pin\", since = \"1.33.0\")]\n    #[rustc_const_stable(feature = \"const_option_ext\", since = \"1.84.0\")]\n    pub const fn as_pin_ref(self: Pin<&Self>) -> Option<Pin<&T>> {\n        // FIXME(const-hack): use `map` once that is possible\n        match Pin::get_ref(self).as_ref() {\n            // SAFETY: `x` is guaranteed to be pinned because it comes from `self`\n            // which is pinned.\n            Some(x) => unsafe { Some(Pin::new_unchecked(x)) },\n            None => None,\n        }\n    }\n\n    /// Converts from <code>[Pin]<[&mut] Option\\<T>></code> to <code>Option<[Pin]<[&mut] T>></code>.\n    ///\n    /// [&mut]: reference \"mutable reference\"\n    #[inline]\n    #[must_use]\n    #[stable(feature = \"pin\", since = \"1.33.0\")]\n    #[rustc_const_stable(feature = \"const_option_ext\", since = \"1.84.0\")]\n    pub const fn as_pin_mut(self: Pin<&mut Self>) -> Option<Pin<&mut T>> {\n        // SAFETY: `get_unchecked_mut` is never used to move the `Option` inside `self`.\n        // `x` is guaranteed to be pinned because it comes from `self` which is pinned.\n        unsafe {\n            // FIXME(const-hack): use `map` once that is possible\n            match Pin::get_unchecked_mut(self).as_mut() {\n                Some(x) => Some(Pin::new_unchecked(x)),\n                None => None,\n            }\n        }\n    }\n\n    #[inline]\n    const fn len(&self) -> usize {\n        // Using the intrinsic avoids emitting a branch to get the 0 or 1.\n        let discriminant: isize = crate::intrinsics::discriminant_value(self);\n        discriminant as usize\n    }\n\n    /// Returns a slice of the contained value, if any. If this is `None`, an\n    /// empty slice is returned. This can be useful to have a single type of\n    /// iterator over an `Option` or slice.\n    ///\n    /// Note: Should you have an `Option<&T>` and wish to get a slice of `T`,\n    /// you can unpack it via `opt.map_or(&[], std::slice::from_ref)`.\n    ///\n    /// # Examples\n    ///\n    /// ```rust\n    /// assert_eq!(\n    ///     [Some(1234).as_slice(), None.as_slice()],\n    ///     [&[1234][..], &[][..]],\n    /// );\n    /// ```\n    ///\n    /// The inverse of this function is (discounting\n    /// borrowing) [`[_]::first`](slice::first):\n    ///\n    /// ```rust\n    /// for i in [Some(1234_u16), None] {\n    ///     assert_eq!(i.as_ref(), i.as_slice().first());\n    /// }\n    /// ```\n    #[inline]\n    #[must_use]\n    #[stable(feature = \"option_as_slice\", since = \"1.75.0\")]\n    #[rustc_const_stable(feature = \"const_option_ext\", since = \"1.84.0\")]\n    pub const fn as_slice(&self) -> &[T] {\n        // SAFETY: When the `Option` is `Some`, we're using the actual pointer\n        // to the payload, with a length of 1, so this is equivalent to\n        // `slice::from_ref`, and thus is safe.\n        // When the `Option` is `None`, the length used is 0, so to be safe it\n        // just needs to be aligned, which it is because `&self` is aligned and\n        // the offset used is a multiple of alignment.\n        //\n        // Here we assume that `offset_of!` always returns an offset to an\n        // in-bounds and correctly aligned position for a `T` (even if in the\n        // `None` case it's just padding).\n        unsafe {\n            slice::from_raw_parts(\n                (self as *const Self).byte_add(core::mem::offset_of!(Self, Some.0)).cast(),\n                self.len(),\n            )\n        }\n    }\n\n    /// Returns a mutable slice of the contained value, if any. If this is\n    /// `None`, an empty slice is returned. This can be useful to have a\n    /// single type of iterator over an `Option` or slice.\n    ///\n    /// Note: Should you have an `Option<&mut T>` instead of a\n    /// `&mut Option<T>`, which this method takes, you can obtain a mutable\n    /// slice via `opt.map_or(&mut [], std::slice::from_mut)`.\n    ///\n    /// # Examples\n    ///\n    /// ```rust\n    /// assert_eq!(\n    ///     [Some(1234).as_mut_slice(), None.as_mut_slice()],\n    ///     [&mut [1234][..], &mut [][..]],\n    /// );\n    /// ```\n    ///\n    /// The result is a mutable slice of zero or one items that points into\n    /// our original `Option`:\n    ///\n    /// ```rust\n    /// let mut x = Some(1234);\n    /// x.as_mut_slice()[0] += 1;\n    /// assert_eq!(x, Some(1235));\n    /// ```\n    ///\n    /// The inverse of this method (discounting borrowing)\n    /// is [`[_]::first_mut`](slice::first_mut):\n    ///\n    /// ```rust\n    /// assert_eq!(Some(123).as_mut_slice().first_mut(), Some(&mut 123))\n    /// ```\n    #[inline]\n    #[must_use]\n    #[stable(feature = \"option_as_slice\", since = \"1.75.0\")]\n    #[rustc_const_stable(feature = \"const_option_ext\", since = \"1.84.0\")]\n    pub const fn as_mut_slice(&mut self) -> &mut [T] {\n        // SAFETY: When the `Option` is `Some`, we're using the actual pointer\n        // to the payload, with a length of 1, so this is equivalent to\n        // `slice::from_mut`, and thus is safe.\n        // When the `Option` is `None`, the length used is 0, so to be safe it\n        // just needs to be aligned, which it is because `&self` is aligned and\n        // the offset used is a multiple of alignment.\n        //\n        // In the new version, the intrinsic creates a `*const T` from a\n        // mutable reference  so it is safe to cast back to a mutable pointer\n        // here. As with `as_slice`, the intrinsic always returns a pointer to\n        // an in-bounds and correctly aligned position for a `T` (even if in\n        // the `None` case it's just padding).\n        unsafe {\n            slice::from_raw_parts_mut(\n                (self as *mut Self).byte_add(core::mem::offset_of!(Self, Some.0)).cast(),\n                self.len(),\n            )\n        }\n    }\n\n    /////////////////////////////////////////////////////////////////////////\n    // Getting to contained values\n    /////////////////////////////////////////////////////////////////////////\n\n    /// Returns the contained [`Some`] value, consuming the `self` value.\n    ///\n    /// # Panics\n    ///\n    /// Panics if the value is a [`None`] with a custom panic message provided by\n    /// `msg`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x = Some(\"value\");\n    /// assert_eq!(x.expect(\"fruits are healthy\"), \"value\");\n    /// ```\n    ///\n    /// ```should_panic\n    /// let x: Option<&str> = None;\n    /// x.expect(\"fruits are healthy\"); // panics with `fruits are healthy`\n    /// ```\n    ///\n    /// # Recommended Message Style\n    ///\n    /// We recommend that `expect` messages are used to describe the reason you\n    /// _expect_ the `Option` should be `Some`.\n    ///\n    /// ```should_panic\n    /// # let slice: &[u8] = &[];\n    /// let item = slice.get(0)\n    ///     .expect(\"slice should not be empty\");\n    /// ```\n    ///\n    /// **Hint**: If you're having trouble remembering how to phrase expect\n    /// error messages remember to focus on the word \"should\" as in \"env\n    /// variable should be set by blah\" or \"the given binary should be available\n    /// and executable by the current user\".\n    ///\n    /// For more detail on expect message styles and the reasoning behind our\n    /// recommendation please refer to the section on [\"Common Message\n    /// Styles\"](../../std/error/index.html#common-message-styles) in the [`std::error`](../../std/error/index.html) module docs.\n    #[inline]\n    #[track_caller]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_diagnostic_item = \"option_expect\"]\n    #[rustc_allow_const_fn_unstable(const_precise_live_drops)]\n    #[rustc_const_stable(feature = \"const_option\", since = \"1.83.0\")]\n    pub const fn expect(self, msg: &str) -> T {\n        match self {\n            Some(val) => val,\n            None => expect_failed(msg),\n        }\n    }\n\n    /// Returns the contained [`Some`] value, consuming the `self` value.\n    ///\n    /// Because this function may panic, its use is generally discouraged.\n    /// Panics are meant for unrecoverable errors, and\n    /// [may abort the entire program][panic-abort].\n    ///\n    /// Instead, prefer to use pattern matching and handle the [`None`]\n    /// case explicitly, or call [`unwrap_or`], [`unwrap_or_else`], or\n    /// [`unwrap_or_default`]. In functions returning `Option`, you can use\n    /// [the `?` (try) operator][try-option].\n    ///\n    /// [panic-abort]: https://doc.rust-lang.org/book/ch09-01-unrecoverable-errors-with-panic.html\n    /// [try-option]: https://doc.rust-lang.org/book/ch09-02-recoverable-errors-with-result.html#where-the--operator-can-be-used\n    /// [`unwrap_or`]: Option::unwrap_or\n    /// [`unwrap_or_else`]: Option::unwrap_or_else\n    /// [`unwrap_or_default`]: Option::unwrap_or_default\n    ///\n    /// # Panics\n    ///\n    /// Panics if the self value equals [`None`].\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x = Some(\"air\");\n    /// assert_eq!(x.unwrap(), \"air\");\n    /// ```\n    ///\n    /// ```should_panic\n    /// let x: Option<&str> = None;\n    /// assert_eq!(x.unwrap(), \"air\"); // fails\n    /// ```\n    #[inline(always)]\n    #[track_caller]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_diagnostic_item = \"option_unwrap\"]\n    #[rustc_allow_const_fn_unstable(const_precise_live_drops)]\n    #[rustc_const_stable(feature = \"const_option\", since = \"1.83.0\")]\n    pub const fn unwrap(self) -> T {\n        match self {\n            Some(val) => val,\n            None => unwrap_failed(),\n        }\n    }\n\n    /// Returns the contained [`Some`] value or a provided default.\n    ///\n    /// Arguments passed to `unwrap_or` are eagerly evaluated; if you are passing\n    /// the result of a function call, it is recommended to use [`unwrap_or_else`],\n    /// which is lazily evaluated.\n    ///\n    /// [`unwrap_or_else`]: Option::unwrap_or_else\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// assert_eq!(Some(\"car\").unwrap_or(\"bike\"), \"car\");\n    /// assert_eq!(None.unwrap_or(\"bike\"), \"bike\");\n    /// ```\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_allow_const_fn_unstable(const_precise_live_drops)]\n    #[rustc_const_unstable(feature = \"const_option_ops\", issue = \"143956\")]\n    pub const fn unwrap_or(self, default: T) -> T\n    where\n        T: [const] Destruct,\n    {\n        match self {\n            Some(x) => x,\n            None => default,\n        }\n    }\n\n    /// Returns the contained [`Some`] value or computes it from a closure.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let k = 10;\n    /// assert_eq!(Some(4).unwrap_or_else(|| 2 * k), 4);\n    /// assert_eq!(None.unwrap_or_else(|| 2 * k), 20);\n    /// ```\n    #[inline]\n    #[track_caller]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_const_unstable(feature = \"const_option_ops\", issue = \"143956\")]\n    pub const fn unwrap_or_else<F>(self, f: F) -> T\n    where\n        F: [const] FnOnce() -> T + [const] Destruct,\n    {\n        match self {\n            Some(x) => x,\n            None => f(),\n        }\n    }\n\n    /// Returns the contained [`Some`] value or a default.\n    ///\n    /// Consumes the `self` argument then, if [`Some`], returns the contained\n    /// value, otherwise if [`None`], returns the [default value] for that\n    /// type.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x: Option<u32> = None;\n    /// let y: Option<u32> = Some(12);\n    ///\n    /// assert_eq!(x.unwrap_or_default(), 0);\n    /// assert_eq!(y.unwrap_or_default(), 12);\n    /// ```\n    ///\n    /// [default value]: Default::default\n    /// [`parse`]: str::parse\n    /// [`FromStr`]: crate::str::FromStr\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_const_unstable(feature = \"const_option_ops\", issue = \"143956\")]\n    pub const fn unwrap_or_default(self) -> T\n    where\n        T: [const] Default,\n    {\n        match self {\n            Some(x) => x,\n            None => T::default(),\n        }\n    }\n\n    /// Returns the contained [`Some`] value, consuming the `self` value,\n    /// without checking that the value is not [`None`].\n    ///\n    /// # Safety\n    ///\n    /// Calling this method on [`None`] is *[undefined behavior]*.\n    ///\n    /// [undefined behavior]: https://doc.rust-lang.org/reference/behavior-considered-undefined.html\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x = Some(\"air\");\n    /// assert_eq!(unsafe { x.unwrap_unchecked() }, \"air\");\n    /// ```\n    ///\n    /// ```no_run\n    /// let x: Option<&str> = None;\n    /// assert_eq!(unsafe { x.unwrap_unchecked() }, \"air\"); // Undefined behavior!\n    /// ```\n    #[inline]\n    #[track_caller]\n    #[stable(feature = \"option_result_unwrap_unchecked\", since = \"1.58.0\")]\n    #[rustc_allow_const_fn_unstable(const_precise_live_drops)]\n    #[rustc_const_stable(feature = \"const_option\", since = \"1.83.0\")]\n    pub const unsafe fn unwrap_unchecked(self) -> T {\n        match self {\n            Some(val) => val,\n            // SAFETY: the safety contract must be upheld by the caller.\n            None => unsafe { hint::unreachable_unchecked() },\n        }\n    }\n\n    /////////////////////////////////////////////////////////////////////////\n    // Transforming contained values\n    /////////////////////////////////////////////////////////////////////////\n\n    /// Maps an `Option<T>` to `Option<U>` by applying a function to a contained value (if `Some`) or returns `None` (if `None`).\n    ///\n    /// # Examples\n    ///\n    /// Calculates the length of an <code>Option<[String]></code> as an\n    /// <code>Option<[usize]></code>, consuming the original:\n    ///\n    /// [String]: ../../std/string/struct.String.html \"String\"\n    /// ```\n    /// let maybe_some_string = Some(String::from(\"Hello, World!\"));\n    /// // `Option::map` takes self *by value*, consuming `maybe_some_string`\n    /// let maybe_some_len = maybe_some_string.map(|s| s.len());\n    /// assert_eq!(maybe_some_len, Some(13));\n    ///\n    /// let x: Option<&str> = None;\n    /// assert_eq!(x.map(|s| s.len()), None);\n    /// ```\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_const_unstable(feature = \"const_option_ops\", issue = \"143956\")]\n    pub const fn map<U, F>(self, f: F) -> Option<U>\n    where\n        F: [const] FnOnce(T) -> U + [const] Destruct,\n    {\n        match self {\n            Some(x) => Some(f(x)),\n            None => None,\n        }\n    }\n\n    /// Calls a function with a reference to the contained value if [`Some`].\n    ///\n    /// Returns the original option.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let list = vec![1, 2, 3];\n    ///\n    /// // prints \"got: 2\"\n    /// let x = list\n    ///     .get(1)\n    ///     .inspect(|x| println!(\"got: {x}\"))\n    ///     .expect(\"list should be long enough\");\n    ///\n    /// // prints nothing\n    /// list.get(5).inspect(|x| println!(\"got: {x}\"));\n    /// ```\n    #[inline]\n    #[stable(feature = \"result_option_inspect\", since = \"1.76.0\")]\n    #[rustc_const_unstable(feature = \"const_option_ops\", issue = \"143956\")]\n    pub const fn inspect<F>(self, f: F) -> Self\n    where\n        F: [const] FnOnce(&T) + [const] Destruct,\n    {\n        if let Some(ref x) = self {\n            f(x);\n        }\n\n        self\n    }\n\n    /// Returns the provided default result (if none),\n    /// or applies a function to the contained value (if any).\n    ///\n    /// Arguments passed to `map_or` are eagerly evaluated; if you are passing\n    /// the result of a function call, it is recommended to use [`map_or_else`],\n    /// which is lazily evaluated.\n    ///\n    /// [`map_or_else`]: Option::map_or_else\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x = Some(\"foo\");\n    /// assert_eq!(x.map_or(42, |v| v.len()), 3);\n    ///\n    /// let x: Option<&str> = None;\n    /// assert_eq!(x.map_or(42, |v| v.len()), 42);\n    /// ```\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[must_use = \"if you don't need the returned value, use `if let` instead\"]\n    #[rustc_const_unstable(feature = \"const_option_ops\", issue = \"143956\")]\n    pub const fn map_or<U, F>(self, default: U, f: F) -> U\n    where\n        F: [const] FnOnce(T) -> U + [const] Destruct,\n        U: [const] Destruct,\n    {\n        match self {\n            Some(t) => f(t),\n            None => default,\n        }\n    }\n\n    /// Computes a default function result (if none), or\n    /// applies a different function to the contained value (if any).\n    ///\n    /// # Basic examples\n    ///\n    /// ```\n    /// let k = 21;\n    ///\n    /// let x = Some(\"foo\");\n    /// assert_eq!(x.map_or_else(|| 2 * k, |v| v.len()), 3);\n    ///\n    /// let x: Option<&str> = None;\n    /// assert_eq!(x.map_or_else(|| 2 * k, |v| v.len()), 42);\n    /// ```\n    ///\n    /// # Handling a Result-based fallback\n    ///\n    /// A somewhat common occurrence when dealing with optional values\n    /// in combination with [`Result<T, E>`] is the case where one wants to invoke\n    /// a fallible fallback if the option is not present.  This example\n    /// parses a command line argument (if present), or the contents of a file to\n    /// an integer.  However, unlike accessing the command line argument, reading\n    /// the file is fallible, so it must be wrapped with `Ok`.\n    ///\n    /// ```no_run\n    /// # fn main() -> Result<(), Box<dyn std::error::Error>> {\n    /// let v: u64 = std::env::args()\n    ///    .nth(1)\n    ///    .map_or_else(|| std::fs::read_to_string(\"/etc/someconfig.conf\"), Ok)?\n    ///    .parse()?;\n    /// #   Ok(())\n    /// # }\n    /// ```\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_const_unstable(feature = \"const_option_ops\", issue = \"143956\")]\n    pub const fn map_or_else<U, D, F>(self, default: D, f: F) -> U\n    where\n        D: [const] FnOnce() -> U + [const] Destruct,\n        F: [const] FnOnce(T) -> U + [const] Destruct,\n    {\n        match self {\n            Some(t) => f(t),\n            None => default(),\n        }\n    }\n\n    /// Maps an `Option<T>` to a `U` by applying function `f` to the contained\n    /// value if the option is [`Some`], otherwise if [`None`], returns the\n    /// [default value] for the type `U`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(result_option_map_or_default)]\n    ///\n    /// let x: Option<&str> = Some(\"hi\");\n    /// let y: Option<&str> = None;\n    ///\n    /// assert_eq!(x.map_or_default(|x| x.len()), 2);\n    /// assert_eq!(y.map_or_default(|y| y.len()), 0);\n    /// ```\n    ///\n    /// [default value]: Default::default\n    #[inline]\n    #[unstable(feature = \"result_option_map_or_default\", issue = \"138099\")]\n    #[rustc_const_unstable(feature = \"const_option_ops\", issue = \"143956\")]\n    pub const fn map_or_default<U, F>(self, f: F) -> U\n    where\n        U: [const] Default,\n        F: [const] FnOnce(T) -> U + [const] Destruct,\n    {\n        match self {\n            Some(t) => f(t),\n            None => U::default(),\n        }\n    }\n\n    /// Transforms the `Option<T>` into a [`Result<T, E>`], mapping [`Some(v)`] to\n    /// [`Ok(v)`] and [`None`] to [`Err(err)`].\n    ///\n    /// Arguments passed to `ok_or` are eagerly evaluated; if you are passing the\n    /// result of a function call, it is recommended to use [`ok_or_else`], which is\n    /// lazily evaluated.\n    ///\n    /// [`Ok(v)`]: Ok\n    /// [`Err(err)`]: Err\n    /// [`Some(v)`]: Some\n    /// [`ok_or_else`]: Option::ok_or_else\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x = Some(\"foo\");\n    /// assert_eq!(x.ok_or(0), Ok(\"foo\"));\n    ///\n    /// let x: Option<&str> = None;\n    /// assert_eq!(x.ok_or(0), Err(0));\n    /// ```\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_const_unstable(feature = \"const_option_ops\", issue = \"143956\")]\n    pub const fn ok_or<E: [const] Destruct>(self, err: E) -> Result<T, E> {\n        match self {\n            Some(v) => Ok(v),\n            None => Err(err),\n        }\n    }\n\n    /// Transforms the `Option<T>` into a [`Result<T, E>`], mapping [`Some(v)`] to\n    /// [`Ok(v)`] and [`None`] to [`Err(err())`].\n    ///\n    /// [`Ok(v)`]: Ok\n    /// [`Err(err())`]: Err\n    /// [`Some(v)`]: Some\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x = Some(\"foo\");\n    /// assert_eq!(x.ok_or_else(|| 0), Ok(\"foo\"));\n    ///\n    /// let x: Option<&str> = None;\n    /// assert_eq!(x.ok_or_else(|| 0), Err(0));\n    /// ```\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_const_unstable(feature = \"const_option_ops\", issue = \"143956\")]\n    pub const fn ok_or_else<E, F>(self, err: F) -> Result<T, E>\n    where\n        F: [const] FnOnce() -> E + [const] Destruct,\n    {\n        match self {\n            Some(v) => Ok(v),\n            None => Err(err()),\n        }\n    }\n\n    /// Converts from `Option<T>` (or `&Option<T>`) to `Option<&T::Target>`.\n    ///\n    /// Leaves the original Option in-place, creating a new one with a reference\n    /// to the original one, additionally coercing the contents via [`Deref`].\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x: Option<String> = Some(\"hey\".to_owned());\n    /// assert_eq!(x.as_deref(), Some(\"hey\"));\n    ///\n    /// let x: Option<String> = None;\n    /// assert_eq!(x.as_deref(), None);\n    /// ```\n    #[inline]\n    #[stable(feature = \"option_deref\", since = \"1.40.0\")]\n    #[rustc_const_unstable(feature = \"const_convert\", issue = \"143773\")]\n    pub const fn as_deref(&self) -> Option<&T::Target>\n    where\n        T: [const] Deref,\n    {\n        self.as_ref().map(Deref::deref)\n    }\n\n    /// Converts from `Option<T>` (or `&mut Option<T>`) to `Option<&mut T::Target>`.\n    ///\n    /// Leaves the original `Option` in-place, creating a new one containing a mutable reference to\n    /// the inner type's [`Deref::Target`] type.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut x: Option<String> = Some(\"hey\".to_owned());\n    /// assert_eq!(x.as_deref_mut().map(|x| {\n    ///     x.make_ascii_uppercase();\n    ///     x\n    /// }), Some(\"HEY\".to_owned().as_mut_str()));\n    /// ```\n    #[inline]\n    #[stable(feature = \"option_deref\", since = \"1.40.0\")]\n    #[rustc_const_unstable(feature = \"const_convert\", issue = \"143773\")]\n    pub const fn as_deref_mut(&mut self) -> Option<&mut T::Target>\n    where\n        T: [const] DerefMut,\n    {\n        self.as_mut().map(DerefMut::deref_mut)\n    }\n\n    /////////////////////////////////////////////////////////////////////////\n    // Iterator constructors\n    /////////////////////////////////////////////////////////////////////////\n\n    /// Returns an iterator over the possibly contained value.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x = Some(4);\n    /// assert_eq!(x.iter().next(), Some(&4));\n    ///\n    /// let x: Option<u32> = None;\n    /// assert_eq!(x.iter().next(), None);\n    /// ```\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    pub fn iter(&self) -> Iter<'_, T> {\n        Iter { inner: Item { opt: self.as_ref() } }\n    }\n\n    /// Returns a mutable iterator over the possibly contained value.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut x = Some(4);\n    /// match x.iter_mut().next() {\n    ///     Some(v) => *v = 42,\n    ///     None => {},\n    /// }\n    /// assert_eq!(x, Some(42));\n    ///\n    /// let mut x: Option<u32> = None;\n    /// assert_eq!(x.iter_mut().next(), None);\n    /// ```\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    pub fn iter_mut(&mut self) -> IterMut<'_, T> {\n        IterMut { inner: Item { opt: self.as_mut() } }\n    }\n\n    /////////////////////////////////////////////////////////////////////////\n    // Boolean operations on the values, eager and lazy\n    /////////////////////////////////////////////////////////////////////////\n\n    /// Returns [`None`] if the option is [`None`], otherwise returns `optb`.\n    ///\n    /// Arguments passed to `and` are eagerly evaluated; if you are passing the\n    /// result of a function call, it is recommended to use [`and_then`], which is\n    /// lazily evaluated.\n    ///\n    /// [`and_then`]: Option::and_then\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x = Some(2);\n    /// let y: Option<&str> = None;\n    /// assert_eq!(x.and(y), None);\n    ///\n    /// let x: Option<u32> = None;\n    /// let y = Some(\"foo\");\n    /// assert_eq!(x.and(y), None);\n    ///\n    /// let x = Some(2);\n    /// let y = Some(\"foo\");\n    /// assert_eq!(x.and(y), Some(\"foo\"));\n    ///\n    /// let x: Option<u32> = None;\n    /// let y: Option<&str> = None;\n    /// assert_eq!(x.and(y), None);\n    /// ```\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_const_unstable(feature = \"const_option_ops\", issue = \"143956\")]\n    pub const fn and<U>(self, optb: Option<U>) -> Option<U>\n    where\n        T: [const] Destruct,\n        U: [const] Destruct,\n    {\n        match self {\n            Some(_) => optb,\n            None => None,\n        }\n    }\n\n    /// Returns [`None`] if the option is [`None`], otherwise calls `f` with the\n    /// wrapped value and returns the result.\n    ///\n    /// Some languages call this operation flatmap.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// fn sq_then_to_string(x: u32) -> Option<String> {\n    ///     x.checked_mul(x).map(|sq| sq.to_string())\n    /// }\n    ///\n    /// assert_eq!(Some(2).and_then(sq_then_to_string), Some(4.to_string()));\n    /// assert_eq!(Some(1_000_000).and_then(sq_then_to_string), None); // overflowed!\n    /// assert_eq!(None.and_then(sq_then_to_string), None);\n    /// ```\n    ///\n    /// Often used to chain fallible operations that may return [`None`].\n    ///\n    /// ```\n    /// let arr_2d = [[\"A0\", \"A1\"], [\"B0\", \"B1\"]];\n    ///\n    /// let item_0_1 = arr_2d.get(0).and_then(|row| row.get(1));\n    /// assert_eq!(item_0_1, Some(&\"A1\"));\n    ///\n    /// let item_2_0 = arr_2d.get(2).and_then(|row| row.get(0));\n    /// assert_eq!(item_2_0, None);\n    /// ```\n    #[doc(alias = \"flatmap\")]\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_confusables(\"flat_map\", \"flatmap\")]\n    #[rustc_const_unstable(feature = \"const_option_ops\", issue = \"143956\")]\n    pub const fn and_then<U, F>(self, f: F) -> Option<U>\n    where\n        F: [const] FnOnce(T) -> Option<U> + [const] Destruct,\n    {\n        match self {\n            Some(x) => f(x),\n            None => None,\n        }\n    }\n\n    /// Returns [`None`] if the option is [`None`], otherwise calls `predicate`\n    /// with the wrapped value and returns:\n    ///\n    /// - [`Some(t)`] if `predicate` returns `true` (where `t` is the wrapped\n    ///   value), and\n    /// - [`None`] if `predicate` returns `false`.\n    ///\n    /// This function works similar to [`Iterator::filter()`]. You can imagine\n    /// the `Option<T>` being an iterator over one or zero elements. `filter()`\n    /// lets you decide which elements to keep.\n    ///\n    /// # Examples\n    ///\n    /// ```rust\n    /// fn is_even(n: &i32) -> bool {\n    ///     n % 2 == 0\n    /// }\n    ///\n    /// assert_eq!(None.filter(is_even), None);\n    /// assert_eq!(Some(3).filter(is_even), None);\n    /// assert_eq!(Some(4).filter(is_even), Some(4));\n    /// ```\n    ///\n    /// [`Some(t)`]: Some\n    #[inline]\n    #[stable(feature = \"option_filter\", since = \"1.27.0\")]\n    #[rustc_const_unstable(feature = \"const_option_ops\", issue = \"143956\")]\n    pub const fn filter<P>(self, predicate: P) -> Self\n    where\n        P: [const] FnOnce(&T) -> bool + [const] Destruct,\n        T: [const] Destruct,\n    {\n        if let Some(x) = self {\n            if predicate(&x) {\n                return Some(x);\n            }\n        }\n        None\n    }\n\n    /// Returns the option if it contains a value, otherwise returns `optb`.\n    ///\n    /// Arguments passed to `or` are eagerly evaluated; if you are passing the\n    /// result of a function call, it is recommended to use [`or_else`], which is\n    /// lazily evaluated.\n    ///\n    /// [`or_else`]: Option::or_else\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x = Some(2);\n    /// let y = None;\n    /// assert_eq!(x.or(y), Some(2));\n    ///\n    /// let x = None;\n    /// let y = Some(100);\n    /// assert_eq!(x.or(y), Some(100));\n    ///\n    /// let x = Some(2);\n    /// let y = Some(100);\n    /// assert_eq!(x.or(y), Some(2));\n    ///\n    /// let x: Option<u32> = None;\n    /// let y = None;\n    /// assert_eq!(x.or(y), None);\n    /// ```\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_const_unstable(feature = \"const_option_ops\", issue = \"143956\")]\n    pub const fn or(self, optb: Option<T>) -> Option<T>\n    where\n        T: [const] Destruct,\n    {\n        match self {\n            x @ Some(_) => x,\n            None => optb,\n        }\n    }\n\n    /// Returns the option if it contains a value, otherwise calls `f` and\n    /// returns the result.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// fn nobody() -> Option<&'static str> { None }\n    /// fn vikings() -> Option<&'static str> { Some(\"vikings\") }\n    ///\n    /// assert_eq!(Some(\"barbarians\").or_else(vikings), Some(\"barbarians\"));\n    /// assert_eq!(None.or_else(vikings), Some(\"vikings\"));\n    /// assert_eq!(None.or_else(nobody), None);\n    /// ```\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_const_unstable(feature = \"const_option_ops\", issue = \"143956\")]\n    pub const fn or_else<F>(self, f: F) -> Option<T>\n    where\n        F: [const] FnOnce() -> Option<T> + [const] Destruct,\n        //FIXME(const_hack): this `T: [const] Destruct` is unnecessary, but even precise live drops can't tell\n        // no value of type `T` gets dropped here\n        T: [const] Destruct,\n    {\n        match self {\n            x @ Some(_) => x,\n            None => f(),\n        }\n    }\n\n    /// Returns [`Some`] if exactly one of `self`, `optb` is [`Some`], otherwise returns [`None`].\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x = Some(2);\n    /// let y: Option<u32> = None;\n    /// assert_eq!(x.xor(y), Some(2));\n    ///\n    /// let x: Option<u32> = None;\n    /// let y = Some(2);\n    /// assert_eq!(x.xor(y), Some(2));\n    ///\n    /// let x = Some(2);\n    /// let y = Some(2);\n    /// assert_eq!(x.xor(y), None);\n    ///\n    /// let x: Option<u32> = None;\n    /// let y: Option<u32> = None;\n    /// assert_eq!(x.xor(y), None);\n    /// ```\n    #[inline]\n    #[stable(feature = \"option_xor\", since = \"1.37.0\")]\n    #[rustc_const_unstable(feature = \"const_option_ops\", issue = \"143956\")]\n    pub const fn xor(self, optb: Option<T>) -> Option<T>\n    where\n        T: [const] Destruct,\n    {\n        match (self, optb) {\n            (a @ Some(_), None) => a,\n            (None, b @ Some(_)) => b,\n            _ => None,\n        }\n    }\n\n    /////////////////////////////////////////////////////////////////////////\n    // Entry-like operations to insert a value and return a reference\n    /////////////////////////////////////////////////////////////////////////\n\n    /// Inserts `value` into the option, then returns a mutable reference to it.\n    ///\n    /// If the option already contains a value, the old value is dropped.\n    ///\n    /// See also [`Option::get_or_insert`], which doesn't update the value if\n    /// the option already contains [`Some`].\n    ///\n    /// # Example\n    ///\n    /// ```\n    /// let mut opt = None;\n    /// let val = opt.insert(1);\n    /// assert_eq!(*val, 1);\n    /// assert_eq!(opt.unwrap(), 1);\n    /// let val = opt.insert(2);\n    /// assert_eq!(*val, 2);\n    /// *val = 3;\n    /// assert_eq!(opt.unwrap(), 3);\n    /// ```\n    #[must_use = \"if you intended to set a value, consider assignment instead\"]\n    #[inline]\n    #[stable(feature = \"option_insert\", since = \"1.53.0\")]\n    #[rustc_const_unstable(feature = \"const_option_ops\", issue = \"143956\")]\n    pub const fn insert(&mut self, value: T) -> &mut T\n    where\n        T: [const] Destruct,\n    {\n        *self = Some(value);\n\n        // SAFETY: the code above just filled the option\n        unsafe { self.as_mut().unwrap_unchecked() }\n    }\n\n    /// Inserts `value` into the option if it is [`None`], then\n    /// returns a mutable reference to the contained value.\n    ///\n    /// See also [`Option::insert`], which updates the value even if\n    /// the option already contains [`Some`].\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut x = None;\n    ///\n    /// {\n    ///     let y: &mut u32 = x.get_or_insert(5);\n    ///     assert_eq!(y, &5);\n    ///\n    ///     *y = 7;\n    /// }\n    ///\n    /// assert_eq!(x, Some(7));\n    /// ```\n    #[inline]\n    #[stable(feature = \"option_entry\", since = \"1.20.0\")]\n    pub fn get_or_insert(&mut self, value: T) -> &mut T {\n        self.get_or_insert_with(|| value)\n    }\n\n    /// Inserts the default value into the option if it is [`None`], then\n    /// returns a mutable reference to the contained value.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut x = None;\n    ///\n    /// {\n    ///     let y: &mut u32 = x.get_or_insert_default();\n    ///     assert_eq!(y, &0);\n    ///\n    ///     *y = 7;\n    /// }\n    ///\n    /// assert_eq!(x, Some(7));\n    /// ```\n    #[inline]\n    #[stable(feature = \"option_get_or_insert_default\", since = \"1.83.0\")]\n    #[rustc_const_unstable(feature = \"const_option_ops\", issue = \"143956\")]\n    pub const fn get_or_insert_default(&mut self) -> &mut T\n    where\n        T: [const] Default + [const] Destruct,\n    {\n        self.get_or_insert_with(T::default)\n    }\n\n    /// Inserts a value computed from `f` into the option if it is [`None`],\n    /// then returns a mutable reference to the contained value.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut x = None;\n    ///\n    /// {\n    ///     let y: &mut u32 = x.get_or_insert_with(|| 5);\n    ///     assert_eq!(y, &5);\n    ///\n    ///     *y = 7;\n    /// }\n    ///\n    /// assert_eq!(x, Some(7));\n    /// ```\n    #[inline]\n    #[stable(feature = \"option_entry\", since = \"1.20.0\")]\n    #[rustc_const_unstable(feature = \"const_option_ops\", issue = \"143956\")]\n    pub const fn get_or_insert_with<F>(&mut self, f: F) -> &mut T\n    where\n        F: [const] FnOnce() -> T + [const] Destruct,\n        T: [const] Destruct,\n    {\n        if let None = self {\n            *self = Some(f());\n        }\n\n        // SAFETY: a `None` variant for `self` would have been replaced by a `Some`\n        // variant in the code above.\n        unsafe { self.as_mut().unwrap_unchecked() }\n    }\n\n    /////////////////////////////////////////////////////////////////////////\n    // Misc\n    /////////////////////////////////////////////////////////////////////////\n\n    /// Takes the value out of the option, leaving a [`None`] in its place.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut x = Some(2);\n    /// let y = x.take();\n    /// assert_eq!(x, None);\n    /// assert_eq!(y, Some(2));\n    ///\n    /// let mut x: Option<u32> = None;\n    /// let y = x.take();\n    /// assert_eq!(x, None);\n    /// assert_eq!(y, None);\n    /// ```\n    #[inline]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_const_stable(feature = \"const_option\", since = \"1.83.0\")]\n    pub const fn take(&mut self) -> Option<T> {\n        // FIXME(const-hack) replace `mem::replace` by `mem::take` when the latter is const ready\n        mem::replace(self, None)\n    }\n\n    /// Takes the value out of the option, but only if the predicate evaluates to\n    /// `true` on a mutable reference to the value.\n    ///\n    /// In other words, replaces `self` with `None` if the predicate returns `true`.\n    /// This method operates similar to [`Option::take`] but conditional.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut x = Some(42);\n    ///\n    /// let prev = x.take_if(|v| if *v == 42 {\n    ///     *v += 1;\n    ///     false\n    /// } else {\n    ///     false\n    /// });\n    /// assert_eq!(x, Some(43));\n    /// assert_eq!(prev, None);\n    ///\n    /// let prev = x.take_if(|v| *v == 43);\n    /// assert_eq!(x, None);\n    /// assert_eq!(prev, Some(43));\n    /// ```\n    #[inline]\n    #[stable(feature = \"option_take_if\", since = \"1.80.0\")]\n    #[rustc_const_unstable(feature = \"const_option_ops\", issue = \"143956\")]\n    pub const fn take_if<P>(&mut self, predicate: P) -> Option<T>\n    where\n        P: [const] FnOnce(&mut T) -> bool + [const] Destruct,\n    {\n        if self.as_mut().map_or(false, predicate) { self.take() } else { None }\n    }\n\n    /// Replaces the actual value in the option by the value given in parameter,\n    /// returning the old value if present,\n    /// leaving a [`Some`] in its place without deinitializing either one.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut x = Some(2);\n    /// let old = x.replace(5);\n    /// assert_eq!(x, Some(5));\n    /// assert_eq!(old, Some(2));\n    ///\n    /// let mut x = None;\n    /// let old = x.replace(3);\n    /// assert_eq!(x, Some(3));\n    /// assert_eq!(old, None);\n    /// ```\n    #[inline]\n    #[stable(feature = \"option_replace\", since = \"1.31.0\")]\n    #[rustc_const_stable(feature = \"const_option\", since = \"1.83.0\")]\n    pub const fn replace(&mut self, value: T) -> Option<T> {\n        mem::replace(self, Some(value))\n    }\n\n    /// Zips `self` with another `Option`.\n    ///\n    /// If `self` is `Some(s)` and `other` is `Some(o)`, this method returns `Some((s, o))`.\n    /// Otherwise, `None` is returned.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x = Some(1);\n    /// let y = Some(\"hi\");\n    /// let z = None::<u8>;\n    ///\n    /// assert_eq!(x.zip(y), Some((1, \"hi\")));\n    /// assert_eq!(x.zip(z), None);\n    /// ```\n    #[stable(feature = \"option_zip_option\", since = \"1.46.0\")]\n    #[rustc_const_unstable(feature = \"const_option_ops\", issue = \"143956\")]\n    pub const fn zip<U>(self, other: Option<U>) -> Option<(T, U)>\n    where\n        T: [const] Destruct,\n        U: [const] Destruct,\n    {\n        match (self, other) {\n            (Some(a), Some(b)) => Some((a, b)),\n            _ => None,\n        }\n    }\n\n    /// Zips `self` and another `Option` with function `f`.\n    ///\n    /// If `self` is `Some(s)` and `other` is `Some(o)`, this method returns `Some(f(s, o))`.\n    /// Otherwise, `None` is returned.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(option_zip)]\n    ///\n    /// #[derive(Debug, PartialEq)]\n    /// struct Point {\n    ///     x: f64,\n    ///     y: f64,\n    /// }\n    ///\n    /// impl Point {\n    ///     fn new(x: f64, y: f64) -> Self {\n    ///         Self { x, y }\n    ///     }\n    /// }\n    ///\n    /// let x = Some(17.5);\n    /// let y = Some(42.7);\n    ///\n    /// assert_eq!(x.zip_with(y, Point::new), Some(Point { x: 17.5, y: 42.7 }));\n    /// assert_eq!(x.zip_with(None, Point::new), None);\n    /// ```\n    #[unstable(feature = \"option_zip\", issue = \"70086\")]\n    #[rustc_const_unstable(feature = \"const_option_ops\", issue = \"143956\")]\n    pub const fn zip_with<U, F, R>(self, other: Option<U>, f: F) -> Option<R>\n    where\n        F: [const] FnOnce(T, U) -> R + [const] Destruct,\n        T: [const] Destruct,\n        U: [const] Destruct,\n    {\n        match (self, other) {\n            (Some(a), Some(b)) => Some(f(a, b)),\n            _ => None,\n        }\n    }\n\n    /// Reduces two options into one, using the provided function if both are `Some`.\n    ///\n    /// If `self` is `Some(s)` and `other` is `Some(o)`, this method returns `Some(f(s, o))`.\n    /// Otherwise, if only one of `self` and `other` is `Some`, that one is returned.\n    /// If both `self` and `other` are `None`, `None` is returned.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(option_reduce)]\n    ///\n    /// let s12 = Some(12);\n    /// let s17 = Some(17);\n    /// let n = None;\n    /// let f = |a, b| a + b;\n    ///\n    /// assert_eq!(s12.reduce(s17, f), Some(29));\n    /// assert_eq!(s12.reduce(n, f), Some(12));\n    /// assert_eq!(n.reduce(s17, f), Some(17));\n    /// assert_eq!(n.reduce(n, f), None);\n    /// ```\n    #[unstable(feature = \"option_reduce\", issue = \"144273\")]\n    pub fn reduce<U, R, F>(self, other: Option<U>, f: F) -> Option<R>\n    where\n        T: Into<R>,\n        U: Into<R>,\n        F: FnOnce(T, U) -> R,\n    {\n        match (self, other) {\n            (Some(a), Some(b)) => Some(f(a, b)),\n            (Some(a), _) => Some(a.into()),\n            (_, Some(b)) => Some(b.into()),\n            _ => None,\n        }\n    }\n}\n\nimpl<T, U> Option<(T, U)> {\n    /// Unzips an option containing a tuple of two options.\n    ///\n    /// If `self` is `Some((a, b))` this method returns `(Some(a), Some(b))`.\n    /// Otherwise, `(None, None)` is returned.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x = Some((1, \"hi\"));\n    /// let y = None::<(u8, u32)>;\n    ///\n    /// assert_eq!(x.unzip(), (Some(1), Some(\"hi\")));\n    /// assert_eq!(y.unzip(), (None, None));\n    /// ```\n    #[inline]\n    #[stable(feature = \"unzip_option\", since = \"1.66.0\")]\n    pub fn unzip(self) -> (Option<T>, Option<U>) {\n        match self {\n            Some((a, b)) => (Some(a), Some(b)),\n            None => (None, None),\n        }\n    }\n}\n\nimpl<T> Option<&T> {\n    /// Maps an `Option<&T>` to an `Option<T>` by copying the contents of the\n    /// option.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x = 12;\n    /// let opt_x = Some(&x);\n    /// assert_eq!(opt_x, Some(&12));\n    /// let copied = opt_x.copied();\n    /// assert_eq!(copied, Some(12));\n    /// ```\n    #[must_use = \"`self` will be dropped if the result is not used\"]\n    #[stable(feature = \"copied\", since = \"1.35.0\")]\n    #[rustc_const_stable(feature = \"const_option\", since = \"1.83.0\")]\n    pub const fn copied(self) -> Option<T>\n    where\n        T: Copy,\n    {\n        // FIXME(const-hack): this implementation, which sidesteps using `Option::map` since it's not const\n        // ready yet, should be reverted when possible to avoid code repetition\n        match self {\n            Some(&v) => Some(v),\n            None => None,\n        }\n    }\n\n    /// Maps an `Option<&T>` to an `Option<T>` by cloning the contents of the\n    /// option.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x = 12;\n    /// let opt_x = Some(&x);\n    /// assert_eq!(opt_x, Some(&12));\n    /// let cloned = opt_x.cloned();\n    /// assert_eq!(cloned, Some(12));\n    /// ```\n    #[must_use = \"`self` will be dropped if the result is not used\"]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    pub fn cloned(self) -> Option<T>\n    where\n        T: Clone,\n    {\n        match self {\n            Some(t) => Some(t.clone()),\n            None => None,\n        }\n    }\n}\n\nimpl<T> Option<&mut T> {\n    /// Maps an `Option<&mut T>` to an `Option<T>` by copying the contents of the\n    /// option.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut x = 12;\n    /// let opt_x = Some(&mut x);\n    /// assert_eq!(opt_x, Some(&mut 12));\n    /// let copied = opt_x.copied();\n    /// assert_eq!(copied, Some(12));\n    /// ```\n    #[must_use = \"`self` will be dropped if the result is not used\"]\n    #[stable(feature = \"copied\", since = \"1.35.0\")]\n    #[rustc_const_stable(feature = \"const_option\", since = \"1.83.0\")]\n    pub const fn copied(self) -> Option<T>\n    where\n        T: Copy,\n    {\n        match self {\n            Some(&mut t) => Some(t),\n            None => None,\n        }\n    }\n\n    /// Maps an `Option<&mut T>` to an `Option<T>` by cloning the contents of the\n    /// option.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut x = 12;\n    /// let opt_x = Some(&mut x);\n    /// assert_eq!(opt_x, Some(&mut 12));\n    /// let cloned = opt_x.cloned();\n    /// assert_eq!(cloned, Some(12));\n    /// ```\n    #[must_use = \"`self` will be dropped if the result is not used\"]\n    #[stable(since = \"1.26.0\", feature = \"option_ref_mut_cloned\")]\n    pub fn cloned(self) -> Option<T>\n    where\n        T: Clone,\n    {\n        match self {\n            Some(t) => Some(t.clone()),\n            None => None,\n        }\n    }\n}\n\nimpl<T, E> Option<Result<T, E>> {\n    /// Transposes an `Option` of a [`Result`] into a [`Result`] of an `Option`.\n    ///\n    /// <code>[Some]\\([Ok]\\(\\_))</code> is mapped to <code>[Ok]\\([Some]\\(\\_))</code>,\n    /// <code>[Some]\\([Err]\\(\\_))</code> is mapped to <code>[Err]\\(\\_)</code>,\n    /// and [`None`] will be mapped to <code>[Ok]\\([None])</code>.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #[derive(Debug, Eq, PartialEq)]\n    /// struct SomeErr;\n    ///\n    /// let x: Option<Result<i32, SomeErr>> = Some(Ok(5));\n    /// let y: Result<Option<i32>, SomeErr> = Ok(Some(5));\n    /// assert_eq!(x.transpose(), y);\n    /// ```\n    #[inline]\n    #[stable(feature = \"transpose_result\", since = \"1.33.0\")]\n    #[rustc_allow_const_fn_unstable(const_precise_live_drops)]\n    #[rustc_const_stable(feature = \"const_option\", since = \"1.83.0\")]\n    pub const fn transpose(self) -> Result<Option<T>, E> {\n        match self {\n            Some(Ok(x)) => Ok(Some(x)),\n            Some(Err(e)) => Err(e),\n            None => Ok(None),\n        }\n    }\n}\n\n#[cfg_attr(not(panic = \"immediate-abort\"), inline(never))]\n#[cfg_attr(panic = \"immediate-abort\", inline)]\n#[cold]\n#[track_caller]\nconst fn unwrap_failed() -> ! {\n    panic(\"called `Option::unwrap()` on a `None` value\")\n}\n\n// This is a separate function to reduce the code size of .expect() itself.\n#[cfg_attr(not(panic = \"immediate-abort\"), inline(never))]\n#[cfg_attr(panic = \"immediate-abort\", inline)]\n#[cold]\n#[track_caller]\nconst fn expect_failed(msg: &str) -> ! {\n    panic_display(&msg)\n}\n\n/////////////////////////////////////////////////////////////////////////////\n// Trait implementations\n/////////////////////////////////////////////////////////////////////////////\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\n#[rustc_const_unstable(feature = \"const_clone\", issue = \"142757\")]\nimpl<T> const Clone for Option<T>\nwhere\n    // FIXME(const_hack): the T: [const] Destruct should be inferred from the Self: [const] Destruct in clone_from.\n    // See https://github.com/rust-lang/rust/issues/144207\n    T: [const] Clone + [const] Destruct,\n{\n    #[inline]\n    fn clone(&self) -> Self {\n        match self {\n            Some(x) => Some(x.clone()),\n            None => None,\n        }\n    }\n\n    #[inline]\n    fn clone_from(&mut self, source: &Self) {\n        match (self, source) {\n            (Some(to), Some(from)) => to.clone_from(from),\n            (to, from) => *to = from.clone(),\n        }\n    }\n}\n\n#[unstable(feature = \"ergonomic_clones\", issue = \"132290\")]\nimpl<T> crate::clone::UseCloned for Option<T> where T: crate::clone::UseCloned {}\n\n#[doc(hidden)]\n#[unstable(feature = \"trivial_clone\", issue = \"none\")]\n#[rustc_const_unstable(feature = \"const_clone\", issue = \"142757\")]\nunsafe impl<T> const TrivialClone for Option<T> where T: [const] TrivialClone + [const] Destruct {}\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\n#[rustc_const_unstable(feature = \"const_default\", issue = \"143894\")]\nimpl<T> const Default for Option<T> {\n    /// Returns [`None`][Option::None].\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let opt: Option<u32> = Option::default();\n    /// assert!(opt.is_none());\n    /// ```\n    #[inline]\n    fn default() -> Option<T> {\n        None\n    }\n}\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl<T> IntoIterator for Option<T> {\n    type Item = T;\n    type IntoIter = IntoIter<T>;\n\n    /// Returns a consuming iterator over the possibly contained value.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x = Some(\"string\");\n    /// let v: Vec<&str> = x.into_iter().collect();\n    /// assert_eq!(v, [\"string\"]);\n    ///\n    /// let x = None;\n    /// let v: Vec<&str> = x.into_iter().collect();\n    /// assert!(v.is_empty());\n    /// ```\n    #[inline]\n    fn into_iter(self) -> IntoIter<T> {\n        IntoIter { inner: Item { opt: self } }\n    }\n}\n\n#[stable(since = \"1.4.0\", feature = \"option_iter\")]\nimpl<'a, T> IntoIterator for &'a Option<T> {\n    type Item = &'a T;\n    type IntoIter = Iter<'a, T>;\n\n    fn into_iter(self) -> Iter<'a, T> {\n        self.iter()\n    }\n}\n\n#[stable(since = \"1.4.0\", feature = \"option_iter\")]\nimpl<'a, T> IntoIterator for &'a mut Option<T> {\n    type Item = &'a mut T;\n    type IntoIter = IterMut<'a, T>;\n\n    fn into_iter(self) -> IterMut<'a, T> {\n        self.iter_mut()\n    }\n}\n\n#[stable(since = \"1.12.0\", feature = \"option_from\")]\n#[rustc_const_unstable(feature = \"const_convert\", issue = \"143773\")]\nimpl<T> const From<T> for Option<T> {\n    /// Moves `val` into a new [`Some`].\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let o: Option<u8> = Option::from(67);\n    ///\n    /// assert_eq!(Some(67), o);\n    /// ```\n    fn from(val: T) -> Option<T> {\n        Some(val)\n    }\n}\n\n#[stable(feature = \"option_ref_from_ref_option\", since = \"1.30.0\")]\n#[rustc_const_unstable(feature = \"const_convert\", issue = \"143773\")]\nimpl<'a, T> const From<&'a Option<T>> for Option<&'a T> {\n    /// Converts from `&Option<T>` to `Option<&T>`.\n    ///\n    /// # Examples\n    ///\n    /// Converts an <code>[Option]<[String]></code> into an <code>[Option]<[usize]></code>, preserving\n    /// the original. The [`map`] method takes the `self` argument by value, consuming the original,\n    /// so this technique uses `from` to first take an [`Option`] to a reference\n    /// to the value inside the original.\n    ///\n    /// [`map`]: Option::map\n    /// [String]: ../../std/string/struct.String.html \"String\"\n    ///\n    /// ```\n    /// let s: Option<String> = Some(String::from(\"Hello, Rustaceans!\"));\n    /// let o: Option<usize> = Option::from(&s).map(|ss: &String| ss.len());\n    ///\n    /// println!(\"Can still print s: {s:?}\");\n    ///\n    /// assert_eq!(o, Some(18));\n    /// ```\n    fn from(o: &'a Option<T>) -> Option<&'a T> {\n        o.as_ref()\n    }\n}\n\n#[stable(feature = \"option_ref_from_ref_option\", since = \"1.30.0\")]\n#[rustc_const_unstable(feature = \"const_convert\", issue = \"143773\")]\nimpl<'a, T> const From<&'a mut Option<T>> for Option<&'a mut T> {\n    /// Converts from `&mut Option<T>` to `Option<&mut T>`\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut s = Some(String::from(\"Hello\"));\n    /// let o: Option<&mut String> = Option::from(&mut s);\n    ///\n    /// match o {\n    ///     Some(t) => *t = String::from(\"Hello, Rustaceans!\"),\n    ///     None => (),\n    /// }\n    ///\n    /// assert_eq!(s, Some(String::from(\"Hello, Rustaceans!\")));\n    /// ```\n    fn from(o: &'a mut Option<T>) -> Option<&'a mut T> {\n        o.as_mut()\n    }\n}\n\n// Ideally, LLVM should be able to optimize our derive code to this.\n// Once https://github.com/llvm/llvm-project/issues/52622 is fixed, we can\n// go back to deriving `PartialEq`.\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl<T> crate::marker::StructuralPartialEq for Option<T> {}\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\n#[rustc_const_unstable(feature = \"const_cmp\", issue = \"143800\")]\nimpl<T: [const] PartialEq> const PartialEq for Option<T> {\n    #[inline]\n    fn eq(&self, other: &Self) -> bool {\n        // Spelling out the cases explicitly optimizes better than\n        // `_ => false`\n        match (self, other) {\n            (Some(l), Some(r)) => *l == *r,\n            (Some(_), None) => false,\n            (None, Some(_)) => false,\n            (None, None) => true,\n        }\n    }\n}\n\n// Manually implementing here somewhat improves codegen for\n// https://github.com/rust-lang/rust/issues/49892, although still\n// not optimal.\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\n#[rustc_const_unstable(feature = \"const_cmp\", issue = \"143800\")]\nimpl<T: [const] PartialOrd> const PartialOrd for Option<T> {\n    #[inline]\n    fn partial_cmp(&self, other: &Self) -> Option<cmp::Ordering> {\n        match (self, other) {\n            (Some(l), Some(r)) => l.partial_cmp(r),\n            (Some(_), None) => Some(cmp::Ordering::Greater),\n            (None, Some(_)) => Some(cmp::Ordering::Less),\n            (None, None) => Some(cmp::Ordering::Equal),\n        }\n    }\n}\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\n#[rustc_const_unstable(feature = \"const_cmp\", issue = \"143800\")]\nimpl<T: [const] Ord> const Ord for Option<T> {\n    #[inline]\n    fn cmp(&self, other: &Self) -> cmp::Ordering {\n        match (self, other) {\n            (Some(l), Some(r)) => l.cmp(r),\n            (Some(_), None) => cmp::Ordering::Greater,\n            (None, Some(_)) => cmp::Ordering::Less,\n            (None, None) => cmp::Ordering::Equal,\n        }\n    }\n}\n\n/////////////////////////////////////////////////////////////////////////////\n// The Option Iterators\n/////////////////////////////////////////////////////////////////////////////\n\n#[derive(Clone, Debug)]\nstruct Item<A> {\n    opt: Option<A>,\n}\n\nimpl<A> Iterator for Item<A> {\n    type Item = A;\n\n    #[inline]\n    fn next(&mut self) -> Option<A> {\n        self.opt.take()\n    }\n\n    #[inline]\n    fn size_hint(&self) -> (usize, Option<usize>) {\n        let len = self.len();\n        (len, Some(len))\n    }\n}\n\nimpl<A> DoubleEndedIterator for Item<A> {\n    #[inline]\n    fn next_back(&mut self) -> Option<A> {\n        self.opt.take()\n    }\n}\n\nimpl<A> ExactSizeIterator for Item<A> {\n    #[inline]\n    fn len(&self) -> usize {\n        self.opt.len()\n    }\n}\nimpl<A> FusedIterator for Item<A> {}\nunsafe impl<A> TrustedLen for Item<A> {}\n\n/// An iterator over a reference to the [`Some`] variant of an [`Option`].\n///\n/// The iterator yields one value if the [`Option`] is a [`Some`], otherwise none.\n///\n/// This `struct` is created by the [`Option::iter`] function.\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\n#[derive(Debug)]\npub struct Iter<'a, A: 'a> {\n    inner: Item<&'a A>,\n}\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl<'a, A> Iterator for Iter<'a, A> {\n    type Item = &'a A;\n\n    #[inline]\n    fn next(&mut self) -> Option<&'a A> {\n        self.inner.next()\n    }\n    #[inline]\n    fn size_hint(&self) -> (usize, Option<usize>) {\n        self.inner.size_hint()\n    }\n}\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl<'a, A> DoubleEndedIterator for Iter<'a, A> {\n    #[inline]\n    fn next_back(&mut self) -> Option<&'a A> {\n        self.inner.next_back()\n    }\n}\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl<A> ExactSizeIterator for Iter<'_, A> {}\n\n#[stable(feature = \"fused\", since = \"1.26.0\")]\nimpl<A> FusedIterator for Iter<'_, A> {}\n\n#[unstable(feature = \"trusted_len\", issue = \"37572\")]\nunsafe impl<A> TrustedLen for Iter<'_, A> {}\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl<A> Clone for Iter<'_, A> {\n    #[inline]\n    fn clone(&self) -> Self {\n        Iter { inner: self.inner.clone() }\n    }\n}\n\n/// An iterator over a mutable reference to the [`Some`] variant of an [`Option`].\n///\n/// The iterator yields one value if the [`Option`] is a [`Some`], otherwise none.\n///\n/// This `struct` is created by the [`Option::iter_mut`] function.\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\n#[derive(Debug)]\npub struct IterMut<'a, A: 'a> {\n    inner: Item<&'a mut A>,\n}\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl<'a, A> Iterator for IterMut<'a, A> {\n    type Item = &'a mut A;\n\n    #[inline]\n    fn next(&mut self) -> Option<&'a mut A> {\n        self.inner.next()\n    }\n    #[inline]\n    fn size_hint(&self) -> (usize, Option<usize>) {\n        self.inner.size_hint()\n    }\n}\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl<'a, A> DoubleEndedIterator for IterMut<'a, A> {\n    #[inline]\n    fn next_back(&mut self) -> Option<&'a mut A> {\n        self.inner.next_back()\n    }\n}\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl<A> ExactSizeIterator for IterMut<'_, A> {}\n\n#[stable(feature = \"fused\", since = \"1.26.0\")]\nimpl<A> FusedIterator for IterMut<'_, A> {}\n#[unstable(feature = \"trusted_len\", issue = \"37572\")]\nunsafe impl<A> TrustedLen for IterMut<'_, A> {}\n\n/// An iterator over the value in [`Some`] variant of an [`Option`].\n///\n/// The iterator yields one value if the [`Option`] is a [`Some`], otherwise none.\n///\n/// This `struct` is created by the [`Option::into_iter`] function.\n#[derive(Clone, Debug)]\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\npub struct IntoIter<A> {\n    inner: Item<A>,\n}\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl<A> Iterator for IntoIter<A> {\n    type Item = A;\n\n    #[inline]\n    fn next(&mut self) -> Option<A> {\n        self.inner.next()\n    }\n    #[inline]\n    fn size_hint(&self) -> (usize, Option<usize>) {\n        self.inner.size_hint()\n    }\n}\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl<A> DoubleEndedIterator for IntoIter<A> {\n    #[inline]\n    fn next_back(&mut self) -> Option<A> {\n        self.inner.next_back()\n    }\n}\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl<A> ExactSizeIterator for IntoIter<A> {}\n\n#[stable(feature = \"fused\", since = \"1.26.0\")]\nimpl<A> FusedIterator for IntoIter<A> {}\n\n#[unstable(feature = \"trusted_len\", issue = \"37572\")]\nunsafe impl<A> TrustedLen for IntoIter<A> {}\n\n/////////////////////////////////////////////////////////////////////////////\n// FromIterator\n/////////////////////////////////////////////////////////////////////////////\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl<A, V: FromIterator<A>> FromIterator<Option<A>> for Option<V> {\n    /// Takes each element in the [`Iterator`]: if it is [`None`][Option::None],\n    /// no further elements are taken, and the [`None`][Option::None] is\n    /// returned. Should no [`None`][Option::None] occur, a container of type\n    /// `V` containing the values of each [`Option`] is returned.\n    ///\n    /// # Examples\n    ///\n    /// Here is an example which increments every integer in a vector.\n    /// We use the checked variant of `add` that returns `None` when the\n    /// calculation would result in an overflow.\n    ///\n    /// ```\n    /// let items = vec![0_u16, 1, 2];\n    ///\n    /// let res: Option<Vec<u16>> = items\n    ///     .iter()\n    ///     .map(|x| x.checked_add(1))\n    ///     .collect();\n    ///\n    /// assert_eq!(res, Some(vec![1, 2, 3]));\n    /// ```\n    ///\n    /// As you can see, this will return the expected, valid items.\n    ///\n    /// Here is another example that tries to subtract one from another list\n    /// of integers, this time checking for underflow:\n    ///\n    /// ```\n    /// let items = vec![2_u16, 1, 0];\n    ///\n    /// let res: Option<Vec<u16>> = items\n    ///     .iter()\n    ///     .map(|x| x.checked_sub(1))\n    ///     .collect();\n    ///\n    /// assert_eq!(res, None);\n    /// ```\n    ///\n    /// Since the last element is zero, it would underflow. Thus, the resulting\n    /// value is `None`.\n    ///\n    /// Here is a variation on the previous example, showing that no\n    /// further elements are taken from `iter` after the first `None`.\n    ///\n    /// ```\n    /// let items = vec![3_u16, 2, 1, 10];\n    ///\n    /// let mut shared = 0;\n    ///\n    /// let res: Option<Vec<u16>> = items\n    ///     .iter()\n    ///     .map(|x| { shared += x; x.checked_sub(2) })\n    ///     .collect();\n    ///\n    /// assert_eq!(res, None);\n    /// assert_eq!(shared, 6);\n    /// ```\n    ///\n    /// Since the third element caused an underflow, no further elements were taken,\n    /// so the final value of `shared` is 6 (= `3 + 2 + 1`), not 16.\n    #[inline]\n    fn from_iter<I: IntoIterator<Item = Option<A>>>(iter: I) -> Option<V> {\n        // FIXME(#11084): This could be replaced with Iterator::scan when this\n        // performance bug is closed.\n\n        iter::try_process(iter.into_iter(), |i| i.collect())\n    }\n}\n\n#[unstable(feature = \"try_trait_v2\", issue = \"84277\", old_name = \"try_trait\")]\n#[rustc_const_unstable(feature = \"const_try\", issue = \"74935\")]\nimpl<T> const ops::Try for Option<T> {\n    type Output = T;\n    type Residual = Option<convert::Infallible>;\n\n    #[inline]\n    fn from_output(output: Self::Output) -> Self {\n        Some(output)\n    }\n\n    #[inline]\n    fn branch(self) -> ControlFlow<Self::Residual, Self::Output> {\n        match self {\n            Some(v) => ControlFlow::Continue(v),\n            None => ControlFlow::Break(None),\n        }\n    }\n}\n\n#[unstable(feature = \"try_trait_v2\", issue = \"84277\", old_name = \"try_trait\")]\n#[rustc_const_unstable(feature = \"const_try\", issue = \"74935\")]\n// Note: manually specifying the residual type instead of using the default to work around\n// https://github.com/rust-lang/rust/issues/99940\nimpl<T> const ops::FromResidual<Option<convert::Infallible>> for Option<T> {\n    #[inline]\n    fn from_residual(residual: Option<convert::Infallible>) -> Self {\n        match residual {\n            None => None,\n        }\n    }\n}\n\n#[diagnostic::do_not_recommend]\n#[unstable(feature = \"try_trait_v2_yeet\", issue = \"96374\")]\n#[rustc_const_unstable(feature = \"const_try\", issue = \"74935\")]\nimpl<T> const ops::FromResidual<ops::Yeet<()>> for Option<T> {\n    #[inline]\n    fn from_residual(ops::Yeet(()): ops::Yeet<()>) -> Self {\n        None\n    }\n}\n\n#[unstable(feature = \"try_trait_v2_residual\", issue = \"91285\")]\n#[rustc_const_unstable(feature = \"const_try\", issue = \"74935\")]\nimpl<T> const ops::Residual<T> for Option<convert::Infallible> {\n    type TryType = Option<T>;\n}\n\nimpl<T> Option<Option<T>> {\n    /// Converts from `Option<Option<T>>` to `Option<T>`.\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// let x: Option<Option<u32>> = Some(Some(6));\n    /// assert_eq!(Some(6), x.flatten());\n    ///\n    /// let x: Option<Option<u32>> = Some(None);\n    /// assert_eq!(None, x.flatten());\n    ///\n    /// let x: Option<Option<u32>> = None;\n    /// assert_eq!(None, x.flatten());\n    /// ```\n    ///\n    /// Flattening only removes one level of nesting at a time:\n    ///\n    /// ```\n    /// let x: Option<Option<Option<u32>>> = Some(Some(Some(6)));\n    /// assert_eq!(Some(Some(6)), x.flatten());\n    /// assert_eq!(Some(6), x.flatten().flatten());\n    /// ```\n    #[inline]\n    #[stable(feature = \"option_flattening\", since = \"1.40.0\")]\n    #[rustc_allow_const_fn_unstable(const_precise_live_drops)]\n    #[rustc_const_stable(feature = \"const_option\", since = \"1.83.0\")]\n    pub const fn flatten(self) -> Option<T> {\n        // FIXME(const-hack): could be written with `and_then`\n        match self {\n            Some(inner) => inner,\n            None => None,\n        }\n    }\n}\n\nimpl<T, const N: usize> [Option<T>; N] {\n    /// Transposes a `[Option<T>; N]` into a `Option<[T; N]>`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(option_array_transpose)]\n    /// # use std::option::Option;\n    ///\n    /// let data = [Some(0); 1000];\n    /// let data: Option<[u8; 1000]> = data.transpose();\n    /// assert_eq!(data, Some([0; 1000]));\n    ///\n    /// let data = [Some(0), None];\n    /// let data: Option<[u8; 2]> = data.transpose();\n    /// assert_eq!(data, None);\n    /// ```\n    #[inline]\n    #[unstable(feature = \"option_array_transpose\", issue = \"130828\")]\n    pub fn transpose(self) -> Option<[T; N]> {\n        self.try_map(core::convert::identity)\n    }\n}\n";

},{}],"4dkmE":[function(require,module,exports,__globalThis) {
module.exports = "//! Slice management and manipulation.\n//!\n//! For more details see [`std::slice`].\n//!\n//! [`std::slice`]: ../../std/slice/index.html\n\n#![stable(feature = \"rust1\", since = \"1.0.0\")]\n\nuse crate::clone::TrivialClone;\nuse crate::cmp::Ordering::{self, Equal, Greater, Less};\nuse crate::intrinsics::{exact_div, unchecked_sub};\nuse crate::mem::{self, MaybeUninit, SizedTypeProperties};\nuse crate::num::NonZero;\nuse crate::ops::{OneSidedRange, OneSidedRangeBound, Range, RangeBounds, RangeInclusive};\nuse crate::panic::const_panic;\nuse crate::simd::{self, Simd};\nuse crate::ub_checks::assert_unsafe_precondition;\nuse crate::{fmt, hint, ptr, range, slice};\n\n#[unstable(\n    feature = \"slice_internals\",\n    issue = \"none\",\n    reason = \"exposed from core to be reused in std; use the memchr crate\"\n)]\n#[doc(hidden)]\n/// Pure Rust memchr implementation, taken from rust-memchr\npub mod memchr;\n\n#[unstable(\n    feature = \"slice_internals\",\n    issue = \"none\",\n    reason = \"exposed from core to be reused in std;\"\n)]\n#[doc(hidden)]\npub mod sort;\n\nmod ascii;\nmod cmp;\npub(crate) mod index;\nmod iter;\nmod raw;\nmod rotate;\nmod specialize;\n\n#[stable(feature = \"inherent_ascii_escape\", since = \"1.60.0\")]\npub use ascii::EscapeAscii;\n#[unstable(feature = \"str_internals\", issue = \"none\")]\n#[doc(hidden)]\npub use ascii::is_ascii_simple;\n#[stable(feature = \"slice_get_slice\", since = \"1.28.0\")]\npub use index::SliceIndex;\n#[unstable(feature = \"slice_range\", issue = \"76393\")]\npub use index::{range, try_range};\n#[unstable(feature = \"array_windows\", issue = \"75027\")]\npub use iter::ArrayWindows;\n#[stable(feature = \"slice_group_by\", since = \"1.77.0\")]\npub use iter::{ChunkBy, ChunkByMut};\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\npub use iter::{Chunks, ChunksMut, Windows};\n#[stable(feature = \"chunks_exact\", since = \"1.31.0\")]\npub use iter::{ChunksExact, ChunksExactMut};\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\npub use iter::{Iter, IterMut};\n#[stable(feature = \"rchunks\", since = \"1.31.0\")]\npub use iter::{RChunks, RChunksExact, RChunksExactMut, RChunksMut};\n#[stable(feature = \"slice_rsplit\", since = \"1.27.0\")]\npub use iter::{RSplit, RSplitMut};\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\npub use iter::{RSplitN, RSplitNMut, Split, SplitMut, SplitN, SplitNMut};\n#[stable(feature = \"split_inclusive\", since = \"1.51.0\")]\npub use iter::{SplitInclusive, SplitInclusiveMut};\n#[stable(feature = \"from_ref\", since = \"1.28.0\")]\npub use raw::{from_mut, from_ref};\n#[unstable(feature = \"slice_from_ptr_range\", issue = \"89792\")]\npub use raw::{from_mut_ptr_range, from_ptr_range};\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\npub use raw::{from_raw_parts, from_raw_parts_mut};\n\n/// Calculates the direction and split point of a one-sided range.\n///\n/// This is a helper function for `split_off` and `split_off_mut` that returns\n/// the direction of the split (front or back) as well as the index at\n/// which to split. Returns `None` if the split index would overflow.\n#[inline]\nfn split_point_of(range: impl OneSidedRange<usize>) -> Option<(Direction, usize)> {\n    use OneSidedRangeBound::{End, EndInclusive, StartInclusive};\n\n    Some(match range.bound() {\n        (StartInclusive, i) => (Direction::Back, i),\n        (End, i) => (Direction::Front, i),\n        (EndInclusive, i) => (Direction::Front, i.checked_add(1)?),\n    })\n}\n\nenum Direction {\n    Front,\n    Back,\n}\n\nimpl<T> [T] {\n    /// Returns the number of elements in the slice.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let a = [1, 2, 3];\n    /// assert_eq!(a.len(), 3);\n    /// ```\n    #[lang = \"slice_len_fn\"]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_const_stable(feature = \"const_slice_len\", since = \"1.39.0\")]\n    #[rustc_no_implicit_autorefs]\n    #[inline]\n    #[must_use]\n    pub const fn len(&self) -> usize {\n        ptr::metadata(self)\n    }\n\n    /// Returns `true` if the slice has a length of 0.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let a = [1, 2, 3];\n    /// assert!(!a.is_empty());\n    ///\n    /// let b: &[i32] = &[];\n    /// assert!(b.is_empty());\n    /// ```\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_const_stable(feature = \"const_slice_is_empty\", since = \"1.39.0\")]\n    #[rustc_no_implicit_autorefs]\n    #[inline]\n    #[must_use]\n    pub const fn is_empty(&self) -> bool {\n        self.len() == 0\n    }\n\n    /// Returns the first element of the slice, or `None` if it is empty.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let v = [10, 40, 30];\n    /// assert_eq!(Some(&10), v.first());\n    ///\n    /// let w: &[i32] = &[];\n    /// assert_eq!(None, w.first());\n    /// ```\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_const_stable(feature = \"const_slice_first_last_not_mut\", since = \"1.56.0\")]\n    #[inline]\n    #[must_use]\n    pub const fn first(&self) -> Option<&T> {\n        if let [first, ..] = self { Some(first) } else { None }\n    }\n\n    /// Returns a mutable reference to the first element of the slice, or `None` if it is empty.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x = &mut [0, 1, 2];\n    ///\n    /// if let Some(first) = x.first_mut() {\n    ///     *first = 5;\n    /// }\n    /// assert_eq!(x, &[5, 1, 2]);\n    ///\n    /// let y: &mut [i32] = &mut [];\n    /// assert_eq!(None, y.first_mut());\n    /// ```\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_const_stable(feature = \"const_slice_first_last\", since = \"1.83.0\")]\n    #[inline]\n    #[must_use]\n    pub const fn first_mut(&mut self) -> Option<&mut T> {\n        if let [first, ..] = self { Some(first) } else { None }\n    }\n\n    /// Returns the first and all the rest of the elements of the slice, or `None` if it is empty.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x = &[0, 1, 2];\n    ///\n    /// if let Some((first, elements)) = x.split_first() {\n    ///     assert_eq!(first, &0);\n    ///     assert_eq!(elements, &[1, 2]);\n    /// }\n    /// ```\n    #[stable(feature = \"slice_splits\", since = \"1.5.0\")]\n    #[rustc_const_stable(feature = \"const_slice_first_last_not_mut\", since = \"1.56.0\")]\n    #[inline]\n    #[must_use]\n    pub const fn split_first(&self) -> Option<(&T, &[T])> {\n        if let [first, tail @ ..] = self { Some((first, tail)) } else { None }\n    }\n\n    /// Returns the first and all the rest of the elements of the slice, or `None` if it is empty.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x = &mut [0, 1, 2];\n    ///\n    /// if let Some((first, elements)) = x.split_first_mut() {\n    ///     *first = 3;\n    ///     elements[0] = 4;\n    ///     elements[1] = 5;\n    /// }\n    /// assert_eq!(x, &[3, 4, 5]);\n    /// ```\n    #[stable(feature = \"slice_splits\", since = \"1.5.0\")]\n    #[rustc_const_stable(feature = \"const_slice_first_last\", since = \"1.83.0\")]\n    #[inline]\n    #[must_use]\n    pub const fn split_first_mut(&mut self) -> Option<(&mut T, &mut [T])> {\n        if let [first, tail @ ..] = self { Some((first, tail)) } else { None }\n    }\n\n    /// Returns the last and all the rest of the elements of the slice, or `None` if it is empty.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x = &[0, 1, 2];\n    ///\n    /// if let Some((last, elements)) = x.split_last() {\n    ///     assert_eq!(last, &2);\n    ///     assert_eq!(elements, &[0, 1]);\n    /// }\n    /// ```\n    #[stable(feature = \"slice_splits\", since = \"1.5.0\")]\n    #[rustc_const_stable(feature = \"const_slice_first_last_not_mut\", since = \"1.56.0\")]\n    #[inline]\n    #[must_use]\n    pub const fn split_last(&self) -> Option<(&T, &[T])> {\n        if let [init @ .., last] = self { Some((last, init)) } else { None }\n    }\n\n    /// Returns the last and all the rest of the elements of the slice, or `None` if it is empty.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x = &mut [0, 1, 2];\n    ///\n    /// if let Some((last, elements)) = x.split_last_mut() {\n    ///     *last = 3;\n    ///     elements[0] = 4;\n    ///     elements[1] = 5;\n    /// }\n    /// assert_eq!(x, &[4, 5, 3]);\n    /// ```\n    #[stable(feature = \"slice_splits\", since = \"1.5.0\")]\n    #[rustc_const_stable(feature = \"const_slice_first_last\", since = \"1.83.0\")]\n    #[inline]\n    #[must_use]\n    pub const fn split_last_mut(&mut self) -> Option<(&mut T, &mut [T])> {\n        if let [init @ .., last] = self { Some((last, init)) } else { None }\n    }\n\n    /// Returns the last element of the slice, or `None` if it is empty.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let v = [10, 40, 30];\n    /// assert_eq!(Some(&30), v.last());\n    ///\n    /// let w: &[i32] = &[];\n    /// assert_eq!(None, w.last());\n    /// ```\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_const_stable(feature = \"const_slice_first_last_not_mut\", since = \"1.56.0\")]\n    #[inline]\n    #[must_use]\n    pub const fn last(&self) -> Option<&T> {\n        if let [.., last] = self { Some(last) } else { None }\n    }\n\n    /// Returns a mutable reference to the last item in the slice, or `None` if it is empty.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x = &mut [0, 1, 2];\n    ///\n    /// if let Some(last) = x.last_mut() {\n    ///     *last = 10;\n    /// }\n    /// assert_eq!(x, &[0, 1, 10]);\n    ///\n    /// let y: &mut [i32] = &mut [];\n    /// assert_eq!(None, y.last_mut());\n    /// ```\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_const_stable(feature = \"const_slice_first_last\", since = \"1.83.0\")]\n    #[inline]\n    #[must_use]\n    pub const fn last_mut(&mut self) -> Option<&mut T> {\n        if let [.., last] = self { Some(last) } else { None }\n    }\n\n    /// Returns an array reference to the first `N` items in the slice.\n    ///\n    /// If the slice is not at least `N` in length, this will return `None`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let u = [10, 40, 30];\n    /// assert_eq!(Some(&[10, 40]), u.first_chunk::<2>());\n    ///\n    /// let v: &[i32] = &[10];\n    /// assert_eq!(None, v.first_chunk::<2>());\n    ///\n    /// let w: &[i32] = &[];\n    /// assert_eq!(Some(&[]), w.first_chunk::<0>());\n    /// ```\n    #[inline]\n    #[stable(feature = \"slice_first_last_chunk\", since = \"1.77.0\")]\n    #[rustc_const_stable(feature = \"slice_first_last_chunk\", since = \"1.77.0\")]\n    pub const fn first_chunk<const N: usize>(&self) -> Option<&[T; N]> {\n        if self.len() < N {\n            None\n        } else {\n            // SAFETY: We explicitly check for the correct number of elements,\n            //   and do not let the reference outlive the slice.\n            Some(unsafe { &*(self.as_ptr().cast_array()) })\n        }\n    }\n\n    /// Returns a mutable array reference to the first `N` items in the slice.\n    ///\n    /// If the slice is not at least `N` in length, this will return `None`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x = &mut [0, 1, 2];\n    ///\n    /// if let Some(first) = x.first_chunk_mut::<2>() {\n    ///     first[0] = 5;\n    ///     first[1] = 4;\n    /// }\n    /// assert_eq!(x, &[5, 4, 2]);\n    ///\n    /// assert_eq!(None, x.first_chunk_mut::<4>());\n    /// ```\n    #[inline]\n    #[stable(feature = \"slice_first_last_chunk\", since = \"1.77.0\")]\n    #[rustc_const_stable(feature = \"const_slice_first_last_chunk\", since = \"1.83.0\")]\n    pub const fn first_chunk_mut<const N: usize>(&mut self) -> Option<&mut [T; N]> {\n        if self.len() < N {\n            None\n        } else {\n            // SAFETY: We explicitly check for the correct number of elements,\n            //   do not let the reference outlive the slice,\n            //   and require exclusive access to the entire slice to mutate the chunk.\n            Some(unsafe { &mut *(self.as_mut_ptr().cast_array()) })\n        }\n    }\n\n    /// Returns an array reference to the first `N` items in the slice and the remaining slice.\n    ///\n    /// If the slice is not at least `N` in length, this will return `None`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x = &[0, 1, 2];\n    ///\n    /// if let Some((first, elements)) = x.split_first_chunk::<2>() {\n    ///     assert_eq!(first, &[0, 1]);\n    ///     assert_eq!(elements, &[2]);\n    /// }\n    ///\n    /// assert_eq!(None, x.split_first_chunk::<4>());\n    /// ```\n    #[inline]\n    #[stable(feature = \"slice_first_last_chunk\", since = \"1.77.0\")]\n    #[rustc_const_stable(feature = \"slice_first_last_chunk\", since = \"1.77.0\")]\n    pub const fn split_first_chunk<const N: usize>(&self) -> Option<(&[T; N], &[T])> {\n        let Some((first, tail)) = self.split_at_checked(N) else { return None };\n\n        // SAFETY: We explicitly check for the correct number of elements,\n        //   and do not let the references outlive the slice.\n        Some((unsafe { &*(first.as_ptr().cast_array()) }, tail))\n    }\n\n    /// Returns a mutable array reference to the first `N` items in the slice and the remaining\n    /// slice.\n    ///\n    /// If the slice is not at least `N` in length, this will return `None`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x = &mut [0, 1, 2];\n    ///\n    /// if let Some((first, elements)) = x.split_first_chunk_mut::<2>() {\n    ///     first[0] = 3;\n    ///     first[1] = 4;\n    ///     elements[0] = 5;\n    /// }\n    /// assert_eq!(x, &[3, 4, 5]);\n    ///\n    /// assert_eq!(None, x.split_first_chunk_mut::<4>());\n    /// ```\n    #[inline]\n    #[stable(feature = \"slice_first_last_chunk\", since = \"1.77.0\")]\n    #[rustc_const_stable(feature = \"const_slice_first_last_chunk\", since = \"1.83.0\")]\n    pub const fn split_first_chunk_mut<const N: usize>(\n        &mut self,\n    ) -> Option<(&mut [T; N], &mut [T])> {\n        let Some((first, tail)) = self.split_at_mut_checked(N) else { return None };\n\n        // SAFETY: We explicitly check for the correct number of elements,\n        //   do not let the reference outlive the slice,\n        //   and enforce exclusive mutability of the chunk by the split.\n        Some((unsafe { &mut *(first.as_mut_ptr().cast_array()) }, tail))\n    }\n\n    /// Returns an array reference to the last `N` items in the slice and the remaining slice.\n    ///\n    /// If the slice is not at least `N` in length, this will return `None`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x = &[0, 1, 2];\n    ///\n    /// if let Some((elements, last)) = x.split_last_chunk::<2>() {\n    ///     assert_eq!(elements, &[0]);\n    ///     assert_eq!(last, &[1, 2]);\n    /// }\n    ///\n    /// assert_eq!(None, x.split_last_chunk::<4>());\n    /// ```\n    #[inline]\n    #[stable(feature = \"slice_first_last_chunk\", since = \"1.77.0\")]\n    #[rustc_const_stable(feature = \"slice_first_last_chunk\", since = \"1.77.0\")]\n    pub const fn split_last_chunk<const N: usize>(&self) -> Option<(&[T], &[T; N])> {\n        let Some(index) = self.len().checked_sub(N) else { return None };\n        let (init, last) = self.split_at(index);\n\n        // SAFETY: We explicitly check for the correct number of elements,\n        //   and do not let the references outlive the slice.\n        Some((init, unsafe { &*(last.as_ptr().cast_array()) }))\n    }\n\n    /// Returns a mutable array reference to the last `N` items in the slice and the remaining\n    /// slice.\n    ///\n    /// If the slice is not at least `N` in length, this will return `None`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x = &mut [0, 1, 2];\n    ///\n    /// if let Some((elements, last)) = x.split_last_chunk_mut::<2>() {\n    ///     last[0] = 3;\n    ///     last[1] = 4;\n    ///     elements[0] = 5;\n    /// }\n    /// assert_eq!(x, &[5, 3, 4]);\n    ///\n    /// assert_eq!(None, x.split_last_chunk_mut::<4>());\n    /// ```\n    #[inline]\n    #[stable(feature = \"slice_first_last_chunk\", since = \"1.77.0\")]\n    #[rustc_const_stable(feature = \"const_slice_first_last_chunk\", since = \"1.83.0\")]\n    pub const fn split_last_chunk_mut<const N: usize>(\n        &mut self,\n    ) -> Option<(&mut [T], &mut [T; N])> {\n        let Some(index) = self.len().checked_sub(N) else { return None };\n        let (init, last) = self.split_at_mut(index);\n\n        // SAFETY: We explicitly check for the correct number of elements,\n        //   do not let the reference outlive the slice,\n        //   and enforce exclusive mutability of the chunk by the split.\n        Some((init, unsafe { &mut *(last.as_mut_ptr().cast_array()) }))\n    }\n\n    /// Returns an array reference to the last `N` items in the slice.\n    ///\n    /// If the slice is not at least `N` in length, this will return `None`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let u = [10, 40, 30];\n    /// assert_eq!(Some(&[40, 30]), u.last_chunk::<2>());\n    ///\n    /// let v: &[i32] = &[10];\n    /// assert_eq!(None, v.last_chunk::<2>());\n    ///\n    /// let w: &[i32] = &[];\n    /// assert_eq!(Some(&[]), w.last_chunk::<0>());\n    /// ```\n    #[inline]\n    #[stable(feature = \"slice_first_last_chunk\", since = \"1.77.0\")]\n    #[rustc_const_stable(feature = \"const_slice_last_chunk\", since = \"1.80.0\")]\n    pub const fn last_chunk<const N: usize>(&self) -> Option<&[T; N]> {\n        // FIXME(const-hack): Without const traits, we need this instead of `get`.\n        let Some(index) = self.len().checked_sub(N) else { return None };\n        let (_, last) = self.split_at(index);\n\n        // SAFETY: We explicitly check for the correct number of elements,\n        //   and do not let the references outlive the slice.\n        Some(unsafe { &*(last.as_ptr().cast_array()) })\n    }\n\n    /// Returns a mutable array reference to the last `N` items in the slice.\n    ///\n    /// If the slice is not at least `N` in length, this will return `None`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x = &mut [0, 1, 2];\n    ///\n    /// if let Some(last) = x.last_chunk_mut::<2>() {\n    ///     last[0] = 10;\n    ///     last[1] = 20;\n    /// }\n    /// assert_eq!(x, &[0, 10, 20]);\n    ///\n    /// assert_eq!(None, x.last_chunk_mut::<4>());\n    /// ```\n    #[inline]\n    #[stable(feature = \"slice_first_last_chunk\", since = \"1.77.0\")]\n    #[rustc_const_stable(feature = \"const_slice_first_last_chunk\", since = \"1.83.0\")]\n    pub const fn last_chunk_mut<const N: usize>(&mut self) -> Option<&mut [T; N]> {\n        // FIXME(const-hack): Without const traits, we need this instead of `get`.\n        let Some(index) = self.len().checked_sub(N) else { return None };\n        let (_, last) = self.split_at_mut(index);\n\n        // SAFETY: We explicitly check for the correct number of elements,\n        //   do not let the reference outlive the slice,\n        //   and require exclusive access to the entire slice to mutate the chunk.\n        Some(unsafe { &mut *(last.as_mut_ptr().cast_array()) })\n    }\n\n    /// Returns a reference to an element or subslice depending on the type of\n    /// index.\n    ///\n    /// - If given a position, returns a reference to the element at that\n    ///   position or `None` if out of bounds.\n    /// - If given a range, returns the subslice corresponding to that range,\n    ///   or `None` if out of bounds.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let v = [10, 40, 30];\n    /// assert_eq!(Some(&40), v.get(1));\n    /// assert_eq!(Some(&[10, 40][..]), v.get(0..2));\n    /// assert_eq!(None, v.get(3));\n    /// assert_eq!(None, v.get(0..4));\n    /// ```\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_no_implicit_autorefs]\n    #[inline]\n    #[must_use]\n    #[rustc_const_unstable(feature = \"const_index\", issue = \"143775\")]\n    pub const fn get<I>(&self, index: I) -> Option<&I::Output>\n    where\n        I: [const] SliceIndex<Self>,\n    {\n        index.get(self)\n    }\n\n    /// Returns a mutable reference to an element or subslice depending on the\n    /// type of index (see [`get`]) or `None` if the index is out of bounds.\n    ///\n    /// [`get`]: slice::get\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x = &mut [0, 1, 2];\n    ///\n    /// if let Some(elem) = x.get_mut(1) {\n    ///     *elem = 42;\n    /// }\n    /// assert_eq!(x, &[0, 42, 2]);\n    /// ```\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_no_implicit_autorefs]\n    #[inline]\n    #[must_use]\n    #[rustc_const_unstable(feature = \"const_index\", issue = \"143775\")]\n    pub const fn get_mut<I>(&mut self, index: I) -> Option<&mut I::Output>\n    where\n        I: [const] SliceIndex<Self>,\n    {\n        index.get_mut(self)\n    }\n\n    /// Returns a reference to an element or subslice, without doing bounds\n    /// checking.\n    ///\n    /// For a safe alternative see [`get`].\n    ///\n    /// # Safety\n    ///\n    /// Calling this method with an out-of-bounds index is *[undefined behavior]*\n    /// even if the resulting reference is not used.\n    ///\n    /// You can think of this like `.get(index).unwrap_unchecked()`.  It's UB\n    /// to call `.get_unchecked(len)`, even if you immediately convert to a\n    /// pointer.  And it's UB to call `.get_unchecked(..len + 1)`,\n    /// `.get_unchecked(..=len)`, or similar.\n    ///\n    /// [`get`]: slice::get\n    /// [undefined behavior]: https://doc.rust-lang.org/reference/behavior-considered-undefined.html\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x = &[1, 2, 4];\n    ///\n    /// unsafe {\n    ///     assert_eq!(x.get_unchecked(1), &2);\n    /// }\n    /// ```\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_no_implicit_autorefs]\n    #[inline]\n    #[must_use]\n    #[track_caller]\n    #[rustc_const_unstable(feature = \"const_index\", issue = \"143775\")]\n    pub const unsafe fn get_unchecked<I>(&self, index: I) -> &I::Output\n    where\n        I: [const] SliceIndex<Self>,\n    {\n        // SAFETY: the caller must uphold most of the safety requirements for `get_unchecked`;\n        // the slice is dereferenceable because `self` is a safe reference.\n        // The returned pointer is safe because impls of `SliceIndex` have to guarantee that it is.\n        unsafe { &*index.get_unchecked(self) }\n    }\n\n    /// Returns a mutable reference to an element or subslice, without doing\n    /// bounds checking.\n    ///\n    /// For a safe alternative see [`get_mut`].\n    ///\n    /// # Safety\n    ///\n    /// Calling this method with an out-of-bounds index is *[undefined behavior]*\n    /// even if the resulting reference is not used.\n    ///\n    /// You can think of this like `.get_mut(index).unwrap_unchecked()`.  It's\n    /// UB to call `.get_unchecked_mut(len)`, even if you immediately convert\n    /// to a pointer.  And it's UB to call `.get_unchecked_mut(..len + 1)`,\n    /// `.get_unchecked_mut(..=len)`, or similar.\n    ///\n    /// [`get_mut`]: slice::get_mut\n    /// [undefined behavior]: https://doc.rust-lang.org/reference/behavior-considered-undefined.html\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x = &mut [1, 2, 4];\n    ///\n    /// unsafe {\n    ///     let elem = x.get_unchecked_mut(1);\n    ///     *elem = 13;\n    /// }\n    /// assert_eq!(x, &[1, 13, 4]);\n    /// ```\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_no_implicit_autorefs]\n    #[inline]\n    #[must_use]\n    #[track_caller]\n    #[rustc_const_unstable(feature = \"const_index\", issue = \"143775\")]\n    pub const unsafe fn get_unchecked_mut<I>(&mut self, index: I) -> &mut I::Output\n    where\n        I: [const] SliceIndex<Self>,\n    {\n        // SAFETY: the caller must uphold the safety requirements for `get_unchecked_mut`;\n        // the slice is dereferenceable because `self` is a safe reference.\n        // The returned pointer is safe because impls of `SliceIndex` have to guarantee that it is.\n        unsafe { &mut *index.get_unchecked_mut(self) }\n    }\n\n    /// Returns a raw pointer to the slice's buffer.\n    ///\n    /// The caller must ensure that the slice outlives the pointer this\n    /// function returns, or else it will end up dangling.\n    ///\n    /// The caller must also ensure that the memory the pointer (non-transitively) points to\n    /// is never written to (except inside an `UnsafeCell`) using this pointer or any pointer\n    /// derived from it. If you need to mutate the contents of the slice, use [`as_mut_ptr`].\n    ///\n    /// Modifying the container referenced by this slice may cause its buffer\n    /// to be reallocated, which would also make any pointers to it invalid.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x = &[1, 2, 4];\n    /// let x_ptr = x.as_ptr();\n    ///\n    /// unsafe {\n    ///     for i in 0..x.len() {\n    ///         assert_eq!(x.get_unchecked(i), &*x_ptr.add(i));\n    ///     }\n    /// }\n    /// ```\n    ///\n    /// [`as_mut_ptr`]: slice::as_mut_ptr\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_const_stable(feature = \"const_slice_as_ptr\", since = \"1.32.0\")]\n    #[rustc_never_returns_null_ptr]\n    #[rustc_as_ptr]\n    #[inline(always)]\n    #[must_use]\n    pub const fn as_ptr(&self) -> *const T {\n        self as *const [T] as *const T\n    }\n\n    /// Returns an unsafe mutable pointer to the slice's buffer.\n    ///\n    /// The caller must ensure that the slice outlives the pointer this\n    /// function returns, or else it will end up dangling.\n    ///\n    /// Modifying the container referenced by this slice may cause its buffer\n    /// to be reallocated, which would also make any pointers to it invalid.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x = &mut [1, 2, 4];\n    /// let x_ptr = x.as_mut_ptr();\n    ///\n    /// unsafe {\n    ///     for i in 0..x.len() {\n    ///         *x_ptr.add(i) += 2;\n    ///     }\n    /// }\n    /// assert_eq!(x, &[3, 4, 6]);\n    /// ```\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_const_stable(feature = \"const_ptr_offset\", since = \"1.61.0\")]\n    #[rustc_never_returns_null_ptr]\n    #[rustc_as_ptr]\n    #[inline(always)]\n    #[must_use]\n    pub const fn as_mut_ptr(&mut self) -> *mut T {\n        self as *mut [T] as *mut T\n    }\n\n    /// Returns the two raw pointers spanning the slice.\n    ///\n    /// The returned range is half-open, which means that the end pointer\n    /// points *one past* the last element of the slice. This way, an empty\n    /// slice is represented by two equal pointers, and the difference between\n    /// the two pointers represents the size of the slice.\n    ///\n    /// See [`as_ptr`] for warnings on using these pointers. The end pointer\n    /// requires extra caution, as it does not point to a valid element in the\n    /// slice.\n    ///\n    /// This function is useful for interacting with foreign interfaces which\n    /// use two pointers to refer to a range of elements in memory, as is\n    /// common in C++.\n    ///\n    /// It can also be useful to check if a pointer to an element refers to an\n    /// element of this slice:\n    ///\n    /// ```\n    /// let a = [1, 2, 3];\n    /// let x = &a[1] as *const _;\n    /// let y = &5 as *const _;\n    ///\n    /// assert!(a.as_ptr_range().contains(&x));\n    /// assert!(!a.as_ptr_range().contains(&y));\n    /// ```\n    ///\n    /// [`as_ptr`]: slice::as_ptr\n    #[stable(feature = \"slice_ptr_range\", since = \"1.48.0\")]\n    #[rustc_const_stable(feature = \"const_ptr_offset\", since = \"1.61.0\")]\n    #[inline]\n    #[must_use]\n    pub const fn as_ptr_range(&self) -> Range<*const T> {\n        let start = self.as_ptr();\n        // SAFETY: The `add` here is safe, because:\n        //\n        //   - Both pointers are part of the same object, as pointing directly\n        //     past the object also counts.\n        //\n        //   - The size of the slice is never larger than `isize::MAX` bytes, as\n        //     noted here:\n        //       - https://github.com/rust-lang/unsafe-code-guidelines/issues/102#issuecomment-473340447\n        //       - https://doc.rust-lang.org/reference/behavior-considered-undefined.html\n        //       - https://doc.rust-lang.org/core/slice/fn.from_raw_parts.html#safety\n        //     (This doesn't seem normative yet, but the very same assumption is\n        //     made in many places, including the Index implementation of slices.)\n        //\n        //   - There is no wrapping around involved, as slices do not wrap past\n        //     the end of the address space.\n        //\n        // See the documentation of [`pointer::add`].\n        let end = unsafe { start.add(self.len()) };\n        start..end\n    }\n\n    /// Returns the two unsafe mutable pointers spanning the slice.\n    ///\n    /// The returned range is half-open, which means that the end pointer\n    /// points *one past* the last element of the slice. This way, an empty\n    /// slice is represented by two equal pointers, and the difference between\n    /// the two pointers represents the size of the slice.\n    ///\n    /// See [`as_mut_ptr`] for warnings on using these pointers. The end\n    /// pointer requires extra caution, as it does not point to a valid element\n    /// in the slice.\n    ///\n    /// This function is useful for interacting with foreign interfaces which\n    /// use two pointers to refer to a range of elements in memory, as is\n    /// common in C++.\n    ///\n    /// [`as_mut_ptr`]: slice::as_mut_ptr\n    #[stable(feature = \"slice_ptr_range\", since = \"1.48.0\")]\n    #[rustc_const_stable(feature = \"const_ptr_offset\", since = \"1.61.0\")]\n    #[inline]\n    #[must_use]\n    pub const fn as_mut_ptr_range(&mut self) -> Range<*mut T> {\n        let start = self.as_mut_ptr();\n        // SAFETY: See as_ptr_range() above for why `add` here is safe.\n        let end = unsafe { start.add(self.len()) };\n        start..end\n    }\n\n    /// Gets a reference to the underlying array.\n    ///\n    /// If `N` is not exactly equal to the length of `self`, then this method returns `None`.\n    #[stable(feature = \"core_slice_as_array\", since = \"1.93.0\")]\n    #[rustc_const_stable(feature = \"core_slice_as_array\", since = \"1.93.0\")]\n    #[inline]\n    #[must_use]\n    pub const fn as_array<const N: usize>(&self) -> Option<&[T; N]> {\n        if self.len() == N {\n            let ptr = self.as_ptr().cast_array();\n\n            // SAFETY: The underlying array of a slice can be reinterpreted as an actual array `[T; N]` if `N` is not greater than the slice's length.\n            let me = unsafe { &*ptr };\n            Some(me)\n        } else {\n            None\n        }\n    }\n\n    /// Gets a mutable reference to the slice's underlying array.\n    ///\n    /// If `N` is not exactly equal to the length of `self`, then this method returns `None`.\n    #[stable(feature = \"core_slice_as_array\", since = \"1.93.0\")]\n    #[rustc_const_stable(feature = \"core_slice_as_array\", since = \"1.93.0\")]\n    #[inline]\n    #[must_use]\n    pub const fn as_mut_array<const N: usize>(&mut self) -> Option<&mut [T; N]> {\n        if self.len() == N {\n            let ptr = self.as_mut_ptr().cast_array();\n\n            // SAFETY: The underlying array of a slice can be reinterpreted as an actual array `[T; N]` if `N` is not greater than the slice's length.\n            let me = unsafe { &mut *ptr };\n            Some(me)\n        } else {\n            None\n        }\n    }\n\n    /// Swaps two elements in the slice.\n    ///\n    /// If `a` equals to `b`, it's guaranteed that elements won't change value.\n    ///\n    /// # Arguments\n    ///\n    /// * a - The index of the first element\n    /// * b - The index of the second element\n    ///\n    /// # Panics\n    ///\n    /// Panics if `a` or `b` are out of bounds.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut v = [\"a\", \"b\", \"c\", \"d\", \"e\"];\n    /// v.swap(2, 4);\n    /// assert!(v == [\"a\", \"b\", \"e\", \"d\", \"c\"]);\n    /// ```\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_const_stable(feature = \"const_swap\", since = \"1.85.0\")]\n    #[inline]\n    #[track_caller]\n    pub const fn swap(&mut self, a: usize, b: usize) {\n        // FIXME: use swap_unchecked here (https://github.com/rust-lang/rust/pull/88540#issuecomment-944344343)\n        // Can't take two mutable loans from one vector, so instead use raw pointers.\n        let pa = &raw mut self[a];\n        let pb = &raw mut self[b];\n        // SAFETY: `pa` and `pb` have been created from safe mutable references and refer\n        // to elements in the slice and therefore are guaranteed to be valid and aligned.\n        // Note that accessing the elements behind `a` and `b` is checked and will\n        // panic when out of bounds.\n        unsafe {\n            ptr::swap(pa, pb);\n        }\n    }\n\n    /// Swaps two elements in the slice, without doing bounds checking.\n    ///\n    /// For a safe alternative see [`swap`].\n    ///\n    /// # Arguments\n    ///\n    /// * a - The index of the first element\n    /// * b - The index of the second element\n    ///\n    /// # Safety\n    ///\n    /// Calling this method with an out-of-bounds index is *[undefined behavior]*.\n    /// The caller has to ensure that `a < self.len()` and `b < self.len()`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(slice_swap_unchecked)]\n    ///\n    /// let mut v = [\"a\", \"b\", \"c\", \"d\"];\n    /// // SAFETY: we know that 1 and 3 are both indices of the slice\n    /// unsafe { v.swap_unchecked(1, 3) };\n    /// assert!(v == [\"a\", \"d\", \"c\", \"b\"]);\n    /// ```\n    ///\n    /// [`swap`]: slice::swap\n    /// [undefined behavior]: https://doc.rust-lang.org/reference/behavior-considered-undefined.html\n    #[unstable(feature = \"slice_swap_unchecked\", issue = \"88539\")]\n    #[track_caller]\n    pub const unsafe fn swap_unchecked(&mut self, a: usize, b: usize) {\n        assert_unsafe_precondition!(\n            check_library_ub,\n            \"slice::swap_unchecked requires that the indices are within the slice\",\n            (\n                len: usize = self.len(),\n                a: usize = a,\n                b: usize = b,\n            ) => a < len && b < len,\n        );\n\n        let ptr = self.as_mut_ptr();\n        // SAFETY: caller has to guarantee that `a < self.len()` and `b < self.len()`\n        unsafe {\n            ptr::swap(ptr.add(a), ptr.add(b));\n        }\n    }\n\n    /// Reverses the order of elements in the slice, in place.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut v = [1, 2, 3];\n    /// v.reverse();\n    /// assert!(v == [3, 2, 1]);\n    /// ```\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_const_stable(feature = \"const_slice_reverse\", since = \"1.90.0\")]\n    #[inline]\n    pub const fn reverse(&mut self) {\n        let half_len = self.len() / 2;\n        let Range { start, end } = self.as_mut_ptr_range();\n\n        // These slices will skip the middle item for an odd length,\n        // since that one doesn't need to move.\n        let (front_half, back_half) =\n            // SAFETY: Both are subparts of the original slice, so the memory\n            // range is valid, and they don't overlap because they're each only\n            // half (or less) of the original slice.\n            unsafe {\n                (\n                    slice::from_raw_parts_mut(start, half_len),\n                    slice::from_raw_parts_mut(end.sub(half_len), half_len),\n                )\n            };\n\n        // Introducing a function boundary here means that the two halves\n        // get `noalias` markers, allowing better optimization as LLVM\n        // knows that they're disjoint, unlike in the original slice.\n        revswap(front_half, back_half, half_len);\n\n        #[inline]\n        const fn revswap<T>(a: &mut [T], b: &mut [T], n: usize) {\n            debug_assert!(a.len() == n);\n            debug_assert!(b.len() == n);\n\n            // Because this function is first compiled in isolation,\n            // this check tells LLVM that the indexing below is\n            // in-bounds. Then after inlining -- once the actual\n            // lengths of the slices are known -- it's removed.\n            // FIXME(const_trait_impl) replace with let (a, b) = (&mut a[..n], &mut b[..n]);\n            let (a, _) = a.split_at_mut(n);\n            let (b, _) = b.split_at_mut(n);\n\n            let mut i = 0;\n            while i < n {\n                mem::swap(&mut a[i], &mut b[n - 1 - i]);\n                i += 1;\n            }\n        }\n    }\n\n    /// Returns an iterator over the slice.\n    ///\n    /// The iterator yields all items from start to end.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x = &[1, 2, 4];\n    /// let mut iterator = x.iter();\n    ///\n    /// assert_eq!(iterator.next(), Some(&1));\n    /// assert_eq!(iterator.next(), Some(&2));\n    /// assert_eq!(iterator.next(), Some(&4));\n    /// assert_eq!(iterator.next(), None);\n    /// ```\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_const_unstable(feature = \"const_slice_make_iter\", issue = \"137737\")]\n    #[inline]\n    #[rustc_diagnostic_item = \"slice_iter\"]\n    pub const fn iter(&self) -> Iter<'_, T> {\n        Iter::new(self)\n    }\n\n    /// Returns an iterator that allows modifying each value.\n    ///\n    /// The iterator yields all items from start to end.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x = &mut [1, 2, 4];\n    /// for elem in x.iter_mut() {\n    ///     *elem += 2;\n    /// }\n    /// assert_eq!(x, &[3, 4, 6]);\n    /// ```\n    #[rustc_const_unstable(feature = \"const_slice_make_iter\", issue = \"137737\")]\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[inline]\n    pub const fn iter_mut(&mut self) -> IterMut<'_, T> {\n        IterMut::new(self)\n    }\n\n    /// Returns an iterator over all contiguous windows of length\n    /// `size`. The windows overlap. If the slice is shorter than\n    /// `size`, the iterator returns no values.\n    ///\n    /// # Panics\n    ///\n    /// Panics if `size` is zero.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let slice = ['l', 'o', 'r', 'e', 'm'];\n    /// let mut iter = slice.windows(3);\n    /// assert_eq!(iter.next().unwrap(), &['l', 'o', 'r']);\n    /// assert_eq!(iter.next().unwrap(), &['o', 'r', 'e']);\n    /// assert_eq!(iter.next().unwrap(), &['r', 'e', 'm']);\n    /// assert!(iter.next().is_none());\n    /// ```\n    ///\n    /// If the slice is shorter than `size`:\n    ///\n    /// ```\n    /// let slice = ['f', 'o', 'o'];\n    /// let mut iter = slice.windows(4);\n    /// assert!(iter.next().is_none());\n    /// ```\n    ///\n    /// Because the [Iterator] trait cannot represent the required lifetimes,\n    /// there is no `windows_mut` analog to `windows`;\n    /// `[0,1,2].windows_mut(2).collect()` would violate [the rules of references]\n    /// (though a [LendingIterator] analog is possible). You can sometimes use\n    /// [`Cell::as_slice_of_cells`](crate::cell::Cell::as_slice_of_cells) in\n    /// conjunction with `windows` instead:\n    ///\n    /// [the rules of references]: https://doc.rust-lang.org/book/ch04-02-references-and-borrowing.html#the-rules-of-references\n    /// [LendingIterator]: https://blog.rust-lang.org/2022/10/28/gats-stabilization.html\n    /// ```\n    /// use std::cell::Cell;\n    ///\n    /// let mut array = ['R', 'u', 's', 't', ' ', '2', '0', '1', '5'];\n    /// let slice = &mut array[..];\n    /// let slice_of_cells: &[Cell<char>] = Cell::from_mut(slice).as_slice_of_cells();\n    /// for w in slice_of_cells.windows(3) {\n    ///     Cell::swap(&w[0], &w[2]);\n    /// }\n    /// assert_eq!(array, ['s', 't', ' ', '2', '0', '1', '5', 'u', 'R']);\n    /// ```\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_const_unstable(feature = \"const_slice_make_iter\", issue = \"137737\")]\n    #[inline]\n    #[track_caller]\n    pub const fn windows(&self, size: usize) -> Windows<'_, T> {\n        let size = NonZero::new(size).expect(\"window size must be non-zero\");\n        Windows::new(self, size)\n    }\n\n    /// Returns an iterator over `chunk_size` elements of the slice at a time, starting at the\n    /// beginning of the slice.\n    ///\n    /// The chunks are slices and do not overlap. If `chunk_size` does not divide the length of the\n    /// slice, then the last chunk will not have length `chunk_size`.\n    ///\n    /// See [`chunks_exact`] for a variant of this iterator that returns chunks of always exactly\n    /// `chunk_size` elements, and [`rchunks`] for the same iterator but starting at the end of the\n    /// slice.\n    ///\n    /// If your `chunk_size` is a constant, consider using [`as_chunks`] instead, which will\n    /// give references to arrays of exactly that length, rather than slices.\n    ///\n    /// # Panics\n    ///\n    /// Panics if `chunk_size` is zero.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let slice = ['l', 'o', 'r', 'e', 'm'];\n    /// let mut iter = slice.chunks(2);\n    /// assert_eq!(iter.next().unwrap(), &['l', 'o']);\n    /// assert_eq!(iter.next().unwrap(), &['r', 'e']);\n    /// assert_eq!(iter.next().unwrap(), &['m']);\n    /// assert!(iter.next().is_none());\n    /// ```\n    ///\n    /// [`chunks_exact`]: slice::chunks_exact\n    /// [`rchunks`]: slice::rchunks\n    /// [`as_chunks`]: slice::as_chunks\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_const_unstable(feature = \"const_slice_make_iter\", issue = \"137737\")]\n    #[inline]\n    #[track_caller]\n    pub const fn chunks(&self, chunk_size: usize) -> Chunks<'_, T> {\n        assert!(chunk_size != 0, \"chunk size must be non-zero\");\n        Chunks::new(self, chunk_size)\n    }\n\n    /// Returns an iterator over `chunk_size` elements of the slice at a time, starting at the\n    /// beginning of the slice.\n    ///\n    /// The chunks are mutable slices, and do not overlap. If `chunk_size` does not divide the\n    /// length of the slice, then the last chunk will not have length `chunk_size`.\n    ///\n    /// See [`chunks_exact_mut`] for a variant of this iterator that returns chunks of always\n    /// exactly `chunk_size` elements, and [`rchunks_mut`] for the same iterator but starting at\n    /// the end of the slice.\n    ///\n    /// If your `chunk_size` is a constant, consider using [`as_chunks_mut`] instead, which will\n    /// give references to arrays of exactly that length, rather than slices.\n    ///\n    /// # Panics\n    ///\n    /// Panics if `chunk_size` is zero.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let v = &mut [0, 0, 0, 0, 0];\n    /// let mut count = 1;\n    ///\n    /// for chunk in v.chunks_mut(2) {\n    ///     for elem in chunk.iter_mut() {\n    ///         *elem += count;\n    ///     }\n    ///     count += 1;\n    /// }\n    /// assert_eq!(v, &[1, 1, 2, 2, 3]);\n    /// ```\n    ///\n    /// [`chunks_exact_mut`]: slice::chunks_exact_mut\n    /// [`rchunks_mut`]: slice::rchunks_mut\n    /// [`as_chunks_mut`]: slice::as_chunks_mut\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_const_unstable(feature = \"const_slice_make_iter\", issue = \"137737\")]\n    #[inline]\n    #[track_caller]\n    pub const fn chunks_mut(&mut self, chunk_size: usize) -> ChunksMut<'_, T> {\n        assert!(chunk_size != 0, \"chunk size must be non-zero\");\n        ChunksMut::new(self, chunk_size)\n    }\n\n    /// Returns an iterator over `chunk_size` elements of the slice at a time, starting at the\n    /// beginning of the slice.\n    ///\n    /// The chunks are slices and do not overlap. If `chunk_size` does not divide the length of the\n    /// slice, then the last up to `chunk_size-1` elements will be omitted and can be retrieved\n    /// from the `remainder` function of the iterator.\n    ///\n    /// Due to each chunk having exactly `chunk_size` elements, the compiler can often optimize the\n    /// resulting code better than in the case of [`chunks`].\n    ///\n    /// See [`chunks`] for a variant of this iterator that also returns the remainder as a smaller\n    /// chunk, and [`rchunks_exact`] for the same iterator but starting at the end of the slice.\n    ///\n    /// If your `chunk_size` is a constant, consider using [`as_chunks`] instead, which will\n    /// give references to arrays of exactly that length, rather than slices.\n    ///\n    /// # Panics\n    ///\n    /// Panics if `chunk_size` is zero.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let slice = ['l', 'o', 'r', 'e', 'm'];\n    /// let mut iter = slice.chunks_exact(2);\n    /// assert_eq!(iter.next().unwrap(), &['l', 'o']);\n    /// assert_eq!(iter.next().unwrap(), &['r', 'e']);\n    /// assert!(iter.next().is_none());\n    /// assert_eq!(iter.remainder(), &['m']);\n    /// ```\n    ///\n    /// [`chunks`]: slice::chunks\n    /// [`rchunks_exact`]: slice::rchunks_exact\n    /// [`as_chunks`]: slice::as_chunks\n    #[stable(feature = \"chunks_exact\", since = \"1.31.0\")]\n    #[rustc_const_unstable(feature = \"const_slice_make_iter\", issue = \"137737\")]\n    #[inline]\n    #[track_caller]\n    pub const fn chunks_exact(&self, chunk_size: usize) -> ChunksExact<'_, T> {\n        assert!(chunk_size != 0, \"chunk size must be non-zero\");\n        ChunksExact::new(self, chunk_size)\n    }\n\n    /// Returns an iterator over `chunk_size` elements of the slice at a time, starting at the\n    /// beginning of the slice.\n    ///\n    /// The chunks are mutable slices, and do not overlap. If `chunk_size` does not divide the\n    /// length of the slice, then the last up to `chunk_size-1` elements will be omitted and can be\n    /// retrieved from the `into_remainder` function of the iterator.\n    ///\n    /// Due to each chunk having exactly `chunk_size` elements, the compiler can often optimize the\n    /// resulting code better than in the case of [`chunks_mut`].\n    ///\n    /// See [`chunks_mut`] for a variant of this iterator that also returns the remainder as a\n    /// smaller chunk, and [`rchunks_exact_mut`] for the same iterator but starting at the end of\n    /// the slice.\n    ///\n    /// If your `chunk_size` is a constant, consider using [`as_chunks_mut`] instead, which will\n    /// give references to arrays of exactly that length, rather than slices.\n    ///\n    /// # Panics\n    ///\n    /// Panics if `chunk_size` is zero.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let v = &mut [0, 0, 0, 0, 0];\n    /// let mut count = 1;\n    ///\n    /// for chunk in v.chunks_exact_mut(2) {\n    ///     for elem in chunk.iter_mut() {\n    ///         *elem += count;\n    ///     }\n    ///     count += 1;\n    /// }\n    /// assert_eq!(v, &[1, 1, 2, 2, 0]);\n    /// ```\n    ///\n    /// [`chunks_mut`]: slice::chunks_mut\n    /// [`rchunks_exact_mut`]: slice::rchunks_exact_mut\n    /// [`as_chunks_mut`]: slice::as_chunks_mut\n    #[stable(feature = \"chunks_exact\", since = \"1.31.0\")]\n    #[rustc_const_unstable(feature = \"const_slice_make_iter\", issue = \"137737\")]\n    #[inline]\n    #[track_caller]\n    pub const fn chunks_exact_mut(&mut self, chunk_size: usize) -> ChunksExactMut<'_, T> {\n        assert!(chunk_size != 0, \"chunk size must be non-zero\");\n        ChunksExactMut::new(self, chunk_size)\n    }\n\n    /// Splits the slice into a slice of `N`-element arrays,\n    /// assuming that there's no remainder.\n    ///\n    /// This is the inverse operation to [`as_flattened`].\n    ///\n    /// [`as_flattened`]: slice::as_flattened\n    ///\n    /// As this is `unsafe`, consider whether you could use [`as_chunks`] or\n    /// [`as_rchunks`] instead, perhaps via something like\n    /// `if let (chunks, []) = slice.as_chunks()` or\n    /// `let (chunks, []) = slice.as_chunks() else { unreachable!() };`.\n    ///\n    /// [`as_chunks`]: slice::as_chunks\n    /// [`as_rchunks`]: slice::as_rchunks\n    ///\n    /// # Safety\n    ///\n    /// This may only be called when\n    /// - The slice splits exactly into `N`-element chunks (aka `self.len() % N == 0`).\n    /// - `N != 0`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let slice: &[char] = &['l', 'o', 'r', 'e', 'm', '!'];\n    /// let chunks: &[[char; 1]] =\n    ///     // SAFETY: 1-element chunks never have remainder\n    ///     unsafe { slice.as_chunks_unchecked() };\n    /// assert_eq!(chunks, &[['l'], ['o'], ['r'], ['e'], ['m'], ['!']]);\n    /// let chunks: &[[char; 3]] =\n    ///     // SAFETY: The slice length (6) is a multiple of 3\n    ///     unsafe { slice.as_chunks_unchecked() };\n    /// assert_eq!(chunks, &[['l', 'o', 'r'], ['e', 'm', '!']]);\n    ///\n    /// // These would be unsound:\n    /// // let chunks: &[[_; 5]] = slice.as_chunks_unchecked() // The slice length is not a multiple of 5\n    /// // let chunks: &[[_; 0]] = slice.as_chunks_unchecked() // Zero-length chunks are never allowed\n    /// ```\n    #[stable(feature = \"slice_as_chunks\", since = \"1.88.0\")]\n    #[rustc_const_stable(feature = \"slice_as_chunks\", since = \"1.88.0\")]\n    #[inline]\n    #[must_use]\n    #[track_caller]\n    pub const unsafe fn as_chunks_unchecked<const N: usize>(&self) -> &[[T; N]] {\n        assert_unsafe_precondition!(\n            check_language_ub,\n            \"slice::as_chunks_unchecked requires `N != 0` and the slice to split exactly into `N`-element chunks\",\n            (n: usize = N, len: usize = self.len()) => n != 0 && len.is_multiple_of(n),\n        );\n        // SAFETY: Caller must guarantee that `N` is nonzero and exactly divides the slice length\n        let new_len = unsafe { exact_div(self.len(), N) };\n        // SAFETY: We cast a slice of `new_len * N` elements into\n        // a slice of `new_len` many `N` elements chunks.\n        unsafe { from_raw_parts(self.as_ptr().cast(), new_len) }\n    }\n\n    /// Splits the slice into a slice of `N`-element arrays,\n    /// starting at the beginning of the slice,\n    /// and a remainder slice with length strictly less than `N`.\n    ///\n    /// The remainder is meaningful in the division sense.  Given\n    /// `let (chunks, remainder) = slice.as_chunks()`, then:\n    /// - `chunks.len()` equals `slice.len() / N`,\n    /// - `remainder.len()` equals `slice.len() % N`, and\n    /// - `slice.len()` equals `chunks.len() * N + remainder.len()`.\n    ///\n    /// You can flatten the chunks back into a slice-of-`T` with [`as_flattened`].\n    ///\n    /// [`as_flattened`]: slice::as_flattened\n    ///\n    /// # Panics\n    ///\n    /// Panics if `N` is zero.\n    ///\n    /// Note that this check is against a const generic parameter, not a runtime\n    /// value, and thus a particular monomorphization will either always panic\n    /// or it will never panic.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let slice = ['l', 'o', 'r', 'e', 'm'];\n    /// let (chunks, remainder) = slice.as_chunks();\n    /// assert_eq!(chunks, &[['l', 'o'], ['r', 'e']]);\n    /// assert_eq!(remainder, &['m']);\n    /// ```\n    ///\n    /// If you expect the slice to be an exact multiple, you can combine\n    /// `let`-`else` with an empty slice pattern:\n    /// ```\n    /// let slice = ['R', 'u', 's', 't'];\n    /// let (chunks, []) = slice.as_chunks::<2>() else {\n    ///     panic!(\"slice didn't have even length\")\n    /// };\n    /// assert_eq!(chunks, &[['R', 'u'], ['s', 't']]);\n    /// ```\n    #[stable(feature = \"slice_as_chunks\", since = \"1.88.0\")]\n    #[rustc_const_stable(feature = \"slice_as_chunks\", since = \"1.88.0\")]\n    #[inline]\n    #[track_caller]\n    #[must_use]\n    pub const fn as_chunks<const N: usize>(&self) -> (&[[T; N]], &[T]) {\n        assert!(N != 0, \"chunk size must be non-zero\");\n        let len_rounded_down = self.len() / N * N;\n        // SAFETY: The rounded-down value is always the same or smaller than the\n        // original length, and thus must be in-bounds of the slice.\n        let (multiple_of_n, remainder) = unsafe { self.split_at_unchecked(len_rounded_down) };\n        // SAFETY: We already panicked for zero, and ensured by construction\n        // that the length of the subslice is a multiple of N.\n        let array_slice = unsafe { multiple_of_n.as_chunks_unchecked() };\n        (array_slice, remainder)\n    }\n\n    /// Splits the slice into a slice of `N`-element arrays,\n    /// starting at the end of the slice,\n    /// and a remainder slice with length strictly less than `N`.\n    ///\n    /// The remainder is meaningful in the division sense.  Given\n    /// `let (remainder, chunks) = slice.as_rchunks()`, then:\n    /// - `remainder.len()` equals `slice.len() % N`,\n    /// - `chunks.len()` equals `slice.len() / N`, and\n    /// - `slice.len()` equals `chunks.len() * N + remainder.len()`.\n    ///\n    /// You can flatten the chunks back into a slice-of-`T` with [`as_flattened`].\n    ///\n    /// [`as_flattened`]: slice::as_flattened\n    ///\n    /// # Panics\n    ///\n    /// Panics if `N` is zero.\n    ///\n    /// Note that this check is against a const generic parameter, not a runtime\n    /// value, and thus a particular monomorphization will either always panic\n    /// or it will never panic.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let slice = ['l', 'o', 'r', 'e', 'm'];\n    /// let (remainder, chunks) = slice.as_rchunks();\n    /// assert_eq!(remainder, &['l']);\n    /// assert_eq!(chunks, &[['o', 'r'], ['e', 'm']]);\n    /// ```\n    #[stable(feature = \"slice_as_chunks\", since = \"1.88.0\")]\n    #[rustc_const_stable(feature = \"slice_as_chunks\", since = \"1.88.0\")]\n    #[inline]\n    #[track_caller]\n    #[must_use]\n    pub const fn as_rchunks<const N: usize>(&self) -> (&[T], &[[T; N]]) {\n        assert!(N != 0, \"chunk size must be non-zero\");\n        let len = self.len() / N;\n        let (remainder, multiple_of_n) = self.split_at(self.len() - len * N);\n        // SAFETY: We already panicked for zero, and ensured by construction\n        // that the length of the subslice is a multiple of N.\n        let array_slice = unsafe { multiple_of_n.as_chunks_unchecked() };\n        (remainder, array_slice)\n    }\n\n    /// Splits the slice into a slice of `N`-element arrays,\n    /// assuming that there's no remainder.\n    ///\n    /// This is the inverse operation to [`as_flattened_mut`].\n    ///\n    /// [`as_flattened_mut`]: slice::as_flattened_mut\n    ///\n    /// As this is `unsafe`, consider whether you could use [`as_chunks_mut`] or\n    /// [`as_rchunks_mut`] instead, perhaps via something like\n    /// `if let (chunks, []) = slice.as_chunks_mut()` or\n    /// `let (chunks, []) = slice.as_chunks_mut() else { unreachable!() };`.\n    ///\n    /// [`as_chunks_mut`]: slice::as_chunks_mut\n    /// [`as_rchunks_mut`]: slice::as_rchunks_mut\n    ///\n    /// # Safety\n    ///\n    /// This may only be called when\n    /// - The slice splits exactly into `N`-element chunks (aka `self.len() % N == 0`).\n    /// - `N != 0`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let slice: &mut [char] = &mut ['l', 'o', 'r', 'e', 'm', '!'];\n    /// let chunks: &mut [[char; 1]] =\n    ///     // SAFETY: 1-element chunks never have remainder\n    ///     unsafe { slice.as_chunks_unchecked_mut() };\n    /// chunks[0] = ['L'];\n    /// assert_eq!(chunks, &[['L'], ['o'], ['r'], ['e'], ['m'], ['!']]);\n    /// let chunks: &mut [[char; 3]] =\n    ///     // SAFETY: The slice length (6) is a multiple of 3\n    ///     unsafe { slice.as_chunks_unchecked_mut() };\n    /// chunks[1] = ['a', 'x', '?'];\n    /// assert_eq!(slice, &['L', 'o', 'r', 'a', 'x', '?']);\n    ///\n    /// // These would be unsound:\n    /// // let chunks: &[[_; 5]] = slice.as_chunks_unchecked_mut() // The slice length is not a multiple of 5\n    /// // let chunks: &[[_; 0]] = slice.as_chunks_unchecked_mut() // Zero-length chunks are never allowed\n    /// ```\n    #[stable(feature = \"slice_as_chunks\", since = \"1.88.0\")]\n    #[rustc_const_stable(feature = \"slice_as_chunks\", since = \"1.88.0\")]\n    #[inline]\n    #[must_use]\n    #[track_caller]\n    pub const unsafe fn as_chunks_unchecked_mut<const N: usize>(&mut self) -> &mut [[T; N]] {\n        assert_unsafe_precondition!(\n            check_language_ub,\n            \"slice::as_chunks_unchecked requires `N != 0` and the slice to split exactly into `N`-element chunks\",\n            (n: usize = N, len: usize = self.len()) => n != 0 && len.is_multiple_of(n)\n        );\n        // SAFETY: Caller must guarantee that `N` is nonzero and exactly divides the slice length\n        let new_len = unsafe { exact_div(self.len(), N) };\n        // SAFETY: We cast a slice of `new_len * N` elements into\n        // a slice of `new_len` many `N` elements chunks.\n        unsafe { from_raw_parts_mut(self.as_mut_ptr().cast(), new_len) }\n    }\n\n    /// Splits the slice into a slice of `N`-element arrays,\n    /// starting at the beginning of the slice,\n    /// and a remainder slice with length strictly less than `N`.\n    ///\n    /// The remainder is meaningful in the division sense.  Given\n    /// `let (chunks, remainder) = slice.as_chunks_mut()`, then:\n    /// - `chunks.len()` equals `slice.len() / N`,\n    /// - `remainder.len()` equals `slice.len() % N`, and\n    /// - `slice.len()` equals `chunks.len() * N + remainder.len()`.\n    ///\n    /// You can flatten the chunks back into a slice-of-`T` with [`as_flattened_mut`].\n    ///\n    /// [`as_flattened_mut`]: slice::as_flattened_mut\n    ///\n    /// # Panics\n    ///\n    /// Panics if `N` is zero.\n    ///\n    /// Note that this check is against a const generic parameter, not a runtime\n    /// value, and thus a particular monomorphization will either always panic\n    /// or it will never panic.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let v = &mut [0, 0, 0, 0, 0];\n    /// let mut count = 1;\n    ///\n    /// let (chunks, remainder) = v.as_chunks_mut();\n    /// remainder[0] = 9;\n    /// for chunk in chunks {\n    ///     *chunk = [count; 2];\n    ///     count += 1;\n    /// }\n    /// assert_eq!(v, &[1, 1, 2, 2, 9]);\n    /// ```\n    #[stable(feature = \"slice_as_chunks\", since = \"1.88.0\")]\n    #[rustc_const_stable(feature = \"slice_as_chunks\", since = \"1.88.0\")]\n    #[inline]\n    #[track_caller]\n    #[must_use]\n    pub const fn as_chunks_mut<const N: usize>(&mut self) -> (&mut [[T; N]], &mut [T]) {\n        assert!(N != 0, \"chunk size must be non-zero\");\n        let len_rounded_down = self.len() / N * N;\n        // SAFETY: The rounded-down value is always the same or smaller than the\n        // original length, and thus must be in-bounds of the slice.\n        let (multiple_of_n, remainder) = unsafe { self.split_at_mut_unchecked(len_rounded_down) };\n        // SAFETY: We already panicked for zero, and ensured by construction\n        // that the length of the subslice is a multiple of N.\n        let array_slice = unsafe { multiple_of_n.as_chunks_unchecked_mut() };\n        (array_slice, remainder)\n    }\n\n    /// Splits the slice into a slice of `N`-element arrays,\n    /// starting at the end of the slice,\n    /// and a remainder slice with length strictly less than `N`.\n    ///\n    /// The remainder is meaningful in the division sense.  Given\n    /// `let (remainder, chunks) = slice.as_rchunks_mut()`, then:\n    /// - `remainder.len()` equals `slice.len() % N`,\n    /// - `chunks.len()` equals `slice.len() / N`, and\n    /// - `slice.len()` equals `chunks.len() * N + remainder.len()`.\n    ///\n    /// You can flatten the chunks back into a slice-of-`T` with [`as_flattened_mut`].\n    ///\n    /// [`as_flattened_mut`]: slice::as_flattened_mut\n    ///\n    /// # Panics\n    ///\n    /// Panics if `N` is zero.\n    ///\n    /// Note that this check is against a const generic parameter, not a runtime\n    /// value, and thus a particular monomorphization will either always panic\n    /// or it will never panic.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let v = &mut [0, 0, 0, 0, 0];\n    /// let mut count = 1;\n    ///\n    /// let (remainder, chunks) = v.as_rchunks_mut();\n    /// remainder[0] = 9;\n    /// for chunk in chunks {\n    ///     *chunk = [count; 2];\n    ///     count += 1;\n    /// }\n    /// assert_eq!(v, &[9, 1, 1, 2, 2]);\n    /// ```\n    #[stable(feature = \"slice_as_chunks\", since = \"1.88.0\")]\n    #[rustc_const_stable(feature = \"slice_as_chunks\", since = \"1.88.0\")]\n    #[inline]\n    #[track_caller]\n    #[must_use]\n    pub const fn as_rchunks_mut<const N: usize>(&mut self) -> (&mut [T], &mut [[T; N]]) {\n        assert!(N != 0, \"chunk size must be non-zero\");\n        let len = self.len() / N;\n        let (remainder, multiple_of_n) = self.split_at_mut(self.len() - len * N);\n        // SAFETY: We already panicked for zero, and ensured by construction\n        // that the length of the subslice is a multiple of N.\n        let array_slice = unsafe { multiple_of_n.as_chunks_unchecked_mut() };\n        (remainder, array_slice)\n    }\n\n    /// Returns an iterator over overlapping windows of `N` elements of a slice,\n    /// starting at the beginning of the slice.\n    ///\n    /// This is the const generic equivalent of [`windows`].\n    ///\n    /// If `N` is greater than the size of the slice, it will return no windows.\n    ///\n    /// # Panics\n    ///\n    /// Panics if `N` is zero. This check will most probably get changed to a compile time\n    /// error before this method gets stabilized.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(array_windows)]\n    /// let slice = [0, 1, 2, 3];\n    /// let mut iter = slice.array_windows();\n    /// assert_eq!(iter.next().unwrap(), &[0, 1]);\n    /// assert_eq!(iter.next().unwrap(), &[1, 2]);\n    /// assert_eq!(iter.next().unwrap(), &[2, 3]);\n    /// assert!(iter.next().is_none());\n    /// ```\n    ///\n    /// [`windows`]: slice::windows\n    #[unstable(feature = \"array_windows\", issue = \"75027\")]\n    #[rustc_const_unstable(feature = \"const_slice_make_iter\", issue = \"137737\")]\n    #[inline]\n    #[track_caller]\n    pub const fn array_windows<const N: usize>(&self) -> ArrayWindows<'_, T, N> {\n        assert!(N != 0, \"window size must be non-zero\");\n        ArrayWindows::new(self)\n    }\n\n    /// Returns an iterator over `chunk_size` elements of the slice at a time, starting at the end\n    /// of the slice.\n    ///\n    /// The chunks are slices and do not overlap. If `chunk_size` does not divide the length of the\n    /// slice, then the last chunk will not have length `chunk_size`.\n    ///\n    /// See [`rchunks_exact`] for a variant of this iterator that returns chunks of always exactly\n    /// `chunk_size` elements, and [`chunks`] for the same iterator but starting at the beginning\n    /// of the slice.\n    ///\n    /// If your `chunk_size` is a constant, consider using [`as_rchunks`] instead, which will\n    /// give references to arrays of exactly that length, rather than slices.\n    ///\n    /// # Panics\n    ///\n    /// Panics if `chunk_size` is zero.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let slice = ['l', 'o', 'r', 'e', 'm'];\n    /// let mut iter = slice.rchunks(2);\n    /// assert_eq!(iter.next().unwrap(), &['e', 'm']);\n    /// assert_eq!(iter.next().unwrap(), &['o', 'r']);\n    /// assert_eq!(iter.next().unwrap(), &['l']);\n    /// assert!(iter.next().is_none());\n    /// ```\n    ///\n    /// [`rchunks_exact`]: slice::rchunks_exact\n    /// [`chunks`]: slice::chunks\n    /// [`as_rchunks`]: slice::as_rchunks\n    #[stable(feature = \"rchunks\", since = \"1.31.0\")]\n    #[rustc_const_unstable(feature = \"const_slice_make_iter\", issue = \"137737\")]\n    #[inline]\n    #[track_caller]\n    pub const fn rchunks(&self, chunk_size: usize) -> RChunks<'_, T> {\n        assert!(chunk_size != 0, \"chunk size must be non-zero\");\n        RChunks::new(self, chunk_size)\n    }\n\n    /// Returns an iterator over `chunk_size` elements of the slice at a time, starting at the end\n    /// of the slice.\n    ///\n    /// The chunks are mutable slices, and do not overlap. If `chunk_size` does not divide the\n    /// length of the slice, then the last chunk will not have length `chunk_size`.\n    ///\n    /// See [`rchunks_exact_mut`] for a variant of this iterator that returns chunks of always\n    /// exactly `chunk_size` elements, and [`chunks_mut`] for the same iterator but starting at the\n    /// beginning of the slice.\n    ///\n    /// If your `chunk_size` is a constant, consider using [`as_rchunks_mut`] instead, which will\n    /// give references to arrays of exactly that length, rather than slices.\n    ///\n    /// # Panics\n    ///\n    /// Panics if `chunk_size` is zero.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let v = &mut [0, 0, 0, 0, 0];\n    /// let mut count = 1;\n    ///\n    /// for chunk in v.rchunks_mut(2) {\n    ///     for elem in chunk.iter_mut() {\n    ///         *elem += count;\n    ///     }\n    ///     count += 1;\n    /// }\n    /// assert_eq!(v, &[3, 2, 2, 1, 1]);\n    /// ```\n    ///\n    /// [`rchunks_exact_mut`]: slice::rchunks_exact_mut\n    /// [`chunks_mut`]: slice::chunks_mut\n    /// [`as_rchunks_mut`]: slice::as_rchunks_mut\n    #[stable(feature = \"rchunks\", since = \"1.31.0\")]\n    #[rustc_const_unstable(feature = \"const_slice_make_iter\", issue = \"137737\")]\n    #[inline]\n    #[track_caller]\n    pub const fn rchunks_mut(&mut self, chunk_size: usize) -> RChunksMut<'_, T> {\n        assert!(chunk_size != 0, \"chunk size must be non-zero\");\n        RChunksMut::new(self, chunk_size)\n    }\n\n    /// Returns an iterator over `chunk_size` elements of the slice at a time, starting at the\n    /// end of the slice.\n    ///\n    /// The chunks are slices and do not overlap. If `chunk_size` does not divide the length of the\n    /// slice, then the last up to `chunk_size-1` elements will be omitted and can be retrieved\n    /// from the `remainder` function of the iterator.\n    ///\n    /// Due to each chunk having exactly `chunk_size` elements, the compiler can often optimize the\n    /// resulting code better than in the case of [`rchunks`].\n    ///\n    /// See [`rchunks`] for a variant of this iterator that also returns the remainder as a smaller\n    /// chunk, and [`chunks_exact`] for the same iterator but starting at the beginning of the\n    /// slice.\n    ///\n    /// If your `chunk_size` is a constant, consider using [`as_rchunks`] instead, which will\n    /// give references to arrays of exactly that length, rather than slices.\n    ///\n    /// # Panics\n    ///\n    /// Panics if `chunk_size` is zero.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let slice = ['l', 'o', 'r', 'e', 'm'];\n    /// let mut iter = slice.rchunks_exact(2);\n    /// assert_eq!(iter.next().unwrap(), &['e', 'm']);\n    /// assert_eq!(iter.next().unwrap(), &['o', 'r']);\n    /// assert!(iter.next().is_none());\n    /// assert_eq!(iter.remainder(), &['l']);\n    /// ```\n    ///\n    /// [`chunks`]: slice::chunks\n    /// [`rchunks`]: slice::rchunks\n    /// [`chunks_exact`]: slice::chunks_exact\n    /// [`as_rchunks`]: slice::as_rchunks\n    #[stable(feature = \"rchunks\", since = \"1.31.0\")]\n    #[rustc_const_unstable(feature = \"const_slice_make_iter\", issue = \"137737\")]\n    #[inline]\n    #[track_caller]\n    pub const fn rchunks_exact(&self, chunk_size: usize) -> RChunksExact<'_, T> {\n        assert!(chunk_size != 0, \"chunk size must be non-zero\");\n        RChunksExact::new(self, chunk_size)\n    }\n\n    /// Returns an iterator over `chunk_size` elements of the slice at a time, starting at the end\n    /// of the slice.\n    ///\n    /// The chunks are mutable slices, and do not overlap. If `chunk_size` does not divide the\n    /// length of the slice, then the last up to `chunk_size-1` elements will be omitted and can be\n    /// retrieved from the `into_remainder` function of the iterator.\n    ///\n    /// Due to each chunk having exactly `chunk_size` elements, the compiler can often optimize the\n    /// resulting code better than in the case of [`chunks_mut`].\n    ///\n    /// See [`rchunks_mut`] for a variant of this iterator that also returns the remainder as a\n    /// smaller chunk, and [`chunks_exact_mut`] for the same iterator but starting at the beginning\n    /// of the slice.\n    ///\n    /// If your `chunk_size` is a constant, consider using [`as_rchunks_mut`] instead, which will\n    /// give references to arrays of exactly that length, rather than slices.\n    ///\n    /// # Panics\n    ///\n    /// Panics if `chunk_size` is zero.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let v = &mut [0, 0, 0, 0, 0];\n    /// let mut count = 1;\n    ///\n    /// for chunk in v.rchunks_exact_mut(2) {\n    ///     for elem in chunk.iter_mut() {\n    ///         *elem += count;\n    ///     }\n    ///     count += 1;\n    /// }\n    /// assert_eq!(v, &[0, 2, 2, 1, 1]);\n    /// ```\n    ///\n    /// [`chunks_mut`]: slice::chunks_mut\n    /// [`rchunks_mut`]: slice::rchunks_mut\n    /// [`chunks_exact_mut`]: slice::chunks_exact_mut\n    /// [`as_rchunks_mut`]: slice::as_rchunks_mut\n    #[stable(feature = \"rchunks\", since = \"1.31.0\")]\n    #[rustc_const_unstable(feature = \"const_slice_make_iter\", issue = \"137737\")]\n    #[inline]\n    #[track_caller]\n    pub const fn rchunks_exact_mut(&mut self, chunk_size: usize) -> RChunksExactMut<'_, T> {\n        assert!(chunk_size != 0, \"chunk size must be non-zero\");\n        RChunksExactMut::new(self, chunk_size)\n    }\n\n    /// Returns an iterator over the slice producing non-overlapping runs\n    /// of elements using the predicate to separate them.\n    ///\n    /// The predicate is called for every pair of consecutive elements,\n    /// meaning that it is called on `slice[0]` and `slice[1]`,\n    /// followed by `slice[1]` and `slice[2]`, and so on.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let slice = &[1, 1, 1, 3, 3, 2, 2, 2];\n    ///\n    /// let mut iter = slice.chunk_by(|a, b| a == b);\n    ///\n    /// assert_eq!(iter.next(), Some(&[1, 1, 1][..]));\n    /// assert_eq!(iter.next(), Some(&[3, 3][..]));\n    /// assert_eq!(iter.next(), Some(&[2, 2, 2][..]));\n    /// assert_eq!(iter.next(), None);\n    /// ```\n    ///\n    /// This method can be used to extract the sorted subslices:\n    ///\n    /// ```\n    /// let slice = &[1, 1, 2, 3, 2, 3, 2, 3, 4];\n    ///\n    /// let mut iter = slice.chunk_by(|a, b| a <= b);\n    ///\n    /// assert_eq!(iter.next(), Some(&[1, 1, 2, 3][..]));\n    /// assert_eq!(iter.next(), Some(&[2, 3][..]));\n    /// assert_eq!(iter.next(), Some(&[2, 3, 4][..]));\n    /// assert_eq!(iter.next(), None);\n    /// ```\n    #[stable(feature = \"slice_group_by\", since = \"1.77.0\")]\n    #[rustc_const_unstable(feature = \"const_slice_make_iter\", issue = \"137737\")]\n    #[inline]\n    pub const fn chunk_by<F>(&self, pred: F) -> ChunkBy<'_, T, F>\n    where\n        F: FnMut(&T, &T) -> bool,\n    {\n        ChunkBy::new(self, pred)\n    }\n\n    /// Returns an iterator over the slice producing non-overlapping mutable\n    /// runs of elements using the predicate to separate them.\n    ///\n    /// The predicate is called for every pair of consecutive elements,\n    /// meaning that it is called on `slice[0]` and `slice[1]`,\n    /// followed by `slice[1]` and `slice[2]`, and so on.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let slice = &mut [1, 1, 1, 3, 3, 2, 2, 2];\n    ///\n    /// let mut iter = slice.chunk_by_mut(|a, b| a == b);\n    ///\n    /// assert_eq!(iter.next(), Some(&mut [1, 1, 1][..]));\n    /// assert_eq!(iter.next(), Some(&mut [3, 3][..]));\n    /// assert_eq!(iter.next(), Some(&mut [2, 2, 2][..]));\n    /// assert_eq!(iter.next(), None);\n    /// ```\n    ///\n    /// This method can be used to extract the sorted subslices:\n    ///\n    /// ```\n    /// let slice = &mut [1, 1, 2, 3, 2, 3, 2, 3, 4];\n    ///\n    /// let mut iter = slice.chunk_by_mut(|a, b| a <= b);\n    ///\n    /// assert_eq!(iter.next(), Some(&mut [1, 1, 2, 3][..]));\n    /// assert_eq!(iter.next(), Some(&mut [2, 3][..]));\n    /// assert_eq!(iter.next(), Some(&mut [2, 3, 4][..]));\n    /// assert_eq!(iter.next(), None);\n    /// ```\n    #[stable(feature = \"slice_group_by\", since = \"1.77.0\")]\n    #[rustc_const_unstable(feature = \"const_slice_make_iter\", issue = \"137737\")]\n    #[inline]\n    pub const fn chunk_by_mut<F>(&mut self, pred: F) -> ChunkByMut<'_, T, F>\n    where\n        F: FnMut(&T, &T) -> bool,\n    {\n        ChunkByMut::new(self, pred)\n    }\n\n    /// Divides one slice into two at an index.\n    ///\n    /// The first will contain all indices from `[0, mid)` (excluding\n    /// the index `mid` itself) and the second will contain all\n    /// indices from `[mid, len)` (excluding the index `len` itself).\n    ///\n    /// # Panics\n    ///\n    /// Panics if `mid > len`.  For a non-panicking alternative see\n    /// [`split_at_checked`](slice::split_at_checked).\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let v = ['a', 'b', 'c'];\n    ///\n    /// {\n    ///    let (left, right) = v.split_at(0);\n    ///    assert_eq!(left, []);\n    ///    assert_eq!(right, ['a', 'b', 'c']);\n    /// }\n    ///\n    /// {\n    ///     let (left, right) = v.split_at(2);\n    ///     assert_eq!(left, ['a', 'b']);\n    ///     assert_eq!(right, ['c']);\n    /// }\n    ///\n    /// {\n    ///     let (left, right) = v.split_at(3);\n    ///     assert_eq!(left, ['a', 'b', 'c']);\n    ///     assert_eq!(right, []);\n    /// }\n    /// ```\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[rustc_const_stable(feature = \"const_slice_split_at_not_mut\", since = \"1.71.0\")]\n    #[inline]\n    #[track_caller]\n    #[must_use]\n    pub const fn split_at(&self, mid: usize) -> (&[T], &[T]) {\n        match self.split_at_checked(mid) {\n            Some(pair) => pair,\n            None => panic!(\"mid > len\"),\n        }\n    }\n\n    /// Divides one mutable slice into two at an index.\n    ///\n    /// The first will contain all indices from `[0, mid)` (excluding\n    /// the index `mid` itself) and the second will contain all\n    /// indices from `[mid, len)` (excluding the index `len` itself).\n    ///\n    /// # Panics\n    ///\n    /// Panics if `mid > len`.  For a non-panicking alternative see\n    /// [`split_at_mut_checked`](slice::split_at_mut_checked).\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut v = [1, 0, 3, 0, 5, 6];\n    /// let (left, right) = v.split_at_mut(2);\n    /// assert_eq!(left, [1, 0]);\n    /// assert_eq!(right, [3, 0, 5, 6]);\n    /// left[1] = 2;\n    /// right[1] = 4;\n    /// assert_eq!(v, [1, 2, 3, 4, 5, 6]);\n    /// ```\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[inline]\n    #[track_caller]\n    #[must_use]\n    #[rustc_const_stable(feature = \"const_slice_split_at_mut\", since = \"1.83.0\")]\n    pub const fn split_at_mut(&mut self, mid: usize) -> (&mut [T], &mut [T]) {\n        match self.split_at_mut_checked(mid) {\n            Some(pair) => pair,\n            None => panic!(\"mid > len\"),\n        }\n    }\n\n    /// Divides one slice into two at an index, without doing bounds checking.\n    ///\n    /// The first will contain all indices from `[0, mid)` (excluding\n    /// the index `mid` itself) and the second will contain all\n    /// indices from `[mid, len)` (excluding the index `len` itself).\n    ///\n    /// For a safe alternative see [`split_at`].\n    ///\n    /// # Safety\n    ///\n    /// Calling this method with an out-of-bounds index is *[undefined behavior]*\n    /// even if the resulting reference is not used. The caller has to ensure that\n    /// `0 <= mid <= self.len()`.\n    ///\n    /// [`split_at`]: slice::split_at\n    /// [undefined behavior]: https://doc.rust-lang.org/reference/behavior-considered-undefined.html\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let v = ['a', 'b', 'c'];\n    ///\n    /// unsafe {\n    ///    let (left, right) = v.split_at_unchecked(0);\n    ///    assert_eq!(left, []);\n    ///    assert_eq!(right, ['a', 'b', 'c']);\n    /// }\n    ///\n    /// unsafe {\n    ///     let (left, right) = v.split_at_unchecked(2);\n    ///     assert_eq!(left, ['a', 'b']);\n    ///     assert_eq!(right, ['c']);\n    /// }\n    ///\n    /// unsafe {\n    ///     let (left, right) = v.split_at_unchecked(3);\n    ///     assert_eq!(left, ['a', 'b', 'c']);\n    ///     assert_eq!(right, []);\n    /// }\n    /// ```\n    #[stable(feature = \"slice_split_at_unchecked\", since = \"1.79.0\")]\n    #[rustc_const_stable(feature = \"const_slice_split_at_unchecked\", since = \"1.77.0\")]\n    #[inline]\n    #[must_use]\n    #[track_caller]\n    pub const unsafe fn split_at_unchecked(&self, mid: usize) -> (&[T], &[T]) {\n        // FIXME(const-hack): the const function `from_raw_parts` is used to make this\n        // function const; previously the implementation used\n        // `(self.get_unchecked(..mid), self.get_unchecked(mid..))`\n\n        let len = self.len();\n        let ptr = self.as_ptr();\n\n        assert_unsafe_precondition!(\n            check_library_ub,\n            \"slice::split_at_unchecked requires the index to be within the slice\",\n            (mid: usize = mid, len: usize = len) => mid <= len,\n        );\n\n        // SAFETY: Caller has to check that `0 <= mid <= self.len()`\n        unsafe { (from_raw_parts(ptr, mid), from_raw_parts(ptr.add(mid), unchecked_sub(len, mid))) }\n    }\n\n    /// Divides one mutable slice into two at an index, without doing bounds checking.\n    ///\n    /// The first will contain all indices from `[0, mid)` (excluding\n    /// the index `mid` itself) and the second will contain all\n    /// indices from `[mid, len)` (excluding the index `len` itself).\n    ///\n    /// For a safe alternative see [`split_at_mut`].\n    ///\n    /// # Safety\n    ///\n    /// Calling this method with an out-of-bounds index is *[undefined behavior]*\n    /// even if the resulting reference is not used. The caller has to ensure that\n    /// `0 <= mid <= self.len()`.\n    ///\n    /// [`split_at_mut`]: slice::split_at_mut\n    /// [undefined behavior]: https://doc.rust-lang.org/reference/behavior-considered-undefined.html\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut v = [1, 0, 3, 0, 5, 6];\n    /// // scoped to restrict the lifetime of the borrows\n    /// unsafe {\n    ///     let (left, right) = v.split_at_mut_unchecked(2);\n    ///     assert_eq!(left, [1, 0]);\n    ///     assert_eq!(right, [3, 0, 5, 6]);\n    ///     left[1] = 2;\n    ///     right[1] = 4;\n    /// }\n    /// assert_eq!(v, [1, 2, 3, 4, 5, 6]);\n    /// ```\n    #[stable(feature = \"slice_split_at_unchecked\", since = \"1.79.0\")]\n    #[rustc_const_stable(feature = \"const_slice_split_at_mut\", since = \"1.83.0\")]\n    #[inline]\n    #[must_use]\n    #[track_caller]\n    pub const unsafe fn split_at_mut_unchecked(&mut self, mid: usize) -> (&mut [T], &mut [T]) {\n        let len = self.len();\n        let ptr = self.as_mut_ptr();\n\n        assert_unsafe_precondition!(\n            check_library_ub,\n            \"slice::split_at_mut_unchecked requires the index to be within the slice\",\n            (mid: usize = mid, len: usize = len) => mid <= len,\n        );\n\n        // SAFETY: Caller has to check that `0 <= mid <= self.len()`.\n        //\n        // `[ptr; mid]` and `[mid; len]` are not overlapping, so returning a mutable reference\n        // is fine.\n        unsafe {\n            (\n                from_raw_parts_mut(ptr, mid),\n                from_raw_parts_mut(ptr.add(mid), unchecked_sub(len, mid)),\n            )\n        }\n    }\n\n    /// Divides one slice into two at an index, returning `None` if the slice is\n    /// too short.\n    ///\n    /// If `mid ≤ len` returns a pair of slices where the first will contain all\n    /// indices from `[0, mid)` (excluding the index `mid` itself) and the\n    /// second will contain all indices from `[mid, len)` (excluding the index\n    /// `len` itself).\n    ///\n    /// Otherwise, if `mid > len`, returns `None`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let v = [1, -2, 3, -4, 5, -6];\n    ///\n    /// {\n    ///    let (left, right) = v.split_at_checked(0).unwrap();\n    ///    assert_eq!(left, []);\n    ///    assert_eq!(right, [1, -2, 3, -4, 5, -6]);\n    /// }\n    ///\n    /// {\n    ///     let (left, right) = v.split_at_checked(2).unwrap();\n    ///     assert_eq!(left, [1, -2]);\n    ///     assert_eq!(right, [3, -4, 5, -6]);\n    /// }\n    ///\n    /// {\n    ///     let (left, right) = v.split_at_checked(6).unwrap();\n    ///     assert_eq!(left, [1, -2, 3, -4, 5, -6]);\n    ///     assert_eq!(right, []);\n    /// }\n    ///\n    /// assert_eq!(None, v.split_at_checked(7));\n    /// ```\n    #[stable(feature = \"split_at_checked\", since = \"1.80.0\")]\n    #[rustc_const_stable(feature = \"split_at_checked\", since = \"1.80.0\")]\n    #[inline]\n    #[must_use]\n    pub const fn split_at_checked(&self, mid: usize) -> Option<(&[T], &[T])> {\n        if mid <= self.len() {\n            // SAFETY: `[ptr; mid]` and `[mid; len]` are inside `self`, which\n            // fulfills the requirements of `split_at_unchecked`.\n            Some(unsafe { self.split_at_unchecked(mid) })\n        } else {\n            None\n        }\n    }\n\n    /// Divides one mutable slice into two at an index, returning `None` if the\n    /// slice is too short.\n    ///\n    /// If `mid ≤ len` returns a pair of slices where the first will contain all\n    /// indices from `[0, mid)` (excluding the index `mid` itself) and the\n    /// second will contain all indices from `[mid, len)` (excluding the index\n    /// `len` itself).\n    ///\n    /// Otherwise, if `mid > len`, returns `None`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut v = [1, 0, 3, 0, 5, 6];\n    ///\n    /// if let Some((left, right)) = v.split_at_mut_checked(2) {\n    ///     assert_eq!(left, [1, 0]);\n    ///     assert_eq!(right, [3, 0, 5, 6]);\n    ///     left[1] = 2;\n    ///     right[1] = 4;\n    /// }\n    /// assert_eq!(v, [1, 2, 3, 4, 5, 6]);\n    ///\n    /// assert_eq!(None, v.split_at_mut_checked(7));\n    /// ```\n    #[stable(feature = \"split_at_checked\", since = \"1.80.0\")]\n    #[rustc_const_stable(feature = \"const_slice_split_at_mut\", since = \"1.83.0\")]\n    #[inline]\n    #[must_use]\n    pub const fn split_at_mut_checked(&mut self, mid: usize) -> Option<(&mut [T], &mut [T])> {\n        if mid <= self.len() {\n            // SAFETY: `[ptr; mid]` and `[mid; len]` are inside `self`, which\n            // fulfills the requirements of `split_at_unchecked`.\n            Some(unsafe { self.split_at_mut_unchecked(mid) })\n        } else {\n            None\n        }\n    }\n\n    /// Returns an iterator over subslices separated by elements that match\n    /// `pred`. The matched element is not contained in the subslices.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let slice = [10, 40, 33, 20];\n    /// let mut iter = slice.split(|num| num % 3 == 0);\n    ///\n    /// assert_eq!(iter.next().unwrap(), &[10, 40]);\n    /// assert_eq!(iter.next().unwrap(), &[20]);\n    /// assert!(iter.next().is_none());\n    /// ```\n    ///\n    /// If the first element is matched, an empty slice will be the first item\n    /// returned by the iterator. Similarly, if the last element in the slice\n    /// is matched, an empty slice will be the last item returned by the\n    /// iterator:\n    ///\n    /// ```\n    /// let slice = [10, 40, 33];\n    /// let mut iter = slice.split(|num| num % 3 == 0);\n    ///\n    /// assert_eq!(iter.next().unwrap(), &[10, 40]);\n    /// assert_eq!(iter.next().unwrap(), &[]);\n    /// assert!(iter.next().is_none());\n    /// ```\n    ///\n    /// If two matched elements are directly adjacent, an empty slice will be\n    /// present between them:\n    ///\n    /// ```\n    /// let slice = [10, 6, 33, 20];\n    /// let mut iter = slice.split(|num| num % 3 == 0);\n    ///\n    /// assert_eq!(iter.next().unwrap(), &[10]);\n    /// assert_eq!(iter.next().unwrap(), &[]);\n    /// assert_eq!(iter.next().unwrap(), &[20]);\n    /// assert!(iter.next().is_none());\n    /// ```\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[inline]\n    pub fn split<F>(&self, pred: F) -> Split<'_, T, F>\n    where\n        F: FnMut(&T) -> bool,\n    {\n        Split::new(self, pred)\n    }\n\n    /// Returns an iterator over mutable subslices separated by elements that\n    /// match `pred`. The matched element is not contained in the subslices.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut v = [10, 40, 30, 20, 60, 50];\n    ///\n    /// for group in v.split_mut(|num| *num % 3 == 0) {\n    ///     group[0] = 1;\n    /// }\n    /// assert_eq!(v, [1, 40, 30, 1, 60, 1]);\n    /// ```\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[inline]\n    pub fn split_mut<F>(&mut self, pred: F) -> SplitMut<'_, T, F>\n    where\n        F: FnMut(&T) -> bool,\n    {\n        SplitMut::new(self, pred)\n    }\n\n    /// Returns an iterator over subslices separated by elements that match\n    /// `pred`. The matched element is contained in the end of the previous\n    /// subslice as a terminator.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let slice = [10, 40, 33, 20];\n    /// let mut iter = slice.split_inclusive(|num| num % 3 == 0);\n    ///\n    /// assert_eq!(iter.next().unwrap(), &[10, 40, 33]);\n    /// assert_eq!(iter.next().unwrap(), &[20]);\n    /// assert!(iter.next().is_none());\n    /// ```\n    ///\n    /// If the last element of the slice is matched,\n    /// that element will be considered the terminator of the preceding slice.\n    /// That slice will be the last item returned by the iterator.\n    ///\n    /// ```\n    /// let slice = [3, 10, 40, 33];\n    /// let mut iter = slice.split_inclusive(|num| num % 3 == 0);\n    ///\n    /// assert_eq!(iter.next().unwrap(), &[3]);\n    /// assert_eq!(iter.next().unwrap(), &[10, 40, 33]);\n    /// assert!(iter.next().is_none());\n    /// ```\n    #[stable(feature = \"split_inclusive\", since = \"1.51.0\")]\n    #[inline]\n    pub fn split_inclusive<F>(&self, pred: F) -> SplitInclusive<'_, T, F>\n    where\n        F: FnMut(&T) -> bool,\n    {\n        SplitInclusive::new(self, pred)\n    }\n\n    /// Returns an iterator over mutable subslices separated by elements that\n    /// match `pred`. The matched element is contained in the previous\n    /// subslice as a terminator.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut v = [10, 40, 30, 20, 60, 50];\n    ///\n    /// for group in v.split_inclusive_mut(|num| *num % 3 == 0) {\n    ///     let terminator_idx = group.len()-1;\n    ///     group[terminator_idx] = 1;\n    /// }\n    /// assert_eq!(v, [10, 40, 1, 20, 1, 1]);\n    /// ```\n    #[stable(feature = \"split_inclusive\", since = \"1.51.0\")]\n    #[inline]\n    pub fn split_inclusive_mut<F>(&mut self, pred: F) -> SplitInclusiveMut<'_, T, F>\n    where\n        F: FnMut(&T) -> bool,\n    {\n        SplitInclusiveMut::new(self, pred)\n    }\n\n    /// Returns an iterator over subslices separated by elements that match\n    /// `pred`, starting at the end of the slice and working backwards.\n    /// The matched element is not contained in the subslices.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let slice = [11, 22, 33, 0, 44, 55];\n    /// let mut iter = slice.rsplit(|num| *num == 0);\n    ///\n    /// assert_eq!(iter.next().unwrap(), &[44, 55]);\n    /// assert_eq!(iter.next().unwrap(), &[11, 22, 33]);\n    /// assert_eq!(iter.next(), None);\n    /// ```\n    ///\n    /// As with `split()`, if the first or last element is matched, an empty\n    /// slice will be the first (or last) item returned by the iterator.\n    ///\n    /// ```\n    /// let v = &[0, 1, 1, 2, 3, 5, 8];\n    /// let mut it = v.rsplit(|n| *n % 2 == 0);\n    /// assert_eq!(it.next().unwrap(), &[]);\n    /// assert_eq!(it.next().unwrap(), &[3, 5]);\n    /// assert_eq!(it.next().unwrap(), &[1, 1]);\n    /// assert_eq!(it.next().unwrap(), &[]);\n    /// assert_eq!(it.next(), None);\n    /// ```\n    #[stable(feature = \"slice_rsplit\", since = \"1.27.0\")]\n    #[inline]\n    pub fn rsplit<F>(&self, pred: F) -> RSplit<'_, T, F>\n    where\n        F: FnMut(&T) -> bool,\n    {\n        RSplit::new(self, pred)\n    }\n\n    /// Returns an iterator over mutable subslices separated by elements that\n    /// match `pred`, starting at the end of the slice and working\n    /// backwards. The matched element is not contained in the subslices.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut v = [100, 400, 300, 200, 600, 500];\n    ///\n    /// let mut count = 0;\n    /// for group in v.rsplit_mut(|num| *num % 3 == 0) {\n    ///     count += 1;\n    ///     group[0] = count;\n    /// }\n    /// assert_eq!(v, [3, 400, 300, 2, 600, 1]);\n    /// ```\n    ///\n    #[stable(feature = \"slice_rsplit\", since = \"1.27.0\")]\n    #[inline]\n    pub fn rsplit_mut<F>(&mut self, pred: F) -> RSplitMut<'_, T, F>\n    where\n        F: FnMut(&T) -> bool,\n    {\n        RSplitMut::new(self, pred)\n    }\n\n    /// Returns an iterator over subslices separated by elements that match\n    /// `pred`, limited to returning at most `n` items. The matched element is\n    /// not contained in the subslices.\n    ///\n    /// The last element returned, if any, will contain the remainder of the\n    /// slice.\n    ///\n    /// # Examples\n    ///\n    /// Print the slice split once by numbers divisible by 3 (i.e., `[10, 40]`,\n    /// `[20, 60, 50]`):\n    ///\n    /// ```\n    /// let v = [10, 40, 30, 20, 60, 50];\n    ///\n    /// for group in v.splitn(2, |num| *num % 3 == 0) {\n    ///     println!(\"{group:?}\");\n    /// }\n    /// ```\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[inline]\n    pub fn splitn<F>(&self, n: usize, pred: F) -> SplitN<'_, T, F>\n    where\n        F: FnMut(&T) -> bool,\n    {\n        SplitN::new(self.split(pred), n)\n    }\n\n    /// Returns an iterator over mutable subslices separated by elements that match\n    /// `pred`, limited to returning at most `n` items. The matched element is\n    /// not contained in the subslices.\n    ///\n    /// The last element returned, if any, will contain the remainder of the\n    /// slice.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut v = [10, 40, 30, 20, 60, 50];\n    ///\n    /// for group in v.splitn_mut(2, |num| *num % 3 == 0) {\n    ///     group[0] = 1;\n    /// }\n    /// assert_eq!(v, [1, 40, 30, 1, 60, 50]);\n    /// ```\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[inline]\n    pub fn splitn_mut<F>(&mut self, n: usize, pred: F) -> SplitNMut<'_, T, F>\n    where\n        F: FnMut(&T) -> bool,\n    {\n        SplitNMut::new(self.split_mut(pred), n)\n    }\n\n    /// Returns an iterator over subslices separated by elements that match\n    /// `pred` limited to returning at most `n` items. This starts at the end of\n    /// the slice and works backwards. The matched element is not contained in\n    /// the subslices.\n    ///\n    /// The last element returned, if any, will contain the remainder of the\n    /// slice.\n    ///\n    /// # Examples\n    ///\n    /// Print the slice split once, starting from the end, by numbers divisible\n    /// by 3 (i.e., `[50]`, `[10, 40, 30, 20]`):\n    ///\n    /// ```\n    /// let v = [10, 40, 30, 20, 60, 50];\n    ///\n    /// for group in v.rsplitn(2, |num| *num % 3 == 0) {\n    ///     println!(\"{group:?}\");\n    /// }\n    /// ```\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[inline]\n    pub fn rsplitn<F>(&self, n: usize, pred: F) -> RSplitN<'_, T, F>\n    where\n        F: FnMut(&T) -> bool,\n    {\n        RSplitN::new(self.rsplit(pred), n)\n    }\n\n    /// Returns an iterator over subslices separated by elements that match\n    /// `pred` limited to returning at most `n` items. This starts at the end of\n    /// the slice and works backwards. The matched element is not contained in\n    /// the subslices.\n    ///\n    /// The last element returned, if any, will contain the remainder of the\n    /// slice.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut s = [10, 40, 30, 20, 60, 50];\n    ///\n    /// for group in s.rsplitn_mut(2, |num| *num % 3 == 0) {\n    ///     group[0] = 1;\n    /// }\n    /// assert_eq!(s, [1, 40, 30, 20, 60, 1]);\n    /// ```\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[inline]\n    pub fn rsplitn_mut<F>(&mut self, n: usize, pred: F) -> RSplitNMut<'_, T, F>\n    where\n        F: FnMut(&T) -> bool,\n    {\n        RSplitNMut::new(self.rsplit_mut(pred), n)\n    }\n\n    /// Splits the slice on the first element that matches the specified\n    /// predicate.\n    ///\n    /// If any matching elements are present in the slice, returns the prefix\n    /// before the match and suffix after. The matching element itself is not\n    /// included. If no elements match, returns `None`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(slice_split_once)]\n    /// let s = [1, 2, 3, 2, 4];\n    /// assert_eq!(s.split_once(|&x| x == 2), Some((\n    ///     &[1][..],\n    ///     &[3, 2, 4][..]\n    /// )));\n    /// assert_eq!(s.split_once(|&x| x == 0), None);\n    /// ```\n    #[unstable(feature = \"slice_split_once\", reason = \"newly added\", issue = \"112811\")]\n    #[inline]\n    pub fn split_once<F>(&self, pred: F) -> Option<(&[T], &[T])>\n    where\n        F: FnMut(&T) -> bool,\n    {\n        let index = self.iter().position(pred)?;\n        Some((&self[..index], &self[index + 1..]))\n    }\n\n    /// Splits the slice on the last element that matches the specified\n    /// predicate.\n    ///\n    /// If any matching elements are present in the slice, returns the prefix\n    /// before the match and suffix after. The matching element itself is not\n    /// included. If no elements match, returns `None`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(slice_split_once)]\n    /// let s = [1, 2, 3, 2, 4];\n    /// assert_eq!(s.rsplit_once(|&x| x == 2), Some((\n    ///     &[1, 2, 3][..],\n    ///     &[4][..]\n    /// )));\n    /// assert_eq!(s.rsplit_once(|&x| x == 0), None);\n    /// ```\n    #[unstable(feature = \"slice_split_once\", reason = \"newly added\", issue = \"112811\")]\n    #[inline]\n    pub fn rsplit_once<F>(&self, pred: F) -> Option<(&[T], &[T])>\n    where\n        F: FnMut(&T) -> bool,\n    {\n        let index = self.iter().rposition(pred)?;\n        Some((&self[..index], &self[index + 1..]))\n    }\n\n    /// Returns `true` if the slice contains an element with the given value.\n    ///\n    /// This operation is *O*(*n*).\n    ///\n    /// Note that if you have a sorted slice, [`binary_search`] may be faster.\n    ///\n    /// [`binary_search`]: slice::binary_search\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let v = [10, 40, 30];\n    /// assert!(v.contains(&30));\n    /// assert!(!v.contains(&50));\n    /// ```\n    ///\n    /// If you do not have a `&T`, but some other value that you can compare\n    /// with one (for example, `String` implements `PartialEq<str>`), you can\n    /// use `iter().any`:\n    ///\n    /// ```\n    /// let v = [String::from(\"hello\"), String::from(\"world\")]; // slice of `String`\n    /// assert!(v.iter().any(|e| e == \"hello\")); // search with `&str`\n    /// assert!(!v.iter().any(|e| e == \"hi\"));\n    /// ```\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[inline]\n    #[must_use]\n    pub fn contains(&self, x: &T) -> bool\n    where\n        T: PartialEq,\n    {\n        cmp::SliceContains::slice_contains(x, self)\n    }\n\n    /// Returns `true` if `needle` is a prefix of the slice or equal to the slice.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let v = [10, 40, 30];\n    /// assert!(v.starts_with(&[10]));\n    /// assert!(v.starts_with(&[10, 40]));\n    /// assert!(v.starts_with(&v));\n    /// assert!(!v.starts_with(&[50]));\n    /// assert!(!v.starts_with(&[10, 50]));\n    /// ```\n    ///\n    /// Always returns `true` if `needle` is an empty slice:\n    ///\n    /// ```\n    /// let v = &[10, 40, 30];\n    /// assert!(v.starts_with(&[]));\n    /// let v: &[u8] = &[];\n    /// assert!(v.starts_with(&[]));\n    /// ```\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[must_use]\n    pub fn starts_with(&self, needle: &[T]) -> bool\n    where\n        T: PartialEq,\n    {\n        let n = needle.len();\n        self.len() >= n && needle == &self[..n]\n    }\n\n    /// Returns `true` if `needle` is a suffix of the slice or equal to the slice.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let v = [10, 40, 30];\n    /// assert!(v.ends_with(&[30]));\n    /// assert!(v.ends_with(&[40, 30]));\n    /// assert!(v.ends_with(&v));\n    /// assert!(!v.ends_with(&[50]));\n    /// assert!(!v.ends_with(&[50, 30]));\n    /// ```\n    ///\n    /// Always returns `true` if `needle` is an empty slice:\n    ///\n    /// ```\n    /// let v = &[10, 40, 30];\n    /// assert!(v.ends_with(&[]));\n    /// let v: &[u8] = &[];\n    /// assert!(v.ends_with(&[]));\n    /// ```\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[must_use]\n    pub fn ends_with(&self, needle: &[T]) -> bool\n    where\n        T: PartialEq,\n    {\n        let (m, n) = (self.len(), needle.len());\n        m >= n && needle == &self[m - n..]\n    }\n\n    /// Returns a subslice with the prefix removed.\n    ///\n    /// If the slice starts with `prefix`, returns the subslice after the prefix, wrapped in `Some`.\n    /// If `prefix` is empty, simply returns the original slice. If `prefix` is equal to the\n    /// original slice, returns an empty slice.\n    ///\n    /// If the slice does not start with `prefix`, returns `None`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let v = &[10, 40, 30];\n    /// assert_eq!(v.strip_prefix(&[10]), Some(&[40, 30][..]));\n    /// assert_eq!(v.strip_prefix(&[10, 40]), Some(&[30][..]));\n    /// assert_eq!(v.strip_prefix(&[10, 40, 30]), Some(&[][..]));\n    /// assert_eq!(v.strip_prefix(&[50]), None);\n    /// assert_eq!(v.strip_prefix(&[10, 50]), None);\n    ///\n    /// let prefix : &str = \"he\";\n    /// assert_eq!(b\"hello\".strip_prefix(prefix.as_bytes()),\n    ///            Some(b\"llo\".as_ref()));\n    /// ```\n    #[must_use = \"returns the subslice without modifying the original\"]\n    #[stable(feature = \"slice_strip\", since = \"1.51.0\")]\n    pub fn strip_prefix<P: SlicePattern<Item = T> + ?Sized>(&self, prefix: &P) -> Option<&[T]>\n    where\n        T: PartialEq,\n    {\n        // This function will need rewriting if and when SlicePattern becomes more sophisticated.\n        let prefix = prefix.as_slice();\n        let n = prefix.len();\n        if n <= self.len() {\n            let (head, tail) = self.split_at(n);\n            if head == prefix {\n                return Some(tail);\n            }\n        }\n        None\n    }\n\n    /// Returns a subslice with the suffix removed.\n    ///\n    /// If the slice ends with `suffix`, returns the subslice before the suffix, wrapped in `Some`.\n    /// If `suffix` is empty, simply returns the original slice. If `suffix` is equal to the\n    /// original slice, returns an empty slice.\n    ///\n    /// If the slice does not end with `suffix`, returns `None`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let v = &[10, 40, 30];\n    /// assert_eq!(v.strip_suffix(&[30]), Some(&[10, 40][..]));\n    /// assert_eq!(v.strip_suffix(&[40, 30]), Some(&[10][..]));\n    /// assert_eq!(v.strip_suffix(&[10, 40, 30]), Some(&[][..]));\n    /// assert_eq!(v.strip_suffix(&[50]), None);\n    /// assert_eq!(v.strip_suffix(&[50, 30]), None);\n    /// ```\n    #[must_use = \"returns the subslice without modifying the original\"]\n    #[stable(feature = \"slice_strip\", since = \"1.51.0\")]\n    pub fn strip_suffix<P: SlicePattern<Item = T> + ?Sized>(&self, suffix: &P) -> Option<&[T]>\n    where\n        T: PartialEq,\n    {\n        // This function will need rewriting if and when SlicePattern becomes more sophisticated.\n        let suffix = suffix.as_slice();\n        let (len, n) = (self.len(), suffix.len());\n        if n <= len {\n            let (head, tail) = self.split_at(len - n);\n            if tail == suffix {\n                return Some(head);\n            }\n        }\n        None\n    }\n\n    /// Returns a subslice with the prefix and suffix removed.\n    ///\n    /// If the slice starts with `prefix` and ends with `suffix`, returns the subslice after the\n    /// prefix and before the suffix, wrapped in `Some`.\n    ///\n    /// If the slice does not start with `prefix` or does not end with `suffix`, returns `None`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(strip_circumfix)]\n    ///\n    /// let v = &[10, 50, 40, 30];\n    /// assert_eq!(v.strip_circumfix(&[10], &[30]), Some(&[50, 40][..]));\n    /// assert_eq!(v.strip_circumfix(&[10], &[40, 30]), Some(&[50][..]));\n    /// assert_eq!(v.strip_circumfix(&[10, 50], &[40, 30]), Some(&[][..]));\n    /// assert_eq!(v.strip_circumfix(&[50], &[30]), None);\n    /// assert_eq!(v.strip_circumfix(&[10], &[40]), None);\n    /// assert_eq!(v.strip_circumfix(&[], &[40, 30]), Some(&[10, 50][..]));\n    /// assert_eq!(v.strip_circumfix(&[10, 50], &[]), Some(&[40, 30][..]));\n    /// ```\n    #[must_use = \"returns the subslice without modifying the original\"]\n    #[unstable(feature = \"strip_circumfix\", issue = \"147946\")]\n    pub fn strip_circumfix<S, P>(&self, prefix: &P, suffix: &S) -> Option<&[T]>\n    where\n        T: PartialEq,\n        S: SlicePattern<Item = T> + ?Sized,\n        P: SlicePattern<Item = T> + ?Sized,\n    {\n        self.strip_prefix(prefix)?.strip_suffix(suffix)\n    }\n\n    /// Returns a subslice with the optional prefix removed.\n    ///\n    /// If the slice starts with `prefix`, returns the subslice after the prefix.  If `prefix`\n    /// is empty or the slice does not start with `prefix`, simply returns the original slice.\n    /// If `prefix` is equal to the original slice, returns an empty slice.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(trim_prefix_suffix)]\n    ///\n    /// let v = &[10, 40, 30];\n    ///\n    /// // Prefix present - removes it\n    /// assert_eq!(v.trim_prefix(&[10]), &[40, 30][..]);\n    /// assert_eq!(v.trim_prefix(&[10, 40]), &[30][..]);\n    /// assert_eq!(v.trim_prefix(&[10, 40, 30]), &[][..]);\n    ///\n    /// // Prefix absent - returns original slice\n    /// assert_eq!(v.trim_prefix(&[50]), &[10, 40, 30][..]);\n    /// assert_eq!(v.trim_prefix(&[10, 50]), &[10, 40, 30][..]);\n    ///\n    /// let prefix : &str = \"he\";\n    /// assert_eq!(b\"hello\".trim_prefix(prefix.as_bytes()), b\"llo\".as_ref());\n    /// ```\n    #[must_use = \"returns the subslice without modifying the original\"]\n    #[unstable(feature = \"trim_prefix_suffix\", issue = \"142312\")]\n    pub fn trim_prefix<P: SlicePattern<Item = T> + ?Sized>(&self, prefix: &P) -> &[T]\n    where\n        T: PartialEq,\n    {\n        // This function will need rewriting if and when SlicePattern becomes more sophisticated.\n        let prefix = prefix.as_slice();\n        let n = prefix.len();\n        if n <= self.len() {\n            let (head, tail) = self.split_at(n);\n            if head == prefix {\n                return tail;\n            }\n        }\n        self\n    }\n\n    /// Returns a subslice with the optional suffix removed.\n    ///\n    /// If the slice ends with `suffix`, returns the subslice before the suffix.  If `suffix`\n    /// is empty or the slice does not end with `suffix`, simply returns the original slice.\n    /// If `suffix` is equal to the original slice, returns an empty slice.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(trim_prefix_suffix)]\n    ///\n    /// let v = &[10, 40, 30];\n    ///\n    /// // Suffix present - removes it\n    /// assert_eq!(v.trim_suffix(&[30]), &[10, 40][..]);\n    /// assert_eq!(v.trim_suffix(&[40, 30]), &[10][..]);\n    /// assert_eq!(v.trim_suffix(&[10, 40, 30]), &[][..]);\n    ///\n    /// // Suffix absent - returns original slice\n    /// assert_eq!(v.trim_suffix(&[50]), &[10, 40, 30][..]);\n    /// assert_eq!(v.trim_suffix(&[50, 30]), &[10, 40, 30][..]);\n    /// ```\n    #[must_use = \"returns the subslice without modifying the original\"]\n    #[unstable(feature = \"trim_prefix_suffix\", issue = \"142312\")]\n    pub fn trim_suffix<P: SlicePattern<Item = T> + ?Sized>(&self, suffix: &P) -> &[T]\n    where\n        T: PartialEq,\n    {\n        // This function will need rewriting if and when SlicePattern becomes more sophisticated.\n        let suffix = suffix.as_slice();\n        let (len, n) = (self.len(), suffix.len());\n        if n <= len {\n            let (head, tail) = self.split_at(len - n);\n            if tail == suffix {\n                return head;\n            }\n        }\n        self\n    }\n\n    /// Binary searches this slice for a given element.\n    /// If the slice is not sorted, the returned result is unspecified and\n    /// meaningless.\n    ///\n    /// If the value is found then [`Result::Ok`] is returned, containing the\n    /// index of the matching element. If there are multiple matches, then any\n    /// one of the matches could be returned. The index is chosen\n    /// deterministically, but is subject to change in future versions of Rust.\n    /// If the value is not found then [`Result::Err`] is returned, containing\n    /// the index where a matching element could be inserted while maintaining\n    /// sorted order.\n    ///\n    /// See also [`binary_search_by`], [`binary_search_by_key`], and [`partition_point`].\n    ///\n    /// [`binary_search_by`]: slice::binary_search_by\n    /// [`binary_search_by_key`]: slice::binary_search_by_key\n    /// [`partition_point`]: slice::partition_point\n    ///\n    /// # Examples\n    ///\n    /// Looks up a series of four elements. The first is found, with a\n    /// uniquely determined position; the second and third are not\n    /// found; the fourth could match any position in `[1, 4]`.\n    ///\n    /// ```\n    /// let s = [0, 1, 1, 1, 1, 2, 3, 5, 8, 13, 21, 34, 55];\n    ///\n    /// assert_eq!(s.binary_search(&13),  Ok(9));\n    /// assert_eq!(s.binary_search(&4),   Err(7));\n    /// assert_eq!(s.binary_search(&100), Err(13));\n    /// let r = s.binary_search(&1);\n    /// assert!(match r { Ok(1..=4) => true, _ => false, });\n    /// ```\n    ///\n    /// If you want to find that whole *range* of matching items, rather than\n    /// an arbitrary matching one, that can be done using [`partition_point`]:\n    /// ```\n    /// let s = [0, 1, 1, 1, 1, 2, 3, 5, 8, 13, 21, 34, 55];\n    ///\n    /// let low = s.partition_point(|x| x < &1);\n    /// assert_eq!(low, 1);\n    /// let high = s.partition_point(|x| x <= &1);\n    /// assert_eq!(high, 5);\n    /// let r = s.binary_search(&1);\n    /// assert!((low..high).contains(&r.unwrap()));\n    ///\n    /// assert!(s[..low].iter().all(|&x| x < 1));\n    /// assert!(s[low..high].iter().all(|&x| x == 1));\n    /// assert!(s[high..].iter().all(|&x| x > 1));\n    ///\n    /// // For something not found, the \"range\" of equal items is empty\n    /// assert_eq!(s.partition_point(|x| x < &11), 9);\n    /// assert_eq!(s.partition_point(|x| x <= &11), 9);\n    /// assert_eq!(s.binary_search(&11), Err(9));\n    /// ```\n    ///\n    /// If you want to insert an item to a sorted vector, while maintaining\n    /// sort order, consider using [`partition_point`]:\n    ///\n    /// ```\n    /// let mut s = vec![0, 1, 1, 1, 1, 2, 3, 5, 8, 13, 21, 34, 55];\n    /// let num = 42;\n    /// let idx = s.partition_point(|&x| x <= num);\n    /// // If `num` is unique, `s.partition_point(|&x| x < num)` (with `<`) is equivalent to\n    /// // `s.binary_search(&num).unwrap_or_else(|x| x)`, but using `<=` will allow `insert`\n    /// // to shift less elements.\n    /// s.insert(idx, num);\n    /// assert_eq!(s, [0, 1, 1, 1, 1, 2, 3, 5, 8, 13, 21, 34, 42, 55]);\n    /// ```\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    pub fn binary_search(&self, x: &T) -> Result<usize, usize>\n    where\n        T: Ord,\n    {\n        self.binary_search_by(|p| p.cmp(x))\n    }\n\n    /// Binary searches this slice with a comparator function.\n    ///\n    /// The comparator function should return an order code that indicates\n    /// whether its argument is `Less`, `Equal` or `Greater` the desired\n    /// target.\n    /// If the slice is not sorted or if the comparator function does not\n    /// implement an order consistent with the sort order of the underlying\n    /// slice, the returned result is unspecified and meaningless.\n    ///\n    /// If the value is found then [`Result::Ok`] is returned, containing the\n    /// index of the matching element. If there are multiple matches, then any\n    /// one of the matches could be returned. The index is chosen\n    /// deterministically, but is subject to change in future versions of Rust.\n    /// If the value is not found then [`Result::Err`] is returned, containing\n    /// the index where a matching element could be inserted while maintaining\n    /// sorted order.\n    ///\n    /// See also [`binary_search`], [`binary_search_by_key`], and [`partition_point`].\n    ///\n    /// [`binary_search`]: slice::binary_search\n    /// [`binary_search_by_key`]: slice::binary_search_by_key\n    /// [`partition_point`]: slice::partition_point\n    ///\n    /// # Examples\n    ///\n    /// Looks up a series of four elements. The first is found, with a\n    /// uniquely determined position; the second and third are not\n    /// found; the fourth could match any position in `[1, 4]`.\n    ///\n    /// ```\n    /// let s = [0, 1, 1, 1, 1, 2, 3, 5, 8, 13, 21, 34, 55];\n    ///\n    /// let seek = 13;\n    /// assert_eq!(s.binary_search_by(|probe| probe.cmp(&seek)), Ok(9));\n    /// let seek = 4;\n    /// assert_eq!(s.binary_search_by(|probe| probe.cmp(&seek)), Err(7));\n    /// let seek = 100;\n    /// assert_eq!(s.binary_search_by(|probe| probe.cmp(&seek)), Err(13));\n    /// let seek = 1;\n    /// let r = s.binary_search_by(|probe| probe.cmp(&seek));\n    /// assert!(match r { Ok(1..=4) => true, _ => false, });\n    /// ```\n    #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    #[inline]\n    pub fn binary_search_by<'a, F>(&'a self, mut f: F) -> Result<usize, usize>\n    where\n        F: FnMut(&'a T) -> Ordering,\n    {\n        let mut size = self.len();\n        if size == 0 {\n            return Err(0);\n        }\n        let mut base = 0usize;\n\n        // This loop intentionally doesn't have an early exit if the comparison\n        // returns Equal. We want the number of loop iterations to depend *only*\n        // on the size of the input slice so that the CPU can reliably predict\n        // the loop count.\n        while size > 1 {\n            let half = size / 2;\n            let mid = base + half;\n\n            // SAFETY: the call is made safe by the following invariants:\n            // - `mid >= 0`: by definition\n            // - `mid < size`: `mid = size / 2 + size / 4 + size / 8 ...`\n            let cmp = f(unsafe { self.get_unchecked(mid) });\n\n            // Binary search interacts poorly with branch prediction, so force\n            // the compiler to use conditional moves if supported by the target\n            // architecture.\n            base = hint::select_unpredictable(cmp == Greater, base, mid);\n\n            // This is imprecise in the case where `size` is odd and the\n            // comparison returns Greater: the mid element still gets included\n            // by `size` even though it's known to be larger than the element\n            // being searched for.\n            //\n            // This is fine though: we gain more performance by keeping the\n            // loop iteration count invariant (and thus predictable) than we\n            // lose from considering one additional element.\n            size -= half;\n        }\n\n        // SAFETY: base is always in [0, size) because base <= mid.\n        let cmp = f(unsafe { self.get_unchecked(base) });\n        if cmp == Equal {\n            // SAFETY: same as the `get_unchecked` above.\n            unsafe { hint::assert_unchecked(base < self.len()) };\n            Ok(base)\n        } else {\n            let result = base + (cmp == Less) as usize;\n            // SAFETY: same as the `get_unchecked` above.\n            // Note that this is `<=`, unlike the assume in the `Ok` path.\n            unsafe { hint::assert_unchecked(result <= self.len()) };\n            Err(result)\n        }\n    }\n\n    /// Binary searches this slice with a key extraction function.\n    ///\n    /// Assumes that the slice is sorted by the key, for instance with\n    /// [`sort_by_key`] using the same key extraction function.\n    /// If the slice is not sorted by the key, the returned result is\n    /// unspecified and meaningless.\n    ///\n    /// If the value is found then [`Result::Ok`] is returned, containing the\n    /// index of the matching element. If there are multiple matches, then any\n    /// one of the matches could be returned. The index is chosen\n    /// deterministically, but is subject to change in future versions of Rust.\n    /// If the value is not found then [`Result::Err`] is returned, containing\n    /// the index where a matching element could be inserted while maintaining\n    /// sorted order.\n    ///\n    /// See also [`binary_search`], [`binary_search_by`], and [`partition_point`].\n    ///\n    /// [`sort_by_key`]: slice::sort_by_key\n    /// [`binary_search`]: slice::binary_search\n    /// [`binary_search_by`]: slice::binary_search_by\n    /// [`partition_point`]: slice::partition_point\n    ///\n    /// # Examples\n    ///\n    /// Looks up a series of four elements in a slice of pairs sorted by\n    /// their second elements. The first is found, with a uniquely\n    /// determined position; the second and third are not found; the\n    /// fourth could match any position in `[1, 4]`.\n    ///\n    /// ```\n    /// let s = [(0, 0), (2, 1), (4, 1), (5, 1), (3, 1),\n    ///          (1, 2), (2, 3), (4, 5), (5, 8), (3, 13),\n    ///          (1, 21), (2, 34), (4, 55)];\n    ///\n    /// assert_eq!(s.binary_search_by_key(&13, |&(a, b)| b),  Ok(9));\n    /// assert_eq!(s.binary_search_by_key(&4, |&(a, b)| b),   Err(7));\n    /// assert_eq!(s.binary_search_by_key(&100, |&(a, b)| b), Err(13));\n    /// let r = s.binary_search_by_key(&1, |&(a, b)| b);\n    /// assert!(match r { Ok(1..=4) => true, _ => false, });\n    /// ```\n    // Lint rustdoc::broken_intra_doc_links is allowed as `slice::sort_by_key` is\n    // in crate `alloc`, and as such doesn't exists yet when building `core`: #74481.\n    // This breaks links when slice is displayed in core, but changing it to use relative links\n    // would break when the item is re-exported. So allow the core links to be broken for now.\n    #[allow(rustdoc::broken_intra_doc_links)]\n    #[stable(feature = \"slice_binary_search_by_key\", since = \"1.10.0\")]\n    #[inline]\n    pub fn binary_search_by_key<'a, B, F>(&'a self, b: &B, mut f: F) -> Result<usize, usize>\n    where\n        F: FnMut(&'a T) -> B,\n        B: Ord,\n    {\n        self.binary_search_by(|k| f(k).cmp(b))\n    }\n\n    /// Sorts the slice in ascending order **without** preserving the initial order of equal elements.\n    ///\n    /// This sort is unstable (i.e., may reorder equal elements), in-place (i.e., does not\n    /// allocate), and *O*(*n* \\* log(*n*)) worst-case.\n    ///\n    /// If the implementation of [`Ord`] for `T` does not implement a [total order], the function\n    /// may panic; even if the function exits normally, the resulting order of elements in the slice\n    /// is unspecified. See also the note on panicking below.\n    ///\n    /// For example `|a, b| (a - b).cmp(a)` is a comparison function that is neither transitive nor\n    /// reflexive nor total, `a < b < c < a` with `a = 1, b = 2, c = 3`. For more information and\n    /// examples see the [`Ord`] documentation.\n    ///\n    ///\n    /// All original elements will remain in the slice and any possible modifications via interior\n    /// mutability are observed in the input. Same is true if the implementation of [`Ord`] for `T` panics.\n    ///\n    /// Sorting types that only implement [`PartialOrd`] such as [`f32`] and [`f64`] require\n    /// additional precautions. For example, `f32::NAN != f32::NAN`, which doesn't fulfill the\n    /// reflexivity requirement of [`Ord`]. By using an alternative comparison function with\n    /// `slice::sort_unstable_by` such as [`f32::total_cmp`] or [`f64::total_cmp`] that defines a\n    /// [total order] users can sort slices containing floating-point values. Alternatively, if all\n    /// values in the slice are guaranteed to be in a subset for which [`PartialOrd::partial_cmp`]\n    /// forms a [total order], it's possible to sort the slice with `sort_unstable_by(|a, b|\n    /// a.partial_cmp(b).unwrap())`.\n    ///\n    /// # Current implementation\n    ///\n    /// The current implementation is based on [ipnsort] by Lukas Bergdoll and Orson Peters, which\n    /// combines the fast average case of quicksort with the fast worst case of heapsort, achieving\n    /// linear time on fully sorted and reversed inputs. On inputs with k distinct elements, the\n    /// expected time to sort the data is *O*(*n* \\* log(*k*)).\n    ///\n    /// It is typically faster than stable sorting, except in a few special cases, e.g., when the\n    /// slice is partially sorted.\n    ///\n    /// # Panics\n    ///\n    /// May panic if the implementation of [`Ord`] for `T` does not implement a [total order], or if\n    /// the [`Ord`] implementation panics.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut v = [4, -5, 1, -3, 2];\n    ///\n    /// v.sort_unstable();\n    /// assert_eq!(v, [-5, -3, 1, 2, 4]);\n    /// ```\n    ///\n    /// [ipnsort]: https://github.com/Voultapher/sort-research-rs/tree/main/ipnsort\n    /// [total order]: https://en.wikipedia.org/wiki/Total_order\n    #[stable(feature = \"sort_unstable\", since = \"1.20.0\")]\n    #[inline]\n    pub fn sort_unstable(&mut self)\n    where\n        T: Ord,\n    {\n        sort::unstable::sort(self, &mut T::lt);\n    }\n\n    /// Sorts the slice in ascending order with a comparison function, **without** preserving the\n    /// initial order of equal elements.\n    ///\n    /// This sort is unstable (i.e., may reorder equal elements), in-place (i.e., does not\n    /// allocate), and *O*(*n* \\* log(*n*)) worst-case.\n    ///\n    /// If the comparison function `compare` does not implement a [total order], the function\n    /// may panic; even if the function exits normally, the resulting order of elements in the slice\n    /// is unspecified. See also the note on panicking below.\n    ///\n    /// For example `|a, b| (a - b).cmp(a)` is a comparison function that is neither transitive nor\n    /// reflexive nor total, `a < b < c < a` with `a = 1, b = 2, c = 3`. For more information and\n    /// examples see the [`Ord`] documentation.\n    ///\n    /// All original elements will remain in the slice and any possible modifications via interior\n    /// mutability are observed in the input. Same is true if `compare` panics.\n    ///\n    /// # Current implementation\n    ///\n    /// The current implementation is based on [ipnsort] by Lukas Bergdoll and Orson Peters, which\n    /// combines the fast average case of quicksort with the fast worst case of heapsort, achieving\n    /// linear time on fully sorted and reversed inputs. On inputs with k distinct elements, the\n    /// expected time to sort the data is *O*(*n* \\* log(*k*)).\n    ///\n    /// It is typically faster than stable sorting, except in a few special cases, e.g., when the\n    /// slice is partially sorted.\n    ///\n    /// # Panics\n    ///\n    /// May panic if the `compare` does not implement a [total order], or if\n    /// the `compare` itself panics.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut v = [4, -5, 1, -3, 2];\n    /// v.sort_unstable_by(|a, b| a.cmp(b));\n    /// assert_eq!(v, [-5, -3, 1, 2, 4]);\n    ///\n    /// // reverse sorting\n    /// v.sort_unstable_by(|a, b| b.cmp(a));\n    /// assert_eq!(v, [4, 2, 1, -3, -5]);\n    /// ```\n    ///\n    /// [ipnsort]: https://github.com/Voultapher/sort-research-rs/tree/main/ipnsort\n    /// [total order]: https://en.wikipedia.org/wiki/Total_order\n    #[stable(feature = \"sort_unstable\", since = \"1.20.0\")]\n    #[inline]\n    pub fn sort_unstable_by<F>(&mut self, mut compare: F)\n    where\n        F: FnMut(&T, &T) -> Ordering,\n    {\n        sort::unstable::sort(self, &mut |a, b| compare(a, b) == Ordering::Less);\n    }\n\n    /// Sorts the slice in ascending order with a key extraction function, **without** preserving\n    /// the initial order of equal elements.\n    ///\n    /// This sort is unstable (i.e., may reorder equal elements), in-place (i.e., does not\n    /// allocate), and *O*(*n* \\* log(*n*)) worst-case.\n    ///\n    /// If the implementation of [`Ord`] for `K` does not implement a [total order], the function\n    /// may panic; even if the function exits normally, the resulting order of elements in the slice\n    /// is unspecified. See also the note on panicking below.\n    ///\n    /// For example `|a, b| (a - b).cmp(a)` is a comparison function that is neither transitive nor\n    /// reflexive nor total, `a < b < c < a` with `a = 1, b = 2, c = 3`. For more information and\n    /// examples see the [`Ord`] documentation.\n    ///\n    /// All original elements will remain in the slice and any possible modifications via interior\n    /// mutability are observed in the input. Same is true if the implementation of [`Ord`] for `K` panics.\n    ///\n    /// # Current implementation\n    ///\n    /// The current implementation is based on [ipnsort] by Lukas Bergdoll and Orson Peters, which\n    /// combines the fast average case of quicksort with the fast worst case of heapsort, achieving\n    /// linear time on fully sorted and reversed inputs. On inputs with k distinct elements, the\n    /// expected time to sort the data is *O*(*n* \\* log(*k*)).\n    ///\n    /// It is typically faster than stable sorting, except in a few special cases, e.g., when the\n    /// slice is partially sorted.\n    ///\n    /// # Panics\n    ///\n    /// May panic if the implementation of [`Ord`] for `K` does not implement a [total order], or if\n    /// the [`Ord`] implementation panics.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut v = [4i32, -5, 1, -3, 2];\n    ///\n    /// v.sort_unstable_by_key(|k| k.abs());\n    /// assert_eq!(v, [1, 2, -3, 4, -5]);\n    /// ```\n    ///\n    /// [ipnsort]: https://github.com/Voultapher/sort-research-rs/tree/main/ipnsort\n    /// [total order]: https://en.wikipedia.org/wiki/Total_order\n    #[stable(feature = \"sort_unstable\", since = \"1.20.0\")]\n    #[inline]\n    pub fn sort_unstable_by_key<K, F>(&mut self, mut f: F)\n    where\n        F: FnMut(&T) -> K,\n        K: Ord,\n    {\n        sort::unstable::sort(self, &mut |a, b| f(a).lt(&f(b)));\n    }\n\n    /// Reorders the slice such that the element at `index` is at a sort-order position. All\n    /// elements before `index` will be `<=` to this value, and all elements after will be `>=` to\n    /// it.\n    ///\n    /// This reordering is unstable (i.e. any element that compares equal to the nth element may end\n    /// up at that position), in-place (i.e.  does not allocate), and runs in *O*(*n*) time. This\n    /// function is also known as \"kth element\" in other libraries.\n    ///\n    /// Returns a triple that partitions the reordered slice:\n    ///\n    /// * The unsorted subslice before `index`, whose elements all satisfy `x <= self[index]`.\n    ///\n    /// * The element at `index`.\n    ///\n    /// * The unsorted subslice after `index`, whose elements all satisfy `x >= self[index]`.\n    ///\n    /// # Current implementation\n    ///\n    /// The current algorithm is an introselect implementation based on [ipnsort] by Lukas Bergdoll\n    /// and Orson Peters, which is also the basis for [`sort_unstable`]. The fallback algorithm is\n    /// Median of Medians using Tukey's Ninther for pivot selection, which guarantees linear runtime\n    /// for all inputs.\n    ///\n    /// [`sort_unstable`]: slice::sort_unstable\n    ///\n    /// # Panics\n    ///\n    /// Panics when `index >= len()`, and so always panics on empty slices.\n    ///\n    /// May panic if the implementation of [`Ord`] for `T` does not implement a [total order].\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut v = [-5i32, 4, 2, -3, 1];\n    ///\n    /// // Find the items `<=` to the median, the median itself, and the items `>=` to it.\n    /// let (lesser, median, greater) = v.select_nth_unstable(2);\n    ///\n    /// assert!(lesser == [-3, -5] || lesser == [-5, -3]);\n    /// assert_eq!(median, &mut 1);\n    /// assert!(greater == [4, 2] || greater == [2, 4]);\n    ///\n    /// // We are only guaranteed the slice will be one of the following, based on the way we sort\n    /// // about the specified index.\n    /// assert!(v == [-3, -5, 1, 2, 4] ||\n    ///         v == [-5, -3, 1, 2, 4] ||\n    ///         v == [-3, -5, 1, 4, 2] ||\n    ///         v == [-5, -3, 1, 4, 2]);\n    /// ```\n    ///\n    /// [ipnsort]: https://github.com/Voultapher/sort-research-rs/tree/main/ipnsort\n    /// [total order]: https://en.wikipedia.org/wiki/Total_order\n    #[stable(feature = \"slice_select_nth_unstable\", since = \"1.49.0\")]\n    #[inline]\n    pub fn select_nth_unstable(&mut self, index: usize) -> (&mut [T], &mut T, &mut [T])\n    where\n        T: Ord,\n    {\n        sort::select::partition_at_index(self, index, T::lt)\n    }\n\n    /// Reorders the slice with a comparator function such that the element at `index` is at a\n    /// sort-order position. All elements before `index` will be `<=` to this value, and all\n    /// elements after will be `>=` to it, according to the comparator function.\n    ///\n    /// This reordering is unstable (i.e. any element that compares equal to the nth element may end\n    /// up at that position), in-place (i.e.  does not allocate), and runs in *O*(*n*) time. This\n    /// function is also known as \"kth element\" in other libraries.\n    ///\n    /// Returns a triple partitioning the reordered slice:\n    ///\n    /// * The unsorted subslice before `index`, whose elements all satisfy\n    ///   `compare(x, self[index]).is_le()`.\n    ///\n    /// * The element at `index`.\n    ///\n    /// * The unsorted subslice after `index`, whose elements all satisfy\n    ///   `compare(x, self[index]).is_ge()`.\n    ///\n    /// # Current implementation\n    ///\n    /// The current algorithm is an introselect implementation based on [ipnsort] by Lukas Bergdoll\n    /// and Orson Peters, which is also the basis for [`sort_unstable`]. The fallback algorithm is\n    /// Median of Medians using Tukey's Ninther for pivot selection, which guarantees linear runtime\n    /// for all inputs.\n    ///\n    /// [`sort_unstable`]: slice::sort_unstable\n    ///\n    /// # Panics\n    ///\n    /// Panics when `index >= len()`, and so always panics on empty slices.\n    ///\n    /// May panic if `compare` does not implement a [total order].\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut v = [-5i32, 4, 2, -3, 1];\n    ///\n    /// // Find the items `>=` to the median, the median itself, and the items `<=` to it, by using\n    /// // a reversed comparator.\n    /// let (before, median, after) = v.select_nth_unstable_by(2, |a, b| b.cmp(a));\n    ///\n    /// assert!(before == [4, 2] || before == [2, 4]);\n    /// assert_eq!(median, &mut 1);\n    /// assert!(after == [-3, -5] || after == [-5, -3]);\n    ///\n    /// // We are only guaranteed the slice will be one of the following, based on the way we sort\n    /// // about the specified index.\n    /// assert!(v == [2, 4, 1, -5, -3] ||\n    ///         v == [2, 4, 1, -3, -5] ||\n    ///         v == [4, 2, 1, -5, -3] ||\n    ///         v == [4, 2, 1, -3, -5]);\n    /// ```\n    ///\n    /// [ipnsort]: https://github.com/Voultapher/sort-research-rs/tree/main/ipnsort\n    /// [total order]: https://en.wikipedia.org/wiki/Total_order\n    #[stable(feature = \"slice_select_nth_unstable\", since = \"1.49.0\")]\n    #[inline]\n    pub fn select_nth_unstable_by<F>(\n        &mut self,\n        index: usize,\n        mut compare: F,\n    ) -> (&mut [T], &mut T, &mut [T])\n    where\n        F: FnMut(&T, &T) -> Ordering,\n    {\n        sort::select::partition_at_index(self, index, |a: &T, b: &T| compare(a, b) == Less)\n    }\n\n    /// Reorders the slice with a key extraction function such that the element at `index` is at a\n    /// sort-order position. All elements before `index` will have keys `<=` to the key at `index`,\n    /// and all elements after will have keys `>=` to it.\n    ///\n    /// This reordering is unstable (i.e. any element that compares equal to the nth element may end\n    /// up at that position), in-place (i.e.  does not allocate), and runs in *O*(*n*) time. This\n    /// function is also known as \"kth element\" in other libraries.\n    ///\n    /// Returns a triple partitioning the reordered slice:\n    ///\n    /// * The unsorted subslice before `index`, whose elements all satisfy `f(x) <= f(self[index])`.\n    ///\n    /// * The element at `index`.\n    ///\n    /// * The unsorted subslice after `index`, whose elements all satisfy `f(x) >= f(self[index])`.\n    ///\n    /// # Current implementation\n    ///\n    /// The current algorithm is an introselect implementation based on [ipnsort] by Lukas Bergdoll\n    /// and Orson Peters, which is also the basis for [`sort_unstable`]. The fallback algorithm is\n    /// Median of Medians using Tukey's Ninther for pivot selection, which guarantees linear runtime\n    /// for all inputs.\n    ///\n    /// [`sort_unstable`]: slice::sort_unstable\n    ///\n    /// # Panics\n    ///\n    /// Panics when `index >= len()`, meaning it always panics on empty slices.\n    ///\n    /// May panic if `K: Ord` does not implement a total order.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut v = [-5i32, 4, 1, -3, 2];\n    ///\n    /// // Find the items `<=` to the absolute median, the absolute median itself, and the items\n    /// // `>=` to it.\n    /// let (lesser, median, greater) = v.select_nth_unstable_by_key(2, |a| a.abs());\n    ///\n    /// assert!(lesser == [1, 2] || lesser == [2, 1]);\n    /// assert_eq!(median, &mut -3);\n    /// assert!(greater == [4, -5] || greater == [-5, 4]);\n    ///\n    /// // We are only guaranteed the slice will be one of the following, based on the way we sort\n    /// // about the specified index.\n    /// assert!(v == [1, 2, -3, 4, -5] ||\n    ///         v == [1, 2, -3, -5, 4] ||\n    ///         v == [2, 1, -3, 4, -5] ||\n    ///         v == [2, 1, -3, -5, 4]);\n    /// ```\n    ///\n    /// [ipnsort]: https://github.com/Voultapher/sort-research-rs/tree/main/ipnsort\n    /// [total order]: https://en.wikipedia.org/wiki/Total_order\n    #[stable(feature = \"slice_select_nth_unstable\", since = \"1.49.0\")]\n    #[inline]\n    pub fn select_nth_unstable_by_key<K, F>(\n        &mut self,\n        index: usize,\n        mut f: F,\n    ) -> (&mut [T], &mut T, &mut [T])\n    where\n        F: FnMut(&T) -> K,\n        K: Ord,\n    {\n        sort::select::partition_at_index(self, index, |a: &T, b: &T| f(a).lt(&f(b)))\n    }\n\n    /// Moves all consecutive repeated elements to the end of the slice according to the\n    /// [`PartialEq`] trait implementation.\n    ///\n    /// Returns two slices. The first contains no consecutive repeated elements.\n    /// The second contains all the duplicates in no specified order.\n    ///\n    /// If the slice is sorted, the first returned slice contains no duplicates.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(slice_partition_dedup)]\n    ///\n    /// let mut slice = [1, 2, 2, 3, 3, 2, 1, 1];\n    ///\n    /// let (dedup, duplicates) = slice.partition_dedup();\n    ///\n    /// assert_eq!(dedup, [1, 2, 3, 2, 1]);\n    /// assert_eq!(duplicates, [2, 3, 1]);\n    /// ```\n    #[unstable(feature = \"slice_partition_dedup\", issue = \"54279\")]\n    #[inline]\n    pub fn partition_dedup(&mut self) -> (&mut [T], &mut [T])\n    where\n        T: PartialEq,\n    {\n        self.partition_dedup_by(|a, b| a == b)\n    }\n\n    /// Moves all but the first of consecutive elements to the end of the slice satisfying\n    /// a given equality relation.\n    ///\n    /// Returns two slices. The first contains no consecutive repeated elements.\n    /// The second contains all the duplicates in no specified order.\n    ///\n    /// The `same_bucket` function is passed references to two elements from the slice and\n    /// must determine if the elements compare equal. The elements are passed in opposite order\n    /// from their order in the slice, so if `same_bucket(a, b)` returns `true`, `a` is moved\n    /// at the end of the slice.\n    ///\n    /// If the slice is sorted, the first returned slice contains no duplicates.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(slice_partition_dedup)]\n    ///\n    /// let mut slice = [\"foo\", \"Foo\", \"BAZ\", \"Bar\", \"bar\", \"baz\", \"BAZ\"];\n    ///\n    /// let (dedup, duplicates) = slice.partition_dedup_by(|a, b| a.eq_ignore_ascii_case(b));\n    ///\n    /// assert_eq!(dedup, [\"foo\", \"BAZ\", \"Bar\", \"baz\"]);\n    /// assert_eq!(duplicates, [\"bar\", \"Foo\", \"BAZ\"]);\n    /// ```\n    #[unstable(feature = \"slice_partition_dedup\", issue = \"54279\")]\n    #[inline]\n    pub fn partition_dedup_by<F>(&mut self, mut same_bucket: F) -> (&mut [T], &mut [T])\n    where\n        F: FnMut(&mut T, &mut T) -> bool,\n    {\n        // Although we have a mutable reference to `self`, we cannot make\n        // *arbitrary* changes. The `same_bucket` calls could panic, so we\n        // must ensure that the slice is in a valid state at all times.\n        //\n        // The way that we handle this is by using swaps; we iterate\n        // over all the elements, swapping as we go so that at the end\n        // the elements we wish to keep are in the front, and those we\n        // wish to reject are at the back. We can then split the slice.\n        // This operation is still `O(n)`.\n        //\n        // Example: We start in this state, where `r` represents \"next\n        // read\" and `w` represents \"next_write\".\n        //\n        //           r\n        //     +---+---+---+---+---+---+\n        //     | 0 | 1 | 1 | 2 | 3 | 3 |\n        //     +---+---+---+---+---+---+\n        //           w\n        //\n        // Comparing self[r] against self[w-1], this is not a duplicate, so\n        // we swap self[r] and self[w] (no effect as r==w) and then increment both\n        // r and w, leaving us with:\n        //\n        //               r\n        //     +---+---+---+---+---+---+\n        //     | 0 | 1 | 1 | 2 | 3 | 3 |\n        //     +---+---+---+---+---+---+\n        //               w\n        //\n        // Comparing self[r] against self[w-1], this value is a duplicate,\n        // so we increment `r` but leave everything else unchanged:\n        //\n        //                   r\n        //     +---+---+---+---+---+---+\n        //     | 0 | 1 | 1 | 2 | 3 | 3 |\n        //     +---+---+---+---+---+---+\n        //               w\n        //\n        // Comparing self[r] against self[w-1], this is not a duplicate,\n        // so swap self[r] and self[w] and advance r and w:\n        //\n        //                       r\n        //     +---+---+---+---+---+---+\n        //     | 0 | 1 | 2 | 1 | 3 | 3 |\n        //     +---+---+---+---+---+---+\n        //                   w\n        //\n        // Not a duplicate, repeat:\n        //\n        //                           r\n        //     +---+---+---+---+---+---+\n        //     | 0 | 1 | 2 | 3 | 1 | 3 |\n        //     +---+---+---+---+---+---+\n        //                       w\n        //\n        // Duplicate, advance r. End of slice. Split at w.\n\n        let len = self.len();\n        if len <= 1 {\n            return (self, &mut []);\n        }\n\n        let ptr = self.as_mut_ptr();\n        let mut next_read: usize = 1;\n        let mut next_write: usize = 1;\n\n        // SAFETY: the `while` condition guarantees `next_read` and `next_write`\n        // are less than `len`, thus are inside `self`. `prev_ptr_write` points to\n        // one element before `ptr_write`, but `next_write` starts at 1, so\n        // `prev_ptr_write` is never less than 0 and is inside the slice.\n        // This fulfils the requirements for dereferencing `ptr_read`, `prev_ptr_write`\n        // and `ptr_write`, and for using `ptr.add(next_read)`, `ptr.add(next_write - 1)`\n        // and `prev_ptr_write.offset(1)`.\n        //\n        // `next_write` is also incremented at most once per loop at most meaning\n        // no element is skipped when it may need to be swapped.\n        //\n        // `ptr_read` and `prev_ptr_write` never point to the same element. This\n        // is required for `&mut *ptr_read`, `&mut *prev_ptr_write` to be safe.\n        // The explanation is simply that `next_read >= next_write` is always true,\n        // thus `next_read > next_write - 1` is too.\n        unsafe {\n            // Avoid bounds checks by using raw pointers.\n            while next_read < len {\n                let ptr_read = ptr.add(next_read);\n                let prev_ptr_write = ptr.add(next_write - 1);\n                if !same_bucket(&mut *ptr_read, &mut *prev_ptr_write) {\n                    if next_read != next_write {\n                        let ptr_write = prev_ptr_write.add(1);\n                        mem::swap(&mut *ptr_read, &mut *ptr_write);\n                    }\n                    next_write += 1;\n                }\n                next_read += 1;\n            }\n        }\n\n        self.split_at_mut(next_write)\n    }\n\n    /// Moves all but the first of consecutive elements to the end of the slice that resolve\n    /// to the same key.\n    ///\n    /// Returns two slices. The first contains no consecutive repeated elements.\n    /// The second contains all the duplicates in no specified order.\n    ///\n    /// If the slice is sorted, the first returned slice contains no duplicates.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(slice_partition_dedup)]\n    ///\n    /// let mut slice = [10, 20, 21, 30, 30, 20, 11, 13];\n    ///\n    /// let (dedup, duplicates) = slice.partition_dedup_by_key(|i| *i / 10);\n    ///\n    /// assert_eq!(dedup, [10, 20, 30, 20, 11]);\n    /// assert_eq!(duplicates, [21, 30, 13]);\n    /// ```\n    #[unstable(feature = \"slice_partition_dedup\", issue = \"54279\")]\n    #[inline]\n    pub fn partition_dedup_by_key<K, F>(&mut self, mut key: F) -> (&mut [T], &mut [T])\n    where\n        F: FnMut(&mut T) -> K,\n        K: PartialEq,\n    {\n        self.partition_dedup_by(|a, b| key(a) == key(b))\n    }\n\n    /// Rotates the slice in-place such that the first `mid` elements of the\n    /// slice move to the end while the last `self.len() - mid` elements move to\n    /// the front.\n    ///\n    /// After calling `rotate_left`, the element previously at index `mid` will\n    /// become the first element in the slice.\n    ///\n    /// # Panics\n    ///\n    /// This function will panic if `mid` is greater than the length of the\n    /// slice. Note that `mid == self.len()` does _not_ panic and is a no-op\n    /// rotation.\n    ///\n    /// # Complexity\n    ///\n    /// Takes linear (in `self.len()`) time.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut a = ['a', 'b', 'c', 'd', 'e', 'f'];\n    /// a.rotate_left(2);\n    /// assert_eq!(a, ['c', 'd', 'e', 'f', 'a', 'b']);\n    /// ```\n    ///\n    /// Rotating a subslice:\n    ///\n    /// ```\n    /// let mut a = ['a', 'b', 'c', 'd', 'e', 'f'];\n    /// a[1..5].rotate_left(1);\n    /// assert_eq!(a, ['a', 'c', 'd', 'e', 'b', 'f']);\n    /// ```\n    #[stable(feature = \"slice_rotate\", since = \"1.26.0\")]\n    #[rustc_const_stable(feature = \"const_slice_rotate\", since = \"1.92.0\")]\n    pub const fn rotate_left(&mut self, mid: usize) {\n        assert!(mid <= self.len());\n        let k = self.len() - mid;\n        let p = self.as_mut_ptr();\n\n        // SAFETY: The range `[p.add(mid) - mid, p.add(mid) + k)` is trivially\n        // valid for reading and writing, as required by `ptr_rotate`.\n        unsafe {\n            rotate::ptr_rotate(mid, p.add(mid), k);\n        }\n    }\n\n    /// Rotates the slice in-place such that the first `self.len() - k`\n    /// elements of the slice move to the end while the last `k` elements move\n    /// to the front.\n    ///\n    /// After calling `rotate_right`, the element previously at index\n    /// `self.len() - k` will become the first element in the slice.\n    ///\n    /// # Panics\n    ///\n    /// This function will panic if `k` is greater than the length of the\n    /// slice. Note that `k == self.len()` does _not_ panic and is a no-op\n    /// rotation.\n    ///\n    /// # Complexity\n    ///\n    /// Takes linear (in `self.len()`) time.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut a = ['a', 'b', 'c', 'd', 'e', 'f'];\n    /// a.rotate_right(2);\n    /// assert_eq!(a, ['e', 'f', 'a', 'b', 'c', 'd']);\n    /// ```\n    ///\n    /// Rotating a subslice:\n    ///\n    /// ```\n    /// let mut a = ['a', 'b', 'c', 'd', 'e', 'f'];\n    /// a[1..5].rotate_right(1);\n    /// assert_eq!(a, ['a', 'e', 'b', 'c', 'd', 'f']);\n    /// ```\n    #[stable(feature = \"slice_rotate\", since = \"1.26.0\")]\n    #[rustc_const_stable(feature = \"const_slice_rotate\", since = \"1.92.0\")]\n    pub const fn rotate_right(&mut self, k: usize) {\n        assert!(k <= self.len());\n        let mid = self.len() - k;\n        let p = self.as_mut_ptr();\n\n        // SAFETY: The range `[p.add(mid) - mid, p.add(mid) + k)` is trivially\n        // valid for reading and writing, as required by `ptr_rotate`.\n        unsafe {\n            rotate::ptr_rotate(mid, p.add(mid), k);\n        }\n    }\n\n    /// Fills `self` with elements by cloning `value`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut buf = vec![0; 10];\n    /// buf.fill(1);\n    /// assert_eq!(buf, vec![1; 10]);\n    /// ```\n    #[doc(alias = \"memset\")]\n    #[stable(feature = \"slice_fill\", since = \"1.50.0\")]\n    pub fn fill(&mut self, value: T)\n    where\n        T: Clone,\n    {\n        specialize::SpecFill::spec_fill(self, value);\n    }\n\n    /// Fills `self` with elements returned by calling a closure repeatedly.\n    ///\n    /// This method uses a closure to create new values. If you'd rather\n    /// [`Clone`] a given value, use [`fill`]. If you want to use the [`Default`]\n    /// trait to generate values, you can pass [`Default::default`] as the\n    /// argument.\n    ///\n    /// [`fill`]: slice::fill\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut buf = vec![1; 10];\n    /// buf.fill_with(Default::default);\n    /// assert_eq!(buf, vec![0; 10]);\n    /// ```\n    #[stable(feature = \"slice_fill_with\", since = \"1.51.0\")]\n    pub fn fill_with<F>(&mut self, mut f: F)\n    where\n        F: FnMut() -> T,\n    {\n        for el in self {\n            *el = f();\n        }\n    }\n\n    /// Copies the elements from `src` into `self`.\n    ///\n    /// The length of `src` must be the same as `self`.\n    ///\n    /// # Panics\n    ///\n    /// This function will panic if the two slices have different lengths.\n    ///\n    /// # Examples\n    ///\n    /// Cloning two elements from a slice into another:\n    ///\n    /// ```\n    /// let src = [1, 2, 3, 4];\n    /// let mut dst = [0, 0];\n    ///\n    /// // Because the slices have to be the same length,\n    /// // we slice the source slice from four elements\n    /// // to two. It will panic if we don't do this.\n    /// dst.clone_from_slice(&src[2..]);\n    ///\n    /// assert_eq!(src, [1, 2, 3, 4]);\n    /// assert_eq!(dst, [3, 4]);\n    /// ```\n    ///\n    /// Rust enforces that there can only be one mutable reference with no\n    /// immutable references to a particular piece of data in a particular\n    /// scope. Because of this, attempting to use `clone_from_slice` on a\n    /// single slice will result in a compile failure:\n    ///\n    /// ```compile_fail\n    /// let mut slice = [1, 2, 3, 4, 5];\n    ///\n    /// slice[..2].clone_from_slice(&slice[3..]); // compile fail!\n    /// ```\n    ///\n    /// To work around this, we can use [`split_at_mut`] to create two distinct\n    /// sub-slices from a slice:\n    ///\n    /// ```\n    /// let mut slice = [1, 2, 3, 4, 5];\n    ///\n    /// {\n    ///     let (left, right) = slice.split_at_mut(2);\n    ///     left.clone_from_slice(&right[1..]);\n    /// }\n    ///\n    /// assert_eq!(slice, [4, 5, 3, 4, 5]);\n    /// ```\n    ///\n    /// [`copy_from_slice`]: slice::copy_from_slice\n    /// [`split_at_mut`]: slice::split_at_mut\n    #[stable(feature = \"clone_from_slice\", since = \"1.7.0\")]\n    #[track_caller]\n    pub fn clone_from_slice(&mut self, src: &[T])\n    where\n        T: Clone,\n    {\n        self.spec_clone_from(src);\n    }\n\n    /// Copies all elements from `src` into `self`, using a memcpy.\n    ///\n    /// The length of `src` must be the same as `self`.\n    ///\n    /// If `T` does not implement `Copy`, use [`clone_from_slice`].\n    ///\n    /// # Panics\n    ///\n    /// This function will panic if the two slices have different lengths.\n    ///\n    /// # Examples\n    ///\n    /// Copying two elements from a slice into another:\n    ///\n    /// ```\n    /// let src = [1, 2, 3, 4];\n    /// let mut dst = [0, 0];\n    ///\n    /// // Because the slices have to be the same length,\n    /// // we slice the source slice from four elements\n    /// // to two. It will panic if we don't do this.\n    /// dst.copy_from_slice(&src[2..]);\n    ///\n    /// assert_eq!(src, [1, 2, 3, 4]);\n    /// assert_eq!(dst, [3, 4]);\n    /// ```\n    ///\n    /// Rust enforces that there can only be one mutable reference with no\n    /// immutable references to a particular piece of data in a particular\n    /// scope. Because of this, attempting to use `copy_from_slice` on a\n    /// single slice will result in a compile failure:\n    ///\n    /// ```compile_fail\n    /// let mut slice = [1, 2, 3, 4, 5];\n    ///\n    /// slice[..2].copy_from_slice(&slice[3..]); // compile fail!\n    /// ```\n    ///\n    /// To work around this, we can use [`split_at_mut`] to create two distinct\n    /// sub-slices from a slice:\n    ///\n    /// ```\n    /// let mut slice = [1, 2, 3, 4, 5];\n    ///\n    /// {\n    ///     let (left, right) = slice.split_at_mut(2);\n    ///     left.copy_from_slice(&right[1..]);\n    /// }\n    ///\n    /// assert_eq!(slice, [4, 5, 3, 4, 5]);\n    /// ```\n    ///\n    /// [`clone_from_slice`]: slice::clone_from_slice\n    /// [`split_at_mut`]: slice::split_at_mut\n    #[doc(alias = \"memcpy\")]\n    #[inline]\n    #[stable(feature = \"copy_from_slice\", since = \"1.9.0\")]\n    #[rustc_const_stable(feature = \"const_copy_from_slice\", since = \"1.87.0\")]\n    #[track_caller]\n    pub const fn copy_from_slice(&mut self, src: &[T])\n    where\n        T: Copy,\n    {\n        // SAFETY: `T` implements `Copy`.\n        unsafe { copy_from_slice_impl(self, src) }\n    }\n\n    /// Copies elements from one part of the slice to another part of itself,\n    /// using a memmove.\n    ///\n    /// `src` is the range within `self` to copy from. `dest` is the starting\n    /// index of the range within `self` to copy to, which will have the same\n    /// length as `src`. The two ranges may overlap. The ends of the two ranges\n    /// must be less than or equal to `self.len()`.\n    ///\n    /// # Panics\n    ///\n    /// This function will panic if either range exceeds the end of the slice,\n    /// or if the end of `src` is before the start.\n    ///\n    /// # Examples\n    ///\n    /// Copying four bytes within a slice:\n    ///\n    /// ```\n    /// let mut bytes = *b\"Hello, World!\";\n    ///\n    /// bytes.copy_within(1..5, 8);\n    ///\n    /// assert_eq!(&bytes, b\"Hello, Wello!\");\n    /// ```\n    #[stable(feature = \"copy_within\", since = \"1.37.0\")]\n    #[track_caller]\n    pub fn copy_within<R: RangeBounds<usize>>(&mut self, src: R, dest: usize)\n    where\n        T: Copy,\n    {\n        let Range { start: src_start, end: src_end } = slice::range(src, ..self.len());\n        let count = src_end - src_start;\n        assert!(dest <= self.len() - count, \"dest is out of bounds\");\n        // SAFETY: the conditions for `ptr::copy` have all been checked above,\n        // as have those for `ptr::add`.\n        unsafe {\n            // Derive both `src_ptr` and `dest_ptr` from the same loan\n            let ptr = self.as_mut_ptr();\n            let src_ptr = ptr.add(src_start);\n            let dest_ptr = ptr.add(dest);\n            ptr::copy(src_ptr, dest_ptr, count);\n        }\n    }\n\n    /// Swaps all elements in `self` with those in `other`.\n    ///\n    /// The length of `other` must be the same as `self`.\n    ///\n    /// # Panics\n    ///\n    /// This function will panic if the two slices have different lengths.\n    ///\n    /// # Example\n    ///\n    /// Swapping two elements across slices:\n    ///\n    /// ```\n    /// let mut slice1 = [0, 0];\n    /// let mut slice2 = [1, 2, 3, 4];\n    ///\n    /// slice1.swap_with_slice(&mut slice2[2..]);\n    ///\n    /// assert_eq!(slice1, [3, 4]);\n    /// assert_eq!(slice2, [1, 2, 0, 0]);\n    /// ```\n    ///\n    /// Rust enforces that there can only be one mutable reference to a\n    /// particular piece of data in a particular scope. Because of this,\n    /// attempting to use `swap_with_slice` on a single slice will result in\n    /// a compile failure:\n    ///\n    /// ```compile_fail\n    /// let mut slice = [1, 2, 3, 4, 5];\n    /// slice[..2].swap_with_slice(&mut slice[3..]); // compile fail!\n    /// ```\n    ///\n    /// To work around this, we can use [`split_at_mut`] to create two distinct\n    /// mutable sub-slices from a slice:\n    ///\n    /// ```\n    /// let mut slice = [1, 2, 3, 4, 5];\n    ///\n    /// {\n    ///     let (left, right) = slice.split_at_mut(2);\n    ///     left.swap_with_slice(&mut right[1..]);\n    /// }\n    ///\n    /// assert_eq!(slice, [4, 5, 3, 1, 2]);\n    /// ```\n    ///\n    /// [`split_at_mut`]: slice::split_at_mut\n    #[stable(feature = \"swap_with_slice\", since = \"1.27.0\")]\n    #[rustc_const_unstable(feature = \"const_swap_with_slice\", issue = \"142204\")]\n    #[track_caller]\n    pub const fn swap_with_slice(&mut self, other: &mut [T]) {\n        assert!(self.len() == other.len(), \"destination and source slices have different lengths\");\n        // SAFETY: `self` is valid for `self.len()` elements by definition, and `src` was\n        // checked to have the same length. The slices cannot overlap because\n        // mutable references are exclusive.\n        unsafe {\n            ptr::swap_nonoverlapping(self.as_mut_ptr(), other.as_mut_ptr(), self.len());\n        }\n    }\n\n    /// Function to calculate lengths of the middle and trailing slice for `align_to{,_mut}`.\n    fn align_to_offsets<U>(&self) -> (usize, usize) {\n        // What we gonna do about `rest` is figure out what multiple of `U`s we can put in a\n        // lowest number of `T`s. And how many `T`s we need for each such \"multiple\".\n        //\n        // Consider for example T=u8 U=u16. Then we can put 1 U in 2 Ts. Simple. Now, consider\n        // for example a case where size_of::<T> = 16, size_of::<U> = 24. We can put 2 Us in\n        // place of every 3 Ts in the `rest` slice. A bit more complicated.\n        //\n        // Formula to calculate this is:\n        //\n        // Us = lcm(size_of::<T>, size_of::<U>) / size_of::<U>\n        // Ts = lcm(size_of::<T>, size_of::<U>) / size_of::<T>\n        //\n        // Expanded and simplified:\n        //\n        // Us = size_of::<T> / gcd(size_of::<T>, size_of::<U>)\n        // Ts = size_of::<U> / gcd(size_of::<T>, size_of::<U>)\n        //\n        // Luckily since all this is constant-evaluated... performance here matters not!\n        const fn gcd(a: usize, b: usize) -> usize {\n            if b == 0 { a } else { gcd(b, a % b) }\n        }\n\n        // Explicitly wrap the function call in a const block so it gets\n        // constant-evaluated even in debug mode.\n        let gcd: usize = const { gcd(size_of::<T>(), size_of::<U>()) };\n        let ts: usize = size_of::<U>() / gcd;\n        let us: usize = size_of::<T>() / gcd;\n\n        // Armed with this knowledge, we can find how many `U`s we can fit!\n        let us_len = self.len() / ts * us;\n        // And how many `T`s will be in the trailing slice!\n        let ts_len = self.len() % ts;\n        (us_len, ts_len)\n    }\n\n    /// Transmutes the slice to a slice of another type, ensuring alignment of the types is\n    /// maintained.\n    ///\n    /// This method splits the slice into three distinct slices: prefix, correctly aligned middle\n    /// slice of a new type, and the suffix slice. The middle part will be as big as possible under\n    /// the given alignment constraint and element size.\n    ///\n    /// This method has no purpose when either input element `T` or output element `U` are\n    /// zero-sized and will return the original slice without splitting anything.\n    ///\n    /// # Safety\n    ///\n    /// This method is essentially a `transmute` with respect to the elements in the returned\n    /// middle slice, so all the usual caveats pertaining to `transmute::<T, U>` also apply here.\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// unsafe {\n    ///     let bytes: [u8; 7] = [1, 2, 3, 4, 5, 6, 7];\n    ///     let (prefix, shorts, suffix) = bytes.align_to::<u16>();\n    ///     // less_efficient_algorithm_for_bytes(prefix);\n    ///     // more_efficient_algorithm_for_aligned_shorts(shorts);\n    ///     // less_efficient_algorithm_for_bytes(suffix);\n    /// }\n    /// ```\n    #[stable(feature = \"slice_align_to\", since = \"1.30.0\")]\n    #[must_use]\n    pub unsafe fn align_to<U>(&self) -> (&[T], &[U], &[T]) {\n        // Note that most of this function will be constant-evaluated,\n        if U::IS_ZST || T::IS_ZST {\n            // handle ZSTs specially, which is – don't handle them at all.\n            return (self, &[], &[]);\n        }\n\n        // First, find at what point do we split between the first and 2nd slice. Easy with\n        // ptr.align_offset.\n        let ptr = self.as_ptr();\n        // SAFETY: See the `align_to_mut` method for the detailed safety comment.\n        let offset = unsafe { crate::ptr::align_offset(ptr, align_of::<U>()) };\n        if offset > self.len() {\n            (self, &[], &[])\n        } else {\n            let (left, rest) = self.split_at(offset);\n            let (us_len, ts_len) = rest.align_to_offsets::<U>();\n            // Inform Miri that we want to consider the \"middle\" pointer to be suitably aligned.\n            #[cfg(miri)]\n            crate::intrinsics::miri_promise_symbolic_alignment(\n                rest.as_ptr().cast(),\n                align_of::<U>(),\n            );\n            // SAFETY: now `rest` is definitely aligned, so `from_raw_parts` below is okay,\n            // since the caller guarantees that we can transmute `T` to `U` safely.\n            unsafe {\n                (\n                    left,\n                    from_raw_parts(rest.as_ptr() as *const U, us_len),\n                    from_raw_parts(rest.as_ptr().add(rest.len() - ts_len), ts_len),\n                )\n            }\n        }\n    }\n\n    /// Transmutes the mutable slice to a mutable slice of another type, ensuring alignment of the\n    /// types is maintained.\n    ///\n    /// This method splits the slice into three distinct slices: prefix, correctly aligned middle\n    /// slice of a new type, and the suffix slice. The middle part will be as big as possible under\n    /// the given alignment constraint and element size.\n    ///\n    /// This method has no purpose when either input element `T` or output element `U` are\n    /// zero-sized and will return the original slice without splitting anything.\n    ///\n    /// # Safety\n    ///\n    /// This method is essentially a `transmute` with respect to the elements in the returned\n    /// middle slice, so all the usual caveats pertaining to `transmute::<T, U>` also apply here.\n    ///\n    /// # Examples\n    ///\n    /// Basic usage:\n    ///\n    /// ```\n    /// unsafe {\n    ///     let mut bytes: [u8; 7] = [1, 2, 3, 4, 5, 6, 7];\n    ///     let (prefix, shorts, suffix) = bytes.align_to_mut::<u16>();\n    ///     // less_efficient_algorithm_for_bytes(prefix);\n    ///     // more_efficient_algorithm_for_aligned_shorts(shorts);\n    ///     // less_efficient_algorithm_for_bytes(suffix);\n    /// }\n    /// ```\n    #[stable(feature = \"slice_align_to\", since = \"1.30.0\")]\n    #[must_use]\n    pub unsafe fn align_to_mut<U>(&mut self) -> (&mut [T], &mut [U], &mut [T]) {\n        // Note that most of this function will be constant-evaluated,\n        if U::IS_ZST || T::IS_ZST {\n            // handle ZSTs specially, which is – don't handle them at all.\n            return (self, &mut [], &mut []);\n        }\n\n        // First, find at what point do we split between the first and 2nd slice. Easy with\n        // ptr.align_offset.\n        let ptr = self.as_ptr();\n        // SAFETY: Here we are ensuring we will use aligned pointers for U for the\n        // rest of the method. This is done by passing a pointer to &[T] with an\n        // alignment targeted for U.\n        // `crate::ptr::align_offset` is called with a correctly aligned and\n        // valid pointer `ptr` (it comes from a reference to `self`) and with\n        // a size that is a power of two (since it comes from the alignment for U),\n        // satisfying its safety constraints.\n        let offset = unsafe { crate::ptr::align_offset(ptr, align_of::<U>()) };\n        if offset > self.len() {\n            (self, &mut [], &mut [])\n        } else {\n            let (left, rest) = self.split_at_mut(offset);\n            let (us_len, ts_len) = rest.align_to_offsets::<U>();\n            let rest_len = rest.len();\n            let mut_ptr = rest.as_mut_ptr();\n            // Inform Miri that we want to consider the \"middle\" pointer to be suitably aligned.\n            #[cfg(miri)]\n            crate::intrinsics::miri_promise_symbolic_alignment(\n                mut_ptr.cast() as *const (),\n                align_of::<U>(),\n            );\n            // We can't use `rest` again after this, that would invalidate its alias `mut_ptr`!\n            // SAFETY: see comments for `align_to`.\n            unsafe {\n                (\n                    left,\n                    from_raw_parts_mut(mut_ptr as *mut U, us_len),\n                    from_raw_parts_mut(mut_ptr.add(rest_len - ts_len), ts_len),\n                )\n            }\n        }\n    }\n\n    /// Splits a slice into a prefix, a middle of aligned SIMD types, and a suffix.\n    ///\n    /// This is a safe wrapper around [`slice::align_to`], so inherits the same\n    /// guarantees as that method.\n    ///\n    /// # Panics\n    ///\n    /// This will panic if the size of the SIMD type is different from\n    /// `LANES` times that of the scalar.\n    ///\n    /// At the time of writing, the trait restrictions on `Simd<T, LANES>` keeps\n    /// that from ever happening, as only power-of-two numbers of lanes are\n    /// supported.  It's possible that, in the future, those restrictions might\n    /// be lifted in a way that would make it possible to see panics from this\n    /// method for something like `LANES == 3`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(portable_simd)]\n    /// use core::simd::prelude::*;\n    ///\n    /// let short = &[1, 2, 3];\n    /// let (prefix, middle, suffix) = short.as_simd::<4>();\n    /// assert_eq!(middle, []); // Not enough elements for anything in the middle\n    ///\n    /// // They might be split in any possible way between prefix and suffix\n    /// let it = prefix.iter().chain(suffix).copied();\n    /// assert_eq!(it.collect::<Vec<_>>(), vec![1, 2, 3]);\n    ///\n    /// fn basic_simd_sum(x: &[f32]) -> f32 {\n    ///     use std::ops::Add;\n    ///     let (prefix, middle, suffix) = x.as_simd();\n    ///     let sums = f32x4::from_array([\n    ///         prefix.iter().copied().sum(),\n    ///         0.0,\n    ///         0.0,\n    ///         suffix.iter().copied().sum(),\n    ///     ]);\n    ///     let sums = middle.iter().copied().fold(sums, f32x4::add);\n    ///     sums.reduce_sum()\n    /// }\n    ///\n    /// let numbers: Vec<f32> = (1..101).map(|x| x as _).collect();\n    /// assert_eq!(basic_simd_sum(&numbers[1..99]), 4949.0);\n    /// ```\n    #[unstable(feature = \"portable_simd\", issue = \"86656\")]\n    #[must_use]\n    pub fn as_simd<const LANES: usize>(&self) -> (&[T], &[Simd<T, LANES>], &[T])\n    where\n        Simd<T, LANES>: AsRef<[T; LANES]>,\n        T: simd::SimdElement,\n        simd::LaneCount<LANES>: simd::SupportedLaneCount,\n    {\n        // These are expected to always match, as vector types are laid out like\n        // arrays per <https://llvm.org/docs/LangRef.html#vector-type>, but we\n        // might as well double-check since it'll optimize away anyhow.\n        assert_eq!(size_of::<Simd<T, LANES>>(), size_of::<[T; LANES]>());\n\n        // SAFETY: The simd types have the same layout as arrays, just with\n        // potentially-higher alignment, so the de-facto transmutes are sound.\n        unsafe { self.align_to() }\n    }\n\n    /// Splits a mutable slice into a mutable prefix, a middle of aligned SIMD types,\n    /// and a mutable suffix.\n    ///\n    /// This is a safe wrapper around [`slice::align_to_mut`], so inherits the same\n    /// guarantees as that method.\n    ///\n    /// This is the mutable version of [`slice::as_simd`]; see that for examples.\n    ///\n    /// # Panics\n    ///\n    /// This will panic if the size of the SIMD type is different from\n    /// `LANES` times that of the scalar.\n    ///\n    /// At the time of writing, the trait restrictions on `Simd<T, LANES>` keeps\n    /// that from ever happening, as only power-of-two numbers of lanes are\n    /// supported.  It's possible that, in the future, those restrictions might\n    /// be lifted in a way that would make it possible to see panics from this\n    /// method for something like `LANES == 3`.\n    #[unstable(feature = \"portable_simd\", issue = \"86656\")]\n    #[must_use]\n    pub fn as_simd_mut<const LANES: usize>(&mut self) -> (&mut [T], &mut [Simd<T, LANES>], &mut [T])\n    where\n        Simd<T, LANES>: AsMut<[T; LANES]>,\n        T: simd::SimdElement,\n        simd::LaneCount<LANES>: simd::SupportedLaneCount,\n    {\n        // These are expected to always match, as vector types are laid out like\n        // arrays per <https://llvm.org/docs/LangRef.html#vector-type>, but we\n        // might as well double-check since it'll optimize away anyhow.\n        assert_eq!(size_of::<Simd<T, LANES>>(), size_of::<[T; LANES]>());\n\n        // SAFETY: The simd types have the same layout as arrays, just with\n        // potentially-higher alignment, so the de-facto transmutes are sound.\n        unsafe { self.align_to_mut() }\n    }\n\n    /// Checks if the elements of this slice are sorted.\n    ///\n    /// That is, for each element `a` and its following element `b`, `a <= b` must hold. If the\n    /// slice yields exactly zero or one element, `true` is returned.\n    ///\n    /// Note that if `Self::Item` is only `PartialOrd`, but not `Ord`, the above definition\n    /// implies that this function returns `false` if any two consecutive items are not\n    /// comparable.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let empty: [i32; 0] = [];\n    ///\n    /// assert!([1, 2, 2, 9].is_sorted());\n    /// assert!(![1, 3, 2, 4].is_sorted());\n    /// assert!([0].is_sorted());\n    /// assert!(empty.is_sorted());\n    /// assert!(![0.0, 1.0, f32::NAN].is_sorted());\n    /// ```\n    #[inline]\n    #[stable(feature = \"is_sorted\", since = \"1.82.0\")]\n    #[must_use]\n    pub fn is_sorted(&self) -> bool\n    where\n        T: PartialOrd,\n    {\n        // This odd number works the best. 32 + 1 extra due to overlapping chunk boundaries.\n        const CHUNK_SIZE: usize = 33;\n        if self.len() < CHUNK_SIZE {\n            return self.windows(2).all(|w| w[0] <= w[1]);\n        }\n        let mut i = 0;\n        // Check in chunks for autovectorization.\n        while i < self.len() - CHUNK_SIZE {\n            let chunk = &self[i..i + CHUNK_SIZE];\n            if !chunk.windows(2).fold(true, |acc, w| acc & (w[0] <= w[1])) {\n                return false;\n            }\n            // We need to ensure that chunk boundaries are also sorted.\n            // Overlap the next chunk with the last element of our last chunk.\n            i += CHUNK_SIZE - 1;\n        }\n        self[i..].windows(2).all(|w| w[0] <= w[1])\n    }\n\n    /// Checks if the elements of this slice are sorted using the given comparator function.\n    ///\n    /// Instead of using `PartialOrd::partial_cmp`, this function uses the given `compare`\n    /// function to determine whether two elements are to be considered in sorted order.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// assert!([1, 2, 2, 9].is_sorted_by(|a, b| a <= b));\n    /// assert!(![1, 2, 2, 9].is_sorted_by(|a, b| a < b));\n    ///\n    /// assert!([0].is_sorted_by(|a, b| true));\n    /// assert!([0].is_sorted_by(|a, b| false));\n    ///\n    /// let empty: [i32; 0] = [];\n    /// assert!(empty.is_sorted_by(|a, b| false));\n    /// assert!(empty.is_sorted_by(|a, b| true));\n    /// ```\n    #[stable(feature = \"is_sorted\", since = \"1.82.0\")]\n    #[must_use]\n    pub fn is_sorted_by<'a, F>(&'a self, mut compare: F) -> bool\n    where\n        F: FnMut(&'a T, &'a T) -> bool,\n    {\n        self.array_windows().all(|[a, b]| compare(a, b))\n    }\n\n    /// Checks if the elements of this slice are sorted using the given key extraction function.\n    ///\n    /// Instead of comparing the slice's elements directly, this function compares the keys of the\n    /// elements, as determined by `f`. Apart from that, it's equivalent to [`is_sorted`]; see its\n    /// documentation for more information.\n    ///\n    /// [`is_sorted`]: slice::is_sorted\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// assert!([\"c\", \"bb\", \"aaa\"].is_sorted_by_key(|s| s.len()));\n    /// assert!(![-2i32, -1, 0, 3].is_sorted_by_key(|n| n.abs()));\n    /// ```\n    #[inline]\n    #[stable(feature = \"is_sorted\", since = \"1.82.0\")]\n    #[must_use]\n    pub fn is_sorted_by_key<'a, F, K>(&'a self, f: F) -> bool\n    where\n        F: FnMut(&'a T) -> K,\n        K: PartialOrd,\n    {\n        self.iter().is_sorted_by_key(f)\n    }\n\n    /// Returns the index of the partition point according to the given predicate\n    /// (the index of the first element of the second partition).\n    ///\n    /// The slice is assumed to be partitioned according to the given predicate.\n    /// This means that all elements for which the predicate returns true are at the start of the slice\n    /// and all elements for which the predicate returns false are at the end.\n    /// For example, `[7, 15, 3, 5, 4, 12, 6]` is partitioned under the predicate `x % 2 != 0`\n    /// (all odd numbers are at the start, all even at the end).\n    ///\n    /// If this slice is not partitioned, the returned result is unspecified and meaningless,\n    /// as this method performs a kind of binary search.\n    ///\n    /// See also [`binary_search`], [`binary_search_by`], and [`binary_search_by_key`].\n    ///\n    /// [`binary_search`]: slice::binary_search\n    /// [`binary_search_by`]: slice::binary_search_by\n    /// [`binary_search_by_key`]: slice::binary_search_by_key\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let v = [1, 2, 3, 3, 5, 6, 7];\n    /// let i = v.partition_point(|&x| x < 5);\n    ///\n    /// assert_eq!(i, 4);\n    /// assert!(v[..i].iter().all(|&x| x < 5));\n    /// assert!(v[i..].iter().all(|&x| !(x < 5)));\n    /// ```\n    ///\n    /// If all elements of the slice match the predicate, including if the slice\n    /// is empty, then the length of the slice will be returned:\n    ///\n    /// ```\n    /// let a = [2, 4, 8];\n    /// assert_eq!(a.partition_point(|x| x < &100), a.len());\n    /// let a: [i32; 0] = [];\n    /// assert_eq!(a.partition_point(|x| x < &100), 0);\n    /// ```\n    ///\n    /// If you want to insert an item to a sorted vector, while maintaining\n    /// sort order:\n    ///\n    /// ```\n    /// let mut s = vec![0, 1, 1, 1, 1, 2, 3, 5, 8, 13, 21, 34, 55];\n    /// let num = 42;\n    /// let idx = s.partition_point(|&x| x <= num);\n    /// s.insert(idx, num);\n    /// assert_eq!(s, [0, 1, 1, 1, 1, 2, 3, 5, 8, 13, 21, 34, 42, 55]);\n    /// ```\n    #[stable(feature = \"partition_point\", since = \"1.52.0\")]\n    #[must_use]\n    pub fn partition_point<P>(&self, mut pred: P) -> usize\n    where\n        P: FnMut(&T) -> bool,\n    {\n        self.binary_search_by(|x| if pred(x) { Less } else { Greater }).unwrap_or_else(|i| i)\n    }\n\n    /// Removes the subslice corresponding to the given range\n    /// and returns a reference to it.\n    ///\n    /// Returns `None` and does not modify the slice if the given\n    /// range is out of bounds.\n    ///\n    /// Note that this method only accepts one-sided ranges such as\n    /// `2..` or `..6`, but not `2..6`.\n    ///\n    /// # Examples\n    ///\n    /// Splitting off the first three elements of a slice:\n    ///\n    /// ```\n    /// let mut slice: &[_] = &['a', 'b', 'c', 'd'];\n    /// let mut first_three = slice.split_off(..3).unwrap();\n    ///\n    /// assert_eq!(slice, &['d']);\n    /// assert_eq!(first_three, &['a', 'b', 'c']);\n    /// ```\n    ///\n    /// Splitting off a slice starting with the third element:\n    ///\n    /// ```\n    /// let mut slice: &[_] = &['a', 'b', 'c', 'd'];\n    /// let mut tail = slice.split_off(2..).unwrap();\n    ///\n    /// assert_eq!(slice, &['a', 'b']);\n    /// assert_eq!(tail, &['c', 'd']);\n    /// ```\n    ///\n    /// Getting `None` when `range` is out of bounds:\n    ///\n    /// ```\n    /// let mut slice: &[_] = &['a', 'b', 'c', 'd'];\n    ///\n    /// assert_eq!(None, slice.split_off(5..));\n    /// assert_eq!(None, slice.split_off(..5));\n    /// assert_eq!(None, slice.split_off(..=4));\n    /// let expected: &[char] = &['a', 'b', 'c', 'd'];\n    /// assert_eq!(Some(expected), slice.split_off(..4));\n    /// ```\n    #[inline]\n    #[must_use = \"method does not modify the slice if the range is out of bounds\"]\n    #[stable(feature = \"slice_take\", since = \"1.87.0\")]\n    pub fn split_off<'a, R: OneSidedRange<usize>>(\n        self: &mut &'a Self,\n        range: R,\n    ) -> Option<&'a Self> {\n        let (direction, split_index) = split_point_of(range)?;\n        if split_index > self.len() {\n            return None;\n        }\n        let (front, back) = self.split_at(split_index);\n        match direction {\n            Direction::Front => {\n                *self = back;\n                Some(front)\n            }\n            Direction::Back => {\n                *self = front;\n                Some(back)\n            }\n        }\n    }\n\n    /// Removes the subslice corresponding to the given range\n    /// and returns a mutable reference to it.\n    ///\n    /// Returns `None` and does not modify the slice if the given\n    /// range is out of bounds.\n    ///\n    /// Note that this method only accepts one-sided ranges such as\n    /// `2..` or `..6`, but not `2..6`.\n    ///\n    /// # Examples\n    ///\n    /// Splitting off the first three elements of a slice:\n    ///\n    /// ```\n    /// let mut slice: &mut [_] = &mut ['a', 'b', 'c', 'd'];\n    /// let mut first_three = slice.split_off_mut(..3).unwrap();\n    ///\n    /// assert_eq!(slice, &mut ['d']);\n    /// assert_eq!(first_three, &mut ['a', 'b', 'c']);\n    /// ```\n    ///\n    /// Splitting off a slice starting with the third element:\n    ///\n    /// ```\n    /// let mut slice: &mut [_] = &mut ['a', 'b', 'c', 'd'];\n    /// let mut tail = slice.split_off_mut(2..).unwrap();\n    ///\n    /// assert_eq!(slice, &mut ['a', 'b']);\n    /// assert_eq!(tail, &mut ['c', 'd']);\n    /// ```\n    ///\n    /// Getting `None` when `range` is out of bounds:\n    ///\n    /// ```\n    /// let mut slice: &mut [_] = &mut ['a', 'b', 'c', 'd'];\n    ///\n    /// assert_eq!(None, slice.split_off_mut(5..));\n    /// assert_eq!(None, slice.split_off_mut(..5));\n    /// assert_eq!(None, slice.split_off_mut(..=4));\n    /// let expected: &mut [_] = &mut ['a', 'b', 'c', 'd'];\n    /// assert_eq!(Some(expected), slice.split_off_mut(..4));\n    /// ```\n    #[inline]\n    #[must_use = \"method does not modify the slice if the range is out of bounds\"]\n    #[stable(feature = \"slice_take\", since = \"1.87.0\")]\n    pub fn split_off_mut<'a, R: OneSidedRange<usize>>(\n        self: &mut &'a mut Self,\n        range: R,\n    ) -> Option<&'a mut Self> {\n        let (direction, split_index) = split_point_of(range)?;\n        if split_index > self.len() {\n            return None;\n        }\n        let (front, back) = mem::take(self).split_at_mut(split_index);\n        match direction {\n            Direction::Front => {\n                *self = back;\n                Some(front)\n            }\n            Direction::Back => {\n                *self = front;\n                Some(back)\n            }\n        }\n    }\n\n    /// Removes the first element of the slice and returns a reference\n    /// to it.\n    ///\n    /// Returns `None` if the slice is empty.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut slice: &[_] = &['a', 'b', 'c'];\n    /// let first = slice.split_off_first().unwrap();\n    ///\n    /// assert_eq!(slice, &['b', 'c']);\n    /// assert_eq!(first, &'a');\n    /// ```\n    #[inline]\n    #[stable(feature = \"slice_take\", since = \"1.87.0\")]\n    #[rustc_const_unstable(feature = \"const_split_off_first_last\", issue = \"138539\")]\n    pub const fn split_off_first<'a>(self: &mut &'a Self) -> Option<&'a T> {\n        // FIXME(const-hack): Use `?` when available in const instead of `let-else`.\n        let Some((first, rem)) = self.split_first() else { return None };\n        *self = rem;\n        Some(first)\n    }\n\n    /// Removes the first element of the slice and returns a mutable\n    /// reference to it.\n    ///\n    /// Returns `None` if the slice is empty.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut slice: &mut [_] = &mut ['a', 'b', 'c'];\n    /// let first = slice.split_off_first_mut().unwrap();\n    /// *first = 'd';\n    ///\n    /// assert_eq!(slice, &['b', 'c']);\n    /// assert_eq!(first, &'d');\n    /// ```\n    #[inline]\n    #[stable(feature = \"slice_take\", since = \"1.87.0\")]\n    #[rustc_const_unstable(feature = \"const_split_off_first_last\", issue = \"138539\")]\n    pub const fn split_off_first_mut<'a>(self: &mut &'a mut Self) -> Option<&'a mut T> {\n        // FIXME(const-hack): Use `mem::take` and `?` when available in const.\n        // Original: `mem::take(self).split_first_mut()?`\n        let Some((first, rem)) = mem::replace(self, &mut []).split_first_mut() else { return None };\n        *self = rem;\n        Some(first)\n    }\n\n    /// Removes the last element of the slice and returns a reference\n    /// to it.\n    ///\n    /// Returns `None` if the slice is empty.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut slice: &[_] = &['a', 'b', 'c'];\n    /// let last = slice.split_off_last().unwrap();\n    ///\n    /// assert_eq!(slice, &['a', 'b']);\n    /// assert_eq!(last, &'c');\n    /// ```\n    #[inline]\n    #[stable(feature = \"slice_take\", since = \"1.87.0\")]\n    #[rustc_const_unstable(feature = \"const_split_off_first_last\", issue = \"138539\")]\n    pub const fn split_off_last<'a>(self: &mut &'a Self) -> Option<&'a T> {\n        // FIXME(const-hack): Use `?` when available in const instead of `let-else`.\n        let Some((last, rem)) = self.split_last() else { return None };\n        *self = rem;\n        Some(last)\n    }\n\n    /// Removes the last element of the slice and returns a mutable\n    /// reference to it.\n    ///\n    /// Returns `None` if the slice is empty.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut slice: &mut [_] = &mut ['a', 'b', 'c'];\n    /// let last = slice.split_off_last_mut().unwrap();\n    /// *last = 'd';\n    ///\n    /// assert_eq!(slice, &['a', 'b']);\n    /// assert_eq!(last, &'d');\n    /// ```\n    #[inline]\n    #[stable(feature = \"slice_take\", since = \"1.87.0\")]\n    #[rustc_const_unstable(feature = \"const_split_off_first_last\", issue = \"138539\")]\n    pub const fn split_off_last_mut<'a>(self: &mut &'a mut Self) -> Option<&'a mut T> {\n        // FIXME(const-hack): Use `mem::take` and `?` when available in const.\n        // Original: `mem::take(self).split_last_mut()?`\n        let Some((last, rem)) = mem::replace(self, &mut []).split_last_mut() else { return None };\n        *self = rem;\n        Some(last)\n    }\n\n    /// Returns mutable references to many indices at once, without doing any checks.\n    ///\n    /// An index can be either a `usize`, a [`Range`] or a [`RangeInclusive`]. Note\n    /// that this method takes an array, so all indices must be of the same type.\n    /// If passed an array of `usize`s this method gives back an array of mutable references\n    /// to single elements, while if passed an array of ranges it gives back an array of\n    /// mutable references to slices.\n    ///\n    /// For a safe alternative see [`get_disjoint_mut`].\n    ///\n    /// # Safety\n    ///\n    /// Calling this method with overlapping or out-of-bounds indices is *[undefined behavior]*\n    /// even if the resulting references are not used.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let x = &mut [1, 2, 4];\n    ///\n    /// unsafe {\n    ///     let [a, b] = x.get_disjoint_unchecked_mut([0, 2]);\n    ///     *a *= 10;\n    ///     *b *= 100;\n    /// }\n    /// assert_eq!(x, &[10, 2, 400]);\n    ///\n    /// unsafe {\n    ///     let [a, b] = x.get_disjoint_unchecked_mut([0..1, 1..3]);\n    ///     a[0] = 8;\n    ///     b[0] = 88;\n    ///     b[1] = 888;\n    /// }\n    /// assert_eq!(x, &[8, 88, 888]);\n    ///\n    /// unsafe {\n    ///     let [a, b] = x.get_disjoint_unchecked_mut([1..=2, 0..=0]);\n    ///     a[0] = 11;\n    ///     a[1] = 111;\n    ///     b[0] = 1;\n    /// }\n    /// assert_eq!(x, &[1, 11, 111]);\n    /// ```\n    ///\n    /// [`get_disjoint_mut`]: slice::get_disjoint_mut\n    /// [undefined behavior]: https://doc.rust-lang.org/reference/behavior-considered-undefined.html\n    #[stable(feature = \"get_many_mut\", since = \"1.86.0\")]\n    #[inline]\n    #[track_caller]\n    pub unsafe fn get_disjoint_unchecked_mut<I, const N: usize>(\n        &mut self,\n        indices: [I; N],\n    ) -> [&mut I::Output; N]\n    where\n        I: GetDisjointMutIndex + SliceIndex<Self>,\n    {\n        // NB: This implementation is written as it is because any variation of\n        // `indices.map(|i| self.get_unchecked_mut(i))` would make miri unhappy,\n        // or generate worse code otherwise. This is also why we need to go\n        // through a raw pointer here.\n        let slice: *mut [T] = self;\n        let mut arr: MaybeUninit<[&mut I::Output; N]> = MaybeUninit::uninit();\n        let arr_ptr = arr.as_mut_ptr();\n\n        // SAFETY: We expect `indices` to contain disjunct values that are\n        // in bounds of `self`.\n        unsafe {\n            for i in 0..N {\n                let idx = indices.get_unchecked(i).clone();\n                arr_ptr.cast::<&mut I::Output>().add(i).write(&mut *slice.get_unchecked_mut(idx));\n            }\n            arr.assume_init()\n        }\n    }\n\n    /// Returns mutable references to many indices at once.\n    ///\n    /// An index can be either a `usize`, a [`Range`] or a [`RangeInclusive`]. Note\n    /// that this method takes an array, so all indices must be of the same type.\n    /// If passed an array of `usize`s this method gives back an array of mutable references\n    /// to single elements, while if passed an array of ranges it gives back an array of\n    /// mutable references to slices.\n    ///\n    /// Returns an error if any index is out-of-bounds, or if there are overlapping indices.\n    /// An empty range is not considered to overlap if it is located at the beginning or at\n    /// the end of another range, but is considered to overlap if it is located in the middle.\n    ///\n    /// This method does a O(n^2) check to check that there are no overlapping indices, so be careful\n    /// when passing many indices.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let v = &mut [1, 2, 3];\n    /// if let Ok([a, b]) = v.get_disjoint_mut([0, 2]) {\n    ///     *a = 413;\n    ///     *b = 612;\n    /// }\n    /// assert_eq!(v, &[413, 2, 612]);\n    ///\n    /// if let Ok([a, b]) = v.get_disjoint_mut([0..1, 1..3]) {\n    ///     a[0] = 8;\n    ///     b[0] = 88;\n    ///     b[1] = 888;\n    /// }\n    /// assert_eq!(v, &[8, 88, 888]);\n    ///\n    /// if let Ok([a, b]) = v.get_disjoint_mut([1..=2, 0..=0]) {\n    ///     a[0] = 11;\n    ///     a[1] = 111;\n    ///     b[0] = 1;\n    /// }\n    /// assert_eq!(v, &[1, 11, 111]);\n    /// ```\n    #[stable(feature = \"get_many_mut\", since = \"1.86.0\")]\n    #[inline]\n    pub fn get_disjoint_mut<I, const N: usize>(\n        &mut self,\n        indices: [I; N],\n    ) -> Result<[&mut I::Output; N], GetDisjointMutError>\n    where\n        I: GetDisjointMutIndex + SliceIndex<Self>,\n    {\n        get_disjoint_check_valid(&indices, self.len())?;\n        // SAFETY: The `get_disjoint_check_valid()` call checked that all indices\n        // are disjunct and in bounds.\n        unsafe { Ok(self.get_disjoint_unchecked_mut(indices)) }\n    }\n\n    /// Returns the index that an element reference points to.\n    ///\n    /// Returns `None` if `element` does not point to the start of an element within the slice.\n    ///\n    /// This method is useful for extending slice iterators like [`slice::split`].\n    ///\n    /// Note that this uses pointer arithmetic and **does not compare elements**.\n    /// To find the index of an element via comparison, use\n    /// [`.iter().position()`](crate::iter::Iterator::position) instead.\n    ///\n    /// # Panics\n    /// Panics if `T` is zero-sized.\n    ///\n    /// # Examples\n    /// Basic usage:\n    /// ```\n    /// #![feature(substr_range)]\n    ///\n    /// let nums: &[u32] = &[1, 7, 1, 1];\n    /// let num = &nums[2];\n    ///\n    /// assert_eq!(num, &1);\n    /// assert_eq!(nums.element_offset(num), Some(2));\n    /// ```\n    /// Returning `None` with an unaligned element:\n    /// ```\n    /// #![feature(substr_range)]\n    ///\n    /// let arr: &[[u32; 2]] = &[[0, 1], [2, 3]];\n    /// let flat_arr: &[u32] = arr.as_flattened();\n    ///\n    /// let ok_elm: &[u32; 2] = flat_arr[0..2].try_into().unwrap();\n    /// let weird_elm: &[u32; 2] = flat_arr[1..3].try_into().unwrap();\n    ///\n    /// assert_eq!(ok_elm, &[0, 1]);\n    /// assert_eq!(weird_elm, &[1, 2]);\n    ///\n    /// assert_eq!(arr.element_offset(ok_elm), Some(0)); // Points to element 0\n    /// assert_eq!(arr.element_offset(weird_elm), None); // Points between element 0 and 1\n    /// ```\n    #[must_use]\n    #[unstable(feature = \"substr_range\", issue = \"126769\")]\n    pub fn element_offset(&self, element: &T) -> Option<usize> {\n        if T::IS_ZST {\n            panic!(\"elements are zero-sized\");\n        }\n\n        let self_start = self.as_ptr().addr();\n        let elem_start = ptr::from_ref(element).addr();\n\n        let byte_offset = elem_start.wrapping_sub(self_start);\n\n        if !byte_offset.is_multiple_of(size_of::<T>()) {\n            return None;\n        }\n\n        let offset = byte_offset / size_of::<T>();\n\n        if offset < self.len() { Some(offset) } else { None }\n    }\n\n    /// Returns the range of indices that a subslice points to.\n    ///\n    /// Returns `None` if `subslice` does not point within the slice or if it is not aligned with the\n    /// elements in the slice.\n    ///\n    /// This method **does not compare elements**. Instead, this method finds the location in the slice that\n    /// `subslice` was obtained from. To find the index of a subslice via comparison, instead use\n    /// [`.windows()`](slice::windows)[`.position()`](crate::iter::Iterator::position).\n    ///\n    /// This method is useful for extending slice iterators like [`slice::split`].\n    ///\n    /// Note that this may return a false positive (either `Some(0..0)` or `Some(self.len()..self.len())`)\n    /// if `subslice` has a length of zero and points to the beginning or end of another, separate, slice.\n    ///\n    /// # Panics\n    /// Panics if `T` is zero-sized.\n    ///\n    /// # Examples\n    /// Basic usage:\n    /// ```\n    /// #![feature(substr_range)]\n    ///\n    /// let nums = &[0, 5, 10, 0, 0, 5];\n    ///\n    /// let mut iter = nums\n    ///     .split(|t| *t == 0)\n    ///     .map(|n| nums.subslice_range(n).unwrap());\n    ///\n    /// assert_eq!(iter.next(), Some(0..0));\n    /// assert_eq!(iter.next(), Some(1..3));\n    /// assert_eq!(iter.next(), Some(4..4));\n    /// assert_eq!(iter.next(), Some(5..6));\n    /// ```\n    #[must_use]\n    #[unstable(feature = \"substr_range\", issue = \"126769\")]\n    pub fn subslice_range(&self, subslice: &[T]) -> Option<Range<usize>> {\n        if T::IS_ZST {\n            panic!(\"elements are zero-sized\");\n        }\n\n        let self_start = self.as_ptr().addr();\n        let subslice_start = subslice.as_ptr().addr();\n\n        let byte_start = subslice_start.wrapping_sub(self_start);\n\n        if !byte_start.is_multiple_of(size_of::<T>()) {\n            return None;\n        }\n\n        let start = byte_start / size_of::<T>();\n        let end = start.wrapping_add(subslice.len());\n\n        if start <= self.len() && end <= self.len() { Some(start..end) } else { None }\n    }\n}\n\nimpl<T> [MaybeUninit<T>] {\n    /// Transmutes the mutable uninitialized slice to a mutable uninitialized slice of\n    /// another type, ensuring alignment of the types is maintained.\n    ///\n    /// This is a safe wrapper around [`slice::align_to_mut`], so inherits the same\n    /// guarantees as that method.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(align_to_uninit_mut)]\n    /// use std::mem::MaybeUninit;\n    ///\n    /// pub struct BumpAllocator<'scope> {\n    ///     memory: &'scope mut [MaybeUninit<u8>],\n    /// }\n    ///\n    /// impl<'scope> BumpAllocator<'scope> {\n    ///     pub fn new(memory: &'scope mut [MaybeUninit<u8>]) -> Self {\n    ///         Self { memory }\n    ///     }\n    ///     pub fn try_alloc_uninit<T>(&mut self) -> Option<&'scope mut MaybeUninit<T>> {\n    ///         let first_end = self.memory.as_ptr().align_offset(align_of::<T>()) + size_of::<T>();\n    ///         let prefix = self.memory.split_off_mut(..first_end)?;\n    ///         Some(&mut prefix.align_to_uninit_mut::<T>().1[0])\n    ///     }\n    ///     pub fn try_alloc_u32(&mut self, value: u32) -> Option<&'scope mut u32> {\n    ///         let uninit = self.try_alloc_uninit()?;\n    ///         Some(uninit.write(value))\n    ///     }\n    /// }\n    ///\n    /// let mut memory = [MaybeUninit::<u8>::uninit(); 10];\n    /// let mut allocator = BumpAllocator::new(&mut memory);\n    /// let v = allocator.try_alloc_u32(42);\n    /// assert_eq!(v, Some(&mut 42));\n    /// ```\n    #[unstable(feature = \"align_to_uninit_mut\", issue = \"139062\")]\n    #[inline]\n    #[must_use]\n    pub fn align_to_uninit_mut<U>(&mut self) -> (&mut Self, &mut [MaybeUninit<U>], &mut Self) {\n        // SAFETY: `MaybeUninit` is transparent. Correct size and alignment are guaranteed by\n        // `align_to_mut` itself. Therefore the only thing that we have to ensure for a safe\n        // `transmute` is that the values are valid for the types involved. But for `MaybeUninit`\n        // any values are valid, so this operation is safe.\n        unsafe { self.align_to_mut() }\n    }\n}\n\nimpl<T, const N: usize> [[T; N]] {\n    /// Takes a `&[[T; N]]`, and flattens it to a `&[T]`.\n    ///\n    /// For the opposite operation, see [`as_chunks`] and [`as_rchunks`].\n    ///\n    /// [`as_chunks`]: slice::as_chunks\n    /// [`as_rchunks`]: slice::as_rchunks\n    ///\n    /// # Panics\n    ///\n    /// This panics if the length of the resulting slice would overflow a `usize`.\n    ///\n    /// This is only possible when flattening a slice of arrays of zero-sized\n    /// types, and thus tends to be irrelevant in practice. If\n    /// `size_of::<T>() > 0`, this will never panic.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// assert_eq!([[1, 2, 3], [4, 5, 6]].as_flattened(), &[1, 2, 3, 4, 5, 6]);\n    ///\n    /// assert_eq!(\n    ///     [[1, 2, 3], [4, 5, 6]].as_flattened(),\n    ///     [[1, 2], [3, 4], [5, 6]].as_flattened(),\n    /// );\n    ///\n    /// let slice_of_empty_arrays: &[[i32; 0]] = &[[], [], [], [], []];\n    /// assert!(slice_of_empty_arrays.as_flattened().is_empty());\n    ///\n    /// let empty_slice_of_arrays: &[[u32; 10]] = &[];\n    /// assert!(empty_slice_of_arrays.as_flattened().is_empty());\n    /// ```\n    #[stable(feature = \"slice_flatten\", since = \"1.80.0\")]\n    #[rustc_const_stable(feature = \"const_slice_flatten\", since = \"1.87.0\")]\n    pub const fn as_flattened(&self) -> &[T] {\n        let len = if T::IS_ZST {\n            self.len().checked_mul(N).expect(\"slice len overflow\")\n        } else {\n            // SAFETY: `self.len() * N` cannot overflow because `self` is\n            // already in the address space.\n            unsafe { self.len().unchecked_mul(N) }\n        };\n        // SAFETY: `[T]` is layout-identical to `[T; N]`\n        unsafe { from_raw_parts(self.as_ptr().cast(), len) }\n    }\n\n    /// Takes a `&mut [[T; N]]`, and flattens it to a `&mut [T]`.\n    ///\n    /// For the opposite operation, see [`as_chunks_mut`] and [`as_rchunks_mut`].\n    ///\n    /// [`as_chunks_mut`]: slice::as_chunks_mut\n    /// [`as_rchunks_mut`]: slice::as_rchunks_mut\n    ///\n    /// # Panics\n    ///\n    /// This panics if the length of the resulting slice would overflow a `usize`.\n    ///\n    /// This is only possible when flattening a slice of arrays of zero-sized\n    /// types, and thus tends to be irrelevant in practice. If\n    /// `size_of::<T>() > 0`, this will never panic.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// fn add_5_to_all(slice: &mut [i32]) {\n    ///     for i in slice {\n    ///         *i += 5;\n    ///     }\n    /// }\n    ///\n    /// let mut array = [[1, 2, 3], [4, 5, 6], [7, 8, 9]];\n    /// add_5_to_all(array.as_flattened_mut());\n    /// assert_eq!(array, [[6, 7, 8], [9, 10, 11], [12, 13, 14]]);\n    /// ```\n    #[stable(feature = \"slice_flatten\", since = \"1.80.0\")]\n    #[rustc_const_stable(feature = \"const_slice_flatten\", since = \"1.87.0\")]\n    pub const fn as_flattened_mut(&mut self) -> &mut [T] {\n        let len = if T::IS_ZST {\n            self.len().checked_mul(N).expect(\"slice len overflow\")\n        } else {\n            // SAFETY: `self.len() * N` cannot overflow because `self` is\n            // already in the address space.\n            unsafe { self.len().unchecked_mul(N) }\n        };\n        // SAFETY: `[T]` is layout-identical to `[T; N]`\n        unsafe { from_raw_parts_mut(self.as_mut_ptr().cast(), len) }\n    }\n}\n\nimpl [f32] {\n    /// Sorts the slice of floats.\n    ///\n    /// This sort is in-place (i.e. does not allocate), *O*(*n* \\* log(*n*)) worst-case, and uses\n    /// the ordering defined by [`f32::total_cmp`].\n    ///\n    /// # Current implementation\n    ///\n    /// This uses the same sorting algorithm as [`sort_unstable_by`](slice::sort_unstable_by).\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(sort_floats)]\n    /// let mut v = [2.6, -5e-8, f32::NAN, 8.29, f32::INFINITY, -1.0, 0.0, -f32::INFINITY, -0.0];\n    ///\n    /// v.sort_floats();\n    /// let sorted = [-f32::INFINITY, -1.0, -5e-8, -0.0, 0.0, 2.6, 8.29, f32::INFINITY, f32::NAN];\n    /// assert_eq!(&v[..8], &sorted[..8]);\n    /// assert!(v[8].is_nan());\n    /// ```\n    #[unstable(feature = \"sort_floats\", issue = \"93396\")]\n    #[inline]\n    pub fn sort_floats(&mut self) {\n        self.sort_unstable_by(f32::total_cmp);\n    }\n}\n\nimpl [f64] {\n    /// Sorts the slice of floats.\n    ///\n    /// This sort is in-place (i.e. does not allocate), *O*(*n* \\* log(*n*)) worst-case, and uses\n    /// the ordering defined by [`f64::total_cmp`].\n    ///\n    /// # Current implementation\n    ///\n    /// This uses the same sorting algorithm as [`sort_unstable_by`](slice::sort_unstable_by).\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(sort_floats)]\n    /// let mut v = [2.6, -5e-8, f64::NAN, 8.29, f64::INFINITY, -1.0, 0.0, -f64::INFINITY, -0.0];\n    ///\n    /// v.sort_floats();\n    /// let sorted = [-f64::INFINITY, -1.0, -5e-8, -0.0, 0.0, 2.6, 8.29, f64::INFINITY, f64::NAN];\n    /// assert_eq!(&v[..8], &sorted[..8]);\n    /// assert!(v[8].is_nan());\n    /// ```\n    #[unstable(feature = \"sort_floats\", issue = \"93396\")]\n    #[inline]\n    pub fn sort_floats(&mut self) {\n        self.sort_unstable_by(f64::total_cmp);\n    }\n}\n\n/// Copies `src` to `dest`.\n///\n/// # Safety\n/// `T` must implement one of `Copy` or `TrivialClone`.\n#[track_caller]\nconst unsafe fn copy_from_slice_impl<T: Clone>(dest: &mut [T], src: &[T]) {\n    // The panic code path was put into a cold function to not bloat the\n    // call site.\n    #[cfg_attr(not(panic = \"immediate-abort\"), inline(never), cold)]\n    #[cfg_attr(panic = \"immediate-abort\", inline)]\n    #[track_caller]\n    const fn len_mismatch_fail(dst_len: usize, src_len: usize) -> ! {\n        const_panic!(\n            \"copy_from_slice: source slice length does not match destination slice length\",\n            \"copy_from_slice: source slice length ({src_len}) does not match destination slice length ({dst_len})\",\n            src_len: usize,\n            dst_len: usize,\n        )\n    }\n\n    if dest.len() != src.len() {\n        len_mismatch_fail(dest.len(), src.len());\n    }\n\n    // SAFETY: `self` is valid for `self.len()` elements by definition, and `src` was\n    // checked to have the same length. The slices cannot overlap because\n    // mutable references are exclusive.\n    unsafe {\n        ptr::copy_nonoverlapping(src.as_ptr(), dest.as_mut_ptr(), dest.len());\n    }\n}\n\ntrait CloneFromSpec<T> {\n    fn spec_clone_from(&mut self, src: &[T]);\n}\n\nimpl<T> CloneFromSpec<T> for [T]\nwhere\n    T: Clone,\n{\n    #[track_caller]\n    default fn spec_clone_from(&mut self, src: &[T]) {\n        assert!(self.len() == src.len(), \"destination and source slices have different lengths\");\n        // NOTE: We need to explicitly slice them to the same length\n        // to make it easier for the optimizer to elide bounds checking.\n        // But since it can't be relied on we also have an explicit specialization for T: Copy.\n        let len = self.len();\n        let src = &src[..len];\n        for i in 0..len {\n            self[i].clone_from(&src[i]);\n        }\n    }\n}\n\nimpl<T> CloneFromSpec<T> for [T]\nwhere\n    T: TrivialClone,\n{\n    #[track_caller]\n    fn spec_clone_from(&mut self, src: &[T]) {\n        // SAFETY: `T` implements `TrivialClone`.\n        unsafe {\n            copy_from_slice_impl(self, src);\n        }\n    }\n}\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\n#[rustc_const_unstable(feature = \"const_default\", issue = \"143894\")]\nimpl<T> const Default for &[T] {\n    /// Creates an empty slice.\n    fn default() -> Self {\n        &[]\n    }\n}\n\n#[stable(feature = \"mut_slice_default\", since = \"1.5.0\")]\n#[rustc_const_unstable(feature = \"const_default\", issue = \"143894\")]\nimpl<T> const Default for &mut [T] {\n    /// Creates a mutable empty slice.\n    fn default() -> Self {\n        &mut []\n    }\n}\n\n#[unstable(feature = \"slice_pattern\", reason = \"stopgap trait for slice patterns\", issue = \"56345\")]\n/// Patterns in slices - currently, only used by `strip_prefix` and `strip_suffix`.  At a future\n/// point, we hope to generalise `core::str::Pattern` (which at the time of writing is limited to\n/// `str`) to slices, and then this trait will be replaced or abolished.\npub trait SlicePattern {\n    /// The element type of the slice being matched on.\n    type Item;\n\n    /// Currently, the consumers of `SlicePattern` need a slice.\n    fn as_slice(&self) -> &[Self::Item];\n}\n\n#[stable(feature = \"slice_strip\", since = \"1.51.0\")]\nimpl<T> SlicePattern for [T] {\n    type Item = T;\n\n    #[inline]\n    fn as_slice(&self) -> &[Self::Item] {\n        self\n    }\n}\n\n#[stable(feature = \"slice_strip\", since = \"1.51.0\")]\nimpl<T, const N: usize> SlicePattern for [T; N] {\n    type Item = T;\n\n    #[inline]\n    fn as_slice(&self) -> &[Self::Item] {\n        self\n    }\n}\n\n/// This checks every index against each other, and against `len`.\n///\n/// This will do `binomial(N + 1, 2) = N * (N + 1) / 2 = 0, 1, 3, 6, 10, ..`\n/// comparison operations.\n#[inline]\nfn get_disjoint_check_valid<I: GetDisjointMutIndex, const N: usize>(\n    indices: &[I; N],\n    len: usize,\n) -> Result<(), GetDisjointMutError> {\n    // NB: The optimizer should inline the loops into a sequence\n    // of instructions without additional branching.\n    for (i, idx) in indices.iter().enumerate() {\n        if !idx.is_in_bounds(len) {\n            return Err(GetDisjointMutError::IndexOutOfBounds);\n        }\n        for idx2 in &indices[..i] {\n            if idx.is_overlapping(idx2) {\n                return Err(GetDisjointMutError::OverlappingIndices);\n            }\n        }\n    }\n    Ok(())\n}\n\n/// The error type returned by [`get_disjoint_mut`][`slice::get_disjoint_mut`].\n///\n/// It indicates one of two possible errors:\n/// - An index is out-of-bounds.\n/// - The same index appeared multiple times in the array\n///   (or different but overlapping indices when ranges are provided).\n///\n/// # Examples\n///\n/// ```\n/// use std::slice::GetDisjointMutError;\n///\n/// let v = &mut [1, 2, 3];\n/// assert_eq!(v.get_disjoint_mut([0, 999]), Err(GetDisjointMutError::IndexOutOfBounds));\n/// assert_eq!(v.get_disjoint_mut([1, 1]), Err(GetDisjointMutError::OverlappingIndices));\n/// ```\n#[stable(feature = \"get_many_mut\", since = \"1.86.0\")]\n#[derive(Debug, Clone, PartialEq, Eq)]\npub enum GetDisjointMutError {\n    /// An index provided was out-of-bounds for the slice.\n    IndexOutOfBounds,\n    /// Two indices provided were overlapping.\n    OverlappingIndices,\n}\n\n#[stable(feature = \"get_many_mut\", since = \"1.86.0\")]\nimpl fmt::Display for GetDisjointMutError {\n    fn fmt(&self, f: &mut fmt::Formatter<'_>) -> fmt::Result {\n        let msg = match self {\n            GetDisjointMutError::IndexOutOfBounds => \"an index is out of bounds\",\n            GetDisjointMutError::OverlappingIndices => \"there were overlapping indices\",\n        };\n        fmt::Display::fmt(msg, f)\n    }\n}\n\nmod private_get_disjoint_mut_index {\n    use super::{Range, RangeInclusive, range};\n\n    #[unstable(feature = \"get_disjoint_mut_helpers\", issue = \"none\")]\n    pub trait Sealed {}\n\n    #[unstable(feature = \"get_disjoint_mut_helpers\", issue = \"none\")]\n    impl Sealed for usize {}\n    #[unstable(feature = \"get_disjoint_mut_helpers\", issue = \"none\")]\n    impl Sealed for Range<usize> {}\n    #[unstable(feature = \"get_disjoint_mut_helpers\", issue = \"none\")]\n    impl Sealed for RangeInclusive<usize> {}\n    #[unstable(feature = \"get_disjoint_mut_helpers\", issue = \"none\")]\n    impl Sealed for range::Range<usize> {}\n    #[unstable(feature = \"get_disjoint_mut_helpers\", issue = \"none\")]\n    impl Sealed for range::RangeInclusive<usize> {}\n}\n\n/// A helper trait for `<[T]>::get_disjoint_mut()`.\n///\n/// # Safety\n///\n/// If `is_in_bounds()` returns `true` and `is_overlapping()` returns `false`,\n/// it must be safe to index the slice with the indices.\n#[unstable(feature = \"get_disjoint_mut_helpers\", issue = \"none\")]\npub unsafe trait GetDisjointMutIndex:\n    Clone + private_get_disjoint_mut_index::Sealed\n{\n    /// Returns `true` if `self` is in bounds for `len` slice elements.\n    #[unstable(feature = \"get_disjoint_mut_helpers\", issue = \"none\")]\n    fn is_in_bounds(&self, len: usize) -> bool;\n\n    /// Returns `true` if `self` overlaps with `other`.\n    ///\n    /// Note that we don't consider zero-length ranges to overlap at the beginning or the end,\n    /// but do consider them to overlap in the middle.\n    #[unstable(feature = \"get_disjoint_mut_helpers\", issue = \"none\")]\n    fn is_overlapping(&self, other: &Self) -> bool;\n}\n\n#[unstable(feature = \"get_disjoint_mut_helpers\", issue = \"none\")]\n// SAFETY: We implement `is_in_bounds()` and `is_overlapping()` correctly.\nunsafe impl GetDisjointMutIndex for usize {\n    #[inline]\n    fn is_in_bounds(&self, len: usize) -> bool {\n        *self < len\n    }\n\n    #[inline]\n    fn is_overlapping(&self, other: &Self) -> bool {\n        *self == *other\n    }\n}\n\n#[unstable(feature = \"get_disjoint_mut_helpers\", issue = \"none\")]\n// SAFETY: We implement `is_in_bounds()` and `is_overlapping()` correctly.\nunsafe impl GetDisjointMutIndex for Range<usize> {\n    #[inline]\n    fn is_in_bounds(&self, len: usize) -> bool {\n        (self.start <= self.end) & (self.end <= len)\n    }\n\n    #[inline]\n    fn is_overlapping(&self, other: &Self) -> bool {\n        (self.start < other.end) & (other.start < self.end)\n    }\n}\n\n#[unstable(feature = \"get_disjoint_mut_helpers\", issue = \"none\")]\n// SAFETY: We implement `is_in_bounds()` and `is_overlapping()` correctly.\nunsafe impl GetDisjointMutIndex for RangeInclusive<usize> {\n    #[inline]\n    fn is_in_bounds(&self, len: usize) -> bool {\n        (self.start <= self.end) & (self.end < len)\n    }\n\n    #[inline]\n    fn is_overlapping(&self, other: &Self) -> bool {\n        (self.start <= other.end) & (other.start <= self.end)\n    }\n}\n\n#[unstable(feature = \"get_disjoint_mut_helpers\", issue = \"none\")]\n// SAFETY: We implement `is_in_bounds()` and `is_overlapping()` correctly.\nunsafe impl GetDisjointMutIndex for range::Range<usize> {\n    #[inline]\n    fn is_in_bounds(&self, len: usize) -> bool {\n        Range::from(*self).is_in_bounds(len)\n    }\n\n    #[inline]\n    fn is_overlapping(&self, other: &Self) -> bool {\n        Range::from(*self).is_overlapping(&Range::from(*other))\n    }\n}\n\n#[unstable(feature = \"get_disjoint_mut_helpers\", issue = \"none\")]\n// SAFETY: We implement `is_in_bounds()` and `is_overlapping()` correctly.\nunsafe impl GetDisjointMutIndex for range::RangeInclusive<usize> {\n    #[inline]\n    fn is_in_bounds(&self, len: usize) -> bool {\n        RangeInclusive::from(*self).is_in_bounds(len)\n    }\n\n    #[inline]\n    fn is_overlapping(&self, other: &Self) -> bool {\n        RangeInclusive::from(*self).is_overlapping(&RangeInclusive::from(*other))\n    }\n}\n";

},{}],"k2q2c":[function(require,module,exports,__globalThis) {
module.exports = "//! Free functions to create `&[T]` and `&mut [T]`.\n\nuse crate::ops::Range;\nuse crate::{array, ptr, ub_checks};\n\n/// Forms a slice from a pointer and a length.\n///\n/// The `len` argument is the number of **elements**, not the number of bytes.\n///\n/// # Safety\n///\n/// Behavior is undefined if any of the following conditions are violated:\n///\n/// * `data` must be non-null, [valid] for reads for `len * size_of::<T>()` many bytes,\n///   and it must be properly aligned. This means in particular:\n///\n///     * The entire memory range of this slice must be contained within a single allocation!\n///       Slices can never span across multiple allocations. See [below](#incorrect-usage)\n///       for an example incorrectly not taking this into account.\n///     * `data` must be non-null and aligned even for zero-length slices or slices of ZSTs. One\n///       reason for this is that enum layout optimizations may rely on references\n///       (including slices of any length) being aligned and non-null to distinguish\n///       them from other data. You can obtain a pointer that is usable as `data`\n///       for zero-length slices using [`NonNull::dangling()`].\n///\n/// * `data` must point to `len` consecutive properly initialized values of type `T`.\n///\n/// * The memory referenced by the returned slice must not be mutated for the duration\n///   of lifetime `'a`, except inside an `UnsafeCell`.\n///\n/// * The total size `len * size_of::<T>()` of the slice must be no larger than `isize::MAX`,\n///   and adding that size to `data` must not \"wrap around\" the address space.\n///   See the safety documentation of [`pointer::offset`].\n///\n/// # Caveat\n///\n/// The lifetime for the returned slice is inferred from its usage. To\n/// prevent accidental misuse, it's suggested to tie the lifetime to whichever\n/// source lifetime is safe in the context, such as by providing a helper\n/// function taking the lifetime of a host value for the slice, or by explicit\n/// annotation.\n///\n/// # Examples\n///\n/// ```\n/// use std::slice;\n///\n/// // manifest a slice for a single element\n/// let x = 42;\n/// let ptr = &x as *const _;\n/// let slice = unsafe { slice::from_raw_parts(ptr, 1) };\n/// assert_eq!(slice[0], 42);\n/// ```\n///\n/// ### Incorrect usage\n///\n/// The following `join_slices` function is **unsound** ⚠️\n///\n/// ```rust,no_run\n/// use std::slice;\n///\n/// fn join_slices<'a, T>(fst: &'a [T], snd: &'a [T]) -> &'a [T] {\n///     let fst_end = fst.as_ptr().wrapping_add(fst.len());\n///     let snd_start = snd.as_ptr();\n///     assert_eq!(fst_end, snd_start, \"Slices must be contiguous!\");\n///     unsafe {\n///         // The assertion above ensures `fst` and `snd` are contiguous, but they might\n///         // still be contained within _different allocations_, in which case\n///         // creating this slice is undefined behavior.\n///         slice::from_raw_parts(fst.as_ptr(), fst.len() + snd.len())\n///     }\n/// }\n///\n/// fn main() {\n///     // `a` and `b` are different allocations...\n///     let a = 42;\n///     let b = 27;\n///     // ... which may nevertheless be laid out contiguously in memory: | a | b |\n///     let _ = join_slices(slice::from_ref(&a), slice::from_ref(&b)); // UB\n/// }\n/// ```\n///\n/// ### FFI: Handling null pointers\n///\n/// In languages such as C++, pointers to empty collections are not guaranteed to be non-null.\n/// When accepting such pointers, they have to be checked for null-ness to avoid undefined\n/// behavior.\n///\n/// ```\n/// use std::slice;\n///\n/// /// Sum the elements of an FFI slice.\n/// ///\n/// /// # Safety\n/// ///\n/// /// If ptr is not NULL, it must be correctly aligned and\n/// /// point to `len` initialized items of type `f32`.\n/// unsafe extern \"C\" fn sum_slice(ptr: *const f32, len: usize) -> f32 {\n///     let data = if ptr.is_null() {\n///         // `len` is assumed to be 0.\n///         &[]\n///     } else {\n///         // SAFETY: see function docstring.\n///         unsafe { slice::from_raw_parts(ptr, len) }\n///     };\n///     data.into_iter().sum()\n/// }\n///\n/// // This could be the result of C++'s std::vector::data():\n/// let ptr = std::ptr::null();\n/// // And this could be std::vector::size():\n/// let len = 0;\n/// assert_eq!(unsafe { sum_slice(ptr, len) }, 0.0);\n/// ```\n///\n/// [valid]: ptr#safety\n/// [`NonNull::dangling()`]: ptr::NonNull::dangling\n#[inline]\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\n#[rustc_const_stable(feature = \"const_slice_from_raw_parts\", since = \"1.64.0\")]\n#[must_use]\n#[rustc_diagnostic_item = \"slice_from_raw_parts\"]\n#[track_caller]\npub const unsafe fn from_raw_parts<'a, T>(data: *const T, len: usize) -> &'a [T] {\n    // SAFETY: the caller must uphold the safety contract for `from_raw_parts`.\n    unsafe {\n        ub_checks::assert_unsafe_precondition!(\n            check_language_ub,\n            \"slice::from_raw_parts requires the pointer to be aligned and non-null, and the total size of the slice not to exceed `isize::MAX`\",\n            (\n                data: *mut () = data as *mut (),\n                size: usize = size_of::<T>(),\n                align: usize = align_of::<T>(),\n                len: usize = len,\n            ) =>\n            ub_checks::maybe_is_aligned_and_not_null(data, align, false)\n                && ub_checks::is_valid_allocation_size(size, len)\n        );\n        &*ptr::slice_from_raw_parts(data, len)\n    }\n}\n\n/// Performs the same functionality as [`from_raw_parts`], except that a\n/// mutable slice is returned.\n///\n/// # Safety\n///\n/// Behavior is undefined if any of the following conditions are violated:\n///\n/// * `data` must be non-null, [valid] for both reads and writes for `len * size_of::<T>()` many bytes,\n///   and it must be properly aligned. This means in particular:\n///\n///     * The entire memory range of this slice must be contained within a single allocation!\n///       Slices can never span across multiple allocations.\n///     * `data` must be non-null and aligned even for zero-length slices or slices of ZSTs. One\n///       reason for this is that enum layout optimizations may rely on references\n///       (including slices of any length) being aligned and non-null to distinguish\n///       them from other data. You can obtain a pointer that is usable as `data`\n///       for zero-length slices using [`NonNull::dangling()`].\n///\n/// * `data` must point to `len` consecutive properly initialized values of type `T`.\n///\n/// * The memory referenced by the returned slice must not be accessed through any other pointer\n///   (not derived from the return value) for the duration of lifetime `'a`.\n///   Both read and write accesses are forbidden.\n///\n/// * The total size `len * size_of::<T>()` of the slice must be no larger than `isize::MAX`,\n///   and adding that size to `data` must not \"wrap around\" the address space.\n///   See the safety documentation of [`pointer::offset`].\n///\n/// [valid]: ptr#safety\n/// [`NonNull::dangling()`]: ptr::NonNull::dangling\n#[inline]\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\n#[rustc_const_stable(feature = \"const_slice_from_raw_parts_mut\", since = \"1.83.0\")]\n#[must_use]\n#[rustc_diagnostic_item = \"slice_from_raw_parts_mut\"]\n#[track_caller]\npub const unsafe fn from_raw_parts_mut<'a, T>(data: *mut T, len: usize) -> &'a mut [T] {\n    // SAFETY: the caller must uphold the safety contract for `from_raw_parts_mut`.\n    unsafe {\n        ub_checks::assert_unsafe_precondition!(\n            check_language_ub,\n            \"slice::from_raw_parts_mut requires the pointer to be aligned and non-null, and the total size of the slice not to exceed `isize::MAX`\",\n            (\n                data: *mut () = data as *mut (),\n                size: usize = size_of::<T>(),\n                align: usize = align_of::<T>(),\n                len: usize = len,\n            ) =>\n            ub_checks::maybe_is_aligned_and_not_null(data, align, false)\n                && ub_checks::is_valid_allocation_size(size, len)\n        );\n        &mut *ptr::slice_from_raw_parts_mut(data, len)\n    }\n}\n\n/// Converts a reference to T into a slice of length 1 (without copying).\n#[stable(feature = \"from_ref\", since = \"1.28.0\")]\n#[rustc_const_stable(feature = \"const_slice_from_ref_shared\", since = \"1.63.0\")]\n#[rustc_diagnostic_item = \"slice_from_ref\"]\n#[must_use]\npub const fn from_ref<T>(s: &T) -> &[T] {\n    array::from_ref(s)\n}\n\n/// Converts a reference to T into a slice of length 1 (without copying).\n#[stable(feature = \"from_ref\", since = \"1.28.0\")]\n#[rustc_const_stable(feature = \"const_slice_from_ref\", since = \"1.83.0\")]\n#[must_use]\npub const fn from_mut<T>(s: &mut T) -> &mut [T] {\n    array::from_mut(s)\n}\n\n/// Forms a slice from a pointer range.\n///\n/// This function is useful for interacting with foreign interfaces which\n/// use two pointers to refer to a range of elements in memory, as is\n/// common in C++.\n///\n/// # Safety\n///\n/// Behavior is undefined if any of the following conditions are violated:\n///\n/// * The `start` pointer of the range must be a non-null, [valid] and properly aligned pointer\n///   to the first element of a slice.\n///\n/// * The `end` pointer must be a [valid] and properly aligned pointer to *one past*\n///   the last element, such that the offset from the end to the start pointer is\n///   the length of the slice.\n///\n/// * The entire memory range of this slice must be contained within a single allocation!\n///   Slices can never span across multiple allocations.\n///\n/// * The range must contain `N` consecutive properly initialized values of type `T`.\n///\n/// * The memory referenced by the returned slice must not be mutated for the duration\n///   of lifetime `'a`, except inside an `UnsafeCell`.\n///\n/// * The total length of the range must be no larger than `isize::MAX`,\n///   and adding that size to `start` must not \"wrap around\" the address space.\n///   See the safety documentation of [`pointer::offset`].\n///\n/// Note that a range created from [`slice::as_ptr_range`] fulfills these requirements.\n///\n/// # Panics\n///\n/// This function panics if `T` is a Zero-Sized Type (“ZST”).\n///\n/// # Caveat\n///\n/// The lifetime for the returned slice is inferred from its usage. To\n/// prevent accidental misuse, it's suggested to tie the lifetime to whichever\n/// source lifetime is safe in the context, such as by providing a helper\n/// function taking the lifetime of a host value for the slice, or by explicit\n/// annotation.\n///\n/// # Examples\n///\n/// ```\n/// #![feature(slice_from_ptr_range)]\n///\n/// use core::slice;\n///\n/// let x = [1, 2, 3];\n/// let range = x.as_ptr_range();\n///\n/// unsafe {\n///     assert_eq!(slice::from_ptr_range(range), &x);\n/// }\n/// ```\n///\n/// [valid]: ptr#safety\n#[unstable(feature = \"slice_from_ptr_range\", issue = \"89792\")]\n#[rustc_const_unstable(feature = \"const_slice_from_ptr_range\", issue = \"89792\")]\n#[track_caller]\npub const unsafe fn from_ptr_range<'a, T>(range: Range<*const T>) -> &'a [T] {\n    // SAFETY: the caller must uphold the safety contract for `from_ptr_range`.\n    unsafe { from_raw_parts(range.start, range.end.offset_from_unsigned(range.start)) }\n}\n\n/// Forms a mutable slice from a pointer range.\n///\n/// This is the same functionality as [`from_ptr_range`], except that a\n/// mutable slice is returned.\n///\n/// This function is useful for interacting with foreign interfaces which\n/// use two pointers to refer to a range of elements in memory, as is\n/// common in C++.\n///\n/// # Safety\n///\n/// Behavior is undefined if any of the following conditions are violated:\n///\n/// * The `start` pointer of the range must be a non-null, [valid] and properly aligned pointer\n///   to the first element of a slice.\n///\n/// * The `end` pointer must be a [valid] and properly aligned pointer to *one past*\n///   the last element, such that the offset from the end to the start pointer is\n///   the length of the slice.\n///\n/// * The entire memory range of this slice must be contained within a single allocation!\n///   Slices can never span across multiple allocations.\n///\n/// * The range must contain `N` consecutive properly initialized values of type `T`.\n///\n/// * The memory referenced by the returned slice must not be accessed through any other pointer\n///   (not derived from the return value) for the duration of lifetime `'a`.\n///   Both read and write accesses are forbidden.\n///\n/// * The total length of the range must be no larger than `isize::MAX`,\n///   and adding that size to `start` must not \"wrap around\" the address space.\n///   See the safety documentation of [`pointer::offset`].\n///\n/// Note that a range created from [`slice::as_mut_ptr_range`] fulfills these requirements.\n///\n/// # Panics\n///\n/// This function panics if `T` is a Zero-Sized Type (“ZST”).\n///\n/// # Caveat\n///\n/// The lifetime for the returned slice is inferred from its usage. To\n/// prevent accidental misuse, it's suggested to tie the lifetime to whichever\n/// source lifetime is safe in the context, such as by providing a helper\n/// function taking the lifetime of a host value for the slice, or by explicit\n/// annotation.\n///\n/// # Examples\n///\n/// ```\n/// #![feature(slice_from_ptr_range)]\n///\n/// use core::slice;\n///\n/// let mut x = [1, 2, 3];\n/// let range = x.as_mut_ptr_range();\n///\n/// unsafe {\n///     assert_eq!(slice::from_mut_ptr_range(range), &mut [1, 2, 3]);\n/// }\n/// ```\n///\n/// [valid]: ptr#safety\n#[unstable(feature = \"slice_from_ptr_range\", issue = \"89792\")]\n#[rustc_const_unstable(feature = \"const_slice_from_mut_ptr_range\", issue = \"89792\")]\npub const unsafe fn from_mut_ptr_range<'a, T>(range: Range<*mut T>) -> &'a mut [T] {\n    // SAFETY: the caller must uphold the safety contract for `from_mut_ptr_range`.\n    unsafe { from_raw_parts_mut(range.start, range.end.offset_from_unsigned(range.start)) }\n}\n";

},{}],"7EVRd":[function(require,module,exports,__globalThis) {
module.exports = "//! Ways to create a `str` from bytes slice.\n\nuse super::Utf8Error;\nuse super::validations::run_utf8_validation;\nuse crate::{mem, ptr};\n\n/// Converts a slice of bytes to a string slice.\n///\n/// This is an alias to [`str::from_utf8`].\n///\n/// A string slice ([`&str`]) is made of bytes ([`u8`]), and a byte slice\n/// ([`&[u8]`][byteslice]) is made of bytes, so this function converts between\n/// the two. Not all byte slices are valid string slices, however: [`&str`] requires\n/// that it is valid UTF-8. `from_utf8()` checks to ensure that the bytes are valid\n/// UTF-8, and then does the conversion.\n///\n/// [`&str`]: str\n/// [byteslice]: slice\n///\n/// If you are sure that the byte slice is valid UTF-8, and you don't want to\n/// incur the overhead of the validity check, there is an unsafe version of\n/// this function, [`from_utf8_unchecked`], which has the same\n/// behavior but skips the check.\n///\n/// If you need a `String` instead of a `&str`, consider\n/// [`String::from_utf8`][string].\n///\n/// [string]: ../../std/string/struct.String.html#method.from_utf8\n///\n/// Because you can stack-allocate a `[u8; N]`, and you can take a\n/// [`&[u8]`][byteslice] of it, this function is one way to have a\n/// stack-allocated string. There is an example of this in the\n/// examples section below.\n///\n/// [byteslice]: slice\n///\n/// # Errors\n///\n/// Returns `Err` if the slice is not UTF-8 with a description as to why the\n/// provided slice is not UTF-8.\n///\n/// # Examples\n///\n/// Basic usage:\n///\n/// ```\n/// use std::str;\n///\n/// // some bytes, in a vector\n/// let sparkle_heart = vec![240, 159, 146, 150];\n///\n/// // We can use the ? (try) operator to check if the bytes are valid\n/// let sparkle_heart = str::from_utf8(&sparkle_heart)?;\n///\n/// assert_eq!(\"💖\", sparkle_heart);\n/// # Ok::<_, str::Utf8Error>(())\n/// ```\n///\n/// Incorrect bytes:\n///\n/// ```\n/// use std::str;\n///\n/// // some invalid bytes, in a vector\n/// let sparkle_heart = vec![0, 159, 146, 150];\n///\n/// assert!(str::from_utf8(&sparkle_heart).is_err());\n/// ```\n///\n/// See the docs for [`Utf8Error`] for more details on the kinds of\n/// errors that can be returned.\n///\n/// A \"stack allocated string\":\n///\n/// ```\n/// use std::str;\n///\n/// // some bytes, in a stack-allocated array\n/// let sparkle_heart = [240, 159, 146, 150];\n///\n/// // We know these bytes are valid, so just use `unwrap()`.\n/// let sparkle_heart: &str = str::from_utf8(&sparkle_heart).unwrap();\n///\n/// assert_eq!(\"💖\", sparkle_heart);\n/// ```\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\n#[rustc_const_stable(feature = \"const_str_from_utf8_shared\", since = \"1.63.0\")]\n#[rustc_diagnostic_item = \"str_from_utf8\"]\npub const fn from_utf8(v: &[u8]) -> Result<&str, Utf8Error> {\n    // FIXME(const-hack): This should use `?` again, once it's `const`\n    match run_utf8_validation(v) {\n        Ok(_) => {\n            // SAFETY: validation succeeded.\n            Ok(unsafe { from_utf8_unchecked(v) })\n        }\n        Err(err) => Err(err),\n    }\n}\n\n/// Converts a mutable slice of bytes to a mutable string slice.\n///\n/// This is an alias to [`str::from_utf8_mut`].\n///\n/// # Examples\n///\n/// Basic usage:\n///\n/// ```\n/// use std::str;\n///\n/// // \"Hello, Rust!\" as a mutable vector\n/// let mut hellorust = vec![72, 101, 108, 108, 111, 44, 32, 82, 117, 115, 116, 33];\n///\n/// // As we know these bytes are valid, we can use `unwrap()`\n/// let outstr = str::from_utf8_mut(&mut hellorust).unwrap();\n///\n/// assert_eq!(\"Hello, Rust!\", outstr);\n/// ```\n///\n/// Incorrect bytes:\n///\n/// ```\n/// use std::str;\n///\n/// // Some invalid bytes in a mutable vector\n/// let mut invalid = vec![128, 223];\n///\n/// assert!(str::from_utf8_mut(&mut invalid).is_err());\n/// ```\n/// See the docs for [`Utf8Error`] for more details on the kinds of\n/// errors that can be returned.\n#[stable(feature = \"str_mut_extras\", since = \"1.20.0\")]\n#[rustc_const_stable(feature = \"const_str_from_utf8\", since = \"1.87.0\")]\n#[rustc_diagnostic_item = \"str_from_utf8_mut\"]\npub const fn from_utf8_mut(v: &mut [u8]) -> Result<&mut str, Utf8Error> {\n    // FIXME(const-hack): This should use `?` again, once it's `const`\n    match run_utf8_validation(v) {\n        Ok(_) => {\n            // SAFETY: validation succeeded.\n            Ok(unsafe { from_utf8_unchecked_mut(v) })\n        }\n        Err(err) => Err(err),\n    }\n}\n\n/// Converts a slice of bytes to a string slice without checking\n/// that the string contains valid UTF-8.\n///\n/// This is an alias to [`str::from_utf8_unchecked`].\n///\n/// See the safe version, [`from_utf8`], for more information.\n///\n/// # Safety\n///\n/// The bytes passed in must be valid UTF-8.\n///\n/// # Examples\n///\n/// Basic usage:\n///\n/// ```\n/// use std::str;\n///\n/// // some bytes, in a vector\n/// let sparkle_heart = vec![240, 159, 146, 150];\n///\n/// let sparkle_heart = unsafe {\n///     str::from_utf8_unchecked(&sparkle_heart)\n/// };\n///\n/// assert_eq!(\"💖\", sparkle_heart);\n/// ```\n#[inline]\n#[must_use]\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\n#[rustc_const_stable(feature = \"const_str_from_utf8_unchecked\", since = \"1.55.0\")]\n#[rustc_diagnostic_item = \"str_from_utf8_unchecked\"]\npub const unsafe fn from_utf8_unchecked(v: &[u8]) -> &str {\n    // SAFETY: the caller must guarantee that the bytes `v` are valid UTF-8.\n    // Also relies on `&str` and `&[u8]` having the same layout.\n    unsafe { mem::transmute(v) }\n}\n\n/// Converts a slice of bytes to a string slice without checking\n/// that the string contains valid UTF-8; mutable version.\n///\n/// This is an alias to [`str::from_utf8_unchecked_mut`].\n///\n/// See the immutable version, [`from_utf8_unchecked()`] for documentation and safety requirements.\n///\n/// # Examples\n///\n/// Basic usage:\n///\n/// ```\n/// use std::str;\n///\n/// let mut heart = vec![240, 159, 146, 150];\n/// let heart = unsafe { str::from_utf8_unchecked_mut(&mut heart) };\n///\n/// assert_eq!(\"💖\", heart);\n/// ```\n#[inline]\n#[must_use]\n#[stable(feature = \"str_mut_extras\", since = \"1.20.0\")]\n#[rustc_const_stable(feature = \"const_str_from_utf8_unchecked_mut\", since = \"1.83.0\")]\n#[rustc_diagnostic_item = \"str_from_utf8_unchecked_mut\"]\npub const unsafe fn from_utf8_unchecked_mut(v: &mut [u8]) -> &mut str {\n    // SAFETY: the caller must guarantee that the bytes `v`\n    // are valid UTF-8, thus the cast to `*mut str` is safe.\n    // Also, the pointer dereference is safe because that pointer\n    // comes from a reference which is guaranteed to be valid for writes.\n    unsafe { &mut *(v as *mut [u8] as *mut str) }\n}\n\n/// Creates a `&str` from a pointer and a length.\n///\n/// The pointed-to bytes must be valid UTF-8.\n/// If this might not be the case, use `str::from_utf8(slice::from_raw_parts(ptr, len))`,\n/// which will return an `Err` if the data isn't valid UTF-8.\n///\n/// This function is the `str` equivalent of [`slice::from_raw_parts`](crate::slice::from_raw_parts).\n/// See that function's documentation for safety concerns and examples.\n///\n/// The mutable version of this function is [`from_raw_parts_mut`].\n#[inline]\n#[must_use]\n#[unstable(feature = \"str_from_raw_parts\", issue = \"119206\")]\npub const unsafe fn from_raw_parts<'a>(ptr: *const u8, len: usize) -> &'a str {\n    // SAFETY: the caller must uphold the safety contract for `from_raw_parts`.\n    unsafe { &*ptr::from_raw_parts(ptr, len) }\n}\n\n/// Creates a `&mut str` from a pointer and a length.\n///\n/// The pointed-to bytes must be valid UTF-8.\n/// If this might not be the case, use `str::from_utf8_mut(slice::from_raw_parts_mut(ptr, len))`,\n/// which will return an `Err` if the data isn't valid UTF-8.\n///\n/// This function is the `str` equivalent of [`slice::from_raw_parts_mut`](crate::slice::from_raw_parts_mut).\n/// See that function's documentation for safety concerns and examples.\n///\n/// The immutable version of this function is [`from_raw_parts`].\n#[inline]\n#[must_use]\n#[unstable(feature = \"str_from_raw_parts\", issue = \"119206\")]\npub const unsafe fn from_raw_parts_mut<'a>(ptr: *mut u8, len: usize) -> &'a mut str {\n    // SAFETY: the caller must uphold the safety contract for `from_raw_parts_mut`.\n    unsafe { &mut *ptr::from_raw_parts_mut(ptr, len) }\n}\n";

},{}],"c0j3E":[function(require,module,exports,__globalThis) {
module.exports = "//! Iterators for `str` methods.\n\nuse super::pattern::{DoubleEndedSearcher, Pattern, ReverseSearcher, Searcher};\nuse super::validations::{next_code_point, next_code_point_reverse};\nuse super::{\n    BytesIsNotEmpty, CharEscapeDebugContinue, CharEscapeDefault, CharEscapeUnicode,\n    IsAsciiWhitespace, IsNotEmpty, IsWhitespace, LinesMap, UnsafeBytesToStr, from_utf8_unchecked,\n};\nuse crate::fmt::{self, Write};\nuse crate::iter::{\n    Chain, Copied, Filter, FlatMap, Flatten, FusedIterator, Map, TrustedLen, TrustedRandomAccess,\n    TrustedRandomAccessNoCoerce,\n};\nuse crate::num::NonZero;\nuse crate::ops::Try;\nuse crate::slice::{self, Split as SliceSplit};\nuse crate::{char as char_mod, option};\n\n/// An iterator over the [`char`]s of a string slice.\n///\n///\n/// This struct is created by the [`chars`] method on [`str`].\n/// See its documentation for more.\n///\n/// [`char`]: prim@char\n/// [`chars`]: str::chars\n#[derive(Clone)]\n#[must_use = \"iterators are lazy and do nothing unless consumed\"]\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\npub struct Chars<'a> {\n    pub(super) iter: slice::Iter<'a, u8>,\n}\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl<'a> Iterator for Chars<'a> {\n    type Item = char;\n\n    #[inline]\n    fn next(&mut self) -> Option<char> {\n        // SAFETY: `str` invariant says `self.iter` is a valid UTF-8 string and\n        // the resulting `ch` is a valid Unicode Scalar Value.\n        unsafe { next_code_point(&mut self.iter).map(|ch| char::from_u32_unchecked(ch)) }\n    }\n\n    #[inline]\n    fn count(self) -> usize {\n        super::count::count_chars(self.as_str())\n    }\n\n    #[inline]\n    fn advance_by(&mut self, mut remainder: usize) -> Result<(), NonZero<usize>> {\n        const CHUNK_SIZE: usize = 32;\n\n        if remainder >= CHUNK_SIZE {\n            let mut chunks = self.iter.as_slice().as_chunks::<CHUNK_SIZE>().0.iter();\n            let mut bytes_skipped: usize = 0;\n\n            while remainder > CHUNK_SIZE\n                && let Some(chunk) = chunks.next()\n            {\n                bytes_skipped += CHUNK_SIZE;\n\n                let mut start_bytes = [false; CHUNK_SIZE];\n\n                for i in 0..CHUNK_SIZE {\n                    start_bytes[i] = !super::validations::utf8_is_cont_byte(chunk[i]);\n                }\n\n                remainder -= start_bytes.into_iter().map(|i| i as u8).sum::<u8>() as usize;\n            }\n\n            // SAFETY: The amount of bytes exists since we just iterated over them,\n            // so advance_by will succeed.\n            unsafe { self.iter.advance_by(bytes_skipped).unwrap_unchecked() };\n\n            // skip trailing continuation bytes\n            while self.iter.len() > 0 {\n                let b = self.iter.as_slice()[0];\n                if !super::validations::utf8_is_cont_byte(b) {\n                    break;\n                }\n                // SAFETY: We just peeked at the byte, therefore it exists\n                unsafe { self.iter.advance_by(1).unwrap_unchecked() };\n            }\n        }\n\n        while (remainder > 0) && (self.iter.len() > 0) {\n            remainder -= 1;\n            let b = self.iter.as_slice()[0];\n            let slurp = super::validations::utf8_char_width(b);\n            // SAFETY: utf8 validity requires that the string must contain\n            // the continuation bytes (if any)\n            unsafe { self.iter.advance_by(slurp).unwrap_unchecked() };\n        }\n\n        NonZero::new(remainder).map_or(Ok(()), Err)\n    }\n\n    #[inline]\n    fn size_hint(&self) -> (usize, Option<usize>) {\n        let len = self.iter.len();\n        // `(len + 3)` can't overflow, because we know that the `slice::Iter`\n        // belongs to a slice in memory which has a maximum length of\n        // `isize::MAX` (that's well below `usize::MAX`).\n        (len.div_ceil(4), Some(len))\n    }\n\n    #[inline]\n    fn last(mut self) -> Option<char> {\n        // No need to go through the entire string.\n        self.next_back()\n    }\n}\n\n#[stable(feature = \"chars_debug_impl\", since = \"1.38.0\")]\nimpl fmt::Debug for Chars<'_> {\n    fn fmt(&self, f: &mut fmt::Formatter<'_>) -> fmt::Result {\n        write!(f, \"Chars(\")?;\n        f.debug_list().entries(self.clone()).finish()?;\n        write!(f, \")\")?;\n        Ok(())\n    }\n}\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl<'a> DoubleEndedIterator for Chars<'a> {\n    #[inline]\n    fn next_back(&mut self) -> Option<char> {\n        // SAFETY: `str` invariant says `self.iter` is a valid UTF-8 string and\n        // the resulting `ch` is a valid Unicode Scalar Value.\n        unsafe { next_code_point_reverse(&mut self.iter).map(|ch| char::from_u32_unchecked(ch)) }\n    }\n}\n\n#[stable(feature = \"fused\", since = \"1.26.0\")]\nimpl FusedIterator for Chars<'_> {}\n\nimpl<'a> Chars<'a> {\n    /// Views the underlying data as a subslice of the original data.\n    ///\n    /// This has the same lifetime as the original slice, and so the\n    /// iterator can continue to be used while this exists.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut chars = \"abc\".chars();\n    ///\n    /// assert_eq!(chars.as_str(), \"abc\");\n    /// chars.next();\n    /// assert_eq!(chars.as_str(), \"bc\");\n    /// chars.next();\n    /// chars.next();\n    /// assert_eq!(chars.as_str(), \"\");\n    /// ```\n    #[stable(feature = \"iter_to_slice\", since = \"1.4.0\")]\n    #[must_use]\n    #[inline]\n    pub fn as_str(&self) -> &'a str {\n        // SAFETY: `Chars` is only made from a str, which guarantees the iter is valid UTF-8.\n        unsafe { from_utf8_unchecked(self.iter.as_slice()) }\n    }\n}\n\n/// An iterator over the [`char`]s of a string slice, and their positions.\n///\n/// This struct is created by the [`char_indices`] method on [`str`].\n/// See its documentation for more.\n///\n/// [`char`]: prim@char\n/// [`char_indices`]: str::char_indices\n#[derive(Clone, Debug)]\n#[must_use = \"iterators are lazy and do nothing unless consumed\"]\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\npub struct CharIndices<'a> {\n    pub(super) front_offset: usize,\n    pub(super) iter: Chars<'a>,\n}\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl<'a> Iterator for CharIndices<'a> {\n    type Item = (usize, char);\n\n    #[inline]\n    fn next(&mut self) -> Option<(usize, char)> {\n        let pre_len = self.iter.iter.len();\n        match self.iter.next() {\n            None => None,\n            Some(ch) => {\n                let index = self.front_offset;\n                let len = self.iter.iter.len();\n                self.front_offset += pre_len - len;\n                Some((index, ch))\n            }\n        }\n    }\n\n    #[inline]\n    fn count(self) -> usize {\n        self.iter.count()\n    }\n\n    #[inline]\n    fn size_hint(&self) -> (usize, Option<usize>) {\n        self.iter.size_hint()\n    }\n\n    #[inline]\n    fn last(mut self) -> Option<(usize, char)> {\n        // No need to go through the entire string.\n        self.next_back()\n    }\n}\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl<'a> DoubleEndedIterator for CharIndices<'a> {\n    #[inline]\n    fn next_back(&mut self) -> Option<(usize, char)> {\n        self.iter.next_back().map(|ch| {\n            let index = self.front_offset + self.iter.iter.len();\n            (index, ch)\n        })\n    }\n}\n\n#[stable(feature = \"fused\", since = \"1.26.0\")]\nimpl FusedIterator for CharIndices<'_> {}\n\nimpl<'a> CharIndices<'a> {\n    /// Views the underlying data as a subslice of the original data.\n    ///\n    /// This has the same lifetime as the original slice, and so the\n    /// iterator can continue to be used while this exists.\n    #[stable(feature = \"iter_to_slice\", since = \"1.4.0\")]\n    #[must_use]\n    #[inline]\n    pub fn as_str(&self) -> &'a str {\n        self.iter.as_str()\n    }\n\n    /// Returns the byte position of the next character, or the length\n    /// of the underlying string if there are no more characters.\n    ///\n    /// This means that, when the iterator has not been fully consumed,\n    /// the returned value will match the index that will be returned\n    /// by the next call to [`next()`](Self::next).\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// let mut chars = \"a楽\".char_indices();\n    ///\n    /// // `next()` has not been called yet, so `offset()` returns the byte\n    /// // index of the first character of the string, which is always 0.\n    /// assert_eq!(chars.offset(), 0);\n    /// // As expected, the first call to `next()` also returns 0 as index.\n    /// assert_eq!(chars.next(), Some((0, 'a')));\n    ///\n    /// // `next()` has been called once, so `offset()` returns the byte index\n    /// // of the second character ...\n    /// assert_eq!(chars.offset(), 1);\n    /// // ... which matches the index returned by the next call to `next()`.\n    /// assert_eq!(chars.next(), Some((1, '楽')));\n    ///\n    /// // Once the iterator has been consumed, `offset()` returns the length\n    /// // in bytes of the string.\n    /// assert_eq!(chars.offset(), 4);\n    /// assert_eq!(chars.next(), None);\n    /// ```\n    #[inline]\n    #[must_use]\n    #[stable(feature = \"char_indices_offset\", since = \"1.82.0\")]\n    pub fn offset(&self) -> usize {\n        self.front_offset\n    }\n}\n\n/// An iterator over the bytes of a string slice.\n///\n/// This struct is created by the [`bytes`] method on [`str`].\n/// See its documentation for more.\n///\n/// [`bytes`]: str::bytes\n#[must_use = \"iterators are lazy and do nothing unless consumed\"]\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\n#[derive(Clone, Debug)]\npub struct Bytes<'a>(pub(super) Copied<slice::Iter<'a, u8>>);\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl Iterator for Bytes<'_> {\n    type Item = u8;\n\n    #[inline]\n    fn next(&mut self) -> Option<u8> {\n        self.0.next()\n    }\n\n    #[inline]\n    fn size_hint(&self) -> (usize, Option<usize>) {\n        self.0.size_hint()\n    }\n\n    #[inline]\n    fn count(self) -> usize {\n        self.0.count()\n    }\n\n    #[inline]\n    fn last(self) -> Option<Self::Item> {\n        self.0.last()\n    }\n\n    #[inline]\n    fn nth(&mut self, n: usize) -> Option<Self::Item> {\n        self.0.nth(n)\n    }\n\n    #[inline]\n    fn all<F>(&mut self, f: F) -> bool\n    where\n        F: FnMut(Self::Item) -> bool,\n    {\n        self.0.all(f)\n    }\n\n    #[inline]\n    fn any<F>(&mut self, f: F) -> bool\n    where\n        F: FnMut(Self::Item) -> bool,\n    {\n        self.0.any(f)\n    }\n\n    #[inline]\n    fn find<P>(&mut self, predicate: P) -> Option<Self::Item>\n    where\n        P: FnMut(&Self::Item) -> bool,\n    {\n        self.0.find(predicate)\n    }\n\n    #[inline]\n    fn position<P>(&mut self, predicate: P) -> Option<usize>\n    where\n        P: FnMut(Self::Item) -> bool,\n    {\n        self.0.position(predicate)\n    }\n\n    #[inline]\n    fn rposition<P>(&mut self, predicate: P) -> Option<usize>\n    where\n        P: FnMut(Self::Item) -> bool,\n    {\n        self.0.rposition(predicate)\n    }\n\n    #[inline]\n    unsafe fn __iterator_get_unchecked(&mut self, idx: usize) -> u8 {\n        // SAFETY: the caller must uphold the safety contract\n        // for `Iterator::__iterator_get_unchecked`.\n        unsafe { self.0.__iterator_get_unchecked(idx) }\n    }\n}\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl DoubleEndedIterator for Bytes<'_> {\n    #[inline]\n    fn next_back(&mut self) -> Option<u8> {\n        self.0.next_back()\n    }\n\n    #[inline]\n    fn nth_back(&mut self, n: usize) -> Option<Self::Item> {\n        self.0.nth_back(n)\n    }\n\n    #[inline]\n    fn rfind<P>(&mut self, predicate: P) -> Option<Self::Item>\n    where\n        P: FnMut(&Self::Item) -> bool,\n    {\n        self.0.rfind(predicate)\n    }\n}\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl ExactSizeIterator for Bytes<'_> {\n    #[inline]\n    fn len(&self) -> usize {\n        self.0.len()\n    }\n\n    #[inline]\n    fn is_empty(&self) -> bool {\n        self.0.is_empty()\n    }\n}\n\n#[stable(feature = \"fused\", since = \"1.26.0\")]\nimpl FusedIterator for Bytes<'_> {}\n\n#[unstable(feature = \"trusted_len\", issue = \"37572\")]\nunsafe impl TrustedLen for Bytes<'_> {}\n\n#[doc(hidden)]\n#[unstable(feature = \"trusted_random_access\", issue = \"none\")]\nunsafe impl TrustedRandomAccess for Bytes<'_> {}\n\n#[doc(hidden)]\n#[unstable(feature = \"trusted_random_access\", issue = \"none\")]\nunsafe impl TrustedRandomAccessNoCoerce for Bytes<'_> {\n    const MAY_HAVE_SIDE_EFFECT: bool = false;\n}\n\n/// This macro generates a Clone impl for string pattern API\n/// wrapper types of the form X<'a, P>\nmacro_rules! derive_pattern_clone {\n    (clone $t:ident with |$s:ident| $e:expr) => {\n        impl<'a, P> Clone for $t<'a, P>\n        where\n            P: Pattern<Searcher<'a>: Clone>,\n        {\n            fn clone(&self) -> Self {\n                let $s = self;\n                $e\n            }\n        }\n    };\n}\n\n/// This macro generates two public iterator structs\n/// wrapping a private internal one that makes use of the `Pattern` API.\n///\n/// For all patterns `P: Pattern` the following items will be\n/// generated (generics omitted):\n///\n/// struct $forward_iterator($internal_iterator);\n/// struct $reverse_iterator($internal_iterator);\n///\n/// impl Iterator for $forward_iterator\n/// { /* internal ends up calling Searcher::next_match() */ }\n///\n/// impl DoubleEndedIterator for $forward_iterator\n///       where P::Searcher: DoubleEndedSearcher\n/// { /* internal ends up calling Searcher::next_match_back() */ }\n///\n/// impl Iterator for $reverse_iterator\n///       where P::Searcher: ReverseSearcher\n/// { /* internal ends up calling Searcher::next_match_back() */ }\n///\n/// impl DoubleEndedIterator for $reverse_iterator\n///       where P::Searcher: DoubleEndedSearcher\n/// { /* internal ends up calling Searcher::next_match() */ }\n///\n/// The internal one is defined outside the macro, and has almost the same\n/// semantic as a DoubleEndedIterator by delegating to `pattern::Searcher` and\n/// `pattern::ReverseSearcher` for both forward and reverse iteration.\n///\n/// \"Almost\", because a `Searcher` and a `ReverseSearcher` for a given\n/// `Pattern` might not return the same elements, so actually implementing\n/// `DoubleEndedIterator` for it would be incorrect.\n/// (See the docs in `str::pattern` for more details)\n///\n/// However, the internal struct still represents a single ended iterator from\n/// either end, and depending on pattern is also a valid double ended iterator,\n/// so the two wrapper structs implement `Iterator`\n/// and `DoubleEndedIterator` depending on the concrete pattern type, leading\n/// to the complex impls seen above.\nmacro_rules! generate_pattern_iterators {\n    {\n        // Forward iterator\n        forward:\n            $(#[$forward_iterator_attribute:meta])*\n            struct $forward_iterator:ident;\n\n        // Reverse iterator\n        reverse:\n            $(#[$reverse_iterator_attribute:meta])*\n            struct $reverse_iterator:ident;\n\n        // Stability of all generated items\n        stability:\n            $(#[$common_stability_attribute:meta])*\n\n        // Internal almost-iterator that is being delegated to\n        internal:\n            $internal_iterator:ident yielding ($iterty:ty);\n\n        // Kind of delegation - either single ended or double ended\n        delegate $($t:tt)*\n    } => {\n        $(#[$forward_iterator_attribute])*\n        $(#[$common_stability_attribute])*\n        pub struct $forward_iterator<'a, P: Pattern>(pub(super) $internal_iterator<'a, P>);\n\n        $(#[$common_stability_attribute])*\n        impl<'a, P> fmt::Debug for $forward_iterator<'a, P>\n        where\n            P: Pattern<Searcher<'a>: fmt::Debug>,\n        {\n            fn fmt(&self, f: &mut fmt::Formatter<'_>) -> fmt::Result {\n                f.debug_tuple(stringify!($forward_iterator))\n                    .field(&self.0)\n                    .finish()\n            }\n        }\n\n        $(#[$common_stability_attribute])*\n        impl<'a, P: Pattern> Iterator for $forward_iterator<'a, P> {\n            type Item = $iterty;\n\n            #[inline]\n            fn next(&mut self) -> Option<$iterty> {\n                self.0.next()\n            }\n        }\n\n        $(#[$common_stability_attribute])*\n        impl<'a, P> Clone for $forward_iterator<'a, P>\n        where\n            P: Pattern<Searcher<'a>: Clone>,\n        {\n            fn clone(&self) -> Self {\n                $forward_iterator(self.0.clone())\n            }\n        }\n\n        $(#[$reverse_iterator_attribute])*\n        $(#[$common_stability_attribute])*\n        pub struct $reverse_iterator<'a, P: Pattern>(pub(super) $internal_iterator<'a, P>);\n\n        $(#[$common_stability_attribute])*\n        impl<'a, P> fmt::Debug for $reverse_iterator<'a, P>\n        where\n            P: Pattern<Searcher<'a>: fmt::Debug>,\n        {\n            fn fmt(&self, f: &mut fmt::Formatter<'_>) -> fmt::Result {\n                f.debug_tuple(stringify!($reverse_iterator))\n                    .field(&self.0)\n                    .finish()\n            }\n        }\n\n        $(#[$common_stability_attribute])*\n        impl<'a, P> Iterator for $reverse_iterator<'a, P>\n        where\n            P: Pattern<Searcher<'a>: ReverseSearcher<'a>>,\n        {\n            type Item = $iterty;\n\n            #[inline]\n            fn next(&mut self) -> Option<$iterty> {\n                self.0.next_back()\n            }\n        }\n\n        $(#[$common_stability_attribute])*\n        impl<'a, P> Clone for $reverse_iterator<'a, P>\n        where\n            P: Pattern<Searcher<'a>: Clone>,\n        {\n            fn clone(&self) -> Self {\n                $reverse_iterator(self.0.clone())\n            }\n        }\n\n        #[stable(feature = \"fused\", since = \"1.26.0\")]\n        impl<'a, P: Pattern> FusedIterator for $forward_iterator<'a, P> {}\n\n        #[stable(feature = \"fused\", since = \"1.26.0\")]\n        impl<'a, P> FusedIterator for $reverse_iterator<'a, P>\n        where\n            P: Pattern<Searcher<'a>: ReverseSearcher<'a>>,\n        {}\n\n        generate_pattern_iterators!($($t)* with $(#[$common_stability_attribute])*,\n                                                $forward_iterator,\n                                                $reverse_iterator, $iterty);\n    };\n    {\n        double ended; with $(#[$common_stability_attribute:meta])*,\n                           $forward_iterator:ident,\n                           $reverse_iterator:ident, $iterty:ty\n    } => {\n        $(#[$common_stability_attribute])*\n        impl<'a, P> DoubleEndedIterator for $forward_iterator<'a, P>\n        where\n            P: Pattern<Searcher<'a>: DoubleEndedSearcher<'a>>,\n        {\n            #[inline]\n            fn next_back(&mut self) -> Option<$iterty> {\n                self.0.next_back()\n            }\n        }\n\n        $(#[$common_stability_attribute])*\n        impl<'a, P> DoubleEndedIterator for $reverse_iterator<'a, P>\n        where\n            P: Pattern<Searcher<'a>: DoubleEndedSearcher<'a>>,\n        {\n            #[inline]\n            fn next_back(&mut self) -> Option<$iterty> {\n                self.0.next()\n            }\n        }\n    };\n    {\n        single ended; with $(#[$common_stability_attribute:meta])*,\n                           $forward_iterator:ident,\n                           $reverse_iterator:ident, $iterty:ty\n    } => {}\n}\n\nderive_pattern_clone! {\n    clone SplitInternal\n    with |s| SplitInternal { matcher: s.matcher.clone(), ..*s }\n}\n\npub(super) struct SplitInternal<'a, P: Pattern> {\n    pub(super) start: usize,\n    pub(super) end: usize,\n    pub(super) matcher: P::Searcher<'a>,\n    pub(super) allow_trailing_empty: bool,\n    pub(super) finished: bool,\n}\n\nimpl<'a, P> fmt::Debug for SplitInternal<'a, P>\nwhere\n    P: Pattern<Searcher<'a>: fmt::Debug>,\n{\n    fn fmt(&self, f: &mut fmt::Formatter<'_>) -> fmt::Result {\n        f.debug_struct(\"SplitInternal\")\n            .field(\"start\", &self.start)\n            .field(\"end\", &self.end)\n            .field(\"matcher\", &self.matcher)\n            .field(\"allow_trailing_empty\", &self.allow_trailing_empty)\n            .field(\"finished\", &self.finished)\n            .finish()\n    }\n}\n\nimpl<'a, P: Pattern> SplitInternal<'a, P> {\n    #[inline]\n    fn get_end(&mut self) -> Option<&'a str> {\n        if !self.finished {\n            self.finished = true;\n\n            if self.allow_trailing_empty || self.end - self.start > 0 {\n                // SAFETY: `self.start` and `self.end` always lie on unicode boundaries.\n                let string = unsafe { self.matcher.haystack().get_unchecked(self.start..self.end) };\n                return Some(string);\n            }\n        }\n\n        None\n    }\n\n    #[inline]\n    fn next(&mut self) -> Option<&'a str> {\n        if self.finished {\n            return None;\n        }\n\n        let haystack = self.matcher.haystack();\n        match self.matcher.next_match() {\n            // SAFETY: `Searcher` guarantees that `a` and `b` lie on unicode boundaries.\n            Some((a, b)) => unsafe {\n                let elt = haystack.get_unchecked(self.start..a);\n                self.start = b;\n                Some(elt)\n            },\n            None => self.get_end(),\n        }\n    }\n\n    #[inline]\n    fn next_inclusive(&mut self) -> Option<&'a str> {\n        if self.finished {\n            return None;\n        }\n\n        let haystack = self.matcher.haystack();\n        match self.matcher.next_match() {\n            // SAFETY: `Searcher` guarantees that `b` lies on unicode boundary,\n            // and self.start is either the start of the original string,\n            // or `b` was assigned to it, so it also lies on unicode boundary.\n            Some((_, b)) => unsafe {\n                let elt = haystack.get_unchecked(self.start..b);\n                self.start = b;\n                Some(elt)\n            },\n            None => self.get_end(),\n        }\n    }\n\n    #[inline]\n    fn next_back(&mut self) -> Option<&'a str>\n    where\n        P::Searcher<'a>: ReverseSearcher<'a>,\n    {\n        if self.finished {\n            return None;\n        }\n\n        if !self.allow_trailing_empty {\n            self.allow_trailing_empty = true;\n            match self.next_back() {\n                Some(elt) if !elt.is_empty() => return Some(elt),\n                _ => {\n                    if self.finished {\n                        return None;\n                    }\n                }\n            }\n        }\n\n        let haystack = self.matcher.haystack();\n        match self.matcher.next_match_back() {\n            // SAFETY: `Searcher` guarantees that `a` and `b` lie on unicode boundaries.\n            Some((a, b)) => unsafe {\n                let elt = haystack.get_unchecked(b..self.end);\n                self.end = a;\n                Some(elt)\n            },\n            // SAFETY: `self.start` and `self.end` always lie on unicode boundaries.\n            None => unsafe {\n                self.finished = true;\n                Some(haystack.get_unchecked(self.start..self.end))\n            },\n        }\n    }\n\n    #[inline]\n    fn next_back_inclusive(&mut self) -> Option<&'a str>\n    where\n        P::Searcher<'a>: ReverseSearcher<'a>,\n    {\n        if self.finished {\n            return None;\n        }\n\n        if !self.allow_trailing_empty {\n            self.allow_trailing_empty = true;\n            match self.next_back_inclusive() {\n                Some(elt) if !elt.is_empty() => return Some(elt),\n                _ => {\n                    if self.finished {\n                        return None;\n                    }\n                }\n            }\n        }\n\n        let haystack = self.matcher.haystack();\n        match self.matcher.next_match_back() {\n            // SAFETY: `Searcher` guarantees that `b` lies on unicode boundary,\n            // and self.end is either the end of the original string,\n            // or `b` was assigned to it, so it also lies on unicode boundary.\n            Some((_, b)) => unsafe {\n                let elt = haystack.get_unchecked(b..self.end);\n                self.end = b;\n                Some(elt)\n            },\n            // SAFETY: self.start is either the start of the original string,\n            // or start of a substring that represents the part of the string that hasn't\n            // iterated yet. Either way, it is guaranteed to lie on unicode boundary.\n            // self.end is either the end of the original string,\n            // or `b` was assigned to it, so it also lies on unicode boundary.\n            None => unsafe {\n                self.finished = true;\n                Some(haystack.get_unchecked(self.start..self.end))\n            },\n        }\n    }\n\n    #[inline]\n    fn remainder(&self) -> Option<&'a str> {\n        // `Self::get_end` doesn't change `self.start`\n        if self.finished {\n            return None;\n        }\n\n        // SAFETY: `self.start` and `self.end` always lie on unicode boundaries.\n        Some(unsafe { self.matcher.haystack().get_unchecked(self.start..self.end) })\n    }\n}\n\ngenerate_pattern_iterators! {\n    forward:\n        /// Created with the method [`split`].\n        ///\n        /// [`split`]: str::split\n        struct Split;\n    reverse:\n        /// Created with the method [`rsplit`].\n        ///\n        /// [`rsplit`]: str::rsplit\n        struct RSplit;\n    stability:\n        #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    internal:\n        SplitInternal yielding (&'a str);\n    delegate double ended;\n}\n\nimpl<'a, P: Pattern> Split<'a, P> {\n    /// Returns remainder of the split string.\n    ///\n    /// If the iterator is empty, returns `None`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(str_split_remainder)]\n    /// let mut split = \"Mary had a little lamb\".split(' ');\n    /// assert_eq!(split.remainder(), Some(\"Mary had a little lamb\"));\n    /// split.next();\n    /// assert_eq!(split.remainder(), Some(\"had a little lamb\"));\n    /// split.by_ref().for_each(drop);\n    /// assert_eq!(split.remainder(), None);\n    /// ```\n    #[inline]\n    #[unstable(feature = \"str_split_remainder\", issue = \"77998\")]\n    pub fn remainder(&self) -> Option<&'a str> {\n        self.0.remainder()\n    }\n}\n\nimpl<'a, P: Pattern> RSplit<'a, P> {\n    /// Returns remainder of the split string.\n    ///\n    /// If the iterator is empty, returns `None`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(str_split_remainder)]\n    /// let mut split = \"Mary had a little lamb\".rsplit(' ');\n    /// assert_eq!(split.remainder(), Some(\"Mary had a little lamb\"));\n    /// split.next();\n    /// assert_eq!(split.remainder(), Some(\"Mary had a little\"));\n    /// split.by_ref().for_each(drop);\n    /// assert_eq!(split.remainder(), None);\n    /// ```\n    #[inline]\n    #[unstable(feature = \"str_split_remainder\", issue = \"77998\")]\n    pub fn remainder(&self) -> Option<&'a str> {\n        self.0.remainder()\n    }\n}\n\ngenerate_pattern_iterators! {\n    forward:\n        /// Created with the method [`split_terminator`].\n        ///\n        /// [`split_terminator`]: str::split_terminator\n        struct SplitTerminator;\n    reverse:\n        /// Created with the method [`rsplit_terminator`].\n        ///\n        /// [`rsplit_terminator`]: str::rsplit_terminator\n        struct RSplitTerminator;\n    stability:\n        #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    internal:\n        SplitInternal yielding (&'a str);\n    delegate double ended;\n}\n\nimpl<'a, P: Pattern> SplitTerminator<'a, P> {\n    /// Returns remainder of the split string.\n    ///\n    /// If the iterator is empty, returns `None`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(str_split_remainder)]\n    /// let mut split = \"A..B..\".split_terminator('.');\n    /// assert_eq!(split.remainder(), Some(\"A..B..\"));\n    /// split.next();\n    /// assert_eq!(split.remainder(), Some(\".B..\"));\n    /// split.by_ref().for_each(drop);\n    /// assert_eq!(split.remainder(), None);\n    /// ```\n    #[inline]\n    #[unstable(feature = \"str_split_remainder\", issue = \"77998\")]\n    pub fn remainder(&self) -> Option<&'a str> {\n        self.0.remainder()\n    }\n}\n\nimpl<'a, P: Pattern> RSplitTerminator<'a, P> {\n    /// Returns remainder of the split string.\n    ///\n    /// If the iterator is empty, returns `None`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(str_split_remainder)]\n    /// let mut split = \"A..B..\".rsplit_terminator('.');\n    /// assert_eq!(split.remainder(), Some(\"A..B..\"));\n    /// split.next();\n    /// assert_eq!(split.remainder(), Some(\"A..B\"));\n    /// split.by_ref().for_each(drop);\n    /// assert_eq!(split.remainder(), None);\n    /// ```\n    #[inline]\n    #[unstable(feature = \"str_split_remainder\", issue = \"77998\")]\n    pub fn remainder(&self) -> Option<&'a str> {\n        self.0.remainder()\n    }\n}\n\nderive_pattern_clone! {\n    clone SplitNInternal\n    with |s| SplitNInternal { iter: s.iter.clone(), ..*s }\n}\n\npub(super) struct SplitNInternal<'a, P: Pattern> {\n    pub(super) iter: SplitInternal<'a, P>,\n    /// The number of splits remaining\n    pub(super) count: usize,\n}\n\nimpl<'a, P> fmt::Debug for SplitNInternal<'a, P>\nwhere\n    P: Pattern<Searcher<'a>: fmt::Debug>,\n{\n    fn fmt(&self, f: &mut fmt::Formatter<'_>) -> fmt::Result {\n        f.debug_struct(\"SplitNInternal\")\n            .field(\"iter\", &self.iter)\n            .field(\"count\", &self.count)\n            .finish()\n    }\n}\n\nimpl<'a, P: Pattern> SplitNInternal<'a, P> {\n    #[inline]\n    fn next(&mut self) -> Option<&'a str> {\n        match self.count {\n            0 => None,\n            1 => {\n                self.count = 0;\n                self.iter.get_end()\n            }\n            _ => {\n                self.count -= 1;\n                self.iter.next()\n            }\n        }\n    }\n\n    #[inline]\n    fn next_back(&mut self) -> Option<&'a str>\n    where\n        P::Searcher<'a>: ReverseSearcher<'a>,\n    {\n        match self.count {\n            0 => None,\n            1 => {\n                self.count = 0;\n                self.iter.get_end()\n            }\n            _ => {\n                self.count -= 1;\n                self.iter.next_back()\n            }\n        }\n    }\n\n    #[inline]\n    fn remainder(&self) -> Option<&'a str> {\n        self.iter.remainder()\n    }\n}\n\ngenerate_pattern_iterators! {\n    forward:\n        /// Created with the method [`splitn`].\n        ///\n        /// [`splitn`]: str::splitn\n        struct SplitN;\n    reverse:\n        /// Created with the method [`rsplitn`].\n        ///\n        /// [`rsplitn`]: str::rsplitn\n        struct RSplitN;\n    stability:\n        #[stable(feature = \"rust1\", since = \"1.0.0\")]\n    internal:\n        SplitNInternal yielding (&'a str);\n    delegate single ended;\n}\n\nimpl<'a, P: Pattern> SplitN<'a, P> {\n    /// Returns remainder of the split string.\n    ///\n    /// If the iterator is empty, returns `None`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(str_split_remainder)]\n    /// let mut split = \"Mary had a little lamb\".splitn(3, ' ');\n    /// assert_eq!(split.remainder(), Some(\"Mary had a little lamb\"));\n    /// split.next();\n    /// assert_eq!(split.remainder(), Some(\"had a little lamb\"));\n    /// split.by_ref().for_each(drop);\n    /// assert_eq!(split.remainder(), None);\n    /// ```\n    #[inline]\n    #[unstable(feature = \"str_split_remainder\", issue = \"77998\")]\n    pub fn remainder(&self) -> Option<&'a str> {\n        self.0.remainder()\n    }\n}\n\nimpl<'a, P: Pattern> RSplitN<'a, P> {\n    /// Returns remainder of the split string.\n    ///\n    /// If the iterator is empty, returns `None`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(str_split_remainder)]\n    /// let mut split = \"Mary had a little lamb\".rsplitn(3, ' ');\n    /// assert_eq!(split.remainder(), Some(\"Mary had a little lamb\"));\n    /// split.next();\n    /// assert_eq!(split.remainder(), Some(\"Mary had a little\"));\n    /// split.by_ref().for_each(drop);\n    /// assert_eq!(split.remainder(), None);\n    /// ```\n    #[inline]\n    #[unstable(feature = \"str_split_remainder\", issue = \"77998\")]\n    pub fn remainder(&self) -> Option<&'a str> {\n        self.0.remainder()\n    }\n}\n\nderive_pattern_clone! {\n    clone MatchIndicesInternal\n    with |s| MatchIndicesInternal(s.0.clone())\n}\n\npub(super) struct MatchIndicesInternal<'a, P: Pattern>(pub(super) P::Searcher<'a>);\n\nimpl<'a, P> fmt::Debug for MatchIndicesInternal<'a, P>\nwhere\n    P: Pattern<Searcher<'a>: fmt::Debug>,\n{\n    fn fmt(&self, f: &mut fmt::Formatter<'_>) -> fmt::Result {\n        f.debug_tuple(\"MatchIndicesInternal\").field(&self.0).finish()\n    }\n}\n\nimpl<'a, P: Pattern> MatchIndicesInternal<'a, P> {\n    #[inline]\n    fn next(&mut self) -> Option<(usize, &'a str)> {\n        self.0\n            .next_match()\n            // SAFETY: `Searcher` guarantees that `start` and `end` lie on unicode boundaries.\n            .map(|(start, end)| unsafe { (start, self.0.haystack().get_unchecked(start..end)) })\n    }\n\n    #[inline]\n    fn next_back(&mut self) -> Option<(usize, &'a str)>\n    where\n        P::Searcher<'a>: ReverseSearcher<'a>,\n    {\n        self.0\n            .next_match_back()\n            // SAFETY: `Searcher` guarantees that `start` and `end` lie on unicode boundaries.\n            .map(|(start, end)| unsafe { (start, self.0.haystack().get_unchecked(start..end)) })\n    }\n}\n\ngenerate_pattern_iterators! {\n    forward:\n        /// Created with the method [`match_indices`].\n        ///\n        /// [`match_indices`]: str::match_indices\n        struct MatchIndices;\n    reverse:\n        /// Created with the method [`rmatch_indices`].\n        ///\n        /// [`rmatch_indices`]: str::rmatch_indices\n        struct RMatchIndices;\n    stability:\n        #[stable(feature = \"str_match_indices\", since = \"1.5.0\")]\n    internal:\n        MatchIndicesInternal yielding ((usize, &'a str));\n    delegate double ended;\n}\n\nderive_pattern_clone! {\n    clone MatchesInternal\n    with |s| MatchesInternal(s.0.clone())\n}\n\npub(super) struct MatchesInternal<'a, P: Pattern>(pub(super) P::Searcher<'a>);\n\nimpl<'a, P> fmt::Debug for MatchesInternal<'a, P>\nwhere\n    P: Pattern<Searcher<'a>: fmt::Debug>,\n{\n    fn fmt(&self, f: &mut fmt::Formatter<'_>) -> fmt::Result {\n        f.debug_tuple(\"MatchesInternal\").field(&self.0).finish()\n    }\n}\n\nimpl<'a, P: Pattern> MatchesInternal<'a, P> {\n    #[inline]\n    fn next(&mut self) -> Option<&'a str> {\n        // SAFETY: `Searcher` guarantees that `start` and `end` lie on unicode boundaries.\n        self.0.next_match().map(|(a, b)| unsafe {\n            // Indices are known to be on utf8 boundaries\n            self.0.haystack().get_unchecked(a..b)\n        })\n    }\n\n    #[inline]\n    fn next_back(&mut self) -> Option<&'a str>\n    where\n        P::Searcher<'a>: ReverseSearcher<'a>,\n    {\n        // SAFETY: `Searcher` guarantees that `start` and `end` lie on unicode boundaries.\n        self.0.next_match_back().map(|(a, b)| unsafe {\n            // Indices are known to be on utf8 boundaries\n            self.0.haystack().get_unchecked(a..b)\n        })\n    }\n}\n\ngenerate_pattern_iterators! {\n    forward:\n        /// Created with the method [`matches`].\n        ///\n        /// [`matches`]: str::matches\n        struct Matches;\n    reverse:\n        /// Created with the method [`rmatches`].\n        ///\n        /// [`rmatches`]: str::rmatches\n        struct RMatches;\n    stability:\n        #[stable(feature = \"str_matches\", since = \"1.2.0\")]\n    internal:\n        MatchesInternal yielding (&'a str);\n    delegate double ended;\n}\n\n/// An iterator over the lines of a string, as string slices.\n///\n/// This struct is created with the [`lines`] method on [`str`].\n/// See its documentation for more.\n///\n/// [`lines`]: str::lines\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\n#[must_use = \"iterators are lazy and do nothing unless consumed\"]\n#[derive(Clone, Debug)]\npub struct Lines<'a>(pub(super) Map<SplitInclusive<'a, char>, LinesMap>);\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl<'a> Iterator for Lines<'a> {\n    type Item = &'a str;\n\n    #[inline]\n    fn next(&mut self) -> Option<&'a str> {\n        self.0.next()\n    }\n\n    #[inline]\n    fn size_hint(&self) -> (usize, Option<usize>) {\n        self.0.size_hint()\n    }\n\n    #[inline]\n    fn last(mut self) -> Option<&'a str> {\n        self.next_back()\n    }\n}\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\nimpl<'a> DoubleEndedIterator for Lines<'a> {\n    #[inline]\n    fn next_back(&mut self) -> Option<&'a str> {\n        self.0.next_back()\n    }\n}\n\n#[stable(feature = \"fused\", since = \"1.26.0\")]\nimpl FusedIterator for Lines<'_> {}\n\nimpl<'a> Lines<'a> {\n    /// Returns the remaining lines of the split string.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(str_lines_remainder)]\n    ///\n    /// let mut lines = \"a\\nb\\nc\\nd\".lines();\n    /// assert_eq!(lines.remainder(), Some(\"a\\nb\\nc\\nd\"));\n    ///\n    /// lines.next();\n    /// assert_eq!(lines.remainder(), Some(\"b\\nc\\nd\"));\n    ///\n    /// lines.by_ref().for_each(drop);\n    /// assert_eq!(lines.remainder(), None);\n    /// ```\n    #[inline]\n    #[must_use]\n    #[unstable(feature = \"str_lines_remainder\", issue = \"77998\")]\n    pub fn remainder(&self) -> Option<&'a str> {\n        self.0.iter.remainder()\n    }\n}\n\n/// Created with the method [`lines_any`].\n///\n/// [`lines_any`]: str::lines_any\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\n#[deprecated(since = \"1.4.0\", note = \"use lines()/Lines instead now\")]\n#[must_use = \"iterators are lazy and do nothing unless consumed\"]\n#[derive(Clone, Debug)]\n#[allow(deprecated)]\npub struct LinesAny<'a>(pub(super) Lines<'a>);\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\n#[allow(deprecated)]\nimpl<'a> Iterator for LinesAny<'a> {\n    type Item = &'a str;\n\n    #[inline]\n    fn next(&mut self) -> Option<&'a str> {\n        self.0.next()\n    }\n\n    #[inline]\n    fn size_hint(&self) -> (usize, Option<usize>) {\n        self.0.size_hint()\n    }\n}\n\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\n#[allow(deprecated)]\nimpl<'a> DoubleEndedIterator for LinesAny<'a> {\n    #[inline]\n    fn next_back(&mut self) -> Option<&'a str> {\n        self.0.next_back()\n    }\n}\n\n#[stable(feature = \"fused\", since = \"1.26.0\")]\n#[allow(deprecated)]\nimpl FusedIterator for LinesAny<'_> {}\n\n/// An iterator over the non-whitespace substrings of a string,\n/// separated by any amount of whitespace.\n///\n/// This struct is created by the [`split_whitespace`] method on [`str`].\n/// See its documentation for more.\n///\n/// [`split_whitespace`]: str::split_whitespace\n#[stable(feature = \"split_whitespace\", since = \"1.1.0\")]\n#[derive(Clone, Debug)]\npub struct SplitWhitespace<'a> {\n    pub(super) inner: Filter<Split<'a, IsWhitespace>, IsNotEmpty>,\n}\n\n/// An iterator over the non-ASCII-whitespace substrings of a string,\n/// separated by any amount of ASCII whitespace.\n///\n/// This struct is created by the [`split_ascii_whitespace`] method on [`str`].\n/// See its documentation for more.\n///\n/// [`split_ascii_whitespace`]: str::split_ascii_whitespace\n#[stable(feature = \"split_ascii_whitespace\", since = \"1.34.0\")]\n#[derive(Clone, Debug)]\npub struct SplitAsciiWhitespace<'a> {\n    pub(super) inner:\n        Map<Filter<SliceSplit<'a, u8, IsAsciiWhitespace>, BytesIsNotEmpty>, UnsafeBytesToStr>,\n}\n\n/// An iterator over the substrings of a string,\n/// terminated by a substring matching to a predicate function\n/// Unlike `Split`, it contains the matched part as a terminator\n/// of the subslice.\n///\n/// This struct is created by the [`split_inclusive`] method on [`str`].\n/// See its documentation for more.\n///\n/// [`split_inclusive`]: str::split_inclusive\n#[stable(feature = \"split_inclusive\", since = \"1.51.0\")]\npub struct SplitInclusive<'a, P: Pattern>(pub(super) SplitInternal<'a, P>);\n\n#[stable(feature = \"split_whitespace\", since = \"1.1.0\")]\nimpl<'a> Iterator for SplitWhitespace<'a> {\n    type Item = &'a str;\n\n    #[inline]\n    fn next(&mut self) -> Option<&'a str> {\n        self.inner.next()\n    }\n\n    #[inline]\n    fn size_hint(&self) -> (usize, Option<usize>) {\n        self.inner.size_hint()\n    }\n\n    #[inline]\n    fn last(mut self) -> Option<&'a str> {\n        self.next_back()\n    }\n}\n\n#[stable(feature = \"split_whitespace\", since = \"1.1.0\")]\nimpl<'a> DoubleEndedIterator for SplitWhitespace<'a> {\n    #[inline]\n    fn next_back(&mut self) -> Option<&'a str> {\n        self.inner.next_back()\n    }\n}\n\n#[stable(feature = \"fused\", since = \"1.26.0\")]\nimpl FusedIterator for SplitWhitespace<'_> {}\n\nimpl<'a> SplitWhitespace<'a> {\n    /// Returns remainder of the split string\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(str_split_whitespace_remainder)]\n    ///\n    /// let mut split = \"Mary had a little lamb\".split_whitespace();\n    /// assert_eq!(split.remainder(), Some(\"Mary had a little lamb\"));\n    ///\n    /// split.next();\n    /// assert_eq!(split.remainder(), Some(\"had a little lamb\"));\n    ///\n    /// split.by_ref().for_each(drop);\n    /// assert_eq!(split.remainder(), None);\n    /// ```\n    #[inline]\n    #[must_use]\n    #[unstable(feature = \"str_split_whitespace_remainder\", issue = \"77998\")]\n    pub fn remainder(&self) -> Option<&'a str> {\n        self.inner.iter.remainder()\n    }\n}\n\n#[stable(feature = \"split_ascii_whitespace\", since = \"1.34.0\")]\nimpl<'a> Iterator for SplitAsciiWhitespace<'a> {\n    type Item = &'a str;\n\n    #[inline]\n    fn next(&mut self) -> Option<&'a str> {\n        self.inner.next()\n    }\n\n    #[inline]\n    fn size_hint(&self) -> (usize, Option<usize>) {\n        self.inner.size_hint()\n    }\n\n    #[inline]\n    fn last(mut self) -> Option<&'a str> {\n        self.next_back()\n    }\n}\n\n#[stable(feature = \"split_ascii_whitespace\", since = \"1.34.0\")]\nimpl<'a> DoubleEndedIterator for SplitAsciiWhitespace<'a> {\n    #[inline]\n    fn next_back(&mut self) -> Option<&'a str> {\n        self.inner.next_back()\n    }\n}\n\n#[stable(feature = \"split_ascii_whitespace\", since = \"1.34.0\")]\nimpl FusedIterator for SplitAsciiWhitespace<'_> {}\n\nimpl<'a> SplitAsciiWhitespace<'a> {\n    /// Returns remainder of the split string.\n    ///\n    /// If the iterator is empty, returns `None`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(str_split_whitespace_remainder)]\n    ///\n    /// let mut split = \"Mary had a little lamb\".split_ascii_whitespace();\n    /// assert_eq!(split.remainder(), Some(\"Mary had a little lamb\"));\n    ///\n    /// split.next();\n    /// assert_eq!(split.remainder(), Some(\"had a little lamb\"));\n    ///\n    /// split.by_ref().for_each(drop);\n    /// assert_eq!(split.remainder(), None);\n    /// ```\n    #[inline]\n    #[must_use]\n    #[unstable(feature = \"str_split_whitespace_remainder\", issue = \"77998\")]\n    pub fn remainder(&self) -> Option<&'a str> {\n        if self.inner.iter.iter.finished {\n            return None;\n        }\n\n        // SAFETY: Slice is created from str.\n        Some(unsafe { crate::str::from_utf8_unchecked(&self.inner.iter.iter.v) })\n    }\n}\n\n#[stable(feature = \"split_inclusive\", since = \"1.51.0\")]\nimpl<'a, P: Pattern> Iterator for SplitInclusive<'a, P> {\n    type Item = &'a str;\n\n    #[inline]\n    fn next(&mut self) -> Option<&'a str> {\n        self.0.next_inclusive()\n    }\n}\n\n#[stable(feature = \"split_inclusive\", since = \"1.51.0\")]\nimpl<'a, P: Pattern<Searcher<'a>: fmt::Debug>> fmt::Debug for SplitInclusive<'a, P> {\n    fn fmt(&self, f: &mut fmt::Formatter<'_>) -> fmt::Result {\n        f.debug_struct(\"SplitInclusive\").field(\"0\", &self.0).finish()\n    }\n}\n\n// FIXME(#26925) Remove in favor of `#[derive(Clone)]`\n#[stable(feature = \"split_inclusive\", since = \"1.51.0\")]\nimpl<'a, P: Pattern<Searcher<'a>: Clone>> Clone for SplitInclusive<'a, P> {\n    fn clone(&self) -> Self {\n        SplitInclusive(self.0.clone())\n    }\n}\n\n#[stable(feature = \"split_inclusive\", since = \"1.51.0\")]\nimpl<'a, P: Pattern<Searcher<'a>: DoubleEndedSearcher<'a>>> DoubleEndedIterator\n    for SplitInclusive<'a, P>\n{\n    #[inline]\n    fn next_back(&mut self) -> Option<&'a str> {\n        self.0.next_back_inclusive()\n    }\n}\n\n#[stable(feature = \"split_inclusive\", since = \"1.51.0\")]\nimpl<'a, P: Pattern> FusedIterator for SplitInclusive<'a, P> {}\n\nimpl<'a, P: Pattern> SplitInclusive<'a, P> {\n    /// Returns remainder of the split string.\n    ///\n    /// If the iterator is empty, returns `None`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// #![feature(str_split_inclusive_remainder)]\n    /// let mut split = \"Mary had a little lamb\".split_inclusive(' ');\n    /// assert_eq!(split.remainder(), Some(\"Mary had a little lamb\"));\n    /// split.next();\n    /// assert_eq!(split.remainder(), Some(\"had a little lamb\"));\n    /// split.by_ref().for_each(drop);\n    /// assert_eq!(split.remainder(), None);\n    /// ```\n    #[inline]\n    #[unstable(feature = \"str_split_inclusive_remainder\", issue = \"77998\")]\n    pub fn remainder(&self) -> Option<&'a str> {\n        self.0.remainder()\n    }\n}\n\n/// An iterator of [`u16`] over the string encoded as UTF-16.\n///\n/// This struct is created by the [`encode_utf16`] method on [`str`].\n/// See its documentation for more.\n///\n/// [`encode_utf16`]: str::encode_utf16\n#[derive(Clone)]\n#[stable(feature = \"encode_utf16\", since = \"1.8.0\")]\npub struct EncodeUtf16<'a> {\n    pub(super) chars: Chars<'a>,\n    pub(super) extra: u16,\n}\n\n#[stable(feature = \"collection_debug\", since = \"1.17.0\")]\nimpl fmt::Debug for EncodeUtf16<'_> {\n    fn fmt(&self, f: &mut fmt::Formatter<'_>) -> fmt::Result {\n        f.debug_struct(\"EncodeUtf16\").finish_non_exhaustive()\n    }\n}\n\n#[stable(feature = \"encode_utf16\", since = \"1.8.0\")]\nimpl<'a> Iterator for EncodeUtf16<'a> {\n    type Item = u16;\n\n    #[inline]\n    fn next(&mut self) -> Option<u16> {\n        if self.extra != 0 {\n            let tmp = self.extra;\n            self.extra = 0;\n            return Some(tmp);\n        }\n\n        let mut buf = [0; 2];\n        self.chars.next().map(|ch| {\n            let n = ch.encode_utf16(&mut buf).len();\n            if n == 2 {\n                self.extra = buf[1];\n            }\n            buf[0]\n        })\n    }\n\n    #[inline]\n    fn size_hint(&self) -> (usize, Option<usize>) {\n        let len = self.chars.iter.len();\n        // The highest bytes:code units ratio occurs for 3-byte sequences,\n        // since a 4-byte sequence results in 2 code units. The lower bound\n        // is therefore determined by assuming the remaining bytes contain as\n        // many 3-byte sequences as possible. The highest bytes:code units\n        // ratio is for 1-byte sequences, so use this for the upper bound.\n        // `(len + 2)` can't overflow, because we know that the `slice::Iter`\n        // belongs to a slice in memory which has a maximum length of\n        // `isize::MAX` (that's well below `usize::MAX`)\n        if self.extra == 0 {\n            (len.div_ceil(3), Some(len))\n        } else {\n            // We're in the middle of a surrogate pair, so add the remaining\n            // surrogate to the bounds.\n            (len.div_ceil(3) + 1, Some(len + 1))\n        }\n    }\n}\n\n#[stable(feature = \"fused\", since = \"1.26.0\")]\nimpl FusedIterator for EncodeUtf16<'_> {}\n\n/// The return type of [`str::escape_debug`].\n#[stable(feature = \"str_escape\", since = \"1.34.0\")]\n#[derive(Clone, Debug)]\npub struct EscapeDebug<'a> {\n    pub(super) inner: Chain<\n        Flatten<option::IntoIter<char_mod::EscapeDebug>>,\n        FlatMap<Chars<'a>, char_mod::EscapeDebug, CharEscapeDebugContinue>,\n    >,\n}\n\n/// The return type of [`str::escape_default`].\n#[stable(feature = \"str_escape\", since = \"1.34.0\")]\n#[derive(Clone, Debug)]\npub struct EscapeDefault<'a> {\n    pub(super) inner: FlatMap<Chars<'a>, char_mod::EscapeDefault, CharEscapeDefault>,\n}\n\n/// The return type of [`str::escape_unicode`].\n#[stable(feature = \"str_escape\", since = \"1.34.0\")]\n#[derive(Clone, Debug)]\npub struct EscapeUnicode<'a> {\n    pub(super) inner: FlatMap<Chars<'a>, char_mod::EscapeUnicode, CharEscapeUnicode>,\n}\n\nmacro_rules! escape_types_impls {\n    ($( $Name: ident ),+) => {$(\n        #[stable(feature = \"str_escape\", since = \"1.34.0\")]\n        impl<'a> fmt::Display for $Name<'a> {\n            fn fmt(&self, f: &mut fmt::Formatter<'_>) -> fmt::Result {\n                self.clone().try_for_each(|c| f.write_char(c))\n            }\n        }\n\n        #[stable(feature = \"str_escape\", since = \"1.34.0\")]\n        impl<'a> Iterator for $Name<'a> {\n            type Item = char;\n\n            #[inline]\n            fn next(&mut self) -> Option<char> { self.inner.next() }\n\n            #[inline]\n            fn size_hint(&self) -> (usize, Option<usize>) { self.inner.size_hint() }\n\n            #[inline]\n            fn try_fold<Acc, Fold, R>(&mut self, init: Acc, fold: Fold) -> R where\n                Self: Sized, Fold: FnMut(Acc, Self::Item) -> R, R: Try<Output = Acc>\n            {\n                self.inner.try_fold(init, fold)\n            }\n\n            #[inline]\n            fn fold<Acc, Fold>(self, init: Acc, fold: Fold) -> Acc\n                where Fold: FnMut(Acc, Self::Item) -> Acc,\n            {\n                self.inner.fold(init, fold)\n            }\n        }\n\n        #[stable(feature = \"str_escape\", since = \"1.34.0\")]\n        impl<'a> FusedIterator for $Name<'a> {}\n    )+}\n}\n\nescape_types_impls!(EscapeDebug, EscapeDefault, EscapeUnicode);\n";

},{}],"2KtSE":[function(require,module,exports,__globalThis) {
module.exports = "#![stable(feature = \"futures_api\", since = \"1.36.0\")]\n\nuse crate::convert;\nuse crate::ops::{self, ControlFlow};\n\n/// Indicates whether a value is available or if the current task has been\n/// scheduled to receive a wakeup instead.\n///\n/// This is returned by [`Future::poll`](core::future::Future::poll).\n#[must_use = \"this `Poll` may be a `Pending` variant, which should be handled\"]\n#[derive(Copy, Clone, Debug, Eq, PartialEq, Ord, PartialOrd, Hash)]\n#[lang = \"Poll\"]\n#[stable(feature = \"futures_api\", since = \"1.36.0\")]\npub enum Poll<T> {\n    /// Represents that a value is immediately ready.\n    #[lang = \"Ready\"]\n    #[stable(feature = \"futures_api\", since = \"1.36.0\")]\n    Ready(#[stable(feature = \"futures_api\", since = \"1.36.0\")] T),\n\n    /// Represents that a value is not ready yet.\n    ///\n    /// When a function returns `Pending`, the function *must* also\n    /// ensure that the current task is scheduled to be awoken when\n    /// progress can be made.\n    #[lang = \"Pending\"]\n    #[stable(feature = \"futures_api\", since = \"1.36.0\")]\n    Pending,\n}\n\nimpl<T> Poll<T> {\n    /// Maps a `Poll<T>` to `Poll<U>` by applying a function to a contained value.\n    ///\n    /// # Examples\n    ///\n    /// Converts a <code>Poll<[String]></code> into a <code>Poll<[usize]></code>, consuming\n    /// the original:\n    ///\n    /// [String]: ../../std/string/struct.String.html \"String\"\n    /// ```\n    /// # use core::task::Poll;\n    /// let poll_some_string = Poll::Ready(String::from(\"Hello, World!\"));\n    /// // `Poll::map` takes self *by value*, consuming `poll_some_string`\n    /// let poll_some_len = poll_some_string.map(|s| s.len());\n    ///\n    /// assert_eq!(poll_some_len, Poll::Ready(13));\n    /// ```\n    #[stable(feature = \"futures_api\", since = \"1.36.0\")]\n    #[inline]\n    pub fn map<U, F>(self, f: F) -> Poll<U>\n    where\n        F: FnOnce(T) -> U,\n    {\n        match self {\n            Poll::Ready(t) => Poll::Ready(f(t)),\n            Poll::Pending => Poll::Pending,\n        }\n    }\n\n    /// Returns `true` if the poll is a [`Poll::Ready`] value.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # use core::task::Poll;\n    /// let x: Poll<u32> = Poll::Ready(2);\n    /// assert_eq!(x.is_ready(), true);\n    ///\n    /// let x: Poll<u32> = Poll::Pending;\n    /// assert_eq!(x.is_ready(), false);\n    /// ```\n    #[inline]\n    #[rustc_const_stable(feature = \"const_poll\", since = \"1.49.0\")]\n    #[stable(feature = \"futures_api\", since = \"1.36.0\")]\n    pub const fn is_ready(&self) -> bool {\n        matches!(*self, Poll::Ready(_))\n    }\n\n    /// Returns `true` if the poll is a [`Pending`] value.\n    ///\n    /// [`Pending`]: Poll::Pending\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # use core::task::Poll;\n    /// let x: Poll<u32> = Poll::Ready(2);\n    /// assert_eq!(x.is_pending(), false);\n    ///\n    /// let x: Poll<u32> = Poll::Pending;\n    /// assert_eq!(x.is_pending(), true);\n    /// ```\n    #[inline]\n    #[rustc_const_stable(feature = \"const_poll\", since = \"1.49.0\")]\n    #[stable(feature = \"futures_api\", since = \"1.36.0\")]\n    pub const fn is_pending(&self) -> bool {\n        !self.is_ready()\n    }\n}\n\nimpl<T, E> Poll<Result<T, E>> {\n    /// Maps a `Poll<Result<T, E>>` to `Poll<Result<U, E>>` by applying a\n    /// function to a contained `Poll::Ready(Ok)` value, leaving all other\n    /// variants untouched.\n    ///\n    /// This function can be used to compose the results of two functions.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # use core::task::Poll;\n    /// let res: Poll<Result<u8, _>> = Poll::Ready(\"12\".parse());\n    /// let squared = res.map_ok(|n| n * n);\n    /// assert_eq!(squared, Poll::Ready(Ok(144)));\n    /// ```\n    #[stable(feature = \"futures_api\", since = \"1.36.0\")]\n    #[inline]\n    pub fn map_ok<U, F>(self, f: F) -> Poll<Result<U, E>>\n    where\n        F: FnOnce(T) -> U,\n    {\n        match self {\n            Poll::Ready(Ok(t)) => Poll::Ready(Ok(f(t))),\n            Poll::Ready(Err(e)) => Poll::Ready(Err(e)),\n            Poll::Pending => Poll::Pending,\n        }\n    }\n\n    /// Maps a `Poll::Ready<Result<T, E>>` to `Poll::Ready<Result<T, U>>` by\n    /// applying a function to a contained `Poll::Ready(Err)` value, leaving all other\n    /// variants untouched.\n    ///\n    /// This function can be used to pass through a successful result while handling\n    /// an error.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # use core::task::Poll;\n    /// let res: Poll<Result<u8, _>> = Poll::Ready(\"oops\".parse());\n    /// let res = res.map_err(|_| 0_u8);\n    /// assert_eq!(res, Poll::Ready(Err(0)));\n    /// ```\n    #[stable(feature = \"futures_api\", since = \"1.36.0\")]\n    #[inline]\n    pub fn map_err<U, F>(self, f: F) -> Poll<Result<T, U>>\n    where\n        F: FnOnce(E) -> U,\n    {\n        match self {\n            Poll::Ready(Ok(t)) => Poll::Ready(Ok(t)),\n            Poll::Ready(Err(e)) => Poll::Ready(Err(f(e))),\n            Poll::Pending => Poll::Pending,\n        }\n    }\n}\n\nimpl<T, E> Poll<Option<Result<T, E>>> {\n    /// Maps a `Poll<Option<Result<T, E>>>` to `Poll<Option<Result<U, E>>>` by\n    /// applying a function to a contained `Poll::Ready(Some(Ok))` value,\n    /// leaving all other variants untouched.\n    ///\n    /// This function can be used to compose the results of two functions.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # use core::task::Poll;\n    /// let res: Poll<Option<Result<u8, _>>> = Poll::Ready(Some(\"12\".parse()));\n    /// let squared = res.map_ok(|n| n * n);\n    /// assert_eq!(squared, Poll::Ready(Some(Ok(144))));\n    /// ```\n    #[stable(feature = \"poll_map\", since = \"1.51.0\")]\n    #[inline]\n    pub fn map_ok<U, F>(self, f: F) -> Poll<Option<Result<U, E>>>\n    where\n        F: FnOnce(T) -> U,\n    {\n        match self {\n            Poll::Ready(Some(Ok(t))) => Poll::Ready(Some(Ok(f(t)))),\n            Poll::Ready(Some(Err(e))) => Poll::Ready(Some(Err(e))),\n            Poll::Ready(None) => Poll::Ready(None),\n            Poll::Pending => Poll::Pending,\n        }\n    }\n\n    /// Maps a `Poll::Ready<Option<Result<T, E>>>` to\n    /// `Poll::Ready<Option<Result<T, F>>>` by applying a function to a\n    /// contained `Poll::Ready(Some(Err))` value, leaving all other variants\n    /// untouched.\n    ///\n    /// This function can be used to pass through a successful result while handling\n    /// an error.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # use core::task::Poll;\n    /// let res: Poll<Option<Result<u8, _>>> = Poll::Ready(Some(\"oops\".parse()));\n    /// let res = res.map_err(|_| 0_u8);\n    /// assert_eq!(res, Poll::Ready(Some(Err(0))));\n    /// ```\n    #[stable(feature = \"poll_map\", since = \"1.51.0\")]\n    #[inline]\n    pub fn map_err<U, F>(self, f: F) -> Poll<Option<Result<T, U>>>\n    where\n        F: FnOnce(E) -> U,\n    {\n        match self {\n            Poll::Ready(Some(Ok(t))) => Poll::Ready(Some(Ok(t))),\n            Poll::Ready(Some(Err(e))) => Poll::Ready(Some(Err(f(e)))),\n            Poll::Ready(None) => Poll::Ready(None),\n            Poll::Pending => Poll::Pending,\n        }\n    }\n}\n\n#[stable(feature = \"futures_api\", since = \"1.36.0\")]\n#[rustc_const_unstable(feature = \"const_convert\", issue = \"143773\")]\nimpl<T> const From<T> for Poll<T> {\n    /// Moves the value into a [`Poll::Ready`] to make a `Poll<T>`.\n    ///\n    /// # Example\n    ///\n    /// ```\n    /// # use core::task::Poll;\n    /// assert_eq!(Poll::from(true), Poll::Ready(true));\n    /// ```\n    fn from(t: T) -> Poll<T> {\n        Poll::Ready(t)\n    }\n}\n\n#[unstable(feature = \"try_trait_v2\", issue = \"84277\", old_name = \"try_trait\")]\nimpl<T, E> ops::Try for Poll<Result<T, E>> {\n    type Output = Poll<T>;\n    type Residual = Result<convert::Infallible, E>;\n\n    #[inline]\n    fn from_output(c: Self::Output) -> Self {\n        c.map(Ok)\n    }\n\n    #[inline]\n    fn branch(self) -> ControlFlow<Self::Residual, Self::Output> {\n        match self {\n            Poll::Ready(Ok(x)) => ControlFlow::Continue(Poll::Ready(x)),\n            Poll::Ready(Err(e)) => ControlFlow::Break(Err(e)),\n            Poll::Pending => ControlFlow::Continue(Poll::Pending),\n        }\n    }\n}\n\n#[unstable(feature = \"try_trait_v2\", issue = \"84277\", old_name = \"try_trait\")]\nimpl<T, E, F: From<E>> ops::FromResidual<Result<convert::Infallible, E>> for Poll<Result<T, F>> {\n    #[inline]\n    fn from_residual(x: Result<convert::Infallible, E>) -> Self {\n        match x {\n            Err(e) => Poll::Ready(Err(From::from(e))),\n        }\n    }\n}\n\n#[unstable(feature = \"try_trait_v2\", issue = \"84277\", old_name = \"try_trait\")]\nimpl<T, E> ops::Try for Poll<Option<Result<T, E>>> {\n    type Output = Poll<Option<T>>;\n    type Residual = Result<convert::Infallible, E>;\n\n    #[inline]\n    fn from_output(c: Self::Output) -> Self {\n        c.map(|x| x.map(Ok))\n    }\n\n    #[inline]\n    fn branch(self) -> ControlFlow<Self::Residual, Self::Output> {\n        match self {\n            Poll::Ready(Some(Ok(x))) => ControlFlow::Continue(Poll::Ready(Some(x))),\n            Poll::Ready(Some(Err(e))) => ControlFlow::Break(Err(e)),\n            Poll::Ready(None) => ControlFlow::Continue(Poll::Ready(None)),\n            Poll::Pending => ControlFlow::Continue(Poll::Pending),\n        }\n    }\n}\n\n#[unstable(feature = \"try_trait_v2\", issue = \"84277\", old_name = \"try_trait\")]\nimpl<T, E, F: From<E>> ops::FromResidual<Result<convert::Infallible, E>>\n    for Poll<Option<Result<T, F>>>\n{\n    #[inline]\n    fn from_residual(x: Result<convert::Infallible, E>) -> Self {\n        match x {\n            Err(e) => Poll::Ready(Some(Err(From::from(e)))),\n        }\n    }\n}\n";

},{}],"5ZDWt":[function(require,module,exports,__globalThis) {
module.exports = "//! Free functions.\n\nuse super::builder::Builder;\nuse super::current::current;\nuse super::join_handle::JoinHandle;\nuse crate::mem::forget;\nuse crate::num::NonZero;\nuse crate::sys::thread as imp;\nuse crate::time::{Duration, Instant};\nuse crate::{io, panicking};\n\n/// Spawns a new thread, returning a [`JoinHandle`] for it.\n///\n/// The join handle provides a [`join`] method that can be used to join the spawned\n/// thread. If the spawned thread panics, [`join`] will return an [`Err`] containing\n/// the argument given to [`panic!`].\n///\n/// If the join handle is dropped, the spawned thread will implicitly be *detached*.\n/// In this case, the spawned thread may no longer be joined.\n/// (It is the responsibility of the program to either eventually join threads it\n/// creates or detach them; otherwise, a resource leak will result.)\n///\n/// This function creates a thread with the default parameters of [`Builder`].\n/// To specify the new thread's stack size or the name, use [`Builder::spawn`].\n///\n/// As you can see in the signature of `spawn` there are two constraints on\n/// both the closure given to `spawn` and its return value, let's explain them:\n///\n/// - The `'static` constraint means that the closure and its return value\n///   must have a lifetime of the whole program execution. The reason for this\n///   is that threads can outlive the lifetime they have been created in.\n///\n///   Indeed if the thread, and by extension its return value, can outlive their\n///   caller, we need to make sure that they will be valid afterwards, and since\n///   we *can't* know when it will return we need to have them valid as long as\n///   possible, that is until the end of the program, hence the `'static`\n///   lifetime.\n/// - The [`Send`] constraint is because the closure will need to be passed\n///   *by value* from the thread where it is spawned to the new thread. Its\n///   return value will need to be passed from the new thread to the thread\n///   where it is `join`ed.\n///   As a reminder, the [`Send`] marker trait expresses that it is safe to be\n///   passed from thread to thread. [`Sync`] expresses that it is safe to have a\n///   reference be passed from thread to thread.\n///\n/// # Panics\n///\n/// Panics if the OS fails to create a thread; use [`Builder::spawn`]\n/// to recover from such errors.\n///\n/// # Examples\n///\n/// Creating a thread.\n///\n/// ```\n/// use std::thread;\n///\n/// let handler = thread::spawn(|| {\n///     // thread code\n/// });\n///\n/// handler.join().unwrap();\n/// ```\n///\n/// As mentioned in the module documentation, threads are usually made to\n/// communicate using [`channels`], here is how it usually looks.\n///\n/// This example also shows how to use `move`, in order to give ownership\n/// of values to a thread.\n///\n/// ```\n/// use std::thread;\n/// use std::sync::mpsc::channel;\n///\n/// let (tx, rx) = channel();\n///\n/// let sender = thread::spawn(move || {\n///     tx.send(\"Hello, thread\".to_owned())\n///         .expect(\"Unable to send on channel\");\n/// });\n///\n/// let receiver = thread::spawn(move || {\n///     let value = rx.recv().expect(\"Unable to receive from channel\");\n///     println!(\"{value}\");\n/// });\n///\n/// sender.join().expect(\"The sender thread has panicked\");\n/// receiver.join().expect(\"The receiver thread has panicked\");\n/// ```\n///\n/// A thread can also return a value through its [`JoinHandle`], you can use\n/// this to make asynchronous computations (futures might be more appropriate\n/// though).\n///\n/// ```\n/// use std::thread;\n///\n/// let computation = thread::spawn(|| {\n///     // Some expensive computation.\n///     42\n/// });\n///\n/// let result = computation.join().unwrap();\n/// println!(\"{result}\");\n/// ```\n///\n/// # Notes\n///\n/// This function has the same minimal guarantee regarding \"foreign\" unwinding operations (e.g.\n/// an exception thrown from C++ code, or a `panic!` in Rust code compiled or linked with a\n/// different runtime) as [`catch_unwind`]; namely, if the thread created with `thread::spawn`\n/// unwinds all the way to the root with such an exception, one of two behaviors are possible,\n/// and it is unspecified which will occur:\n///\n/// * The process aborts.\n/// * The process does not abort, and [`join`] will return a `Result::Err`\n///   containing an opaque type.\n///\n/// [`catch_unwind`]: ../../std/panic/fn.catch_unwind.html\n/// [`channels`]: crate::sync::mpsc\n/// [`join`]: JoinHandle::join\n/// [`Err`]: crate::result::Result::Err\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\n#[cfg_attr(miri, track_caller)] // even without panics, this helps for Miri backtraces\npub fn spawn<F, T>(f: F) -> JoinHandle<T>\nwhere\n    F: FnOnce() -> T,\n    F: Send + 'static,\n    T: Send + 'static,\n{\n    Builder::new().spawn(f).expect(\"failed to spawn thread\")\n}\n\n/// Cooperatively gives up a timeslice to the OS scheduler.\n///\n/// This calls the underlying OS scheduler's yield primitive, signaling\n/// that the calling thread is willing to give up its remaining timeslice\n/// so that the OS may schedule other threads on the CPU.\n///\n/// A drawback of yielding in a loop is that if the OS does not have any\n/// other ready threads to run on the current CPU, the thread will effectively\n/// busy-wait, which wastes CPU time and energy.\n///\n/// Therefore, when waiting for events of interest, a programmer's first\n/// choice should be to use synchronization devices such as [`channel`]s,\n/// [`Condvar`]s, [`Mutex`]es or [`join`] since these primitives are\n/// implemented in a blocking manner, giving up the CPU until the event\n/// of interest has occurred which avoids repeated yielding.\n///\n/// `yield_now` should thus be used only rarely, mostly in situations where\n/// repeated polling is required because there is no other suitable way to\n/// learn when an event of interest has occurred.\n///\n/// # Examples\n///\n/// ```\n/// use std::thread;\n///\n/// thread::yield_now();\n/// ```\n///\n/// [`channel`]: crate::sync::mpsc\n/// [`join`]: JoinHandle::join\n/// [`Condvar`]: crate::sync::Condvar\n/// [`Mutex`]: crate::sync::Mutex\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\npub fn yield_now() {\n    imp::yield_now()\n}\n\n/// Determines whether the current thread is unwinding because of panic.\n///\n/// A common use of this feature is to poison shared resources when writing\n/// unsafe code, by checking `panicking` when the `drop` is called.\n///\n/// This is usually not needed when writing safe code, as [`Mutex`es][Mutex]\n/// already poison themselves when a thread panics while holding the lock.\n///\n/// This can also be used in multithreaded applications, in order to send a\n/// message to other threads warning that a thread has panicked (e.g., for\n/// monitoring purposes).\n///\n/// # Examples\n///\n/// ```should_panic\n/// use std::thread;\n///\n/// struct SomeStruct;\n///\n/// impl Drop for SomeStruct {\n///     fn drop(&mut self) {\n///         if thread::panicking() {\n///             println!(\"dropped while unwinding\");\n///         } else {\n///             println!(\"dropped while not unwinding\");\n///         }\n///     }\n/// }\n///\n/// {\n///     print!(\"a: \");\n///     let a = SomeStruct;\n/// }\n///\n/// {\n///     print!(\"b: \");\n///     let b = SomeStruct;\n///     panic!()\n/// }\n/// ```\n///\n/// [Mutex]: crate::sync::Mutex\n#[inline]\n#[must_use]\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\npub fn panicking() -> bool {\n    panicking::panicking()\n}\n\n/// Uses [`sleep`].\n///\n/// Puts the current thread to sleep for at least the specified amount of time.\n///\n/// The thread may sleep longer than the duration specified due to scheduling\n/// specifics or platform-dependent functionality. It will never sleep less.\n///\n/// This function is blocking, and should not be used in `async` functions.\n///\n/// # Platform-specific behavior\n///\n/// On Unix platforms, the underlying syscall may be interrupted by a\n/// spurious wakeup or signal handler. To ensure the sleep occurs for at least\n/// the specified duration, this function may invoke that system call multiple\n/// times.\n///\n/// # Examples\n///\n/// ```no_run\n/// use std::thread;\n///\n/// // Let's sleep for 2 seconds:\n/// thread::sleep_ms(2000);\n/// ```\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\n#[deprecated(since = \"1.6.0\", note = \"replaced by `std::thread::sleep`\")]\npub fn sleep_ms(ms: u32) {\n    sleep(Duration::from_millis(ms as u64))\n}\n\n/// Puts the current thread to sleep for at least the specified amount of time.\n///\n/// The thread may sleep longer than the duration specified due to scheduling\n/// specifics or platform-dependent functionality. It will never sleep less.\n///\n/// This function is blocking, and should not be used in `async` functions.\n///\n/// # Platform-specific behavior\n///\n/// On Unix platforms, the underlying syscall may be interrupted by a\n/// spurious wakeup or signal handler. To ensure the sleep occurs for at least\n/// the specified duration, this function may invoke that system call multiple\n/// times.\n/// Platforms which do not support nanosecond precision for sleeping will\n/// have `dur` rounded up to the nearest granularity of time they can sleep for.\n///\n/// Currently, specifying a zero duration on Unix platforms returns immediately\n/// without invoking the underlying [`nanosleep`] syscall, whereas on Windows\n/// platforms the underlying [`Sleep`] syscall is always invoked.\n/// If the intention is to yield the current time-slice you may want to use\n/// [`yield_now`] instead.\n///\n/// [`nanosleep`]: https://linux.die.net/man/2/nanosleep\n/// [`Sleep`]: https://docs.microsoft.com/en-us/windows/win32/api/synchapi/nf-synchapi-sleep\n///\n/// # Examples\n///\n/// ```no_run\n/// use std::{thread, time};\n///\n/// let ten_millis = time::Duration::from_millis(10);\n/// let now = time::Instant::now();\n///\n/// thread::sleep(ten_millis);\n///\n/// assert!(now.elapsed() >= ten_millis);\n/// ```\n#[stable(feature = \"thread_sleep\", since = \"1.4.0\")]\npub fn sleep(dur: Duration) {\n    imp::sleep(dur)\n}\n\n/// Puts the current thread to sleep until the specified deadline has passed.\n///\n/// The thread may still be asleep after the deadline specified due to\n/// scheduling specifics or platform-dependent functionality. It will never\n/// wake before.\n///\n/// This function is blocking, and should not be used in `async` functions.\n///\n/// # Platform-specific behavior\n///\n/// In most cases this function will call an OS specific function. Where that\n/// is not supported [`sleep`] is used. Those platforms are referred to as other\n/// in the table below.\n///\n/// # Underlying System calls\n///\n/// The following system calls are [currently] being used:\n///\n/// |  Platform |               System call                                            |\n/// |-----------|----------------------------------------------------------------------|\n/// | Linux     | [clock_nanosleep] (Monotonic clock)                                  |\n/// | BSD except OpenBSD | [clock_nanosleep] (Monotonic Clock)]                        |\n/// | Android   | [clock_nanosleep] (Monotonic Clock)]                                 |\n/// | Solaris   | [clock_nanosleep] (Monotonic Clock)]                                 |\n/// | Illumos   | [clock_nanosleep] (Monotonic Clock)]                                 |\n/// | Dragonfly | [clock_nanosleep] (Monotonic Clock)]                                 |\n/// | Hurd      | [clock_nanosleep] (Monotonic Clock)]                                 |\n/// | Fuchsia   | [clock_nanosleep] (Monotonic Clock)]                                 |\n/// | Vxworks   | [clock_nanosleep] (Monotonic Clock)]                                 |\n/// | Other     | `sleep_until` uses [`sleep`] and does not issue a syscall itself     |\n///\n/// [currently]: crate::io#platform-specific-behavior\n/// [clock_nanosleep]: https://linux.die.net/man/3/clock_nanosleep\n///\n/// **Disclaimer:** These system calls might change over time.\n///\n/// # Examples\n///\n/// A simple game loop that limits the game to 60 frames per second.\n///\n/// ```no_run\n/// #![feature(thread_sleep_until)]\n/// # use std::time::{Duration, Instant};\n/// # use std::thread;\n/// #\n/// # fn update() {}\n/// # fn render() {}\n/// #\n/// let max_fps = 60.0;\n/// let frame_time = Duration::from_secs_f32(1.0/max_fps);\n/// let mut next_frame = Instant::now();\n/// loop {\n///     thread::sleep_until(next_frame);\n///     next_frame += frame_time;\n///     update();\n///     render();\n/// }\n/// ```\n///\n/// A slow API we must not call too fast and which takes a few\n/// tries before succeeding. By using `sleep_until` the time the\n/// API call takes does not influence when we retry or when we give up\n///\n/// ```no_run\n/// #![feature(thread_sleep_until)]\n/// # use std::time::{Duration, Instant};\n/// # use std::thread;\n/// #\n/// # enum Status {\n/// #     Ready(usize),\n/// #     Waiting,\n/// # }\n/// # fn slow_web_api_call() -> Status { Status::Ready(42) }\n/// #\n/// # const MAX_DURATION: Duration = Duration::from_secs(10);\n/// #\n/// # fn try_api_call() -> Result<usize, ()> {\n/// let deadline = Instant::now() + MAX_DURATION;\n/// let delay = Duration::from_millis(250);\n/// let mut next_attempt = Instant::now();\n/// loop {\n///     if Instant::now() > deadline {\n///         break Err(());\n///     }\n///     if let Status::Ready(data) = slow_web_api_call() {\n///         break Ok(data);\n///     }\n///\n///     next_attempt = deadline.min(next_attempt + delay);\n///     thread::sleep_until(next_attempt);\n/// }\n/// # }\n/// # let _data = try_api_call();\n/// ```\n#[unstable(feature = \"thread_sleep_until\", issue = \"113752\")]\npub fn sleep_until(deadline: Instant) {\n    imp::sleep_until(deadline)\n}\n\n/// Used to ensure that `park` and `park_timeout` do not unwind, as that can\n/// cause undefined behavior if not handled correctly (see #102398 for context).\nstruct PanicGuard;\n\nimpl Drop for PanicGuard {\n    fn drop(&mut self) {\n        rtabort!(\"an irrecoverable error occurred while synchronizing threads\")\n    }\n}\n\n/// Blocks unless or until the current thread's token is made available.\n///\n/// A call to `park` does not guarantee that the thread will remain parked\n/// forever, and callers should be prepared for this possibility. However,\n/// it is guaranteed that this function will not panic (it may abort the\n/// process if the implementation encounters some rare errors).\n///\n/// # `park` and `unpark`\n///\n/// Every thread is equipped with some basic low-level blocking support, via the\n/// [`thread::park`][`park`] function and [`thread::Thread::unpark`][`unpark`]\n/// method. [`park`] blocks the current thread, which can then be resumed from\n/// another thread by calling the [`unpark`] method on the blocked thread's\n/// handle.\n///\n/// Conceptually, each [`Thread`] handle has an associated token, which is\n/// initially not present:\n///\n/// * The [`thread::park`][`park`] function blocks the current thread unless or\n///   until the token is available for its thread handle, at which point it\n///   atomically consumes the token. It may also return *spuriously*, without\n///   consuming the token. [`thread::park_timeout`] does the same, but allows\n///   specifying a maximum time to block the thread for.\n///\n/// * The [`unpark`] method on a [`Thread`] atomically makes the token available\n///   if it wasn't already. Because the token can be held by a thread even if it is currently not\n///   parked, [`unpark`] followed by [`park`] will result in the second call returning immediately.\n///   However, note that to rely on this guarantee, you need to make sure that your `unpark` happens\n///   after all `park` that may be done by other data structures!\n///\n/// The API is typically used by acquiring a handle to the current thread, placing that handle in a\n/// shared data structure so that other threads can find it, and then `park`ing in a loop. When some\n/// desired condition is met, another thread calls [`unpark`] on the handle. The last bullet point\n/// above guarantees that even if the `unpark` occurs before the thread is finished `park`ing, it\n/// will be woken up properly.\n///\n/// Note that the coordination via the shared data structure is crucial: If you `unpark` a thread\n/// without first establishing that it is about to be `park`ing within your code, that `unpark` may\n/// get consumed by a *different* `park` in the same thread, leading to a deadlock. This also means\n/// you must not call unknown code between setting up for parking and calling `park`; for instance,\n/// if you invoke `println!`, that may itself call `park` and thus consume your `unpark` and cause a\n/// deadlock.\n///\n/// The motivation for this design is twofold:\n///\n/// * It avoids the need to allocate mutexes and condvars when building new\n///   synchronization primitives; the threads already provide basic\n///   blocking/signaling.\n///\n/// * It can be implemented very efficiently on many platforms.\n///\n/// # Memory Ordering\n///\n/// Calls to `unpark` _synchronize-with_ calls to `park`, meaning that memory\n/// operations performed before a call to `unpark` are made visible to the thread that\n/// consumes the token and returns from `park`. Note that all `park` and `unpark`\n/// operations for a given thread form a total order and _all_ prior `unpark` operations\n/// synchronize-with `park`.\n///\n/// In atomic ordering terms, `unpark` performs a `Release` operation and `park`\n/// performs the corresponding `Acquire` operation. Calls to `unpark` for the same\n/// thread form a [release sequence].\n///\n/// Note that being unblocked does not imply a call was made to `unpark`, because\n/// wakeups can also be spurious. For example, a valid, but inefficient,\n/// implementation could have `park` and `unpark` return immediately without doing anything,\n/// making *all* wakeups spurious.\n///\n/// # Examples\n///\n/// ```\n/// use std::thread;\n/// use std::sync::atomic::{Ordering, AtomicBool};\n/// use std::time::Duration;\n///\n/// static QUEUED: AtomicBool = AtomicBool::new(false);\n/// static FLAG: AtomicBool = AtomicBool::new(false);\n///\n/// let parked_thread = thread::spawn(move || {\n///     println!(\"Thread spawned\");\n///     // Signal that we are going to `park`. Between this store and our `park`, there may\n///     // be no other `park`, or else that `park` could consume our `unpark` token!\n///     QUEUED.store(true, Ordering::Release);\n///     // We want to wait until the flag is set. We *could* just spin, but using\n///     // park/unpark is more efficient.\n///     while !FLAG.load(Ordering::Acquire) {\n///         // We can *not* use `println!` here since that could use thread parking internally.\n///         thread::park();\n///         // We *could* get here spuriously, i.e., way before the 10ms below are over!\n///         // But that is no problem, we are in a loop until the flag is set anyway.\n///     }\n///     println!(\"Flag received\");\n/// });\n///\n/// // Let some time pass for the thread to be spawned.\n/// thread::sleep(Duration::from_millis(10));\n///\n/// // Ensure the thread is about to park.\n/// // This is crucial! It guarantees that the `unpark` below is not consumed\n/// // by some other code in the parked thread (e.g. inside `println!`).\n/// while !QUEUED.load(Ordering::Acquire) {\n///     // Spinning is of course inefficient; in practice, this would more likely be\n///     // a dequeue where we have no work to do if there's nobody queued.\n///     std::hint::spin_loop();\n/// }\n///\n/// // Set the flag, and let the thread wake up.\n/// // There is no race condition here: if `unpark`\n/// // happens first, `park` will return immediately.\n/// // There is also no other `park` that could consume this token,\n/// // since we waited until the other thread got queued.\n/// // Hence there is no risk of a deadlock.\n/// FLAG.store(true, Ordering::Release);\n/// println!(\"Unpark the thread\");\n/// parked_thread.thread().unpark();\n///\n/// parked_thread.join().unwrap();\n/// ```\n///\n/// [`Thread`]: super::Thread\n/// [`unpark`]: super::Thread::unpark\n/// [`thread::park_timeout`]: park_timeout\n/// [release sequence]: https://en.cppreference.com/w/cpp/atomic/memory_order#Release_sequence\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\npub fn park() {\n    let guard = PanicGuard;\n    // SAFETY: park_timeout is called on the parker owned by this thread.\n    unsafe {\n        current().park();\n    }\n    // No panic occurred, do not abort.\n    forget(guard);\n}\n\n/// Uses [`park_timeout`].\n///\n/// Blocks unless or until the current thread's token is made available or\n/// the specified duration has been reached (may wake spuriously).\n///\n/// The semantics of this function are equivalent to [`park`] except\n/// that the thread will be blocked for roughly no longer than `dur`. This\n/// method should not be used for precise timing due to anomalies such as\n/// preemption or platform differences that might not cause the maximum\n/// amount of time waited to be precisely `ms` long.\n///\n/// See the [park documentation][`park`] for more detail.\n#[stable(feature = \"rust1\", since = \"1.0.0\")]\n#[deprecated(since = \"1.6.0\", note = \"replaced by `std::thread::park_timeout`\")]\npub fn park_timeout_ms(ms: u32) {\n    park_timeout(Duration::from_millis(ms as u64))\n}\n\n/// Blocks unless or until the current thread's token is made available or\n/// the specified duration has been reached (may wake spuriously).\n///\n/// The semantics of this function are equivalent to [`park`][park] except\n/// that the thread will be blocked for roughly no longer than `dur`. This\n/// method should not be used for precise timing due to anomalies such as\n/// preemption or platform differences that might not cause the maximum\n/// amount of time waited to be precisely `dur` long.\n///\n/// See the [park documentation][park] for more details.\n///\n/// # Platform-specific behavior\n///\n/// Platforms which do not support nanosecond precision for sleeping will have\n/// `dur` rounded up to the nearest granularity of time they can sleep for.\n///\n/// # Examples\n///\n/// Waiting for the complete expiration of the timeout:\n///\n/// ```rust,no_run\n/// use std::thread::park_timeout;\n/// use std::time::{Instant, Duration};\n///\n/// let timeout = Duration::from_secs(2);\n/// let beginning_park = Instant::now();\n///\n/// let mut timeout_remaining = timeout;\n/// loop {\n///     park_timeout(timeout_remaining);\n///     let elapsed = beginning_park.elapsed();\n///     if elapsed >= timeout {\n///         break;\n///     }\n///     println!(\"restarting park_timeout after {elapsed:?}\");\n///     timeout_remaining = timeout - elapsed;\n/// }\n/// ```\n#[stable(feature = \"park_timeout\", since = \"1.4.0\")]\npub fn park_timeout(dur: Duration) {\n    let guard = PanicGuard;\n    // SAFETY: park_timeout is called on a handle owned by this thread.\n    unsafe {\n        current().park_timeout(dur);\n    }\n    // No panic occurred, do not abort.\n    forget(guard);\n}\n\n/// Returns an estimate of the default amount of parallelism a program should use.\n///\n/// Parallelism is a resource. A given machine provides a certain capacity for\n/// parallelism, i.e., a bound on the number of computations it can perform\n/// simultaneously. This number often corresponds to the amount of CPUs a\n/// computer has, but it may diverge in various cases.\n///\n/// Host environments such as VMs or container orchestrators may want to\n/// restrict the amount of parallelism made available to programs in them. This\n/// is often done to limit the potential impact of (unintentionally)\n/// resource-intensive programs on other programs running on the same machine.\n///\n/// # Limitations\n///\n/// The purpose of this API is to provide an easy and portable way to query\n/// the default amount of parallelism the program should use. Among other things it\n/// does not expose information on NUMA regions, does not account for\n/// differences in (co)processor capabilities or current system load,\n/// and will not modify the program's global state in order to more accurately\n/// query the amount of available parallelism.\n///\n/// Where both fixed steady-state and burst limits are available the steady-state\n/// capacity will be used to ensure more predictable latencies.\n///\n/// Resource limits can be changed during the runtime of a program, therefore the value is\n/// not cached and instead recomputed every time this function is called. It should not be\n/// called from hot code.\n///\n/// The value returned by this function should be considered a simplified\n/// approximation of the actual amount of parallelism available at any given\n/// time. To get a more detailed or precise overview of the amount of\n/// parallelism available to the program, you may wish to use\n/// platform-specific APIs as well. The following platform limitations currently\n/// apply to `available_parallelism`:\n///\n/// On Windows:\n/// - It may undercount the amount of parallelism available on systems with more\n///   than 64 logical CPUs. However, programs typically need specific support to\n///   take advantage of more than 64 logical CPUs, and in the absence of such\n///   support, the number returned by this function accurately reflects the\n///   number of logical CPUs the program can use by default.\n/// - It may overcount the amount of parallelism available on systems limited by\n///   process-wide affinity masks, or job object limitations.\n///\n/// On Linux:\n/// - It may overcount the amount of parallelism available when limited by a\n///   process-wide affinity mask or cgroup quotas and `sched_getaffinity()` or cgroup fs can't be\n///   queried, e.g. due to sandboxing.\n/// - It may undercount the amount of parallelism if the current thread's affinity mask\n///   does not reflect the process' cpuset, e.g. due to pinned threads.\n/// - If the process is in a cgroup v1 cpu controller, this may need to\n///   scan mountpoints to find the corresponding cgroup v1 controller,\n///   which may take time on systems with large numbers of mountpoints.\n///   (This does not apply to cgroup v2, or to processes not in a\n///   cgroup.)\n/// - It does not attempt to take `ulimit` into account. If there is a limit set on the number of\n///   threads, `available_parallelism` cannot know how much of that limit a Rust program should\n///   take, or know in a reliable and race-free way how much of that limit is already taken.\n///\n/// On all targets:\n/// - It may overcount the amount of parallelism available when running in a VM\n/// with CPU usage limits (e.g. an overcommitted host).\n///\n/// # Errors\n///\n/// This function will, but is not limited to, return errors in the following\n/// cases:\n///\n/// - If the amount of parallelism is not known for the target platform.\n/// - If the program lacks permission to query the amount of parallelism made\n///   available to it.\n///\n/// # Examples\n///\n/// ```\n/// # #![allow(dead_code)]\n/// use std::{io, thread};\n///\n/// fn main() -> io::Result<()> {\n///     let count = thread::available_parallelism()?.get();\n///     assert!(count >= 1_usize);\n///     Ok(())\n/// }\n/// ```\n#[doc(alias = \"available_concurrency\")] // Alias for a previous name we gave this API on unstable.\n#[doc(alias = \"hardware_concurrency\")] // Alias for C++ `std::thread::hardware_concurrency`.\n#[doc(alias = \"num_cpus\")] // Alias for a popular ecosystem crate which provides similar functionality.\n#[stable(feature = \"available_parallelism\", since = \"1.59.0\")]\npub fn available_parallelism() -> io::Result<NonZero<usize>> {\n    imp::available_parallelism()\n}\n";

},{}],"idCyy":[function(require,module,exports,__globalThis) {
module.exports = "use super::Result;\nuse super::builder::Builder;\nuse super::current::current_or_unnamed;\nuse super::lifecycle::{JoinInner, spawn_unchecked};\nuse super::thread::Thread;\nuse crate::marker::PhantomData;\nuse crate::panic::{AssertUnwindSafe, catch_unwind, resume_unwind};\nuse crate::sync::Arc;\nuse crate::sync::atomic::{Atomic, AtomicBool, AtomicUsize, Ordering};\nuse crate::{fmt, io};\n\n/// A scope to spawn scoped threads in.\n///\n/// See [`scope`] for details.\n#[stable(feature = \"scoped_threads\", since = \"1.63.0\")]\npub struct Scope<'scope, 'env: 'scope> {\n    data: Arc<ScopeData>,\n    /// Invariance over 'scope, to make sure 'scope cannot shrink,\n    /// which is necessary for soundness.\n    ///\n    /// Without invariance, this would compile fine but be unsound:\n    ///\n    /// ```compile_fail,E0373\n    /// std::thread::scope(|s| {\n    ///     s.spawn(|| {\n    ///         let a = String::from(\"abcd\");\n    ///         s.spawn(|| println!(\"{a:?}\")); // might run after `a` is dropped\n    ///     });\n    /// });\n    /// ```\n    scope: PhantomData<&'scope mut &'scope ()>,\n    env: PhantomData<&'env mut &'env ()>,\n}\n\n/// An owned permission to join on a scoped thread (block on its termination).\n///\n/// See [`Scope::spawn`] for details.\n#[stable(feature = \"scoped_threads\", since = \"1.63.0\")]\npub struct ScopedJoinHandle<'scope, T>(JoinInner<'scope, T>);\n\npub(super) struct ScopeData {\n    num_running_threads: Atomic<usize>,\n    a_thread_panicked: Atomic<bool>,\n    main_thread: Thread,\n}\n\nimpl ScopeData {\n    pub(super) fn increment_num_running_threads(&self) {\n        // We check for 'overflow' with usize::MAX / 2, to make sure there's no\n        // chance it overflows to 0, which would result in unsoundness.\n        if self.num_running_threads.fetch_add(1, Ordering::Relaxed) > usize::MAX / 2 {\n            // This can only reasonably happen by mem::forget()'ing a lot of ScopedJoinHandles.\n            self.overflow();\n        }\n    }\n\n    #[cold]\n    fn overflow(&self) {\n        self.decrement_num_running_threads(false);\n        panic!(\"too many running threads in thread scope\");\n    }\n\n    pub(super) fn decrement_num_running_threads(&self, panic: bool) {\n        if panic {\n            self.a_thread_panicked.store(true, Ordering::Relaxed);\n        }\n        if self.num_running_threads.fetch_sub(1, Ordering::Release) == 1 {\n            self.main_thread.unpark();\n        }\n    }\n}\n\n/// Creates a scope for spawning scoped threads.\n///\n/// The function passed to `scope` will be provided a [`Scope`] object,\n/// through which scoped threads can be [spawned][`Scope::spawn`].\n///\n/// Unlike non-scoped threads, scoped threads can borrow non-`'static` data,\n/// as the scope guarantees all threads will be joined at the end of the scope.\n///\n/// All threads spawned within the scope that haven't been manually joined\n/// will be automatically joined before this function returns.\n///\n/// # Panics\n///\n/// If any of the automatically joined threads panicked, this function will panic.\n///\n/// If you want to handle panics from spawned threads,\n/// [`join`][ScopedJoinHandle::join] them before the end of the scope.\n///\n/// # Example\n///\n/// ```\n/// use std::thread;\n///\n/// let mut a = vec![1, 2, 3];\n/// let mut x = 0;\n///\n/// thread::scope(|s| {\n///     s.spawn(|| {\n///         println!(\"hello from the first scoped thread\");\n///         // We can borrow `a` here.\n///         dbg!(&a);\n///     });\n///     s.spawn(|| {\n///         println!(\"hello from the second scoped thread\");\n///         // We can even mutably borrow `x` here,\n///         // because no other threads are using it.\n///         x += a[0] + a[2];\n///     });\n///     println!(\"hello from the main thread\");\n/// });\n///\n/// // After the scope, we can modify and access our variables again:\n/// a.push(4);\n/// assert_eq!(x, a.len());\n/// ```\n///\n/// # Lifetimes\n///\n/// Scoped threads involve two lifetimes: `'scope` and `'env`.\n///\n/// The `'scope` lifetime represents the lifetime of the scope itself.\n/// That is: the time during which new scoped threads may be spawned,\n/// and also the time during which they might still be running.\n/// Once this lifetime ends, all scoped threads are joined.\n/// This lifetime starts within the `scope` function, before `f` (the argument to `scope`) starts.\n/// It ends after `f` returns and all scoped threads have been joined, but before `scope` returns.\n///\n/// The `'env` lifetime represents the lifetime of whatever is borrowed by the scoped threads.\n/// This lifetime must outlast the call to `scope`, and thus cannot be smaller than `'scope`.\n/// It can be as small as the call to `scope`, meaning that anything that outlives this call,\n/// such as local variables defined right before the scope, can be borrowed by the scoped threads.\n///\n/// The `'env: 'scope` bound is part of the definition of the `Scope` type.\n#[track_caller]\n#[stable(feature = \"scoped_threads\", since = \"1.63.0\")]\npub fn scope<'env, F, T>(f: F) -> T\nwhere\n    F: for<'scope> FnOnce(&'scope Scope<'scope, 'env>) -> T,\n{\n    // We put the `ScopeData` into an `Arc` so that other threads can finish their\n    // `decrement_num_running_threads` even after this function returns.\n    let scope = Scope {\n        data: Arc::new(ScopeData {\n            num_running_threads: AtomicUsize::new(0),\n            main_thread: current_or_unnamed(),\n            a_thread_panicked: AtomicBool::new(false),\n        }),\n        env: PhantomData,\n        scope: PhantomData,\n    };\n\n    // Run `f`, but catch panics so we can make sure to wait for all the threads to join.\n    let result = catch_unwind(AssertUnwindSafe(|| f(&scope)));\n\n    // Wait until all the threads are finished.\n    while scope.data.num_running_threads.load(Ordering::Acquire) != 0 {\n        // SAFETY: this is the main thread, the handle belongs to us.\n        unsafe { scope.data.main_thread.park() };\n    }\n\n    // Throw any panic from `f`, or the return value of `f` if no thread panicked.\n    match result {\n        Err(e) => resume_unwind(e),\n        Ok(_) if scope.data.a_thread_panicked.load(Ordering::Relaxed) => {\n            panic!(\"a scoped thread panicked\")\n        }\n        Ok(result) => result,\n    }\n}\n\nimpl<'scope, 'env> Scope<'scope, 'env> {\n    /// Spawns a new thread within a scope, returning a [`ScopedJoinHandle`] for it.\n    ///\n    /// Unlike non-scoped threads, threads spawned with this function may\n    /// borrow non-`'static` data from the outside the scope. See [`scope`] for\n    /// details.\n    ///\n    /// The join handle provides a [`join`] method that can be used to join the spawned\n    /// thread. If the spawned thread panics, [`join`] will return an [`Err`] containing\n    /// the panic payload.\n    ///\n    /// If the join handle is dropped, the spawned thread will be implicitly joined at the\n    /// end of the scope. In that case, if the spawned thread panics, [`scope`] will\n    /// panic after all threads are joined.\n    ///\n    /// This function creates a thread with the default parameters of [`Builder`].\n    /// To specify the new thread's stack size or the name, use [`Builder::spawn_scoped`].\n    ///\n    /// # Panics\n    ///\n    /// Panics if the OS fails to create a thread; use [`Builder::spawn_scoped`]\n    /// to recover from such errors.\n    ///\n    /// [`join`]: ScopedJoinHandle::join\n    #[stable(feature = \"scoped_threads\", since = \"1.63.0\")]\n    pub fn spawn<F, T>(&'scope self, f: F) -> ScopedJoinHandle<'scope, T>\n    where\n        F: FnOnce() -> T + Send + 'scope,\n        T: Send + 'scope,\n    {\n        Builder::new().spawn_scoped(self, f).expect(\"failed to spawn thread\")\n    }\n}\n\nimpl Builder {\n    /// Spawns a new scoped thread using the settings set through this `Builder`.\n    ///\n    /// Unlike [`Scope::spawn`], this method yields an [`io::Result`] to\n    /// capture any failure to create the thread at the OS level.\n    ///\n    /// [`io::Result`]: crate::io::Result\n    ///\n    /// # Panics\n    ///\n    /// Panics if a thread name was set and it contained null bytes.\n    ///\n    /// # Example\n    ///\n    /// ```\n    /// use std::thread;\n    ///\n    /// let mut a = vec![1, 2, 3];\n    /// let mut x = 0;\n    ///\n    /// thread::scope(|s| {\n    ///     thread::Builder::new()\n    ///         .name(\"first\".to_string())\n    ///         .spawn_scoped(s, ||\n    ///     {\n    ///         println!(\"hello from the {:?} scoped thread\", thread::current().name());\n    ///         // We can borrow `a` here.\n    ///         dbg!(&a);\n    ///     })\n    ///     .unwrap();\n    ///     thread::Builder::new()\n    ///         .name(\"second\".to_string())\n    ///         .spawn_scoped(s, ||\n    ///     {\n    ///         println!(\"hello from the {:?} scoped thread\", thread::current().name());\n    ///         // We can even mutably borrow `x` here,\n    ///         // because no other threads are using it.\n    ///         x += a[0] + a[2];\n    ///     })\n    ///     .unwrap();\n    ///     println!(\"hello from the main thread\");\n    /// });\n    ///\n    /// // After the scope, we can modify and access our variables again:\n    /// a.push(4);\n    /// assert_eq!(x, a.len());\n    /// ```\n    #[stable(feature = \"scoped_threads\", since = \"1.63.0\")]\n    pub fn spawn_scoped<'scope, 'env, F, T>(\n        self,\n        scope: &'scope Scope<'scope, 'env>,\n        f: F,\n    ) -> io::Result<ScopedJoinHandle<'scope, T>>\n    where\n        F: FnOnce() -> T + Send + 'scope,\n        T: Send + 'scope,\n    {\n        let Builder { name, stack_size, no_hooks } = self;\n        Ok(ScopedJoinHandle(unsafe {\n            spawn_unchecked(name, stack_size, no_hooks, Some(scope.data.clone()), f)\n        }?))\n    }\n}\n\nimpl<'scope, T> ScopedJoinHandle<'scope, T> {\n    /// Extracts a handle to the underlying thread.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// use std::thread;\n    ///\n    /// thread::scope(|s| {\n    ///     let t = s.spawn(|| {\n    ///         println!(\"hello\");\n    ///     });\n    ///     println!(\"thread id: {:?}\", t.thread().id());\n    /// });\n    /// ```\n    #[must_use]\n    #[stable(feature = \"scoped_threads\", since = \"1.63.0\")]\n    pub fn thread(&self) -> &Thread {\n        self.0.thread()\n    }\n\n    /// Waits for the associated thread to finish.\n    ///\n    /// This function will return immediately if the associated thread has already finished.\n    ///\n    /// In terms of [atomic memory orderings], the completion of the associated\n    /// thread synchronizes with this function returning.\n    /// In other words, all operations performed by that thread\n    /// [happen before](https://doc.rust-lang.org/nomicon/atomics.html#data-accesses)\n    /// all operations that happen after `join` returns.\n    ///\n    /// If the associated thread panics, [`Err`] is returned with the panic payload.\n    ///\n    /// [atomic memory orderings]: crate::sync::atomic\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// use std::thread;\n    ///\n    /// thread::scope(|s| {\n    ///     let t = s.spawn(|| {\n    ///         panic!(\"oh no\");\n    ///     });\n    ///     assert!(t.join().is_err());\n    /// });\n    /// ```\n    #[stable(feature = \"scoped_threads\", since = \"1.63.0\")]\n    pub fn join(self) -> Result<T> {\n        self.0.join()\n    }\n\n    /// Checks if the associated thread has finished running its main function.\n    ///\n    /// `is_finished` supports implementing a non-blocking join operation, by checking\n    /// `is_finished`, and calling `join` if it returns `true`. This function does not block. To\n    /// block while waiting on the thread to finish, use [`join`][Self::join].\n    ///\n    /// This might return `true` for a brief moment after the thread's main\n    /// function has returned, but before the thread itself has stopped running.\n    /// However, once this returns `true`, [`join`][Self::join] can be expected\n    /// to return quickly, without blocking for any significant amount of time.\n    #[stable(feature = \"scoped_threads\", since = \"1.63.0\")]\n    pub fn is_finished(&self) -> bool {\n        self.0.is_finished()\n    }\n}\n\n#[stable(feature = \"scoped_threads\", since = \"1.63.0\")]\nimpl fmt::Debug for Scope<'_, '_> {\n    fn fmt(&self, f: &mut fmt::Formatter<'_>) -> fmt::Result {\n        f.debug_struct(\"Scope\")\n            .field(\"num_running_threads\", &self.data.num_running_threads.load(Ordering::Relaxed))\n            .field(\"a_thread_panicked\", &self.data.a_thread_panicked.load(Ordering::Relaxed))\n            .field(\"main_thread\", &self.data.main_thread)\n            .finish_non_exhaustive()\n    }\n}\n\n#[stable(feature = \"scoped_threads\", since = \"1.63.0\")]\nimpl<'scope, T> fmt::Debug for ScopedJoinHandle<'scope, T> {\n    fn fmt(&self, f: &mut fmt::Formatter<'_>) -> fmt::Result {\n        f.debug_struct(\"ScopedJoinHandle\").finish_non_exhaustive()\n    }\n}\n";

},{}],"6rN9e":[function(require,module,exports,__globalThis) {
module.exports = "//! Futures.\n\nuse core::ops::DerefMut;\nuse core::pin::Pin;\nuse core::task::{Context, Poll};\n\n#[doc(no_inline)]\npub use core::future::Future;\n\n/// An owned dynamically typed [`Future`] for use in cases where you can't\n/// statically type your result or need to add some indirection.\n///\n/// This type is often created by the [`boxed`] method on [`FutureExt`]. See its documentation for more.\n///\n/// [`boxed`]: https://docs.rs/futures/latest/futures/future/trait.FutureExt.html#method.boxed\n/// [`FutureExt`]: https://docs.rs/futures/latest/futures/future/trait.FutureExt.html\n#[cfg(feature = \"alloc\")]\npub type BoxFuture<'a, T> = Pin<alloc::boxed::Box<dyn Future<Output = T> + Send + 'a>>;\n\n/// `BoxFuture`, but without the `Send` requirement.\n///\n/// This type is often created by the [`boxed_local`] method on [`FutureExt`]. See its documentation for more.\n///\n/// [`boxed_local`]: https://docs.rs/futures/latest/futures/future/trait.FutureExt.html#method.boxed_local\n/// [`FutureExt`]: https://docs.rs/futures/latest/futures/future/trait.FutureExt.html\n#[cfg(feature = \"alloc\")]\npub type LocalBoxFuture<'a, T> = Pin<alloc::boxed::Box<dyn Future<Output = T> + 'a>>;\n\n/// A future which tracks whether or not the underlying future\n/// should no longer be polled.\n///\n/// `is_terminated` will return `true` if a future should no longer be polled.\n/// Usually, this state occurs after `poll` (or `try_poll`) returned\n/// `Poll::Ready`. However, `is_terminated` may also return `true` if a future\n/// has become inactive and can no longer make progress and should be ignored\n/// or dropped rather than being `poll`ed again.\npub trait FusedFuture: Future {\n    /// Returns `true` if the underlying future should no longer be polled.\n    fn is_terminated(&self) -> bool;\n}\n\nimpl<F: FusedFuture + ?Sized + Unpin> FusedFuture for &mut F {\n    fn is_terminated(&self) -> bool {\n        <F as FusedFuture>::is_terminated(&**self)\n    }\n}\n\nimpl<P> FusedFuture for Pin<P>\nwhere\n    P: DerefMut + Unpin,\n    P::Target: FusedFuture,\n{\n    fn is_terminated(&self) -> bool {\n        <P::Target as FusedFuture>::is_terminated(&**self)\n    }\n}\n\nmod private_try_future {\n    use super::Future;\n\n    pub trait Sealed {}\n\n    impl<F, T, E> Sealed for F where F: ?Sized + Future<Output = Result<T, E>> {}\n}\n\n/// A convenience for futures that return `Result` values that includes\n/// a variety of adapters tailored to such futures.\npub trait TryFuture: Future + private_try_future::Sealed {\n    /// The type of successful values yielded by this future\n    type Ok;\n\n    /// The type of failures yielded by this future\n    type Error;\n\n    /// Poll this `TryFuture` as if it were a `Future`.\n    ///\n    /// This method is a stopgap for a compiler limitation that prevents us from\n    /// directly inheriting from the `Future` trait; in the future it won't be\n    /// needed.\n    fn try_poll(self: Pin<&mut Self>, cx: &mut Context<'_>) -> Poll<Result<Self::Ok, Self::Error>>;\n}\n\nimpl<F, T, E> TryFuture for F\nwhere\n    F: ?Sized + Future<Output = Result<T, E>>,\n{\n    type Ok = T;\n    type Error = E;\n\n    #[inline]\n    fn try_poll(self: Pin<&mut Self>, cx: &mut Context<'_>) -> Poll<Self::Output> {\n        self.poll(cx)\n    }\n}\n\n#[cfg(feature = \"alloc\")]\nmod if_alloc {\n    use super::*;\n    use alloc::boxed::Box;\n\n    impl<F: FusedFuture + ?Sized + Unpin> FusedFuture for Box<F> {\n        fn is_terminated(&self) -> bool {\n            <F as FusedFuture>::is_terminated(&**self)\n        }\n    }\n\n    #[cfg(feature = \"std\")]\n    impl<F: FusedFuture> FusedFuture for std::panic::AssertUnwindSafe<F> {\n        fn is_terminated(&self) -> bool {\n            <F as FusedFuture>::is_terminated(&**self)\n        }\n    }\n}\n";

},{}],"8UBmk":[function(require,module,exports,__globalThis) {
module.exports = "//! Asynchronous streams.\n\nuse core::ops::DerefMut;\nuse core::pin::Pin;\nuse core::task::{Context, Poll};\n\n/// An owned dynamically typed [`Stream`] for use in cases where you can't\n/// statically type your result or need to add some indirection.\n///\n/// This type is often created by the [`boxed`] method on [`StreamExt`]. See its documentation for more.\n///\n/// [`boxed`]: https://docs.rs/futures/latest/futures/stream/trait.StreamExt.html#method.boxed\n/// [`StreamExt`]: https://docs.rs/futures/latest/futures/stream/trait.StreamExt.html\n#[cfg(feature = \"alloc\")]\npub type BoxStream<'a, T> = Pin<alloc::boxed::Box<dyn Stream<Item = T> + Send + 'a>>;\n\n/// `BoxStream`, but without the `Send` requirement.\n///\n/// This type is often created by the [`boxed_local`] method on [`StreamExt`]. See its documentation for more.\n///\n/// [`boxed_local`]: https://docs.rs/futures/latest/futures/stream/trait.StreamExt.html#method.boxed_local\n/// [`StreamExt`]: https://docs.rs/futures/latest/futures/stream/trait.StreamExt.html\n#[cfg(feature = \"alloc\")]\npub type LocalBoxStream<'a, T> = Pin<alloc::boxed::Box<dyn Stream<Item = T> + 'a>>;\n\n/// A stream of values produced asynchronously.\n///\n/// If `Future<Output = T>` is an asynchronous version of `T`, then `Stream<Item\n/// = T>` is an asynchronous version of `Iterator<Item = T>`. A stream\n/// represents a sequence of value-producing events that occur asynchronously to\n/// the caller.\n///\n/// The trait is modeled after `Future`, but allows `poll_next` to be called\n/// even after a value has been produced, yielding `None` once the stream has\n/// been fully exhausted.\n#[must_use = \"streams do nothing unless polled\"]\npub trait Stream {\n    /// Values yielded by the stream.\n    type Item;\n\n    /// Attempt to pull out the next value of this stream, registering the\n    /// current task for wakeup if the value is not yet available, and returning\n    /// `None` if the stream is exhausted.\n    ///\n    /// # Return value\n    ///\n    /// There are several possible return values, each indicating a distinct\n    /// stream state:\n    ///\n    /// - `Poll::Pending` means that this stream's next value is not ready\n    ///   yet. Implementations will ensure that the current task will be notified\n    ///   when the next value may be ready.\n    ///\n    /// - `Poll::Ready(Some(val))` means that the stream has successfully\n    ///   produced a value, `val`, and may produce further values on subsequent\n    ///   `poll_next` calls.\n    ///\n    /// - `Poll::Ready(None)` means that the stream has terminated, and\n    ///   `poll_next` should not be invoked again.\n    ///\n    /// # Panics\n    ///\n    /// Once a stream has finished (returned `Ready(None)` from `poll_next`), calling its\n    /// `poll_next` method again may panic, block forever, or cause other kinds of\n    /// problems; the `Stream` trait places no requirements on the effects of\n    /// such a call. However, as the `poll_next` method is not marked `unsafe`,\n    /// Rust's usual rules apply: calls must never cause undefined behavior\n    /// (memory corruption, incorrect use of `unsafe` functions, or the like),\n    /// regardless of the stream's state.\n    ///\n    /// If this is difficult to guard against then the [`fuse`] adapter can be used\n    /// to ensure that `poll_next` always returns `Ready(None)` in subsequent\n    /// calls.\n    ///\n    /// [`fuse`]: https://docs.rs/futures/0.3/futures/stream/trait.StreamExt.html#method.fuse\n    fn poll_next(self: Pin<&mut Self>, cx: &mut Context<'_>) -> Poll<Option<Self::Item>>;\n\n    /// Returns the bounds on the remaining length of the stream.\n    ///\n    /// Specifically, `size_hint()` returns a tuple where the first element\n    /// is the lower bound, and the second element is the upper bound.\n    ///\n    /// The second half of the tuple that is returned is an [`Option`]`<`[`usize`]`>`.\n    /// A [`None`] here means that either there is no known upper bound, or the\n    /// upper bound is larger than [`usize`].\n    ///\n    /// # Implementation notes\n    ///\n    /// It is not enforced that a stream implementation yields the declared\n    /// number of elements. A buggy stream may yield less than the lower bound\n    /// or more than the upper bound of elements.\n    ///\n    /// `size_hint()` is primarily intended to be used for optimizations such as\n    /// reserving space for the elements of the stream, but must not be\n    /// trusted to e.g., omit bounds checks in unsafe code. An incorrect\n    /// implementation of `size_hint()` should not lead to memory safety\n    /// violations.\n    ///\n    /// That said, the implementation should provide a correct estimation,\n    /// because otherwise it would be a violation of the trait's protocol.\n    ///\n    /// The default implementation returns `(0, `[`None`]`)` which is correct for any\n    /// stream.\n    #[inline]\n    fn size_hint(&self) -> (usize, Option<usize>) {\n        (0, None)\n    }\n}\n\nimpl<S: ?Sized + Stream + Unpin> Stream for &mut S {\n    type Item = S::Item;\n\n    fn poll_next(mut self: Pin<&mut Self>, cx: &mut Context<'_>) -> Poll<Option<Self::Item>> {\n        S::poll_next(Pin::new(&mut **self), cx)\n    }\n\n    fn size_hint(&self) -> (usize, Option<usize>) {\n        (**self).size_hint()\n    }\n}\n\nimpl<P> Stream for Pin<P>\nwhere\n    P: DerefMut + Unpin,\n    P::Target: Stream,\n{\n    type Item = <P::Target as Stream>::Item;\n\n    fn poll_next(self: Pin<&mut Self>, cx: &mut Context<'_>) -> Poll<Option<Self::Item>> {\n        self.get_mut().as_mut().poll_next(cx)\n    }\n\n    fn size_hint(&self) -> (usize, Option<usize>) {\n        (**self).size_hint()\n    }\n}\n\n/// A stream which tracks whether or not the underlying stream\n/// should no longer be polled.\n///\n/// `is_terminated` will return `true` if a future should no longer be polled.\n/// Usually, this state occurs after `poll_next` (or `try_poll_next`) returned\n/// `Poll::Ready(None)`. However, `is_terminated` may also return `true` if a\n/// stream has become inactive and can no longer make progress and should be\n/// ignored or dropped rather than being polled again.\npub trait FusedStream: Stream {\n    /// Returns `true` if the stream should no longer be polled.\n    fn is_terminated(&self) -> bool;\n}\n\nimpl<F: ?Sized + FusedStream + Unpin> FusedStream for &mut F {\n    fn is_terminated(&self) -> bool {\n        <F as FusedStream>::is_terminated(&**self)\n    }\n}\n\nimpl<P> FusedStream for Pin<P>\nwhere\n    P: DerefMut + Unpin,\n    P::Target: FusedStream,\n{\n    fn is_terminated(&self) -> bool {\n        <P::Target as FusedStream>::is_terminated(&**self)\n    }\n}\n\nmod private_try_stream {\n    use super::Stream;\n\n    pub trait Sealed {}\n\n    impl<S, T, E> Sealed for S where S: ?Sized + Stream<Item = Result<T, E>> {}\n}\n\n/// A convenience for streams that return `Result` values that includes\n/// a variety of adapters tailored to such futures.\npub trait TryStream: Stream + private_try_stream::Sealed {\n    /// The type of successful values yielded by this future\n    type Ok;\n\n    /// The type of failures yielded by this future\n    type Error;\n\n    /// Poll this `TryStream` as if it were a `Stream`.\n    ///\n    /// This method is a stopgap for a compiler limitation that prevents us from\n    /// directly inheriting from the `Stream` trait; in the future it won't be\n    /// needed.\n    fn try_poll_next(\n        self: Pin<&mut Self>,\n        cx: &mut Context<'_>,\n    ) -> Poll<Option<Result<Self::Ok, Self::Error>>>;\n}\n\nimpl<S, T, E> TryStream for S\nwhere\n    S: ?Sized + Stream<Item = Result<T, E>>,\n{\n    type Ok = T;\n    type Error = E;\n\n    fn try_poll_next(\n        self: Pin<&mut Self>,\n        cx: &mut Context<'_>,\n    ) -> Poll<Option<Result<Self::Ok, Self::Error>>> {\n        self.poll_next(cx)\n    }\n}\n\n#[cfg(feature = \"alloc\")]\nmod if_alloc {\n    use super::*;\n    use alloc::boxed::Box;\n\n    impl<S: ?Sized + Stream + Unpin> Stream for Box<S> {\n        type Item = S::Item;\n\n        fn poll_next(mut self: Pin<&mut Self>, cx: &mut Context<'_>) -> Poll<Option<Self::Item>> {\n            Pin::new(&mut **self).poll_next(cx)\n        }\n\n        fn size_hint(&self) -> (usize, Option<usize>) {\n            (**self).size_hint()\n        }\n    }\n\n    #[cfg(feature = \"std\")]\n    impl<S: Stream> Stream for std::panic::AssertUnwindSafe<S> {\n        type Item = S::Item;\n\n        fn poll_next(self: Pin<&mut Self>, cx: &mut Context<'_>) -> Poll<Option<S::Item>> {\n            unsafe { self.map_unchecked_mut(|x| &mut x.0) }.poll_next(cx)\n        }\n\n        fn size_hint(&self) -> (usize, Option<usize>) {\n            self.0.size_hint()\n        }\n    }\n\n    impl<S: ?Sized + FusedStream + Unpin> FusedStream for Box<S> {\n        fn is_terminated(&self) -> bool {\n            <S as FusedStream>::is_terminated(&**self)\n        }\n    }\n}\n";

},{}],"8CCFF":[function(require,module,exports,__globalThis) {
module.exports = "//! Asynchronous I/O\n//!\n//! This crate contains the `AsyncRead`, `AsyncWrite`, `AsyncSeek`, and\n//! `AsyncBufRead` traits, the asynchronous analogs to\n//! `std::io::{Read, Write, Seek, BufRead}`. The primary difference is\n//! that these traits integrate with the asynchronous task system.\n//!\n//! All items of this library are only available when the `std` feature of this\n//! library is activated, and it is activated by default.\n\n#![no_std]\n#![doc(test(\n    no_crate_inject,\n    attr(\n        deny(warnings, rust_2018_idioms, single_use_lifetimes),\n        allow(dead_code, unused_assignments, unused_variables)\n    )\n))]\n#![warn(missing_docs, /* unsafe_op_in_unsafe_fn */)] // unsafe_op_in_unsafe_fn requires Rust 1.52\n#![cfg_attr(docsrs, feature(doc_cfg))]\n\n#[cfg(feature = \"std\")]\nextern crate std;\n\n#[cfg(feature = \"std\")]\nmod if_std {\n    use std::boxed::Box;\n    use std::io;\n    use std::ops::DerefMut;\n    use std::pin::Pin;\n    use std::task::{Context, Poll};\n    use std::vec::Vec;\n\n    // Re-export some types from `std::io` so that users don't have to deal\n    // with conflicts when `use`ing `futures::io` and `std::io`.\n    #[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\n    #[doc(no_inline)]\n    pub use io::{Error, ErrorKind, IoSlice, IoSliceMut, Result, SeekFrom};\n\n    /// Read bytes asynchronously.\n    ///\n    /// This trait is analogous to the `std::io::Read` trait, but integrates\n    /// with the asynchronous task system. In particular, the `poll_read`\n    /// method, unlike `Read::read`, will automatically queue the current task\n    /// for wakeup and return if data is not yet available, rather than blocking\n    /// the calling thread.\n    pub trait AsyncRead {\n        /// Attempt to read from the `AsyncRead` into `buf`.\n        ///\n        /// On success, returns `Poll::Ready(Ok(num_bytes_read))`.\n        ///\n        /// If no data is available for reading, the method returns\n        /// `Poll::Pending` and arranges for the current task (via\n        /// `cx.waker().wake_by_ref()`) to receive a notification when the object becomes\n        /// readable or is closed.\n        ///\n        /// # Implementation\n        ///\n        /// This function may not return errors of kind `WouldBlock` or\n        /// `Interrupted`.  Implementations must convert `WouldBlock` into\n        /// `Poll::Pending` and either internally retry or convert\n        /// `Interrupted` into another error kind.\n        fn poll_read(\n            self: Pin<&mut Self>,\n            cx: &mut Context<'_>,\n            buf: &mut [u8],\n        ) -> Poll<Result<usize>>;\n\n        /// Attempt to read from the `AsyncRead` into `bufs` using vectored\n        /// IO operations.\n        ///\n        /// This method is similar to `poll_read`, but allows data to be read\n        /// into multiple buffers using a single operation.\n        ///\n        /// On success, returns `Poll::Ready(Ok(num_bytes_read))`.\n        ///\n        /// If no data is available for reading, the method returns\n        /// `Poll::Pending` and arranges for the current task (via\n        /// `cx.waker().wake_by_ref()`) to receive a notification when the object becomes\n        /// readable or is closed.\n        /// By default, this method delegates to using `poll_read` on the first\n        /// nonempty buffer in `bufs`, or an empty one if none exists. Objects which\n        /// support vectored IO should override this method.\n        ///\n        /// # Implementation\n        ///\n        /// This function may not return errors of kind `WouldBlock` or\n        /// `Interrupted`.  Implementations must convert `WouldBlock` into\n        /// `Poll::Pending` and either internally retry or convert\n        /// `Interrupted` into another error kind.\n        fn poll_read_vectored(\n            self: Pin<&mut Self>,\n            cx: &mut Context<'_>,\n            bufs: &mut [IoSliceMut<'_>],\n        ) -> Poll<Result<usize>> {\n            for b in bufs {\n                if !b.is_empty() {\n                    return self.poll_read(cx, b);\n                }\n            }\n\n            self.poll_read(cx, &mut [])\n        }\n    }\n\n    /// Write bytes asynchronously.\n    ///\n    /// This trait is analogous to the `std::io::Write` trait, but integrates\n    /// with the asynchronous task system. In particular, the `poll_write`\n    /// method, unlike `Write::write`, will automatically queue the current task\n    /// for wakeup and return if the writer cannot take more data, rather than blocking\n    /// the calling thread.\n    pub trait AsyncWrite {\n        /// Attempt to write bytes from `buf` into the object.\n        ///\n        /// On success, returns `Poll::Ready(Ok(num_bytes_written))`.\n        ///\n        /// If the object is not ready for writing, the method returns\n        /// `Poll::Pending` and arranges for the current task (via\n        /// `cx.waker().wake_by_ref()`) to receive a notification when the object becomes\n        /// writable or is closed.\n        ///\n        /// # Implementation\n        ///\n        /// This function may not return errors of kind `WouldBlock` or\n        /// `Interrupted`.  Implementations must convert `WouldBlock` into\n        /// `Poll::Pending` and either internally retry or convert\n        /// `Interrupted` into another error kind.\n        ///\n        /// `poll_write` must try to make progress by flushing the underlying object if\n        /// that is the only way the underlying object can become writable again.\n        fn poll_write(\n            self: Pin<&mut Self>,\n            cx: &mut Context<'_>,\n            buf: &[u8],\n        ) -> Poll<Result<usize>>;\n\n        /// Attempt to write bytes from `bufs` into the object using vectored\n        /// IO operations.\n        ///\n        /// This method is similar to `poll_write`, but allows data from multiple buffers to be written\n        /// using a single operation.\n        ///\n        /// On success, returns `Poll::Ready(Ok(num_bytes_written))`.\n        ///\n        /// If the object is not ready for writing, the method returns\n        /// `Poll::Pending` and arranges for the current task (via\n        /// `cx.waker().wake_by_ref()`) to receive a notification when the object becomes\n        /// writable or is closed.\n        ///\n        /// By default, this method delegates to using `poll_write` on the first\n        /// nonempty buffer in `bufs`, or an empty one if none exists. Objects which\n        /// support vectored IO should override this method.\n        ///\n        /// # Implementation\n        ///\n        /// This function may not return errors of kind `WouldBlock` or\n        /// `Interrupted`.  Implementations must convert `WouldBlock` into\n        /// `Poll::Pending` and either internally retry or convert\n        /// `Interrupted` into another error kind.\n        fn poll_write_vectored(\n            self: Pin<&mut Self>,\n            cx: &mut Context<'_>,\n            bufs: &[IoSlice<'_>],\n        ) -> Poll<Result<usize>> {\n            for b in bufs {\n                if !b.is_empty() {\n                    return self.poll_write(cx, b);\n                }\n            }\n\n            self.poll_write(cx, &[])\n        }\n\n        /// Attempt to flush the object, ensuring that any buffered data reach\n        /// their destination.\n        ///\n        /// On success, returns `Poll::Ready(Ok(()))`.\n        ///\n        /// If flushing cannot immediately complete, this method returns\n        /// `Poll::Pending` and arranges for the current task (via\n        /// `cx.waker().wake_by_ref()`) to receive a notification when the object can make\n        /// progress towards flushing.\n        ///\n        /// # Implementation\n        ///\n        /// This function may not return errors of kind `WouldBlock` or\n        /// `Interrupted`.  Implementations must convert `WouldBlock` into\n        /// `Poll::Pending` and either internally retry or convert\n        /// `Interrupted` into another error kind.\n        ///\n        /// It only makes sense to do anything here if you actually buffer data.\n        fn poll_flush(self: Pin<&mut Self>, cx: &mut Context<'_>) -> Poll<Result<()>>;\n\n        /// Attempt to close the object.\n        ///\n        /// On success, returns `Poll::Ready(Ok(()))`.\n        ///\n        /// If closing cannot immediately complete, this function returns\n        /// `Poll::Pending` and arranges for the current task (via\n        /// `cx.waker().wake_by_ref()`) to receive a notification when the object can make\n        /// progress towards closing.\n        ///\n        /// # Implementation\n        ///\n        /// This function may not return errors of kind `WouldBlock` or\n        /// `Interrupted`.  Implementations must convert `WouldBlock` into\n        /// `Poll::Pending` and either internally retry or convert\n        /// `Interrupted` into another error kind.\n        fn poll_close(self: Pin<&mut Self>, cx: &mut Context<'_>) -> Poll<Result<()>>;\n    }\n\n    /// Seek bytes asynchronously.\n    ///\n    /// This trait is analogous to the `std::io::Seek` trait, but integrates\n    /// with the asynchronous task system. In particular, the `poll_seek`\n    /// method, unlike `Seek::seek`, will automatically queue the current task\n    /// for wakeup and return if data is not yet available, rather than blocking\n    /// the calling thread.\n    pub trait AsyncSeek {\n        /// Attempt to seek to an offset, in bytes, in a stream.\n        ///\n        /// A seek beyond the end of a stream is allowed, but behavior is defined\n        /// by the implementation.\n        ///\n        /// If the seek operation completed successfully,\n        /// this method returns the new position from the start of the stream.\n        /// That position can be used later with [`SeekFrom::Start`].\n        ///\n        /// # Errors\n        ///\n        /// Seeking to a negative offset is considered an error.\n        ///\n        /// # Implementation\n        ///\n        /// This function may not return errors of kind `WouldBlock` or\n        /// `Interrupted`.  Implementations must convert `WouldBlock` into\n        /// `Poll::Pending` and either internally retry or convert\n        /// `Interrupted` into another error kind.\n        fn poll_seek(\n            self: Pin<&mut Self>,\n            cx: &mut Context<'_>,\n            pos: SeekFrom,\n        ) -> Poll<Result<u64>>;\n    }\n\n    /// Read bytes asynchronously.\n    ///\n    /// This trait is analogous to the `std::io::BufRead` trait, but integrates\n    /// with the asynchronous task system. In particular, the `poll_fill_buf`\n    /// method, unlike `BufRead::fill_buf`, will automatically queue the current task\n    /// for wakeup and return if data is not yet available, rather than blocking\n    /// the calling thread.\n    pub trait AsyncBufRead: AsyncRead {\n        /// Attempt to return the contents of the internal buffer, filling it with more data\n        /// from the inner reader if it is empty.\n        ///\n        /// On success, returns `Poll::Ready(Ok(buf))`.\n        ///\n        /// If no data is available for reading, the method returns\n        /// `Poll::Pending` and arranges for the current task (via\n        /// `cx.waker().wake_by_ref()`) to receive a notification when the object becomes\n        /// readable or is closed.\n        ///\n        /// This function is a lower-level call. It needs to be paired with the\n        /// [`consume`] method to function properly. When calling this\n        /// method, none of the contents will be \"read\" in the sense that later\n        /// calling [`poll_read`] may return the same contents. As such, [`consume`] must\n        /// be called with the number of bytes that are consumed from this buffer to\n        /// ensure that the bytes are never returned twice.\n        ///\n        /// [`poll_read`]: AsyncRead::poll_read\n        /// [`consume`]: AsyncBufRead::consume\n        ///\n        /// An empty buffer returned indicates that the stream has reached EOF.\n        ///\n        /// # Implementation\n        ///\n        /// This function may not return errors of kind `WouldBlock` or\n        /// `Interrupted`.  Implementations must convert `WouldBlock` into\n        /// `Poll::Pending` and either internally retry or convert\n        /// `Interrupted` into another error kind.\n        fn poll_fill_buf(self: Pin<&mut Self>, cx: &mut Context<'_>) -> Poll<Result<&[u8]>>;\n\n        /// Tells this buffer that `amt` bytes have been consumed from the buffer,\n        /// so they should no longer be returned in calls to [`poll_read`].\n        ///\n        /// This function is a lower-level call. It needs to be paired with the\n        /// [`poll_fill_buf`] method to function properly. This function does\n        /// not perform any I/O, it simply informs this object that some amount of\n        /// its buffer, returned from [`poll_fill_buf`], has been consumed and should\n        /// no longer be returned. As such, this function may do odd things if\n        /// [`poll_fill_buf`] isn't called before calling it.\n        ///\n        /// The `amt` must be `<=` the number of bytes in the buffer returned by\n        /// [`poll_fill_buf`].\n        ///\n        /// [`poll_read`]: AsyncRead::poll_read\n        /// [`poll_fill_buf`]: AsyncBufRead::poll_fill_buf\n        fn consume(self: Pin<&mut Self>, amt: usize);\n    }\n\n    macro_rules! deref_async_read {\n        () => {\n            fn poll_read(\n                mut self: Pin<&mut Self>,\n                cx: &mut Context<'_>,\n                buf: &mut [u8],\n            ) -> Poll<Result<usize>> {\n                Pin::new(&mut **self).poll_read(cx, buf)\n            }\n\n            fn poll_read_vectored(\n                mut self: Pin<&mut Self>,\n                cx: &mut Context<'_>,\n                bufs: &mut [IoSliceMut<'_>],\n            ) -> Poll<Result<usize>> {\n                Pin::new(&mut **self).poll_read_vectored(cx, bufs)\n            }\n        };\n    }\n\n    impl<T: ?Sized + AsyncRead + Unpin> AsyncRead for Box<T> {\n        deref_async_read!();\n    }\n\n    impl<T: ?Sized + AsyncRead + Unpin> AsyncRead for &mut T {\n        deref_async_read!();\n    }\n\n    impl<P> AsyncRead for Pin<P>\n    where\n        P: DerefMut + Unpin,\n        P::Target: AsyncRead,\n    {\n        fn poll_read(\n            self: Pin<&mut Self>,\n            cx: &mut Context<'_>,\n            buf: &mut [u8],\n        ) -> Poll<Result<usize>> {\n            self.get_mut().as_mut().poll_read(cx, buf)\n        }\n\n        fn poll_read_vectored(\n            self: Pin<&mut Self>,\n            cx: &mut Context<'_>,\n            bufs: &mut [IoSliceMut<'_>],\n        ) -> Poll<Result<usize>> {\n            self.get_mut().as_mut().poll_read_vectored(cx, bufs)\n        }\n    }\n\n    macro_rules! delegate_async_read_to_stdio {\n        () => {\n            fn poll_read(\n                mut self: Pin<&mut Self>,\n                _: &mut Context<'_>,\n                buf: &mut [u8],\n            ) -> Poll<Result<usize>> {\n                Poll::Ready(io::Read::read(&mut *self, buf))\n            }\n\n            fn poll_read_vectored(\n                mut self: Pin<&mut Self>,\n                _: &mut Context<'_>,\n                bufs: &mut [IoSliceMut<'_>],\n            ) -> Poll<Result<usize>> {\n                Poll::Ready(io::Read::read_vectored(&mut *self, bufs))\n            }\n        };\n    }\n\n    impl AsyncRead for &[u8] {\n        delegate_async_read_to_stdio!();\n    }\n\n    macro_rules! deref_async_write {\n        () => {\n            fn poll_write(\n                mut self: Pin<&mut Self>,\n                cx: &mut Context<'_>,\n                buf: &[u8],\n            ) -> Poll<Result<usize>> {\n                Pin::new(&mut **self).poll_write(cx, buf)\n            }\n\n            fn poll_write_vectored(\n                mut self: Pin<&mut Self>,\n                cx: &mut Context<'_>,\n                bufs: &[IoSlice<'_>],\n            ) -> Poll<Result<usize>> {\n                Pin::new(&mut **self).poll_write_vectored(cx, bufs)\n            }\n\n            fn poll_flush(mut self: Pin<&mut Self>, cx: &mut Context<'_>) -> Poll<Result<()>> {\n                Pin::new(&mut **self).poll_flush(cx)\n            }\n\n            fn poll_close(mut self: Pin<&mut Self>, cx: &mut Context<'_>) -> Poll<Result<()>> {\n                Pin::new(&mut **self).poll_close(cx)\n            }\n        };\n    }\n\n    impl<T: ?Sized + AsyncWrite + Unpin> AsyncWrite for Box<T> {\n        deref_async_write!();\n    }\n\n    impl<T: ?Sized + AsyncWrite + Unpin> AsyncWrite for &mut T {\n        deref_async_write!();\n    }\n\n    impl<P> AsyncWrite for Pin<P>\n    where\n        P: DerefMut + Unpin,\n        P::Target: AsyncWrite,\n    {\n        fn poll_write(\n            self: Pin<&mut Self>,\n            cx: &mut Context<'_>,\n            buf: &[u8],\n        ) -> Poll<Result<usize>> {\n            self.get_mut().as_mut().poll_write(cx, buf)\n        }\n\n        fn poll_write_vectored(\n            self: Pin<&mut Self>,\n            cx: &mut Context<'_>,\n            bufs: &[IoSlice<'_>],\n        ) -> Poll<Result<usize>> {\n            self.get_mut().as_mut().poll_write_vectored(cx, bufs)\n        }\n\n        fn poll_flush(self: Pin<&mut Self>, cx: &mut Context<'_>) -> Poll<Result<()>> {\n            self.get_mut().as_mut().poll_flush(cx)\n        }\n\n        fn poll_close(self: Pin<&mut Self>, cx: &mut Context<'_>) -> Poll<Result<()>> {\n            self.get_mut().as_mut().poll_close(cx)\n        }\n    }\n\n    macro_rules! delegate_async_write_to_stdio {\n        () => {\n            fn poll_write(\n                mut self: Pin<&mut Self>,\n                _: &mut Context<'_>,\n                buf: &[u8],\n            ) -> Poll<Result<usize>> {\n                Poll::Ready(io::Write::write(&mut *self, buf))\n            }\n\n            fn poll_write_vectored(\n                mut self: Pin<&mut Self>,\n                _: &mut Context<'_>,\n                bufs: &[IoSlice<'_>],\n            ) -> Poll<Result<usize>> {\n                Poll::Ready(io::Write::write_vectored(&mut *self, bufs))\n            }\n\n            fn poll_flush(mut self: Pin<&mut Self>, _: &mut Context<'_>) -> Poll<Result<()>> {\n                Poll::Ready(io::Write::flush(&mut *self))\n            }\n\n            fn poll_close(self: Pin<&mut Self>, cx: &mut Context<'_>) -> Poll<Result<()>> {\n                self.poll_flush(cx)\n            }\n        };\n    }\n\n    impl AsyncWrite for Vec<u8> {\n        delegate_async_write_to_stdio!();\n    }\n\n    macro_rules! deref_async_seek {\n        () => {\n            fn poll_seek(\n                mut self: Pin<&mut Self>,\n                cx: &mut Context<'_>,\n                pos: SeekFrom,\n            ) -> Poll<Result<u64>> {\n                Pin::new(&mut **self).poll_seek(cx, pos)\n            }\n        };\n    }\n\n    impl<T: ?Sized + AsyncSeek + Unpin> AsyncSeek for Box<T> {\n        deref_async_seek!();\n    }\n\n    impl<T: ?Sized + AsyncSeek + Unpin> AsyncSeek for &mut T {\n        deref_async_seek!();\n    }\n\n    impl<P> AsyncSeek for Pin<P>\n    where\n        P: DerefMut + Unpin,\n        P::Target: AsyncSeek,\n    {\n        fn poll_seek(\n            self: Pin<&mut Self>,\n            cx: &mut Context<'_>,\n            pos: SeekFrom,\n        ) -> Poll<Result<u64>> {\n            self.get_mut().as_mut().poll_seek(cx, pos)\n        }\n    }\n\n    macro_rules! deref_async_buf_read {\n        () => {\n            fn poll_fill_buf(self: Pin<&mut Self>, cx: &mut Context<'_>) -> Poll<Result<&[u8]>> {\n                Pin::new(&mut **self.get_mut()).poll_fill_buf(cx)\n            }\n\n            fn consume(mut self: Pin<&mut Self>, amt: usize) {\n                Pin::new(&mut **self).consume(amt)\n            }\n        };\n    }\n\n    impl<T: ?Sized + AsyncBufRead + Unpin> AsyncBufRead for Box<T> {\n        deref_async_buf_read!();\n    }\n\n    impl<T: ?Sized + AsyncBufRead + Unpin> AsyncBufRead for &mut T {\n        deref_async_buf_read!();\n    }\n\n    impl<P> AsyncBufRead for Pin<P>\n    where\n        P: DerefMut + Unpin,\n        P::Target: AsyncBufRead,\n    {\n        fn poll_fill_buf(self: Pin<&mut Self>, cx: &mut Context<'_>) -> Poll<Result<&[u8]>> {\n            self.get_mut().as_mut().poll_fill_buf(cx)\n        }\n\n        fn consume(self: Pin<&mut Self>, amt: usize) {\n            self.get_mut().as_mut().consume(amt)\n        }\n    }\n\n    macro_rules! delegate_async_buf_read_to_stdio {\n        () => {\n            fn poll_fill_buf(self: Pin<&mut Self>, _: &mut Context<'_>) -> Poll<Result<&[u8]>> {\n                Poll::Ready(io::BufRead::fill_buf(self.get_mut()))\n            }\n\n            fn consume(self: Pin<&mut Self>, amt: usize) {\n                io::BufRead::consume(self.get_mut(), amt)\n            }\n        };\n    }\n\n    impl AsyncBufRead for &[u8] {\n        delegate_async_buf_read_to_stdio!();\n    }\n}\n\n#[cfg(feature = \"std\")]\npub use self::if_std::*;\n";

},{}],"14PiQ":[function(require,module,exports,__globalThis) {
module.exports = "//! Asynchronous I/O.\n//!\n//! This module is the asynchronous version of `std::io`. It defines four\n//! traits, [`AsyncRead`], [`AsyncWrite`], [`AsyncSeek`], and [`AsyncBufRead`],\n//! which mirror the `Read`, `Write`, `Seek`, and `BufRead` traits of the\n//! standard library. However, these traits integrate with the asynchronous\n//! task system, so that if an I/O object isn't ready for reading (or writing),\n//! the thread is not blocked, and instead the current task is queued to be\n//! woken when I/O is ready.\n//!\n//! In addition, the [`AsyncReadExt`], [`AsyncWriteExt`], [`AsyncSeekExt`], and\n//! [`AsyncBufReadExt`] extension traits offer a variety of useful combinators\n//! for operating with asynchronous I/O objects, including ways to work with\n//! them using futures, streams and sinks.\n//!\n//! This module is only available when the `std` feature of this\n//! library is activated, and it is activated by default.\n\n#[cfg(feature = \"io-compat\")]\n#[cfg_attr(docsrs, doc(cfg(feature = \"io-compat\")))]\nuse crate::compat::Compat;\nuse crate::future::assert_future;\nuse crate::stream::assert_stream;\nuse std::{pin::Pin, string::String, vec::Vec};\n\n// Re-export some types from `std::io` so that users don't have to deal\n// with conflicts when `use`ing `futures::io` and `std::io`.\n#[doc(no_inline)]\npub use std::io::{Error, ErrorKind, IoSlice, IoSliceMut, Result, SeekFrom};\n\npub use futures_io::{AsyncBufRead, AsyncRead, AsyncSeek, AsyncWrite};\n\n// used by `BufReader` and `BufWriter`\n// https://github.com/rust-lang/rust/blob/master/src/libstd/sys_common/io.rs#L1\nconst DEFAULT_BUF_SIZE: usize = 8 * 1024;\n\nmod allow_std;\npub use self::allow_std::AllowStdIo;\n\nmod buf_reader;\npub use self::buf_reader::{BufReader, SeeKRelative};\n\nmod buf_writer;\npub use self::buf_writer::BufWriter;\n\nmod line_writer;\npub use self::line_writer::LineWriter;\n\nmod chain;\npub use self::chain::Chain;\n\nmod close;\npub use self::close::Close;\n\nmod copy;\npub use self::copy::{copy, Copy};\n\nmod copy_buf;\npub use self::copy_buf::{copy_buf, CopyBuf};\n\nmod copy_buf_abortable;\npub use self::copy_buf_abortable::{copy_buf_abortable, CopyBufAbortable};\n\nmod cursor;\npub use self::cursor::Cursor;\n\nmod empty;\npub use self::empty::{empty, Empty};\n\nmod fill_buf;\npub use self::fill_buf::FillBuf;\n\nmod flush;\npub use self::flush::Flush;\n\n#[cfg(feature = \"sink\")]\n#[cfg_attr(docsrs, doc(cfg(feature = \"sink\")))]\nmod into_sink;\n#[cfg(feature = \"sink\")]\n#[cfg_attr(docsrs, doc(cfg(feature = \"sink\")))]\npub use self::into_sink::IntoSink;\n\nmod lines;\npub use self::lines::Lines;\n\nmod read;\npub use self::read::Read;\n\nmod read_vectored;\npub use self::read_vectored::ReadVectored;\n\nmod read_exact;\npub use self::read_exact::ReadExact;\n\nmod read_line;\npub use self::read_line::ReadLine;\n\nmod read_to_end;\npub use self::read_to_end::ReadToEnd;\n\nmod read_to_string;\npub use self::read_to_string::ReadToString;\n\nmod read_until;\npub use self::read_until::ReadUntil;\n\nmod repeat;\npub use self::repeat::{repeat, Repeat};\n\nmod seek;\npub use self::seek::Seek;\n\nmod sink;\npub use self::sink::{sink, Sink};\n\nmod split;\npub use self::split::{ReadHalf, ReuniteError, WriteHalf};\n\nmod take;\npub use self::take::Take;\n\nmod window;\npub use self::window::Window;\n\nmod write;\npub use self::write::Write;\n\nmod write_vectored;\npub use self::write_vectored::WriteVectored;\n\nmod write_all;\npub use self::write_all::WriteAll;\n\n#[cfg(feature = \"write-all-vectored\")]\nmod write_all_vectored;\n#[cfg(feature = \"write-all-vectored\")]\npub use self::write_all_vectored::WriteAllVectored;\n\n/// An extension trait which adds utility methods to `AsyncRead` types.\npub trait AsyncReadExt: AsyncRead {\n    /// Creates an adaptor which will chain this stream with another.\n    ///\n    /// The returned `AsyncRead` instance will first read all bytes from this object\n    /// until EOF is encountered. Afterwards the output is equivalent to the\n    /// output of `next`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::io::{AsyncReadExt, Cursor};\n    ///\n    /// let reader1 = Cursor::new([1, 2, 3, 4]);\n    /// let reader2 = Cursor::new([5, 6, 7, 8]);\n    ///\n    /// let mut reader = reader1.chain(reader2);\n    /// let mut buffer = Vec::new();\n    ///\n    /// // read the value into a Vec.\n    /// reader.read_to_end(&mut buffer).await?;\n    /// assert_eq!(buffer, [1, 2, 3, 4, 5, 6, 7, 8]);\n    /// # Ok::<(), Box<dyn std::error::Error>>(()) }).unwrap();\n    /// ```\n    fn chain<R>(self, next: R) -> Chain<Self, R>\n    where\n        Self: Sized,\n        R: AsyncRead,\n    {\n        assert_read(Chain::new(self, next))\n    }\n\n    /// Tries to read some bytes directly into the given `buf` in asynchronous\n    /// manner, returning a future type.\n    ///\n    /// The returned future will resolve to the number of bytes read once the read\n    /// operation is completed.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::io::{AsyncReadExt, Cursor};\n    ///\n    /// let mut reader = Cursor::new([1, 2, 3, 4]);\n    /// let mut output = [0u8; 5];\n    ///\n    /// let bytes = reader.read(&mut output[..]).await?;\n    ///\n    /// // This is only guaranteed to be 4 because `&[u8]` is a synchronous\n    /// // reader. In a real system you could get anywhere from 1 to\n    /// // `output.len()` bytes in a single read.\n    /// assert_eq!(bytes, 4);\n    /// assert_eq!(output, [1, 2, 3, 4, 0]);\n    /// # Ok::<(), Box<dyn std::error::Error>>(()) }).unwrap();\n    /// ```\n    fn read<'a>(&'a mut self, buf: &'a mut [u8]) -> Read<'a, Self>\n    where\n        Self: Unpin,\n    {\n        assert_future::<Result<usize>, _>(Read::new(self, buf))\n    }\n\n    /// Creates a future which will read from the `AsyncRead` into `bufs` using vectored\n    /// IO operations.\n    ///\n    /// The returned future will resolve to the number of bytes read once the read\n    /// operation is completed.\n    fn read_vectored<'a>(&'a mut self, bufs: &'a mut [IoSliceMut<'a>]) -> ReadVectored<'a, Self>\n    where\n        Self: Unpin,\n    {\n        assert_future::<Result<usize>, _>(ReadVectored::new(self, bufs))\n    }\n\n    /// Creates a future which will read exactly enough bytes to fill `buf`,\n    /// returning an error if end of file (EOF) is hit sooner.\n    ///\n    /// The returned future will resolve once the read operation is completed.\n    ///\n    /// In the case of an error the buffer and the object will be discarded, with\n    /// the error yielded.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::io::{AsyncReadExt, Cursor};\n    ///\n    /// let mut reader = Cursor::new([1, 2, 3, 4]);\n    /// let mut output = [0u8; 4];\n    ///\n    /// reader.read_exact(&mut output).await?;\n    ///\n    /// assert_eq!(output, [1, 2, 3, 4]);\n    /// # Ok::<(), Box<dyn std::error::Error>>(()) }).unwrap();\n    /// ```\n    ///\n    /// ## EOF is hit before `buf` is filled\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::io::{self, AsyncReadExt, Cursor};\n    ///\n    /// let mut reader = Cursor::new([1, 2, 3, 4]);\n    /// let mut output = [0u8; 5];\n    ///\n    /// let result = reader.read_exact(&mut output).await;\n    ///\n    /// assert_eq!(result.unwrap_err().kind(), io::ErrorKind::UnexpectedEof);\n    /// # });\n    /// ```\n    fn read_exact<'a>(&'a mut self, buf: &'a mut [u8]) -> ReadExact<'a, Self>\n    where\n        Self: Unpin,\n    {\n        assert_future::<Result<()>, _>(ReadExact::new(self, buf))\n    }\n\n    /// Creates a future which will read all the bytes from this `AsyncRead`.\n    ///\n    /// On success the total number of bytes read is returned.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::io::{AsyncReadExt, Cursor};\n    ///\n    /// let mut reader = Cursor::new([1, 2, 3, 4]);\n    /// let mut output = Vec::with_capacity(4);\n    ///\n    /// let bytes = reader.read_to_end(&mut output).await?;\n    ///\n    /// assert_eq!(bytes, 4);\n    /// assert_eq!(output, vec![1, 2, 3, 4]);\n    /// # Ok::<(), Box<dyn std::error::Error>>(()) }).unwrap();\n    /// ```\n    fn read_to_end<'a>(&'a mut self, buf: &'a mut Vec<u8>) -> ReadToEnd<'a, Self>\n    where\n        Self: Unpin,\n    {\n        assert_future::<Result<usize>, _>(ReadToEnd::new(self, buf))\n    }\n\n    /// Creates a future which will read all the bytes from this `AsyncRead`.\n    ///\n    /// On success the total number of bytes read is returned.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::io::{AsyncReadExt, Cursor};\n    ///\n    /// let mut reader = Cursor::new(&b\"1234\"[..]);\n    /// let mut buffer = String::with_capacity(4);\n    ///\n    /// let bytes = reader.read_to_string(&mut buffer).await?;\n    ///\n    /// assert_eq!(bytes, 4);\n    /// assert_eq!(buffer, String::from(\"1234\"));\n    /// # Ok::<(), Box<dyn std::error::Error>>(()) }).unwrap();\n    /// ```\n    fn read_to_string<'a>(&'a mut self, buf: &'a mut String) -> ReadToString<'a, Self>\n    where\n        Self: Unpin,\n    {\n        assert_future::<Result<usize>, _>(ReadToString::new(self, buf))\n    }\n\n    /// Helper method for splitting this read/write object into two halves.\n    ///\n    /// The two halves returned implement the `AsyncRead` and `AsyncWrite`\n    /// traits, respectively.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::io::{self, AsyncReadExt, Cursor};\n    ///\n    /// // Note that for `Cursor` the read and write halves share a single\n    /// // seek position. This may or may not be true for other types that\n    /// // implement both `AsyncRead` and `AsyncWrite`.\n    ///\n    /// let reader = Cursor::new([1, 2, 3, 4]);\n    /// let mut buffer = Cursor::new(vec![0, 0, 0, 0, 5, 6, 7, 8]);\n    /// let mut writer = Cursor::new(vec![0u8; 5]);\n    ///\n    /// {\n    ///     let (buffer_reader, mut buffer_writer) = (&mut buffer).split();\n    ///     io::copy(reader, &mut buffer_writer).await?;\n    ///     io::copy(buffer_reader, &mut writer).await?;\n    /// }\n    ///\n    /// assert_eq!(buffer.into_inner(), [1, 2, 3, 4, 5, 6, 7, 8]);\n    /// assert_eq!(writer.into_inner(), [5, 6, 7, 8, 0]);\n    /// # Ok::<(), Box<dyn std::error::Error>>(()) }).unwrap();\n    /// ```\n    fn split(self) -> (ReadHalf<Self>, WriteHalf<Self>)\n    where\n        Self: AsyncWrite + Sized,\n    {\n        let (r, w) = split::split(self);\n        (assert_read(r), assert_write(w))\n    }\n\n    /// Creates an AsyncRead adapter which will read at most `limit` bytes\n    /// from the underlying reader.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::io::{AsyncReadExt, Cursor};\n    ///\n    /// let reader = Cursor::new(&b\"12345678\"[..]);\n    /// let mut buffer = [0; 5];\n    ///\n    /// let mut take = reader.take(4);\n    /// let n = take.read(&mut buffer).await?;\n    ///\n    /// assert_eq!(n, 4);\n    /// assert_eq!(&buffer, b\"1234\\0\");\n    /// # Ok::<(), Box<dyn std::error::Error>>(()) }).unwrap();\n    /// ```\n    fn take(self, limit: u64) -> Take<Self>\n    where\n        Self: Sized,\n    {\n        assert_read(Take::new(self, limit))\n    }\n\n    /// Wraps an [`AsyncRead`] in a compatibility wrapper that allows it to be\n    /// used as a futures 0.1 / tokio-io 0.1 `AsyncRead`. If the wrapped type\n    /// implements [`AsyncWrite`] as well, the result will also implement the\n    /// futures 0.1 / tokio 0.1 `AsyncWrite` trait.\n    ///\n    /// Requires the `io-compat` feature to enable.\n    #[cfg(feature = \"io-compat\")]\n    #[cfg_attr(docsrs, doc(cfg(feature = \"io-compat\")))]\n    fn compat(self) -> Compat<Self>\n    where\n        Self: Sized + Unpin,\n    {\n        Compat::new(self)\n    }\n}\n\nimpl<R: AsyncRead + ?Sized> AsyncReadExt for R {}\n\n/// An extension trait which adds utility methods to `AsyncWrite` types.\npub trait AsyncWriteExt: AsyncWrite {\n    /// Creates a future which will entirely flush this `AsyncWrite`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::io::{AllowStdIo, AsyncWriteExt};\n    /// use std::io::{BufWriter, Cursor};\n    ///\n    /// let mut output = vec![0u8; 5];\n    ///\n    /// {\n    ///     let writer = Cursor::new(&mut output);\n    ///     let mut buffered = AllowStdIo::new(BufWriter::new(writer));\n    ///     buffered.write_all(&[1, 2]).await?;\n    ///     buffered.write_all(&[3, 4]).await?;\n    ///     buffered.flush().await?;\n    /// }\n    ///\n    /// assert_eq!(output, [1, 2, 3, 4, 0]);\n    /// # Ok::<(), Box<dyn std::error::Error>>(()) }).unwrap();\n    /// ```\n    fn flush(&mut self) -> Flush<'_, Self>\n    where\n        Self: Unpin,\n    {\n        assert_future::<Result<()>, _>(Flush::new(self))\n    }\n\n    /// Creates a future which will entirely close this `AsyncWrite`.\n    fn close(&mut self) -> Close<'_, Self>\n    where\n        Self: Unpin,\n    {\n        assert_future::<Result<()>, _>(Close::new(self))\n    }\n\n    /// Creates a future which will write bytes from `buf` into the object.\n    ///\n    /// The returned future will resolve to the number of bytes written once the write\n    /// operation is completed.\n    fn write<'a>(&'a mut self, buf: &'a [u8]) -> Write<'a, Self>\n    where\n        Self: Unpin,\n    {\n        assert_future::<Result<usize>, _>(Write::new(self, buf))\n    }\n\n    /// Creates a future which will write bytes from `bufs` into the object using vectored\n    /// IO operations.\n    ///\n    /// The returned future will resolve to the number of bytes written once the write\n    /// operation is completed.\n    fn write_vectored<'a>(&'a mut self, bufs: &'a [IoSlice<'a>]) -> WriteVectored<'a, Self>\n    where\n        Self: Unpin,\n    {\n        assert_future::<Result<usize>, _>(WriteVectored::new(self, bufs))\n    }\n\n    /// Write data into this object.\n    ///\n    /// Creates a future that will write the entire contents of the buffer `buf` into\n    /// this `AsyncWrite`.\n    ///\n    /// The returned future will not complete until all the data has been written.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::io::{AsyncWriteExt, Cursor};\n    ///\n    /// let mut writer = Cursor::new(vec![0u8; 5]);\n    ///\n    /// writer.write_all(&[1, 2, 3, 4]).await?;\n    ///\n    /// assert_eq!(writer.into_inner(), [1, 2, 3, 4, 0]);\n    /// # Ok::<(), Box<dyn std::error::Error>>(()) }).unwrap();\n    /// ```\n    fn write_all<'a>(&'a mut self, buf: &'a [u8]) -> WriteAll<'a, Self>\n    where\n        Self: Unpin,\n    {\n        assert_future::<Result<()>, _>(WriteAll::new(self, buf))\n    }\n\n    /// Attempts to write multiple buffers into this writer.\n    ///\n    /// Creates a future that will write the entire contents of `bufs` into this\n    /// `AsyncWrite` using [vectored writes].\n    ///\n    /// The returned future will not complete until all the data has been\n    /// written.\n    ///\n    /// [vectored writes]: std::io::Write::write_vectored\n    ///\n    /// # Notes\n    ///\n    /// Unlike `io::Write::write_vectored`, this takes a *mutable* reference to\n    /// a slice of `IoSlice`s, not an immutable one. That's because we need to\n    /// modify the slice to keep track of the bytes already written.\n    ///\n    /// Once this futures returns, the contents of `bufs` are unspecified, as\n    /// this depends on how many calls to `write_vectored` were necessary. It is\n    /// best to understand this function as taking ownership of `bufs` and to\n    /// not use `bufs` afterwards. The underlying buffers, to which the\n    /// `IoSlice`s point (but not the `IoSlice`s themselves), are unchanged and\n    /// can be reused.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::io::AsyncWriteExt;\n    /// use futures_util::io::Cursor;\n    /// use std::io::IoSlice;\n    ///\n    /// let mut writer = Cursor::new(Vec::new());\n    /// let bufs = &mut [\n    ///     IoSlice::new(&[1]),\n    ///     IoSlice::new(&[2, 3]),\n    ///     IoSlice::new(&[4, 5, 6]),\n    /// ];\n    ///\n    /// writer.write_all_vectored(bufs).await?;\n    /// // Note: the contents of `bufs` is now unspecified, see the Notes section.\n    ///\n    /// assert_eq!(writer.into_inner(), &[1, 2, 3, 4, 5, 6]);\n    /// # Ok::<(), Box<dyn std::error::Error>>(()) }).unwrap();\n    /// ```\n    #[cfg(feature = \"write-all-vectored\")]\n    fn write_all_vectored<'a>(\n        &'a mut self,\n        bufs: &'a mut [IoSlice<'a>],\n    ) -> WriteAllVectored<'a, Self>\n    where\n        Self: Unpin,\n    {\n        assert_future::<Result<()>, _>(WriteAllVectored::new(self, bufs))\n    }\n\n    /// Wraps an [`AsyncWrite`] in a compatibility wrapper that allows it to be\n    /// used as a futures 0.1 / tokio-io 0.1 `AsyncWrite`.\n    /// Requires the `io-compat` feature to enable.\n    #[cfg(feature = \"io-compat\")]\n    #[cfg_attr(docsrs, doc(cfg(feature = \"io-compat\")))]\n    fn compat_write(self) -> Compat<Self>\n    where\n        Self: Sized + Unpin,\n    {\n        Compat::new(self)\n    }\n\n    /// Allow using an [`AsyncWrite`] as a [`Sink`](futures_sink::Sink)`<Item: AsRef<[u8]>>`.\n    ///\n    /// This adapter produces a sink that will write each value passed to it\n    /// into the underlying writer.\n    ///\n    /// Note that this function consumes the given writer, returning a wrapped\n    /// version.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::io::AsyncWriteExt;\n    /// use futures::stream::{self, StreamExt};\n    ///\n    /// let stream = stream::iter(vec![Ok([1, 2, 3]), Ok([4, 5, 6])]);\n    ///\n    /// let mut writer = vec![];\n    ///\n    /// stream.forward((&mut writer).into_sink()).await?;\n    ///\n    /// assert_eq!(writer, vec![1, 2, 3, 4, 5, 6]);\n    /// # Ok::<(), Box<dyn std::error::Error>>(())\n    /// # })?;\n    /// # Ok::<(), Box<dyn std::error::Error>>(())\n    /// ```\n    #[cfg(feature = \"sink\")]\n    #[cfg_attr(docsrs, doc(cfg(feature = \"sink\")))]\n    fn into_sink<Item: AsRef<[u8]>>(self) -> IntoSink<Self, Item>\n    where\n        Self: Sized,\n    {\n        crate::sink::assert_sink::<Item, Error, _>(IntoSink::new(self))\n    }\n}\n\nimpl<W: AsyncWrite + ?Sized> AsyncWriteExt for W {}\n\n/// An extension trait which adds utility methods to `AsyncSeek` types.\npub trait AsyncSeekExt: AsyncSeek {\n    /// Creates a future which will seek an IO object, and then yield the\n    /// new position in the object and the object itself.\n    ///\n    /// In the case of an error the buffer and the object will be discarded, with\n    /// the error yielded.\n    fn seek(&mut self, pos: SeekFrom) -> Seek<'_, Self>\n    where\n        Self: Unpin,\n    {\n        assert_future::<Result<u64>, _>(Seek::new(self, pos))\n    }\n\n    /// Creates a future which will return the current seek position from the\n    /// start of the stream.\n    ///\n    /// This is equivalent to `self.seek(SeekFrom::Current(0))`.\n    fn stream_position(&mut self) -> Seek<'_, Self>\n    where\n        Self: Unpin,\n    {\n        self.seek(SeekFrom::Current(0))\n    }\n}\n\nimpl<S: AsyncSeek + ?Sized> AsyncSeekExt for S {}\n\n/// An extension trait which adds utility methods to `AsyncBufRead` types.\npub trait AsyncBufReadExt: AsyncBufRead {\n    /// Creates a future which will wait for a non-empty buffer to be available from this I/O\n    /// object or EOF to be reached.\n    ///\n    /// This method is the async equivalent to [`BufRead::fill_buf`](std::io::BufRead::fill_buf).\n    ///\n    /// ```rust\n    /// # futures::executor::block_on(async {\n    /// use futures::{io::AsyncBufReadExt as _, stream::{iter, TryStreamExt as _}};\n    ///\n    /// let mut stream = iter(vec![Ok(vec![1, 2, 3]), Ok(vec![4, 5, 6])]).into_async_read();\n    ///\n    /// assert_eq!(stream.fill_buf().await?, vec![1, 2, 3]);\n    /// stream.consume_unpin(2);\n    ///\n    /// assert_eq!(stream.fill_buf().await?, vec![3]);\n    /// stream.consume_unpin(1);\n    ///\n    /// assert_eq!(stream.fill_buf().await?, vec![4, 5, 6]);\n    /// stream.consume_unpin(3);\n    ///\n    /// assert_eq!(stream.fill_buf().await?, vec![]);\n    /// # Ok::<(), Box<dyn std::error::Error>>(()) }).unwrap();\n    /// ```\n    fn fill_buf(&mut self) -> FillBuf<'_, Self>\n    where\n        Self: Unpin,\n    {\n        assert_future::<Result<&[u8]>, _>(FillBuf::new(self))\n    }\n\n    /// A convenience for calling [`AsyncBufRead::consume`] on [`Unpin`] IO types.\n    ///\n    /// ```rust\n    /// # futures::executor::block_on(async {\n    /// use futures::{io::AsyncBufReadExt as _, stream::{iter, TryStreamExt as _}};\n    ///\n    /// let mut stream = iter(vec![Ok(vec![1, 2, 3])]).into_async_read();\n    ///\n    /// assert_eq!(stream.fill_buf().await?, vec![1, 2, 3]);\n    /// stream.consume_unpin(2);\n    ///\n    /// assert_eq!(stream.fill_buf().await?, vec![3]);\n    /// stream.consume_unpin(1);\n    ///\n    /// assert_eq!(stream.fill_buf().await?, vec![]);\n    /// # Ok::<(), Box<dyn std::error::Error>>(()) }).unwrap();\n    /// ```\n    fn consume_unpin(&mut self, amt: usize)\n    where\n        Self: Unpin,\n    {\n        Pin::new(self).consume(amt)\n    }\n\n    /// Creates a future which will read all the bytes associated with this I/O\n    /// object into `buf` until the delimiter `byte` or EOF is reached.\n    /// This method is the async equivalent to [`BufRead::read_until`](std::io::BufRead::read_until).\n    ///\n    /// This function will read bytes from the underlying stream until the\n    /// delimiter or EOF is found. Once found, all bytes up to, and including,\n    /// the delimiter (if found) will be appended to `buf`.\n    ///\n    /// The returned future will resolve to the number of bytes read once the read\n    /// operation is completed.\n    ///\n    /// In the case of an error the buffer and the object will be discarded, with\n    /// the error yielded.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::io::{AsyncBufReadExt, Cursor};\n    ///\n    /// let mut cursor = Cursor::new(b\"lorem-ipsum\");\n    /// let mut buf = vec![];\n    ///\n    /// // cursor is at 'l'\n    /// let num_bytes = cursor.read_until(b'-', &mut buf).await?;\n    /// assert_eq!(num_bytes, 6);\n    /// assert_eq!(buf, b\"lorem-\");\n    /// buf.clear();\n    ///\n    /// // cursor is at 'i'\n    /// let num_bytes = cursor.read_until(b'-', &mut buf).await?;\n    /// assert_eq!(num_bytes, 5);\n    /// assert_eq!(buf, b\"ipsum\");\n    /// buf.clear();\n    ///\n    /// // cursor is at EOF\n    /// let num_bytes = cursor.read_until(b'-', &mut buf).await?;\n    /// assert_eq!(num_bytes, 0);\n    /// assert_eq!(buf, b\"\");\n    /// # Ok::<(), Box<dyn std::error::Error>>(()) }).unwrap();\n    /// ```\n    fn read_until<'a>(&'a mut self, byte: u8, buf: &'a mut Vec<u8>) -> ReadUntil<'a, Self>\n    where\n        Self: Unpin,\n    {\n        assert_future::<Result<usize>, _>(ReadUntil::new(self, byte, buf))\n    }\n\n    /// Creates a future which will read all the bytes associated with this I/O\n    /// object into `buf` until a newline (the 0xA byte) or EOF is reached,\n    /// This method is the async equivalent to [`BufRead::read_line`](std::io::BufRead::read_line).\n    ///\n    /// This function will read bytes from the underlying stream until the\n    /// newline delimiter (the 0xA byte) or EOF is found. Once found, all bytes\n    /// up to, and including, the delimiter (if found) will be appended to\n    /// `buf`.\n    ///\n    /// The returned future will resolve to the number of bytes read once the read\n    /// operation is completed.\n    ///\n    /// In the case of an error the buffer and the object will be discarded, with\n    /// the error yielded.\n    ///\n    /// # Errors\n    ///\n    /// This function has the same error semantics as [`read_until`] and will\n    /// also return an error if the read bytes are not valid UTF-8. If an I/O\n    /// error is encountered then `buf` may contain some bytes already read in\n    /// the event that all data read so far was valid UTF-8.\n    ///\n    /// [`read_until`]: AsyncBufReadExt::read_until\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::io::{AsyncBufReadExt, Cursor};\n    ///\n    /// let mut cursor = Cursor::new(b\"foo\\nbar\");\n    /// let mut buf = String::new();\n    ///\n    /// // cursor is at 'f'\n    /// let num_bytes = cursor.read_line(&mut buf).await?;\n    /// assert_eq!(num_bytes, 4);\n    /// assert_eq!(buf, \"foo\\n\");\n    /// buf.clear();\n    ///\n    /// // cursor is at 'b'\n    /// let num_bytes = cursor.read_line(&mut buf).await?;\n    /// assert_eq!(num_bytes, 3);\n    /// assert_eq!(buf, \"bar\");\n    /// buf.clear();\n    ///\n    /// // cursor is at EOF\n    /// let num_bytes = cursor.read_line(&mut buf).await?;\n    /// assert_eq!(num_bytes, 0);\n    /// assert_eq!(buf, \"\");\n    /// # Ok::<(), Box<dyn std::error::Error>>(()) }).unwrap();\n    /// ```\n    fn read_line<'a>(&'a mut self, buf: &'a mut String) -> ReadLine<'a, Self>\n    where\n        Self: Unpin,\n    {\n        assert_future::<Result<usize>, _>(ReadLine::new(self, buf))\n    }\n\n    /// Returns a stream over the lines of this reader.\n    /// This method is the async equivalent to [`BufRead::lines`](std::io::BufRead::lines).\n    ///\n    /// The stream returned from this function will yield instances of\n    /// [`io::Result`]`<`[`String`]`>`. Each string returned will *not* have a newline\n    /// byte (the 0xA byte) or CRLF (0xD, 0xA bytes) at the end.\n    ///\n    /// [`io::Result`]: std::io::Result\n    /// [`String`]: String\n    ///\n    /// # Errors\n    ///\n    /// Each line of the stream has the same error semantics as [`AsyncBufReadExt::read_line`].\n    ///\n    /// [`AsyncBufReadExt::read_line`]: AsyncBufReadExt::read_line\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::io::{AsyncBufReadExt, Cursor};\n    /// use futures::stream::StreamExt;\n    ///\n    /// let cursor = Cursor::new(b\"lorem\\nipsum\\xc2\\r\\ndolor\");\n    ///\n    /// let mut lines_stream = cursor.lines().map(|l| l.unwrap_or(String::from(\"invalid UTF_8\")));\n    /// assert_eq!(lines_stream.next().await, Some(String::from(\"lorem\")));\n    /// assert_eq!(lines_stream.next().await, Some(String::from(\"invalid UTF_8\")));\n    /// assert_eq!(lines_stream.next().await, Some(String::from(\"dolor\")));\n    /// assert_eq!(lines_stream.next().await, None);\n    /// # Ok::<(), Box<dyn std::error::Error>>(()) }).unwrap();\n    /// ```\n    fn lines(self) -> Lines<Self>\n    where\n        Self: Sized,\n    {\n        assert_stream::<Result<String>, _>(Lines::new(self))\n    }\n}\n\nimpl<R: AsyncBufRead + ?Sized> AsyncBufReadExt for R {}\n\n// Just a helper function to ensure the reader we're returning all have the\n// right implementations.\npub(crate) fn assert_read<R>(reader: R) -> R\nwhere\n    R: AsyncRead,\n{\n    reader\n}\n// Just a helper function to ensure the writer we're returning all have the\n// right implementations.\npub(crate) fn assert_write<W>(writer: W) -> W\nwhere\n    W: AsyncWrite,\n{\n    writer\n}\n";

},{}],"cpBA8":[function(require,module,exports,__globalThis) {
module.exports = "//! Futures\n//!\n//! This module contains a number of functions for working with `Future`s,\n//! including the `FutureExt` trait which adds methods to `Future` types.\n\nuse crate::fns::{inspect_fn, into_fn, ok_fn, InspectFn, IntoFn, OkFn};\nuse crate::future::{assert_future, Either};\nuse crate::never::Never;\nuse crate::stream::assert_stream;\n#[cfg(feature = \"alloc\")]\nuse alloc::boxed::Box;\nuse core::pin::pin;\nuse core::pin::Pin;\n#[cfg(feature = \"alloc\")]\nuse futures_core::future::{BoxFuture, LocalBoxFuture};\nuse futures_core::{\n    future::Future,\n    stream::Stream,\n    task::{Context, Poll},\n};\n\n// Combinators\n\nmod flatten;\nmod fuse;\nmod map;\n\ndelegate_all!(\n    /// Future for the [`flatten`](super::FutureExt::flatten) method.\n    Flatten<F>(\n        flatten::Flatten<F, <F as Future>::Output>\n    ): Debug + Future + FusedFuture + New[|x: F| flatten::Flatten::new(x)]\n    where F: Future\n);\n\ndelegate_all!(\n    /// Stream for the [`flatten_stream`](FutureExt::flatten_stream) method.\n    FlattenStream<F>(\n        flatten::Flatten<F, <F as Future>::Output>\n    ): Debug + Sink + Stream + FusedStream + New[|x: F| flatten::Flatten::new(x)]\n    where F: Future\n);\n\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use fuse::Fuse;\n\ndelegate_all!(\n    /// Future for the [`map`](super::FutureExt::map) method.\n    Map<Fut, F>(\n        map::Map<Fut, F>\n    ): Debug + Future + FusedFuture + New[|x: Fut, f: F| map::Map::new(x, f)]\n);\n\ndelegate_all!(\n    /// Stream for the [`into_stream`](FutureExt::into_stream) method.\n    IntoStream<F>(\n        crate::stream::Once<F>\n    ): Debug + Stream + FusedStream + New[|x: F| crate::stream::Once::new(x)]\n);\n\ndelegate_all!(\n    /// Future for the [`map_into`](FutureExt::map_into) combinator.\n    MapInto<Fut, T>(\n        Map<Fut, IntoFn<T>>\n    ): Debug + Future + FusedFuture + New[|x: Fut| Map::new(x, into_fn())]\n);\n\ndelegate_all!(\n    /// Future for the [`then`](FutureExt::then) method.\n    Then<Fut1, Fut2, F>(\n        flatten::Flatten<Map<Fut1, F>, Fut2>\n    ): Debug + Future + FusedFuture + New[|x: Fut1, y: F| flatten::Flatten::new(Map::new(x, y))]\n);\n\ndelegate_all!(\n    /// Future for the [`inspect`](FutureExt::inspect) method.\n    Inspect<Fut, F>(\n        map::Map<Fut, InspectFn<F>>\n    ): Debug + Future + FusedFuture + New[|x: Fut, f: F| map::Map::new(x, inspect_fn(f))]\n);\n\ndelegate_all!(\n    /// Future for the [`never_error`](super::FutureExt::never_error) combinator.\n    NeverError<Fut>(\n        Map<Fut, OkFn<Never>>\n    ): Debug + Future + FusedFuture + New[|x: Fut| Map::new(x, ok_fn())]\n);\n\ndelegate_all!(\n    /// Future for the [`unit_error`](super::FutureExt::unit_error) combinator.\n    UnitError<Fut>(\n        Map<Fut, OkFn<()>>\n    ): Debug + Future + FusedFuture + New[|x: Fut| Map::new(x, ok_fn())]\n);\n\n#[cfg(feature = \"std\")]\nmod catch_unwind;\n#[cfg(feature = \"std\")]\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::catch_unwind::CatchUnwind;\n\n#[cfg(feature = \"channel\")]\n#[cfg_attr(docsrs, doc(cfg(feature = \"channel\")))]\n#[cfg(feature = \"std\")]\nmod remote_handle;\n#[cfg(feature = \"channel\")]\n#[cfg_attr(docsrs, doc(cfg(feature = \"channel\")))]\n#[cfg(feature = \"std\")]\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::remote_handle::{Remote, RemoteHandle};\n\n#[cfg(any(feature = \"std\", all(feature = \"alloc\", feature = \"spin\")))]\nmod shared;\n#[cfg(any(feature = \"std\", all(feature = \"alloc\", feature = \"spin\")))]\npub use self::shared::{Shared, WeakShared};\n\nimpl<T: ?Sized> FutureExt for T where T: Future {}\n\n/// An extension trait for `Future`s that provides a variety of convenient\n/// adapters.\npub trait FutureExt: Future {\n    /// Map this future's output to a different type, returning a new future of\n    /// the resulting type.\n    ///\n    /// This function is similar to the `Option::map` or `Iterator::map` where\n    /// it will change the type of the underlying future. This is useful to\n    /// chain along a computation once a future has been resolved.\n    ///\n    /// Note that this function consumes the receiving future and returns a\n    /// wrapped version of it, similar to the existing `map` methods in the\n    /// standard library.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::future::FutureExt;\n    ///\n    /// let future = async { 1 };\n    /// let new_future = future.map(|x| x + 3);\n    /// assert_eq!(new_future.await, 4);\n    /// # });\n    /// ```\n    fn map<U, F>(self, f: F) -> Map<Self, F>\n    where\n        F: FnOnce(Self::Output) -> U,\n        Self: Sized,\n    {\n        assert_future::<U, _>(Map::new(self, f))\n    }\n\n    /// Map this future's output to a different type, returning a new future of\n    /// the resulting type.\n    ///\n    /// This function is equivalent to calling `map(Into::into)` but allows naming\n    /// the return type.\n    fn map_into<U>(self) -> MapInto<Self, U>\n    where\n        Self::Output: Into<U>,\n        Self: Sized,\n    {\n        assert_future::<U, _>(MapInto::new(self))\n    }\n\n    /// Chain on a computation for when a future finished, passing the result of\n    /// the future to the provided closure `f`.\n    ///\n    /// The returned value of the closure must implement the `Future` trait\n    /// and can represent some more work to be done before the composed future\n    /// is finished.\n    ///\n    /// The closure `f` is only run *after* successful completion of the `self`\n    /// future.\n    ///\n    /// Note that this function consumes the receiving future and returns a\n    /// wrapped version of it.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::future::FutureExt;\n    ///\n    /// let future_of_1 = async { 1 };\n    /// let future_of_4 = future_of_1.then(|x| async move { x + 3 });\n    /// assert_eq!(future_of_4.await, 4);\n    /// # });\n    /// ```\n    fn then<Fut, F>(self, f: F) -> Then<Self, Fut, F>\n    where\n        F: FnOnce(Self::Output) -> Fut,\n        Fut: Future,\n        Self: Sized,\n    {\n        assert_future::<Fut::Output, _>(Then::new(self, f))\n    }\n\n    /// Wrap this future in an `Either` future, making it the left-hand variant\n    /// of that `Either`.\n    ///\n    /// This can be used in combination with the `right_future` method to write `if`\n    /// statements that evaluate to different futures in different branches.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::future::FutureExt;\n    ///\n    /// let x = 6;\n    /// let future = if x < 10 {\n    ///     async { true }.left_future()\n    /// } else {\n    ///     async { false }.right_future()\n    /// };\n    ///\n    /// assert_eq!(future.await, true);\n    /// # });\n    /// ```\n    fn left_future<B>(self) -> Either<Self, B>\n    where\n        B: Future<Output = Self::Output>,\n        Self: Sized,\n    {\n        assert_future::<Self::Output, _>(Either::Left(self))\n    }\n\n    /// Wrap this future in an `Either` future, making it the right-hand variant\n    /// of that `Either`.\n    ///\n    /// This can be used in combination with the `left_future` method to write `if`\n    /// statements that evaluate to different futures in different branches.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::future::FutureExt;\n    ///\n    /// let x = 6;\n    /// let future = if x > 10 {\n    ///     async { true }.left_future()\n    /// } else {\n    ///     async { false }.right_future()\n    /// };\n    ///\n    /// assert_eq!(future.await, false);\n    /// # });\n    /// ```\n    fn right_future<A>(self) -> Either<A, Self>\n    where\n        A: Future<Output = Self::Output>,\n        Self: Sized,\n    {\n        assert_future::<Self::Output, _>(Either::Right(self))\n    }\n\n    /// Convert this future into a single element stream.\n    ///\n    /// The returned stream contains single success if this future resolves to\n    /// success or single error if this future resolves into error.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::future::FutureExt;\n    /// use futures::stream::StreamExt;\n    ///\n    /// let future = async { 17 };\n    /// let stream = future.into_stream();\n    /// let collected: Vec<_> = stream.collect().await;\n    /// assert_eq!(collected, vec![17]);\n    /// # });\n    /// ```\n    fn into_stream(self) -> IntoStream<Self>\n    where\n        Self: Sized,\n    {\n        assert_stream::<Self::Output, _>(IntoStream::new(self))\n    }\n\n    /// Flatten the execution of this future when the output of this\n    /// future is itself another future.\n    ///\n    /// This can be useful when combining futures together to flatten the\n    /// computation out the final result.\n    ///\n    /// This method is roughly equivalent to `self.then(|x| x)`.\n    ///\n    /// Note that this function consumes the receiving future and returns a\n    /// wrapped version of it.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::future::FutureExt;\n    ///\n    /// let nested_future = async { async { 1 } };\n    /// let future = nested_future.flatten();\n    /// assert_eq!(future.await, 1);\n    /// # });\n    /// ```\n    fn flatten(self) -> Flatten<Self>\n    where\n        Self::Output: Future,\n        Self: Sized,\n    {\n        let f = Flatten::new(self);\n        assert_future::<<<Self as Future>::Output as Future>::Output, _>(f)\n    }\n\n    /// Flatten the execution of this future when the successful result of this\n    /// future is a stream.\n    ///\n    /// This can be useful when stream initialization is deferred, and it is\n    /// convenient to work with that stream as if stream was available at the\n    /// call site.\n    ///\n    /// Note that this function consumes this future and returns a wrapped\n    /// version of it.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::future::FutureExt;\n    /// use futures::stream::{self, StreamExt};\n    ///\n    /// let stream_items = vec![17, 18, 19];\n    /// let future_of_a_stream = async { stream::iter(stream_items) };\n    ///\n    /// let stream = future_of_a_stream.flatten_stream();\n    /// let list: Vec<_> = stream.collect().await;\n    /// assert_eq!(list, vec![17, 18, 19]);\n    /// # });\n    /// ```\n    fn flatten_stream(self) -> FlattenStream<Self>\n    where\n        Self::Output: Stream,\n        Self: Sized,\n    {\n        assert_stream::<<Self::Output as Stream>::Item, _>(FlattenStream::new(self))\n    }\n\n    /// Fuse a future such that `poll` will never again be called once it has\n    /// completed. This method can be used to turn any `Future` into a\n    /// `FusedFuture`.\n    ///\n    /// Normally, once a future has returned `Poll::Ready` from `poll`,\n    /// any further calls could exhibit bad behavior such as blocking\n    /// forever, panicking, never returning, etc. If it is known that `poll`\n    /// may be called too often then this method can be used to ensure that it\n    /// has defined semantics.\n    ///\n    /// If a `fuse`d future is `poll`ed after having returned `Poll::Ready`\n    /// previously, it will return `Poll::Pending`, from `poll` again (and will\n    /// continue to do so for all future calls to `poll`).\n    ///\n    /// This combinator will drop the underlying future as soon as it has been\n    /// completed to ensure resources are reclaimed as soon as possible.\n    fn fuse(self) -> Fuse<Self>\n    where\n        Self: Sized,\n    {\n        let f = Fuse::new(self);\n        assert_future::<Self::Output, _>(f)\n    }\n\n    /// Do something with the output of a future before passing it on.\n    ///\n    /// When using futures, you'll often chain several of them together.  While\n    /// working on such code, you might want to check out what's happening at\n    /// various parts in the pipeline, without consuming the intermediate\n    /// value. To do that, insert a call to `inspect`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::future::FutureExt;\n    ///\n    /// let future = async { 1 };\n    /// let new_future = future.inspect(|&x| println!(\"about to resolve: {}\", x));\n    /// assert_eq!(new_future.await, 1);\n    /// # });\n    /// ```\n    fn inspect<F>(self, f: F) -> Inspect<Self, F>\n    where\n        F: FnOnce(&Self::Output),\n        Self: Sized,\n    {\n        assert_future::<Self::Output, _>(Inspect::new(self, f))\n    }\n\n    /// Catches unwinding panics while polling the future.\n    ///\n    /// In general, panics within a future can propagate all the way out to the\n    /// task level. This combinator makes it possible to halt unwinding within\n    /// the future itself. It's most commonly used within task executors. It's\n    /// not recommended to use this for error handling.\n    ///\n    /// Note that this method requires the `UnwindSafe` bound from the standard\n    /// library. This isn't always applied automatically, and the standard\n    /// library provides an `AssertUnwindSafe` wrapper type to apply it\n    /// after-the fact. To assist using this method, the `Future` trait is also\n    /// implemented for `AssertUnwindSafe<F>` where `F` implements `Future`.\n    ///\n    /// This method is only available when the `std` feature of this\n    /// library is activated, and it is activated by default.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::future::{self, FutureExt, Ready};\n    ///\n    /// let future = future::ready(2);\n    /// assert!(future.catch_unwind().await.is_ok());\n    ///\n    /// let future = future::lazy(|_| -> Ready<i32> {\n    ///     unimplemented!()\n    /// });\n    /// assert!(future.catch_unwind().await.is_err());\n    /// # });\n    /// ```\n    #[cfg(feature = \"std\")]\n    fn catch_unwind(self) -> CatchUnwind<Self>\n    where\n        Self: Sized + ::std::panic::UnwindSafe,\n    {\n        assert_future::<Result<Self::Output, Box<dyn std::any::Any + Send>>, _>(CatchUnwind::new(\n            self,\n        ))\n    }\n\n    /// Create a cloneable handle to this future where all handles will resolve\n    /// to the same result.\n    ///\n    /// The `shared` combinator method provides a method to convert any future\n    /// into a cloneable future. It enables a future to be polled by multiple\n    /// threads.\n    ///\n    /// This method is only available when the `std` or 'spin' feature of this\n    /// library is activated, and it is activated by default.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::future::FutureExt;\n    ///\n    /// let future = async { 6 };\n    /// let shared1 = future.shared();\n    /// let shared2 = shared1.clone();\n    ///\n    /// assert_eq!(6, shared1.await);\n    /// assert_eq!(6, shared2.await);\n    /// # });\n    /// ```\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::future::FutureExt;\n    /// use futures::executor::block_on;\n    /// use std::thread;\n    ///\n    /// let future = async { 6 };\n    /// let shared1 = future.shared();\n    /// let shared2 = shared1.clone();\n    /// let join_handle = thread::spawn(move || {\n    ///     assert_eq!(6, block_on(shared2));\n    /// });\n    /// assert_eq!(6, shared1.await);\n    /// join_handle.join().unwrap();\n    /// # });\n    /// ```\n    #[cfg(any(feature = \"std\", all(feature = \"alloc\", feature = \"spin\")))]\n    fn shared(self) -> Shared<Self>\n    where\n        Self: Sized,\n        Self::Output: Clone,\n    {\n        assert_future::<Self::Output, _>(Shared::new(self))\n    }\n\n    /// Turn this future into a future that yields `()` on completion and sends\n    /// its output to another future on a separate task.\n    ///\n    /// This can be used with spawning executors to easily retrieve the result\n    /// of a future executing on a separate task or thread.\n    ///\n    /// This method is only available when the `std` feature of this\n    /// library is activated, and it is activated by default.\n    #[cfg(feature = \"channel\")]\n    #[cfg_attr(docsrs, doc(cfg(feature = \"channel\")))]\n    #[cfg(feature = \"std\")]\n    fn remote_handle(self) -> (Remote<Self>, RemoteHandle<Self::Output>)\n    where\n        Self: Sized,\n    {\n        let (wrapped, handle) = remote_handle::remote_handle(self);\n        (assert_future::<(), _>(wrapped), handle)\n    }\n\n    /// Wrap the future in a Box, pinning it.\n    ///\n    /// This method is only available when the `std` or `alloc` feature of this\n    /// library is activated, and it is activated by default.\n    #[cfg(feature = \"alloc\")]\n    fn boxed<'a>(self) -> BoxFuture<'a, Self::Output>\n    where\n        Self: Sized + Send + 'a,\n    {\n        assert_future::<Self::Output, _>(Box::pin(self))\n    }\n\n    /// Wrap the future in a Box, pinning it.\n    ///\n    /// Similar to `boxed`, but without the `Send` requirement.\n    ///\n    /// This method is only available when the `std` or `alloc` feature of this\n    /// library is activated, and it is activated by default.\n    #[cfg(feature = \"alloc\")]\n    fn boxed_local<'a>(self) -> LocalBoxFuture<'a, Self::Output>\n    where\n        Self: Sized + 'a,\n    {\n        assert_future::<Self::Output, _>(Box::pin(self))\n    }\n\n    /// Turns a [`Future<Output = T>`](Future) into a\n    /// [`TryFuture<Ok = T, Error = ()`>](futures_core::future::TryFuture).\n    fn unit_error(self) -> UnitError<Self>\n    where\n        Self: Sized,\n    {\n        assert_future::<Result<Self::Output, ()>, _>(UnitError::new(self))\n    }\n\n    /// Turns a [`Future<Output = T>`](Future) into a\n    /// [`TryFuture<Ok = T, Error = Never`>](futures_core::future::TryFuture).\n    fn never_error(self) -> NeverError<Self>\n    where\n        Self: Sized,\n    {\n        assert_future::<Result<Self::Output, Never>, _>(NeverError::new(self))\n    }\n\n    /// A convenience for calling `Future::poll` on `Unpin` future types.\n    fn poll_unpin(&mut self, cx: &mut Context<'_>) -> Poll<Self::Output>\n    where\n        Self: Unpin,\n    {\n        Pin::new(self).poll(cx)\n    }\n\n    /// Evaluates and consumes the future, returning the resulting output if\n    /// the future is ready after the first call to `Future::poll`.\n    ///\n    /// If `poll` instead returns `Poll::Pending`, `None` is returned.\n    ///\n    /// This method is useful in cases where immediacy is more important than\n    /// waiting for a result. It is also convenient for quickly obtaining\n    /// the value of a future that is known to always resolve immediately.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # use futures::prelude::*;\n    /// use futures::{future::ready, future::pending};\n    /// let future_ready = ready(\"foobar\");\n    /// let future_pending = pending::<&'static str>();\n    ///\n    /// assert_eq!(future_ready.now_or_never(), Some(\"foobar\"));\n    /// assert_eq!(future_pending.now_or_never(), None);\n    /// ```\n    ///\n    /// In cases where it is absolutely known that a future should always\n    /// resolve immediately and never return `Poll::Pending`, this method can\n    /// be combined with `expect()`:\n    ///\n    /// ```\n    /// # use futures::{prelude::*, future::ready};\n    /// let future_ready = ready(\"foobar\");\n    ///\n    /// assert_eq!(future_ready.now_or_never().expect(\"Future not ready\"), \"foobar\");\n    /// ```\n    fn now_or_never(self) -> Option<Self::Output>\n    where\n        Self: Sized,\n    {\n        let noop_waker = crate::task::noop_waker();\n        let mut cx = Context::from_waker(&noop_waker);\n\n        let this = pin!(self);\n        match this.poll(&mut cx) {\n            Poll::Ready(x) => Some(x),\n            _ => None,\n        }\n    }\n}\n";

},{}],"d7KkU":[function(require,module,exports,__globalThis) {
module.exports = "//! Futures\n//!\n//! This module contains a number of functions for working with `Future`s,\n//! including the `FutureExt` trait which adds methods to `Future` types.\n\n#[cfg(feature = \"compat\")]\nuse crate::compat::Compat;\nuse core::pin::Pin;\nuse futures_core::{\n    future::TryFuture,\n    stream::TryStream,\n    task::{Context, Poll},\n};\n#[cfg(feature = \"sink\")]\nuse futures_sink::Sink;\n\nuse crate::fns::{\n    inspect_err_fn, inspect_ok_fn, into_fn, map_err_fn, map_ok_fn, map_ok_or_else_fn,\n    unwrap_or_else_fn, InspectErrFn, InspectOkFn, IntoFn, MapErrFn, MapOkFn, MapOkOrElseFn,\n    UnwrapOrElseFn,\n};\nuse crate::future::{assert_future, Inspect, Map};\nuse crate::stream::assert_stream;\n\n// Combinators\nmod into_future;\nmod try_flatten;\nmod try_flatten_err;\n\ndelegate_all!(\n    /// Future for the [`try_flatten`](TryFutureExt::try_flatten) method.\n    TryFlatten<Fut1, Fut2>(\n        try_flatten::TryFlatten<Fut1, Fut2>\n    ): Debug + Future + FusedFuture + New[|x: Fut1| try_flatten::TryFlatten::new(x)]\n);\n\ndelegate_all!(\n    /// Future for the [`try_flatten_err`](TryFutureExt::try_flatten_err) method.\n    TryFlattenErr<Fut1, Fut2>(\n        try_flatten_err::TryFlattenErr<Fut1, Fut2>\n    ): Debug + Future + FusedFuture + New[|x: Fut1| try_flatten_err::TryFlattenErr::new(x)]\n);\n\ndelegate_all!(\n    /// Future for the [`try_flatten_stream`](TryFutureExt::try_flatten_stream) method.\n    TryFlattenStream<Fut>(\n        try_flatten::TryFlatten<Fut, Fut::Ok>\n    ): Debug + Sink + Stream + FusedStream + New[|x: Fut| try_flatten::TryFlatten::new(x)]\n    where Fut: TryFuture\n);\n\n#[cfg(feature = \"sink\")]\ndelegate_all!(\n    /// Sink for the [`flatten_sink`](TryFutureExt::flatten_sink) method.\n    #[cfg_attr(docsrs, doc(cfg(feature = \"sink\")))]\n    FlattenSink<Fut, Si>(\n        try_flatten::TryFlatten<Fut, Si>\n    ): Debug + Sink + Stream + FusedStream + New[|x: Fut| try_flatten::TryFlatten::new(x)]\n);\n\ndelegate_all!(\n    /// Future for the [`and_then`](TryFutureExt::and_then) method.\n    AndThen<Fut1, Fut2, F>(\n        TryFlatten<MapOk<Fut1, F>, Fut2>\n    ): Debug + Future + FusedFuture + New[|x: Fut1, f: F| TryFlatten::new(MapOk::new(x, f))]\n);\n\ndelegate_all!(\n    /// Future for the [`or_else`](TryFutureExt::or_else) method.\n    OrElse<Fut1, Fut2, F>(\n        TryFlattenErr<MapErr<Fut1, F>, Fut2>\n    ): Debug + Future + FusedFuture + New[|x: Fut1, f: F| TryFlattenErr::new(MapErr::new(x, f))]\n);\n\ndelegate_all!(\n    /// Future for the [`err_into`](TryFutureExt::err_into) method.\n    ErrInto<Fut, E>(\n        MapErr<Fut, IntoFn<E>>\n    ): Debug + Future + FusedFuture + New[|x: Fut| MapErr::new(x, into_fn())]\n);\n\ndelegate_all!(\n    /// Future for the [`ok_into`](TryFutureExt::ok_into) method.\n    OkInto<Fut, E>(\n        MapOk<Fut, IntoFn<E>>\n    ): Debug + Future + FusedFuture + New[|x: Fut| MapOk::new(x, into_fn())]\n);\n\ndelegate_all!(\n    /// Future for the [`inspect_ok`](super::TryFutureExt::inspect_ok) method.\n    InspectOk<Fut, F>(\n        Inspect<IntoFuture<Fut>, InspectOkFn<F>>\n    ): Debug + Future + FusedFuture + New[|x: Fut, f: F| Inspect::new(IntoFuture::new(x), inspect_ok_fn(f))]\n);\n\ndelegate_all!(\n    /// Future for the [`inspect_err`](super::TryFutureExt::inspect_err) method.\n    InspectErr<Fut, F>(\n        Inspect<IntoFuture<Fut>, InspectErrFn<F>>\n    ): Debug + Future + FusedFuture + New[|x: Fut, f: F| Inspect::new(IntoFuture::new(x), inspect_err_fn(f))]\n);\n\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::into_future::IntoFuture;\n\ndelegate_all!(\n    /// Future for the [`map_ok`](TryFutureExt::map_ok) method.\n    MapOk<Fut, F>(\n        Map<IntoFuture<Fut>, MapOkFn<F>>\n    ): Debug + Future + FusedFuture + New[|x: Fut, f: F| Map::new(IntoFuture::new(x), map_ok_fn(f))]\n);\n\ndelegate_all!(\n    /// Future for the [`map_err`](TryFutureExt::map_err) method.\n    MapErr<Fut, F>(\n        Map<IntoFuture<Fut>, MapErrFn<F>>\n    ): Debug + Future + FusedFuture + New[|x: Fut, f: F| Map::new(IntoFuture::new(x), map_err_fn(f))]\n);\n\ndelegate_all!(\n    /// Future for the [`map_ok_or_else`](TryFutureExt::map_ok_or_else) method.\n    MapOkOrElse<Fut, F, G>(\n        Map<IntoFuture<Fut>, MapOkOrElseFn<F, G>>\n    ): Debug + Future + FusedFuture + New[|x: Fut, f: F, g: G| Map::new(IntoFuture::new(x), map_ok_or_else_fn(f, g))]\n);\n\ndelegate_all!(\n    /// Future for the [`unwrap_or_else`](TryFutureExt::unwrap_or_else) method.\n    UnwrapOrElse<Fut, F>(\n        Map<IntoFuture<Fut>, UnwrapOrElseFn<F>>\n    ): Debug + Future + FusedFuture + New[|x: Fut, f: F| Map::new(IntoFuture::new(x), unwrap_or_else_fn(f))]\n);\n\nimpl<Fut: ?Sized + TryFuture> TryFutureExt for Fut {}\n\n/// Adapters specific to [`Result`]-returning futures\npub trait TryFutureExt: TryFuture {\n    /// Flattens the execution of this future when the successful result of this\n    /// future is a [`Sink`].\n    ///\n    /// This can be useful when sink initialization is deferred, and it is\n    /// convenient to work with that sink as if the sink was available at the\n    /// call site.\n    ///\n    /// Note that this function consumes this future and returns a wrapped\n    /// version of it.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// use futures::future::{Future, TryFutureExt};\n    /// use futures::sink::Sink;\n    /// # use futures::channel::mpsc::{self, SendError};\n    /// # type T = i32;\n    /// # type E = SendError;\n    ///\n    /// fn make_sink_async() -> impl Future<Output = Result<\n    ///     impl Sink<T, Error = E>,\n    ///     E,\n    /// >> { // ... }\n    /// # let (tx, _rx) = mpsc::unbounded::<i32>();\n    /// # futures::future::ready(Ok(tx))\n    /// # }\n    /// fn take_sink(sink: impl Sink<T, Error = E>) { /* ... */ }\n    ///\n    /// let fut = make_sink_async();\n    /// take_sink(fut.flatten_sink())\n    /// ```\n    #[cfg(feature = \"sink\")]\n    #[cfg_attr(docsrs, doc(cfg(feature = \"sink\")))]\n    fn flatten_sink<Item>(self) -> FlattenSink<Self, Self::Ok>\n    where\n        Self::Ok: Sink<Item, Error = Self::Error>,\n        Self: Sized,\n    {\n        crate::sink::assert_sink::<Item, Self::Error, _>(FlattenSink::new(self))\n    }\n\n    /// Maps this future's success value to a different value.\n    ///\n    /// This method can be used to change the [`Ok`](TryFuture::Ok) type of the\n    /// future into a different type. It is similar to the [`Result::map`]\n    /// method. You can use this method to chain along a computation once the\n    /// future has been resolved.\n    ///\n    /// The provided closure `f` will only be called if this future is resolved\n    /// to an [`Ok`]. If it resolves to an [`Err`], panics, or is dropped, then\n    /// the provided closure will never be invoked.\n    ///\n    /// Note that this method consumes the future it is called on and returns a\n    /// wrapped version of it.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// use futures::future::TryFutureExt;\n    ///\n    /// # futures::executor::block_on(async {\n    /// let future = async { Ok::<i32, i32>(1) };\n    /// let future = future.map_ok(|x| x + 3);\n    /// assert_eq!(future.await, Ok(4));\n    /// # });\n    /// ```\n    ///\n    /// Calling [`map_ok`](TryFutureExt::map_ok) on an errored future has no\n    /// effect:\n    ///\n    /// ```\n    /// use futures::future::TryFutureExt;\n    ///\n    /// # futures::executor::block_on(async {\n    /// let future = async { Err::<i32, i32>(1) };\n    /// let future = future.map_ok(|x| x + 3);\n    /// assert_eq!(future.await, Err(1));\n    /// # });\n    /// ```\n    fn map_ok<T, F>(self, f: F) -> MapOk<Self, F>\n    where\n        F: FnOnce(Self::Ok) -> T,\n        Self: Sized,\n    {\n        assert_future::<Result<T, Self::Error>, _>(MapOk::new(self, f))\n    }\n\n    /// Maps this future's success value to a different value, and permits for error handling resulting in the same type.\n    ///\n    /// This method can be used to coalesce your [`Ok`](TryFuture::Ok) type and [`Error`](TryFuture::Error) into another type,\n    /// where that type is the same for both outcomes.\n    ///\n    /// The provided closure `f` will only be called if this future is resolved\n    /// to an [`Ok`]. If it resolves to an [`Err`], panics, or is dropped, then\n    /// the provided closure will never be invoked.\n    ///\n    /// The provided closure `e` will only be called if this future is resolved\n    /// to an [`Err`]. If it resolves to an [`Ok`], panics, or is dropped, then\n    /// the provided closure will never be invoked.\n    ///\n    /// Note that this method consumes the future it is called on and returns a\n    /// wrapped version of it.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// use futures::future::TryFutureExt;\n    ///\n    /// # futures::executor::block_on(async {\n    /// let future = async { Ok::<i32, i32>(5) };\n    /// let future = future.map_ok_or_else(|x| x * 2, |x| x + 3);\n    /// assert_eq!(future.await, 8);\n    ///\n    /// let future = async { Err::<i32, i32>(5) };\n    /// let future = future.map_ok_or_else(|x| x * 2, |x| x + 3);\n    /// assert_eq!(future.await, 10);\n    /// # });\n    /// ```\n    ///\n    fn map_ok_or_else<T, E, F>(self, e: E, f: F) -> MapOkOrElse<Self, F, E>\n    where\n        F: FnOnce(Self::Ok) -> T,\n        E: FnOnce(Self::Error) -> T,\n        Self: Sized,\n    {\n        assert_future::<T, _>(MapOkOrElse::new(self, f, e))\n    }\n\n    /// Maps this future's error value to a different value.\n    ///\n    /// This method can be used to change the [`Error`](TryFuture::Error) type\n    /// of the future into a different type. It is similar to the\n    /// [`Result::map_err`] method. You can use this method for example to\n    /// ensure that futures have the same [`Error`](TryFuture::Error) type when\n    /// using [`select!`] or [`join!`].\n    ///\n    /// The provided closure `f` will only be called if this future is resolved\n    /// to an [`Err`]. If it resolves to an [`Ok`], panics, or is dropped, then\n    /// the provided closure will never be invoked.\n    ///\n    /// Note that this method consumes the future it is called on and returns a\n    /// wrapped version of it.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// use futures::future::TryFutureExt;\n    ///\n    /// # futures::executor::block_on(async {\n    /// let future = async { Err::<i32, i32>(1) };\n    /// let future = future.map_err(|x| x + 3);\n    /// assert_eq!(future.await, Err(4));\n    /// # });\n    /// ```\n    ///\n    /// Calling [`map_err`](TryFutureExt::map_err) on a successful future has\n    /// no effect:\n    ///\n    /// ```\n    /// use futures::future::TryFutureExt;\n    ///\n    /// # futures::executor::block_on(async {\n    /// let future = async { Ok::<i32, i32>(1) };\n    /// let future = future.map_err(|x| x + 3);\n    /// assert_eq!(future.await, Ok(1));\n    /// # });\n    /// ```\n    ///\n    /// [`join!`]: crate::join\n    /// [`select!`]: crate::select\n    fn map_err<E, F>(self, f: F) -> MapErr<Self, F>\n    where\n        F: FnOnce(Self::Error) -> E,\n        Self: Sized,\n    {\n        assert_future::<Result<Self::Ok, E>, _>(MapErr::new(self, f))\n    }\n\n    /// Maps this future's [`Error`](TryFuture::Error) to a new error type\n    /// using the [`Into`](std::convert::Into) trait.\n    ///\n    /// This method does for futures what the `?`-operator does for\n    /// [`Result`]: It lets the compiler infer the type of the resulting\n    /// error. Just as [`map_err`](TryFutureExt::map_err), this is useful for\n    /// example to ensure that futures have the same [`Error`](TryFuture::Error)\n    /// type when using [`select!`] or [`join!`].\n    ///\n    /// Note that this method consumes the future it is called on and returns a\n    /// wrapped version of it.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// use futures::future::TryFutureExt;\n    ///\n    /// # futures::executor::block_on(async {\n    /// let future_err_u8 = async { Err::<(), u8>(1) };\n    /// let future_err_i32 = future_err_u8.err_into::<i32>();\n    /// # });\n    /// ```\n    ///\n    /// [`join!`]: crate::join\n    /// [`select!`]: crate::select\n    fn err_into<E>(self) -> ErrInto<Self, E>\n    where\n        Self: Sized,\n        Self::Error: Into<E>,\n    {\n        assert_future::<Result<Self::Ok, E>, _>(ErrInto::new(self))\n    }\n\n    /// Maps this future's [`Ok`](TryFuture::Ok) to a new type\n    /// using the [`Into`](std::convert::Into) trait.\n    fn ok_into<U>(self) -> OkInto<Self, U>\n    where\n        Self: Sized,\n        Self::Ok: Into<U>,\n    {\n        assert_future::<Result<U, Self::Error>, _>(OkInto::new(self))\n    }\n\n    /// Executes another future after this one resolves successfully. The\n    /// success value is passed to a closure to create this subsequent future.\n    ///\n    /// The provided closure `f` will only be called if this future is resolved\n    /// to an [`Ok`]. If this future resolves to an [`Err`], panics, or is\n    /// dropped, then the provided closure will never be invoked. The\n    /// [`Error`](TryFuture::Error) type of this future and the future\n    /// returned by `f` have to match.\n    ///\n    /// Note that this method consumes the future it is called on and returns a\n    /// wrapped version of it.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// use futures::future::TryFutureExt;\n    ///\n    /// # futures::executor::block_on(async {\n    /// let future = async { Ok::<i32, i32>(1) };\n    /// let future = future.and_then(|x| async move { Ok::<i32, i32>(x + 3) });\n    /// assert_eq!(future.await, Ok(4));\n    /// # });\n    /// ```\n    ///\n    /// Calling [`and_then`](TryFutureExt::and_then) on an errored future has no\n    /// effect:\n    ///\n    /// ```\n    /// use futures::future::TryFutureExt;\n    ///\n    /// # futures::executor::block_on(async {\n    /// let future = async { Err::<i32, i32>(1) };\n    /// let future = future.and_then(|x| async move { Err::<i32, i32>(x + 3) });\n    /// assert_eq!(future.await, Err(1));\n    /// # });\n    /// ```\n    fn and_then<Fut, F>(self, f: F) -> AndThen<Self, Fut, F>\n    where\n        F: FnOnce(Self::Ok) -> Fut,\n        Fut: TryFuture<Error = Self::Error>,\n        Self: Sized,\n    {\n        assert_future::<Result<Fut::Ok, Fut::Error>, _>(AndThen::new(self, f))\n    }\n\n    /// Executes another future if this one resolves to an error. The\n    /// error value is passed to a closure to create this subsequent future.\n    ///\n    /// The provided closure `f` will only be called if this future is resolved\n    /// to an [`Err`]. If this future resolves to an [`Ok`], panics, or is\n    /// dropped, then the provided closure will never be invoked. The\n    /// [`Ok`](TryFuture::Ok) type of this future and the future returned by `f`\n    /// have to match.\n    ///\n    /// Note that this method consumes the future it is called on and returns a\n    /// wrapped version of it.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// use futures::future::TryFutureExt;\n    ///\n    /// # futures::executor::block_on(async {\n    /// let future = async { Err::<i32, i32>(1) };\n    /// let future = future.or_else(|x| async move { Err::<i32, i32>(x + 3) });\n    /// assert_eq!(future.await, Err(4));\n    /// # });\n    /// ```\n    ///\n    /// Calling [`or_else`](TryFutureExt::or_else) on a successful future has\n    /// no effect:\n    ///\n    /// ```\n    /// use futures::future::TryFutureExt;\n    ///\n    /// # futures::executor::block_on(async {\n    /// let future = async { Ok::<i32, i32>(1) };\n    /// let future = future.or_else(|x| async move { Ok::<i32, i32>(x + 3) });\n    /// assert_eq!(future.await, Ok(1));\n    /// # });\n    /// ```\n    fn or_else<Fut, F>(self, f: F) -> OrElse<Self, Fut, F>\n    where\n        F: FnOnce(Self::Error) -> Fut,\n        Fut: TryFuture<Ok = Self::Ok>,\n        Self: Sized,\n    {\n        assert_future::<Result<Fut::Ok, Fut::Error>, _>(OrElse::new(self, f))\n    }\n\n    /// Do something with the success value of a future before passing it on.\n    ///\n    /// When using futures, you'll often chain several of them together.  While\n    /// working on such code, you might want to check out what's happening at\n    /// various parts in the pipeline, without consuming the intermediate\n    /// value. To do that, insert a call to `inspect_ok`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::future::TryFutureExt;\n    ///\n    /// let future = async { Ok::<_, ()>(1) };\n    /// let new_future = future.inspect_ok(|&x| println!(\"about to resolve: {}\", x));\n    /// assert_eq!(new_future.await, Ok(1));\n    /// # });\n    /// ```\n    fn inspect_ok<F>(self, f: F) -> InspectOk<Self, F>\n    where\n        F: FnOnce(&Self::Ok),\n        Self: Sized,\n    {\n        assert_future::<Result<Self::Ok, Self::Error>, _>(InspectOk::new(self, f))\n    }\n\n    /// Do something with the error value of a future before passing it on.\n    ///\n    /// When using futures, you'll often chain several of them together.  While\n    /// working on such code, you might want to check out what's happening at\n    /// various parts in the pipeline, without consuming the intermediate\n    /// value. To do that, insert a call to `inspect_err`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::future::TryFutureExt;\n    ///\n    /// let future = async { Err::<(), _>(1) };\n    /// let new_future = future.inspect_err(|&x| println!(\"about to error: {}\", x));\n    /// assert_eq!(new_future.await, Err(1));\n    /// # });\n    /// ```\n    fn inspect_err<F>(self, f: F) -> InspectErr<Self, F>\n    where\n        F: FnOnce(&Self::Error),\n        Self: Sized,\n    {\n        assert_future::<Result<Self::Ok, Self::Error>, _>(InspectErr::new(self, f))\n    }\n\n    /// Flatten the execution of this future when the successful result of this\n    /// future is another future.\n    ///\n    /// This is equivalent to `future.and_then(|x| x)`.\n    fn try_flatten(self) -> TryFlatten<Self, Self::Ok>\n    where\n        Self::Ok: TryFuture<Error = Self::Error>,\n        Self: Sized,\n    {\n        assert_future::<Result<<Self::Ok as TryFuture>::Ok, Self::Error>, _>(TryFlatten::new(self))\n    }\n\n    /// Flatten the execution of this future when the successful result of this\n    /// future is a stream.\n    ///\n    /// This can be useful when stream initialization is deferred, and it is\n    /// convenient to work with that stream as if stream was available at the\n    /// call site.\n    ///\n    /// Note that this function consumes this future and returns a wrapped\n    /// version of it.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::future::TryFutureExt;\n    /// use futures::stream::{self, TryStreamExt};\n    ///\n    /// let stream_items = vec![17, 18, 19].into_iter().map(Ok);\n    /// let future_of_a_stream = async { Ok::<_, ()>(stream::iter(stream_items)) };\n    ///\n    /// let stream = future_of_a_stream.try_flatten_stream();\n    /// let list = stream.try_collect::<Vec<_>>().await;\n    /// assert_eq!(list, Ok(vec![17, 18, 19]));\n    /// # });\n    /// ```\n    fn try_flatten_stream(self) -> TryFlattenStream<Self>\n    where\n        Self::Ok: TryStream<Error = Self::Error>,\n        Self: Sized,\n    {\n        assert_stream::<Result<<Self::Ok as TryStream>::Ok, Self::Error>, _>(TryFlattenStream::new(\n            self,\n        ))\n    }\n\n    /// Unwraps this future's output, producing a future with this future's\n    /// [`Ok`](TryFuture::Ok) type as its\n    /// [`Output`](std::future::Future::Output) type.\n    ///\n    /// If this future is resolved successfully, the returned future will\n    /// contain the original future's success value as output. Otherwise, the\n    /// closure `f` is called with the error value to produce an alternate\n    /// success value.\n    ///\n    /// This method is similar to the [`Result::unwrap_or_else`] method.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// use futures::future::TryFutureExt;\n    ///\n    /// # futures::executor::block_on(async {\n    /// let future = async { Err::<(), &str>(\"Boom!\") };\n    /// let future = future.unwrap_or_else(|_| ());\n    /// assert_eq!(future.await, ());\n    /// # });\n    /// ```\n    fn unwrap_or_else<F>(self, f: F) -> UnwrapOrElse<Self, F>\n    where\n        Self: Sized,\n        F: FnOnce(Self::Error) -> Self::Ok,\n    {\n        assert_future::<Self::Ok, _>(UnwrapOrElse::new(self, f))\n    }\n\n    /// Wraps a [`TryFuture`] into a future compatible with libraries using\n    /// futures 0.1 future definitions. Requires the `compat` feature to enable.\n    #[cfg(feature = \"compat\")]\n    #[cfg_attr(docsrs, doc(cfg(feature = \"compat\")))]\n    fn compat(self) -> Compat<Self>\n    where\n        Self: Sized + Unpin,\n    {\n        Compat::new(self)\n    }\n\n    /// Wraps a [`TryFuture`] into a type that implements\n    /// [`Future`](std::future::Future).\n    ///\n    /// [`TryFuture`]s currently do not implement the\n    /// [`Future`](std::future::Future) trait due to limitations of the\n    /// compiler.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// use futures::future::{Future, TryFuture, TryFutureExt};\n    ///\n    /// # type T = i32;\n    /// # type E = ();\n    /// fn make_try_future() -> impl TryFuture<Ok = T, Error = E> { // ... }\n    /// # async { Ok::<i32, ()>(1) }\n    /// # }\n    /// fn take_future(future: impl Future<Output = Result<T, E>>) { /* ... */ }\n    ///\n    /// take_future(make_try_future().into_future());\n    /// ```\n    fn into_future(self) -> IntoFuture<Self>\n    where\n        Self: Sized,\n    {\n        assert_future::<Result<Self::Ok, Self::Error>, _>(IntoFuture::new(self))\n    }\n\n    /// A convenience method for calling [`TryFuture::try_poll`] on [`Unpin`]\n    /// future types.\n    fn try_poll_unpin(&mut self, cx: &mut Context<'_>) -> Poll<Result<Self::Ok, Self::Error>>\n    where\n        Self: Unpin,\n    {\n        Pin::new(self).try_poll(cx)\n    }\n}\n";

},{}],"i2MCQ":[function(require,module,exports,__globalThis) {
module.exports = "//! Streams\n//!\n//! This module contains a number of functions for working with `Stream`s,\n//! including the `StreamExt` trait which adds methods to `Stream` types.\n\nuse crate::future::{assert_future, Either};\nuse crate::stream::assert_stream;\n#[cfg(feature = \"alloc\")]\nuse alloc::boxed::Box;\n#[cfg(feature = \"alloc\")]\nuse alloc::vec::Vec;\nuse core::pin::Pin;\n#[cfg(feature = \"sink\")]\nuse futures_core::stream::TryStream;\n#[cfg(feature = \"alloc\")]\nuse futures_core::stream::{BoxStream, LocalBoxStream};\nuse futures_core::{\n    future::Future,\n    stream::{FusedStream, Stream},\n    task::{Context, Poll},\n};\n#[cfg(feature = \"sink\")]\nuse futures_sink::Sink;\n\nuse crate::fns::{inspect_fn, InspectFn};\n\nmod chain;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::chain::Chain;\n\nmod collect;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::collect::Collect;\n\nmod unzip;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::unzip::Unzip;\n\nmod concat;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::concat::Concat;\n\nmod count;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::count::Count;\n\nmod cycle;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::cycle::Cycle;\n\nmod enumerate;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::enumerate::Enumerate;\n\nmod filter;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::filter::Filter;\n\nmod filter_map;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::filter_map::FilterMap;\n\nmod flatten;\n\ndelegate_all!(\n    /// Stream for the [`flatten`](StreamExt::flatten) method.\n    Flatten<St>(\n        flatten::Flatten<St, St::Item>\n    ): Debug + Sink + Stream + FusedStream + AccessInner[St, (.)] + New[|x: St| flatten::Flatten::new(x)]\n    where St: Stream\n);\n\nmod fold;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::fold::Fold;\n\nmod any;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::any::Any;\n\nmod all;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::all::All;\n\n#[cfg(feature = \"sink\")]\nmod forward;\n\n#[cfg(feature = \"sink\")]\ndelegate_all!(\n    /// Future for the [`forward`](super::StreamExt::forward) method.\n    #[cfg_attr(docsrs, doc(cfg(feature = \"sink\")))]\n    Forward<St, Si>(\n        forward::Forward<St, Si, St::Ok>\n    ): Debug + Future + FusedFuture + New[|x: St, y: Si| forward::Forward::new(x, y)]\n    where St: TryStream\n);\n\nmod for_each;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::for_each::ForEach;\n\nmod fuse;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::fuse::Fuse;\n\nmod into_future;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::into_future::StreamFuture;\n\ndelegate_all!(\n    /// Stream for the [`inspect`](StreamExt::inspect) method.\n    Inspect<St, F>(\n        map::Map<St, InspectFn<F>>\n    ): Debug + Sink + Stream + FusedStream + AccessInner[St, (.)] + New[|x: St, f: F| map::Map::new(x, inspect_fn(f))]\n);\n\nmod map;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::map::Map;\n\ndelegate_all!(\n    /// Stream for the [`flat_map`](StreamExt::flat_map) method.\n    FlatMap<St, U, F>(\n        flatten::Flatten<Map<St, F>, U>\n    ): Debug + Sink + Stream + FusedStream + AccessInner[St, (. .)] + New[|x: St, f: F| flatten::Flatten::new(Map::new(x, f))]\n);\n\nmod next;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::next::Next;\n\nmod select_next_some;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::select_next_some::SelectNextSome;\n\nmod peek;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::peek::{NextIf, NextIfEq, Peek, PeekMut, Peekable};\n\nmod skip;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::skip::Skip;\n\nmod skip_while;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::skip_while::SkipWhile;\n\nmod take;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::take::Take;\n\nmod take_while;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::take_while::TakeWhile;\n\nmod take_until;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::take_until::TakeUntil;\n\nmod then;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::then::Then;\n\nmod zip;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::zip::Zip;\n\n#[cfg(feature = \"alloc\")]\nmod chunks;\n#[cfg(feature = \"alloc\")]\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::chunks::Chunks;\n\n#[cfg(feature = \"alloc\")]\nmod ready_chunks;\n#[cfg(feature = \"alloc\")]\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::ready_chunks::ReadyChunks;\n\nmod scan;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::scan::Scan;\n\n#[cfg_attr(target_os = \"none\", cfg(target_has_atomic = \"ptr\"))]\n#[cfg(feature = \"alloc\")]\nmod buffer_unordered;\n#[cfg_attr(target_os = \"none\", cfg(target_has_atomic = \"ptr\"))]\n#[cfg(feature = \"alloc\")]\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::buffer_unordered::BufferUnordered;\n\n#[cfg_attr(target_os = \"none\", cfg(target_has_atomic = \"ptr\"))]\n#[cfg(feature = \"alloc\")]\nmod buffered;\n#[cfg_attr(target_os = \"none\", cfg(target_has_atomic = \"ptr\"))]\n#[cfg(feature = \"alloc\")]\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::buffered::Buffered;\n\n#[cfg_attr(target_os = \"none\", cfg(target_has_atomic = \"ptr\"))]\n#[cfg(feature = \"alloc\")]\npub(crate) mod flatten_unordered;\n\n#[cfg_attr(target_os = \"none\", cfg(target_has_atomic = \"ptr\"))]\n#[cfg(feature = \"alloc\")]\n#[allow(unreachable_pub)]\npub use self::flatten_unordered::FlattenUnordered;\n\n#[cfg_attr(target_os = \"none\", cfg(target_has_atomic = \"ptr\"))]\n#[cfg(feature = \"alloc\")]\ndelegate_all!(\n    /// Stream for the [`flat_map_unordered`](StreamExt::flat_map_unordered) method.\n    FlatMapUnordered<St, U, F>(\n        FlattenUnordered<Map<St, F>>\n    ): Debug + Sink + Stream + FusedStream + AccessInner[St, (. .)] + New[|x: St, limit: Option<usize>, f: F| FlattenUnordered::new(Map::new(x, f), limit)]\n    where St: Stream, U: Stream, U: Unpin, F: FnMut(St::Item) -> U\n);\n\n#[cfg_attr(target_os = \"none\", cfg(target_has_atomic = \"ptr\"))]\n#[cfg(feature = \"alloc\")]\nmod for_each_concurrent;\n#[cfg_attr(target_os = \"none\", cfg(target_has_atomic = \"ptr\"))]\n#[cfg(feature = \"alloc\")]\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::for_each_concurrent::ForEachConcurrent;\n\n#[cfg_attr(target_os = \"none\", cfg(target_has_atomic = \"ptr\"))]\n#[cfg(feature = \"sink\")]\n#[cfg_attr(docsrs, doc(cfg(feature = \"sink\")))]\n#[cfg(feature = \"alloc\")]\nmod split;\n#[cfg_attr(target_os = \"none\", cfg(target_has_atomic = \"ptr\"))]\n#[cfg(feature = \"sink\")]\n#[cfg_attr(docsrs, doc(cfg(feature = \"sink\")))]\n#[cfg(feature = \"alloc\")]\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::split::{ReuniteError, SplitSink, SplitStream};\n\n#[cfg(feature = \"std\")]\nmod catch_unwind;\n#[cfg(feature = \"std\")]\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::catch_unwind::CatchUnwind;\n\nimpl<T: ?Sized> StreamExt for T where T: Stream {}\n\n/// An extension trait for `Stream`s that provides a variety of convenient\n/// combinator functions.\npub trait StreamExt: Stream {\n    /// Creates a future that resolves to the next item in the stream.\n    ///\n    /// Note that because `next` doesn't take ownership over the stream,\n    /// the [`Stream`] type must be [`Unpin`]. If you want to use `next` with a\n    /// [`!Unpin`](Unpin) stream, you'll first have to pin the stream. This can\n    /// be done by boxing the stream using [`Box::pin`] or\n    /// pinning it to the stack using the `pin_mut!` macro from the `pin_utils`\n    /// crate.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::stream::{self, StreamExt};\n    ///\n    /// let mut stream = stream::iter(1..=3);\n    ///\n    /// assert_eq!(stream.next().await, Some(1));\n    /// assert_eq!(stream.next().await, Some(2));\n    /// assert_eq!(stream.next().await, Some(3));\n    /// assert_eq!(stream.next().await, None);\n    /// # });\n    /// ```\n    fn next(&mut self) -> Next<'_, Self>\n    where\n        Self: Unpin,\n    {\n        assert_future::<Option<Self::Item>, _>(Next::new(self))\n    }\n\n    /// Converts this stream into a future of `(next_item, tail_of_stream)`.\n    /// If the stream terminates, then the next item is [`None`].\n    ///\n    /// The returned future can be used to compose streams and futures together\n    /// by placing everything into the \"world of futures\".\n    ///\n    /// Note that because `into_future` moves the stream, the [`Stream`] type\n    /// must be [`Unpin`]. If you want to use `into_future` with a\n    /// [`!Unpin`](Unpin) stream, you'll first have to pin the stream. This can\n    /// be done by boxing the stream using [`Box::pin`] or\n    /// pinning it to the stack using the `pin_mut!` macro from the `pin_utils`\n    /// crate.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::stream::{self, StreamExt};\n    ///\n    /// let stream = stream::iter(1..=3);\n    ///\n    /// let (item, stream) = stream.into_future().await;\n    /// assert_eq!(Some(1), item);\n    ///\n    /// let (item, stream) = stream.into_future().await;\n    /// assert_eq!(Some(2), item);\n    /// # });\n    /// ```\n    fn into_future(self) -> StreamFuture<Self>\n    where\n        Self: Sized + Unpin,\n    {\n        assert_future::<(Option<Self::Item>, Self), _>(StreamFuture::new(self))\n    }\n\n    /// Maps this stream's items to a different type, returning a new stream of\n    /// the resulting type.\n    ///\n    /// The provided closure is executed over all elements of this stream as\n    /// they are made available. It is executed inline with calls to\n    /// [`poll_next`](Stream::poll_next).\n    ///\n    /// Note that this function consumes the stream passed into it and returns a\n    /// wrapped version of it, similar to the existing `map` methods in the\n    /// standard library.\n    ///\n    /// See [`StreamExt::then`](Self::then) if you want to use a closure that\n    /// returns a future instead of a value.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::stream::{self, StreamExt};\n    ///\n    /// let stream = stream::iter(1..=3);\n    /// let stream = stream.map(|x| x + 3);\n    ///\n    /// assert_eq!(vec![4, 5, 6], stream.collect::<Vec<_>>().await);\n    /// # });\n    /// ```\n    fn map<T, F>(self, f: F) -> Map<Self, F>\n    where\n        F: FnMut(Self::Item) -> T,\n        Self: Sized,\n    {\n        assert_stream::<T, _>(Map::new(self, f))\n    }\n\n    /// Creates a stream which gives the current iteration count as well as\n    /// the next value.\n    ///\n    /// The stream returned yields pairs `(i, val)`, where `i` is the\n    /// current index of iteration and `val` is the value returned by the\n    /// stream.\n    ///\n    /// `enumerate()` keeps its count as a [`usize`]. If you want to count by a\n    /// different sized integer, the [`zip`](StreamExt::zip) function provides similar\n    /// functionality.\n    ///\n    /// # Overflow Behavior\n    ///\n    /// The method does no guarding against overflows, so enumerating more than\n    /// [`usize::MAX`] elements either produces the wrong result or panics. If\n    /// debug assertions are enabled, a panic is guaranteed.\n    ///\n    /// # Panics\n    ///\n    /// The returned stream might panic if the to-be-returned index would\n    /// overflow a [`usize`].\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::stream::{self, StreamExt};\n    ///\n    /// let stream = stream::iter(vec!['a', 'b', 'c']);\n    ///\n    /// let mut stream = stream.enumerate();\n    ///\n    /// assert_eq!(stream.next().await, Some((0, 'a')));\n    /// assert_eq!(stream.next().await, Some((1, 'b')));\n    /// assert_eq!(stream.next().await, Some((2, 'c')));\n    /// assert_eq!(stream.next().await, None);\n    /// # });\n    /// ```\n    fn enumerate(self) -> Enumerate<Self>\n    where\n        Self: Sized,\n    {\n        assert_stream::<(usize, Self::Item), _>(Enumerate::new(self))\n    }\n\n    /// Filters the values produced by this stream according to the provided\n    /// asynchronous predicate.\n    ///\n    /// As values of this stream are made available, the provided predicate `f`\n    /// will be run against them. If the predicate returns a `Future` which\n    /// resolves to `true`, then the stream will yield the value, but if the\n    /// predicate returns a `Future` which resolves to `false`, then the value\n    /// will be discarded and the next value will be produced.\n    ///\n    /// Note that this function consumes the stream passed into it and returns a\n    /// wrapped version of it, similar to the existing `filter` methods in the\n    /// standard library.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::future;\n    /// use futures::stream::{self, StreamExt};\n    ///\n    /// let stream = stream::iter(1..=10);\n    /// let events = stream.filter(|x| future::ready(x % 2 == 0));\n    ///\n    /// assert_eq!(vec![2, 4, 6, 8, 10], events.collect::<Vec<_>>().await);\n    /// # });\n    /// ```\n    fn filter<Fut, F>(self, f: F) -> Filter<Self, Fut, F>\n    where\n        F: FnMut(&Self::Item) -> Fut,\n        Fut: Future<Output = bool>,\n        Self: Sized,\n    {\n        assert_stream::<Self::Item, _>(Filter::new(self, f))\n    }\n\n    /// Filters the values produced by this stream while simultaneously mapping\n    /// them to a different type according to the provided asynchronous closure.\n    ///\n    /// As values of this stream are made available, the provided function will\n    /// be run on them. If the future returned by the predicate `f` resolves to\n    /// [`Some(item)`](Some) then the stream will yield the value `item`, but if\n    /// it resolves to [`None`] then the next value will be produced.\n    ///\n    /// Note that this function consumes the stream passed into it and returns a\n    /// wrapped version of it, similar to the existing `filter_map` methods in\n    /// the standard library.\n    ///\n    /// # Examples\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::stream::{self, StreamExt};\n    ///\n    /// let stream = stream::iter(1..=10);\n    /// let events = stream.filter_map(|x| async move {\n    ///     if x % 2 == 0 { Some(x + 1) } else { None }\n    /// });\n    ///\n    /// assert_eq!(vec![3, 5, 7, 9, 11], events.collect::<Vec<_>>().await);\n    /// # });\n    /// ```\n    fn filter_map<Fut, T, F>(self, f: F) -> FilterMap<Self, Fut, F>\n    where\n        F: FnMut(Self::Item) -> Fut,\n        Fut: Future<Output = Option<T>>,\n        Self: Sized,\n    {\n        assert_stream::<T, _>(FilterMap::new(self, f))\n    }\n\n    /// Computes from this stream's items new items of a different type using\n    /// an asynchronous closure.\n    ///\n    /// The provided closure `f` will be called with an `Item` once a value is\n    /// ready, it returns a future which will then be run to completion\n    /// to produce the next value on this stream.\n    ///\n    /// Note that this function consumes the stream passed into it and returns a\n    /// wrapped version of it.\n    ///\n    /// See [`StreamExt::map`](Self::map) if you want to use a closure that\n    /// returns a value instead of a future.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::stream::{self, StreamExt};\n    ///\n    /// let stream = stream::iter(1..=3);\n    /// let stream = stream.then(|x| async move { x + 3 });\n    ///\n    /// assert_eq!(vec![4, 5, 6], stream.collect::<Vec<_>>().await);\n    /// # });\n    /// ```\n    fn then<Fut, F>(self, f: F) -> Then<Self, Fut, F>\n    where\n        F: FnMut(Self::Item) -> Fut,\n        Fut: Future,\n        Self: Sized,\n    {\n        assert_stream::<Fut::Output, _>(Then::new(self, f))\n    }\n\n    /// Transforms a stream into a collection, returning a\n    /// future representing the result of that computation.\n    ///\n    /// The returned future will be resolved when the stream terminates.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::channel::mpsc;\n    /// use futures::stream::StreamExt;\n    /// use std::thread;\n    ///\n    /// let (tx, rx) = mpsc::unbounded();\n    ///\n    /// thread::spawn(move || {\n    ///     for i in 1..=5 {\n    ///         tx.unbounded_send(i).unwrap();\n    ///     }\n    /// });\n    ///\n    /// let output = rx.collect::<Vec<i32>>().await;\n    /// assert_eq!(output, vec![1, 2, 3, 4, 5]);\n    /// # });\n    /// ```\n    fn collect<C: Default + Extend<Self::Item>>(self) -> Collect<Self, C>\n    where\n        Self: Sized,\n    {\n        assert_future::<C, _>(Collect::new(self))\n    }\n\n    /// Converts a stream of pairs into a future, which\n    /// resolves to pair of containers.\n    ///\n    /// `unzip()` produces a future, which resolves to two\n    /// collections: one from the left elements of the pairs,\n    /// and one from the right elements.\n    ///\n    /// The returned future will be resolved when the stream terminates.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::channel::mpsc;\n    /// use futures::stream::StreamExt;\n    /// use std::thread;\n    ///\n    /// let (tx, rx) = mpsc::unbounded();\n    ///\n    /// thread::spawn(move || {\n    ///     tx.unbounded_send((1, 2)).unwrap();\n    ///     tx.unbounded_send((3, 4)).unwrap();\n    ///     tx.unbounded_send((5, 6)).unwrap();\n    /// });\n    ///\n    /// let (o1, o2): (Vec<_>, Vec<_>) = rx.unzip().await;\n    /// assert_eq!(o1, vec![1, 3, 5]);\n    /// assert_eq!(o2, vec![2, 4, 6]);\n    /// # });\n    /// ```\n    fn unzip<A, B, FromA, FromB>(self) -> Unzip<Self, FromA, FromB>\n    where\n        FromA: Default + Extend<A>,\n        FromB: Default + Extend<B>,\n        Self: Sized + Stream<Item = (A, B)>,\n    {\n        assert_future::<(FromA, FromB), _>(Unzip::new(self))\n    }\n\n    /// Concatenate all items of a stream into a single extendable\n    /// destination, returning a future representing the end result.\n    ///\n    /// This combinator will extend the first item with the contents\n    /// of all the subsequent results of the stream. If the stream is\n    /// empty, the default value will be returned.\n    ///\n    /// Works with all collections that implement the\n    /// [`Extend`](std::iter::Extend) trait.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::channel::mpsc;\n    /// use futures::stream::StreamExt;\n    /// use std::thread;\n    ///\n    /// let (tx, rx) = mpsc::unbounded();\n    ///\n    /// thread::spawn(move || {\n    ///     for i in (0..3).rev() {\n    ///         let n = i * 3;\n    ///         tx.unbounded_send(vec![n + 1, n + 2, n + 3]).unwrap();\n    ///     }\n    /// });\n    ///\n    /// let result = rx.concat().await;\n    ///\n    /// assert_eq!(result, vec![7, 8, 9, 4, 5, 6, 1, 2, 3]);\n    /// # });\n    /// ```\n    fn concat(self) -> Concat<Self>\n    where\n        Self: Sized,\n        Self::Item: Extend<<<Self as Stream>::Item as IntoIterator>::Item> + IntoIterator + Default,\n    {\n        assert_future::<Self::Item, _>(Concat::new(self))\n    }\n\n    /// Drives the stream to completion, counting the number of items.\n    ///\n    /// # Overflow Behavior\n    ///\n    /// The method does no guarding against overflows, so counting elements of a\n    /// stream with more than [`usize::MAX`] elements either produces the wrong\n    /// result or panics. If debug assertions are enabled, a panic is guaranteed.\n    ///\n    /// # Panics\n    ///\n    /// This function might panic if the iterator has more than [`usize::MAX`]\n    /// elements.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::stream::{self, StreamExt};\n    ///\n    /// let stream = stream::iter(1..=10);\n    /// let count = stream.count().await;\n    ///\n    /// assert_eq!(count, 10);\n    /// # });\n    /// ```\n    fn count(self) -> Count<Self>\n    where\n        Self: Sized,\n    {\n        assert_future::<usize, _>(Count::new(self))\n    }\n\n    /// Repeats a stream endlessly.\n    ///\n    /// The stream never terminates. Note that you likely want to avoid\n    /// usage of `collect` or such on the returned stream as it will exhaust\n    /// available memory as it tries to just fill up all RAM.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::stream::{self, StreamExt};\n    /// let a = [1, 2, 3];\n    /// let mut s = stream::iter(a.iter()).cycle();\n    ///\n    /// assert_eq!(s.next().await, Some(&1));\n    /// assert_eq!(s.next().await, Some(&2));\n    /// assert_eq!(s.next().await, Some(&3));\n    /// assert_eq!(s.next().await, Some(&1));\n    /// assert_eq!(s.next().await, Some(&2));\n    /// assert_eq!(s.next().await, Some(&3));\n    /// assert_eq!(s.next().await, Some(&1));\n    /// # });\n    /// ```\n    fn cycle(self) -> Cycle<Self>\n    where\n        Self: Sized + Clone,\n    {\n        assert_stream::<Self::Item, _>(Cycle::new(self))\n    }\n\n    /// Execute an accumulating asynchronous computation over a stream,\n    /// collecting all the values into one final result.\n    ///\n    /// This combinator will accumulate all values returned by this stream\n    /// according to the closure provided. The initial state is also provided to\n    /// this method and then is returned again by each execution of the closure.\n    /// Once the entire stream has been exhausted the returned future will\n    /// resolve to this value.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::stream::{self, StreamExt};\n    ///\n    /// let number_stream = stream::iter(0..6);\n    /// let sum = number_stream.fold(0, |acc, x| async move { acc + x });\n    /// assert_eq!(sum.await, 15);\n    /// # });\n    /// ```\n    fn fold<T, Fut, F>(self, init: T, f: F) -> Fold<Self, Fut, T, F>\n    where\n        F: FnMut(T, Self::Item) -> Fut,\n        Fut: Future<Output = T>,\n        Self: Sized,\n    {\n        assert_future::<T, _>(Fold::new(self, f, init))\n    }\n\n    /// Execute predicate over asynchronous stream, and return `true` if any element in stream satisfied a predicate.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::stream::{self, StreamExt};\n    ///\n    /// let number_stream = stream::iter(0..10);\n    /// let contain_three = number_stream.any(|i| async move { i == 3 });\n    /// assert_eq!(contain_three.await, true);\n    /// # });\n    /// ```\n    fn any<Fut, F>(self, f: F) -> Any<Self, Fut, F>\n    where\n        F: FnMut(Self::Item) -> Fut,\n        Fut: Future<Output = bool>,\n        Self: Sized,\n    {\n        assert_future::<bool, _>(Any::new(self, f))\n    }\n\n    /// Execute predicate over asynchronous stream, and return `true` if all element in stream satisfied a predicate.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::stream::{self, StreamExt};\n    ///\n    /// let number_stream = stream::iter(0..10);\n    /// let less_then_twenty = number_stream.all(|i| async move { i < 20 });\n    /// assert_eq!(less_then_twenty.await, true);\n    /// # });\n    /// ```\n    fn all<Fut, F>(self, f: F) -> All<Self, Fut, F>\n    where\n        F: FnMut(Self::Item) -> Fut,\n        Fut: Future<Output = bool>,\n        Self: Sized,\n    {\n        assert_future::<bool, _>(All::new(self, f))\n    }\n\n    /// Flattens a stream of streams into just one continuous stream.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::channel::mpsc;\n    /// use futures::stream::StreamExt;\n    /// use std::thread;\n    ///\n    /// let (tx1, rx1) = mpsc::unbounded();\n    /// let (tx2, rx2) = mpsc::unbounded();\n    /// let (tx3, rx3) = mpsc::unbounded();\n    ///\n    /// thread::spawn(move || {\n    ///     tx1.unbounded_send(1).unwrap();\n    ///     tx1.unbounded_send(2).unwrap();\n    /// });\n    /// thread::spawn(move || {\n    ///     tx2.unbounded_send(3).unwrap();\n    ///     tx2.unbounded_send(4).unwrap();\n    /// });\n    /// thread::spawn(move || {\n    ///     tx3.unbounded_send(rx1).unwrap();\n    ///     tx3.unbounded_send(rx2).unwrap();\n    /// });\n    ///\n    /// let output = rx3.flatten().collect::<Vec<i32>>().await;\n    /// assert_eq!(output, vec![1, 2, 3, 4]);\n    /// # });\n    /// ```\n    fn flatten(self) -> Flatten<Self>\n    where\n        Self::Item: Stream,\n        Self: Sized,\n    {\n        assert_stream::<<Self::Item as Stream>::Item, _>(Flatten::new(self))\n    }\n\n    /// Flattens a stream of streams into just one continuous stream. Polls\n    /// inner streams produced by the base stream concurrently.\n    ///\n    /// The only argument is an optional limit on the number of concurrently\n    /// polled streams. If this limit is not `None`, no more than `limit` streams\n    /// will be polled at the same time. The `limit` argument is of type\n    /// `Into<Option<usize>>`, and so can be provided as either `None`,\n    /// `Some(10)`, or just `10`. Note: a limit of zero is interpreted as\n    /// no limit at all, and will have the same result as passing in `None`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::channel::mpsc;\n    /// use futures::stream::StreamExt;\n    /// use std::thread;\n    ///\n    /// let (tx1, rx1) = mpsc::unbounded();\n    /// let (tx2, rx2) = mpsc::unbounded();\n    /// let (tx3, rx3) = mpsc::unbounded();\n    ///\n    /// thread::spawn(move || {\n    ///     tx1.unbounded_send(1).unwrap();\n    ///     tx1.unbounded_send(2).unwrap();\n    /// });\n    /// thread::spawn(move || {\n    ///     tx2.unbounded_send(3).unwrap();\n    ///     tx2.unbounded_send(4).unwrap();\n    /// });\n    /// thread::spawn(move || {\n    ///     tx3.unbounded_send(rx1).unwrap();\n    ///     tx3.unbounded_send(rx2).unwrap();\n    /// });\n    ///\n    /// let mut output = rx3.flatten_unordered(None).collect::<Vec<i32>>().await;\n    /// output.sort();\n    ///\n    /// assert_eq!(output, vec![1, 2, 3, 4]);\n    /// # });\n    /// ```\n    #[cfg_attr(target_os = \"none\", cfg(target_has_atomic = \"ptr\"))]\n    #[cfg(feature = \"alloc\")]\n    fn flatten_unordered(self, limit: impl Into<Option<usize>>) -> FlattenUnordered<Self>\n    where\n        Self::Item: Stream + Unpin,\n        Self: Sized,\n    {\n        assert_stream::<<Self::Item as Stream>::Item, _>(FlattenUnordered::new(self, limit.into()))\n    }\n\n    /// Maps a stream like [`StreamExt::map`] but flattens nested `Stream`s.\n    ///\n    /// [`StreamExt::map`] is very useful, but if it produces a `Stream` instead,\n    /// you would have to chain combinators like `.map(f).flatten()` while this\n    /// combinator provides ability to write `.flat_map(f)` instead of chaining.\n    ///\n    /// The provided closure which produces inner streams is executed over all elements\n    /// of stream as last inner stream is terminated and next stream item is available.\n    ///\n    /// Note that this function consumes the stream passed into it and returns a\n    /// wrapped version of it, similar to the existing `flat_map` methods in the\n    /// standard library.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::stream::{self, StreamExt};\n    ///\n    /// let stream = stream::iter(1..=3);\n    /// let stream = stream.flat_map(|x| stream::iter(vec![x + 3; x]));\n    ///\n    /// assert_eq!(vec![4, 5, 5, 6, 6, 6], stream.collect::<Vec<_>>().await);\n    /// # });\n    /// ```\n    fn flat_map<U, F>(self, f: F) -> FlatMap<Self, U, F>\n    where\n        F: FnMut(Self::Item) -> U,\n        U: Stream,\n        Self: Sized,\n    {\n        assert_stream::<U::Item, _>(FlatMap::new(self, f))\n    }\n\n    /// Maps a stream like [`StreamExt::map`] but flattens nested `Stream`s\n    /// and polls them concurrently, yielding items in any order, as they made\n    /// available.\n    ///\n    /// [`StreamExt::map`] is very useful, but if it produces `Stream`s\n    /// instead, and you need to poll all of them concurrently, you would\n    /// have to use something like `for_each_concurrent` and merge values\n    /// by hand. This combinator provides ability to collect all values\n    /// from concurrently polled streams into one stream.\n    ///\n    /// The first argument is an optional limit on the number of concurrently\n    /// polled streams. If this limit is not `None`, no more than `limit` streams\n    /// will be polled at the same time. The `limit` argument is of type\n    /// `Into<Option<usize>>`, and so can be provided as either `None`,\n    /// `Some(10)`, or just `10`. Note: a limit of zero is interpreted as\n    /// no limit at all, and will have the same result as passing in `None`.\n    ///\n    /// The provided closure which produces inner streams is executed over\n    /// all elements of stream as next stream item is available and limit\n    /// of concurrently processed streams isn't exceeded.\n    ///\n    /// Note that this function consumes the stream passed into it and\n    /// returns a wrapped version of it.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::stream::{self, StreamExt};\n    ///\n    /// let stream = stream::iter(1..5);\n    /// let stream = stream.flat_map_unordered(1, |x| stream::iter(vec![x; x]));\n    /// let mut values = stream.collect::<Vec<_>>().await;\n    /// values.sort();\n    ///\n    /// assert_eq!(vec![1usize, 2, 2, 3, 3, 3, 4, 4, 4, 4], values);\n    /// # });\n    /// ```\n    #[cfg_attr(target_os = \"none\", cfg(target_has_atomic = \"ptr\"))]\n    #[cfg(feature = \"alloc\")]\n    fn flat_map_unordered<U, F>(\n        self,\n        limit: impl Into<Option<usize>>,\n        f: F,\n    ) -> FlatMapUnordered<Self, U, F>\n    where\n        U: Stream + Unpin,\n        F: FnMut(Self::Item) -> U,\n        Self: Sized,\n    {\n        assert_stream::<U::Item, _>(FlatMapUnordered::new(self, limit.into(), f))\n    }\n\n    /// Combinator similar to [`StreamExt::fold`] that holds internal state\n    /// and produces a new stream.\n    ///\n    /// Accepts initial state and closure which will be applied to each element\n    /// of the stream until provided closure returns `None`. Once `None` is\n    /// returned, stream will be terminated.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::future;\n    /// use futures::stream::{self, StreamExt};\n    ///\n    /// let stream = stream::iter(1..=10);\n    ///\n    /// let stream = stream.scan(0, |state, x| {\n    ///     *state += x;\n    ///     future::ready(if *state < 10 { Some(x) } else { None })\n    /// });\n    ///\n    /// assert_eq!(vec![1, 2, 3], stream.collect::<Vec<_>>().await);\n    /// # });\n    /// ```\n    fn scan<S, B, Fut, F>(self, initial_state: S, f: F) -> Scan<Self, S, Fut, F>\n    where\n        F: FnMut(&mut S, Self::Item) -> Fut,\n        Fut: Future<Output = Option<B>>,\n        Self: Sized,\n    {\n        assert_stream::<B, _>(Scan::new(self, initial_state, f))\n    }\n\n    /// Skip elements on this stream while the provided asynchronous predicate\n    /// resolves to `true`.\n    ///\n    /// This function, like `Iterator::skip_while`, will skip elements on the\n    /// stream until the predicate `f` resolves to `false`. Once one element\n    /// returns `false`, all future elements will be returned from the underlying\n    /// stream.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::future;\n    /// use futures::stream::{self, StreamExt};\n    ///\n    /// let stream = stream::iter(1..=10);\n    ///\n    /// let stream = stream.skip_while(|x| future::ready(*x <= 5));\n    ///\n    /// assert_eq!(vec![6, 7, 8, 9, 10], stream.collect::<Vec<_>>().await);\n    /// # });\n    /// ```\n    fn skip_while<Fut, F>(self, f: F) -> SkipWhile<Self, Fut, F>\n    where\n        F: FnMut(&Self::Item) -> Fut,\n        Fut: Future<Output = bool>,\n        Self: Sized,\n    {\n        assert_stream::<Self::Item, _>(SkipWhile::new(self, f))\n    }\n\n    /// Take elements from this stream while the provided asynchronous predicate\n    /// resolves to `true`.\n    ///\n    /// This function, like `Iterator::take_while`, will take elements from the\n    /// stream until the predicate `f` resolves to `false`. Once one element\n    /// returns `false`, it will always return that the stream is done.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::future;\n    /// use futures::stream::{self, StreamExt};\n    ///\n    /// let stream = stream::iter(1..=10);\n    ///\n    /// let stream = stream.take_while(|x| future::ready(*x <= 5));\n    ///\n    /// assert_eq!(vec![1, 2, 3, 4, 5], stream.collect::<Vec<_>>().await);\n    /// # });\n    /// ```\n    fn take_while<Fut, F>(self, f: F) -> TakeWhile<Self, Fut, F>\n    where\n        F: FnMut(&Self::Item) -> Fut,\n        Fut: Future<Output = bool>,\n        Self: Sized,\n    {\n        assert_stream::<Self::Item, _>(TakeWhile::new(self, f))\n    }\n\n    /// Take elements from this stream until the provided future resolves.\n    ///\n    /// This function will take elements from the stream until the provided\n    /// stopping future `fut` resolves. Once the `fut` future becomes ready,\n    /// this stream combinator will always return that the stream is done.\n    ///\n    /// The stopping future may return any type. Once the stream is stopped\n    /// the result of the stopping future may be accessed with `TakeUntil::take_result()`.\n    /// The stream may also be resumed with `TakeUntil::take_future()`.\n    /// See the documentation of [`TakeUntil`] for more information.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::future;\n    /// use futures::stream::{self, StreamExt};\n    /// use futures::task::Poll;\n    ///\n    /// let stream = stream::iter(1..=10);\n    ///\n    /// let mut i = 0;\n    /// let stop_fut = future::poll_fn(|_cx| {\n    ///     i += 1;\n    ///     if i <= 5 {\n    ///         Poll::Pending\n    ///     } else {\n    ///         Poll::Ready(())\n    ///     }\n    /// });\n    ///\n    /// let stream = stream.take_until(stop_fut);\n    ///\n    /// assert_eq!(vec![1, 2, 3, 4, 5], stream.collect::<Vec<_>>().await);\n    /// # });\n    /// ```\n    fn take_until<Fut>(self, fut: Fut) -> TakeUntil<Self, Fut>\n    where\n        Fut: Future,\n        Self: Sized,\n    {\n        assert_stream::<Self::Item, _>(TakeUntil::new(self, fut))\n    }\n\n    /// Runs this stream to completion, executing the provided asynchronous\n    /// closure for each element on the stream.\n    ///\n    /// The closure provided will be called for each item this stream produces,\n    /// yielding a future. That future will then be executed to completion\n    /// before moving on to the next item.\n    ///\n    /// The returned value is a `Future` where the `Output` type is `()`; it is\n    /// executed entirely for its side effects.\n    ///\n    /// To process each item in the stream and produce another stream instead\n    /// of a single future, use `then` instead.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::future;\n    /// use futures::stream::{self, StreamExt};\n    ///\n    /// let mut x = 0;\n    ///\n    /// {\n    ///     let fut = stream::repeat(1).take(3).for_each(|item| {\n    ///         x += item;\n    ///         future::ready(())\n    ///     });\n    ///     fut.await;\n    /// }\n    ///\n    /// assert_eq!(x, 3);\n    /// # });\n    /// ```\n    fn for_each<Fut, F>(self, f: F) -> ForEach<Self, Fut, F>\n    where\n        F: FnMut(Self::Item) -> Fut,\n        Fut: Future<Output = ()>,\n        Self: Sized,\n    {\n        assert_future::<(), _>(ForEach::new(self, f))\n    }\n\n    /// Runs this stream to completion, executing the provided asynchronous\n    /// closure for each element on the stream concurrently as elements become\n    /// available.\n    ///\n    /// This is similar to [`StreamExt::for_each`], but the futures\n    /// produced by the closure are run concurrently (but not in parallel--\n    /// this combinator does not introduce any threads).\n    ///\n    /// The closure provided will be called for each item this stream produces,\n    /// yielding a future. That future will then be executed to completion\n    /// concurrently with the other futures produced by the closure.\n    ///\n    /// The first argument is an optional limit on the number of concurrent\n    /// futures. If this limit is not `None`, no more than `limit` futures\n    /// will be run concurrently. The `limit` argument is of type\n    /// `Into<Option<usize>>`, and so can be provided as either `None`,\n    /// `Some(10)`, or just `10`. Note: a limit of zero is interpreted as\n    /// no limit at all, and will have the same result as passing in `None`.\n    ///\n    /// This method is only available when the `std` or `alloc` feature of this\n    /// library is activated, and it is activated by default.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::channel::oneshot;\n    /// use futures::stream::{self, StreamExt};\n    ///\n    /// let (tx1, rx1) = oneshot::channel();\n    /// let (tx2, rx2) = oneshot::channel();\n    /// let (tx3, rx3) = oneshot::channel();\n    ///\n    /// let fut = stream::iter(vec![rx1, rx2, rx3]).for_each_concurrent(\n    ///     /* limit */ 2,\n    ///     |rx| async move {\n    ///         rx.await.unwrap();\n    ///     }\n    /// );\n    /// tx1.send(()).unwrap();\n    /// tx2.send(()).unwrap();\n    /// tx3.send(()).unwrap();\n    /// fut.await;\n    /// # })\n    /// ```\n    #[cfg_attr(target_os = \"none\", cfg(target_has_atomic = \"ptr\"))]\n    #[cfg(feature = \"alloc\")]\n    fn for_each_concurrent<Fut, F>(\n        self,\n        limit: impl Into<Option<usize>>,\n        f: F,\n    ) -> ForEachConcurrent<Self, Fut, F>\n    where\n        F: FnMut(Self::Item) -> Fut,\n        Fut: Future<Output = ()>,\n        Self: Sized,\n    {\n        assert_future::<(), _>(ForEachConcurrent::new(self, limit.into(), f))\n    }\n\n    /// Creates a new stream of at most `n` items of the underlying stream.\n    ///\n    /// Once `n` items have been yielded from this stream then it will always\n    /// return that the stream is done.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::stream::{self, StreamExt};\n    ///\n    /// let stream = stream::iter(1..=10).take(3);\n    ///\n    /// assert_eq!(vec![1, 2, 3], stream.collect::<Vec<_>>().await);\n    /// # });\n    /// ```\n    fn take(self, n: usize) -> Take<Self>\n    where\n        Self: Sized,\n    {\n        assert_stream::<Self::Item, _>(Take::new(self, n))\n    }\n\n    /// Creates a new stream which skips `n` items of the underlying stream.\n    ///\n    /// Once `n` items have been skipped from this stream then it will always\n    /// return the remaining items on this stream.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::stream::{self, StreamExt};\n    ///\n    /// let stream = stream::iter(1..=10).skip(5);\n    ///\n    /// assert_eq!(vec![6, 7, 8, 9, 10], stream.collect::<Vec<_>>().await);\n    /// # });\n    /// ```\n    fn skip(self, n: usize) -> Skip<Self>\n    where\n        Self: Sized,\n    {\n        assert_stream::<Self::Item, _>(Skip::new(self, n))\n    }\n\n    /// Fuse a stream such that [`poll_next`](Stream::poll_next) will never\n    /// again be called once it has finished. This method can be used to turn\n    /// any `Stream` into a `FusedStream`.\n    ///\n    /// Normally, once a stream has returned [`None`] from\n    /// [`poll_next`](Stream::poll_next) any further calls could exhibit bad\n    /// behavior such as block forever, panic, never return, etc. If it is known\n    /// that [`poll_next`](Stream::poll_next) may be called after stream\n    /// has already finished, then this method can be used to ensure that it has\n    /// defined semantics.\n    ///\n    /// The [`poll_next`](Stream::poll_next) method of a `fuse`d stream\n    /// is guaranteed to return [`None`] after the underlying stream has\n    /// finished.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// use futures::executor::block_on_stream;\n    /// use futures::stream::{self, StreamExt};\n    /// use futures::task::Poll;\n    ///\n    /// let mut x = 0;\n    /// let stream = stream::poll_fn(|_| {\n    ///     x += 1;\n    ///     match x {\n    ///         0..=2 => Poll::Ready(Some(x)),\n    ///         3 => Poll::Ready(None),\n    ///         _ => panic!(\"should not happen\")\n    ///     }\n    /// }).fuse();\n    ///\n    /// let mut iter = block_on_stream(stream);\n    /// assert_eq!(Some(1), iter.next());\n    /// assert_eq!(Some(2), iter.next());\n    /// assert_eq!(None, iter.next());\n    /// assert_eq!(None, iter.next());\n    /// // ...\n    /// ```\n    fn fuse(self) -> Fuse<Self>\n    where\n        Self: Sized,\n    {\n        assert_stream::<Self::Item, _>(Fuse::new(self))\n    }\n\n    /// Borrows a stream, rather than consuming it.\n    ///\n    /// This is useful to allow applying stream adaptors while still retaining\n    /// ownership of the original stream.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::stream::{self, StreamExt};\n    ///\n    /// let mut stream = stream::iter(1..5);\n    ///\n    /// let sum = stream.by_ref()\n    ///                 .take(2)\n    ///                 .fold(0, |a, b| async move { a + b })\n    ///                 .await;\n    /// assert_eq!(sum, 3);\n    ///\n    /// // You can use the stream again\n    /// let sum = stream.take(2)\n    ///                 .fold(0, |a, b| async move { a + b })\n    ///                 .await;\n    /// assert_eq!(sum, 7);\n    /// # });\n    /// ```\n    fn by_ref(&mut self) -> &mut Self {\n        self\n    }\n\n    /// Catches unwinding panics while polling the stream.\n    ///\n    /// Caught panic (if any) will be the last element of the resulting stream.\n    ///\n    /// In general, panics within a stream can propagate all the way out to the\n    /// task level. This combinator makes it possible to halt unwinding within\n    /// the stream itself. It's most commonly used within task executors. This\n    /// method should not be used for error handling.\n    ///\n    /// Note that this method requires the `UnwindSafe` bound from the standard\n    /// library. This isn't always applied automatically, and the standard\n    /// library provides an `AssertUnwindSafe` wrapper type to apply it\n    /// after-the fact. To assist using this method, the [`Stream`] trait is\n    /// also implemented for `AssertUnwindSafe<St>` where `St` implements\n    /// [`Stream`].\n    ///\n    /// This method is only available when the `std` feature of this\n    /// library is activated, and it is activated by default.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::stream::{self, StreamExt};\n    ///\n    /// let stream = stream::iter(vec![Some(10), None, Some(11)]);\n    /// // Panic on second element\n    /// let stream_panicking = stream.map(|o| o.unwrap());\n    /// // Collect all the results\n    /// let stream = stream_panicking.catch_unwind();\n    ///\n    /// let results: Vec<Result<i32, _>> = stream.collect().await;\n    /// match results[0] {\n    ///     Ok(10) => {}\n    ///     _ => panic!(\"unexpected result!\"),\n    /// }\n    /// assert!(results[1].is_err());\n    /// assert_eq!(results.len(), 2);\n    /// # });\n    /// ```\n    #[cfg(feature = \"std\")]\n    fn catch_unwind(self) -> CatchUnwind<Self>\n    where\n        Self: Sized + std::panic::UnwindSafe,\n    {\n        assert_stream(CatchUnwind::new(self))\n    }\n\n    /// Wrap the stream in a Box, pinning it.\n    ///\n    /// This method is only available when the `std` or `alloc` feature of this\n    /// library is activated, and it is activated by default.\n    #[cfg(feature = \"alloc\")]\n    fn boxed<'a>(self) -> BoxStream<'a, Self::Item>\n    where\n        Self: Sized + Send + 'a,\n    {\n        assert_stream::<Self::Item, _>(Box::pin(self))\n    }\n\n    /// Wrap the stream in a Box, pinning it.\n    ///\n    /// Similar to `boxed`, but without the `Send` requirement.\n    ///\n    /// This method is only available when the `std` or `alloc` feature of this\n    /// library is activated, and it is activated by default.\n    #[cfg(feature = \"alloc\")]\n    fn boxed_local<'a>(self) -> LocalBoxStream<'a, Self::Item>\n    where\n        Self: Sized + 'a,\n    {\n        assert_stream::<Self::Item, _>(Box::pin(self))\n    }\n\n    /// An adaptor for creating a buffered list of pending futures.\n    ///\n    /// If this stream's item can be converted into a future, then this adaptor\n    /// will buffer up to at most `n` futures and then return the outputs in the\n    /// same order as the underlying stream. No more than `n` futures will be\n    /// buffered at any point in time, and less than `n` may also be buffered\n    /// depending on the state of each future.\n    ///\n    /// The returned stream will be a stream of each future's output.\n    ///\n    /// This method is only available when the `std` or `alloc` feature of this\n    /// library is activated, and it is activated by default.\n    #[cfg_attr(target_os = \"none\", cfg(target_has_atomic = \"ptr\"))]\n    #[cfg(feature = \"alloc\")]\n    fn buffered(self, n: usize) -> Buffered<Self>\n    where\n        Self::Item: Future,\n        Self: Sized,\n    {\n        assert_stream::<<Self::Item as Future>::Output, _>(Buffered::new(self, n))\n    }\n\n    /// An adaptor for creating a buffered list of pending futures (unordered).\n    ///\n    /// If this stream's item can be converted into a future, then this adaptor\n    /// will buffer up to `n` futures and then return the outputs in the order\n    /// in which they complete. No more than `n` futures will be buffered at\n    /// any point in time, and less than `n` may also be buffered depending on\n    /// the state of each future.\n    ///\n    /// The returned stream will be a stream of each future's output.\n    ///\n    /// This method is only available when the `std` or `alloc` feature of this\n    /// library is activated, and it is activated by default.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::channel::oneshot;\n    /// use futures::stream::{self, StreamExt};\n    ///\n    /// let (send_one, recv_one) = oneshot::channel();\n    /// let (send_two, recv_two) = oneshot::channel();\n    ///\n    /// let stream_of_futures = stream::iter(vec![recv_one, recv_two]);\n    /// let mut buffered = stream_of_futures.buffer_unordered(10);\n    ///\n    /// send_two.send(2i32)?;\n    /// assert_eq!(buffered.next().await, Some(Ok(2i32)));\n    ///\n    /// send_one.send(1i32)?;\n    /// assert_eq!(buffered.next().await, Some(Ok(1i32)));\n    ///\n    /// assert_eq!(buffered.next().await, None);\n    /// # Ok::<(), i32>(()) }).unwrap();\n    /// ```\n    #[cfg_attr(target_os = \"none\", cfg(target_has_atomic = \"ptr\"))]\n    #[cfg(feature = \"alloc\")]\n    fn buffer_unordered(self, n: usize) -> BufferUnordered<Self>\n    where\n        Self::Item: Future,\n        Self: Sized,\n    {\n        assert_stream::<<Self::Item as Future>::Output, _>(BufferUnordered::new(self, n))\n    }\n\n    /// An adapter for zipping two streams together.\n    ///\n    /// The zipped stream waits for both streams to produce an item, and then\n    /// returns that pair. If either stream ends then the zipped stream will\n    /// also end.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::stream::{self, StreamExt};\n    ///\n    /// let stream1 = stream::iter(1..=3);\n    /// let stream2 = stream::iter(5..=10);\n    ///\n    /// let vec = stream1.zip(stream2)\n    ///                  .collect::<Vec<_>>()\n    ///                  .await;\n    /// assert_eq!(vec![(1, 5), (2, 6), (3, 7)], vec);\n    /// # });\n    /// ```\n    ///\n    fn zip<St>(self, other: St) -> Zip<Self, St>\n    where\n        St: Stream,\n        Self: Sized,\n    {\n        assert_stream::<(Self::Item, St::Item), _>(Zip::new(self, other))\n    }\n\n    /// Adapter for chaining two streams.\n    ///\n    /// The resulting stream emits elements from the first stream, and when\n    /// first stream reaches the end, emits the elements from the second stream.\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::stream::{self, StreamExt};\n    ///\n    /// let stream1 = stream::iter(vec![Ok(10), Err(false)]);\n    /// let stream2 = stream::iter(vec![Err(true), Ok(20)]);\n    ///\n    /// let stream = stream1.chain(stream2);\n    ///\n    /// let result: Vec<_> = stream.collect().await;\n    /// assert_eq!(result, vec![\n    ///     Ok(10),\n    ///     Err(false),\n    ///     Err(true),\n    ///     Ok(20),\n    /// ]);\n    /// # });\n    /// ```\n    fn chain<St>(self, other: St) -> Chain<Self, St>\n    where\n        St: Stream<Item = Self::Item>,\n        Self: Sized,\n    {\n        assert_stream::<Self::Item, _>(Chain::new(self, other))\n    }\n\n    /// Creates a new stream which exposes a `peek` method.\n    ///\n    /// Calling `peek` returns a reference to the next item in the stream.\n    fn peekable(self) -> Peekable<Self>\n    where\n        Self: Sized,\n    {\n        assert_stream::<Self::Item, _>(Peekable::new(self))\n    }\n\n    /// An adaptor for chunking up items of the stream inside a vector.\n    ///\n    /// This combinator will attempt to pull items from this stream and buffer\n    /// them into a local vector. At most `capacity` items will get buffered\n    /// before they're yielded from the returned stream.\n    ///\n    /// Note that the vectors returned from this iterator may not always have\n    /// `capacity` elements. If the underlying stream ended and only a partial\n    /// vector was created, it'll be returned. Additionally if an error happens\n    /// from the underlying stream then the currently buffered items will be\n    /// yielded.\n    ///\n    /// This method is only available when the `std` or `alloc` feature of this\n    /// library is activated, and it is activated by default.\n    ///\n    /// # Panics\n    ///\n    /// This method will panic if `capacity` is zero.\n    #[cfg(feature = \"alloc\")]\n    fn chunks(self, capacity: usize) -> Chunks<Self>\n    where\n        Self: Sized,\n    {\n        assert_stream::<Vec<Self::Item>, _>(Chunks::new(self, capacity))\n    }\n\n    /// An adaptor for chunking up ready items of the stream inside a vector.\n    ///\n    /// This combinator will attempt to pull ready items from this stream and\n    /// buffer them into a local vector. At most `capacity` items will get\n    /// buffered before they're yielded from the returned stream. If underlying\n    /// stream returns `Poll::Pending`, and collected chunk is not empty, it will\n    /// be immediately returned.\n    ///\n    /// If the underlying stream ended and only a partial vector was created,\n    /// it will be returned.\n    ///\n    /// This method is only available when the `std` or `alloc` feature of this\n    /// library is activated, and it is activated by default.\n    ///\n    /// # Panics\n    ///\n    /// This method will panic if `capacity` is zero.\n    #[cfg(feature = \"alloc\")]\n    fn ready_chunks(self, capacity: usize) -> ReadyChunks<Self>\n    where\n        Self: Sized,\n    {\n        assert_stream::<Vec<Self::Item>, _>(ReadyChunks::new(self, capacity))\n    }\n\n    /// A future that completes after the given stream has been fully processed\n    /// into the sink and the sink has been flushed and closed.\n    ///\n    /// This future will drive the stream to keep producing items until it is\n    /// exhausted, sending each item to the sink. It will complete once the\n    /// stream is exhausted, the sink has received and flushed all items, and\n    /// the sink is closed. Note that neither the original stream nor provided\n    /// sink will be output by this future. Pass the sink by `Pin<&mut S>`\n    /// (for example, via `forward(&mut sink)` inside an `async` fn/block) in\n    /// order to preserve access to the `Sink`. If the stream produces an error,\n    /// that error will be returned by this future without flushing/closing the sink.\n    #[cfg(feature = \"sink\")]\n    #[cfg_attr(docsrs, doc(cfg(feature = \"sink\")))]\n    fn forward<S>(self, sink: S) -> Forward<Self, S>\n    where\n        S: Sink<Self::Ok, Error = Self::Error>,\n        Self: TryStream + Sized,\n        // Self: TryStream + Sized + Stream<Item = Result<<Self as TryStream>::Ok, <Self as TryStream>::Error>>,\n    {\n        // TODO: type mismatch resolving `<Self as futures_core::Stream>::Item == std::result::Result<<Self as futures_core::TryStream>::Ok, <Self as futures_core::TryStream>::Error>`\n        // assert_future::<Result<(), Self::Error>, _>(Forward::new(self, sink))\n        Forward::new(self, sink)\n    }\n\n    /// Splits this `Stream + Sink` object into separate `Sink` and `Stream`\n    /// objects.\n    ///\n    /// This can be useful when you want to split ownership between tasks, or\n    /// allow direct interaction between the two objects (e.g. via\n    /// `Sink::send_all`).\n    ///\n    /// This method is only available when the `std` or `alloc` feature of this\n    /// library is activated, and it is activated by default.\n    #[cfg(feature = \"sink\")]\n    #[cfg_attr(docsrs, doc(cfg(feature = \"sink\")))]\n    #[cfg_attr(target_os = \"none\", cfg(target_has_atomic = \"ptr\"))]\n    #[cfg(feature = \"alloc\")]\n    fn split<Item>(self) -> (SplitSink<Self, Item>, SplitStream<Self>)\n    where\n        Self: Sink<Item> + Sized,\n    {\n        let (sink, stream) = split::split(self);\n        (\n            crate::sink::assert_sink::<Item, Self::Error, _>(sink),\n            assert_stream::<Self::Item, _>(stream),\n        )\n    }\n\n    /// Do something with each item of this stream, afterwards passing it on.\n    ///\n    /// This is similar to the `Iterator::inspect` method in the standard\n    /// library where it allows easily inspecting each value as it passes\n    /// through the stream, for example to debug what's going on.\n    fn inspect<F>(self, f: F) -> Inspect<Self, F>\n    where\n        F: FnMut(&Self::Item),\n        Self: Sized,\n    {\n        assert_stream::<Self::Item, _>(Inspect::new(self, f))\n    }\n\n    /// Wrap this stream in an `Either` stream, making it the left-hand variant\n    /// of that `Either`.\n    ///\n    /// This can be used in combination with the `right_stream` method to write `if`\n    /// statements that evaluate to different streams in different branches.\n    fn left_stream<B>(self) -> Either<Self, B>\n    where\n        B: Stream<Item = Self::Item>,\n        Self: Sized,\n    {\n        assert_stream::<Self::Item, _>(Either::Left(self))\n    }\n\n    /// Wrap this stream in an `Either` stream, making it the right-hand variant\n    /// of that `Either`.\n    ///\n    /// This can be used in combination with the `left_stream` method to write `if`\n    /// statements that evaluate to different streams in different branches.\n    fn right_stream<B>(self) -> Either<B, Self>\n    where\n        B: Stream<Item = Self::Item>,\n        Self: Sized,\n    {\n        assert_stream::<Self::Item, _>(Either::Right(self))\n    }\n\n    /// A convenience method for calling [`Stream::poll_next`] on [`Unpin`]\n    /// stream types.\n    fn poll_next_unpin(&mut self, cx: &mut Context<'_>) -> Poll<Option<Self::Item>>\n    where\n        Self: Unpin,\n    {\n        Pin::new(self).poll_next(cx)\n    }\n\n    /// Returns a [`Future`] that resolves when the next item in this stream is\n    /// ready.\n    ///\n    /// This is similar to the [`next`][StreamExt::next] method, but it won't\n    /// resolve to [`None`] if used on an empty [`Stream`]. Instead, the\n    /// returned future type will return `true` from\n    /// [`FusedFuture::is_terminated`][] when the [`Stream`] is empty, allowing\n    /// [`select_next_some`][StreamExt::select_next_some] to be easily used with\n    /// the [`select!`] macro.\n    ///\n    /// If the future is polled after this [`Stream`] is empty it will panic.\n    /// Using the future with a [`FusedFuture`][]-aware primitive like the\n    /// [`select!`] macro will prevent this.\n    ///\n    /// [`FusedFuture`]: futures_core::future::FusedFuture\n    /// [`FusedFuture::is_terminated`]: futures_core::future::FusedFuture::is_terminated\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::{future, select};\n    /// use futures::stream::{StreamExt, FuturesUnordered};\n    ///\n    /// let mut fut = future::ready(1);\n    /// let mut async_tasks = FuturesUnordered::new();\n    /// let mut total = 0;\n    /// loop {\n    ///     select! {\n    ///         num = fut => {\n    ///             // First, the `ready` future completes.\n    ///             total += num;\n    ///             // Then we spawn a new task onto `async_tasks`,\n    ///             async_tasks.push(async { 5 });\n    ///         },\n    ///         // On the next iteration of the loop, the task we spawned\n    ///         // completes.\n    ///         num = async_tasks.select_next_some() => {\n    ///             total += num;\n    ///         }\n    ///         // Finally, both the `ready` future and `async_tasks` have\n    ///         // finished, so we enter the `complete` branch.\n    ///         complete => break,\n    ///     }\n    /// }\n    /// assert_eq!(total, 6);\n    /// # });\n    /// ```\n    ///\n    /// [`select!`]: crate::select\n    fn select_next_some(&mut self) -> SelectNextSome<'_, Self>\n    where\n        Self: Unpin + FusedStream,\n    {\n        assert_future::<Self::Item, _>(SelectNextSome::new(self))\n    }\n}\n";

},{}],"bI0yc":[function(require,module,exports,__globalThis) {
module.exports = "//! Streams\n//!\n//! This module contains a number of functions for working with `Streams`s\n//! that return `Result`s, allowing for short-circuiting computations.\n\n#[cfg(feature = \"compat\")]\nuse crate::compat::Compat;\nuse crate::fns::{\n    inspect_err_fn, inspect_ok_fn, into_fn, map_err_fn, map_ok_fn, InspectErrFn, InspectOkFn,\n    IntoFn, MapErrFn, MapOkFn,\n};\nuse crate::future::assert_future;\nuse crate::stream::assert_stream;\nuse crate::stream::{Inspect, Map};\n#[cfg(feature = \"alloc\")]\nuse alloc::vec::Vec;\nuse core::pin::Pin;\n\nuse futures_core::{\n    future::{Future, TryFuture},\n    stream::TryStream,\n    task::{Context, Poll},\n};\n\nmod and_then;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::and_then::AndThen;\n\ndelegate_all!(\n    /// Stream for the [`err_into`](super::TryStreamExt::err_into) method.\n    ErrInto<St, E>(\n        MapErr<St, IntoFn<E>>\n    ): Debug + Sink + Stream + FusedStream + AccessInner[St, (.)] + New[|x: St| MapErr::new(x, into_fn())]\n);\n\ndelegate_all!(\n    /// Stream for the [`inspect_ok`](super::TryStreamExt::inspect_ok) method.\n    InspectOk<St, F>(\n        Inspect<IntoStream<St>, InspectOkFn<F>>\n    ): Debug + Sink + Stream + FusedStream + AccessInner[St, (. .)] + New[|x: St, f: F| Inspect::new(IntoStream::new(x), inspect_ok_fn(f))]\n);\n\ndelegate_all!(\n    /// Stream for the [`inspect_err`](super::TryStreamExt::inspect_err) method.\n    InspectErr<St, F>(\n        Inspect<IntoStream<St>, InspectErrFn<F>>\n    ): Debug + Sink + Stream + FusedStream + AccessInner[St, (. .)] + New[|x: St, f: F| Inspect::new(IntoStream::new(x), inspect_err_fn(f))]\n);\n\nmod into_stream;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::into_stream::IntoStream;\n\ndelegate_all!(\n    /// Stream for the [`map_ok`](super::TryStreamExt::map_ok) method.\n    MapOk<St, F>(\n        Map<IntoStream<St>, MapOkFn<F>>\n    ): Debug + Sink + Stream + FusedStream + AccessInner[St, (. .)] + New[|x: St, f: F| Map::new(IntoStream::new(x), map_ok_fn(f))]\n);\n\ndelegate_all!(\n    /// Stream for the [`map_err`](super::TryStreamExt::map_err) method.\n    MapErr<St, F>(\n        Map<IntoStream<St>, MapErrFn<F>>\n    ): Debug + Sink + Stream + FusedStream + AccessInner[St, (. .)] + New[|x: St, f: F| Map::new(IntoStream::new(x), map_err_fn(f))]\n);\n\nmod or_else;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::or_else::OrElse;\n\nmod try_next;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::try_next::TryNext;\n\nmod try_for_each;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::try_for_each::TryForEach;\n\nmod try_filter;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::try_filter::TryFilter;\n\nmod try_filter_map;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::try_filter_map::TryFilterMap;\n\nmod try_flatten;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::try_flatten::TryFlatten;\n\n#[cfg_attr(target_os = \"none\", cfg(target_has_atomic = \"ptr\"))]\n#[cfg(feature = \"alloc\")]\nmod try_flatten_unordered;\n#[cfg_attr(target_os = \"none\", cfg(target_has_atomic = \"ptr\"))]\n#[cfg(feature = \"alloc\")]\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::try_flatten_unordered::TryFlattenUnordered;\n\nmod try_collect;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::try_collect::TryCollect;\n\nmod try_concat;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::try_concat::TryConcat;\n\n#[cfg(feature = \"alloc\")]\nmod try_chunks;\n#[cfg(feature = \"alloc\")]\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::try_chunks::{TryChunks, TryChunksError};\n\n#[cfg(feature = \"alloc\")]\nmod try_ready_chunks;\n#[cfg(feature = \"alloc\")]\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::try_ready_chunks::{TryReadyChunks, TryReadyChunksError};\n\nmod try_fold;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::try_fold::TryFold;\n\nmod try_unfold;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::try_unfold::{try_unfold, TryUnfold};\n\nmod try_skip_while;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::try_skip_while::TrySkipWhile;\n\nmod try_take_while;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::try_take_while::TryTakeWhile;\n\n#[cfg_attr(target_os = \"none\", cfg(target_has_atomic = \"ptr\"))]\n#[cfg(feature = \"alloc\")]\nmod try_buffer_unordered;\n#[cfg_attr(target_os = \"none\", cfg(target_has_atomic = \"ptr\"))]\n#[cfg(feature = \"alloc\")]\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::try_buffer_unordered::TryBufferUnordered;\n\n#[cfg_attr(target_os = \"none\", cfg(target_has_atomic = \"ptr\"))]\n#[cfg(feature = \"alloc\")]\nmod try_buffered;\n#[cfg_attr(target_os = \"none\", cfg(target_has_atomic = \"ptr\"))]\n#[cfg(feature = \"alloc\")]\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::try_buffered::TryBuffered;\n\n#[cfg_attr(target_os = \"none\", cfg(target_has_atomic = \"ptr\"))]\n#[cfg(feature = \"alloc\")]\nmod try_for_each_concurrent;\n#[cfg_attr(target_os = \"none\", cfg(target_has_atomic = \"ptr\"))]\n#[cfg(feature = \"alloc\")]\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::try_for_each_concurrent::TryForEachConcurrent;\n\n#[cfg(feature = \"io\")]\n#[cfg(feature = \"std\")]\nmod into_async_read;\n#[cfg(feature = \"io\")]\n#[cfg_attr(docsrs, doc(cfg(feature = \"io\")))]\n#[cfg(feature = \"std\")]\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::into_async_read::IntoAsyncRead;\n\nmod try_all;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::try_all::TryAll;\n\nmod try_any;\n#[allow(unreachable_pub)] // https://github.com/rust-lang/rust/issues/57411\npub use self::try_any::TryAny;\n\nimpl<S: ?Sized + TryStream> TryStreamExt for S {}\n\n/// Adapters specific to `Result`-returning streams\npub trait TryStreamExt: TryStream {\n    /// Wraps the current stream in a new stream which converts the error type\n    /// into the one provided.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::stream::{self, TryStreamExt};\n    ///\n    /// let mut stream =\n    ///     stream::iter(vec![Ok(()), Err(5i32)])\n    ///         .err_into::<i64>();\n    ///\n    /// assert_eq!(stream.try_next().await, Ok(Some(())));\n    /// assert_eq!(stream.try_next().await, Err(5i64));\n    /// # })\n    /// ```\n    fn err_into<E>(self) -> ErrInto<Self, E>\n    where\n        Self: Sized,\n        Self::Error: Into<E>,\n    {\n        assert_stream::<Result<Self::Ok, E>, _>(ErrInto::new(self))\n    }\n\n    /// Wraps the current stream in a new stream which maps the success value\n    /// using the provided closure.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::stream::{self, TryStreamExt};\n    ///\n    /// let mut stream =\n    ///     stream::iter(vec![Ok(5), Err(0)])\n    ///         .map_ok(|x| x + 2);\n    ///\n    /// assert_eq!(stream.try_next().await, Ok(Some(7)));\n    /// assert_eq!(stream.try_next().await, Err(0));\n    /// # })\n    /// ```\n    fn map_ok<T, F>(self, f: F) -> MapOk<Self, F>\n    where\n        Self: Sized,\n        F: FnMut(Self::Ok) -> T,\n    {\n        assert_stream::<Result<T, Self::Error>, _>(MapOk::new(self, f))\n    }\n\n    /// Wraps the current stream in a new stream which maps the error value\n    /// using the provided closure.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::stream::{self, TryStreamExt};\n    ///\n    /// let mut stream =\n    ///     stream::iter(vec![Ok(5), Err(0)])\n    ///         .map_err(|x| x + 2);\n    ///\n    /// assert_eq!(stream.try_next().await, Ok(Some(5)));\n    /// assert_eq!(stream.try_next().await, Err(2));\n    /// # })\n    /// ```\n    fn map_err<E, F>(self, f: F) -> MapErr<Self, F>\n    where\n        Self: Sized,\n        F: FnMut(Self::Error) -> E,\n    {\n        assert_stream::<Result<Self::Ok, E>, _>(MapErr::new(self, f))\n    }\n\n    /// Chain on a computation for when a value is ready, passing the successful\n    /// results to the provided closure `f`.\n    ///\n    /// This function can be used to run a unit of work when the next successful\n    /// value on a stream is ready. The closure provided will be yielded a value\n    /// when ready, and the returned future will then be run to completion to\n    /// produce the next value on this stream.\n    ///\n    /// Any errors produced by this stream will not be passed to the closure,\n    /// and will be passed through.\n    ///\n    /// The returned value of the closure must implement the `TryFuture` trait\n    /// and can represent some more work to be done before the composed stream\n    /// is finished.\n    ///\n    /// Note that this function consumes the receiving stream and returns a\n    /// wrapped version of it.\n    ///\n    /// To process the entire stream and return a single future representing\n    /// success or error, use `try_for_each` instead.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// use futures::channel::mpsc;\n    /// use futures::future;\n    /// use futures::stream::TryStreamExt;\n    ///\n    /// let (_tx, rx) = mpsc::channel::<Result<i32, ()>>(1);\n    ///\n    /// let rx = rx.and_then(|result| {\n    ///     future::ok(if result % 2 == 0 {\n    ///         Some(result)\n    ///     } else {\n    ///         None\n    ///     })\n    /// });\n    /// ```\n    fn and_then<Fut, F>(self, f: F) -> AndThen<Self, Fut, F>\n    where\n        F: FnMut(Self::Ok) -> Fut,\n        Fut: TryFuture<Error = Self::Error>,\n        Self: Sized,\n    {\n        assert_stream::<Result<Fut::Ok, Fut::Error>, _>(AndThen::new(self, f))\n    }\n\n    /// Chain on a computation for when an error happens, passing the\n    /// erroneous result to the provided closure `f`.\n    ///\n    /// This function can be used to run a unit of work and attempt to recover from\n    /// an error if one happens. The closure provided will be yielded an error\n    /// when one appears, and the returned future will then be run to completion\n    /// to produce the next value on this stream.\n    ///\n    /// Any successful values produced by this stream will not be passed to the\n    /// closure, and will be passed through.\n    ///\n    /// The returned value of the closure must implement the [`TryFuture`](futures_core::future::TryFuture) trait\n    /// and can represent some more work to be done before the composed stream\n    /// is finished.\n    ///\n    /// Note that this function consumes the receiving stream and returns a\n    /// wrapped version of it.\n    fn or_else<Fut, F>(self, f: F) -> OrElse<Self, Fut, F>\n    where\n        F: FnMut(Self::Error) -> Fut,\n        Fut: TryFuture<Ok = Self::Ok>,\n        Self: Sized,\n    {\n        assert_stream::<Result<Self::Ok, Fut::Error>, _>(OrElse::new(self, f))\n    }\n\n    /// Do something with the success value of this stream, afterwards passing\n    /// it on.\n    ///\n    /// This is similar to the `StreamExt::inspect` method where it allows\n    /// easily inspecting the success value as it passes through the stream, for\n    /// example to debug what's going on.\n    fn inspect_ok<F>(self, f: F) -> InspectOk<Self, F>\n    where\n        F: FnMut(&Self::Ok),\n        Self: Sized,\n    {\n        assert_stream::<Result<Self::Ok, Self::Error>, _>(InspectOk::new(self, f))\n    }\n\n    /// Do something with the error value of this stream, afterwards passing it on.\n    ///\n    /// This is similar to the `StreamExt::inspect` method where it allows\n    /// easily inspecting the error value as it passes through the stream, for\n    /// example to debug what's going on.\n    fn inspect_err<F>(self, f: F) -> InspectErr<Self, F>\n    where\n        F: FnMut(&Self::Error),\n        Self: Sized,\n    {\n        assert_stream::<Result<Self::Ok, Self::Error>, _>(InspectErr::new(self, f))\n    }\n\n    /// Wraps a [`TryStream`] into a type that implements\n    /// [`Stream`](futures_core::stream::Stream)\n    ///\n    /// [`TryStream`]s currently do not implement the\n    /// [`Stream`](futures_core::stream::Stream) trait because of limitations\n    /// of the compiler.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// use futures::stream::{Stream, TryStream, TryStreamExt};\n    ///\n    /// # type T = i32;\n    /// # type E = ();\n    /// fn make_try_stream() -> impl TryStream<Ok = T, Error = E> { // ... }\n    /// # futures::stream::empty()\n    /// # }\n    /// fn take_stream(stream: impl Stream<Item = Result<T, E>>) { /* ... */ }\n    ///\n    /// take_stream(make_try_stream().into_stream());\n    /// ```\n    fn into_stream(self) -> IntoStream<Self>\n    where\n        Self: Sized,\n    {\n        assert_stream::<Result<Self::Ok, Self::Error>, _>(IntoStream::new(self))\n    }\n\n    /// Creates a future that attempts to resolve the next item in the stream.\n    /// If an error is encountered before the next item, the error is returned\n    /// instead.\n    ///\n    /// This is similar to the `Stream::next` combinator, but returns a\n    /// `Result<Option<T>, E>` rather than an `Option<Result<T, E>>`, making\n    /// for easy use with the `?` operator.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::stream::{self, TryStreamExt};\n    ///\n    /// let mut stream = stream::iter(vec![Ok(()), Err(())]);\n    ///\n    /// assert_eq!(stream.try_next().await, Ok(Some(())));\n    /// assert_eq!(stream.try_next().await, Err(()));\n    /// # })\n    /// ```\n    fn try_next(&mut self) -> TryNext<'_, Self>\n    where\n        Self: Unpin,\n    {\n        assert_future::<Result<Option<Self::Ok>, Self::Error>, _>(TryNext::new(self))\n    }\n\n    /// Attempts to run this stream to completion, executing the provided\n    /// asynchronous closure for each element on the stream.\n    ///\n    /// The provided closure will be called for each item this stream produces,\n    /// yielding a future. That future will then be executed to completion\n    /// before moving on to the next item.\n    ///\n    /// The returned value is a [`Future`](futures_core::future::Future) where the\n    /// [`Output`](futures_core::future::Future::Output) type is\n    /// `Result<(), Self::Error>`. If any of the intermediate\n    /// futures or the stream returns an error, this future will return\n    /// immediately with an error.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::future;\n    /// use futures::stream::{self, TryStreamExt};\n    ///\n    /// let mut x = 0i32;\n    ///\n    /// {\n    ///     let fut = stream::repeat(Ok(1)).try_for_each(|item| {\n    ///         x += item;\n    ///         future::ready(if x == 3 { Err(()) } else { Ok(()) })\n    ///     });\n    ///     assert_eq!(fut.await, Err(()));\n    /// }\n    ///\n    /// assert_eq!(x, 3);\n    /// # })\n    /// ```\n    fn try_for_each<Fut, F>(self, f: F) -> TryForEach<Self, Fut, F>\n    where\n        F: FnMut(Self::Ok) -> Fut,\n        Fut: TryFuture<Ok = (), Error = Self::Error>,\n        Self: Sized,\n    {\n        assert_future::<Result<(), Self::Error>, _>(TryForEach::new(self, f))\n    }\n\n    /// Skip elements on this stream while the provided asynchronous predicate\n    /// resolves to `true`.\n    ///\n    /// This function is similar to\n    /// [`StreamExt::skip_while`](crate::stream::StreamExt::skip_while) but exits\n    /// early if an error occurs.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::future;\n    /// use futures::stream::{self, TryStreamExt};\n    ///\n    /// let stream = stream::iter(vec![Ok::<i32, i32>(1), Ok(3), Ok(2)]);\n    /// let stream = stream.try_skip_while(|x| future::ready(Ok(*x < 3)));\n    ///\n    /// let output: Result<Vec<i32>, i32> = stream.try_collect().await;\n    /// assert_eq!(output, Ok(vec![3, 2]));\n    /// # })\n    /// ```\n    fn try_skip_while<Fut, F>(self, f: F) -> TrySkipWhile<Self, Fut, F>\n    where\n        F: FnMut(&Self::Ok) -> Fut,\n        Fut: TryFuture<Ok = bool, Error = Self::Error>,\n        Self: Sized,\n    {\n        assert_stream::<Result<Self::Ok, Self::Error>, _>(TrySkipWhile::new(self, f))\n    }\n\n    /// Take elements on this stream while the provided asynchronous predicate\n    /// resolves to `true`.\n    ///\n    /// This function is similar to\n    /// [`StreamExt::take_while`](crate::stream::StreamExt::take_while) but exits\n    /// early if an error occurs.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::future;\n    /// use futures::stream::{self, TryStreamExt};\n    ///\n    /// let stream = stream::iter(vec![Ok::<i32, i32>(1), Ok(2), Ok(3), Ok(2)]);\n    /// let stream = stream.try_take_while(|x| future::ready(Ok(*x < 3)));\n    ///\n    /// let output: Result<Vec<i32>, i32> = stream.try_collect().await;\n    /// assert_eq!(output, Ok(vec![1, 2]));\n    /// # })\n    /// ```\n    fn try_take_while<Fut, F>(self, f: F) -> TryTakeWhile<Self, Fut, F>\n    where\n        F: FnMut(&Self::Ok) -> Fut,\n        Fut: TryFuture<Ok = bool, Error = Self::Error>,\n        Self: Sized,\n    {\n        assert_stream::<Result<Self::Ok, Self::Error>, _>(TryTakeWhile::new(self, f))\n    }\n\n    /// Attempts to run this stream to completion, executing the provided asynchronous\n    /// closure for each element on the stream concurrently as elements become\n    /// available, exiting as soon as an error occurs.\n    ///\n    /// This is similar to\n    /// [`StreamExt::for_each_concurrent`](crate::stream::StreamExt::for_each_concurrent),\n    /// but will resolve to an error immediately if the underlying stream or the provided\n    /// closure return an error.\n    ///\n    /// This method is only available when the `std` or `alloc` feature of this\n    /// library is activated, and it is activated by default.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::channel::oneshot;\n    /// use futures::stream::{self, StreamExt, TryStreamExt};\n    ///\n    /// let (tx1, rx1) = oneshot::channel();\n    /// let (tx2, rx2) = oneshot::channel();\n    /// let (_tx3, rx3) = oneshot::channel();\n    ///\n    /// let stream = stream::iter(vec![rx1, rx2, rx3]);\n    /// let fut = stream.map(Ok).try_for_each_concurrent(\n    ///     /* limit */ 2,\n    ///     |rx| async move {\n    ///         let res: Result<(), oneshot::Canceled> = rx.await;\n    ///         res\n    ///     }\n    /// );\n    ///\n    /// tx1.send(()).unwrap();\n    /// // Drop the second sender so that `rx2` resolves to `Canceled`.\n    /// drop(tx2);\n    ///\n    /// // The final result is an error because the second future\n    /// // resulted in an error.\n    /// assert_eq!(Err(oneshot::Canceled), fut.await);\n    /// # })\n    /// ```\n    #[cfg_attr(target_os = \"none\", cfg(target_has_atomic = \"ptr\"))]\n    #[cfg(feature = \"alloc\")]\n    fn try_for_each_concurrent<Fut, F>(\n        self,\n        limit: impl Into<Option<usize>>,\n        f: F,\n    ) -> TryForEachConcurrent<Self, Fut, F>\n    where\n        F: FnMut(Self::Ok) -> Fut,\n        Fut: Future<Output = Result<(), Self::Error>>,\n        Self: Sized,\n    {\n        assert_future::<Result<(), Self::Error>, _>(TryForEachConcurrent::new(\n            self,\n            limit.into(),\n            f,\n        ))\n    }\n\n    /// Attempt to transform a stream into a collection,\n    /// returning a future representing the result of that computation.\n    ///\n    /// This combinator will collect all successful results of this stream and\n    /// collect them into the specified collection type. If an error happens then all\n    /// collected elements will be dropped and the error will be returned.\n    ///\n    /// The returned future will be resolved when the stream terminates.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::channel::mpsc;\n    /// use futures::stream::TryStreamExt;\n    /// use std::thread;\n    ///\n    /// let (tx, rx) = mpsc::unbounded();\n    ///\n    /// thread::spawn(move || {\n    ///     for i in 1..=5 {\n    ///         tx.unbounded_send(Ok(i)).unwrap();\n    ///     }\n    ///     tx.unbounded_send(Err(6)).unwrap();\n    /// });\n    ///\n    /// let output: Result<Vec<i32>, i32> = rx.try_collect().await;\n    /// assert_eq!(output, Err(6));\n    /// # })\n    /// ```\n    fn try_collect<C: Default + Extend<Self::Ok>>(self) -> TryCollect<Self, C>\n    where\n        Self: Sized,\n    {\n        assert_future::<Result<C, Self::Error>, _>(TryCollect::new(self))\n    }\n\n    /// An adaptor for chunking up successful items of the stream inside a vector.\n    ///\n    /// This combinator will attempt to pull successful items from this stream and buffer\n    /// them into a local vector. At most `capacity` items will get buffered\n    /// before they're yielded from the returned stream.\n    ///\n    /// Note that the vectors returned from this iterator may not always have\n    /// `capacity` elements. If the underlying stream ended and only a partial\n    /// vector was created, it'll be returned. Additionally if an error happens\n    /// from the underlying stream then the currently buffered items will be\n    /// yielded.\n    ///\n    /// This method is only available when the `std` or `alloc` feature of this\n    /// library is activated, and it is activated by default.\n    ///\n    /// This function is similar to\n    /// [`StreamExt::chunks`](crate::stream::StreamExt::chunks) but exits\n    /// early if an error occurs.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::stream::{self, TryChunksError, TryStreamExt};\n    ///\n    /// let stream = stream::iter(vec![Ok::<i32, i32>(1), Ok(2), Ok(3), Err(4), Ok(5), Ok(6)]);\n    /// let mut stream = stream.try_chunks(2);\n    ///\n    /// assert_eq!(stream.try_next().await, Ok(Some(vec![1, 2])));\n    /// assert_eq!(stream.try_next().await, Err(TryChunksError(vec![3], 4)));\n    /// assert_eq!(stream.try_next().await, Ok(Some(vec![5, 6])));\n    /// # })\n    /// ```\n    ///\n    /// # Panics\n    ///\n    /// This method will panic if `capacity` is zero.\n    #[cfg(feature = \"alloc\")]\n    fn try_chunks(self, capacity: usize) -> TryChunks<Self>\n    where\n        Self: Sized,\n    {\n        assert_stream::<Result<Vec<Self::Ok>, TryChunksError<Self::Ok, Self::Error>>, _>(\n            TryChunks::new(self, capacity),\n        )\n    }\n\n    /// An adaptor for chunking up successful, ready items of the stream inside a vector.\n    ///\n    /// This combinator will attempt to pull successful items from this stream and buffer\n    /// them into a local vector. At most `capacity` items will get buffered\n    /// before they're yielded from the returned stream. If the underlying stream\n    /// returns `Poll::Pending`, and the collected chunk is not empty, it will\n    /// be immediately returned.\n    ///\n    /// Note that the vectors returned from this iterator may not always have\n    /// `capacity` elements. If the underlying stream ended and only a partial\n    /// vector was created, it'll be returned. Additionally if an error happens\n    /// from the underlying stream then the currently buffered items will be\n    /// yielded.\n    ///\n    /// This method is only available when the `std` or `alloc` feature of this\n    /// library is activated, and it is activated by default.\n    ///\n    /// This function is similar to\n    /// [`StreamExt::ready_chunks`](crate::stream::StreamExt::ready_chunks) but exits\n    /// early if an error occurs.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::stream::{self, TryReadyChunksError, TryStreamExt};\n    ///\n    /// let stream = stream::iter(vec![Ok::<i32, i32>(1), Ok(2), Ok(3), Err(4), Ok(5), Ok(6)]);\n    /// let mut stream = stream.try_ready_chunks(2);\n    ///\n    /// assert_eq!(stream.try_next().await, Ok(Some(vec![1, 2])));\n    /// assert_eq!(stream.try_next().await, Err(TryReadyChunksError(vec![3], 4)));\n    /// assert_eq!(stream.try_next().await, Ok(Some(vec![5, 6])));\n    /// # })\n    /// ```\n    ///\n    /// # Panics\n    ///\n    /// This method will panic if `capacity` is zero.\n    #[cfg(feature = \"alloc\")]\n    fn try_ready_chunks(self, capacity: usize) -> TryReadyChunks<Self>\n    where\n        Self: Sized,\n    {\n        assert_stream::<Result<Vec<Self::Ok>, TryReadyChunksError<Self::Ok, Self::Error>>, _>(\n            TryReadyChunks::new(self, capacity),\n        )\n    }\n\n    /// Attempt to filter the values produced by this stream according to the\n    /// provided asynchronous closure.\n    ///\n    /// As values of this stream are made available, the provided predicate `f`\n    /// will be run on them. If the predicate returns a `Future` which resolves\n    /// to `true`, then the stream will yield the value, but if the predicate\n    /// return a `Future` which resolves to `false`, then the value will be\n    /// discarded and the next value will be produced.\n    ///\n    /// All errors are passed through without filtering in this combinator.\n    ///\n    /// Note that this function consumes the stream passed into it and returns a\n    /// wrapped version of it, similar to the existing `filter` methods in\n    /// the standard library.\n    ///\n    /// # Examples\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::future;\n    /// use futures::stream::{self, StreamExt, TryStreamExt};\n    ///\n    /// let stream = stream::iter(vec![Ok(1i32), Ok(2i32), Ok(3i32), Err(\"error\")]);\n    /// let mut evens = stream.try_filter(|x| {\n    ///     future::ready(x % 2 == 0)\n    /// });\n    ///\n    /// assert_eq!(evens.next().await, Some(Ok(2)));\n    /// assert_eq!(evens.next().await, Some(Err(\"error\")));\n    /// # })\n    /// ```\n    fn try_filter<Fut, F>(self, f: F) -> TryFilter<Self, Fut, F>\n    where\n        Fut: Future<Output = bool>,\n        F: FnMut(&Self::Ok) -> Fut,\n        Self: Sized,\n    {\n        assert_stream::<Result<Self::Ok, Self::Error>, _>(TryFilter::new(self, f))\n    }\n\n    /// Attempt to filter the values produced by this stream while\n    /// simultaneously mapping them to a different type according to the\n    /// provided asynchronous closure.\n    ///\n    /// As values of this stream are made available, the provided function will\n    /// be run on them. If the future returned by the predicate `f` resolves to\n    /// [`Some(item)`](Some) then the stream will yield the value `item`, but if\n    /// it resolves to [`None`] then the next value will be produced.\n    ///\n    /// All errors are passed through without filtering in this combinator.\n    ///\n    /// Note that this function consumes the stream passed into it and returns a\n    /// wrapped version of it, similar to the existing `filter_map` methods in\n    /// the standard library.\n    ///\n    /// # Examples\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use core::pin::pin;\n    ///\n    /// use futures::stream;\n    /// use futures::stream::StreamExt;\n    /// use futures::stream::TryStreamExt;\n    ///\n    /// let stream = stream::iter(vec![Ok(1i32), Ok(6i32), Err(\"error\")]);\n    /// let halves = stream.try_filter_map(|x| async move {\n    ///     let ret = if x % 2 == 0 { Some(x / 2) } else { None };\n    ///     Ok(ret)\n    /// });\n    ///\n    /// let mut halves = pin!(halves);\n    /// assert_eq!(halves.next().await, Some(Ok(3)));\n    /// assert_eq!(halves.next().await, Some(Err(\"error\")));\n    /// # })\n    /// ```\n    fn try_filter_map<Fut, F, T>(self, f: F) -> TryFilterMap<Self, Fut, F>\n    where\n        Fut: TryFuture<Ok = Option<T>, Error = Self::Error>,\n        F: FnMut(Self::Ok) -> Fut,\n        Self: Sized,\n    {\n        assert_stream::<Result<T, Self::Error>, _>(TryFilterMap::new(self, f))\n    }\n\n    /// Flattens a stream of streams into just one continuous stream. Produced streams\n    /// will be polled concurrently and any errors will be passed through without looking at them.\n    /// If the underlying base stream returns an error, it will be **immediately** propagated.\n    ///\n    /// The only argument is an optional limit on the number of concurrently\n    /// polled streams. If this limit is not `None`, no more than `limit` streams\n    /// will be polled at the same time. The `limit` argument is of type\n    /// `Into<Option<usize>>`, and so can be provided as either `None`,\n    /// `Some(10)`, or just `10`. Note: a limit of zero is interpreted as\n    /// no limit at all, and will have the same result as passing in `None`.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::channel::mpsc;\n    /// use futures::stream::{StreamExt, TryStreamExt};\n    /// use std::thread;\n    ///\n    /// let (tx1, rx1) = mpsc::unbounded();\n    /// let (tx2, rx2) = mpsc::unbounded();\n    /// let (tx3, rx3) = mpsc::unbounded();\n    ///\n    /// thread::spawn(move || {\n    ///     tx1.unbounded_send(Ok(1)).unwrap();\n    /// });\n    /// thread::spawn(move || {\n    ///     tx2.unbounded_send(Ok(2)).unwrap();\n    ///     tx2.unbounded_send(Err(3)).unwrap();\n    ///     tx2.unbounded_send(Ok(4)).unwrap();\n    /// });\n    /// thread::spawn(move || {\n    ///     tx3.unbounded_send(Ok(rx1)).unwrap();\n    ///     tx3.unbounded_send(Ok(rx2)).unwrap();\n    ///     tx3.unbounded_send(Err(5)).unwrap();\n    /// });\n    ///\n    /// let stream = rx3.try_flatten_unordered(None);\n    /// let mut values: Vec<_> = stream.collect().await;\n    /// values.sort();\n    ///\n    /// assert_eq!(values, vec![Ok(1), Ok(2), Ok(4), Err(3), Err(5)]);\n    /// # });\n    /// ```\n    #[cfg_attr(target_os = \"none\", cfg(target_has_atomic = \"ptr\"))]\n    #[cfg(feature = \"alloc\")]\n    fn try_flatten_unordered(self, limit: impl Into<Option<usize>>) -> TryFlattenUnordered<Self>\n    where\n        Self::Ok: TryStream + Unpin,\n        <Self::Ok as TryStream>::Error: From<Self::Error>,\n        Self: Sized,\n    {\n        assert_stream::<Result<<Self::Ok as TryStream>::Ok, <Self::Ok as TryStream>::Error>, _>(\n            TryFlattenUnordered::new(self, limit),\n        )\n    }\n\n    /// Flattens a stream of streams into just one continuous stream.\n    ///\n    /// If this stream's elements are themselves streams then this combinator\n    /// will flatten out the entire stream to one long chain of elements. Any\n    /// errors are passed through without looking at them, but otherwise each\n    /// individual stream will get exhausted before moving on to the next.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::channel::mpsc;\n    /// use futures::stream::{StreamExt, TryStreamExt};\n    /// use std::thread;\n    ///\n    /// let (tx1, rx1) = mpsc::unbounded();\n    /// let (tx2, rx2) = mpsc::unbounded();\n    /// let (tx3, rx3) = mpsc::unbounded();\n    ///\n    /// thread::spawn(move || {\n    ///     tx1.unbounded_send(Ok(1)).unwrap();\n    /// });\n    /// thread::spawn(move || {\n    ///     tx2.unbounded_send(Ok(2)).unwrap();\n    ///     tx2.unbounded_send(Err(3)).unwrap();\n    ///     tx2.unbounded_send(Ok(4)).unwrap();\n    /// });\n    /// thread::spawn(move || {\n    ///     tx3.unbounded_send(Ok(rx1)).unwrap();\n    ///     tx3.unbounded_send(Ok(rx2)).unwrap();\n    ///     tx3.unbounded_send(Err(5)).unwrap();\n    /// });\n    ///\n    /// let mut stream = rx3.try_flatten();\n    /// assert_eq!(stream.next().await, Some(Ok(1)));\n    /// assert_eq!(stream.next().await, Some(Ok(2)));\n    /// assert_eq!(stream.next().await, Some(Err(3)));\n    /// assert_eq!(stream.next().await, Some(Ok(4)));\n    /// assert_eq!(stream.next().await, Some(Err(5)));\n    /// assert_eq!(stream.next().await, None);\n    /// # });\n    /// ```\n    fn try_flatten(self) -> TryFlatten<Self>\n    where\n        Self::Ok: TryStream,\n        <Self::Ok as TryStream>::Error: From<Self::Error>,\n        Self: Sized,\n    {\n        assert_stream::<Result<<Self::Ok as TryStream>::Ok, <Self::Ok as TryStream>::Error>, _>(\n            TryFlatten::new(self),\n        )\n    }\n\n    /// Attempt to execute an accumulating asynchronous computation over a\n    /// stream, collecting all the values into one final result.\n    ///\n    /// This combinator will accumulate all values returned by this stream\n    /// according to the closure provided. The initial state is also provided to\n    /// this method and then is returned again by each execution of the closure.\n    /// Once the entire stream has been exhausted the returned future will\n    /// resolve to this value.\n    ///\n    /// This method is similar to [`fold`](crate::stream::StreamExt::fold), but will\n    /// exit early if an error is encountered in either the stream or the\n    /// provided closure.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::stream::{self, TryStreamExt};\n    ///\n    /// let number_stream = stream::iter(vec![Ok::<i32, i32>(1), Ok(2)]);\n    /// let sum = number_stream.try_fold(0, |acc, x| async move { Ok(acc + x) });\n    /// assert_eq!(sum.await, Ok(3));\n    ///\n    /// let number_stream_with_err = stream::iter(vec![Ok::<i32, i32>(1), Err(2), Ok(1)]);\n    /// let sum = number_stream_with_err.try_fold(0, |acc, x| async move { Ok(acc + x) });\n    /// assert_eq!(sum.await, Err(2));\n    /// # })\n    /// ```\n    fn try_fold<T, Fut, F>(self, init: T, f: F) -> TryFold<Self, Fut, T, F>\n    where\n        F: FnMut(T, Self::Ok) -> Fut,\n        Fut: TryFuture<Ok = T, Error = Self::Error>,\n        Self: Sized,\n    {\n        assert_future::<Result<T, Self::Error>, _>(TryFold::new(self, f, init))\n    }\n\n    /// Attempt to concatenate all items of a stream into a single\n    /// extendable destination, returning a future representing the end result.\n    ///\n    /// This combinator will extend the first item with the contents of all\n    /// the subsequent successful results of the stream. If the stream is empty,\n    /// the default value will be returned.\n    ///\n    /// Works with all collections that implement the [`Extend`](std::iter::Extend) trait.\n    ///\n    /// This method is similar to [`concat`](crate::stream::StreamExt::concat), but will\n    /// exit early if an error is encountered in the stream.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::channel::mpsc;\n    /// use futures::stream::TryStreamExt;\n    /// use std::thread;\n    ///\n    /// let (tx, rx) = mpsc::unbounded::<Result<Vec<i32>, ()>>();\n    ///\n    /// thread::spawn(move || {\n    ///     for i in (0..3).rev() {\n    ///         let n = i * 3;\n    ///         tx.unbounded_send(Ok(vec![n + 1, n + 2, n + 3])).unwrap();\n    ///     }\n    /// });\n    ///\n    /// let result = rx.try_concat().await;\n    ///\n    /// assert_eq!(result, Ok(vec![7, 8, 9, 4, 5, 6, 1, 2, 3]));\n    /// # });\n    /// ```\n    fn try_concat(self) -> TryConcat<Self>\n    where\n        Self: Sized,\n        Self::Ok: Extend<<<Self as TryStream>::Ok as IntoIterator>::Item> + IntoIterator + Default,\n    {\n        assert_future::<Result<Self::Ok, Self::Error>, _>(TryConcat::new(self))\n    }\n\n    /// Attempt to execute several futures from a stream concurrently (unordered).\n    ///\n    /// This stream's `Ok` type must be a [`TryFuture`](futures_core::future::TryFuture) with an `Error` type\n    /// that matches the stream's `Error` type.\n    ///\n    /// This adaptor will buffer up to `n` futures and then return their\n    /// outputs in the order in which they complete. If the underlying stream\n    /// returns an error, it will be immediately propagated.\n    ///\n    /// The returned stream will be a stream of results, each containing either\n    /// an error or a future's output. An error can be produced either by the\n    /// underlying stream itself or by one of the futures it yielded.\n    ///\n    /// This method is only available when the `std` or `alloc` feature of this\n    /// library is activated, and it is activated by default.\n    ///\n    /// # Examples\n    ///\n    /// Results are returned in the order of completion:\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::channel::oneshot;\n    /// use futures::stream::{self, StreamExt, TryStreamExt};\n    ///\n    /// let (send_one, recv_one) = oneshot::channel();\n    /// let (send_two, recv_two) = oneshot::channel();\n    ///\n    /// let stream_of_futures = stream::iter(vec![Ok(recv_one), Ok(recv_two)]);\n    ///\n    /// let mut buffered = stream_of_futures.try_buffer_unordered(10);\n    ///\n    /// send_two.send(2i32)?;\n    /// assert_eq!(buffered.next().await, Some(Ok(2i32)));\n    ///\n    /// send_one.send(1i32)?;\n    /// assert_eq!(buffered.next().await, Some(Ok(1i32)));\n    ///\n    /// assert_eq!(buffered.next().await, None);\n    /// # Ok::<(), i32>(()) }).unwrap();\n    /// ```\n    ///\n    /// Errors from the underlying stream itself are propagated:\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::channel::mpsc;\n    /// use futures::stream::{StreamExt, TryStreamExt};\n    ///\n    /// let (sink, stream_of_futures) = mpsc::unbounded();\n    /// let mut buffered = stream_of_futures.try_buffer_unordered(10);\n    ///\n    /// sink.unbounded_send(Ok(async { Ok(7i32) }))?;\n    /// assert_eq!(buffered.next().await, Some(Ok(7i32)));\n    ///\n    /// sink.unbounded_send(Err(\"error in the stream\"))?;\n    /// assert_eq!(buffered.next().await, Some(Err(\"error in the stream\")));\n    /// # Ok::<(), Box<dyn std::error::Error>>(()) }).unwrap();\n    /// ```\n    #[cfg_attr(target_os = \"none\", cfg(target_has_atomic = \"ptr\"))]\n    #[cfg(feature = \"alloc\")]\n    fn try_buffer_unordered(self, n: usize) -> TryBufferUnordered<Self>\n    where\n        Self::Ok: TryFuture<Error = Self::Error>,\n        Self: Sized,\n    {\n        assert_stream::<Result<<Self::Ok as TryFuture>::Ok, Self::Error>, _>(\n            TryBufferUnordered::new(self, n),\n        )\n    }\n\n    /// Attempt to execute several futures from a stream concurrently.\n    ///\n    /// This stream's `Ok` type must be a [`TryFuture`](futures_core::future::TryFuture) with an `Error` type\n    /// that matches the stream's `Error` type.\n    ///\n    /// This adaptor will buffer up to `n` futures and then return their\n    /// outputs in the same order as the underlying stream. If the underlying stream returns an error, it will\n    /// be immediately propagated.\n    ///\n    /// The returned stream will be a stream of results, each containing either\n    /// an error or a future's output. An error can be produced either by the\n    /// underlying stream itself or by one of the futures it yielded.\n    ///\n    /// This method is only available when the `std` or `alloc` feature of this\n    /// library is activated, and it is activated by default.\n    ///\n    /// # Examples\n    ///\n    /// Results are returned in the order of addition:\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::channel::oneshot;\n    /// use futures::future::lazy;\n    /// use futures::stream::{self, StreamExt, TryStreamExt};\n    ///\n    /// let (send_one, recv_one) = oneshot::channel();\n    /// let (send_two, recv_two) = oneshot::channel();\n    ///\n    /// let mut buffered = lazy(move |cx| {\n    ///     let stream_of_futures = stream::iter(vec![Ok(recv_one), Ok(recv_two)]);\n    ///\n    ///     let mut buffered = stream_of_futures.try_buffered(10);\n    ///\n    ///     assert!(buffered.try_poll_next_unpin(cx).is_pending());\n    ///\n    ///     send_two.send(2i32)?;\n    ///     assert!(buffered.try_poll_next_unpin(cx).is_pending());\n    ///     Ok::<_, i32>(buffered)\n    /// }).await?;\n    ///\n    /// send_one.send(1i32)?;\n    /// assert_eq!(buffered.next().await, Some(Ok(1i32)));\n    /// assert_eq!(buffered.next().await, Some(Ok(2i32)));\n    ///\n    /// assert_eq!(buffered.next().await, None);\n    /// # Ok::<(), i32>(()) }).unwrap();\n    /// ```\n    ///\n    /// Errors from the underlying stream itself are propagated:\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::channel::mpsc;\n    /// use futures::stream::{StreamExt, TryStreamExt};\n    ///\n    /// let (sink, stream_of_futures) = mpsc::unbounded();\n    /// let mut buffered = stream_of_futures.try_buffered(10);\n    ///\n    /// sink.unbounded_send(Ok(async { Ok(7i32) }))?;\n    /// assert_eq!(buffered.next().await, Some(Ok(7i32)));\n    ///\n    /// sink.unbounded_send(Err(\"error in the stream\"))?;\n    /// assert_eq!(buffered.next().await, Some(Err(\"error in the stream\")));\n    /// # Ok::<(), Box<dyn std::error::Error>>(()) }).unwrap();\n    /// ```\n    #[cfg_attr(target_os = \"none\", cfg(target_has_atomic = \"ptr\"))]\n    #[cfg(feature = \"alloc\")]\n    fn try_buffered(self, n: usize) -> TryBuffered<Self>\n    where\n        Self::Ok: TryFuture<Error = Self::Error>,\n        Self: Sized,\n    {\n        assert_stream::<Result<<Self::Ok as TryFuture>::Ok, Self::Error>, _>(TryBuffered::new(\n            self, n,\n        ))\n    }\n\n    // TODO: false positive warning from rustdoc. Verify once #43466 settles\n    //\n    /// A convenience method for calling [`TryStream::try_poll_next`] on [`Unpin`]\n    /// stream types.\n    fn try_poll_next_unpin(\n        &mut self,\n        cx: &mut Context<'_>,\n    ) -> Poll<Option<Result<Self::Ok, Self::Error>>>\n    where\n        Self: Unpin,\n    {\n        Pin::new(self).try_poll_next(cx)\n    }\n\n    /// Wraps a [`TryStream`] into a stream compatible with libraries using\n    /// futures 0.1 `Stream`. Requires the `compat` feature to be enabled.\n    /// ```\n    /// # if cfg!(miri) { return; } // Miri does not support epoll\n    /// use futures::future::{FutureExt, TryFutureExt};\n    /// # let (tx, rx) = futures::channel::oneshot::channel();\n    ///\n    /// let future03 = async {\n    ///     println!(\"Running on the pool\");\n    ///     tx.send(42).unwrap();\n    /// };\n    ///\n    /// let future01 = future03\n    ///     .unit_error() // Make it a TryFuture\n    ///     .boxed()  // Make it Unpin\n    ///     .compat();\n    ///\n    /// tokio::run(future01);\n    /// # assert_eq!(42, futures::executor::block_on(rx).unwrap());\n    /// ```\n    #[cfg(feature = \"compat\")]\n    #[cfg_attr(docsrs, doc(cfg(feature = \"compat\")))]\n    fn compat(self) -> Compat<Self>\n    where\n        Self: Sized + Unpin,\n    {\n        Compat::new(self)\n    }\n\n    /// Adapter that converts this stream into an [`AsyncBufRead`](crate::io::AsyncBufRead).\n    ///\n    /// This method is only available when the `std` feature of this\n    /// library is activated, and it is activated by default.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::stream::{self, TryStreamExt};\n    /// use futures::io::AsyncReadExt;\n    ///\n    /// let stream = stream::iter([Ok(vec![1, 2, 3]), Ok(vec![4, 5])]);\n    /// let mut reader = stream.into_async_read();\n    ///\n    /// let mut buf = Vec::new();\n    /// reader.read_to_end(&mut buf).await.unwrap();\n    /// assert_eq!(buf, [1, 2, 3, 4, 5]);\n    /// # })\n    /// ```\n    #[cfg(feature = \"io\")]\n    #[cfg_attr(docsrs, doc(cfg(feature = \"io\")))]\n    #[cfg(feature = \"std\")]\n    fn into_async_read(self) -> IntoAsyncRead<Self>\n    where\n        Self: Sized + TryStreamExt<Error = std::io::Error>,\n        Self::Ok: AsRef<[u8]>,\n    {\n        crate::io::assert_read(IntoAsyncRead::new(self))\n    }\n\n    /// Attempt to execute a predicate over an asynchronous stream and evaluate if all items\n    /// satisfy the predicate. Exits early if an `Err` is encountered or if an `Ok` item is found\n    /// that does not satisfy the predicate.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::stream::{self, StreamExt, TryStreamExt};\n    /// use std::convert::Infallible;\n    ///\n    /// let number_stream = stream::iter(1..10).map(Ok::<_, Infallible>);\n    /// let positive = number_stream.try_all(|i| async move { i > 0 });\n    /// assert_eq!(positive.await, Ok(true));\n    ///\n    /// let stream_with_errors = stream::iter([Ok(1), Err(\"err\"), Ok(3)]);\n    /// let positive = stream_with_errors.try_all(|i| async move { i > 0 });\n    /// assert_eq!(positive.await, Err(\"err\"));\n    /// # });\n    /// ```\n    fn try_all<Fut, F>(self, f: F) -> TryAll<Self, Fut, F>\n    where\n        Self: Sized,\n        F: FnMut(Self::Ok) -> Fut,\n        Fut: Future<Output = bool>,\n    {\n        assert_future::<Result<bool, Self::Error>, _>(TryAll::new(self, f))\n    }\n\n    /// Attempt to execute a predicate over an asynchronous stream and evaluate if any items\n    /// satisfy the predicate. Exits early if an `Err` is encountered or if an `Ok` item is found\n    /// that satisfies the predicate.\n    ///\n    /// # Examples\n    ///\n    /// ```\n    /// # futures::executor::block_on(async {\n    /// use futures::stream::{self, StreamExt, TryStreamExt};\n    /// use std::convert::Infallible;\n    ///\n    /// let number_stream = stream::iter(0..10).map(Ok::<_, Infallible>);\n    /// let contain_three = number_stream.try_any(|i| async move { i == 3 });\n    /// assert_eq!(contain_three.await, Ok(true));\n    ///\n    /// let stream_with_errors = stream::iter([Ok(1), Err(\"err\"), Ok(3)]);\n    /// let contain_three = stream_with_errors.try_any(|i| async move { i == 3 });\n    /// assert_eq!(contain_three.await, Err(\"err\"));\n    /// # });\n    /// ```\n    fn try_any<Fut, F>(self, f: F) -> TryAny<Self, Fut, F>\n    where\n        Self: Sized,\n        F: FnMut(Self::Ok) -> Fut,\n        Fut: Future<Output = bool>,\n    {\n        assert_future::<Result<bool, Self::Error>, _>(TryAny::new(self, f))\n    }\n}\n";

},{}],"2LOB4":[function(require,module,exports,__globalThis) {
module.exports = "use crate::attr::Attribute;\nuse crate::data::{Fields, FieldsNamed, Variant};\nuse crate::generics::Generics;\nuse crate::ident::Ident;\nuse crate::punctuated::Punctuated;\nuse crate::restriction::Visibility;\nuse crate::token;\nuse alloc::vec::Vec;\n\nast_struct! {\n    /// Data structure sent to a `proc_macro_derive` macro.\n    #[cfg_attr(docsrs, doc(cfg(feature = \"derive\")))]\n    pub struct DeriveInput {\n        pub attrs: Vec<Attribute>,\n        pub vis: Visibility,\n        pub ident: Ident,\n        pub generics: Generics,\n        pub data: Data,\n    }\n}\n\nast_enum! {\n    /// The storage of a struct, enum or union data structure.\n    ///\n    /// # Syntax tree enum\n    ///\n    /// This type is a [syntax tree enum].\n    ///\n    /// [syntax tree enum]: crate::expr::Expr#syntax-tree-enums\n    #[cfg_attr(docsrs, doc(cfg(feature = \"derive\")))]\n    pub enum Data {\n        Struct(DataStruct),\n        Enum(DataEnum),\n        Union(DataUnion),\n    }\n}\n\nast_struct! {\n    /// A struct input to a `proc_macro_derive` macro.\n    #[cfg_attr(docsrs, doc(cfg(feature = \"derive\")))]\n    pub struct DataStruct {\n        pub struct_token: Token![struct],\n        pub fields: Fields,\n        pub semi_token: Option<Token![;]>,\n    }\n}\n\nast_struct! {\n    /// An enum input to a `proc_macro_derive` macro.\n    #[cfg_attr(docsrs, doc(cfg(feature = \"derive\")))]\n    pub struct DataEnum {\n        pub enum_token: Token![enum],\n        pub brace_token: token::Brace,\n        pub variants: Punctuated<Variant, Token![,]>,\n    }\n}\n\nast_struct! {\n    /// An untagged union input to a `proc_macro_derive` macro.\n    #[cfg_attr(docsrs, doc(cfg(feature = \"derive\")))]\n    pub struct DataUnion {\n        pub union_token: Token![union],\n        pub fields: FieldsNamed,\n    }\n}\n\n#[cfg(feature = \"parsing\")]\npub(crate) mod parsing {\n    use crate::attr::Attribute;\n    use crate::data::{Fields, FieldsNamed, Variant};\n    use crate::derive::{Data, DataEnum, DataStruct, DataUnion, DeriveInput};\n    use crate::error::Result;\n    use crate::generics::{Generics, WhereClause};\n    use crate::ident::Ident;\n    use crate::parse::{Parse, ParseStream};\n    use crate::punctuated::Punctuated;\n    use crate::restriction::Visibility;\n    use crate::token;\n\n    #[cfg_attr(docsrs, doc(cfg(feature = \"parsing\")))]\n    impl Parse for DeriveInput {\n        fn parse(input: ParseStream) -> Result<Self> {\n            let attrs = input.call(Attribute::parse_outer)?;\n            let vis = input.parse::<Visibility>()?;\n\n            let lookahead = input.lookahead1();\n            if lookahead.peek(Token![struct]) {\n                let struct_token = input.parse::<Token![struct]>()?;\n                let ident = input.parse::<Ident>()?;\n                let generics = input.parse::<Generics>()?;\n                let (where_clause, fields, semi) = data_struct(input)?;\n                Ok(DeriveInput {\n                    attrs,\n                    vis,\n                    ident,\n                    generics: Generics {\n                        where_clause,\n                        ..generics\n                    },\n                    data: Data::Struct(DataStruct {\n                        struct_token,\n                        fields,\n                        semi_token: semi,\n                    }),\n                })\n            } else if lookahead.peek(Token![enum]) {\n                let enum_token = input.parse::<Token![enum]>()?;\n                let ident = input.parse::<Ident>()?;\n                let generics = input.parse::<Generics>()?;\n                let (where_clause, brace, variants) = data_enum(input)?;\n                Ok(DeriveInput {\n                    attrs,\n                    vis,\n                    ident,\n                    generics: Generics {\n                        where_clause,\n                        ..generics\n                    },\n                    data: Data::Enum(DataEnum {\n                        enum_token,\n                        brace_token: brace,\n                        variants,\n                    }),\n                })\n            } else if lookahead.peek(Token![union]) {\n                let union_token = input.parse::<Token![union]>()?;\n                let ident = input.parse::<Ident>()?;\n                let generics = input.parse::<Generics>()?;\n                let (where_clause, fields) = data_union(input)?;\n                Ok(DeriveInput {\n                    attrs,\n                    vis,\n                    ident,\n                    generics: Generics {\n                        where_clause,\n                        ..generics\n                    },\n                    data: Data::Union(DataUnion {\n                        union_token,\n                        fields,\n                    }),\n                })\n            } else {\n                Err(lookahead.error())\n            }\n        }\n    }\n\n    pub(crate) fn data_struct(\n        input: ParseStream,\n    ) -> Result<(Option<WhereClause>, Fields, Option<Token![;]>)> {\n        let mut lookahead = input.lookahead1();\n        let mut where_clause = None;\n        if lookahead.peek(Token![where]) {\n            where_clause = Some(input.parse()?);\n            lookahead = input.lookahead1();\n        }\n\n        if where_clause.is_none() && lookahead.peek(token::Paren) {\n            let fields = input.parse()?;\n\n            lookahead = input.lookahead1();\n            if lookahead.peek(Token![where]) {\n                where_clause = Some(input.parse()?);\n                lookahead = input.lookahead1();\n            }\n\n            if lookahead.peek(Token![;]) {\n                let semi = input.parse()?;\n                Ok((where_clause, Fields::Unnamed(fields), Some(semi)))\n            } else {\n                Err(lookahead.error())\n            }\n        } else if lookahead.peek(token::Brace) {\n            let fields = input.parse()?;\n            Ok((where_clause, Fields::Named(fields), None))\n        } else if lookahead.peek(Token![;]) {\n            let semi = input.parse()?;\n            Ok((where_clause, Fields::Unit, Some(semi)))\n        } else {\n            Err(lookahead.error())\n        }\n    }\n\n    pub(crate) fn data_enum(\n        input: ParseStream,\n    ) -> Result<(\n        Option<WhereClause>,\n        token::Brace,\n        Punctuated<Variant, Token![,]>,\n    )> {\n        let where_clause = input.parse()?;\n\n        let content;\n        let brace = braced!(content in input);\n        let variants = content.parse_terminated(Variant::parse, Token![,])?;\n\n        Ok((where_clause, brace, variants))\n    }\n\n    pub(crate) fn data_union(input: ParseStream) -> Result<(Option<WhereClause>, FieldsNamed)> {\n        let where_clause = input.parse()?;\n        let fields = input.parse()?;\n        Ok((where_clause, fields))\n    }\n}\n\n#[cfg(feature = \"printing\")]\nmod printing {\n    use crate::attr::FilterAttrs;\n    use crate::data::Fields;\n    use crate::derive::{Data, DeriveInput};\n    use crate::print::TokensOrDefault;\n    use proc_macro2::TokenStream;\n    use quote::ToTokens;\n\n    #[cfg_attr(docsrs, doc(cfg(feature = \"printing\")))]\n    impl ToTokens for DeriveInput {\n        fn to_tokens(&self, tokens: &mut TokenStream) {\n            for attr in self.attrs.outer() {\n                attr.to_tokens(tokens);\n            }\n            self.vis.to_tokens(tokens);\n            match &self.data {\n                Data::Struct(d) => d.struct_token.to_tokens(tokens),\n                Data::Enum(d) => d.enum_token.to_tokens(tokens),\n                Data::Union(d) => d.union_token.to_tokens(tokens),\n            }\n            self.ident.to_tokens(tokens);\n            self.generics.to_tokens(tokens);\n            match &self.data {\n                Data::Struct(data) => match &data.fields {\n                    Fields::Named(fields) => {\n                        self.generics.where_clause.to_tokens(tokens);\n                        fields.to_tokens(tokens);\n                    }\n                    Fields::Unnamed(fields) => {\n                        fields.to_tokens(tokens);\n                        self.generics.where_clause.to_tokens(tokens);\n                        TokensOrDefault(&data.semi_token).to_tokens(tokens);\n                    }\n                    Fields::Unit => {\n                        self.generics.where_clause.to_tokens(tokens);\n                        TokensOrDefault(&data.semi_token).to_tokens(tokens);\n                    }\n                },\n                Data::Enum(data) => {\n                    self.generics.where_clause.to_tokens(tokens);\n                    data.brace_token.surround(tokens, |tokens| {\n                        data.variants.to_tokens(tokens);\n                    });\n                }\n                Data::Union(data) => {\n                    self.generics.where_clause.to_tokens(tokens);\n                    data.fields.to_tokens(tokens);\n                }\n            }\n        }\n    }\n}\n";

},{}],"2jMSg":[function(require,module,exports,__globalThis) {
module.exports = "use super::ReadBuf;\nuse std::io;\nuse std::ops::DerefMut;\nuse std::pin::Pin;\nuse std::task::{Context, Poll};\n\n/// Reads bytes from a source.\n///\n/// This trait is analogous to the [`std::io::Read`] trait, but integrates with\n/// the asynchronous task system. In particular, the [`poll_read`] method,\n/// unlike [`Read::read`], will automatically queue the current task for wakeup\n/// and return if data is not yet available, rather than blocking the calling\n/// thread.\n///\n/// Specifically, this means that the `poll_read` function will return one of\n/// the following:\n///\n/// * `Poll::Ready(Ok(()))` means that data was immediately read and placed into\n///   the output buffer. The amount of data read can be determined by the\n///   increase in the length of the slice returned by `ReadBuf::filled`. If the\n///   difference is 0, either EOF has been reached, or the output buffer had zero\n///   capacity (i.e. `buf.remaining()` == 0).\n///\n/// * `Poll::Pending` means that no data was read into the buffer\n///   provided. The I/O object is not currently readable but may become readable\n///   in the future. Most importantly, **the current future's task is scheduled\n///   to get unparked when the object is readable**. This means that like\n///   `Future::poll` you'll receive a notification when the I/O object is\n///   readable again.\n///\n/// * `Poll::Ready(Err(e))` for other errors are standard I/O errors coming from the\n///   underlying object.\n///\n/// This trait importantly means that the `read` method only works in the\n/// context of a future's task. The object may panic if used outside of a task.\n///\n/// Utilities for working with `AsyncRead` values are provided by\n/// [`AsyncReadExt`].\n///\n/// [`poll_read`]: AsyncRead::poll_read\n/// [`std::io::Read`]: std::io::Read\n/// [`Read::read`]: std::io::Read::read\n/// [`AsyncReadExt`]: crate::io::AsyncReadExt\npub trait AsyncRead {\n    /// Attempts to read from the `AsyncRead` into `buf`.\n    ///\n    /// On success, returns `Poll::Ready(Ok(()))` and places data in the\n    /// unfilled portion of `buf`. If no data was read (`buf.filled().len()` is\n    /// unchanged), it implies that EOF has been reached, or the output buffer\n    /// had zero capacity (i.e. `buf.remaining()` == 0).\n    ///\n    /// If no data is available for reading, the method returns `Poll::Pending`\n    /// and arranges for the current task (via `cx.waker()`) to receive a\n    /// notification when the object becomes readable or is closed.\n    fn poll_read(\n        self: Pin<&mut Self>,\n        cx: &mut Context<'_>,\n        buf: &mut ReadBuf<'_>,\n    ) -> Poll<io::Result<()>>;\n}\n\nmacro_rules! deref_async_read {\n    () => {\n        fn poll_read(\n            mut self: Pin<&mut Self>,\n            cx: &mut Context<'_>,\n            buf: &mut ReadBuf<'_>,\n        ) -> Poll<io::Result<()>> {\n            Pin::new(&mut **self).poll_read(cx, buf)\n        }\n    };\n}\n\nimpl<T: ?Sized + AsyncRead + Unpin> AsyncRead for Box<T> {\n    deref_async_read!();\n}\n\nimpl<T: ?Sized + AsyncRead + Unpin> AsyncRead for &mut T {\n    deref_async_read!();\n}\n\nimpl<P> AsyncRead for Pin<P>\nwhere\n    P: DerefMut,\n    P::Target: AsyncRead,\n{\n    fn poll_read(\n        self: Pin<&mut Self>,\n        cx: &mut Context<'_>,\n        buf: &mut ReadBuf<'_>,\n    ) -> Poll<io::Result<()>> {\n        crate::util::pin_as_deref_mut(self).poll_read(cx, buf)\n    }\n}\n\nimpl AsyncRead for &[u8] {\n    fn poll_read(\n        mut self: Pin<&mut Self>,\n        _cx: &mut Context<'_>,\n        buf: &mut ReadBuf<'_>,\n    ) -> Poll<io::Result<()>> {\n        let amt = std::cmp::min(self.len(), buf.remaining());\n        let (a, b) = self.split_at(amt);\n        buf.put_slice(a);\n        *self = b;\n        Poll::Ready(Ok(()))\n    }\n}\n\nimpl<T: AsRef<[u8]> + Unpin> AsyncRead for io::Cursor<T> {\n    fn poll_read(\n        mut self: Pin<&mut Self>,\n        _cx: &mut Context<'_>,\n        buf: &mut ReadBuf<'_>,\n    ) -> Poll<io::Result<()>> {\n        let pos = self.position();\n        let slice: &[u8] = (*self).get_ref().as_ref();\n\n        // The position could technically be out of bounds, so don't panic...\n        if pos > slice.len() as u64 {\n            return Poll::Ready(Ok(()));\n        }\n\n        let start = pos as usize;\n        let amt = std::cmp::min(slice.len() - start, buf.remaining());\n        // Add won't overflow because of pos check above.\n        let end = start + amt;\n        buf.put_slice(&slice[start..end]);\n        self.set_position(end as u64);\n\n        Poll::Ready(Ok(()))\n    }\n}\n";

},{}],"bh2f9":[function(require,module,exports,__globalThis) {
module.exports = "use crate::io::util::chain::{chain, Chain};\nuse crate::io::util::read::{read, Read};\nuse crate::io::util::read_buf::{read_buf, ReadBuf};\nuse crate::io::util::read_exact::{read_exact, ReadExact};\nuse crate::io::util::read_int::{ReadF32, ReadF32Le, ReadF64, ReadF64Le};\nuse crate::io::util::read_int::{\n    ReadI128, ReadI128Le, ReadI16, ReadI16Le, ReadI32, ReadI32Le, ReadI64, ReadI64Le, ReadI8,\n};\nuse crate::io::util::read_int::{\n    ReadU128, ReadU128Le, ReadU16, ReadU16Le, ReadU32, ReadU32Le, ReadU64, ReadU64Le, ReadU8,\n};\nuse crate::io::util::read_to_end::{read_to_end, ReadToEnd};\nuse crate::io::util::read_to_string::{read_to_string, ReadToString};\nuse crate::io::util::take::{take, Take};\nuse crate::io::AsyncRead;\n\nuse bytes::BufMut;\n\ncfg_io_util! {\n    /// Defines numeric reader\n    macro_rules! read_impl {\n        (\n            $(\n                $(#[$outer:meta])*\n                fn $name:ident(&mut self) -> $($fut:ident)*;\n            )*\n        ) => {\n            $(\n                $(#[$outer])*\n                fn $name(&mut self) -> $($fut)*<&mut Self> where Self: Unpin {\n                    $($fut)*::new(self)\n                }\n            )*\n        }\n    }\n\n    /// Reads bytes from a source.\n    ///\n    /// Implemented as an extension trait, adding utility methods to all\n    /// [`AsyncRead`] types. Callers will tend to import this trait instead of\n    /// [`AsyncRead`].\n    ///\n    /// ```no_run\n    /// # #[cfg(not(target_family = \"wasm\"))]\n    /// # {\n    /// use tokio::fs::File;\n    /// use tokio::io::{self, AsyncReadExt};\n    ///\n    /// #[tokio::main]\n    /// async fn main() -> io::Result<()> {\n    ///     let mut f = File::open(\"foo.txt\").await?;\n    ///     let mut buffer = [0; 10];\n    ///\n    ///     // The `read` method is defined by this trait.\n    ///     let n = f.read(&mut buffer[..]).await?;\n    ///\n    ///     Ok(())\n    /// }\n    /// # }\n    /// ```\n    ///\n    /// See [module][crate::io] documentation for more details.\n    ///\n    /// [`AsyncRead`]: AsyncRead\n    pub trait AsyncReadExt: AsyncRead {\n        /// Creates a new `AsyncRead` instance that chains this stream with\n        /// `next`.\n        ///\n        /// The returned `AsyncRead` instance will first read all bytes from this object\n        /// until EOF is encountered. Afterwards the output is equivalent to the\n        /// output of `next`.\n        ///\n        /// # Examples\n        ///\n        /// [`File`][crate::fs::File]s implement `AsyncRead`:\n        ///\n        /// ```no_run\n        /// # #[cfg(not(target_family = \"wasm\"))]\n        /// # {\n        /// use tokio::fs::File;\n        /// use tokio::io::{self, AsyncReadExt};\n        ///\n        /// #[tokio::main]\n        /// async fn main() -> io::Result<()> {\n        ///     let f1 = File::open(\"foo.txt\").await?;\n        ///     let f2 = File::open(\"bar.txt\").await?;\n        ///\n        ///     let mut handle = f1.chain(f2);\n        ///     let mut buffer = String::new();\n        ///\n        ///     // read the value into a String. We could use any AsyncRead\n        ///     // method here, this is just one example.\n        ///     handle.read_to_string(&mut buffer).await?;\n        ///     Ok(())\n        /// }\n        /// # }\n        /// ```\n        fn chain<R>(self, next: R) -> Chain<Self, R>\n        where\n            Self: Sized,\n            R: AsyncRead,\n        {\n            chain(self, next)\n        }\n\n        /// Pulls some bytes from this source into the specified buffer,\n        /// returning how many bytes were read.\n        ///\n        /// Equivalent to:\n        ///\n        /// ```ignore\n        /// async fn read(&mut self, buf: &mut [u8]) -> io::Result<usize>;\n        /// ```\n        ///\n        /// This method does not provide any guarantees about whether it\n        /// completes immediately or asynchronously.\n        ///\n        /// # Return\n        ///\n        /// If the return value of this method is `Ok(n)`, then it must be\n        /// guaranteed that `0 <= n <= buf.len()`. A nonzero `n` value indicates\n        /// that the buffer `buf` has been filled in with `n` bytes of data from\n        /// this source. If `n` is `0`, then it can indicate one of two\n        /// scenarios:\n        ///\n        /// 1. This reader has reached its \"end of file\" and will likely no longer\n        ///    be able to produce bytes. Note that this does not mean that the\n        ///    reader will *always* no longer be able to produce bytes.\n        /// 2. The buffer specified was 0 bytes in length.\n        ///\n        /// No guarantees are provided about the contents of `buf` when this\n        /// function is called, implementations cannot rely on any property of the\n        /// contents of `buf` being true. It is recommended that *implementations*\n        /// only write data to `buf` instead of reading its contents.\n        ///\n        /// Correspondingly, however, *callers* of this method may not assume\n        /// any guarantees about how the implementation uses `buf`. It is\n        /// possible that the code that's supposed to write to the buffer might\n        /// also read from it. It is your responsibility to make sure that `buf`\n        /// is initialized before calling `read`.\n        ///\n        /// # Errors\n        ///\n        /// If this function encounters any form of I/O or other error, an error\n        /// variant will be returned. If an error is returned then it must be\n        /// guaranteed that no bytes were read.\n        ///\n        /// # Cancel safety\n        ///\n        /// This method is cancel safe. If you use it as the event in a\n        /// [`tokio::select!`](crate::select) statement and some other branch\n        /// completes first, then it is guaranteed that no data was read.\n        ///\n        /// # Examples\n        ///\n        /// [`File`][crate::fs::File]s implement `Read`:\n        ///\n        /// ```no_run\n        /// # #[cfg(not(target_family = \"wasm\"))]\n        /// # {\n        /// use tokio::fs::File;\n        /// use tokio::io::{self, AsyncReadExt};\n        ///\n        /// #[tokio::main]\n        /// async fn main() -> io::Result<()> {\n        ///     let mut f = File::open(\"foo.txt\").await?;\n        ///     let mut buffer = [0; 10];\n        ///\n        ///     // read up to 10 bytes\n        ///     let n = f.read(&mut buffer[..]).await?;\n        ///\n        ///     println!(\"The bytes: {:?}\", &buffer[..n]);\n        ///     Ok(())\n        /// }\n        /// # }\n        /// ```\n        fn read<'a>(&'a mut self, buf: &'a mut [u8]) -> Read<'a, Self>\n        where\n            Self: Unpin,\n        {\n            read(self, buf)\n        }\n\n        /// Pulls some bytes from this source into the specified buffer,\n        /// advancing the buffer's internal cursor.\n        ///\n        /// Equivalent to:\n        ///\n        /// ```ignore\n        /// async fn read_buf<B: BufMut>(&mut self, buf: &mut B) -> io::Result<usize>;\n        /// ```\n        ///\n        /// Usually, only a single `read` syscall is issued, even if there is\n        /// more space in the supplied buffer.\n        ///\n        /// This method does not provide any guarantees about whether it\n        /// completes immediately or asynchronously.\n        ///\n        /// # Return\n        ///\n        /// A nonzero `n` value indicates that the buffer `buf` has been filled\n        /// in with `n` bytes of data from this source. If `n` is `0`, then it\n        /// can indicate one of two scenarios:\n        ///\n        /// 1. This reader has reached its \"end of file\" and will likely no longer\n        ///    be able to produce bytes. Note that this does not mean that the\n        ///    reader will *always* no longer be able to produce bytes.\n        /// 2. The buffer specified had a remaining capacity of zero.\n        ///\n        /// # Errors\n        ///\n        /// If this function encounters any form of I/O or other error, an error\n        /// variant will be returned. If an error is returned then it must be\n        /// guaranteed that no bytes were read.\n        ///\n        /// # Cancel safety\n        ///\n        /// This method is cancel safe. If you use it as the event in a\n        /// [`tokio::select!`](crate::select) statement and some other branch\n        /// completes first, then it is guaranteed that no data was read.\n        ///\n        /// # Examples\n        ///\n        /// [`File`] implements `Read` and [`BytesMut`] implements [`BufMut`]:\n        ///\n        /// [`File`]: crate::fs::File\n        /// [`BytesMut`]: bytes::BytesMut\n        /// [`BufMut`]: bytes::BufMut\n        ///\n        /// ```no_run\n        /// # #[cfg(not(target_family = \"wasm\"))]\n        /// # {\n        /// use tokio::fs::File;\n        /// use tokio::io::{self, AsyncReadExt};\n        ///\n        /// use bytes::BytesMut;\n        ///\n        /// #[tokio::main]\n        /// async fn main() -> io::Result<()> {\n        ///     let mut f = File::open(\"foo.txt\").await?;\n        ///     let mut buffer = BytesMut::with_capacity(10);\n        ///\n        ///     assert!(buffer.is_empty());\n        ///     assert!(buffer.capacity() >= 10);\n        ///\n        ///     // note that the return value is not needed to access the data\n        ///     // that was read as `buffer`'s internal cursor is updated.\n        ///     //\n        ///     // this might read more than 10 bytes if the capacity of `buffer`\n        ///     // is larger than 10.\n        ///     f.read_buf(&mut buffer).await?;\n        ///\n        ///     println!(\"The bytes: {:?}\", &buffer[..]);\n        ///     Ok(())\n        /// }\n        /// # }\n        /// ```\n        fn read_buf<'a, B>(&'a mut self, buf: &'a mut B) -> ReadBuf<'a, Self, B>\n        where\n            Self: Unpin,\n            B: BufMut + ?Sized,\n        {\n            read_buf(self, buf)\n        }\n\n        /// Reads the exact number of bytes required to fill `buf`.\n        ///\n        /// Equivalent to:\n        ///\n        /// ```ignore\n        /// async fn read_exact(&mut self, buf: &mut [u8]) -> io::Result<usize>;\n        /// ```\n        ///\n        /// This function reads as many bytes as necessary to completely fill\n        /// the specified buffer `buf`.\n        ///\n        /// # Errors\n        ///\n        /// If the operation encounters an \"end of file\" before completely\n        /// filling the buffer, it returns an error of the kind\n        /// [`ErrorKind::UnexpectedEof`]. The contents of `buf` are unspecified\n        /// in this case.\n        ///\n        /// If any other read error is encountered then the operation\n        /// immediately returns. The contents of `buf` are unspecified in this\n        /// case.\n        ///\n        /// If this operation returns an error, it is unspecified how many bytes\n        /// it has read, but it will never read more than would be necessary to\n        /// completely fill the buffer.\n        ///\n        /// # Cancel safety\n        ///\n        /// This method is not cancellation safe. If the method is used as the\n        /// event in a [`tokio::select!`](crate::select) statement and some\n        /// other branch completes first, then some data may already have been\n        /// read into `buf`.\n        ///\n        /// # Examples\n        ///\n        /// [`File`][crate::fs::File]s implement `Read`:\n        ///\n        /// ```no_run\n        /// # #[cfg(not(target_family = \"wasm\"))]\n        /// # {\n        /// use tokio::fs::File;\n        /// use tokio::io::{self, AsyncReadExt};\n        ///\n        /// #[tokio::main]\n        /// async fn main() -> io::Result<()> {\n        ///     let mut f = File::open(\"foo.txt\").await?;\n        ///     let len = 10;\n        ///     let mut buffer = vec![0; len];\n        ///\n        ///     // read exactly 10 bytes\n        ///     f.read_exact(&mut buffer).await?;\n        ///     Ok(())\n        /// }\n        /// # }\n        /// ```\n        ///\n        /// [`ErrorKind::UnexpectedEof`]: std::io::ErrorKind::UnexpectedEof\n        fn read_exact<'a>(&'a mut self, buf: &'a mut [u8]) -> ReadExact<'a, Self>\n        where\n            Self: Unpin,\n        {\n            read_exact(self, buf)\n        }\n\n        read_impl! {\n            /// Reads an unsigned 8 bit integer from the underlying reader.\n            ///\n            /// Equivalent to:\n            ///\n            /// ```ignore\n            /// async fn read_u8(&mut self) -> io::Result<u8>;\n            /// ```\n            ///\n            /// It is recommended to use a buffered reader to avoid excessive\n            /// syscalls.\n            ///\n            /// # Errors\n            ///\n            /// This method returns the same errors as [`AsyncReadExt::read_exact`].\n            ///\n            /// [`AsyncReadExt::read_exact`]: AsyncReadExt::read_exact\n            ///\n            /// # Cancel safety\n            ///\n            /// This method is cancel safe. If this method is used as an event in a\n            /// [`tokio::select!`](crate::select) statement and some other branch\n            /// completes first, it is guaranteed that no data were read.\n            ///\n            /// # Examples\n            ///\n            /// Read unsigned 8 bit integers from an `AsyncRead`:\n            ///\n            /// ```rust\n            /// use tokio::io::{self, AsyncReadExt};\n            ///\n            /// use std::io::Cursor;\n            ///\n            /// # #[tokio::main(flavor = \"current_thread\")]\n            /// # async fn main() -> io::Result<()> {\n            /// let mut reader = Cursor::new(vec![2, 5]);\n            ///\n            /// assert_eq!(2, reader.read_u8().await?);\n            /// assert_eq!(5, reader.read_u8().await?);\n            ///\n            /// Ok(())\n            /// # }\n            /// ```\n            fn read_u8(&mut self) -> ReadU8;\n\n            /// Reads a signed 8 bit integer from the underlying reader.\n            ///\n            /// Equivalent to:\n            ///\n            /// ```ignore\n            /// async fn read_i8(&mut self) -> io::Result<i8>;\n            /// ```\n            ///\n            /// It is recommended to use a buffered reader to avoid excessive\n            /// syscalls.\n            ///\n            /// # Errors\n            ///\n            /// This method returns the same errors as [`AsyncReadExt::read_exact`].\n            ///\n            /// [`AsyncReadExt::read_exact`]: AsyncReadExt::read_exact\n            ///\n            /// # Cancel safety\n            ///\n            /// This method is cancel safe. If this method is used as an event in a\n            /// [`tokio::select!`](crate::select) statement and some other branch\n            /// completes first, it is guaranteed that no data were read.\n            ///\n            /// # Examples\n            ///\n            /// Read unsigned 8 bit integers from an `AsyncRead`:\n            ///\n            /// ```rust\n            /// use tokio::io::{self, AsyncReadExt};\n            ///\n            /// use std::io::Cursor;\n            ///\n            /// # #[tokio::main(flavor = \"current_thread\")]\n            /// # async fn main() -> io::Result<()> {\n            /// let mut reader = Cursor::new(vec![0x02, 0xfb]);\n            ///\n            /// assert_eq!(2, reader.read_i8().await?);\n            /// assert_eq!(-5, reader.read_i8().await?);\n            ///\n            /// Ok(())\n            /// # }\n            /// ```\n            fn read_i8(&mut self) -> ReadI8;\n\n            /// Reads an unsigned 16-bit integer in big-endian order from the\n            /// underlying reader.\n            ///\n            /// Equivalent to:\n            ///\n            /// ```ignore\n            /// async fn read_u16(&mut self) -> io::Result<u16>;\n            /// ```\n            ///\n            /// It is recommended to use a buffered reader to avoid excessive\n            /// syscalls.\n            ///\n            /// # Errors\n            ///\n            /// This method returns the same errors as [`AsyncReadExt::read_exact`].\n            ///\n            /// [`AsyncReadExt::read_exact`]: AsyncReadExt::read_exact\n            ///\n            /// # Cancel safety\n            ///\n            /// This method is not cancellation safe. If the method is used as the\n            /// event in a [`tokio::select!`](crate::select) statement and some\n            /// other branch completes first, then some data may be lost.\n            ///\n            /// # Examples\n            ///\n            /// Read unsigned 16 bit big-endian integers from a `AsyncRead`:\n            ///\n            /// ```rust\n            /// use tokio::io::{self, AsyncReadExt};\n            ///\n            /// use std::io::Cursor;\n            ///\n            /// # #[tokio::main(flavor = \"current_thread\")]\n            /// # async fn main() -> io::Result<()> {\n            /// let mut reader = Cursor::new(vec![2, 5, 3, 0]);\n            ///\n            /// assert_eq!(517, reader.read_u16().await?);\n            /// assert_eq!(768, reader.read_u16().await?);\n            /// Ok(())\n            /// # }\n            /// ```\n            fn read_u16(&mut self) -> ReadU16;\n\n            /// Reads a signed 16-bit integer in big-endian order from the\n            /// underlying reader.\n            ///\n            /// Equivalent to:\n            ///\n            /// ```ignore\n            /// async fn read_i16(&mut self) -> io::Result<i16>;\n            /// ```\n            ///\n            /// It is recommended to use a buffered reader to avoid excessive\n            /// syscalls.\n            ///\n            /// # Errors\n            ///\n            /// This method returns the same errors as [`AsyncReadExt::read_exact`].\n            ///\n            /// [`AsyncReadExt::read_exact`]: AsyncReadExt::read_exact\n            ///\n            /// # Cancel safety\n            ///\n            /// This method is not cancellation safe. If the method is used as the\n            /// event in a [`tokio::select!`](crate::select) statement and some\n            /// other branch completes first, then some data may be lost.\n            ///\n            /// # Examples\n            ///\n            /// Read signed 16 bit big-endian integers from a `AsyncRead`:\n            ///\n            /// ```rust\n            /// use tokio::io::{self, AsyncReadExt};\n            ///\n            /// use std::io::Cursor;\n            ///\n            /// # #[tokio::main(flavor = \"current_thread\")]\n            /// # async fn main() -> io::Result<()> {\n            /// let mut reader = Cursor::new(vec![0x00, 0xc1, 0xff, 0x7c]);\n            ///\n            /// assert_eq!(193, reader.read_i16().await?);\n            /// assert_eq!(-132, reader.read_i16().await?);\n            /// Ok(())\n            /// # }\n            /// ```\n            fn read_i16(&mut self) -> ReadI16;\n\n            /// Reads an unsigned 32-bit integer in big-endian order from the\n            /// underlying reader.\n            ///\n            /// Equivalent to:\n            ///\n            /// ```ignore\n            /// async fn read_u32(&mut self) -> io::Result<u32>;\n            /// ```\n            ///\n            /// It is recommended to use a buffered reader to avoid excessive\n            /// syscalls.\n            ///\n            /// # Errors\n            ///\n            /// This method returns the same errors as [`AsyncReadExt::read_exact`].\n            ///\n            /// [`AsyncReadExt::read_exact`]: AsyncReadExt::read_exact\n            ///\n            /// # Cancel safety\n            ///\n            /// This method is not cancellation safe. If the method is used as the\n            /// event in a [`tokio::select!`](crate::select) statement and some\n            /// other branch completes first, then some data may be lost.\n            ///\n            /// # Examples\n            ///\n            /// Read unsigned 32-bit big-endian integers from a `AsyncRead`:\n            ///\n            /// ```rust\n            /// use tokio::io::{self, AsyncReadExt};\n            ///\n            /// use std::io::Cursor;\n            ///\n            /// # #[tokio::main(flavor = \"current_thread\")]\n            /// # async fn main() -> io::Result<()> {\n            /// let mut reader = Cursor::new(vec![0x00, 0x00, 0x01, 0x0b]);\n            ///\n            /// assert_eq!(267, reader.read_u32().await?);\n            /// Ok(())\n            /// # }\n            /// ```\n            fn read_u32(&mut self) -> ReadU32;\n\n            /// Reads a signed 32-bit integer in big-endian order from the\n            /// underlying reader.\n            ///\n            ///\n            /// Equivalent to:\n            ///\n            /// ```ignore\n            /// async fn read_i32(&mut self) -> io::Result<i32>;\n            /// ```\n            ///\n            /// It is recommended to use a buffered reader to avoid excessive\n            /// syscalls.\n            ///\n            /// # Errors\n            ///\n            /// This method returns the same errors as [`AsyncReadExt::read_exact`].\n            ///\n            /// [`AsyncReadExt::read_exact`]: AsyncReadExt::read_exact\n            ///\n            /// # Cancel safety\n            ///\n            /// This method is not cancellation safe. If the method is used as the\n            /// event in a [`tokio::select!`](crate::select) statement and some\n            /// other branch completes first, then some data may be lost.\n            ///\n            /// # Examples\n            ///\n            /// Read signed 32-bit big-endian integers from a `AsyncRead`:\n            ///\n            /// ```rust\n            /// use tokio::io::{self, AsyncReadExt};\n            ///\n            /// use std::io::Cursor;\n            ///\n            /// # #[tokio::main(flavor = \"current_thread\")]\n            /// # async fn main() -> io::Result<()> {\n            /// let mut reader = Cursor::new(vec![0xff, 0xff, 0x7a, 0x33]);\n            ///\n            /// assert_eq!(-34253, reader.read_i32().await?);\n            /// Ok(())\n            /// # }\n            /// ```\n            fn read_i32(&mut self) -> ReadI32;\n\n            /// Reads an unsigned 64-bit integer in big-endian order from the\n            /// underlying reader.\n            ///\n            /// Equivalent to:\n            ///\n            /// ```ignore\n            /// async fn read_u64(&mut self) -> io::Result<u64>;\n            /// ```\n            ///\n            /// It is recommended to use a buffered reader to avoid excessive\n            /// syscalls.\n            ///\n            /// # Errors\n            ///\n            /// This method returns the same errors as [`AsyncReadExt::read_exact`].\n            ///\n            /// [`AsyncReadExt::read_exact`]: AsyncReadExt::read_exact\n            ///\n            /// # Cancel safety\n            ///\n            /// This method is not cancellation safe. If the method is used as the\n            /// event in a [`tokio::select!`](crate::select) statement and some\n            /// other branch completes first, then some data may be lost.\n            ///\n            /// # Examples\n            ///\n            /// Read unsigned 64-bit big-endian integers from a `AsyncRead`:\n            ///\n            /// ```rust\n            /// use tokio::io::{self, AsyncReadExt};\n            ///\n            /// use std::io::Cursor;\n            ///\n            /// # #[tokio::main(flavor = \"current_thread\")]\n            /// # async fn main() -> io::Result<()> {\n            /// let mut reader = Cursor::new(vec![\n            ///     0x00, 0x03, 0x43, 0x95, 0x4d, 0x60, 0x86, 0x83\n            /// ]);\n            ///\n            /// assert_eq!(918733457491587, reader.read_u64().await?);\n            /// Ok(())\n            /// # }\n            /// ```\n            fn read_u64(&mut self) -> ReadU64;\n\n            /// Reads an signed 64-bit integer in big-endian order from the\n            /// underlying reader.\n            ///\n            /// Equivalent to:\n            ///\n            /// ```ignore\n            /// async fn read_i64(&mut self) -> io::Result<i64>;\n            /// ```\n            ///\n            /// It is recommended to use a buffered reader to avoid excessive\n            /// syscalls.\n            ///\n            /// # Errors\n            ///\n            /// This method returns the same errors as [`AsyncReadExt::read_exact`].\n            ///\n            /// [`AsyncReadExt::read_exact`]: AsyncReadExt::read_exact\n            ///\n            /// # Cancel safety\n            ///\n            /// This method is not cancellation safe. If the method is used as the\n            /// event in a [`tokio::select!`](crate::select) statement and some\n            /// other branch completes first, then some data may be lost.\n            ///\n            /// # Examples\n            ///\n            /// Read signed 64-bit big-endian integers from a `AsyncRead`:\n            ///\n            /// ```rust\n            /// use tokio::io::{self, AsyncReadExt};\n            ///\n            /// use std::io::Cursor;\n            ///\n            /// # #[tokio::main(flavor = \"current_thread\")]\n            /// # async fn main() -> io::Result<()> {\n            /// let mut reader = Cursor::new(vec![0x80, 0, 0, 0, 0, 0, 0, 0]);\n            ///\n            /// assert_eq!(i64::MIN, reader.read_i64().await?);\n            /// Ok(())\n            /// # }\n            /// ```\n            fn read_i64(&mut self) -> ReadI64;\n\n            /// Reads an unsigned 128-bit integer in big-endian order from the\n            /// underlying reader.\n            ///\n            /// Equivalent to:\n            ///\n            /// ```ignore\n            /// async fn read_u128(&mut self) -> io::Result<u128>;\n            /// ```\n            ///\n            /// It is recommended to use a buffered reader to avoid excessive\n            /// syscalls.\n            ///\n            /// # Errors\n            ///\n            /// This method returns the same errors as [`AsyncReadExt::read_exact`].\n            ///\n            /// [`AsyncReadExt::read_exact`]: AsyncReadExt::read_exact\n            ///\n            /// # Cancel safety\n            ///\n            /// This method is not cancellation safe. If the method is used as the\n            /// event in a [`tokio::select!`](crate::select) statement and some\n            /// other branch completes first, then some data may be lost.\n            ///\n            /// # Examples\n            ///\n            /// Read unsigned 128-bit big-endian integers from a `AsyncRead`:\n            ///\n            /// ```rust\n            /// use tokio::io::{self, AsyncReadExt};\n            ///\n            /// use std::io::Cursor;\n            ///\n            /// # #[tokio::main(flavor = \"current_thread\")]\n            /// # async fn main() -> io::Result<()> {\n            /// let mut reader = Cursor::new(vec![\n            ///         0x00, 0x03, 0x43, 0x95, 0x4d, 0x60, 0x86, 0x83,\n            ///     0x00, 0x03, 0x43, 0x95, 0x4d, 0x60, 0x86, 0x83\n            /// ]);\n            ///\n            /// assert_eq!(16947640962301618749969007319746179, reader.read_u128().await?);\n            /// Ok(())\n            /// # }\n            /// ```\n            fn read_u128(&mut self) -> ReadU128;\n\n            /// Reads an signed 128-bit integer in big-endian order from the\n            /// underlying reader.\n            ///\n            /// Equivalent to:\n            ///\n            /// ```ignore\n            /// async fn read_i128(&mut self) -> io::Result<i128>;\n            /// ```\n            ///\n            /// It is recommended to use a buffered reader to avoid excessive\n            /// syscalls.\n            ///\n            /// # Errors\n            ///\n            /// This method returns the same errors as [`AsyncReadExt::read_exact`].\n            ///\n            /// [`AsyncReadExt::read_exact`]: AsyncReadExt::read_exact\n            ///\n            /// # Cancel safety\n            ///\n            /// This method is not cancellation safe. If the method is used as the\n            /// event in a [`tokio::select!`](crate::select) statement and some\n            /// other branch completes first, then some data may be lost.\n            ///\n            /// # Examples\n            ///\n            /// Read signed 128-bit big-endian integers from a `AsyncRead`:\n            ///\n            /// ```rust\n            /// use tokio::io::{self, AsyncReadExt};\n            ///\n            /// use std::io::Cursor;\n            ///\n            /// # #[tokio::main(flavor = \"current_thread\")]\n            /// # async fn main() -> io::Result<()> {\n            /// let mut reader = Cursor::new(vec![\n            ///     0x80, 0, 0, 0, 0, 0, 0, 0,\n            ///     0, 0, 0, 0, 0, 0, 0, 0\n            /// ]);\n            ///\n            /// assert_eq!(i128::MIN, reader.read_i128().await?);\n            /// Ok(())\n            /// # }\n            /// ```\n            fn read_i128(&mut self) -> ReadI128;\n\n            /// Reads an 32-bit floating point type in big-endian order from the\n            /// underlying reader.\n            ///\n            /// Equivalent to:\n            ///\n            /// ```ignore\n            /// async fn read_f32(&mut self) -> io::Result<f32>;\n            /// ```\n            ///\n            /// It is recommended to use a buffered reader to avoid excessive\n            /// syscalls.\n            ///\n            /// # Errors\n            ///\n            /// This method returns the same errors as [`AsyncReadExt::read_exact`].\n            ///\n            /// [`AsyncReadExt::read_exact`]: AsyncReadExt::read_exact\n            ///\n            /// # Cancel safety\n            ///\n            /// This method is not cancellation safe. If the method is used as the\n            /// event in a [`tokio::select!`](crate::select) statement and some\n            /// other branch completes first, then some data may be lost.\n            ///\n            /// # Examples\n            ///\n            /// Read 32-bit floating point type from a `AsyncRead`:\n            ///\n            /// ```rust\n            /// use tokio::io::{self, AsyncReadExt};\n            ///\n            /// use std::io::Cursor;\n            ///\n            /// # #[tokio::main(flavor = \"current_thread\")]\n            /// # async fn main() -> io::Result<()> {\n            /// let mut reader = Cursor::new(vec![0xff, 0x7f, 0xff, 0xff]);\n            ///\n            /// assert_eq!(f32::MIN, reader.read_f32().await?);\n            /// Ok(())\n            /// # }\n            /// ```\n            fn read_f32(&mut self) -> ReadF32;\n\n            /// Reads an 64-bit floating point type in big-endian order from the\n            /// underlying reader.\n            ///\n            /// Equivalent to:\n            ///\n            /// ```ignore\n            /// async fn read_f64(&mut self) -> io::Result<f64>;\n            /// ```\n            ///\n            /// It is recommended to use a buffered reader to avoid excessive\n            /// syscalls.\n            ///\n            /// # Errors\n            ///\n            /// This method returns the same errors as [`AsyncReadExt::read_exact`].\n            ///\n            /// [`AsyncReadExt::read_exact`]: AsyncReadExt::read_exact\n            ///\n            /// # Cancel safety\n            ///\n            /// This method is not cancellation safe. If the method is used as the\n            /// event in a [`tokio::select!`](crate::select) statement and some\n            /// other branch completes first, then some data may be lost.\n            ///\n            /// # Examples\n            ///\n            /// Read 64-bit floating point type from a `AsyncRead`:\n            ///\n            /// ```rust\n            /// use tokio::io::{self, AsyncReadExt};\n            ///\n            /// use std::io::Cursor;\n            ///\n            /// # #[tokio::main(flavor = \"current_thread\")]\n            /// # async fn main() -> io::Result<()> {\n            /// let mut reader = Cursor::new(vec![\n            ///     0xff, 0xef, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff\n            /// ]);\n            ///\n            /// assert_eq!(f64::MIN, reader.read_f64().await?);\n            /// Ok(())\n            /// # }\n            /// ```\n            fn read_f64(&mut self) -> ReadF64;\n\n            /// Reads an unsigned 16-bit integer in little-endian order from the\n            /// underlying reader.\n            ///\n            /// Equivalent to:\n            ///\n            /// ```ignore\n            /// async fn read_u16_le(&mut self) -> io::Result<u16>;\n            /// ```\n            ///\n            /// It is recommended to use a buffered reader to avoid excessive\n            /// syscalls.\n            ///\n            /// # Errors\n            ///\n            /// This method returns the same errors as [`AsyncReadExt::read_exact`].\n            ///\n            /// [`AsyncReadExt::read_exact`]: AsyncReadExt::read_exact\n            ///\n            /// # Cancel safety\n            ///\n            /// This method is not cancellation safe. If the method is used as the\n            /// event in a [`tokio::select!`](crate::select) statement and some\n            /// other branch completes first, then some data may be lost.\n            ///\n            /// # Examples\n            ///\n            /// Read unsigned 16 bit little-endian integers from a `AsyncRead`:\n            ///\n            /// ```rust\n            /// use tokio::io::{self, AsyncReadExt};\n            ///\n            /// use std::io::Cursor;\n            ///\n            /// # #[tokio::main(flavor = \"current_thread\")]\n            /// # async fn main() -> io::Result<()> {\n            /// let mut reader = Cursor::new(vec![2, 5, 3, 0]);\n            ///\n            /// assert_eq!(1282, reader.read_u16_le().await?);\n            /// assert_eq!(3, reader.read_u16_le().await?);\n            /// Ok(())\n            /// # }\n            /// ```\n            fn read_u16_le(&mut self) -> ReadU16Le;\n\n            /// Reads a signed 16-bit integer in little-endian order from the\n            /// underlying reader.\n            ///\n            /// Equivalent to:\n            ///\n            /// ```ignore\n            /// async fn read_i16_le(&mut self) -> io::Result<i16>;\n            /// ```\n            ///\n            /// It is recommended to use a buffered reader to avoid excessive\n            /// syscalls.\n            ///\n            /// # Errors\n            ///\n            /// This method returns the same errors as [`AsyncReadExt::read_exact`].\n            ///\n            /// [`AsyncReadExt::read_exact`]: AsyncReadExt::read_exact\n            ///\n            /// # Cancel safety\n            ///\n            /// This method is not cancellation safe. If the method is used as the\n            /// event in a [`tokio::select!`](crate::select) statement and some\n            /// other branch completes first, then some data may be lost.\n            ///\n            /// # Examples\n            ///\n            /// Read signed 16 bit little-endian integers from a `AsyncRead`:\n            ///\n            /// ```rust\n            /// use tokio::io::{self, AsyncReadExt};\n            ///\n            /// use std::io::Cursor;\n            ///\n            /// # #[tokio::main(flavor = \"current_thread\")]\n            /// # async fn main() -> io::Result<()> {\n            /// let mut reader = Cursor::new(vec![0x00, 0xc1, 0xff, 0x7c]);\n            ///\n            /// assert_eq!(-16128, reader.read_i16_le().await?);\n            /// assert_eq!(31999, reader.read_i16_le().await?);\n            /// Ok(())\n            /// # }\n            /// ```\n            fn read_i16_le(&mut self) -> ReadI16Le;\n\n            /// Reads an unsigned 32-bit integer in little-endian order from the\n            /// underlying reader.\n            ///\n            /// Equivalent to:\n            ///\n            /// ```ignore\n            /// async fn read_u32_le(&mut self) -> io::Result<u32>;\n            /// ```\n            ///\n            /// It is recommended to use a buffered reader to avoid excessive\n            /// syscalls.\n            ///\n            /// # Errors\n            ///\n            /// This method returns the same errors as [`AsyncReadExt::read_exact`].\n            ///\n            /// [`AsyncReadExt::read_exact`]: AsyncReadExt::read_exact\n            ///\n            /// # Cancel safety\n            ///\n            /// This method is not cancellation safe. If the method is used as the\n            /// event in a [`tokio::select!`](crate::select) statement and some\n            /// other branch completes first, then some data may be lost.\n            ///\n            /// # Examples\n            ///\n            /// Read unsigned 32-bit little-endian integers from a `AsyncRead`:\n            ///\n            /// ```rust\n            /// use tokio::io::{self, AsyncReadExt};\n            ///\n            /// use std::io::Cursor;\n            ///\n            /// # #[tokio::main(flavor = \"current_thread\")]\n            /// # async fn main() -> io::Result<()> {\n            /// let mut reader = Cursor::new(vec![0x00, 0x00, 0x01, 0x0b]);\n            ///\n            /// assert_eq!(184614912, reader.read_u32_le().await?);\n            /// Ok(())\n            /// # }\n            /// ```\n            fn read_u32_le(&mut self) -> ReadU32Le;\n\n            /// Reads a signed 32-bit integer in little-endian order from the\n            /// underlying reader.\n            ///\n            ///\n            /// Equivalent to:\n            ///\n            /// ```ignore\n            /// async fn read_i32_le(&mut self) -> io::Result<i32>;\n            /// ```\n            ///\n            /// It is recommended to use a buffered reader to avoid excessive\n            /// syscalls.\n            ///\n            /// # Errors\n            ///\n            /// This method returns the same errors as [`AsyncReadExt::read_exact`].\n            ///\n            /// [`AsyncReadExt::read_exact`]: AsyncReadExt::read_exact\n            ///\n            /// # Cancel safety\n            ///\n            /// This method is not cancellation safe. If the method is used as the\n            /// event in a [`tokio::select!`](crate::select) statement and some\n            /// other branch completes first, then some data may be lost.\n            ///\n            /// # Examples\n            ///\n            /// Read signed 32-bit little-endian integers from a `AsyncRead`:\n            ///\n            /// ```rust\n            /// use tokio::io::{self, AsyncReadExt};\n            ///\n            /// use std::io::Cursor;\n            ///\n            /// # #[tokio::main(flavor = \"current_thread\")]\n            /// # async fn main() -> io::Result<()> {\n            /// let mut reader = Cursor::new(vec![0xff, 0xff, 0x7a, 0x33]);\n            ///\n            /// assert_eq!(863698943, reader.read_i32_le().await?);\n            /// Ok(())\n            /// # }\n            /// ```\n            fn read_i32_le(&mut self) -> ReadI32Le;\n\n            /// Reads an unsigned 64-bit integer in little-endian order from the\n            /// underlying reader.\n            ///\n            /// Equivalent to:\n            ///\n            /// ```ignore\n            /// async fn read_u64_le(&mut self) -> io::Result<u64>;\n            /// ```\n            ///\n            /// It is recommended to use a buffered reader to avoid excessive\n            /// syscalls.\n            ///\n            /// # Errors\n            ///\n            /// This method returns the same errors as [`AsyncReadExt::read_exact`].\n            ///\n            /// [`AsyncReadExt::read_exact`]: AsyncReadExt::read_exact\n            ///\n            /// # Cancel safety\n            ///\n            /// This method is not cancellation safe. If the method is used as the\n            /// event in a [`tokio::select!`](crate::select) statement and some\n            /// other branch completes first, then some data may be lost.\n            ///\n            /// # Examples\n            ///\n            /// Read unsigned 64-bit little-endian integers from a `AsyncRead`:\n            ///\n            /// ```rust\n            /// use tokio::io::{self, AsyncReadExt};\n            ///\n            /// use std::io::Cursor;\n            ///\n            /// # #[tokio::main(flavor = \"current_thread\")]\n            /// # async fn main() -> io::Result<()> {\n            /// let mut reader = Cursor::new(vec![\n            ///     0x00, 0x03, 0x43, 0x95, 0x4d, 0x60, 0x86, 0x83\n            /// ]);\n            ///\n            /// assert_eq!(9477368352180732672, reader.read_u64_le().await?);\n            /// Ok(())\n            /// # }\n            /// ```\n            fn read_u64_le(&mut self) -> ReadU64Le;\n\n            /// Reads an signed 64-bit integer in little-endian order from the\n            /// underlying reader.\n            ///\n            /// Equivalent to:\n            ///\n            /// ```ignore\n            /// async fn read_i64_le(&mut self) -> io::Result<i64>;\n            /// ```\n            ///\n            /// It is recommended to use a buffered reader to avoid excessive\n            /// syscalls.\n            ///\n            /// # Errors\n            ///\n            /// This method returns the same errors as [`AsyncReadExt::read_exact`].\n            ///\n            /// [`AsyncReadExt::read_exact`]: AsyncReadExt::read_exact\n            ///\n            /// # Cancel safety\n            ///\n            /// This method is not cancellation safe. If the method is used as the\n            /// event in a [`tokio::select!`](crate::select) statement and some\n            /// other branch completes first, then some data may be lost.\n            ///\n            /// # Examples\n            ///\n            /// Read signed 64-bit little-endian integers from a `AsyncRead`:\n            ///\n            /// ```rust\n            /// use tokio::io::{self, AsyncReadExt};\n            ///\n            /// use std::io::Cursor;\n            ///\n            /// # #[tokio::main(flavor = \"current_thread\")]\n            /// # async fn main() -> io::Result<()> {\n            /// let mut reader = Cursor::new(vec![0x80, 0, 0, 0, 0, 0, 0, 0]);\n            ///\n            /// assert_eq!(128, reader.read_i64_le().await?);\n            /// Ok(())\n            /// # }\n            /// ```\n            fn read_i64_le(&mut self) -> ReadI64Le;\n\n            /// Reads an unsigned 128-bit integer in little-endian order from the\n            /// underlying reader.\n            ///\n            /// Equivalent to:\n            ///\n            /// ```ignore\n            /// async fn read_u128_le(&mut self) -> io::Result<u128>;\n            /// ```\n            ///\n            /// It is recommended to use a buffered reader to avoid excessive\n            /// syscalls.\n            ///\n            /// # Errors\n            ///\n            /// This method returns the same errors as [`AsyncReadExt::read_exact`].\n            ///\n            /// [`AsyncReadExt::read_exact`]: AsyncReadExt::read_exact\n            ///\n            /// # Cancel safety\n            ///\n            /// This method is not cancellation safe. If the method is used as the\n            /// event in a [`tokio::select!`](crate::select) statement and some\n            /// other branch completes first, then some data may be lost.\n            ///\n            /// # Examples\n            ///\n            /// Read unsigned 128-bit little-endian integers from a `AsyncRead`:\n            ///\n            /// ```rust\n            /// use tokio::io::{self, AsyncReadExt};\n            ///\n            /// use std::io::Cursor;\n            ///\n            /// # #[tokio::main(flavor = \"current_thread\")]\n            /// # async fn main() -> io::Result<()> {\n            /// let mut reader = Cursor::new(vec![\n            ///     0x00, 0x03, 0x43, 0x95, 0x4d, 0x60, 0x86, 0x83,\n            ///     0x00, 0x03, 0x43, 0x95, 0x4d, 0x60, 0x86, 0x83\n            /// ]);\n            ///\n            /// assert_eq!(174826588484952389081207917399662330624, reader.read_u128_le().await?);\n            /// Ok(())\n            /// # }\n            /// ```\n            fn read_u128_le(&mut self) -> ReadU128Le;\n\n            /// Reads an signed 128-bit integer in little-endian order from the\n            /// underlying reader.\n            ///\n            /// Equivalent to:\n            ///\n            /// ```ignore\n            /// async fn read_i128_le(&mut self) -> io::Result<i128>;\n            /// ```\n            ///\n            /// It is recommended to use a buffered reader to avoid excessive\n            /// syscalls.\n            ///\n            /// # Errors\n            ///\n            /// This method returns the same errors as [`AsyncReadExt::read_exact`].\n            ///\n            /// [`AsyncReadExt::read_exact`]: AsyncReadExt::read_exact\n            ///\n            /// # Cancel safety\n            ///\n            /// This method is not cancellation safe. If the method is used as the\n            /// event in a [`tokio::select!`](crate::select) statement and some\n            /// other branch completes first, then some data may be lost.\n            ///\n            /// # Examples\n            ///\n            /// Read signed 128-bit little-endian integers from a `AsyncRead`:\n            ///\n            /// ```rust\n            /// use tokio::io::{self, AsyncReadExt};\n            ///\n            /// use std::io::Cursor;\n            ///\n            /// # #[tokio::main(flavor = \"current_thread\")]\n            /// # async fn main() -> io::Result<()> {\n            /// let mut reader = Cursor::new(vec![\n            ///     0x80, 0, 0, 0, 0, 0, 0, 0,\n            ///     0, 0, 0, 0, 0, 0, 0, 0\n            /// ]);\n            ///\n            /// assert_eq!(128, reader.read_i128_le().await?);\n            /// Ok(())\n            /// # }\n            /// ```\n            fn read_i128_le(&mut self) -> ReadI128Le;\n\n            /// Reads an 32-bit floating point type in little-endian order from the\n            /// underlying reader.\n            ///\n            /// Equivalent to:\n            ///\n            /// ```ignore\n            /// async fn read_f32_le(&mut self) -> io::Result<f32>;\n            /// ```\n            ///\n            /// It is recommended to use a buffered reader to avoid excessive\n            /// syscalls.\n            ///\n            /// # Errors\n            ///\n            /// This method returns the same errors as [`AsyncReadExt::read_exact`].\n            ///\n            /// [`AsyncReadExt::read_exact`]: AsyncReadExt::read_exact\n            ///\n            /// # Cancel safety\n            ///\n            /// This method is not cancellation safe. If the method is used as the\n            /// event in a [`tokio::select!`](crate::select) statement and some\n            /// other branch completes first, then some data may be lost.\n            ///\n            /// # Examples\n            ///\n            /// Read 32-bit floating point type from a `AsyncRead`:\n            ///\n            /// ```rust\n            /// use tokio::io::{self, AsyncReadExt};\n            ///\n            /// use std::io::Cursor;\n            ///\n            /// # #[tokio::main(flavor = \"current_thread\")]\n            /// # async fn main() -> io::Result<()> {\n            /// let mut reader = Cursor::new(vec![0xff, 0xff, 0x7f, 0xff]);\n            ///\n            /// assert_eq!(f32::MIN, reader.read_f32_le().await?);\n            /// Ok(())\n            /// # }\n            /// ```\n            fn read_f32_le(&mut self) -> ReadF32Le;\n\n            /// Reads an 64-bit floating point type in little-endian order from the\n            /// underlying reader.\n            ///\n            /// Equivalent to:\n            ///\n            /// ```ignore\n            /// async fn read_f64_le(&mut self) -> io::Result<f64>;\n            /// ```\n            ///\n            /// It is recommended to use a buffered reader to avoid excessive\n            /// syscalls.\n            ///\n            /// # Errors\n            ///\n            /// This method returns the same errors as [`AsyncReadExt::read_exact`].\n            ///\n            /// [`AsyncReadExt::read_exact`]: AsyncReadExt::read_exact\n            ///\n            /// # Cancel safety\n            ///\n            /// This method is not cancellation safe. If the method is used as the\n            /// event in a [`tokio::select!`](crate::select) statement and some\n            /// other branch completes first, then some data may be lost.\n            ///\n            /// # Examples\n            ///\n            /// Read 64-bit floating point type from a `AsyncRead`:\n            ///\n            /// ```rust\n            /// use tokio::io::{self, AsyncReadExt};\n            ///\n            /// use std::io::Cursor;\n            ///\n            /// # #[tokio::main(flavor = \"current_thread\")]\n            /// # async fn main() -> io::Result<()> {\n            /// let mut reader = Cursor::new(vec![\n            ///     0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xef, 0xff\n            /// ]);\n            ///\n            /// assert_eq!(f64::MIN, reader.read_f64_le().await?);\n            /// Ok(())\n            /// # }\n            /// ```\n            fn read_f64_le(&mut self) -> ReadF64Le;\n        }\n\n        /// Reads all bytes until EOF in this source, placing them into `buf`.\n        ///\n        /// Equivalent to:\n        ///\n        /// ```ignore\n        /// async fn read_to_end(&mut self, buf: &mut Vec<u8>) -> io::Result<usize>;\n        /// ```\n        ///\n        /// All bytes read from this source will be appended to the specified\n        /// buffer `buf`. This function will continuously call [`read()`] to\n        /// append more data to `buf` until [`read()`] returns `Ok(0)`.\n        ///\n        /// If successful, the total number of bytes read is returned.\n        ///\n        /// [`read()`]: AsyncReadExt::read\n        ///\n        /// # Errors\n        ///\n        /// If a read error is encountered then the `read_to_end` operation\n        /// immediately completes. Any bytes which have already been read will\n        /// be appended to `buf`.\n        ///\n        /// # Examples\n        ///\n        /// [`File`][crate::fs::File]s implement `Read`:\n        ///\n        /// ```no_run\n        /// # #[cfg(not(target_family = \"wasm\"))]\n        /// # {\n        /// use tokio::io::{self, AsyncReadExt};\n        /// use tokio::fs::File;\n        ///\n        /// #[tokio::main]\n        /// async fn main() -> io::Result<()> {\n        ///     let mut f = File::open(\"foo.txt\").await?;\n        ///     let mut buffer = Vec::new();\n        ///\n        ///     // read the whole file\n        ///     f.read_to_end(&mut buffer).await?;\n        ///     Ok(())\n        /// }\n        /// # }\n        /// ```\n        ///\n        /// (See also the [`tokio::fs::read`] convenience function for reading from a\n        /// file.)\n        ///\n        /// [`tokio::fs::read`]: fn@crate::fs::read\n        fn read_to_end<'a>(&'a mut self, buf: &'a mut Vec<u8>) -> ReadToEnd<'a, Self>\n        where\n            Self: Unpin,\n        {\n            read_to_end(self, buf)\n        }\n\n        /// Reads all bytes until EOF in this source, appending them to `buf`.\n        ///\n        /// Equivalent to:\n        ///\n        /// ```ignore\n        /// async fn read_to_string(&mut self, buf: &mut String) -> io::Result<usize>;\n        /// ```\n        ///\n        /// If successful, the number of bytes which were read and appended to\n        /// `buf` is returned.\n        ///\n        /// # Errors\n        ///\n        /// If the data in this stream is *not* valid UTF-8 then an error is\n        /// returned and `buf` is unchanged.\n        ///\n        /// See [`read_to_end`][AsyncReadExt::read_to_end] for other error semantics.\n        ///\n        /// # Examples\n        ///\n        /// [`File`][crate::fs::File]s implement `Read`:\n        ///\n        /// ```no_run\n        /// # #[cfg(not(target_family = \"wasm\"))]\n        /// # {\n        /// use tokio::io::{self, AsyncReadExt};\n        /// use tokio::fs::File;\n        ///\n        /// #[tokio::main]\n        /// async fn main() -> io::Result<()> {\n        ///     let mut f = File::open(\"foo.txt\").await?;\n        ///     let mut buffer = String::new();\n        ///\n        ///     f.read_to_string(&mut buffer).await?;\n        ///     Ok(())\n        /// }\n        /// # }\n        /// ```\n        ///\n        /// (See also the [`crate::fs::read_to_string`] convenience function for\n        /// reading from a file.)\n        ///\n        /// [`crate::fs::read_to_string`]: fn@crate::fs::read_to_string\n        fn read_to_string<'a>(&'a mut self, dst: &'a mut String) -> ReadToString<'a, Self>\n        where\n            Self: Unpin,\n        {\n            read_to_string(self, dst)\n        }\n\n        /// Creates an adaptor which reads at most `limit` bytes from it.\n        ///\n        /// This function returns a new instance of `AsyncRead` which will read\n        /// at most `limit` bytes, after which it will always return EOF\n        /// (`Ok(0)`). Any read errors will not count towards the number of\n        /// bytes read and future calls to [`read()`] may succeed.\n        ///\n        /// [`read()`]: fn@crate::io::AsyncReadExt::read\n        ///\n        /// [read]: AsyncReadExt::read\n        ///\n        /// # Examples\n        ///\n        /// [`File`][crate::fs::File]s implement `Read`:\n        ///\n        /// ```no_run\n        /// # #[cfg(not(target_family = \"wasm\"))]\n        /// # {\n        /// use tokio::io::{self, AsyncReadExt};\n        /// use tokio::fs::File;\n        ///\n        /// #[tokio::main]\n        /// async fn main() -> io::Result<()> {\n        ///     let f = File::open(\"foo.txt\").await?;\n        ///     let mut buffer = [0; 5];\n        ///\n        ///     // read at most five bytes\n        ///     let mut handle = f.take(5);\n        ///\n        ///     handle.read(&mut buffer).await?;\n        ///     Ok(())\n        /// }\n        /// # }\n        /// ```\n        fn take(self, limit: u64) -> Take<Self>\n        where\n            Self: Sized,\n        {\n            take(self, limit)\n        }\n    }\n}\n\nimpl<R: AsyncRead + ?Sized> AsyncReadExt for R {}\n";

},{}],"cDzyF":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("6pZPW");

},{}],"fWTUT":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("aqEHy");

},{}],"azG9c":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("7WyoC");

},{}],"i9tZV":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    for v in vec![1, 2, 3] {\n        // ...\n    }\n\n    let mut i = vec![1, 2, 3].into_iter();\n    while let Some(v) = i.next() {\n        // ...\n    }\n}\n";

},{}],"j1r0Q":[function(require,module,exports,__globalThis) {
module.exports = "fn do_thing_3_times<F>(thing: F)\nwhere\n    F: Fn(),\n{\n    thing();\n    thing();\n    thing();\n}\n\nfn main() {\n    do_thing_3_times(|| println!(\"Hello!\"));\n}\n";

},{}],"kE3Pq":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    for i in (0..10).map(|v| v * 2) {\n        println!(\"{i}\");\n    }\n}\n";

},{}],"96CT0":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    for i in (0..10).filter(|v| *v < 5) {\n        println!(\"{i}\");\n    }\n\n    for i in (0..10).filter(|v| v < &5) {\n        println!(\"{i}\");\n    }\n\n    for i in (0..10).filter(|&v| v < 5) {\n        println!(\"{i}\");\n    }\n}\n";

},{}],"4NBD0":[function(require,module,exports,__globalThis) {
module.exports = "use std::collections::{HashSet, LinkedList};\n\nfn main() {\n    let nums: Vec<_> = (0..10).collect();\n    let nums: HashSet<_> = (0..10).collect();\n    let nums: LinkedList<_> = (0..10).collect();\n}\n";

},{}],"7911h":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let nums: Vec<_> = (0..10).map(|x| x * x).filter(|&x| x <= 50).collect();\n    println!(\"{nums:?}\");\n}\n";

},{}],"aZ7lg":[function(require,module,exports,__globalThis) {
module.exports = "pub fn optimized() -> u32 {\n    (0..10).map(|x| x * x).filter(|&x| x < 50).sum()\n}\n\nfn main() {\n    println!(\"{}\", optimized());\n}\n";

},{}],"erTHK":[function(require,module,exports,__globalThis) {
module.exports = "fn avoid() {\n    let scores = vec![1, 2, 3];\n    for i in 0..scores.len() {\n        let v = scores[i];\n        println!(\"{v}\");\n    }\n}\n\nfn prefer() {\n    let scores = vec![1, 2, 3];\n    for v in &scores {\n        println!(\"{v}\");\n    }\n}\n\nfn main() {\n    avoid();\n    prefer();\n}\n";

},{}],"lR11Q":[function(require,module,exports,__globalThis) {
module.exports = "fn song_names() /* -> What type goes here? */ {\n    vec![\"crash\", \"wow\", \"my heart will go on\"]\n}\n\nfn short_song_names() /* -> What type goes here? */ {\n    song_names().filter(|name| name.len() < 5)\n}\n\nfn main() {\n    for name in short_song_names() {\n        println!(\"Listen to {name}\");\n    }\n}\n";

},{}],"f3Uew":[function(require,module,exports,__globalThis) {
module.exports = "fn song_names() {\n    vec![\"crash\", \"wow\", \"my heart will go on\"].into_iter()\n}\n\nfn short_song_names() /* -> What type goes here? */ {\n    song_names().filter(|name| name.len() < 5)\n}\n\nfn main() {\n    for name in short_song_names() {\n        println!(\"Listen to {name}\");\n    }\n}\n";

},{}],"Xkfn6":[function(require,module,exports,__globalThis) {
module.exports = "error[E0308]: mismatched types\n --> returning-iterators/src/main.rs:8:5\n  |\n8 |     vec![\"crash\", \"wow\", \"my heart will go on\"].into_iter()\n  |     ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^ expected `()`, found\n  |                                                             `IntoIter<&str>`\n  |\n  = note: expected unit type `()`\n                found struct `std::vec::IntoIter<&str>`\nhelp: consider using a semicolon here\n  |\n8 |     vec![\"crash\", \"wow\", \"my heart will go on\"].into_iter();\n  |                                                            +\nhelp: try adding a return type\n  |\n7 | fn song_names() -> std::vec::IntoIter<&str> {\n  |                 +++++++++++++++++++++++++++\n\nerror[E0599]: `()` is not an iterator\n  --> returning-iterators/src/main.rs:18:18\n   |\n18 |     song_names().filter(|name| name.len() < 5)\n   |                  ^^^^^^ `()` is not an iterator\n   |\n   = note: the following trait bounds were not satisfied:\n           `(): Iterator`\n           which is required by `&mut (): Iterator`\n\nerror[E0277]: `()` is not an iterator\n  --> returning-iterators/src/main.rs:37:17\n   |\n37 |     for name in short_song_names() {\n   |                 ^^^^^^^^^^^^^^^^^^ `()` is not an iterator\n   |\n   = help: the trait `Iterator` is not implemented for `()`\n   = note: required for `()` to implement `IntoIterator`\n\nSome errors have detailed explanations: E0277, E0308, E0599.\nFor more information about an error, try `rustc --explain E0277`.\nerror: could not compile `returning-iterators` (bin \"returning-iterators\") due to 3 previous\n       errors\n";

},{}],"8VIIu":[function(require,module,exports,__globalThis) {
module.exports = "fn song_names() -> std::vec::IntoIter<&'static str> {\n    vec![\"crash\", \"wow\", \"my heart will go on\"].into_iter()\n}\n\nfn short_song_names() /* -> What type goes here? */ {\n    song_names().filter(|name| name.len() < 5)\n}\n\nfn main() {\n    for name in short_song_names() {\n        println!(\"Listen to {name}\");\n    }\n}\n";

},{}],"bYvp1":[function(require,module,exports,__globalThis) {
module.exports = "fn song_names() -> std::vec::IntoIter<&'static str> {\n    vec![\"crash\", \"wow\", \"my heart will go on\"].into_iter()\n}\n\nfn short_song_names() {\n    song_names().filter(|name| name.len() < 5)\n}\n\nfn main() {\n    for name in short_song_names() {\n        println!(\"Listen to {name}\");\n    }\n}\n";

},{}],"ie6w9":[function(require,module,exports,__globalThis) {
module.exports = "error[E0308]: mismatched types\n  --> returning-iterators/src/main.rs:23:5\n   |\n23 |     song_names().filter(|name| name.len() < 5)\n   |     ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^ expected `()`, found\n   |                                                `Filter<IntoIter<&str>,\n   |                                                {closure@main.rs:23:25}>`\n   |\n   = note: expected unit type `()`\n                 found struct `Filter<std::vec::IntoIter<&str>,\n                 {closure@returning-iterators/src/main.rs:23:25: 23:31}>`\nhelp: consider using a semicolon here\n   |\n23 |     song_names().filter(|name| name.len() < 5);\n   |                                               +\nhelp: try adding a return type\n   |\n22 | fn short_song_names() -> impl Iterator<Item = &str> {\n   |                       +++++++++++++++++++++++++++++\n\nerror[E0277]: `()` is not an iterator\n  --> returning-iterators/src/main.rs:37:17\n   |\n37 |     for name in short_song_names() {\n   |                 ^^^^^^^^^^^^^^^^^^ `()` is not an iterator\n   |\n   = help: the trait `Iterator` is not implemented for `()`\n   = note: required for `()` to implement `IntoIterator`\n\nSome errors have detailed explanations: E0277, E0308.\nFor more information about an error, try `rustc --explain E0277`.\nerror: could not compile `returning-iterators` (bin \"returning-iterators\") due to 2 previous\n       errors\n";

},{}],"aBQuT":[function(require,module,exports,__globalThis) {
module.exports = "fn song_names() -> impl Iterator<Item = &'static str> {\n    vec![\"crash\", \"wow\", \"my heart will go on\"].into_iter()\n}\n\nfn short_song_names() -> impl Iterator<Item = &'static str> {\n    song_names().filter(|name| name.len() < 5)\n}\n\nfn main() {\n    for name in short_song_names() {\n        println!(\"Listen to {name}\");\n    }\n}\n";

},{}],"lsep9":[function(require,module,exports,__globalThis) {
module.exports = "fn song_names() -> impl Iterator<Item = &'static str> {\n    vec![\"crash\", \"wow\", \"my heart will go on\"].into_iter()\n}\n\nfn good_song_names(short: bool) -> impl Iterator<Item = &'static str> {\n    if short {\n        song_names().filter(|name| name.len() < 5)\n    } else {\n        song_names().filter(|name| name.len() > 5)\n    }\n}\n\nfn main() {\n    for name in good_song_names(true) {\n        println!(\"Listen to {name}\");\n    }\n}\n";

},{}],"gcKVD":[function(require,module,exports,__globalThis) {
module.exports = "error[E0308]: `if` and `else` have incompatible types\n  --> conditionally-returning-iterators/src/main.rs:10:9\n   |\n 1 |   fn song_names() -> impl Iterator<Item = &'static str> {\n   |                      ----------------------------------\n   |                      |\n   |                      the expected opaque type\n   |                      the found opaque type\n...\n 7 | /     if short {\n 8 | |         song_names().filter(|name| name.len() < 5)\n   | |         ------------------------------------------\n   | |         |                   |\n   | |         |                   the expected closure\n   | |         expected because of this\n 9 | |     } else {\n10 | |         song_names().filter(|name| name.len() > 5)\n   | |         ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^ expected closure, found a different\n   | |                                                    closure\n11 | |     }\n   | |_____- `if` and `else` have incompatible types\n   |\n   = note: expected struct `Filter<_,\n              {closure@conditionally-returning-iterators/src/main.rs:8:29: 8:35}>`\n              found struct `Filter<_,\n              {closure@conditionally-returning-iterators/src/main.rs:10:29: 10:35}>`\n   = note: no two closures, even if identical, have the same type\n   = help: consider boxing your closure and/or using it as a trait object\nhelp: you could change the return type to be a boxed trait object\n   |\n 6 - fn good_song_names(short: bool) -> impl Iterator<Item = &'static str> {\n 6 + fn good_song_names(short: bool) -> Box<dyn Iterator<Item = &'static str>> {\n   |\nhelp: if you change the return type to expect trait objects, box the returned expressions\n   |\n 8 ~         Box::new(song_names().filter(|name| name.len() < 5))\n 9 |     } else {\n10 ~         Box::new(song_names().filter(|name| name.len() > 5))\n   |\n\nFor more information about this error, try `rustc --explain E0308`.\nerror: could not compile `conditionally-returning-iterators` (bin\n       \"conditionally-returning-iterators\") due to 1 previous error\n";

},{}],"85CuL":[function(require,module,exports,__globalThis) {
module.exports = "fn song_names() -> impl Iterator<Item = &'static str> {\n    vec![\"crash\", \"wow\", \"my heart will go on\"].into_iter()\n}\n\nfn good_song_names(short: bool) -> Box<dyn Iterator<Item = &'static str>> {\n    if short {\n        Box::new(song_names().filter(|name| name.len() < 5))\n    } else {\n        Box::new(song_names().filter(|name| name.len() > 5))\n    }\n}\n\nfn main() {\n    for name in good_song_names(true) {\n        println!(\"Listen to {name}\");\n    }\n}\n";

},{}],"5nO3S":[function(require,module,exports,__globalThis) {
module.exports = "impl Iterator for MyType {\n    type Item = TheTypeOfEachElement;\n\n    fn next(&mut self) -> Option<Self::Item> {\n        None\n    }\n}\n\nstruct TheTypeOfEachElement;\nstruct MyType;\n\nstruct FortyTwo;\n\nimpl Iterator for FortyTwo {\n    type Item = i32;\n\n    fn next(&mut self) -> Option<Self::Item> {\n        Some(42)\n    }\n}\n\nstruct Upward(i32);\n\nimpl Iterator for Upward {\n    type Item = i32;\n\n    fn next(&mut self) -> Option<Self::Item> {\n        self.0 += 1;\n        Some(self.0)\n    }\n}\n\nfn main() {\n    for _ in MyType {}\n\n    for v in FortyTwo.take(10) {\n        println!(\"{v:?}\");\n    }\n\n    for v in Upward(10).take(10) {\n        println!(\"{v:?}\");\n    }\n}\n";

},{}],"8bgKp":[function(require,module,exports,__globalThis) {
module.exports = "struct PowersOfTwo(u8);\n\nimpl PowersOfTwo {\n    fn new() -> Self {\n        PowersOfTwo(0)\n    }\n}\n\nimpl Iterator for PowersOfTwo {\n    type Item = u32;\n\n    fn next(&mut self) -> Option<Self::Item> {\n        let v = Some(1 << self.0);\n        self.0 += 1;\n        v\n    }\n}\n\nfn main() {\n    assert_eq!(\n        PowersOfTwo::new().take(10).collect::<Vec<_>>(),\n        vec![1, 2, 4, 8, 16, 32, 64, 128, 256, 512]\n    );\n}\n";

},{}],"fEUkh":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let input = \"12 Bananas\";\n    let letters = input.chars();\n    for l in letters {\n        if l == ' ' {\n            break;\n        }\n    }\n    println!(\"{}\", letters.as_str());\n}\n";

},{}],"cA2iU":[function(require,module,exports,__globalThis) {
module.exports = "error[E0382]: borrow of moved value: `letters`\n   --> ownership-transfer/src/main.rs:10:20\n    |\n  4 |     let letters = input.chars();\n    |         ------- move occurs because `letters` has type `Chars<'_>`, which does not\n    |                 implement the `Copy` trait\n  5 |     for l in letters {\n    |              ------- `letters` moved due to this implicit call to `.into_iter()`\n...\n 10 |     println!(\"{}\", letters.as_str());\n    |                    ^^^^^^^ value borrowed here after move\n    |\nnote: `into_iter` takes ownership of the receiver `self`, which moves `letters`\n   --> core/src/iter/traits/collect.rs:312:18\n    |\n312 |     fn into_iter(self) -> Self::IntoIter;\n    |                  ^^^^\n\nFor more information about this error, try `rustc --explain E0382`.\nerror: could not compile `ownership-transfer` (bin \"ownership-transfer\") due to 1 previous\n       error\n";

},{}],"ajGsn":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let input = \"12 Bananas\";\n    let mut letters = input.chars();\n    for l in letters.by_ref() {\n        if l == ' ' {\n            break;\n        }\n    }\n    println!(\"{}\", letters.as_str());\n}\n";

},{}],"2WQVv":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let input = \"12 Bananas\";\n    let mut letters = input.chars();\n    for l in &mut letters {\n        if l == ' ' {\n            break;\n        }\n    }\n    println!(\"{}\", letters.as_str());\n}\n";

},{}],"dn317":[function(require,module,exports,__globalThis) {
module.exports = "[package]\nname = \"using-itertools\"\nversion = \"0.1.0\"\nedition = \"2024\"\n\n# See more keys and their definitions at https://doc.rust-lang.org/cargo/reference/manifest.html\n\n[dependencies]\nitertools = \"0.12.1\"\n\n[lints]\nworkspace = true\n";

},{}],"6HNK8":[function(require,module,exports,__globalThis) {
module.exports = "use itertools::Itertools;\n\nfn main() {\n    for (x, y) in (0..10).cartesian_product(0..10) {\n        // ...\n    }\n\n    if itertools::all(vec![1, 2, 3], |v| v < 3) {\n        // ...\n    }\n}\n";

},{}],"h1okP":[function(require,module,exports,__globalThis) {
module.exports = "[package]\nname = \"using-rayon\"\nversion = \"0.1.0\"\nedition = \"2024\"\n\n# See more keys and their definitions at https://doc.rust-lang.org/cargo/reference/manifest.html\n\n[dependencies]\nrayon = \"1.10.0\"\n\n[lints]\nworkspace = true\n";

},{}],"gggha":[function(require,module,exports,__globalThis) {
module.exports = "use rayon::prelude::*;\n\nfn main() {\n    let s: u64 = (0..1_000_000_u64)\n        .into_par_iter()\n        .map(|i| i * i)\n        .map(|i| i + 1)\n        .sum();\n\n    println!(\"{s}\");\n}\n";

},{}],"5g7WI":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let scores = [10_i32, 20, 30];\n    scores.iter().filter(|v| v < 50).count();\n}\n";

},{}],"dcKQD":[function(require,module,exports,__globalThis) {
module.exports = "error[E0308]: mismatched types\n --> multiple-references/src/main.rs:4:34\n  |\n4 |     scores.iter().filter(|v| v < 50).count();\n  |                                  ^^ expected `&&i32`, found integer\n\nFor more information about this error, try `rustc --explain E0308`.\nerror: could not compile `multiple-references` (bin \"multiple-references\") due to 1 previous\n       error\n";

},{}],"1tfM0":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let scores = [10_i32, 20, 30];\n\n    scores.iter().filter(|v| v.is_positive()).count();\n\n    scores.iter().filter(|&v| (v - 1) < 10).count();\n    scores.iter().filter(|v| (*v - 1) < 10).count();\n\n    scores.iter().filter(|&&v| v < 10).count();\n}\n";

},{}],"f1fxP":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let numbers: Vec<_> = (0..10).map(|i| i * i).collect();\n    for n in numbers {\n        println!(\"n: {n}\");\n    }\n}\n";

},{}],"5P3aC":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let numbers = (0..10).map(|i| i * i);\n    for n in numbers {\n        println!(\"n: {n}\");\n    }\n}\n";

},{}],"l3NzU":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let nested = vec![String::from(\"ab\"), String::from(\"cd\")];\n    let combined = nested\n        .into_iter()\n        .flat_map(|inner| inner.chars())\n        .collect::<String>();\n}\n";

},{}],"kqBU7":[function(require,module,exports,__globalThis) {
module.exports = "error[E0515]: cannot return value referencing function parameter `inner`\n --> non-eager-collection/src/main.rs:6:27\n  |\n6 |         .flat_map(|inner| inner.chars())\n  |                           -----^^^^^^^^\n  |                           |\n  |                           returns a value referencing data owned by the current function\n  |                           `inner` is borrowed here\n  |\n  = help: use `.collect()` to allocate the iterator\n\nFor more information about this error, try `rustc --explain E0515`.\nerror: could not compile `non-eager-collection` (bin \"non-eager-collection\") due to 1 previous\n       error\n";

},{}],"7NJ5J":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let nested = vec![String::from(\"ab\"), String::from(\"cd\")];\n    let combined = nested\n        .into_iter()\n        .flat_map(|inner| inner.chars().collect::<Vec<_>>())\n        .collect::<String>();\n}\n";

},{}],"4cRxL":[function(require,module,exports,__globalThis) {
module.exports = "struct StrangeIter {\n    data: Vec<i32>,\n    index: usize,\n}\n\nimpl Iterator for StrangeIter {\n    type Item = &i32;\n\n    fn next(&mut self) -> Option<Self::Item> {\n        Some(&self.data[self.index])\n    }\n}\n\nfn main() {}\n";

},{}],"bgF63":[function(require,module,exports,__globalThis) {
module.exports = "error: associated type `Iterator::Item` is declared without lifetime parameters, so using a\n       borrowed type for them requires that lifetime to come from the implemented type\n --> item-refers-to-iterator/src/main.rs:8:17\n  |\n8 |     type Item = &i32;\n  |                 ^\n  |\nnote: you can't create an `Iterator` that borrows each `Item` from itself, but you can instead\n      create a new type that borrows your existing type and implement `Iterator` for that new\n      type\n --> item-refers-to-iterator/src/main.rs:7:19\n  |\n7 | impl Iterator for StrangeIter {\n  |                   ^^^^^^^^^^^\n\nerror: could not compile `item-refers-to-iterator` (bin \"item-refers-to-iterator\") due to 1\n       previous error\n";

},{}],"ao7DP":[function(require,module,exports,__globalThis) {
module.exports = "struct StrangeIter {\n    data: Vec<i32>,\n    index: usize,\n}\n\ntrait LendingIterator {\n    type Item<'a>\n    where\n        Self: 'a;\n\n    fn next(&mut self) -> Option<Self::Item<'_>>;\n}\n\nimpl LendingIterator for StrangeIter {\n    type Item<'a> = &'a i32;\n\n    fn next(&mut self) -> Option<Self::Item<'_>> {\n        Some(&self.data[self.index])\n    }\n}\n\nfn main() {}\n";

},{}],"eLVDB":[function(require,module,exports,__globalThis) {
module.exports = "#![feature(coroutines, coroutine_trait)]\n\nfn example() -> impl std::ops::Coroutine<Yield = i32, Return = ()> {\n    #[coroutine] || {\n        yield 42;\n        yield 99;\n        yield -1;\n    }\n}\n\nfn main() {\n    println!(\"Hello, world!\");\n}\n";

},{}],"6MTJf":[function(require,module,exports,__globalThis) {
/*@jsxRuntime automatic*/ /*@jsxImportSource react*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "title", ()=>title);
parcelHelpers.export(exports, "default", ()=>MDXContent);
var _jsxRuntime = require("react/jsx-runtime");
var _directives = require("./Directives");
var _changeDeck = require("./ChangeDeck");
var _changeDeckDefault = parcelHelpers.interopDefault(_changeDeck);
var _splash = require("./layout/Splash");
var _splashDefault = parcelHelpers.interopDefault(_splash);
var _testPattern = require("./TestPattern");
var _testPatternDefault = parcelHelpers.interopDefault(_testPattern);
var _transclude = require("./Transclude");
var _transcludeDefault = parcelHelpers.interopDefault(_transclude);
var _basicStructureOfATrait = require("rust:types/basic-structure-of-a-trait");
var _basicStructureOfATraitDefault = parcelHelpers.interopDefault(_basicStructureOfATrait);
var _implDisplayForVec = require("rust:types/impl-display-for-vec");
var _implDisplayForVecDefault = parcelHelpers.interopDefault(_implDisplayForVec);
var _implDisplayForVec1 = require("stderr:types/impl-display-for-vec");
var _implDisplayForVecDefault1 = parcelHelpers.interopDefault(_implDisplayForVec1);
var _implDisplayForVecRev1 = require("rust:types/impl-display-for-vec?rev=1");
var _implDisplayForVecRev1Default = parcelHelpers.interopDefault(_implDisplayForVecRev1);
var _implDisplayForVecRev11 = require("stderr:types/impl-display-for-vec?rev=1");
var _implDisplayForVecRev1Default1 = parcelHelpers.interopDefault(_implDisplayForVecRev11);
var _traitsInScope = require("rust:types/traits-in-scope");
var _traitsInScopeDefault = parcelHelpers.interopDefault(_traitsInScope);
var _traitsInScopeRev0 = require("stderr:types/traits-in-scope?rev=0");
var _traitsInScopeRev0Default = parcelHelpers.interopDefault(_traitsInScopeRev0);
var _traitsInScopeRev1 = require("rust:types/traits-in-scope?rev=1");
var _traitsInScopeRev1Default = parcelHelpers.interopDefault(_traitsInScopeRev1);
var _traitForOdd = require("rust:types/trait-for-odd");
var _traitForOddDefault = parcelHelpers.interopDefault(_traitForOdd);
var _basicGenericStructure = require("rust:types/basic-generic-structure");
var _basicGenericStructureDefault = parcelHelpers.interopDefault(_basicGenericStructure);
var _traitBounds = require("rust:types/trait-bounds");
var _traitBoundsDefault = parcelHelpers.interopDefault(_traitBounds);
var _traitBounds1 = require("stderr:types/trait-bounds");
var _traitBoundsDefault1 = parcelHelpers.interopDefault(_traitBounds1);
var _traitBoundsRev1 = require("rust:types/trait-bounds?rev=1");
var _traitBoundsRev1Default = parcelHelpers.interopDefault(_traitBoundsRev1);
var _traitBoundsRev2 = require("rust:types/trait-bounds?rev=2");
var _traitBoundsRev2Default = parcelHelpers.interopDefault(_traitBoundsRev2);
var _traitBoundsRev3 = require("rust:types/trait-bounds?rev=3");
var _traitBoundsRev3Default = parcelHelpers.interopDefault(_traitBoundsRev3);
var _traitBoundsRev4 = require("rust:types/trait-bounds?rev=4");
var _traitBoundsRev4Default = parcelHelpers.interopDefault(_traitBoundsRev4);
var _traitBoundsRev41 = require("stderr:types/trait-bounds?rev=4");
var _traitBoundsRev4Default1 = parcelHelpers.interopDefault(_traitBoundsRev41);
var _twoCopies = require("rust:types/two-copies");
var _twoCopiesDefault = parcelHelpers.interopDefault(_twoCopies);
var _associatedTypes = require("rust:types/associated-types");
var _associatedTypesDefault = parcelHelpers.interopDefault(_associatedTypes);
var _associatedTypesRev1 = require("rust:types/associated-types?rev=1");
var _associatedTypesRev1Default = parcelHelpers.interopDefault(_associatedTypesRev1);
var _associatedTypesRev2 = require("rust:types/associated-types?rev=2");
var _associatedTypesRev2Default = parcelHelpers.interopDefault(_associatedTypesRev2);
var _associatedTypesRev21 = require("stderr:types/associated-types?rev=2");
var _associatedTypesRev2Default1 = parcelHelpers.interopDefault(_associatedTypesRev21);
var _associatedTypesRev3 = require("rust:types/associated-types?rev=3");
var _associatedTypesRev3Default = parcelHelpers.interopDefault(_associatedTypesRev3);
var _associatedTypesRev4 = require("rust:types/associated-types?rev=4");
var _associatedTypesRev4Default = parcelHelpers.interopDefault(_associatedTypesRev4);
var _associatedTypesRev41 = require("stderr:types/associated-types?rev=4");
var _associatedTypesRev4Default1 = parcelHelpers.interopDefault(_associatedTypesRev41);
var _associatedTypesRev5 = require("rust:types/associated-types?rev=5");
var _associatedTypesRev5Default = parcelHelpers.interopDefault(_associatedTypesRev5);
var _takingIterators = require("rust:types/taking-iterators");
var _takingIteratorsDefault = parcelHelpers.interopDefault(_takingIterators);
var _takingIteratorsRev1 = require("rust:types/taking-iterators?rev=1");
var _takingIteratorsRev1Default = parcelHelpers.interopDefault(_takingIteratorsRev1);
var _genericTraits = require("rust:types/generic-traits");
var _genericTraitsDefault = parcelHelpers.interopDefault(_genericTraits);
var _genericAssociatedTypes = require("rust:types/generic-associated-types");
var _genericAssociatedTypesDefault = parcelHelpers.interopDefault(_genericAssociatedTypes);
var _defaultFunctions = require("rust:types/default-functions");
var _defaultFunctionsDefault = parcelHelpers.interopDefault(_defaultFunctions);
var _supertraits = require("rust:types/supertraits");
var _supertraitsDefault = parcelHelpers.interopDefault(_supertraits);
var _associatedConstants = require("rust:types/associated-constants");
var _associatedConstantsDefault = parcelHelpers.interopDefault(_associatedConstants);
var _defaultTypeParams = require("rust:types/default-type-params");
var _defaultTypeParamsDefault = parcelHelpers.interopDefault(_defaultTypeParams);
var _kitchenSink = require("rust:types/kitchen-sink");
var _kitchenSinkDefault = parcelHelpers.interopDefault(_kitchenSink);
var _monomorphization = require("rust:types/monomorphization");
var _monomorphizationDefault = parcelHelpers.interopDefault(_monomorphization);
var _monomorphizationRev1 = require("rust:types/monomorphization?rev=1");
var _monomorphizationRev1Default = parcelHelpers.interopDefault(_monomorphizationRev1);
var _traitObjects = require("rust:types/trait-objects");
var _traitObjectsDefault = parcelHelpers.interopDefault(_traitObjects);
var _traitObjectsRev1 = require("rust:types/trait-objects?rev=1");
var _traitObjectsRev1Default = parcelHelpers.interopDefault(_traitObjectsRev1);
var _traitObjectsRev11 = require("stderr:types/trait-objects?rev=1");
var _traitObjectsRev1Default1 = parcelHelpers.interopDefault(_traitObjectsRev11);
var _traitObjectsRev2 = require("rust:types/trait-objects?rev=2");
var _traitObjectsRev2Default = parcelHelpers.interopDefault(_traitObjectsRev2);
var _dynCompatibility = require("rust:types/dyn-compatibility");
var _dynCompatibilityDefault = parcelHelpers.interopDefault(_dynCompatibility);
var _dynCompatibility1 = require("stderr:types/dyn-compatibility");
var _dynCompatibilityDefault1 = parcelHelpers.interopDefault(_dynCompatibility1);
var _traitObjectMath = require("rust:types/trait-object-math");
var _traitObjectMathDefault = parcelHelpers.interopDefault(_traitObjectMath);
var _ownedTraitObjects = require("rust:types/owned-trait-objects");
var _ownedTraitObjectsDefault = parcelHelpers.interopDefault(_ownedTraitObjects);
var _implTrait = require("rust:types/impl-trait");
var _implTraitDefault = parcelHelpers.interopDefault(_implTrait);
var _voldemortTypes = require("rust:types/voldemort-types");
var _voldemortTypesDefault = parcelHelpers.interopDefault(_voldemortTypes);
var _voldemortTypesRev1 = require("rust:types/voldemort-types?rev=1");
var _voldemortTypesRev1Default = parcelHelpers.interopDefault(_voldemortTypesRev1);
var _voldemortTypesRev2 = require("rust:types/voldemort-types?rev=2");
var _voldemortTypesRev2Default = parcelHelpers.interopDefault(_voldemortTypesRev2);
var _voldemortTypesRev21 = require("stderr:types/voldemort-types?rev=2");
var _voldemortTypesRev2Default1 = parcelHelpers.interopDefault(_voldemortTypesRev21);
var _implTraitReturn = require("rust:types/impl-trait-return");
var _implTraitReturnDefault = parcelHelpers.interopDefault(_implTraitReturn);
var _implTraitReturnRev1 = require("rust:types/impl-trait-return?rev=1");
var _implTraitReturnRev1Default = parcelHelpers.interopDefault(_implTraitReturnRev1);
var _implTraitArg = require("rust:types/impl-trait-arg");
var _implTraitArgDefault = parcelHelpers.interopDefault(_implTraitArg);
var _implTraitArgRev1 = require("rust:types/impl-trait-arg?rev=1");
var _implTraitArgRev1Default = parcelHelpers.interopDefault(_implTraitArgRev1);
var _implTraitArgRev2 = require("rust:types/impl-trait-arg?rev=2");
var _implTraitArgRev2Default = parcelHelpers.interopDefault(_implTraitArgRev2);
var _implTraitIterators = require("rust:types/impl-trait-iterators");
var _implTraitIteratorsDefault = parcelHelpers.interopDefault(_implTraitIterators);
var _callerChooses = require("rust:types/caller-chooses");
var _callerChoosesDefault = parcelHelpers.interopDefault(_callerChooses);
var _callerChooses1 = require("stderr:types/caller-chooses");
var _callerChoosesDefault1 = parcelHelpers.interopDefault(_callerChooses1);
var _callerChoosesRev1 = require("rust:types/caller-chooses?rev=1");
var _callerChoosesRev1Default = parcelHelpers.interopDefault(_callerChoosesRev1);
var _kindsOfGenerics = require("rust:types/kinds-of-generics");
var _kindsOfGenericsDefault = parcelHelpers.interopDefault(_kindsOfGenerics);
var _constGenerics = require("rust:types/const-generics");
var _constGenericsDefault = parcelHelpers.interopDefault(_constGenerics);
var _constGenericsDefaults = require("rust:types/const-generics-defaults");
var _constGenericsDefaultsDefault = parcelHelpers.interopDefault(_constGenericsDefaults);
var _lifetimeBounds = require("rust:types/lifetime-bounds");
var _lifetimeBoundsDefault = parcelHelpers.interopDefault(_lifetimeBounds);
var _lifetimeBounds1 = require("stderr:types/lifetime-bounds");
var _lifetimeBoundsDefault1 = parcelHelpers.interopDefault(_lifetimeBounds1);
var _lifetimeBoundsRev1 = require("rust:types/lifetime-bounds?rev=1");
var _lifetimeBoundsRev1Default = parcelHelpers.interopDefault(_lifetimeBoundsRev1);
var _lifetimesAndTraits = require("rust:types/lifetimes-and-traits");
var _lifetimesAndTraitsDefault = parcelHelpers.interopDefault(_lifetimesAndTraits);
var _lifetimesAndTraits1 = require("stderr:types/lifetimes-and-traits");
var _lifetimesAndTraitsDefault1 = parcelHelpers.interopDefault(_lifetimesAndTraits1);
var _lifetimesAndTraitsRev1 = require("rust:types/lifetimes-and-traits?rev=1");
var _lifetimesAndTraitsRev1Default = parcelHelpers.interopDefault(_lifetimesAndTraitsRev1);
var _lifetimesAndTraitsRev2 = require("rust:types/lifetimes-and-traits?rev=2");
var _lifetimesAndTraitsRev2Default = parcelHelpers.interopDefault(_lifetimesAndTraitsRev2);
var _lifetimesAndTraitsRev3 = require("rust:types/lifetimes-and-traits?rev=3");
var _lifetimesAndTraitsRev3Default = parcelHelpers.interopDefault(_lifetimesAndTraitsRev3);
var _lifetimesAndTraitsRev4 = require("rust:types/lifetimes-and-traits?rev=4");
var _lifetimesAndTraitsRev4Default = parcelHelpers.interopDefault(_lifetimesAndTraitsRev4);
var _lifetimesAndTraitsRev5 = require("rust:types/lifetimes-and-traits?rev=5");
var _lifetimesAndTraitsRev5Default = parcelHelpers.interopDefault(_lifetimesAndTraitsRev5);
var _higherRankedTraitBounds = require("rust:types/higher-ranked-trait-bounds");
var _higherRankedTraitBoundsDefault = parcelHelpers.interopDefault(_higherRankedTraitBounds);
var _higherRankedTraitBounds1 = require("stderr:types/higher-ranked-trait-bounds");
var _higherRankedTraitBoundsDefault1 = parcelHelpers.interopDefault(_higherRankedTraitBounds1);
var _higherRankedTraitBoundsRev1 = require("rust:types/higher-ranked-trait-bounds?rev=1");
var _higherRankedTraitBoundsRev1Default = parcelHelpers.interopDefault(_higherRankedTraitBoundsRev1);
var _higherRankedTraitBoundsRev11 = require("stderr:types/higher-ranked-trait-bounds?rev=1");
var _higherRankedTraitBoundsRev1Default1 = parcelHelpers.interopDefault(_higherRankedTraitBoundsRev11);
var _higherRankedTraitBoundsRev2 = require("rust:types/higher-ranked-trait-bounds?rev=2");
var _higherRankedTraitBoundsRev2Default = parcelHelpers.interopDefault(_higherRankedTraitBoundsRev2);
var _higherRankedTraitBoundsRev21 = require("stderr:types/higher-ranked-trait-bounds?rev=2");
var _higherRankedTraitBoundsRev2Default1 = parcelHelpers.interopDefault(_higherRankedTraitBoundsRev21);
var _higherRankedTraitBoundsRev3 = require("rust:types/higher-ranked-trait-bounds?rev=3");
var _higherRankedTraitBoundsRev3Default = parcelHelpers.interopDefault(_higherRankedTraitBoundsRev3);
var _higherRankedTraitBoundsRev31 = require("stderr:types/higher-ranked-trait-bounds?rev=3");
var _higherRankedTraitBoundsRev3Default1 = parcelHelpers.interopDefault(_higherRankedTraitBoundsRev31);
var _higherRankedTraitBoundsRev4 = require("rust:types/higher-ranked-trait-bounds?rev=4");
var _higherRankedTraitBoundsRev4Default = parcelHelpers.interopDefault(_higherRankedTraitBoundsRev4);
var _specialization = require("rust:types/specialization");
var _specializationDefault = parcelHelpers.interopDefault(_specialization);
var _specialization1 = require("stderr:types/specialization");
var _specializationDefault1 = parcelHelpers.interopDefault(_specialization1);
var _specializationRev1 = require("rust:types/specialization?rev=1");
var _specializationRev1Default = parcelHelpers.interopDefault(_specializationRev1);
var _constGenericsUserTypes = require("rust:types/const-generics-user-types");
var _constGenericsUserTypesDefault = parcelHelpers.interopDefault(_constGenericsUserTypes);
var _constGenericsUserTypes1 = require("stderr:types/const-generics-user-types");
var _constGenericsUserTypesDefault1 = parcelHelpers.interopDefault(_constGenericsUserTypes1);
var _constGenericsUserTypesRev1 = require("rust:types/const-generics-user-types?rev=1");
var _constGenericsUserTypesRev1Default = parcelHelpers.interopDefault(_constGenericsUserTypesRev1);
var _constGenericsExpressions = require("rust:types/const-generics-expressions");
var _constGenericsExpressionsDefault = parcelHelpers.interopDefault(_constGenericsExpressions);
var _constGenericsExpressions1 = require("stderr:types/const-generics-expressions");
var _constGenericsExpressionsDefault1 = parcelHelpers.interopDefault(_constGenericsExpressions1);
var _constGenericsExpressionsRev1 = require("rust:types/const-generics-expressions?rev=1");
var _constGenericsExpressionsRev1Default = parcelHelpers.interopDefault(_constGenericsExpressionsRev1);
var _typeAliasImplTrait = require("rust:types/type-alias-impl-trait");
var _typeAliasImplTraitDefault = parcelHelpers.interopDefault(_typeAliasImplTrait);
var _typeAliasImplTrait1 = require("stderr:types/type-alias-impl-trait");
var _typeAliasImplTraitDefault1 = parcelHelpers.interopDefault(_typeAliasImplTrait1);
var _typeAliasImplTraitRev1 = require("rust:types/type-alias-impl-trait?rev=1");
var _typeAliasImplTraitRev1Default = parcelHelpers.interopDefault(_typeAliasImplTraitRev1);
var _autoTraits = require("rust:types/auto-traits");
var _autoTraitsDefault = parcelHelpers.interopDefault(_autoTraits);
var _autoTraits1 = require("stderr:types/auto-traits");
var _autoTraitsDefault1 = parcelHelpers.interopDefault(_autoTraits1);
var _autoTraitsRev1 = require("rust:types/auto-traits?rev=1");
var _autoTraitsRev1Default = parcelHelpers.interopDefault(_autoTraitsRev1);
var _autoTraitsRev11 = require("stderr:types/auto-traits?rev=1");
var _autoTraitsRev1Default1 = parcelHelpers.interopDefault(_autoTraitsRev11);
const title = "Advanced types and traits";
function _createMdxContent(props) {
    const _components = {
        a: "a",
        code: "code",
        em: "em",
        h1: "h1",
        h2: "h2",
        h3: "h3",
        hr: "hr",
        li: "li",
        p: "p",
        strong: "strong",
        ul: "ul",
        ...props.components
    }, { SplitSlides } = _components;
    if (!SplitSlides) _missingMdxReference("SplitSlides", true);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SplitSlides, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _testPatternDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Advanced types and traits"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Traits are Rust's primary interesting form of abstraction"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Functions provide abstraction, but are well-known"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Macros are a different kind of abstraction, but less common"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Common traits"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Copy"
                            }),
                            " / ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Clone"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Debug"
                            }),
                            " / ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Display"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Iterator"
                            }),
                            " / ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "IntoIterator"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Into"
                            }),
                            " / ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "From"
                            }),
                            " / ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "TryInto"
                            }),
                            " / ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "TryFrom"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Fn"
                            }),
                            " / ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "FnMut"
                            }),
                            " / ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "FnOnce"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Add"
                            }),
                            " / ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Sub"
                            }),
                            " / ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Mul"
                            }),
                            " / ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Div"
                            }),
                            " / etc."
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Read"
                            }),
                            " / ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Write"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Many more in the standard library"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Some of the standard library traits have special syntax (e.g. ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Add"
                            }),
                            ")"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Many crates define traits and implement them"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Basic structure of a trait"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _basicStructureOfATraitDefault.default),
                focusOn: "1+17"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Basic structure of a trait"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _basicStructureOfATraitDefault.default),
                focusOn: "1+17",
                emphasize: "1"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Keyword ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "trait"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Give it a name"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Basic structure of a trait"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _basicStructureOfATraitDefault.default),
                focusOn: "1+17",
                emphasize: "2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Add methods and associated functions, just like an inherent implementation"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Does not need a body"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Basic structure of a trait"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _basicStructureOfATraitDefault.default),
                focusOn: "1+17",
                emphasize: "7[5+9]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "A block distinct from the trait and the type is used for implementation"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Basic structure of a trait"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _basicStructureOfATraitDefault.default),
                focusOn: "1+17",
                emphasize: "8,9,10"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Body of the implementation"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Basic structure of a trait"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _basicStructureOfATraitDefault.default),
                focusOn: "1+17",
                emphasize: "15"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Methods and associated functions can be called the same as inherent ones"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Why the separate / repetitive syntax?"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: "Implement your trait for other crate's types"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _basicStructureOfATraitDefault.default),
                focusOn: "18+5",
                emphasize: "1[11+8]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Can define traits for types you don't own"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: "Sometimes, that's the reason for the trait"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _basicStructureOfATraitDefault.default),
                focusOn: "24+7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "If that's the only purpose, known as an ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.em, {
                                children: "extension trait"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "How far can we go?"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _implDisplayForVecDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _implDisplayForVecDefault1.default),
                lang: "compiler-error",
                focusOn: "1+11"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "How far can we go?"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _implDisplayForVecRev1Default.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "What do you expect the output to be?"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _implDisplayForVecRev1Default1.default),
                lang: "compiler-error",
                focusOn: "1+13"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Orphan rules and coherence"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "The crate must own either:",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "the type being defined"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "the trait being defined"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Prevents conflicting implementations between crates"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Prevents adding an implementation being a breaking change"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Pedantically, the restriction is more complicated, but that covers 99% of the cases"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Traits must be in scope to be used"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _traitsInScopeDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Traits must be in scope to be used"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _traitsInScopeRev0Default.default),
                lang: "compiler-error",
                focusOn: "1+15"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Traits must be in scope to be used"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _traitsInScopeRev1Default.default),
                emphasize: "13"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Exercise: Write a trait for if something is \"odd\""
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Define it for at least two types"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "One type should be an integer of some flavor"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Code like this should run:"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                                src: (0, _traitForOddDefault.default),
                                focusOn: "18+2",
                                copyAllCode: false
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One potential solution"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _traitForOddDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Generics"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Adding methods to types is nice",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "not the real power of traits"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Create code that works on multiple types"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Basic structure of generic functions"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _basicGenericStructureDefault.default),
                focusOn: "1+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Basic structure of generic functions"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _basicGenericStructureDefault.default),
                focusOn: "1+3",
                emphasize: "1[13+3]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Declare the generic type"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Done to clearly disambiguate any real type with the same name"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Basic structure of generic functions"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _basicGenericStructureDefault.default),
                focusOn: "1+3",
                emphasize: "1[24+1],1[30+1]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Can then use that generic type as an argument or return type"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Basic structure of generic types"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _basicGenericStructureDefault.default),
                focusOn: "5+7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Basic structure of generic types"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _basicGenericStructureDefault.default),
                focusOn: "5+7",
                emphasize: "1[15+3]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "The struct declares the generic type (same reasons)"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Basic structure of generic types"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _basicGenericStructureDefault.default),
                focusOn: "5+7",
                emphasize: "1[19+1]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Can make use of the generic type"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Basic structure of generic types"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _basicGenericStructureDefault.default),
                focusOn: "5+7",
                emphasize: "3[4+3]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Implementations also declare the generic type"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Basic structure of generic types"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _basicGenericStructureDefault.default),
                focusOn: "5+7",
                emphasize: "3[16+3]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Basic structure of generic types"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _basicGenericStructureDefault.default),
                focusOn: "5+7",
                emphasize: "4[27+1]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "What can we do with a generic?"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _traitBoundsDefault.default),
                focusOn: "1+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _traitBoundsDefault1.default),
                lang: "compiler-error",
                focusOn: "1+11"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Trait bounds"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Fewer restrictions",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "more types are likely to be allowed"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "fewer actions can be taken on a value"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "More restrictions",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "fewer types are likely to be allowed"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "more actions can be taken on a value"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Trait bounds"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Inline"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _traitBoundsRev1Default.default),
                focusOn: "1+5",
                emphasize: "3[15+9]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Where clause"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _traitBoundsRev2Default.default),
                focusOn: "1+8",
                emphasize: "4,5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "I advocate for the ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "where"
                            }),
                            " clause in almost every case."
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "I find:",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "it's better for scanning the code"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "less version control churn"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "more complicated conditions"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Multiple trait bounds"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Inline"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _traitBoundsRev3Default.default),
                focusOn: "1+5",
                emphasize: "3[17+23]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Where clause"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _traitBoundsRev4Default.default),
                focusOn: "1+6",
                emphasize: "5,6"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Where clause can also have multiple lines for the same generic"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Failing to meet trait bounds"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _traitBoundsRev4Default.default),
                focusOn: "11+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _traitBoundsRev4Default1.default),
                lang: "compiler-error",
                focusOn: "1+17"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Error is provided at the location of use, not somewhere deep in a callstack"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Exercise: Function that makes two duplicates of a value"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Takes a single value"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Returns two values in a tuple"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Code like this should run:"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                                src: (0, _twoCopiesDefault.default),
                                focusOn: "9+4",
                                copyAllCode: false
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Bonus"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Does it actually need to make ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.em, {
                                children: "two"
                            }),
                            " duplicates?"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One potential solution"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _twoCopiesDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Abstracting across types in abstract functions"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _associatedTypesDefault.default),
                focusOn: "1+21"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _associatedTypesDefault.default),
                focusOn: "23+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Could use dynamic dispatch via trait object or enum"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Associated types"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Specify types that are relevant to the trait"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "The implementer of the trait chooses the type"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Basic structure of associated types"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _associatedTypesRev1Default.default),
                focusOn: "11+21"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Basic structure of associated types"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _associatedTypesRev1Default.default),
                focusOn: "11+21",
                emphasize: "2,8,16"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Basic structure of associated types"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _associatedTypesRev1Default.default),
                focusOn: "11+21",
                emphasize: "4,10,18"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Using associated types"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _associatedTypesRev1Default.default),
                focusOn: "33+6"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Works fine, right?"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Using associated types"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _associatedTypesRev2Default.default),
                focusOn: "33+7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _associatedTypesRev2Default1.default),
                lang: "compiler-error",
                focusOn: "1+12"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Trait bounds can be applied to associated types as well"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _associatedTypesRev3Default.default),
                focusOn: "33+10"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Trait bounds can be applied to associated types as well"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _associatedTypesRev3Default.default),
                focusOn: "33+10",
                emphasize: "6"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "What if we wanted a specific associated type?"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _associatedTypesRev4Default.default),
                focusOn: "33+7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "What if we wanted a specific associated type?"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _associatedTypesRev4Default1.default),
                lang: "compiler-error",
                focusOn: "1+19"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Specific associated types"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _associatedTypesRev5Default.default),
                focusOn: "33+7",
                emphasize: "3[12+20]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Exercise: Write two functions that take iterators"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.p, {
                                children: [
                                    "One function takes an iterator of ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                        children: "i32"
                                    }),
                                    "s and adds them together"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.p, {
                                children: [
                                    "One function takes an iterator of anything implementing ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                        children: "ToString"
                                    }),
                                    " and joins them into one string"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Code like this should run:"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                                src: (0, _takingIteratorsDefault.default),
                                focusOn: "25+7",
                                copyAllCode: false
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Bonus"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Can you remove the ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "into_iter()"
                            }),
                            " call?"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Does anyone ask about the empty iterator case?"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One potential solution"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _takingIteratorsDefault.default),
                focusOn: "1+23"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One potential solution"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _takingIteratorsRev1Default.default),
                focusOn: "1+15"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Generic traits"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Traits can also have generic types"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Using generic traits"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _genericTraitsDefault.default),
                focusOn: "1+20"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Simplified version of actual trait"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Using generic traits"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _genericTraitsDefault.default),
                focusOn: "1+20",
                emphasize: "1[11+3]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Using generic traits"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _genericTraitsDefault.default),
                focusOn: "1+20",
                emphasize: "10[11+6],11[25+6],16[11+2],17[25+2]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Choosing a trait with generics vs. associated types"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Trait methods are selected by:",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "the method name"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "the implementing type"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "any generic types in play"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "A generic trait can be implemented many times for a type"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Generic traits can be more cumbersome to use"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "When in doubt, start with an associated type"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Generic associated types"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _genericAssociatedTypesDefault.default),
                focusOn: "1+7",
                emphasize: "2[14+2],6[12+2],6[17+2],6[51+2]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Allows associated types to themselves be generic"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Allows tying the lifetime of ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Item"
                            }),
                            " to ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "self"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Generic associated types"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _genericAssociatedTypesDefault.default),
                focusOn: "9+25",
                emphasize: "7[14+2],7[21+2],9[44+2]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Using lifetime elision here"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "More tricks that traits can do"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Default functions"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Supertraits"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Associated constants"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Default type parameters"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Default functions"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "A trait can provide a default implementation of a function"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Implementors of the trait can provide a better implementation"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "The function should do the same thing"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Default functions"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _defaultFunctionsDefault.default),
                focusOn: "1+28"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Default functions"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _defaultFunctionsDefault.default),
                focusOn: "1+28",
                emphasize: "4,5,6"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Default functions"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _defaultFunctionsDefault.default),
                focusOn: "1+28",
                emphasize: "11,12,13,14,15"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Default functions"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _defaultFunctionsDefault.default),
                focusOn: "1+28",
                emphasize: "24,25,26"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "There's no equivalent of ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "super()"
                            }),
                            ", this is not inheritance"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Supertraits"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Implementing the trait requires implementing supertraits"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Can use supertrait's functionality in trait implementation"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Supertraits"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _supertraitsDefault.default),
                focusOn: "1+18"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Supertraits"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _supertraitsDefault.default),
                focusOn: "1+18",
                emphasize: "3[12+7]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Supertraits"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _supertraitsDefault.default),
                focusOn: "1+18",
                emphasize: "7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Associated constants"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Constants associated with the implementation of the trait"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Guaranteed to be evaluated at compile-time"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Type of the constant can be an associated type or generic"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Associated constants"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _associatedConstantsDefault.default),
                focusOn: "1+16"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Associated constants"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _associatedConstantsDefault.default),
                focusOn: "1+16",
                emphasize: "2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Associated constants"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _associatedConstantsDefault.default),
                focusOn: "1+16",
                emphasize: "10"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Default type parameters"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "You need the flexibility of a generic type",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "but there's a frequently used type"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Also available when defining a type or a type alias"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Default type parameters"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _defaultTypeParamsDefault.default),
                focusOn: "1+12"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Default type parameters"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _defaultTypeParamsDefault.default),
                focusOn: "1+12",
                emphasize: "1[16+7]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Default type parameters"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _defaultTypeParamsDefault.default),
                focusOn: "1+12",
                emphasize: "7[5+9]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Default type parameters"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _defaultTypeParamsDefault.default),
                focusOn: "1+12",
                emphasize: "8[37+3]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Exercise: Kitchen sink features of traits"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Create a trait for snacks that:"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "requires types to be printed via ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "{:?}"
                                            })
                                        ]
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "requires types to be tested for equality with each other"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "The trait has a method that \"eats\" another snack"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "print out which snacks were eaten"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "by default: if the snacks are equal, eat both; otherwise do nothing"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "the snack ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "Cookie"
                                            }),
                                            " does something special",
                                            "\n",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                                children: [
                                                    "\n",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                                        children: [
                                                            "if the snacks are ",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.strong, {
                                                                children: "not"
                                                            }),
                                                            " equal, eat only the first; otherwise do nothing"
                                                        ]
                                                    }),
                                                    "\n"
                                                ]
                                            }),
                                            "\n"
                                        ]
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Code like this should run:"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                                src: (0, _kitchenSinkDefault.default),
                                focusOn: "26+3",
                                copyAllCode: false
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One potential solution"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _kitchenSinkDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Generics have no runtime overhead"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "At compile time, effectively copy code for each unique type"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "The fancy term is ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.em, {
                                children: "monomorphization"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Good example of ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.em, {
                                children: "zero cost abstraction"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "a human could not have written the same code better"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Can lead to code bloat"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Optimizer may combine code that is identical"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Monomorphization (before)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _monomorphizationDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Monomorphization (after)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _monomorphizationRev1Default.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Not actual names or code generated"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Trait objects"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Allow for dynamic dispatch"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Always behind a pointer of some kind",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "&"
                                            }),
                                            ", ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "Box"
                                            }),
                                            ", ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "Rc"
                                            }),
                                            ", ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "Arc"
                                            }),
                                            ", etc."
                                        ]
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Only one implementation of the code created"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Trait objects"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _traitObjectsDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Trait objects"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _traitObjectsDefault.default),
                emphasize: "17[15+3]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Required starting in 2021"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Trait objects"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _traitObjectsDefault.default),
                emphasize: "22[10+5],23[10+5]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Take a reference to the concrete"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Heterogenous collections"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _traitObjectsRev1Default.default),
                focusOn: "21+6"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _traitObjectsRev1Default1.default),
                lang: "compiler-error",
                focusOn: "1+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Heterogenous collections"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _traitObjectsRev2Default.default),
                focusOn: "21+7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Heterogenous collections"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _traitObjectsRev2Default.default),
                focusOn: "21+7",
                emphasize: "2[14+17]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Explcitly type the vector as of trait objects"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Needed to distinguish from vector of ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Box<Doll>"
                            }),
                            " or ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Box<Drum>"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Heterogenous collections"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _traitObjectsRev2Default.default),
                focusOn: "21+7",
                emphasize: "2[39+9],2[52+1],2[55+9],2[68+1]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Box each value in the collection"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Heterogenous collections"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _traitObjectsRev2Default.default),
                focusOn: "21+7",
                emphasize: "4[14+3]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "A bit of syntax trickery since ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Box<dyn Trait>"
                            }),
                            " doesn't implement ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Trait"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Could avoid this by implementing it"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Could talk about ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Deref"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Trait object implementation"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "A trait object is a ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.em, {
                                children: "fat pointer"
                            }),
                            " (Two pointers)",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Pointer to the data"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "Pointer to the method implementations (the ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.em, {
                                                children: "vtable"
                                            }),
                                            ")"
                                        ]
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Most of the time, you don't need to worry about this."
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Dyn compatibility / object safety"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Not all traits can be made into trait objects"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Condensed version of the rules:",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "Functions must have a ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "self"
                                            }),
                                            " parameter (a.k.a. be methods)"
                                        ]
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "Methods may not use ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "Self"
                                            }),
                                            " as an argument or return type"
                                        ]
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Methods may not use generics"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "The reason that these all fail is because we are unable to create the vtable"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Previous versions of Rust used the term \"object safety\", but we are moving away from it"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Dyn compatibility demonstrated"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _dynCompatibilityDefault.default),
                focusOn: "1+7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _dynCompatibilityDefault1.default),
                lang: "compiler-error",
                focusOn: "1+15"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Clone"
                            }),
                            " and ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "PartialEq"
                            }),
                            " are common ways to hit this"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Exercise: Math with trait objects"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.p, {
                                children: [
                                    "Create a trait with a method that takes and returns an ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                        children: "i32"
                                    })
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Create two implementations of the trait"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Create a function that takes a slice of trait objects and an initial value"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Value is passed through the sequence of trait objects"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Code like this should run:"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                                src: (0, _traitObjectMathDefault.default),
                                focusOn: "26",
                                copyAllCode: false
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Hints"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "The argument type will be ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "&[&dyn MyTraitName]"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Bonus"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Replace the function with another implementation of the trait"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One potential solution"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _traitObjectMathDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Returning a value that implements a trait"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Returning a value that doesn't specify the concrete type",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "don't want to name it"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "cannot name it"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Owned trait objects"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _ownedTraitObjectsDefault.default),
                focusOn: "1+15"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Owned trait objects"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _ownedTraitObjectsDefault.default),
                focusOn: "1+15",
                emphasize: "7[44+15]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Owned trait objects"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _ownedTraitObjectsDefault.default),
                focusOn: "1+15",
                emphasize: "9[24+9],9[36+1],10[25+9],10[42+1],11[25+9],11[40+1],12[26+9],12[39+1]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Frequently it's ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Box"
                            }),
                            ", but other owning types are valid too (",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Rc"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Arc"
                            }),
                            ")"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "impl Trait"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _implTraitDefault.default),
                focusOn: "1+16"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "impl Trait"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _implTraitDefault.default),
                focusOn: "1+16",
                emphasize: "13[15+11]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Note the keyword ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "impl"
                            }),
                            " instead of ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "dyn"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "This is a reason it's recommended to use the ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "dyn"
                            }),
                            " keyword"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "impl Trait"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _implTraitDefault.default),
                focusOn: "1+16",
                emphasize: "14[4+3]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "No need for heap allocation"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "The compiler knows there's a concrete type, it's just not exposed"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "The type who must not be named"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _voldemortTypesDefault.default),
                focusOn: "2+2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "But what type is ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "some_closure"
                            }),
                            "?"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _voldemortTypesRev1Default.default),
                focusOn: "2+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "As a hint, this compiles"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Peeking under the covers"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _voldemortTypesRev2Default.default),
                focusOn: "2+1",
                emphasize: "1[16+4]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Peeking under the covers"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _voldemortTypesRev2Default.default),
                focusOn: "2+1"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _voldemortTypesRev2Default1.default),
                lang: "compiler-error",
                focusOn: "1+10"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Peeking under the covers"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _voldemortTypesRev2Default.default),
                focusOn: "2+1"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _voldemortTypesRev2Default1.default),
                lang: "compiler-error",
                focusOn: "1+10",
                emphasize: "10"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "This type is made by the compiler and cannot be named by the programmer"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "impl Trait"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Allows returning a concrete type without saying what that type is"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Value does not require heap allocation"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Some limitations when used with traits",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Cannot be used as an associated type"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Trait is no longer dyn compatible"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Not possible to express additional bounds"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "impl Trait"
                    }),
                    " can return closures"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _implTraitReturnDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "impl Trait"
                    }),
                    " can return iterators containing closures"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _implTraitReturnRev1Default.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Not limited to iterators, those are just very common"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "impl Trait"
                    }),
                    " as an argument"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _implTraitArgDefault.default),
                focusOn: "1+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _implTraitArgRev1Default.default),
                focusOn: "1+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _implTraitArgRev2Default.default),
                focusOn: "1+8"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "All of these are the same"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Less ceremony to more, ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "where"
                            }),
                            " clause more powerful"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Exercise: ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "impl Trait"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.p, {
                                children: [
                                    "Create three functions manipulating iterators of ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                        children: "i32"
                                    }),
                                    ":"
                                ]
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "generate an iterator"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "take an iterator, double every value, return the iterator"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "take an iterator and print each value"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Code like this should run:"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                                src: (0, _implTraitIteratorsDefault.default),
                                focusOn: "16",
                                copyAllCode: false
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Bonus"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Generate an infinite iterator",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "use a method from ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "Iterator"
                                            }),
                                            " to limit it"
                                        ]
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One potential solution"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _implTraitIteratorsDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "The caller picks concrete types for generics"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _callerChoosesDefault.default),
                focusOn: "1+6"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _callerChoosesDefault1.default),
                lang: "compiler-error",
                focusOn: "1+17"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "This does mean that argument position and return position ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "impl Trait"
                            }),
                            " are different."
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "The caller picks concrete types for generics"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _callerChoosesDefault.default),
                focusOn: "1+6"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _callerChoosesDefault.default),
                focusOn: "9"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "The caller picks concrete types for generics"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _callerChoosesRev1Default.default),
                focusOn: "1+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Rust has three kinds of generics"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Lifetimes"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                                src: (0, _kindsOfGenericsDefault.default),
                                focusOn: "1"
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Types"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                                src: (0, _kindsOfGenericsDefault.default),
                                focusOn: "3"
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Constants"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                                src: (0, _kindsOfGenericsDefault.default),
                                focusOn: "5"
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Constants are new in Rust 1.51!"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Const generics"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _constGenericsDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Advanced const generics - defaults"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _constGenericsDefaultsDefault.default),
                focusOn: "1+1"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Const generics"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Largely used for generalizing over arrays"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Can be used with integers, ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "char"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "bool"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Old versions of Rust only implemented traits for array lengths <= 32"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Was done via macro; const generics saved space and compile time"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Doesn't support custom types or expressions"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Lifetime bounds"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Generic types may be or contain a reference",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "If so, the reference must be valid as long as the bound"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Otherwise, meets any bound"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Explicit syntax not often needed",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "An argument ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "&'a T"
                                            }),
                                            " implies ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "T: 'a"
                                            })
                                        ]
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Lifetime bounds"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _lifetimeBoundsDefault.default),
                focusOn: "1+7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _lifetimeBoundsDefault1.default),
                lang: "compiler-error",
                focusOn: "1+14"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Lifetime bounds"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _lifetimeBoundsRev1Default.default),
                focusOn: "1+8",
                emphasize: "5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Lifetimes and return-position ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "impl Trait"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _lifetimesAndTraitsDefault.default),
                focusOn: "1+10"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Lifetimes and return-position ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "impl Trait"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _lifetimesAndTraitsDefault1.default),
                lang: "compiler-error",
                focusOn: "1+16"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "This code compiles in Rust 2024"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Lifetimes and return-position ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "impl Trait"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Lifetimes elided"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _lifetimesAndTraitsDefault.default),
                focusOn: "6+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Lifetimes explicit"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _lifetimesAndTraitsRev1Default.default),
                focusOn: "6+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Lifetimes and return-position ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "impl Trait"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Lifetimes elided"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _lifetimesAndTraitsDefault.default),
                focusOn: "6+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Lifetimes explicit"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _lifetimesAndTraitsRev1Default.default),
                focusOn: "6+5",
                emphasize: "2[14+2],2[19+2],2[58+7]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Lifetimes and return-position ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "impl Trait"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Lifetimes elided"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _lifetimesAndTraitsDefault.default),
                focusOn: "6+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Lifetimes explicit"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _lifetimesAndTraitsRev1Default.default),
                focusOn: "6+5",
                emphasize: "3[8+18]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Lifetimes and return-position ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "impl Trait"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Lifetimes elided"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _lifetimesAndTraitsDefault.default),
                focusOn: "6+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Lifetimes explicit"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _lifetimesAndTraitsRev1Default.default),
                focusOn: "6+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Actual types"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _lifetimesAndTraitsRev2Default.default),
                focusOn: "6+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "The iterator is ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.em, {
                                children: "lazy"
                            }),
                            ", so it has to maintain a reference to the data"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Lifetimes and return-position ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "impl Trait"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Lifetimes elided"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _lifetimesAndTraitsDefault.default),
                focusOn: "6+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Lifetimes explicit"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _lifetimesAndTraitsRev1Default.default),
                focusOn: "6+5",
                emphasize: "2[58+7]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Actual types"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _lifetimesAndTraitsRev2Default.default),
                focusOn: "6+5",
                emphasize: "2[66+2]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Indicating lifetimes"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Explicit lifetime"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _lifetimesAndTraitsRev3Default.default),
                focusOn: "6+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Clearly shows all the pieces"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Anonymous lifetime"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _lifetimesAndTraitsRev4Default.default),
                focusOn: "6+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "There ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.em, {
                                children: "is"
                            }),
                            " a lifetime, but we don't care to name it"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h3, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "use<..>"
                    }),
                    " syntax"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _lifetimesAndTraitsRev5Default.default),
                focusOn: "6+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "As of Rust 1.82"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "This is more precise / less restrictive in certain cases"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Higher-ranked trait bounds"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _higherRankedTraitBoundsDefault.default),
                focusOn: "1+25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Higher-ranked trait bounds"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _higherRankedTraitBoundsDefault.default),
                focusOn: "1+25",
                emphasize: "3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Higher-ranked trait bounds"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _higherRankedTraitBoundsDefault.default),
                focusOn: "1+25",
                emphasize: "7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Higher-ranked trait bounds"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _higherRankedTraitBoundsDefault.default),
                focusOn: "1+25",
                emphasize: "12,13,14,15,16,17,21,22,23,24,25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Higher-ranked trait bounds"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _higherRankedTraitBoundsDefault.default),
                focusOn: "27+7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _higherRankedTraitBoundsDefault1.default),
                lang: "compiler-error",
                focusOn: "1+14"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Higher-ranked trait bounds"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _higherRankedTraitBoundsRev1Default.default),
                focusOn: "27+8",
                emphasize: "4"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _higherRankedTraitBoundsRev1Default1.default),
                lang: "compiler-error",
                focusOn: "1+6"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Only focusing on the first error"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Higher-ranked trait bounds"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _higherRankedTraitBoundsRev2Default.default),
                focusOn: "27+8",
                emphasize: "1[24+2],4[5+2]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _higherRankedTraitBoundsRev2Default1.default),
                lang: "compiler-error",
                focusOn: "1+15"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Higher-ranked trait bounds"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _higherRankedTraitBoundsRev3Default.default),
                focusOn: "27+10",
                emphasize: "5,6"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Two cycles later..."
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _higherRankedTraitBoundsRev3Default1.default),
                focusOn: "1+14",
                lang: "compiler-error"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Higher-ranked trait bounds"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _higherRankedTraitBoundsRev1Default1.default),
                lang: "compiler-error",
                focusOn: "7+4"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _higherRankedTraitBoundsRev4Default.default),
                focusOn: "27+8",
                emphasize: "4[4+7]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Future work"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Being worked on"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Specialization"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Advanced const generics"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Enhanced ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "impl Trait"
                            }),
                            " / existential types"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Beyond"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Auto traits"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Warning: may or may not happen in 2025 (since 2022...)"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Warning: may or may not look like the code shown here"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Specialization"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _specializationDefault.default),
                focusOn: "1+12"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Implement the ability to get the size of any type that can be made into an iterator"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _specializationDefault.default),
                focusOn: "14+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "But we want faster code for a ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Vec"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Specialization"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _specializationDefault1.default),
                lang: "compiler-error",
                focusOn: "1+10"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Specialization"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _specializationRev1Default.default),
                focusOn: "1+20",
                emphasize: "1"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Specialization"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _specializationRev1Default.default),
                focusOn: "1+20",
                emphasize: "11[4+7]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "This works!"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Current implementation has known soundness holes."
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Future work to allow specializing on traits, not just types"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Advanced const generics - user types"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _constGenericsUserTypesDefault.default),
                focusOn: "1+9"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _constGenericsUserTypesDefault1.default),
                lang: "compiler-error",
                focusOn: "1+9"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Advanced const generics - user types"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _constGenericsUserTypesRev1Default.default),
                focusOn: "1+12",
                emphasize: "1,3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Advanced const generics - expressions"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _constGenericsExpressionsDefault.default),
                focusOn: "1+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _constGenericsExpressionsDefault1.default),
                lang: "compiler-error",
                focusOn: "1+10"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Advanced const generics - expressions"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _constGenericsExpressionsRev1Default.default),
                focusOn: "1+5",
                emphasize: "1"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Enhanced ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "impl Trait"
                    }),
                    " / existential types"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _typeAliasImplTraitDefault.default),
                focusOn: "1+15"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _typeAliasImplTraitDefault1.default),
                lang: "compiler-error",
                focusOn: "1+9"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Enhanced ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "impl Trait"
                    }),
                    " / existential types"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _typeAliasImplTraitRev1Default.default),
                focusOn: "1+17",
                emphasize: "1"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "This works!"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Waiting on syntax agreement?"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Needs GATs"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Auto traits"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _autoTraitsDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _autoTraitsDefault1.default),
                lang: "compiler-error",
                focusOn: "1+9,11"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Auto traits"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _autoTraitsRev1Default.default),
                emphasize: "1"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Auto traits"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _autoTraitsRev1Default.default),
                emphasize: "3[0+4]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Auto traits"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _autoTraitsRev1Default1.default),
                lang: "compiler-error",
                focusOn: "1+18"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Auto traits"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _autoTraitsRev1Default1.default),
                lang: "compiler-error",
                focusOn: "20+14,38,43,49,54+6"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                    href: "https://docs.google.com/forms/d/e/1FAIpQLSdwO_txrSUGOE1O8Xclof6MTJWsGq8TiVm0bKt5rSdnmh39QQ/viewform?usp=publish-editor",
                    children: "Quiz"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _changeDeckDefault.default), {
                    deck: "overview",
                    children: "Return"
                })
            })
        ]
    });
}
function MDXContent(props = {}) {
    const { wrapper: MDXLayout } = props.components || {};
    return MDXLayout ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(MDXLayout, {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_createMdxContent, {
            ...props
        })
    }) : _createMdxContent(props);
}
function _missingMdxReference(id, component, place) {
    throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it." + (place ? "\nIt\u2019s referenced in your code at `" + place + "`" : ""));
}

},{"react/jsx-runtime":"afIHK","./Directives":"6Yemz","./ChangeDeck":"29Jlq","./layout/Splash":"1mDy7","./TestPattern":"g0BPT","./Transclude":"fUgcm","rust:types/basic-structure-of-a-trait":"g46cT","rust:types/impl-display-for-vec":"ljXKq","stderr:types/impl-display-for-vec":"5D9oo","rust:types/impl-display-for-vec?rev=1":"faCkM","stderr:types/impl-display-for-vec?rev=1":"7pSC1","rust:types/traits-in-scope":"jvnwY","stderr:types/traits-in-scope?rev=0":"eGSJh","rust:types/traits-in-scope?rev=1":"8KrS9","rust:types/trait-for-odd":"7rZJa","rust:types/basic-generic-structure":"elvO1","rust:types/trait-bounds":"dmozk","stderr:types/trait-bounds":"i1qoj","rust:types/trait-bounds?rev=1":"b1VKk","rust:types/trait-bounds?rev=2":"kFziP","rust:types/trait-bounds?rev=3":"fIFCo","rust:types/trait-bounds?rev=4":"8ONK5","stderr:types/trait-bounds?rev=4":"bux1X","rust:types/two-copies":"fbASu","rust:types/associated-types":"4miwW","rust:types/associated-types?rev=1":"hKmUx","rust:types/associated-types?rev=2":"8nofx","stderr:types/associated-types?rev=2":"eVgyF","rust:types/associated-types?rev=3":"cjzT0","rust:types/associated-types?rev=4":"6jTYQ","stderr:types/associated-types?rev=4":"fX0lv","rust:types/associated-types?rev=5":"llZ3q","rust:types/taking-iterators":"f9ybc","rust:types/taking-iterators?rev=1":"3CJFq","rust:types/generic-traits":"jVK5m","rust:types/generic-associated-types":"3PwlQ","rust:types/default-functions":"4o9tM","rust:types/supertraits":"6BNW6","rust:types/associated-constants":"kijSg","rust:types/default-type-params":"22CGe","rust:types/kitchen-sink":"6wSRl","rust:types/monomorphization":"2n9QN","rust:types/monomorphization?rev=1":"6vsFf","rust:types/trait-objects":"iqlys","rust:types/trait-objects?rev=1":"j3abf","stderr:types/trait-objects?rev=1":"ei7jU","rust:types/trait-objects?rev=2":"4u0gv","rust:types/dyn-compatibility":"4GvZz","stderr:types/dyn-compatibility":"bWfXl","rust:types/trait-object-math":"3Ap35","rust:types/owned-trait-objects":"fcUoH","rust:types/impl-trait":"iHIMm","rust:types/voldemort-types":"aWfxi","rust:types/voldemort-types?rev=1":"aNglz","rust:types/voldemort-types?rev=2":"5QgQ3","stderr:types/voldemort-types?rev=2":"kgYPh","rust:types/impl-trait-return":"9JeI2","rust:types/impl-trait-return?rev=1":"ivKSF","rust:types/impl-trait-arg":"etNgm","rust:types/impl-trait-arg?rev=1":"dyYhT","rust:types/impl-trait-arg?rev=2":"2DcNH","rust:types/impl-trait-iterators":"89XxG","rust:types/caller-chooses":"eUiRl","stderr:types/caller-chooses":"307ix","rust:types/caller-chooses?rev=1":"7eSdn","rust:types/kinds-of-generics":"9PWrX","rust:types/const-generics":"lLRin","rust:types/const-generics-defaults":"47EEr","rust:types/lifetime-bounds":"fZ0aZ","stderr:types/lifetime-bounds":"4JMio","rust:types/lifetime-bounds?rev=1":"8Z901","rust:types/lifetimes-and-traits":"hJ2T7","stderr:types/lifetimes-and-traits":"aS6Rw","rust:types/lifetimes-and-traits?rev=1":"elTwr","rust:types/lifetimes-and-traits?rev=2":"1lQw1","rust:types/lifetimes-and-traits?rev=3":"3O7oj","rust:types/lifetimes-and-traits?rev=4":"6Rnru","rust:types/lifetimes-and-traits?rev=5":"d8UQb","rust:types/higher-ranked-trait-bounds":"hy9mc","stderr:types/higher-ranked-trait-bounds":"a3lJO","rust:types/higher-ranked-trait-bounds?rev=1":"ioxTM","stderr:types/higher-ranked-trait-bounds?rev=1":"3KiHp","rust:types/higher-ranked-trait-bounds?rev=2":"aCC6J","stderr:types/higher-ranked-trait-bounds?rev=2":"12foN","rust:types/higher-ranked-trait-bounds?rev=3":"l2STI","stderr:types/higher-ranked-trait-bounds?rev=3":"ylWm3","rust:types/higher-ranked-trait-bounds?rev=4":"9fr0a","rust:types/specialization":"9R5Vg","stderr:types/specialization":"4gfh5","rust:types/specialization?rev=1":"lRovX","rust:types/const-generics-user-types":"62wBu","stderr:types/const-generics-user-types":"3sQuZ","rust:types/const-generics-user-types?rev=1":"aCEmW","rust:types/const-generics-expressions":"1Fysb","stderr:types/const-generics-expressions":"uKgPw","rust:types/const-generics-expressions?rev=1":"5Wn5C","rust:types/type-alias-impl-trait":"e1gx4","stderr:types/type-alias-impl-trait":"dmljz","rust:types/type-alias-impl-trait?rev=1":"9hL63","rust:types/auto-traits":"52ntE","stderr:types/auto-traits":"48EIl","rust:types/auto-traits?rev=1":"kDFwy","stderr:types/auto-traits?rev=1":"56Omc","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"g46cT":[function(require,module,exports,__globalThis) {
module.exports = "trait Price {\n    fn price(&self) -> i32;\n}\n\nstruct Apple;\n\nimpl Price for Apple {\n    fn price(&self) -> i32 {\n        1\n    }\n}\n\nfn main() {\n    let a = Apple;\n    println!(\"{}\", a.price());\n}\n\nimpl Price for bool {\n    fn price(&self) -> i32 {\n        10\n    }\n}\n\ntrait StringCaseExt {\n    fn apply_awesome_case(&mut self);\n}\n\nimpl StringCaseExt for String {\n    fn apply_awesome_case(&mut self) { /* ... */ }\n}\n";

},{}],"ljXKq":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    println!(\"{}\", vec![1, 2, 3]);\n}\n";

},{}],"5D9oo":[function(require,module,exports,__globalThis) {
module.exports = "error[E0277]: `Vec<{integer}>` doesn't implement `std::fmt::Display`\n --> impl-display-for-vec/src/main.rs:5:5\n  |\n5 |     println!(\"{}\", vec![1, 2, 3]);\n  |     ^^^^^^^^^^--^^^^^^^^^^^^^^^^^\n  |     |         |\n  |     |         required by this formatting parameter\n  |     `Vec<{integer}>` cannot be formatted with the default formatter\n  |\n  = help: the trait `std::fmt::Display` is not implemented for `Vec<{integer}>`\n  = note: in format strings you may be able to use `{:?}` (or {:#?} for pretty-print) instead\n\nFor more information about this error, try `rustc --explain E0277`.\nerror: could not compile `impl-display-for-vec` (bin \"impl-display-for-vec\") due to 1 previous\n       error\n";

},{}],"faCkM":[function(require,module,exports,__globalThis) {
module.exports = "use std::fmt;\n\nfn main() {\n    println!(\"{}\", vec![1, 2, 3]);\n}\n\nimpl fmt::Display for Vec<i32> {\n    fn fmt(&self, f: &mut fmt::Formatter) -> fmt::Result {\n        f.write_str(\"I am a vector\")\n    }\n}\n";

},{}],"7pSC1":[function(require,module,exports,__globalThis) {
module.exports = "error[E0117]: only traits defined in the current crate can be implemented for types defined\n              outside of the crate\n --> impl-display-for-vec/src/main.rs:9:1\n  |\n9 | impl fmt::Display for Vec<i32> {\n  | ^^^^^^^^^^^^^^^^^^^^^^--------\n  |                       |\n  |                       `Vec` is not defined in the current crate\n  |\n  = note: impl doesn't have any local type before any uncovered type parameters\n  = note: for more information see\n  =       https://doc.rust-lang.org/reference/items/implementations.html#orphan-rules\n  = note: define and implement a trait or new type instead\n\nFor more information about this error, try `rustc --explain E0117`.\nerror: could not compile `impl-display-for-vec` (bin \"impl-display-for-vec\") due to 1 previous\n       error\n";

},{}],"jvnwY":[function(require,module,exports,__globalThis) {
module.exports = "mod inner {\n    pub trait MyExt {\n        fn example(&self) -> i32;\n    }\n\n    impl MyExt for bool {\n        fn example(&self) -> i32 {\n            42\n        }\n    }\n}\n\nfn main() {\n    false.example();\n}\n";

},{}],"eGSJh":[function(require,module,exports,__globalThis) {
module.exports = "error[E0599]: no method named `example` found for type `bool` in the current scope\n  --> traits-in-scope/src/main.rs:17:11\n   |\n 3 |         fn example(&self) -> i32;\n   |            ------- the method is available for `bool` here\n...\n17 |     false.example();\n   |           ^^^^^^^ method not found in `bool`\n   |\n   = help: items from traits can only be used if the trait is in scope\nhelp: trait `MyExt` which provides `example` is implemented but not in scope; perhaps you want\n   |  to import it\n   |\n 1 + use crate::inner::MyExt;\n   |\n\nFor more information about this error, try `rustc --explain E0599`.\nerror: could not compile `traits-in-scope` (bin \"traits-in-scope\") due to 1 previous error\n";

},{}],"8KrS9":[function(require,module,exports,__globalThis) {
module.exports = "mod inner {\n    pub trait MyExt {\n        fn example(&self) -> i32;\n    }\n\n    impl MyExt for bool {\n        fn example(&self) -> i32 {\n            42\n        }\n    }\n}\n\nuse inner::MyExt;\n\nfn main() {\n    false.example();\n}\n";

},{}],"7rZJa":[function(require,module,exports,__globalThis) {
module.exports = "trait IsOdd {\n    fn is_odd(&self) -> bool;\n}\n\nimpl IsOdd for bool {\n    fn is_odd(&self) -> bool {\n        *self\n    }\n}\n\nimpl IsOdd for i32 {\n    fn is_odd(&self) -> bool {\n        *self % 2 != 0\n    }\n}\n\nfn main() {\n    println!(\"{}\", true.is_odd());\n    println!(\"{}\", 42.is_odd());\n}\n";

},{}],"elvO1":[function(require,module,exports,__globalThis) {
module.exports = "fn my_generic<T>(value: T) -> T {\n    value\n}\n\nstruct MyStruct<T>(T);\n\nimpl<T> MyStruct<T> {\n    fn my_generic(self) -> T {\n        self.0\n    }\n}\n\nfn main() {}\n";

},{}],"dmozk":[function(require,module,exports,__globalThis) {
module.exports = "fn my_generic<T>(value: T) {\n    println!(\"{value}\");\n}\n\nfn main() {\n    my_generic(vec![1, 2, 3]);\n}\n";

},{}],"i1qoj":[function(require,module,exports,__globalThis) {
module.exports = "error[E0277]: `T` doesn't implement `std::fmt::Display`\n --> trait-bounds/src/main.rs:3:15\n  |\n3 |     println!(\"{value}\");\n  |               ^^^^^^^ `T` cannot be formatted with the default formatter\n  |\n  = note: in format strings you may be able to use `{:?}` (or {:#?} for pretty-print) instead\nhelp: consider restricting type parameter `T` with trait `Display`\n  |\n2 | fn my_generic<T: std::fmt::Display>(value: T) {\n  |                +++++++++++++++++++\n\nFor more information about this error, try `rustc --explain E0277`.\nerror: could not compile `trait-bounds` (bin \"trait-bounds\") due to 1 previous error\n";

},{}],"b1VKk":[function(require,module,exports,__globalThis) {
module.exports = "use std::fmt::Display;\n\nfn my_generic<T: Display>(value: T) {\n    println!(\"{value}\");\n}\n\nfn main() {\n    my_generic(vec![1, 2, 3]);\n}\n";

},{}],"kFziP":[function(require,module,exports,__globalThis) {
module.exports = "use std::fmt::Display;\n\nfn my_generic<T>(value: T)\nwhere\n    T: Display,\n{\n    println!(\"{value}\");\n}\n\nfn main() {\n    my_generic(vec![1, 2, 3]);\n}\n";

},{}],"fIFCo":[function(require,module,exports,__globalThis) {
module.exports = "use std::fmt::{Debug, Display};\n\nfn my_generic<T: Debug + Display + Clone>(value: T) {\n    println!(\"{value}\");\n}\n\nfn main() {\n    my_generic(vec![1, 2, 3]);\n}\n";

},{}],"8ONK5":[function(require,module,exports,__globalThis) {
module.exports = "use std::fmt::{Debug, Display};\n\nfn my_generic<T>(value: T)\nwhere\n    T: Debug + Display,\n    T: Clone,\n{\n    println!(\"{value}\");\n}\n\nfn main() {\n    my_generic(vec![1, 2, 3]);\n}\n";

},{}],"bux1X":[function(require,module,exports,__globalThis) {
module.exports = "error[E0277]: `Vec<{integer}>` doesn't implement `std::fmt::Display`\n  --> trait-bounds/src/main.rs:40:16\n   |\n40 |     my_generic(vec![1, 2, 3]);\n   |     ---------- ^^^^^^^^^^^^^ the trait `std::fmt::Display` is not implemented for\n   |     |                        `Vec<{integer}>`\n   |     |\n   |     required by a bound introduced by this call\n   |\nnote: required by a bound in `my_generic`\n  --> trait-bounds/src/main.rs:33:16\n   |\n31 | fn my_generic<T>(value: T)\n   |    ---------- required by a bound in this function\n32 | where\n33 |     T: Debug + Display,\n   |                ^^^^^^^ required by this bound in `my_generic`\n\nFor more information about this error, try `rustc --explain E0277`.\nerror: could not compile `trait-bounds` (bin \"trait-bounds\") due to 1 previous error\n";

},{}],"fbASu":[function(require,module,exports,__globalThis) {
module.exports = "fn generic_duplicator<T>(value: T) -> (T, T)\nwhere\n    T: Clone,\n{\n    (value.clone(), value)\n}\n\nfn main() {\n    let (a, b) = generic_duplicator(vec![1, 2, 3]);\n    assert_eq!(a, b);\n    let (x, y) = generic_duplicator(false);\n    assert_eq!(x, y);\n}\n";

},{}],"4miwW":[function(require,module,exports,__globalThis) {
module.exports = "#[derive(Debug)]\nstruct Dollars(u32);\n\n#[derive(Debug)]\nstruct Baht(u32);\n\nstruct Apple;\n\nimpl Apple {\n    fn price(&self) -> Dollars {\n        Dollars(1)\n    }\n}\n\nstruct Durian;\n\nimpl Durian {\n    fn price(&self) -> Baht {\n        Baht(50)\n    }\n}\n\ntrait Fruit {\n    fn price(&self) /* -> What type goes here? */;\n}\n\nfn main() {}\n";

},{}],"hKmUx":[function(require,module,exports,__globalThis) {
module.exports = "#[derive(Debug)]\nstruct Dollars(u32);\n\n#[derive(Debug)]\nstruct Baht(u32);\n\nstruct Apple;\n\nstruct Durian;\n\ntrait Fruit {\n    type Currency;\n\n    fn price(&self) -> Self::Currency;\n}\n\nimpl Fruit for Apple {\n    type Currency = Dollars;\n\n    fn price(&self) -> Self::Currency {\n        Dollars(1)\n    }\n}\n\nimpl Fruit for Durian {\n    type Currency = Baht;\n\n    fn price(&self) -> Self::Currency {\n        Baht(50)\n    }\n}\n\nfn generic_fruit<T>(fruit: T)\nwhere\n    T: Fruit,\n{\n    let price = fruit.price();\n}\n\nfn main() {}\n";

},{}],"8nofx":[function(require,module,exports,__globalThis) {
module.exports = "#[derive(Debug)]\nstruct Dollars(u32);\n\n#[derive(Debug)]\nstruct Baht(u32);\n\nstruct Apple;\n\nstruct Durian;\n\ntrait Fruit {\n    type Currency;\n\n    fn price(&self) -> Self::Currency;\n}\n\nimpl Fruit for Apple {\n    type Currency = Dollars;\n\n    fn price(&self) -> Self::Currency {\n        Dollars(1)\n    }\n}\n\nimpl Fruit for Durian {\n    type Currency = Baht;\n\n    fn price(&self) -> Self::Currency {\n        Baht(50)\n    }\n}\n\nfn generic_fruit<T>(fruit: T)\nwhere\n    T: Fruit,\n{\n    let price = fruit.price();\n    println!(\"This fruit costs {price:?}\");\n}\n\nfn main() {}\n";

},{}],"eVgyF":[function(require,module,exports,__globalThis) {
module.exports = "error[E0277]: `<T as Fruit>::Currency` doesn't implement `Debug`\n  --> associated-types/src/main.rs:69:32\n   |\n69 |     println!(\"This fruit costs {price:?}\");\n   |                                ^^^^^^^^^ `<T as Fruit>::Currency` cannot be formatted\n   |                                          using `{:?}` because it doesn't implement `Debug`\n   |\n   = help: the trait `Debug` is not implemented for `<T as Fruit>::Currency`\nhelp: consider further restricting the associated type\n   |\n66 |     T: Fruit, <T as Fruit>::Currency: Debug\n   |               +++++++++++++++++++++++++++++\n\nFor more information about this error, try `rustc --explain E0277`.\nerror: could not compile `associated-types` (bin \"associated-types\") due to 1 previous error\n";

},{}],"cjzT0":[function(require,module,exports,__globalThis) {
module.exports = "#[derive(Debug)]\nstruct Dollars(u32);\n\n#[derive(Debug)]\nstruct Baht(u32);\n\nstruct Apple;\n\nstruct Durian;\n\ntrait Fruit {\n    type Currency;\n\n    fn price(&self) -> Self::Currency;\n}\n\nimpl Fruit for Apple {\n    type Currency = Dollars;\n\n    fn price(&self) -> Self::Currency {\n        Dollars(1)\n    }\n}\n\nimpl Fruit for Durian {\n    type Currency = Baht;\n\n    fn price(&self) -> Self::Currency {\n        Baht(50)\n    }\n}\n\nuse std::fmt::Debug;\n\nfn generic_fruit<T>(fruit: T)\nwhere\n    T: Fruit,\n    T::Currency: Debug,\n{\n    let price = fruit.price();\n    println!(\"This fruit costs {price:?}\");\n}\n\nfn main() {}\n";

},{}],"6jTYQ":[function(require,module,exports,__globalThis) {
module.exports = "#[derive(Debug)]\nstruct Dollars(u32);\n\n#[derive(Debug)]\nstruct Baht(u32);\n\nstruct Apple;\n\nstruct Durian;\n\ntrait Fruit {\n    type Currency;\n\n    fn price(&self) -> Self::Currency;\n}\n\nimpl Fruit for Apple {\n    type Currency = Dollars;\n\n    fn price(&self) -> Self::Currency {\n        Dollars(1)\n    }\n}\n\nimpl Fruit for Durian {\n    type Currency = Baht;\n\n    fn price(&self) -> Self::Currency {\n        Baht(50)\n    }\n}\n\nfn generic_us_fruit<T>(fruit: T)\nwhere\n    T: Fruit,\n{\n    let Dollars(price) = fruit.price();\n    println!(\"This fruit costs {price} USD\");\n}\n\nfn main() {}\n";

},{}],"fX0lv":[function(require,module,exports,__globalThis) {
module.exports = "error[E0308]: mismatched types\n  --> associated-types/src/main.rs:90:9\n   |\n90 |     let Dollars(price) = fruit.price();\n   |         ^^^^^^^^^^^^^^   ------------- this expression has type `<T as Fruit>::Currency`\n   |         |\n   |         expected associated type, found `Dollars`\n   |\n   = note: expected associated type `<T as Fruit>::Currency`\n                       found struct `Dollars`\nhelp: a method is available that returns `<T as Fruit>::Currency`\n  --> associated-types/src/main.rs:34:5\n   |\n34 |     fn price(&self) -> Self::Currency;\n   |     ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^ consider calling `Fruit::price`\nhelp: consider constraining the associated type `<T as Fruit>::Currency` to `Dollars`\n   |\n88 |     T: Fruit<Currency = Dollars>,\n   |             ++++++++++++++++++++\n\nFor more information about this error, try `rustc --explain E0308`.\nerror: could not compile `associated-types` (bin \"associated-types\") due to 1 previous error\n";

},{}],"llZ3q":[function(require,module,exports,__globalThis) {
module.exports = "#[derive(Debug)]\nstruct Dollars(u32);\n\n#[derive(Debug)]\nstruct Baht(u32);\n\nstruct Apple;\n\nstruct Durian;\n\ntrait Fruit {\n    type Currency;\n\n    fn price(&self) -> Self::Currency;\n}\n\nimpl Fruit for Apple {\n    type Currency = Dollars;\n\n    fn price(&self) -> Self::Currency {\n        Dollars(1)\n    }\n}\n\nimpl Fruit for Durian {\n    type Currency = Baht;\n\n    fn price(&self) -> Self::Currency {\n        Baht(50)\n    }\n}\n\nfn generic_us_fruit<T>(fruit: T)\nwhere\n    T: Fruit<Currency = Dollars>,\n{\n    let Dollars(price) = fruit.price();\n    println!(\"This fruit costs {price} USD\");\n}\n\nfn main() {}\n";

},{}],"f9ybc":[function(require,module,exports,__globalThis) {
module.exports = "fn add_them_up<I>(iter: I) -> i32\nwhere\n    I: Iterator<Item = i32>,\n{\n    let mut sum = 0;\n    for v in iter {\n        sum += v;\n    }\n    sum\n}\n\nfn stringify<I>(iter: I) -> String\nwhere\n    I: Iterator,\n    I::Item: ToString,\n{\n    let mut string = String::new();\n    for v in iter {\n        string += &v.to_string();\n    }\n    string\n}\n\nfn main() {\n    assert_eq!(45, add_them_up(0..10));\n\n    let string_slices = [\"hello\", \" \", \"world\"];\n    assert_eq!(\"hello world\", stringify(string_slices.into_iter()));\n\n    let strings = [\"hello\", \" \", \"world\"].map(String::from);\n    assert_eq!(\"hello world\", stringify(strings.into_iter()));\n}\n";

},{}],"3CJFq":[function(require,module,exports,__globalThis) {
module.exports = "fn add_them_up<I>(iter: I) -> i32\nwhere\n    I: Iterator<Item = i32>,\n{\n    iter.fold(0, |sum, v| sum + v)\n}\n\nfn stringify<I>(iter: I) -> String\nwhere\n    I: Iterator,\n    I::Item: ToString,\n{\n    iter.fold(String::new(), |string, v| string + &v.to_string())\n}\n\nfn main() {\n    assert_eq!(45, add_them_up(0..10));\n\n    let string_slices = [\"hello\", \" \", \"world\"];\n    assert_eq!(\"hello world\", stringify(string_slices.into_iter()));\n\n    let strings = [\"hello\", \" \", \"world\"].map(String::from);\n    assert_eq!(\"hello world\", stringify(strings.into_iter()));\n}\n";

},{}],"jVK5m":[function(require,module,exports,__globalThis) {
module.exports = "trait AsRef<T> {\n    fn as_ref(&self) -> &T;\n}\n\nstruct Student {\n    name: String,\n    age: u8,\n}\n\nimpl AsRef<String> for Student {\n    fn as_ref(&self) -> &String {\n        &self.name\n    }\n}\n\nimpl AsRef<u8> for Student {\n    fn as_ref(&self) -> &u8 {\n        &self.age\n    }\n}\n\nfn main() {}\n";

},{}],"3PwlQ":[function(require,module,exports,__globalThis) {
module.exports = "trait LendingIterator {\n    type Item<'a>\n    where\n        Self: 'a;\n\n    fn next<'a>(&'a mut self) -> Option<Self::Item<'a>>;\n}\n\nstruct BufferedData {\n    data: [u8; 4],\n    idx: usize,\n}\n\nimpl LendingIterator for BufferedData {\n    type Item<'a> = &'a mut u8;\n\n    fn next(&mut self) -> Option<Self::Item<'_>> {\n        let v = self.data.get_mut(self.idx)?;\n        self.idx += 1;\n        Some(v)\n    }\n}\n\nfn main() {\n    let mut buf = BufferedData {\n        data: [1, 2, 3, 4],\n        idx: 0,\n    };\n\n    while let Some(v) = buf.next() {\n        println!(\"{v}\");\n    }\n}\n";

},{}],"4o9tM":[function(require,module,exports,__globalThis) {
module.exports = "trait Person {\n    fn name(&self) -> &str;\n\n    fn greet(&self) {\n        println!(\"Hello, {}!\", self.name())\n    }\n}\n\nstruct Child(String);\n\nimpl Person for Child {\n    fn name(&self) -> &str {\n        &self.0\n    }\n}\n\nstruct Pilot(String);\n\nimpl Person for Pilot {\n    fn name(&self) -> &str {\n        &self.0\n    }\n\n    fn greet(&self) {\n        println!(\"Hello, this is your pilot speaking.\")\n    }\n}\n\nfn main() {}\n";

},{}],"6BNW6":[function(require,module,exports,__globalThis) {
module.exports = "use std::fmt::Debug;\n\ntrait Person: Debug {\n    fn name(&self) -> &str;\n\n    fn greet(&self) {\n        println!(\"Hello, {self:?}!\")\n    }\n}\n\n#[derive(Debug)]\nstruct Child(String);\n\nimpl Person for Child {\n    fn name(&self) -> &str {\n        &self.0\n    }\n}\n\nfn main() {}\n";

},{}],"kijSg":[function(require,module,exports,__globalThis) {
module.exports = "trait Fruit {\n    const ITEMS_PER_BOX: u8;\n\n    fn price(&self) -> u32;\n}\n\nstruct Orange;\n\nimpl Fruit for Orange {\n    const ITEMS_PER_BOX: u8 = 32;\n\n    fn price(&self) -> u32 {\n        30\n    }\n}\n\nfn main() {}\n";

},{}],"22CGe":[function(require,module,exports,__globalThis) {
module.exports = "trait AudioFile<D = f32> {\n    fn silence_below(&mut self, min: D);\n}\n\nstruct Mp3;\n\nimpl AudioFile for Mp3 {\n    fn silence_below(&mut self, min: f32) {\n        /* ... */\n    }\n}\n\nfn main() {}\n";

},{}],"6wSRl":[function(require,module,exports,__globalThis) {
module.exports = "use std::fmt::Debug;\n\ntrait Snack: Debug + PartialEq {\n    fn consume(&self, other: &Self) {\n        if self == other {\n            println!(\"Eating {self:?} and {other:?}\")\n        }\n    }\n}\n\n#[derive(Debug, PartialEq)]\nstruct Candy(u8);\nimpl Snack for Candy {}\n\n#[derive(Debug, PartialEq)]\nstruct Cookie(u8);\nimpl Snack for Cookie {\n    fn consume(&self, other: &Self) {\n        if self != other {\n            println!(\"Eating just {self:?}\")\n        }\n    }\n}\n\nfn main() {\n    Cookie(3).consume(&Cookie(4)); // Eats Cookie(3)\n    Cookie(3).consume(&Cookie(3)); // Eats nothing\n    Candy(1).consume(&Candy(1)); // Eats both candy\n}\n";

},{}],"2n9QN":[function(require,module,exports,__globalThis) {
module.exports = "trait Math {\n    fn complicated_thing(&self);\n}\n\nstruct Geometry;\n\nimpl Math for Geometry {\n    fn complicated_thing(&self) {\n        println!(\"Bisecting the angle\")\n    }\n}\n\nstruct Calculus;\n\nimpl Math for Calculus {\n    fn complicated_thing(&self) {\n        println!(\"Remembering to add the constant\")\n    }\n}\n\nfn do_math<M: Math>(math: M) {\n    math.complicated_thing();\n}\n\nfn main() {\n    do_math(Geometry);\n    do_math(Calculus);\n}\n";

},{}],"6vsFf":[function(require,module,exports,__globalThis) {
module.exports = "struct Geometry;\n\nstruct Calculus;\n\nfn do_math__Geometry(math: Geometry) {\n    println!(\"Bisecting the angle\")\n}\n\nfn do_math__Calculus(math: Calculus) {\n    println!(\"Remembering to add the constant\")\n}\n\nfn main() {\n    do_math__Geometry(Geometry);\n    do_math__Calculus(Calculus);\n}\n";

},{}],"iqlys":[function(require,module,exports,__globalThis) {
module.exports = "trait Toy {\n    fn cavort_with(&self);\n}\n\nstruct Doll;\n\nimpl Toy for Doll {\n    fn cavort_with(&self) { /* ... */ }\n}\n\nstruct Drum;\n\nimpl Toy for Drum {\n    fn cavort_with(&self) { /* ... */ }\n}\n\nfn child(toy: &dyn Toy) {\n    toy.cavort_with()\n}\n\nfn main() {\n    child(&Doll);\n    child(&Drum);\n}\n";

},{}],"j3abf":[function(require,module,exports,__globalThis) {
module.exports = "trait Toy {\n    fn cavort_with(&self);\n}\n\nstruct Doll;\n\nimpl Toy for Doll {\n    fn cavort_with(&self) { /* ... */ }\n}\n\nstruct Drum;\n\nimpl Toy for Drum {\n    fn cavort_with(&self) { /* ... */ }\n}\n\nfn child(toy: &dyn Toy) {\n    toy.cavort_with()\n}\n\nfn main() {\n    let toys = vec![Doll, Drum];\n    for toy in &toys {\n        child(toy);\n    }\n}\n";

},{}],"ei7jU":[function(require,module,exports,__globalThis) {
module.exports = "error[E0308]: mismatched types\n  --> trait-objects/src/main.rs:29:27\n   |\n29 |     let toys = vec![Doll, Drum];\n   |                           ^^^^ expected `Doll`, found `Drum`\n\nFor more information about this error, try `rustc --explain E0308`.\nerror: could not compile `trait-objects` (bin \"trait-objects\") due to 1 previous error\n";

},{}],"4u0gv":[function(require,module,exports,__globalThis) {
module.exports = "trait Toy {\n    fn cavort_with(&self);\n}\n\nstruct Doll;\n\nimpl Toy for Doll {\n    fn cavort_with(&self) { /* ... */ }\n}\n\nstruct Drum;\n\nimpl Toy for Drum {\n    fn cavort_with(&self) { /* ... */ }\n}\n\nfn child(toy: &dyn Toy) {\n    toy.cavort_with()\n}\n\nfn main() {\n    let toys: Vec<Box<dyn Toy>> = vec![Box::new(Doll), Box::new(Drum)];\n    for toy in &toys {\n        child(&**toy);\n    }\n}\n";

},{}],"4GvZz":[function(require,module,exports,__globalThis) {
module.exports = "trait Toy: Clone {\n    fn cavort_with(&self);\n}\n\nfn play_twice(toy: &dyn Toy) {\n    let another_toy = toy.clone();\n}\n\nfn main() {}\n";

},{}],"bWfXl":[function(require,module,exports,__globalThis) {
module.exports = "error[E0038]: the trait `Toy` is not dyn compatible\n --> dyn-compatibility/src/main.rs:5:21\n  |\n5 | fn play_twice(toy: &dyn Toy) {\n  |                     ^^^^^^^ `Toy` is not dyn compatible\n  |\nnote: for a trait to be dyn compatible it needs to allow building a vtable\n      for more information, visit\n      <https://doc.rust-lang.org/reference/items/traits.html#dyn-compatibility>\n --> dyn-compatibility/src/main.rs:1:12\n  |\n1 | trait Toy: Clone {\n  |       ---  ^^^^^ ...because it requires `Self: Sized`\n  |       |\n  |       this trait is not dyn compatible...\n\nFor more information about this error, try `rustc --explain E0038`.\nerror: could not compile `dyn-compatibility` (bin \"dyn-compatibility\") due to 1 previous error\n";

},{}],"3Ap35":[function(require,module,exports,__globalThis) {
module.exports = "trait Operation {\n    fn operation(&self, v: i32) -> i32;\n}\n\nstruct AddFortyTwo;\n\nimpl Operation for AddFortyTwo {\n    fn operation(&self, v: i32) -> i32 {\n        v + 42\n    }\n}\n\nstruct DivideBy(i32);\n\nimpl Operation for DivideBy {\n    fn operation(&self, v: i32) -> i32 {\n        v / self.0\n    }\n}\n\nfn run_calculations(s: i32, ops: &[&dyn Operation]) -> i32 {\n    ops.into_iter().fold(s, |s, op| op.operation(s))\n}\n\nfn main() {\n    assert_eq!(run_calculations(0, &[&AddFortyTwo, &DivideBy(10)]), 4);\n}\n";

},{}],"fcUoH":[function(require,module,exports,__globalThis) {
module.exports = "trait Animal {\n    fn speak(&self);\n}\n\n// Assume structs and trait implementations for Cat, Dinosaur, Rabbit, Newt\n\nfn animal(is_loud: bool, is_fuzzy: bool) -> Box<dyn Animal> {\n    match (is_loud, is_fuzzy) {\n        (true, true) => Box::new(Cat),\n        (true, false) => Box::new(Dinosaur),\n        (false, true) => Box::new(Rabbit),\n        (false, false) => Box::new(Newt),\n    }\n}\n\nstruct Cat;\nimpl Animal for Cat {\n    fn speak(&self) {}\n}\n\nstruct Dinosaur;\nimpl Animal for Dinosaur {\n    fn speak(&self) {}\n}\n\nstruct Rabbit;\nimpl Animal for Rabbit {\n    fn speak(&self) {}\n}\n\nstruct Newt;\nimpl Animal for Newt {\n    fn speak(&self) {}\n}\n\nfn main() {}\n";

},{}],"iHIMm":[function(require,module,exports,__globalThis) {
module.exports = "trait Animal {\n    fn speak(&self);\n}\n\nstruct Cat;\n\nimpl Animal for Cat {\n    fn speak(&self) {\n        println!(\"meow\")\n    }\n}\n\nfn meower() -> impl Animal {\n    Cat\n}\n\nfn main() {\n    meower().speak();\n}\n";

},{}],"aWfxi":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let some_closure = |i| i + 1;\n    let v = some_closure(42);\n}\n";

},{}],"aNglz":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let some_closure = |i| i + 1;\n    let closure_trait_obj: &dyn Fn(i32) -> i32 = &some_closure;\n    let v = closure_trait_obj(42);\n}\n";

},{}],"5QgQ3":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let some_closure: () = |i| i + 1;\n}\n";

},{}],"kgYPh":[function(require,module,exports,__globalThis) {
module.exports = "error[E0308]: mismatched types\n  --> voldemort-types/src/main.rs:16:28\n   |\n16 |     let some_closure: () = |i| i + 1;\n   |                       --   ^^^^^^^^^ expected `()`, found closure\n   |                       |\n   |                       expected due to this\n   |\n   = note: expected unit type `()`\n                found closure `{closure@voldemort-types/src/main.rs:16:28: 16:31}`\n\nFor more information about this error, try `rustc --explain E0308`.\nerror: could not compile `voldemort-types` (bin \"voldemort-types\") due to 1 previous error\n";

},{}],"9JeI2":[function(require,module,exports,__globalThis) {
module.exports = "fn make_adder(v: i32) -> impl Fn(i32) -> i32 {\n    move |v2| v + v2\n}\n\nfn main() {\n    let add_1 = make_adder(1);\n    assert_eq!(add_1(2), 3);\n}\n";

},{}],"ivKSF":[function(require,module,exports,__globalThis) {
module.exports = "fn make_iter() -> impl Iterator<Item = i32> {\n    vec![0, 1, 2].into_iter().map(|v| v * v)\n}\n\nfn main() {\n    for i in make_iter() {\n        println!(\"{i}\");\n    }\n}\n";

},{}],"etNgm":[function(require,module,exports,__globalThis) {
module.exports = "fn lots_of_noise(animal: impl Animal) {\n    for _ in 0..10 {\n        animal.speak()\n    }\n}\n\nfn main() {}\n";

},{}],"dyYhT":[function(require,module,exports,__globalThis) {
module.exports = "fn lots_of_noise<A: Animal>(animal: A) {\n    for _ in 0..10 {\n        animal.speak()\n    }\n}\n\nfn main() {}\n";

},{}],"2DcNH":[function(require,module,exports,__globalThis) {
module.exports = "fn lots_of_noise<A>(animal: A)\nwhere\n    A: Animal,\n{\n    for _ in 0..10 {\n        animal.speak()\n    }\n}\n\nfn main() {}\n";

},{}],"89XxG":[function(require,module,exports,__globalThis) {
module.exports = "fn generate() -> impl Iterator<Item = i32> {\n    0..10\n}\n\nfn double(i: impl Iterator<Item = i32>) -> impl Iterator<Item = i32> {\n    i.map(|v| v * 2)\n}\n\nfn print(i: impl Iterator<Item = i32>) {\n    for v in i {\n        println!(\"{v}\")\n    }\n}\n\nfn main() {\n    print(double(generate()));\n}\n";

},{}],"eUiRl":[function(require,module,exports,__globalThis) {
module.exports = "fn something_printable<T>() -> T\nwhere\n    T: std::fmt::Display,\n{\n    \"42\"\n}\n\nfn bad_usage() {\n    something_printable::<bool>();\n}\n\nfn main() {}\n";

},{}],"307ix":[function(require,module,exports,__globalThis) {
module.exports = "error[E0308]: mismatched types\n --> caller-chooses/src/main.rs:6:5\n  |\n2 | fn something_printable<T>() -> T\n  |                        -       -\n  |                        |       |\n  |                        |       expected `T` because of return type\n  |                        |       help: consider using an impl return type: `impl\n  |                        |             std::fmt::Display`\n  |                        expected this type parameter\n...\n6 |     \"42\"\n  |     ^^^^ expected type parameter `T`, found `&str`\n  |\n  = note: expected type parameter `T`\n                  found reference `&'static str`\n  = note: the caller chooses a type for `T` which can be different from `&'static str`\n\nFor more information about this error, try `rustc --explain E0308`.\nerror: could not compile `caller-chooses` (bin \"caller-chooses\") due to 1 previous error\n";

},{}],"7eSdn":[function(require,module,exports,__globalThis) {
module.exports = "fn something_printable() -> impl std::fmt::Display {\n    \"42\"\n}\n\nfn main() {}\n";

},{}],"9PWrX":[function(require,module,exports,__globalThis) {
module.exports = "fn alpha<'a>(x: &'a u8) {}\n\nfn sigma<T>(x: T) {}\n\nfn omega<const N: usize>() {}\n\nfn main() {}\n";

},{}],"lLRin":[function(require,module,exports,__globalThis) {
module.exports = "fn many_zeroes<const N: usize>() -> [i32; N] {\n    [0; N]\n}\n\nfn main() {\n    many_zeroes::<8>();\n}\n";

},{}],"47EEr":[function(require,module,exports,__globalThis) {
module.exports = "struct Example<const N: usize = 42>;\n\nfn main() {}\n";

},{}],"fZ0aZ":[function(require,module,exports,__globalThis) {
module.exports = "fn cloned<'a, I, T>(v: I) -> T\nwhere\n    I: Into<&'a T>,\n    T: Clone,\n{\n    v.into().clone()\n}\n\nfn main() {}\n";

},{}],"4JMio":[function(require,module,exports,__globalThis) {
module.exports = "error[E0309]: the parameter type `T` may not live long enough\n --> lifetime-bounds/src/main.rs:4:8\n  |\n2 | fn cloned<'a, I, T>(v: I) -> T\n  |           -- the parameter type `T` must be valid for the lifetime `'a` as defined here...\n3 | where\n4 |     I: Into<&'a T>,\n  |        ^^^^^^^^^^^ ...so that the reference type `&'a T` does not outlive the data it\n  |                    points at\n  |\nhelp: consider adding an explicit lifetime bound\n  |\n5 |     T: Clone + 'a,\n  |              ++++\n\nerror[E0309]: the parameter type `T` may not live long enough\n --> lifetime-bounds/src/main.rs:7:5\n  |\n2 | fn cloned<'a, I, T>(v: I) -> T\n  |           -- the parameter type `T` must be valid for the lifetime `'a` as defined here...\n...\n7 |     v.into().clone()\n  |     ^^^^^^^^ ...so that the type `T` will meet its required lifetime bounds\n  |\nhelp: consider adding an explicit lifetime bound\n  |\n5 |     T: Clone + 'a,\n  |              ++++\n\nFor more information about this error, try `rustc --explain E0309`.\nerror: could not compile `lifetime-bounds` (bin \"lifetime-bounds\") due to 2 previous errors\n";

},{}],"8Z901":[function(require,module,exports,__globalThis) {
module.exports = "fn cloned<'a, I, T>(v: I) -> T\nwhere\n    I: Into<&'a T>,\n    T: Clone,\n    T: 'a,\n{\n    v.into().clone()\n}\n\nfn main() {}\n";

},{}],"hJ2T7":[function(require,module,exports,__globalThis) {
module.exports = "#[derive(Debug, Default)]\nstruct Gradebook {\n    scores: Vec<u8>,\n}\n\nimpl Gradebook {\n    fn scores(&self) -> impl Iterator<Item = u8> {\n        self.scores.iter().copied()\n    }\n}\n\nfn main() {}\n";

},{}],"aS6Rw":[function(require,module,exports,__globalThis) {
module.exports = "error[E0700]: hidden type for `impl Iterator<Item = u8>` captures lifetime that does not\n              appear in bounds\n --> lifetimes-and-traits/src/main.rs:9:9\n  |\n8 |     fn scores(&self) -> impl Iterator<Item = u8> {\n  |               -----     ------------------------ opaque type defined here\n  |               |\n  |               hidden type `Copied<std::slice::Iter<'_, u8>>` captures the anonymous\n  |               lifetime defined here\n9 |         self.scores.iter().copied()\n  |         ^^^^^^^^^^^^^^^^^^^^^^^^^^^\n  |\nhelp: add a `use<...>` bound to explicitly capture `'_`\n  |\n8 |     fn scores(&self) -> impl Iterator<Item = u8> + use<'_> {\n  |                                                  +++++++++\n\nFor more information about this error, try `rustc --explain E0700`.\nerror: could not compile `lifetimes-and-traits` (bin \"lifetimes-and-traits\") due to 1 previous\n       error\n";

},{}],"elTwr":[function(require,module,exports,__globalThis) {
module.exports = "#[derive(Debug, Default)]\nstruct Gradebook {\n    scores: Vec<u8>,\n}\n\nimpl Gradebook {\n    fn scores<'a>(&'a self) -> impl Iterator<Item = u8> + 'static {\n        self.scores.iter().copied()\n    }\n}\n\nfn main() {}\n";

},{}],"1lQw1":[function(require,module,exports,__globalThis) {
module.exports = "#[derive(Debug, Default)]\nstruct Gradebook {\n    scores: Vec<u8>,\n}\n\nimpl Gradebook {\n    fn scores<'a>(&'a self) -> std::iter::Copied<std::slice::Iter<'a, u8>> {\n        self.scores.iter().copied()\n    }\n}\n\nfn main() {}\n";

},{}],"3O7oj":[function(require,module,exports,__globalThis) {
module.exports = "#[derive(Debug, Default)]\nstruct Gradebook {\n    scores: Vec<u8>,\n}\n\nimpl Gradebook {\n    fn scores<'a>(&'a self) -> impl Iterator<Item = u8> + 'a {\n        self.scores.iter().copied()\n    }\n}\n\nfn main() {}\n";

},{}],"6Rnru":[function(require,module,exports,__globalThis) {
module.exports = "#[derive(Debug, Default)]\nstruct Gradebook {\n    scores: Vec<u8>,\n}\n\nimpl Gradebook {\n    fn scores(&self) -> impl Iterator<Item = u8> + '_ {\n        self.scores.iter().copied()\n    }\n}\n\nfn main() {}\n";

},{}],"d8UQb":[function(require,module,exports,__globalThis) {
module.exports = "#[derive(Debug, Default)]\nstruct Gradebook {\n    scores: Vec<u8>,\n}\n\nimpl Gradebook {\n    fn scores(&self) -> impl Iterator<Item = u8> + use<'_> {\n        self.scores.iter().copied()\n    }\n}\n\nfn main() {}\n";

},{}],"hy9mc":[function(require,module,exports,__globalThis) {
module.exports = "trait Holder {\n    type Value;\n    fn get(&self) -> &Self::Value;\n}\n\ntrait Identify {\n    fn identify(&self);\n}\n\nstruct Container(Example);\n\nimpl Holder for Container {\n    type Value = Example;\n    fn get(&self) -> &Self::Value {\n        &self.0\n    }\n}\n\nstruct Example;\n\nimpl Identify for Example {\n    fn identify(&self) {\n        println!(\"I am an Example\")\n    }\n}\n\nfn default_and_identify<H>(holder: H)\nwhere\n    H: Holder,\n{\n    let value = holder.get();\n    value.identify();\n}\n\nfn main() {}\n";

},{}],"a3lJO":[function(require,module,exports,__globalThis) {
module.exports = "error[E0599]: no method named `identify` found for reference `&<H as Holder>::Value` in the\n              current scope\n  --> higher-ranked-trait-bounds/src/main.rs:33:11\n   |\n33 |     value.identify();\n   |           ^^^^^^^^ method not found in `&<H as Holder>::Value`\n   |\n   = help: items from traits can only be used if the trait is implemented and in scope\nnote: `Identify` defines an item `identify`, perhaps you need to implement it\n  --> higher-ranked-trait-bounds/src/main.rs:6:1\n   |\n 6 | trait Identify {\n   | ^^^^^^^^^^^^^^\n\nFor more information about this error, try `rustc --explain E0599`.\nerror: could not compile `higher-ranked-trait-bounds` (bin \"higher-ranked-trait-bounds\") due\n       to 1 previous error\n";

},{}],"ioxTM":[function(require,module,exports,__globalThis) {
module.exports = "trait Holder {\n    type Value;\n    fn get(&self) -> &Self::Value;\n}\n\ntrait Identify {\n    fn identify(&self);\n}\n\nstruct Container(Example);\n\nimpl Holder for Container {\n    type Value = Example;\n    fn get(&self) -> &Self::Value {\n        &self.0\n    }\n}\n\nstruct Example;\n\nimpl Identify for Example {\n    fn identify(&self) {\n        println!(\"I am an Example\")\n    }\n}\n\nfn default_and_identify<H>(holder: H)\nwhere\n    H: Holder,\n    &H::Value: Identify,\n{\n    let value = holder.get();\n    value.identify();\n}\n\nfn main() {}\n";

},{}],"3KiHp":[function(require,module,exports,__globalThis) {
module.exports = "error[E0637]: `&` without an explicit lifetime name cannot be used here\n  --> higher-ranked-trait-bounds/src/main.rs:40:5\n   |\n40 |     &H::Value: Identify,\n   |     ^ explicit lifetime name needed here\n   |\nhelp: consider introducing a higher-ranked lifetime here\n   |\n40 |     for<'a> &'a H::Value: Identify,\n   |     +++++++  ++\n\nFor more information about this error, try `rustc --explain E0637`.\nerror: could not compile `higher-ranked-trait-bounds` (bin \"higher-ranked-trait-bounds\") due\n       to 1 previous error\n";

},{}],"aCC6J":[function(require,module,exports,__globalThis) {
module.exports = "trait Holder {\n    type Value;\n    fn get(&self) -> &Self::Value;\n}\n\ntrait Identify {\n    fn identify(&self);\n}\n\nstruct Container(Example);\n\nimpl Holder for Container {\n    type Value = Example;\n    fn get(&self) -> &Self::Value {\n        &self.0\n    }\n}\n\nstruct Example;\n\nimpl Identify for Example {\n    fn identify(&self) {\n        println!(\"I am an Example\")\n    }\n}\n\nfn default_and_identify<'a, H>(holder: H)\nwhere\n    H: Holder,\n    &'a H::Value: Identify,\n{\n    let value = holder.get();\n    value.identify();\n}\n\nfn main() {}\n";

},{}],"12foN":[function(require,module,exports,__globalThis) {
module.exports = "error[E0309]: the associated type `<H as Holder>::Value` may not live long enough\n  --> higher-ranked-trait-bounds/src/main.rs:50:19\n   |\n47 | fn default_and_identify<'a, H>(holder: H)\n   |                         -- the associated type `<H as Holder>::Value` must be valid for\n   |                            the lifetime `'a` as defined here...\n...\n50 |     &'a H::Value: Identify,\n   |                   ^^^^^^^^ ...so that the reference type `&'a <H as Holder>::Value` does\n   |                            not outlive the data it points at\n   |\nhelp: consider adding an explicit lifetime bound\n   |\n50 |     &'a H::Value: Identify, <H as Holder>::Value: 'a\n   |                             ++++++++++++++++++++++++\n\nerror[E0597]: `holder` does not live long enough\n  --> higher-ranked-trait-bounds/src/main.rs:52:17\n   |\n47 | fn default_and_identify<'a, H>(holder: H)\n   |                         --     ------ binding `holder` declared here\n   |                         |\n   |                         lifetime `'a` defined here\n...\n52 |     let value = holder.get();\n   |                 ^^^^^^ borrowed value does not live long enough\n53 |     value.identify();\n   |     ---------------- argument requires that `holder` is borrowed for `'a`\n54 | }\n   | - `holder` dropped here while still borrowed\n\nerror[E0309]: the parameter type `H` may not live long enough\n  --> higher-ranked-trait-bounds/src/main.rs:52:17\n   |\n47 | fn default_and_identify<'a, H>(holder: H)\n   |                         -- the parameter type `H` must be valid for the lifetime `'a` as\n   |                            defined here...\n...\n52 |     let value = holder.get();\n   |                 ^^^^^^^^^^^^ ...so that the type `H` will meet its required lifetime\n   |                              bounds\n   |\nhelp: consider adding an explicit lifetime bound\n   |\n49 |     H: Holder + 'a,\n   |               ++++\n\nerror[E0309]: the associated type `<H as Holder>::Value` may not live long enough\n  --> higher-ranked-trait-bounds/src/main.rs:52:17\n   |\n47 | fn default_and_identify<'a, H>(holder: H)\n   |                         -- the associated type `<H as Holder>::Value` must be valid for\n   |                            the lifetime `'a` as defined here...\n...\n52 |     let value = holder.get();\n   |                 ^^^^^^^^^^^^ ...so that the type `<H as Holder>::Value` will meet its\n   |                              required lifetime bounds\n   |\nhelp: consider adding an explicit lifetime bound\n   |\n50 |     &'a H::Value: Identify, <H as Holder>::Value: 'a\n   |                             ++++++++++++++++++++++++\n\nerror[E0309]: the associated type `<H as Holder>::Value` may not live long enough\n  --> higher-ranked-trait-bounds/src/main.rs:53:5\n   |\n47 | fn default_and_identify<'a, H>(holder: H)\n   |                         -- the associated type `<H as Holder>::Value` must be valid for\n   |                            the lifetime `'a` as defined here...\n...\n53 |     value.identify();\n   |     ^^^^^^^^^^^^^^^^ ...so that the type `<H as Holder>::Value` will meet its required\n   |                      lifetime bounds\n   |\nhelp: consider adding an explicit lifetime bound\n   |\n50 |     &'a H::Value: Identify, <H as Holder>::Value: 'a\n   |                             ++++++++++++++++++++++++\n\nSome errors have detailed explanations: E0309, E0597.\nFor more information about an error, try `rustc --explain E0309`.\nerror: could not compile `higher-ranked-trait-bounds` (bin \"higher-ranked-trait-bounds\") due\n       to 5 previous errors\n";

},{}],"l2STI":[function(require,module,exports,__globalThis) {
module.exports = "trait Holder {\n    type Value;\n    fn get(&self) -> &Self::Value;\n}\n\ntrait Identify {\n    fn identify(&self);\n}\n\nstruct Container(Example);\n\nimpl Holder for Container {\n    type Value = Example;\n    fn get(&self) -> &Self::Value {\n        &self.0\n    }\n}\n\nstruct Example;\n\nimpl Identify for Example {\n    fn identify(&self) {\n        println!(\"I am an Example\")\n    }\n}\n\nfn default_and_identify<'a, H>(holder: H)\nwhere\n    H: Holder,\n    &'a H::Value: Identify,\n    H::Value: 'a,\n    H: 'a,\n{\n    let value = holder.get();\n    value.identify();\n}\n\nfn main() {}\n";

},{}],"ylWm3":[function(require,module,exports,__globalThis) {
module.exports = "error[E0597]: `holder` does not live long enough\n  --> higher-ranked-trait-bounds/src/main.rs:64:17\n   |\n57 | fn default_and_identify<'a, H>(holder: H)\n   |                         --     ------ binding `holder` declared here\n   |                         |\n   |                         lifetime `'a` defined here\n...\n64 |     let value = holder.get();\n   |                 ^^^^^^ borrowed value does not live long enough\n65 |     value.identify();\n   |     ---------------- argument requires that `holder` is borrowed for `'a`\n66 | }\n   | - `holder` dropped here while still borrowed\n\nFor more information about this error, try `rustc --explain E0597`.\nerror: could not compile `higher-ranked-trait-bounds` (bin \"higher-ranked-trait-bounds\") due\n       to 1 previous error\n";

},{}],"9fr0a":[function(require,module,exports,__globalThis) {
module.exports = "trait Holder {\n    type Value;\n    fn get(&self) -> &Self::Value;\n}\n\ntrait Identify {\n    fn identify(&self);\n}\n\nstruct Container(Example);\n\nimpl Holder for Container {\n    type Value = Example;\n    fn get(&self) -> &Self::Value {\n        &self.0\n    }\n}\n\nstruct Example;\n\nimpl Identify for Example {\n    fn identify(&self) {\n        println!(\"I am an Example\")\n    }\n}\n\nfn default_and_identify<H>(holder: H)\nwhere\n    H: Holder,\n    for<'a> &'a H::Value: Identify,\n{\n    let value = holder.get();\n    value.identify();\n}\n\nfn main() {}\n";

},{}],"9R5Vg":[function(require,module,exports,__globalThis) {
module.exports = "trait Size {\n    fn size(self) -> usize;\n}\n\nimpl<I> Size for I\nwhere\n    I: IntoIterator,\n{\n    fn size(self) -> usize {\n        self.into_iter().count()\n    }\n}\n\nimpl<T> Size for Vec<T> {\n    fn size(self) -> usize {\n        self.len()\n    }\n}\n\nfn main() {}\n";

},{}],"4gfh5":[function(require,module,exports,__globalThis) {
module.exports = "error[E0119]: conflicting implementations of trait `Size` for type `Vec<_>`\n  --> specialization/src/main.rs:27:1\n   |\n 8 | / impl<I> Size for I\n 9 | | where\n10 | |     I: IntoIterator,\n   | |____________________- first implementation here\n...\n27 |   impl<T> Size for Vec<T> {\n   |   ^^^^^^^^^^^^^^^^^^^^^^^ conflicting implementation for `Vec<_>`\n\nFor more information about this error, try `rustc --explain E0119`.\nerror: could not compile `specialization` (bin \"specialization\") due to 1 previous error\n";

},{}],"lRovX":[function(require,module,exports,__globalThis) {
module.exports = "#![feature(min_specialization)]\n\ntrait Size {\n    fn size(self) -> usize;\n}\n\nimpl<I> Size for I\nwhere\n    I: IntoIterator,\n{\n    default fn size(self) -> usize {\n        self.into_iter().count()\n    }\n}\n\nimpl<T> Size for Vec<T> {\n    fn size(self) -> usize {\n        self.len()\n    }\n}\n\nfn main() {}\n";

},{}],"62wBu":[function(require,module,exports,__globalThis) {
module.exports = "#[derive(PartialEq, Eq)]\nenum Mode {\n    Alpha,\n    Beta,\n}\n\nfn process_data<const MODE: Mode>() {\n    todo!()\n}\n\nfn main() {}\n";

},{}],"3sQuZ":[function(require,module,exports,__globalThis) {
module.exports = "error: `Mode` is forbidden as the type of a const generic parameter\n  --> const-generics-user-types/src/main.rs:10:29\n   |\n10 | fn process_data<const MODE: Mode>() {\n   |                             ^^^^\n   |\n   = note: the only supported types are integers, `bool`, and `char`\nhelp: add `#![feature(min_adt_const_params)]` to the crate attributes to enable more complex\n   |  and user defined types\n   |\n 3 + #![feature(min_adt_const_params)]\n   |\n\nerror: could not compile `const-generics-user-types` (bin \"const-generics-user-types\") due to\n       1 previous error\n";

},{}],"aCEmW":[function(require,module,exports,__globalThis) {
module.exports = "#![feature(min_adt_const_params)]\n\n#[derive(std::marker::ConstParamTy)]\n#[derive(PartialEq, Eq)]\nenum Mode {\n    Alpha,\n    Beta,\n}\n\nfn process_data<const MODE: Mode>() {\n    todo!()\n}\n\nfn main() {}\n";

},{}],"1Fysb":[function(require,module,exports,__globalThis) {
module.exports = "fn append<const N: usize>(a: [u8; N], v: u8) -> [u8; N + 1] {\n    todo!()\n}\n\nfn main() {}\n";

},{}],"uKgPw":[function(require,module,exports,__globalThis) {
module.exports = "error: generic parameters may not be used in const operations\n --> const-generics-expressions/src/main.rs:3:54\n  |\n3 | fn append<const N: usize>(a: [u8; N], v: u8) -> [u8; N + 1] {\n  |                                                      ^ cannot perform const operation\n  |                                                        using `N`\n  |\n  = help: const parameters may only be used as standalone arguments here, i.e. `N`\n  = help: add `#![feature(generic_const_exprs)]` to allow generic const expressions\n\nerror: could not compile `const-generics-expressions` (bin \"const-generics-expressions\") due\n       to 1 previous error\n";

},{}],"5Wn5C":[function(require,module,exports,__globalThis) {
module.exports = "#![feature(generic_const_exprs)]\n\nfn append<const N: usize>(a: [u8; N], v: u8) -> [u8; N + 1] {\n    todo!()\n}\n\nfn main() {}\n";

},{}],"e1gx4":[function(require,module,exports,__globalThis) {
module.exports = "trait Creator {\n    type Iter: Iterator<Item = u8>;\n\n    fn create(&self) -> Self::Iter;\n}\n\nstruct Example;\n\nimpl Creator for Example {\n    type Iter = impl Iterator<Item = u8>;\n\n    fn create(&self) -> Self::Iter {\n        vec![1, 2, 3].into_iter()\n    }\n}\n\nfn main() {}\n";

},{}],"dmljz":[function(require,module,exports,__globalThis) {
module.exports = "error[E0658]: `impl Trait` in associated types is unstable\n  --> type-alias-impl-trait/src/main.rs:12:17\n   |\n12 |     type Iter = impl Iterator<Item = u8>;\n   |                 ^^^^^^^^^^^^^^^^^^^^^^^^\n   |\n   = note: see issue #63063 <https://github.com/rust-lang/rust/issues/63063> for more\n   =       information\n   = help: add `#![feature(impl_trait_in_assoc_type)]` to the crate attributes to enable\n   = note: this compiler was built on 2026-06-08; consider upgrading it if it is out of date\n\nFor more information about this error, try `rustc --explain E0658`.\nerror: could not compile `type-alias-impl-trait` (bin \"type-alias-impl-trait\") due to 1\n       previous error\n";

},{}],"9hL63":[function(require,module,exports,__globalThis) {
module.exports = "#![feature(impl_trait_in_assoc_type)]\n\ntrait Creator {\n    type Iter: Iterator<Item = u8>;\n\n    fn create(&self) -> Self::Iter;\n}\n\nstruct Example;\n\nimpl Creator for Example {\n    type Iter = impl Iterator<Item = u8>;\n\n    fn create(&self) -> Self::Iter {\n        vec![1, 2, 3].into_iter()\n    }\n}\n\nfn main() {}\n";

},{}],"52ntE":[function(require,module,exports,__globalThis) {
module.exports = "trait NotFeline {}\n\nstruct Cat;\nstruct CatCafe(Vec<Cat>);\nstruct Dog;\n\nimpl !NotFeline for Cat {}\n\nfn no_cats_allowed<A: NotFeline>(animal: A) {}\n\nfn main() {\n    no_cats_allowed(Cat);             // Should fail\n    no_cats_allowed(CatCafe(vec![])); // Should fail\n    no_cats_allowed(Dog);             // Should be OK\n}\n";

},{}],"48EIl":[function(require,module,exports,__globalThis) {
module.exports = "error[E0658]: negative impls are experimental\n  --> auto-traits/src/main.rs:13:6\n   |\n13 | impl !NotFeline for Cat {}\n   |      ^^^^^^^^^^\n   |\n   = note: see issue #68318 <https://github.com/rust-lang/rust/issues/68318> for more\n   =       information\n   = help: add `#![feature(negative_impls)]` to the crate attributes to enable\n   = note: this compiler was built on 2026-06-08; consider upgrading it if it is out of date\n   = help: use marker types for now\n\nerror[E0277]: the trait bound `Cat: NotFeline` is not satisfied\n  --> auto-traits/src/main.rs:18:21\n   |\n18 |     no_cats_allowed(Cat);             // Should fail\n   |     --------------- ^^^ unsatisfied trait bound\n   |     |\n   |     required by a bound introduced by this call\n   |\nhelp: the trait `NotFeline` is not implemented for `Cat`\n  --> auto-traits/src/main.rs:9:1\n   |\n 9 | struct Cat;\n   | ^^^^^^^^^^\nnote: required by a bound in `no_cats_allowed`\n  --> auto-traits/src/main.rs:15:23\n   |\n15 | fn no_cats_allowed<A: NotFeline>(animal: A) {}\n   |                       ^^^^^^^^^ required by this bound in `no_cats_allowed`\n\nerror[E0277]: the trait bound `CatCafe: NotFeline` is not satisfied\n  --> auto-traits/src/main.rs:19:21\n   |\n19 |     no_cats_allowed(CatCafe(vec![])); // Should fail\n   |     --------------- ^^^^^^^^^^^^^^^ unsatisfied trait bound\n   |     |\n   |     required by a bound introduced by this call\n   |\nhelp: the trait `NotFeline` is not implemented for `CatCafe`\n  --> auto-traits/src/main.rs:10:1\n   |\n10 | struct CatCafe(Vec<Cat>);\n   | ^^^^^^^^^^^^^^\nnote: required by a bound in `no_cats_allowed`\n  --> auto-traits/src/main.rs:15:23\n   |\n15 | fn no_cats_allowed<A: NotFeline>(animal: A) {}\n   |                       ^^^^^^^^^ required by this bound in `no_cats_allowed`\n\nerror[E0277]: the trait bound `Dog: NotFeline` is not satisfied\n  --> auto-traits/src/main.rs:20:21\n   |\n20 |     no_cats_allowed(Dog);             // Should be OK\n   |     --------------- ^^^ unsatisfied trait bound\n   |     |\n   |     required by a bound introduced by this call\n   |\nhelp: the trait `NotFeline` is not implemented for `Dog`\n  --> auto-traits/src/main.rs:11:1\n   |\n11 | struct Dog;\n   | ^^^^^^^^^^\nnote: required by a bound in `no_cats_allowed`\n  --> auto-traits/src/main.rs:15:23\n   |\n15 | fn no_cats_allowed<A: NotFeline>(animal: A) {}\n   |                       ^^^^^^^^^ required by this bound in `no_cats_allowed`\n\nSome errors have detailed explanations: E0277, E0658.\nFor more information about an error, try `rustc --explain E0277`.\nerror: could not compile `auto-traits` (bin \"auto-traits\") due to 4 previous errors\n";

},{}],"kDFwy":[function(require,module,exports,__globalThis) {
module.exports = "#![feature(auto_traits, negative_impls)]\n\nauto trait NotFeline {}\n\nstruct Cat;\nstruct CatCafe(Vec<Cat>);\nstruct Dog;\n\nimpl !NotFeline for Cat {}\n\nfn no_cats_allowed<A: NotFeline>(animal: A) {}\n\nfn main() {\n    no_cats_allowed(Cat);             // Should fail\n    no_cats_allowed(CatCafe(vec![])); // Should fail\n    no_cats_allowed(Dog);             // Should be OK\n}\n";

},{}],"56Omc":[function(require,module,exports,__globalThis) {
module.exports = "error[E0277]: the trait bound `Cat: NotFeline` is not satisfied\n  --> auto-traits/src/main.rs:18:21\n   |\n18 |     no_cats_allowed(Cat);             // Should fail\n   |     --------------- ^^^ unsatisfied trait bound\n   |     |\n   |     required by a bound introduced by this call\n   |\nhelp: the trait `NotFeline` is not implemented for `Cat`\n  --> auto-traits/src/main.rs:9:1\n   |\n 9 | struct Cat;\n   | ^^^^^^^^^^\nnote: required by a bound in `no_cats_allowed`\n  --> auto-traits/src/main.rs:15:23\n   |\n15 | fn no_cats_allowed<A: NotFeline>(animal: A) {}\n   |                       ^^^^^^^^^ required by this bound in `no_cats_allowed`\n\nerror[E0277]: the trait bound `Cat: NotFeline` is not satisfied in `CatCafe`\n   --> auto-traits/src/main.rs:19:21\n    |\n 19 |     no_cats_allowed(CatCafe(vec![])); // Should fail\n    |     --------------- ^^^^^^^^^^^^^^^ unsatisfied trait bound\n    |     |\n    |     required by a bound introduced by this call\n    |\nhelp: within `CatCafe`, the trait `NotFeline` is not implemented for `Cat`\n   --> auto-traits/src/main.rs:9:1\n    |\n  9 | struct Cat;\n    | ^^^^^^^^^^\nnote: required because it appears within the type `PhantomData<Cat>`\n   --> core/src/marker.rs:811:12\n    |\n811 | pub struct PhantomData<T: PointeeSized>;\n    |            ^^^^^^^^^^^\nnote: required because it appears within the type `alloc::raw_vec::RawVec<Cat>`\n   --> alloc/src/raw_vec/mod.rs:73:19\n    |\n 73 | pub(crate) struct RawVec<T, A: Allocator = Global> {\n    |                   ^^^^^^\nnote: required because it appears within the type `Vec<Cat>`\n   --> alloc/src/vec/mod.rs:438:12\n    |\n438 | pub struct Vec<T, #[unstable(feature = \"allocator_api\", issue = \"32838\")] A: Allocator =\n    |            Global> {\n    |            ^^^\nnote: required because it appears within the type `CatCafe`\n   --> auto-traits/src/main.rs:10:8\n    |\n 10 | struct CatCafe(Vec<Cat>);\n    |        ^^^^^^^\nnote: required by a bound in `no_cats_allowed`\n   --> auto-traits/src/main.rs:15:23\n    |\n 15 | fn no_cats_allowed<A: NotFeline>(animal: A) {}\n    |                       ^^^^^^^^^ required by this bound in `no_cats_allowed`\n\nFor more information about this error, try `rustc --explain E0277`.\nerror: could not compile `auto-traits` (bin \"auto-traits\") due to 2 previous errors\n";

},{}],"1s6WQ":[function(require,module,exports,__globalThis) {
/*@jsxRuntime automatic*/ /*@jsxImportSource react*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "title", ()=>title);
parcelHelpers.export(exports, "default", ()=>MDXContent);
var _jsxRuntime = require("react/jsx-runtime");
var _directives = require("./Directives");
var _changeDeck = require("./ChangeDeck");
var _changeDeckDefault = parcelHelpers.interopDefault(_changeDeck);
var _splash = require("./layout/Splash");
var _splashDefault = parcelHelpers.interopDefault(_splash);
var _skip = require("./layout/Skip");
var _skipDefault = parcelHelpers.interopDefault(_skip);
var _testPattern = require("./TestPattern");
var _testPatternDefault = parcelHelpers.interopDefault(_testPattern);
var _transclude = require("./Transclude");
var _transcludeDefault = parcelHelpers.interopDefault(_transclude);
var _quote = require("./Quote");
var _quoteDefault = parcelHelpers.interopDefault(_quote);
var _excerpts = require("./Excerpts");
var _quotes = require("./Quotes");
var _threadNoJoin = require("rust:concurrency/thread-no-join");
var _threadNoJoinDefault = parcelHelpers.interopDefault(_threadNoJoin);
var _threadWithJoin = require("rust:concurrency/thread-with-join");
var _threadWithJoinDefault = parcelHelpers.interopDefault(_threadWithJoin);
var _referenceVariable = require("rust:concurrency/reference-variable");
var _referenceVariableDefault = parcelHelpers.interopDefault(_referenceVariable);
var _referenceVariable1 = require("stderr:concurrency/reference-variable");
var _referenceVariableDefault1 = parcelHelpers.interopDefault(_referenceVariable1);
var _closureCapture = require("rust:concurrency/closure-capture");
var _closureCaptureDefault = parcelHelpers.interopDefault(_closureCapture);
var _closureCaptureRev1 = require("rust:concurrency/closure-capture?rev=1");
var _closureCaptureRev1Default = parcelHelpers.interopDefault(_closureCaptureRev1);
var _referenceVariableRev1 = require("rust:concurrency/reference-variable?rev=1");
var _referenceVariableRev1Default = parcelHelpers.interopDefault(_referenceVariableRev1);
var _referenceVariableRev11 = require("stdout:concurrency/reference-variable?rev=1");
var _referenceVariableRev1Default1 = parcelHelpers.interopDefault(_referenceVariableRev11);
var _mutateVariable = require("rust:concurrency/mutate-variable");
var _mutateVariableDefault = parcelHelpers.interopDefault(_mutateVariable);
var _mutateVariable1 = require("stderr:concurrency/mutate-variable");
var _mutateVariableDefault1 = parcelHelpers.interopDefault(_mutateVariable1);
var _sharedOwnershipClone = require("rust:concurrency/shared-ownership-clone");
var _sharedOwnershipCloneDefault = parcelHelpers.interopDefault(_sharedOwnershipClone);
var _sharedOwnershipClone1 = require("stderr:concurrency/shared-ownership-clone");
var _sharedOwnershipCloneDefault1 = parcelHelpers.interopDefault(_sharedOwnershipClone1);
var _sharedOwnershipCloneRev1 = require("rust:concurrency/shared-ownership-clone?rev=1");
var _sharedOwnershipCloneRev1Default = parcelHelpers.interopDefault(_sharedOwnershipCloneRev1);
var _sharedOwnershipCloneRev11 = require("stdout:concurrency/shared-ownership-clone?rev=1");
var _sharedOwnershipCloneRev1Default1 = parcelHelpers.interopDefault(_sharedOwnershipCloneRev11);
var _sharedOwnershipImmutable = require("rust:concurrency/shared-ownership-immutable");
var _sharedOwnershipImmutableDefault = parcelHelpers.interopDefault(_sharedOwnershipImmutable);
var _sharedOwnershipImmutable1 = require("stderr:concurrency/shared-ownership-immutable");
var _sharedOwnershipImmutableDefault1 = parcelHelpers.interopDefault(_sharedOwnershipImmutable1);
var _interiorMutability = require("rust:concurrency/interior-mutability");
var _interiorMutabilityDefault = parcelHelpers.interopDefault(_interiorMutability);
var _interiorMutabilityRev1 = require("rust:concurrency/interior-mutability?rev=1");
var _interiorMutabilityRev1Default = parcelHelpers.interopDefault(_interiorMutabilityRev1);
var _appliedSharedOwnershipInteriorMutability = require("rust:concurrency/applied-shared-ownership-interior-mutability");
var _appliedSharedOwnershipInteriorMutabilityDefault = parcelHelpers.interopDefault(_appliedSharedOwnershipInteriorMutability);
var _exerciseThreads = require("rust:concurrency/exercise-threads");
var _exerciseThreadsDefault = parcelHelpers.interopDefault(_exerciseThreads);
var _channels = require("rust:concurrency/channels");
var _channelsDefault = parcelHelpers.interopDefault(_channels);
var _channels1 = require("stdout:concurrency/channels");
var _channelsDefault1 = parcelHelpers.interopDefault(_channels1);
var _channelsMpsc = require("rust:concurrency/channels-mpsc");
var _channelsMpscDefault = parcelHelpers.interopDefault(_channelsMpsc);
var _channelsMpsc1 = require("stdout:concurrency/channels-mpsc");
var _channelsMpscDefault1 = parcelHelpers.interopDefault(_channelsMpsc1);
var _channelsMutability = require("rust:concurrency/channels-mutability");
var _channelsMutabilityDefault = parcelHelpers.interopDefault(_channelsMutability);
var _exerciseChannels = require("rust:concurrency/exercise-channels");
var _exerciseChannelsDefault = parcelHelpers.interopDefault(_exerciseChannels);
var _parentThreadStackReference = require("rust:concurrency/parent-thread-stack-reference");
var _parentThreadStackReferenceDefault = parcelHelpers.interopDefault(_parentThreadStackReference);
var _scopedThreads = require("rust:concurrency/scoped-threads");
var _scopedThreadsDefault = parcelHelpers.interopDefault(_scopedThreads);
var _scopedThreads1 = require("stdout:concurrency/scoped-threads");
var _scopedThreadsDefault1 = parcelHelpers.interopDefault(_scopedThreads1);
var _scopedThreadsRev1 = require("rust:concurrency/scoped-threads?rev=1");
var _scopedThreadsRev1Default = parcelHelpers.interopDefault(_scopedThreadsRev1);
var _scopedThreadsRev11 = require("stdout:concurrency/scoped-threads?rev=1");
var _scopedThreadsRev1Default1 = parcelHelpers.interopDefault(_scopedThreadsRev11);
var _scopedThreadsRev2 = require("rust:concurrency/scoped-threads?rev=2");
var _scopedThreadsRev2Default = parcelHelpers.interopDefault(_scopedThreadsRev2);
var _scopedThreadsRev21 = require("stderr:concurrency/scoped-threads?rev=2");
var _scopedThreadsRev2Default1 = parcelHelpers.interopDefault(_scopedThreadsRev21);
var _exerciseScopedThreads = require("rust:concurrency/exercise-scoped-threads");
var _exerciseScopedThreadsDefault = parcelHelpers.interopDefault(_exerciseScopedThreads);
var _sendSyncMisuse = require("rust:concurrency/send-sync-misuse");
var _sendSyncMisuseDefault = parcelHelpers.interopDefault(_sendSyncMisuse);
var _sendSyncMisuse1 = require("stderr:concurrency/send-sync-misuse");
var _sendSyncMisuseDefault1 = parcelHelpers.interopDefault(_sendSyncMisuse1);
var _rayon = require("toml:concurrency/rayon");
var _rayonDefault = parcelHelpers.interopDefault(_rayon);
var _rayon1 = require("rust:concurrency/rayon");
var _rayonDefault1 = parcelHelpers.interopDefault(_rayon1);
var _rayon2 = require("stdout:concurrency/rayon");
var _rayonDefault2 = parcelHelpers.interopDefault(_rayon2);
var _exerciseRayon = require("rust:concurrency/exercise-rayon");
var _exerciseRayonDefault = parcelHelpers.interopDefault(_exerciseRayon);
var _futuresOld = require("rust:concurrency/futures-old");
var _futuresOldDefault = parcelHelpers.interopDefault(_futuresOld);
var _futuresNew = require("rust:concurrency/futures-new");
var _futuresNewDefault = parcelHelpers.interopDefault(_futuresNew);
const title = "Fearless concurrency";
function _createMdxContent(props) {
    const _components = {
        a: "a",
        code: "code",
        em: "em",
        h1: "h1",
        h2: "h2",
        h3: "h3",
        hr: "hr",
        li: "li",
        p: "p",
        pre: "pre",
        ul: "ul",
        ...props.components
    }, { SplitSlides } = _components;
    if (!SplitSlides) _missingMdxReference("SplitSlides", true);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SplitSlides, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _testPatternDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Fearless concurrency"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Threads"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.p, {
                children: [
                    "Rust provides access to native threads via ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "std::thread"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "thread::spawn"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: "Provides a simpler entrypoint to start a thread."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.ThreadSpawn), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Ignore ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Send"
                            }),
                            " and ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "'static"
                            }),
                            " for right now, we will cover those in a second"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _threadNoJoinDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "What do you expect to happen when we try to compile and run this?"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "thread::spawn"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-compiler-output"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Yes, actually nothing"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-compiler-output",
                    children: "Hello from another thread!\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "If you are very (un)lucky"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Threads can be detached"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "TODO: discuss why useful"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Threads can be joined"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _threadWithJoinDefault.default),
                emphasize: "7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "You can call ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "join"
                            }),
                            " on the returned handle to wait for the thread to finish."
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "If a thread panics, the result of ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "join"
                            }),
                            " will be an error"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Referencing a variable"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _referenceVariableDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _referenceVariableDefault1.default),
                focusOn: "1+14"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "move"
                    }),
                    " closures"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _referenceVariableDefault1.default),
                focusOn: "15+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Closures capture by inspecting usage..."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _closureCaptureDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Note that the syntax for all the closures is the same"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Compare to C++ where you have to be more explicit about how and what is captured"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "... which is ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.em, {
                        children: "almost"
                    }),
                    " always right"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: "It isn't what we want when a value is only used by reference but we\nwant the closure to own the value regardless."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "move"
                    }),
                    " closures force ownership to be transferred"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _closureCaptureRev1Default.default),
                emphasize: "16[13+4],20[13+4]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Referencing a variable"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _referenceVariableRev1Default.default),
                emphasize: "6[18+4]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-output",
                src: (0, _referenceVariableRev1Default1.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Mutating a variable"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _mutateVariableDefault.default),
                focusOn: "4+12"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _mutateVariableDefault1.default),
                focusOn: "1+14"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Shared ownership"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                            children: "Rc"
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                            children: "Arc"
                        })
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Guarantees and tradeoffs"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Single vs multiple threads"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Makes non-cloneable types cloneable"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _sharedOwnershipCloneDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _sharedOwnershipCloneDefault1.default),
                focusOn: "1+12"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Makes non-cloneable types cloneable..."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _sharedOwnershipCloneRev1Default.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-output",
                src: (0, _sharedOwnershipCloneRev1Default1.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "... but ..."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _sharedOwnershipImmutableDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "... no longer mutable"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _sharedOwnershipImmutableDefault1.default),
                focusOn: "11+8"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Interior mutability"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                            children: "Cell"
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                            children: "RefCell"
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                            children: "Atomic*"
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                            children: "Mutex"
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                            children: "RwLock"
                        })
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Guarantees and tradeoffs"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "Copy"
                                            }),
                                            " vs not"
                                        ]
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Single vs multiple threads"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Fairness"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Works by moving borrow checking to runtime, not compile time"
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Interior mutability"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "What's the simplest way we can prevent two mutable references?"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _interiorMutabilityDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "What's the simplest way we can prevent two mutable references while allowing references?"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _interiorMutabilityRev1Default.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Applying shared ownership and interior mutability"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _appliedSharedOwnershipInteriorMutabilityDefault.default),
                focusOn: "7+13",
                emphasize: "1[13+30]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "We choose ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Arc"
                            }),
                            " and ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Mutex"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Arc"
                            }),
                            " and ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Mutex"
                            }),
                            " are needed for multithreading"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Mutex"
                            }),
                            " is a reasonable default"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Applying shared ownership and interior mutability"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _appliedSharedOwnershipInteriorMutabilityDefault.default),
                focusOn: "7+13",
                emphasize: "3[26+8]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Create a shared copy to give to the thread"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Applying shared ownership and interior mutability"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _appliedSharedOwnershipInteriorMutabilityDefault.default),
                focusOn: "7+13",
                emphasize: "6[17+31],10[6+31]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Move borrow checking to runtime, which additionally can fail."
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Applying shared ownership and interior mutability"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _appliedSharedOwnershipInteriorMutabilityDefault.default),
                focusOn: "7+13"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Will this compile? What will it output?"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-compiler-output",
                    children: "Scores A: Mutex { data: [42], poisoned: false, .. }\nScores B: Mutex { data: [42, 2, 1], poisoned: false, .. }\nScores C: Mutex { data: [42, 2, 1], poisoned: false, .. }\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-compiler-output",
                    children: "Scores C: Mutex { data: [42, 2], poisoned: false, .. }\nScores A: Mutex { data: [42, 2], poisoned: false, .. }\nScores B: Mutex { data: [42, 2, 1], poisoned: false, .. }\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-compiler-output",
                    children: "Scores A: Mutex { data: [42], poisoned: false, .. }\nScores C: Mutex { data: [42, 2], poisoned: false, .. }\nScores B: Mutex { data: [42, 2, 1], poisoned: false, .. }\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "While Rust prevents data races, it doesn't enforce logical ordering (race conditions)"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Exercise: Adding up numbers in parallel"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Given a large vector of numbers, add up all the numbers in parallel"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Each thread adds up a different section of the vector"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Then sum up the results from the threads"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Code like this should run:"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                                src: (0, _exerciseThreadsDefault.default),
                                focusOn: "25+2",
                                copyAllCode: false
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Bonus"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Instead of returning values from the threads, write to a shared total count"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One answer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _exerciseThreadsDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Sharing values while the thread is running"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _quotes.ChannelQuote), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "What are channels good for?"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Communicating between concurrent workers",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Different types can be sent through a channel"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Avoiding lower level primitives",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "mutex"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "condition variable"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Notably ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.em, {
                                children: "while"
                            }),
                            " they are still running"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Using channels"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _channelsDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Using channels"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _channelsDefault.default),
                emphasize: "1[10+10]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Importing the channel module"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Using channels"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _channelsDefault.default),
                emphasize: "4"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Creating a channel"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Pair of sender and receiver"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "This is an ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.em, {
                                children: "unbounded"
                            }),
                            " channel, there's also bounded ones"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Using channels"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _channelsDefault.default),
                emphasize: "8"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Sending a value can fail"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Using channels"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _channelsDefault.default),
                emphasize: "13"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "A receiver can be treated as an iterator"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Iterator ends when all the senders have been dropped or an error occurs"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "It also has methods to allow timeouts"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Using channels"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-output",
                src: (0, _channelsDefault1.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Output from the channel is received in the same order it was added"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Multi Producer, Single Consumer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _channelsMpscDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Multi Producer, Single Consumer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _channelsMpscDefault.default),
                emphasize: "8"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Multi Producer, Single Consumer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _channelsMpscDefault.default),
                emphasize: "16"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Multi Producer, Single Consumer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-output",
                src: (0, _channelsMpscDefault1.default),
                focusOn: "1+28"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Output from the channel is received in the same order it was added"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "No ordering between the producers"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Avoiding locks with channels"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _channelsMutabilityDefault.default),
                focusOn: "3+27"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Avoiding locks with channels"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _channelsMutabilityDefault.default),
                focusOn: "3+27",
                emphasize: "8"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Multiple threads are able to send data in."
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Avoiding locks with channels"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _channelsMutabilityDefault.default),
                focusOn: "3+27",
                emphasize: "14"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "One thread takes ownership of the ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Vec"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Allowed to mutate because there's one owner"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Avoiding locks with channels"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _channelsMutabilityDefault.default),
                focusOn: "3+27",
                emphasize: "18"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Returning a value when the thread is done"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Could also have its own channel to send along"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Exercise: Adding up numbers using channels"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Each thread adds up a different section of the vector"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Send the partial sum for every ten numbers summed up"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Code like this should run:"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                                src: (0, _exerciseChannelsDefault.default),
                                focusOn: "38+2",
                                copyAllCode: false
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Hints"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Ensure unused sending half(s) are dropped"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One answer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _exerciseChannelsDefault.default),
                focusOn: "6+29"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: ".fold(0, |sum, x| dbg!(sum + x))"
                            }),
                            " to see the running total"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "The ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "'static"
                    }),
                    " bound"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _referenceVariableDefault1.default),
                focusOn: "10+1",
                emphasize: "1[50+7]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.ThreadSpawn), {
                emphasize: "4[14+7],5[14+7]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Recall:",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "lifetime bounds mean any references in the type must be valid that long"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "'static"
                                            }),
                                            " means \"lives the entire length of the program\""
                                        ]
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "'static"
                    }),
                    " prevents memory unsafety"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _parentThreadStackReferenceDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Since thread can be detached, no guarantee that the parent thread (and the variable) will be available when the thread runs."
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "'static"
                            }),
                            " is conservative for ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "thread::spawn"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "What if the child thread exited first?"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Known as \"scoped threads\""
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Available in the standard library since Rust 1.63"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Choices also available in the crate ecosystem"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Was available before 1.0, but had unsafety"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Scoped threads"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.ThreadScopedScope), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.ThreadScopedSpawn), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Scoped threads"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _scopedThreadsDefault.default),
                focusOn: "3+9"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Will this compile?"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Different signature to enforce that the child thread exits first"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-output",
                src: (0, _scopedThreadsDefault1.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Scoped threads"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _scopedThreadsRev1Default.default),
                focusOn: "3+12",
                emphasize: "2[8+3],7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Will this compile?"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-output",
                src: (0, _scopedThreadsRev1Default1.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Scoped threads"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _scopedThreadsRev2Default.default),
                focusOn: "3+10",
                emphasize: "6"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Will this compile?"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _scopedThreadsRev2Default1.default),
                focusOn: "1+15"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Exercise: Adding up numbers using scoped threads"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Each thread adds up a different section of the vector"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Then sum up the results from the threads"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.p, {
                                children: [
                                    "No need to use ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                        children: "Arc"
                                    })
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Code like this should run:"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                                src: (0, _exerciseScopedThreadsDefault.default),
                                focusOn: "18+2",
                                copyAllCode: false
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One answer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _exerciseScopedThreadsDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "Send"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Regular threads"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.ThreadSpawn), {
                emphasize: "4[7+4],5[7+4]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Scoped threads"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.ThreadScopedSpawn), {
                emphasize: "4[27+4],5[11+4]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "Send"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: "Types that can be transferred across thread boundaries."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "Sync"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: "Types for which it is safe to share references between threads."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Automatically implemented for a type if all components implement it."
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Types that are not ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "Send"
                    }),
                    " or ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "Sync"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h2, {
                children: [
                    "Not ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "Send"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                            children: "Rc"
                        })
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h2, {
                children: [
                    "Not ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "Sync"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Cell"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "RefCell"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Compiler prevents misuse"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _sendSyncMisuseDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Compiler prevents misuse"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _sendSyncMisuseDefault1.default),
                focusOn: "1+28"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Pieces of the landscape"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Language"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                            children: "Send"
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                            children: "Sync"
                        })
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Standard library"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "OS threads"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Scoped threads"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Arc"
                            }),
                            " / ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Mutex"
                            }),
                            " / MPSC channels"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Crates"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Scoped threads"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Parallel iterators"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Rayon"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _quoteDefault.default), {
                caption: "Rayon documentation",
                href: "https://crates.io/crates/rayon",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                    children: "Rayon is a data-parallelism library for Rust. It is extremely lightweight and\nmakes it easy to convert a sequential computation into a parallel one. It also\nguarantees data-race freedom."
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Add as a dependency"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "toml",
                src: (0, _rayonDefault.default),
                focusOn: "8-9"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Rayon"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _rayonDefault1.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Will this compile and what will it print?"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-output",
                src: (0, _rayonDefault2.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Exercise: Adding up numbers using parallel iterators"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Code like this should run:"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                                src: (0, _exerciseRayonDefault.default),
                                focusOn: "8+2",
                                copyAllCode: false
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Hints"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Implementation of ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "adder"
                            }),
                            " is one expression"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One answer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _exerciseRayonDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "And now for something completely different..."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Threads are great for:",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "parallelism"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "CPU-intensive work"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Not needed for:",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "concurrency"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "IO-intensive work"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "A ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.em, {
                        children: "promise"
                    }),
                    " of a brighter ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.em, {
                        children: "future"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Rust has an established ecosystem using futures"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Rust 1.36 added ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Future"
                            }),
                            " to the standard library"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Rust 1.39 introduced ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "async"
                            }),
                            " / ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "await"
                            }),
                            " syntax"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Pedantically, promises and futures are subtly different, but for many purposes that doesn't matter"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Futures in Rust 1.36"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _futuresOldDefault.default),
                focusOn: "1+24"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "This uses Edition 2021"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Futures in Rust 1.36"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _futuresOldDefault.default),
                focusOn: "1+24",
                emphasize: "3[24+28]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Futures in Rust 1.36"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _futuresOldDefault.default),
                focusOn: "1+24",
                emphasize: "4[4+17],4[40+1]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Futures in Rust 1.36"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _futuresOldDefault.default),
                focusOn: "1+24",
                emphasize: "11[8+5],11[56+4],13[15+12],14[8+4]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Futures in... the present"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _futuresNewDefault.default),
                focusOn: "1+27"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Futures in... the present"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _futuresNewDefault.default),
                focusOn: "1+27",
                emphasize: "3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Futures in... the present"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _futuresNewDefault.default),
                focusOn: "1+27",
                emphasize: "4"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Futures in... the present"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _futuresNewDefault.default),
                focusOn: "1+27",
                emphasize: "10[25+5]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Futures in... the present"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _futuresNewDefault.default),
                focusOn: "1+27",
                emphasize: "11[36+6],12[55+6],17[40+6]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                    href: "https://docs.google.com/forms/d/e/1FAIpQLScJK08xifPJVzYBFGokXe2Cz4wY_n_9UnHgR-D3UvhxrDx5Uw/viewform?usp=publish-editor",
                    children: "Quiz"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _changeDeckDefault.default), {
                    deck: "overview",
                    children: "Return"
                })
            })
        ]
    });
}
function MDXContent(props = {}) {
    const { wrapper: MDXLayout } = props.components || {};
    return MDXLayout ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(MDXLayout, {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_createMdxContent, {
            ...props
        })
    }) : _createMdxContent(props);
}
function _missingMdxReference(id, component, place) {
    throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it." + (place ? "\nIt\u2019s referenced in your code at `" + place + "`" : ""));
}

},{"react/jsx-runtime":"afIHK","./Directives":"6Yemz","./ChangeDeck":"29Jlq","./layout/Splash":"1mDy7","./layout/Skip":"1ziV3","./TestPattern":"g0BPT","./Transclude":"fUgcm","./Quote":"7JX1G","./Excerpts":"5uobq","./Quotes":"9LaLC","rust:concurrency/thread-no-join":"lbrii","rust:concurrency/thread-with-join":"873YX","rust:concurrency/reference-variable":"hh8Yo","stderr:concurrency/reference-variable":"lNyBZ","rust:concurrency/closure-capture":"cD6ea","rust:concurrency/closure-capture?rev=1":"9QPo2","rust:concurrency/reference-variable?rev=1":"gjxSZ","stdout:concurrency/reference-variable?rev=1":"lsFH3","rust:concurrency/mutate-variable":"3L8QP","stderr:concurrency/mutate-variable":"5Rcjy","rust:concurrency/shared-ownership-clone":"czH9i","stderr:concurrency/shared-ownership-clone":"do4j5","rust:concurrency/shared-ownership-clone?rev=1":"c6lvk","stdout:concurrency/shared-ownership-clone?rev=1":"h5vkk","rust:concurrency/shared-ownership-immutable":"h9ttB","stderr:concurrency/shared-ownership-immutable":"hXsqO","rust:concurrency/interior-mutability":"64eNE","rust:concurrency/interior-mutability?rev=1":"fPRtI","rust:concurrency/applied-shared-ownership-interior-mutability":"5k7ET","rust:concurrency/exercise-threads":"fM7O3","rust:concurrency/channels":"eTkBq","stdout:concurrency/channels":"6Oq0I","rust:concurrency/channels-mpsc":"esgSw","stdout:concurrency/channels-mpsc":"4p0wv","rust:concurrency/channels-mutability":"c0LlK","rust:concurrency/exercise-channels":"aPhve","rust:concurrency/parent-thread-stack-reference":"cVoPT","rust:concurrency/scoped-threads":"bXW7Q","stdout:concurrency/scoped-threads":"8I6v0","rust:concurrency/scoped-threads?rev=1":"gRBIA","stdout:concurrency/scoped-threads?rev=1":"2DXk2","rust:concurrency/scoped-threads?rev=2":"byWZ3","stderr:concurrency/scoped-threads?rev=2":"1Byrz","rust:concurrency/exercise-scoped-threads":"jiqY6","rust:concurrency/send-sync-misuse":"1PBwJ","stderr:concurrency/send-sync-misuse":"auDR1","toml:concurrency/rayon":"K4SuP","rust:concurrency/rayon":"6WmFU","stdout:concurrency/rayon":"3tcqg","rust:concurrency/exercise-rayon":"QogQ9","rust:concurrency/futures-old":"d0zlN","rust:concurrency/futures-new":"3tk0h","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"7JX1G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _quoteModuleCss = require("./Quote.module.css");
const Quote = ({ children, caption, href })=>{
    const captionContent = href ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
        href: href,
        children: caption
    }) : caption;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("figure", {
        className: _quoteModuleCss.container,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("blockquote", {
                className: _quoteModuleCss.quote,
                children: children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("figcaption", {
                className: _quoteModuleCss.caption,
                children: captionContent
            })
        ]
    });
};
exports.default = Quote;

},{"react/jsx-runtime":"afIHK","./Quote.module.css":"9CxS8","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"9CxS8":[function(require,module,exports,__globalThis) {
module.exports["caption"] = `D9r7qa_caption`;
module.exports["container"] = `D9r7qa_container`;
module.exports["quote"] = `D9r7qa_quote`;

},{}],"9LaLC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChannelQuote", ()=>ChannelQuote);
var _jsxRuntime = require("react/jsx-runtime");
var _quote = require("./Quote");
var _quoteDefault = parcelHelpers.interopDefault(_quote);
const ChannelQuote = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _quoteDefault.default), {
        caption: "Effective Go",
        href: "https://go.dev/doc/effective_go",
        children: "Do not communicate by sharing memory; instead, share memory by communicating."
    });

},{"react/jsx-runtime":"afIHK","./Quote":"7JX1G","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"lbrii":[function(require,module,exports,__globalThis) {
module.exports = "use std::thread;\n\nfn main() {\n    thread::spawn(|| {\n        println!(\"Hello from another thread!\");\n    });\n}\n";

},{}],"873YX":[function(require,module,exports,__globalThis) {
module.exports = "use std::thread;\n\nfn main() {\n    thread::spawn(|| {\n        println!(\"Hello from another thread!\");\n    })\n    .join()\n    .expect(\"The thread panicked\");\n}\n";

},{}],"hh8Yo":[function(require,module,exports,__globalThis) {
module.exports = "use std::thread;\n\nfn main() {\n    let score = 42;\n\n    thread::spawn(|| println!(\"The score is: {score}\"))\n        .join()\n        .expect(\"The thread panicked\");\n}\n";

},{}],"lNyBZ":[function(require,module,exports,__globalThis) {
module.exports = "error[E0373]: closure may outlive the current function, but it borrows `score`, which is owned\n              by the current function\n --> reference-variable/src/main.rs:7:19\n  |\n7 |     thread::spawn(|| println!(\"The score is: {score}\"))\n  |                   ^^                          ----- `score` is borrowed here\n  |                   |\n  |                   may outlive borrowed value `score`\n  |\nnote: function requires argument type to outlive `'static`\n --> reference-variable/src/main.rs:7:5\n  |\n7 |     thread::spawn(|| println!(\"The score is: {score}\"))\n  |     ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\nhelp: to force the closure to take ownership of `score` (and any other referenced variables),\n  |   use the `move` keyword\n  |\n7 |     thread::spawn(move || println!(\"The score is: {score}\"))\n  |                   ++++\n\nFor more information about this error, try `rustc --explain E0373`.\nerror: could not compile `reference-variable` (bin \"reference-variable\") due to 1 previous\n       error\n";

},{}],"cD6ea":[function(require,module,exports,__globalThis) {
module.exports = "#[derive(Debug)]\nstruct Example;\n\nimpl Example {\n    fn by_value(self) {}\n    fn by_mut_ref(&mut self) {}\n    fn by_ref(&self) {}\n}\n\nfn main() {\n    let e1 = Example;\n    let c1 = || e1.by_value();\n    println!(\"{e1:?}\"); // Fails\n\n    let mut e2 = Example;\n    let c2 = || e2.by_mut_ref();\n    println!(\"{e2:?}\");\n\n    let e3 = Example;\n    let c3 = || e3.by_ref();\n    println!(\"{e3:?}\");\n}\n";

},{}],"9QPo2":[function(require,module,exports,__globalThis) {
module.exports = "#[derive(Debug)]\nstruct Example;\n\nimpl Example {\n    fn by_value(self) {}\n    fn by_mut_ref(&mut self) {}\n    fn by_ref(&self) {}\n}\n\nfn main() {\n    let e1 = Example;\n    let c1 = || e1.by_value();\n    println!(\"{e1:?}\"); // Fails\n\n    let mut e2 = Example;\n    let c2 = move || e2.by_mut_ref();\n    println!(\"{e2:?}\"); // Fails\n\n    let e3 = Example;\n    let c3 = move || e3.by_ref();\n    println!(\"{e3:?}\"); // Fails\n}\n";

},{}],"gjxSZ":[function(require,module,exports,__globalThis) {
module.exports = "use std::thread;\n\nfn main() {\n    let score = 42;\n\n    thread::spawn(move || println!(\"The score is: {score}\"))\n        .join()\n        .expect(\"The thread panicked\");\n}\n";

},{}],"lsFH3":[function(require,module,exports,__globalThis) {
module.exports = "The score is: 42\n";

},{}],"3L8QP":[function(require,module,exports,__globalThis) {
module.exports = "use std::thread;\n\nfn main() {\n    let mut scores = vec![42];\n\n    let handle = thread::spawn(move || {\n        println!(\"Scores A: {scores:?}\");\n        scores.push(1);\n        println!(\"Scores B: {scores:?}\");\n    });\n\n    scores.push(2);\n    println!(\"Scores C: {scores:?}\");\n\n    handle.join().expect(\"The thread panicked\");\n}\n";

},{}],"5Rcjy":[function(require,module,exports,__globalThis) {
module.exports = "error[E0382]: borrow of moved value: `scores`\n  --> mutate-variable/src/main.rs:12:5\n   |\n 4 |     let mut scores = vec![42];\n   |         ---------- move occurs because `scores` has type `Vec<i32>`, which does not\n   |                    implement the `Copy` trait\n 5 |\n 6 |     let handle = thread::spawn(move || {\n   |                                ------- value moved into closure here\n 7 |         println!(\"Scores A: {scores:?}\");\n   |                              ------ variable moved due to use in closure\n...\n12 |     scores.push(2);\n   |     ^^^^^^ value borrowed here after move\n   |\nhelp: consider cloning the value before moving it into the closure\n   |\n 6 ~     let value = scores.clone();\n 7 ~     let handle = thread::spawn(move || {\n 8 ~         println!(\"Scores A: {value:?}\");\n   |\n\nFor more information about this error, try `rustc --explain E0382`.\nerror: could not compile `mutate-variable` (bin \"mutate-variable\") due to 1 previous error\n";

},{}],"czH9i":[function(require,module,exports,__globalThis) {
module.exports = "#[derive(Debug)]\nstruct CannotDuplicate;\n\nfn main() {\n    let one = CannotDuplicate;\n    let another_one = one.clone();\n\n    println!(\"{one:?}\");\n    println!(\"{another_one:?}\");\n}\n";

},{}],"do4j5":[function(require,module,exports,__globalThis) {
module.exports = "error[E0599]: no method named `clone` found for struct `CannotDuplicate` in the current scope\n  --> shared-ownership-clone/src/main.rs:10:27\n   |\n 5 | struct CannotDuplicate;\n   | ---------------------- method `clone` not found for this struct\n...\n10 |     let another_one = one.clone();\n   |                           ^^^^^ method not found in `CannotDuplicate`\n   |\n   = help: items from traits can only be used if the trait is implemented and in scope\n   = note: the following trait defines an item `clone`, perhaps you need to implement it:\n           candidate #1: `Clone`\n\nFor more information about this error, try `rustc --explain E0599`.\nerror: could not compile `shared-ownership-clone` (bin \"shared-ownership-clone\") due to 1\n       previous error\n";

},{}],"c6lvk":[function(require,module,exports,__globalThis) {
module.exports = "use std::rc::Rc;\n\n#[derive(Debug)]\nstruct CannotDuplicate;\n\nfn main() {\n    let shared = Rc::new(CannotDuplicate);\n    let another_shared = shared.clone();\n\n    println!(\"{shared:?}\");\n    println!(\"{another_shared:?}\");\n}\n";

},{}],"h5vkk":[function(require,module,exports,__globalThis) {
module.exports = "CannotDuplicate\nCannotDuplicate\n";

},{}],"h9ttB":[function(require,module,exports,__globalThis) {
module.exports = "use std::rc::Rc;\n\nfn main() {\n    let mut shared = Rc::new(42);\n    *shared += 1;\n}\n";

},{}],"hXsqO":[function(require,module,exports,__globalThis) {
module.exports = "warning: variable does not need to be mutable\n --> shared-ownership-immutable/src/main.rs:4:9\n  |\n4 |     let mut shared = Rc::new(42);\n  |         ----^^^^^^\n  |         |\n  |         help: remove this `mut`\n  |\n  = note: `#[warn(unused_mut)]` (part of `#[warn(unused)]`) on by default\n\nerror[E0594]: cannot assign to data in an `Rc`\n --> shared-ownership-immutable/src/main.rs:5:5\n  |\n5 |     *shared += 1;\n  |     ^^^^^^^^^^^^ cannot assign\n  |\n  = help: trait `DerefMut` is required to modify through a dereference, but it is not\n  =       implemented for `Rc<i32>`\n\nFor more information about this error, try `rustc --explain E0594`.\nerror: could not compile `shared-ownership-immutable` (bin \"shared-ownership-immutable\") due\n       to 1 previous error; 1 warning emitted\n";

},{}],"64eNE":[function(require,module,exports,__globalThis) {
module.exports = "use std::cell::Cell;\n\nfn main() {\n    let shared = Cell::new(42);\n    shared.set(99);\n}\n";

},{}],"fPRtI":[function(require,module,exports,__globalThis) {
module.exports = "use std::cell::RefCell;\n\nfn main() {\n    let shared = RefCell::new(42);\n    *shared.borrow_mut() += 1;\n}\n";

},{}],"5k7ET":[function(require,module,exports,__globalThis) {
module.exports = "use std::{\n    sync::{Arc, Mutex},\n    thread,\n};\n\nfn main() {\n    let scores = Arc::new(Mutex::new(vec![42]));\n\n    let thread_scores = scores.clone();\n    let handle = thread::spawn(move || {\n        println!(\"Scores A: {thread_scores:?}\");\n        thread_scores.lock().expect(\"lock poisoned\").push(1);\n        println!(\"Scores B: {thread_scores:?}\");\n    });\n\n    scores.lock().expect(\"lock poisoned\").push(2);\n    println!(\"Scores C: {scores:?}\");\n\n    handle.join().expect(\"The thread panicked\");\n}\n";

},{}],"fM7O3":[function(require,module,exports,__globalThis) {
module.exports = "use std::{sync::Arc, thread};\n\nfn adder(nums: Vec<i64>, n_threads: usize) -> i64 {\n    let nums = Arc::new(nums);\n    let size = nums.len() / n_threads;\n\n    let t: Vec<_> = (0..n_threads)\n        .map(|i| {\n            let nums = nums.clone();\n            thread::spawn(move || {\n                let start = i * size;\n                let end = (i + 1) * size;\n                nums[start..end].iter().sum::<i64>()\n            })\n        })\n        .collect();\n\n    t.into_iter()\n        .map(|t| t.join().expect(\"Thread panicked\"))\n        .sum()\n}\n\nfn main() {\n    for n_threads in 1..=8 {\n        let nums: Vec<_> = (0..40_320).collect();\n        assert_eq!(812_831_040, adder(nums, n_threads));\n    }\n}\n";

},{}],"eTkBq":[function(require,module,exports,__globalThis) {
module.exports = "use std::{sync::mpsc, thread};\n\nfn main() {\n    let (tx, rx) = mpsc::channel();\n\n    let t1 = thread::spawn(move || {\n        for i in 0..10 {\n            tx.send(i).expect(\"Unable to send to thread 2\");\n        }\n    });\n\n    let t2 = thread::spawn(move || {\n        for j in rx {\n            println!(\"{j}\");\n        }\n    });\n\n    t1.join().expect(\"Thread 1 panicked\");\n    t2.join().expect(\"Thread 2 panicked\");\n}\n";

},{}],"6Oq0I":[function(require,module,exports,__globalThis) {
module.exports = "0\n1\n2\n3\n4\n5\n6\n7\n8\n9\n";

},{}],"esgSw":[function(require,module,exports,__globalThis) {
module.exports = "use std::{sync::mpsc, thread};\n\nfn main() {\n    let (tx, rx) = mpsc::channel();\n\n    let t1s: Vec<_> = (0..2)\n        .map(|_| {\n            let tx = tx.clone();\n            thread::spawn(move || {\n                for i in 0..100 {\n                    tx.send(i).expect(\"Unable to send to thread 2\");\n                }\n            })\n        })\n        .collect();\n    drop(tx);\n\n    let t2 = thread::spawn(move || {\n        for j in rx {\n            println!(\"{j}\");\n        }\n    });\n\n    for t in t1s {\n        t.join().expect(\"Sending thread panicked\")\n    }\n    t2.join().expect(\"Thread 2 panicked\");\n}\n";

},{}],"4p0wv":[function(require,module,exports,__globalThis) {
module.exports = "0\n0\n1\n1\n2\n2\n3\n3\n4\n4\n5\n5\n6\n7\n8\n9\n10\n11\n12\n6\n13\n14\n7\n15\n8\n16\n9\n17\n10\n18\n19\n20\n21\n22\n23\n24\n25\n26\n27\n28\n29\n30\n31\n32\n33\n34\n35\n36\n37\n38\n39\n40\n41\n42\n43\n44\n45\n46\n47\n48\n49\n50\n51\n52\n53\n54\n55\n56\n57\n58\n59\n60\n61\n62\n63\n64\n65\n66\n67\n68\n69\n70\n71\n72\n73\n74\n75\n76\n77\n78\n79\n80\n81\n82\n83\n84\n85\n11\n86\n87\n12\n13\n88\n14\n89\n90\n15\n16\n91\n17\n92\n18\n93\n19\n94\n20\n95\n21\n96\n22\n97\n23\n98\n24\n99\n25\n26\n27\n28\n29\n30\n31\n32\n33\n34\n35\n36\n37\n38\n39\n40\n41\n42\n43\n44\n45\n46\n47\n48\n49\n50\n51\n52\n53\n54\n55\n56\n57\n58\n59\n60\n61\n62\n63\n64\n65\n66\n67\n68\n69\n70\n71\n72\n73\n74\n75\n76\n77\n78\n79\n80\n81\n82\n83\n84\n85\n86\n87\n88\n89\n90\n91\n92\n93\n94\n95\n96\n97\n98\n99\n";

},{}],"c0LlK":[function(require,module,exports,__globalThis) {
module.exports = "use std::{sync::mpsc, thread};\n\nfn main() {\n    let (tx, rx) = mpsc::channel();\n\n    let t1s: Vec<_> = std::iter::repeat_n(tx, 10)\n        .enumerate()\n        .map(|(i, tx)| {\n            thread::spawn(move || {\n                tx.send(i).expect(\"Unable to send value to the appender\");\n            })\n        })\n        .collect();\n\n    let appender = thread::spawn(move || {\n        let mut scores = Vec::new();\n        for score in rx {\n            scores.push(score);\n        }\n        scores\n    });\n\n    for t in t1s {\n        t.join().expect(\"Sending thread panicked\")\n    }\n    let scores = appender.join().expect(\"The thread panicked\");\n    println!(\"{scores:?}\");\n}\n";

},{}],"aPhve":[function(require,module,exports,__globalThis) {
module.exports = "use std::{\n    sync::{mpsc, Arc},\n    thread,\n};\n\nfn adder(nums: Vec<i64>, n_threads: usize) -> i64 {\n    let nums = Arc::new(nums);\n    let (tx, rx) = mpsc::channel();\n\n    let chunk_size = nums.len() / n_threads;\n\n    let sum_threads: Vec<_> = (0..n_threads)\n        .map(|i| {\n            let tx = tx.clone();\n            let nums = nums.clone();\n            thread::spawn(move || {\n                let chunk = nums.chunks(chunk_size).nth(i).unwrap_or_default();\n                for sub_chunk in chunk.chunks(10) {\n                    let sum = sub_chunk.iter().sum::<i64>();\n                    tx.send(sum).expect(\"Unable to send a partial sum\");\n                }\n            })\n        })\n        .collect();\n    drop(tx);\n\n    let sum = rx.into_iter().sum::<i64>();\n\n    for t in sum_threads {\n        t.join().expect(\"thread panicked\");\n    }\n\n    sum\n}\n\nfn main() {\n    for n_threads in 1..=8 {\n        let nums: Vec<_> = (0..40_320).collect();\n        assert_eq!(812_831_040, adder(nums, n_threads));\n    }\n}\n";

},{}],"cVoPT":[function(require,module,exports,__globalThis) {
module.exports = "use std::thread;\n\nfn main() {\n    thread::spawn(|| {\n        let mut local_variable = String::new();\n        thread::spawn(|| {\n            local_variable.push_str(\"nested\");\n        });\n    });\n}\n";

},{}],"bXW7Q":[function(require,module,exports,__globalThis) {
module.exports = "use std::thread;\n\nfn main() {\n    let score = 42;\n\n    thread::scope(|scope| {\n        scope.spawn(|| {\n            println!(\"The score is: {score}\");\n        });\n    });\n}\n";

},{}],"8I6v0":[function(require,module,exports,__globalThis) {
module.exports = "The score is: 42\n";

},{}],"gRBIA":[function(require,module,exports,__globalThis) {
module.exports = "use std::thread;\n\nfn main() {\n    let mut score = 42;\n\n    thread::scope(|scope| {\n        scope.spawn(|| {\n            println!(\"The score is: {score}\");\n            score += 1;\n        });\n    });\n\n    println!(\"The score is: {score}\");\n}\n";

},{}],"2DXk2":[function(require,module,exports,__globalThis) {
module.exports = "The score is: 42\nThe score is: 43\n";

},{}],"byWZ3":[function(require,module,exports,__globalThis) {
module.exports = "use std::thread;\n\nfn main() {\n    let mut score = 42;\n\n    thread::scope(|scope| {\n        scope.spawn(|| score += 1);\n        scope.spawn(|| score += 1);\n    });\n\n    println!(\"The score is: {score}\");\n}\n";

},{}],"1Byrz":[function(require,module,exports,__globalThis) {
module.exports = "error[E0499]: cannot borrow `score` as mutable more than once at a time\n   --> scoped-threads/src/main.rs:34:21\n    |\n 32 |     thread::scope(|scope| {\n    |                    ----- has type `&'1 Scope<'1, '_>`\n 33 |         scope.spawn(|| score += 1);\n    |         --------------------------\n    |         |           |  |\n    |         |           |  first borrow occurs due to use of `score` in closure\n    |         |           first mutable borrow occurs here\n    |         argument requires that `score` is borrowed for `'1`\n 34 |         scope.spawn(|| score += 1);\n    |                     ^^ ----- second borrow occurs due to use of `score` in closure\n    |                     |\n    |                     second mutable borrow occurs here\n    |\nnote: requirement that the value outlives `'1` introduced here\n   --> std/src/thread/scoped.rs:203:35\n    |\n203 |         F: FnOnce() -> T + Send + 'scope,\n    |                                   ^^^^^^\n\nFor more information about this error, try `rustc --explain E0499`.\nerror: could not compile `scoped-threads` (bin \"scoped-threads\") due to 1 previous error\n";

},{}],"jiqY6":[function(require,module,exports,__globalThis) {
module.exports = "use std::thread;\n\nfn adder(nums: &[i64], n_threads: usize) -> i64 {\n    let chunk_size = nums.len() / n_threads;\n\n    thread::scope(|scope| {\n        nums.chunks(chunk_size)\n            .map(|chunk| scope.spawn(|| chunk.iter().sum::<i64>()))\n            .collect::<Vec<_>>()\n            .into_iter()\n            .map(|t| t.join().expect(\"Thread panicked\"))\n            .sum()\n    })\n}\n\nfn main() {\n    for t in 1..=8 {\n        let nums: Vec<_> = (0..10_000).collect();\n        assert_eq!(49_995_000, adder(&nums, t));\n    }\n}\n";

},{}],"1PBwJ":[function(require,module,exports,__globalThis) {
module.exports = "use std::{rc::Rc, thread};\n\nfn main() {\n    let one = Rc::new(42);\n    let another = one.clone();\n\n    thread::spawn(move || {\n        println!(\"{another:?}\");\n    });\n}\n";

},{}],"auDR1":[function(require,module,exports,__globalThis) {
module.exports = "error[E0277]: `Rc<i32>` cannot be sent between threads safely\n   --> send-sync-misuse/src/main.rs:7:19\n    |\n  7 |       thread::spawn(move || {\n    |       ------------- ^------\n    |       |             |\n    |  _____|_____________within this `{closure@send-sync-misuse/src/main.rs:7:19: 7:26}`\n    | |     |\n    | |     required by a bound introduced by this call\n  8 | |         println!(\"{another:?}\");\n  9 | |     });\n    | |_____^ `Rc<i32>` cannot be sent between threads safely\n    |\n    = help: within `{closure@send-sync-misuse/src/main.rs:7:19: 7:26}`, the trait `Send` is\n    =       not implemented for `Rc<i32>`\nnote: required because it's used within this closure\n   --> send-sync-misuse/src/main.rs:7:19\n    |\n  7 |     thread::spawn(move || {\n    |                   ^^^^^^^\nnote: required by a bound in `spawn`\n   --> std/src/thread/functions.rs:128:8\n    |\n125 | pub fn spawn<F, T>(f: F) -> JoinHandle<T>\n    |        ----- required by a bound in this function\n...\n128 |     F: Send + 'static,\n    |        ^^^^ required by this bound in `spawn`\n\nFor more information about this error, try `rustc --explain E0277`.\nerror: could not compile `send-sync-misuse` (bin \"send-sync-misuse\") due to 1 previous error\n";

},{}],"K4SuP":[function(require,module,exports,__globalThis) {
module.exports = "[package]\nname = \"rayon\"\nversion = \"0.1.0\"\nedition = \"2024\"\n\n# See more keys and their definitions at https://doc.rust-lang.org/cargo/reference/manifest.html\n\n[dependencies]\nrayon = \"1.10.0\"\n\n[lints]\nworkspace = true\n";

},{}],"6WmFU":[function(require,module,exports,__globalThis) {
module.exports = "use rayon::prelude::*;\n\nfn main() {\n    (0..10).into_par_iter().for_each(|i| println!(\"{i}\"));\n}\n";

},{}],"3tcqg":[function(require,module,exports,__globalThis) {
module.exports = "5\n9\n0\n6\n2\n1\n3\n4\n8\n7\n";

},{}],"QogQ9":[function(require,module,exports,__globalThis) {
module.exports = "use rayon::prelude::*;\n\nfn adder(nums: &[i64]) -> i64 {\n    nums.into_par_iter().sum()\n}\n\nfn main() {\n    let nums: Vec<_> = (0..10_000).collect();\n    assert_eq!(49_995_000, adder(&nums));\n}\n";

},{}],"d0zlN":[function(require,module,exports,__globalThis) {
module.exports = "use futures::{executor, future, Future, FutureExt};\n\nfn fetch_user_data() -> impl Future<Output = String> {\n    future::lazy(|_| \"Vivian\".to_owned())\n}\n\n// fetch_activity_feed, fetch_notification_count_for defined elsewhere\n\nfn load_homepage() -> impl Future<Output = String> {\n    let name_and_count = fetch_user_data()\n        .then(|name| fetch_notification_count_for(&name).map(|count| (name, count)));\n\n    let both = future::join(name_and_count, fetch_activity_feed());\n    both.map(|((name, count), activity)| {\n        format!(\n            \"User {name} has {count} notifications. Activity: {}\",\n            activity.join(\", \"),\n        )\n    })\n}\n\nfn main() {\n    println!(\"{}\", executor::block_on(load_homepage()));\n}\n\nfn fetch_activity_feed() -> impl Future<Output = Vec<String>> {\n    future::ready(Vec::new())\n}\n\nfn fetch_notification_count_for(_user: &str) -> impl Future<Output = i32> {\n    future::ready(0)\n}\n";

},{}],"3tk0h":[function(require,module,exports,__globalThis) {
module.exports = "use futures::{executor, future};\n\nasync fn fetch_user_data() -> String {\n    \"Vivian\".to_owned()\n}\n\n// fetch_activity_feed, fetch_notification_count_for defined elsewhere\n\nasync fn load_homepage() -> String {\n    let name_and_count = async {\n        let name = fetch_user_data().await;\n        let count = fetch_notification_count_for(&name).await;\n        (name, count)\n    };\n\n    let both = future::join(name_and_count, fetch_activity_feed());\n    let ((name, count), activity) = both.await;\n\n    format!(\n        \"User {name} has {count} notifications. Activity: {}\",\n        activity.join(\", \"),\n    )\n}\n\nfn main() {\n    println!(\"{}\", executor::block_on(load_homepage()));\n}\n\nasync fn fetch_activity_feed() -> Vec<String> {\n    Vec::new()\n}\n\nasync fn fetch_notification_count_for(_user: &str) -> i32 {\n    0\n}\n";

},{}],"iXvhc":[function(require,module,exports,__globalThis) {
/*@jsxRuntime automatic*/ /*@jsxImportSource react*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "title", ()=>title);
parcelHelpers.export(exports, "default", ()=>MDXContent);
var _jsxRuntime = require("react/jsx-runtime");
var _directives = require("./Directives");
var _changeDeck = require("./ChangeDeck");
var _changeDeckDefault = parcelHelpers.interopDefault(_changeDeck);
var _splash = require("./layout/Splash");
var _splashDefault = parcelHelpers.interopDefault(_splash);
var _testPattern = require("./TestPattern");
var _testPatternDefault = parcelHelpers.interopDefault(_testPattern);
var _transclude = require("./Transclude");
var _transcludeDefault = parcelHelpers.interopDefault(_transclude);
var _quote = require("./Quote");
var _quoteDefault = parcelHelpers.interopDefault(_quote);
var _excerpts = require("./Excerpts");
var _quotes = require("./Quotes");
var _asyncModuleCss = require("./async.module.css");
var _singlePng = require("./assets/async/single.png");
var _singlePngDefault = parcelHelpers.interopDefault(_singlePng);
var _threadsPng = require("./assets/async/threads.png");
var _threadsPngDefault = parcelHelpers.interopDefault(_threadsPng);
var _asyncPng = require("./assets/async/async.png");
var _asyncPngDefault = parcelHelpers.interopDefault(_asyncPng);
var _basicSyntax = require("rust:async/basic-syntax");
var _basicSyntaxDefault = parcelHelpers.interopDefault(_basicSyntax);
var _errorHandling = require("rust:async/error-handling");
var _errorHandlingDefault = parcelHelpers.interopDefault(_errorHandling);
var _forgetAwait = require("rust:async/forget-await");
var _forgetAwaitDefault = parcelHelpers.interopDefault(_forgetAwait);
var _forgetAwait1 = require("stderr:async/forget-await");
var _forgetAwaitDefault1 = parcelHelpers.interopDefault(_forgetAwait1);
var _implFutureSugar = require("rust:async/impl-future-sugar");
var _implFutureSugarDefault = parcelHelpers.interopDefault(_implFutureSugar);
var _executorPng = require("./assets/async/executor.png");
var _executorPngDefault = parcelHelpers.interopDefault(_executorPng);
var _driveToCompletion = require("toml:async/drive-to-completion");
var _driveToCompletionDefault = parcelHelpers.interopDefault(_driveToCompletion);
var _driveToCompletion1 = require("rust:async/drive-to-completion");
var _driveToCompletionDefault1 = parcelHelpers.interopDefault(_driveToCompletion1);
var _exerciseCombinators = require("toml:async/exercise-combinators");
var _exerciseCombinatorsDefault = parcelHelpers.interopDefault(_exerciseCombinators);
var _exerciseCombinators1 = require("rust:async/exercise-combinators");
var _exerciseCombinatorsDefault1 = parcelHelpers.interopDefault(_exerciseCombinators1);
var _concurrencyVsParallelism = require("rust:async/concurrency-vs-parallelism");
var _concurrencyVsParallelismDefault = parcelHelpers.interopDefault(_concurrencyVsParallelism);
var _concurrencyVsParallelism1 = require("stdout:async/concurrency-vs-parallelism");
var _concurrencyVsParallelismDefault1 = parcelHelpers.interopDefault(_concurrencyVsParallelism1);
var _concurrencyVsParallelismRev1 = require("rust:async/concurrency-vs-parallelism?rev=1");
var _concurrencyVsParallelismRev1Default = parcelHelpers.interopDefault(_concurrencyVsParallelismRev1);
var _concurrencyVsParallelismRev11 = require("stdout:async/concurrency-vs-parallelism?rev=1");
var _concurrencyVsParallelismRev1Default1 = parcelHelpers.interopDefault(_concurrencyVsParallelismRev11);
var _asyncFromSyncOnceTokio = require("rust:async/async-from-sync-once-tokio");
var _asyncFromSyncOnceTokioDefault = parcelHelpers.interopDefault(_asyncFromSyncOnceTokio);
var _asyncFromSyncSequentialTokio = require("rust:async/async-from-sync-sequential-tokio");
var _asyncFromSyncSequentialTokioDefault = parcelHelpers.interopDefault(_asyncFromSyncSequentialTokio);
var _asyncFromSyncConcurrentTokio = require("rust:async/async-from-sync-concurrent-tokio");
var _asyncFromSyncConcurrentTokioDefault = parcelHelpers.interopDefault(_asyncFromSyncConcurrentTokio);
var _asyncFromSyncOnceAsyncStd = require("rust:async/async-from-sync-once-async-std");
var _asyncFromSyncOnceAsyncStdDefault = parcelHelpers.interopDefault(_asyncFromSyncOnceAsyncStd);
var _asyncFromSyncSequentialAsyncStd = require("rust:async/async-from-sync-sequential-async-std");
var _asyncFromSyncSequentialAsyncStdDefault = parcelHelpers.interopDefault(_asyncFromSyncSequentialAsyncStd);
var _asyncFromSyncConcurrentAsyncStd = require("rust:async/async-from-sync-concurrent-async-std");
var _asyncFromSyncConcurrentAsyncStdDefault = parcelHelpers.interopDefault(_asyncFromSyncConcurrentAsyncStd);
var _asyncTests = require("rust:async/async-tests");
var _asyncTestsDefault = parcelHelpers.interopDefault(_asyncTests);
var _asyncTestsRev1 = require("rust:async/async-tests?rev=1");
var _asyncTestsRev1Default = parcelHelpers.interopDefault(_asyncTestsRev1);
var _blocking = require("rust:async/blocking");
var _blockingDefault = parcelHelpers.interopDefault(_blocking);
var _blocking1 = require("stdout:async/blocking");
var _blockingDefault1 = parcelHelpers.interopDefault(_blocking1);
var _blockingRev1 = require("rust:async/blocking?rev=1");
var _blockingRev1Default = parcelHelpers.interopDefault(_blockingRev1);
var _blockingRev11 = require("stdout:async/blocking?rev=1");
var _blockingRev1Default1 = parcelHelpers.interopDefault(_blockingRev11);
var _blockingRev2 = require("rust:async/blocking?rev=2");
var _blockingRev2Default = parcelHelpers.interopDefault(_blockingRev2);
var _blockingRev21 = require("stdout:async/blocking?rev=2");
var _blockingRev2Default1 = parcelHelpers.interopDefault(_blockingRev21);
var _cpuBound = require("rust:async/cpu-bound");
var _cpuBoundDefault = parcelHelpers.interopDefault(_cpuBound);
var _cpuBound1 = require("stdout:async/cpu-bound");
var _cpuBoundDefault1 = parcelHelpers.interopDefault(_cpuBound1);
var _lifetimes = require("rust:async/lifetimes");
var _lifetimesDefault = parcelHelpers.interopDefault(_lifetimes);
var _sharingData = require("rust:async/sharing-data");
var _sharingDataDefault = parcelHelpers.interopDefault(_sharingData);
var _sharingData1 = require("stderr:async/sharing-data");
var _sharingDataDefault1 = parcelHelpers.interopDefault(_sharingData1);
var _sharingDataRev1 = require("rust:async/sharing-data?rev=1");
var _sharingDataRev1Default = parcelHelpers.interopDefault(_sharingDataRev1);
var _sharingMutableData = require("rust:async/sharing-mutable-data");
var _sharingMutableDataDefault = parcelHelpers.interopDefault(_sharingMutableData);
var _sharingMutableData1 = require("stderr:async/sharing-mutable-data");
var _sharingMutableDataDefault1 = parcelHelpers.interopDefault(_sharingMutableData1);
var _sharingMutableDataRev1 = require("rust:async/sharing-mutable-data?rev=1");
var _sharingMutableDataRev1Default = parcelHelpers.interopDefault(_sharingMutableDataRev1);
var _channels = require("rust:async/channels");
var _channelsDefault = parcelHelpers.interopDefault(_channels);
var _exerciseEchoServer = require("toml:async/exercise-echo-server");
var _exerciseEchoServerDefault = parcelHelpers.interopDefault(_exerciseEchoServer);
var _exerciseEchoServer1 = require("rust:async/exercise-echo-server");
var _exerciseEchoServerDefault1 = parcelHelpers.interopDefault(_exerciseEchoServer1);
const title = "Asynchronous programming";
function _createMdxContent(props) {
    const _components = {
        a: "a",
        code: "code",
        em: "em",
        h1: "h1",
        h2: "h2",
        hr: "hr",
        li: "li",
        p: "p",
        pre: "pre",
        strong: "strong",
        ul: "ul",
        ...props.components
    }, { SplitSlides } = _components;
    if (!SplitSlides) _missingMdxReference("SplitSlides", true);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SplitSlides, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _testPatternDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Asynchronous programming"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "What's the point of asynchronous Rust?"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "JavaScript, C#, Python"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Future is something that will eventually have a value"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Promise is something that you can complete"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                className: _asyncModuleCss.fullImage,
                src: (0, _singlePngDefault.default),
                alt: "A single blocking job"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                className: _asyncModuleCss.fullImage,
                src: (0, _threadsPngDefault.default),
                alt: "Three blocking jobs"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                className: _asyncModuleCss.fullImage,
                src: (0, _asyncPngDefault.default),
                alt: "Three jobs, one thread"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Defining an asynchronous function"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _basicSyntaxDefault.default),
                focusOn: "1+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "An async function doesn't do anything when called."
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Allows the compiler to perform a transformation on the code"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Calling an asynchronous function"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "From an asynchronous function"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _basicSyntaxDefault.default),
                focusOn: "5+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Only valid inside an ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "async"
                            }),
                            " function ..."
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "From an asynchronous block"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _basicSyntaxDefault.default),
                focusOn: "9+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "... or block"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: ".await"
                            }),
                            " is a place where control may be yielded to something else."
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Postfix keyword is unique in Rust (so far)"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Asynchronous functions and error handling"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _errorHandlingDefault.default),
                focusOn: "1+8",
                emphasize: "6[67+7]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Key reason that the postfix keyword was chosen"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Nothing special here, just a combination of existing ideas"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Forgetting to await"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _forgetAwaitDefault.default),
                focusOn: "1+7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _forgetAwaitDefault1.default),
                focusOn: "1+7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "TODO: are there times we don't want to ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: ".await"
                            }),
                            "?",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "returning a future?"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "spawning a task"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "impl Future"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _implFutureSugarDefault.default),
                focusOn: "1+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Same as"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _implFutureSugarDefault.default),
                focusOn: "5+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "impl Future"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _implFutureSugarDefault.default),
                focusOn: "9+7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Futures predate async/await (2016-07-31 vs 2019-11-07)"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "TODO: was there a place where lifetime annotations worked better?"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "The ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "Future"
                    }),
                    " trait"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.FutureTrait), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.PollEnum), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: "Compare / contrast to:"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.IteratorTrait), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.OptionEnum), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Executors"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Starts the initial call to ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Future::poll"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Unlike other languages, not built in"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                className: _asyncModuleCss.fullImage,
                src: (0, _executorPngDefault.default),
                alt: "The executor loop"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Executor goes through tasks until they all say pending, sleeps"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Task gets a waker, that waker is given ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.em, {
                                children: "somewhere"
                            }),
                            " and can be used when more data available"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Common executors"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "futures"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Tokio"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "async-std"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "smol"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "async-std and smol share dependencies"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Language vs. standard library vs. crates"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "async"
                            }),
                            " and ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "await"
                            }),
                            " are built into the language"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Future"
                            }),
                            " is part of the standard library"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "crates provide useful capabilities"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Just like other parts of Rust, many things pushed to crates"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "There's no One True executor"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Tradeoffs and strengths"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "embedded"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "The futures crate"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "additional abstractions"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "common functionality"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "channels"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "IO abstractions"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "executor",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "tasks"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Driving a future to completion"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "toml",
                src: (0, _driveToCompletionDefault.default),
                focusOn: "8+2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _driveToCompletionDefault1.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Not the only executor"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "The ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "FutureExt"
                    }),
                    " trait"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.FutureExtTrait), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "methods like ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "map"
                            }),
                            " or ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "into_stream"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Futures that can fail"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.TryFutureTrait), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.TryFutureExtTrait), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "methods like ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "map_ok"
                            }),
                            " and ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "map_err"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Streams"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.StreamTrait), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Not in the standard library (yet!)"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Analog to ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Iterator"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.StreamExtTrait), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "methods like",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "map"
                                            }),
                                            ", ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "fold"
                                            }),
                                            ", ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "enumerate"
                                            })
                                        ]
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "buffer"
                                            }),
                                            ", ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "buffer_unordered"
                                            }),
                                            ", ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "for_each_concurrent"
                                            })
                                        ]
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Streams that can fail"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.TryStreamTrait), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.TryStreamExtTrait), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "methods like ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "and_then"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "or_else"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Common combinators"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                            children: "join"
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                            children: "select"
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                            children: "now_or_never"
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                            children: "buffer_unordered"
                        })
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Exercise"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Create three async functions",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Take in some numbers, return some numbers"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Call these functions from ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "main"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Use ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "futures::future::join"
                            }),
                            " to run two concurrently"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Use ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "futures::executor::block_on"
                            }),
                            " to drive futures to completion"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Bonus"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Use ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "select"
                            }),
                            " to race two concurrently"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Create a stream from calling one of the async functions",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Sum it up"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One answer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "toml",
                src: (0, _exerciseCombinatorsDefault.default),
                focusOn: "8+2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _exerciseCombinatorsDefault1.default),
                focusOn: "1+15,17,19,21"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Concurrency vs. parallelism"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _concurrencyVsParallelismDefault.default),
                focusOn: "1+13"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-output",
                src: (0, _concurrencyVsParallelismDefault1.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Concurrency vs. parallelism"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _concurrencyVsParallelismRev1Default.default),
                focusOn: "1+13",
                emphasize: "7[12+18],8[12+18]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-output",
                src: (0, _concurrencyVsParallelismRev1Default1.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Tasks"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Similar to threads"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Lightweight"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Millions of tasks should be fine"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Run into OS limitations (file handles, memory) first"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "TODO: Some kind of picture here (extension of previous one?)"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Parallelism requires executor support"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Futures",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "\u274C ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "futures::executor::block_on"
                                            })
                                        ]
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "\u2705 ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "futures::executor::ThreadPool"
                                            })
                                        ]
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Tokio",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "\u274C ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "tokio::runtime::Builder::new_current_thread()"
                                            })
                                        ]
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "\u2705 ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "tokio::runtime::Builder::new_multi_thread()"
                                            })
                                        ]
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Both use feature flags, differences in default enabled",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "Futures: ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "executor"
                                            }),
                                            ", ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "thread-pool"
                                            })
                                        ]
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "Tokio: ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "rt"
                                            }),
                                            ", ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "rt-multi-thread"
                                            })
                                        ]
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Spawning a task doesn't guarantee parallelism",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Just like you can spawn threads on a single-core system"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Calling asynchronous code from synchronous"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Once"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Sequentially"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Concurrently"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Once (Tokio)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _asyncFromSyncOnceTokioDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "The procedural macro ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "tokio::main"
                            }),
                            " wraps the body of the function\nwith code that starts an executor, submits the body, blocking on it."
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Most common way of starting the executor."
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Sequentially (Tokio)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _asyncFromSyncSequentialTokioDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Create one runtime and reuse it"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Concurrently (Tokio)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _asyncFromSyncConcurrentTokioDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Create a runtime on a separate thread and send pieces of work to it."
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Can also involve another channel back for intermediate results."
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Once (async-std)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _asyncFromSyncOnceAsyncStdDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "The procedural macro ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "async_std::main"
                            }),
                            " wraps the body of the\nfunction with code that submits the body to the executor, blocking\non it."
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Sequentially (async-std)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _asyncFromSyncSequentialAsyncStdDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "async-std has a global executor that is lazily-initialized; no need\nto do it ourselves"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Concurrently (async-std)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _asyncFromSyncConcurrentAsyncStdDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Asynchronous tests"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _asyncTestsDefault.default),
                focusOn: "1+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _asyncTestsRev1Default.default),
                focusOn: "1+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Rust's test framework is multithreaded"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Tokio's test annotation creates a \"smaller\" executor"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Calling synchronous code from asynchronous"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _quoteDefault.default), {
                caption: "Tokio documentation",
                href: "https://docs.rs/tokio/latest/tokio/#cpu-bound-tasks-and-blocking-code",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.p, {
                    children: [
                        "[C]ode that spends a long time without reaching an ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                            children: ".await"
                        }),
                        " will prevent other tasks from running"
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Calling synchronous code from asynchronous"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "IO-bound / blocking",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Reading from a file"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Reading from a socket that isn't in non-blocking mode"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "Using ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "Mutex"
                                            }),
                                            " / ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "RwLock"
                                            }),
                                            " / channels"
                                        ]
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Sleeping"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "CPU-bound"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "As a rough guideline, aim for max 1 ms between await points."
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Don't need to worry if you are performing small calculations."
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Blocking"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _blockingDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-output",
                src: (0, _blockingDefault1.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Never perform anything that would block inside an asynchronous task"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Blocking correctly (Tokio)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _blockingRev1Default.default),
                emphasize: "8[12+20],8[33+2],12[12+20],12[33+2],18[58+21],19[58+21]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-output",
                src: (0, _blockingRev1Default1.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Creates threads that can just sit there blocked by the OS"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "More expensive than a task"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Blocking correctly (async-std)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _blockingRev2Default.default),
                emphasize: "8[12+20],8[33+2],12[12+20],12[33+2]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-output",
                src: (0, _blockingRev2Default1.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "CPU-bound"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Async code works best when you are waiting most of the time"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Blocking work can be handed off to lots of threads",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "That wait most of the time"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Don't create lots of threads that are all active",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Causes CPU contention"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "CPU-bound (Tokio)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _cpuBoundDefault.default),
                focusOn: "1+18"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "CPU-bound (Tokio)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _cpuBoundDefault.default),
                focusOn: "20+16"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "CPU-bound (Tokio)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-output",
                src: (0, _cpuBoundDefault1.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Common gotchas"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Files"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Holding a blocking lock across an await point"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "OSes generally don't have a non-blocking file API, but that's changing"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "The lock guard prevents spawning the task"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Lifetimes"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _lifetimesDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Works pretty much the same, most of the time"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "https://github.com/rust-lang/rust/issues/42940"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Sharing data"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _sharingDataDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Sharing data"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _sharingDataDefault1.default),
                focusOn: "1+17"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Sharing data"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _sharingDataRev1Default.default),
                emphasize: "11[22+4]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Sharing mutable data"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _sharingMutableDataDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Sharing mutable data"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _sharingMutableDataDefault1.default),
                focusOn: "1+32"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Sharing mutable data"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _sharingMutableDataDefault1.default),
                focusOn: "33+16"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Sharing mutable data"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _sharingMutableDataRev1Default.default),
                emphasize: "4,8[17+20],8[47+2],12,14[22+32]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Using channels"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _quotes.ChannelQuote), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Using channels"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _channelsDefault.default),
                focusOn: "6+25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Move mutation into a separate task"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Can be prettied up into a lightweight \"actor\" concept"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "Wrap the ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "tx"
                                            }),
                                            " in a little struct with methods that send"
                                        ]
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Introduce an enum for the different methods desired"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Match on the enum in the spawned task"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Use a oneshot channel to handle response"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "Maybe make it a ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "spawn_blocking"
                                            }),
                                            " as needed"
                                        ]
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Asynchronous IO"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "futures::io::AsyncRead"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.FuturesIoAsyncReadPollRead), {
                emphasize: "4[9+9],5[10+13]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "tokio::io::AsyncRead"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.TokioAsyncReadPollRead), {
                emphasize: "4[9+16],5[10+14]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Very confusing to have similar traits with same names but small differences!"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "futures"
                            }),
                            " is also ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "async_std::io::Read"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "AsyncReadExt"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "futures::io::AsyncReadExt"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.FuturesAsyncReadExtRead), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "tokio::io::AsyncReadExt"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.TokioAsyncReadExtRead), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Still confusing, but at least they are the same here."
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Exercise"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Create a TCP echo server"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Hints"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.strong, {
                                children: "Cargo.toml"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                                lang: "toml",
                                src: (0, _exerciseEchoServerDefault.default),
                                focusOn: "9",
                                copyAllCode: false
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.strong, {
                                children: "main.rs"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                                src: (0, _exerciseEchoServerDefault1.default),
                                focusOn: "5",
                                copyAllCode: false
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.strong, {
                                children: "client"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                    children: "nc 127.0.0.1 9876\n"
                                })
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Bonus"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Support multiple clients"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One answer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _exerciseEchoServerDefault1.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Ecosystem libraries"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                                href: "https://github.com/awslabs/aws-sdk-rust",
                                children: "aws-sdk-rust"
                            }),
                            " \u2014 AWS SDK"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                                href: "https://crates.io/crates/hyper",
                                children: "hyper"
                            }),
                            " \u2014 HTTP/1 and HTTP/2 implementation"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                                href: "https://crates.io/crates/reqwest",
                                children: "reqwest"
                            }),
                            " \u2014 Ergonomic, batteries-included HTTP client"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                                href: "https://crates.io/crates/tonic",
                                children: "tonic"
                            }),
                            " \u2014 gRPC over HTTP/2"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Ecosystem (web server) frameworks"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                                href: "https://crates.io/crates/axum",
                                children: "axum"
                            }),
                            " \u2014 focuses on ergonomics and modularity"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                                href: "https://crates.io/crates/warp",
                                children: "warp"
                            }),
                            " \u2014 super-easy and composable for warp speeds"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                                href: "https://crates.io/crates/actix-web",
                                children: "actix-web"
                            }),
                            " \u2014 powerful, pragmatic, and extremely fast"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                                href: "https://crates.io/crates/rocket",
                                children: "rocket"
                            }),
                            " \u2014 a focus ease-of-use, expressibility, and speed"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Annoyances and gotchas"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Use of ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "async fn"
                            }),
                            " in public traits is discouraged",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                                            href: "https://crates.io/crates/async-trait",
                                            children: "async-trait"
                                        })
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                                            href: "https://crates.io/crates/trait-variant",
                                            children: "trait-variant"
                                        })
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Annoyances and gotchas"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Tokio vs async-std",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "not all concepts are abstracted"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "some are overlapping"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "tasks (",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "spawn"
                                            }),
                                            ")"
                                        ]
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "io (",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "AsyncRead"
                                            }),
                                            ")"
                                        ]
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "Stream"
                                            }),
                                            " isn't stable"
                                        ]
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Tokio needs feature flags"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _changeDeckDefault.default), {
                    deck: "overview",
                    children: "Return"
                })
            })
        ]
    });
}
function MDXContent(props = {}) {
    const { wrapper: MDXLayout } = props.components || {};
    return MDXLayout ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(MDXLayout, {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_createMdxContent, {
            ...props
        })
    }) : _createMdxContent(props);
}
function _missingMdxReference(id, component, place) {
    throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it." + (place ? "\nIt\u2019s referenced in your code at `" + place + "`" : ""));
}

},{"react/jsx-runtime":"afIHK","./Directives":"6Yemz","./ChangeDeck":"29Jlq","./layout/Splash":"1mDy7","./TestPattern":"g0BPT","./Transclude":"fUgcm","./Quote":"7JX1G","./Excerpts":"5uobq","./Quotes":"9LaLC","./async.module.css":"hsLOs","./assets/async/single.png":"adNBu","./assets/async/threads.png":"8FaaU","./assets/async/async.png":"5byAV","rust:async/basic-syntax":"daplb","rust:async/error-handling":"b8qUv","rust:async/forget-await":"1rMQJ","stderr:async/forget-await":"eG04z","rust:async/impl-future-sugar":"38c5V","./assets/async/executor.png":"dyn3x","toml:async/drive-to-completion":"ddWiK","rust:async/drive-to-completion":"fnaRN","toml:async/exercise-combinators":"fgWBP","rust:async/exercise-combinators":"aiGCm","rust:async/concurrency-vs-parallelism":"jG1Oo","stdout:async/concurrency-vs-parallelism":"agy30","rust:async/concurrency-vs-parallelism?rev=1":"fFOOu","stdout:async/concurrency-vs-parallelism?rev=1":"9ht9r","rust:async/async-from-sync-once-tokio":"erXy4","rust:async/async-from-sync-sequential-tokio":"3ms4H","rust:async/async-from-sync-concurrent-tokio":"iTGtk","rust:async/async-from-sync-once-async-std":"i7lA9","rust:async/async-from-sync-sequential-async-std":"43y7V","rust:async/async-from-sync-concurrent-async-std":"lWoH0","rust:async/async-tests":"iUyd6","rust:async/async-tests?rev=1":"ePkGP","rust:async/blocking":"jwks8","stdout:async/blocking":"hUvZ1","rust:async/blocking?rev=1":"54jQr","stdout:async/blocking?rev=1":"dFtIC","rust:async/blocking?rev=2":"e2KvN","stdout:async/blocking?rev=2":"5VX3M","rust:async/cpu-bound":"772kl","stdout:async/cpu-bound":"ce6eI","rust:async/lifetimes":"iIhNR","rust:async/sharing-data":"5aBIx","stderr:async/sharing-data":"jwCWA","rust:async/sharing-data?rev=1":"ecJCh","rust:async/sharing-mutable-data":"iTA2P","stderr:async/sharing-mutable-data":"bYqgs","rust:async/sharing-mutable-data?rev=1":"8L43z","rust:async/channels":"eN0Pc","toml:async/exercise-echo-server":"20UY2","rust:async/exercise-echo-server":"4jdX4","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"hsLOs":[function(require,module,exports,__globalThis) {
var _utilModuleCss = require("./util.module.css");
module.exports["fullImage"] = `ljQcMW_fullImage ${_utilModuleCss["-fullImage"]}`;

},{"./util.module.css":"lqfZi"}],"adNBu":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("8o4DF");

},{}],"8FaaU":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("6uUHF");

},{}],"5byAV":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("6Qbep");

},{}],"daplb":[function(require,module,exports,__globalThis) {
module.exports = "async fn eniac(a: i32, b: i32) -> i32 {\n    a + b\n}\n\nasync fn deep_blue(a: i32, b: i32) {\n    let a_move = eniac(a, b).await;\n}\n\nfn deep_thought(a: i32, b: i32) {\n    let sometime = async {\n        let a_move = eniac(a, b).await;\n    };\n}\n\nfn main() {}\n";

},{}],"b8qUv":[function(require,module,exports,__globalThis) {
module.exports = "async fn download_web_page(url: &str) -> Result<String, Error> {\n    todo!()\n}\n\nasync fn get_available_products() -> Result<usize, Error> {\n    let html = download_web_page(\"http://ferris-merch.example.com\").await?;\n    Ok(html.len())\n}\n\nstruct Error;\n\nfn main() {}\n";

},{}],"1rMQJ":[function(require,module,exports,__globalThis) {
module.exports = "async fn inner() -> i32 {\n    42\n}\n\nasync fn outer() -> i32 {\n    inner() + 1\n}\n\nfn main() {}\n";

},{}],"eG04z":[function(require,module,exports,__globalThis) {
module.exports = "error[E0369]: cannot add `{integer}` to `impl Future<Output = i32>`\n --> forget-await/src/main.rs:6:13\n  |\n6 |     inner() + 1\n  |     ------- ^ - {integer}\n  |     |\n  |     impl Future<Output = i32>\n\nFor more information about this error, try `rustc --explain E0369`.\nerror: could not compile `forget-await` (bin \"forget-await\") due to 1 previous error\n";

},{}],"38c5V":[function(require,module,exports,__globalThis) {
module.exports = "async fn sugared() -> i32 {\n    42\n}\n\nfn desugared() -> impl std::future::Future<Output = i32> {\n    async { 42 }\n}\n\nfn a_tale_of_two_times() -> impl std::future::Future<Output = ()> {\n    println!(\"Run immediately on function invocation\");\n\n    async {\n        println!(\"Run when polled\");\n    }\n}\n\nfn main() {}\n";

},{}],"dyn3x":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("if0qk");

},{}],"ddWiK":[function(require,module,exports,__globalThis) {
module.exports = "[package]\nname = \"drive-to-completion\"\nversion = \"0.1.0\"\nedition = \"2024\"\n\n# See more keys and their definitions at https://doc.rust-lang.org/cargo/reference/manifest.html\n\n[dependencies]\nfutures = \"0.3.31\"\n\n[lints]\nworkspace = true\n";

},{}],"fnaRN":[function(require,module,exports,__globalThis) {
module.exports = "use futures::executor;\n\nasync fn deep_blue(a: i32, b: i32) -> i32 {\n    a + b\n}\n\nfn main() {\n    let v = executor::block_on(deep_blue(1, 2));\n    println!(\"{v}\");\n}\n";

},{}],"fgWBP":[function(require,module,exports,__globalThis) {
module.exports = "[package]\nname = \"exercise-combinators\"\nversion = \"0.1.0\"\nedition = \"2024\"\n\n# See more keys and their definitions at https://doc.rust-lang.org/cargo/reference/manifest.html\n\n[dependencies]\nfutures = \"0.3.31\"\n\n[lints]\nworkspace = true\n";

},{}],"aiGCm":[function(require,module,exports,__globalThis) {
module.exports = "use futures::{executor, future};\n\nfn main() {\n    let v = executor::block_on(async {\n        let a = double(1);\n        let b = negate(2);\n        let c = square(3);\n\n        let (a, b) = future::join(a, b).await;\n        a + b + c.await\n    });\n\n    dbg!(v);\n}\n\n#[rustfmt::skip]\nasync fn double(v: i32) -> i32 { v * 2 }\n#[rustfmt::skip]\nasync fn negate(v: i32) -> i32 { -v }\n#[rustfmt::skip]\nasync fn square(v: i32) -> i32 { v * v }\n";

},{}],"jG1Oo":[function(require,module,exports,__globalThis) {
module.exports = "use futures::future;\nuse std::time::Instant;\n\n#[tokio::main]\nasync fn main() {\n    let start = Instant::now();\n    let a = async { process_for_100ms() };\n    let b = async { process_for_100ms() };\n\n    let (_a, _b) = future::join(a, b).await;\n    let duration = start.elapsed();\n    dbg!(duration);\n}\n\nfn process_for_100ms() {\n    std::thread::sleep(std::time::Duration::from_millis(100));\n}\n";

},{}],"agy30":[function(require,module,exports,__globalThis) {
module.exports = "[concurrency-vs-parallelism/src/main.rs:13:5] duration = 209.800042ms\n";

},{}],"fFOOu":[function(require,module,exports,__globalThis) {
module.exports = "use futures::future;\nuse std::time::Instant;\n\n#[tokio::main]\nasync fn main() {\n    let start = Instant::now();\n    let a = tokio::task::spawn(async { process_for_100ms() });\n    let b = tokio::task::spawn(async { process_for_100ms() });\n\n    let (_a, _b) = future::join(a, b).await;\n    let duration = start.elapsed();\n    dbg!(duration);\n}\n\nfn process_for_100ms() {\n    std::thread::sleep(std::time::Duration::from_millis(100));\n}\n";

},{}],"9ht9r":[function(require,module,exports,__globalThis) {
module.exports = "[concurrency-vs-parallelism/src/main.rs:25:5] duration = 105.167084ms\n";

},{}],"erXy4":[function(require,module,exports,__globalThis) {
module.exports = "#[tokio::main]\nasync fn main() {\n    let a = async { 42 };\n    let b = a.await;\n    println!(\"{b}\");\n}\n";

},{}],"3ms4H":[function(require,module,exports,__globalThis) {
module.exports = "use tokio::runtime::Runtime;\n\nfn main() {\n    let runtime = Runtime::new().expect(\"Unable to start the runtime\");\n\n    let a = runtime.block_on(async { 1 });\n    let b = runtime.block_on(async { 2 });\n\n    dbg!(a + b);\n}\n";

},{}],"iTGtk":[function(require,module,exports,__globalThis) {
module.exports = "use std::thread;\nuse tokio::sync::mpsc;\n\nfn main() {\n    let (tx, rx) = mpsc::channel(10);\n    let runner = thread::spawn(|| core(rx));\n\n    for i in 0..100 {\n        tx.blocking_send(i).expect(\"Unable to send\")\n    }\n    drop(tx);\n\n    let sum = runner.join().expect(\"Runner panicked\");\n    dbg!(sum);\n}\n\n#[tokio::main]\nasync fn core(mut rx: mpsc::Receiver<i32>) -> i32 {\n    let mut sum = 0;\n    while let Some(i) = rx.recv().await {\n        sum += i;\n    }\n    sum\n}\n";

},{}],"i7lA9":[function(require,module,exports,__globalThis) {
module.exports = "#[async_std::main]\nasync fn main() {\n    let a = async { 42 };\n    let b = a.await;\n    println!(\"{b}\");\n}\n";

},{}],"43y7V":[function(require,module,exports,__globalThis) {
module.exports = "use async_std::task;\n\nfn main() {\n    let a = task::block_on(async { 1 });\n    let b = task::block_on(async { 2 });\n\n    dbg!(a + b);\n}\n";

},{}],"lWoH0":[function(require,module,exports,__globalThis) {
module.exports = "use async_std::{channel, task};\nuse futures::StreamExt;\nuse std::thread;\n\nfn main() {\n    let (tx, rx) = channel::bounded(10);\n    let runner = thread::spawn(move || {\n        task::block_on(rx.fold(0, |acc, i| async move { acc + i }))\n    });\n\n    for i in 0..100 {\n        task::block_on(tx.send(i)).expect(\"unable to send\");\n    }\n    drop(tx);\n\n    let sum = runner.join().expect(\"runner panicked\");\n    dbg!(sum);\n}\n";

},{}],"iUyd6":[function(require,module,exports,__globalThis) {
module.exports = "#[tokio::test]\nasync fn test_async() {\n    let a = async { 99 };\n    assert_eq!(99, a.await);\n}\n\nfn main() {}\n";

},{}],"ePkGP":[function(require,module,exports,__globalThis) {
module.exports = "#[async_std::test]\nasync fn test_async() {\n    let a = async { 99 };\n    assert_eq!(99, a.await);\n}\n\nfn main() {}\n";

},{}],"jwks8":[function(require,module,exports,__globalThis) {
module.exports = "use futures::FutureExt;\nuse std::{thread, time::Duration};\n\n#[tokio::main]\nasync fn main() {\n    let a = async {\n        thread::sleep(Duration::from_millis(100));\n        1\n    };\n    let b = async {\n        thread::sleep(Duration::from_millis(10));\n        2\n    };\n\n    futures::select! {\n        a = a.fuse() => println!(\"a resolved first: {a}\"),\n        b = b.fuse() => println!(\"b resolved first: {b}\"),\n    };\n}\n";

},{}],"hUvZ1":[function(require,module,exports,__globalThis) {
module.exports = "a resolved first: 1\n";

},{}],"54jQr":[function(require,module,exports,__globalThis) {
module.exports = "use futures::FutureExt;\nuse std::{thread, time::Duration};\n\nuse tokio::task;\n\n#[tokio::main]\nasync fn main() {\n    let a = task::spawn_blocking(|| {\n        thread::sleep(Duration::from_millis(100));\n        1\n    });\n    let b = task::spawn_blocking(|| {\n        thread::sleep(Duration::from_millis(10));\n        2\n    });\n\n    futures::select! {\n        a = a.fuse() => println!(\"a resolved first: {}\", a.expect(\"a panicked\")),\n        b = b.fuse() => println!(\"b resolved first: {}\", b.expect(\"b panicked\")),\n    };\n}\n";

},{}],"dFtIC":[function(require,module,exports,__globalThis) {
module.exports = "b resolved first: 2\n";

},{}],"e2KvN":[function(require,module,exports,__globalThis) {
module.exports = "use futures::FutureExt;\nuse std::{thread, time::Duration};\n\nuse async_std::task;\n\n#[async_std::main]\nasync fn main() {\n    let a = task::spawn_blocking(|| {\n        thread::sleep(Duration::from_millis(100));\n        1\n    });\n    let b = task::spawn_blocking(|| {\n        thread::sleep(Duration::from_millis(10));\n        2\n    });\n\n    futures::select! {\n        a = a.fuse() => println!(\"a resolved first: {a}\"),\n        b = b.fuse() => println!(\"b resolved first: {b}\"),\n    };\n}\n";

},{}],"5VX3M":[function(require,module,exports,__globalThis) {
module.exports = "b resolved first: 2\n";

},{}],"772kl":[function(require,module,exports,__globalThis) {
module.exports = "use futures::executor;\nuse std::{thread, time::Duration};\nuse tokio::sync::mpsc;\n\n#[tokio::main]\nasync fn main() {\n    let (tx, rx) = mpsc::channel(1);\n\n    let child = thread::spawn(|| cpu_worker(rx));\n\n    for i in 0..5 {\n        tx.send(i).await.expect(\"Unable to send\");\n        eprintln!(\"Sent {i}\");\n    }\n    drop(tx);\n\n    child.join().expect(\"Thread pool thread panicked\");\n}\n\nfn cpu_worker(mut rx: mpsc::Receiver<u8>) {\n    let pool = rayon::ThreadPoolBuilder::new()\n        .num_threads(2)\n        .build()\n        .expect(\"Unable to create threadpool\");\n\n    pool.scope(|s| {\n        while let Some(i) = executor::block_on(rx.recv()) {\n            s.spawn(move |_| {\n                eprintln!(\"Thread {i} starting\");\n                thread::sleep(Duration::from_secs(1));\n                eprintln!(\"Thread {i} stopping\");\n            })\n        }\n    });\n}\n";

},{}],"ce6eI":[function(require,module,exports,__globalThis) {
module.exports = "Sent 0\nSent 1\nSent 2\nThread 0 starting\nSent 3\nSent 4\nThread 4 starting\nThread 4 stopping\nThread 3 starting\nThread 0 stopping\nThread 1 starting\nThread 3 stopping\nThread 2 starting\nThread 1 stopping\nThread 2 stopping\n";

},{}],"iIhNR":[function(require,module,exports,__globalThis) {
module.exports = "async fn demo(s: &str) -> &str {\n    s.trim()\n}\n\n#[tokio::main]\nasync fn main() {\n    let name = String::from(\" Augustus Gloop \");\n    let name = demo(&name).await;\n    dbg!(name);\n}\n";

},{}],"5aBIx":[function(require,module,exports,__globalThis) {
module.exports = "use tokio::task;\n\nasync fn demo(s: &str) -> &str {\n    s.trim()\n}\n\n#[tokio::main]\nasync fn main() {\n    let name = String::from(\" Augustus Gloop \");\n\n    task::spawn(async {\n        let name = demo(&name).await;\n        dbg!(name);\n    })\n    .await\n    .expect(\"Task panicked\");\n}\n";

},{}],"jwCWA":[function(require,module,exports,__globalThis) {
module.exports = "error[E0373]: async block may outlive the current function, but it borrows `name`, which is\n              owned by the current function\n  --> sharing-data/src/main.rs:12:17\n   |\n12 |     task::spawn(async {\n   |                 ^^^^^ may outlive borrowed value `name`\n13 |         let name = demo(&name).await;\n   |                          ---- `name` is borrowed here\n   |\n   = note: async blocks are not executed immediately and must either take a reference or\n   =       ownership of outside variables they use\nhelp: to force the async block to take ownership of `name` (and any other referenced\n   |  variables), use the `move` keyword\n   |\n12 |     task::spawn(async move {\n   |                       ++++\n\nFor more information about this error, try `rustc --explain E0373`.\nerror: could not compile `sharing-data` (bin \"sharing-data\") due to 1 previous error\n";

},{}],"ecJCh":[function(require,module,exports,__globalThis) {
module.exports = "use tokio::task;\n\nasync fn demo(s: &str) -> &str {\n    s.trim()\n}\n\n#[tokio::main]\nasync fn main() {\n    let name = String::from(\" Augustus Gloop \");\n\n    task::spawn(async move {\n        let name = demo(&name).await;\n        dbg!(name);\n    })\n    .await\n    .expect(\"Task panicked\");\n}\n";

},{}],"iTA2P":[function(require,module,exports,__globalThis) {
module.exports = "use futures::{stream::FuturesUnordered, StreamExt};\nuse tokio::task;\n\n#[tokio::main]\nasync fn main() {\n    let mut scores = Vec::new();\n\n    let tasks: FuturesUnordered<_> = (0..5)\n        .map(|i| {\n            task::spawn(async move {\n                scores.push(i);\n            })\n        })\n        .collect();\n\n    tasks\n        .for_each(|r| async { r.expect(\"a task panicked\") })\n        .await;\n\n    dbg!(scores);\n}\n";

},{}],"bYqgs":[function(require,module,exports,__globalThis) {
module.exports = "error[E0507]: cannot move out of `scores`, a captured variable in an `FnMut` closure\n   --> sharing-mutable-data/src/main.rs:11:25\n    |\n  7 |     let mut scores = Vec::new();\n    |         ----------   ---------- move occurs because `scores` has type `Vec<i32>`, which\n    |         |                       does not implement the `Copy` trait\n    |         |\n    |         captured outer variable\n...\n 10 |         .map(|i| {\n    |              --- captured by this `FnMut` closure\n 11 |             task::spawn(async move {\n    |                         ^^^^^^^^^^ `scores` is moved here\n 12 |                 scores.push(i);\n    |                 ------ variable moved due to use in coroutine\n    |\nhelp: `Fn` and `FnMut` closures require captured values to be able to be consumed multiple\n      times, but `FnOnce` closures may consume them only once\n   --> core/src/iter/traits/iterator.rs:834:12\n    |\n834 |         F: FnMut(Self::Item) -> B,\n    |            ^^^^^^^^^^^^^^^^^^^^^^\nhelp: consider cloning the value before moving it into the closure\n    |\n 11 ~             task::spawn({\n 12 +             let value = scores.clone();\n 13 ~             async move {\n 14 ~                 value.push(i);\n 15 ~             }\n 16 ~             })\n    |\n\nerror[E0382]: use of moved value: `scores`\n  --> sharing-mutable-data/src/main.rs:21:5\n   |\n 7 |     let mut scores = Vec::new();\n   |         ---------- move occurs because `scores` has type `Vec<i32>`, which does not\n   |                    implement the `Copy` trait\n...\n10 |         .map(|i| {\n   |              --- value moved into closure here\n11 |             task::spawn(async move {\n12 |                 scores.push(i);\n   |                 ------ variable moved due to use in closure\n...\n21 |     dbg!(scores);\n   |     ^^^^^^^^^^^^ value used here after move\n\nSome errors have detailed explanations: E0382, E0507.\nFor more information about an error, try `rustc --explain E0382`.\nerror: could not compile `sharing-mutable-data` (bin \"sharing-mutable-data\") due to 2 previous\n       errors\n";

},{}],"8L43z":[function(require,module,exports,__globalThis) {
module.exports = "use futures::{stream::FuturesUnordered, StreamExt};\nuse tokio::task;\n\nuse std::sync::{Arc, Mutex};\n\n#[tokio::main]\nasync fn main() {\n    let scores = Arc::new(Mutex::new(Vec::new()));\n\n    let tasks: FuturesUnordered<_> = (0..5)\n        .map(|i| {\n            let scores = scores.clone();\n            task::spawn(async move {\n                scores.lock().expect(\"mutex poisoned\").push(i);\n            })\n        })\n        .collect();\n\n    tasks\n        .for_each(|r| async { r.expect(\"a task panicked\") })\n        .await;\n\n    dbg!(scores);\n}\n";

},{}],"eN0Pc":[function(require,module,exports,__globalThis) {
module.exports = "use futures::{stream::FuturesUnordered, StreamExt};\nuse tokio::{sync::mpsc, task};\n\n#[tokio::main]\nasync fn main() {\n    let (tx, mut rx) = mpsc::channel(10);\n\n    let appender = task::spawn(async move {\n        let mut scores = Vec::new();\n        while let Some(i) = rx.recv().await {\n            scores.push(i);\n        }\n        scores\n    });\n\n    let tasks = std::iter::repeat_n(tx, 5)\n        .enumerate()\n        .map(|(i, tx)| {\n            task::spawn(async move {\n                tx.send(i).await.expect(\"Unable to send value\");\n            })\n        })\n        .collect::<FuturesUnordered<_>>();\n\n    tasks\n        .for_each(|r| async { r.expect(\"a task panicked\") })\n        .await;\n\n    let scores = appender.await.expect(\"appender panicked\");\n    dbg!(scores);\n}\n";

},{}],"20UY2":[function(require,module,exports,__globalThis) {
module.exports = "[package]\nname = \"exercise-echo-server\"\nversion = \"0.1.0\"\nedition = \"2024\"\n\n# See more keys and their definitions at https://doc.rust-lang.org/cargo/reference/manifest.html\n\n[dependencies]\ntokio = { version = \"1.43.0\", features = [\"full\"] }\n\n[lints]\nworkspace = true\n";

},{}],"4jdX4":[function(require,module,exports,__globalThis) {
module.exports = "use tokio::io::{AsyncReadExt, AsyncWriteExt};\n\n#[tokio::main]\nasync fn main() {\n    let l = tokio::net::TcpListener::bind(\"127.0.0.1:9876\")\n        .await\n        .expect(\"Unable to bind\");\n\n    while let Ok((mut stream, _addr)) = l.accept().await {\n        tokio::spawn(async move {\n            let mut buf = [0u8; 100];\n            loop {\n                let n_bytes = stream.read(&mut buf).await.expect(\"Unable to read\");\n                if n_bytes == 0 {\n                    break;\n                }\n                stream\n                    .write_all(&buf[..n_bytes])\n                    .await\n                    .expect(\"Unable to write\");\n            }\n        });\n    }\n}\n";

},{}],"3REJc":[function(require,module,exports,__globalThis) {
/*@jsxRuntime automatic*/ /*@jsxImportSource react*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "title", ()=>title);
parcelHelpers.export(exports, "default", ()=>MDXContent);
var _jsxRuntime = require("react/jsx-runtime");
var _directives = require("./Directives");
var _changeDeck = require("./ChangeDeck");
var _changeDeckDefault = parcelHelpers.interopDefault(_changeDeck);
var _splash = require("./layout/Splash");
var _splashDefault = parcelHelpers.interopDefault(_splash);
var _skip = require("./layout/Skip");
var _skipDefault = parcelHelpers.interopDefault(_skip);
var _testPattern = require("./TestPattern");
var _testPatternDefault = parcelHelpers.interopDefault(_testPattern);
var _transclude = require("./Transclude");
var _transcludeDefault = parcelHelpers.interopDefault(_transclude);
var _quote = require("./Quote");
var _quoteDefault = parcelHelpers.interopDefault(_quote);
var _typesOfVariables = require("rust:from-dynamic-languages/types-of-variables");
var _typesOfVariablesDefault = parcelHelpers.interopDefault(_typesOfVariables);
var _typesOfVariables1 = require("stderr:from-dynamic-languages/types-of-variables");
var _typesOfVariablesDefault1 = parcelHelpers.interopDefault(_typesOfVariables1);
var _singleTypeEnum = require("rust:from-dynamic-languages/single-type-enum");
var _singleTypeEnumDefault = parcelHelpers.interopDefault(_singleTypeEnum);
var _singleTypeTraitObject = require("rust:from-dynamic-languages/single-type-trait-object");
var _singleTypeTraitObjectDefault = parcelHelpers.interopDefault(_singleTypeTraitObject);
var _exerciseHeterogenousCollection = require("rust:from-dynamic-languages/exercise-heterogenous-collection");
var _exerciseHeterogenousCollectionDefault = parcelHelpers.interopDefault(_exerciseHeterogenousCollection);
var _exerciseHeterogenousCollectionRev1 = require("rust:from-dynamic-languages/exercise-heterogenous-collection?rev=1");
var _exerciseHeterogenousCollectionRev1Default = parcelHelpers.interopDefault(_exerciseHeterogenousCollectionRev1);
var _reusingCode = require("rust:from-dynamic-languages/reusing-code");
var _reusingCodeDefault = parcelHelpers.interopDefault(_reusingCode);
var _reusingCodeRev1 = require("rust:from-dynamic-languages/reusing-code?rev=1");
var _reusingCodeRev1Default = parcelHelpers.interopDefault(_reusingCodeRev1);
var _enumDynamicDispatch = require("rust:from-dynamic-languages/enum-dynamic-dispatch");
var _enumDynamicDispatchDefault = parcelHelpers.interopDefault(_enumDynamicDispatch);
var _notYetWritten = require("rust:from-dynamic-languages/not-yet-written");
var _notYetWrittenDefault = parcelHelpers.interopDefault(_notYetWritten);
var _notYetWritten1 = require("stderr:from-dynamic-languages/not-yet-written");
var _notYetWrittenDefault1 = parcelHelpers.interopDefault(_notYetWritten1);
var _notYetWrittenRev1 = require("rust:from-dynamic-languages/not-yet-written?rev=1");
var _notYetWrittenRev1Default = parcelHelpers.interopDefault(_notYetWrittenRev1);
var _serialization = require("rust:from-dynamic-languages/serialization");
var _serializationDefault = parcelHelpers.interopDefault(_serialization);
var _serialization1 = require("stderr:from-dynamic-languages/serialization");
var _serializationDefault1 = parcelHelpers.interopDefault(_serialization1);
var _serializationRev1 = require("rust:from-dynamic-languages/serialization?rev=1");
var _serializationRev1Default = parcelHelpers.interopDefault(_serializationRev1);
var _macrosDecl = require("rust:from-dynamic-languages/macros-decl");
var _macrosDeclDefault = parcelHelpers.interopDefault(_macrosDecl);
var _macrosProc = require("rust:from-dynamic-languages/macros-proc");
var _macrosProcDefault = parcelHelpers.interopDefault(_macrosProc);
var _stackVsHeap = require("rust:from-dynamic-languages/stack-vs-heap");
var _stackVsHeapDefault = parcelHelpers.interopDefault(_stackVsHeap);
var _unsizedValues = require("rust:from-dynamic-languages/unsized-values");
var _unsizedValuesDefault = parcelHelpers.interopDefault(_unsizedValues);
var _unsizedValues1 = require("stderr:from-dynamic-languages/unsized-values");
var _unsizedValuesDefault1 = parcelHelpers.interopDefault(_unsizedValues1);
var _overrideReuseDefaultMethod = require("rust:from-dynamic-languages/override-reuse-default-method");
var _overrideReuseDefaultMethodDefault = parcelHelpers.interopDefault(_overrideReuseDefaultMethod);
var _overrideReuseDefaultMethodRev1 = require("rust:from-dynamic-languages/override-reuse-default-method?rev=1");
var _overrideReuseDefaultMethodRev1Default = parcelHelpers.interopDefault(_overrideReuseDefaultMethodRev1);
const title = "Coming to Rust from dynamic languages";
function _createMdxContent(props) {
    const _components = {
        a: "a",
        code: "code",
        em: "em",
        h1: "h1",
        h2: "h2",
        h3: "h3",
        hr: "hr",
        li: "li",
        p: "p",
        pre: "pre",
        ul: "ul",
        ...props.components
    }, { SplitSlides } = _components;
    if (!SplitSlides) _missingMdxReference("SplitSlides", true);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SplitSlides, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _testPatternDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Coming to Rust ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                    " from dynamic languages"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Statically vs dynamically typed"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "What does this mean to people?"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Statically typed"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Types are assigned at compile time, based on the source code"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Dynamically typed"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Types are assigned at run time, based on the value"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Most languages aren't completely in one side or the other; Rust has some dynamic abilities"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "There's also strongly vs. weakly typed"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Types of variables"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "JavaScript"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-javascript",
                    children: "const name = Math.random() < 0.5 ? \"Vivian\" : 42;\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "What is the type of ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "name"
                            }),
                            "? \"It depends\""
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Rust"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _typesOfVariablesDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _typesOfVariablesDefault1.default),
                focusOn: "1+8"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Can't say \"it depends\" in Rust"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Rust variables must have a single type"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Enums"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _singleTypeEnumDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "The type of ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "name"
                            }),
                            " is now the ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Name"
                            }),
                            " enum. Enum variants are not their own type."
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Enums know which variant they are"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Great when you have a fixed set of choices"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Rust variables must have a single type"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Trait objects"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _singleTypeTraitObjectDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Explicit type on the variable, ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Box::new"
                            }),
                            " on each instance"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Boxed like this requires heap allocation"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Great when you have an unbounded set of choices"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Exercise"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Create a vector \"containing multiple types\"",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "e.g. an integer, a boolean, and a string"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Print out the vector",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "\n",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                                                src: (0, _exerciseHeterogenousCollectionDefault.default),
                                                focusOn: "4+1",
                                                copyAllCode: false
                                            }),
                                            "\n"
                                        ]
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Bonus"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Use an enum instead of a trait object or vice versa"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One answer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _exerciseHeterogenousCollectionDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _skipDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Another answer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _exerciseHeterogenousCollectionRev1Default.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Reusing code"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "JavaScript"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-javascript",
                    children: "class Dog {\n  make_noise() {\n    console.log(\"woof\");\n  }\n}\n\nclass Cat {\n  make_noise() {\n    console.log(\"meow\");\n  }\n}\n\nconst hug = (animal) => {\n  animal.make_noise();\n};\n\nhug(new Dog());\nhug(new Cat());\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Commonly called duck-typing"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Reusing code"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _reusingCodeDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Can immediately see that it's bigger"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Reusing code"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _reusingCodeDefault.default),
                emphasize: "1,2,3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Define a trait"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Reusing code"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _reusingCodeDefault.default),
                emphasize: "6,7,8,9,10,11,13,14,15,16,17,18"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Implement the trait"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Reusing code"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _reusingCodeDefault.default),
                emphasize: "19[15+11]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Restrict arguments to the function via generics"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Choosing how code is generated"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Static dispatch"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _reusingCodeDefault.default),
                focusOn: "19+8",
                emphasize: "1[15+11],6[8+3],7[8+3]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Compiler generates code specific to each concrete type passed in"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Can use that information to highly optimize"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Dynamic dispatch"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _reusingCodeRev1Default.default),
                focusOn: "19+8",
                emphasize: "1[15+11],6[8+4],7[8+4]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Still a trait object, but behind a reference here, not a ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Box"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Compiler generates one function"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Can't be optimized as much"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Reduces total amount of code generated"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Enums are dynamic dispatch too"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _enumDynamicDispatchDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "The ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "match"
                            }),
                            " checks the enum variant and calls the appropriate branch"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Can be automated with something like ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                                href: "https://docs.rs/enum_dispatch/",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                    children: "enum_dispatch"
                                })
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Limits of trait objects"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Dyn compatibility / object safety"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Cannot require that ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Self"
                            }),
                            " be ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Sized"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "e.g. ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "Clone"
                                            })
                                        ]
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "This includes taking ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "self"
                                            }),
                                            " by value"
                                        ]
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Cannot have an associated function",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "e.g. ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "Default"
                                            })
                                        ]
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Cannot use a generic as an argument or return value",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "e.g. ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "Hash"
                                            })
                                        ]
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "This includes ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "Self"
                                            })
                                        ]
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Not-yet-written code"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "JavaScript"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-javascript",
                    children: "class Animal {\n  shouldFrolic() {\n    return false; // FIXME: check the frolyq API\n  }\n\n  dance() {\n    if (this.shouldFrolic()) {\n      this.frolic();\n    }\n  }\n}\n\nnew Animal().dance();\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Not-yet-written code"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Rust"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _notYetWrittenDefault.default),
                focusOn: "1+3,6+14"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _notYetWrittenDefault1.default),
                focusOn: "12+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Functions without bodies"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _notYetWrittenDefault.default),
                focusOn: "1+4,15+1"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _notYetWrittenDefault1.default),
                focusOn: "1+11"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Use ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "todo!"
                    }),
                    " or ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "unimplemented!"
                    }),
                    " for placeholder code"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _notYetWrittenRev1Default.default),
                focusOn: "1+21",
                emphasize: "5,9"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Introspection / Reflection"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "The ability to view information about the system",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Types / methods"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Memory usage, open files"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "What source file defined some piece of code"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "The ability to create or modify that information",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "New types or methods"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Decorators, loggers, contracts"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Serialization"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "JavaScript"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-javascript",
                    children: "class Animal {\n  name = \"Leo\";\n  age = 3;\n}\n\nconsole.log(JSON.stringify(new Animal()));\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-none",
                    children: "{\"name\":\"Leo\",\"age\":3}\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Serialization"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Rust"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _serializationDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _serializationDefault1.default),
                focusOn: "1+7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Code generation via macros"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _serializationRev1Default.default),
                emphasize: "1,3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "We've already seen this for ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "derive(Debug)"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "This steps through the struct's fields and serializes each in turn"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Macros"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Run by the compiler while your code is compiling"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Two kinds",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Declarative macros"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Procedural macros"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Declarative macros"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _macrosDeclDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Written inside of your code"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Can be used to create new control flow based on existing"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "e.g. the ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "try"
                            }),
                            " macro"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Smarter than C macros, probably not quite as powerful as Lisp macros"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Procedural macros"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _macrosProcDefault.default),
                focusOn: "5+7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Written in a separate crate"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Parses the related Rust code"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Generates additional or replacement code"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Code generation via build scripts"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Runs before your code is compiled"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Separate Rust binary"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Can interact with just about anything",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Cargo"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Filesystem"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Network"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "C compiler"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Systems languages give you choices and control"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Static vs dynamic dispatch"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Details of representations"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Location of values"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "This also means that you have to ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.em, {
                                children: "make"
                            }),
                            " those choices"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Value representations"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "It can be important how many bytes a value takes up",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "u8"
                                            }),
                                            " / ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "u16"
                                            }),
                                            " / ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "u32"
                                            }),
                                            " / ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "u64"
                                            }),
                                            " / ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "u128"
                                            })
                                        ]
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "It can be important what kinds of values it can hold",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "u32"
                                            }),
                                            " / ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "i32"
                                            }),
                                            " / ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "f32"
                                            })
                                        ]
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "It can be important how a value is stored in memory",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Interfacing with hardware registers"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "The stack vs. the heap"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Stack",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Efficient access patterns"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Good cache locality"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Requires static knowledge of values"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Heap",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Access patterns can vary widely"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Cache locality can vary widely"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Allows very dynamic allocation"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "LinkedList"
                            }),
                            " and ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Vec"
                            }),
                            " both use the heap, but linked lists are terrible"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "The stack vs. the heap"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _stackVsHeapDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "The stack vs. the heap"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _stackVsHeapDefault.default),
                emphasize: "2[32+15]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: "At least 13 bytes are on the heap"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "The stack vs. the heap"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _stackVsHeapDefault.default),
                emphasize: "2[8+8]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: "24 bytes are on the stack"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "For 64-bit architecture; 12 on 32-bit"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Can use ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "mem::size_of"
                            }),
                            " to find this out"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Everything on the stack has a known size"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _unsizedValuesDefault.default),
                focusOn: "1+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _unsizedValuesDefault1.default),
                focusOn: "1+14"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Object-oriented design"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Rust is a great object-oriented language"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Depending on your definitions of \"object\" and \"object-oriented\""
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Many of the entries from ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.em, {
                                children: "Design Patterns"
                            }),
                            " apply"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\"fun\" facts",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "patterns basically exist to work around limitations/shortcomings"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "No real agreed on definition of what object-oriented means",
                                            "\n",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                                children: [
                                                    "\n",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                                        children: "I prefer Alan Kay's definition of message passing and cells"
                                                    }),
                                                    "\n"
                                                ]
                                            }),
                                            "\n"
                                        ]
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Rust does not have inheritance"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _quoteDefault.default), {
                caption: "Design Patterns",
                children: "Favor composition over inheritance"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Really easy to follow this advice when there is no inheritance"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Unfortunately, there's not great delegation syntax either"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Overriding and reusing a parent method"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-javascript",
                    children: "class Calculations {\n  log_info() {\n    console.log(\">>> \" + this.required() + \" <<<\");\n  }\n}\n\nclass Example extends Calculations {\n  required() {\n    return 42;\n  }\n\n  log_info() {\n    console.log(\"More info\");\n    super.log_info();\n  }\n}\n\nnew Example().log_info();\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Overriding and reusing a default trait method"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _overrideReuseDefaultMethodDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Overriding and reusing a provided trait method"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _overrideReuseDefaultMethodRev1Default.default),
                emphasize: "5,9,10,11,22"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "No amazing solution here; just extract a function"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Likely better to reorganize the code"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                    href: "https://docs.google.com/forms/d/e/1FAIpQLSfXEFvRSmuh3bd27ofZN27n5TyyR_7Qk9v-MhT9MmJzFK7bKQ/viewform?usp=publish-editor",
                    children: "Quiz"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _changeDeckDefault.default), {
                    deck: "overview",
                    children: "Return"
                })
            })
        ]
    });
}
function MDXContent(props = {}) {
    const { wrapper: MDXLayout } = props.components || {};
    return MDXLayout ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(MDXLayout, {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_createMdxContent, {
            ...props
        })
    }) : _createMdxContent(props);
}
function _missingMdxReference(id, component, place) {
    throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it." + (place ? "\nIt\u2019s referenced in your code at `" + place + "`" : ""));
}

},{"react/jsx-runtime":"afIHK","./Directives":"6Yemz","./ChangeDeck":"29Jlq","./layout/Splash":"1mDy7","./layout/Skip":"1ziV3","./TestPattern":"g0BPT","./Transclude":"fUgcm","./Quote":"7JX1G","rust:from-dynamic-languages/types-of-variables":"6td6a","stderr:from-dynamic-languages/types-of-variables":"feiSy","rust:from-dynamic-languages/single-type-enum":"437gV","rust:from-dynamic-languages/single-type-trait-object":"kfajs","rust:from-dynamic-languages/exercise-heterogenous-collection":"k85R7","rust:from-dynamic-languages/exercise-heterogenous-collection?rev=1":"eZYW1","rust:from-dynamic-languages/reusing-code":"4mku8","rust:from-dynamic-languages/reusing-code?rev=1":"6pvbf","rust:from-dynamic-languages/enum-dynamic-dispatch":"efOoq","rust:from-dynamic-languages/not-yet-written":"7yVi7","stderr:from-dynamic-languages/not-yet-written":"3sXhI","rust:from-dynamic-languages/not-yet-written?rev=1":"0rwzD","rust:from-dynamic-languages/serialization":"emU5L","stderr:from-dynamic-languages/serialization":"goXSK","rust:from-dynamic-languages/serialization?rev=1":"cYcDr","rust:from-dynamic-languages/macros-decl":"irQhD","rust:from-dynamic-languages/macros-proc":"iizxi","rust:from-dynamic-languages/stack-vs-heap":"7WuPk","rust:from-dynamic-languages/unsized-values":"dMlsm","stderr:from-dynamic-languages/unsized-values":"clSxn","rust:from-dynamic-languages/override-reuse-default-method":"82lFR","rust:from-dynamic-languages/override-reuse-default-method?rev=1":"45ucQ","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"6td6a":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let name = if rand::random() { \"Vivian\" } else { 42 };\n}\n";

},{}],"feiSy":[function(require,module,exports,__globalThis) {
module.exports = "error[E0308]: `if` and `else` have incompatible types\n --> types-of-variables/src/main.rs:2:54\n  |\n2 |     let name = if rand::random() { \"Vivian\" } else { 42 };\n  |                                    --------          ^^ expected `&str`, found integer\n  |                                    |\n  |                                    expected because of this\n\nFor more information about this error, try `rustc --explain E0308`.\nerror: could not compile `types-of-variables` (bin \"types-of-variables\") due to 1 previous\n       error\n";

},{}],"437gV":[function(require,module,exports,__globalThis) {
module.exports = "#[derive(Debug)]\nenum Name {\n    String(&'static str),\n    Number(i32),\n}\n\nfn main() {\n    let name = if rand::random() {\n        Name::String(\"Vivian\")\n    } else {\n        Name::Number(42)\n    };\n}\n";

},{}],"kfajs":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let name: Box<dyn std::fmt::Debug> = if rand::random() {\n        Box::new(\"Vivian\")\n    } else {\n        Box::new(42)\n    };\n}\n";

},{}],"k85R7":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let items: Vec<Box<dyn std::fmt::Debug>> =\n        vec![Box::new(42), Box::new(false), Box::new(\"hello\")];\n    println!(\"{items:?}\");\n}\n";

},{}],"eZYW1":[function(require,module,exports,__globalThis) {
module.exports = "#[derive(Debug)]\nenum Item {\n    Number(i32),\n    Bool(bool),\n    String(&'static str),\n}\n\nfn main() {\n    let items = vec![Item::Number(42), Item::Bool(false), Item::String(\"hello\")];\n    println!(\"{items:?}\");\n}\n";

},{}],"4mku8":[function(require,module,exports,__globalThis) {
module.exports = "trait Noiser {\n    fn make_noise(&self);\n}\n\nstruct Dog;\nimpl Noiser for Dog {\n    fn make_noise(&self) {\n        println!(\"woof\");\n    }\n}\n\nstruct Cat;\nimpl Noiser for Cat {\n    fn make_noise(&self) {\n        println!(\"meow\");\n    }\n}\n\nfn hug(animal: impl Noiser) {\n    animal.make_noise();\n}\n\nfn main() {\n    hug(Dog);\n    hug(Cat);\n}\n";

},{}],"6pvbf":[function(require,module,exports,__globalThis) {
module.exports = "trait Noiser {\n    fn make_noise(&self);\n}\n\nstruct Dog;\nimpl Noiser for Dog {\n    fn make_noise(&self) {\n        println!(\"woof\");\n    }\n}\n\nstruct Cat;\nimpl Noiser for Cat {\n    fn make_noise(&self) {\n        println!(\"meow\");\n    }\n}\n\nfn hug(animal: &dyn Noiser) {\n    animal.make_noise();\n}\n\nfn main() {\n    hug(&Dog);\n    hug(&Cat);\n}\n";

},{}],"efOoq":[function(require,module,exports,__globalThis) {
module.exports = "enum Animal {\n    Dog,\n    Cat,\n}\n\nimpl Animal {\n    fn make_noise(&self) {\n        match self {\n            Self::Dog => println!(\"woof\"),\n            Self::Cat => println!(\"meow\"),\n        }\n    }\n}\n\nfn hug(animal: Animal) {\n    animal.make_noise();\n}\n\nfn main() {\n    hug(Animal::Dog);\n    hug(Animal::Cat);\n}\n";

},{}],"7yVi7":[function(require,module,exports,__globalThis) {
module.exports = "struct Animal;\n\nimpl Animal {\n    fn zoo() -> Vec<Animal> {}\n\n    fn should_frolic(&self) -> bool {\n        false // FIXME: check the frolyq API\n    }\n\n    fn dance(&self) {\n        if self.should_frolic() {\n            self.frolic();\n        }\n    }\n}\n\nfn main() {\n    Animal.dance();\n}\n";

},{}],"3sXhI":[function(require,module,exports,__globalThis) {
module.exports = "error[E0308]: mismatched types\n --> not-yet-written/src/main.rs:5:17\n  |\n5 |     fn zoo() -> Vec<Animal> {}\n  |        ---      ^^^^^^^^^^^ expected `Vec<Animal>`, found `()`\n  |        |\n  |        implicitly returns `()` as its body has no tail or `return` expression\n  |\n  = note: expected struct `Vec<Animal>`\n          found unit type `()`\n\nerror[E0599]: no method named `frolic` found for reference `&Animal` in the current scope\n  --> not-yet-written/src/main.rs:13:18\n   |\n13 |             self.frolic();\n   |                  ^^^^^^ method not found in `&Animal`\n\nSome errors have detailed explanations: E0308, E0599.\nFor more information about an error, try `rustc --explain E0308`.\nerror: could not compile `not-yet-written` (bin \"not-yet-written\") due to 2 previous errors\n";

},{}],"0rwzD":[function(require,module,exports,__globalThis) {
module.exports = "struct Animal;\n\nimpl Animal {\n    fn zoo() -> Vec<Animal> {\n        todo!(\"Build a zoo\")\n    }\n\n    fn frolic(&self) {\n        unimplemented!(\"Don't know how to frolic\")\n    }\n\n    fn should_frolic(&self) -> bool {\n        false // FIXME: check the frolyq API\n    }\n\n    fn dance(&self) {\n        if self.should_frolic() {\n            self.frolic();\n        }\n    }\n}\n\nfn main() {\n    Animal.dance();\n}\n";

},{}],"emU5L":[function(require,module,exports,__globalThis) {
module.exports = "struct Animal {\n    name: &'static str,\n    age: i32,\n}\n\nimpl Default for Animal {\n    fn default() -> Self {\n        Self {\n            name: \"Leo\",\n            age: 3,\n        }\n    }\n}\n\nfn main() {\n    serde_json::to_string(&Animal::default()).expect(\"Unable to serialize\");\n}\n";

},{}],"goXSK":[function(require,module,exports,__globalThis) {
module.exports = "error[E0277]: the trait bound `Animal: serde::Serialize` is not satisfied\n    --> serialization/src/main.rs:20:27\n     |\n  20 |     serde_json::to_string(&Animal::default()).expect(\"Unable to serialize\");\n     |     --------------------- ^^^^^^^^^^^^^^^^^^ unsatisfied trait bound\n     |     |\n     |     required by a bound introduced by this call\n     |\nhelp: the trait `serde_core::ser::Serialize` is not implemented for `Animal`\n    --> serialization/src/main.rs:5:1\n     |\n   5 | struct Animal {\n     | ^^^^^^^^^^^^^\n     = note: for local types consider adding `#[derive(serde::Serialize)]` to your `Animal`\n     =       type\n     = note: for types from other crates check whether the crate offers a `serde` feature flag\n     = help: the following other types implement trait `serde_core::ser::Serialize`:\n               &'a T\n               &'a mut T\n               ()\n               (T,)\n               (T0, T1)\n               (T0, T1, T2)\n               (T0, T1, T2, T3)\n               (T0, T1, T2, T3, T4)\n             and 129 others\nnote: required by a bound in `serde_json::to_string`\n    --> serde_json-1.0.149/src/ser.rs:2247:17\n     |\n2245 | pub fn to_string<T>(value: &T) -> Result<String>\n     |        --------- required by a bound in this function\n2246 | where\n2247 |     T: ?Sized + Serialize,\n     |                 ^^^^^^^^^ required by this bound in `to_string`\n\nFor more information about this error, try `rustc --explain E0277`.\nerror: could not compile `serialization` (bin \"serialization\") due to 1 previous error\n";

},{}],"cYcDr":[function(require,module,exports,__globalThis) {
module.exports = "use serde::Serialize;\n\n#[derive(Serialize)]\nstruct Animal {\n    name: &'static str,\n    age: i32,\n}\n\nimpl Default for Animal {\n    fn default() -> Self {\n        Self {\n            name: \"Leo\",\n            age: 3,\n        }\n    }\n}\n\nfn main() {\n    serde_json::to_string(&Animal::default()).expect(\"Unable to serialize\");\n}\n";

},{}],"irQhD":[function(require,module,exports,__globalThis) {
module.exports = "macro_rules! do_twice {\n    ($thing_to_do: expr) => {\n        $thing_to_do;\n        $thing_to_do;\n    };\n}\n\nfn main() {\n    do_twice!(println!(\"Hi\"));\n}\n";

},{}],"iizxi":[function(require,module,exports,__globalThis) {
module.exports = "use println as my_custom_functional_macro;\nuse tracing::instrument as my_custom_attribute;\nuse Debug as MyCustomDerive;\n\n#[derive(MyCustomDerive)]\nstruct Foo;\n\n#[my_custom_attribute]\nfn main() {\n    my_custom_functional_macro!();\n}\n";

},{}],"7WuPk":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let greeting = String::from(\"Hello, world!\");\n}\n";

},{}],"dMlsm":[function(require,module,exports,__globalThis) {
module.exports = "fn an_unsized_value(items: [u8]) -> u8 {\n    items.iter().sum()\n}\n\nfn main() {}\n";

},{}],"clSxn":[function(require,module,exports,__globalThis) {
module.exports = "error[E0277]: the size for values of type `[u8]` cannot be known at compilation time\n --> unsized-values/src/main.rs:1:28\n  |\n1 | fn an_unsized_value(items: [u8]) -> u8 {\n  |                            ^^^^ doesn't have a size known at compile-time\n  |\n  = help: the trait `Sized` is not implemented for `[u8]`\n  = help: unsized fn params are gated as an unstable feature\nhelp: function arguments must have a statically known size, borrowed slices always have a\n  |   known size\n  |\n1 | fn an_unsized_value(items: &[u8]) -> u8 {\n  |                            +\n\nFor more information about this error, try `rustc --explain E0277`.\nerror: could not compile `unsized-values` (bin \"unsized-values\") due to 1 previous error\n";

},{}],"82lFR":[function(require,module,exports,__globalThis) {
module.exports = "trait Calculations {\n    fn required(&self) -> u8;\n\n    fn log_info(&self) {\n        println!(\">>> {} <<<\", self.required())\n    }\n}\n\nstruct Example;\n\nimpl Calculations for Example {\n    fn required(&self) -> u8 {\n        42\n    }\n\n    fn log_info(&self) {\n        println!(\"More info\");\n        // How do we print the fancy text now?\n    }\n}\n\nfn main() {\n    Example.log_info();\n}\n";

},{}],"45ucQ":[function(require,module,exports,__globalThis) {
module.exports = "trait Calculations {\n    fn required(&self) -> u8;\n\n    fn log_info(&self) {\n        log_info(self)\n    }\n}\n\nfn log_info(c: &(impl Calculations + ?Sized)) {\n    println!(\">>> {} <<<\", c.required())\n}\n\nstruct Example;\n\nimpl Calculations for Example {\n    fn required(&self) -> u8 {\n        42\n    }\n\n    fn log_info(&self) {\n        println!(\"More info\");\n        log_info(self);\n    }\n}\n\nfn main() {\n    Example.log_info();\n}\n";

},{}],"gQf7s":[function(require,module,exports,__globalThis) {
/*@jsxRuntime automatic*/ /*@jsxImportSource react*/ /*TODO: Should we show destructuring (in param, even)?*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "title", ()=>title);
parcelHelpers.export(exports, "default", ()=>MDXContent);
var _jsxRuntime = require("react/jsx-runtime");
var _directives = require("./Directives");
var _changeDeck = require("./ChangeDeck");
var _changeDeckDefault = parcelHelpers.interopDefault(_changeDeck);
var _splash = require("./layout/Splash");
var _splashDefault = parcelHelpers.interopDefault(_splash);
var _testPattern = require("./TestPattern");
var _testPatternDefault = parcelHelpers.interopDefault(_testPattern);
var _transclude = require("./Transclude");
var _transcludeDefault = parcelHelpers.interopDefault(_transclude);
var _typeTheory = require("rust:reliable-code-using-types/type-theory");
var _typeTheoryDefault = parcelHelpers.interopDefault(_typeTheory);
var _newtypes = require("rust:reliable-code-using-types/newtypes");
var _newtypesDefault = parcelHelpers.interopDefault(_newtypes);
var _newtypesRev1 = require("rust:reliable-code-using-types/newtypes?rev=1");
var _newtypesRev1Default = parcelHelpers.interopDefault(_newtypesRev1);
var _newtypesRev11 = require("stderr:reliable-code-using-types/newtypes?rev=1");
var _newtypesRev1Default1 = parcelHelpers.interopDefault(_newtypesRev11);
var _newtypesRev2 = require("rust:reliable-code-using-types/newtypes?rev=2");
var _newtypesRev2Default = parcelHelpers.interopDefault(_newtypesRev2);
var _constrainedData = require("rust:reliable-code-using-types/constrained-data");
var _constrainedDataDefault = parcelHelpers.interopDefault(_constrainedData);
var _constrainedDataRev1 = require("rust:reliable-code-using-types/constrained-data?rev=1");
var _constrainedDataRev1Default = parcelHelpers.interopDefault(_constrainedDataRev1);
var _constrainedDataRev11 = require("stderr:reliable-code-using-types/constrained-data?rev=1");
var _constrainedDataRev1Default1 = parcelHelpers.interopDefault(_constrainedDataRev11);
var _newtypeDownsides = require("rust:reliable-code-using-types/newtype-downsides");
var _newtypeDownsidesDefault = parcelHelpers.interopDefault(_newtypeDownsides);
var _newtypeDownsides1 = require("stderr:reliable-code-using-types/newtype-downsides");
var _newtypeDownsidesDefault1 = parcelHelpers.interopDefault(_newtypeDownsides1);
var _newtypeDownsidesRev1 = require("rust:reliable-code-using-types/newtype-downsides?rev=1");
var _newtypeDownsidesRev1Default = parcelHelpers.interopDefault(_newtypeDownsidesRev1);
var _derefAntipattern = require("rust:reliable-code-using-types/deref-antipattern");
var _derefAntipatternDefault = parcelHelpers.interopDefault(_derefAntipattern);
var _constrainByInclusion = require("rust:reliable-code-using-types/constrain-by-inclusion");
var _constrainByInclusionDefault = parcelHelpers.interopDefault(_constrainByInclusion);
var _constrainByInclusionRev1 = require("rust:reliable-code-using-types/constrain-by-inclusion?rev=1");
var _constrainByInclusionRev1Default = parcelHelpers.interopDefault(_constrainByInclusionRev1);
var _enumWithData = require("rust:reliable-code-using-types/enum-with-data");
var _enumWithDataDefault = parcelHelpers.interopDefault(_enumWithData);
var _enumWithDataRev1 = require("rust:reliable-code-using-types/enum-with-data?rev=1");
var _enumWithDataRev1Default = parcelHelpers.interopDefault(_enumWithDataRev1);
var _enumWithDataRev11 = require("stderr:reliable-code-using-types/enum-with-data?rev=1");
var _enumWithDataRev1Default1 = parcelHelpers.interopDefault(_enumWithDataRev11);
var _typestate = require("rust:reliable-code-using-types/typestate");
var _typestateDefault = parcelHelpers.interopDefault(_typestate);
var _typestate1 = require("stderr:reliable-code-using-types/typestate");
var _typestateDefault1 = parcelHelpers.interopDefault(_typestate1);
var _exerciseVendingMachine = require("rust:reliable-code-using-types/exercise-vending-machine");
var _exerciseVendingMachineDefault = parcelHelpers.interopDefault(_exerciseVendingMachine);
var _patternMatchingPitfalls = require("rust:reliable-code-using-types/pattern-matching-pitfalls");
var _patternMatchingPitfallsDefault = parcelHelpers.interopDefault(_patternMatchingPitfalls);
var _patternMatchingPitfallsRev1 = require("rust:reliable-code-using-types/pattern-matching-pitfalls?rev=1");
var _patternMatchingPitfallsRev1Default = parcelHelpers.interopDefault(_patternMatchingPitfallsRev1);
var _libRs = require("rust:reliable-code-using-types/non-exhaustive-matching/my-library/src/lib.rs");
var _libRsDefault = parcelHelpers.interopDefault(_libRs);
var _nonExhaustiveMatching = require("rust:reliable-code-using-types/non-exhaustive-matching");
var _nonExhaustiveMatchingDefault = parcelHelpers.interopDefault(_nonExhaustiveMatching);
var _nonExhaustiveMatching1 = require("stderr:reliable-code-using-types/non-exhaustive-matching");
var _nonExhaustiveMatchingDefault1 = parcelHelpers.interopDefault(_nonExhaustiveMatching1);
var _pseudoRefinementTypes = require("rust:reliable-code-using-types/pseudo-refinement-types");
var _pseudoRefinementTypesDefault = parcelHelpers.interopDefault(_pseudoRefinementTypes);
var _pseudoRefinementTypesRev1 = require("rust:reliable-code-using-types/pseudo-refinement-types?rev=1");
var _pseudoRefinementTypesRev1Default = parcelHelpers.interopDefault(_pseudoRefinementTypesRev1);
var _pseudoDependentTypes = require("rust:reliable-code-using-types/pseudo-dependent-types");
var _pseudoDependentTypesDefault = parcelHelpers.interopDefault(_pseudoDependentTypes);
var _pseudoDependentTypesRev1 = require("rust:reliable-code-using-types/pseudo-dependent-types?rev=1");
var _pseudoDependentTypesRev1Default = parcelHelpers.interopDefault(_pseudoDependentTypesRev1);
const title = "Using types to write reliable code";
function _createMdxContent(props) {
    const _components = {
        a: "a",
        code: "code",
        em: "em",
        h1: "h1",
        h2: "h2",
        h3: "h3",
        hr: "hr",
        li: "li",
        p: "p",
        pre: "pre",
        ul: "ul",
        ...props.components
    }, { SplitSlides } = _components;
    if (!SplitSlides) _missingMdxReference("SplitSlides", true);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SplitSlides, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _testPatternDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Using types to write",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                    "reliable code"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "The point of types"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Label what you have"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Constrain what you can do with it"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Offload bookkeeping to the compiler"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Verify more at compile time instead of run time"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Doesn't usually remove all runtime cost"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Fancy type theory terms"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "struct"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "\"Product type\""
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Each field multiplies the number of possible states"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                                src: (0, _typeTheoryDefault.default),
                                focusOn: "1+4"
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "enum"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "\"Sum type\""
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Each variant increments the number of possible states"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                                src: (0, _typeTheoryDefault.default),
                                focusOn: "6+4"
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Use these tools to get as narrow an outline around your domain as possible"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Everything looks the same"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _newtypesDefault.default),
                focusOn: "1+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "\"primitive obsession\""
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _newtypesDefault.default),
                focusOn: "9"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Oops, just lost a bunch of money!"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Newtypes"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Give a new name to existing types"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Do not forward any abilities of the wrapped type"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Can be used to denote restrictions or constraints"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Do not take any more space than the underlying type"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Affected by visibility"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Rust has a nominal type system, not structural"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Newtypes"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _newtypesRev1Default.default),
                focusOn: "1,3+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _newtypesRev1Default.default),
                focusOn: "13+1"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Newtypes"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _newtypesRev1Default.default),
                focusOn: "1,3+5",
                emphasize: "1,2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _newtypesRev1Default.default),
                focusOn: "13+1"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Newtypes"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _newtypesRev1Default.default),
                focusOn: "1,3+5",
                emphasize: "4[24+9],4[39+9],4[58+6]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _newtypesRev1Default.default),
                focusOn: "13+1"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Newtypes"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _newtypesRev1Default.default),
                focusOn: "1,3+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _newtypesRev1Default.default),
                focusOn: "13+1",
                emphasize: "1[27+7],1[37+1]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Newtypes"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _newtypesRev1Default.default),
                focusOn: "1,3+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _newtypesRev1Default.default),
                focusOn: "13+1"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Newtypes"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _newtypesRev1Default1.default),
                focusOn: "1+18"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "What future problem awaits after we fix the argument order?"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "We need to go deeper"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _newtypesRev2Default.default),
                focusOn: "1,3+3,7+6"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _newtypesRev2Default.default),
                focusOn: "17"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "We need to go deeper"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _newtypesRev2Default.default),
                focusOn: "1,3+3,7+6",
                emphasize: "4,5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _newtypesRev2Default.default),
                focusOn: "17"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "We need to go deeper"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _newtypesRev2Default.default),
                focusOn: "1,3+3,7+6",
                emphasize: "7[24+4],7[34+2]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _newtypesRev2Default.default),
                focusOn: "17"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "We need to go deeper"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _newtypesRev2Default.default),
                focusOn: "1,3+3,7+6"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _newtypesRev2Default.default),
                focusOn: "17",
                emphasize: "1[15+5],1[30+1],1[33+3],1[42+1]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Rust does not have named arguments at call time; this is one possible replacement"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Another is just a new struct."
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Newtypes for constrained data"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _constrainedDataDefault.default),
                focusOn: "1+11"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "We provide a constructor that validates the constraints"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Could use a ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Result"
                            }),
                            " if we wanted to be informative about why"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "No function that accepts an ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Email"
                            }),
                            " needs to perform any further checks"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Privacy and visibility matter"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _constrainedDataDefault.default),
                focusOn: "1+11"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _constrainedDataDefault.default),
                focusOn: "13+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Use modules to enforce visibility"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _constrainedDataRev1Default.default),
                focusOn: "1,4+12"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Remember that you are guarding against other programmers"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "It's worth being paranoid in a public library, less in private library, less in application"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Use modules to enforce visibility"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _constrainedDataRev1Default.default),
                focusOn: "17+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _constrainedDataRev1Default1.default),
                focusOn: "1+15"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Downsides of newtypes"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _newtypeDownsidesDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _newtypeDownsidesDefault1.default),
                focusOn: "1+18"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "They are ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.em, {
                                children: "new types"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Implement all the traits and methods you need"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _newtypeDownsidesRev1Default.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "May give you the ability to provide better names (e.g. instead of ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Vec::push"
                            }),
                            "))"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Add has 8 or so variants for integers"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "No simple delegation syntax"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Be wary of implementing ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "Deref"
                    }),
                    " and ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "DerefMut"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _derefAntipatternDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "These traits are used by smart pointers like ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Box"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Allow trivially breaking the encapsulation"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Constrain values by inclusion"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _constrainByInclusionDefault.default),
                focusOn: "1+8"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "\"stringly-typed\""
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "We have the panic case"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "What about capitalization"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Only create valid values"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _constrainByInclusionRev1Default.default),
                focusOn: "1+16"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Other languages and basically do this; nothing special"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "enum"
                    }),
                    "s can store data"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _enumWithDataDefault.default),
                focusOn: "1+20"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Doesn't work well with ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "&mut"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _enumWithDataRev1Default.default),
                focusOn: "1+20",
                emphasize: "10[20+9],13[14+1]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Doesn't work well with ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "&mut"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _enumWithDataRev1Default1.default),
                focusOn: "1+19"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Can clone the values (maybe ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Rc"
                            }),
                            " / ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Arc"
                            }),
                            ")"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Can make the values ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Option"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Can ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "take"
                            }),
                            " the values if they implement ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Default"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Typestate"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _typestateDefault.default),
                focusOn: "1+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "\"Session types\" are the same idea applied to communication between entities"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Typestate"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _typestateDefault.default),
                focusOn: "7+25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Typestate"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _typestateDefault.default),
                focusOn: "33+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _typestateDefault1.default),
                focusOn: "1+12"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Exercise: Vending machine state machine"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "States are \"idle\" and \"added money\""
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "User events are \"asked for refund\", \"selected a drink\", \"added money\""
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "The amount of money added is in cents and is variable"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "A drink costs 50 cents"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Code like this should run:"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                                src: (0, _exerciseVendingMachineDefault.default),
                                focusOn: "59,63+2",
                                copyAllCode: false
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Hints"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Take ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "self"
                            }),
                            " and return ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Self"
                            }),
                            " from your method to allow chaining"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Match on a tuple of ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "(state, event)"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Bonus"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Try using typestate"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "How would making the money into an enum affect the example?"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One answer (1/4)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _exerciseVendingMachineDefault.default),
                focusOn: "1+12"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One answer (2/4)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _exerciseVendingMachineDefault.default),
                focusOn: "14+16"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One answer (3/4)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _exerciseVendingMachineDefault.default),
                focusOn: "31+26"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One answer (4/4)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _exerciseVendingMachineDefault.default),
                focusOn: "58+10"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Pattern-matching pitfalls"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _patternMatchingPitfallsDefault.default),
                focusOn: "1+2,4+15"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Pattern-matching pitfalls"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _patternMatchingPitfallsRev1Default.default),
                focusOn: "1+2,4+16",
                emphasize: "7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "A catch all will ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.em, {
                                children: "catch all"
                            }),
                            ", even variants you add later"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Similar concept is possible when matching on a struct"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Non-exhaustive matching"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _libRsDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Non-exhaustive matching"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _nonExhaustiveMatchingDefault.default),
                focusOn: "1+8"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Non-exhaustive matching"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                lang: "compiler-error",
                src: (0, _nonExhaustiveMatchingDefault1.default),
                focusOn: "1+20"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Some things that Rust's type system cannot do"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Refinement types"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Dependent types"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Refinement types"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-rust",
                    children: "// Invalid syntax\nfn divide(a: i32, b: i32 \u220C {0}) -> i32 {\n    a / b\n}\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Refinement type replacements"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Create a newtype"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _pseudoRefinementTypesDefault.default),
                focusOn: "1+14"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "This has a weakness - ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: ".0"
                            }),
                            " is modifiable"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Refinement type replacements"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Use an existing newtype"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _pseudoRefinementTypesRev1Default.default),
                focusOn: "1+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Non-zero types are built-in as they enable optimizations"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Dependent types"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-rust",
                    children: "// Invalid syntax\nfn start_game(players: usize) -> [Player; players] {\n    // ...\n}\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Types are dependent on a value"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Dependent type replacements"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Abandon it"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _pseudoDependentTypesDefault.default),
                focusOn: "1+2,4"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Can be combined with a newtype to enforce some restrictions"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Dependent type replacements"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h3, {
                children: "Use const generics"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _pseudoDependentTypesRev1Default.default),
                focusOn: "1+2,4"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Not a direct replacement, but might fit in some cases"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Be pragmatic"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Adding types can increase the clarity of your code"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Adding types can decrease the clarity of your code"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Carol's opinion of Haskell: \"it's only types, no code\""
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Apply these techniques where you get the most benefit",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Correctness-critical"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Widely used"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Performance"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Memory safety"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                    href: "https://docs.google.com/forms/d/e/1FAIpQLScm5lrMkEXGGANtUZ4HOLUCD0fkdB70JwBT6uF0gNAqvM7Etw/viewform?usp=publish-editor",
                    children: "Quiz"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _changeDeckDefault.default), {
                    deck: "overview",
                    children: "Return"
                })
            })
        ]
    });
}
function MDXContent(props = {}) {
    const { wrapper: MDXLayout } = props.components || {};
    return MDXLayout ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(MDXLayout, {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_createMdxContent, {
            ...props
        })
    }) : _createMdxContent(props);
}
function _missingMdxReference(id, component, place) {
    throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it." + (place ? "\nIt\u2019s referenced in your code at `" + place + "`" : ""));
}

},{"react/jsx-runtime":"afIHK","./Directives":"6Yemz","./ChangeDeck":"29Jlq","./layout/Splash":"1mDy7","./TestPattern":"g0BPT","./Transclude":"fUgcm","rust:reliable-code-using-types/type-theory":"iEQXH","rust:reliable-code-using-types/newtypes":"eNSN6","rust:reliable-code-using-types/newtypes?rev=1":"cGXUb","stderr:reliable-code-using-types/newtypes?rev=1":"9TUgD","rust:reliable-code-using-types/newtypes?rev=2":"76loq","rust:reliable-code-using-types/constrained-data":"cJBS7","rust:reliable-code-using-types/constrained-data?rev=1":"5oUlp","stderr:reliable-code-using-types/constrained-data?rev=1":"aj81R","rust:reliable-code-using-types/newtype-downsides":"3LwbF","stderr:reliable-code-using-types/newtype-downsides":"i5QcL","rust:reliable-code-using-types/newtype-downsides?rev=1":"6e0hb","rust:reliable-code-using-types/deref-antipattern":"63qvR","rust:reliable-code-using-types/constrain-by-inclusion":"8Zwb9","rust:reliable-code-using-types/constrain-by-inclusion?rev=1":"8qPzO","rust:reliable-code-using-types/enum-with-data":"duZt1","rust:reliable-code-using-types/enum-with-data?rev=1":"2Gpmy","stderr:reliable-code-using-types/enum-with-data?rev=1":"bsx5w","rust:reliable-code-using-types/typestate":"9n3U8","stderr:reliable-code-using-types/typestate":"11AbH","rust:reliable-code-using-types/exercise-vending-machine":"anYWq","rust:reliable-code-using-types/pattern-matching-pitfalls":"7XK2W","rust:reliable-code-using-types/pattern-matching-pitfalls?rev=1":"ko0le","rust:reliable-code-using-types/non-exhaustive-matching/my-library/src/lib.rs":"6eKq0","rust:reliable-code-using-types/non-exhaustive-matching":"20GsK","stderr:reliable-code-using-types/non-exhaustive-matching":"ddCFC","rust:reliable-code-using-types/pseudo-refinement-types":"9Wxyo","rust:reliable-code-using-types/pseudo-refinement-types?rev=1":"liCLq","rust:reliable-code-using-types/pseudo-dependent-types":"6YbyW","rust:reliable-code-using-types/pseudo-dependent-types?rev=1":"7Uj2T","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"iEQXH":[function(require,module,exports,__globalThis) {
module.exports = "struct Coordinate {\n    x: i8,\n    y: i8,\n}\n\nenum Direction {\n    X,\n    Y,\n}\n\nfn main() {}\n";

},{}],"eNSN6":[function(require,module,exports,__globalThis) {
module.exports = "fn transfer_money(from: u32, to: u32, amount: u32) {\n    // ...\n}\n\nfn main() {\n    let my_account = 0;\n    let amazon = 0;\n\n    transfer_money(my_account, 100, amazon);\n}\n";

},{}],"cGXUb":[function(require,module,exports,__globalThis) {
module.exports = "struct AccountId(u32);\n\nstruct Amount(u32);\n\nfn transfer_money(from: AccountId, to: AccountId, amount: Amount) {\n    // ...\n}\n\nfn main() {\n    let my_account = AccountId(0);\n    let amazon = AccountId(0);\n\n    transfer_money(my_account, Amount(100), amazon);\n}\n";

},{}],"9TUgD":[function(require,module,exports,__globalThis) {
module.exports = "error[E0308]: arguments to this function are incorrect\n  --> newtypes/src/main.rs:29:5\n   |\n29 |     transfer_money(my_account, Amount(100), amazon);\n   |     ^^^^^^^^^^^^^^             -----------  ------ expected `Amount`, found `AccountId`\n   |                                |\n   |                                expected `AccountId`, found `Amount`\n   |\nnote: function defined here\n  --> newtypes/src/main.rs:20:4\n   |\n20 | fn transfer_money(from: AccountId, to: AccountId, amount: Amount) {\n   |    ^^^^^^^^^^^^^^\nhelp: swap these arguments\n   |\n29 -     transfer_money(my_account, Amount(100), amazon);\n29 +     transfer_money(my_account, amazon, Amount(100));\n   |\n\nFor more information about this error, try `rustc --explain E0308`.\nerror: could not compile `newtypes` (bin \"newtypes\") due to 1 previous error\n";

},{}],"76loq":[function(require,module,exports,__globalThis) {
module.exports = "struct AccountId(u32);\n\nstruct Amount(u32);\n\nstruct From(AccountId);\n\nstruct To(AccountId);\n\nfn transfer_money(from: From, to: To, amount: Amount) {\n    // ...\n}\n\nfn main() {\n    let my_account = AccountId(0);\n    let amazon = AccountId(0);\n\n    transfer_money(From(my_account), To(amazon), Amount(100));\n}\n";

},{}],"cJBS7":[function(require,module,exports,__globalThis) {
module.exports = "struct Email(String);\n\nimpl Email {\n    fn new(s: String) -> Option<Self> {\n        if is_valid_email(&s) {\n            Some(Self(s))\n        } else {\n            None\n        }\n    }\n}\n\nfn nefarious_hacker() -> Email {\n    Email(String::from(\"not-an-email\"))\n}\n\nfn is_valid_email(_: &str) -> bool {\n    true\n}\n\nfn main() {}\n";

},{}],"5oUlp":[function(require,module,exports,__globalThis) {
module.exports = "mod email {\n    use super::is_valid_email;\n\n    pub struct Email(String);\n\n    impl Email {\n        pub fn new(s: String) -> Option<Self> {\n            if is_valid_email(&s) {\n                Some(Self(s))\n            } else {\n                None\n            }\n        }\n    }\n}\n\nuse email::Email;\n\nfn nefarious_hacker() -> Email {\n    Email(String::from(\"not-an-email\"))\n}\n\nfn is_valid_email(_: &str) -> bool {\n    true\n}\n\nfn main() {}\n";

},{}],"aj81R":[function(require,module,exports,__globalThis) {
module.exports = "error[E0423]: cannot initialize a tuple struct which contains private fields\n  --> constrained-data/src/main.rs:36:5\n   |\n36 |     Email(String::from(\"not-an-email\"))\n   |     ^^^^^\n   |\nnote: constructor is not visible here due to private fields\n  --> constrained-data/src/main.rs:19:22\n   |\n19 |     pub struct Email(String);\n   |                      ^^^^^^ private field\nhelp: consider making the field publicly accessible\n   |\n19 |     pub struct Email(pub String);\n   |                      +++\n\nFor more information about this error, try `rustc --explain E0423`.\nerror: could not compile `constrained-data` (bin \"constrained-data\") due to 1 previous error\n";

},{}],"3LwbF":[function(require,module,exports,__globalThis) {
module.exports = "struct Meters(u32);\n\nfn main() {\n    let distance = Meters(12) + Meters(1);\n}\n";

},{}],"i5QcL":[function(require,module,exports,__globalThis) {
module.exports = "error[E0369]: cannot add `Meters` to `Meters`\n  --> newtype-downsides/src/main.rs:13:31\n   |\n13 |     let distance = Meters(12) + Meters(1);\n   |                    ---------- ^ --------- Meters\n   |                    |\n   |                    Meters\n   |\nnote: an implementation of `Add` might be missing for `Meters`\n  --> newtype-downsides/src/main.rs:1:1\n   |\n 1 | struct Meters(u32);\n   | ^^^^^^^^^^^^^ must implement `Add`\nnote: the trait `Add` must be implemented\n  --> core/src/ops/arith.rs:76:1\n   |\n76 | pub const trait Add<Rhs = Self> {\n   | ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n\nFor more information about this error, try `rustc --explain E0369`.\nerror: could not compile `newtype-downsides` (bin \"newtype-downsides\") due to 1 previous error\n";

},{}],"6e0hb":[function(require,module,exports,__globalThis) {
module.exports = "struct Meters(u32);\n\nimpl std::ops::Add for Meters {\n    type Output = Meters;\n\n    fn add(self, other: Meters) -> Self::Output {\n        Meters(self.0 + other.0)\n    }\n}\n\nfn main() {\n    let distance = Meters(12) + Meters(1);\n}\n";

},{}],"63qvR":[function(require,module,exports,__globalThis) {
module.exports = "struct Meters(u32);\n\nimpl std::ops::Deref for Meters {\n    type Target = u32;\n\n    fn deref(&self) -> &Self::Target {\n        &self.0\n    }\n}\n\nimpl std::ops::DerefMut for Meters {\n    fn deref_mut(&mut self) -> &mut Self::Target {\n        &mut self.0\n    }\n}\n\nfn increment_by_six(v: &mut u32) {\n    *v += 6;\n}\n\nfn main() {\n    let mut distance = Meters(10);\n    increment_by_six(&mut distance);\n}\n";

},{}],"8Zwb9":[function(require,module,exports,__globalThis) {
module.exports = "fn next_color(current: &'static str) -> &'static str {\n    match current {\n        \"red\" => \"green\",\n        \"yellow\" => \"red\",\n        \"green\" => \"yellow\",\n        other => panic!(\"Unknown color {other}\"),\n    }\n}\n\nfn main() {}\n";

},{}],"8qPzO":[function(require,module,exports,__globalThis) {
module.exports = "#[derive(Debug, Copy, Clone)]\nenum Color {\n    Red,\n    Yellow,\n    Green,\n}\n\nimpl Color {\n    fn next_color(self) -> Self {\n        match self {\n            Color::Red => Color::Green,\n            Color::Yellow => Color::Red,\n            Color::Green => Color::Yellow,\n        }\n    }\n}\n\nfn main() {}\n";

},{}],"duZt1":[function(require,module,exports,__globalThis) {
module.exports = "#[derive(Debug, Clone)]\nenum Login {\n    Unauthenticated,\n    WithUsername { username: String },\n    WithPassword { password: String },\n    WithBoth { username: String, password: String },\n}\n\nimpl Login {\n    fn add_username(self, username: String) -> Self {\n        use Login::*;\n\n        match self {\n            Unauthenticated => WithUsername { username },\n            WithUsername { .. } => WithUsername { username },\n            WithPassword { password } => WithBoth { username, password },\n            WithBoth { password, .. } => WithBoth { username, password },\n        }\n    }\n}\n\nfn main() {}\n";

},{}],"2Gpmy":[function(require,module,exports,__globalThis) {
module.exports = "#[derive(Debug, Clone)]\nenum Login {\n    Unauthenticated,\n    WithUsername { username: String },\n    WithPassword { password: String },\n    WithBoth { username: String, password: String },\n}\n\nimpl Login {\n    fn add_username(&mut self, username: String) -> Self {\n        use Login::*;\n\n        match *self {\n            Unauthenticated => WithUsername { username },\n            WithUsername { .. } => WithUsername { username },\n            WithPassword { password } => WithBoth { username, password },\n            WithBoth { password, .. } => WithBoth { username, password },\n        }\n    }\n}\n\nfn main() {}\n";

},{}],"bsx5w":[function(require,module,exports,__globalThis) {
module.exports = "error[E0507]: cannot move out of `self.password` as enum variant `WithPassword` which is\n              behind a mutable reference\n  --> enum-with-data/src/main.rs:28:15\n   |\n28 |         match *self {\n   |               ^^^^^\n...\n31 |             WithPassword { password } => WithBoth { username, password },\n   |                            -------- data moved here\n32 |             WithBoth { password, .. } => WithBoth { username, password },\n   |                        -------- ...and here\n   |\n   = note: move occurs because these variables have types that don't implement the `Copy` trait\nhelp: consider removing the dereference here\n   |\n28 -         match *self {\n28 +         match self {\n   |\n\nFor more information about this error, try `rustc --explain E0507`.\nerror: could not compile `enum-with-data` (bin \"enum-with-data\") due to 1 previous error\n";

},{}],"9n3U8":[function(require,module,exports,__globalThis) {
module.exports = "struct Airplane<S>(S);\n\nstruct AtGate;\nstruct Taxiing;\nstruct InFlight;\n\nimpl Airplane<AtGate> {\n    fn new() -> Self {\n        Airplane(AtGate)\n    }\n\n    fn push_back(self) -> Airplane<Taxiing> {\n        Airplane(Taxiing)\n    }\n}\n\nimpl Airplane<Taxiing> {\n    fn return_to_gate(self) -> Airplane<AtGate> {\n        Airplane(AtGate)\n    }\n\n    fn take_off(self) -> Airplane<InFlight> {\n        Airplane(InFlight)\n    }\n}\n\nimpl Airplane<InFlight> {\n    fn land(self) -> Airplane<Taxiing> {\n        Airplane(Taxiing)\n    }\n}\n\nfn main() {\n    Airplane::new().take_off();\n}\n";

},{}],"11AbH":[function(require,module,exports,__globalThis) {
module.exports = "error[E0599]: no method named `take_off` found for struct `Airplane<AtGate>` in the current\n              scope\n  --> typestate/src/main.rs:34:21\n   |\n 1 | struct Airplane<S>(S);\n   | ------------------ method `take_off` not found for this struct\n...\n34 |     Airplane::new().take_off();\n   |                     ^^^^^^^^ method not found in `Airplane<AtGate>`\n   |\n   = note: the method was found for `Airplane<Taxiing>`\n\nFor more information about this error, try `rustc --explain E0599`.\nerror: could not compile `typestate` (bin \"typestate\") due to 1 previous error\n";

},{}],"anYWq":[function(require,module,exports,__globalThis) {
module.exports = "#[derive(Debug, Copy, Clone)]\nenum VendingMachine {\n    Idle,\n    MoneyAdded { total: u8 },\n}\n\n#[derive(Debug, Copy, Clone)]\nenum Event {\n    Refund,\n    SelectDrink,\n    AddMoney { amount: u8 },\n}\n\nconst DRINK_COST: u8 = 50;\n\nimpl VendingMachine {\n    fn handle_event(self, event: Event) -> Self {\n        use Event::*;\n        use VendingMachine::*;\n\n        match (self, event) {\n            (Idle, Refund) => Idle,\n\n            (Idle, SelectDrink) => {\n                println!(\"Add {DRINK_COST} cents\");\n                Idle\n            }\n\n            (Idle, AddMoney { amount }) => MoneyAdded { total: amount },\n\n            (MoneyAdded { total }, Refund) => {\n                println!(\"Here is your {total} cents\");\n                Idle\n            }\n\n            (MoneyAdded { total }, SelectDrink) => match total.checked_sub(DRINK_COST) {\n                Some(change) => {\n                    println!(\"Here's your drink\");\n                    if change == 0 {\n                        Idle\n                    } else {\n                        MoneyAdded { total: change }\n                    }\n                }\n                None => {\n                    println!(\"Add {} more cents\", DRINK_COST - total);\n                    MoneyAdded { total }\n                }\n            },\n\n            (MoneyAdded { total }, AddMoney { amount }) => MoneyAdded {\n                total: total + amount,\n            },\n        }\n    }\n}\n\nfn main() {\n    VendingMachine::Idle\n        .handle_event(Event::SelectDrink)\n        .handle_event(Event::Refund)\n        .handle_event(Event::AddMoney { amount: 25 })\n        .handle_event(Event::AddMoney { amount: 50 })\n        .handle_event(Event::SelectDrink)\n        .handle_event(Event::SelectDrink)\n        .handle_event(Event::Refund);\n}\n";

},{}],"7XK2W":[function(require,module,exports,__globalThis) {
module.exports = "fn example() -> Result<i32, Error> {\n    // ...\n    Ok(0)\n}\n\nenum Error {\n    ServerDisconnected,\n    AliensLanded,\n    GlobalThermonuclearWar,\n}\n\nfn main() {\n    match example() {\n        Ok(v) => println!(\"Got a value: {v}\"),\n        Err(Error::ServerDisconnected) => println!(\"Server is gone\"),\n        Err(_) => panic!(\"Add some more tests...\"),\n    }\n}\n";

},{}],"ko0le":[function(require,module,exports,__globalThis) {
module.exports = "fn example() -> Result<i32, Error> {\n    // ...\n    Ok(0)\n}\n\nenum Error {\n    ServerDisconnected,\n    ServerVersionMismatch,\n    AliensLanded,\n    GlobalThermonuclearWar,\n}\n\nfn main() {\n    match example() {\n        Ok(v) => println!(\"Got a value: {v}\"),\n        Err(Error::ServerDisconnected) => println!(\"Server is gone\"),\n        Err(_) => panic!(\"Add some more tests...\"),\n    }\n}\n";

},{}],"6eKq0":[function(require,module,exports,__globalThis) {
module.exports = "#[non_exhaustive]\npub enum Error {\n    ServerDisconnected,\n    ServerVersionMismatch,\n}\n\npub fn inside_the_library(error: Error) {\n    match error {\n        Error::ServerDisconnected => {}\n        Error::ServerVersionMismatch => {}\n    }\n}\n";

},{}],"20GsK":[function(require,module,exports,__globalThis) {
module.exports = "use my_library::Error;\n\nfn outside_the_library(error: Error) {\n    match error {\n        Error::ServerDisconnected => {}\n        Error::ServerVersionMismatch => {}\n    }\n}\n\nfn main() {}\n";

},{}],"ddCFC":[function(require,module,exports,__globalThis) {
module.exports = "error[E0004]: non-exhaustive patterns: `_` not covered\n --> non-exhaustive-matching/src/main.rs:4:11\n  |\n4 |     match error {\n  |           ^^^^^ pattern `_` not covered\n  |\nnote: `my_library::Error` defined here\n --> non-exhaustive-matching/my-library/src/lib.rs:2:1\n  |\n2 | pub enum Error {\n  | ^^^^^^^^^^^^^^\n  = note: the matched value is of type `my_library::Error`\n  = note: `my_library::Error` is marked as non-exhaustive, so a wildcard `_` is necessary to\n  =       match exhaustively\nhelp: ensure that all possible cases are being handled by adding a match arm with a wildcard\n  |   pattern or an explicit pattern as shown\n  |\n6 ~         Error::ServerVersionMismatch => {},\n7 +         _ => todo!()\n  |\n\nFor more information about this error, try `rustc --explain E0004`.\nerror: could not compile `non-exhaustive-matching` (bin \"non-exhaustive-matching\") due to 1\n       previous error\n";

},{}],"9Wxyo":[function(require,module,exports,__globalThis) {
module.exports = "struct NonZeroI32(i32);\n\nimpl NonZeroI32 {\n    fn from_i32(v: i32) -> Option<Self> {\n        match v {\n            0 => None,\n            v => Some(NonZeroI32(v)),\n        }\n    }\n}\n\nfn divide(a: i32, b: NonZeroI32) -> i32 {\n    a / b.0\n}\n\nfn main() {}\n";

},{}],"liCLq":[function(require,module,exports,__globalThis) {
module.exports = "use std::num::NonZeroI32;\n\nfn divide(a: i32, b: NonZeroI32) -> i32 {\n    a / b.get()\n}\n\nfn main() {}\n";

},{}],"6YbyW":[function(require,module,exports,__globalThis) {
module.exports = "fn start_game(players: usize) -> Vec<Player> {\n    // ...\n    vec![]\n}\n\n#[derive(Copy, Clone)]\nstruct Player;\n\nfn main() {}\n";

},{}],"7Uj2T":[function(require,module,exports,__globalThis) {
module.exports = "fn start_game<const PLAYERS: usize>() -> [Player; PLAYERS] {\n    // ...\n    [Player; PLAYERS]\n}\n\n#[derive(Copy, Clone)]\nstruct Player;\n\nfn main() {}\n";

},{}],"g1UBA":[function(require,module,exports,__globalThis) {
/*@jsxRuntime automatic*/ /*@jsxImportSource react*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "title", ()=>title);
parcelHelpers.export(exports, "default", ()=>MDXContent);
var _jsxRuntime = require("react/jsx-runtime");
var _directives = require("./Directives");
var _changeDeck = require("./ChangeDeck");
var _changeDeckDefault = parcelHelpers.interopDefault(_changeDeck);
var _splash = require("./layout/Splash");
var _splashDefault = parcelHelpers.interopDefault(_splash);
var _testPattern = require("./TestPattern");
var _testPatternDefault = parcelHelpers.interopDefault(_testPattern);
var _transclude = require("./Transclude");
var _transcludeDefault = parcelHelpers.interopDefault(_transclude);
var _quote = require("./Quote");
var _quoteDefault = parcelHelpers.interopDefault(_quote);
var _testingModuleCss = require("./testing.module.css");
var _oneTest = require("rust:testing/one-test");
var _oneTestDefault = parcelHelpers.interopDefault(_oneTest);
var _oneTest1 = require("stdout:testing/one-test");
var _oneTestDefault1 = parcelHelpers.interopDefault(_oneTest1);
var _writingUnitTest = require("rust:testing/writing-unit-test");
var _writingUnitTestDefault = parcelHelpers.interopDefault(_writingUnitTest);
var _libRs = require("rust:testing/writing-integration-test/src/lib.rs");
var _libRsDefault = parcelHelpers.interopDefault(_libRs);
var _basicRs = require("rust:testing/writing-integration-test/tests/basic.rs");
var _basicRsDefault = parcelHelpers.interopDefault(_basicRs);
var _advancedFeatures = require("rust:testing/advanced-features");
var _advancedFeaturesDefault = parcelHelpers.interopDefault(_advancedFeatures);
var _redGreenRefactorPng = require("./assets/testing/red-green-refactor.png");
var _redGreenRefactorPngDefault = parcelHelpers.interopDefault(_redGreenRefactorPng);
var _sketchWithUnimplemented = require("rust:testing/sketch-with-unimplemented");
var _sketchWithUnimplementedDefault = parcelHelpers.interopDefault(_sketchWithUnimplemented);
var _refactoring = require("rust:testing/refactoring");
var _refactoringDefault = parcelHelpers.interopDefault(_refactoring);
var _refactoringRev1 = require("rust:testing/refactoring?rev=1");
var _refactoringRev1Default = parcelHelpers.interopDefault(_refactoringRev1);
var _refactoringRev11 = require("stderr:testing/refactoring?rev=1");
var _refactoringRev1Default1 = parcelHelpers.interopDefault(_refactoringRev11);
var _exerciseRomanNumerals = require("rust:testing/exercise-roman-numerals");
var _exerciseRomanNumeralsDefault = parcelHelpers.interopDefault(_exerciseRomanNumerals);
var _makingItTestable = require("rust:testing/making-it-testable");
var _makingItTestableDefault = parcelHelpers.interopDefault(_makingItTestable);
var _makingItTestableRev1 = require("rust:testing/making-it-testable?rev=1");
var _makingItTestableRev1Default = parcelHelpers.interopDefault(_makingItTestableRev1);
var _makingItTestableRev2 = require("rust:testing/making-it-testable?rev=2");
var _makingItTestableRev2Default = parcelHelpers.interopDefault(_makingItTestableRev2);
var _dependencyInjection = require("rust:testing/dependency-injection");
var _dependencyInjectionDefault = parcelHelpers.interopDefault(_dependencyInjection);
var _exerciseTestableCode = require("rust:testing/exercise-testable-code");
var _exerciseTestableCodeDefault = parcelHelpers.interopDefault(_exerciseTestableCode);
var _exerciseTestableCodeRev1 = require("rust:testing/exercise-testable-code?rev=1");
var _exerciseTestableCodeRev1Default = parcelHelpers.interopDefault(_exerciseTestableCodeRev1);
var _conditionalCompilation = require("rust:testing/conditional-compilation");
var _conditionalCompilationDefault = parcelHelpers.interopDefault(_conditionalCompilation);
const title = "Testing";
function _createMdxContent(props) {
    const _components = {
        a: "a",
        code: "code",
        em: "em",
        h1: "h1",
        h2: "h2",
        hr: "hr",
        li: "li",
        p: "p",
        pre: "pre",
        strong: "strong",
        ul: "ul",
        ...props.components
    }, { SplitSlides } = _components;
    if (!SplitSlides) _missingMdxReference("SplitSlides", true);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SplitSlides, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _testPatternDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Testing"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Writing a test"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: "Built-in simple testing framework and assertions"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _oneTestDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Writing a test"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: "Built-in simple testing framework and assertions"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _oneTestDefault.default),
                emphasize: "5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Adding the ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "#[test]"
                            }),
                            " attribute to a function will cause it to be run as a test"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Must take no arguments"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Writing a test"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: "Built-in simple testing framework and assertions"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _oneTestDefault.default),
                emphasize: "7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "There's also ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "assert"
                            }),
                            " and ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "assert_ne"
                            }),
                            "."
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Any panic will cause the test to fail"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Running a test"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _oneTestDefault1.default),
                lang: "compiler-output",
                focusOn: "2+4",
                insert: {
                    1: "% cargo test\n"
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "cargo test"
                            }),
                            " has a myriad of options, helpful to run ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "cargo test --help"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Unit tests vs. integration tests"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Unit tests"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Small"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Fast"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Isolated"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Integration tests"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Larger"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Slower"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Many parts"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "This is a complicated and nuanced area"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Both are subset of ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.em, {
                                children: "functional"
                            }),
                            " tests; there's also non-functional tests"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Rust mechanics for unit tests vs. integration tests"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Unit tests"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "In the same file as the unit being tested"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Integration tests"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "Separate file in the ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "tests"
                                            }),
                                            " directory"
                                        ]
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "These are general guidelines",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "You could write unit tests in a separate module / file"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "You could write a completely different crate to test a library"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Writing a unit test"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _writingUnitTestDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Writing a unit test"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _writingUnitTestDefault.default),
                emphasize: "6"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Put tests in a module. Allows us to group test-specific things."
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Module is underneath the code being tested",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "This allows us to test items that are ultimately private"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Writing a unit test"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _writingUnitTestDefault.default),
                emphasize: "5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Only compile the module when building tests"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Helps compile speed"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Prevents unintended things from being compiled in production"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Writing a unit test"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _writingUnitTestDefault.default),
                emphasize: "7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Rust's privacy rules allow a submodule to see everything from the parent"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Writing an integration test"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.strong, {
                    children: "src/lib.rs"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _libRsDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Writing an integration test"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.strong, {
                    children: "src/lib.rs"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _libRsDefault.default),
                emphasize: "1[0+3]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Must make the function (or method, or type, etc.) public"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Writing an integration test"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.strong, {
                    children: "src/lib.rs"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _libRsDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.strong, {
                    children: "tests/basic.rs"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _basicRsDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Writing an integration test"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.strong, {
                    children: "src/lib.rs"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _libRsDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.strong, {
                    children: "tests/basic.rs"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _basicRsDefault.default),
                emphasize: "1"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Import the public items to be able to use them"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Advanced test features"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h2, {
                children: [
                    "Returning ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "Result"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _advancedFeaturesDefault.default),
                focusOn: "1+8"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "This allows you to focus the test on the important part"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Any ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Err"
                            }),
                            " will count as a test failure"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Advanced test features"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Require that a panic occurs"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _advancedFeaturesDefault.default),
                focusOn: "10+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "expected"
                            }),
                            " text must be in the panic message"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "expected"
                            }),
                            " is optional"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Advanced test runner features"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Limiting which tests are run"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-compiler-output",
                    children: "% cargo test not_a_test\n\nrunning 0 tests\n\ntest result: ok. 0 passed; 0 failed; 0 ignored; 0 measured; 1 filtered out; finished in 0.00s\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-compiler-output",
                    children: "% cargo test a_test\n\nrunning 1 test\ntest a_test ... ok\n\ntest result: ok. 1 passed; 0 failed; 0 ignored; 0 measured; 0 filtered out; finished in 0.00s\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Does a simple substring match for name"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "There are options for restricting to unit tests/integration tests/etc."
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Advanced test runner features"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Multi-threaded by default"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-compiler-output",
                    children: "% cargo test -- --test-threads=1\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Note the intermediate ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "--"
                            }),
                            "; separates Cargo arguments from the test binary"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Output of tests is captured by default"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-compiler-output",
                    children: "% cargo test -- --nocapture\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Done to prevent useless interleaved output"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "If a test fails, the captured output is printed at the end"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "When to test"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Test never"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Test after"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Test before"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Test-driven development"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Test-driven design"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "There's a continuum of testing"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "\"never\" means that your customers are the one testing"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Test-before is writing up a bunch of tests before any code"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "TD Development vs Design is all about how much you listen to the code"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Red, Green, Refactor"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                className: _testingModuleCss.chunkyImage,
                src: (0, _redGreenRefactorPngDefault.default),
                alt: "Red, Green, Refactor Cycle"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Write a single failing test"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Do the simplest thing that will make the test pass"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Review the code (both test ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.strong, {
                                children: "and"
                            }),
                            " production) for improvements"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Beware the malicious programmer!"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Red to green"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Write a test",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Try to make it compile"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Write the production code",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Make it compile"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Make test pass"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Test code might not be able to compile due to missing / incomplete production code"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "This is not strictly linear; may have to iterate"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "That iteration is the seed of the ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.em, {
                                children: "design"
                            }),
                            " part of TDD"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Use ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "todo!()"
                    }),
                    " / ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "unimplemented!"
                    }),
                    " to sketch out code"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _sketchWithUnimplementedDefault.default),
                focusOn: "1+17"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Refactoring"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _quoteDefault.default), {
                caption: "Refactoring: Improving the Design of Existing Code",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                    children: "Refactoring is a disciplined technique for restructuring an existing body of\ncode, altering its internal structure without changing its external behavior."
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Notably this means that",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "you ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.strong, {
                                                children: "cannot"
                                            }),
                                            " refactor without some kind of test"
                                        ]
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "you ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.strong, {
                                                children: "cannot"
                                            }),
                                            " add new functionality"
                                        ]
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "I bet you've worked with someone who has misused it to mean \"changing stuff\""
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Refactoring in a statically-typed language"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _refactoringDefault.default),
                focusOn: "1+7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Refactoring in a statically-typed language"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _refactoringRev1Default.default),
                focusOn: "1+9",
                emphasize: "1,3[13+7],4[9+2]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: "The compiler is your friend!"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _refactoringRev1Default1.default),
                lang: "compiler-error",
                focusOn: "1+17"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Any usage of a function or type counts as a ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.em, {
                                children: "kind"
                            }),
                            " of test"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Reduces the need to have a bunch of edge case tests"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Exercise: Roman numeral converter"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Create a function that converts a number to the Roman numeral equivalent"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Repeat value to add it: 1 \u2192 I, 2 \u2192 II, 3 \u2192 III"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Smaller before larger to subtract: 4 \u2192 IV, 5 \u2192 V, 6 \u2192 VI"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "I (1), V (5), X (10), L (50), C (100), D (500), M (1000)"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                            href: "http://www.novaroma.org/via_romana/numbers.html",
                            children: "Roman numeral reference"
                        })
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Try to be as strict about TDD as you can",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "No production code until a test requires it"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "No refactoring while any test is red"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Optionally, try committing after every green and every refactor"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One potential solution"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Production code (1/2)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _exerciseRomanNumeralsDefault.default),
                focusOn: "1+24"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One potential solution"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Test code (2/2)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _exerciseRomanNumeralsDefault.default),
                focusOn: "26+28"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One potential solution"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Questions encountered"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "What is the name of the function?"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "What types does it take / return?",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "Started with ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "i32"
                                            }),
                                            ", changed to ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "u32"
                                            }),
                                            ", then to ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "u16"
                                            })
                                        ]
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Around 5 or 6 I wanted to refactor - tests were red!"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Around 10, I started seeing a pattern and wanted to refactor again"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Wondered if ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "=="
                            }),
                            " can be made into ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: ">="
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Refactored tests to be data-driven, using list of correct answers"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Can comment / stash in-progress tests or continue to add hacks to production code"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Tests offer an environment and opportunity to explore"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Making code testable"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _makingItTestableDefault.default),
                focusOn: "1+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "There's a bug in this function \u2014 how would you add a test for it?"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: "Testing something requires controlling it"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Pass in arguments"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _makingItTestableRev1Default.default),
                focusOn: "1+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Functions / methods that accept arguments"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Including constructor functions"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "The best example of this kind of function is a pure function"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _makingItTestableRev2Default.default),
                focusOn: "1+3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Watch out for hidden globals / singletons"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Time"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Database"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Network"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Filesystem"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Hardware"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "You can have singletons without baking them into your code"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Use traits for dependency injection"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _dependencyInjectionDefault.default),
                focusOn: "1+11"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Traits are monomorphized, so no loss in production code"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "The levels of abstraction are up to you"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Dependency injection frameworks exist and might have given this a bad name"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Exercise: Writing testable code"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Write a function that counts the words in Cargo.toml"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Prints the count to standard out"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Tips"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "A word is whitespace-separated"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One potential solution"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Hard-to-test version"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _exerciseTestableCodeDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One potential solution"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Production code (1/2)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _exerciseTestableCodeRev1Default.default),
                focusOn: "1+18"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One potential solution"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Test code (2/2)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _exerciseTestableCodeRev1Default.default),
                focusOn: "20+23"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Assert is buried in the test struct"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Could use interior mutability to save args and assert later"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Conditional compilation as a big hammer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _conditionalCompilationDefault.default),
                focusOn: "1+15"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Not a fan of this style, but it's effective when making something testable that wasn't originally."
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Do unit tests actually test anything?"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Fast"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Highly localized"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Amount of code covered is smaller"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "This can feel like \"pushing peas around on the plate\""
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "What about integration tests?"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "There is no substitute for integration tests"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Ensures that pieces work together"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "You can choose what pieces are being integrated",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Control outside that integration"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "What about system tests?"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "There is no substitute for system tests"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Ensures that the product does the right thing"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "You will need to control ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.em, {
                                children: "everything"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Relatively expensive, slow, and brittle"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "What's the right balance of tests?"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "It depends",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "your code"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "your team"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "your risk tolerance"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "your time"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "your money"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Problems and solutions"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "No tests? \u2192 Write tests"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Bad tests? \u2192 Write tests first"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Hard to write tests? \u2192 Inject dependencies"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Deeper testing topics"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Benchmarking",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                            children: "cargo bench"
                                        })
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                                            href: "https://crates.io/crates/criterion",
                                            children: "Criterion"
                                        })
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Fuzzing",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                                            href: "https://crates.io/crates/cargo-fuzz",
                                            children: "Cargo Fuzz"
                                        })
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                                            href: "https://crates.io/crates/afl",
                                            children: "AFL"
                                        })
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Property-based testing",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                                            href: "https://crates.io/crates/proptest",
                                            children: "Proptest"
                                        })
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                                            href: "https://crates.io/crates/quickcheck",
                                            children: "Quickcheck"
                                        })
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                    href: "https://docs.google.com/forms/d/e/1FAIpQLSd9jsF54a81MJOV8FofU_OuUvKpjH3tBp1E1LxgnK1BJNTjiA/viewform?usp=publish-editor",
                    children: "Quiz"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _changeDeckDefault.default), {
                    deck: "overview",
                    children: "Return"
                })
            })
        ]
    });
}
function MDXContent(props = {}) {
    const { wrapper: MDXLayout } = props.components || {};
    return MDXLayout ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(MDXLayout, {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_createMdxContent, {
            ...props
        })
    }) : _createMdxContent(props);
}
function _missingMdxReference(id, component, place) {
    throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it." + (place ? "\nIt\u2019s referenced in your code at `" + place + "`" : ""));
}

},{"react/jsx-runtime":"afIHK","./Directives":"6Yemz","./ChangeDeck":"29Jlq","./layout/Splash":"1mDy7","./TestPattern":"g0BPT","./Transclude":"fUgcm","./Quote":"7JX1G","./testing.module.css":"aIRNe","rust:testing/one-test":"8Alt1","stdout:testing/one-test":"dqpOF","rust:testing/writing-unit-test":"1pBwf","rust:testing/writing-integration-test/src/lib.rs":"2l7Te","rust:testing/writing-integration-test/tests/basic.rs":"bd2UT","rust:testing/advanced-features":"5g6ob","./assets/testing/red-green-refactor.png":"czjmx","rust:testing/sketch-with-unimplemented":"5YZOe","rust:testing/refactoring":"a7Dxm","rust:testing/refactoring?rev=1":"jCy6b","stderr:testing/refactoring?rev=1":"3znvQ","rust:testing/exercise-roman-numerals":"fvS39","rust:testing/making-it-testable":"7A9Zu","rust:testing/making-it-testable?rev=1":"8UWq2","rust:testing/making-it-testable?rev=2":"9qOpA","rust:testing/dependency-injection":"fMlZH","rust:testing/exercise-testable-code":"eENQf","rust:testing/exercise-testable-code?rev=1":"gMamK","rust:testing/conditional-compilation":"h6Mae","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"aIRNe":[function(require,module,exports,__globalThis) {
var _utilModuleCss = require("./util.module.css");
module.exports["chunkyImage"] = `W4YxZW_chunkyImage ${_utilModuleCss["-chunkyImage"]}`;

},{"./util.module.css":"lqfZi"}],"8Alt1":[function(require,module,exports,__globalThis) {
module.exports = "fn add(a: i32, b: i32) -> i32 {\n    a + b\n}\n\n#[test]\nfn adding_one() {\n    assert_eq!(43, add(42, 1));\n}\n";

},{}],"dqpOF":[function(require,module,exports,__globalThis) {
module.exports = "\nrunning 1 test\ntest adding_one ... ok\n\ntest result: ok. 1 passed; 0 failed; 0 ignored; 0 measured; 0 filtered out; finished in 0.00s\n\n";

},{}],"1pBwf":[function(require,module,exports,__globalThis) {
module.exports = "fn add(a: i32, b: i32) -> i32 {\n    a + b\n}\n\n#[cfg(test)]\nmod test {\n    use super::*;\n\n    #[test]\n    fn adding_one() {\n        assert_eq!(43, add(42, 1));\n    }\n}\n";

},{}],"2l7Te":[function(require,module,exports,__globalThis) {
module.exports = "pub fn add(a: i32, b: i32) -> i32 {\n    a + b\n}\n";

},{}],"bd2UT":[function(require,module,exports,__globalThis) {
module.exports = "use writing_integration_test::add;\n\n#[test]\nfn adding_one() {\n    assert_eq!(43, add(42, 1));\n}\n";

},{}],"5g6ob":[function(require,module,exports,__globalThis) {
module.exports = "#[test]\nfn return_result() -> Result<(), Box<dyn std::error::Error>> {\n    let dict = std::fs::read_to_string(\"/usr/share/dict/web2\")?;\n    for word in dict.split_whitespace() {\n        assert_eq!(word, \"cow\");\n    }\n    Ok(())\n}\n\n#[test]\n#[should_panic(expected = \"Invalid\")]\nfn should_panic() {\n    \"12d3\".parse::<i32>().unwrap();\n}\n";

},{}],"czjmx":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("deFUW");

},{}],"5YZOe":[function(require,module,exports,__globalThis) {
module.exports = "fn log_in_to_server() {\n    let username = get_username();\n    let password = get_password();\n    check_password(&username, &password);\n}\n\nfn get_username() -> String {\n    todo!()\n}\n\nfn get_password() -> String {\n    unimplemented!()\n}\n\nfn check_password(username: &str, password: &str) -> bool {\n    panic!(\"Really any kind of panic\")\n}\n\nfn main() {}\n";

},{}],"a7Dxm":[function(require,module,exports,__globalThis) {
module.exports = "fn divide(a: f32, b: f32) -> f32 {\n    b / a\n}\n\nfn use_it() {\n    println!(\"{}\", divide(10.0, 5.0));\n}\n\nfn main() {}\n";

},{}],"jCy6b":[function(require,module,exports,__globalThis) {
module.exports = "struct Divisor(f32);\n\nfn divide(a: Divisor, b: f32) -> f32 {\n    b / a.0\n}\n\nfn use_it() {\n    println!(\"{}\", divide(10.0, 5.0));\n}\n\nfn main() {}\n";

},{}],"3znvQ":[function(require,module,exports,__globalThis) {
module.exports = "error[E0308]: mismatched types\n  --> refactoring/src/main.rs:15:27\n   |\n15 |     println!(\"{}\", divide(10.0, 5.0));\n   |                    ------ ^^^^ expected `Divisor`, found floating-point number\n   |                    |\n   |                    arguments to this function are incorrect\n   |\nnote: function defined here\n  --> refactoring/src/main.rs:10:4\n   |\n10 | fn divide(a: Divisor, b: f32) -> f32 {\n   |    ^^^^^^ ----------\nhelp: try wrapping the expression in `Divisor`\n   |\n15 |     println!(\"{}\", divide(Divisor(10.0), 5.0));\n   |                           ++++++++    +\n\nFor more information about this error, try `rustc --explain E0308`.\nerror: could not compile `refactoring` (bin \"refactoring\") due to 1 previous error\n";

},{}],"fvS39":[function(require,module,exports,__globalThis) {
module.exports = "const ROMAN_MAPPING: &[(u16, &str)] = &[\n    (1000, \"M\"), (900,  \"CM\"),\n    (500,  \"D\"), (400,  \"CD\"),\n    (100,  \"C\"), (90,   \"XC\"),\n    (50,   \"L\"), (40,   \"XL\"),\n    (10,   \"X\"), (9,    \"IX\"),\n    (5,    \"V\"), (4,    \"IV\"),\n    (1,    \"I\"),\n];\n\nfn roman(mut value: u16) -> String {\n    let mut s = String::new();\n\n    while value > 0 {\n        for &(v, roman_equivalent) in ROMAN_MAPPING {\n            while value >= v {\n                s.push_str(roman_equivalent);\n                value -= v;\n            }\n        }\n    }\n\n    s\n}\n\n#[cfg(test)]\nmod test {\n    use super::*;\n    type Result<T, E = Box<dyn std::error::Error>> = std::result::Result<T, E>;\n\n    #[test]\n    fn roman_values() -> Result<()> {\n        let cases = std::fs::read_to_string(\"roman.txt\")?;\n        let cases = cases.lines().map(|l| -> Result<_> {\n            let mut parts = l.split_whitespace();\n            let val = parts.next().ok_or(\"Missing number\")?.parse()?;\n            let expected = parts.next().ok_or(\"Missing expected result\")?;\n            Ok((val, expected))\n        });\n\n        for case in cases {\n            let (val, expected) = case?;\n            assert_eq!(\n                expected,\n                roman(val),\n                \"Value {val} was converted incorrectly\",\n            );\n        }\n\n        Ok(())\n    }\n}\n\nfn main() {}\n";

},{}],"7A9Zu":[function(require,module,exports,__globalThis) {
module.exports = "fn check_username_and_password_with_server() -> bool {\n    todo!()\n}\n\nfn main() {}\n";

},{}],"8UWq2":[function(require,module,exports,__globalThis) {
module.exports = "fn check_username_and_password_with_server(username: &str, password: &str) -> bool {\n    todo!()\n}\n\nfn main() {}\n";

},{}],"9qOpA":[function(require,module,exports,__globalThis) {
module.exports = "fn check_username_and_password_with_server(login: LoginInformation) -> bool {\n    todo!()\n}\n\nstruct LoginInformation;\n\nfn main() {}\n";

},{}],"fMlZH":[function(require,module,exports,__globalThis) {
module.exports = "trait Server {\n    fn send_bytes(&self, bytes: &[u8]) -> Vec<u8>;\n}\n\nfn check_username_and_password_with_server(\n    username: &str,\n    password: &str,\n    server: impl Server,\n) -> bool {\n    todo!()\n}\n\nfn main() {}\n";

},{}],"eENQf":[function(require,module,exports,__globalThis) {
module.exports = "fn word_count() {\n    let data = std::fs::read_to_string(\"Cargo.toml\").expect(\"No such file\");\n    let count = data.split_whitespace().count();\n    println!(\"Has {count} words\");\n}\n";

},{}],"gMamK":[function(require,module,exports,__globalThis) {
module.exports = "trait Logger {\n    fn words(&self, count: usize);\n}\n\nfn word_count(file: &str, logger: impl Logger) {\n    let data = std::fs::read_to_string(file).expect(\"No such file\");\n    let count = data.split_whitespace().count();\n    logger.words(count)\n}\n\n#[derive(Debug, Copy, Clone, Default)]\nstruct StdoutLogger;\n\nimpl Logger for StdoutLogger {\n    fn words(&self, count: usize) {\n        println!(\"Has {count} words\");\n    }\n}\n\n#[cfg(test)]\nmod test {\n    use super::*;\n\n    #[derive(Debug, Copy, Clone)]\n    struct AssertingLogger(usize);\n\n    impl Logger for AssertingLogger {\n        fn words(&self, count: usize) {\n            assert_eq!(\n                self.0, count,\n                \"AssertingLogger::words received incorrect argument\"\n            );\n        }\n    }\n\n    #[test]\n    fn example() -> Result<(), Box<dyn std::error::Error>> {\n        std::fs::write(\"/tmp/junk\", \"alpha beta gamma\")?;\n        word_count(\"/tmp/junk\", AssertingLogger(3));\n        Ok(())\n    }\n}\n";

},{}],"h6Mae":[function(require,module,exports,__globalThis) {
module.exports = "#[cfg(not(test))]\nfn write_to_server(bytes: &[u8]) -> Vec<u8> {\n    todo!()\n}\n\n#[cfg(test)]\nfn write_to_server(bytes: &[u8]) -> Vec<u8> {\n    todo!()\n}\n\nfn check_username_and_password_with_server(username: &str, password: &str) -> bool {\n    let u = write_to_server(username.as_bytes());\n    let p = write_to_server(password.as_bytes());\n    u == p\n}\n\nfn main() {}\n";

},{}],"lLpkf":[function(require,module,exports,__globalThis) {
/*@jsxRuntime automatic*/ /*@jsxImportSource react*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "title", ()=>title);
parcelHelpers.export(exports, "default", ()=>MDXContent);
var _jsxRuntime = require("react/jsx-runtime");
var _directives = require("./Directives");
var _changeDeck = require("./ChangeDeck");
var _changeDeckDefault = parcelHelpers.interopDefault(_changeDeck);
var _splash = require("./layout/Splash");
var _splashDefault = parcelHelpers.interopDefault(_splash);
var _testPattern = require("./TestPattern");
var _testPatternDefault = parcelHelpers.interopDefault(_testPattern);
var _transclude = require("./Transclude");
var _transcludeDefault = parcelHelpers.interopDefault(_transclude);
var _excerpts = require("./Excerpts");
var _useRegex = require("toml:strings-vs-bytes/use-regex");
var _useRegexDefault = parcelHelpers.interopDefault(_useRegex);
var _useRegex1 = require("rust:strings-vs-bytes/use-regex");
var _useRegexDefault1 = parcelHelpers.interopDefault(_useRegex1);
var _useJetscii = require("toml:strings-vs-bytes/use-jetscii");
var _useJetsciiDefault = parcelHelpers.interopDefault(_useJetscii);
var _useJetscii1 = require("rust:strings-vs-bytes/use-jetscii");
var _useJetsciiDefault1 = parcelHelpers.interopDefault(_useJetscii1);
const title = "Strings vs bytes";
function _createMdxContent(props) {
    const _components = {
        code: "code",
        h1: "h1",
        hr: "hr",
        li: "li",
        pre: "pre",
        ul: "ul",
        ...props.components
    }, { SplitSlides } = _components;
    if (!SplitSlides) _missingMdxReference("SplitSlides", true);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SplitSlides, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _testPatternDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Strings vs bytes"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "History"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "ASCII - 1963"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Basic English text (letters, numbers, punctuation, control chars)"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Unicode - 1991 / 1996"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Big change in 2.0"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "UTF-8 - 1993"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "How we store Unicode as bytes"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Has the nice advantage of being a superset of ASCII"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Rust strings"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "UTF-8"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Know their length"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Not NUL-terminated"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Strings are just fancy byte arrays"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.String), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "\"Fancy\" because they ensure that the bytes are always valid UTF-8"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Strings are bytes"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-rust",
                    children: "impl str {\n    pub fn as_bytes(&self) -> &[u8] { /* ... */ }\n}\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-rust",
                    children: "impl String {\n    pub fn into_bytes(self) -> Vec<u8> { /* ... */ }\n}\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Remember that ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "&String"
                            }),
                            " can be treated as a ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "&str"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Bytes are sometimes strings"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.StrFromUtf8), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.StringFromUtf8), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Don't know why ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "str"
                            }),
                            " is a free function and not associated function."
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Interacting with byte slices"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Standard library is a bit weak for some of this",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "Work being done to improve the ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "Pattern"
                                            }),
                                            " / ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "Needle"
                                            }),
                                            " / ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "Haystack"
                                            }),
                                            " API"
                                        ]
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Regex"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Jetscii"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Other crates"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Regex"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _useRegexDefault.default),
                lang: "toml",
                focusOn: "8+2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _useRegexDefault1.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Jetscii"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _useJetsciiDefault.default),
                lang: "toml",
                focusOn: "8+2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _useJetsciiDefault1.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _changeDeckDefault.default), {
                    deck: "overview",
                    children: "Return"
                })
            })
        ]
    });
}
function MDXContent(props = {}) {
    const { wrapper: MDXLayout } = props.components || {};
    return MDXLayout ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(MDXLayout, {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_createMdxContent, {
            ...props
        })
    }) : _createMdxContent(props);
}
function _missingMdxReference(id, component, place) {
    throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it." + (place ? "\nIt\u2019s referenced in your code at `" + place + "`" : ""));
}

},{"react/jsx-runtime":"afIHK","./Directives":"6Yemz","./ChangeDeck":"29Jlq","./layout/Splash":"1mDy7","./TestPattern":"g0BPT","./Transclude":"fUgcm","./Excerpts":"5uobq","toml:strings-vs-bytes/use-regex":"gxA0W","rust:strings-vs-bytes/use-regex":"3Zaty","toml:strings-vs-bytes/use-jetscii":"f59pc","rust:strings-vs-bytes/use-jetscii":"at1jW","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"gxA0W":[function(require,module,exports,__globalThis) {
module.exports = "[package]\nname = \"use-regex\"\nversion = \"0.1.0\"\nedition = \"2024\"\n\n# See more keys and their definitions at https://doc.rust-lang.org/cargo/reference/manifest.html\n\n[dependencies]\nregex = \"1.11.1\"\n\n[lints]\nworkspace = true\n";

},{}],"3Zaty":[function(require,module,exports,__globalThis) {
module.exports = "use regex::bytes::Regex;\n\nfn main() {\n    let data = b\"xxxxTIFFxxxx\";\n    let tiff = Regex::new(r#\"(?-u)T..F\"#).unwrap();\n    if let Some(m) = tiff.find(data) {\n        println!(\"Found {:?}\", m.as_bytes());\n    }\n}\n";

},{}],"f59pc":[function(require,module,exports,__globalThis) {
module.exports = "[package]\nname = \"use-jetscii\"\nversion = \"0.1.0\"\nedition = \"2024\"\n\n# See more keys and their definitions at https://doc.rust-lang.org/cargo/reference/manifest.html\n\n[dependencies]\njetscii = \"0.5.3\"\n\n[lints]\nworkspace = true\n";

},{}],"at1jW":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let data = b\"xxxxTIFFxxxx\";\n    if let Some(m) = jetscii::bytes!(b'T', b'I', b'F').find(data) {\n        println!(\"Found {:?}\", m);\n    }\n}\n";

},{}],"pP6XZ":[function(require,module,exports,__globalThis) {
/*@jsxRuntime automatic*/ /*@jsxImportSource react*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "title", ()=>title);
parcelHelpers.export(exports, "SerializePrelude", ()=>SerializePrelude);
parcelHelpers.export(exports, "default", ()=>MDXContent);
var _jsxRuntime = require("react/jsx-runtime");
var _directives = require("./Directives");
var _changeDeck = require("./ChangeDeck");
var _changeDeckDefault = parcelHelpers.interopDefault(_changeDeck);
var _splash = require("./layout/Splash");
var _splashDefault = parcelHelpers.interopDefault(_splash);
var _testPattern = require("./TestPattern");
var _testPatternDefault = parcelHelpers.interopDefault(_testPattern);
var _transclude = require("./Transclude");
var _transcludeDefault = parcelHelpers.interopDefault(_transclude);
var _excerpts = require("./Excerpts");
var _oldTry = require("rust:macros/old-try");
var _oldTryDefault = parcelHelpers.interopDefault(_oldTry);
var _helloWorld = require("rust:macros/hello-world");
var _helloWorldDefault = parcelHelpers.interopDefault(_helloWorld);
var _arguments = require("rust:macros/arguments");
var _argumentsDefault = parcelHelpers.interopDefault(_arguments);
var _patterns = require("rust:macros/patterns");
var _patternsDefault = parcelHelpers.interopDefault(_patterns);
var _repetition = require("rust:macros/repetition");
var _repetitionDefault = parcelHelpers.interopDefault(_repetition);
var _exerciseMacro = require("rust:macros/exercise-macro");
var _exerciseMacroDefault = parcelHelpers.interopDefault(_exerciseMacro);
var _serialize = require("rust:macros/serialize");
var _serializeDefault = parcelHelpers.interopDefault(_serialize);
var _serializeRev1 = require("rust:macros/serialize?rev=1");
var _serializeRev1Default = parcelHelpers.interopDefault(_serializeRev1);
var _libRs = require("rust:macros/serialize/serialize-derive/src/lib.rs");
var _libRsDefault = parcelHelpers.interopDefault(_libRs);
const title = "Macros";
const SerializePrelude = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
        src: (0, _serializeDefault.default),
        focusOn: "1+5,10,15",
        transform: {
            5: [
                /$/,
                " /* ... */ }"
            ],
            6: [
                /$/,
                " /* ... */ }"
            ],
            7: [
                /$/,
                " /* ... */ }"
            ]
        }
    });
function _createMdxContent(props) {
    const _components = {
        a: "a",
        code: "code",
        em: "em",
        h1: "h1",
        h2: "h2",
        hr: "hr",
        li: "li",
        p: "p",
        ul: "ul",
        ...props.components
    }, { SplitSlides } = _components;
    if (!SplitSlides) _missingMdxReference("SplitSlides", true);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SplitSlides, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _testPatternDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Macros"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Types of macros"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Declarative"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Procedural"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Declarative"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Defined inside your code"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Match on the structure of the arguments",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "abstract syntax tree (AST)"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Hygenic"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Why use a macro?"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _oldTryDefault.default),
                focusOn: "1+8"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Allow you to construct new types of syntax."
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Before ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "?"
                            }),
                            ", there was a macro called ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "try"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Macro hello world"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _helloWorldDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Macro hello world"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _helloWorldDefault.default),
                emphasize: "1[0+12]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Macro hello world"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _helloWorldDefault.default),
                emphasize: "1[13+7]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Macro hello world"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _helloWorldDefault.default),
                emphasize: "2,3,4"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Macro hello world"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _helloWorldDefault.default),
                emphasize: "4[5+1]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Macro arguments"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _argumentsDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Macro arguments"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _argumentsDefault.default),
                emphasize: "2[5+2],5[5+3],11[13+2],12[13+3]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Can use various literal tokens to select which macro arm"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Macro patterns"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _patternsDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Macro patterns"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _patternsDefault.default),
                emphasize: "2[5+4],3[17+4]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Variables are prefixed with a dollar sign."
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Macro patterns"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _patternsDefault.default),
                emphasize: "2[11+4]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "\"type\" is different; corresponds to things that can be parsed"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Macro fragment specifiers"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "expr"
                            }),
                            ": an expression"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "ident"
                            }),
                            ": an identifier"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "ty"
                            }),
                            ": a type"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "item"
                            }),
                            ": an item, like a function, struct, module, etc."
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                            href: "https://doc.rust-lang.org/1.71.0/reference/macros-by-example.html#metavariables",
                            children: "more"
                        })
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "These are just a sample of some selectors"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Valid macro locations"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Expressions / Statements"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Items"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "impl"
                            }),
                            " Items"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Types"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Patterns"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Macros allow for repetition"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _repetitionDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Macros allow for repetition"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _repetitionDefault.default),
                emphasize: "4[15+2],4[28+3],6[21+2],6[28+3]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Separator can be ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: ","
                            }),
                            " / ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: ";"
                            }),
                            " / ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "=>"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Repetition can be ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "*"
                            }),
                            " / ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "+"
                            }),
                            " / ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "?"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Many macros use recursive logic like this"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Matched pairs"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Macro can be called with ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "[]"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "()"
                            }),
                            ", or ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "{}"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Must always be correctly nested and balanced"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Must always generate correct code; nothing broken"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Exercise: macro"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Create a macro that takes a number and an expression"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Runs the expression number of times"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Code like this should run:"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                                src: (0, _exerciseMacroDefault.default),
                                focusOn: "10",
                                copyAllCode: false
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Hints"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "How would you write this code ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.em, {
                                children: "without"
                            }),
                            " a macro?"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One answer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _exerciseMacroDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "counting with macros isn't really possible, so a recursive solution can't work here"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Procedural"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "More complicated logic"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Macro is given an input stream and returns a stream"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Parse input manually from the stream"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Implementation is in a separate crate"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Common use case: deriving trait implementations"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SerializePrelude, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _serializeDefault.default),
                focusOn: "21+5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _serializeDefault.default),
                focusOn: "27+9"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Common use case: deriving trait implementations"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SerializePrelude, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _serializeRev1Default.default),
                focusOn: "23+6",
                emphasize: "1"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Syn"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.DeriveInput), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.Data), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.DataStruct), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Most common way to parse Rust code"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "The entire Rust AST is exposed as structs and enums"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Can be tedious to pick through, but sure to not forget a case"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Quote"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _libRsDefault.default),
                focusOn: "25-33"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Quote"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _libRsDefault.default),
                focusOn: "25-33",
                emphasize: "2[23],5[12],5[29]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Uses ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "#"
                            }),
                            " instead of ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "$"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Quote is black magic, as far as I'm concerned"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _changeDeckDefault.default), {
                    deck: "overview",
                    children: "Return"
                })
            })
        ]
    });
}
function MDXContent(props = {}) {
    const { wrapper: MDXLayout } = props.components || {};
    return MDXLayout ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(MDXLayout, {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_createMdxContent, {
            ...props
        })
    }) : _createMdxContent(props);
}
function _missingMdxReference(id, component, place) {
    throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it." + (place ? "\nIt\u2019s referenced in your code at `" + place + "`" : ""));
}

},{"react/jsx-runtime":"afIHK","./Directives":"6Yemz","./ChangeDeck":"29Jlq","./layout/Splash":"1mDy7","./TestPattern":"g0BPT","./Transclude":"fUgcm","./Excerpts":"5uobq","rust:macros/old-try":"cDEph","rust:macros/hello-world":"4ptTY","rust:macros/arguments":"3FZk1","rust:macros/patterns":"bFxmd","rust:macros/repetition":"g1nCg","rust:macros/exercise-macro":"ajggo","rust:macros/serialize":"5mKhB","rust:macros/serialize?rev=1":"eOtxe","rust:macros/serialize/serialize-derive/src/lib.rs":"453uN","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"cDEph":[function(require,module,exports,__globalThis) {
module.exports = "macro_rules! old_try {\n    ($e: expr) => {\n        match $e {\n            Ok(v) => v,\n            Err(e) => return Err(e.into()),\n        }\n    };\n}\n\nfn a() -> Result<(), ()> {\n    old_try!(Result::<(), ()>::Ok(()));\n    Ok(())\n}\n\nfn main() {}\n";

},{}],"4ptTY":[function(require,module,exports,__globalThis) {
module.exports = "macro_rules! example {\n    () => {\n        println!(\"Hello, world!\")\n    };\n}\n\nfn main() {\n    example!();\n}\n";

},{}],"3FZk1":[function(require,module,exports,__globalThis) {
module.exports = "macro_rules! example {\n    (hi) => {\n        println!(\"hello\")\n    };\n    (bye) => {\n        println!(\"goodbye\")\n    };\n}\n\nfn main() {\n    example!(hi);\n    example!(bye);\n}\n";

},{}],"bFxmd":[function(require,module,exports,__globalThis) {
module.exports = "macro_rules! example {\n    ($arg: expr) => {\n        println!($arg)\n    };\n}\n\nfn main() {\n    example!(\"hello\");\n}\n";

},{}],"g1nCg":[function(require,module,exports,__globalThis) {
module.exports = "macro_rules! print_lines {\n    () => {};\n    ($e: expr) => { println!($e); };\n    ($e: expr, $($tail: expr),+) => {\n        print_lines!($e);\n        print_lines!($($tail),*);\n    };\n}\n\nfn main() {\n    print_lines!(\"a\", \"b\", \"c\");\n}\n";

},{}],"ajggo":[function(require,module,exports,__globalThis) {
module.exports = "macro_rules! times {\n    ($n: expr, $body: expr) => {\n        for _ in 0..$n {\n            $body\n        }\n    };\n}\n\nfn main() {\n    times!(3, println!(\"I think I can\"));\n}\n";

},{}],"5mKhB":[function(require,module,exports,__globalThis) {
module.exports = "trait Serialize {\n    fn to_bytes(&self) -> Vec<u8>;\n}\n\nimpl Serialize for u8 {\n    fn to_bytes(&self) -> Vec<u8> {\n        vec![8]\n    }\n}\nimpl Serialize for u16 {\n    fn to_bytes(&self) -> Vec<u8> {\n        vec![16]\n    }\n}\nimpl Serialize for u32 {\n    fn to_bytes(&self) -> Vec<u8> {\n        vec![32]\n    }\n}\n\nstruct MyStruct {\n    id: u8,\n    score: u16,\n    count: u32,\n}\n\nimpl Serialize for MyStruct {\n    fn to_bytes(&self) -> Vec<u8> {\n        let mut v = vec![];\n        v.extend(&self.id.to_bytes());\n        v.extend(&self.score.to_bytes());\n        v.extend(&self.count.to_bytes());\n        v\n    }\n}\n\nfn main() {\n    let s = MyStruct {\n        id: 0,\n        score: 0,\n        count: 0,\n    };\n    assert_eq!(s.to_bytes(), [8, 16, 32]);\n}\n";

},{}],"eOtxe":[function(require,module,exports,__globalThis) {
module.exports = "use serialize_derive::Serialize;\n\ntrait Serialize {\n    fn to_bytes(&self) -> Vec<u8>;\n}\n\nimpl Serialize for u8 {\n    fn to_bytes(&self) -> Vec<u8> {\n        vec![8]\n    }\n}\nimpl Serialize for u16 {\n    fn to_bytes(&self) -> Vec<u8> {\n        vec![16]\n    }\n}\nimpl Serialize for u32 {\n    fn to_bytes(&self) -> Vec<u8> {\n        vec![32]\n    }\n}\n\n#[derive(Serialize)]\nstruct MyStruct {\n    id: u8,\n    score: u16,\n    count: u32,\n}\n\nfn main() {\n    let s = MyStruct {\n        id: 0,\n        score: 0,\n        count: 0,\n    };\n    assert_eq!(s.to_bytes(), [8, 16, 32]);\n}\n";

},{}],"453uN":[function(require,module,exports,__globalThis) {
module.exports = "use proc_macro::TokenStream;\nuse quote::quote;\nuse syn::{parse_macro_input, Data, DeriveInput, Fields};\n\n#[proc_macro_derive(Serialize)]\npub fn serialize(input: TokenStream) -> TokenStream {\n    let input = parse_macro_input!(input as DeriveInput);\n\n    let expanded = expand_serialize(input);\n\n    TokenStream::from(expanded)\n}\n\nfn expand_serialize(input: DeriveInput) -> proc_macro2::TokenStream {\n    let type_name = input.ident;\n\n    let Data::Struct(data_struct) = input.data else {\n        panic!()\n    };\n    let Fields::Named(named_fields) = data_struct.fields else {\n        panic!()\n    };\n    let field_names = named_fields.named.into_iter().map(|f| f.ident);\n\n    quote! {\n        impl Serialize for #type_name {\n            fn to_bytes(&self) -> Vec<u8> {\n                let mut v = vec![];\n                #(v.extend(&self.#field_names.to_bytes());)*\n                v\n            }\n        }\n    }\n}\n";

},{}],"NpCky":[function(require,module,exports,__globalThis) {
/*@jsxRuntime automatic*/ /*@jsxImportSource react*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "title", ()=>title);
parcelHelpers.export(exports, "default", ()=>MDXContent);
var _jsxRuntime = require("react/jsx-runtime");
var _directives = require("./Directives");
var _changeDeck = require("./ChangeDeck");
var _changeDeckDefault = parcelHelpers.interopDefault(_changeDeck);
var _splash = require("./layout/Splash");
var _splashDefault = parcelHelpers.interopDefault(_splash);
var _testPattern = require("./TestPattern");
var _testPatternDefault = parcelHelpers.interopDefault(_testPattern);
var _transclude = require("./Transclude");
var _transcludeDefault = parcelHelpers.interopDefault(_transclude);
var _excerpts = require("./Excerpts");
var _dereferenceRawPointer = require("rust:ffi/dereference-raw-pointer");
var _dereferenceRawPointerDefault = parcelHelpers.interopDefault(_dereferenceRawPointer);
var _dereferenceRawPointer1 = require("stderr:ffi/dereference-raw-pointer");
var _dereferenceRawPointerDefault1 = parcelHelpers.interopDefault(_dereferenceRawPointer1);
var _dereferenceRawPointerRev1 = require("rust:ffi/dereference-raw-pointer?rev=1");
var _dereferenceRawPointerRev1Default = parcelHelpers.interopDefault(_dereferenceRawPointerRev1);
var _dereferenceRawPointerRev2 = require("rust:ffi/dereference-raw-pointer?rev=2");
var _dereferenceRawPointerRev2Default = parcelHelpers.interopDefault(_dereferenceRawPointerRev2);
var _callUnsafeFn = require("rust:ffi/call-unsafe-fn");
var _callUnsafeFnDefault = parcelHelpers.interopDefault(_callUnsafeFn);
var _whyUnsafe = require("rust:ffi/why-unsafe");
var _whyUnsafeDefault = parcelHelpers.interopDefault(_whyUnsafe);
var _whyUnsafe1 = require("stderr:ffi/why-unsafe");
var _whyUnsafeDefault1 = parcelHelpers.interopDefault(_whyUnsafe1);
var _pathological = require("rust:ffi/pathological");
var _pathologicalDefault = parcelHelpers.interopDefault(_pathological);
var _splitAtMut = require("rust:ffi/split-at-mut");
var _splitAtMutDefault = parcelHelpers.interopDefault(_splitAtMut);
var _exerciseStrangeIndexing = require("rust:ffi/exercise-strange-indexing");
var _exerciseStrangeIndexingDefault = parcelHelpers.interopDefault(_exerciseStrangeIndexing);
var _exerciseStrangeIndexingRev1 = require("rust:ffi/exercise-strange-indexing?rev=1");
var _exerciseStrangeIndexingRev1Default = parcelHelpers.interopDefault(_exerciseStrangeIndexingRev1);
var _exerciseStrangeIndexingRev2 = require("rust:ffi/exercise-strange-indexing?rev=2");
var _exerciseStrangeIndexingRev2Default = parcelHelpers.interopDefault(_exerciseStrangeIndexingRev2);
const title = "Unsafe code and interfacing with C";
function _createMdxContent(props) {
    const _components = {
        a: "a",
        code: "code",
        em: "em",
        h1: "h1",
        h2: "h2",
        hr: "hr",
        li: "li",
        p: "p",
        pre: "pre",
        ul: "ul",
        ...props.components
    }, { SplitSlides } = _components;
    if (!SplitSlides) _missingMdxReference("SplitSlides", true);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SplitSlides, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _testPatternDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Unsafe code and ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                    " interfacing with C"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "The tale of two languages"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Rust can be thought of as two related languages",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Safe Rust"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Unsafe Rust"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "What can you do in unsafe Rust?"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Dereference a raw pointer"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Call an unsafe function"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Implement an unsafe trait"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Read or write a mutable static variable"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Read a field of a union"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "You still can't do unsafe things"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "The compiler just can't ensure the safety"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Raw pointers"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "References (",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "&T"
                            }),
                            " / ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "&mut T"
                            }),
                            ")",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "Are never ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "NULL"
                                            })
                                        ]
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Always point to a valid value"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Have lifetimes"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Raw pointers (",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "*const T"
                            }),
                            " / ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "*mut T"
                            }),
                            ")",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "Can be ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "NULL"
                                            })
                                        ]
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Can point anywhere"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Do not have lifetimes"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Dereferencing a raw pointer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _dereferenceRawPointerDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _dereferenceRawPointerDefault1.default),
                lang: "compiler-error",
                focusOn: "1+8"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Dereferencing a raw pointer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _dereferenceRawPointerRev1Default.default),
                emphasize: "5[19+8],5[39+1]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Creating a reference"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _dereferenceRawPointerRev2Default.default),
                emphasize: "5[37+2]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "A note on using ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "unsafe"
                    }),
                    " blocks"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Document why ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.em, {
                                children: "this"
                            }),
                            " unsafe block is safe"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Show your preconditions and how you uphold them"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Debate on whether preconditions go inside the ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "unsafe"
                            }),
                            " block or not"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Debate on how big ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "unsafe"
                            }),
                            " blocks should be"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Calling an unsafe function"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _callUnsafeFnDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Calling an unsafe function"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _callUnsafeFnDefault.default),
                emphasize: "1[0+6]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "We cannot guarantee that this function is safe for any arbitrary pointer"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Unsafe code is used to build safe abstractions"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Vec"
                            }),
                            " uses unsafe code internally"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "You don't need unsafe code to use ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Vec"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Type and module systems keep unsafe code contained"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Safe Rust should never cause undefined behavior"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Why is unsafe Rust needed?"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _whyUnsafeDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _whyUnsafeDefault1.default),
                lang: "compiler-error",
                focusOn: "1+10"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "[]"
                            }),
                            " syntax is provided by a trait."
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "no guarantee that it returns different values"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "The pathological case"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _pathologicalDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "slice::split_at_mut"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _whyUnsafeDefault1.default),
                lang: "compiler-error",
                focusOn: "11+1"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _splitAtMutDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Will this compile?"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "slice::split_at_mut"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.SliceSplitAtMut), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.SliceSplitAtMutChecked), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "slice::split_at_mut"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.SliceSplitAtMutUnchecked), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Safety comments removed"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Exercise: Our own strange indexing"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Create a function that is given a mutable slice and an index"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Return a tuple of mutable references to the element before, at, and after the index"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Code like this should run:"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                                src: (0, _exerciseStrangeIndexingDefault.default),
                                focusOn: "16+6",
                                copyAllCode: false
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Bonus"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Write this by only calling safe functions"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One answer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _exerciseStrangeIndexingDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One answer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _exerciseStrangeIndexingRev1Default.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One answer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _exerciseStrangeIndexingRev2Default.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "The Foreign Function Interface (FFI)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Allows leveraging entire C ecosystem"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "As well as any other language with a C API"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "C is the Lingua Franca"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.em, {
                    children: "The Rust FFI Omnibus"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                    href: "http://jakegoulding.com/rust-ffi-omnibus/",
                    children: "jakegoulding.com/rust-ffi-omnibus/"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Module structure"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-rust",
                    children: "mod awesome {\n    mod ffi {\n        // Declarations of the C functions\n    }\n\n    // Rust abstractions on top of the C functions\n}\n\n// Usage of the Rust abstractions\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Using the module system and visibility to our advantage"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "In real code, would recommend putting the ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "ffi"
                            }),
                            " module in a separate crate"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Has to do with single linking of a C library"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "extern"
                    }),
                    " blocks"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-rust",
                    children: "unsafe extern \"C\" {\n    pub fn awesome_version() -> c_int;\n}\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Declares external functions / arguments / return types"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Technically the ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "\"C\""
                            }),
                            " isn't needed, but it's recommended"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "unsafe"
                            }),
                            " is new as of Rust 2024"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Only certain types are valid to pass across FFI"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Have been annotated with ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "#[repr(C)]"
                            }),
                            "."
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Common building blocks are available in ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "core::ffi"
                            }),
                            "."
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "C strings"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                            children: "char *"
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Undefined encoding, but UTF-8 (or ASCII) is common on macOS and Linux"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "NUL-terminated"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Rust strings"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "&str"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "String"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Encoded in UTF-8"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "May contain embedded NULs"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Converting strings"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                            children: "std::ffi::CStr"
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Can convert a ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "char *"
                            }),
                            " to a ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "&str"
                            }),
                            "."
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Is that a ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "char *"
                    }),
                    " or a ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "char *"
                    }),
                    "?"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Should you free a ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "char *"
                            }),
                            "?"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "How do you free a ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "char *"
                            }),
                            "?"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "While it's annoying that Rust has multiple string types, it's better than the alternative"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Freeing a string"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "libc"
                            }),
                            " crate declares functions from the C library"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Add it to your crate with ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "cargo add libc"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Also provides type aliases for the current platform"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Exercise: Write a Rust binding for ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "awesome_features_enabled"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                            href: "https://gitlab.com/integer32llc/ffi-training-code/",
                            children: "gitlab.com/integer32llc/ffi-training-code"
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Add the appropriate ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "extern"
                            }),
                            " function definition (and any needed types)"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Write a safe Rust wrapper and print out the value"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Call the wrapper from main"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "How long is the string valid for?"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Touch on lifetime ambiguity"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One answer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Available at tag ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                                href: "https://gitlab.com/integer32llc/ffi-training-code/-/blob/step-1/src/main.rs",
                                children: "step-1"
                            }),
                            " (",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                                href: "https://gitlab.com/integer32llc/ffi-training-code/-/compare/step-0...step-1",
                                children: "diff"
                            }),
                            ")"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Casting between primitive types"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Use the ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "as"
                            }),
                            " keyword"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Can cast",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "between integers and floats"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                                        children: [
                                            "from ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "bool"
                                            }),
                                            " and ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                                children: "char"
                                            }),
                                            " to integers"
                                        ]
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "between pointers and pointers"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "between pointers and addresses"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "from C-style enums to integers"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "C-style enums"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-rust",
                    children: "enum Days {\n    Monday = 1,\n    Tuesday = 2,\n}\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-rust",
                    children: "Days::Monday as u8\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Alternatives to ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "as"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Into::into"
                            }),
                            " and ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "TryInto::try_into"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                            children: "pointer::cast"
                        })
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "as"
                            }),
                            " is a big hammer, and more scoped tools may be useful"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Exercise: Write a Rust binding for ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "awesome_greeting"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Add the appropriate ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "extern"
                            }),
                            " function definition (and any needed types)"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Write a safe Rust wrapper and ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.em, {
                                children: "return"
                            }),
                            " the value"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Print the value from main"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Hints"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Don't leak any memory"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One answer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Available at tag ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                                href: "https://gitlab.com/integer32llc/ffi-training-code/-/blob/step-2/src/main.rs",
                                children: "step-2"
                            }),
                            " (",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                                href: "https://gitlab.com/integer32llc/ffi-training-code/-/compare/step-1...step-2",
                                children: "diff"
                            }),
                            ")"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "*mut T"
                    }),
                    " vs ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "*const T"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Unlike references (",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "&T"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "&mut T"
                            }),
                            "), these are more what you'd call \"guidelines\" than actual rules"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Can cast back and forth with ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "as"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Recommend using the type that's closer to your intention"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Opaque types / pointers"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Common practice to hide details of implementation"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.p, {
                                children: [
                                    "Often done via ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.em, {
                                        children: "opaque pointer"
                                    })
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Often something like"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                    className: "language-c",
                                    children: "typedef struct awesome_type awesome_type_t;\n"
                                })
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Opaque types in Rust"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Using the type system is wonderful"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Not a great solution today"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.p, {
                                children: [
                                    "Represented as an non-creatable, zero-sized, ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                        children: "repr(C)"
                                    }),
                                    " type that opts-out of default traits:"
                                ]
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                    className: "language-rust",
                                    children: "#[repr(C)]\npub struct MyOpaqueType {\n    _data: (),\n    _marker: core::marker::PhantomData<(*mut u8, core::marker::PhantomPinned)>,\n}\n"
                                })
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "In the future, will have nice syntax:"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                    className: "language-rust",
                                    children: "unsafe extern \"C\" {\n    type MyOpaqueType;\n}\n"
                                })
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Use this type in the FFI signatures as a pointer"
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Drop"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Responsible for cleanup of a type when it goes out of scope"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "It's a trait, but a little special treatment by the compiler"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                    className: "language-rust",
                                    children: "impl Drop for MyType {\n    fn drop(&mut self) {\n        todo!();\n    }\n}\n"
                                })
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Leaking memory is ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.em, {
                        children: "safe"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "It's not expected that a value will be leaked, but it's possible."
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Memory safety should never rely on ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Drop"
                            }),
                            " being run"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Exercise: Write a Rust binding for ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "awesome_new"
                    }),
                    " and ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "awesome_free"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Add the appropriate ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "extern"
                            }),
                            " function definitions (and any needed types)"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Write a safe Rust type that calls ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "awesome_new"
                            }),
                            " and ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "awesome_free"
                            }),
                            " appropriately",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Only these functions, for now"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Construct this type from main"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One answer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Available at tag ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                                href: "https://gitlab.com/integer32llc/ffi-training-code/-/blob/step-3/src/main.rs",
                                children: "step-3"
                            }),
                            " (",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                                href: "https://gitlab.com/integer32llc/ffi-training-code/-/compare/step-2...step-3",
                                children: "diff"
                            }),
                            ")"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Lifetimes and FFI"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Most C code doesn't state lifetimes"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "In many cases, a pointer lasts as long as the object"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Same as equivalent Rust code:"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                    className: "language-rust",
                                    children: "fn foo(&self) -> &SomeType { /* ... */ }\n// Same as\nfn foo<'a>(&'a self) -> &'a SomeType { /* ... */ }\n"
                                })
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Mutating the object may invalidate the pointer!"
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "If you are lucky, the function has documentation, it mentions lifetimes, and is still accurate."
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Exercise: Write a Rust binding for ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "awesome_value"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Add the appropriate ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "extern"
                            }),
                            " function definitions (and any needed types)"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Add a safe method to the Rust type that calls ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "awesome_value"
                            }),
                            " appropriately"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Call the method in main, print out the value, change the value, print it out again"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One answer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Available at tag ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                                href: "https://gitlab.com/integer32llc/ffi-training-code/-/blob/step-4/src/main.rs",
                                children: "step-4"
                            }),
                            " (",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                                href: "https://gitlab.com/integer32llc/ffi-training-code/-/compare/step-3...step-4",
                                children: "diff"
                            }),
                            ")"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Multiple return values"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "C has no concept of this"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Instead, pass in one or more pointer"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Sometimes called \"out params\""
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Uninitialized data"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "C allows variables to be uninitialized:"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                    className: "language-c",
                                    children: "int foo;\n"
                                })
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.p, {
                                children: [
                                    "If needed in Rust, can use ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                        children: "mem::MaybeUninit"
                                    })
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Highly and subtly unsafe"
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "If possible, initialize values anyway."
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "C arrays"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "C does not have a standard way of passing arrays of data."
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Usually a pointer and a length"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Sometimes sentinel-terminated"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Constructing Slices"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.SliceFromRawParts), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _excerpts.SliceFromRawPartsMut), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.h1, {
                children: [
                    "Exercise: Write a Rust binding for ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                        children: "awesome_values"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Add the appropriate ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "extern"
                            }),
                            " function definitions (and any needed types)"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Add a safe method to the Rust type that calls ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "awesome_values"
                            }),
                            " appropriately"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Call the method in main, print out the sum of all the values, change the value, print it out again"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "One answer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Available at tag ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                                href: "https://gitlab.com/integer32llc/ffi-training-code/-/blob/step-5/src/main.rs",
                                children: "step-5"
                            }),
                            " (",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                                href: "https://gitlab.com/integer32llc/ffi-training-code/-/compare/step-4...step-5",
                                children: "diff"
                            }),
                            ")"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Tools"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                                    href: "https://rust-lang.github.io/rust-bindgen/",
                                    children: "bindgen"
                                })
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Automatically generates Rust FFI bindings to C (and some C++) libraries."
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                                    href: "https://github.com/mozilla/cbindgen",
                                    children: "cbindgen"
                                })
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "A project for generating C bindings from Rust code"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                                    href: "https://c2rust.com",
                                    children: "c2rust"
                                })
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "C to Rust translation, refactoring, and cross-checking"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Language-specific tools"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                            href: "https://cxx.rs",
                            children: "CXX"
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                            href: "https://napi.rs",
                            children: "NAPI-RS"
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                            href: "https://pyo3.rs/",
                            children: "PyO3"
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                            href: "https://docs.rs/crate/rustler/latest",
                            children: "rustler"
                        })
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "When you have a fixed target, you can usually get a tighter integration"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                    href: "https://docs.google.com/forms/d/e/1FAIpQLSccrAL8ctnfg_uabvek1_6kFpBTUl51QJwLYqsMkKjs3URG8w/viewform?usp=publish-editor",
                    children: "Quiz"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _changeDeckDefault.default), {
                    deck: "overview",
                    children: "Return"
                })
            })
        ]
    });
}
function MDXContent(props = {}) {
    const { wrapper: MDXLayout } = props.components || {};
    return MDXLayout ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(MDXLayout, {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_createMdxContent, {
            ...props
        })
    }) : _createMdxContent(props);
}
function _missingMdxReference(id, component, place) {
    throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it." + (place ? "\nIt\u2019s referenced in your code at `" + place + "`" : ""));
}

},{"react/jsx-runtime":"afIHK","./Directives":"6Yemz","./ChangeDeck":"29Jlq","./layout/Splash":"1mDy7","./TestPattern":"g0BPT","./Transclude":"fUgcm","./Excerpts":"5uobq","rust:ffi/dereference-raw-pointer":"cqnSf","stderr:ffi/dereference-raw-pointer":"fWrGq","rust:ffi/dereference-raw-pointer?rev=1":"h5XIg","rust:ffi/dereference-raw-pointer?rev=2":"j5BY2","rust:ffi/call-unsafe-fn":"gF0qK","rust:ffi/why-unsafe":"zPDIr","stderr:ffi/why-unsafe":"jx1ac","rust:ffi/pathological":"ehB2D","rust:ffi/split-at-mut":"5SGjb","rust:ffi/exercise-strange-indexing":"5Ls43","rust:ffi/exercise-strange-indexing?rev=1":"cccWg","rust:ffi/exercise-strange-indexing?rev=2":"l1gaw","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"cqnSf":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let value: i32 = 42;\n    let value_ref: &i32 = &value;\n    let value_ptr: *const i32 = value_ref;\n    println!(\"{}\", *value_ptr);\n}\n";

},{}],"fWrGq":[function(require,module,exports,__globalThis) {
module.exports = "error[E0133]: dereference of raw pointer is unsafe and requires unsafe block\n --> dereference-raw-pointer/src/main.rs:6:20\n  |\n6 |     println!(\"{}\", *value_ptr);\n  |                    ^^^^^^^^^^ dereference of raw pointer\n  |\n  = note: raw pointers may be null, dangling or unaligned; they can violate aliasing rules and\n  =       cause data races: all of these are undefined behavior\n\nFor more information about this error, try `rustc --explain E0133`.\nerror: could not compile `dereference-raw-pointer` (bin \"dereference-raw-pointer\") due to 1\n       previous error\n";

},{}],"h5XIg":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let value: i32 = 42;\n    let value_ref: &i32 = &value;\n    let value_ptr: *const i32 = value_ref;\n    println!(\"{}\", unsafe { *value_ptr });\n}\n";

},{}],"j5BY2":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let value: i32 = 42;\n    let value_ref: &i32 = &value;\n    let value_ptr: *const i32 = value_ref;\n    let another_ref: &i32 = unsafe { &*value_ptr };\n}\n";

},{}],"gF0qK":[function(require,module,exports,__globalThis) {
module.exports = "unsafe fn print_a_pointer_value(ptr: *const i32) {\n    println!(\"{}\", unsafe { *ptr });\n}\n\nfn main() {\n    let value: i32 = 42;\n    let value_ref: &i32 = &value;\n    let value_ptr: *const i32 = value_ref;\n    // This pointer is valid because it's immutable and the value will\n    // be in scope until the end of the function.\n    unsafe {\n        print_a_pointer_value(value_ptr);\n    }\n}\n";

},{}],"zPDIr":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let mut scores = [1, 2, 3];\n    let score1 = &mut scores[0];\n    let score2 = &mut scores[1];\n    println!(\"Duplicate score? {}\", score1 == score2);\n}\n";

},{}],"jx1ac":[function(require,module,exports,__globalThis) {
module.exports = "error[E0499]: cannot borrow `scores[_]` as mutable more than once at a time\n --> why-unsafe/src/main.rs:4:18\n  |\n3 |     let score1 = &mut scores[0];\n  |                  -------------- first mutable borrow occurs here\n4 |     let score2 = &mut scores[1];\n  |                  ^^^^^^^^^^^^^^ second mutable borrow occurs here\n5 |     println!(\"Duplicate score? {}\", score1 == score2);\n  |                                     ------ first borrow later used here\n  |\n  = help: use `.split_at_mut(position)` to obtain two mutable non-overlapping sub-slices\n\nFor more information about this error, try `rustc --explain E0499`.\nerror: could not compile `why-unsafe` (bin \"why-unsafe\") due to 1 previous error\n";

},{}],"ehB2D":[function(require,module,exports,__globalThis) {
module.exports = "use std::ops::{Index, IndexMut};\n\nstruct One(u8);\n\nimpl Index<usize> for One {\n    type Output = u8;\n\n    fn index(&self, _idx: usize) -> &u8 {\n        &self.0\n    }\n}\n\nimpl IndexMut<usize> for One {\n    fn index_mut(&mut self, _idx: usize) -> &mut u8 {\n        &mut self.0\n    }\n}\n\nfn main() {\n    let mut o = One(42);\n    let a = &mut o[0];\n    let b = &mut o[1];\n    println!(\"Same? {}\", a == b);\n}\n";

},{}],"5SGjb":[function(require,module,exports,__globalThis) {
module.exports = "fn main() {\n    let mut scores = [1, 2, 3];\n    let (a, b) = scores.split_at_mut(1);\n    let score1 = &mut a[0];\n    let score2 = &mut b[0];\n    println!(\"Duplicate score? {}\", score1 == score2);\n}\n";

},{}],"5Ls43":[function(require,module,exports,__globalThis) {
module.exports = "fn trio<T>(s: &mut [T], idx: usize) -> (&mut T, &mut T, &mut T) {\n    let start = s.as_mut_ptr();\n\n    let i0 = idx.strict_sub(1); // Checks `idx >= 1`\n    let i1 = idx;\n    let i2 = idx.strict_add(1); // Checks `idx < usize::MAX`\n\n    assert!(i2 < s.len()); // Checks `idx + 1` is in-bounds\n\n    unsafe {\n        let a = start.add(i0);\n        let b = start.add(i1);\n        let c = start.add(i2);\n        (&mut *a, &mut *b, &mut *c)\n    }\n}\n\nfn main() {\n    let mut scores = [1, 2, 3];\n    let (a, b, c) = trio(&mut scores, 1);\n    *a = 10;\n    *b = 100;\n    *c = 1000;\n    assert_eq!(scores, [10, 100, 1000]);\n}\n";

},{}],"cccWg":[function(require,module,exports,__globalThis) {
module.exports = "fn trio<T>(s: &mut [T], idx: usize) -> (&mut T, &mut T, &mut T) {\n    let (a, b) = s.split_at_mut(idx);\n    let (b, c) = b.split_at_mut(1);\n    (a.last_mut().unwrap(), b.first_mut().unwrap(), c.first_mut().unwrap())\n}\n\nfn main() {\n    let mut scores = [1, 2, 3];\n    let (a, b, c) = trio(&mut scores, 1);\n    *a = 10;\n    *b = 100;\n    *c = 1000;\n    assert_eq!(scores, [10, 100, 1000]);\n}\n";

},{}],"l1gaw":[function(require,module,exports,__globalThis) {
module.exports = "fn trio<T>(s: &mut [T], idx: usize) -> (&mut T, &mut T, &mut T) {\n    s.get_disjoint_mut([idx - 1, idx, idx + 1]).unwrap().into()\n}\n\nfn main() {\n    let mut scores = [1, 2, 3];\n    let (a, b, c) = trio(&mut scores, 1);\n    *a = 10;\n    *b = 100;\n    *c = 1000;\n    assert_eq!(scores, [10, 100, 1000]);\n}\n";

},{}],"klxCd":[function(require,module,exports,__globalThis) {
/*@jsxRuntime automatic*/ /*@jsxImportSource react*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "title", ()=>title);
parcelHelpers.export(exports, "default", ()=>MDXContent);
var _jsxRuntime = require("react/jsx-runtime");
var _directives = require("./Directives");
var _changeDeck = require("./ChangeDeck");
var _changeDeckDefault = parcelHelpers.interopDefault(_changeDeck);
var _splash = require("./layout/Splash");
var _splashDefault = parcelHelpers.interopDefault(_splash);
var _testPattern = require("./TestPattern");
var _testPatternDefault = parcelHelpers.interopDefault(_testPattern);
var _transclude = require("./Transclude");
var _transcludeDefault = parcelHelpers.interopDefault(_transclude);
var _embeddedRs = require("rust:extracted/embedded.rs");
var _embeddedRsDefault = parcelHelpers.interopDefault(_embeddedRs);
const title = "Embedded development";
function _createMdxContent(props) {
    const _components = {
        a: "a",
        code: "code",
        h1: "h1",
        h2: "h2",
        hr: "hr",
        li: "li",
        p: "p",
        pre: "pre",
        ul: "ul",
        ...props.components
    }, { SplitSlides } = _components;
    if (!SplitSlides) _missingMdxReference("SplitSlides", true);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SplitSlides, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _testPatternDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Embedded development"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Cross-compiling"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                children: "All Rust compilers are cross-compilers"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-compiler-output",
                    children: "% cargo build --target=thumbv7em-none-eabihf\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "But the standard library isn't always available"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-compiler-error",
                    children: "error[E0463]: can't find crate for `std`\n  |\n  = note: the `thumbv7em-none-eabihf` target may not be installed\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "The standard library is a fac\u0327ade"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Platform interaction"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Re-exports APIs from lower-level crates",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                            children: "libcore"
                                        })
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                            children: "liballoc"
                                        })
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "libcore"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Dependency-free"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Platform agnostic"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Fundamental traits and types"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Methods for primitive types"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    children: "liballoc"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Heap-allocated values",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Smart pointers"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Collections"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Important websites"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                                    href: "https://rust-embedded.github.io/discovery/",
                                    children: "The Discovery Book"
                                })
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                                            href: "https://github.com/rust-embedded/discovery/",
                                            children: "micro::bit v2"
                                        })
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                                    href: "https://rust-embedded.github.io/book/",
                                    children: "The Embedded Book"
                                })
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Install new tools"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "libcore"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-compiler-output",
                    children: "% rustup target add thumbv7em-none-eabihf\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "There's also a tool called Xargo that helps compile your own libcore/liballoc/libstd"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Install new tools"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "cargo-embed"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-compiler-output",
                    children: "% cargo install cargo-embed\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Flashes the board"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Provides a local GDB server"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Install new tools"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "minicom"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-compiler-output",
                    children: "# macOS\n% brew install minicom\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Connects to serial device"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Install new tools"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "GDB"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-compiler-output",
                    children: "# macOS\n% brew tap ArmMbed/homebrew-formulae\n% brew install arm-none-eabi-gcc\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Connects to cargo-embed to allow breakpoints and stepping"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Differences for embedded code"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "src/05-led-roulette/src/main.rs"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _embeddedRsDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Differences for embedded code"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "src/05-led-roulette/src/main.rs"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _embeddedRsDefault.default),
                emphasize: "1"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "deny"
                            }),
                            " - changes warning into an error"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Not 100% sure why they have this, but I think it's mostly to prove a point"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Differences for embedded code"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "src/05-led-roulette/src/main.rs"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _embeddedRsDefault.default),
                emphasize: "2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "no_main"
                            }),
                            " - Disables the standard Rust entrypoint"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Differences for embedded code"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "src/05-led-roulette/src/main.rs"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _embeddedRsDefault.default),
                emphasize: "3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "no_std"
                            }),
                            " - prevents linking to the standard library"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Differences for embedded code"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "src/05-led-roulette/src/main.rs"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _embeddedRsDefault.default),
                emphasize: "5,9"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "entry"
                            }),
                            " is a procedural macro that rewrites the ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "main"
                            }),
                            " function to be a valid entrypoint"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Differences for embedded code"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "src/05-led-roulette/src/main.rs"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _embeddedRsDefault.default),
                emphasize: "10[10+4],15,16"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "!"
                            }),
                            " is the never type - function must not return"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "First program"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Build and load the code"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-compiler-output",
                    children: "% cargo embed --features v2 --target thumbv7em-none-eabihf\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-compiler-output",
                    children: "% gdb target/thumbv7em-none-eabihf/debug/led-roulette\n\n(gdb) target remote :1337\n...\n(gdb) break main\n...\n(gdb) c\nContinuing.\n\nBreakpoint 1, led_roulette::__cortex_m_rt_main_trampoline () at src/05-led-roulette/src/main.rs:9\n9   #[entry]\n(gdb) s\nled_roulette::__cortex_m_rt_main () at src/05-led-roulette/src/main.rs:12\n12      let x = 42;\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "In two windows"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Doing something useful"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Goal: blink the lights in some interesting way"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "How do we access the lights?"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.pre, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                    className: "language-compiler-output",
                    children: "cargo doc --target thumbv7em-none-eabihf --features v2 --open\n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Live coding"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Talk about?",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "volatile reads / writes"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "types for safety"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: ".cargo/config file"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "GDB init file"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "RTOS"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                            href: "https://arewertosyet.com",
                            children: "Are We RTOS Yet?"
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                            href: "https://github.com/embassy-rs/embassy",
                            children: "Embassy"
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                            href: "https://www.tockos.org/",
                            children: "Tock"
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                            href: "https://rtic.rs/",
                            children: "RTIC"
                        })
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "These can vary in how much they are \"RT\" and \"OS\""
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _changeDeckDefault.default), {
                    deck: "overview",
                    children: "Return"
                })
            })
        ]
    });
}
function MDXContent(props = {}) {
    const { wrapper: MDXLayout } = props.components || {};
    return MDXLayout ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(MDXLayout, {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_createMdxContent, {
            ...props
        })
    }) : _createMdxContent(props);
}
function _missingMdxReference(id, component, place) {
    throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it." + (place ? "\nIt\u2019s referenced in your code at `" + place + "`" : ""));
}

},{"react/jsx-runtime":"afIHK","./Directives":"6Yemz","./ChangeDeck":"29Jlq","./layout/Splash":"1mDy7","./TestPattern":"g0BPT","./Transclude":"fUgcm","rust:extracted/embedded.rs":"fScEw","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"fScEw":[function(require,module,exports,__globalThis) {
module.exports = "#![deny(unsafe_code)]\n#![no_main]\n#![no_std]\n\nuse cortex_m_rt::entry;\nuse panic_halt as _;\nuse microbit as _;\n\n#[entry]\nfn main() -> ! {\n    let _y;\n    let x = 42;\n    _y = x;\n\n    // infinite loop; just so we don't leave this stack frame\n    loop {}\n}\n";

},{}],"60Nom":[function(require,module,exports,__globalThis) {
/*@jsxRuntime automatic*/ /*@jsxImportSource react*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "title", ()=>title);
parcelHelpers.export(exports, "default", ()=>MDXContent);
var _jsxRuntime = require("react/jsx-runtime");
var _directives = require("./Directives");
var _changeDeck = require("./ChangeDeck");
var _changeDeckDefault = parcelHelpers.interopDefault(_changeDeck);
var _splash = require("./layout/Splash");
var _splashDefault = parcelHelpers.interopDefault(_splash);
var _testPattern = require("./TestPattern");
var _testPatternDefault = parcelHelpers.interopDefault(_testPattern);
var _transclude = require("./Transclude");
var _transcludeDefault = parcelHelpers.interopDefault(_transclude);
var _cycle = require("rust:tetramem/cycle");
var _cycleDefault = parcelHelpers.interopDefault(_cycle);
var _cycle1 = require("stderr:tetramem/cycle");
var _cycleDefault1 = parcelHelpers.interopDefault(_cycle1);
var _cycleRev1 = require("rust:tetramem/cycle?rev=1");
var _cycleRev1Default = parcelHelpers.interopDefault(_cycleRev1);
var _cycleRev2 = require("rust:tetramem/cycle?rev=2");
var _cycleRev2Default = parcelHelpers.interopDefault(_cycleRev2);
var _cycleRev21 = require("stderr:tetramem/cycle?rev=2");
var _cycleRev2Default1 = parcelHelpers.interopDefault(_cycleRev21);
var _cycleRev3 = require("rust:tetramem/cycle?rev=3");
var _cycleRev3Default = parcelHelpers.interopDefault(_cycleRev3);
var _cycleRev4 = require("rust:tetramem/cycle?rev=4");
var _cycleRev4Default = parcelHelpers.interopDefault(_cycleRev4);
var _cycleRev41 = require("stderr:tetramem/cycle?rev=4");
var _cycleRev4Default1 = parcelHelpers.interopDefault(_cycleRev41);
var _cycleRev5 = require("rust:tetramem/cycle?rev=5");
var _cycleRev5Default = parcelHelpers.interopDefault(_cycleRev5);
var _cycleRev6 = require("rust:tetramem/cycle?rev=6");
var _cycleRev6Default = parcelHelpers.interopDefault(_cycleRev6);
const title = "TetraMem";
function _createMdxContent(props) {
    const _components = {
        a: "a",
        code: "code",
        h1: "h1",
        h2: "h2",
        hr: "hr",
        li: "li",
        p: "p",
        ul: "ul",
        ...props.components
    }, { SplitSlides } = _components;
    if (!SplitSlides) _missingMdxReference("SplitSlides", true);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SplitSlides, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _testPatternDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "TetraMem"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Arenas"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "Primarily used for performance"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Amortizes memory allocations and deallocations"
                                    }),
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Benefits from cache locality"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.p, {
                                children: "No free lunch"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Memory usage grows"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Best fit with plain-old-data types, otherwise still have O(N) ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Drop"
                            }),
                            " calls"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Caution for false sharing if used in multithreaded mutation"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Rust-specific benefits"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Allocated values all share the same lifetime"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Allocation method may not need ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "&mut"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Cycles"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _cycleDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Cycles"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _cycleDefault.default),
                focusOn: "17+7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _cycleDefault1.default),
                lang: "compiler-error",
                focusOn: "1+11"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Requires mutable reference while already borrowed"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Add interior mutability"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _cycleRev1Default.default),
                emphasize: "1,5[19+5],5[45+1],6[20+5],6[46+1],13[31+7],14[32+7]20[4+8],21[4+9],23[23+5],23[40+1],24[23+5],24[39+1]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "This works, but the number of houses is fixed at compile time as\neach is a separate variable."
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Make it dynamic"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _cycleRev2Default.default),
                focusOn: "19+8",
                emphasize: "2,3[15+16],3[44+1],4[16+16],4[45+1]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Vec::push_mut"
                            }),
                            " is relatively new"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _cycleRev2Default1.default),
                lang: "compiler-error",
                focusOn: "1+10"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Can't add second item because pushing (and reallocating) might\ninvalidate references to the first item"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Get all references at once"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _cycleRev3Default.default),
                focusOn: "19+12",
                emphasize: "3,4[11+4],5,6[11+4],8"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Let intermediate references be invalidated; this compiles"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Get all references at once"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _cycleRev4Default.default),
                focusOn: "19+14",
                emphasize: "13"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Continue), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _cycleRev4Default1.default),
                lang: "compiler-error",
                focusOn: "1+11"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Can't add any more; we are back where we started"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Limited as the number of indices is fixed at compile time"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Arenas to the rescue"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _cycleRev5Default.default),
                focusOn: "3+2,21+10",
                emphasize: "1,4,5[22+5],6[23+5]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Arena::alloc"
                            }),
                            " takes in ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "&self"
                            }),
                            " as there's no way it will invalidate previous references"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Indices to the rescue"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcludeDefault.default), {
                src: (0, _cycleRev6Default.default),
                focusOn: "3+6,19+12",
                emphasize: "3[31+5],4[32+5],14[4+12],15[4+13]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "This is trivially available and memory safe"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Introduces fallibility, here via the panic during indexing"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Lookups may be slower due to indirection"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Possibility of index confusion via ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "usize"
                            }),
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Encourage newtyping"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Index can be invalidated via typical ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Vec"
                            }),
                            " methods"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "\"Arena\" is a broad term"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                            href: "https://donsz.nl/blog/arenas",
                            children: "https://donsz.nl/blog/arenas"
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "What is returned from allocation?",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Reference vs index"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.li, {
                        children: [
                            "Can elements be freed?",
                            "\n",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                                children: [
                                    "\n",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                                        children: "Is accidental reuse of indices prevented?"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.Notes), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Reuse of indices often called the ABA problem"
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Topic sm\xf6rg\xe5sbord"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Dynamic dispatch"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Explicit enums (closed set) vs dyn trait (open set)"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                            href: "https://docs.rs/enum_dispatch/",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "enum_dispatch"
                            })
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                            href: "https://doc.rust-lang.org/stable/std/any/trait.Any.html",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "dyn Any"
                            })
                        })
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Topic sm\xf6rg\xe5sbord"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Interesting types"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                            href: "https://doc.rust-lang.org/stable/std/marker/struct.PhantomData.html",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "PhantomData"
                            })
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                            href: "https://doc.rust-lang.org/stable/std/cell/struct.UnsafeCell.html",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "UnsafeCell"
                            })
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                            href: "https://doc.rust-lang.org/stable/std/pin/struct.Pin.html",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "Pin"
                            })
                        })
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Topic sm\xf6rg\xe5sbord"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Performance"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                            href: "https://doc.rust-lang.org/beta/reference/attributes/codegen.html#r-attributes.codegen.inline",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "#[inline]"
                            })
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                            href: "https://doc.rust-lang.org/stable/std/hint/fn.cold_path.html",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "cold_path"
                            })
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                            href: "https://doc.rust-lang.org/stable/std/hint/fn.assert_unchecked.html",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "assert_unchecked"
                            })
                        })
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Topic sm\xf6rg\xe5sbord"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Building"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: "Crates are the unit of compilation"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                            href: "https://doc.rust-lang.org/cargo/reference/workspaces.html",
                            children: "Cargo workspaces"
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                            href: "https://doc.rust-lang.org/cargo/reference/timings.html",
                            children: "Build timing"
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                            href: "https://doc.rust-lang.org/cargo/reference/profiles.html#lto",
                            children: "Link-time optimization (LTO)"
                        })
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: "Topic sm\xf6rg\xe5sbord"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h2, {
                children: "Third party tools"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_components.ul, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                            href: "https://crates.io/crates/cargo-audit",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "cargo audit"
                            })
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                            href: "https://crates.io/crates/cargo-crev",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "cargo crev"
                            })
                        })
                    }),
                    "\n",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.li, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.a, {
                            href: "https://crates.io/crates/cargo-geiger",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.code, {
                                children: "cargo geiger"
                            })
                        })
                    }),
                    "\n"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.hr, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directives.SlideLayout), {
                use: (0, _splashDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.h1, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _changeDeckDefault.default), {
                    deck: "overview",
                    children: "Return"
                })
            })
        ]
    });
}
function MDXContent(props = {}) {
    const { wrapper: MDXLayout } = props.components || {};
    return MDXLayout ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(MDXLayout, {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_createMdxContent, {
            ...props
        })
    }) : _createMdxContent(props);
}
function _missingMdxReference(id, component, place) {
    throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it." + (place ? "\nIt\u2019s referenced in your code at `" + place + "`" : ""));
}

},{"react/jsx-runtime":"afIHK","./Directives":"6Yemz","./ChangeDeck":"29Jlq","./layout/Splash":"1mDy7","./TestPattern":"g0BPT","./Transclude":"fUgcm","rust:tetramem/cycle":"4U42P","stderr:tetramem/cycle":"fqTiA","rust:tetramem/cycle?rev=1":"jYGXz","rust:tetramem/cycle?rev=2":"iWX49","stderr:tetramem/cycle?rev=2":"cebWX","rust:tetramem/cycle?rev=3":"7zhbp","rust:tetramem/cycle?rev=4":"6rYRt","stderr:tetramem/cycle?rev=4":"9a1Fx","rust:tetramem/cycle?rev=5":"cmYmI","rust:tetramem/cycle?rev=6":"jryco","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"4U42P":[function(require,module,exports,__globalThis) {
module.exports = "struct House<'a> {\n    occupants: u8,\n    left_neighbor: Option<&'a House<'a>>,\n    right_neighbor: Option<&'a House<'a>>,\n}\n\nimpl<'a> House<'a> {\n    fn new(occupants: u8) -> Self {\n        House {\n            occupants,\n            left_neighbor: None,\n            right_neighbor: None,\n        }\n    }\n}\n\nfn main() {\n    let mut left = House::new(1);\n    let mut right = House::new(2);\n\n    left.right_neighbor = Some(&right);\n    right.left_neighbor = Some(&left);\n}\n";

},{}],"fqTiA":[function(require,module,exports,__globalThis) {
module.exports = "error[E0506]: cannot assign to `right.left_neighbor` because it is borrowed\n  --> cycle/src/main.rs:67:5\n   |\n66 |     left.right_neighbor = Some(&right);\n   |                                ------ `right.left_neighbor` is borrowed\n   |                                       here\n67 |     right.left_neighbor = Some(&left);\n   |     ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n   |     |\n   |     `right.left_neighbor` is assigned to here but it was already borrowed\n   |     borrow later used here\n\nwarning: value assigned to `right` is never read\n  --> cycle/src/main.rs:67:5\n   |\n67 |     right.left_neighbor = Some(&left);\n   |     ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n   |\n   = help: maybe it is overwritten before being read?\n   = note: `#[warn(unused_assignments)]` (part of `#[warn(unused)]`) on by\n   =       default\n\nFor more information about this error, try `rustc --explain E0506`.\nerror: could not compile `cycle` (bin \"cycle\") due to 1 previous error; 1\n       warning emitted\n";

},{}],"jYGXz":[function(require,module,exports,__globalThis) {
module.exports = "use std::cell::Cell;\n\nstruct House<'a> {\n    occupants: u8,\n    left_neighbor: Cell<Option<&'a House<'a>>>,\n    right_neighbor: Cell<Option<&'a House<'a>>>,\n}\n\nimpl<'a> House<'a> {\n    fn new(occupants: u8) -> Self {\n        House {\n            occupants,\n            left_neighbor: None.into(),\n            right_neighbor: None.into(),\n        }\n    }\n}\n\nfn main() {\n    let left = House::new(1);\n    let right = House::new(2);\n\n    left.right_neighbor.set(Some(&right));\n    right.left_neighbor.set(Some(&left));\n}\n";

},{}],"iWX49":[function(require,module,exports,__globalThis) {
module.exports = "use std::cell::Cell;\n\nstruct House<'a> {\n    occupants: u8,\n    left_neighbor: Cell<Option<&'a House<'a>>>,\n    right_neighbor: Cell<Option<&'a House<'a>>>,\n}\n\nimpl<'a> House<'a> {\n    fn new(occupants: u8) -> Self {\n        House {\n            occupants,\n            left_neighbor: None.into(),\n            right_neighbor: None.into(),\n        }\n    }\n}\n\nfn main() {\n    let mut houses = Vec::new();\n    let left = houses.push_mut(House::new(1));\n    let right = houses.push_mut(House::new(2));\n\n    left.right_neighbor.set(Some(right));\n    right.left_neighbor.set(Some(left));\n}\n";

},{}],"cebWX":[function(require,module,exports,__globalThis) {
module.exports = "error[E0499]: cannot borrow `houses` as mutable more than once at a time\n  --> cycle/src/main.rs:83:17\n   |\n82 |     let left = houses.push_mut(House::new(1));\n   |                ------ first mutable borrow occurs here\n83 |     let right = houses.push_mut(House::new(2));\n   |                 ^^^^^^ second mutable borrow occurs here\n84 |\n85 |     left.right_neighbor.set(Some(right));\n   |     ------------------- first borrow later used here\n\nFor more information about this error, try `rustc --explain E0499`.\nerror: could not compile `cycle` (bin \"cycle\") due to 1 previous error\n";

},{}],"7zhbp":[function(require,module,exports,__globalThis) {
module.exports = "use std::cell::Cell;\n\nstruct House<'a> {\n    occupants: u8,\n    left_neighbor: Cell<Option<&'a House<'a>>>,\n    right_neighbor: Cell<Option<&'a House<'a>>>,\n}\n\nimpl<'a> House<'a> {\n    fn new(occupants: u8) -> Self {\n        House {\n            occupants,\n            left_neighbor: None.into(),\n            right_neighbor: None.into(),\n        }\n    }\n}\n\nfn main() {\n    let mut houses = Vec::new();\n    let left = houses.len();\n    houses.push(House::new(1));\n    let right = houses.len();\n    houses.push(House::new(2));\n\n    let [left, right] = houses.get_disjoint_mut([left, right]).unwrap();\n\n    left.right_neighbor.set(Some(right));\n    right.left_neighbor.set(Some(left));\n}\n";

},{}],"6rYRt":[function(require,module,exports,__globalThis) {
module.exports = "use std::cell::Cell;\n\nstruct House<'a> {\n    occupants: u8,\n    left_neighbor: Cell<Option<&'a House<'a>>>,\n    right_neighbor: Cell<Option<&'a House<'a>>>,\n}\n\nimpl<'a> House<'a> {\n    fn new(occupants: u8) -> Self {\n        House {\n            occupants,\n            left_neighbor: None.into(),\n            right_neighbor: None.into(),\n        }\n    }\n}\n\nfn main() {\n    let mut houses = Vec::new();\n    let left = houses.len();\n    houses.push(House::new(1));\n    let right = houses.len();\n    houses.push(House::new(2));\n\n    let [left, right] = houses.get_disjoint_mut([left, right]).unwrap();\n\n    left.right_neighbor.set(Some(right));\n    right.left_neighbor.set(Some(left));\n\n    let another = houses.push(House::new(3));\n}\n";

},{}],"9a1Fx":[function(require,module,exports,__globalThis) {
module.exports = "error[E0499]: cannot borrow `houses` as mutable more than once at a time\n   --> cycle/src/main.rs:116:19\n    |\n111 |     let [left, right] = houses.get_disjoint_mut([left, right]).unwrap();\n    |                         ------ first mutable borrow occurs here\n...\n116 |     let another = houses.push(House::new(3));\n    |                   ^^^^^^\n    |                   |\n    |                   second mutable borrow occurs here\n    |                   first borrow later used here\n\nFor more information about this error, try `rustc --explain E0499`.\nerror: could not compile `cycle` (bin \"cycle\") due to 1 previous error\n";

},{}],"cmYmI":[function(require,module,exports,__globalThis) {
module.exports = "use std::cell::Cell;\n\nuse typed_arena::Arena;\n\nstruct House<'a> {\n    occupants: u8,\n    left_neighbor: Cell<Option<&'a House<'a>>>,\n    right_neighbor: Cell<Option<&'a House<'a>>>,\n}\n\nimpl<'a> House<'a> {\n    fn new(occupants: u8) -> Self {\n        House {\n            occupants,\n            left_neighbor: None.into(),\n            right_neighbor: None.into(),\n        }\n    }\n}\n\nfn main() {\n    let houses = Arena::new();\n    let left = houses.alloc(House::new(1));\n    let right = houses.alloc(House::new(2));\n\n    left.right_neighbor.set(Some(right));\n    right.left_neighbor.set(Some(left));\n\n    let another = houses.alloc(House::new(3));\n}\n";

},{}],"jryco":[function(require,module,exports,__globalThis) {
module.exports = "use std::cell::Cell;\n\nstruct House {\n    occupants: u8,\n    left_neighbor: Cell<Option<usize>>,\n    right_neighbor: Cell<Option<usize>>,\n}\n\nimpl House {\n    fn new(occupants: u8) -> Self {\n        House {\n            occupants,\n            left_neighbor: None.into(),\n            right_neighbor: None.into(),\n        }\n    }\n}\n\nfn main() {\n    let mut houses = Vec::new();\n    let left = houses.len();\n    houses.push(House::new(1));\n    let right = houses.len();\n    houses.push(House::new(2));\n\n    houses[left].right_neighbor.set(Some(right));\n    houses[right].left_neighbor.set(Some(left));\n\n    let another = houses.push(House::new(3));\n}\n";

},{}],"lh9XQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
class ErrorBoundary extends (0, _reactDefault.default).Component {
    static getDerivedStateFromError(error) {
        return {
            error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.log(error, errorInfo);
    }
    render() {
        if (this.state.error) // Fallback UI
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
            children: "Something went wrong."
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: this.props.children
        });
    }
    constructor(...args){
        super(...args), this.state = {
            error: undefined
        };
    }
}
exports.default = ErrorBoundary;

},{"react/jsx-runtime":"afIHK","react":"7e5Pu","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"lIETM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _hooks = require("./app/hooks");
var _helpSlice = require("./features/help/helpSlice");
var _helpModuleCss = require("./Help.module.css");
const KEYS = [
    [
        [
            "\u2190",
            "\u2191",
            "PgUp"
        ],
        "Previous slide"
    ],
    [
        [
            "\u2192",
            "\u2193",
            "PgDn"
        ],
        "Next slide"
    ],
    [
        [
            "Home"
        ],
        "First slide"
    ],
    [
        [
            "End"
        ],
        "Last slide"
    ],
    [
        [
            "a"
        ],
        "Toggle aspect ratio"
    ],
    [
        [
            "c"
        ],
        "Clone window"
    ],
    [
        [
            "e"
        ],
        "Toggle emphasis"
    ],
    [
        [
            "g"
        ],
        "Go to slide number"
    ],
    [
        [
            "p"
        ],
        "Toggle presenter mode"
    ],
    [
        [
            "s"
        ],
        "Toggle skipped overlay"
    ],
    [
        [
            "+",
            "="
        ],
        "Increase font size"
    ],
    [
        [
            "-",
            "_"
        ],
        "Decrease font size"
    ],
    [
        [
            ")"
        ],
        "Reset font size"
    ],
    [
        [
            "?"
        ],
        "Show help"
    ]
];
const Keycap = ({ keycap })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: _helpModuleCss.keycap,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
            children: keycap
        })
    });
const Key = ({ theKey })=>{
    const [keycaps, description] = theKey;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: _helpModuleCss.set,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: _helpModuleCss.keycaps,
                children: keycaps.map((keycap, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Keycap, {
                        keycap: keycap
                    }, i))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: description
            })
        ]
    });
};
const Help = ()=>{
    const enabled = (0, _hooks.useAppSelector)((state)=>state.help.enabled);
    const dispatch = (0, _reactRedux.useDispatch)();
    const close = (0, _react.useCallback)(()=>dispatch(_helpSlice.close()), [
        dispatch
    ]);
    const dialog = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        if (!dialog.current) return;
        if (enabled) dialog.current.showModal();
        else dialog.current.close();
    }, [
        enabled
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("dialog", {
        ref: dialog,
        onClose: close,
        className: _helpModuleCss.dialog,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
            method: "dialog",
            onReset: close,
            className: _helpModuleCss.container,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    type: "reset",
                    className: _helpModuleCss.close,
                    children: "\u2716"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: _helpModuleCss.title,
                    children: "Help"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: _helpModuleCss.sets,
                    children: KEYS.map((key, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Key, {
                            theKey: key
                        }, i))
                })
            ]
        })
    });
};
exports.default = Help;

},{"react/jsx-runtime":"afIHK","react":"7e5Pu","react-redux":"904HS","./app/hooks":"8D69K","./features/help/helpSlice":"3yLXh","./Help.module.css":"5e32Z","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"3yLXh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "helpSlice", ()=>helpSlice);
parcelHelpers.export(exports, "close", ()=>close);
parcelHelpers.export(exports, "toggle", ()=>toggle);
var _toolkit = require("@reduxjs/toolkit");
const initialState = {
    enabled: false
};
const helpSlice = (0, _toolkit.createSlice)({
    name: "help",
    initialState,
    reducers: {
        close: (state)=>{
            state.enabled = false;
        },
        toggle: (state)=>{
            state.enabled = !state.enabled;
        }
    }
});
const { close, toggle } = helpSlice.actions;
exports.default = helpSlice.reducer;

},{"@reduxjs/toolkit":"4eORJ","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"5e32Z":[function(require,module,exports,__globalThis) {
module.exports["close"] = `K4NMUa_close`;
module.exports["container"] = `K4NMUa_container`;
module.exports["dialog"] = `K4NMUa_dialog`;
module.exports["keycap"] = `K4NMUa_keycap`;
module.exports["keycaps"] = `K4NMUa_keycaps`;
module.exports["set"] = `K4NMUa_set`;
module.exports["sets"] = `K4NMUa_sets`;
module.exports["title"] = `K4NMUa_title`;

},{}],"9bWnr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _hooks = require("./app/hooks");
const HtmlStyler = ()=>{
    const fontSize = (0, _hooks.useAppSelector)((s)=>s.window.fontSize);
    (0, _react.useEffect)(()=>{
        window.document.documentElement.style.fontSize = `${fontSize}%`;
    }, [
        fontSize
    ]);
    return null;
};
exports.default = HtmlStyler;

},{"react":"7e5Pu","./app/hooks":"8D69K","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"cORaO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reducer", ()=>reducer);
parcelHelpers.export(exports, "buildStore", ()=>buildStore);
var _toolkit = require("@reduxjs/toolkit");
var _listenerMiddleware = require("./listenerMiddleware");
var _buildBroadcastMiddleware = require("./buildBroadcastMiddleware");
var _buildBroadcastMiddlewareDefault = parcelHelpers.interopDefault(_buildBroadcastMiddleware);
var _buildUrlMiddleware = require("./buildUrlMiddleware");
var _buildUrlMiddlewareDefault = parcelHelpers.interopDefault(_buildUrlMiddleware);
var _deckSlice = require("../features/deck/deckSlice");
var _deckSliceDefault = parcelHelpers.interopDefault(_deckSlice);
var _helpSlice = require("../features/help/helpSlice");
var _helpSliceDefault = parcelHelpers.interopDefault(_helpSlice);
var _transcludeSlice = require("../features/transclude/transcludeSlice");
var _transcludeSliceDefault = parcelHelpers.interopDefault(_transcludeSlice);
var _routeSlice = require("../features/route/routeSlice");
var _routeSliceDefault = parcelHelpers.interopDefault(_routeSlice);
var _windowSlice = require("../features/window/windowSlice");
var _windowSliceDefault = parcelHelpers.interopDefault(_windowSlice);
var _skippedSlice = require("../features/skipped/skippedSlice");
var _skippedSliceDefault = parcelHelpers.interopDefault(_skippedSlice);
const reducer = {
    deck: (0, _deckSliceDefault.default),
    help: (0, _helpSliceDefault.default),
    transclude: (0, _transcludeSliceDefault.default),
    route: (0, _routeSliceDefault.default),
    skipped: (0, _skippedSliceDefault.default),
    window: (0, _windowSliceDefault.default)
};
const buildStore = ({ channel, window })=>{
    (0, _buildBroadcastMiddlewareDefault.default)(channel);
    (0, _buildUrlMiddlewareDefault.default)(window);
    return (0, _toolkit.configureStore)({
        reducer,
        middleware: (getDefaultMiddleware)=>getDefaultMiddleware().concat((0, _listenerMiddleware.listenerMiddleware).middleware)
    });
};

},{"@reduxjs/toolkit":"4eORJ","./listenerMiddleware":"02g3T","./buildBroadcastMiddleware":"dhyKe","./buildUrlMiddleware":"aunJZ","../features/deck/deckSlice":"dvasY","../features/help/helpSlice":"3yLXh","../features/transclude/transcludeSlice":"1B57U","../features/route/routeSlice":"2FQD2","../features/window/windowSlice":"b9JbQ","../features/skipped/skippedSlice":"gcTsW","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"02g3T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "listenerMiddleware", ()=>listenerMiddleware);
parcelHelpers.export(exports, "startAppListening", ()=>startAppListening);
parcelHelpers.export(exports, "addAppListener", ()=>addAppListener);
var _toolkit = require("@reduxjs/toolkit");
const listenerMiddleware = (0, _toolkit.createListenerMiddleware)();
const startAppListening = listenerMiddleware.startListening.withTypes();
const addAppListener = (0, _toolkit.addListener).withTypes();

},{"@reduxjs/toolkit":"4eORJ","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"dhyKe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _listenerMiddleware = require("./listenerMiddleware");
var _broadcast = require("./broadcast");
const buildBroadcastMiddleware = (channel)=>{
    (0, _listenerMiddleware.startAppListening)({
        actionCreator: (0, _broadcast.broadcast),
        effect: async (action, listenerApi)=>{
            channel.postMessage(action.payload);
            for (const childAction of action.payload)listenerApi.dispatch(childAction);
        }
    });
};
exports.default = buildBroadcastMiddleware;

},{"./listenerMiddleware":"02g3T","./broadcast":"eOCff","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"aunJZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _listenerMiddleware = require("./listenerMiddleware");
const buildUrlMiddleware = (window)=>{
    (0, _listenerMiddleware.startAppListening)({
        predicate: (_action, currentState, previousState)=>{
            const slideIndex = currentState.deck.slideIndex != previousState.deck.slideIndex;
            const deck = currentState.route.deck != previousState.route.deck;
            return slideIndex || deck;
        },
        effect: async (_action, listenerApi)=>{
            const state = listenerApi.getState();
            const page = state.deck.slideIndex;
            const deck = state.route.deck;
            const originalLocation = window.location.toString();
            const url = new URL(originalLocation);
            url.searchParams.set("page", page.toString());
            url.searchParams.set("deck", deck.toString());
            const newLocation = url.toString();
            if (newLocation !== originalLocation) window.history.pushState(null, "", newLocation);
        }
    });
};
exports.default = buildUrlMiddleware;

},{"./listenerMiddleware":"02g3T","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"1B57U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transcludeSlice", ()=>transcludeSlice);
parcelHelpers.export(exports, "toggleShowCopy", ()=>toggleShowCopy);
parcelHelpers.export(exports, "toggleShowEmphasis", ()=>toggleShowEmphasis);
var _toolkit = require("@reduxjs/toolkit");
const initialState = {
    showCopy: false,
    showEmphasis: true
};
const transcludeSlice = (0, _toolkit.createSlice)({
    name: "transclude",
    initialState,
    reducers: {
        toggleShowCopy: (state)=>{
            state.showCopy = !state.showCopy;
        },
        toggleShowEmphasis: (state)=>{
            state.showEmphasis = !state.showEmphasis;
        }
    }
});
const { toggleShowCopy, toggleShowEmphasis } = transcludeSlice.actions;
exports.default = transcludeSlice.reducer;

},{"@reduxjs/toolkit":"4eORJ","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"b9JbQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "windowSlice", ()=>windowSlice);
parcelHelpers.export(exports, "reset", ()=>reset);
parcelHelpers.export(exports, "increase", ()=>increase);
parcelHelpers.export(exports, "decrease", ()=>decrease);
var _toolkit = require("@reduxjs/toolkit");
const initialState = {
    fontSize: 100
};
const windowSlice = (0, _toolkit.createSlice)({
    name: "window",
    initialState,
    reducers: {
        reset: (state)=>{
            state.fontSize = initialState.fontSize;
        },
        increase: (state)=>{
            state.fontSize += 5;
        },
        decrease: (state)=>{
            state.fontSize -= 5;
        }
    }
});
const { reset, increase, decrease } = windowSlice.actions;
exports.default = windowSlice.reducer;

},{"@reduxjs/toolkit":"4eORJ","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}],"gcTsW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "skippedSlice", ()=>skippedSlice);
parcelHelpers.export(exports, "toggleSkipped", ()=>toggleSkipped);
var _toolkit = require("@reduxjs/toolkit");
const initialState = {
    showSkipped: true
};
const skippedSlice = (0, _toolkit.createSlice)({
    name: "skipped",
    initialState,
    reducers: {
        toggleSkipped: (state)=>{
            state.showSkipped = !state.showSkipped;
        }
    }
});
const { toggleSkipped } = skippedSlice.actions;
exports.default = skippedSlice.reducer;

},{"@reduxjs/toolkit":"4eORJ","@parcel/transformer-js/src/esmodule-helpers.js":"jWxmR"}]},["5DEId"], "5DEId", "parcelRequire9f8b", {})

//# sourceMappingURL=tetramem.a6bc76c5.js.map
